export const stateZipCodes = [
  {
    zip_code: "31008",

    ste_name: "GA",
  },
  {
    zip_code: "31052",

    ste_name: "GA",
  },
  {
    zip_code: "31301",

    ste_name: "GA",
  },
  {
    zip_code: "31547",

    ste_name: "GA",
  },
  {
    zip_code: "31622",

    ste_name: "GA",
  },
  {
    zip_code: "31698",

    ste_name: "GA",
  },
  {
    zip_code: "31909",

    ste_name: "GA",
  },
  {
    zip_code: "32063",

    ste_name: "FL",
  },
  {
    zip_code: "32095",

    ste_name: "FL",
  },
  {
    zip_code: "32218",

    ste_name: "FL",
  },
  {
    zip_code: "32258",

    ste_name: "FL",
  },
  {
    zip_code: "32304",

    ste_name: "FL",
  },
  {
    zip_code: "32427",

    ste_name: "FL",
  },
  {
    zip_code: "32443",

    ste_name: "FL",
  },
  {
    zip_code: "32465",

    ste_name: "FL",
  },
  {
    zip_code: "32534",

    ste_name: "FL",
  },
  {
    zip_code: "32618",

    ste_name: "FL",
  },
  {
    zip_code: "32626",

    ste_name: "FL",
  },
  {
    zip_code: "32653",

    ste_name: "FL",
  },
  {
    zip_code: "32669",

    ste_name: "FL",
  },
  {
    zip_code: "32759",

    ste_name: "FL",
  },
  {
    zip_code: "32792",

    ste_name: "FL",
  },
  {
    zip_code: "32827",

    ste_name: "FL",
  },
  {
    zip_code: "32952",

    ste_name: "FL",
  },
  {
    zip_code: "32968",

    ste_name: "FL",
  },
  {
    zip_code: "33125",

    ste_name: "FL",
  },
  {
    zip_code: "33142",

    ste_name: "FL",
  },
  {
    zip_code: "33150",

    ste_name: "FL",
  },
  {
    zip_code: "33155",

    ste_name: "FL",
  },
  {
    zip_code: "33437",

    ste_name: "FL",
  },
  {
    zip_code: "33510",

    ste_name: "FL",
  },
  {
    zip_code: "33573",

    ste_name: "FL",
  },
  {
    zip_code: "33767",

    ste_name: "FL",
  },
  {
    zip_code: "33850",

    ste_name: "FL",
  },
  {
    zip_code: "33856",

    ste_name: "FL",
  },
  {
    zip_code: "33868",

    ste_name: "FL",
  },
  {
    zip_code: "33981",

    ste_name: "FL",
  },
  {
    zip_code: "34145",

    ste_name: "FL",
  },
  {
    zip_code: "34223",

    ste_name: "FL",
  },
  {
    zip_code: "34285",

    ste_name: "FL",
  },
  {
    zip_code: "34293",

    ste_name: "FL",
  },
  {
    zip_code: "34445",

    ste_name: "FL",
  },
  {
    zip_code: "34475",

    ste_name: "FL",
  },
  {
    zip_code: "35083",

    ste_name: "AL",
  },
  {
    zip_code: "35085",

    ste_name: "AL",
  },
  {
    zip_code: "35091",

    ste_name: "AL",
  },
  {
    zip_code: "35116",

    ste_name: "AL",
  },
  {
    zip_code: "35133",

    ste_name: "AL",
  },
  {
    zip_code: "35172",

    ste_name: "AL",
  },
  {
    zip_code: "35217",

    ste_name: "AL",
  },
  {
    zip_code: "35242",

    ste_name: "AL",
  },
  {
    zip_code: "35458",

    ste_name: "AL",
  },
  {
    zip_code: "35548",

    ste_name: "AL",
  },
  {
    zip_code: "35559",

    ste_name: "AL",
  },
  {
    zip_code: "35575",

    ste_name: "AL",
  },
  {
    zip_code: "35973",

    ste_name: "AL",
  },
  {
    zip_code: "36093",

    ste_name: "AL",
  },
  {
    zip_code: "36314",

    ste_name: "AL",
  },
  {
    zip_code: "36505",

    ste_name: "AL",
  },
  {
    zip_code: "36560",

    ste_name: "AL",
  },
  {
    zip_code: "36575",

    ste_name: "AL",
  },
  {
    zip_code: "36617",

    ste_name: "AL",
  },
  {
    zip_code: "36738",

    ste_name: "AL",
  },
  {
    zip_code: "36907",

    ste_name: "AL",
  },
  {
    zip_code: "37014",

    ste_name: "TN",
  },
  {
    zip_code: "37129",

    ste_name: "TN",
  },
  {
    zip_code: "37144",

    ste_name: "TN",
  },
  {
    zip_code: "37183",

    ste_name: "TN",
  },
  {
    zip_code: "37205",

    ste_name: "TN",
  },
  {
    zip_code: "37373",

    ste_name: "TN",
  },
  {
    zip_code: "37410",

    ste_name: "TN",
  },
  {
    zip_code: "37681",

    ste_name: "TN",
  },
  {
    zip_code: "37743",

    ste_name: "TN",
  },
  {
    zip_code: "37770",

    ste_name: "TN",
  },
  {
    zip_code: "37821",

    ste_name: "TN",
  },
  {
    zip_code: "37861",

    ste_name: "TN",
  },
  {
    zip_code: "38070",

    ste_name: "TN",
  },
  {
    zip_code: "38259",

    ste_name: "TN",
  },
  {
    zip_code: "38334",

    ste_name: "TN",
  },
  {
    zip_code: "38355",

    ste_name: "TN",
  },
  {
    zip_code: "38372",

    ste_name: "TN",
  },
  {
    zip_code: "38382",

    ste_name: "TN",
  },
  {
    zip_code: "38392",

    ste_name: "TN",
  },
  {
    zip_code: "38449",

    ste_name: "TN",
  },
  {
    zip_code: "38472",

    ste_name: "TN",
  },
  {
    zip_code: "38601",

    ste_name: "MS",
  },
  {
    zip_code: "38621",

    ste_name: "MS",
  },
  {
    zip_code: "38652",

    ste_name: "MS",
  },
  {
    zip_code: "38774",

    ste_name: "MS",
  },
  {
    zip_code: "38843",

    ste_name: "MS",
  },
  {
    zip_code: "38857",

    ste_name: "MS",
  },
  {
    zip_code: "38953",

    ste_name: "MS",
  },
  {
    zip_code: "39086",

    ste_name: "MS",
  },
  {
    zip_code: "39113",

    ste_name: "MS",
  },
  {
    zip_code: "39194",

    ste_name: "MS",
  },
  {
    zip_code: "39217",

    ste_name: "MS",
  },
  {
    zip_code: "39332",

    ste_name: "MS",
  },
  {
    zip_code: "39474",

    ste_name: "MS",
  },
  {
    zip_code: "39745",

    ste_name: "MS",
  },
  {
    zip_code: "39828",

    ste_name: "GA",
  },
  {
    zip_code: "40003",

    ste_name: "KY",
  },
  {
    zip_code: "40109",

    ste_name: "KY",
  },
  {
    zip_code: "40143",

    ste_name: "KY",
  },
  {
    zip_code: "40157",

    ste_name: "KY",
  },
  {
    zip_code: "40162",

    ste_name: "KY",
  },
  {
    zip_code: "40464",

    ste_name: "KY",
  },
  {
    zip_code: "40503",

    ste_name: "KY",
  },
  {
    zip_code: "40508",

    ste_name: "KY",
  },
  {
    zip_code: "41075",

    ste_name: "KY",
  },
  {
    zip_code: "41535",

    ste_name: "KY",
  },
  {
    zip_code: "41539",

    ste_name: "KY",
  },
  {
    zip_code: "41553",

    ste_name: "KY",
  },
  {
    zip_code: "41555",

    ste_name: "KY",
  },
  {
    zip_code: "41843",

    ste_name: "KY",
  },
  {
    zip_code: "41861",

    ste_name: "KY",
  },
  {
    zip_code: "42038",

    ste_name: "KY",
  },
  {
    zip_code: "42130",

    ste_name: "KY",
  },
  {
    zip_code: "42170",

    ste_name: "KY",
  },
  {
    zip_code: "42324",

    ste_name: "KY",
  },
  {
    zip_code: "42376",

    ste_name: "KY",
  },
  {
    zip_code: "42516",

    ste_name: "KY",
  },
  {
    zip_code: "42603",

    ste_name: "KY",
  },
  {
    zip_code: "43002",

    ste_name: "OH",
  },
  {
    zip_code: "43126",

    ste_name: "OH",
  },
  {
    zip_code: "43158",

    ste_name: "OH",
  },
  {
    zip_code: "43160",

    ste_name: "OH",
  },
  {
    zip_code: "43206",

    ste_name: "OH",
  },
  {
    zip_code: "43221",

    ste_name: "OH",
  },
  {
    zip_code: "43228",

    ste_name: "OH",
  },
  {
    zip_code: "43324",

    ste_name: "OH",
  },
  {
    zip_code: "43333",

    ste_name: "OH",
  },
  {
    zip_code: "43360",

    ste_name: "OH",
  },
  {
    zip_code: "43569",

    ste_name: "OH",
  },
  {
    zip_code: "43570",

    ste_name: "OH",
  },
  {
    zip_code: "43771",

    ste_name: "OH",
  },
  {
    zip_code: "43822",

    ste_name: "OH",
  },
  {
    zip_code: "43913",

    ste_name: "OH",
  },
  {
    zip_code: "43926",

    ste_name: "OH",
  },
  {
    zip_code: "43935",

    ste_name: "OH",
  },
  {
    zip_code: "43940",

    ste_name: "OH",
  },
  {
    zip_code: "43962",

    ste_name: "OH",
  },
  {
    zip_code: "43977",

    ste_name: "OH",
  },
  {
    zip_code: "44074",

    ste_name: "OH",
  },
  {
    zip_code: "44076",

    ste_name: "OH",
  },
  {
    zip_code: "44143",

    ste_name: "OH",
  },
  {
    zip_code: "44221",

    ste_name: "OH",
  },
  {
    zip_code: "44275",

    ste_name: "OH",
  },
  {
    zip_code: "44319",

    ste_name: "OH",
  },
  {
    zip_code: "44410",

    ste_name: "OH",
  },
  {
    zip_code: "44417",

    ste_name: "OH",
  },
  {
    zip_code: "44442",

    ste_name: "OH",
  },
  {
    zip_code: "44515",

    ste_name: "OH",
  },
  {
    zip_code: "44614",

    ste_name: "OH",
  },
  {
    zip_code: "44675",

    ste_name: "OH",
  },
  {
    zip_code: "44708",

    ste_name: "OH",
  },
  {
    zip_code: "44903",

    ste_name: "OH",
  },
  {
    zip_code: "45003",

    ste_name: "OH",
  },
  {
    zip_code: "45044",

    ste_name: "OH",
  },
  {
    zip_code: "45146",

    ste_name: "OH",
  },
  {
    zip_code: "45156",

    ste_name: "OH",
  },
  {
    zip_code: "45208",

    ste_name: "OH",
  },
  {
    zip_code: "45211",

    ste_name: "OH",
  },
  {
    zip_code: "45255",

    ste_name: "OH",
  },
  {
    zip_code: "45349",

    ste_name: "OH",
  },
  {
    zip_code: "45390",

    ste_name: "OH",
  },
  {
    zip_code: "45434",

    ste_name: "OH",
  },
  {
    zip_code: "45614",

    ste_name: "OH",
  },
  {
    zip_code: "45618",

    ste_name: "OH",
  },
  {
    zip_code: "45640",

    ste_name: "OH",
  },
  {
    zip_code: "45651",

    ste_name: "OH",
  },
  {
    zip_code: "45741",

    ste_name: "OH",
  },
  {
    zip_code: "45743",

    ste_name: "OH",
  },
  {
    zip_code: "45760",

    ste_name: "OH",
  },
  {
    zip_code: "45778",

    ste_name: "OH",
  },
  {
    zip_code: "45889",

    ste_name: "OH",
  },
  {
    zip_code: "46036",

    ste_name: "IN",
  },
  {
    zip_code: "46371",

    ste_name: "IN",
  },
  {
    zip_code: "46772",

    ste_name: "IN",
  },
  {
    zip_code: "46793",

    ste_name: "IN",
  },
  {
    zip_code: "46952",

    ste_name: "IN",
  },
  {
    zip_code: "46957",

    ste_name: "IN",
  },
  {
    zip_code: "46982",

    ste_name: "IN",
  },
  {
    zip_code: "46987",

    ste_name: "IN",
  },
  {
    zip_code: "47115",

    ste_name: "IN",
  },
  {
    zip_code: "47119",

    ste_name: "IN",
  },
  {
    zip_code: "47160",

    ste_name: "IN",
  },
  {
    zip_code: "47282",

    ste_name: "IN",
  },
  {
    zip_code: "47371",

    ste_name: "IN",
  },
  {
    zip_code: "47446",

    ste_name: "IN",
  },
  {
    zip_code: "47532",

    ste_name: "IN",
  },
  {
    zip_code: "47536",

    ste_name: "IN",
  },
  {
    zip_code: "47586",

    ste_name: "IN",
  },
  {
    zip_code: "47838",

    ste_name: "IN",
  },
  {
    zip_code: "47881",

    ste_name: "IN",
  },
  {
    zip_code: "47882",

    ste_name: "IN",
  },
  {
    zip_code: "47922",

    ste_name: "IN",
  },
  {
    zip_code: "48021",

    ste_name: "MI",
  },
  {
    zip_code: "48083",

    ste_name: "MI",
  },
  {
    zip_code: "48161",

    ste_name: "MI",
  },
  {
    zip_code: "48178",

    ste_name: "MI",
  },
  {
    zip_code: "48191",

    ste_name: "MI",
  },
  {
    zip_code: "48197",

    ste_name: "MI",
  },
  {
    zip_code: "48218",

    ste_name: "MI",
  },
  {
    zip_code: "48350",

    ste_name: "MI",
  },
  {
    zip_code: "48401",

    ste_name: "MI",
  },
  {
    zip_code: "48439",

    ste_name: "MI",
  },
  {
    zip_code: "48473",

    ste_name: "MI",
  },
  {
    zip_code: "48505",

    ste_name: "MI",
  },
  {
    zip_code: "48642",

    ste_name: "MI",
  },
  {
    zip_code: "48933",

    ste_name: "MI",
  },
  {
    zip_code: "49004",

    ste_name: "MI",
  },
  {
    zip_code: "49013",

    ste_name: "MI",
  },
  {
    zip_code: "49036",

    ste_name: "MI",
  },
  {
    zip_code: "49043",

    ste_name: "MI",
  },
  {
    zip_code: "49045",

    ste_name: "MI",
  },
  {
    zip_code: "49048",

    ste_name: "MI",
  },
  {
    zip_code: "49052",

    ste_name: "MI",
  },
  {
    zip_code: "49078",

    ste_name: "MI",
  },
  {
    zip_code: "49079",

    ste_name: "MI",
  },
  {
    zip_code: "49102",

    ste_name: "MI",
  },
  {
    zip_code: "49276",

    ste_name: "MI",
  },
  {
    zip_code: "49323",

    ste_name: "MI",
  },
  {
    zip_code: "49336",

    ste_name: "MI",
  },
  {
    zip_code: "49424",

    ste_name: "MI",
  },
  {
    zip_code: "49461",

    ste_name: "MI",
  },
  {
    zip_code: "49464",

    ste_name: "MI",
  },
  {
    zip_code: "49735",

    ste_name: "MI",
  },
  {
    zip_code: "49780",

    ste_name: "MI",
  },
  {
    zip_code: "49795",

    ste_name: "MI",
  },
  {
    zip_code: "49870",

    ste_name: "MI",
  },
  {
    zip_code: "49902",

    ste_name: "MI",
  },
  {
    zip_code: "49962",

    ste_name: "MI",
  },
  {
    zip_code: "50147",

    ste_name: "IA",
  },
  {
    zip_code: "50207",

    ste_name: "IA",
  },
  {
    zip_code: "50272",

    ste_name: "IA",
  },
  {
    zip_code: "50275",

    ste_name: "IA",
  },
  {
    zip_code: "50309",

    ste_name: "IA",
  },
  {
    zip_code: "50432",

    ste_name: "IA",
  },
  {
    zip_code: "50521",

    ste_name: "IA",
  },
  {
    zip_code: "50546",

    ste_name: "IA",
  },
  {
    zip_code: "50629",

    ste_name: "IA",
  },
  {
    zip_code: "51360",

    ste_name: "IA",
  },
  {
    zip_code: "51458",

    ste_name: "IA",
  },
  {
    zip_code: "51561",

    ste_name: "IA",
  },
  {
    zip_code: "51638",

    ste_name: "IA",
  },
  {
    zip_code: "52052",

    ste_name: "IA",
  },
  {
    zip_code: "52078",

    ste_name: "IA",
  },
  {
    zip_code: "52206",

    ste_name: "IA",
  },
  {
    zip_code: "52233",

    ste_name: "IA",
  },
  {
    zip_code: "52245",

    ste_name: "IA",
  },
  {
    zip_code: "52338",

    ste_name: "IA",
  },
  {
    zip_code: "52352",

    ste_name: "IA",
  },
  {
    zip_code: "53023",

    ste_name: "WI",
  },
  {
    zip_code: "53033",

    ste_name: "WI",
  },
  {
    zip_code: "53072",

    ste_name: "WI",
  },
  {
    zip_code: "53182",

    ste_name: "WI",
  },
  {
    zip_code: "53185",

    ste_name: "WI",
  },
  {
    zip_code: "53216",

    ste_name: "WI",
  },
  {
    zip_code: "53532",

    ste_name: "WI",
  },
  {
    zip_code: "53587",

    ste_name: "WI",
  },
  {
    zip_code: "53713",

    ste_name: "WI",
  },
  {
    zip_code: "53919",

    ste_name: "WI",
  },
  {
    zip_code: "53935",

    ste_name: "WI",
  },
  {
    zip_code: "54207",

    ste_name: "WI",
  },
  {
    zip_code: "54513",

    ste_name: "WI",
  },
  {
    zip_code: "54526",

    ste_name: "WI",
  },
  {
    zip_code: "54538",

    ste_name: "WI",
  },
  {
    zip_code: "54546",

    ste_name: "WI",
  },
  {
    zip_code: "54627",

    ste_name: "WI",
  },
  {
    zip_code: "54724",

    ste_name: "WI",
  },
  {
    zip_code: "54725",

    ste_name: "WI",
  },
  {
    zip_code: "54734",

    ste_name: "WI",
  },
  {
    zip_code: "54931",

    ste_name: "WI",
  },
  {
    zip_code: "54984",

    ste_name: "WI",
  },
  {
    zip_code: "54985",

    ste_name: "WI",
  },
  {
    zip_code: "55029",

    ste_name: "MN",
  },
  {
    zip_code: "55092",

    ste_name: "MN",
  },
  {
    zip_code: "55117",

    ste_name: "MN",
  },
  {
    zip_code: "55301",

    ste_name: "MN",
  },
  {
    zip_code: "55303",

    ste_name: "MN",
  },
  {
    zip_code: "55304",

    ste_name: "MN",
  },
  {
    zip_code: "55336",

    ste_name: "MN",
  },
  {
    zip_code: "55338",

    ste_name: "MN",
  },
  {
    zip_code: "55352",

    ste_name: "MN",
  },
  {
    zip_code: "55378",

    ste_name: "MN",
  },
  {
    zip_code: "55401",

    ste_name: "MN",
  },
  {
    zip_code: "55412",

    ste_name: "MN",
  },
  {
    zip_code: "55434",

    ste_name: "MN",
  },
  {
    zip_code: "55604",

    ste_name: "MN",
  },
  {
    zip_code: "55787",

    ste_name: "MN",
  },
  {
    zip_code: "55901",

    ste_name: "MN",
  },
  {
    zip_code: "55906",

    ste_name: "MN",
  },
  {
    zip_code: "55921",

    ste_name: "MN",
  },
  {
    zip_code: "55981",

    ste_name: "MN",
  },
  {
    zip_code: "56089",

    ste_name: "MN",
  },
  {
    zip_code: "56093",

    ste_name: "MN",
  },
  {
    zip_code: "56128",

    ste_name: "MN",
  },
  {
    zip_code: "56136",

    ste_name: "MN",
  },
  {
    zip_code: "56145",

    ste_name: "MN",
  },
  {
    zip_code: "56157",

    ste_name: "MN",
  },
  {
    zip_code: "56171",

    ste_name: "MN",
  },
  {
    zip_code: "56208",

    ste_name: "MN",
  },
  {
    zip_code: "56210",

    ste_name: "MN",
  },
  {
    zip_code: "56236",

    ste_name: "MN",
  },
  {
    zip_code: "56308",

    ste_name: "MN",
  },
  {
    zip_code: "56369",

    ste_name: "MN",
  },
  {
    zip_code: "56425",

    ste_name: "MN",
  },
  {
    zip_code: "56461",

    ste_name: "MN",
  },
  {
    zip_code: "56464",

    ste_name: "MN",
  },
  {
    zip_code: "56470",

    ste_name: "MN",
  },
  {
    zip_code: "56550",

    ste_name: "MN",
  },
  {
    zip_code: "56552",

    ste_name: "MN",
  },
  {
    zip_code: "56554",

    ste_name: "MN",
  },
  {
    zip_code: "56644",

    ste_name: "MN",
  },
  {
    zip_code: "56653",

    ste_name: "MN",
  },
  {
    zip_code: "56659",

    ste_name: "MN",
  },
  {
    zip_code: "56751",

    ste_name: "MN",
  },
  {
    zip_code: "56763",

    ste_name: "MN",
  },
  {
    zip_code: "57016",

    ste_name: "SD",
  },
  {
    zip_code: "57197",

    ste_name: "SD",
  },
  {
    zip_code: "57239",

    ste_name: "SD",
  },
  {
    zip_code: "57242",

    ste_name: "SD",
  },
  {
    zip_code: "57251",

    ste_name: "SD",
  },
  {
    zip_code: "57259",

    ste_name: "SD",
  },
  {
    zip_code: "57269",

    ste_name: "SD",
  },
  {
    zip_code: "57301",

    ste_name: "SD",
  },
  {
    zip_code: "57312",

    ste_name: "SD",
  },
  {
    zip_code: "57366",

    ste_name: "SD",
  },
  {
    zip_code: "57383",

    ste_name: "SD",
  },
  {
    zip_code: "57718",

    ste_name: "SD",
  },
  {
    zip_code: "57744",

    ste_name: "SD",
  },
  {
    zip_code: "57748",

    ste_name: "SD",
  },
  {
    zip_code: "57762",

    ste_name: "SD",
  },
  {
    zip_code: "58021",

    ste_name: "ND",
  },
  {
    zip_code: "58103",

    ste_name: "ND",
  },
  {
    zip_code: "58230",

    ste_name: "ND",
  },
  {
    zip_code: "58249",

    ste_name: "ND",
  },
  {
    zip_code: "58265",

    ste_name: "ND",
  },
  {
    zip_code: "58431",

    ste_name: "ND",
  },
  {
    zip_code: "58482",

    ste_name: "ND",
  },
  {
    zip_code: "58520",

    ste_name: "ND",
  },
  {
    zip_code: "58620",

    ste_name: "ND",
  },
  {
    zip_code: "58737",

    ste_name: "ND",
  },
  {
    zip_code: "90004",

    ste_name: "CA",
  },
  {
    zip_code: "90021",

    ste_name: "CA",
  },
  {
    zip_code: "90027",

    ste_name: "CA",
  },
  {
    zip_code: "90240",

    ste_name: "CA",
  },
  {
    zip_code: "90274",

    ste_name: "CA",
  },
  {
    zip_code: "90303",

    ste_name: "CA",
  },
  {
    zip_code: "90723",

    ste_name: "CA",
  },
  {
    zip_code: "90822",

    ste_name: "CA",
  },
  {
    zip_code: "91108",

    ste_name: "CA",
  },
  {
    zip_code: "91304",

    ste_name: "CA",
  },
  {
    zip_code: "91702",

    ste_name: "CA",
  },
  {
    zip_code: "91914",

    ste_name: "CA",
  },
  {
    zip_code: "91941",

    ste_name: "CA",
  },
  {
    zip_code: "92210",

    ste_name: "CA",
  },
  {
    zip_code: "92211",

    ste_name: "CA",
  },
  {
    zip_code: "92342",

    ste_name: "CA",
  },
  {
    zip_code: "92345",

    ste_name: "CA",
  },
  {
    zip_code: "92359",

    ste_name: "CA",
  },
  {
    zip_code: "92377",

    ste_name: "CA",
  },
  {
    zip_code: "92545",

    ste_name: "CA",
  },
  {
    zip_code: "92571",

    ste_name: "CA",
  },
  {
    zip_code: "92626",

    ste_name: "CA",
  },
  {
    zip_code: "92630",

    ste_name: "CA",
  },
  {
    zip_code: "92887",

    ste_name: "CA",
  },
  {
    zip_code: "93043",

    ste_name: "CA",
  },
  {
    zip_code: "93202",

    ste_name: "CA",
  },
  {
    zip_code: "93257",

    ste_name: "CA",
  },
  {
    zip_code: "93455",

    ste_name: "CA",
  },
  {
    zip_code: "93465",

    ste_name: "CA",
  },
  {
    zip_code: "93561",

    ste_name: "CA",
  },
  {
    zip_code: "93615",

    ste_name: "CA",
  },
  {
    zip_code: "93705",

    ste_name: "CA",
  },
  {
    zip_code: "93905",

    ste_name: "CA",
  },
  {
    zip_code: "93906",

    ste_name: "CA",
  },
  {
    zip_code: "93927",

    ste_name: "CA",
  },
  {
    zip_code: "94041",

    ste_name: "CA",
  },
  {
    zip_code: "94107",

    ste_name: "CA",
  },
  {
    zip_code: "94132",

    ste_name: "CA",
  },
  {
    zip_code: "94596",

    ste_name: "CA",
  },
  {
    zip_code: "94597",

    ste_name: "CA",
  },
  {
    zip_code: "94602",

    ste_name: "CA",
  },
  {
    zip_code: "94707",

    ste_name: "CA",
  },
  {
    zip_code: "94924",

    ste_name: "CA",
  },
  {
    zip_code: "95006",

    ste_name: "CA",
  },
  {
    zip_code: "95046",

    ste_name: "CA",
  },
  {
    zip_code: "95064",

    ste_name: "CA",
  },
  {
    zip_code: "95135",

    ste_name: "CA",
  },
  {
    zip_code: "95315",

    ste_name: "CA",
  },
  {
    zip_code: "95328",

    ste_name: "CA",
  },
  {
    zip_code: "95346",

    ste_name: "CA",
  },
  {
    zip_code: "95350",

    ste_name: "CA",
  },
  {
    zip_code: "95369",

    ste_name: "CA",
  },
  {
    zip_code: "95372",

    ste_name: "CA",
  },
  {
    zip_code: "95375",

    ste_name: "CA",
  },
  {
    zip_code: "95387",

    ste_name: "CA",
  },
  {
    zip_code: "95410",

    ste_name: "CA",
  },
  {
    zip_code: "95436",

    ste_name: "CA",
  },
  {
    zip_code: "95452",

    ste_name: "CA",
  },
  {
    zip_code: "95540",

    ste_name: "CA",
  },
  {
    zip_code: "95558",

    ste_name: "CA",
  },
  {
    zip_code: "95560",

    ste_name: "CA",
  },
  {
    zip_code: "95567",

    ste_name: "CA",
  },
  {
    zip_code: "95621",

    ste_name: "CA",
  },
  {
    zip_code: "95672",

    ste_name: "CA",
  },
  {
    zip_code: "95823",

    ste_name: "CA",
  },
  {
    zip_code: "95920",

    ste_name: "CA",
  },
  {
    zip_code: "95965",

    ste_name: "CA",
  },
  {
    zip_code: "95975",

    ste_name: "CA",
  },
  {
    zip_code: "95978",

    ste_name: "CA",
  },
  {
    zip_code: "96044",

    ste_name: "CA",
  },
  {
    zip_code: "96046",

    ste_name: "CA",
  },
  {
    zip_code: "96049",

    ste_name: "CA",
  },
  {
    zip_code: "96075",

    ste_name: "CA",
  },
  {
    zip_code: "96092",

    ste_name: "CA",
  },
  {
    zip_code: "96126",

    ste_name: "CA",
  },
  {
    zip_code: "96729",

    ste_name: "HI",
  },
  {
    zip_code: "96916",

    ste_name: "GU",
  },
  {
    zip_code: "96952",

    ste_name: "MP",
  },
  {
    zip_code: "97042",

    ste_name: "OR",
  },
  {
    zip_code: "97128",

    ste_name: "OR",
  },
  {
    zip_code: "97204",

    ste_name: "OR",
  },
  {
    zip_code: "97333",

    ste_name: "OR",
  },
  {
    zip_code: "97366",

    ste_name: "OR",
  },
  {
    zip_code: "97437",

    ste_name: "OR",
  },
  {
    zip_code: "97443",

    ste_name: "OR",
  },
  {
    zip_code: "97722",

    ste_name: "OR",
  },
  {
    zip_code: "97733",

    ste_name: "OR",
  },
  {
    zip_code: "97735",

    ste_name: "OR",
  },
  {
    zip_code: "97741",

    ste_name: "OR",
  },
  {
    zip_code: "97869",

    ste_name: "OR",
  },
  {
    zip_code: "97883",

    ste_name: "OR",
  },
  {
    zip_code: "97909",

    ste_name: "OR",
  },
  {
    zip_code: "98019",

    ste_name: "WA",
  },
  {
    zip_code: "98118",

    ste_name: "WA",
  },
  {
    zip_code: "98256",

    ste_name: "WA",
  },
  {
    zip_code: "98272",

    ste_name: "WA",
  },
  {
    zip_code: "98279",

    ste_name: "WA",
  },
  {
    zip_code: "98311",

    ste_name: "WA",
  },
  {
    zip_code: "98323",

    ste_name: "WA",
  },
  {
    zip_code: "98351",

    ste_name: "WA",
  },
  {
    zip_code: "98359",

    ste_name: "WA",
  },
  {
    zip_code: "21651",

    ste_name: "MD",
  },
  {
    zip_code: "21660",

    ste_name: "MD",
  },
  {
    zip_code: "21663",

    ste_name: "MD",
  },
  {
    zip_code: "22312",

    ste_name: "VA",
  },
  {
    zip_code: "22406",

    ste_name: "VA",
  },
  {
    zip_code: "22436",

    ste_name: "VA",
  },
  {
    zip_code: "22643",

    ste_name: "VA",
  },
  {
    zip_code: "98408",

    ste_name: "WA",
  },
  {
    zip_code: "98433",

    ste_name: "WA",
  },
  {
    zip_code: "98446",

    ste_name: "WA",
  },
  {
    zip_code: "98571",

    ste_name: "WA",
  },
  {
    zip_code: "98595",

    ste_name: "WA",
  },
  {
    zip_code: "98626",

    ste_name: "WA",
  },
  {
    zip_code: "98639",

    ste_name: "WA",
  },
  {
    zip_code: "98645",

    ste_name: "WA",
  },
  {
    zip_code: "98648",

    ste_name: "WA",
  },
  {
    zip_code: "98649",

    ste_name: "WA",
  },
  {
    zip_code: "98821",

    ste_name: "WA",
  },
  {
    zip_code: "98933",

    ste_name: "WA",
  },
  {
    zip_code: "98941",

    ste_name: "WA",
  },
  {
    zip_code: "99001",

    ste_name: "WA",
  },
  {
    zip_code: "99005",

    ste_name: "WA",
  },
  {
    zip_code: "99022",

    ste_name: "WA",
  },
  {
    zip_code: "99037",

    ste_name: "WA",
  },
  {
    zip_code: "99117",

    ste_name: "WA",
  },
  {
    zip_code: "99140",

    ste_name: "WA",
  },
  {
    zip_code: "99163",

    ste_name: "WA",
  },
  {
    zip_code: "99333",

    ste_name: "WA",
  },
  {
    zip_code: "99547",

    ste_name: "AK",
  },
  {
    zip_code: "99569",

    ste_name: "AK",
  },
  {
    zip_code: "99668",

    ste_name: "AK",
  },
  {
    zip_code: "99703",

    ste_name: "AK",
  },
  {
    zip_code: "99714",

    ste_name: "AK",
  },
  {
    zip_code: "99721",

    ste_name: "AK",
  },
  {
    zip_code: "99727",

    ste_name: "AK",
  },
  {
    zip_code: "99736",

    ste_name: "AK",
  },
  {
    zip_code: "58789",

    ste_name: "ND",
  },
  {
    zip_code: "59050",

    ste_name: "MT",
  },
  {
    zip_code: "59055",

    ste_name: "MT",
  },
  {
    zip_code: "59065",

    ste_name: "MT",
  },
  {
    zip_code: "59257",

    ste_name: "MT",
  },
  {
    zip_code: "59259",

    ste_name: "MT",
  },
  {
    zip_code: "59336",

    ste_name: "MT",
  },
  {
    zip_code: "59349",

    ste_name: "MT",
  },
  {
    zip_code: "59422",

    ste_name: "MT",
  },
  {
    zip_code: "59480",

    ste_name: "MT",
  },
  {
    zip_code: "59546",

    ste_name: "MT",
  },
  {
    zip_code: "59721",

    ste_name: "MT",
  },
  {
    zip_code: "59728",

    ste_name: "MT",
  },
  {
    zip_code: "59824",

    ste_name: "MT",
  },
  {
    zip_code: "59923",

    ste_name: "MT",
  },
  {
    zip_code: "60016",

    ste_name: "IL",
  },
  {
    zip_code: "60033",

    ste_name: "IL",
  },
  {
    zip_code: "60043",

    ste_name: "IL",
  },
  {
    zip_code: "60143",

    ste_name: "IL",
  },
  {
    zip_code: "60153",

    ste_name: "IL",
  },
  {
    zip_code: "60154",

    ste_name: "IL",
  },
  {
    zip_code: "60177",

    ste_name: "IL",
  },
  {
    zip_code: "60416",

    ste_name: "IL",
  },
  {
    zip_code: "60423",

    ste_name: "IL",
  },
  {
    zip_code: "60428",

    ste_name: "IL",
  },
  {
    zip_code: "60438",

    ste_name: "IL",
  },
  {
    zip_code: "60472",

    ste_name: "IL",
  },
  {
    zip_code: "60526",

    ste_name: "IL",
  },
  {
    zip_code: "60557",

    ste_name: "IL",
  },
  {
    zip_code: "60561",

    ste_name: "IL",
  },
  {
    zip_code: "60601",

    ste_name: "IL",
  },
  {
    zip_code: "60630",

    ste_name: "IL",
  },
  {
    zip_code: "60640",

    ste_name: "IL",
  },
  {
    zip_code: "60922",

    ste_name: "IL",
  },
  {
    zip_code: "60950",

    ste_name: "IL",
  },
  {
    zip_code: "61032",

    ste_name: "IL",
  },
  {
    zip_code: "61275",

    ste_name: "IL",
  },
  {
    zip_code: "61345",

    ste_name: "IL",
  },
  {
    zip_code: "61416",

    ste_name: "IL",
  },
  {
    zip_code: "61448",

    ste_name: "IL",
  },
  {
    zip_code: "61731",

    ste_name: "IL",
  },
  {
    zip_code: "61759",

    ste_name: "IL",
  },
  {
    zip_code: "61761",

    ste_name: "IL",
  },
  {
    zip_code: "61858",

    ste_name: "IL",
  },
  {
    zip_code: "61936",

    ste_name: "IL",
  },
  {
    zip_code: "62010",

    ste_name: "IL",
  },
  {
    zip_code: "62018",

    ste_name: "IL",
  },
  {
    zip_code: "62077",

    ste_name: "IL",
  },
  {
    zip_code: "62215",

    ste_name: "IL",
  },
  {
    zip_code: "62225",

    ste_name: "IL",
  },
  {
    zip_code: "62326",

    ste_name: "IL",
  },
  {
    zip_code: "62353",

    ste_name: "IL",
  },
  {
    zip_code: "62376",

    ste_name: "IL",
  },
  {
    zip_code: "62414",

    ste_name: "IL",
  },
  {
    zip_code: "62426",

    ste_name: "IL",
  },
  {
    zip_code: "62445",

    ste_name: "IL",
  },
  {
    zip_code: "62512",

    ste_name: "IL",
  },
  {
    zip_code: "62517",

    ste_name: "IL",
  },
  {
    zip_code: "62627",

    ste_name: "IL",
  },
  {
    zip_code: "62691",

    ste_name: "IL",
  },
  {
    zip_code: "62803",

    ste_name: "IL",
  },
  {
    zip_code: "62817",

    ste_name: "IL",
  },
  {
    zip_code: "62828",

    ste_name: "IL",
  },
  {
    zip_code: "62884",

    ste_name: "IL",
  },
  {
    zip_code: "62902",

    ste_name: "IL",
  },
  {
    zip_code: "62922",

    ste_name: "IL",
  },
  {
    zip_code: "63303",

    ste_name: "MO",
  },
  {
    zip_code: "63343",

    ste_name: "MO",
  },
  {
    zip_code: "63453",

    ste_name: "MO",
  },
  {
    zip_code: "63531",

    ste_name: "MO",
  },
  {
    zip_code: "63532",

    ste_name: "MO",
  },
  {
    zip_code: "63541",

    ste_name: "MO",
  },
  {
    zip_code: "63660",

    ste_name: "MO",
  },
  {
    zip_code: "63826",

    ste_name: "MO",
  },
  {
    zip_code: "63834",

    ste_name: "MO",
  },
  {
    zip_code: "63846",

    ste_name: "MO",
  },
  {
    zip_code: "63882",

    ste_name: "MO",
  },
  {
    zip_code: "63936",

    ste_name: "MO",
  },
  {
    zip_code: "64098",

    ste_name: "MO",
  },
  {
    zip_code: "64112",

    ste_name: "MO",
  },
  {
    zip_code: "64137",

    ste_name: "MO",
  },
  {
    zip_code: "64424",

    ste_name: "MO",
  },
  {
    zip_code: "64433",

    ste_name: "MO",
  },
  {
    zip_code: "64458",

    ste_name: "MO",
  },
  {
    zip_code: "64461",

    ste_name: "MO",
  },
  {
    zip_code: "64491",

    ste_name: "MO",
  },
  {
    zip_code: "64497",

    ste_name: "MO",
  },
  {
    zip_code: "64625",

    ste_name: "MO",
  },
  {
    zip_code: "64630",

    ste_name: "MO",
  },
  {
    zip_code: "64724",

    ste_name: "MO",
  },
  {
    zip_code: "64733",

    ste_name: "MO",
  },
  {
    zip_code: "65010",

    ste_name: "MO",
  },
  {
    zip_code: "65050",

    ste_name: "MO",
  },
  {
    zip_code: "65058",

    ste_name: "MO",
  },
  {
    zip_code: "65077",

    ste_name: "MO",
  },
  {
    zip_code: "65244",

    ste_name: "MO",
  },
  {
    zip_code: "65284",

    ste_name: "MO",
  },
  {
    zip_code: "65438",

    ste_name: "MO",
  },
  {
    zip_code: "65468",

    ste_name: "MO",
  },
  {
    zip_code: "65613",

    ste_name: "MO",
  },
  {
    zip_code: "65646",

    ste_name: "MO",
  },
  {
    zip_code: "65680",

    ste_name: "MO",
  },
  {
    zip_code: "65738",

    ste_name: "MO",
  },
  {
    zip_code: "65807",

    ste_name: "MO",
  },
  {
    zip_code: "66060",

    ste_name: "KS",
  },
  {
    zip_code: "66075",

    ste_name: "KS",
  },
  {
    zip_code: "66092",

    ste_name: "KS",
  },
  {
    zip_code: "66418",

    ste_name: "KS",
  },
  {
    zip_code: "66516",

    ste_name: "KS",
  },
  {
    zip_code: "66717",

    ste_name: "KS",
  },
  {
    zip_code: "66760",

    ste_name: "KS",
  },
  {
    zip_code: "66945",

    ste_name: "KS",
  },
  {
    zip_code: "67019",

    ste_name: "KS",
  },
  {
    zip_code: "67020",

    ste_name: "KS",
  },
  {
    zip_code: "67056",

    ste_name: "KS",
  },
  {
    zip_code: "67118",

    ste_name: "KS",
  },
  {
    zip_code: "67425",

    ste_name: "KS",
  },
  {
    zip_code: "67458",

    ste_name: "KS",
  },
  {
    zip_code: "67626",

    ste_name: "KS",
  },
  {
    zip_code: "67674",

    ste_name: "KS",
  },
  {
    zip_code: "67758",

    ste_name: "KS",
  },
  {
    zip_code: "67761",

    ste_name: "KS",
  },
  {
    zip_code: "68028",

    ste_name: "NE",
  },
  {
    zip_code: "68107",

    ste_name: "NE",
  },
  {
    zip_code: "68147",

    ste_name: "NE",
  },
  {
    zip_code: "68325",

    ste_name: "NE",
  },
  {
    zip_code: "68341",

    ste_name: "NE",
  },
  {
    zip_code: "68410",

    ste_name: "NE",
  },
  {
    zip_code: "68503",

    ste_name: "NE",
  },
  {
    zip_code: "68641",

    ste_name: "NE",
  },
  {
    zip_code: "68741",

    ste_name: "NE",
  },
  {
    zip_code: "68747",

    ste_name: "NE",
  },
  {
    zip_code: "68771",

    ste_name: "NE",
  },
  {
    zip_code: "68789",

    ste_name: "NE",
  },
  {
    zip_code: "68929",

    ste_name: "NE",
  },
  {
    zip_code: "68966",

    ste_name: "NE",
  },
  {
    zip_code: "68976",

    ste_name: "NE",
  },
  {
    zip_code: "69022",

    ste_name: "NE",
  },
  {
    zip_code: "69026",

    ste_name: "NE",
  },
  {
    zip_code: "69034",

    ste_name: "NE",
  },
  {
    zip_code: "69128",

    ste_name: "NE",
  },
  {
    zip_code: "69155",

    ste_name: "NE",
  },
  {
    zip_code: "70072",

    ste_name: "LA",
  },
  {
    zip_code: "70090",

    ste_name: "LA",
  },
  {
    zip_code: "70115",

    ste_name: "LA",
  },
  {
    zip_code: "70126",

    ste_name: "LA",
  },
  {
    zip_code: "70342",

    ste_name: "LA",
  },
  {
    zip_code: "70442",

    ste_name: "LA",
  },
  {
    zip_code: "70523",

    ste_name: "LA",
  },
  {
    zip_code: "70535",

    ste_name: "LA",
  },
  {
    zip_code: "70549",

    ste_name: "LA",
  },
  {
    zip_code: "70643",

    ste_name: "LA",
  },
  {
    zip_code: "70647",

    ste_name: "LA",
  },
  {
    zip_code: "70648",

    ste_name: "LA",
  },
  {
    zip_code: "70715",

    ste_name: "LA",
  },
  {
    zip_code: "70763",

    ste_name: "LA",
  },
  {
    zip_code: "70801",

    ste_name: "LA",
  },
  {
    zip_code: "71052",

    ste_name: "LA",
  },
  {
    zip_code: "71101",

    ste_name: "LA",
  },
  {
    zip_code: "71222",

    ste_name: "LA",
  },
  {
    zip_code: "71327",

    ste_name: "LA",
  },
  {
    zip_code: "71339",

    ste_name: "LA",
  },
  {
    zip_code: "71350",

    ste_name: "LA",
  },
  {
    zip_code: "71360",

    ste_name: "LA",
  },
  {
    zip_code: "71417",

    ste_name: "LA",
  },
  {
    zip_code: "71454",

    ste_name: "LA",
  },
  {
    zip_code: "71658",

    ste_name: "AR",
  },
  {
    zip_code: "71820",

    ste_name: "AR",
  },
  {
    zip_code: "71846",

    ste_name: "AR",
  },
  {
    zip_code: "71945",

    ste_name: "AR",
  },
  {
    zip_code: "72128",

    ste_name: "AR",
  },
  {
    zip_code: "72132",

    ste_name: "AR",
  },
  {
    zip_code: "72170",

    ste_name: "AR",
  },
  {
    zip_code: "72175",

    ste_name: "AR",
  },
  {
    zip_code: "72320",

    ste_name: "AR",
  },
  {
    zip_code: "72325",

    ste_name: "AR",
  },
  {
    zip_code: "72332",

    ste_name: "AR",
  },
  {
    zip_code: "72364",

    ste_name: "AR",
  },
  {
    zip_code: "72365",

    ste_name: "AR",
  },
  {
    zip_code: "72394",

    ste_name: "AR",
  },
  {
    zip_code: "72628",

    ste_name: "AR",
  },
  {
    zip_code: "72662",

    ste_name: "AR",
  },
  {
    zip_code: "72753",

    ste_name: "AR",
  },
  {
    zip_code: "72758",

    ste_name: "AR",
  },
  {
    zip_code: "72821",

    ste_name: "AR",
  },
  {
    zip_code: "72928",

    ste_name: "AR",
  },
  {
    zip_code: "72946",

    ste_name: "AR",
  },
  {
    zip_code: "73002",

    ste_name: "OK",
  },
  {
    zip_code: "73006",

    ste_name: "OK",
  },
  {
    zip_code: "73030",

    ste_name: "OK",
  },
  {
    zip_code: "73059",

    ste_name: "OK",
  },
  {
    zip_code: "73097",

    ste_name: "OK",
  },
  {
    zip_code: "73159",

    ste_name: "OK",
  },
  {
    zip_code: "73507",

    ste_name: "OK",
  },
  {
    zip_code: "73553",

    ste_name: "OK",
  },
  {
    zip_code: "73620",

    ste_name: "OK",
  },
  {
    zip_code: "73666",

    ste_name: "OK",
  },
  {
    zip_code: "73701",

    ste_name: "OK",
  },
  {
    zip_code: "73801",

    ste_name: "OK",
  },
  {
    zip_code: "73851",

    ste_name: "OK",
  },
  {
    zip_code: "73858",

    ste_name: "OK",
  },
  {
    zip_code: "74044",

    ste_name: "OK",
  },
  {
    zip_code: "74053",

    ste_name: "OK",
  },
  {
    zip_code: "74105",

    ste_name: "OK",
  },
  {
    zip_code: "74423",

    ste_name: "OK",
  },
  {
    zip_code: "74427",

    ste_name: "OK",
  },
  {
    zip_code: "74555",

    ste_name: "OK",
  },
  {
    zip_code: "74631",

    ste_name: "OK",
  },
  {
    zip_code: "74740",

    ste_name: "OK",
  },
  {
    zip_code: "74873",

    ste_name: "OK",
  },
  {
    zip_code: "74939",

    ste_name: "OK",
  },
  {
    zip_code: "74944",

    ste_name: "OK",
  },
  {
    zip_code: "74951",

    ste_name: "OK",
  },
  {
    zip_code: "75090",

    ste_name: "TX",
  },
  {
    zip_code: "75207",

    ste_name: "TX",
  },
  {
    zip_code: "75208",

    ste_name: "TX",
  },
  {
    zip_code: "75270",

    ste_name: "TX",
  },
  {
    zip_code: "75433",

    ste_name: "TX",
  },
  {
    zip_code: "75436",

    ste_name: "TX",
  },
  {
    zip_code: "75447",

    ste_name: "TX",
  },
  {
    zip_code: "75473",

    ste_name: "TX",
  },
  {
    zip_code: "75571",

    ste_name: "TX",
  },
  {
    zip_code: "75640",

    ste_name: "TX",
  },
  {
    zip_code: "75667",

    ste_name: "TX",
  },
  {
    zip_code: "75755",

    ste_name: "TX",
  },
  {
    zip_code: "75832",

    ste_name: "TX",
  },
  {
    zip_code: "75844",

    ste_name: "TX",
  },
  {
    zip_code: "75860",

    ste_name: "TX",
  },
  {
    zip_code: "76013",

    ste_name: "TX",
  },
  {
    zip_code: "76028",

    ste_name: "TX",
  },
  {
    zip_code: "76035",

    ste_name: "TX",
  },
  {
    zip_code: "76127",

    ste_name: "TX",
  },
  {
    zip_code: "76249",

    ste_name: "TX",
  },
  {
    zip_code: "76268",

    ste_name: "TX",
  },
  {
    zip_code: "76430",

    ste_name: "TX",
  },
  {
    zip_code: "76466",

    ste_name: "TX",
  },
  {
    zip_code: "76469",

    ste_name: "TX",
  },
  {
    zip_code: "76481",

    ste_name: "TX",
  },
  {
    zip_code: "76561",

    ste_name: "TX",
  },
  {
    zip_code: "76666",

    ste_name: "TX",
  },
  {
    zip_code: "76667",

    ste_name: "TX",
  },
  {
    zip_code: "76710",

    ste_name: "TX",
  },
  {
    zip_code: "76827",

    ste_name: "TX",
  },
  {
    zip_code: "76842",

    ste_name: "TX",
  },
  {
    zip_code: "76854",

    ste_name: "TX",
  },
  {
    zip_code: "77044",

    ste_name: "TX",
  },
  {
    zip_code: "77072",

    ste_name: "TX",
  },
  {
    zip_code: "77351",

    ste_name: "TX",
  },
  {
    zip_code: "77354",

    ste_name: "TX",
  },
  {
    zip_code: "77414",

    ste_name: "TX",
  },
  {
    zip_code: "77430",

    ste_name: "TX",
  },
  {
    zip_code: "77451",

    ste_name: "TX",
  },
  {
    zip_code: "77477",

    ste_name: "TX",
  },
  {
    zip_code: "77547",

    ste_name: "TX",
  },
  {
    zip_code: "77703",

    ste_name: "TX",
  },
  {
    zip_code: "77706",

    ste_name: "TX",
  },
  {
    zip_code: "78012",

    ste_name: "TX",
  },
  {
    zip_code: "78024",

    ste_name: "TX",
  },
  {
    zip_code: "78107",

    ste_name: "TX",
  },
  {
    zip_code: "78133",

    ste_name: "TX",
  },
  {
    zip_code: "78204",

    ste_name: "TX",
  },
  {
    zip_code: "78227",

    ste_name: "TX",
  },
  {
    zip_code: "78238",

    ste_name: "TX",
  },
  {
    zip_code: "78243",

    ste_name: "TX",
  },
  {
    zip_code: "78374",

    ste_name: "TX",
  },
  {
    zip_code: "78409",

    ste_name: "TX",
  },
  {
    zip_code: "78535",

    ste_name: "TX",
  },
  {
    zip_code: "78538",

    ste_name: "TX",
  },
  {
    zip_code: "78539",

    ste_name: "TX",
  },
  {
    zip_code: "78552",

    ste_name: "TX",
  },
  {
    zip_code: "78558",

    ste_name: "TX",
  },
  {
    zip_code: "78565",

    ste_name: "TX",
  },
  {
    zip_code: "78609",

    ste_name: "TX",
  },
  {
    zip_code: "78703",

    ste_name: "TX",
  },
  {
    zip_code: "79022",

    ste_name: "TX",
  },
  {
    zip_code: "79056",

    ste_name: "TX",
  },
  {
    zip_code: "79091",

    ste_name: "TX",
  },
  {
    zip_code: "79225",

    ste_name: "TX",
  },
  {
    zip_code: "79233",

    ste_name: "TX",
  },
  {
    zip_code: "79372",

    ste_name: "TX",
  },
  {
    zip_code: "79373",

    ste_name: "TX",
  },
  {
    zip_code: "79414",

    ste_name: "TX",
  },
  {
    zip_code: "79528",

    ste_name: "TX",
  },
  {
    zip_code: "79545",

    ste_name: "TX",
  },
  {
    zip_code: "79566",

    ste_name: "TX",
  },
  {
    zip_code: "79705",

    ste_name: "TX",
  },
  {
    zip_code: "79713",

    ste_name: "TX",
  },
  {
    zip_code: "79743",

    ste_name: "TX",
  },
  {
    zip_code: "79749",

    ste_name: "TX",
  },
  {
    zip_code: "79752",

    ste_name: "TX",
  },
  {
    zip_code: "79777",

    ste_name: "TX",
  },
  {
    zip_code: "79907",

    ste_name: "TX",
  },
  {
    zip_code: "79935",

    ste_name: "TX",
  },
  {
    zip_code: "80022",

    ste_name: "CO",
  },
  {
    zip_code: "80111",

    ste_name: "CO",
  },
  {
    zip_code: "80135",

    ste_name: "CO",
  },
  {
    zip_code: "80226",

    ste_name: "CO",
  },
  {
    zip_code: "80434",

    ste_name: "CO",
  },
  {
    zip_code: "80438",

    ste_name: "CO",
  },
  {
    zip_code: "80461",

    ste_name: "CO",
  },
  {
    zip_code: "80511",

    ste_name: "CO",
  },
  {
    zip_code: "80535",

    ste_name: "CO",
  },
  {
    zip_code: "80622",

    ste_name: "CO",
  },
  {
    zip_code: "80750",

    ste_name: "CO",
  },
  {
    zip_code: "80864",

    ste_name: "CO",
  },
  {
    zip_code: "80905",

    ste_name: "CO",
  },
  {
    zip_code: "81137",

    ste_name: "CO",
  },
  {
    zip_code: "81138",

    ste_name: "CO",
  },
  {
    zip_code: "81253",

    ste_name: "CO",
  },
  {
    zip_code: "81401",

    ste_name: "CO",
  },
  {
    zip_code: "81527",

    ste_name: "CO",
  },
  {
    zip_code: "82061",

    ste_name: "WY",
  },
  {
    zip_code: "82332",

    ste_name: "WY",
  },
  {
    zip_code: "82435",

    ste_name: "WY",
  },
  {
    zip_code: "82630",

    ste_name: "WY",
  },
  {
    zip_code: "82642",

    ste_name: "WY",
  },
  {
    zip_code: "82648",

    ste_name: "WY",
  },
  {
    zip_code: "82834",

    ste_name: "WY",
  },
  {
    zip_code: "82837",

    ste_name: "WY",
  },
  {
    zip_code: "82901",

    ste_name: "WY",
  },
  {
    zip_code: "82923",

    ste_name: "WY",
  },
  {
    zip_code: "82933",

    ste_name: "WY",
  },
  {
    zip_code: "83013",

    ste_name: "WY",
  },
  {
    zip_code: "83238",

    ste_name: "ID",
  },
  {
    zip_code: "83277",

    ste_name: "ID",
  },
  {
    zip_code: "83346",

    ste_name: "ID",
  },
  {
    zip_code: "83638",

    ste_name: "ID",
  },
  {
    zip_code: "83810",

    ste_name: "ID",
  },
  {
    zip_code: "83837",

    ste_name: "ID",
  },
  {
    zip_code: "84049",

    ste_name: "UT",
  },
  {
    zip_code: "84055",

    ste_name: "UT",
  },
  {
    zip_code: "84082",

    ste_name: "UT",
  },
  {
    zip_code: "84102",

    ste_name: "UT",
  },
  {
    zip_code: "84327",

    ste_name: "UT",
  },
  {
    zip_code: "84522",

    ste_name: "UT",
  },
  {
    zip_code: "84633",

    ste_name: "UT",
  },
  {
    zip_code: "84643",

    ste_name: "UT",
  },
  {
    zip_code: "84657",

    ste_name: "UT",
  },
  {
    zip_code: "84701",

    ste_name: "UT",
  },
  {
    zip_code: "84749",

    ste_name: "UT",
  },
  {
    zip_code: "84754",

    ste_name: "UT",
  },
  {
    zip_code: "84765",

    ste_name: "UT",
  },
  {
    zip_code: "85041",

    ste_name: "AZ",
  },
  {
    zip_code: "85135",

    ste_name: "AZ",
  },
  {
    zip_code: "85145",

    ste_name: "AZ",
  },
  {
    zip_code: "85266",

    ste_name: "AZ",
  },
  {
    zip_code: "85334",

    ste_name: "AZ",
  },
  {
    zip_code: "85387",

    ste_name: "AZ",
  },
  {
    zip_code: "85747",

    ste_name: "AZ",
  },
  {
    zip_code: "86022",

    ste_name: "AZ",
  },
  {
    zip_code: "86044",

    ste_name: "AZ",
  },
  {
    zip_code: "86335",

    ste_name: "AZ",
  },
  {
    zip_code: "86434",

    ste_name: "AZ",
  },
  {
    zip_code: "86437",

    ste_name: "AZ",
  },
  {
    zip_code: "86441",

    ste_name: "AZ",
  },
  {
    zip_code: "87015",

    ste_name: "NM",
  },
  {
    zip_code: "87718",

    ste_name: "NM",
  },
  {
    zip_code: "87731",

    ste_name: "NM",
  },
  {
    zip_code: "87930",

    ste_name: "NM",
  },
  {
    zip_code: "88024",

    ste_name: "NM",
  },
  {
    zip_code: "88040",

    ste_name: "NM",
  },
  {
    zip_code: "88053",

    ste_name: "NM",
  },
  {
    zip_code: "88310",

    ste_name: "NM",
  },
  {
    zip_code: "88342",

    ste_name: "NM",
  },
  {
    zip_code: "89031",

    ste_name: "NV",
  },
  {
    zip_code: "89444",

    ste_name: "NV",
  },
  {
    zip_code: "89519",

    ste_name: "NV",
  },
  {
    zip_code: "89822",

    ste_name: "NV",
  },
  {
    zip_code: "637",

    ste_name: "PR",
  },
  {
    zip_code: "662",

    ste_name: "PR",
  },
  {
    zip_code: "692",

    ste_name: "PR",
  },
  {
    zip_code: "725",

    ste_name: "PR",
  },
  {
    zip_code: "784",

    ste_name: "PR",
  },
  {
    zip_code: "795",

    ste_name: "PR",
  },
  {
    zip_code: "951",

    ste_name: "PR",
  },
  {
    zip_code: "961",

    ste_name: "PR",
  },
  {
    zip_code: "987",

    ste_name: "PR",
  },
  {
    zip_code: "1020",

    ste_name: "MA",
  },
  {
    zip_code: "1075",

    ste_name: "MA",
  },
  {
    zip_code: "1096",

    ste_name: "MA",
  },
  {
    zip_code: "1243",

    ste_name: "MA",
  },
  {
    zip_code: "1267",

    ste_name: "MA",
  },
  {
    zip_code: "1605",

    ste_name: "MA",
  },
  {
    zip_code: "1720",

    ste_name: "MA",
  },
  {
    zip_code: "1742",

    ste_name: "MA",
  },
  {
    zip_code: "1760",

    ste_name: "MA",
  },
  {
    zip_code: "1776",

    ste_name: "MA",
  },
  {
    zip_code: "1833",

    ste_name: "MA",
  },
  {
    zip_code: "1844",

    ste_name: "MA",
  },
  {
    zip_code: "1851",

    ste_name: "MA",
  },
  {
    zip_code: "1938",

    ste_name: "MA",
  },
  {
    zip_code: "2116",

    ste_name: "MA",
  },
  {
    zip_code: "2127",

    ste_name: "MA",
  },
  {
    zip_code: "2356",

    ste_name: "MA",
  },
  {
    zip_code: "2421",

    ste_name: "MA",
  },
  {
    zip_code: "2556",

    ste_name: "MA",
  },
  {
    zip_code: "2576",

    ste_name: "MA",
  },
  {
    zip_code: "2657",

    ste_name: "MA",
  },
  {
    zip_code: "2670",

    ste_name: "MA",
  },
  {
    zip_code: "2770",

    ste_name: "MA",
  },
  {
    zip_code: "2831",

    ste_name: "RI",
  },
  {
    zip_code: "3047",

    ste_name: "NH",
  },
  {
    zip_code: "3225",

    ste_name: "NH",
  },
  {
    zip_code: "3256",

    ste_name: "NH",
  },
  {
    zip_code: "3257",

    ste_name: "NH",
  },
  {
    zip_code: "3287",

    ste_name: "NH",
  },
  {
    zip_code: "3836",

    ste_name: "NH",
  },
  {
    zip_code: "3852",

    ste_name: "NH",
  },
  {
    zip_code: "3906",

    ste_name: "ME",
  },
  {
    zip_code: "3911",

    ste_name: "ME",
  },
  {
    zip_code: "4228",

    ste_name: "ME",
  },
  {
    zip_code: "4270",

    ste_name: "ME",
  },
  {
    zip_code: "4294",

    ste_name: "ME",
  },
  {
    zip_code: "4346",

    ste_name: "ME",
  },
  {
    zip_code: "4418",

    ste_name: "ME",
  },
  {
    zip_code: "4430",

    ste_name: "ME",
  },
  {
    zip_code: "4444",

    ste_name: "ME",
  },
  {
    zip_code: "4461",

    ste_name: "ME",
  },
  {
    zip_code: "4481",

    ste_name: "ME",
  },
  {
    zip_code: "4537",

    ste_name: "ME",
  },
  {
    zip_code: "4555",

    ste_name: "ME",
  },
  {
    zip_code: "4612",

    ste_name: "ME",
  },
  {
    zip_code: "4664",

    ste_name: "ME",
  },
  {
    zip_code: "4852",

    ste_name: "ME",
  },
  {
    zip_code: "5037",

    ste_name: "VT",
  },
  {
    zip_code: "5081",

    ste_name: "VT",
  },
  {
    zip_code: "5086",

    ste_name: "VT",
  },
  {
    zip_code: "5146",

    ste_name: "VT",
  },
  {
    zip_code: "5353",

    ste_name: "VT",
  },
  {
    zip_code: "5361",

    ste_name: "VT",
  },
  {
    zip_code: "5682",

    ste_name: "VT",
  },
  {
    zip_code: "5902",

    ste_name: "VT",
  },
  {
    zip_code: "5905",

    ste_name: "VT",
  },
  {
    zip_code: "6002",

    ste_name: "CT",
  },
  {
    zip_code: "6058",

    ste_name: "CT",
  },
  {
    zip_code: "6063",

    ste_name: "CT",
  },
  {
    zip_code: "6093",

    ste_name: "CT",
  },
  {
    zip_code: "6096",

    ste_name: "CT",
  },
  {
    zip_code: "6118",

    ste_name: "CT",
  },
  {
    zip_code: "6235",

    ste_name: "CT",
  },
  {
    zip_code: "6281",

    ste_name: "CT",
  },
  {
    zip_code: "6353",

    ste_name: "CT",
  },
  {
    zip_code: "6409",

    ste_name: "CT",
  },
  {
    zip_code: "6510",

    ste_name: "CT",
  },
  {
    zip_code: "7103",

    ste_name: "NJ",
  },
  {
    zip_code: "7307",

    ste_name: "NJ",
  },
  {
    zip_code: "7311",

    ste_name: "NJ",
  },
  {
    zip_code: "7444",

    ste_name: "NJ",
  },
  {
    zip_code: "7462",

    ste_name: "NJ",
  },
  {
    zip_code: "7512",

    ste_name: "NJ",
  },
  {
    zip_code: "7722",

    ste_name: "NJ",
  },
  {
    zip_code: "7762",

    ste_name: "NJ",
  },
  {
    zip_code: "7853",

    ste_name: "NJ",
  },
  {
    zip_code: "7871",

    ste_name: "NJ",
  },
  {
    zip_code: "7933",

    ste_name: "NJ",
  },
  {
    zip_code: "7979",

    ste_name: "NJ",
  },
  {
    zip_code: "8022",

    ste_name: "NJ",
  },
  {
    zip_code: "8045",

    ste_name: "NJ",
  },
  {
    zip_code: "8051",

    ste_name: "NJ",
  },
  {
    zip_code: "8084",

    ste_name: "NJ",
  },
  {
    zip_code: "8103",

    ste_name: "NJ",
  },
  {
    zip_code: "8514",

    ste_name: "NJ",
  },
  {
    zip_code: "8527",

    ste_name: "NJ",
  },
  {
    zip_code: "8536",

    ste_name: "NJ",
  },
  {
    zip_code: "8610",

    ste_name: "NJ",
  },
  {
    zip_code: "8641",

    ste_name: "NJ",
  },
  {
    zip_code: "8755",

    ste_name: "NJ",
  },
  {
    zip_code: "8830",

    ste_name: "NJ",
  },
  {
    zip_code: "8904",

    ste_name: "NJ",
  },
  {
    zip_code: "10003",

    ste_name: "NY",
  },
  {
    zip_code: "10023",

    ste_name: "NY",
  },
  {
    zip_code: "10069",

    ste_name: "NY",
  },
  {
    zip_code: "10279",

    ste_name: "NY",
  },
  {
    zip_code: "10501",

    ste_name: "NY",
  },
  {
    zip_code: "10505",

    ste_name: "NY",
  },
  {
    zip_code: "10511",

    ste_name: "NY",
  },
  {
    zip_code: "10533",

    ste_name: "NY",
  },
  {
    zip_code: "10989",

    ste_name: "NY",
  },
  {
    zip_code: "10996",

    ste_name: "NY",
  },
  {
    zip_code: "11105",

    ste_name: "NY",
  },
  {
    zip_code: "11220",

    ste_name: "NY",
  },
  {
    zip_code: "11411",

    ste_name: "NY",
  },
  {
    zip_code: "11798",

    ste_name: "NY",
  },
  {
    zip_code: "11946",

    ste_name: "NY",
  },
  {
    zip_code: "12137",

    ste_name: "NY",
  },
  {
    zip_code: "12169",

    ste_name: "NY",
  },
  {
    zip_code: "12185",

    ste_name: "NY",
  },
  {
    zip_code: "12404",

    ste_name: "NY",
  },
  {
    zip_code: "12441",

    ste_name: "NY",
  },
  {
    zip_code: "12481",

    ste_name: "NY",
  },
  {
    zip_code: "12492",

    ste_name: "NY",
  },
  {
    zip_code: "12498",

    ste_name: "NY",
  },
  {
    zip_code: "12503",

    ste_name: "NY",
  },
  {
    zip_code: "12769",

    ste_name: "NY",
  },
  {
    zip_code: "12788",

    ste_name: "NY",
  },
  {
    zip_code: "13037",

    ste_name: "NY",
  },
  {
    zip_code: "13068",

    ste_name: "NY",
  },
  {
    zip_code: "13074",

    ste_name: "NY",
  },
  {
    zip_code: "13104",

    ste_name: "NY",
  },
  {
    zip_code: "13322",

    ste_name: "NY",
  },
  {
    zip_code: "13431",

    ste_name: "NY",
  },
  {
    zip_code: "13488",

    ste_name: "NY",
  },
  {
    zip_code: "13630",

    ste_name: "NY",
  },
  {
    zip_code: "13695",

    ste_name: "NY",
  },
  {
    zip_code: "13813",

    ste_name: "NY",
  },
  {
    zip_code: "13826",

    ste_name: "NY",
  },
  {
    zip_code: "13843",

    ste_name: "NY",
  },
  {
    zip_code: "13845",

    ste_name: "NY",
  },
  {
    zip_code: "14043",

    ste_name: "NY",
  },
  {
    zip_code: "14061",

    ste_name: "NY",
  },
  {
    zip_code: "14066",

    ste_name: "NY",
  },
  {
    zip_code: "14111",

    ste_name: "NY",
  },
  {
    zip_code: "14145",

    ste_name: "NY",
  },
  {
    zip_code: "14428",

    ste_name: "NY",
  },
  {
    zip_code: "14516",

    ste_name: "NY",
  },
  {
    zip_code: "14522",

    ste_name: "NY",
  },
  {
    zip_code: "14620",

    ste_name: "NY",
  },
  {
    zip_code: "14622",

    ste_name: "NY",
  },
  {
    zip_code: "14731",

    ste_name: "NY",
  },
  {
    zip_code: "14732",

    ste_name: "NY",
  },
  {
    zip_code: "14787",

    ste_name: "NY",
  },
  {
    zip_code: "14803",

    ste_name: "NY",
  },
  {
    zip_code: "14808",

    ste_name: "NY",
  },
  {
    zip_code: "14812",

    ste_name: "NY",
  },
  {
    zip_code: "14880",

    ste_name: "NY",
  },
  {
    zip_code: "14886",

    ste_name: "NY",
  },
  {
    zip_code: "14904",

    ste_name: "NY",
  },
  {
    zip_code: "15012",

    ste_name: "PA",
  },
  {
    zip_code: "15019",

    ste_name: "PA",
  },
  {
    zip_code: "15084",

    ste_name: "PA",
  },
  {
    zip_code: "15147",

    ste_name: "PA",
  },
  {
    zip_code: "15208",

    ste_name: "PA",
  },
  {
    zip_code: "15213",

    ste_name: "PA",
  },
  {
    zip_code: "15348",

    ste_name: "PA",
  },
  {
    zip_code: "15449",

    ste_name: "PA",
  },
  {
    zip_code: "15459",

    ste_name: "PA",
  },
  {
    zip_code: "15620",

    ste_name: "PA",
  },
  {
    zip_code: "15631",

    ste_name: "PA",
  },
  {
    zip_code: "15688",

    ste_name: "PA",
  },
  {
    zip_code: "15689",

    ste_name: "PA",
  },
  {
    zip_code: "15728",

    ste_name: "PA",
  },
  {
    zip_code: "15825",

    ste_name: "PA",
  },
  {
    zip_code: "15943",

    ste_name: "PA",
  },
  {
    zip_code: "15963",

    ste_name: "PA",
  },
  {
    zip_code: "16022",

    ste_name: "PA",
  },
  {
    zip_code: "16244",

    ste_name: "PA",
  },
  {
    zip_code: "16312",

    ste_name: "PA",
  },
  {
    zip_code: "16372",

    ste_name: "PA",
  },
  {
    zip_code: "16412",

    ste_name: "PA",
  },
  {
    zip_code: "16735",

    ste_name: "PA",
  },
  {
    zip_code: "16834",

    ste_name: "PA",
  },
  {
    zip_code: "16911",

    ste_name: "PA",
  },
  {
    zip_code: "17020",

    ste_name: "PA",
  },
  {
    zip_code: "17038",

    ste_name: "PA",
  },
  {
    zip_code: "17086",

    ste_name: "PA",
  },
  {
    zip_code: "17222",

    ste_name: "PA",
  },
  {
    zip_code: "17329",

    ste_name: "PA",
  },
  {
    zip_code: "17507",

    ste_name: "PA",
  },
  {
    zip_code: "17540",

    ste_name: "PA",
  },
  {
    zip_code: "17888",

    ste_name: "PA",
  },
  {
    zip_code: "17968",

    ste_name: "PA",
  },
  {
    zip_code: "18074",

    ste_name: "PA",
  },
  {
    zip_code: "18079",

    ste_name: "PA",
  },
  {
    zip_code: "18224",

    ste_name: "PA",
  },
  {
    zip_code: "18225",

    ste_name: "PA",
  },
  {
    zip_code: "18248",

    ste_name: "PA",
  },
  {
    zip_code: "18250",

    ste_name: "PA",
  },
  {
    zip_code: "18255",

    ste_name: "PA",
  },
  {
    zip_code: "18326",

    ste_name: "PA",
  },
  {
    zip_code: "18434",

    ste_name: "PA",
  },
  {
    zip_code: "18441",

    ste_name: "PA",
  },
  {
    zip_code: "18469",

    ste_name: "PA",
  },
  {
    zip_code: "18625",

    ste_name: "PA",
  },
  {
    zip_code: "18840",

    ste_name: "PA",
  },
  {
    zip_code: "18912",

    ste_name: "PA",
  },
  {
    zip_code: "18960",

    ste_name: "PA",
  },
  {
    zip_code: "18977",

    ste_name: "PA",
  },
  {
    zip_code: "19079",

    ste_name: "PA",
  },
  {
    zip_code: "19106",

    ste_name: "PA",
  },
  {
    zip_code: "19115",

    ste_name: "PA",
  },
  {
    zip_code: "19383",

    ste_name: "PA",
  },
  {
    zip_code: "19390",

    ste_name: "PA",
  },
  {
    zip_code: "19428",

    ste_name: "PA",
  },
  {
    zip_code: "19436",

    ste_name: "PA",
  },
  {
    zip_code: "19511",

    ste_name: "PA",
  },
  {
    zip_code: "19543",

    ste_name: "PA",
  },
  {
    zip_code: "19551",

    ste_name: "PA",
  },
  {
    zip_code: "19736",

    ste_name: "DE",
  },
  {
    zip_code: "19901",

    ste_name: "DE",
  },
  {
    zip_code: "19950",

    ste_name: "DE",
  },
  {
    zip_code: "20132",

    ste_name: "VA",
  },
  {
    zip_code: "20373",

    ste_name: "DC",
  },
  {
    zip_code: "20535",

    ste_name: "DC",
  },
  {
    zip_code: "20608",

    ste_name: "MD",
  },
  {
    zip_code: "20634",

    ste_name: "MD",
  },
  {
    zip_code: "20833",

    ste_name: "MD",
  },
  {
    zip_code: "21045",

    ste_name: "MD",
  },
  {
    zip_code: "21061",

    ste_name: "MD",
  },
  {
    zip_code: "21087",

    ste_name: "MD",
  },
  {
    zip_code: "21111",

    ste_name: "MD",
  },
  {
    zip_code: "21117",

    ste_name: "MD",
  },
  {
    zip_code: "21152",

    ste_name: "MD",
  },
  {
    zip_code: "21213",

    ste_name: "MD",
  },
  {
    zip_code: "21244",

    ste_name: "MD",
  },
  {
    zip_code: "21286",

    ste_name: "MD",
  },
  {
    zip_code: "21529",

    ste_name: "MD",
  },
  {
    zip_code: "21540",

    ste_name: "MD",
  },
  {
    zip_code: "22701",

    ste_name: "VA",
  },
  {
    zip_code: "22716",

    ste_name: "VA",
  },
  {
    zip_code: "22718",

    ste_name: "VA",
  },
  {
    zip_code: "22830",

    ste_name: "VA",
  },
  {
    zip_code: "22831",

    ste_name: "VA",
  },
  {
    zip_code: "22948",

    ste_name: "VA",
  },
  {
    zip_code: "23025",

    ste_name: "VA",
  },
  {
    zip_code: "23032",

    ste_name: "VA",
  },
  {
    zip_code: "23060",

    ste_name: "VA",
  },
  {
    zip_code: "23084",

    ste_name: "VA",
  },
  {
    zip_code: "23138",

    ste_name: "VA",
  },
  {
    zip_code: "23359",

    ste_name: "VA",
  },
  {
    zip_code: "23833",

    ste_name: "VA",
  },
  {
    zip_code: "24073",

    ste_name: "VA",
  },
  {
    zip_code: "24091",

    ste_name: "VA",
  },
  {
    zip_code: "24101",

    ste_name: "VA",
  },
  {
    zip_code: "24217",

    ste_name: "VA",
  },
  {
    zip_code: "24354",

    ste_name: "VA",
  },
  {
    zip_code: "24555",

    ste_name: "VA",
  },
  {
    zip_code: "24602",

    ste_name: "VA",
  },
  {
    zip_code: "24879",

    ste_name: "WV",
  },
  {
    zip_code: "24986",

    ste_name: "WV",
  },
  {
    zip_code: "25035",

    ste_name: "WV",
  },
  {
    zip_code: "25044",

    ste_name: "WV",
  },
  {
    zip_code: "25045",

    ste_name: "WV",
  },
  {
    zip_code: "25062",

    ste_name: "WV",
  },
  {
    zip_code: "25093",

    ste_name: "WV",
  },
  {
    zip_code: "25164",

    ste_name: "WV",
  },
  {
    zip_code: "25266",

    ste_name: "WV",
  },
  {
    zip_code: "25413",

    ste_name: "WV",
  },
  {
    zip_code: "25420",

    ste_name: "WV",
  },
  {
    zip_code: "25422",

    ste_name: "WV",
  },
  {
    zip_code: "25511",

    ste_name: "WV",
  },
  {
    zip_code: "25676",

    ste_name: "WV",
  },
  {
    zip_code: "25846",

    ste_name: "WV",
  },
  {
    zip_code: "25962",

    ste_name: "WV",
  },
  {
    zip_code: "25979",

    ste_name: "WV",
  },
  {
    zip_code: "26030",

    ste_name: "WV",
  },
  {
    zip_code: "26175",

    ste_name: "WV",
  },
  {
    zip_code: "26178",

    ste_name: "WV",
  },
  {
    zip_code: "26228",

    ste_name: "WV",
  },
  {
    zip_code: "26241",

    ste_name: "WV",
  },
  {
    zip_code: "26275",

    ste_name: "WV",
  },
  {
    zip_code: "26451",

    ste_name: "WV",
  },
  {
    zip_code: "26520",

    ste_name: "WV",
  },
  {
    zip_code: "26541",

    ste_name: "WV",
  },
  {
    zip_code: "26690",

    ste_name: "WV",
  },
  {
    zip_code: "26808",

    ste_name: "WV",
  },
  {
    zip_code: "27053",

    ste_name: "NC",
  },
  {
    zip_code: "27127",

    ste_name: "NC",
  },
  {
    zip_code: "27332",

    ste_name: "NC",
  },
  {
    zip_code: "27608",

    ste_name: "NC",
  },
  {
    zip_code: "27707",

    ste_name: "NC",
  },
  {
    zip_code: "27819",

    ste_name: "NC",
  },
  {
    zip_code: "27828",

    ste_name: "NC",
  },
  {
    zip_code: "27857",

    ste_name: "NC",
  },
  {
    zip_code: "27888",

    ste_name: "NC",
  },
  {
    zip_code: "27947",

    ste_name: "NC",
  },
  {
    zip_code: "27981",

    ste_name: "NC",
  },
  {
    zip_code: "28052",

    ste_name: "NC",
  },
  {
    zip_code: "28072",

    ste_name: "NC",
  },
  {
    zip_code: "28270",

    ste_name: "NC",
  },
  {
    zip_code: "28307",

    ste_name: "NC",
  },
  {
    zip_code: "28325",

    ste_name: "NC",
  },
  {
    zip_code: "28332",

    ste_name: "NC",
  },
  {
    zip_code: "28348",

    ste_name: "NC",
  },
  {
    zip_code: "28582",

    ste_name: "NC",
  },
  {
    zip_code: "28623",

    ste_name: "NC",
  },
  {
    zip_code: "28659",

    ste_name: "NC",
  },
  {
    zip_code: "28663",

    ste_name: "NC",
  },
  {
    zip_code: "28697",

    ste_name: "NC",
  },
  {
    zip_code: "28725",

    ste_name: "NC",
  },
  {
    zip_code: "28746",

    ste_name: "NC",
  },
  {
    zip_code: "28762",

    ste_name: "NC",
  },
  {
    zip_code: "28909",

    ste_name: "NC",
  },
  {
    zip_code: "29014",

    ste_name: "SC",
  },
  {
    zip_code: "29015",

    ste_name: "SC",
  },
  {
    zip_code: "29133",

    ste_name: "SC",
  },
  {
    zip_code: "29168",

    ste_name: "SC",
  },
  {
    zip_code: "29316",

    ste_name: "SC",
  },
  {
    zip_code: "29335",

    ste_name: "SC",
  },
  {
    zip_code: "29384",

    ste_name: "SC",
  },
  {
    zip_code: "29410",

    ste_name: "SC",
  },
  {
    zip_code: "29418",

    ste_name: "SC",
  },
  {
    zip_code: "29448",

    ste_name: "SC",
  },
  {
    zip_code: "29452",

    ste_name: "SC",
  },
  {
    zip_code: "29566",

    ste_name: "SC",
  },
  {
    zip_code: "29570",

    ste_name: "SC",
  },
  {
    zip_code: "29582",

    ste_name: "SC",
  },
  {
    zip_code: "29601",

    ste_name: "SC",
  },
  {
    zip_code: "29638",

    ste_name: "SC",
  },
  {
    zip_code: "29639",

    ste_name: "SC",
  },
  {
    zip_code: "29665",

    ste_name: "SC",
  },
  {
    zip_code: "29666",

    ste_name: "SC",
  },
  {
    zip_code: "29678",

    ste_name: "SC",
  },
  {
    zip_code: "29690",

    ste_name: "SC",
  },
  {
    zip_code: "29717",

    ste_name: "SC",
  },
  {
    zip_code: "30067",

    ste_name: "GA",
  },
  {
    zip_code: "30071",

    ste_name: "GA",
  },
  {
    zip_code: "30116",

    ste_name: "GA",
  },
  {
    zip_code: "30206",

    ste_name: "GA",
  },
  {
    zip_code: "30223",

    ste_name: "GA",
  },
  {
    zip_code: "30260",

    ste_name: "GA",
  },
  {
    zip_code: "30284",

    ste_name: "GA",
  },
  {
    zip_code: "30292",

    ste_name: "GA",
  },
  {
    zip_code: "30313",

    ste_name: "GA",
  },
  {
    zip_code: "30438",

    ste_name: "GA",
  },
  {
    zip_code: "30457",

    ste_name: "GA",
  },
  {
    zip_code: "30501",

    ste_name: "GA",
  },
  {
    zip_code: "30624",

    ste_name: "GA",
  },
  {
    zip_code: "30627",

    ste_name: "GA",
  },
  {
    zip_code: "30643",

    ste_name: "GA",
  },
  {
    zip_code: "58784",

    ste_name: "ND",
  },
  {
    zip_code: "59029",

    ste_name: "MT",
  },
  {
    zip_code: "59047",

    ste_name: "MT",
  },
  {
    zip_code: "59072",

    ste_name: "MT",
  },
  {
    zip_code: "59106",

    ste_name: "MT",
  },
  {
    zip_code: "59253",

    ste_name: "MT",
  },
  {
    zip_code: "59404",

    ste_name: "MT",
  },
  {
    zip_code: "59414",

    ste_name: "MT",
  },
  {
    zip_code: "59450",

    ste_name: "MT",
  },
  {
    zip_code: "59482",

    ste_name: "MT",
  },
  {
    zip_code: "59642",

    ste_name: "MT",
  },
  {
    zip_code: "59754",

    ste_name: "MT",
  },
  {
    zip_code: "60022",

    ste_name: "IL",
  },
  {
    zip_code: "60061",

    ste_name: "IL",
  },
  {
    zip_code: "60070",

    ste_name: "IL",
  },
  {
    zip_code: "60110",

    ste_name: "IL",
  },
  {
    zip_code: "60113",

    ste_name: "IL",
  },
  {
    zip_code: "60124",

    ste_name: "IL",
  },
  {
    zip_code: "60178",

    ste_name: "IL",
  },
  {
    zip_code: "60408",

    ste_name: "IL",
  },
  {
    zip_code: "60422",

    ste_name: "IL",
  },
  {
    zip_code: "60431",

    ste_name: "IL",
  },
  {
    zip_code: "60470",

    ste_name: "IL",
  },
  {
    zip_code: "60480",

    ste_name: "IL",
  },
  {
    zip_code: "60560",

    ste_name: "IL",
  },
  {
    zip_code: "60714",

    ste_name: "IL",
  },
  {
    zip_code: "60926",

    ste_name: "IL",
  },
  {
    zip_code: "60933",

    ste_name: "IL",
  },
  {
    zip_code: "60957",

    ste_name: "IL",
  },
  {
    zip_code: "61027",

    ste_name: "IL",
  },
  {
    zip_code: "61472",

    ste_name: "IL",
  },
  {
    zip_code: "61480",

    ste_name: "IL",
  },
  {
    zip_code: "61524",

    ste_name: "IL",
  },
  {
    zip_code: "61528",

    ste_name: "IL",
  },
  {
    zip_code: "61563",

    ste_name: "IL",
  },
  {
    zip_code: "61749",

    ste_name: "IL",
  },
  {
    zip_code: "62014",

    ste_name: "IL",
  },
  {
    zip_code: "62083",

    ste_name: "IL",
  },
  {
    zip_code: "62233",

    ste_name: "IL",
  },
  {
    zip_code: "62237",

    ste_name: "IL",
  },
  {
    zip_code: "62305",

    ste_name: "IL",
  },
  {
    zip_code: "62374",

    ste_name: "IL",
  },
  {
    zip_code: "62378",

    ste_name: "IL",
  },
  {
    zip_code: "62424",

    ste_name: "IL",
  },
  {
    zip_code: "62540",

    ste_name: "IL",
  },
  {
    zip_code: "62622",

    ste_name: "IL",
  },
  {
    zip_code: "62644",

    ste_name: "IL",
  },
  {
    zip_code: "62673",

    ste_name: "IL",
  },
  {
    zip_code: "62931",

    ste_name: "IL",
  },
  {
    zip_code: "62956",

    ste_name: "IL",
  },
  {
    zip_code: "62957",

    ste_name: "IL",
  },
  {
    zip_code: "62966",

    ste_name: "IL",
  },
  {
    zip_code: "62984",

    ste_name: "IL",
  },
  {
    zip_code: "63047",

    ste_name: "MO",
  },
  {
    zip_code: "63050",

    ste_name: "MO",
  },
  {
    zip_code: "63136",

    ste_name: "MO",
  },
  {
    zip_code: "63349",

    ste_name: "MO",
  },
  {
    zip_code: "63548",

    ste_name: "MO",
  },
  {
    zip_code: "63630",

    ste_name: "MO",
  },
  {
    zip_code: "63780",

    ste_name: "MO",
  },
  {
    zip_code: "63782",

    ste_name: "MO",
  },
  {
    zip_code: "63823",

    ste_name: "MO",
  },
  {
    zip_code: "63837",

    ste_name: "MO",
  },
  {
    zip_code: "63841",

    ste_name: "MO",
  },
  {
    zip_code: "63876",

    ste_name: "MO",
  },
  {
    zip_code: "63944",

    ste_name: "MO",
  },
  {
    zip_code: "64096",

    ste_name: "MO",
  },
  {
    zip_code: "64470",

    ste_name: "MO",
  },
  {
    zip_code: "64484",

    ste_name: "MO",
  },
  {
    zip_code: "64489",

    ste_name: "MO",
  },
  {
    zip_code: "64501",

    ste_name: "MO",
  },
  {
    zip_code: "64503",

    ste_name: "MO",
  },
  {
    zip_code: "64624",

    ste_name: "MO",
  },
  {
    zip_code: "64640",

    ste_name: "MO",
  },
  {
    zip_code: "64642",

    ste_name: "MO",
  },
  {
    zip_code: "64648",

    ste_name: "MO",
  },
  {
    zip_code: "64671",

    ste_name: "MO",
  },
  {
    zip_code: "64676",

    ste_name: "MO",
  },
  {
    zip_code: "64750",

    ste_name: "MO",
  },
  {
    zip_code: "64762",

    ste_name: "MO",
  },
  {
    zip_code: "64804",

    ste_name: "MO",
  },
  {
    zip_code: "65026",

    ste_name: "MO",
  },
  {
    zip_code: "65068",

    ste_name: "MO",
  },
  {
    zip_code: "65254",

    ste_name: "MO",
  },
  {
    zip_code: "65258",

    ste_name: "MO",
  },
  {
    zip_code: "65444",

    ste_name: "MO",
  },
  {
    zip_code: "65484",

    ste_name: "MO",
  },
  {
    zip_code: "65631",

    ste_name: "MO",
  },
  {
    zip_code: "65667",

    ste_name: "MO",
  },
  {
    zip_code: "65791",

    ste_name: "MO",
  },
  {
    zip_code: "66050",

    ste_name: "KS",
  },
  {
    zip_code: "66109",

    ste_name: "KS",
  },
  {
    zip_code: "66226",

    ste_name: "KS",
  },
  {
    zip_code: "66404",

    ste_name: "KS",
  },
  {
    zip_code: "66415",

    ste_name: "KS",
  },
  {
    zip_code: "66424",

    ste_name: "KS",
  },
  {
    zip_code: "66701",

    ste_name: "KS",
  },
  {
    zip_code: "66769",

    ste_name: "KS",
  },
  {
    zip_code: "66830",

    ste_name: "KS",
  },
  {
    zip_code: "66839",

    ste_name: "KS",
  },
  {
    zip_code: "66864",

    ste_name: "KS",
  },
  {
    zip_code: "66869",

    ste_name: "KS",
  },
  {
    zip_code: "66933",

    ste_name: "KS",
  },
  {
    zip_code: "67017",

    ste_name: "KS",
  },
  {
    zip_code: "67026",

    ste_name: "KS",
  },
  {
    zip_code: "67031",

    ste_name: "KS",
  },
  {
    zip_code: "67041",

    ste_name: "KS",
  },
  {
    zip_code: "67049",

    ste_name: "KS",
  },
  {
    zip_code: "67106",

    ste_name: "KS",
  },
  {
    zip_code: "67109",

    ste_name: "KS",
  },
  {
    zip_code: "67114",

    ste_name: "KS",
  },
  {
    zip_code: "67460",

    ste_name: "KS",
  },
  {
    zip_code: "67554",

    ste_name: "KS",
  },
  {
    zip_code: "67561",

    ste_name: "KS",
  },
  {
    zip_code: "67570",

    ste_name: "KS",
  },
  {
    zip_code: "67632",

    ste_name: "KS",
  },
  {
    zip_code: "67644",

    ste_name: "KS",
  },
  {
    zip_code: "67732",

    ste_name: "KS",
  },
  {
    zip_code: "67749",

    ste_name: "KS",
  },
  {
    zip_code: "67835",

    ste_name: "KS",
  },
  {
    zip_code: "67871",

    ste_name: "KS",
  },
  {
    zip_code: "67954",

    ste_name: "KS",
  },
  {
    zip_code: "68117",

    ste_name: "NE",
  },
  {
    zip_code: "68137",

    ste_name: "NE",
  },
  {
    zip_code: "68164",

    ste_name: "NE",
  },
  {
    zip_code: "68321",

    ste_name: "NE",
  },
  {
    zip_code: "68372",

    ste_name: "NE",
  },
  {
    zip_code: "68527",

    ste_name: "NE",
  },
  {
    zip_code: "68651",

    ste_name: "NE",
  },
  {
    zip_code: "68761",

    ste_name: "NE",
  },
  {
    zip_code: "68843",

    ste_name: "NE",
  },
  {
    zip_code: "68845",

    ste_name: "NE",
  },
  {
    zip_code: "68852",

    ste_name: "NE",
  },
  {
    zip_code: "68855",

    ste_name: "NE",
  },
  {
    zip_code: "68862",

    ste_name: "NE",
  },
  {
    zip_code: "68872",

    ste_name: "NE",
  },
  {
    zip_code: "68934",

    ste_name: "NE",
  },
  {
    zip_code: "68937",

    ste_name: "NE",
  },
  {
    zip_code: "68938",

    ste_name: "NE",
  },
  {
    zip_code: "69343",

    ste_name: "NE",
  },
  {
    zip_code: "70082",

    ste_name: "LA",
  },
  {
    zip_code: "70356",

    ste_name: "LA",
  },
  {
    zip_code: "70358",

    ste_name: "LA",
  },
  {
    zip_code: "70427",

    ste_name: "LA",
  },
  {
    zip_code: "70435",

    ste_name: "LA",
  },
  {
    zip_code: "70538",

    ste_name: "LA",
  },
  {
    zip_code: "70548",

    ste_name: "LA",
  },
  {
    zip_code: "70555",

    ste_name: "LA",
  },
  {
    zip_code: "70559",

    ste_name: "LA",
  },
  {
    zip_code: "70582",

    ste_name: "LA",
  },
  {
    zip_code: "70661",

    ste_name: "LA",
  },
  {
    zip_code: "70719",

    ste_name: "LA",
  },
  {
    zip_code: "70748",

    ste_name: "LA",
  },
  {
    zip_code: "70753",

    ste_name: "LA",
  },
  {
    zip_code: "71046",

    ste_name: "LA",
  },
  {
    zip_code: "71209",

    ste_name: "LA",
  },
  {
    zip_code: "71286",

    ste_name: "LA",
  },
  {
    zip_code: "71325",

    ste_name: "LA",
  },
  {
    zip_code: "71345",

    ste_name: "LA",
  },
  {
    zip_code: "71356",

    ste_name: "LA",
  },
  {
    zip_code: "71357",

    ste_name: "LA",
  },
  {
    zip_code: "71369",

    ste_name: "LA",
  },
  {
    zip_code: "71404",

    ste_name: "LA",
  },
  {
    zip_code: "71407",

    ste_name: "LA",
  },
  {
    zip_code: "71426",

    ste_name: "LA",
  },
  {
    zip_code: "71661",

    ste_name: "AR",
  },
  {
    zip_code: "71909",

    ste_name: "AR",
  },
  {
    zip_code: "71944",

    ste_name: "AR",
  },
  {
    zip_code: "71957",

    ste_name: "AR",
  },
  {
    zip_code: "72035",

    ste_name: "AR",
  },
  {
    zip_code: "72328",

    ste_name: "AR",
  },
  {
    zip_code: "72410",

    ste_name: "AR",
  },
  {
    zip_code: "72445",

    ste_name: "AR",
  },
  {
    zip_code: "72524",

    ste_name: "AR",
  },
  {
    zip_code: "72530",

    ste_name: "AR",
  },
  {
    zip_code: "72537",

    ste_name: "AR",
  },
  {
    zip_code: "72672",

    ste_name: "AR",
  },
  {
    zip_code: "72687",

    ste_name: "AR",
  },
  {
    zip_code: "72762",

    ste_name: "AR",
  },
  {
    zip_code: "72855",

    ste_name: "AR",
  },
  {
    zip_code: "73007",

    ste_name: "OK",
  },
  {
    zip_code: "73011",

    ste_name: "OK",
  },
  {
    zip_code: "73019",

    ste_name: "OK",
  },
  {
    zip_code: "73029",

    ste_name: "OK",
  },
  {
    zip_code: "73043",

    ste_name: "OK",
  },
  {
    zip_code: "73448",

    ste_name: "OK",
  },
  {
    zip_code: "73449",

    ste_name: "OK",
  },
  {
    zip_code: "73455",

    ste_name: "OK",
  },
  {
    zip_code: "73487",

    ste_name: "OK",
  },
  {
    zip_code: "73554",

    ste_name: "OK",
  },
  {
    zip_code: "73560",

    ste_name: "OK",
  },
  {
    zip_code: "73632",

    ste_name: "OK",
  },
  {
    zip_code: "73641",

    ste_name: "OK",
  },
  {
    zip_code: "73718",

    ste_name: "OK",
  },
  {
    zip_code: "73743",

    ste_name: "OK",
  },
  {
    zip_code: "73755",

    ste_name: "OK",
  },
  {
    zip_code: "74020",

    ste_name: "OK",
  },
  {
    zip_code: "74027",

    ste_name: "OK",
  },
  {
    zip_code: "74078",

    ste_name: "OK",
  },
  {
    zip_code: "74104",

    ste_name: "OK",
  },
  {
    zip_code: "74346",

    ste_name: "OK",
  },
  {
    zip_code: "74368",

    ste_name: "OK",
  },
  {
    zip_code: "74438",

    ste_name: "OK",
  },
  {
    zip_code: "74570",

    ste_name: "OK",
  },
  {
    zip_code: "74646",

    ste_name: "OK",
  },
  {
    zip_code: "74734",

    ste_name: "OK",
  },
  {
    zip_code: "74759",

    ste_name: "OK",
  },
  {
    zip_code: "74872",

    ste_name: "OK",
  },
  {
    zip_code: "75019",

    ste_name: "TX",
  },
  {
    zip_code: "75024",

    ste_name: "TX",
  },
  {
    zip_code: "75035",

    ste_name: "TX",
  },
  {
    zip_code: "75164",

    ste_name: "TX",
  },
  {
    zip_code: "75218",

    ste_name: "TX",
  },
  {
    zip_code: "75452",

    ste_name: "TX",
  },
  {
    zip_code: "75476",

    ste_name: "TX",
  },
  {
    zip_code: "75481",

    ste_name: "TX",
  },
  {
    zip_code: "75482",

    ste_name: "TX",
  },
  {
    zip_code: "75556",

    ste_name: "TX",
  },
  {
    zip_code: "75603",

    ste_name: "TX",
  },
  {
    zip_code: "75681",

    ste_name: "TX",
  },
  {
    zip_code: "75780",

    ste_name: "TX",
  },
  {
    zip_code: "75790",

    ste_name: "TX",
  },
  {
    zip_code: "75792",

    ste_name: "TX",
  },
  {
    zip_code: "75862",

    ste_name: "TX",
  },
  {
    zip_code: "76248",

    ste_name: "TX",
  },
  {
    zip_code: "76435",

    ste_name: "TX",
  },
  {
    zip_code: "76513",

    ste_name: "TX",
  },
  {
    zip_code: "76632",

    ste_name: "TX",
  },
  {
    zip_code: "76643",

    ste_name: "TX",
  },
  {
    zip_code: "76653",

    ste_name: "TX",
  },
  {
    zip_code: "77014",

    ste_name: "TX",
  },
  {
    zip_code: "77030",

    ste_name: "TX",
  },
  {
    zip_code: "77036",

    ste_name: "TX",
  },
  {
    zip_code: "77059",

    ste_name: "TX",
  },
  {
    zip_code: "77060",

    ste_name: "TX",
  },
  {
    zip_code: "77433",

    ste_name: "TX",
  },
  {
    zip_code: "77446",

    ste_name: "TX",
  },
  {
    zip_code: "77453",

    ste_name: "TX",
  },
  {
    zip_code: "77550",

    ste_name: "TX",
  },
  {
    zip_code: "77665",

    ste_name: "TX",
  },
  {
    zip_code: "77702",

    ste_name: "TX",
  },
  {
    zip_code: "77879",

    ste_name: "TX",
  },
  {
    zip_code: "78009",

    ste_name: "TX",
  },
  {
    zip_code: "78019",

    ste_name: "TX",
  },
  {
    zip_code: "78070",

    ste_name: "TX",
  },
  {
    zip_code: "78132",

    ste_name: "TX",
  },
  {
    zip_code: "78151",

    ste_name: "TX",
  },
  {
    zip_code: "78222",

    ste_name: "TX",
  },
  {
    zip_code: "78385",

    ste_name: "TX",
  },
  {
    zip_code: "78410",

    ste_name: "TX",
  },
  {
    zip_code: "78590",

    ste_name: "TX",
  },
  {
    zip_code: "78597",

    ste_name: "TX",
  },
  {
    zip_code: "78616",

    ste_name: "TX",
  },
  {
    zip_code: "78619",

    ste_name: "TX",
  },
  {
    zip_code: "78659",

    ste_name: "TX",
  },
  {
    zip_code: "78664",

    ste_name: "TX",
  },
  {
    zip_code: "78735",

    ste_name: "TX",
  },
  {
    zip_code: "78753",

    ste_name: "TX",
  },
  {
    zip_code: "78870",

    ste_name: "TX",
  },
  {
    zip_code: "78938",

    ste_name: "TX",
  },
  {
    zip_code: "79045",

    ste_name: "TX",
  },
  {
    zip_code: "79336",

    ste_name: "TX",
  },
  {
    zip_code: "79347",

    ste_name: "TX",
  },
  {
    zip_code: "79350",

    ste_name: "TX",
  },
  {
    zip_code: "79502",

    ste_name: "TX",
  },
  {
    zip_code: "79529",

    ste_name: "TX",
  },
  {
    zip_code: "79783",

    ste_name: "TX",
  },
  {
    zip_code: "79906",

    ste_name: "TX",
  },
  {
    zip_code: "79920",

    ste_name: "TX",
  },
  {
    zip_code: "79942",

    ste_name: "TX",
  },
  {
    zip_code: "80105",

    ste_name: "CO",
  },
  {
    zip_code: "80118",

    ste_name: "CO",
  },
  {
    zip_code: "80120",

    ste_name: "CO",
  },
  {
    zip_code: "80121",

    ste_name: "CO",
  },
  {
    zip_code: "80123",

    ste_name: "CO",
  },
  {
    zip_code: "80227",

    ste_name: "CO",
  },
  {
    zip_code: "80235",

    ste_name: "CO",
  },
  {
    zip_code: "80237",

    ste_name: "CO",
  },
  {
    zip_code: "80264",

    ste_name: "CO",
  },
  {
    zip_code: "80423",

    ste_name: "CO",
  },
  {
    zip_code: "80510",

    ste_name: "CO",
  },
  {
    zip_code: "80521",

    ste_name: "CO",
  },
  {
    zip_code: "80914",

    ste_name: "CO",
  },
  {
    zip_code: "80921",

    ste_name: "CO",
  },
  {
    zip_code: "81020",

    ste_name: "CO",
  },
  {
    zip_code: "81036",

    ste_name: "CO",
  },
  {
    zip_code: "81043",

    ste_name: "CO",
  },
  {
    zip_code: "81148",

    ste_name: "CO",
  },
  {
    zip_code: "81225",

    ste_name: "CO",
  },
  {
    zip_code: "81325",

    ste_name: "CO",
  },
  {
    zip_code: "81335",

    ste_name: "CO",
  },
  {
    zip_code: "81640",

    ste_name: "CO",
  },
  {
    zip_code: "82190",

    ste_name: "WY",
  },
  {
    zip_code: "82227",

    ste_name: "WY",
  },
  {
    zip_code: "82243",

    ste_name: "WY",
  },
  {
    zip_code: "82335",

    ste_name: "WY",
  },
  {
    zip_code: "82420",

    ste_name: "WY",
  },
  {
    zip_code: "82450",

    ste_name: "WY",
  },
  {
    zip_code: "82501",

    ste_name: "WY",
  },
  {
    zip_code: "82725",

    ste_name: "WY",
  },
  {
    zip_code: "82838",

    ste_name: "WY",
  },
  {
    zip_code: "82929",

    ste_name: "WY",
  },
  {
    zip_code: "83112",

    ste_name: "WY",
  },
  {
    zip_code: "83217",

    ste_name: "ID",
  },
  {
    zip_code: "83223",

    ste_name: "ID",
  },
  {
    zip_code: "83234",

    ste_name: "ID",
  },
  {
    zip_code: "83342",

    ste_name: "ID",
  },
  {
    zip_code: "83465",

    ste_name: "ID",
  },
  {
    zip_code: "83547",

    ste_name: "ID",
  },
  {
    zip_code: "83650",

    ste_name: "ID",
  },
  {
    zip_code: "83656",

    ste_name: "ID",
  },
  {
    zip_code: "83687",

    ste_name: "ID",
  },
  {
    zip_code: "83849",

    ste_name: "ID",
  },
  {
    zip_code: "84023",

    ste_name: "UT",
  },
  {
    zip_code: "84037",

    ste_name: "UT",
  },
  {
    zip_code: "84050",

    ste_name: "UT",
  },
  {
    zip_code: "84115",

    ste_name: "UT",
  },
  {
    zip_code: "84318",

    ste_name: "UT",
  },
  {
    zip_code: "84642",

    ste_name: "UT",
  },
  {
    zip_code: "84750",

    ste_name: "UT",
  },
  {
    zip_code: "84758",

    ste_name: "UT",
  },
  {
    zip_code: "84790",

    ste_name: "UT",
  },
  {
    zip_code: "85013",

    ste_name: "AZ",
  },
  {
    zip_code: "85042",

    ste_name: "AZ",
  },
  {
    zip_code: "85045",

    ste_name: "AZ",
  },
  {
    zip_code: "85123",

    ste_name: "AZ",
  },
  {
    zip_code: "85137",

    ste_name: "AZ",
  },
  {
    zip_code: "85324",

    ste_name: "AZ",
  },
  {
    zip_code: "85344",

    ste_name: "AZ",
  },
  {
    zip_code: "85348",

    ste_name: "AZ",
  },
  {
    zip_code: "85357",

    ste_name: "AZ",
  },
  {
    zip_code: "85381",

    ste_name: "AZ",
  },
  {
    zip_code: "85546",

    ste_name: "AZ",
  },
  {
    zip_code: "85551",

    ste_name: "AZ",
  },
  {
    zip_code: "85619",

    ste_name: "AZ",
  },
  {
    zip_code: "85736",

    ste_name: "AZ",
  },
  {
    zip_code: "86432",

    ste_name: "AZ",
  },
  {
    zip_code: "86442",

    ste_name: "AZ",
  },
  {
    zip_code: "86504",

    ste_name: "AZ",
  },
  {
    zip_code: "87023",

    ste_name: "NM",
  },
  {
    zip_code: "87036",

    ste_name: "NM",
  },
  {
    zip_code: "87415",

    ste_name: "NM",
  },
  {
    zip_code: "87508",

    ste_name: "NM",
  },
  {
    zip_code: "87567",

    ste_name: "NM",
  },
  {
    zip_code: "87732",

    ste_name: "NM",
  },
  {
    zip_code: "87935",

    ste_name: "NM",
  },
  {
    zip_code: "89012",

    ste_name: "NV",
  },
  {
    zip_code: "89043",

    ste_name: "NV",
  },
  {
    zip_code: "89109",

    ste_name: "NV",
  },
  {
    zip_code: "89404",

    ste_name: "NV",
  },
  {
    zip_code: "89427",

    ste_name: "NV",
  },
  {
    zip_code: "90024",

    ste_name: "CA",
  },
  {
    zip_code: "90059",

    ste_name: "CA",
  },
  {
    zip_code: "90068",

    ste_name: "CA",
  },
  {
    zip_code: "90220",

    ste_name: "CA",
  },
  {
    zip_code: "90232",

    ste_name: "CA",
  },
  {
    zip_code: "90248",

    ste_name: "CA",
  },
  {
    zip_code: "90277",

    ste_name: "CA",
  },
  {
    zip_code: "90503",

    ste_name: "CA",
  },
  {
    zip_code: "90604",

    ste_name: "CA",
  },
  {
    zip_code: "90631",

    ste_name: "CA",
  },
  {
    zip_code: "90732",

    ste_name: "CA",
  },
  {
    zip_code: "91302",

    ste_name: "CA",
  },
  {
    zip_code: "91364",

    ste_name: "CA",
  },
  {
    zip_code: "91423",

    ste_name: "CA",
  },
  {
    zip_code: "91701",

    ste_name: "CA",
  },
  {
    zip_code: "91784",

    ste_name: "CA",
  },
  {
    zip_code: "91917",

    ste_name: "CA",
  },
  {
    zip_code: "91977",

    ste_name: "CA",
  },
  {
    zip_code: "92121",

    ste_name: "CA",
  },
  {
    zip_code: "92277",

    ste_name: "CA",
  },
  {
    zip_code: "92324",

    ste_name: "CA",
  },
  {
    zip_code: "92866",

    ste_name: "CA",
  },
  {
    zip_code: "93021",

    ste_name: "CA",
  },
  {
    zip_code: "93207",

    ste_name: "CA",
  },
  {
    zip_code: "93215",

    ste_name: "CA",
  },
  {
    zip_code: "93291",

    ste_name: "CA",
  },
  {
    zip_code: "93401",

    ste_name: "CA",
  },
  {
    zip_code: "93562",

    ste_name: "CA",
  },
  {
    zip_code: "93625",

    ste_name: "CA",
  },
  {
    zip_code: "94086",

    ste_name: "CA",
  },
  {
    zip_code: "94404",

    ste_name: "CA",
  },
  {
    zip_code: "94526",

    ste_name: "CA",
  },
  {
    zip_code: "94528",

    ste_name: "CA",
  },
  {
    zip_code: "94556",

    ste_name: "CA",
  },
  {
    zip_code: "94582",

    ste_name: "CA",
  },
  {
    zip_code: "94950",

    ste_name: "CA",
  },
  {
    zip_code: "95127",

    ste_name: "CA",
  },
  {
    zip_code: "95207",

    ste_name: "CA",
  },
  {
    zip_code: "95223",

    ste_name: "CA",
  },
  {
    zip_code: "95230",

    ste_name: "CA",
  },
  {
    zip_code: "95313",

    ste_name: "CA",
  },
  {
    zip_code: "95335",

    ste_name: "CA",
  },
  {
    zip_code: "95338",

    ste_name: "CA",
  },
  {
    zip_code: "95351",

    ste_name: "CA",
  },
  {
    zip_code: "95422",

    ste_name: "CA",
  },
  {
    zip_code: "95427",

    ste_name: "CA",
  },
  {
    zip_code: "95437",

    ste_name: "CA",
  },
  {
    zip_code: "95450",

    ste_name: "CA",
  },
  {
    zip_code: "95536",

    ste_name: "CA",
  },
  {
    zip_code: "95587",

    ste_name: "CA",
  },
  {
    zip_code: "95623",

    ste_name: "CA",
  },
  {
    zip_code: "95642",

    ste_name: "CA",
  },
  {
    zip_code: "95650",

    ste_name: "CA",
  },
  {
    zip_code: "95681",

    ste_name: "CA",
  },
  {
    zip_code: "95687",

    ste_name: "CA",
  },
  {
    zip_code: "95697",

    ste_name: "CA",
  },
  {
    zip_code: "95941",

    ste_name: "CA",
  },
  {
    zip_code: "95963",

    ste_name: "CA",
  },
  {
    zip_code: "95986",

    ste_name: "CA",
  },
  {
    zip_code: "96011",

    ste_name: "CA",
  },
  {
    zip_code: "96027",

    ste_name: "CA",
  },
  {
    zip_code: "96034",

    ste_name: "CA",
  },
  {
    zip_code: "96121",

    ste_name: "CA",
  },
  {
    zip_code: "96719",

    ste_name: "HI",
  },
  {
    zip_code: "96921",

    ste_name: "GU",
  },
  {
    zip_code: "97102",

    ste_name: "OR",
  },
  {
    zip_code: "97109",

    ste_name: "OR",
  },
  {
    zip_code: "97112",

    ste_name: "OR",
  },
  {
    zip_code: "97113",

    ste_name: "OR",
  },
  {
    zip_code: "97133",

    ste_name: "OR",
  },
  {
    zip_code: "97148",

    ste_name: "OR",
  },
  {
    zip_code: "97210",

    ste_name: "OR",
  },
  {
    zip_code: "97224",

    ste_name: "OR",
  },
  {
    zip_code: "97301",

    ste_name: "OR",
  },
  {
    zip_code: "97302",

    ste_name: "OR",
  },
  {
    zip_code: "97376",

    ste_name: "OR",
  },
  {
    zip_code: "97381",

    ste_name: "OR",
  },
  {
    zip_code: "97430",

    ste_name: "OR",
  },
  {
    zip_code: "97444",

    ste_name: "OR",
  },
  {
    zip_code: "97452",

    ste_name: "OR",
  },
  {
    zip_code: "97462",

    ste_name: "OR",
  },
  {
    zip_code: "97495",

    ste_name: "OR",
  },
  {
    zip_code: "97501",

    ste_name: "OR",
  },
  {
    zip_code: "97601",

    ste_name: "OR",
  },
  {
    zip_code: "97641",

    ste_name: "OR",
  },
  {
    zip_code: "97843",

    ste_name: "OR",
  },
  {
    zip_code: "98154",

    ste_name: "WA",
  },
  {
    zip_code: "98208",

    ste_name: "WA",
  },
  {
    zip_code: "98220",

    ste_name: "WA",
  },
  {
    zip_code: "98244",

    ste_name: "WA",
  },
  {
    zip_code: "98362",

    ste_name: "WA",
  },
  {
    zip_code: "98387",

    ste_name: "WA",
  },
  {
    zip_code: "98499",

    ste_name: "WA",
  },
  {
    zip_code: "98532",

    ste_name: "WA",
  },
  {
    zip_code: "98536",

    ste_name: "WA",
  },
  {
    zip_code: "98570",

    ste_name: "WA",
  },
  {
    zip_code: "98590",

    ste_name: "WA",
  },
  {
    zip_code: "98611",

    ste_name: "WA",
  },
  {
    zip_code: "98619",

    ste_name: "WA",
  },
  {
    zip_code: "98620",

    ste_name: "WA",
  },
  {
    zip_code: "98629",

    ste_name: "WA",
  },
  {
    zip_code: "98663",

    ste_name: "WA",
  },
  {
    zip_code: "98851",

    ste_name: "WA",
  },
  {
    zip_code: "98932",

    ste_name: "WA",
  },
  {
    zip_code: "98937",

    ste_name: "WA",
  },
  {
    zip_code: "98947",

    ste_name: "WA",
  },
  {
    zip_code: "99323",

    ste_name: "WA",
  },
  {
    zip_code: "99337",

    ste_name: "WA",
  },
  {
    zip_code: "99609",

    ste_name: "AK",
  },
  {
    zip_code: "99645",

    ste_name: "AK",
  },
  {
    zip_code: "99760",

    ste_name: "AK",
  },
  {
    zip_code: "99765",

    ste_name: "AK",
  },
  {
    zip_code: "99771",

    ste_name: "AK",
  },
  {
    zip_code: "99781",

    ste_name: "AK",
  },
  {
    zip_code: "99903",

    ste_name: "AK",
  },
  {
    zip_code: "21048",

    ste_name: "MD",
  },
  {
    zip_code: "21053",

    ste_name: "MD",
  },
  {
    zip_code: "21146",

    ste_name: "MD",
  },
  {
    zip_code: "21562",

    ste_name: "MD",
  },
  {
    zip_code: "21601",

    ste_name: "MD",
  },
  {
    zip_code: "21853",

    ste_name: "MD",
  },
  {
    zip_code: "21918",

    ste_name: "MD",
  },
  {
    zip_code: "31031",

    ste_name: "GA",
  },
  {
    zip_code: "31775",

    ste_name: "GA",
  },
  {
    zip_code: "31778",

    ste_name: "GA",
  },
  {
    zip_code: "31804",

    ste_name: "GA",
  },
  {
    zip_code: "32181",

    ste_name: "FL",
  },
  {
    zip_code: "32228",

    ste_name: "FL",
  },
  {
    zip_code: "32246",

    ste_name: "FL",
  },
  {
    zip_code: "32254",

    ste_name: "FL",
  },
  {
    zip_code: "32332",

    ste_name: "FL",
  },
  {
    zip_code: "32714",

    ste_name: "FL",
  },
  {
    zip_code: "32726",

    ste_name: "FL",
  },
  {
    zip_code: "32751",

    ste_name: "FL",
  },
  {
    zip_code: "32903",

    ste_name: "FL",
  },
  {
    zip_code: "33004",

    ste_name: "FL",
  },
  {
    zip_code: "33063",

    ste_name: "FL",
  },
  {
    zip_code: "33176",

    ste_name: "FL",
  },
  {
    zip_code: "33326",

    ste_name: "FL",
  },
  {
    zip_code: "33331",

    ste_name: "FL",
  },
  {
    zip_code: "33418",

    ste_name: "FL",
  },
  {
    zip_code: "33446",

    ste_name: "FL",
  },
  {
    zip_code: "33570",

    ste_name: "FL",
  },
  {
    zip_code: "33629",

    ste_name: "FL",
  },
  {
    zip_code: "33703",

    ste_name: "FL",
  },
  {
    zip_code: "33707",

    ste_name: "FL",
  },
  {
    zip_code: "33815",

    ste_name: "FL",
  },
  {
    zip_code: "33847",

    ste_name: "FL",
  },
  {
    zip_code: "33904",

    ste_name: "FL",
  },
  {
    zip_code: "33935",

    ste_name: "FL",
  },
  {
    zip_code: "34219",

    ste_name: "FL",
  },
  {
    zip_code: "34473",

    ste_name: "FL",
  },
  {
    zip_code: "34480",

    ste_name: "FL",
  },
  {
    zip_code: "34683",

    ste_name: "FL",
  },
  {
    zip_code: "34785",

    ste_name: "FL",
  },
  {
    zip_code: "35553",

    ste_name: "AL",
  },
  {
    zip_code: "35570",

    ste_name: "AL",
  },
  {
    zip_code: "35577",

    ste_name: "AL",
  },
  {
    zip_code: "35584",

    ste_name: "AL",
  },
  {
    zip_code: "35613",

    ste_name: "AL",
  },
  {
    zip_code: "35645",

    ste_name: "AL",
  },
  {
    zip_code: "35760",

    ste_name: "AL",
  },
  {
    zip_code: "35805",

    ste_name: "AL",
  },
  {
    zip_code: "35811",

    ste_name: "AL",
  },
  {
    zip_code: "35824",

    ste_name: "AL",
  },
  {
    zip_code: "36025",

    ste_name: "AL",
  },
  {
    zip_code: "36343",

    ste_name: "AL",
  },
  {
    zip_code: "36467",

    ste_name: "AL",
  },
  {
    zip_code: "36523",

    ste_name: "AL",
  },
  {
    zip_code: "36571",

    ste_name: "AL",
  },
  {
    zip_code: "36758",

    ste_name: "AL",
  },
  {
    zip_code: "37037",

    ste_name: "TN",
  },
  {
    zip_code: "37076",

    ste_name: "TN",
  },
  {
    zip_code: "37326",

    ste_name: "TN",
  },
  {
    zip_code: "37339",

    ste_name: "TN",
  },
  {
    zip_code: "37406",

    ste_name: "TN",
  },
  {
    zip_code: "37722",

    ste_name: "TN",
  },
  {
    zip_code: "37748",

    ste_name: "TN",
  },
  {
    zip_code: "37777",

    ste_name: "TN",
  },
  {
    zip_code: "38050",

    ste_name: "TN",
  },
  {
    zip_code: "38079",

    ste_name: "TN",
  },
  {
    zip_code: "38117",

    ste_name: "TN",
  },
  {
    zip_code: "38224",

    ste_name: "TN",
  },
  {
    zip_code: "38225",

    ste_name: "TN",
  },
  {
    zip_code: "38321",

    ste_name: "TN",
  },
  {
    zip_code: "38343",

    ste_name: "TN",
  },
  {
    zip_code: "38552",

    ste_name: "TN",
  },
  {
    zip_code: "38619",

    ste_name: "MS",
  },
  {
    zip_code: "38642",

    ste_name: "MS",
  },
  {
    zip_code: "38676",

    ste_name: "MS",
  },
  {
    zip_code: "38746",

    ste_name: "MS",
  },
  {
    zip_code: "38759",

    ste_name: "MS",
  },
  {
    zip_code: "38945",

    ste_name: "MS",
  },
  {
    zip_code: "39038",

    ste_name: "MS",
  },
  {
    zip_code: "39047",

    ste_name: "MS",
  },
  {
    zip_code: "39079",

    ste_name: "MS",
  },
  {
    zip_code: "39116",

    ste_name: "MS",
  },
  {
    zip_code: "39305",

    ste_name: "MS",
  },
  {
    zip_code: "39327",

    ste_name: "MS",
  },
  {
    zip_code: "39356",

    ste_name: "MS",
  },
  {
    zip_code: "39443",

    ste_name: "MS",
  },
  {
    zip_code: "39507",

    ste_name: "MS",
  },
  {
    zip_code: "39834",

    ste_name: "GA",
  },
  {
    zip_code: "40040",

    ste_name: "KY",
  },
  {
    zip_code: "40052",

    ste_name: "KY",
  },
  {
    zip_code: "40055",

    ste_name: "KY",
  },
  {
    zip_code: "40056",

    ste_name: "KY",
  },
  {
    zip_code: "40146",

    ste_name: "KY",
  },
  {
    zip_code: "40155",

    ste_name: "KY",
  },
  {
    zip_code: "40505",

    ste_name: "KY",
  },
  {
    zip_code: "40807",

    ste_name: "KY",
  },
  {
    zip_code: "40823",

    ste_name: "KY",
  },
  {
    zip_code: "40843",

    ste_name: "KY",
  },
  {
    zip_code: "41052",

    ste_name: "KY",
  },
  {
    zip_code: "41055",

    ste_name: "KY",
  },
  {
    zip_code: "41168",

    ste_name: "KY",
  },
  {
    zip_code: "41238",

    ste_name: "KY",
  },
  {
    zip_code: "41557",

    ste_name: "KY",
  },
  {
    zip_code: "41667",

    ste_name: "KY",
  },
  {
    zip_code: "41712",

    ste_name: "KY",
  },
  {
    zip_code: "42031",

    ste_name: "KY",
  },
  {
    zip_code: "42083",

    ste_name: "KY",
  },
  {
    zip_code: "42217",

    ste_name: "KY",
  },
  {
    zip_code: "42265",

    ste_name: "KY",
  },
  {
    zip_code: "42344",

    ste_name: "KY",
  },
  {
    zip_code: "42347",

    ste_name: "KY",
  },
  {
    zip_code: "42411",

    ste_name: "KY",
  },
  {
    zip_code: "42431",

    ste_name: "KY",
  },
  {
    zip_code: "42565",

    ste_name: "KY",
  },
  {
    zip_code: "42649",

    ste_name: "KY",
  },
  {
    zip_code: "43021",

    ste_name: "OH",
  },
  {
    zip_code: "43026",

    ste_name: "OH",
  },
  {
    zip_code: "43062",

    ste_name: "OH",
  },
  {
    zip_code: "43065",

    ste_name: "OH",
  },
  {
    zip_code: "43070",

    ste_name: "OH",
  },
  {
    zip_code: "43119",

    ste_name: "OH",
  },
  {
    zip_code: "43138",

    ste_name: "OH",
  },
  {
    zip_code: "43155",

    ste_name: "OH",
  },
  {
    zip_code: "43231",

    ste_name: "OH",
  },
  {
    zip_code: "43316",

    ste_name: "OH",
  },
  {
    zip_code: "43320",

    ste_name: "OH",
  },
  {
    zip_code: "43342",

    ste_name: "OH",
  },
  {
    zip_code: "43357",

    ste_name: "OH",
  },
  {
    zip_code: "43527",

    ste_name: "OH",
  },
  {
    zip_code: "43723",

    ste_name: "OH",
  },
  {
    zip_code: "43746",

    ste_name: "OH",
  },
  {
    zip_code: "43777",

    ste_name: "OH",
  },
  {
    zip_code: "43961",

    ste_name: "OH",
  },
  {
    zip_code: "43968",

    ste_name: "OH",
  },
  {
    zip_code: "43972",

    ste_name: "OH",
  },
  {
    zip_code: "44050",

    ste_name: "OH",
  },
  {
    zip_code: "44124",

    ste_name: "OH",
  },
  {
    zip_code: "44139",

    ste_name: "OH",
  },
  {
    zip_code: "44230",

    ste_name: "OH",
  },
  {
    zip_code: "44253",

    ste_name: "OH",
  },
  {
    zip_code: "44302",

    ste_name: "OH",
  },
  {
    zip_code: "44311",

    ste_name: "OH",
  },
  {
    zip_code: "44428",

    ste_name: "OH",
  },
  {
    zip_code: "44443",

    ste_name: "OH",
  },
  {
    zip_code: "44470",

    ste_name: "OH",
  },
  {
    zip_code: "44709",

    ste_name: "OH",
  },
  {
    zip_code: "44714",

    ste_name: "OH",
  },
  {
    zip_code: "44836",

    ste_name: "OH",
  },
  {
    zip_code: "44847",

    ste_name: "OH",
  },
  {
    zip_code: "44905",

    ste_name: "OH",
  },
  {
    zip_code: "45014",

    ste_name: "OH",
  },
  {
    zip_code: "45033",

    ste_name: "OH",
  },
  {
    zip_code: "45122",

    ste_name: "OH",
  },
  {
    zip_code: "45224",

    ste_name: "OH",
  },
  {
    zip_code: "45317",

    ste_name: "OH",
  },
  {
    zip_code: "45337",

    ste_name: "OH",
  },
  {
    zip_code: "45459",

    ste_name: "OH",
  },
  {
    zip_code: "45624",

    ste_name: "OH",
  },
  {
    zip_code: "45628",

    ste_name: "OH",
  },
  {
    zip_code: "45682",

    ste_name: "OH",
  },
  {
    zip_code: "45694",

    ste_name: "OH",
  },
  {
    zip_code: "45766",

    ste_name: "OH",
  },
  {
    zip_code: "45866",

    ste_name: "OH",
  },
  {
    zip_code: "45876",

    ste_name: "OH",
  },
  {
    zip_code: "46062",

    ste_name: "IN",
  },
  {
    zip_code: "46172",

    ste_name: "IN",
  },
  {
    zip_code: "46348",

    ste_name: "IN",
  },
  {
    zip_code: "46349",

    ste_name: "IN",
  },
  {
    zip_code: "46360",

    ste_name: "IN",
  },
  {
    zip_code: "46544",

    ste_name: "IN",
  },
  {
    zip_code: "46635",

    ste_name: "IN",
  },
  {
    zip_code: "46737",

    ste_name: "IN",
  },
  {
    zip_code: "46747",

    ste_name: "IN",
  },
  {
    zip_code: "46994",

    ste_name: "IN",
  },
  {
    zip_code: "47001",

    ste_name: "IN",
  },
  {
    zip_code: "47040",

    ste_name: "IN",
  },
  {
    zip_code: "47166",

    ste_name: "IN",
  },
  {
    zip_code: "47263",

    ste_name: "IN",
  },
  {
    zip_code: "47274",

    ste_name: "IN",
  },
  {
    zip_code: "47374",

    ste_name: "IN",
  },
  {
    zip_code: "47403",

    ste_name: "IN",
  },
  {
    zip_code: "47454",

    ste_name: "IN",
  },
  {
    zip_code: "47462",

    ste_name: "IN",
  },
  {
    zip_code: "47522",

    ste_name: "IN",
  },
  {
    zip_code: "47968",

    ste_name: "IN",
  },
  {
    zip_code: "48095",

    ste_name: "MI",
  },
  {
    zip_code: "48201",

    ste_name: "MI",
  },
  {
    zip_code: "48206",

    ste_name: "MI",
  },
  {
    zip_code: "48335",

    ste_name: "MI",
  },
  {
    zip_code: "48367",

    ste_name: "MI",
  },
  {
    zip_code: "48437",

    ste_name: "MI",
  },
  {
    zip_code: "48453",

    ste_name: "MI",
  },
  {
    zip_code: "48466",

    ste_name: "MI",
  },
  {
    zip_code: "48631",

    ste_name: "MI",
  },
  {
    zip_code: "48662",

    ste_name: "MI",
  },
  {
    zip_code: "48667",

    ste_name: "MI",
  },
  {
    zip_code: "48705",

    ste_name: "MI",
  },
  {
    zip_code: "48730",

    ste_name: "MI",
  },
  {
    zip_code: "48848",

    ste_name: "MI",
  },
  {
    zip_code: "48896",

    ste_name: "MI",
  },
  {
    zip_code: "49095",

    ste_name: "MI",
  },
  {
    zip_code: "49238",

    ste_name: "MI",
  },
  {
    zip_code: "49265",

    ste_name: "MI",
  },
  {
    zip_code: "49288",

    ste_name: "MI",
  },
  {
    zip_code: "49306",

    ste_name: "MI",
  },
  {
    zip_code: "49419",

    ste_name: "MI",
  },
  {
    zip_code: "49509",

    ste_name: "MI",
  },
  {
    zip_code: "49519",

    ste_name: "MI",
  },
  {
    zip_code: "49619",

    ste_name: "MI",
  },
  {
    zip_code: "49625",

    ste_name: "MI",
  },
  {
    zip_code: "49632",

    ste_name: "MI",
  },
  {
    zip_code: "49651",

    ste_name: "MI",
  },
  {
    zip_code: "49710",

    ste_name: "MI",
  },
  {
    zip_code: "49726",

    ste_name: "MI",
  },
  {
    zip_code: "49752",

    ste_name: "MI",
  },
  {
    zip_code: "49760",

    ste_name: "MI",
  },
  {
    zip_code: "49765",

    ste_name: "MI",
  },
  {
    zip_code: "49769",

    ste_name: "MI",
  },
  {
    zip_code: "49826",

    ste_name: "MI",
  },
  {
    zip_code: "49872",

    ste_name: "MI",
  },
  {
    zip_code: "49876",

    ste_name: "MI",
  },
  {
    zip_code: "49903",

    ste_name: "MI",
  },
  {
    zip_code: "49905",

    ste_name: "MI",
  },
  {
    zip_code: "49919",

    ste_name: "MI",
  },
  {
    zip_code: "49920",

    ste_name: "MI",
  },
  {
    zip_code: "50014",

    ste_name: "IA",
  },
  {
    zip_code: "50074",

    ste_name: "IA",
  },
  {
    zip_code: "50142",

    ste_name: "IA",
  },
  {
    zip_code: "50161",

    ste_name: "IA",
  },
  {
    zip_code: "50225",

    ste_name: "IA",
  },
  {
    zip_code: "50265",

    ste_name: "IA",
  },
  {
    zip_code: "50566",

    ste_name: "IA",
  },
  {
    zip_code: "50604",

    ste_name: "IA",
  },
  {
    zip_code: "50605",

    ste_name: "IA",
  },
  {
    zip_code: "50668",

    ste_name: "IA",
  },
  {
    zip_code: "50672",

    ste_name: "IA",
  },
  {
    zip_code: "50862",

    ste_name: "IA",
  },
  {
    zip_code: "51011",

    ste_name: "IA",
  },
  {
    zip_code: "51052",

    ste_name: "IA",
  },
  {
    zip_code: "51247",

    ste_name: "IA",
  },
  {
    zip_code: "51331",

    ste_name: "IA",
  },
  {
    zip_code: "51632",

    ste_name: "IA",
  },
  {
    zip_code: "52030",

    ste_name: "IA",
  },
  {
    zip_code: "52035",

    ste_name: "IA",
  },
  {
    zip_code: "52040",

    ste_name: "IA",
  },
  {
    zip_code: "52132",

    ste_name: "IA",
  },
  {
    zip_code: "52136",

    ste_name: "IA",
  },
  {
    zip_code: "52165",

    ste_name: "IA",
  },
  {
    zip_code: "52246",

    ste_name: "IA",
  },
  {
    zip_code: "52306",

    ste_name: "IA",
  },
  {
    zip_code: "52555",

    ste_name: "IA",
  },
  {
    zip_code: "52572",

    ste_name: "IA",
  },
  {
    zip_code: "52577",

    ste_name: "IA",
  },
  {
    zip_code: "52626",

    ste_name: "IA",
  },
  {
    zip_code: "52649",

    ste_name: "IA",
  },
  {
    zip_code: "52737",

    ste_name: "IA",
  },
  {
    zip_code: "53047",

    ste_name: "WI",
  },
  {
    zip_code: "53080",

    ste_name: "WI",
  },
  {
    zip_code: "53125",

    ste_name: "WI",
  },
  {
    zip_code: "53172",

    ste_name: "WI",
  },
  {
    zip_code: "53505",

    ste_name: "WI",
  },
  {
    zip_code: "53523",

    ste_name: "WI",
  },
  {
    zip_code: "53594",

    ste_name: "WI",
  },
  {
    zip_code: "53597",

    ste_name: "WI",
  },
  {
    zip_code: "53714",

    ste_name: "WI",
  },
  {
    zip_code: "53939",

    ste_name: "WI",
  },
  {
    zip_code: "53944",

    ste_name: "WI",
  },
  {
    zip_code: "54020",

    ste_name: "WI",
  },
  {
    zip_code: "54169",

    ste_name: "WI",
  },
  {
    zip_code: "54440",

    ste_name: "WI",
  },
  {
    zip_code: "54465",

    ste_name: "WI",
  },
  {
    zip_code: "54527",

    ste_name: "WI",
  },
  {
    zip_code: "54536",

    ste_name: "WI",
  },
  {
    zip_code: "54642",

    ste_name: "WI",
  },
  {
    zip_code: "54821",

    ste_name: "WI",
  },
  {
    zip_code: "54836",

    ste_name: "WI",
  },
  {
    zip_code: "54862",

    ste_name: "WI",
  },
  {
    zip_code: "54864",

    ste_name: "WI",
  },
  {
    zip_code: "54923",

    ste_name: "WI",
  },
  {
    zip_code: "54943",

    ste_name: "WI",
  },
  {
    zip_code: "54964",

    ste_name: "WI",
  },
  {
    zip_code: "54986",

    ste_name: "WI",
  },
  {
    zip_code: "55019",

    ste_name: "MN",
  },
  {
    zip_code: "55024",

    ste_name: "MN",
  },
  {
    zip_code: "55372",

    ste_name: "MN",
  },
  {
    zip_code: "55403",

    ste_name: "MN",
  },
  {
    zip_code: "55405",

    ste_name: "MN",
  },
  {
    zip_code: "55455",

    ste_name: "MN",
  },
  {
    zip_code: "55725",

    ste_name: "MN",
  },
  {
    zip_code: "55726",

    ste_name: "MN",
  },
  {
    zip_code: "55807",

    ste_name: "MN",
  },
  {
    zip_code: "55814",

    ste_name: "MN",
  },
  {
    zip_code: "55991",

    ste_name: "MN",
  },
  {
    zip_code: "56047",

    ste_name: "MN",
  },
  {
    zip_code: "56056",

    ste_name: "MN",
  },
  {
    zip_code: "56111",

    ste_name: "MN",
  },
  {
    zip_code: "56137",

    ste_name: "MN",
  },
  {
    zip_code: "56149",

    ste_name: "MN",
  },
  {
    zip_code: "56230",

    ste_name: "MN",
  },
  {
    zip_code: "56237",

    ste_name: "MN",
  },
  {
    zip_code: "56274",

    ste_name: "MN",
  },
  {
    zip_code: "56444",

    ste_name: "MN",
  },
  {
    zip_code: "56522",

    ste_name: "MN",
  },
  {
    zip_code: "56565",

    ste_name: "MN",
  },
  {
    zip_code: "56686",

    ste_name: "MN",
  },
  {
    zip_code: "56725",

    ste_name: "MN",
  },
  {
    zip_code: "56726",

    ste_name: "MN",
  },
  {
    zip_code: "56762",

    ste_name: "MN",
  },
  {
    zip_code: "57043",

    ste_name: "SD",
  },
  {
    zip_code: "57068",

    ste_name: "SD",
  },
  {
    zip_code: "57072",

    ste_name: "SD",
  },
  {
    zip_code: "57325",

    ste_name: "SD",
  },
  {
    zip_code: "57342",

    ste_name: "SD",
  },
  {
    zip_code: "57362",

    ste_name: "SD",
  },
  {
    zip_code: "57401",

    ste_name: "SD",
  },
  {
    zip_code: "57552",

    ste_name: "SD",
  },
  {
    zip_code: "57633",

    ste_name: "SD",
  },
  {
    zip_code: "57636",

    ste_name: "SD",
  },
  {
    zip_code: "57658",

    ste_name: "SD",
  },
  {
    zip_code: "57725",

    ste_name: "SD",
  },
  {
    zip_code: "58017",

    ste_name: "ND",
  },
  {
    zip_code: "58029",

    ste_name: "ND",
  },
  {
    zip_code: "58203",

    ste_name: "ND",
  },
  {
    zip_code: "58212",

    ste_name: "ND",
  },
  {
    zip_code: "58214",

    ste_name: "ND",
  },
  {
    zip_code: "58261",

    ste_name: "ND",
  },
  {
    zip_code: "58317",

    ste_name: "ND",
  },
  {
    zip_code: "58381",

    ste_name: "ND",
  },
  {
    zip_code: "58420",

    ste_name: "ND",
  },
  {
    zip_code: "58558",

    ste_name: "ND",
  },
  {
    zip_code: "58642",

    ste_name: "ND",
  },
  {
    zip_code: "58705",

    ste_name: "ND",
  },
  {
    zip_code: "659",

    ste_name: "PR",
  },
  {
    zip_code: "680",

    ste_name: "PR",
  },
  {
    zip_code: "736",

    ste_name: "PR",
  },
  {
    zip_code: "1026",

    ste_name: "MA",
  },
  {
    zip_code: "1063",

    ste_name: "MA",
  },
  {
    zip_code: "1104",

    ste_name: "MA",
  },
  {
    zip_code: "1129",

    ste_name: "MA",
  },
  {
    zip_code: "1379",

    ste_name: "MA",
  },
  {
    zip_code: "1464",

    ste_name: "MA",
  },
  {
    zip_code: "1501",

    ste_name: "MA",
  },
  {
    zip_code: "1564",

    ste_name: "MA",
  },
  {
    zip_code: "1718",

    ste_name: "MA",
  },
  {
    zip_code: "1985",

    ste_name: "MA",
  },
  {
    zip_code: "2122",

    ste_name: "MA",
  },
  {
    zip_code: "2126",

    ste_name: "MA",
  },
  {
    zip_code: "2149",

    ste_name: "MA",
  },
  {
    zip_code: "2322",

    ste_name: "MA",
  },
  {
    zip_code: "2364",

    ste_name: "MA",
  },
  {
    zip_code: "2457",

    ste_name: "MA",
  },
  {
    zip_code: "2540",

    ste_name: "MA",
  },
  {
    zip_code: "2557",

    ste_name: "MA",
  },
  {
    zip_code: "2647",

    ste_name: "MA",
  },
  {
    zip_code: "2663",

    ste_name: "MA",
  },
  {
    zip_code: "2671",

    ste_name: "MA",
  },
  {
    zip_code: "2721",

    ste_name: "MA",
  },
  {
    zip_code: "2745",

    ste_name: "MA",
  },
  {
    zip_code: "2802",

    ste_name: "RI",
  },
  {
    zip_code: "3037",

    ste_name: "NH",
  },
  {
    zip_code: "3084",

    ste_name: "NH",
  },
  {
    zip_code: "3249",

    ste_name: "NH",
  },
  {
    zip_code: "3260",

    ste_name: "NH",
  },
  {
    zip_code: "3261",

    ste_name: "NH",
  },
  {
    zip_code: "3273",

    ste_name: "NH",
  },
  {
    zip_code: "3446",

    ste_name: "NH",
  },
  {
    zip_code: "3570",

    ste_name: "NH",
  },
  {
    zip_code: "3574",

    ste_name: "NH",
  },
  {
    zip_code: "3609",

    ste_name: "NH",
  },
  {
    zip_code: "3766",

    ste_name: "NH",
  },
  {
    zip_code: "3811",

    ste_name: "NH",
  },
  {
    zip_code: "3844",

    ste_name: "NH",
  },
  {
    zip_code: "3849",

    ste_name: "NH",
  },
  {
    zip_code: "3860",

    ste_name: "NH",
  },
  {
    zip_code: "3904",

    ste_name: "ME",
  },
  {
    zip_code: "3905",

    ste_name: "ME",
  },
  {
    zip_code: "4022",

    ste_name: "ME",
  },
  {
    zip_code: "4037",

    ste_name: "ME",
  },
  {
    zip_code: "4226",

    ste_name: "ME",
  },
  {
    zip_code: "4236",

    ste_name: "ME",
  },
  {
    zip_code: "4263",

    ste_name: "ME",
  },
  {
    zip_code: "4330",

    ste_name: "ME",
  },
  {
    zip_code: "4353",

    ste_name: "ME",
  },
  {
    zip_code: "4459",

    ste_name: "ME",
  },
  {
    zip_code: "4492",

    ste_name: "ME",
  },
  {
    zip_code: "4574",

    ste_name: "ME",
  },
  {
    zip_code: "4653",

    ste_name: "ME",
  },
  {
    zip_code: "4761",

    ste_name: "ME",
  },
  {
    zip_code: "4912",

    ste_name: "ME",
  },
  {
    zip_code: "5033",

    ste_name: "VT",
  },
  {
    zip_code: "5342",

    ste_name: "VT",
  },
  {
    zip_code: "5408",

    ste_name: "VT",
  },
  {
    zip_code: "5730",

    ste_name: "VT",
  },
  {
    zip_code: "5753",

    ste_name: "VT",
  },
  {
    zip_code: "5821",

    ste_name: "VT",
  },
  {
    zip_code: "5830",

    ste_name: "VT",
  },
  {
    zip_code: "6042",

    ste_name: "CT",
  },
  {
    zip_code: "6088",

    ste_name: "CT",
  },
  {
    zip_code: "6089",

    ste_name: "CT",
  },
  {
    zip_code: "6237",

    ste_name: "CT",
  },
  {
    zip_code: "6241",

    ste_name: "CT",
  },
  {
    zip_code: "6266",

    ste_name: "CT",
  },
  {
    zip_code: "6340",

    ste_name: "CT",
  },
  {
    zip_code: "6437",

    ste_name: "CT",
  },
  {
    zip_code: "6482",

    ste_name: "CT",
  },
  {
    zip_code: "6484",

    ste_name: "CT",
  },
  {
    zip_code: "6830",

    ste_name: "CT",
  },
  {
    zip_code: "7011",

    ste_name: "NJ",
  },
  {
    zip_code: "7034",

    ste_name: "NJ",
  },
  {
    zip_code: "7058",

    ste_name: "NJ",
  },
  {
    zip_code: "7060",

    ste_name: "NJ",
  },
  {
    zip_code: "7064",

    ste_name: "NJ",
  },
  {
    zip_code: "7065",

    ste_name: "NJ",
  },
  {
    zip_code: "7522",

    ste_name: "NJ",
  },
  {
    zip_code: "7644",

    ste_name: "NJ",
  },
  {
    zip_code: "7656",

    ste_name: "NJ",
  },
  {
    zip_code: "7661",

    ste_name: "NJ",
  },
  {
    zip_code: "7719",

    ste_name: "NJ",
  },
  {
    zip_code: "7836",

    ste_name: "NJ",
  },
  {
    zip_code: "8090",

    ste_name: "NJ",
  },
  {
    zip_code: "8091",

    ste_name: "NJ",
  },
  {
    zip_code: "8092",

    ste_name: "NJ",
  },
  {
    zip_code: "8095",

    ste_name: "NJ",
  },
  {
    zip_code: "8221",

    ste_name: "NJ",
  },
  {
    zip_code: "8251",

    ste_name: "NJ",
  },
  {
    zip_code: "8691",

    ste_name: "NJ",
  },
  {
    zip_code: "8730",

    ste_name: "NJ",
  },
  {
    zip_code: "8750",

    ste_name: "NJ",
  },
  {
    zip_code: "8758",

    ste_name: "NJ",
  },
  {
    zip_code: "10031",

    ste_name: "NY",
  },
  {
    zip_code: "10112",

    ste_name: "NY",
  },
  {
    zip_code: "10199",

    ste_name: "NY",
  },
  {
    zip_code: "10301",

    ste_name: "NY",
  },
  {
    zip_code: "10454",

    ste_name: "NY",
  },
  {
    zip_code: "10456",

    ste_name: "NY",
  },
  {
    zip_code: "10459",

    ste_name: "NY",
  },
  {
    zip_code: "10538",

    ste_name: "NY",
  },
  {
    zip_code: "10588",

    ste_name: "NY",
  },
  {
    zip_code: "10604",

    ste_name: "NY",
  },
  {
    zip_code: "10605",

    ste_name: "NY",
  },
  {
    zip_code: "10607",

    ste_name: "NY",
  },
  {
    zip_code: "10969",

    ste_name: "NY",
  },
  {
    zip_code: "10998",

    ste_name: "NY",
  },
  {
    zip_code: "11211",

    ste_name: "NY",
  },
  {
    zip_code: "11363",

    ste_name: "NY",
  },
  {
    zip_code: "11717",

    ste_name: "NY",
  },
  {
    zip_code: "11764",

    ste_name: "NY",
  },
  {
    zip_code: "11803",

    ste_name: "NY",
  },
  {
    zip_code: "12017",

    ste_name: "NY",
  },
  {
    zip_code: "12084",

    ste_name: "NY",
  },
  {
    zip_code: "12117",

    ste_name: "NY",
  },
  {
    zip_code: "12139",

    ste_name: "NY",
  },
  {
    zip_code: "12153",

    ste_name: "NY",
  },
  {
    zip_code: "12493",

    ste_name: "NY",
  },
  {
    zip_code: "12569",

    ste_name: "NY",
  },
  {
    zip_code: "12946",

    ste_name: "NY",
  },
  {
    zip_code: "12972",

    ste_name: "NY",
  },
  {
    zip_code: "13083",

    ste_name: "NY",
  },
  {
    zip_code: "13088",

    ste_name: "NY",
  },
  {
    zip_code: "13162",

    ste_name: "NY",
  },
  {
    zip_code: "13313",

    ste_name: "NY",
  },
  {
    zip_code: "13326",

    ste_name: "NY",
  },
  {
    zip_code: "13327",

    ste_name: "NY",
  },
  {
    zip_code: "13428",

    ste_name: "NY",
  },
  {
    zip_code: "13494",

    ste_name: "NY",
  },
  {
    zip_code: "13638",

    ste_name: "NY",
  },
  {
    zip_code: "13739",

    ste_name: "NY",
  },
  {
    zip_code: "14005",

    ste_name: "NY",
  },
  {
    zip_code: "14024",

    ste_name: "NY",
  },
  {
    zip_code: "14067",

    ste_name: "NY",
  },
  {
    zip_code: "14129",

    ste_name: "NY",
  },
  {
    zip_code: "14215",

    ste_name: "NY",
  },
  {
    zip_code: "14222",

    ste_name: "NY",
  },
  {
    zip_code: "14425",

    ste_name: "NY",
  },
  {
    zip_code: "14433",

    ste_name: "NY",
  },
  {
    zip_code: "14437",

    ste_name: "NY",
  },
  {
    zip_code: "14476",

    ste_name: "NY",
  },
  {
    zip_code: "14615",

    ste_name: "NY",
  },
  {
    zip_code: "14735",

    ste_name: "NY",
  },
  {
    zip_code: "14822",

    ste_name: "NY",
  },
  {
    zip_code: "14824",

    ste_name: "NY",
  },
  {
    zip_code: "14855",

    ste_name: "NY",
  },
  {
    zip_code: "15020",

    ste_name: "PA",
  },
  {
    zip_code: "15024",

    ste_name: "PA",
  },
  {
    zip_code: "15083",

    ste_name: "PA",
  },
  {
    zip_code: "15331",

    ste_name: "PA",
  },
  {
    zip_code: "15442",

    ste_name: "PA",
  },
  {
    zip_code: "15451",

    ste_name: "PA",
  },
  {
    zip_code: "15477",

    ste_name: "PA",
  },
  {
    zip_code: "15546",

    ste_name: "PA",
  },
  {
    zip_code: "15622",

    ste_name: "PA",
  },
  {
    zip_code: "15661",

    ste_name: "PA",
  },
  {
    zip_code: "15662",

    ste_name: "PA",
  },
  {
    zip_code: "15741",

    ste_name: "PA",
  },
  {
    zip_code: "15750",

    ste_name: "PA",
  },
  {
    zip_code: "15780",

    ste_name: "PA",
  },
  {
    zip_code: "15827",

    ste_name: "PA",
  },
  {
    zip_code: "15849",

    ste_name: "PA",
  },
  {
    zip_code: "15902",

    ste_name: "PA",
  },
  {
    zip_code: "15930",

    ste_name: "PA",
  },
  {
    zip_code: "16002",

    ste_name: "PA",
  },
  {
    zip_code: "16023",

    ste_name: "PA",
  },
  {
    zip_code: "16027",

    ste_name: "PA",
  },
  {
    zip_code: "16150",

    ste_name: "PA",
  },
  {
    zip_code: "16226",

    ste_name: "PA",
  },
  {
    zip_code: "16229",

    ste_name: "PA",
  },
  {
    zip_code: "16317",

    ste_name: "PA",
  },
  {
    zip_code: "16371",

    ste_name: "PA",
  },
  {
    zip_code: "16433",

    ste_name: "PA",
  },
  {
    zip_code: "16435",

    ste_name: "PA",
  },
  {
    zip_code: "16436",

    ste_name: "PA",
  },
  {
    zip_code: "16647",

    ste_name: "PA",
  },
  {
    zip_code: "16683",

    ste_name: "PA",
  },
  {
    zip_code: "16691",

    ste_name: "PA",
  },
  {
    zip_code: "16915",

    ste_name: "PA",
  },
  {
    zip_code: "16935",

    ste_name: "PA",
  },
  {
    zip_code: "17002",

    ste_name: "PA",
  },
  {
    zip_code: "17009",

    ste_name: "PA",
  },
  {
    zip_code: "17019",

    ste_name: "PA",
  },
  {
    zip_code: "17076",

    ste_name: "PA",
  },
  {
    zip_code: "17097",

    ste_name: "PA",
  },
  {
    zip_code: "17224",

    ste_name: "PA",
  },
  {
    zip_code: "17246",

    ste_name: "PA",
  },
  {
    zip_code: "17252",

    ste_name: "PA",
  },
  {
    zip_code: "17508",

    ste_name: "PA",
  },
  {
    zip_code: "17569",

    ste_name: "PA",
  },
  {
    zip_code: "17745",

    ste_name: "PA",
  },
  {
    zip_code: "17824",

    ste_name: "PA",
  },
  {
    zip_code: "17856",

    ste_name: "PA",
  },
  {
    zip_code: "17857",

    ste_name: "PA",
  },
  {
    zip_code: "17920",

    ste_name: "PA",
  },
  {
    zip_code: "17933",

    ste_name: "PA",
  },
  {
    zip_code: "17951",

    ste_name: "PA",
  },
  {
    zip_code: "18052",

    ste_name: "PA",
  },
  {
    zip_code: "18054",

    ste_name: "PA",
  },
  {
    zip_code: "18073",

    ste_name: "PA",
  },
  {
    zip_code: "18088",

    ste_name: "PA",
  },
  {
    zip_code: "18102",

    ste_name: "PA",
  },
  {
    zip_code: "18210",

    ste_name: "PA",
  },
  {
    zip_code: "18235",

    ste_name: "PA",
  },
  {
    zip_code: "18302",

    ste_name: "PA",
  },
  {
    zip_code: "18328",

    ste_name: "PA",
  },
  {
    zip_code: "18428",

    ste_name: "PA",
  },
  {
    zip_code: "18454",

    ste_name: "PA",
  },
  {
    zip_code: "18643",

    ste_name: "PA",
  },
  {
    zip_code: "18656",

    ste_name: "PA",
  },
  {
    zip_code: "18940",

    ste_name: "PA",
  },
  {
    zip_code: "18951",

    ste_name: "PA",
  },
  {
    zip_code: "19018",

    ste_name: "PA",
  },
  {
    zip_code: "19021",

    ste_name: "PA",
  },
  {
    zip_code: "19027",

    ste_name: "PA",
  },
  {
    zip_code: "19055",

    ste_name: "PA",
  },
  {
    zip_code: "19126",

    ste_name: "PA",
  },
  {
    zip_code: "19316",

    ste_name: "PA",
  },
  {
    zip_code: "19435",

    ste_name: "PA",
  },
  {
    zip_code: "19438",

    ste_name: "PA",
  },
  {
    zip_code: "19446",

    ste_name: "PA",
  },
  {
    zip_code: "19454",

    ste_name: "PA",
  },
  {
    zip_code: "19456",

    ste_name: "PA",
  },
  {
    zip_code: "19468",

    ste_name: "PA",
  },
  {
    zip_code: "19519",

    ste_name: "PA",
  },
  {
    zip_code: "19520",

    ste_name: "PA",
  },
  {
    zip_code: "19547",

    ste_name: "PA",
  },
  {
    zip_code: "19730",

    ste_name: "DE",
  },
  {
    zip_code: "20119",

    ste_name: "VA",
  },
  {
    zip_code: "20645",

    ste_name: "MD",
  },
  {
    zip_code: "20659",

    ste_name: "MD",
  },
  {
    zip_code: "20765",

    ste_name: "MD",
  },
  {
    zip_code: "20896",

    ste_name: "MD",
  },
  {
    zip_code: "21047",

    ste_name: "MD",
  },
  {
    zip_code: "21076",

    ste_name: "MD",
  },
  {
    zip_code: "21077",

    ste_name: "MD",
  },
  {
    zip_code: "21085",

    ste_name: "MD",
  },
  {
    zip_code: "22443",

    ste_name: "VA",
  },
  {
    zip_code: "22530",

    ste_name: "VA",
  },
  {
    zip_code: "22548",

    ste_name: "VA",
  },
  {
    zip_code: "22713",

    ste_name: "VA",
  },
  {
    zip_code: "22737",

    ste_name: "VA",
  },
  {
    zip_code: "22841",

    ste_name: "VA",
  },
  {
    zip_code: "22842",

    ste_name: "VA",
  },
  {
    zip_code: "23056",

    ste_name: "VA",
  },
  {
    zip_code: "23064",

    ste_name: "VA",
  },
  {
    zip_code: "23089",

    ste_name: "VA",
  },
  {
    zip_code: "23092",

    ste_name: "VA",
  },
  {
    zip_code: "23102",

    ste_name: "VA",
  },
  {
    zip_code: "23235",

    ste_name: "VA",
  },
  {
    zip_code: "23830",

    ste_name: "VA",
  },
  {
    zip_code: "23937",

    ste_name: "VA",
  },
  {
    zip_code: "24015",

    ste_name: "VA",
  },
  {
    zip_code: "24179",

    ste_name: "VA",
  },
  {
    zip_code: "24219",

    ste_name: "VA",
  },
  {
    zip_code: "24220",

    ste_name: "VA",
  },
  {
    zip_code: "24312",

    ste_name: "VA",
  },
  {
    zip_code: "24381",

    ste_name: "VA",
  },
  {
    zip_code: "24445",

    ste_name: "VA",
  },
  {
    zip_code: "24501",

    ste_name: "VA",
  },
  {
    zip_code: "24531",

    ste_name: "VA",
  },
  {
    zip_code: "24553",

    ste_name: "VA",
  },
  {
    zip_code: "24614",

    ste_name: "VA",
  },
  {
    zip_code: "24631",

    ste_name: "VA",
  },
  {
    zip_code: "24649",

    ste_name: "VA",
  },
  {
    zip_code: "25015",

    ste_name: "WV",
  },
  {
    zip_code: "25051",

    ste_name: "WV",
  },
  {
    zip_code: "25057",

    ste_name: "WV",
  },
  {
    zip_code: "25136",

    ste_name: "WV",
  },
  {
    zip_code: "25143",

    ste_name: "WV",
  },
  {
    zip_code: "25168",

    ste_name: "WV",
  },
  {
    zip_code: "25261",

    ste_name: "WV",
  },
  {
    zip_code: "25267",

    ste_name: "WV",
  },
  {
    zip_code: "25268",

    ste_name: "WV",
  },
  {
    zip_code: "25287",

    ste_name: "WV",
  },
  {
    zip_code: "25301",

    ste_name: "WV",
  },
  {
    zip_code: "25530",

    ste_name: "WV",
  },
  {
    zip_code: "25560",

    ste_name: "WV",
  },
  {
    zip_code: "25654",

    ste_name: "WV",
  },
  {
    zip_code: "25670",

    ste_name: "WV",
  },
  {
    zip_code: "25701",

    ste_name: "WV",
  },
  {
    zip_code: "25818",

    ste_name: "WV",
  },
  {
    zip_code: "25843",

    ste_name: "WV",
  },
  {
    zip_code: "26266",

    ste_name: "WV",
  },
  {
    zip_code: "26426",

    ste_name: "WV",
  },
  {
    zip_code: "26440",

    ste_name: "WV",
  },
  {
    zip_code: "26679",

    ste_name: "WV",
  },
  {
    zip_code: "26717",

    ste_name: "WV",
  },
  {
    zip_code: "26753",

    ste_name: "WV",
  },
  {
    zip_code: "26761",

    ste_name: "WV",
  },
  {
    zip_code: "26833",

    ste_name: "WV",
  },
  {
    zip_code: "27011",

    ste_name: "NC",
  },
  {
    zip_code: "27024",

    ste_name: "NC",
  },
  {
    zip_code: "27040",

    ste_name: "NC",
  },
  {
    zip_code: "27042",

    ste_name: "NC",
  },
  {
    zip_code: "27205",

    ste_name: "NC",
  },
  {
    zip_code: "27207",

    ste_name: "NC",
  },
  {
    zip_code: "27208",

    ste_name: "NC",
  },
  {
    zip_code: "27565",

    ste_name: "NC",
  },
  {
    zip_code: "27604",

    ste_name: "NC",
  },
  {
    zip_code: "27701",

    ste_name: "NC",
  },
  {
    zip_code: "27822",

    ste_name: "NC",
  },
  {
    zip_code: "27847",

    ste_name: "NC",
  },
  {
    zip_code: "27915",

    ste_name: "NC",
  },
  {
    zip_code: "28001",

    ste_name: "NC",
  },
  {
    zip_code: "28023",

    ste_name: "NC",
  },
  {
    zip_code: "28086",

    ste_name: "NC",
  },
  {
    zip_code: "28091",

    ste_name: "NC",
  },
  {
    zip_code: "28135",

    ste_name: "NC",
  },
  {
    zip_code: "28166",

    ste_name: "NC",
  },
  {
    zip_code: "28169",

    ste_name: "NC",
  },
  {
    zip_code: "28305",

    ste_name: "NC",
  },
  {
    zip_code: "28363",

    ste_name: "NC",
  },
  {
    zip_code: "28371",

    ste_name: "NC",
  },
  {
    zip_code: "28384",

    ste_name: "NC",
  },
  {
    zip_code: "28470",

    ste_name: "NC",
  },
  {
    zip_code: "28479",

    ste_name: "NC",
  },
  {
    zip_code: "28570",

    ste_name: "NC",
  },
  {
    zip_code: "28594",

    ste_name: "NC",
  },
  {
    zip_code: "28604",

    ste_name: "NC",
  },
  {
    zip_code: "28631",

    ste_name: "NC",
  },
  {
    zip_code: "28650",

    ste_name: "NC",
  },
  {
    zip_code: "28702",

    ste_name: "NC",
  },
  {
    zip_code: "28716",

    ste_name: "NC",
  },
  {
    zip_code: "28731",

    ste_name: "NC",
  },
  {
    zip_code: "28772",

    ste_name: "NC",
  },
  {
    zip_code: "29036",

    ste_name: "SC",
  },
  {
    zip_code: "29037",

    ste_name: "SC",
  },
  {
    zip_code: "29069",

    ste_name: "SC",
  },
  {
    zip_code: "29208",

    ste_name: "SC",
  },
  {
    zip_code: "29324",

    ste_name: "SC",
  },
  {
    zip_code: "29464",

    ste_name: "SC",
  },
  {
    zip_code: "29466",

    ste_name: "SC",
  },
  {
    zip_code: "29488",

    ste_name: "SC",
  },
  {
    zip_code: "29543",

    ste_name: "SC",
  },
  {
    zip_code: "29546",

    ste_name: "SC",
  },
  {
    zip_code: "29555",

    ste_name: "SC",
  },
  {
    zip_code: "29592",

    ste_name: "SC",
  },
  {
    zip_code: "29605",

    ste_name: "SC",
  },
  {
    zip_code: "29661",

    ste_name: "SC",
  },
  {
    zip_code: "29915",

    ste_name: "SC",
  },
  {
    zip_code: "29932",

    ste_name: "SC",
  },
  {
    zip_code: "30072",

    ste_name: "GA",
  },
  {
    zip_code: "30096",

    ste_name: "GA",
  },
  {
    zip_code: "30274",

    ste_name: "GA",
  },
  {
    zip_code: "30275",

    ste_name: "GA",
  },
  {
    zip_code: "30281",

    ste_name: "GA",
  },
  {
    zip_code: "30318",

    ste_name: "GA",
  },
  {
    zip_code: "30340",

    ste_name: "GA",
  },
  {
    zip_code: "30470",

    ste_name: "GA",
  },
  {
    zip_code: "30567",

    ste_name: "GA",
  },
  {
    zip_code: "30711",

    ste_name: "GA",
  },
  {
    zip_code: "30753",

    ste_name: "GA",
  },
  {
    zip_code: "30823",

    ste_name: "GA",
  },
  {
    zip_code: "90005",

    ste_name: "CA",
  },
  {
    zip_code: "90006",

    ste_name: "CA",
  },
  {
    zip_code: "90008",

    ste_name: "CA",
  },
  {
    zip_code: "90040",

    ste_name: "CA",
  },
  {
    zip_code: "90045",

    ste_name: "CA",
  },
  {
    zip_code: "90401",

    ste_name: "CA",
  },
  {
    zip_code: "90504",

    ste_name: "CA",
  },
  {
    zip_code: "90717",

    ste_name: "CA",
  },
  {
    zip_code: "90808",

    ste_name: "CA",
  },
  {
    zip_code: "91214",

    ste_name: "CA",
  },
  {
    zip_code: "91324",

    ste_name: "CA",
  },
  {
    zip_code: "91331",

    ste_name: "CA",
  },
  {
    zip_code: "91371",

    ste_name: "CA",
  },
  {
    zip_code: "91384",

    ste_name: "CA",
  },
  {
    zip_code: "91730",

    ste_name: "CA",
  },
  {
    zip_code: "91762",

    ste_name: "CA",
  },
  {
    zip_code: "92007",

    ste_name: "CA",
  },
  {
    zip_code: "92081",

    ste_name: "CA",
  },
  {
    zip_code: "92113",

    ste_name: "CA",
  },
  {
    zip_code: "92114",

    ste_name: "CA",
  },
  {
    zip_code: "92118",

    ste_name: "CA",
  },
  {
    zip_code: "92250",

    ste_name: "CA",
  },
  {
    zip_code: "92284",

    ste_name: "CA",
  },
  {
    zip_code: "92305",

    ste_name: "CA",
  },
  {
    zip_code: "92384",

    ste_name: "CA",
  },
  {
    zip_code: "92660",

    ste_name: "CA",
  },
  {
    zip_code: "92662",

    ste_name: "CA",
  },
  {
    zip_code: "93103",

    ste_name: "CA",
  },
  {
    zip_code: "93117",

    ste_name: "CA",
  },
  {
    zip_code: "93221",

    ste_name: "CA",
  },
  {
    zip_code: "93962",

    ste_name: "CA",
  },
  {
    zip_code: "94117",

    ste_name: "CA",
  },
  {
    zip_code: "94507",

    ste_name: "CA",
  },
  {
    zip_code: "94535",

    ste_name: "CA",
  },
  {
    zip_code: "94803",

    ste_name: "CA",
  },
  {
    zip_code: "94904",

    ste_name: "CA",
  },
  {
    zip_code: "94928",

    ste_name: "CA",
  },
  {
    zip_code: "94947",

    ste_name: "CA",
  },
  {
    zip_code: "95003",

    ste_name: "CA",
  },
  {
    zip_code: "95045",

    ste_name: "CA",
  },
  {
    zip_code: "95070",

    ste_name: "CA",
  },
  {
    zip_code: "95242",

    ste_name: "CA",
  },
  {
    zip_code: "95245",

    ste_name: "CA",
  },
  {
    zip_code: "95301",

    ste_name: "CA",
  },
  {
    zip_code: "95355",

    ste_name: "CA",
  },
  {
    zip_code: "95383",

    ste_name: "CA",
  },
  {
    zip_code: "95385",

    ste_name: "CA",
  },
  {
    zip_code: "95555",

    ste_name: "CA",
  },
  {
    zip_code: "95595",

    ste_name: "CA",
  },
  {
    zip_code: "95626",

    ste_name: "CA",
  },
  {
    zip_code: "95668",

    ste_name: "CA",
  },
  {
    zip_code: "95690",

    ste_name: "CA",
  },
  {
    zip_code: "95691",

    ste_name: "CA",
  },
  {
    zip_code: "95709",

    ste_name: "CA",
  },
  {
    zip_code: "95765",

    ste_name: "CA",
  },
  {
    zip_code: "95814",

    ste_name: "CA",
  },
  {
    zip_code: "95916",

    ste_name: "CA",
  },
  {
    zip_code: "95926",

    ste_name: "CA",
  },
  {
    zip_code: "95955",

    ste_name: "CA",
  },
  {
    zip_code: "96008",

    ste_name: "CA",
  },
  {
    zip_code: "96047",

    ste_name: "CA",
  },
  {
    zip_code: "96055",

    ste_name: "CA",
  },
  {
    zip_code: "96062",

    ste_name: "CA",
  },
  {
    zip_code: "96821",

    ste_name: "HI",
  },
  {
    zip_code: "96915",

    ste_name: "GU",
  },
  {
    zip_code: "97020",

    ste_name: "OR",
  },
  {
    zip_code: "97054",

    ste_name: "OR",
  },
  {
    zip_code: "97136",

    ste_name: "OR",
  },
  {
    zip_code: "97205",

    ste_name: "OR",
  },
  {
    zip_code: "97230",

    ste_name: "OR",
  },
  {
    zip_code: "97343",

    ste_name: "OR",
  },
  {
    zip_code: "97351",

    ste_name: "OR",
  },
  {
    zip_code: "97364",

    ste_name: "OR",
  },
  {
    zip_code: "97365",

    ste_name: "OR",
  },
  {
    zip_code: "97538",

    ste_name: "OR",
  },
  {
    zip_code: "97730",

    ste_name: "OR",
  },
  {
    zip_code: "97732",

    ste_name: "OR",
  },
  {
    zip_code: "98029",

    ste_name: "WA",
  },
  {
    zip_code: "98070",

    ste_name: "WA",
  },
  {
    zip_code: "98074",

    ste_name: "WA",
  },
  {
    zip_code: "98103",

    ste_name: "WA",
  },
  {
    zip_code: "98257",

    ste_name: "WA",
  },
  {
    zip_code: "98336",

    ste_name: "WA",
  },
  {
    zip_code: "98346",

    ste_name: "WA",
  },
  {
    zip_code: "57432",

    ste_name: "SD",
  },
  {
    zip_code: "93262",

    ste_name: "CA",
  },
  {
    zip_code: "93432",

    ste_name: "CA",
  },
  {
    zip_code: "93441",

    ste_name: "CA",
  },
  {
    zip_code: "93514",

    ste_name: "CA",
  },
  {
    zip_code: "93529",

    ste_name: "CA",
  },
  {
    zip_code: "93536",

    ste_name: "CA",
  },
  {
    zip_code: "93545",

    ste_name: "CA",
  },
  {
    zip_code: "93633",

    ste_name: "CA",
  },
  {
    zip_code: "664",

    ste_name: "PR",
  },
  {
    zip_code: "717",

    ste_name: "PR",
  },
  {
    zip_code: "979",

    ste_name: "PR",
  },
  {
    zip_code: "1022",

    ste_name: "MA",
  },
  {
    zip_code: "1034",

    ste_name: "MA",
  },
  {
    zip_code: "1037",

    ste_name: "MA",
  },
  {
    zip_code: "1038",

    ste_name: "MA",
  },
  {
    zip_code: "1331",

    ste_name: "MA",
  },
  {
    zip_code: "1341",

    ste_name: "MA",
  },
  {
    zip_code: "1524",

    ste_name: "MA",
  },
  {
    zip_code: "1832",

    ste_name: "MA",
  },
  {
    zip_code: "1835",

    ste_name: "MA",
  },
  {
    zip_code: "1887",

    ste_name: "MA",
  },
  {
    zip_code: "2109",

    ste_name: "MA",
  },
  {
    zip_code: "2150",

    ste_name: "MA",
  },
  {
    zip_code: "2170",

    ste_name: "MA",
  },
  {
    zip_code: "2472",

    ste_name: "MA",
  },
  {
    zip_code: "2493",

    ste_name: "MA",
  },
  {
    zip_code: "2532",

    ste_name: "MA",
  },
  {
    zip_code: "2718",

    ste_name: "MA",
  },
  {
    zip_code: "2762",

    ste_name: "MA",
  },
  {
    zip_code: "2808",

    ste_name: "RI",
  },
  {
    zip_code: "2812",

    ste_name: "RI",
  },
  {
    zip_code: "2826",

    ste_name: "RI",
  },
  {
    zip_code: "2828",

    ste_name: "RI",
  },
  {
    zip_code: "2830",

    ste_name: "RI",
  },
  {
    zip_code: "2837",

    ste_name: "RI",
  },
  {
    zip_code: "3055",

    ste_name: "NH",
  },
  {
    zip_code: "3057",

    ste_name: "NH",
  },
  {
    zip_code: "3221",

    ste_name: "NH",
  },
  {
    zip_code: "3222",

    ste_name: "NH",
  },
  {
    zip_code: "3243",

    ste_name: "NH",
  },
  {
    zip_code: "3246",

    ste_name: "NH",
  },
  {
    zip_code: "3254",

    ste_name: "NH",
  },
  {
    zip_code: "3264",

    ste_name: "NH",
  },
  {
    zip_code: "3746",

    ste_name: "NH",
  },
  {
    zip_code: "3748",

    ste_name: "NH",
  },
  {
    zip_code: "3825",

    ste_name: "NH",
  },
  {
    zip_code: "3847",

    ste_name: "NH",
  },
  {
    zip_code: "3853",

    ste_name: "NH",
  },
  {
    zip_code: "4050",

    ste_name: "ME",
  },
  {
    zip_code: "4108",

    ste_name: "ME",
  },
  {
    zip_code: "4345",

    ste_name: "ME",
  },
  {
    zip_code: "4490",

    ste_name: "ME",
  },
  {
    zip_code: "4497",

    ste_name: "ME",
  },
  {
    zip_code: "4605",

    ste_name: "ME",
  },
  {
    zip_code: "4849",

    ste_name: "ME",
  },
  {
    zip_code: "4921",

    ste_name: "ME",
  },
  {
    zip_code: "4953",

    ste_name: "ME",
  },
  {
    zip_code: "4958",

    ste_name: "ME",
  },
  {
    zip_code: "4964",

    ste_name: "ME",
  },
  {
    zip_code: "4973",

    ste_name: "ME",
  },
  {
    zip_code: "5075",

    ste_name: "VT",
  },
  {
    zip_code: "5077",

    ste_name: "VT",
  },
  {
    zip_code: "5252",

    ste_name: "VT",
  },
  {
    zip_code: "5455",

    ste_name: "VT",
  },
  {
    zip_code: "5778",

    ste_name: "VT",
  },
  {
    zip_code: "5824",

    ste_name: "VT",
  },
  {
    zip_code: "6023",

    ste_name: "CT",
  },
  {
    zip_code: "6032",

    ste_name: "CT",
  },
  {
    zip_code: "6254",

    ste_name: "CT",
  },
  {
    zip_code: "6263",

    ste_name: "CT",
  },
  {
    zip_code: "6360",

    ste_name: "CT",
  },
  {
    zip_code: "6374",

    ste_name: "CT",
  },
  {
    zip_code: "6444",

    ste_name: "CT",
  },
  {
    zip_code: "6517",

    ste_name: "CT",
  },
  {
    zip_code: "6519",

    ste_name: "CT",
  },
  {
    zip_code: "6611",

    ste_name: "CT",
  },
  {
    zip_code: "6708",

    ste_name: "CT",
  },
  {
    zip_code: "6757",

    ste_name: "CT",
  },
  {
    zip_code: "6783",

    ste_name: "CT",
  },
  {
    zip_code: "6890",

    ste_name: "CT",
  },
  {
    zip_code: "7003",

    ste_name: "NJ",
  },
  {
    zip_code: "7055",

    ste_name: "NJ",
  },
  {
    zip_code: "7306",

    ste_name: "NJ",
  },
  {
    zip_code: "7627",

    ste_name: "NJ",
  },
  {
    zip_code: "7645",

    ste_name: "NJ",
  },
  {
    zip_code: "7663",

    ste_name: "NJ",
  },
  {
    zip_code: "7731",

    ste_name: "NJ",
  },
  {
    zip_code: "7826",

    ste_name: "NJ",
  },
  {
    zip_code: "7830",

    ste_name: "NJ",
  },
  {
    zip_code: "7846",

    ste_name: "NJ",
  },
  {
    zip_code: "7870",

    ste_name: "NJ",
  },
  {
    zip_code: "7977",

    ste_name: "NJ",
  },
  {
    zip_code: "8030",

    ste_name: "NJ",
  },
  {
    zip_code: "8039",

    ste_name: "NJ",
  },
  {
    zip_code: "8071",

    ste_name: "NJ",
  },
  {
    zip_code: "8314",

    ste_name: "NJ",
  },
  {
    zip_code: "8319",

    ste_name: "NJ",
  },
  {
    zip_code: "8328",

    ste_name: "NJ",
  },
  {
    zip_code: "8406",

    ste_name: "NJ",
  },
  {
    zip_code: "8740",

    ste_name: "NJ",
  },
  {
    zip_code: "8857",

    ste_name: "NJ",
  },
  {
    zip_code: "10032",

    ste_name: "NY",
  },
  {
    zip_code: "10451",

    ste_name: "NY",
  },
  {
    zip_code: "10458",

    ste_name: "NY",
  },
  {
    zip_code: "10570",

    ste_name: "NY",
  },
  {
    zip_code: "10990",

    ste_name: "NY",
  },
  {
    zip_code: "11005",

    ste_name: "NY",
  },
  {
    zip_code: "11203",

    ste_name: "NY",
  },
  {
    zip_code: "11212",

    ste_name: "NY",
  },
  {
    zip_code: "11221",

    ste_name: "NY",
  },
  {
    zip_code: "11224",

    ste_name: "NY",
  },
  {
    zip_code: "11354",

    ste_name: "NY",
  },
  {
    zip_code: "11413",

    ste_name: "NY",
  },
  {
    zip_code: "11425",

    ste_name: "NY",
  },
  {
    zip_code: "11580",

    ste_name: "NY",
  },
  {
    zip_code: "11715",

    ste_name: "NY",
  },
  {
    zip_code: "11754",

    ste_name: "NY",
  },
  {
    zip_code: "11942",

    ste_name: "NY",
  },
  {
    zip_code: "12051",

    ste_name: "NY",
  },
  {
    zip_code: "12154",

    ste_name: "NY",
  },
  {
    zip_code: "12208",

    ste_name: "NY",
  },
  {
    zip_code: "12307",

    ste_name: "NY",
  },
  {
    zip_code: "12309",

    ste_name: "NY",
  },
  {
    zip_code: "12407",

    ste_name: "NY",
  },
  {
    zip_code: "12423",

    ste_name: "NY",
  },
  {
    zip_code: "12443",

    ste_name: "NY",
  },
  {
    zip_code: "12487",

    ste_name: "NY",
  },
  {
    zip_code: "12489",

    ste_name: "NY",
  },
  {
    zip_code: "12527",

    ste_name: "NY",
  },
  {
    zip_code: "12547",

    ste_name: "NY",
  },
  {
    zip_code: "12741",

    ste_name: "NY",
  },
  {
    zip_code: "12811",

    ste_name: "NY",
  },
  {
    zip_code: "12844",

    ste_name: "NY",
  },
  {
    zip_code: "12861",

    ste_name: "NY",
  },
  {
    zip_code: "12932",

    ste_name: "NY",
  },
  {
    zip_code: "12956",

    ste_name: "NY",
  },
  {
    zip_code: "12973",

    ste_name: "NY",
  },
  {
    zip_code: "13118",

    ste_name: "NY",
  },
  {
    zip_code: "13152",

    ste_name: "NY",
  },
  {
    zip_code: "13290",

    ste_name: "NY",
  },
  {
    zip_code: "13339",

    ste_name: "NY",
  },
  {
    zip_code: "13364",

    ste_name: "NY",
  },
  {
    zip_code: "13410",

    ste_name: "NY",
  },
  {
    zip_code: "13661",

    ste_name: "NY",
  },
  {
    zip_code: "13776",

    ste_name: "NY",
  },
  {
    zip_code: "13809",

    ste_name: "NY",
  },
  {
    zip_code: "14020",

    ste_name: "NY",
  },
  {
    zip_code: "14026",

    ste_name: "NY",
  },
  {
    zip_code: "14169",

    ste_name: "NY",
  },
  {
    zip_code: "14502",

    ste_name: "NY",
  },
  {
    zip_code: "14626",

    ste_name: "NY",
  },
  {
    zip_code: "14715",

    ste_name: "NY",
  },
  {
    zip_code: "14756",

    ste_name: "NY",
  },
  {
    zip_code: "14819",

    ste_name: "NY",
  },
  {
    zip_code: "14827",

    ste_name: "NY",
  },
  {
    zip_code: "14840",

    ste_name: "NY",
  },
  {
    zip_code: "14884",

    ste_name: "NY",
  },
  {
    zip_code: "14892",

    ste_name: "NY",
  },
  {
    zip_code: "14895",

    ste_name: "NY",
  },
  {
    zip_code: "15004",

    ste_name: "PA",
  },
  {
    zip_code: "15010",

    ste_name: "PA",
  },
  {
    zip_code: "15116",

    ste_name: "PA",
  },
  {
    zip_code: "15120",

    ste_name: "PA",
  },
  {
    zip_code: "15376",

    ste_name: "PA",
  },
  {
    zip_code: "15410",

    ste_name: "PA",
  },
  {
    zip_code: "15412",

    ste_name: "PA",
  },
  {
    zip_code: "15461",

    ste_name: "PA",
  },
  {
    zip_code: "15478",

    ste_name: "PA",
  },
  {
    zip_code: "15537",

    ste_name: "PA",
  },
  {
    zip_code: "15541",

    ste_name: "PA",
  },
  {
    zip_code: "15557",

    ste_name: "PA",
  },
  {
    zip_code: "15562",

    ste_name: "PA",
  },
  {
    zip_code: "15673",

    ste_name: "PA",
  },
  {
    zip_code: "15733",

    ste_name: "PA",
  },
  {
    zip_code: "15770",

    ste_name: "PA",
  },
  {
    zip_code: "15954",

    ste_name: "PA",
  },
  {
    zip_code: "16052",

    ste_name: "PA",
  },
  {
    zip_code: "16063",

    ste_name: "PA",
  },
  {
    zip_code: "16156",

    ste_name: "PA",
  },
  {
    zip_code: "16212",

    ste_name: "PA",
  },
  {
    zip_code: "16341",

    ste_name: "PA",
  },
  {
    zip_code: "16345",

    ste_name: "PA",
  },
  {
    zip_code: "16362",

    ste_name: "PA",
  },
  {
    zip_code: "16417",

    ste_name: "PA",
  },
  {
    zip_code: "16546",

    ste_name: "PA",
  },
  {
    zip_code: "16611",

    ste_name: "PA",
  },
  {
    zip_code: "16616",

    ste_name: "PA",
  },
  {
    zip_code: "16665",

    ste_name: "PA",
  },
  {
    zip_code: "16848",

    ste_name: "PA",
  },
  {
    zip_code: "16852",

    ste_name: "PA",
  },
  {
    zip_code: "16929",

    ste_name: "PA",
  },
  {
    zip_code: "17027",

    ste_name: "PA",
  },
  {
    zip_code: "17028",

    ste_name: "PA",
  },
  {
    zip_code: "17078",

    ste_name: "PA",
  },
  {
    zip_code: "17331",

    ste_name: "PA",
  },
  {
    zip_code: "17344",

    ste_name: "PA",
  },
  {
    zip_code: "17355",

    ste_name: "PA",
  },
  {
    zip_code: "17368",

    ste_name: "PA",
  },
  {
    zip_code: "17519",

    ste_name: "PA",
  },
  {
    zip_code: "17522",

    ste_name: "PA",
  },
  {
    zip_code: "17576",

    ste_name: "PA",
  },
  {
    zip_code: "17606",

    ste_name: "PA",
  },
  {
    zip_code: "17740",

    ste_name: "PA",
  },
  {
    zip_code: "17865",

    ste_name: "PA",
  },
  {
    zip_code: "17887",

    ste_name: "PA",
  },
  {
    zip_code: "17889",

    ste_name: "PA",
  },
  {
    zip_code: "18020",

    ste_name: "PA",
  },
  {
    zip_code: "18031",

    ste_name: "PA",
  },
  {
    zip_code: "18327",

    ste_name: "PA",
  },
  {
    zip_code: "18344",

    ste_name: "PA",
  },
  {
    zip_code: "18438",

    ste_name: "PA",
  },
  {
    zip_code: "18504",

    ste_name: "PA",
  },
  {
    zip_code: "18510",

    ste_name: "PA",
  },
  {
    zip_code: "18708",

    ste_name: "PA",
  },
  {
    zip_code: "18914",

    ste_name: "PA",
  },
  {
    zip_code: "18972",

    ste_name: "PA",
  },
  {
    zip_code: "18976",

    ste_name: "PA",
  },
  {
    zip_code: "19009",

    ste_name: "PA",
  },
  {
    zip_code: "19044",

    ste_name: "PA",
  },
  {
    zip_code: "19085",

    ste_name: "PA",
  },
  {
    zip_code: "19131",

    ste_name: "PA",
  },
  {
    zip_code: "19462",

    ste_name: "PA",
  },
  {
    zip_code: "19510",

    ste_name: "PA",
  },
  {
    zip_code: "19936",

    ste_name: "DE",
  },
  {
    zip_code: "19964",

    ste_name: "DE",
  },
  {
    zip_code: "20009",

    ste_name: "DC",
  },
  {
    zip_code: "20110",

    ste_name: "VA",
  },
  {
    zip_code: "20171",

    ste_name: "VA",
  },
  {
    zip_code: "20181",

    ste_name: "VA",
  },
  {
    zip_code: "20245",

    ste_name: "DC",
  },
  {
    zip_code: "20553",

    ste_name: "DC",
  },
  {
    zip_code: "20622",

    ste_name: "MD",
  },
  {
    zip_code: "20854",

    ste_name: "MD",
  },
  {
    zip_code: "20868",

    ste_name: "MD",
  },
  {
    zip_code: "21050",

    ste_name: "MD",
  },
  {
    zip_code: "21104",

    ste_name: "MD",
  },
  {
    zip_code: "21215",

    ste_name: "MD",
  },
  {
    zip_code: "21252",

    ste_name: "MD",
  },
  {
    zip_code: "21409",

    ste_name: "MD",
  },
  {
    zip_code: "21530",

    ste_name: "MD",
  },
  {
    zip_code: "21722",

    ste_name: "MD",
  },
  {
    zip_code: "21755",

    ste_name: "MD",
  },
  {
    zip_code: "21830",

    ste_name: "MD",
  },
  {
    zip_code: "21840",

    ste_name: "MD",
  },
  {
    zip_code: "22025",

    ste_name: "VA",
  },
  {
    zip_code: "22035",

    ste_name: "VA",
  },
  {
    zip_code: "22405",

    ste_name: "VA",
  },
  {
    zip_code: "22476",

    ste_name: "VA",
  },
  {
    zip_code: "22601",

    ste_name: "VA",
  },
  {
    zip_code: "22942",

    ste_name: "VA",
  },
  {
    zip_code: "23035",

    ste_name: "VA",
  },
  {
    zip_code: "23069",

    ste_name: "VA",
  },
  {
    zip_code: "23076",

    ste_name: "VA",
  },
  {
    zip_code: "23086",

    ste_name: "VA",
  },
  {
    zip_code: "23176",

    ste_name: "VA",
  },
  {
    zip_code: "23437",

    ste_name: "VA",
  },
  {
    zip_code: "23666",

    ste_name: "VA",
  },
  {
    zip_code: "23701",

    ste_name: "VA",
  },
  {
    zip_code: "23888",

    ste_name: "VA",
  },
  {
    zip_code: "23917",

    ste_name: "VA",
  },
  {
    zip_code: "23942",

    ste_name: "VA",
  },
  {
    zip_code: "23947",

    ste_name: "VA",
  },
  {
    zip_code: "24079",

    ste_name: "VA",
  },
  {
    zip_code: "24083",

    ste_name: "VA",
  },
  {
    zip_code: "24124",

    ste_name: "VA",
  },
  {
    zip_code: "24162",

    ste_name: "VA",
  },
  {
    zip_code: "24265",

    ste_name: "VA",
  },
  {
    zip_code: "24311",

    ste_name: "VA",
  },
  {
    zip_code: "24313",

    ste_name: "VA",
  },
  {
    zip_code: "24314",

    ste_name: "VA",
  },
  {
    zip_code: "24317",

    ste_name: "VA",
  },
  {
    zip_code: "24328",

    ste_name: "VA",
  },
  {
    zip_code: "24382",

    ste_name: "VA",
  },
  {
    zip_code: "24558",

    ste_name: "VA",
  },
  {
    zip_code: "24574",

    ste_name: "VA",
  },
  {
    zip_code: "24581",

    ste_name: "VA",
  },
  {
    zip_code: "24826",

    ste_name: "WV",
  },
  {
    zip_code: "24882",

    ste_name: "WV",
  },
  {
    zip_code: "25003",

    ste_name: "WV",
  },
  {
    zip_code: "25011",

    ste_name: "WV",
  },
  {
    zip_code: "25106",

    ste_name: "WV",
  },
  {
    zip_code: "25204",

    ste_name: "WV",
  },
  {
    zip_code: "25442",

    ste_name: "WV",
  },
  {
    zip_code: "25504",

    ste_name: "WV",
  },
  {
    zip_code: "25637",

    ste_name: "WV",
  },
  {
    zip_code: "25651",

    ste_name: "WV",
  },
  {
    zip_code: "25703",

    ste_name: "WV",
  },
  {
    zip_code: "25840",

    ste_name: "WV",
  },
  {
    zip_code: "25841",

    ste_name: "WV",
  },
  {
    zip_code: "25904",

    ste_name: "WV",
  },
  {
    zip_code: "26155",

    ste_name: "WV",
  },
  {
    zip_code: "26269",

    ste_name: "WV",
  },
  {
    zip_code: "26505",

    ste_name: "WV",
  },
  {
    zip_code: "26560",

    ste_name: "WV",
  },
  {
    zip_code: "27014",

    ste_name: "NC",
  },
  {
    zip_code: "27030",

    ste_name: "NC",
  },
  {
    zip_code: "27110",

    ste_name: "NC",
  },
  {
    zip_code: "27262",

    ste_name: "NC",
  },
  {
    zip_code: "27316",

    ste_name: "NC",
  },
  {
    zip_code: "27410",

    ste_name: "NC",
  },
  {
    zip_code: "27525",

    ste_name: "NC",
  },
  {
    zip_code: "27539",

    ste_name: "NC",
  },
  {
    zip_code: "27587",

    ste_name: "NC",
  },
  {
    zip_code: "27816",

    ste_name: "NC",
  },
  {
    zip_code: "27922",

    ste_name: "NC",
  },
  {
    zip_code: "28054",

    ste_name: "NC",
  },
  {
    zip_code: "28056",

    ste_name: "NC",
  },
  {
    zip_code: "28098",

    ste_name: "NC",
  },
  {
    zip_code: "28278",

    ste_name: "NC",
  },
  {
    zip_code: "28401",

    ste_name: "NC",
  },
  {
    zip_code: "28412",

    ste_name: "NC",
  },
  {
    zip_code: "28425",

    ste_name: "NC",
  },
  {
    zip_code: "28445",

    ste_name: "NC",
  },
  {
    zip_code: "28480",

    ste_name: "NC",
  },
  {
    zip_code: "28547",

    ste_name: "NC",
  },
  {
    zip_code: "28573",

    ste_name: "NC",
  },
  {
    zip_code: "28574",

    ste_name: "NC",
  },
  {
    zip_code: "28642",

    ste_name: "NC",
  },
  {
    zip_code: "28722",

    ste_name: "NC",
  },
  {
    zip_code: "28902",

    ste_name: "NC",
  },
  {
    zip_code: "28905",

    ste_name: "NC",
  },
  {
    zip_code: "29058",

    ste_name: "SC",
  },
  {
    zip_code: "29563",

    ste_name: "SC",
  },
  {
    zip_code: "29626",

    ste_name: "SC",
  },
  {
    zip_code: "29651",

    ste_name: "SC",
  },
  {
    zip_code: "29851",

    ste_name: "SC",
  },
  {
    zip_code: "30075",

    ste_name: "GA",
  },
  {
    zip_code: "30179",

    ste_name: "GA",
  },
  {
    zip_code: "30314",

    ste_name: "GA",
  },
  {
    zip_code: "30360",

    ste_name: "GA",
  },
  {
    zip_code: "30504",

    ste_name: "GA",
  },
  {
    zip_code: "30528",

    ste_name: "GA",
  },
  {
    zip_code: "30549",

    ste_name: "GA",
  },
  {
    zip_code: "30621",

    ste_name: "GA",
  },
  {
    zip_code: "30678",

    ste_name: "GA",
  },
  {
    zip_code: "30726",

    ste_name: "GA",
  },
  {
    zip_code: "31037",

    ste_name: "GA",
  },
  {
    zip_code: "31085",

    ste_name: "GA",
  },
  {
    zip_code: "31210",

    ste_name: "GA",
  },
  {
    zip_code: "31331",

    ste_name: "GA",
  },
  {
    zip_code: "31415",

    ste_name: "GA",
  },
  {
    zip_code: "31558",

    ste_name: "GA",
  },
  {
    zip_code: "31826",

    ste_name: "GA",
  },
  {
    zip_code: "31830",

    ste_name: "GA",
  },
  {
    zip_code: "31833",

    ste_name: "GA",
  },
  {
    zip_code: "31905",

    ste_name: "GA",
  },
  {
    zip_code: "32189",

    ste_name: "FL",
  },
  {
    zip_code: "32204",

    ste_name: "FL",
  },
  {
    zip_code: "32209",

    ste_name: "FL",
  },
  {
    zip_code: "32221",

    ste_name: "FL",
  },
  {
    zip_code: "32336",

    ste_name: "FL",
  },
  {
    zip_code: "32440",

    ste_name: "FL",
  },
  {
    zip_code: "32577",

    ste_name: "FL",
  },
  {
    zip_code: "32579",

    ste_name: "FL",
  },
  {
    zip_code: "32617",

    ste_name: "FL",
  },
  {
    zip_code: "32668",

    ste_name: "FL",
  },
  {
    zip_code: "32709",

    ste_name: "FL",
  },
  {
    zip_code: "32724",

    ste_name: "FL",
  },
  {
    zip_code: "32829",

    ste_name: "FL",
  },
  {
    zip_code: "32837",

    ste_name: "FL",
  },
  {
    zip_code: "32926",

    ste_name: "FL",
  },
  {
    zip_code: "32948",

    ste_name: "FL",
  },
  {
    zip_code: "33028",

    ste_name: "FL",
  },
  {
    zip_code: "33040",

    ste_name: "FL",
  },
  {
    zip_code: "33071",

    ste_name: "FL",
  },
  {
    zip_code: "33109",

    ste_name: "FL",
  },
  {
    zip_code: "33154",

    ste_name: "FL",
  },
  {
    zip_code: "33306",

    ste_name: "FL",
  },
  {
    zip_code: "33461",

    ste_name: "FL",
  },
  {
    zip_code: "33527",

    ste_name: "FL",
  },
  {
    zip_code: "33544",

    ste_name: "FL",
  },
  {
    zip_code: "33812",

    ste_name: "FL",
  },
  {
    zip_code: "33983",

    ste_name: "FL",
  },
  {
    zip_code: "34114",

    ste_name: "FL",
  },
  {
    zip_code: "34470",

    ste_name: "FL",
  },
  {
    zip_code: "34488",

    ste_name: "FL",
  },
  {
    zip_code: "34736",

    ste_name: "FL",
  },
  {
    zip_code: "34746",

    ste_name: "FL",
  },
  {
    zip_code: "34769",

    ste_name: "FL",
  },
  {
    zip_code: "34974",

    ste_name: "FL",
  },
  {
    zip_code: "35016",

    ste_name: "AL",
  },
  {
    zip_code: "35042",

    ste_name: "AL",
  },
  {
    zip_code: "35077",

    ste_name: "AL",
  },
  {
    zip_code: "35094",

    ste_name: "AL",
  },
  {
    zip_code: "35097",

    ste_name: "AL",
  },
  {
    zip_code: "35120",

    ste_name: "AL",
  },
  {
    zip_code: "35139",

    ste_name: "AL",
  },
  {
    zip_code: "35203",

    ste_name: "AL",
  },
  {
    zip_code: "35204",

    ste_name: "AL",
  },
  {
    zip_code: "35235",

    ste_name: "AL",
  },
  {
    zip_code: "35441",

    ste_name: "AL",
  },
  {
    zip_code: "35545",

    ste_name: "AL",
  },
  {
    zip_code: "35555",

    ste_name: "AL",
  },
  {
    zip_code: "35630",

    ste_name: "AL",
  },
  {
    zip_code: "35633",

    ste_name: "AL",
  },
  {
    zip_code: "35961",

    ste_name: "AL",
  },
  {
    zip_code: "36032",

    ste_name: "AL",
  },
  {
    zip_code: "36081",

    ste_name: "AL",
  },
  {
    zip_code: "36260",

    ste_name: "AL",
  },
  {
    zip_code: "36271",

    ste_name: "AL",
  },
  {
    zip_code: "36345",

    ste_name: "AL",
  },
  {
    zip_code: "36360",

    ste_name: "AL",
  },
  {
    zip_code: "36477",

    ste_name: "AL",
  },
  {
    zip_code: "36545",

    ste_name: "AL",
  },
  {
    zip_code: "36555",

    ste_name: "AL",
  },
  {
    zip_code: "36752",

    ste_name: "AL",
  },
  {
    zip_code: "36753",

    ste_name: "AL",
  },
  {
    zip_code: "36869",

    ste_name: "AL",
  },
  {
    zip_code: "37059",

    ste_name: "TN",
  },
  {
    zip_code: "37072",

    ste_name: "TN",
  },
  {
    zip_code: "37130",

    ste_name: "TN",
  },
  {
    zip_code: "37150",

    ste_name: "TN",
  },
  {
    zip_code: "37215",

    ste_name: "TN",
  },
  {
    zip_code: "37331",

    ste_name: "TN",
  },
  {
    zip_code: "37340",

    ste_name: "TN",
  },
  {
    zip_code: "37381",

    ste_name: "TN",
  },
  {
    zip_code: "37616",

    ste_name: "TN",
  },
  {
    zip_code: "37721",

    ste_name: "TN",
  },
  {
    zip_code: "37870",

    ste_name: "TN",
  },
  {
    zip_code: "37874",

    ste_name: "TN",
  },
  {
    zip_code: "37918",

    ste_name: "TN",
  },
  {
    zip_code: "37919",

    ste_name: "TN",
  },
  {
    zip_code: "38063",

    ste_name: "TN",
  },
  {
    zip_code: "38126",

    ste_name: "TN",
  },
  {
    zip_code: "38131",

    ste_name: "TN",
  },
  {
    zip_code: "38230",

    ste_name: "TN",
  },
  {
    zip_code: "38387",

    ste_name: "TN",
  },
  {
    zip_code: "38457",

    ste_name: "TN",
  },
  {
    zip_code: "38469",

    ste_name: "TN",
  },
  {
    zip_code: "38504",

    ste_name: "TN",
  },
  {
    zip_code: "38633",

    ste_name: "MS",
  },
  {
    zip_code: "38644",

    ste_name: "MS",
  },
  {
    zip_code: "38666",

    ste_name: "MS",
  },
  {
    zip_code: "38701",

    ste_name: "MS",
  },
  {
    zip_code: "38736",

    ste_name: "MS",
  },
  {
    zip_code: "38801",

    ste_name: "MS",
  },
  {
    zip_code: "38850",

    ste_name: "MS",
  },
  {
    zip_code: "38965",

    ste_name: "MS",
  },
  {
    zip_code: "39176",

    ste_name: "MS",
  },
  {
    zip_code: "39213",

    ste_name: "MS",
  },
  {
    zip_code: "39464",

    ste_name: "MS",
  },
  {
    zip_code: "39576",

    ste_name: "MS",
  },
  {
    zip_code: "39705",

    ste_name: "MS",
  },
  {
    zip_code: "39773",

    ste_name: "MS",
  },
  {
    zip_code: "39840",

    ste_name: "GA",
  },
  {
    zip_code: "40014",

    ste_name: "KY",
  },
  {
    zip_code: "40037",

    ste_name: "KY",
  },
  {
    zip_code: "40152",

    ste_name: "KY",
  },
  {
    zip_code: "40161",

    ste_name: "KY",
  },
  {
    zip_code: "40215",

    ste_name: "KY",
  },
  {
    zip_code: "40243",

    ste_name: "KY",
  },
  {
    zip_code: "40330",

    ste_name: "KY",
  },
  {
    zip_code: "40334",

    ste_name: "KY",
  },
  {
    zip_code: "40339",

    ste_name: "KY",
  },
  {
    zip_code: "40387",

    ste_name: "KY",
  },
  {
    zip_code: "40434",

    ste_name: "KY",
  },
  {
    zip_code: "40437",

    ste_name: "KY",
  },
  {
    zip_code: "40771",

    ste_name: "KY",
  },
  {
    zip_code: "40826",

    ste_name: "KY",
  },
  {
    zip_code: "40873",

    ste_name: "KY",
  },
  {
    zip_code: "40964",

    ste_name: "KY",
  },
  {
    zip_code: "40983",

    ste_name: "KY",
  },
  {
    zip_code: "41010",

    ste_name: "KY",
  },
  {
    zip_code: "41039",

    ste_name: "KY",
  },
  {
    zip_code: "41048",

    ste_name: "KY",
  },
  {
    zip_code: "41076",

    ste_name: "KY",
  },
  {
    zip_code: "41080",

    ste_name: "KY",
  },
  {
    zip_code: "41226",

    ste_name: "KY",
  },
  {
    zip_code: "41366",

    ste_name: "KY",
  },
  {
    zip_code: "41612",

    ste_name: "KY",
  },
  {
    zip_code: "41643",

    ste_name: "KY",
  },
  {
    zip_code: "41723",

    ste_name: "KY",
  },
  {
    zip_code: "41763",

    ste_name: "KY",
  },
  {
    zip_code: "41777",

    ste_name: "KY",
  },
  {
    zip_code: "41822",

    ste_name: "KY",
  },
  {
    zip_code: "42028",

    ste_name: "KY",
  },
  {
    zip_code: "42044",

    ste_name: "KY",
  },
  {
    zip_code: "42055",

    ste_name: "KY",
  },
  {
    zip_code: "42103",

    ste_name: "KY",
  },
  {
    zip_code: "42140",

    ste_name: "KY",
  },
  {
    zip_code: "42207",

    ste_name: "KY",
  },
  {
    zip_code: "42215",

    ste_name: "KY",
  },
  {
    zip_code: "42321",

    ste_name: "KY",
  },
  {
    zip_code: "42351",

    ste_name: "KY",
  },
  {
    zip_code: "42408",

    ste_name: "KY",
  },
  {
    zip_code: "42437",

    ste_name: "KY",
  },
  {
    zip_code: "42440",

    ste_name: "KY",
  },
  {
    zip_code: "42519",

    ste_name: "KY",
  },
  {
    zip_code: "42528",

    ste_name: "KY",
  },
  {
    zip_code: "43001",

    ste_name: "OH",
  },
  {
    zip_code: "43014",

    ste_name: "OH",
  },
  {
    zip_code: "43066",

    ste_name: "OH",
  },
  {
    zip_code: "43152",

    ste_name: "OH",
  },
  {
    zip_code: "43334",

    ste_name: "OH",
  },
  {
    zip_code: "43420",

    ste_name: "OH",
  },
  {
    zip_code: "43521",

    ste_name: "OH",
  },
  {
    zip_code: "43534",

    ste_name: "OH",
  },
  {
    zip_code: "43556",

    ste_name: "OH",
  },
  {
    zip_code: "43721",

    ste_name: "OH",
  },
  {
    zip_code: "43761",

    ste_name: "OH",
  },
  {
    zip_code: "43811",

    ste_name: "OH",
  },
  {
    zip_code: "43946",

    ste_name: "OH",
  },
  {
    zip_code: "44039",

    ste_name: "OH",
  },
  {
    zip_code: "44060",

    ste_name: "OH",
  },
  {
    zip_code: "44126",

    ste_name: "OH",
  },
  {
    zip_code: "44134",

    ste_name: "OH",
  },
  {
    zip_code: "44135",

    ste_name: "OH",
  },
  {
    zip_code: "44287",

    ste_name: "OH",
  },
  {
    zip_code: "44401",

    ste_name: "OH",
  },
  {
    zip_code: "44652",

    ste_name: "OH",
  },
  {
    zip_code: "44653",

    ste_name: "OH",
  },
  {
    zip_code: "44822",

    ste_name: "OH",
  },
  {
    zip_code: "44880",

    ste_name: "OH",
  },
  {
    zip_code: "44883",

    ste_name: "OH",
  },
  {
    zip_code: "45001",

    ste_name: "OH",
  },
  {
    zip_code: "45042",

    ste_name: "OH",
  },
  {
    zip_code: "45051",

    ste_name: "OH",
  },
  {
    zip_code: "45121",

    ste_name: "OH",
  },
  {
    zip_code: "45236",

    ste_name: "OH",
  },
  {
    zip_code: "45303",

    ste_name: "OH",
  },
  {
    zip_code: "45336",

    ste_name: "OH",
  },
  {
    zip_code: "45338",

    ste_name: "OH",
  },
  {
    zip_code: "45351",

    ste_name: "OH",
  },
  {
    zip_code: "45415",

    ste_name: "OH",
  },
  {
    zip_code: "45673",

    ste_name: "OH",
  },
  {
    zip_code: "45742",

    ste_name: "OH",
  },
  {
    zip_code: "45746",

    ste_name: "OH",
  },
  {
    zip_code: "45784",

    ste_name: "OH",
  },
  {
    zip_code: "45788",

    ste_name: "OH",
  },
  {
    zip_code: "45814",

    ste_name: "OH",
  },
  {
    zip_code: "45821",

    ste_name: "OH",
  },
  {
    zip_code: "45828",

    ste_name: "OH",
  },
  {
    zip_code: "45877",

    ste_name: "OH",
  },
  {
    zip_code: "46016",

    ste_name: "IN",
  },
  {
    zip_code: "46056",

    ste_name: "IN",
  },
  {
    zip_code: "46060",

    ste_name: "IN",
  },
  {
    zip_code: "46149",

    ste_name: "IN",
  },
  {
    zip_code: "46256",

    ste_name: "IN",
  },
  {
    zip_code: "46324",

    ste_name: "IN",
  },
  {
    zip_code: "46540",

    ste_name: "IN",
  },
  {
    zip_code: "46637",

    ste_name: "IN",
  },
  {
    zip_code: "46738",

    ste_name: "IN",
  },
  {
    zip_code: "46746",

    ste_name: "IN",
  },
  {
    zip_code: "46764",

    ste_name: "IN",
  },
  {
    zip_code: "46779",

    ste_name: "IN",
  },
  {
    zip_code: "46928",

    ste_name: "IN",
  },
  {
    zip_code: "47010",

    ste_name: "IN",
  },
  {
    zip_code: "47111",

    ste_name: "IN",
  },
  {
    zip_code: "47130",

    ste_name: "IN",
  },
  {
    zip_code: "47272",

    ste_name: "IN",
  },
  {
    zip_code: "47302",

    ste_name: "IN",
  },
  {
    zip_code: "47393",

    ste_name: "IN",
  },
  {
    zip_code: "47429",

    ste_name: "IN",
  },
  {
    zip_code: "47443",

    ste_name: "IN",
  },
  {
    zip_code: "47453",

    ste_name: "IN",
  },
  {
    zip_code: "47713",

    ste_name: "IN",
  },
  {
    zip_code: "47725",

    ste_name: "IN",
  },
  {
    zip_code: "47802",

    ste_name: "IN",
  },
  {
    zip_code: "47909",

    ste_name: "IN",
  },
  {
    zip_code: "47918",

    ste_name: "IN",
  },
  {
    zip_code: "47924",

    ste_name: "IN",
  },
  {
    zip_code: "47980",

    ste_name: "IN",
  },
  {
    zip_code: "47982",

    ste_name: "IN",
  },
  {
    zip_code: "47994",

    ste_name: "IN",
  },
  {
    zip_code: "48038",

    ste_name: "MI",
  },
  {
    zip_code: "48041",

    ste_name: "MI",
  },
  {
    zip_code: "48070",

    ste_name: "MI",
  },
  {
    zip_code: "48096",

    ste_name: "MI",
  },
  {
    zip_code: "48133",

    ste_name: "MI",
  },
  {
    zip_code: "48192",

    ste_name: "MI",
  },
  {
    zip_code: "48438",

    ste_name: "MI",
  },
  {
    zip_code: "48475",

    ste_name: "MI",
  },
  {
    zip_code: "48602",

    ste_name: "MI",
  },
  {
    zip_code: "48629",

    ste_name: "MI",
  },
  {
    zip_code: "48724",

    ste_name: "MI",
  },
  {
    zip_code: "48733",

    ste_name: "MI",
  },
  {
    zip_code: "48735",

    ste_name: "MI",
  },
  {
    zip_code: "48740",

    ste_name: "MI",
  },
  {
    zip_code: "48816",

    ste_name: "MI",
  },
  {
    zip_code: "48821",

    ste_name: "MI",
  },
  {
    zip_code: "48843",

    ste_name: "MI",
  },
  {
    zip_code: "48857",

    ste_name: "MI",
  },
  {
    zip_code: "48881",

    ste_name: "MI",
  },
  {
    zip_code: "48890",

    ste_name: "MI",
  },
  {
    zip_code: "49053",

    ste_name: "MI",
  },
  {
    zip_code: "49068",

    ste_name: "MI",
  },
  {
    zip_code: "49277",

    ste_name: "MI",
  },
  {
    zip_code: "49342",

    ste_name: "MI",
  },
  {
    zip_code: "49406",

    ste_name: "MI",
  },
  {
    zip_code: "49689",

    ste_name: "MI",
  },
  {
    zip_code: "49733",

    ste_name: "MI",
  },
  {
    zip_code: "49791",

    ste_name: "MI",
  },
  {
    zip_code: "49812",

    ste_name: "MI",
  },
  {
    zip_code: "50051",

    ste_name: "IA",
  },
  {
    zip_code: "50117",

    ste_name: "IA",
  },
  {
    zip_code: "50217",

    ste_name: "IA",
  },
  {
    zip_code: "50219",

    ste_name: "IA",
  },
  {
    zip_code: "50234",

    ste_name: "IA",
  },
  {
    zip_code: "50240",

    ste_name: "IA",
  },
  {
    zip_code: "50251",

    ste_name: "IA",
  },
  {
    zip_code: "50455",

    ste_name: "IA",
  },
  {
    zip_code: "50519",

    ste_name: "IA",
  },
  {
    zip_code: "50524",

    ste_name: "IA",
  },
  {
    zip_code: "50551",

    ste_name: "IA",
  },
  {
    zip_code: "50585",

    ste_name: "IA",
  },
  {
    zip_code: "50613",

    ste_name: "IA",
  },
  {
    zip_code: "50622",

    ste_name: "IA",
  },
  {
    zip_code: "50630",

    ste_name: "IA",
  },
  {
    zip_code: "50707",

    ste_name: "IA",
  },
  {
    zip_code: "50845",

    ste_name: "IA",
  },
  {
    zip_code: "51031",

    ste_name: "IA",
  },
  {
    zip_code: "51105",

    ste_name: "IA",
  },
  {
    zip_code: "51109",

    ste_name: "IA",
  },
  {
    zip_code: "51443",

    ste_name: "IA",
  },
  {
    zip_code: "51573",

    ste_name: "IA",
  },
  {
    zip_code: "51656",

    ste_name: "IA",
  },
  {
    zip_code: "52041",

    ste_name: "IA",
  },
  {
    zip_code: "52046",

    ste_name: "IA",
  },
  {
    zip_code: "52057",

    ste_name: "IA",
  },
  {
    zip_code: "52065",

    ste_name: "IA",
  },
  {
    zip_code: "52077",

    ste_name: "IA",
  },
  {
    zip_code: "52218",

    ste_name: "IA",
  },
  {
    zip_code: "52333",

    ste_name: "IA",
  },
  {
    zip_code: "52342",

    ste_name: "IA",
  },
  {
    zip_code: "52554",

    ste_name: "IA",
  },
  {
    zip_code: "52576",

    ste_name: "IA",
  },
  {
    zip_code: "52591",

    ste_name: "IA",
  },
  {
    zip_code: "52627",

    ste_name: "IA",
  },
  {
    zip_code: "53014",

    ste_name: "WI",
  },
  {
    zip_code: "53031",

    ste_name: "WI",
  },
  {
    zip_code: "53038",

    ste_name: "WI",
  },
  {
    zip_code: "53058",

    ste_name: "WI",
  },
  {
    zip_code: "53076",

    ste_name: "WI",
  },
  {
    zip_code: "53137",

    ste_name: "WI",
  },
  {
    zip_code: "53139",

    ste_name: "WI",
  },
  {
    zip_code: "53404",

    ste_name: "WI",
  },
  {
    zip_code: "53563",

    ste_name: "WI",
  },
  {
    zip_code: "53572",

    ste_name: "WI",
  },
  {
    zip_code: "53586",

    ste_name: "WI",
  },
  {
    zip_code: "53817",

    ste_name: "WI",
  },
  {
    zip_code: "53827",

    ste_name: "WI",
  },
  {
    zip_code: "53924",

    ste_name: "WI",
  },
  {
    zip_code: "53947",

    ste_name: "WI",
  },
  {
    zip_code: "54001",

    ste_name: "WI",
  },
  {
    zip_code: "54009",

    ste_name: "WI",
  },
  {
    zip_code: "54014",

    ste_name: "WI",
  },
  {
    zip_code: "54130",

    ste_name: "WI",
  },
  {
    zip_code: "54166",

    ste_name: "WI",
  },
  {
    zip_code: "54406",

    ste_name: "WI",
  },
  {
    zip_code: "54457",

    ste_name: "WI",
  },
  {
    zip_code: "54558",

    ste_name: "WI",
  },
  {
    zip_code: "54568",

    ste_name: "WI",
  },
  {
    zip_code: "54601",

    ste_name: "WI",
  },
  {
    zip_code: "54623",

    ste_name: "WI",
  },
  {
    zip_code: "54624",

    ste_name: "WI",
  },
  {
    zip_code: "54626",

    ste_name: "WI",
  },
  {
    zip_code: "54630",

    ste_name: "WI",
  },
  {
    zip_code: "54667",

    ste_name: "WI",
  },
  {
    zip_code: "54729",

    ste_name: "WI",
  },
  {
    zip_code: "54733",

    ste_name: "WI",
  },
  {
    zip_code: "54768",

    ste_name: "WI",
  },
  {
    zip_code: "54820",

    ste_name: "WI",
  },
  {
    zip_code: "54867",

    ste_name: "WI",
  },
  {
    zip_code: "54868",

    ste_name: "WI",
  },
  {
    zip_code: "54875",

    ste_name: "WI",
  },
  {
    zip_code: "54901",

    ste_name: "WI",
  },
  {
    zip_code: "55032",

    ste_name: "MN",
  },
  {
    zip_code: "55033",

    ste_name: "MN",
  },
  {
    zip_code: "55073",

    ste_name: "MN",
  },
  {
    zip_code: "55106",

    ste_name: "MN",
  },
  {
    zip_code: "55124",

    ste_name: "MN",
  },
  {
    zip_code: "55314",

    ste_name: "MN",
  },
  {
    zip_code: "55385",

    ste_name: "MN",
  },
  {
    zip_code: "55395",

    ste_name: "MN",
  },
  {
    zip_code: "55431",

    ste_name: "MN",
  },
  {
    zip_code: "55446",

    ste_name: "MN",
  },
  {
    zip_code: "55606",

    ste_name: "MN",
  },
  {
    zip_code: "55731",

    ste_name: "MN",
  },
  {
    zip_code: "55753",

    ste_name: "MN",
  },
  {
    zip_code: "55765",

    ste_name: "MN",
  },
  {
    zip_code: "55786",

    ste_name: "MN",
  },
  {
    zip_code: "55804",

    ste_name: "MN",
  },
  {
    zip_code: "55934",

    ste_name: "MN",
  },
  {
    zip_code: "55940",

    ste_name: "MN",
  },
  {
    zip_code: "55945",

    ste_name: "MN",
  },
  {
    zip_code: "56088",

    ste_name: "MN",
  },
  {
    zip_code: "56114",

    ste_name: "MN",
  },
  {
    zip_code: "56153",

    ste_name: "MN",
  },
  {
    zip_code: "56225",

    ste_name: "MN",
  },
  {
    zip_code: "56244",

    ste_name: "MN",
  },
  {
    zip_code: "56258",

    ste_name: "MN",
  },
  {
    zip_code: "56279",

    ste_name: "MN",
  },
  {
    zip_code: "56284",

    ste_name: "MN",
  },
  {
    zip_code: "56312",

    ste_name: "MN",
  },
  {
    zip_code: "56328",

    ste_name: "MN",
  },
  {
    zip_code: "56359",

    ste_name: "MN",
  },
  {
    zip_code: "56438",

    ste_name: "MN",
  },
  {
    zip_code: "56448",

    ste_name: "MN",
  },
  {
    zip_code: "56521",

    ste_name: "MN",
  },
  {
    zip_code: "56580",

    ste_name: "MN",
  },
  {
    zip_code: "56681",

    ste_name: "MN",
  },
  {
    zip_code: "56759",

    ste_name: "MN",
  },
  {
    zip_code: "57021",

    ste_name: "SD",
  },
  {
    zip_code: "57035",

    ste_name: "SD",
  },
  {
    zip_code: "57266",

    ste_name: "SD",
  },
  {
    zip_code: "57376",

    ste_name: "SD",
  },
  {
    zip_code: "57540",

    ste_name: "SD",
  },
  {
    zip_code: "57555",

    ste_name: "SD",
  },
  {
    zip_code: "57571",

    ste_name: "SD",
  },
  {
    zip_code: "57577",

    ste_name: "SD",
  },
  {
    zip_code: "57621",

    ste_name: "SD",
  },
  {
    zip_code: "58004",

    ste_name: "ND",
  },
  {
    zip_code: "58201",

    ste_name: "ND",
  },
  {
    zip_code: "58210",

    ste_name: "ND",
  },
  {
    zip_code: "58239",

    ste_name: "ND",
  },
  {
    zip_code: "58425",

    ste_name: "ND",
  },
  {
    zip_code: "58477",

    ste_name: "ND",
  },
  {
    zip_code: "58544",

    ste_name: "ND",
  },
  {
    zip_code: "58561",

    ste_name: "ND",
  },
  {
    zip_code: "58573",

    ste_name: "ND",
  },
  {
    zip_code: "58734",

    ste_name: "ND",
  },
  {
    zip_code: "59024",

    ste_name: "MT",
  },
  {
    zip_code: "59064",

    ste_name: "MT",
  },
  {
    zip_code: "59418",

    ste_name: "MT",
  },
  {
    zip_code: "59453",

    ste_name: "MT",
  },
  {
    zip_code: "59463",

    ste_name: "MT",
  },
  {
    zip_code: "59601",

    ste_name: "MT",
  },
  {
    zip_code: "59714",

    ste_name: "MT",
  },
  {
    zip_code: "59855",

    ste_name: "MT",
  },
  {
    zip_code: "59865",

    ste_name: "MT",
  },
  {
    zip_code: "60015",

    ste_name: "IL",
  },
  {
    zip_code: "60045",

    ste_name: "IL",
  },
  {
    zip_code: "60053",

    ste_name: "IL",
  },
  {
    zip_code: "60062",

    ste_name: "IL",
  },
  {
    zip_code: "60085",

    ste_name: "IL",
  },
  {
    zip_code: "60139",

    ste_name: "IL",
  },
  {
    zip_code: "60155",

    ste_name: "IL",
  },
  {
    zip_code: "60401",

    ste_name: "IL",
  },
  {
    zip_code: "60531",

    ste_name: "IL",
  },
  {
    zip_code: "60540",

    ste_name: "IL",
  },
  {
    zip_code: "60661",

    ste_name: "IL",
  },
  {
    zip_code: "60910",

    ste_name: "IL",
  },
  {
    zip_code: "61241",

    ste_name: "IL",
  },
  {
    zip_code: "61310",

    ste_name: "IL",
  },
  {
    zip_code: "61318",

    ste_name: "IL",
  },
  {
    zip_code: "61335",

    ste_name: "IL",
  },
  {
    zip_code: "61363",

    ste_name: "IL",
  },
  {
    zip_code: "61453",

    ste_name: "IL",
  },
  {
    zip_code: "61489",

    ste_name: "IL",
  },
  {
    zip_code: "61544",

    ste_name: "IL",
  },
  {
    zip_code: "61611",

    ste_name: "IL",
  },
  {
    zip_code: "61720",

    ste_name: "IL",
  },
  {
    zip_code: "61755",

    ste_name: "IL",
  },
  {
    zip_code: "61848",

    ste_name: "IL",
  },
  {
    zip_code: "61857",

    ste_name: "IL",
  },
  {
    zip_code: "61872",

    ste_name: "IL",
  },
  {
    zip_code: "61957",

    ste_name: "IL",
  },
  {
    zip_code: "62030",

    ste_name: "IL",
  },
  {
    zip_code: "62053",

    ste_name: "IL",
  },
  {
    zip_code: "62086",

    ste_name: "IL",
  },
  {
    zip_code: "62095",

    ste_name: "IL",
  },
  {
    zip_code: "62250",

    ste_name: "IL",
  },
  {
    zip_code: "62254",

    ste_name: "IL",
  },
  {
    zip_code: "62439",

    ste_name: "IL",
  },
  {
    zip_code: "62440",

    ste_name: "IL",
  },
  {
    zip_code: "62480",

    ste_name: "IL",
  },
  {
    zip_code: "62537",

    ste_name: "IL",
  },
  {
    zip_code: "62550",

    ste_name: "IL",
  },
  {
    zip_code: "62557",

    ste_name: "IL",
  },
  {
    zip_code: "62806",

    ste_name: "IL",
  },
  {
    zip_code: "62844",

    ste_name: "IL",
  },
  {
    zip_code: "62886",

    ste_name: "IL",
  },
  {
    zip_code: "62979",

    ste_name: "IL",
  },
  {
    zip_code: "63084",

    ste_name: "MO",
  },
  {
    zip_code: "63106",

    ste_name: "MO",
  },
  {
    zip_code: "63121",

    ste_name: "MO",
  },
  {
    zip_code: "63376",

    ste_name: "MO",
  },
  {
    zip_code: "63433",

    ste_name: "MO",
  },
  {
    zip_code: "63540",

    ste_name: "MO",
  },
  {
    zip_code: "63543",

    ste_name: "MO",
  },
  {
    zip_code: "63566",

    ste_name: "MO",
  },
  {
    zip_code: "63801",

    ste_name: "MO",
  },
  {
    zip_code: "63951",

    ste_name: "MO",
  },
  {
    zip_code: "64063",

    ste_name: "MO",
  },
  {
    zip_code: "64072",

    ste_name: "MO",
  },
  {
    zip_code: "64081",

    ste_name: "MO",
  },
  {
    zip_code: "64126",

    ste_name: "MO",
  },
  {
    zip_code: "64127",

    ste_name: "MO",
  },
  {
    zip_code: "64441",

    ste_name: "MO",
  },
  {
    zip_code: "64448",

    ste_name: "MO",
  },
  {
    zip_code: "64752",

    ste_name: "MO",
  },
  {
    zip_code: "64840",

    ste_name: "MO",
  },
  {
    zip_code: "65017",

    ste_name: "MO",
  },
  {
    zip_code: "65260",

    ste_name: "MO",
  },
  {
    zip_code: "65287",

    ste_name: "MO",
  },
  {
    zip_code: "65336",

    ste_name: "MO",
  },
  {
    zip_code: "65441",

    ste_name: "MO",
  },
  {
    zip_code: "65529",

    ste_name: "MO",
  },
  {
    zip_code: "65560",

    ste_name: "MO",
  },
  {
    zip_code: "65634",

    ste_name: "MO",
  },
  {
    zip_code: "65723",

    ste_name: "MO",
  },
  {
    zip_code: "65787",

    ste_name: "MO",
  },
  {
    zip_code: "66040",

    ste_name: "KS",
  },
  {
    zip_code: "66043",

    ste_name: "KS",
  },
  {
    zip_code: "66073",

    ste_name: "KS",
  },
  {
    zip_code: "66208",

    ste_name: "KS",
  },
  {
    zip_code: "66414",

    ste_name: "KS",
  },
  {
    zip_code: "66431",

    ste_name: "KS",
  },
  {
    zip_code: "66509",

    ste_name: "KS",
  },
  {
    zip_code: "66515",

    ste_name: "KS",
  },
  {
    zip_code: "66528",

    ste_name: "KS",
  },
  {
    zip_code: "66544",

    ste_name: "KS",
  },
  {
    zip_code: "66619",

    ste_name: "KS",
  },
  {
    zip_code: "66930",

    ste_name: "KS",
  },
  {
    zip_code: "67008",

    ste_name: "KS",
  },
  {
    zip_code: "67047",

    ste_name: "KS",
  },
  {
    zip_code: "67072",

    ste_name: "KS",
  },
  {
    zip_code: "67140",

    ste_name: "KS",
  },
  {
    zip_code: "67146",

    ste_name: "KS",
  },
  {
    zip_code: "67416",

    ste_name: "KS",
  },
  {
    zip_code: "67442",

    ste_name: "KS",
  },
  {
    zip_code: "67513",

    ste_name: "KS",
  },
  {
    zip_code: "67552",

    ste_name: "KS",
  },
  {
    zip_code: "67560",

    ste_name: "KS",
  },
  {
    zip_code: "67643",

    ste_name: "KS",
  },
  {
    zip_code: "67658",

    ste_name: "KS",
  },
  {
    zip_code: "67675",

    ste_name: "KS",
  },
  {
    zip_code: "67764",

    ste_name: "KS",
  },
  {
    zip_code: "67877",

    ste_name: "KS",
  },
  {
    zip_code: "68045",

    ste_name: "NE",
  },
  {
    zip_code: "68314",

    ste_name: "NE",
  },
  {
    zip_code: "68322",

    ste_name: "NE",
  },
  {
    zip_code: "68340",

    ste_name: "NE",
  },
  {
    zip_code: "68357",

    ste_name: "NE",
  },
  {
    zip_code: "68361",

    ste_name: "NE",
  },
  {
    zip_code: "68413",

    ste_name: "NE",
  },
  {
    zip_code: "68452",

    ste_name: "NE",
  },
  {
    zip_code: "68455",

    ste_name: "NE",
  },
  {
    zip_code: "68460",

    ste_name: "NE",
  },
  {
    zip_code: "68622",

    ste_name: "NE",
  },
  {
    zip_code: "68723",

    ste_name: "NE",
  },
  {
    zip_code: "68725",

    ste_name: "NE",
  },
  {
    zip_code: "68756",

    ste_name: "NE",
  },
  {
    zip_code: "68769",

    ste_name: "NE",
  },
  {
    zip_code: "68786",

    ste_name: "NE",
  },
  {
    zip_code: "68840",

    ste_name: "NE",
  },
  {
    zip_code: "68959",

    ste_name: "NE",
  },
  {
    zip_code: "68967",

    ste_name: "NE",
  },
  {
    zip_code: "68980",

    ste_name: "NE",
  },
  {
    zip_code: "69041",

    ste_name: "NE",
  },
  {
    zip_code: "69337",

    ste_name: "NE",
  },
  {
    zip_code: "70339",

    ste_name: "LA",
  },
  {
    zip_code: "70611",

    ste_name: "LA",
  },
  {
    zip_code: "70638",

    ste_name: "LA",
  },
  {
    zip_code: "70762",

    ste_name: "LA",
  },
  {
    zip_code: "71043",

    ste_name: "LA",
  },
  {
    zip_code: "71129",

    ste_name: "LA",
  },
  {
    zip_code: "71220",

    ste_name: "LA",
  },
  {
    zip_code: "71253",

    ste_name: "LA",
  },
  {
    zip_code: "71351",

    ste_name: "LA",
  },
  {
    zip_code: "71463",

    ste_name: "LA",
  },
  {
    zip_code: "71749",

    ste_name: "AR",
  },
  {
    zip_code: "71823",

    ste_name: "AR",
  },
  {
    zip_code: "71826",

    ste_name: "AR",
  },
  {
    zip_code: "71827",

    ste_name: "AR",
  },
  {
    zip_code: "71855",

    ste_name: "AR",
  },
  {
    zip_code: "72051",

    ste_name: "AR",
  },
  {
    zip_code: "72157",

    ste_name: "AR",
  },
  {
    zip_code: "72338",

    ste_name: "AR",
  },
  {
    zip_code: "72466",

    ste_name: "AR",
  },
  {
    zip_code: "72471",

    ste_name: "AR",
  },
  {
    zip_code: "72472",

    ste_name: "AR",
  },
  {
    zip_code: "72565",

    ste_name: "AR",
  },
  {
    zip_code: "72668",

    ste_name: "AR",
  },
  {
    zip_code: "72669",

    ste_name: "AR",
  },
  {
    zip_code: "72719",

    ste_name: "AR",
  },
  {
    zip_code: "72841",

    ste_name: "AR",
  },
  {
    zip_code: "72853",

    ste_name: "AR",
  },
  {
    zip_code: "73024",

    ste_name: "OK",
  },
  {
    zip_code: "73052",

    ste_name: "OK",
  },
  {
    zip_code: "73090",

    ste_name: "OK",
  },
  {
    zip_code: "73120",

    ste_name: "OK",
  },
  {
    zip_code: "73149",

    ste_name: "OK",
  },
  {
    zip_code: "73434",

    ste_name: "OK",
  },
  {
    zip_code: "73463",

    ste_name: "OK",
  },
  {
    zip_code: "73505",

    ste_name: "OK",
  },
  {
    zip_code: "73647",

    ste_name: "OK",
  },
  {
    zip_code: "73658",

    ste_name: "OK",
  },
  {
    zip_code: "73753",

    ste_name: "OK",
  },
  {
    zip_code: "74134",

    ste_name: "OK",
  },
  {
    zip_code: "74361",

    ste_name: "OK",
  },
  {
    zip_code: "74366",

    ste_name: "OK",
  },
  {
    zip_code: "74454",

    ste_name: "OK",
  },
  {
    zip_code: "74471",

    ste_name: "OK",
  },
  {
    zip_code: "74522",

    ste_name: "OK",
  },
  {
    zip_code: "74536",

    ste_name: "OK",
  },
  {
    zip_code: "74538",

    ste_name: "OK",
  },
  {
    zip_code: "74540",

    ste_name: "OK",
  },
  {
    zip_code: "74637",

    ste_name: "OK",
  },
  {
    zip_code: "74701",

    ste_name: "OK",
  },
  {
    zip_code: "74747",

    ste_name: "OK",
  },
  {
    zip_code: "74761",

    ste_name: "OK",
  },
  {
    zip_code: "74837",

    ste_name: "OK",
  },
  {
    zip_code: "75077",

    ste_name: "TX",
  },
  {
    zip_code: "75103",

    ste_name: "TX",
  },
  {
    zip_code: "75110",

    ste_name: "TX",
  },
  {
    zip_code: "75159",

    ste_name: "TX",
  },
  {
    zip_code: "75181",

    ste_name: "TX",
  },
  {
    zip_code: "75236",

    ste_name: "TX",
  },
  {
    zip_code: "75453",

    ste_name: "TX",
  },
  {
    zip_code: "75489",

    ste_name: "TX",
  },
  {
    zip_code: "75565",

    ste_name: "TX",
  },
  {
    zip_code: "75703",

    ste_name: "TX",
  },
  {
    zip_code: "75779",

    ste_name: "TX",
  },
  {
    zip_code: "75846",

    ste_name: "TX",
  },
  {
    zip_code: "76048",

    ste_name: "TX",
  },
  {
    zip_code: "76119",

    ste_name: "TX",
  },
  {
    zip_code: "76442",

    ste_name: "TX",
  },
  {
    zip_code: "76449",

    ste_name: "TX",
  },
  {
    zip_code: "76664",

    ste_name: "TX",
  },
  {
    zip_code: "76680",

    ste_name: "TX",
  },
  {
    zip_code: "76853",

    ste_name: "TX",
  },
  {
    zip_code: "76941",

    ste_name: "TX",
  },
  {
    zip_code: "76950",

    ste_name: "TX",
  },
  {
    zip_code: "76957",

    ste_name: "TX",
  },
  {
    zip_code: "77302",

    ste_name: "TX",
  },
  {
    zip_code: "77385",

    ste_name: "TX",
  },
  {
    zip_code: "77412",

    ste_name: "TX",
  },
  {
    zip_code: "77423",

    ste_name: "TX",
  },
  {
    zip_code: "77428",

    ste_name: "TX",
  },
  {
    zip_code: "77464",

    ste_name: "TX",
  },
  {
    zip_code: "77469",

    ste_name: "TX",
  },
  {
    zip_code: "77502",

    ste_name: "TX",
  },
  {
    zip_code: "77514",

    ste_name: "TX",
  },
  {
    zip_code: "77845",

    ste_name: "TX",
  },
  {
    zip_code: "77876",

    ste_name: "TX",
  },
  {
    zip_code: "77957",

    ste_name: "TX",
  },
  {
    zip_code: "77979",

    ste_name: "TX",
  },
  {
    zip_code: "77995",

    ste_name: "TX",
  },
  {
    zip_code: "78001",

    ste_name: "TX",
  },
  {
    zip_code: "78039",

    ste_name: "TX",
  },
  {
    zip_code: "78218",

    ste_name: "TX",
  },
  {
    zip_code: "78255",

    ste_name: "TX",
  },
  {
    zip_code: "78339",

    ste_name: "TX",
  },
  {
    zip_code: "78351",

    ste_name: "TX",
  },
  {
    zip_code: "78361",

    ste_name: "TX",
  },
  {
    zip_code: "78407",

    ste_name: "TX",
  },
  {
    zip_code: "78414",

    ste_name: "TX",
  },
  {
    zip_code: "78417",

    ste_name: "TX",
  },
  {
    zip_code: "78576",

    ste_name: "TX",
  },
  {
    zip_code: "78598",

    ste_name: "TX",
  },
  {
    zip_code: "78608",

    ste_name: "TX",
  },
  {
    zip_code: "78614",

    ste_name: "TX",
  },
  {
    zip_code: "78618",

    ste_name: "TX",
  },
  {
    zip_code: "78632",

    ste_name: "TX",
  },
  {
    zip_code: "78677",

    ste_name: "TX",
  },
  {
    zip_code: "78702",

    ste_name: "TX",
  },
  {
    zip_code: "78721",

    ste_name: "TX",
  },
  {
    zip_code: "78744",

    ste_name: "TX",
  },
  {
    zip_code: "78750",

    ste_name: "TX",
  },
  {
    zip_code: "78851",

    ste_name: "TX",
  },
  {
    zip_code: "78933",

    ste_name: "TX",
  },
  {
    zip_code: "79011",

    ste_name: "TX",
  },
  {
    zip_code: "79082",

    ste_name: "TX",
  },
  {
    zip_code: "79094",

    ste_name: "TX",
  },
  {
    zip_code: "79257",

    ste_name: "TX",
  },
  {
    zip_code: "79503",

    ste_name: "TX",
  },
  {
    zip_code: "79504",

    ste_name: "TX",
  },
  {
    zip_code: "79699",

    ste_name: "TX",
  },
  {
    zip_code: "79707",

    ste_name: "TX",
  },
  {
    zip_code: "79852",

    ste_name: "TX",
  },
  {
    zip_code: "79904",

    ste_name: "TX",
  },
  {
    zip_code: "79905",

    ste_name: "TX",
  },
  {
    zip_code: "80117",

    ste_name: "CO",
  },
  {
    zip_code: "80125",

    ste_name: "CO",
  },
  {
    zip_code: "80543",

    ste_name: "CO",
  },
  {
    zip_code: "80547",

    ste_name: "CO",
  },
  {
    zip_code: "80644",

    ste_name: "CO",
  },
  {
    zip_code: "80829",

    ste_name: "CO",
  },
  {
    zip_code: "81152",

    ste_name: "CO",
  },
  {
    zip_code: "81410",

    ste_name: "CO",
  },
  {
    zip_code: "81620",

    ste_name: "CO",
  },
  {
    zip_code: "81635",

    ste_name: "CO",
  },
  {
    zip_code: "82007",

    ste_name: "WY",
  },
  {
    zip_code: "82229",

    ste_name: "WY",
  },
  {
    zip_code: "82401",

    ste_name: "WY",
  },
  {
    zip_code: "82640",

    ste_name: "WY",
  },
  {
    zip_code: "83012",

    ste_name: "WY",
  },
  {
    zip_code: "83232",

    ste_name: "ID",
  },
  {
    zip_code: "83252",

    ste_name: "ID",
  },
  {
    zip_code: "83285",

    ste_name: "ID",
  },
  {
    zip_code: "83333",

    ste_name: "ID",
  },
  {
    zip_code: "83435",

    ste_name: "ID",
  },
  {
    zip_code: "83451",

    ste_name: "ID",
  },
  {
    zip_code: "83468",

    ste_name: "ID",
  },
  {
    zip_code: "83536",

    ste_name: "ID",
  },
  {
    zip_code: "83605",

    ste_name: "ID",
  },
  {
    zip_code: "83628",

    ste_name: "ID",
  },
  {
    zip_code: "83805",

    ste_name: "ID",
  },
  {
    zip_code: "84060",

    ste_name: "UT",
  },
  {
    zip_code: "84067",

    ste_name: "UT",
  },
  {
    zip_code: "84069",

    ste_name: "UT",
  },
  {
    zip_code: "84098",

    ste_name: "UT",
  },
  {
    zip_code: "84121",

    ste_name: "UT",
  },
  {
    zip_code: "84301",

    ste_name: "UT",
  },
  {
    zip_code: "84302",

    ste_name: "UT",
  },
  {
    zip_code: "84338",

    ste_name: "UT",
  },
  {
    zip_code: "84537",

    ste_name: "UT",
  },
  {
    zip_code: "84634",

    ste_name: "UT",
  },
  {
    zip_code: "84656",

    ste_name: "UT",
  },
  {
    zip_code: "85050",

    ste_name: "AZ",
  },
  {
    zip_code: "85172",

    ste_name: "AZ",
  },
  {
    zip_code: "85543",

    ste_name: "AZ",
  },
  {
    zip_code: "85605",

    ste_name: "AZ",
  },
  {
    zip_code: "85623",

    ste_name: "AZ",
  },
  {
    zip_code: "85645",

    ste_name: "AZ",
  },
  {
    zip_code: "85901",

    ste_name: "AZ",
  },
  {
    zip_code: "85924",

    ste_name: "AZ",
  },
  {
    zip_code: "86023",

    ste_name: "AZ",
  },
  {
    zip_code: "86413",

    ste_name: "AZ",
  },
  {
    zip_code: "86556",

    ste_name: "AZ",
  },
  {
    zip_code: "87005",

    ste_name: "NM",
  },
  {
    zip_code: "87040",

    ste_name: "NM",
  },
  {
    zip_code: "87043",

    ste_name: "NM",
  },
  {
    zip_code: "87070",

    ste_name: "NM",
  },
  {
    zip_code: "87114",

    ste_name: "NM",
  },
  {
    zip_code: "87319",

    ste_name: "NM",
  },
  {
    zip_code: "87455",

    ste_name: "NM",
  },
  {
    zip_code: "87514",

    ste_name: "NM",
  },
  {
    zip_code: "87522",

    ste_name: "NM",
  },
  {
    zip_code: "87528",

    ste_name: "NM",
  },
  {
    zip_code: "87532",

    ste_name: "NM",
  },
  {
    zip_code: "88042",

    ste_name: "NM",
  },
  {
    zip_code: "88121",

    ste_name: "NM",
  },
  {
    zip_code: "88210",

    ste_name: "NM",
  },
  {
    zip_code: "88240",

    ste_name: "NM",
  },
  {
    zip_code: "88253",

    ste_name: "NM",
  },
  {
    zip_code: "89084",

    ste_name: "NV",
  },
  {
    zip_code: "89143",

    ste_name: "NV",
  },
  {
    zip_code: "89405",

    ste_name: "NV",
  },
  {
    zip_code: "89448",

    ste_name: "NV",
  },
  {
    zip_code: "89701",

    ste_name: "NV",
  },
  {
    zip_code: "98613",

    ste_name: "WA",
  },
  {
    zip_code: "98664",

    ste_name: "WA",
  },
  {
    zip_code: "98686",

    ste_name: "WA",
  },
  {
    zip_code: "98827",

    ste_name: "WA",
  },
  {
    zip_code: "98857",

    ste_name: "WA",
  },
  {
    zip_code: "98858",

    ste_name: "WA",
  },
  {
    zip_code: "98903",

    ste_name: "WA",
  },
  {
    zip_code: "99012",

    ste_name: "WA",
  },
  {
    zip_code: "99031",

    ste_name: "WA",
  },
  {
    zip_code: "99133",

    ste_name: "WA",
  },
  {
    zip_code: "99148",

    ste_name: "WA",
  },
  {
    zip_code: "99156",

    ste_name: "WA",
  },
  {
    zip_code: "99161",

    ste_name: "WA",
  },
  {
    zip_code: "99171",

    ste_name: "WA",
  },
  {
    zip_code: "99328",

    ste_name: "WA",
  },
  {
    zip_code: "99343",

    ste_name: "WA",
  },
  {
    zip_code: "99559",

    ste_name: "AK",
  },
  {
    zip_code: "99585",

    ste_name: "AK",
  },
  {
    zip_code: "99611",

    ste_name: "AK",
  },
  {
    zip_code: "99631",

    ste_name: "AK",
  },
  {
    zip_code: "99670",

    ste_name: "AK",
  },
  {
    zip_code: "99709",

    ste_name: "AK",
  },
  {
    zip_code: "99712",

    ste_name: "AK",
  },
  {
    zip_code: "99742",

    ste_name: "AK",
  },
  {
    zip_code: "99772",

    ste_name: "AK",
  },
  {
    zip_code: "99835",

    ste_name: "AK",
  },
  {
    zip_code: "99927",

    ste_name: "AK",
  },
  {
    zip_code: "690",

    ste_name: "PR",
  },
  {
    zip_code: "694",

    ste_name: "PR",
  },
  {
    zip_code: "823",

    ste_name: "VI",
  },
  {
    zip_code: "906",

    ste_name: "PR",
  },
  {
    zip_code: "971",

    ste_name: "PR",
  },
  {
    zip_code: "985",

    ste_name: "PR",
  },
  {
    zip_code: "1068",

    ste_name: "MA",
  },
  {
    zip_code: "1071",

    ste_name: "MA",
  },
  {
    zip_code: "1079",

    ste_name: "MA",
  },
  {
    zip_code: "1151",

    ste_name: "MA",
  },
  {
    zip_code: "1224",

    ste_name: "MA",
  },
  {
    zip_code: "1240",

    ste_name: "MA",
  },
  {
    zip_code: "1253",

    ste_name: "MA",
  },
  {
    zip_code: "1254",

    ste_name: "MA",
  },
  {
    zip_code: "1340",

    ste_name: "MA",
  },
  {
    zip_code: "1434",

    ste_name: "MA",
  },
  {
    zip_code: "1436",

    ste_name: "MA",
  },
  {
    zip_code: "1467",

    ste_name: "MA",
  },
  {
    zip_code: "1590",

    ste_name: "MA",
  },
  {
    zip_code: "1821",

    ste_name: "MA",
  },
  {
    zip_code: "1902",

    ste_name: "MA",
  },
  {
    zip_code: "1950",

    ste_name: "MA",
  },
  {
    zip_code: "1970",

    ste_name: "MA",
  },
  {
    zip_code: "2035",

    ste_name: "MA",
  },
  {
    zip_code: "2186",

    ste_name: "MA",
  },
  {
    zip_code: "2351",

    ste_name: "MA",
  },
  {
    zip_code: "2446",

    ste_name: "MA",
  },
  {
    zip_code: "2653",

    ste_name: "MA",
  },
  {
    zip_code: "2816",

    ste_name: "RI",
  },
  {
    zip_code: "2908",

    ste_name: "RI",
  },
  {
    zip_code: "3076",

    ste_name: "NH",
  },
  {
    zip_code: "3226",

    ste_name: "NH",
  },
  {
    zip_code: "3233",

    ste_name: "NH",
  },
  {
    zip_code: "3461",

    ste_name: "NH",
  },
  {
    zip_code: "3883",

    ste_name: "NH",
  },
  {
    zip_code: "3887",

    ste_name: "NH",
  },
  {
    zip_code: "4051",

    ste_name: "ME",
  },
  {
    zip_code: "4061",

    ste_name: "ME",
  },
  {
    zip_code: "4240",

    ste_name: "ME",
  },
  {
    zip_code: "4349",

    ste_name: "ME",
  },
  {
    zip_code: "4352",

    ste_name: "ME",
  },
  {
    zip_code: "4489",

    ste_name: "ME",
  },
  {
    zip_code: "4496",

    ste_name: "ME",
  },
  {
    zip_code: "4627",

    ste_name: "ME",
  },
  {
    zip_code: "4683",

    ste_name: "ME",
  },
  {
    zip_code: "4732",

    ste_name: "ME",
  },
  {
    zip_code: "4853",

    ste_name: "ME",
  },
  {
    zip_code: "4982",

    ste_name: "ME",
  },
  {
    zip_code: "5254",

    ste_name: "VT",
  },
  {
    zip_code: "5403",

    ste_name: "VT",
  },
  {
    zip_code: "5440",

    ste_name: "VT",
  },
  {
    zip_code: "5448",

    ste_name: "VT",
  },
  {
    zip_code: "5471",

    ste_name: "VT",
  },
  {
    zip_code: "5494",

    ste_name: "VT",
  },
  {
    zip_code: "5602",

    ste_name: "VT",
  },
  {
    zip_code: "5647",

    ste_name: "VT",
  },
  {
    zip_code: "5765",

    ste_name: "VT",
  },
  {
    zip_code: "5872",

    ste_name: "VT",
  },
  {
    zip_code: "5875",

    ste_name: "VT",
  },
  {
    zip_code: "6243",

    ste_name: "CT",
  },
  {
    zip_code: "6355",

    ste_name: "CT",
  },
  {
    zip_code: "6382",

    ste_name: "CT",
  },
  {
    zip_code: "6389",

    ste_name: "CT",
  },
  {
    zip_code: "6390",

    ste_name: "NY",
  },
  {
    zip_code: "6469",

    ste_name: "CT",
  },
  {
    zip_code: "6471",

    ste_name: "CT",
  },
  {
    zip_code: "6488",

    ste_name: "CT",
  },
  {
    zip_code: "6704",

    ste_name: "CT",
  },
  {
    zip_code: "6710",

    ste_name: "CT",
  },
  {
    zip_code: "7008",

    ste_name: "NJ",
  },
  {
    zip_code: "7087",

    ste_name: "NJ",
  },
  {
    zip_code: "7860",

    ste_name: "NJ",
  },
  {
    zip_code: "7940",

    ste_name: "NJ",
  },
  {
    zip_code: "8033",

    ste_name: "NJ",
  },
  {
    zip_code: "8041",

    ste_name: "NJ",
  },
  {
    zip_code: "8064",

    ste_name: "NJ",
  },
  {
    zip_code: "8215",

    ste_name: "NJ",
  },
  {
    zip_code: "8226",

    ste_name: "NJ",
  },
  {
    zip_code: "22963",

    ste_name: "VA",
  },
  {
    zip_code: "22967",

    ste_name: "VA",
  },
  {
    zip_code: "23004",

    ste_name: "VA",
  },
  {
    zip_code: "23066",

    ste_name: "VA",
  },
  {
    zip_code: "23113",

    ste_name: "VA",
  },
  {
    zip_code: "23123",

    ste_name: "VA",
  },
  {
    zip_code: "23226",

    ste_name: "VA",
  },
  {
    zip_code: "23250",

    ste_name: "VA",
  },
  {
    zip_code: "23306",

    ste_name: "VA",
  },
  {
    zip_code: "23308",

    ste_name: "VA",
  },
  {
    zip_code: "23354",

    ste_name: "VA",
  },
  {
    zip_code: "23414",

    ste_name: "VA",
  },
  {
    zip_code: "23504",

    ste_name: "VA",
  },
  {
    zip_code: "23509",

    ste_name: "VA",
  },
  {
    zip_code: "23604",

    ste_name: "VA",
  },
  {
    zip_code: "23828",

    ste_name: "VA",
  },
  {
    zip_code: "23894",

    ste_name: "VA",
  },
  {
    zip_code: "24077",

    ste_name: "VA",
  },
  {
    zip_code: "24082",

    ste_name: "VA",
  },
  {
    zip_code: "24168",

    ste_name: "VA",
  },
  {
    zip_code: "24258",

    ste_name: "VA",
  },
  {
    zip_code: "24273",

    ste_name: "VA",
  },
  {
    zip_code: "24282",

    ste_name: "VA",
  },
  {
    zip_code: "24448",

    ste_name: "VA",
  },
  {
    zip_code: "24504",

    ste_name: "VA",
  },
  {
    zip_code: "24572",

    ste_name: "VA",
  },
  {
    zip_code: "24577",

    ste_name: "VA",
  },
  {
    zip_code: "24869",

    ste_name: "WV",
  },
  {
    zip_code: "24901",

    ste_name: "WV",
  },
  {
    zip_code: "24927",

    ste_name: "WV",
  },
  {
    zip_code: "24974",

    ste_name: "WV",
  },
  {
    zip_code: "25024",

    ste_name: "WV",
  },
  {
    zip_code: "25059",

    ste_name: "WV",
  },
  {
    zip_code: "25086",

    ste_name: "WV",
  },
  {
    zip_code: "25304",

    ste_name: "WV",
  },
  {
    zip_code: "25550",

    ste_name: "WV",
  },
  {
    zip_code: "25801",

    ste_name: "WV",
  },
  {
    zip_code: "25911",

    ste_name: "WV",
  },
  {
    zip_code: "26060",

    ste_name: "WV",
  },
  {
    zip_code: "26164",

    ste_name: "WV",
  },
  {
    zip_code: "26203",

    ste_name: "WV",
  },
  {
    zip_code: "26215",

    ste_name: "WV",
  },
  {
    zip_code: "26237",

    ste_name: "WV",
  },
  {
    zip_code: "26435",

    ste_name: "WV",
  },
  {
    zip_code: "26501",

    ste_name: "WV",
  },
  {
    zip_code: "26570",

    ste_name: "WV",
  },
  {
    zip_code: "26582",

    ste_name: "WV",
  },
  {
    zip_code: "26691",

    ste_name: "WV",
  },
  {
    zip_code: "26707",

    ste_name: "WV",
  },
  {
    zip_code: "26710",

    ste_name: "WV",
  },
  {
    zip_code: "27013",

    ste_name: "NC",
  },
  {
    zip_code: "27017",

    ste_name: "NC",
  },
  {
    zip_code: "27301",

    ste_name: "NC",
  },
  {
    zip_code: "27357",

    ste_name: "NC",
  },
  {
    zip_code: "27507",

    ste_name: "NC",
  },
  {
    zip_code: "27557",

    ste_name: "NC",
  },
  {
    zip_code: "27849",

    ste_name: "NC",
  },
  {
    zip_code: "27964",

    ste_name: "NC",
  },
  {
    zip_code: "27967",

    ste_name: "NC",
  },
  {
    zip_code: "27974",

    ste_name: "NC",
  },
  {
    zip_code: "28006",

    ste_name: "NC",
  },
  {
    zip_code: "28076",

    ste_name: "NC",
  },
  {
    zip_code: "28081",

    ste_name: "NC",
  },
  {
    zip_code: "28210",

    ste_name: "NC",
  },
  {
    zip_code: "28311",

    ste_name: "NC",
  },
  {
    zip_code: "28347",

    ste_name: "NC",
  },
  {
    zip_code: "28350",

    ste_name: "NC",
  },
  {
    zip_code: "28391",

    ste_name: "NC",
  },
  {
    zip_code: "28467",

    ste_name: "NC",
  },
  {
    zip_code: "28528",

    ste_name: "NC",
  },
  {
    zip_code: "28557",

    ste_name: "NC",
  },
  {
    zip_code: "28580",

    ste_name: "NC",
  },
  {
    zip_code: "28584",

    ste_name: "NC",
  },
  {
    zip_code: "28609",

    ste_name: "NC",
  },
  {
    zip_code: "28670",

    ste_name: "NC",
  },
  {
    zip_code: "28698",

    ste_name: "NC",
  },
  {
    zip_code: "28704",

    ste_name: "NC",
  },
  {
    zip_code: "28901",

    ste_name: "NC",
  },
  {
    zip_code: "29016",

    ste_name: "SC",
  },
  {
    zip_code: "29038",

    ste_name: "SC",
  },
  {
    zip_code: "29078",

    ste_name: "SC",
  },
  {
    zip_code: "29102",

    ste_name: "SC",
  },
  {
    zip_code: "29172",

    ste_name: "SC",
  },
  {
    zip_code: "29449",

    ste_name: "SC",
  },
  {
    zip_code: "29547",

    ste_name: "SC",
  },
  {
    zip_code: "29550",

    ste_name: "SC",
  },
  {
    zip_code: "29718",

    ste_name: "SC",
  },
  {
    zip_code: "29729",

    ste_name: "SC",
  },
  {
    zip_code: "29827",

    ste_name: "SC",
  },
  {
    zip_code: "29910",

    ste_name: "SC",
  },
  {
    zip_code: "29943",

    ste_name: "SC",
  },
  {
    zip_code: "30009",

    ste_name: "GA",
  },
  {
    zip_code: "30087",

    ste_name: "GA",
  },
  {
    zip_code: "30205",

    ste_name: "GA",
  },
  {
    zip_code: "30326",

    ste_name: "GA",
  },
  {
    zip_code: "30401",

    ste_name: "GA",
  },
  {
    zip_code: "30412",

    ste_name: "GA",
  },
  {
    zip_code: "30510",

    ste_name: "GA",
  },
  {
    zip_code: "30536",

    ste_name: "GA",
  },
  {
    zip_code: "30563",

    ste_name: "GA",
  },
  {
    zip_code: "30602",

    ste_name: "GA",
  },
  {
    zip_code: "30721",

    ste_name: "GA",
  },
  {
    zip_code: "30742",

    ste_name: "GA",
  },
  {
    zip_code: "58775",

    ste_name: "ND",
  },
  {
    zip_code: "58838",

    ste_name: "ND",
  },
  {
    zip_code: "58854",

    ste_name: "ND",
  },
  {
    zip_code: "59038",

    ste_name: "MT",
  },
  {
    zip_code: "59061",

    ste_name: "MT",
  },
  {
    zip_code: "59101",

    ste_name: "MT",
  },
  {
    zip_code: "59256",

    ste_name: "MT",
  },
  {
    zip_code: "59343",

    ste_name: "MT",
  },
  {
    zip_code: "59421",

    ste_name: "MT",
  },
  {
    zip_code: "59443",

    ste_name: "MT",
  },
  {
    zip_code: "59444",

    ste_name: "MT",
  },
  {
    zip_code: "59446",

    ste_name: "MT",
  },
  {
    zip_code: "59447",

    ste_name: "MT",
  },
  {
    zip_code: "59526",

    ste_name: "MT",
  },
  {
    zip_code: "59831",

    ste_name: "MT",
  },
  {
    zip_code: "59842",

    ste_name: "MT",
  },
  {
    zip_code: "59918",

    ste_name: "MT",
  },
  {
    zip_code: "60021",

    ste_name: "IL",
  },
  {
    zip_code: "60060",

    ste_name: "IL",
  },
  {
    zip_code: "60091",

    ste_name: "IL",
  },
  {
    zip_code: "60165",

    ste_name: "IL",
  },
  {
    zip_code: "60191",

    ste_name: "IL",
  },
  {
    zip_code: "60432",

    ste_name: "IL",
  },
  {
    zip_code: "60445",

    ste_name: "IL",
  },
  {
    zip_code: "60453",

    ste_name: "IL",
  },
  {
    zip_code: "60474",

    ste_name: "IL",
  },
  {
    zip_code: "60476",

    ste_name: "IL",
  },
  {
    zip_code: "60534",

    ste_name: "IL",
  },
  {
    zip_code: "60554",

    ste_name: "IL",
  },
  {
    zip_code: "60914",

    ste_name: "IL",
  },
  {
    zip_code: "60917",

    ste_name: "IL",
  },
  {
    zip_code: "61010",

    ste_name: "IL",
  },
  {
    zip_code: "61025",

    ste_name: "IL",
  },
  {
    zip_code: "61087",

    ste_name: "IL",
  },
  {
    zip_code: "61104",

    ste_name: "IL",
  },
  {
    zip_code: "61109",

    ste_name: "IL",
  },
  {
    zip_code: "61242",

    ste_name: "IL",
  },
  {
    zip_code: "61319",

    ste_name: "IL",
  },
  {
    zip_code: "61362",

    ste_name: "IL",
  },
  {
    zip_code: "61412",

    ste_name: "IL",
  },
  {
    zip_code: "61421",

    ste_name: "IL",
  },
  {
    zip_code: "61436",

    ste_name: "IL",
  },
  {
    zip_code: "61531",

    ste_name: "IL",
  },
  {
    zip_code: "61545",

    ste_name: "IL",
  },
  {
    zip_code: "61552",

    ste_name: "IL",
  },
  {
    zip_code: "61742",

    ste_name: "IL",
  },
  {
    zip_code: "61818",

    ste_name: "IL",
  },
  {
    zip_code: "61839",

    ste_name: "IL",
  },
  {
    zip_code: "61843",

    ste_name: "IL",
  },
  {
    zip_code: "61956",

    ste_name: "IL",
  },
  {
    zip_code: "62037",

    ste_name: "IL",
  },
  {
    zip_code: "62079",

    ste_name: "IL",
  },
  {
    zip_code: "62081",

    ste_name: "IL",
  },
  {
    zip_code: "62093",

    ste_name: "IL",
  },
  {
    zip_code: "62204",

    ste_name: "IL",
  },
  {
    zip_code: "62231",

    ste_name: "IL",
  },
  {
    zip_code: "62232",

    ste_name: "IL",
  },
  {
    zip_code: "62280",

    ste_name: "IL",
  },
  {
    zip_code: "62346",

    ste_name: "IL",
  },
  {
    zip_code: "62367",

    ste_name: "IL",
  },
  {
    zip_code: "62674",

    ste_name: "IL",
  },
  {
    zip_code: "62833",

    ste_name: "IL",
  },
  {
    zip_code: "62854",

    ste_name: "IL",
  },
  {
    zip_code: "62871",

    ste_name: "IL",
  },
  {
    zip_code: "62896",

    ste_name: "IL",
  },
  {
    zip_code: "62918",

    ste_name: "IL",
  },
  {
    zip_code: "62930",

    ste_name: "IL",
  },
  {
    zip_code: "62939",

    ste_name: "IL",
  },
  {
    zip_code: "62962",

    ste_name: "IL",
  },
  {
    zip_code: "62994",

    ste_name: "IL",
  },
  {
    zip_code: "63110",

    ste_name: "MO",
  },
  {
    zip_code: "63123",

    ste_name: "MO",
  },
  {
    zip_code: "63361",

    ste_name: "MO",
  },
  {
    zip_code: "63386",

    ste_name: "MO",
  },
  {
    zip_code: "63388",

    ste_name: "MO",
  },
  {
    zip_code: "63452",

    ste_name: "MO",
  },
  {
    zip_code: "63459",

    ste_name: "MO",
  },
  {
    zip_code: "63629",

    ste_name: "MO",
  },
  {
    zip_code: "63732",

    ste_name: "MO",
  },
  {
    zip_code: "63839",

    ste_name: "MO",
  },
  {
    zip_code: "63868",

    ste_name: "MO",
  },
  {
    zip_code: "63879",

    ste_name: "MO",
  },
  {
    zip_code: "63932",

    ste_name: "MO",
  },
  {
    zip_code: "63953",

    ste_name: "MO",
  },
  {
    zip_code: "64037",

    ste_name: "MO",
  },
  {
    zip_code: "64061",

    ste_name: "MO",
  },
  {
    zip_code: "64066",

    ste_name: "MO",
  },
  {
    zip_code: "64459",

    ste_name: "MO",
  },
  {
    zip_code: "64645",

    ste_name: "MO",
  },
  {
    zip_code: "64723",

    ste_name: "MO",
  },
  {
    zip_code: "64735",

    ste_name: "MO",
  },
  {
    zip_code: "64843",

    ste_name: "MO",
  },
  {
    zip_code: "64858",

    ste_name: "MO",
  },
  {
    zip_code: "64862",

    ste_name: "MO",
  },
  {
    zip_code: "65240",

    ste_name: "MO",
  },
  {
    zip_code: "65462",

    ste_name: "MO",
  },
  {
    zip_code: "65624",

    ste_name: "MO",
  },
  {
    zip_code: "65733",

    ste_name: "MO",
  },
  {
    zip_code: "65767",

    ste_name: "MO",
  },
  {
    zip_code: "66023",

    ste_name: "KS",
  },
  {
    zip_code: "66031",

    ste_name: "KS",
  },
  {
    zip_code: "66032",

    ste_name: "KS",
  },
  {
    zip_code: "66033",

    ste_name: "KS",
  },
  {
    zip_code: "66048",

    ste_name: "KS",
  },
  {
    zip_code: "66064",

    ste_name: "KS",
  },
  {
    zip_code: "66087",

    ste_name: "KS",
  },
  {
    zip_code: "66101",

    ste_name: "KS",
  },
  {
    zip_code: "66203",

    ste_name: "KS",
  },
  {
    zip_code: "66214",

    ste_name: "KS",
  },
  {
    zip_code: "66224",

    ste_name: "KS",
  },
  {
    zip_code: "66403",

    ste_name: "KS",
  },
  {
    zip_code: "66440",

    ste_name: "KS",
  },
  {
    zip_code: "66546",

    ste_name: "KS",
  },
  {
    zip_code: "66725",

    ste_name: "KS",
  },
  {
    zip_code: "66753",

    ste_name: "KS",
  },
  {
    zip_code: "66838",

    ste_name: "KS",
  },
  {
    zip_code: "66842",

    ste_name: "KS",
  },
  {
    zip_code: "66935",

    ste_name: "KS",
  },
  {
    zip_code: "66968",

    ste_name: "KS",
  },
  {
    zip_code: "67035",

    ste_name: "KS",
  },
  {
    zip_code: "67144",

    ste_name: "KS",
  },
  {
    zip_code: "67227",

    ste_name: "KS",
  },
  {
    zip_code: "67452",

    ste_name: "KS",
  },
  {
    zip_code: "67474",

    ste_name: "KS",
  },
  {
    zip_code: "67511",

    ste_name: "KS",
  },
  {
    zip_code: "67548",

    ste_name: "KS",
  },
  {
    zip_code: "67557",

    ste_name: "KS",
  },
  {
    zip_code: "67559",

    ste_name: "KS",
  },
  {
    zip_code: "67579",

    ste_name: "KS",
  },
  {
    zip_code: "67634",

    ste_name: "KS",
  },
  {
    zip_code: "67735",

    ste_name: "KS",
  },
  {
    zip_code: "68039",

    ste_name: "NE",
  },
  {
    zip_code: "68065",

    ste_name: "NE",
  },
  {
    zip_code: "68069",

    ste_name: "NE",
  },
  {
    zip_code: "68104",

    ste_name: "NE",
  },
  {
    zip_code: "68154",

    ste_name: "NE",
  },
  {
    zip_code: "68301",

    ste_name: "NE",
  },
  {
    zip_code: "68335",

    ste_name: "NE",
  },
  {
    zip_code: "68365",

    ste_name: "NE",
  },
  {
    zip_code: "68456",

    ste_name: "NE",
  },
  {
    zip_code: "68467",

    ste_name: "NE",
  },
  {
    zip_code: "68522",

    ste_name: "NE",
  },
  {
    zip_code: "68635",

    ste_name: "NE",
  },
  {
    zip_code: "68753",

    ste_name: "NE",
  },
  {
    zip_code: "68873",

    ste_name: "NE",
  },
  {
    zip_code: "68883",

    ste_name: "NE",
  },
  {
    zip_code: "68939",

    ste_name: "NE",
  },
  {
    zip_code: "68974",

    ste_name: "NE",
  },
  {
    zip_code: "70065",

    ste_name: "LA",
  },
  {
    zip_code: "70071",

    ste_name: "LA",
  },
  {
    zip_code: "70080",

    ste_name: "LA",
  },
  {
    zip_code: "70117",

    ste_name: "LA",
  },
  {
    zip_code: "70352",

    ste_name: "LA",
  },
  {
    zip_code: "70445",

    ste_name: "LA",
  },
  {
    zip_code: "70451",

    ste_name: "LA",
  },
  {
    zip_code: "70532",

    ste_name: "LA",
  },
  {
    zip_code: "70577",

    ste_name: "LA",
  },
  {
    zip_code: "70581",

    ste_name: "LA",
  },
  {
    zip_code: "70651",

    ste_name: "LA",
  },
  {
    zip_code: "70788",

    ste_name: "LA",
  },
  {
    zip_code: "70819",

    ste_name: "LA",
  },
  {
    zip_code: "71030",

    ste_name: "LA",
  },
  {
    zip_code: "71038",

    ste_name: "LA",
  },
  {
    zip_code: "71064",

    ste_name: "LA",
  },
  {
    zip_code: "71069",

    ste_name: "LA",
  },
  {
    zip_code: "71109",

    ste_name: "LA",
  },
  {
    zip_code: "71219",

    ste_name: "LA",
  },
  {
    zip_code: "71227",

    ste_name: "LA",
  },
  {
    zip_code: "71235",

    ste_name: "LA",
  },
  {
    zip_code: "71241",

    ste_name: "LA",
  },
  {
    zip_code: "71263",

    ste_name: "LA",
  },
  {
    zip_code: "71266",

    ste_name: "LA",
  },
  {
    zip_code: "71353",

    ste_name: "LA",
  },
  {
    zip_code: "71406",

    ste_name: "LA",
  },
  {
    zip_code: "71410",

    ste_name: "LA",
  },
  {
    zip_code: "71472",

    ste_name: "LA",
  },
  {
    zip_code: "71643",

    ste_name: "AR",
  },
  {
    zip_code: "71644",

    ste_name: "AR",
  },
  {
    zip_code: "71660",

    ste_name: "AR",
  },
  {
    zip_code: "71670",

    ste_name: "AR",
  },
  {
    zip_code: "71671",

    ste_name: "AR",
  },
  {
    zip_code: "71763",

    ste_name: "AR",
  },
  {
    zip_code: "71825",

    ste_name: "AR",
  },
  {
    zip_code: "71971",

    ste_name: "AR",
  },
  {
    zip_code: "72003",

    ste_name: "AR",
  },
  {
    zip_code: "72040",

    ste_name: "AR",
  },
  {
    zip_code: "72084",

    ste_name: "AR",
  },
  {
    zip_code: "72101",

    ste_name: "AR",
  },
  {
    zip_code: "72173",

    ste_name: "AR",
  },
  {
    zip_code: "72201",

    ste_name: "AR",
  },
  {
    zip_code: "72227",

    ste_name: "AR",
  },
  {
    zip_code: "72330",

    ste_name: "AR",
  },
  {
    zip_code: "72392",

    ste_name: "AR",
  },
  {
    zip_code: "72411",

    ste_name: "AR",
  },
  {
    zip_code: "72433",

    ste_name: "AR",
  },
  {
    zip_code: "72453",

    ste_name: "AR",
  },
  {
    zip_code: "72461",

    ste_name: "AR",
  },
  {
    zip_code: "72479",

    ste_name: "AR",
  },
  {
    zip_code: "72732",

    ste_name: "AR",
  },
  {
    zip_code: "72760",

    ste_name: "AR",
  },
  {
    zip_code: "72835",

    ste_name: "AR",
  },
  {
    zip_code: "72927",

    ste_name: "AR",
  },
  {
    zip_code: "72952",

    ste_name: "AR",
  },
  {
    zip_code: "73010",

    ste_name: "OK",
  },
  {
    zip_code: "73032",

    ste_name: "OK",
  },
  {
    zip_code: "73056",

    ste_name: "OK",
  },
  {
    zip_code: "73063",

    ste_name: "OK",
  },
  {
    zip_code: "73078",

    ste_name: "OK",
  },
  {
    zip_code: "73531",

    ste_name: "OK",
  },
  {
    zip_code: "73532",

    ste_name: "OK",
  },
  {
    zip_code: "73550",

    ste_name: "OK",
  },
  {
    zip_code: "73567",

    ste_name: "OK",
  },
  {
    zip_code: "73659",

    ste_name: "OK",
  },
  {
    zip_code: "73727",

    ste_name: "OK",
  },
  {
    zip_code: "73735",

    ste_name: "OK",
  },
  {
    zip_code: "73762",

    ste_name: "OK",
  },
  {
    zip_code: "73842",

    ste_name: "OK",
  },
  {
    zip_code: "74331",

    ste_name: "OK",
  },
  {
    zip_code: "74343",

    ste_name: "OK",
  },
  {
    zip_code: "74352",

    ste_name: "OK",
  },
  {
    zip_code: "74401",

    ste_name: "OK",
  },
  {
    zip_code: "74430",

    ste_name: "OK",
  },
  {
    zip_code: "74731",

    ste_name: "OK",
  },
  {
    zip_code: "74827",

    ste_name: "OK",
  },
  {
    zip_code: "74830",

    ste_name: "OK",
  },
  {
    zip_code: "74843",

    ste_name: "OK",
  },
  {
    zip_code: "74857",

    ste_name: "OK",
  },
  {
    zip_code: "74869",

    ste_name: "OK",
  },
  {
    zip_code: "74902",

    ste_name: "OK",
  },
  {
    zip_code: "74935",

    ste_name: "OK",
  },
  {
    zip_code: "74942",

    ste_name: "OK",
  },
  {
    zip_code: "74948",

    ste_name: "OK",
  },
  {
    zip_code: "75001",

    ste_name: "TX",
  },
  {
    zip_code: "75065",

    ste_name: "TX",
  },
  {
    zip_code: "75119",

    ste_name: "TX",
  },
  {
    zip_code: "75132",

    ste_name: "TX",
  },
  {
    zip_code: "75158",

    ste_name: "TX",
  },
  {
    zip_code: "75235",

    ste_name: "TX",
  },
  {
    zip_code: "75241",

    ste_name: "TX",
  },
  {
    zip_code: "75410",

    ste_name: "TX",
  },
  {
    zip_code: "75412",

    ste_name: "TX",
  },
  {
    zip_code: "75420",

    ste_name: "TX",
  },
  {
    zip_code: "75439",

    ste_name: "TX",
  },
  {
    zip_code: "75440",

    ste_name: "TX",
  },
  {
    zip_code: "75441",

    ste_name: "TX",
  },
  {
    zip_code: "75497",

    ste_name: "TX",
  },
  {
    zip_code: "75644",

    ste_name: "TX",
  },
  {
    zip_code: "75692",

    ste_name: "TX",
  },
  {
    zip_code: "75788",

    ste_name: "TX",
  },
  {
    zip_code: "75938",

    ste_name: "TX",
  },
  {
    zip_code: "75954",

    ste_name: "TX",
  },
  {
    zip_code: "76012",

    ste_name: "TX",
  },
  {
    zip_code: "76016",

    ste_name: "TX",
  },
  {
    zip_code: "76064",

    ste_name: "TX",
  },
  {
    zip_code: "76107",

    ste_name: "TX",
  },
  {
    zip_code: "76208",

    ste_name: "TX",
  },
  {
    zip_code: "76234",

    ste_name: "TX",
  },
  {
    zip_code: "76370",

    ste_name: "TX",
  },
  {
    zip_code: "76436",

    ste_name: "TX",
  },
  {
    zip_code: "76483",

    ste_name: "TX",
  },
  {
    zip_code: "76501",

    ste_name: "TX",
  },
  {
    zip_code: "76518",

    ste_name: "TX",
  },
  {
    zip_code: "76525",

    ste_name: "TX",
  },
  {
    zip_code: "76649",

    ste_name: "TX",
  },
  {
    zip_code: "76712",

    ste_name: "TX",
  },
  {
    zip_code: "76828",

    ste_name: "TX",
  },
  {
    zip_code: "76848",

    ste_name: "TX",
  },
  {
    zip_code: "76870",

    ste_name: "TX",
  },
  {
    zip_code: "77004",

    ste_name: "TX",
  },
  {
    zip_code: "77039",

    ste_name: "TX",
  },
  {
    zip_code: "77373",

    ste_name: "TX",
  },
  {
    zip_code: "77381",

    ste_name: "TX",
  },
  {
    zip_code: "77386",

    ste_name: "TX",
  },
  {
    zip_code: "77505",

    ste_name: "TX",
  },
  {
    zip_code: "77506",

    ste_name: "TX",
  },
  {
    zip_code: "77515",

    ste_name: "TX",
  },
  {
    zip_code: "77562",

    ste_name: "TX",
  },
  {
    zip_code: "77586",

    ste_name: "TX",
  },
  {
    zip_code: "77622",

    ste_name: "TX",
  },
  {
    zip_code: "77836",

    ste_name: "TX",
  },
  {
    zip_code: "78004",

    ste_name: "TX",
  },
  {
    zip_code: "78146",

    ste_name: "TX",
  },
  {
    zip_code: "78154",

    ste_name: "TX",
  },
  {
    zip_code: "78363",

    ste_name: "TX",
  },
  {
    zip_code: "78605",

    ste_name: "TX",
  },
  {
    zip_code: "78639",

    ste_name: "TX",
  },
  {
    zip_code: "78655",

    ste_name: "TX",
  },
  {
    zip_code: "78671",

    ste_name: "TX",
  },
  {
    zip_code: "78741",

    ste_name: "TX",
  },
  {
    zip_code: "78758",

    ste_name: "TX",
  },
  {
    zip_code: "79070",

    ste_name: "TX",
  },
  {
    zip_code: "79083",

    ste_name: "TX",
  },
  {
    zip_code: "79369",

    ste_name: "TX",
  },
  {
    zip_code: "79754",

    ste_name: "TX",
  },
  {
    zip_code: "79782",

    ste_name: "TX",
  },
  {
    zip_code: "79835",

    ste_name: "TX",
  },
  {
    zip_code: "79908",

    ste_name: "TX",
  },
  {
    zip_code: "80106",

    ste_name: "CO",
  },
  {
    zip_code: "80206",

    ste_name: "CO",
  },
  {
    zip_code: "80290",

    ste_name: "CO",
  },
  {
    zip_code: "80428",

    ste_name: "CO",
  },
  {
    zip_code: "80443",

    ste_name: "CO",
  },
  {
    zip_code: "80487",

    ste_name: "CO",
  },
  {
    zip_code: "80488",

    ste_name: "CO",
  },
  {
    zip_code: "80524",

    ste_name: "CO",
  },
  {
    zip_code: "80546",

    ste_name: "CO",
  },
  {
    zip_code: "80721",

    ste_name: "CO",
  },
  {
    zip_code: "80729",

    ste_name: "CO",
  },
  {
    zip_code: "80755",

    ste_name: "CO",
  },
  {
    zip_code: "81024",

    ste_name: "CO",
  },
  {
    zip_code: "81049",

    ste_name: "CO",
  },
  {
    zip_code: "81120",

    ste_name: "CO",
  },
  {
    zip_code: "81126",

    ste_name: "CO",
  },
  {
    zip_code: "81411",

    ste_name: "CO",
  },
  {
    zip_code: "82210",

    ste_name: "WY",
  },
  {
    zip_code: "82324",

    ste_name: "WY",
  },
  {
    zip_code: "83320",

    ste_name: "ID",
  },
  {
    zip_code: "83322",

    ste_name: "ID",
  },
  {
    zip_code: "83553",

    ste_name: "ID",
  },
  {
    zip_code: "83629",

    ste_name: "ID",
  },
  {
    zip_code: "83651",

    ste_name: "ID",
  },
  {
    zip_code: "83672",

    ste_name: "ID",
  },
  {
    zip_code: "83861",

    ste_name: "ID",
  },
  {
    zip_code: "84047",

    ste_name: "UT",
  },
  {
    zip_code: "84088",

    ste_name: "UT",
  },
  {
    zip_code: "84309",

    ste_name: "UT",
  },
  {
    zip_code: "84324",

    ste_name: "UT",
  },
  {
    zip_code: "84521",

    ste_name: "UT",
  },
  {
    zip_code: "84639",

    ste_name: "UT",
  },
  {
    zip_code: "84651",

    ste_name: "UT",
  },
  {
    zip_code: "84710",

    ste_name: "UT",
  },
  {
    zip_code: "84755",

    ste_name: "UT",
  },
  {
    zip_code: "85009",

    ste_name: "AZ",
  },
  {
    zip_code: "85309",

    ste_name: "AZ",
  },
  {
    zip_code: "85360",

    ste_name: "AZ",
  },
  {
    zip_code: "85545",

    ste_name: "AZ",
  },
  {
    zip_code: "85550",

    ste_name: "AZ",
  },
  {
    zip_code: "85627",

    ste_name: "AZ",
  },
  {
    zip_code: "85724",

    ste_name: "AZ",
  },
  {
    zip_code: "85934",

    ste_name: "AZ",
  },
  {
    zip_code: "86324",

    ste_name: "AZ",
  },
  {
    zip_code: "86338",

    ste_name: "AZ",
  },
  {
    zip_code: "86431",

    ste_name: "AZ",
  },
  {
    zip_code: "87002",

    ste_name: "NM",
  },
  {
    zip_code: "87013",

    ste_name: "NM",
  },
  {
    zip_code: "87517",

    ste_name: "NM",
  },
  {
    zip_code: "87521",

    ste_name: "NM",
  },
  {
    zip_code: "87523",

    ste_name: "NM",
  },
  {
    zip_code: "87543",

    ste_name: "NM",
  },
  {
    zip_code: "87553",

    ste_name: "NM",
  },
  {
    zip_code: "87729",

    ste_name: "NM",
  },
  {
    zip_code: "87827",

    ste_name: "NM",
  },
  {
    zip_code: "88063",

    ste_name: "NM",
  },
  {
    zip_code: "88312",

    ste_name: "NM",
  },
  {
    zip_code: "88338",

    ste_name: "NM",
  },
  {
    zip_code: "88349",

    ste_name: "NM",
  },
  {
    zip_code: "88436",

    ste_name: "NM",
  },
  {
    zip_code: "89027",

    ste_name: "NV",
  },
  {
    zip_code: "89102",

    ste_name: "NV",
  },
  {
    zip_code: "89123",

    ste_name: "NV",
  },
  {
    zip_code: "89124",

    ste_name: "NV",
  },
  {
    zip_code: "89429",

    ste_name: "NV",
  },
  {
    zip_code: "89523",

    ste_name: "NV",
  },
  {
    zip_code: "7961",

    ste_name: "NJ",
  },
  {
    zip_code: "8310",

    ste_name: "NJ",
  },
  {
    zip_code: "8505",

    ste_name: "NJ",
  },
  {
    zip_code: "8735",

    ste_name: "NJ",
  },
  {
    zip_code: "8823",

    ste_name: "NJ",
  },
  {
    zip_code: "10020",

    ste_name: "NY",
  },
  {
    zip_code: "10455",

    ste_name: "NY",
  },
  {
    zip_code: "10507",

    ste_name: "NY",
  },
  {
    zip_code: "10510",

    ste_name: "NY",
  },
  {
    zip_code: "10527",

    ste_name: "NY",
  },
  {
    zip_code: "10594",

    ste_name: "NY",
  },
  {
    zip_code: "10993",

    ste_name: "NY",
  },
  {
    zip_code: "11102",

    ste_name: "NY",
  },
  {
    zip_code: "11104",

    ste_name: "NY",
  },
  {
    zip_code: "11569",

    ste_name: "NY",
  },
  {
    zip_code: "11570",

    ste_name: "NY",
  },
  {
    zip_code: "11581",

    ste_name: "NY",
  },
  {
    zip_code: "11951",

    ste_name: "NY",
  },
  {
    zip_code: "12036",

    ste_name: "NY",
  },
  {
    zip_code: "12069",

    ste_name: "NY",
  },
  {
    zip_code: "12090",

    ste_name: "NY",
  },
  {
    zip_code: "12110",

    ste_name: "NY",
  },
  {
    zip_code: "12189",

    ste_name: "NY",
  },
  {
    zip_code: "12194",

    ste_name: "NY",
  },
  {
    zip_code: "12422",

    ste_name: "NY",
  },
  {
    zip_code: "12442",

    ste_name: "NY",
  },
  {
    zip_code: "12457",

    ste_name: "NY",
  },
  {
    zip_code: "12468",

    ste_name: "NY",
  },
  {
    zip_code: "12586",

    ste_name: "NY",
  },
  {
    zip_code: "12733",

    ste_name: "NY",
  },
  {
    zip_code: "12836",

    ste_name: "NY",
  },
  {
    zip_code: "12853",

    ste_name: "NY",
  },
  {
    zip_code: "12856",

    ste_name: "NY",
  },
  {
    zip_code: "12884",

    ste_name: "NY",
  },
  {
    zip_code: "12885",

    ste_name: "NY",
  },
  {
    zip_code: "12913",

    ste_name: "NY",
  },
  {
    zip_code: "12934",

    ste_name: "NY",
  },
  {
    zip_code: "12935",

    ste_name: "NY",
  },
  {
    zip_code: "12975",

    ste_name: "NY",
  },
  {
    zip_code: "13069",

    ste_name: "NY",
  },
  {
    zip_code: "13117",

    ste_name: "NY",
  },
  {
    zip_code: "13155",

    ste_name: "NY",
  },
  {
    zip_code: "13354",

    ste_name: "NY",
  },
  {
    zip_code: "13407",

    ste_name: "NY",
  },
  {
    zip_code: "13435",

    ste_name: "NY",
  },
  {
    zip_code: "13484",

    ste_name: "NY",
  },
  {
    zip_code: "13495",

    ste_name: "NY",
  },
  {
    zip_code: "13620",

    ste_name: "NY",
  },
  {
    zip_code: "13730",

    ste_name: "NY",
  },
  {
    zip_code: "13736",

    ste_name: "NY",
  },
  {
    zip_code: "13847",

    ste_name: "NY",
  },
  {
    zip_code: "13859",

    ste_name: "NY",
  },
  {
    zip_code: "14075",

    ste_name: "NY",
  },
  {
    zip_code: "14085",

    ste_name: "NY",
  },
  {
    zip_code: "14109",

    ste_name: "NY",
  },
  {
    zip_code: "14125",

    ste_name: "NY",
  },
  {
    zip_code: "14210",

    ste_name: "NY",
  },
  {
    zip_code: "14415",

    ste_name: "NY",
  },
  {
    zip_code: "14541",

    ste_name: "NY",
  },
  {
    zip_code: "14609",

    ste_name: "NY",
  },
  {
    zip_code: "14784",

    ste_name: "NY",
  },
  {
    zip_code: "14810",

    ste_name: "NY",
  },
  {
    zip_code: "14830",

    ste_name: "NY",
  },
  {
    zip_code: "15033",

    ste_name: "PA",
  },
  {
    zip_code: "15035",

    ste_name: "PA",
  },
  {
    zip_code: "15133",

    ste_name: "PA",
  },
  {
    zip_code: "15140",

    ste_name: "PA",
  },
  {
    zip_code: "15212",

    ste_name: "PA",
  },
  {
    zip_code: "15218",

    ste_name: "PA",
  },
  {
    zip_code: "15220",

    ste_name: "PA",
  },
  {
    zip_code: "15224",

    ste_name: "PA",
  },
  {
    zip_code: "15233",

    ste_name: "PA",
  },
  {
    zip_code: "15243",

    ste_name: "PA",
  },
  {
    zip_code: "15315",

    ste_name: "PA",
  },
  {
    zip_code: "15337",

    ste_name: "PA",
  },
  {
    zip_code: "15364",

    ste_name: "PA",
  },
  {
    zip_code: "15417",

    ste_name: "PA",
  },
  {
    zip_code: "15492",

    ste_name: "PA",
  },
  {
    zip_code: "15636",

    ste_name: "PA",
  },
  {
    zip_code: "15721",

    ste_name: "PA",
  },
  {
    zip_code: "15729",

    ste_name: "PA",
  },
  {
    zip_code: "15730",

    ste_name: "PA",
  },
  {
    zip_code: "15757",

    ste_name: "PA",
  },
  {
    zip_code: "15771",

    ste_name: "PA",
  },
  {
    zip_code: "15934",

    ste_name: "PA",
  },
  {
    zip_code: "15953",

    ste_name: "PA",
  },
  {
    zip_code: "16127",

    ste_name: "PA",
  },
  {
    zip_code: "16145",

    ste_name: "PA",
  },
  {
    zip_code: "16224",

    ste_name: "PA",
  },
  {
    zip_code: "16248",

    ste_name: "PA",
  },
  {
    zip_code: "16253",

    ste_name: "PA",
  },
  {
    zip_code: "16313",

    ste_name: "PA",
  },
  {
    zip_code: "16314",

    ste_name: "PA",
  },
  {
    zip_code: "16316",

    ste_name: "PA",
  },
  {
    zip_code: "16401",

    ste_name: "PA",
  },
  {
    zip_code: "16636",

    ste_name: "PA",
  },
  {
    zip_code: "16638",

    ste_name: "PA",
  },
  {
    zip_code: "16645",

    ste_name: "PA",
  },
  {
    zip_code: "16740",

    ste_name: "PA",
  },
  {
    zip_code: "16832",

    ste_name: "PA",
  },
  {
    zip_code: "16847",

    ste_name: "PA",
  },
  {
    zip_code: "16866",

    ste_name: "PA",
  },
  {
    zip_code: "16877",

    ste_name: "PA",
  },
  {
    zip_code: "16940",

    ste_name: "PA",
  },
  {
    zip_code: "17007",

    ste_name: "PA",
  },
  {
    zip_code: "17011",

    ste_name: "PA",
  },
  {
    zip_code: "17065",

    ste_name: "PA",
  },
  {
    zip_code: "17068",

    ste_name: "PA",
  },
  {
    zip_code: "17093",

    ste_name: "PA",
  },
  {
    zip_code: "17210",

    ste_name: "PA",
  },
  {
    zip_code: "17228",

    ste_name: "PA",
  },
  {
    zip_code: "17267",

    ste_name: "PA",
  },
  {
    zip_code: "17302",

    ste_name: "PA",
  },
  {
    zip_code: "17307",

    ste_name: "PA",
  },
  {
    zip_code: "17309",

    ste_name: "PA",
  },
  {
    zip_code: "17314",

    ste_name: "PA",
  },
  {
    zip_code: "17360",

    ste_name: "PA",
  },
  {
    zip_code: "17372",

    ste_name: "PA",
  },
  {
    zip_code: "17582",

    ste_name: "PA",
  },
  {
    zip_code: "17830",

    ste_name: "PA",
  },
  {
    zip_code: "17853",

    ste_name: "PA",
  },
  {
    zip_code: "17861",

    ste_name: "PA",
  },
  {
    zip_code: "17867",

    ste_name: "PA",
  },
  {
    zip_code: "17976",

    ste_name: "PA",
  },
  {
    zip_code: "18030",

    ste_name: "PA",
  },
  {
    zip_code: "18104",

    ste_name: "PA",
  },
  {
    zip_code: "18195",

    ste_name: "PA",
  },
  {
    zip_code: "18256",

    ste_name: "PA",
  },
  {
    zip_code: "18322",

    ste_name: "PA",
  },
  {
    zip_code: "18457",

    ste_name: "PA",
  },
  {
    zip_code: "18459",

    ste_name: "PA",
  },
  {
    zip_code: "18462",

    ste_name: "PA",
  },
  {
    zip_code: "18507",

    ste_name: "PA",
  },
  {
    zip_code: "18602",

    ste_name: "PA",
  },
  {
    zip_code: "18701",

    ste_name: "PA",
  },
  {
    zip_code: "18818",

    ste_name: "PA",
  },
  {
    zip_code: "18845",

    ste_name: "PA",
  },
  {
    zip_code: "18964",

    ste_name: "PA",
  },
  {
    zip_code: "19003",

    ste_name: "PA",
  },
  {
    zip_code: "19006",

    ste_name: "PA",
  },
  {
    zip_code: "19046",

    ste_name: "PA",
  },
  {
    zip_code: "19053",

    ste_name: "PA",
  },
  {
    zip_code: "19507",

    ste_name: "PA",
  },
  {
    zip_code: "19526",

    ste_name: "PA",
  },
  {
    zip_code: "19940",

    ste_name: "DE",
  },
  {
    zip_code: "19947",

    ste_name: "DE",
  },
  {
    zip_code: "20135",

    ste_name: "VA",
  },
  {
    zip_code: "20601",

    ste_name: "MD",
  },
  {
    zip_code: "20624",

    ste_name: "MD",
  },
  {
    zip_code: "20628",

    ste_name: "MD",
  },
  {
    zip_code: "20629",

    ste_name: "MD",
  },
  {
    zip_code: "20664",

    ste_name: "MD",
  },
  {
    zip_code: "20685",

    ste_name: "MD",
  },
  {
    zip_code: "20722",

    ste_name: "MD",
  },
  {
    zip_code: "20733",

    ste_name: "MD",
  },
  {
    zip_code: "20735",

    ste_name: "MD",
  },
  {
    zip_code: "20772",

    ste_name: "MD",
  },
  {
    zip_code: "20861",

    ste_name: "MD",
  },
  {
    zip_code: "21555",

    ste_name: "MD",
  },
  {
    zip_code: "21620",

    ste_name: "MD",
  },
  {
    zip_code: "21629",

    ste_name: "MD",
  },
  {
    zip_code: "21705",

    ste_name: "MD",
  },
  {
    zip_code: "21734",

    ste_name: "MD",
  },
  {
    zip_code: "21737",

    ste_name: "MD",
  },
  {
    zip_code: "21738",

    ste_name: "MD",
  },
  {
    zip_code: "21774",

    ste_name: "MD",
  },
  {
    zip_code: "21862",

    ste_name: "MD",
  },
  {
    zip_code: "21904",

    ste_name: "MD",
  },
  {
    zip_code: "22201",

    ste_name: "VA",
  },
  {
    zip_code: "22207",

    ste_name: "VA",
  },
  {
    zip_code: "22603",

    ste_name: "VA",
  },
  {
    zip_code: "22711",

    ste_name: "VA",
  },
  {
    zip_code: "22723",

    ste_name: "VA",
  },
  {
    zip_code: "22736",

    ste_name: "VA",
  },
  {
    zip_code: "90715",

    ste_name: "CA",
  },
  {
    zip_code: "90716",

    ste_name: "CA",
  },
  {
    zip_code: "91601",

    ste_name: "CA",
  },
  {
    zip_code: "91741",

    ste_name: "CA",
  },
  {
    zip_code: "91916",

    ste_name: "CA",
  },
  {
    zip_code: "91945",

    ste_name: "CA",
  },
  {
    zip_code: "91962",

    ste_name: "CA",
  },
  {
    zip_code: "92055",

    ste_name: "CA",
  },
  {
    zip_code: "92103",

    ste_name: "CA",
  },
  {
    zip_code: "92130",

    ste_name: "CA",
  },
  {
    zip_code: "92236",

    ste_name: "CA",
  },
  {
    zip_code: "92363",

    ste_name: "CA",
  },
  {
    zip_code: "92385",

    ste_name: "CA",
  },
  {
    zip_code: "92624",

    ste_name: "CA",
  },
  {
    zip_code: "92653",

    ste_name: "CA",
  },
  {
    zip_code: "92657",

    ste_name: "CA",
  },
  {
    zip_code: "92805",

    ste_name: "CA",
  },
  {
    zip_code: "92883",

    ste_name: "CA",
  },
  {
    zip_code: "93041",

    ste_name: "CA",
  },
  {
    zip_code: "93205",

    ste_name: "CA",
  },
  {
    zip_code: "93220",

    ste_name: "CA",
  },
  {
    zip_code: "93243",

    ste_name: "CA",
  },
  {
    zip_code: "93301",

    ste_name: "CA",
  },
  {
    zip_code: "93424",

    ste_name: "CA",
  },
  {
    zip_code: "93461",

    ste_name: "CA",
  },
  {
    zip_code: "93550",

    ste_name: "CA",
  },
  {
    zip_code: "93552",

    ste_name: "CA",
  },
  {
    zip_code: "93711",

    ste_name: "CA",
  },
  {
    zip_code: "94122",

    ste_name: "CA",
  },
  {
    zip_code: "94591",

    ste_name: "CA",
  },
  {
    zip_code: "94931",

    ste_name: "CA",
  },
  {
    zip_code: "94965",

    ste_name: "CA",
  },
  {
    zip_code: "95053",

    ste_name: "CA",
  },
  {
    zip_code: "95066",

    ste_name: "CA",
  },
  {
    zip_code: "95132",

    ste_name: "CA",
  },
  {
    zip_code: "95432",

    ste_name: "CA",
  },
  {
    zip_code: "95435",

    ste_name: "CA",
  },
  {
    zip_code: "95441",

    ste_name: "CA",
  },
  {
    zip_code: "95628",

    ste_name: "CA",
  },
  {
    zip_code: "95651",

    ste_name: "CA",
  },
  {
    zip_code: "95722",

    ste_name: "CA",
  },
  {
    zip_code: "95825",

    ste_name: "CA",
  },
  {
    zip_code: "95977",

    ste_name: "CA",
  },
  {
    zip_code: "96021",

    ste_name: "CA",
  },
  {
    zip_code: "96022",

    ste_name: "CA",
  },
  {
    zip_code: "96029",

    ste_name: "CA",
  },
  {
    zip_code: "96040",

    ste_name: "CA",
  },
  {
    zip_code: "96074",

    ste_name: "CA",
  },
  {
    zip_code: "96090",

    ste_name: "CA",
  },
  {
    zip_code: "96109",

    ste_name: "CA",
  },
  {
    zip_code: "96140",

    ste_name: "CA",
  },
  {
    zip_code: "96772",

    ste_name: "HI",
  },
  {
    zip_code: "96917",

    ste_name: "GU",
  },
  {
    zip_code: "97018",

    ste_name: "OR",
  },
  {
    zip_code: "97040",

    ste_name: "OR",
  },
  {
    zip_code: "97049",

    ste_name: "OR",
  },
  {
    zip_code: "97071",

    ste_name: "OR",
  },
  {
    zip_code: "97115",

    ste_name: "OR",
  },
  {
    zip_code: "97352",

    ste_name: "OR",
  },
  {
    zip_code: "97394",

    ste_name: "OR",
  },
  {
    zip_code: "97405",

    ste_name: "OR",
  },
  {
    zip_code: "97484",

    ste_name: "OR",
  },
  {
    zip_code: "97526",

    ste_name: "OR",
  },
  {
    zip_code: "97603",

    ste_name: "OR",
  },
  {
    zip_code: "97818",

    ste_name: "OR",
  },
  {
    zip_code: "97862",

    ste_name: "OR",
  },
  {
    zip_code: "97865",

    ste_name: "OR",
  },
  {
    zip_code: "97874",

    ste_name: "OR",
  },
  {
    zip_code: "98008",

    ste_name: "WA",
  },
  {
    zip_code: "98053",

    ste_name: "WA",
  },
  {
    zip_code: "98109",

    ste_name: "WA",
  },
  {
    zip_code: "98178",

    ste_name: "WA",
  },
  {
    zip_code: "98288",

    ste_name: "WA",
  },
  {
    zip_code: "58105",

    ste_name: "ND",
  },
  {
    zip_code: "58366",

    ste_name: "ND",
  },
  {
    zip_code: "58433",

    ste_name: "ND",
  },
  {
    zip_code: "58443",

    ste_name: "ND",
  },
  {
    zip_code: "58521",

    ste_name: "ND",
  },
  {
    zip_code: "58636",

    ste_name: "ND",
  },
  {
    zip_code: "58641",

    ste_name: "ND",
  },
  {
    zip_code: "98376",

    ste_name: "WA",
  },
  {
    zip_code: "98550",

    ste_name: "WA",
  },
  {
    zip_code: "98583",

    ste_name: "WA",
  },
  {
    zip_code: "98644",

    ste_name: "WA",
  },
  {
    zip_code: "98684",

    ste_name: "WA",
  },
  {
    zip_code: "98826",

    ste_name: "WA",
  },
  {
    zip_code: "98833",

    ste_name: "WA",
  },
  {
    zip_code: "98843",

    ste_name: "WA",
  },
  {
    zip_code: "98946",

    ste_name: "WA",
  },
  {
    zip_code: "98950",

    ste_name: "WA",
  },
  {
    zip_code: "99029",

    ste_name: "WA",
  },
  {
    zip_code: "99103",

    ste_name: "WA",
  },
  {
    zip_code: "99111",

    ste_name: "WA",
  },
  {
    zip_code: "99123",

    ste_name: "WA",
  },
  {
    zip_code: "99129",

    ste_name: "WA",
  },
  {
    zip_code: "99356",

    ste_name: "WA",
  },
  {
    zip_code: "99518",

    ste_name: "AK",
  },
  {
    zip_code: "99571",

    ste_name: "AK",
  },
  {
    zip_code: "99578",

    ste_name: "AK",
  },
  {
    zip_code: "99632",

    ste_name: "AK",
  },
  {
    zip_code: "99650",

    ste_name: "AK",
  },
  {
    zip_code: "99722",

    ste_name: "AK",
  },
  {
    zip_code: "99726",

    ste_name: "AK",
  },
  {
    zip_code: "99744",

    ste_name: "AK",
  },
  {
    zip_code: "99754",

    ste_name: "AK",
  },
  {
    zip_code: "99790",

    ste_name: "AK",
  },
  {
    zip_code: "99829",

    ste_name: "AK",
  },
  {
    zip_code: "99918",

    ste_name: "AK",
  },
  {
    zip_code: "31011",

    ste_name: "GA",
  },
  {
    zip_code: "31027",

    ste_name: "GA",
  },
  {
    zip_code: "31029",

    ste_name: "GA",
  },
  {
    zip_code: "31041",

    ste_name: "GA",
  },
  {
    zip_code: "31096",

    ste_name: "GA",
  },
  {
    zip_code: "31516",

    ste_name: "GA",
  },
  {
    zip_code: "31634",

    ste_name: "GA",
  },
  {
    zip_code: "31756",

    ste_name: "GA",
  },
  {
    zip_code: "31771",

    ste_name: "GA",
  },
  {
    zip_code: "31772",

    ste_name: "GA",
  },
  {
    zip_code: "31794",

    ste_name: "GA",
  },
  {
    zip_code: "31825",

    ste_name: "GA",
  },
  {
    zip_code: "32008",

    ste_name: "FL",
  },
  {
    zip_code: "32128",

    ste_name: "FL",
  },
  {
    zip_code: "32141",

    ste_name: "FL",
  },
  {
    zip_code: "32210",

    ste_name: "FL",
  },
  {
    zip_code: "32217",

    ste_name: "FL",
  },
  {
    zip_code: "32222",

    ste_name: "FL",
  },
  {
    zip_code: "32303",

    ste_name: "FL",
  },
  {
    zip_code: "32359",

    ste_name: "FL",
  },
  {
    zip_code: "32407",

    ste_name: "FL",
  },
  {
    zip_code: "32444",

    ste_name: "FL",
  },
  {
    zip_code: "32583",

    ste_name: "FL",
  },
  {
    zip_code: "32750",

    ste_name: "FL",
  },
  {
    zip_code: "32909",

    ste_name: "FL",
  },
  {
    zip_code: "33042",

    ste_name: "FL",
  },
  {
    zip_code: "33172",

    ste_name: "FL",
  },
  {
    zip_code: "33186",

    ste_name: "FL",
  },
  {
    zip_code: "33309",

    ste_name: "FL",
  },
  {
    zip_code: "33324",

    ste_name: "FL",
  },
  {
    zip_code: "33409",

    ste_name: "FL",
  },
  {
    zip_code: "33467",

    ste_name: "FL",
  },
  {
    zip_code: "33523",

    ste_name: "FL",
  },
  {
    zip_code: "33569",

    ste_name: "FL",
  },
  {
    zip_code: "33619",

    ste_name: "FL",
  },
  {
    zip_code: "33712",

    ste_name: "FL",
  },
  {
    zip_code: "33714",

    ste_name: "FL",
  },
  {
    zip_code: "33870",

    ste_name: "FL",
  },
  {
    zip_code: "33945",

    ste_name: "FL",
  },
  {
    zip_code: "33953",

    ste_name: "FL",
  },
  {
    zip_code: "34103",

    ste_name: "FL",
  },
  {
    zip_code: "34116",

    ste_name: "FL",
  },
  {
    zip_code: "34211",

    ste_name: "FL",
  },
  {
    zip_code: "34234",

    ste_name: "FL",
  },
  {
    zip_code: "34237",

    ste_name: "FL",
  },
  {
    zip_code: "34481",

    ste_name: "FL",
  },
  {
    zip_code: "34614",

    ste_name: "FL",
  },
  {
    zip_code: "34655",

    ste_name: "FL",
  },
  {
    zip_code: "34771",

    ste_name: "FL",
  },
  {
    zip_code: "34972",

    ste_name: "FL",
  },
  {
    zip_code: "34996",

    ste_name: "FL",
  },
  {
    zip_code: "35033",

    ste_name: "AL",
  },
  {
    zip_code: "35073",

    ste_name: "AL",
  },
  {
    zip_code: "35150",

    ste_name: "AL",
  },
  {
    zip_code: "35456",

    ste_name: "AL",
  },
  {
    zip_code: "35481",

    ste_name: "AL",
  },
  {
    zip_code: "35504",

    ste_name: "AL",
  },
  {
    zip_code: "35587",

    ste_name: "AL",
  },
  {
    zip_code: "35593",

    ste_name: "AL",
  },
  {
    zip_code: "35594",

    ste_name: "AL",
  },
  {
    zip_code: "35646",

    ste_name: "AL",
  },
  {
    zip_code: "35739",

    ste_name: "AL",
  },
  {
    zip_code: "35806",

    ste_name: "AL",
  },
  {
    zip_code: "35951",

    ste_name: "AL",
  },
  {
    zip_code: "36251",

    ste_name: "AL",
  },
  {
    zip_code: "36268",

    ste_name: "AL",
  },
  {
    zip_code: "36274",

    ste_name: "AL",
  },
  {
    zip_code: "36322",

    ste_name: "AL",
  },
  {
    zip_code: "36371",

    ste_name: "AL",
  },
  {
    zip_code: "36507",

    ste_name: "AL",
  },
  {
    zip_code: "36558",

    ste_name: "AL",
  },
  {
    zip_code: "36688",

    ste_name: "AL",
  },
  {
    zip_code: "36728",

    ste_name: "AL",
  },
  {
    zip_code: "36759",

    ste_name: "AL",
  },
  {
    zip_code: "36773",

    ste_name: "AL",
  },
  {
    zip_code: "36919",

    ste_name: "AL",
  },
  {
    zip_code: "37032",

    ste_name: "TN",
  },
  {
    zip_code: "37046",

    ste_name: "TN",
  },
  {
    zip_code: "37174",

    ste_name: "TN",
  },
  {
    zip_code: "37185",

    ste_name: "TN",
  },
  {
    zip_code: "37190",

    ste_name: "TN",
  },
  {
    zip_code: "37210",

    ste_name: "TN",
  },
  {
    zip_code: "37216",

    ste_name: "TN",
  },
  {
    zip_code: "37243",

    ste_name: "TN",
  },
  {
    zip_code: "37376",

    ste_name: "TN",
  },
  {
    zip_code: "37379",

    ste_name: "TN",
  },
  {
    zip_code: "37660",

    ste_name: "TN",
  },
  {
    zip_code: "37714",

    ste_name: "TN",
  },
  {
    zip_code: "37762",

    ste_name: "TN",
  },
  {
    zip_code: "37803",

    ste_name: "TN",
  },
  {
    zip_code: "37811",

    ste_name: "TN",
  },
  {
    zip_code: "37826",

    ste_name: "TN",
  },
  {
    zip_code: "37828",

    ste_name: "TN",
  },
  {
    zip_code: "38077",

    ste_name: "TN",
  },
  {
    zip_code: "38132",

    ste_name: "TN",
  },
  {
    zip_code: "38141",

    ste_name: "TN",
  },
  {
    zip_code: "38152",

    ste_name: "TN",
  },
  {
    zip_code: "38232",

    ste_name: "TN",
  },
  {
    zip_code: "38237",

    ste_name: "TN",
  },
  {
    zip_code: "38260",

    ste_name: "TN",
  },
  {
    zip_code: "38305",

    ste_name: "TN",
  },
  {
    zip_code: "38339",

    ste_name: "TN",
  },
  {
    zip_code: "38340",

    ste_name: "TN",
  },
  {
    zip_code: "38371",

    ste_name: "TN",
  },
  {
    zip_code: "38582",

    ste_name: "TN",
  },
  {
    zip_code: "38630",

    ste_name: "MS",
  },
  {
    zip_code: "38637",

    ste_name: "MS",
  },
  {
    zip_code: "38646",

    ste_name: "MS",
  },
  {
    zip_code: "38654",

    ste_name: "MS",
  },
  {
    zip_code: "38826",

    ste_name: "MS",
  },
  {
    zip_code: "39041",

    ste_name: "MS",
  },
  {
    zip_code: "39051",

    ste_name: "MS",
  },
  {
    zip_code: "39082",

    ste_name: "MS",
  },
  {
    zip_code: "39160",

    ste_name: "MS",
  },
  {
    zip_code: "39320",

    ste_name: "MS",
  },
  {
    zip_code: "39482",

    ste_name: "MS",
  },
  {
    zip_code: "39571",

    ste_name: "MS",
  },
  {
    zip_code: "39572",

    ste_name: "MS",
  },
  {
    zip_code: "39668",

    ste_name: "MS",
  },
  {
    zip_code: "40170",

    ste_name: "KY",
  },
  {
    zip_code: "40177",

    ste_name: "KY",
  },
  {
    zip_code: "40203",

    ste_name: "KY",
  },
  {
    zip_code: "40212",

    ste_name: "KY",
  },
  {
    zip_code: "40272",

    ste_name: "KY",
  },
  {
    zip_code: "40360",

    ste_name: "KY",
  },
  {
    zip_code: "40472",

    ste_name: "KY",
  },
  {
    zip_code: "40475",

    ste_name: "KY",
  },
  {
    zip_code: "40509",

    ste_name: "KY",
  },
  {
    zip_code: "40865",

    ste_name: "KY",
  },
  {
    zip_code: "41001",

    ste_name: "KY",
  },
  {
    zip_code: "41040",

    ste_name: "KY",
  },
  {
    zip_code: "41142",

    ste_name: "KY",
  },
  {
    zip_code: "41254",

    ste_name: "KY",
  },
  {
    zip_code: "41264",

    ste_name: "KY",
  },
  {
    zip_code: "41311",

    ste_name: "KY",
  },
  {
    zip_code: "41531",

    ste_name: "KY",
  },
  {
    zip_code: "41544",

    ste_name: "KY",
  },
  {
    zip_code: "41619",

    ste_name: "KY",
  },
  {
    zip_code: "41722",

    ste_name: "KY",
  },
  {
    zip_code: "41774",

    ste_name: "KY",
  },
  {
    zip_code: "41819",

    ste_name: "KY",
  },
  {
    zip_code: "41828",

    ste_name: "KY",
  },
  {
    zip_code: "41858",

    ste_name: "KY",
  },
  {
    zip_code: "41859",

    ste_name: "KY",
  },
  {
    zip_code: "42058",

    ste_name: "KY",
  },
  {
    zip_code: "42081",

    ste_name: "KY",
  },
  {
    zip_code: "42266",

    ste_name: "KY",
  },
  {
    zip_code: "42370",

    ste_name: "KY",
  },
  {
    zip_code: "42378",

    ste_name: "KY",
  },
  {
    zip_code: "42629",

    ste_name: "KY",
  },
  {
    zip_code: "42638",

    ste_name: "KY",
  },
  {
    zip_code: "43010",

    ste_name: "OH",
  },
  {
    zip_code: "43112",

    ste_name: "OH",
  },
  {
    zip_code: "43213",

    ste_name: "OH",
  },
  {
    zip_code: "43432",

    ste_name: "OH",
  },
  {
    zip_code: "43460",

    ste_name: "OH",
  },
  {
    zip_code: "43466",

    ste_name: "OH",
  },
  {
    zip_code: "43532",

    ste_name: "OH",
  },
  {
    zip_code: "43843",

    ste_name: "OH",
  },
  {
    zip_code: "43963",

    ste_name: "OH",
  },
  {
    zip_code: "43970",

    ste_name: "OH",
  },
  {
    zip_code: "44077",

    ste_name: "OH",
  },
  {
    zip_code: "44082",

    ste_name: "OH",
  },
  {
    zip_code: "44314",

    ste_name: "OH",
  },
  {
    zip_code: "44406",

    ste_name: "OH",
  },
  {
    zip_code: "44484",

    ste_name: "OH",
  },
  {
    zip_code: "44680",

    ste_name: "OH",
  },
  {
    zip_code: "44706",

    ste_name: "OH",
  },
  {
    zip_code: "44870",

    ste_name: "OH",
  },
  {
    zip_code: "45066",

    ste_name: "OH",
  },
  {
    zip_code: "45232",

    ste_name: "OH",
  },
  {
    zip_code: "45332",

    ste_name: "OH",
  },
  {
    zip_code: "45334",

    ste_name: "OH",
  },
  {
    zip_code: "45356",

    ste_name: "OH",
  },
  {
    zip_code: "45409",

    ste_name: "OH",
  },
  {
    zip_code: "45414",

    ste_name: "OH",
  },
  {
    zip_code: "45428",

    ste_name: "OH",
  },
  {
    zip_code: "45432",

    ste_name: "OH",
  },
  {
    zip_code: "45787",

    ste_name: "OH",
  },
  {
    zip_code: "45827",

    ste_name: "OH",
  },
  {
    zip_code: "45888",

    ste_name: "OH",
  },
  {
    zip_code: "45894",

    ste_name: "OH",
  },
  {
    zip_code: "46075",

    ste_name: "IN",
  },
  {
    zip_code: "46104",

    ste_name: "IN",
  },
  {
    zip_code: "46111",

    ste_name: "IN",
  },
  {
    zip_code: "46115",

    ste_name: "IN",
  },
  {
    zip_code: "46217",

    ste_name: "IN",
  },
  {
    zip_code: "46310",

    ste_name: "IN",
  },
  {
    zip_code: "46528",

    ste_name: "IN",
  },
  {
    zip_code: "46530",

    ste_name: "IN",
  },
  {
    zip_code: "46574",

    ste_name: "IN",
  },
  {
    zip_code: "46614",

    ste_name: "IN",
  },
  {
    zip_code: "46742",

    ste_name: "IN",
  },
  {
    zip_code: "46788",

    ste_name: "IN",
  },
  {
    zip_code: "46807",

    ste_name: "IN",
  },
  {
    zip_code: "46968",

    ste_name: "IN",
  },
  {
    zip_code: "47112",

    ste_name: "IN",
  },
  {
    zip_code: "47126",

    ste_name: "IN",
  },
  {
    zip_code: "47265",

    ste_name: "IN",
  },
  {
    zip_code: "47330",

    ste_name: "IN",
  },
  {
    zip_code: "47455",

    ste_name: "IN",
  },
  {
    zip_code: "47469",

    ste_name: "IN",
  },
  {
    zip_code: "47471",

    ste_name: "IN",
  },
  {
    zip_code: "47521",

    ste_name: "IN",
  },
  {
    zip_code: "47552",

    ste_name: "IN",
  },
  {
    zip_code: "47634",

    ste_name: "IN",
  },
  {
    zip_code: "47666",

    ste_name: "IN",
  },
  {
    zip_code: "47834",

    ste_name: "IN",
  },
  {
    zip_code: "47906",

    ste_name: "IN",
  },
  {
    zip_code: "47916",

    ste_name: "IN",
  },
  {
    zip_code: "47929",

    ste_name: "IN",
  },
  {
    zip_code: "47977",

    ste_name: "IN",
  },
  {
    zip_code: "48023",

    ste_name: "MI",
  },
  {
    zip_code: "48028",

    ste_name: "MI",
  },
  {
    zip_code: "48034",

    ste_name: "MI",
  },
  {
    zip_code: "48044",

    ste_name: "MI",
  },
  {
    zip_code: "48067",

    ste_name: "MI",
  },
  {
    zip_code: "48109",

    ste_name: "MI",
  },
  {
    zip_code: "48176",

    ste_name: "MI",
  },
  {
    zip_code: "48212",

    ste_name: "MI",
  },
  {
    zip_code: "48306",

    ste_name: "MI",
  },
  {
    zip_code: "48313",

    ste_name: "MI",
  },
  {
    zip_code: "48371",

    ste_name: "MI",
  },
  {
    zip_code: "48449",

    ste_name: "MI",
  },
  {
    zip_code: "48467",

    ste_name: "MI",
  },
  {
    zip_code: "48469",

    ste_name: "MI",
  },
  {
    zip_code: "48471",

    ste_name: "MI",
  },
  {
    zip_code: "48601",

    ste_name: "MI",
  },
  {
    zip_code: "48650",

    ste_name: "MI",
  },
  {
    zip_code: "48654",

    ste_name: "MI",
  },
  {
    zip_code: "48706",

    ste_name: "MI",
  },
  {
    zip_code: "48734",

    ste_name: "MI",
  },
  {
    zip_code: "48855",

    ste_name: "MI",
  },
  {
    zip_code: "48870",

    ste_name: "MI",
  },
  {
    zip_code: "49038",

    ste_name: "MI",
  },
  {
    zip_code: "49083",

    ste_name: "MI",
  },
  {
    zip_code: "49237",

    ste_name: "MI",
  },
  {
    zip_code: "49241",

    ste_name: "MI",
  },
  {
    zip_code: "49248",

    ste_name: "MI",
  },
  {
    zip_code: "49266",

    ste_name: "MI",
  },
  {
    zip_code: "49335",

    ste_name: "MI",
  },
  {
    zip_code: "49436",

    ste_name: "MI",
  },
  {
    zip_code: "49621",

    ste_name: "MI",
  },
  {
    zip_code: "49626",

    ste_name: "MI",
  },
  {
    zip_code: "49680",

    ste_name: "MI",
  },
  {
    zip_code: "49819",

    ste_name: "MI",
  },
  {
    zip_code: "49827",

    ste_name: "MI",
  },
  {
    zip_code: "49841",

    ste_name: "MI",
  },
  {
    zip_code: "49879",

    ste_name: "MI",
  },
  {
    zip_code: "49884",

    ste_name: "MI",
  },
  {
    zip_code: "49901",

    ste_name: "MI",
  },
  {
    zip_code: "49921",

    ste_name: "MI",
  },
  {
    zip_code: "49938",

    ste_name: "MI",
  },
  {
    zip_code: "49942",

    ste_name: "MI",
  },
  {
    zip_code: "49970",

    ste_name: "MI",
  },
  {
    zip_code: "50020",

    ste_name: "IA",
  },
  {
    zip_code: "50039",

    ste_name: "IA",
  },
  {
    zip_code: "50055",

    ste_name: "IA",
  },
  {
    zip_code: "50065",

    ste_name: "IA",
  },
  {
    zip_code: "50120",

    ste_name: "IA",
  },
  {
    zip_code: "50141",

    ste_name: "IA",
  },
  {
    zip_code: "50212",

    ste_name: "IA",
  },
  {
    zip_code: "50216",

    ste_name: "IA",
  },
  {
    zip_code: "50218",

    ste_name: "IA",
  },
  {
    zip_code: "50223",

    ste_name: "IA",
  },
  {
    zip_code: "50315",

    ste_name: "IA",
  },
  {
    zip_code: "50423",

    ste_name: "IA",
  },
  {
    zip_code: "50468",

    ste_name: "IA",
  },
  {
    zip_code: "50471",

    ste_name: "IA",
  },
  {
    zip_code: "50520",

    ste_name: "IA",
  },
  {
    zip_code: "50539",

    ste_name: "IA",
  },
  {
    zip_code: "50545",

    ste_name: "IA",
  },
  {
    zip_code: "50562",

    ste_name: "IA",
  },
  {
    zip_code: "50578",

    ste_name: "IA",
  },
  {
    zip_code: "50594",

    ste_name: "IA",
  },
  {
    zip_code: "50603",

    ste_name: "IA",
  },
  {
    zip_code: "50606",

    ste_name: "IA",
  },
  {
    zip_code: "50643",

    ste_name: "IA",
  },
  {
    zip_code: "50677",

    ste_name: "IA",
  },
  {
    zip_code: "50836",

    ste_name: "IA",
  },
  {
    zip_code: "50837",

    ste_name: "IA",
  },
  {
    zip_code: "51047",

    ste_name: "IA",
  },
  {
    zip_code: "51061",

    ste_name: "IA",
  },
  {
    zip_code: "51553",

    ste_name: "IA",
  },
  {
    zip_code: "51648",

    ste_name: "IA",
  },
  {
    zip_code: "51652",

    ste_name: "IA",
  },
  {
    zip_code: "52068",

    ste_name: "IA",
  },
  {
    zip_code: "52209",

    ste_name: "IA",
  },
  {
    zip_code: "52308",

    ste_name: "IA",
  },
  {
    zip_code: "52332",

    ste_name: "IA",
  },
  {
    zip_code: "52537",

    ste_name: "IA",
  },
  {
    zip_code: "52556",

    ste_name: "IA",
  },
  {
    zip_code: "52653",

    ste_name: "IA",
  },
  {
    zip_code: "52766",

    ste_name: "IA",
  },
  {
    zip_code: "52769",

    ste_name: "IA",
  },
  {
    zip_code: "53029",

    ste_name: "WI",
  },
  {
    zip_code: "53040",

    ste_name: "WI",
  },
  {
    zip_code: "53221",

    ste_name: "WI",
  },
  {
    zip_code: "53540",

    ste_name: "WI",
  },
  {
    zip_code: "53821",

    ste_name: "WI",
  },
  {
    zip_code: "53930",

    ste_name: "WI",
  },
  {
    zip_code: "53931",

    ste_name: "WI",
  },
  {
    zip_code: "54005",

    ste_name: "WI",
  },
  {
    zip_code: "54006",

    ste_name: "WI",
  },
  {
    zip_code: "54149",

    ste_name: "WI",
  },
  {
    zip_code: "54232",

    ste_name: "WI",
  },
  {
    zip_code: "54409",

    ste_name: "WI",
  },
  {
    zip_code: "54423",

    ste_name: "WI",
  },
  {
    zip_code: "54430",

    ste_name: "WI",
  },
  {
    zip_code: "54451",

    ste_name: "WI",
  },
  {
    zip_code: "54480",

    ste_name: "WI",
  },
  {
    zip_code: "54495",

    ste_name: "WI",
  },
  {
    zip_code: "54498",

    ste_name: "WI",
  },
  {
    zip_code: "54515",

    ste_name: "WI",
  },
  {
    zip_code: "54650",

    ste_name: "WI",
  },
  {
    zip_code: "54872",

    ste_name: "WI",
  },
  {
    zip_code: "54902",

    ste_name: "WI",
  },
  {
    zip_code: "54927",

    ste_name: "WI",
  },
  {
    zip_code: "54937",

    ste_name: "WI",
  },
  {
    zip_code: "54946",

    ste_name: "WI",
  },
  {
    zip_code: "54947",

    ste_name: "WI",
  },
  {
    zip_code: "55079",

    ste_name: "MN",
  },
  {
    zip_code: "55125",

    ste_name: "MN",
  },
  {
    zip_code: "55309",

    ste_name: "MN",
  },
  {
    zip_code: "55363",

    ste_name: "MN",
  },
  {
    zip_code: "55420",

    ste_name: "MN",
  },
  {
    zip_code: "55721",

    ste_name: "MN",
  },
  {
    zip_code: "55904",

    ste_name: "MN",
  },
  {
    zip_code: "55922",

    ste_name: "MN",
  },
  {
    zip_code: "55947",

    ste_name: "MN",
  },
  {
    zip_code: "55951",

    ste_name: "MN",
  },
  {
    zip_code: "55963",

    ste_name: "MN",
  },
  {
    zip_code: "56027",

    ste_name: "MN",
  },
  {
    zip_code: "56085",

    ste_name: "MN",
  },
  {
    zip_code: "56183",

    ste_name: "MN",
  },
  {
    zip_code: "56214",

    ste_name: "MN",
  },
  {
    zip_code: "56220",

    ste_name: "MN",
  },
  {
    zip_code: "56226",

    ste_name: "MN",
  },
  {
    zip_code: "56227",

    ste_name: "MN",
  },
  {
    zip_code: "56315",

    ste_name: "MN",
  },
  {
    zip_code: "56336",

    ste_name: "MN",
  },
  {
    zip_code: "56342",

    ste_name: "MN",
  },
  {
    zip_code: "56474",

    ste_name: "MN",
  },
  {
    zip_code: "56542",

    ste_name: "MN",
  },
  {
    zip_code: "56556",

    ste_name: "MN",
  },
  {
    zip_code: "56557",

    ste_name: "MN",
  },
  {
    zip_code: "56590",

    ste_name: "MN",
  },
  {
    zip_code: "56634",

    ste_name: "MN",
  },
  {
    zip_code: "56637",

    ste_name: "MN",
  },
  {
    zip_code: "56641",

    ste_name: "MN",
  },
  {
    zip_code: "56662",

    ste_name: "MN",
  },
  {
    zip_code: "56666",

    ste_name: "MN",
  },
  {
    zip_code: "56688",

    ste_name: "MN",
  },
  {
    zip_code: "57004",

    ste_name: "SD",
  },
  {
    zip_code: "57006",

    ste_name: "SD",
  },
  {
    zip_code: "57020",

    ste_name: "SD",
  },
  {
    zip_code: "57025",

    ste_name: "SD",
  },
  {
    zip_code: "57030",

    ste_name: "SD",
  },
  {
    zip_code: "57270",

    ste_name: "SD",
  },
  {
    zip_code: "57361",

    ste_name: "SD",
  },
  {
    zip_code: "57384",

    ste_name: "SD",
  },
  {
    zip_code: "57434",

    ste_name: "SD",
  },
  {
    zip_code: "57536",

    ste_name: "SD",
  },
  {
    zip_code: "57567",

    ste_name: "SD",
  },
  {
    zip_code: "57585",

    ste_name: "SD",
  },
  {
    zip_code: "57741",

    ste_name: "SD",
  },
  {
    zip_code: "58016",

    ste_name: "ND",
  },
  {
    zip_code: "58018",

    ste_name: "ND",
  },
  {
    zip_code: "58048",

    ste_name: "ND",
  },
  {
    zip_code: "58227",

    ste_name: "ND",
  },
  {
    zip_code: "58250",

    ste_name: "ND",
  },
  {
    zip_code: "58316",

    ste_name: "ND",
  },
  {
    zip_code: "58323",

    ste_name: "ND",
  },
  {
    zip_code: "31012",

    ste_name: "GA",
  },
  {
    zip_code: "31019",

    ste_name: "GA",
  },
  {
    zip_code: "31021",

    ste_name: "GA",
  },
  {
    zip_code: "31030",

    ste_name: "GA",
  },
  {
    zip_code: "31049",

    ste_name: "GA",
  },
  {
    zip_code: "31061",

    ste_name: "GA",
  },
  {
    zip_code: "31079",

    ste_name: "GA",
  },
  {
    zip_code: "31312",

    ste_name: "GA",
  },
  {
    zip_code: "31404",

    ste_name: "GA",
  },
  {
    zip_code: "31501",

    ste_name: "GA",
  },
  {
    zip_code: "31623",

    ste_name: "GA",
  },
  {
    zip_code: "31812",

    ste_name: "GA",
  },
  {
    zip_code: "32011",

    ste_name: "FL",
  },
  {
    zip_code: "32043",

    ste_name: "FL",
  },
  {
    zip_code: "32137",

    ste_name: "FL",
  },
  {
    zip_code: "32139",

    ste_name: "FL",
  },
  {
    zip_code: "32180",

    ste_name: "FL",
  },
  {
    zip_code: "32208",

    ste_name: "FL",
  },
  {
    zip_code: "32259",

    ste_name: "FL",
  },
  {
    zip_code: "32343",

    ste_name: "FL",
  },
  {
    zip_code: "32358",

    ste_name: "FL",
  },
  {
    zip_code: "32511",

    ste_name: "FL",
  },
  {
    zip_code: "32563",

    ste_name: "FL",
  },
  {
    zip_code: "32616",

    ste_name: "FL",
  },
  {
    zip_code: "32839",

    ste_name: "FL",
  },
  {
    zip_code: "32935",

    ste_name: "FL",
  },
  {
    zip_code: "32958",

    ste_name: "FL",
  },
  {
    zip_code: "32970",

    ste_name: "FL",
  },
  {
    zip_code: "33014",

    ste_name: "FL",
  },
  {
    zip_code: "33027",

    ste_name: "FL",
  },
  {
    zip_code: "33126",

    ste_name: "FL",
  },
  {
    zip_code: "33135",

    ste_name: "FL",
  },
  {
    zip_code: "33304",

    ste_name: "FL",
  },
  {
    zip_code: "33330",

    ste_name: "FL",
  },
  {
    zip_code: "33412",

    ste_name: "FL",
  },
  {
    zip_code: "33435",

    ste_name: "FL",
  },
  {
    zip_code: "33469",

    ste_name: "FL",
  },
  {
    zip_code: "33559",

    ste_name: "FL",
  },
  {
    zip_code: "33576",

    ste_name: "FL",
  },
  {
    zip_code: "33777",

    ste_name: "FL",
  },
  {
    zip_code: "33778",

    ste_name: "FL",
  },
  {
    zip_code: "33825",

    ste_name: "FL",
  },
  {
    zip_code: "33838",

    ste_name: "FL",
  },
  {
    zip_code: "33884",

    ste_name: "FL",
  },
  {
    zip_code: "33916",

    ste_name: "FL",
  },
  {
    zip_code: "33971",

    ste_name: "FL",
  },
  {
    zip_code: "34232",

    ste_name: "FL",
  },
  {
    zip_code: "34610",

    ste_name: "FL",
  },
  {
    zip_code: "34748",

    ste_name: "FL",
  },
  {
    zip_code: "34987",

    ste_name: "FL",
  },
  {
    zip_code: "35023",

    ste_name: "AL",
  },
  {
    zip_code: "35043",

    ste_name: "AL",
  },
  {
    zip_code: "35121",

    ste_name: "AL",
  },
  {
    zip_code: "35178",

    ste_name: "AL",
  },
  {
    zip_code: "35209",

    ste_name: "AL",
  },
  {
    zip_code: "35221",

    ste_name: "AL",
  },
  {
    zip_code: "35452",

    ste_name: "AL",
  },
  {
    zip_code: "35540",

    ste_name: "AL",
  },
  {
    zip_code: "35651",

    ste_name: "AL",
  },
  {
    zip_code: "35677",

    ste_name: "AL",
  },
  {
    zip_code: "35768",

    ste_name: "AL",
  },
  {
    zip_code: "35907",

    ste_name: "AL",
  },
  {
    zip_code: "35986",

    ste_name: "AL",
  },
  {
    zip_code: "35989",

    ste_name: "AL",
  },
  {
    zip_code: "36088",

    ste_name: "AL",
  },
  {
    zip_code: "36205",

    ste_name: "AL",
  },
  {
    zip_code: "36207",

    ste_name: "AL",
  },
  {
    zip_code: "36264",

    ste_name: "AL",
  },
  {
    zip_code: "36280",

    ste_name: "AL",
  },
  {
    zip_code: "36473",

    ste_name: "AL",
  },
  {
    zip_code: "36509",

    ste_name: "AL",
  },
  {
    zip_code: "36877",

    ste_name: "AL",
  },
  {
    zip_code: "37067",

    ste_name: "TN",
  },
  {
    zip_code: "37096",

    ste_name: "TN",
  },
  {
    zip_code: "37167",

    ste_name: "TN",
  },
  {
    zip_code: "37207",

    ste_name: "TN",
  },
  {
    zip_code: "37334",

    ste_name: "TN",
  },
  {
    zip_code: "37342",

    ste_name: "TN",
  },
  {
    zip_code: "37398",

    ste_name: "TN",
  },
  {
    zip_code: "37416",

    ste_name: "TN",
  },
  {
    zip_code: "37711",

    ste_name: "TN",
  },
  {
    zip_code: "37752",

    ste_name: "TN",
  },
  {
    zip_code: "37774",

    ste_name: "TN",
  },
  {
    zip_code: "37846",

    ste_name: "TN",
  },
  {
    zip_code: "37877",

    ste_name: "TN",
  },
  {
    zip_code: "37914",

    ste_name: "TN",
  },
  {
    zip_code: "37934",

    ste_name: "TN",
  },
  {
    zip_code: "38067",

    ste_name: "TN",
  },
  {
    zip_code: "38342",

    ste_name: "TN",
  },
  {
    zip_code: "38460",

    ste_name: "TN",
  },
  {
    zip_code: "38462",

    ste_name: "TN",
  },
  {
    zip_code: "38548",

    ste_name: "TN",
  },
  {
    zip_code: "38671",

    ste_name: "MS",
  },
  {
    zip_code: "38672",

    ste_name: "MS",
  },
  {
    zip_code: "38704",

    ste_name: "MS",
  },
  {
    zip_code: "38858",

    ste_name: "MS",
  },
  {
    zip_code: "38860",

    ste_name: "MS",
  },
  {
    zip_code: "38862",

    ste_name: "MS",
  },
  {
    zip_code: "38944",

    ste_name: "MS",
  },
  {
    zip_code: "39088",

    ste_name: "MS",
  },
  {
    zip_code: "39092",

    ste_name: "MS",
  },
  {
    zip_code: "39338",

    ste_name: "MS",
  },
  {
    zip_code: "39339",

    ste_name: "MS",
  },
  {
    zip_code: "39354",

    ste_name: "MS",
  },
  {
    zip_code: "39532",

    ste_name: "MS",
  },
  {
    zip_code: "39564",

    ste_name: "MS",
  },
  {
    zip_code: "39629",

    ste_name: "MS",
  },
  {
    zip_code: "39631",

    ste_name: "MS",
  },
  {
    zip_code: "39744",

    ste_name: "MS",
  },
  {
    zip_code: "39755",

    ste_name: "MS",
  },
  {
    zip_code: "40347",

    ste_name: "KY",
  },
  {
    zip_code: "40351",

    ste_name: "KY",
  },
  {
    zip_code: "40914",

    ste_name: "KY",
  },
  {
    zip_code: "40939",

    ste_name: "KY",
  },
  {
    zip_code: "41146",

    ste_name: "KY",
  },
  {
    zip_code: "41166",

    ste_name: "KY",
  },
  {
    zip_code: "41219",

    ste_name: "KY",
  },
  {
    zip_code: "41257",

    ste_name: "KY",
  },
  {
    zip_code: "41268",

    ste_name: "KY",
  },
  {
    zip_code: "41472",

    ste_name: "KY",
  },
  {
    zip_code: "41513",

    ste_name: "KY",
  },
  {
    zip_code: "41558",

    ste_name: "KY",
  },
  {
    zip_code: "41566",

    ste_name: "KY",
  },
  {
    zip_code: "41640",

    ste_name: "KY",
  },
  {
    zip_code: "41835",

    ste_name: "KY",
  },
  {
    zip_code: "42035",

    ste_name: "KY",
  },
  {
    zip_code: "42041",

    ste_name: "KY",
  },
  {
    zip_code: "42048",

    ste_name: "KY",
  },
  {
    zip_code: "42050",

    ste_name: "KY",
  },
  {
    zip_code: "42071",

    ste_name: "KY",
  },
  {
    zip_code: "42129",

    ste_name: "KY",
  },
  {
    zip_code: "42141",

    ste_name: "KY",
  },
  {
    zip_code: "42223",

    ste_name: "KY",
  },
  {
    zip_code: "42352",

    ste_name: "KY",
  },
  {
    zip_code: "42450",

    ste_name: "KY",
  },
  {
    zip_code: "42717",

    ste_name: "KY",
  },
  {
    zip_code: "43103",

    ste_name: "OH",
  },
  {
    zip_code: "43127",

    ste_name: "OH",
  },
  {
    zip_code: "43207",

    ste_name: "OH",
  },
  {
    zip_code: "43322",

    ste_name: "OH",
  },
  {
    zip_code: "43337",

    ste_name: "OH",
  },
  {
    zip_code: "43468",

    ste_name: "OH",
  },
  {
    zip_code: "43537",

    ste_name: "OH",
  },
  {
    zip_code: "43605",

    ste_name: "OH",
  },
  {
    zip_code: "43611",

    ste_name: "OH",
  },
  {
    zip_code: "43786",

    ste_name: "OH",
  },
  {
    zip_code: "43934",

    ste_name: "OH",
  },
  {
    zip_code: "44011",

    ste_name: "OH",
  },
  {
    zip_code: "44040",

    ste_name: "OH",
  },
  {
    zip_code: "44054",

    ste_name: "OH",
  },
  {
    zip_code: "44203",

    ste_name: "OH",
  },
  {
    zip_code: "44236",

    ste_name: "OH",
  },
  {
    zip_code: "44243",

    ste_name: "OH",
  },
  {
    zip_code: "44276",

    ste_name: "OH",
  },
  {
    zip_code: "44308",

    ste_name: "OH",
  },
  {
    zip_code: "44506",

    ste_name: "OH",
  },
  {
    zip_code: "44509",

    ste_name: "OH",
  },
  {
    zip_code: "44608",

    ste_name: "OH",
  },
  {
    zip_code: "44626",

    ste_name: "OH",
  },
  {
    zip_code: "44629",

    ste_name: "OH",
  },
  {
    zip_code: "44718",

    ste_name: "OH",
  },
  {
    zip_code: "44802",

    ste_name: "OH",
  },
  {
    zip_code: "44805",

    ste_name: "OH",
  },
  {
    zip_code: "44841",

    ste_name: "OH",
  },
  {
    zip_code: "44854",

    ste_name: "OH",
  },
  {
    zip_code: "44857",

    ste_name: "OH",
  },
  {
    zip_code: "44882",

    ste_name: "OH",
  },
  {
    zip_code: "44904",

    ste_name: "OH",
  },
  {
    zip_code: "45068",

    ste_name: "OH",
  },
  {
    zip_code: "45155",

    ste_name: "OH",
  },
  {
    zip_code: "45243",

    ste_name: "OH",
  },
  {
    zip_code: "45308",

    ste_name: "OH",
  },
  {
    zip_code: "45323",

    ste_name: "OH",
  },
  {
    zip_code: "45405",

    ste_name: "OH",
  },
  {
    zip_code: "45621",

    ste_name: "OH",
  },
  {
    zip_code: "45648",

    ste_name: "OH",
  },
  {
    zip_code: "45744",

    ste_name: "OH",
  },
  {
    zip_code: "45813",

    ste_name: "OH",
  },
  {
    zip_code: "45841",

    ste_name: "OH",
  },
  {
    zip_code: "45851",

    ste_name: "OH",
  },
  {
    zip_code: "46107",

    ste_name: "IN",
  },
  {
    zip_code: "46126",

    ste_name: "IN",
  },
  {
    zip_code: "46128",

    ste_name: "IN",
  },
  {
    zip_code: "46150",

    ste_name: "IN",
  },
  {
    zip_code: "46157",

    ste_name: "IN",
  },
  {
    zip_code: "46182",

    ste_name: "IN",
  },
  {
    zip_code: "46311",

    ste_name: "IN",
  },
  {
    zip_code: "46390",

    ste_name: "IN",
  },
  {
    zip_code: "46567",

    ste_name: "IN",
  },
  {
    zip_code: "46573",

    ste_name: "IN",
  },
  {
    zip_code: "46803",

    ste_name: "IN",
  },
  {
    zip_code: "46913",

    ste_name: "IN",
  },
  {
    zip_code: "46947",

    ste_name: "IN",
  },
  {
    zip_code: "46985",

    ste_name: "IN",
  },
  {
    zip_code: "47117",

    ste_name: "IN",
  },
  {
    zip_code: "47164",

    ste_name: "IN",
  },
  {
    zip_code: "47177",

    ste_name: "IN",
  },
  {
    zip_code: "47244",

    ste_name: "IN",
  },
  {
    zip_code: "47401",

    ste_name: "IN",
  },
  {
    zip_code: "47576",

    ste_name: "IN",
  },
  {
    zip_code: "47612",

    ste_name: "IN",
  },
  {
    zip_code: "47841",

    ste_name: "IN",
  },
  {
    zip_code: "47847",

    ste_name: "IN",
  },
  {
    zip_code: "47850",

    ste_name: "IN",
  },
  {
    zip_code: "47865",

    ste_name: "IN",
  },
  {
    zip_code: "47866",

    ste_name: "IN",
  },
  {
    zip_code: "47872",

    ste_name: "IN",
  },
  {
    zip_code: "47921",

    ste_name: "IN",
  },
  {
    zip_code: "47943",

    ste_name: "IN",
  },
  {
    zip_code: "47990",

    ste_name: "IN",
  },
  {
    zip_code: "48015",

    ste_name: "MI",
  },
  {
    zip_code: "48048",

    ste_name: "MI",
  },
  {
    zip_code: "48081",

    ste_name: "MI",
  },
  {
    zip_code: "48097",

    ste_name: "MI",
  },
  {
    zip_code: "48105",

    ste_name: "MI",
  },
  {
    zip_code: "48124",

    ste_name: "MI",
  },
  {
    zip_code: "48187",

    ste_name: "MI",
  },
  {
    zip_code: "48301",

    ste_name: "MI",
  },
  {
    zip_code: "48315",

    ste_name: "MI",
  },
  {
    zip_code: "48362",

    ste_name: "MI",
  },
  {
    zip_code: "48413",

    ste_name: "MI",
  },
  {
    zip_code: "48418",

    ste_name: "MI",
  },
  {
    zip_code: "48442",

    ste_name: "MI",
  },
  {
    zip_code: "48446",

    ste_name: "MI",
  },
  {
    zip_code: "48603",

    ste_name: "MI",
  },
  {
    zip_code: "48617",

    ste_name: "MI",
  },
  {
    zip_code: "48619",

    ste_name: "MI",
  },
  {
    zip_code: "48628",

    ste_name: "MI",
  },
  {
    zip_code: "48653",

    ste_name: "MI",
  },
  {
    zip_code: "48701",

    ste_name: "MI",
  },
  {
    zip_code: "48729",

    ste_name: "MI",
  },
  {
    zip_code: "48746",

    ste_name: "MI",
  },
  {
    zip_code: "48809",

    ste_name: "MI",
  },
  {
    zip_code: "48811",

    ste_name: "MI",
  },
  {
    zip_code: "49006",

    ste_name: "MI",
  },
  {
    zip_code: "49080",

    ste_name: "MI",
  },
  {
    zip_code: "49119",

    ste_name: "MI",
  },
  {
    zip_code: "49269",

    ste_name: "MI",
  },
  {
    zip_code: "49282",

    ste_name: "MI",
  },
  {
    zip_code: "49287",

    ste_name: "MI",
  },
  {
    zip_code: "49309",

    ste_name: "MI",
  },
  {
    zip_code: "49401",

    ste_name: "MI",
  },
  {
    zip_code: "49615",

    ste_name: "MI",
  },
  {
    zip_code: "49622",

    ste_name: "MI",
  },
  {
    zip_code: "49623",

    ste_name: "MI",
  },
  {
    zip_code: "49664",

    ste_name: "MI",
  },
  {
    zip_code: "49667",

    ste_name: "MI",
  },
  {
    zip_code: "49747",

    ste_name: "MI",
  },
  {
    zip_code: "49748",

    ste_name: "MI",
  },
  {
    zip_code: "49808",

    ste_name: "MI",
  },
  {
    zip_code: "49892",

    ste_name: "MI",
  },
  {
    zip_code: "49922",

    ste_name: "MI",
  },
  {
    zip_code: "50071",

    ste_name: "IA",
  },
  {
    zip_code: "50119",

    ste_name: "IA",
  },
  {
    zip_code: "50122",

    ste_name: "IA",
  },
  {
    zip_code: "50132",

    ste_name: "IA",
  },
  {
    zip_code: "50158",

    ste_name: "IA",
  },
  {
    zip_code: "50201",

    ste_name: "IA",
  },
  {
    zip_code: "50264",

    ste_name: "IA",
  },
  {
    zip_code: "50268",

    ste_name: "IA",
  },
  {
    zip_code: "50470",

    ste_name: "IA",
  },
  {
    zip_code: "50571",

    ste_name: "IA",
  },
  {
    zip_code: "50576",

    ste_name: "IA",
  },
  {
    zip_code: "50669",

    ste_name: "IA",
  },
  {
    zip_code: "51004",

    ste_name: "IA",
  },
  {
    zip_code: "51035",

    ste_name: "IA",
  },
  {
    zip_code: "51050",

    ste_name: "IA",
  },
  {
    zip_code: "51231",

    ste_name: "IA",
  },
  {
    zip_code: "51235",

    ste_name: "IA",
  },
  {
    zip_code: "51301",

    ste_name: "IA",
  },
  {
    zip_code: "51636",

    ste_name: "IA",
  },
  {
    zip_code: "52037",

    ste_name: "IA",
  },
  {
    zip_code: "52039",

    ste_name: "IA",
  },
  {
    zip_code: "52203",

    ste_name: "IA",
  },
  {
    zip_code: "52565",

    ste_name: "IA",
  },
  {
    zip_code: "52588",

    ste_name: "IA",
  },
  {
    zip_code: "52745",

    ste_name: "IA",
  },
  {
    zip_code: "52748",

    ste_name: "IA",
  },
  {
    zip_code: "53016",

    ste_name: "WI",
  },
  {
    zip_code: "53021",

    ste_name: "WI",
  },
  {
    zip_code: "53150",

    ste_name: "WI",
  },
  {
    zip_code: "53184",

    ste_name: "WI",
  },
  {
    zip_code: "53207",

    ste_name: "WI",
  },
  {
    zip_code: "53209",

    ste_name: "WI",
  },
  {
    zip_code: "53213",

    ste_name: "WI",
  },
  {
    zip_code: "53217",

    ste_name: "WI",
  },
  {
    zip_code: "53402",

    ste_name: "WI",
  },
  {
    zip_code: "53501",

    ste_name: "WI",
  },
  {
    zip_code: "53560",

    ste_name: "WI",
  },
  {
    zip_code: "53579",

    ste_name: "WI",
  },
  {
    zip_code: "53803",

    ste_name: "WI",
  },
  {
    zip_code: "53806",

    ste_name: "WI",
  },
  {
    zip_code: "53807",

    ste_name: "WI",
  },
  {
    zip_code: "53956",

    ste_name: "WI",
  },
  {
    zip_code: "53969",

    ste_name: "WI",
  },
  {
    zip_code: "54004",

    ste_name: "WI",
  },
  {
    zip_code: "54201",

    ste_name: "WI",
  },
  {
    zip_code: "54247",

    ste_name: "WI",
  },
  {
    zip_code: "54301",

    ste_name: "WI",
  },
  {
    zip_code: "54454",

    ste_name: "WI",
  },
  {
    zip_code: "54486",

    ste_name: "WI",
  },
  {
    zip_code: "54521",

    ste_name: "WI",
  },
  {
    zip_code: "54555",

    ste_name: "WI",
  },
  {
    zip_code: "54559",

    ste_name: "WI",
  },
  {
    zip_code: "54566",

    ste_name: "WI",
  },
  {
    zip_code: "54658",

    ste_name: "WI",
  },
  {
    zip_code: "54727",

    ste_name: "WI",
  },
  {
    zip_code: "54827",

    ste_name: "WI",
  },
  {
    zip_code: "54829",

    ste_name: "WI",
  },
  {
    zip_code: "54840",

    ste_name: "WI",
  },
  {
    zip_code: "54891",

    ste_name: "WI",
  },
  {
    zip_code: "54963",

    ste_name: "WI",
  },
  {
    zip_code: "55009",

    ste_name: "MN",
  },
  {
    zip_code: "55089",

    ste_name: "MN",
  },
  {
    zip_code: "55307",

    ste_name: "MN",
  },
  {
    zip_code: "55312",

    ste_name: "MN",
  },
  {
    zip_code: "55335",

    ste_name: "MN",
  },
  {
    zip_code: "55353",

    ste_name: "MN",
  },
  {
    zip_code: "55413",

    ste_name: "MN",
  },
  {
    zip_code: "55425",

    ste_name: "MN",
  },
  {
    zip_code: "55615",

    ste_name: "MN",
  },
  {
    zip_code: "55723",

    ste_name: "MN",
  },
  {
    zip_code: "55738",

    ste_name: "MN",
  },
  {
    zip_code: "55746",

    ste_name: "MN",
  },
  {
    zip_code: "55927",

    ste_name: "MN",
  },
  {
    zip_code: "56098",

    ste_name: "MN",
  },
  {
    zip_code: "56185",

    ste_name: "MN",
  },
  {
    zip_code: "56340",

    ste_name: "MN",
  },
  {
    zip_code: "56347",

    ste_name: "MN",
  },
  {
    zip_code: "56389",

    ste_name: "MN",
  },
  {
    zip_code: "56431",

    ste_name: "MN",
  },
  {
    zip_code: "56572",

    ste_name: "MN",
  },
  {
    zip_code: "56581",

    ste_name: "MN",
  },
  {
    zip_code: "56687",

    ste_name: "MN",
  },
  {
    zip_code: "56722",

    ste_name: "MN",
  },
  {
    zip_code: "56744",

    ste_name: "MN",
  },
  {
    zip_code: "56755",

    ste_name: "MN",
  },
  {
    zip_code: "57010",

    ste_name: "SD",
  },
  {
    zip_code: "57066",

    ste_name: "SD",
  },
  {
    zip_code: "57214",

    ste_name: "SD",
  },
  {
    zip_code: "57219",

    ste_name: "SD",
  },
  {
    zip_code: "57224",

    ste_name: "SD",
  },
  {
    zip_code: "57226",

    ste_name: "SD",
  },
  {
    zip_code: "57241",

    ste_name: "SD",
  },
  {
    zip_code: "57335",

    ste_name: "SD",
  },
  {
    zip_code: "57386",

    ste_name: "SD",
  },
  {
    zip_code: "57441",

    ste_name: "SD",
  },
  {
    zip_code: "57548",

    ste_name: "SD",
  },
  {
    zip_code: "57580",

    ste_name: "SD",
  },
  {
    zip_code: "57626",

    ste_name: "SD",
  },
  {
    zip_code: "57752",

    ste_name: "SD",
  },
  {
    zip_code: "57755",

    ste_name: "SD",
  },
  {
    zip_code: "58030",

    ste_name: "ND",
  },
  {
    zip_code: "58052",

    ste_name: "ND",
  },
  {
    zip_code: "58067",

    ste_name: "ND",
  },
  {
    zip_code: "58244",

    ste_name: "ND",
  },
  {
    zip_code: "58266",

    ste_name: "ND",
  },
  {
    zip_code: "58413",

    ste_name: "ND",
  },
  {
    zip_code: "58415",

    ste_name: "ND",
  },
  {
    zip_code: "58703",

    ste_name: "ND",
  },
  {
    zip_code: "58725",

    ste_name: "ND",
  },
  {
    zip_code: "90010",

    ste_name: "CA",
  },
  {
    zip_code: "90221",

    ste_name: "CA",
  },
  {
    zip_code: "90265",

    ste_name: "CA",
  },
  {
    zip_code: "91204",

    ste_name: "CA",
  },
  {
    zip_code: "91355",

    ste_name: "CA",
  },
  {
    zip_code: "91723",

    ste_name: "CA",
  },
  {
    zip_code: "91750",

    ste_name: "CA",
  },
  {
    zip_code: "91765",

    ste_name: "CA",
  },
  {
    zip_code: "91766",

    ste_name: "CA",
  },
  {
    zip_code: "91790",

    ste_name: "CA",
  },
  {
    zip_code: "91902",

    ste_name: "CA",
  },
  {
    zip_code: "92117",

    ste_name: "CA",
  },
  {
    zip_code: "92122",

    ste_name: "CA",
  },
  {
    zip_code: "92278",

    ste_name: "CA",
  },
  {
    zip_code: "92310",

    ste_name: "CA",
  },
  {
    zip_code: "92316",

    ste_name: "CA",
  },
  {
    zip_code: "92501",

    ste_name: "CA",
  },
  {
    zip_code: "92508",

    ste_name: "CA",
  },
  {
    zip_code: "92625",

    ste_name: "CA",
  },
  {
    zip_code: "92678",

    ste_name: "CA",
  },
  {
    zip_code: "92694",

    ste_name: "CA",
  },
  {
    zip_code: "92880",

    ste_name: "CA",
  },
  {
    zip_code: "93234",

    ste_name: "CA",
  },
  {
    zip_code: "93238",

    ste_name: "CA",
  },
  {
    zip_code: "93254",

    ste_name: "CA",
  },
  {
    zip_code: "94542",

    ste_name: "CA",
  },
  {
    zip_code: "94567",

    ste_name: "CA",
  },
  {
    zip_code: "94939",

    ste_name: "CA",
  },
  {
    zip_code: "94972",

    ste_name: "CA",
  },
  {
    zip_code: "95004",

    ste_name: "CA",
  },
  {
    zip_code: "95237",

    ste_name: "CA",
  },
  {
    zip_code: "95255",

    ste_name: "CA",
  },
  {
    zip_code: "95307",

    ste_name: "CA",
  },
  {
    zip_code: "95357",

    ste_name: "CA",
  },
  {
    zip_code: "95364",

    ste_name: "CA",
  },
  {
    zip_code: "95379",

    ste_name: "CA",
  },
  {
    zip_code: "95492",

    ste_name: "CA",
  },
  {
    zip_code: "95559",

    ste_name: "CA",
  },
  {
    zip_code: "95570",

    ste_name: "CA",
  },
  {
    zip_code: "95589",

    ste_name: "CA",
  },
  {
    zip_code: "95641",

    ste_name: "CA",
  },
  {
    zip_code: "95713",

    ste_name: "CA",
  },
  {
    zip_code: "95728",

    ste_name: "CA",
  },
  {
    zip_code: "95915",

    ste_name: "CA",
  },
  {
    zip_code: "95942",

    ste_name: "CA",
  },
  {
    zip_code: "95945",

    ste_name: "CA",
  },
  {
    zip_code: "95993",

    ste_name: "CA",
  },
  {
    zip_code: "96113",

    ste_name: "CA",
  },
  {
    zip_code: "96130",

    ste_name: "CA",
  },
  {
    zip_code: "96134",

    ste_name: "CA",
  },
  {
    zip_code: "96730",

    ste_name: "HI",
  },
  {
    zip_code: "96777",

    ste_name: "HI",
  },
  {
    zip_code: "97022",

    ste_name: "OR",
  },
  {
    zip_code: "97055",

    ste_name: "OR",
  },
  {
    zip_code: "97070",

    ste_name: "OR",
  },
  {
    zip_code: "97147",

    ste_name: "OR",
  },
  {
    zip_code: "97209",

    ste_name: "OR",
  },
  {
    zip_code: "97322",

    ste_name: "OR",
  },
  {
    zip_code: "97392",

    ste_name: "OR",
  },
  {
    zip_code: "97406",

    ste_name: "OR",
  },
  {
    zip_code: "97416",

    ste_name: "OR",
  },
  {
    zip_code: "97454",

    ste_name: "OR",
  },
  {
    zip_code: "97819",

    ste_name: "OR",
  },
  {
    zip_code: "97875",

    ste_name: "OR",
  },
  {
    zip_code: "98023",

    ste_name: "WA",
  },
  {
    zip_code: "98174",

    ste_name: "WA",
  },
  {
    zip_code: "98201",

    ste_name: "WA",
  },
  {
    zip_code: "98204",

    ste_name: "WA",
  },
  {
    zip_code: "98365",

    ste_name: "WA",
  },
  {
    zip_code: "93422",

    ste_name: "CA",
  },
  {
    zip_code: "93437",

    ste_name: "CA",
  },
  {
    zip_code: "93543",

    ste_name: "CA",
  },
  {
    zip_code: "93657",

    ste_name: "CA",
  },
  {
    zip_code: "93727",

    ste_name: "CA",
  },
  {
    zip_code: "93907",

    ste_name: "CA",
  },
  {
    zip_code: "94028",

    ste_name: "CA",
  },
  {
    zip_code: "94104",

    ste_name: "CA",
  },
  {
    zip_code: "94118",

    ste_name: "CA",
  },
  {
    zip_code: "94124",

    ste_name: "CA",
  },
  {
    zip_code: "98026",

    ste_name: "WA",
  },
  {
    zip_code: "98047",

    ste_name: "WA",
  },
  {
    zip_code: "98107",

    ste_name: "WA",
  },
  {
    zip_code: "98110",

    ste_name: "WA",
  },
  {
    zip_code: "98164",

    ste_name: "WA",
  },
  {
    zip_code: "98295",

    ste_name: "WA",
  },
  {
    zip_code: "98404",

    ste_name: "WA",
  },
  {
    zip_code: "98559",

    ste_name: "WA",
  },
  {
    zip_code: "98631",

    ste_name: "WA",
  },
  {
    zip_code: "98660",

    ste_name: "WA",
  },
  {
    zip_code: "98802",

    ste_name: "WA",
  },
  {
    zip_code: "98836",

    ste_name: "WA",
  },
  {
    zip_code: "98847",

    ste_name: "WA",
  },
  {
    zip_code: "98855",

    ste_name: "WA",
  },
  {
    zip_code: "98856",

    ste_name: "WA",
  },
  {
    zip_code: "98934",

    ste_name: "WA",
  },
  {
    zip_code: "99116",

    ste_name: "WA",
  },
  {
    zip_code: "99118",

    ste_name: "WA",
  },
  {
    zip_code: "99124",

    ste_name: "WA",
  },
  {
    zip_code: "99138",

    ste_name: "WA",
  },
  {
    zip_code: "99166",

    ste_name: "WA",
  },
  {
    zip_code: "99167",

    ste_name: "WA",
  },
  {
    zip_code: "99176",

    ste_name: "WA",
  },
  {
    zip_code: "99217",

    ste_name: "WA",
  },
  {
    zip_code: "99344",

    ste_name: "WA",
  },
  {
    zip_code: "99346",

    ste_name: "WA",
  },
  {
    zip_code: "99361",

    ste_name: "WA",
  },
  {
    zip_code: "99556",

    ste_name: "AK",
  },
  {
    zip_code: "99573",

    ste_name: "AK",
  },
  {
    zip_code: "99614",

    ste_name: "AK",
  },
  {
    zip_code: "99639",

    ste_name: "AK",
  },
  {
    zip_code: "99649",

    ste_name: "AK",
  },
  {
    zip_code: "99689",

    ste_name: "AK",
  },
  {
    zip_code: "99739",

    ste_name: "AK",
  },
  {
    zip_code: "99743",

    ste_name: "AK",
  },
  {
    zip_code: "7079",

    ste_name: "NJ",
  },
  {
    zip_code: "7102",

    ste_name: "NJ",
  },
  {
    zip_code: "7105",

    ste_name: "NJ",
  },
  {
    zip_code: "7421",

    ste_name: "NJ",
  },
  {
    zip_code: "7502",

    ste_name: "NJ",
  },
  {
    zip_code: "7504",

    ste_name: "NJ",
  },
  {
    zip_code: "7513",

    ste_name: "NJ",
  },
  {
    zip_code: "7652",

    ste_name: "NJ",
  },
  {
    zip_code: "7712",

    ste_name: "NJ",
  },
  {
    zip_code: "7866",

    ste_name: "NJ",
  },
  {
    zip_code: "7922",

    ste_name: "NJ",
  },
  {
    zip_code: "8043",

    ste_name: "NJ",
  },
  {
    zip_code: "8104",

    ste_name: "NJ",
  },
  {
    zip_code: "8349",

    ste_name: "NJ",
  },
  {
    zip_code: "8638",

    ste_name: "NJ",
  },
  {
    zip_code: "58456",

    ste_name: "ND",
  },
  {
    zip_code: "58530",

    ste_name: "ND",
  },
  {
    zip_code: "58580",

    ste_name: "ND",
  },
  {
    zip_code: "646",

    ste_name: "PR",
  },
  {
    zip_code: "650",

    ste_name: "PR",
  },
  {
    zip_code: "705",

    ste_name: "PR",
  },
  {
    zip_code: "1036",

    ste_name: "MA",
  },
  {
    zip_code: "1375",

    ste_name: "MA",
  },
  {
    zip_code: "1378",

    ste_name: "MA",
  },
  {
    zip_code: "1453",

    ste_name: "MA",
  },
  {
    zip_code: "1521",

    ste_name: "MA",
  },
  {
    zip_code: "1531",

    ste_name: "MA",
  },
  {
    zip_code: "1545",

    ste_name: "MA",
  },
  {
    zip_code: "1588",

    ste_name: "MA",
  },
  {
    zip_code: "1841",

    ste_name: "MA",
  },
  {
    zip_code: "1864",

    ste_name: "MA",
  },
  {
    zip_code: "1922",

    ste_name: "MA",
  },
  {
    zip_code: "1969",

    ste_name: "MA",
  },
  {
    zip_code: "2045",

    ste_name: "MA",
  },
  {
    zip_code: "2056",

    ste_name: "MA",
  },
  {
    zip_code: "2134",

    ste_name: "MA",
  },
  {
    zip_code: "2366",

    ste_name: "MA",
  },
  {
    zip_code: "2474",

    ste_name: "MA",
  },
  {
    zip_code: "2538",

    ste_name: "MA",
  },
  {
    zip_code: "2747",

    ste_name: "MA",
  },
  {
    zip_code: "2771",

    ste_name: "MA",
  },
  {
    zip_code: "2806",

    ste_name: "RI",
  },
  {
    zip_code: "2818",

    ste_name: "RI",
  },
  {
    zip_code: "2822",

    ste_name: "RI",
  },
  {
    zip_code: "2863",

    ste_name: "RI",
  },
  {
    zip_code: "2875",

    ste_name: "RI",
  },
  {
    zip_code: "3045",

    ste_name: "NH",
  },
  {
    zip_code: "3062",

    ste_name: "NH",
  },
  {
    zip_code: "3253",

    ste_name: "NH",
  },
  {
    zip_code: "3259",

    ste_name: "NH",
  },
  {
    zip_code: "3449",

    ste_name: "NH",
  },
  {
    zip_code: "3752",

    ste_name: "NH",
  },
  {
    zip_code: "3818",

    ste_name: "NH",
  },
  {
    zip_code: "3823",

    ste_name: "NH",
  },
  {
    zip_code: "3841",

    ste_name: "NH",
  },
  {
    zip_code: "3890",

    ste_name: "NH",
  },
  {
    zip_code: "3910",

    ste_name: "ME",
  },
  {
    zip_code: "4005",

    ste_name: "ME",
  },
  {
    zip_code: "4066",

    ste_name: "ME",
  },
  {
    zip_code: "4068",

    ste_name: "ME",
  },
  {
    zip_code: "4071",

    ste_name: "ME",
  },
  {
    zip_code: "4086",

    ste_name: "ME",
  },
  {
    zip_code: "4095",

    ste_name: "ME",
  },
  {
    zip_code: "4101",

    ste_name: "ME",
  },
  {
    zip_code: "4110",

    ste_name: "ME",
  },
  {
    zip_code: "4257",

    ste_name: "ME",
  },
  {
    zip_code: "4284",

    ste_name: "ME",
  },
  {
    zip_code: "4471",

    ste_name: "ME",
  },
  {
    zip_code: "4472",

    ste_name: "ME",
  },
  {
    zip_code: "4530",

    ste_name: "ME",
  },
  {
    zip_code: "4558",

    ste_name: "ME",
  },
  {
    zip_code: "4576",

    ste_name: "ME",
  },
  {
    zip_code: "4685",

    ste_name: "ME",
  },
  {
    zip_code: "4928",

    ste_name: "ME",
  },
  {
    zip_code: "4940",

    ste_name: "ME",
  },
  {
    zip_code: "4963",

    ste_name: "ME",
  },
  {
    zip_code: "5089",

    ste_name: "VT",
  },
  {
    zip_code: "5358",

    ste_name: "VT",
  },
  {
    zip_code: "5452",

    ste_name: "VT",
  },
  {
    zip_code: "5468",

    ste_name: "VT",
  },
  {
    zip_code: "5640",

    ste_name: "VT",
  },
  {
    zip_code: "5679",

    ste_name: "VT",
  },
  {
    zip_code: "5758",

    ste_name: "VT",
  },
  {
    zip_code: "5769",

    ste_name: "VT",
  },
  {
    zip_code: "5853",

    ste_name: "VT",
  },
  {
    zip_code: "6062",

    ste_name: "CT",
  },
  {
    zip_code: "6108",

    ste_name: "CT",
  },
  {
    zip_code: "6359",

    ste_name: "CT",
  },
  {
    zip_code: "6405",

    ste_name: "CT",
  },
  {
    zip_code: "6438",

    ste_name: "CT",
  },
  {
    zip_code: "6511",

    ste_name: "CT",
  },
  {
    zip_code: "6712",

    ste_name: "CT",
  },
  {
    zip_code: "6716",

    ste_name: "CT",
  },
  {
    zip_code: "6785",

    ste_name: "CT",
  },
  {
    zip_code: "6786",

    ste_name: "CT",
  },
  {
    zip_code: "7004",

    ste_name: "NJ",
  },
  {
    zip_code: "7018",

    ste_name: "NJ",
  },
  {
    zip_code: "7067",

    ste_name: "NJ",
  },
  {
    zip_code: "8801",

    ste_name: "NJ",
  },
  {
    zip_code: "8844",

    ste_name: "NJ",
  },
  {
    zip_code: "8858",

    ste_name: "NJ",
  },
  {
    zip_code: "8873",

    ste_name: "NJ",
  },
  {
    zip_code: "8901",

    ste_name: "NJ",
  },
  {
    zip_code: "10006",

    ste_name: "NY",
  },
  {
    zip_code: "10021",

    ste_name: "NY",
  },
  {
    zip_code: "10036",

    ste_name: "NY",
  },
  {
    zip_code: "10119",

    ste_name: "NY",
  },
  {
    zip_code: "10128",

    ste_name: "NY",
  },
  {
    zip_code: "10314",

    ste_name: "NY",
  },
  {
    zip_code: "10472",

    ste_name: "NY",
  },
  {
    zip_code: "10502",

    ste_name: "NY",
  },
  {
    zip_code: "10503",

    ste_name: "NY",
  },
  {
    zip_code: "10522",

    ste_name: "NY",
  },
  {
    zip_code: "10543",

    ste_name: "NY",
  },
  {
    zip_code: "10970",

    ste_name: "NY",
  },
  {
    zip_code: "11230",

    ste_name: "NY",
  },
  {
    zip_code: "11231",

    ste_name: "NY",
  },
  {
    zip_code: "11355",

    ste_name: "NY",
  },
  {
    zip_code: "11423",

    ste_name: "NY",
  },
  {
    zip_code: "11432",

    ste_name: "NY",
  },
  {
    zip_code: "11545",

    ste_name: "NY",
  },
  {
    zip_code: "11547",

    ste_name: "NY",
  },
  {
    zip_code: "11766",

    ste_name: "NY",
  },
  {
    zip_code: "12043",

    ste_name: "NY",
  },
  {
    zip_code: "12166",

    ste_name: "NY",
  },
  {
    zip_code: "12172",

    ste_name: "NY",
  },
  {
    zip_code: "12187",

    ste_name: "NY",
  },
  {
    zip_code: "12440",

    ste_name: "NY",
  },
  {
    zip_code: "12446",

    ste_name: "NY",
  },
  {
    zip_code: "12454",

    ste_name: "NY",
  },
  {
    zip_code: "12736",

    ste_name: "NY",
  },
  {
    zip_code: "12776",

    ste_name: "NY",
  },
  {
    zip_code: "12787",

    ste_name: "NY",
  },
  {
    zip_code: "12790",

    ste_name: "NY",
  },
  {
    zip_code: "12821",

    ste_name: "NY",
  },
  {
    zip_code: "12911",

    ste_name: "NY",
  },
  {
    zip_code: "12976",

    ste_name: "NY",
  },
  {
    zip_code: "13027",

    ste_name: "NY",
  },
  {
    zip_code: "13044",

    ste_name: "NY",
  },
  {
    zip_code: "13063",

    ste_name: "NY",
  },
  {
    zip_code: "13115",

    ste_name: "NY",
  },
  {
    zip_code: "13131",

    ste_name: "NY",
  },
  {
    zip_code: "13167",

    ste_name: "NY",
  },
  {
    zip_code: "13325",

    ste_name: "NY",
  },
  {
    zip_code: "13345",

    ste_name: "NY",
  },
  {
    zip_code: "13362",

    ste_name: "NY",
  },
  {
    zip_code: "13409",

    ste_name: "NY",
  },
  {
    zip_code: "13675",

    ste_name: "NY",
  },
  {
    zip_code: "13680",

    ste_name: "NY",
  },
  {
    zip_code: "13794",

    ste_name: "NY",
  },
  {
    zip_code: "13830",

    ste_name: "NY",
  },
  {
    zip_code: "13860",

    ste_name: "NY",
  },
  {
    zip_code: "14134",

    ste_name: "NY",
  },
  {
    zip_code: "14172",

    ste_name: "NY",
  },
  {
    zip_code: "14204",

    ste_name: "NY",
  },
  {
    zip_code: "14468",

    ste_name: "NY",
  },
  {
    zip_code: "14513",

    ste_name: "NY",
  },
  {
    zip_code: "14548",

    ste_name: "NY",
  },
  {
    zip_code: "14588",

    ste_name: "NY",
  },
  {
    zip_code: "14611",

    ste_name: "NY",
  },
  {
    zip_code: "14717",

    ste_name: "NY",
  },
  {
    zip_code: "14720",

    ste_name: "NY",
  },
  {
    zip_code: "14724",

    ste_name: "NY",
  },
  {
    zip_code: "14739",

    ste_name: "NY",
  },
  {
    zip_code: "14760",

    ste_name: "NY",
  },
  {
    zip_code: "14767",

    ste_name: "NY",
  },
  {
    zip_code: "14873",

    ste_name: "NY",
  },
  {
    zip_code: "15063",

    ste_name: "PA",
  },
  {
    zip_code: "15071",

    ste_name: "PA",
  },
  {
    zip_code: "15228",

    ste_name: "PA",
  },
  {
    zip_code: "15312",

    ste_name: "PA",
  },
  {
    zip_code: "15358",

    ste_name: "PA",
  },
  {
    zip_code: "15362",

    ste_name: "PA",
  },
  {
    zip_code: "15419",

    ste_name: "PA",
  },
  {
    zip_code: "15430",

    ste_name: "PA",
  },
  {
    zip_code: "15434",

    ste_name: "PA",
  },
  {
    zip_code: "15438",

    ste_name: "PA",
  },
  {
    zip_code: "15551",

    ste_name: "PA",
  },
  {
    zip_code: "15678",

    ste_name: "PA",
  },
  {
    zip_code: "15693",

    ste_name: "PA",
  },
  {
    zip_code: "15698",

    ste_name: "PA",
  },
  {
    zip_code: "15714",

    ste_name: "PA",
  },
  {
    zip_code: "15926",

    ste_name: "PA",
  },
  {
    zip_code: "15942",

    ste_name: "PA",
  },
  {
    zip_code: "16045",

    ste_name: "PA",
  },
  {
    zip_code: "16046",

    ste_name: "PA",
  },
  {
    zip_code: "16132",

    ste_name: "PA",
  },
  {
    zip_code: "16155",

    ste_name: "PA",
  },
  {
    zip_code: "16239",

    ste_name: "PA",
  },
  {
    zip_code: "16322",

    ste_name: "PA",
  },
  {
    zip_code: "16334",

    ste_name: "PA",
  },
  {
    zip_code: "16402",

    ste_name: "PA",
  },
  {
    zip_code: "16655",

    ste_name: "PA",
  },
  {
    zip_code: "16671",

    ste_name: "PA",
  },
  {
    zip_code: "16686",

    ste_name: "PA",
  },
  {
    zip_code: "16829",

    ste_name: "PA",
  },
  {
    zip_code: "16833",

    ste_name: "PA",
  },
  {
    zip_code: "16876",

    ste_name: "PA",
  },
  {
    zip_code: "17023",

    ste_name: "PA",
  },
  {
    zip_code: "17051",

    ste_name: "PA",
  },
  {
    zip_code: "17260",

    ste_name: "PA",
  },
  {
    zip_code: "17339",

    ste_name: "PA",
  },
  {
    zip_code: "17363",

    ste_name: "PA",
  },
  {
    zip_code: "17505",

    ste_name: "PA",
  },
  {
    zip_code: "17835",

    ste_name: "PA",
  },
  {
    zip_code: "17836",

    ste_name: "PA",
  },
  {
    zip_code: "17945",

    ste_name: "PA",
  },
  {
    zip_code: "17948",

    ste_name: "PA",
  },
  {
    zip_code: "17981",

    ste_name: "PA",
  },
  {
    zip_code: "18042",

    ste_name: "PA",
  },
  {
    zip_code: "18069",

    ste_name: "PA",
  },
  {
    zip_code: "18083",

    ste_name: "PA",
  },
  {
    zip_code: "18223",

    ste_name: "PA",
  },
  {
    zip_code: "18242",

    ste_name: "PA",
  },
  {
    zip_code: "18251",

    ste_name: "PA",
  },
  {
    zip_code: "18332",

    ste_name: "PA",
  },
  {
    zip_code: "18343",

    ste_name: "PA",
  },
  {
    zip_code: "18473",

    ste_name: "PA",
  },
  {
    zip_code: "18628",

    ste_name: "PA",
  },
  {
    zip_code: "18706",

    ste_name: "PA",
  },
  {
    zip_code: "18831",

    ste_name: "PA",
  },
  {
    zip_code: "18913",

    ste_name: "PA",
  },
  {
    zip_code: "18942",

    ste_name: "PA",
  },
  {
    zip_code: "19033",

    ste_name: "PA",
  },
  {
    zip_code: "19061",

    ste_name: "PA",
  },
  {
    zip_code: "19081",

    ste_name: "PA",
  },
  {
    zip_code: "19142",

    ste_name: "PA",
  },
  {
    zip_code: "19345",

    ste_name: "PA",
  },
  {
    zip_code: "19352",

    ste_name: "PA",
  },
  {
    zip_code: "19538",

    ste_name: "PA",
  },
  {
    zip_code: "19560",

    ste_name: "PA",
  },
  {
    zip_code: "19606",

    ste_name: "PA",
  },
  {
    zip_code: "19701",

    ste_name: "DE",
  },
  {
    zip_code: "19805",

    ste_name: "DE",
  },
  {
    zip_code: "19968",

    ste_name: "DE",
  },
  {
    zip_code: "19975",

    ste_name: "DE",
  },
  {
    zip_code: "19977",

    ste_name: "DE",
  },
  {
    zip_code: "20019",

    ste_name: "DC",
  },
  {
    zip_code: "20130",

    ste_name: "VA",
  },
  {
    zip_code: "20166",

    ste_name: "VA",
  },
  {
    zip_code: "20230",

    ste_name: "DC",
  },
  {
    zip_code: "20611",

    ste_name: "MD",
  },
  {
    zip_code: "20653",

    ste_name: "MD",
  },
  {
    zip_code: "20764",

    ste_name: "MD",
  },
  {
    zip_code: "20776",

    ste_name: "MD",
  },
  {
    zip_code: "20784",

    ste_name: "MD",
  },
  {
    zip_code: "20817",

    ste_name: "MD",
  },
  {
    zip_code: "21013",

    ste_name: "MD",
  },
  {
    zip_code: "21206",

    ste_name: "MD",
  },
  {
    zip_code: "21538",

    ste_name: "MD",
  },
  {
    zip_code: "21550",

    ste_name: "MD",
  },
  {
    zip_code: "21644",

    ste_name: "MD",
  },
  {
    zip_code: "21676",

    ste_name: "MD",
  },
  {
    zip_code: "22060",

    ste_name: "VA",
  },
  {
    zip_code: "22205",

    ste_name: "VA",
  },
  {
    zip_code: "22309",

    ste_name: "VA",
  },
  {
    zip_code: "22640",

    ste_name: "VA",
  },
  {
    zip_code: "22738",

    ste_name: "VA",
  },
  {
    zip_code: "22742",

    ste_name: "VA",
  },
  {
    zip_code: "22807",

    ste_name: "VA",
  },
  {
    zip_code: "22940",

    ste_name: "VA",
  },
  {
    zip_code: "22947",

    ste_name: "VA",
  },
  {
    zip_code: "23129",

    ste_name: "VA",
  },
  {
    zip_code: "23337",

    ste_name: "VA",
  },
  {
    zip_code: "23418",

    ste_name: "VA",
  },
  {
    zip_code: "23850",

    ste_name: "VA",
  },
  {
    zip_code: "24017",

    ste_name: "VA",
  },
  {
    zip_code: "24128",

    ste_name: "VA",
  },
  {
    zip_code: "24175",

    ste_name: "VA",
  },
  {
    zip_code: "24315",

    ste_name: "VA",
  },
  {
    zip_code: "24416",

    ste_name: "VA",
  },
  {
    zip_code: "24433",

    ste_name: "VA",
  },
  {
    zip_code: "24482",

    ste_name: "VA",
  },
  {
    zip_code: "24485",

    ste_name: "VA",
  },
  {
    zip_code: "24534",

    ste_name: "VA",
  },
  {
    zip_code: "24604",

    ste_name: "VA",
  },
  {
    zip_code: "24918",

    ste_name: "WV",
  },
  {
    zip_code: "24944",

    ste_name: "WV",
  },
  {
    zip_code: "24945",

    ste_name: "WV",
  },
  {
    zip_code: "24957",

    ste_name: "WV",
  },
  {
    zip_code: "24983",

    ste_name: "WV",
  },
  {
    zip_code: "25039",

    ste_name: "WV",
  },
  {
    zip_code: "25118",

    ste_name: "WV",
  },
  {
    zip_code: "25126",

    ste_name: "WV",
  },
  {
    zip_code: "25130",

    ste_name: "WV",
  },
  {
    zip_code: "25161",

    ste_name: "WV",
  },
  {
    zip_code: "25165",

    ste_name: "WV",
  },
  {
    zip_code: "25239",

    ste_name: "WV",
  },
  {
    zip_code: "25245",

    ste_name: "WV",
  },
  {
    zip_code: "25251",

    ste_name: "WV",
  },
  {
    zip_code: "25264",

    ste_name: "WV",
  },
  {
    zip_code: "25271",

    ste_name: "WV",
  },
  {
    zip_code: "25302",

    ste_name: "WV",
  },
  {
    zip_code: "25309",

    ste_name: "WV",
  },
  {
    zip_code: "25506",

    ste_name: "WV",
  },
  {
    zip_code: "25545",

    ste_name: "WV",
  },
  {
    zip_code: "25557",

    ste_name: "WV",
  },
  {
    zip_code: "25635",

    ste_name: "WV",
  },
  {
    zip_code: "25688",

    ste_name: "WV",
  },
  {
    zip_code: "26032",

    ste_name: "WV",
  },
  {
    zip_code: "26033",

    ste_name: "WV",
  },
  {
    zip_code: "26133",

    ste_name: "WV",
  },
  {
    zip_code: "26143",

    ste_name: "WV",
  },
  {
    zip_code: "26147",

    ste_name: "WV",
  },
  {
    zip_code: "26416",

    ste_name: "WV",
  },
  {
    zip_code: "26588",

    ste_name: "WV",
  },
  {
    zip_code: "26810",

    ste_name: "WV",
  },
  {
    zip_code: "27007",

    ste_name: "NC",
  },
  {
    zip_code: "27027",

    ste_name: "NC",
  },
  {
    zip_code: "27101",

    ste_name: "NC",
  },
  {
    zip_code: "27107",

    ste_name: "NC",
  },
  {
    zip_code: "27215",

    ste_name: "NC",
  },
  {
    zip_code: "27310",

    ste_name: "NC",
  },
  {
    zip_code: "27510",

    ste_name: "NC",
  },
  {
    zip_code: "27529",

    ste_name: "NC",
  },
  {
    zip_code: "27853",

    ste_name: "NC",
  },
  {
    zip_code: "27941",

    ste_name: "NC",
  },
  {
    zip_code: "27950",

    ste_name: "NC",
  },
  {
    zip_code: "27976",

    ste_name: "NC",
  },
  {
    zip_code: "28079",

    ste_name: "NC",
  },
  {
    zip_code: "28089",

    ste_name: "NC",
  },
  {
    zip_code: "28119",

    ste_name: "NC",
  },
  {
    zip_code: "28203",

    ste_name: "NC",
  },
  {
    zip_code: "28327",

    ste_name: "NC",
  },
  {
    zip_code: "28334",

    ste_name: "NC",
  },
  {
    zip_code: "28423",

    ste_name: "NC",
  },
  {
    zip_code: "28434",

    ste_name: "NC",
  },
  {
    zip_code: "28447",

    ste_name: "NC",
  },
  {
    zip_code: "28453",

    ste_name: "NC",
  },
  {
    zip_code: "28460",

    ste_name: "NC",
  },
  {
    zip_code: "28463",

    ste_name: "NC",
  },
  {
    zip_code: "28468",

    ste_name: "NC",
  },
  {
    zip_code: "28546",

    ste_name: "NC",
  },
  {
    zip_code: "28586",

    ste_name: "NC",
  },
  {
    zip_code: "28601",

    ste_name: "NC",
  },
  {
    zip_code: "28621",

    ste_name: "NC",
  },
  {
    zip_code: "28643",

    ste_name: "NC",
  },
  {
    zip_code: "28668",

    ste_name: "NC",
  },
  {
    zip_code: "28740",

    ste_name: "NC",
  },
  {
    zip_code: "28803",

    ste_name: "NC",
  },
  {
    zip_code: "29020",

    ste_name: "SC",
  },
  {
    zip_code: "29059",

    ste_name: "SC",
  },
  {
    zip_code: "29108",

    ste_name: "SC",
  },
  {
    zip_code: "29137",

    ste_name: "SC",
  },
  {
    zip_code: "29369",

    ste_name: "SC",
  },
  {
    zip_code: "29406",

    ste_name: "SC",
  },
  {
    zip_code: "29437",

    ste_name: "SC",
  },
  {
    zip_code: "29577",

    ste_name: "SC",
  },
  {
    zip_code: "29650",

    ste_name: "SC",
  },
  {
    zip_code: "29687",

    ste_name: "SC",
  },
  {
    zip_code: "29924",

    ste_name: "SC",
  },
  {
    zip_code: "30043",

    ste_name: "GA",
  },
  {
    zip_code: "30114",

    ste_name: "GA",
  },
  {
    zip_code: "30120",

    ste_name: "GA",
  },
  {
    zip_code: "30127",

    ste_name: "GA",
  },
  {
    zip_code: "30141",

    ste_name: "GA",
  },
  {
    zip_code: "30143",

    ste_name: "GA",
  },
  {
    zip_code: "30215",

    ste_name: "GA",
  },
  {
    zip_code: "30250",

    ste_name: "GA",
  },
  {
    zip_code: "30251",

    ste_name: "GA",
  },
  {
    zip_code: "30259",

    ste_name: "GA",
  },
  {
    zip_code: "30307",

    ste_name: "GA",
  },
  {
    zip_code: "30311",

    ste_name: "GA",
  },
  {
    zip_code: "30322",

    ste_name: "GA",
  },
  {
    zip_code: "30513",

    ste_name: "GA",
  },
  {
    zip_code: "30547",

    ste_name: "GA",
  },
  {
    zip_code: "30558",

    ste_name: "GA",
  },
  {
    zip_code: "30564",

    ste_name: "GA",
  },
  {
    zip_code: "30576",

    ste_name: "GA",
  },
  {
    zip_code: "30631",

    ste_name: "GA",
  },
  {
    zip_code: "30750",

    ste_name: "GA",
  },
  {
    zip_code: "30757",

    ste_name: "GA",
  },
  {
    zip_code: "58765",

    ste_name: "ND",
  },
  {
    zip_code: "58769",

    ste_name: "ND",
  },
  {
    zip_code: "58773",

    ste_name: "ND",
  },
  {
    zip_code: "58787",

    ste_name: "ND",
  },
  {
    zip_code: "58794",

    ste_name: "ND",
  },
  {
    zip_code: "59003",

    ste_name: "MT",
  },
  {
    zip_code: "59008",

    ste_name: "MT",
  },
  {
    zip_code: "59059",

    ste_name: "MT",
  },
  {
    zip_code: "59066",

    ste_name: "MT",
  },
  {
    zip_code: "59081",

    ste_name: "MT",
  },
  {
    zip_code: "59275",

    ste_name: "MT",
  },
  {
    zip_code: "59487",

    ste_name: "MT",
  },
  {
    zip_code: "59535",

    ste_name: "MT",
  },
  {
    zip_code: "59538",

    ste_name: "MT",
  },
  {
    zip_code: "59640",

    ste_name: "MT",
  },
  {
    zip_code: "59747",

    ste_name: "MT",
  },
  {
    zip_code: "59841",

    ste_name: "MT",
  },
  {
    zip_code: "59867",

    ste_name: "MT",
  },
  {
    zip_code: "60018",

    ste_name: "IL",
  },
  {
    zip_code: "60146",

    ste_name: "IL",
  },
  {
    zip_code: "60189",

    ste_name: "IL",
  },
  {
    zip_code: "60304",

    ste_name: "IL",
  },
  {
    zip_code: "60419",

    ste_name: "IL",
  },
  {
    zip_code: "60519",

    ste_name: "IL",
  },
  {
    zip_code: "60638",

    ste_name: "IL",
  },
  {
    zip_code: "60927",

    ste_name: "IL",
  },
  {
    zip_code: "60936",

    ste_name: "IL",
  },
  {
    zip_code: "60941",

    ste_name: "IL",
  },
  {
    zip_code: "60942",

    ste_name: "IL",
  },
  {
    zip_code: "60952",

    ste_name: "IL",
  },
  {
    zip_code: "60963",

    ste_name: "IL",
  },
  {
    zip_code: "60969",

    ste_name: "IL",
  },
  {
    zip_code: "61049",

    ste_name: "IL",
  },
  {
    zip_code: "61065",

    ste_name: "IL",
  },
  {
    zip_code: "61284",

    ste_name: "IL",
  },
  {
    zip_code: "61349",

    ste_name: "IL",
  },
  {
    zip_code: "61356",

    ste_name: "IL",
  },
  {
    zip_code: "61414",

    ste_name: "IL",
  },
  {
    zip_code: "61418",

    ste_name: "IL",
  },
  {
    zip_code: "61419",

    ste_name: "IL",
  },
  {
    zip_code: "61452",

    ste_name: "IL",
  },
  {
    zip_code: "61476",

    ste_name: "IL",
  },
  {
    zip_code: "61490",

    ste_name: "IL",
  },
  {
    zip_code: "61539",

    ste_name: "IL",
  },
  {
    zip_code: "61569",

    ste_name: "IL",
  },
  {
    zip_code: "61572",

    ste_name: "IL",
  },
  {
    zip_code: "61740",

    ste_name: "IL",
  },
  {
    zip_code: "61853",

    ste_name: "IL",
  },
  {
    zip_code: "61870",

    ste_name: "IL",
  },
  {
    zip_code: "61928",

    ste_name: "IL",
  },
  {
    zip_code: "62236",

    ste_name: "IL",
  },
  {
    zip_code: "62242",

    ste_name: "IL",
  },
  {
    zip_code: "62330",

    ste_name: "IL",
  },
  {
    zip_code: "62417",

    ste_name: "IL",
  },
  {
    zip_code: "62419",

    ste_name: "IL",
  },
  {
    zip_code: "62458",

    ste_name: "IL",
  },
  {
    zip_code: "62460",

    ste_name: "IL",
  },
  {
    zip_code: "62546",

    ste_name: "IL",
  },
  {
    zip_code: "62611",

    ste_name: "IL",
  },
  {
    zip_code: "62626",

    ste_name: "IL",
  },
  {
    zip_code: "62634",

    ste_name: "IL",
  },
  {
    zip_code: "62655",

    ste_name: "IL",
  },
  {
    zip_code: "62671",

    ste_name: "IL",
  },
  {
    zip_code: "62677",

    ste_name: "IL",
  },
  {
    zip_code: "62688",

    ste_name: "IL",
  },
  {
    zip_code: "62819",

    ste_name: "IL",
  },
  {
    zip_code: "62881",

    ste_name: "IL",
  },
  {
    zip_code: "62889",

    ste_name: "IL",
  },
  {
    zip_code: "62924",

    ste_name: "IL",
  },
  {
    zip_code: "62983",

    ste_name: "IL",
  },
  {
    zip_code: "62985",

    ste_name: "IL",
  },
  {
    zip_code: "63037",

    ste_name: "MO",
  },
  {
    zip_code: "63119",

    ste_name: "MO",
  },
  {
    zip_code: "63137",

    ste_name: "MO",
  },
  {
    zip_code: "63369",

    ste_name: "MO",
  },
  {
    zip_code: "63382",

    ste_name: "MO",
  },
  {
    zip_code: "63385",

    ste_name: "MO",
  },
  {
    zip_code: "63653",

    ste_name: "MO",
  },
  {
    zip_code: "63744",

    ste_name: "MO",
  },
  {
    zip_code: "63746",

    ste_name: "MO",
  },
  {
    zip_code: "63771",

    ste_name: "MO",
  },
  {
    zip_code: "63863",

    ste_name: "MO",
  },
  {
    zip_code: "63965",

    ste_name: "MO",
  },
  {
    zip_code: "64101",

    ste_name: "MO",
  },
  {
    zip_code: "64427",

    ste_name: "MO",
  },
  {
    zip_code: "64479",

    ste_name: "MO",
  },
  {
    zip_code: "64658",

    ste_name: "MO",
  },
  {
    zip_code: "64740",

    ste_name: "MO",
  },
  {
    zip_code: "64841",

    ste_name: "MO",
  },
  {
    zip_code: "65020",

    ste_name: "MO",
  },
  {
    zip_code: "65034",

    ste_name: "MO",
  },
  {
    zip_code: "65035",

    ste_name: "MO",
  },
  {
    zip_code: "65053",

    ste_name: "MO",
  },
  {
    zip_code: "65275",

    ste_name: "MO",
  },
  {
    zip_code: "65351",

    ste_name: "MO",
  },
  {
    zip_code: "65440",

    ste_name: "MO",
  },
  {
    zip_code: "65627",

    ste_name: "MO",
  },
  {
    zip_code: "65638",

    ste_name: "MO",
  },
  {
    zip_code: "65649",

    ste_name: "MO",
  },
  {
    zip_code: "65689",

    ste_name: "MO",
  },
  {
    zip_code: "65752",

    ste_name: "MO",
  },
  {
    zip_code: "65766",

    ste_name: "MO",
  },
  {
    zip_code: "65786",

    ste_name: "MO",
  },
  {
    zip_code: "66209",

    ste_name: "KS",
  },
  {
    zip_code: "66422",

    ste_name: "KS",
  },
  {
    zip_code: "66527",

    ste_name: "KS",
  },
  {
    zip_code: "66611",

    ste_name: "KS",
  },
  {
    zip_code: "66612",

    ste_name: "KS",
  },
  {
    zip_code: "66736",

    ste_name: "KS",
  },
  {
    zip_code: "66772",

    ste_name: "KS",
  },
  {
    zip_code: "66778",

    ste_name: "KS",
  },
  {
    zip_code: "66833",

    ste_name: "KS",
  },
  {
    zip_code: "66856",

    ste_name: "KS",
  },
  {
    zip_code: "66861",

    ste_name: "KS",
  },
  {
    zip_code: "66952",

    ste_name: "KS",
  },
  {
    zip_code: "66963",

    ste_name: "KS",
  },
  {
    zip_code: "67104",

    ste_name: "KS",
  },
  {
    zip_code: "67149",

    ste_name: "KS",
  },
  {
    zip_code: "67208",

    ste_name: "KS",
  },
  {
    zip_code: "67219",

    ste_name: "KS",
  },
  {
    zip_code: "67223",

    ste_name: "KS",
  },
  {
    zip_code: "67427",

    ste_name: "KS",
  },
  {
    zip_code: "67441",

    ste_name: "KS",
  },
  {
    zip_code: "67545",

    ste_name: "KS",
  },
  {
    zip_code: "67664",

    ste_name: "KS",
  },
  {
    zip_code: "67669",

    ste_name: "KS",
  },
  {
    zip_code: "67853",

    ste_name: "KS",
  },
  {
    zip_code: "68005",

    ste_name: "NE",
  },
  {
    zip_code: "68017",

    ste_name: "NE",
  },
  {
    zip_code: "68048",

    ste_name: "NE",
  },
  {
    zip_code: "68073",

    ste_name: "NE",
  },
  {
    zip_code: "68102",

    ste_name: "NE",
  },
  {
    zip_code: "68135",

    ste_name: "NE",
  },
  {
    zip_code: "68331",

    ste_name: "NE",
  },
  {
    zip_code: "68402",

    ste_name: "NE",
  },
  {
    zip_code: "68644",

    ste_name: "NE",
  },
  {
    zip_code: "68666",

    ste_name: "NE",
  },
  {
    zip_code: "68831",

    ste_name: "NE",
  },
  {
    zip_code: "69043",

    ste_name: "NE",
  },
  {
    zip_code: "69143",

    ste_name: "NE",
  },
  {
    zip_code: "69168",

    ste_name: "NE",
  },
  {
    zip_code: "69334",

    ste_name: "NE",
  },
  {
    zip_code: "70047",

    ste_name: "LA",
  },
  {
    zip_code: "70094",

    ste_name: "LA",
  },
  {
    zip_code: "70163",

    ste_name: "LA",
  },
  {
    zip_code: "70355",

    ste_name: "LA",
  },
  {
    zip_code: "70607",

    ste_name: "LA",
  },
  {
    zip_code: "70770",

    ste_name: "LA",
  },
  {
    zip_code: "71018",

    ste_name: "LA",
  },
  {
    zip_code: "71060",

    ste_name: "LA",
  },
  {
    zip_code: "71071",

    ste_name: "LA",
  },
  {
    zip_code: "71225",

    ste_name: "LA",
  },
  {
    zip_code: "71264",

    ste_name: "LA",
  },
  {
    zip_code: "71346",

    ste_name: "LA",
  },
  {
    zip_code: "71367",

    ste_name: "LA",
  },
  {
    zip_code: "71461",

    ste_name: "LA",
  },
  {
    zip_code: "71647",

    ste_name: "AR",
  },
  {
    zip_code: "71752",

    ste_name: "AR",
  },
  {
    zip_code: "71759",

    ste_name: "AR",
  },
  {
    zip_code: "71857",

    ste_name: "AR",
  },
  {
    zip_code: "72315",

    ste_name: "AR",
  },
  {
    zip_code: "72331",

    ste_name: "AR",
  },
  {
    zip_code: "72428",

    ste_name: "AR",
  },
  {
    zip_code: "72436",

    ste_name: "AR",
  },
  {
    zip_code: "72543",

    ste_name: "AR",
  },
  {
    zip_code: "72569",

    ste_name: "AR",
  },
  {
    zip_code: "72802",

    ste_name: "AR",
  },
  {
    zip_code: "72949",

    ste_name: "AR",
  },
  {
    zip_code: "73064",

    ste_name: "OK",
  },
  {
    zip_code: "73128",

    ste_name: "OK",
  },
  {
    zip_code: "73145",

    ste_name: "OK",
  },
  {
    zip_code: "73162",

    ste_name: "OK",
  },
  {
    zip_code: "73438",

    ste_name: "OK",
  },
  {
    zip_code: "73537",

    ste_name: "OK",
  },
  {
    zip_code: "73562",

    ste_name: "OK",
  },
  {
    zip_code: "73571",

    ste_name: "OK",
  },
  {
    zip_code: "73601",

    ste_name: "OK",
  },
  {
    zip_code: "73646",

    ste_name: "OK",
  },
  {
    zip_code: "73661",

    ste_name: "OK",
  },
  {
    zip_code: "73720",

    ste_name: "OK",
  },
  {
    zip_code: "73832",

    ste_name: "OK",
  },
  {
    zip_code: "73835",

    ste_name: "OK",
  },
  {
    zip_code: "73855",

    ste_name: "OK",
  },
  {
    zip_code: "73932",

    ste_name: "OK",
  },
  {
    zip_code: "74041",

    ste_name: "OK",
  },
  {
    zip_code: "74051",

    ste_name: "OK",
  },
  {
    zip_code: "74107",

    ste_name: "OK",
  },
  {
    zip_code: "74441",

    ste_name: "OK",
  },
  {
    zip_code: "74521",

    ste_name: "OK",
  },
  {
    zip_code: "74644",

    ste_name: "OK",
  },
  {
    zip_code: "74826",

    ste_name: "OK",
  },
  {
    zip_code: "74865",

    ste_name: "OK",
  },
  {
    zip_code: "75022",

    ste_name: "TX",
  },
  {
    zip_code: "75057",

    ste_name: "TX",
  },
  {
    zip_code: "75071",

    ste_name: "TX",
  },
  {
    zip_code: "75087",

    ste_name: "TX",
  },
  {
    zip_code: "75089",

    ste_name: "TX",
  },
  {
    zip_code: "75114",

    ste_name: "TX",
  },
  {
    zip_code: "75117",

    ste_name: "TX",
  },
  {
    zip_code: "75157",

    ste_name: "TX",
  },
  {
    zip_code: "75211",

    ste_name: "TX",
  },
  {
    zip_code: "75214",

    ste_name: "TX",
  },
  {
    zip_code: "75232",

    ste_name: "TX",
  },
  {
    zip_code: "75233",

    ste_name: "TX",
  },
  {
    zip_code: "75253",

    ste_name: "TX",
  },
  {
    zip_code: "75432",

    ste_name: "TX",
  },
  {
    zip_code: "75437",

    ste_name: "TX",
  },
  {
    zip_code: "75474",

    ste_name: "TX",
  },
  {
    zip_code: "75503",

    ste_name: "TX",
  },
  {
    zip_code: "75838",

    ste_name: "TX",
  },
  {
    zip_code: "75948",

    ste_name: "TX",
  },
  {
    zip_code: "75964",

    ste_name: "TX",
  },
  {
    zip_code: "76265",

    ste_name: "TX",
  },
  {
    zip_code: "76472",

    ste_name: "TX",
  },
  {
    zip_code: "76537",

    ste_name: "TX",
  },
  {
    zip_code: "76565",

    ste_name: "TX",
  },
  {
    zip_code: "76566",

    ste_name: "TX",
  },
  {
    zip_code: "76573",

    ste_name: "TX",
  },
  {
    zip_code: "76574",

    ste_name: "TX",
  },
  {
    zip_code: "76579",

    ste_name: "TX",
  },
  {
    zip_code: "76637",

    ste_name: "TX",
  },
  {
    zip_code: "76645",

    ste_name: "TX",
  },
  {
    zip_code: "76657",

    ste_name: "TX",
  },
  {
    zip_code: "76679",

    ste_name: "TX",
  },
  {
    zip_code: "76685",

    ste_name: "TX",
  },
  {
    zip_code: "76873",

    ste_name: "TX",
  },
  {
    zip_code: "76935",

    ste_name: "TX",
  },
  {
    zip_code: "77029",

    ste_name: "TX",
  },
  {
    zip_code: "77037",

    ste_name: "TX",
  },
  {
    zip_code: "77075",

    ste_name: "TX",
  },
  {
    zip_code: "77078",

    ste_name: "TX",
  },
  {
    zip_code: "77092",

    ste_name: "TX",
  },
  {
    zip_code: "77331",

    ste_name: "TX",
  },
  {
    zip_code: "77342",

    ste_name: "TX",
  },
  {
    zip_code: "77368",

    ste_name: "TX",
  },
  {
    zip_code: "77466",

    ste_name: "TX",
  },
  {
    zip_code: "77480",

    ste_name: "TX",
  },
  {
    zip_code: "77484",

    ste_name: "TX",
  },
  {
    zip_code: "77503",

    ste_name: "TX",
  },
  {
    zip_code: "77536",

    ste_name: "TX",
  },
  {
    zip_code: "77563",

    ste_name: "TX",
  },
  {
    zip_code: "77837",

    ste_name: "TX",
  },
  {
    zip_code: "77993",

    ste_name: "TX",
  },
  {
    zip_code: "78014",

    ste_name: "TX",
  },
  {
    zip_code: "78072",

    ste_name: "TX",
  },
  {
    zip_code: "78102",

    ste_name: "TX",
  },
  {
    zip_code: "78253",

    ste_name: "TX",
  },
  {
    zip_code: "78387",

    ste_name: "TX",
  },
  {
    zip_code: "78570",

    ste_name: "TX",
  },
  {
    zip_code: "78584",

    ste_name: "TX",
  },
  {
    zip_code: "78652",

    ste_name: "TX",
  },
  {
    zip_code: "78705",

    ste_name: "TX",
  },
  {
    zip_code: "78759",

    ste_name: "TX",
  },
  {
    zip_code: "78830",

    ste_name: "TX",
  },
  {
    zip_code: "78834",

    ste_name: "TX",
  },
  {
    zip_code: "78886",

    ste_name: "TX",
  },
  {
    zip_code: "78962",

    ste_name: "TX",
  },
  {
    zip_code: "79051",

    ste_name: "TX",
  },
  {
    zip_code: "79081",

    ste_name: "TX",
  },
  {
    zip_code: "79086",

    ste_name: "TX",
  },
  {
    zip_code: "79095",

    ste_name: "TX",
  },
  {
    zip_code: "79119",

    ste_name: "TX",
  },
  {
    zip_code: "79226",

    ste_name: "TX",
  },
  {
    zip_code: "79371",

    ste_name: "TX",
  },
  {
    zip_code: "79403",

    ste_name: "TX",
  },
  {
    zip_code: "79423",

    ste_name: "TX",
  },
  {
    zip_code: "79501",

    ste_name: "TX",
  },
  {
    zip_code: "79506",

    ste_name: "TX",
  },
  {
    zip_code: "79518",

    ste_name: "TX",
  },
  {
    zip_code: "79763",

    ste_name: "TX",
  },
  {
    zip_code: "79765",

    ste_name: "TX",
  },
  {
    zip_code: "79938",

    ste_name: "TX",
  },
  {
    zip_code: "80015",

    ste_name: "CO",
  },
  {
    zip_code: "80236",

    ste_name: "CO",
  },
  {
    zip_code: "80468",

    ste_name: "CO",
  },
  {
    zip_code: "80513",

    ste_name: "CO",
  },
  {
    zip_code: "80514",

    ste_name: "CO",
  },
  {
    zip_code: "80549",

    ste_name: "CO",
  },
  {
    zip_code: "80726",

    ste_name: "CO",
  },
  {
    zip_code: "80737",

    ste_name: "CO",
  },
  {
    zip_code: "80907",

    ste_name: "CO",
  },
  {
    zip_code: "80920",

    ste_name: "CO",
  },
  {
    zip_code: "81030",

    ste_name: "CO",
  },
  {
    zip_code: "81039",

    ste_name: "CO",
  },
  {
    zip_code: "81067",

    ste_name: "CO",
  },
  {
    zip_code: "81133",

    ste_name: "CO",
  },
  {
    zip_code: "81224",

    ste_name: "CO",
  },
  {
    zip_code: "81301",

    ste_name: "CO",
  },
  {
    zip_code: "81418",

    ste_name: "CO",
  },
  {
    zip_code: "81433",

    ste_name: "CO",
  },
  {
    zip_code: "81523",

    ste_name: "CO",
  },
  {
    zip_code: "81624",

    ste_name: "CO",
  },
  {
    zip_code: "82070",

    ste_name: "WY",
  },
  {
    zip_code: "82512",

    ste_name: "WY",
  },
  {
    zip_code: "82636",

    ste_name: "WY",
  },
  {
    zip_code: "82727",

    ste_name: "WY",
  },
  {
    zip_code: "83314",

    ste_name: "ID",
  },
  {
    zip_code: "83348",

    ste_name: "ID",
  },
  {
    zip_code: "83450",

    ste_name: "ID",
  },
  {
    zip_code: "83549",

    ste_name: "ID",
  },
  {
    zip_code: "83654",

    ste_name: "ID",
  },
  {
    zip_code: "83705",

    ste_name: "ID",
  },
  {
    zip_code: "83835",

    ste_name: "ID",
  },
  {
    zip_code: "83852",

    ste_name: "ID",
  },
  {
    zip_code: "84065",

    ste_name: "UT",
  },
  {
    zip_code: "84081",

    ste_name: "UT",
  },
  {
    zip_code: "84117",

    ste_name: "UT",
  },
  {
    zip_code: "84119",

    ste_name: "UT",
  },
  {
    zip_code: "84180",

    ste_name: "UT",
  },
  {
    zip_code: "84332",

    ste_name: "UT",
  },
  {
    zip_code: "84518",

    ste_name: "UT",
  },
  {
    zip_code: "84604",

    ste_name: "UT",
  },
  {
    zip_code: "84628",

    ste_name: "UT",
  },
  {
    zip_code: "84638",

    ste_name: "UT",
  },
  {
    zip_code: "84645",

    ste_name: "UT",
  },
  {
    zip_code: "84732",

    ste_name: "UT",
  },
  {
    zip_code: "84740",

    ste_name: "UT",
  },
  {
    zip_code: "84753",

    ste_name: "UT",
  },
  {
    zip_code: "84781",

    ste_name: "UT",
  },
  {
    zip_code: "85140",

    ste_name: "AZ",
  },
  {
    zip_code: "85141",

    ste_name: "AZ",
  },
  {
    zip_code: "85142",

    ste_name: "AZ",
  },
  {
    zip_code: "85205",

    ste_name: "AZ",
  },
  {
    zip_code: "85250",

    ste_name: "AZ",
  },
  {
    zip_code: "85284",

    ste_name: "AZ",
  },
  {
    zip_code: "85286",

    ste_name: "AZ",
  },
  {
    zip_code: "85392",

    ste_name: "AZ",
  },
  {
    zip_code: "85395",

    ste_name: "AZ",
  },
  {
    zip_code: "85603",

    ste_name: "AZ",
  },
  {
    zip_code: "85613",

    ste_name: "AZ",
  },
  {
    zip_code: "85928",

    ste_name: "AZ",
  },
  {
    zip_code: "85929",

    ste_name: "AZ",
  },
  {
    zip_code: "85939",

    ste_name: "AZ",
  },
  {
    zip_code: "86035",

    ste_name: "AZ",
  },
  {
    zip_code: "86332",

    ste_name: "AZ",
  },
  {
    zip_code: "86438",

    ste_name: "AZ",
  },
  {
    zip_code: "87017",

    ste_name: "NM",
  },
  {
    zip_code: "87310",

    ste_name: "NM",
  },
  {
    zip_code: "87565",

    ste_name: "NM",
  },
  {
    zip_code: "87820",

    ste_name: "NM",
  },
  {
    zip_code: "87939",

    ste_name: "NM",
  },
  {
    zip_code: "88048",

    ste_name: "NM",
  },
  {
    zip_code: "88260",

    ste_name: "NM",
  },
  {
    zip_code: "88311",

    ste_name: "NM",
  },
  {
    zip_code: "89046",

    ste_name: "NV",
  },
  {
    zip_code: "89145",

    ste_name: "NV",
  },
  {
    zip_code: "89317",

    ste_name: "NV",
  },
  {
    zip_code: "89418",

    ste_name: "NV",
  },
  {
    zip_code: "89422",

    ste_name: "NV",
  },
  {
    zip_code: "89431",

    ste_name: "NV",
  },
  {
    zip_code: "89801",

    ste_name: "NV",
  },
  {
    zip_code: "602",

    ste_name: "PR",
  },
  {
    zip_code: "698",

    ste_name: "PR",
  },
  {
    zip_code: "707",

    ste_name: "PR",
  },
  {
    zip_code: "714",

    ste_name: "PR",
  },
  {
    zip_code: "715",

    ste_name: "PR",
  },
  {
    zip_code: "719",

    ste_name: "PR",
  },
  {
    zip_code: "927",

    ste_name: "PR",
  },
  {
    zip_code: "982",

    ste_name: "PR",
  },
  {
    zip_code: "1027",

    ste_name: "MA",
  },
  {
    zip_code: "1029",

    ste_name: "MA",
  },
  {
    zip_code: "1069",

    ste_name: "MA",
  },
  {
    zip_code: "1081",

    ste_name: "MA",
  },
  {
    zip_code: "1201",

    ste_name: "MA",
  },
  {
    zip_code: "1473",

    ste_name: "MA",
  },
  {
    zip_code: "1523",

    ste_name: "MA",
  },
  {
    zip_code: "1527",

    ste_name: "MA",
  },
  {
    zip_code: "1561",

    ste_name: "MA",
  },
  {
    zip_code: "1701",

    ste_name: "MA",
  },
  {
    zip_code: "1860",

    ste_name: "MA",
  },
  {
    zip_code: "2032",

    ste_name: "MA",
  },
  {
    zip_code: "2460",

    ste_name: "MA",
  },
  {
    zip_code: "2543",

    ste_name: "MA",
  },
  {
    zip_code: "2779",

    ste_name: "MA",
  },
  {
    zip_code: "2809",

    ste_name: "RI",
  },
  {
    zip_code: "2860",

    ste_name: "RI",
  },
  {
    zip_code: "3053",

    ste_name: "NH",
  },
  {
    zip_code: "3234",

    ste_name: "NH",
  },
  {
    zip_code: "3291",

    ste_name: "NH",
  },
  {
    zip_code: "3588",

    ste_name: "NH",
  },
  {
    zip_code: "3743",

    ste_name: "NH",
  },
  {
    zip_code: "3754",

    ste_name: "NH",
  },
  {
    zip_code: "3774",

    ste_name: "NH",
  },
  {
    zip_code: "3780",

    ste_name: "NH",
  },
  {
    zip_code: "3838",

    ste_name: "NH",
  },
  {
    zip_code: "3886",

    ste_name: "NH",
  },
  {
    zip_code: "4043",

    ste_name: "ME",
  },
  {
    zip_code: "4063",

    ste_name: "ME",
  },
  {
    zip_code: "4087",

    ste_name: "ME",
  },
  {
    zip_code: "4092",

    ste_name: "ME",
  },
  {
    zip_code: "4097",

    ste_name: "ME",
  },
  {
    zip_code: "4224",

    ste_name: "ME",
  },
  {
    zip_code: "4254",

    ste_name: "ME",
  },
  {
    zip_code: "4259",

    ste_name: "ME",
  },
  {
    zip_code: "4289",

    ste_name: "ME",
  },
  {
    zip_code: "4359",

    ste_name: "ME",
  },
  {
    zip_code: "4431",

    ste_name: "ME",
  },
  {
    zip_code: "4442",

    ste_name: "ME",
  },
  {
    zip_code: "4779",

    ste_name: "ME",
  },
  {
    zip_code: "4780",

    ste_name: "ME",
  },
  {
    zip_code: "4922",

    ste_name: "ME",
  },
  {
    zip_code: "4938",

    ste_name: "ME",
  },
  {
    zip_code: "4967",

    ste_name: "ME",
  },
  {
    zip_code: "4989",

    ste_name: "ME",
  },
  {
    zip_code: "5058",

    ste_name: "VT",
  },
  {
    zip_code: "5060",

    ste_name: "VT",
  },
  {
    zip_code: "5076",

    ste_name: "VT",
  },
  {
    zip_code: "5079",

    ste_name: "VT",
  },
  {
    zip_code: "5486",

    ste_name: "VT",
  },
  {
    zip_code: "5652",

    ste_name: "VT",
  },
  {
    zip_code: "5757",

    ste_name: "VT",
  },
  {
    zip_code: "5860",

    ste_name: "VT",
  },
  {
    zip_code: "6068",

    ste_name: "CT",
  },
  {
    zip_code: "6278",

    ste_name: "CT",
  },
  {
    zip_code: "6279",

    ste_name: "CT",
  },
  {
    zip_code: "6424",

    ste_name: "CT",
  },
  {
    zip_code: "6442",

    ste_name: "CT",
  },
  {
    zip_code: "6460",

    ste_name: "CT",
  },
  {
    zip_code: "6512",

    ste_name: "CT",
  },
  {
    zip_code: "6804",

    ste_name: "CT",
  },
  {
    zip_code: "6807",

    ste_name: "CT",
  },
  {
    zip_code: "6880",

    ste_name: "CT",
  },
  {
    zip_code: "7021",

    ste_name: "NJ",
  },
  {
    zip_code: "7023",

    ste_name: "NJ",
  },
  {
    zip_code: "7050",

    ste_name: "NJ",
  },
  {
    zip_code: "7109",

    ste_name: "NJ",
  },
  {
    zip_code: "7201",

    ste_name: "NJ",
  },
  {
    zip_code: "7439",

    ste_name: "NJ",
  },
  {
    zip_code: "7603",

    ste_name: "NJ",
  },
  {
    zip_code: "7748",

    ste_name: "NJ",
  },
  {
    zip_code: "7857",

    ste_name: "NJ",
  },
  {
    zip_code: "7921",

    ste_name: "NJ",
  },
  {
    zip_code: "8010",

    ste_name: "NJ",
  },
  {
    zip_code: "8031",

    ste_name: "NJ",
  },
  {
    zip_code: "8074",

    ste_name: "NJ",
  },
  {
    zip_code: "8077",

    ste_name: "NJ",
  },
  {
    zip_code: "8086",

    ste_name: "NJ",
  },
  {
    zip_code: "8108",

    ste_name: "NJ",
  },
  {
    zip_code: "8240",

    ste_name: "NJ",
  },
  {
    zip_code: "8510",

    ste_name: "NJ",
  },
  {
    zip_code: "8805",

    ste_name: "NJ",
  },
  {
    zip_code: "8831",

    ste_name: "NJ",
  },
  {
    zip_code: "8890",

    ste_name: "NJ",
  },
  {
    zip_code: "10465",

    ste_name: "NY",
  },
  {
    zip_code: "10504",

    ste_name: "NY",
  },
  {
    zip_code: "10512",

    ste_name: "NY",
  },
  {
    zip_code: "10590",

    ste_name: "NY",
  },
  {
    zip_code: "10701",

    ste_name: "NY",
  },
  {
    zip_code: "10804",

    ste_name: "NY",
  },
  {
    zip_code: "10976",

    ste_name: "NY",
  },
  {
    zip_code: "11004",

    ste_name: "NY",
  },
  {
    zip_code: "11106",

    ste_name: "NY",
  },
  {
    zip_code: "11218",

    ste_name: "NY",
  },
  {
    zip_code: "11426",

    ste_name: "NY",
  },
  {
    zip_code: "12010",

    ste_name: "NY",
  },
  {
    zip_code: "12067",

    ste_name: "NY",
  },
  {
    zip_code: "12075",

    ste_name: "NY",
  },
  {
    zip_code: "12086",

    ste_name: "NY",
  },
  {
    zip_code: "12132",

    ste_name: "NY",
  },
  {
    zip_code: "12148",

    ste_name: "NY",
  },
  {
    zip_code: "12175",

    ste_name: "NY",
  },
  {
    zip_code: "12460",

    ste_name: "NY",
  },
  {
    zip_code: "12524",

    ste_name: "NY",
  },
  {
    zip_code: "12529",

    ste_name: "NY",
  },
  {
    zip_code: "12577",

    ste_name: "NY",
  },
  {
    zip_code: "12771",

    ste_name: "NY",
  },
  {
    zip_code: "12815",

    ste_name: "NY",
  },
  {
    zip_code: "12816",

    ste_name: "NY",
  },
  {
    zip_code: "12817",

    ste_name: "NY",
  },
  {
    zip_code: "12838",

    ste_name: "NY",
  },
  {
    zip_code: "12851",

    ste_name: "NY",
  },
  {
    zip_code: "12916",

    ste_name: "NY",
  },
  {
    zip_code: "12918",

    ste_name: "NY",
  },
  {
    zip_code: "12919",

    ste_name: "NY",
  },
  {
    zip_code: "12945",

    ste_name: "NY",
  },
  {
    zip_code: "13031",

    ste_name: "NY",
  },
  {
    zip_code: "13042",

    ste_name: "NY",
  },
  {
    zip_code: "13062",

    ste_name: "NY",
  },
  {
    zip_code: "13071",

    ste_name: "NY",
  },
  {
    zip_code: "13092",

    ste_name: "NY",
  },
  {
    zip_code: "13120",

    ste_name: "NY",
  },
  {
    zip_code: "13132",

    ste_name: "NY",
  },
  {
    zip_code: "13320",

    ste_name: "NY",
  },
  {
    zip_code: "13348",

    ste_name: "NY",
  },
  {
    zip_code: "13425",

    ste_name: "NY",
  },
  {
    zip_code: "13454",

    ste_name: "NY",
  },
  {
    zip_code: "13477",

    ste_name: "NY",
  },
  {
    zip_code: "13605",

    ste_name: "NY",
  },
  {
    zip_code: "13607",

    ste_name: "NY",
  },
  {
    zip_code: "13774",

    ste_name: "NY",
  },
  {
    zip_code: "13815",

    ste_name: "NY",
  },
  {
    zip_code: "13844",

    ste_name: "NY",
  },
  {
    zip_code: "13856",

    ste_name: "NY",
  },
  {
    zip_code: "14025",

    ste_name: "NY",
  },
  {
    zip_code: "14072",

    ste_name: "NY",
  },
  {
    zip_code: "14170",

    ste_name: "NY",
  },
  {
    zip_code: "14467",

    ste_name: "NY",
  },
  {
    zip_code: "14487",

    ste_name: "NY",
  },
  {
    zip_code: "14568",

    ste_name: "NY",
  },
  {
    zip_code: "14719",

    ste_name: "NY",
  },
  {
    zip_code: "14737",

    ste_name: "NY",
  },
  {
    zip_code: "14747",

    ste_name: "NY",
  },
  {
    zip_code: "14877",

    ste_name: "NY",
  },
  {
    zip_code: "15021",

    ste_name: "PA",
  },
  {
    zip_code: "15027",

    ste_name: "PA",
  },
  {
    zip_code: "15061",

    ste_name: "PA",
  },
  {
    zip_code: "15144",

    ste_name: "PA",
  },
  {
    zip_code: "15146",

    ste_name: "PA",
  },
  {
    zip_code: "15232",

    ste_name: "PA",
  },
  {
    zip_code: "15350",

    ste_name: "PA",
  },
  {
    zip_code: "15353",

    ste_name: "PA",
  },
  {
    zip_code: "15617",

    ste_name: "PA",
  },
  {
    zip_code: "15644",

    ste_name: "PA",
  },
  {
    zip_code: "15713",

    ste_name: "PA",
  },
  {
    zip_code: "15748",

    ste_name: "PA",
  },
  {
    zip_code: "15773",

    ste_name: "PA",
  },
  {
    zip_code: "15778",

    ste_name: "PA",
  },
  {
    zip_code: "15783",

    ste_name: "PA",
  },
  {
    zip_code: "15924",

    ste_name: "PA",
  },
  {
    zip_code: "15925",

    ste_name: "PA",
  },
  {
    zip_code: "15935",

    ste_name: "PA",
  },
  {
    zip_code: "16025",

    ste_name: "PA",
  },
  {
    zip_code: "16041",

    ste_name: "PA",
  },
  {
    zip_code: "16117",

    ste_name: "PA",
  },
  {
    zip_code: "16235",

    ste_name: "PA",
  },
  {
    zip_code: "16311",

    ste_name: "PA",
  },
  {
    zip_code: "16350",

    ste_name: "PA",
  },
  {
    zip_code: "16444",

    ste_name: "PA",
  },
  {
    zip_code: "16634",

    ste_name: "PA",
  },
  {
    zip_code: "16652",

    ste_name: "PA",
  },
  {
    zip_code: "16659",

    ste_name: "PA",
  },
  {
    zip_code: "16662",

    ste_name: "PA",
  },
  {
    zip_code: "16901",

    ste_name: "PA",
  },
  {
    zip_code: "17018",

    ste_name: "PA",
  },
  {
    zip_code: "17046",

    ste_name: "PA",
  },
  {
    zip_code: "17059",

    ste_name: "PA",
  },
  {
    zip_code: "17213",

    ste_name: "PA",
  },
  {
    zip_code: "17215",

    ste_name: "PA",
  },
  {
    zip_code: "17322",

    ste_name: "PA",
  },
  {
    zip_code: "17327",

    ste_name: "PA",
  },
  {
    zip_code: "17362",

    ste_name: "PA",
  },
  {
    zip_code: "17841",

    ste_name: "PA",
  },
  {
    zip_code: "17859",

    ste_name: "PA",
  },
  {
    zip_code: "17957",

    ste_name: "PA",
  },
  {
    zip_code: "17959",

    ste_name: "PA",
  },
  {
    zip_code: "17970",

    ste_name: "PA",
  },
  {
    zip_code: "17978",

    ste_name: "PA",
  },
  {
    zip_code: "18077",

    ste_name: "PA",
  },
  {
    zip_code: "18091",

    ste_name: "PA",
  },
  {
    zip_code: "18218",

    ste_name: "PA",
  },
  {
    zip_code: "18335",

    ste_name: "PA",
  },
  {
    zip_code: "18340",

    ste_name: "PA",
  },
  {
    zip_code: "18452",

    ste_name: "PA",
  },
  {
    zip_code: "18518",

    ste_name: "PA",
  },
  {
    zip_code: "18660",

    ste_name: "PA",
  },
  {
    zip_code: "18704",

    ste_name: "PA",
  },
  {
    zip_code: "18846",

    ste_name: "PA",
  },
  {
    zip_code: "19030",

    ste_name: "PA",
  },
  {
    zip_code: "19041",

    ste_name: "PA",
  },
  {
    zip_code: "19054",

    ste_name: "PA",
  },
  {
    zip_code: "19064",

    ste_name: "PA",
  },
  {
    zip_code: "19116",

    ste_name: "PA",
  },
  {
    zip_code: "19311",

    ste_name: "PA",
  },
  {
    zip_code: "19350",

    ste_name: "PA",
  },
  {
    zip_code: "19533",

    ste_name: "PA",
  },
  {
    zip_code: "19550",

    ste_name: "PA",
  },
  {
    zip_code: "19611",

    ste_name: "PA",
  },
  {
    zip_code: "19703",

    ste_name: "DE",
  },
  {
    zip_code: "19904",

    ste_name: "DE",
  },
  {
    zip_code: "19943",

    ste_name: "DE",
  },
  {
    zip_code: "19952",

    ste_name: "DE",
  },
  {
    zip_code: "19966",

    ste_name: "DE",
  },
  {
    zip_code: "20010",

    ste_name: "DC",
  },
  {
    zip_code: "20011",

    ste_name: "DC",
  },
  {
    zip_code: "20151",

    ste_name: "VA",
  },
  {
    zip_code: "20191",

    ste_name: "VA",
  },
  {
    zip_code: "20616",

    ste_name: "MD",
  },
  {
    zip_code: "20759",

    ste_name: "MD",
  },
  {
    zip_code: "20778",

    ste_name: "MD",
  },
  {
    zip_code: "20815",

    ste_name: "MD",
  },
  {
    zip_code: "20839",

    ste_name: "MD",
  },
  {
    zip_code: "20862",

    ste_name: "MD",
  },
  {
    zip_code: "20910",

    ste_name: "MD",
  },
  {
    zip_code: "21132",

    ste_name: "MD",
  },
  {
    zip_code: "21521",

    ste_name: "MD",
  },
  {
    zip_code: "21541",

    ste_name: "MD",
  },
  {
    zip_code: "21622",

    ste_name: "MD",
  },
  {
    zip_code: "21638",

    ste_name: "MD",
  },
  {
    zip_code: "21643",

    ste_name: "MD",
  },
  {
    zip_code: "21650",

    ste_name: "MD",
  },
  {
    zip_code: "21668",

    ste_name: "MD",
  },
  {
    zip_code: "21678",

    ste_name: "MD",
  },
  {
    zip_code: "21740",

    ste_name: "MD",
  },
  {
    zip_code: "21842",

    ste_name: "MD",
  },
  {
    zip_code: "21912",

    ste_name: "MD",
  },
  {
    zip_code: "21930",

    ste_name: "MD",
  },
  {
    zip_code: "22033",

    ste_name: "VA",
  },
  {
    zip_code: "22102",

    ste_name: "VA",
  },
  {
    zip_code: "22182",

    ste_name: "VA",
  },
  {
    zip_code: "22488",

    ste_name: "VA",
  },
  {
    zip_code: "22529",

    ste_name: "VA",
  },
  {
    zip_code: "22644",

    ste_name: "VA",
  },
  {
    zip_code: "22726",

    ste_name: "VA",
  },
  {
    zip_code: "22743",

    ste_name: "VA",
  },
  {
    zip_code: "22802",

    ste_name: "VA",
  },
  {
    zip_code: "22812",

    ste_name: "VA",
  },
  {
    zip_code: "23065",

    ste_name: "VA",
  },
  {
    zip_code: "23083",

    ste_name: "VA",
  },
  {
    zip_code: "23125",

    ste_name: "VA",
  },
  {
    zip_code: "23238",

    ste_name: "VA",
  },
  {
    zip_code: "23302",

    ste_name: "VA",
  },
  {
    zip_code: "23316",

    ste_name: "VA",
  },
  {
    zip_code: "23357",

    ste_name: "VA",
  },
  {
    zip_code: "23433",

    ste_name: "VA",
  },
  {
    zip_code: "23436",

    ste_name: "VA",
  },
  {
    zip_code: "23459",

    ste_name: "VA",
  },
  {
    zip_code: "23874",

    ste_name: "VA",
  },
  {
    zip_code: "23885",

    ste_name: "VA",
  },
  {
    zip_code: "23952",

    ste_name: "VA",
  },
  {
    zip_code: "23963",

    ste_name: "VA",
  },
  {
    zip_code: "24150",

    ste_name: "VA",
  },
  {
    zip_code: "24250",

    ste_name: "VA",
  },
  {
    zip_code: "24301",

    ste_name: "VA",
  },
  {
    zip_code: "24351",

    ste_name: "VA",
  },
  {
    zip_code: "24431",

    ste_name: "VA",
  },
  {
    zip_code: "24450",

    ste_name: "VA",
  },
  {
    zip_code: "24579",

    ste_name: "VA",
  },
  {
    zip_code: "24599",

    ste_name: "VA",
  },
  {
    zip_code: "24620",

    ste_name: "VA",
  },
  {
    zip_code: "24731",

    ste_name: "WV",
  },
  {
    zip_code: "24828",

    ste_name: "WV",
  },
  {
    zip_code: "24845",

    ste_name: "WV",
  },
  {
    zip_code: "24887",

    ste_name: "WV",
  },
  {
    zip_code: "25036",

    ste_name: "WV",
  },
  {
    zip_code: "25054",

    ste_name: "WV",
  },
  {
    zip_code: "25114",

    ste_name: "WV",
  },
  {
    zip_code: "25275",

    ste_name: "WV",
  },
  {
    zip_code: "25286",

    ste_name: "WV",
  },
  {
    zip_code: "25404",

    ste_name: "WV",
  },
  {
    zip_code: "25565",

    ste_name: "WV",
  },
  {
    zip_code: "25669",

    ste_name: "WV",
  },
  {
    zip_code: "25845",

    ste_name: "WV",
  },
  {
    zip_code: "25878",

    ste_name: "WV",
  },
  {
    zip_code: "25936",

    ste_name: "WV",
  },
  {
    zip_code: "26034",

    ste_name: "WV",
  },
  {
    zip_code: "26036",

    ste_name: "WV",
  },
  {
    zip_code: "26181",

    ste_name: "WV",
  },
  {
    zip_code: "26301",

    ste_name: "WV",
  },
  {
    zip_code: "26321",

    ste_name: "WV",
  },
  {
    zip_code: "26404",

    ste_name: "WV",
  },
  {
    zip_code: "26436",

    ste_name: "WV",
  },
  {
    zip_code: "26456",

    ste_name: "WV",
  },
  {
    zip_code: "26802",

    ste_name: "WV",
  },
  {
    zip_code: "26884",

    ste_name: "WV",
  },
  {
    zip_code: "27006",

    ste_name: "NC",
  },
  {
    zip_code: "27403",

    ste_name: "NC",
  },
  {
    zip_code: "27864",

    ste_name: "NC",
  },
  {
    zip_code: "27889",

    ste_name: "NC",
  },
  {
    zip_code: "27958",

    ste_name: "NC",
  },
  {
    zip_code: "27986",

    ste_name: "NC",
  },
  {
    zip_code: "28007",

    ste_name: "NC",
  },
  {
    zip_code: "28114",

    ste_name: "NC",
  },
  {
    zip_code: "28344",

    ste_name: "NC",
  },
  {
    zip_code: "28533",

    ste_name: "NC",
  },
  {
    zip_code: "28589",

    ste_name: "NC",
  },
  {
    zip_code: "28602",

    ste_name: "NC",
  },
  {
    zip_code: "28613",

    ste_name: "NC",
  },
  {
    zip_code: "28649",

    ste_name: "NC",
  },
  {
    zip_code: "28654",

    ste_name: "NC",
  },
  {
    zip_code: "28658",

    ste_name: "NC",
  },
  {
    zip_code: "28665",

    ste_name: "NC",
  },
  {
    zip_code: "28749",

    ste_name: "NC",
  },
  {
    zip_code: "28752",

    ste_name: "NC",
  },
  {
    zip_code: "28759",

    ste_name: "NC",
  },
  {
    zip_code: "28783",

    ste_name: "NC",
  },
  {
    zip_code: "29051",

    ste_name: "SC",
  },
  {
    zip_code: "29054",

    ste_name: "SC",
  },
  {
    zip_code: "29115",

    ste_name: "SC",
  },
  {
    zip_code: "29204",

    ste_name: "SC",
  },
  {
    zip_code: "29373",

    ste_name: "SC",
  },
  {
    zip_code: "29405",

    ste_name: "SC",
  },
  {
    zip_code: "29510",

    ste_name: "SC",
  },
  {
    zip_code: "29532",

    ste_name: "SC",
  },
  {
    zip_code: "29544",

    ste_name: "SC",
  },
  {
    zip_code: "29574",

    ste_name: "SC",
  },
  {
    zip_code: "29654",

    ste_name: "SC",
  },
  {
    zip_code: "29704",

    ste_name: "SC",
  },
  {
    zip_code: "29844",

    ste_name: "SC",
  },
  {
    zip_code: "29916",

    ste_name: "SC",
  },
  {
    zip_code: "29926",

    ste_name: "SC",
  },
  {
    zip_code: "30139",

    ste_name: "GA",
  },
  {
    zip_code: "30171",

    ste_name: "GA",
  },
  {
    zip_code: "30177",

    ste_name: "GA",
  },
  {
    zip_code: "30189",

    ste_name: "GA",
  },
  {
    zip_code: "30273",

    ste_name: "GA",
  },
  {
    zip_code: "30295",

    ste_name: "GA",
  },
  {
    zip_code: "30448",

    ste_name: "GA",
  },
  {
    zip_code: "30461",

    ste_name: "GA",
  },
  {
    zip_code: "30474",

    ste_name: "GA",
  },
  {
    zip_code: "30543",

    ste_name: "GA",
  },
  {
    zip_code: "30677",

    ste_name: "GA",
  },
  {
    zip_code: "30751",

    ste_name: "GA",
  },
  {
    zip_code: "30809",

    ste_name: "GA",
  },
  {
    zip_code: "58783",

    ste_name: "ND",
  },
  {
    zip_code: "58844",

    ste_name: "ND",
  },
  {
    zip_code: "59019",

    ste_name: "MT",
  },
  {
    zip_code: "59022",

    ste_name: "MT",
  },
  {
    zip_code: "59069",

    ste_name: "MT",
  },
  {
    zip_code: "59301",

    ste_name: "MT",
  },
  {
    zip_code: "59332",

    ste_name: "MT",
  },
  {
    zip_code: "59477",

    ste_name: "MT",
  },
  {
    zip_code: "59524",

    ste_name: "MT",
  },
  {
    zip_code: "59529",

    ste_name: "MT",
  },
  {
    zip_code: "59643",

    ste_name: "MT",
  },
  {
    zip_code: "59733",

    ste_name: "MT",
  },
  {
    zip_code: "59755",

    ste_name: "MT",
  },
  {
    zip_code: "59856",

    ste_name: "MT",
  },
  {
    zip_code: "59912",

    ste_name: "MT",
  },
  {
    zip_code: "60081",

    ste_name: "IL",
  },
  {
    zip_code: "60108",

    ste_name: "IL",
  },
  {
    zip_code: "60136",

    ste_name: "IL",
  },
  {
    zip_code: "60187",

    ste_name: "IL",
  },
  {
    zip_code: "60444",

    ste_name: "IL",
  },
  {
    zip_code: "60447",

    ste_name: "IL",
  },
  {
    zip_code: "60448",

    ste_name: "IL",
  },
  {
    zip_code: "60510",

    ste_name: "IL",
  },
  {
    zip_code: "60512",

    ste_name: "IL",
  },
  {
    zip_code: "60532",

    ste_name: "IL",
  },
  {
    zip_code: "60555",

    ste_name: "IL",
  },
  {
    zip_code: "60586",

    ste_name: "IL",
  },
  {
    zip_code: "60614",

    ste_name: "IL",
  },
  {
    zip_code: "60618",

    ste_name: "IL",
  },
  {
    zip_code: "60633",

    ste_name: "IL",
  },
  {
    zip_code: "60642",

    ste_name: "IL",
  },
  {
    zip_code: "60928",

    ste_name: "IL",
  },
  {
    zip_code: "61039",

    ste_name: "IL",
  },
  {
    zip_code: "61042",

    ste_name: "IL",
  },
  {
    zip_code: "61059",

    ste_name: "IL",
  },
  {
    zip_code: "61091",

    ste_name: "IL",
  },
  {
    zip_code: "61259",

    ste_name: "IL",
  },
  {
    zip_code: "61282",

    ste_name: "IL",
  },
  {
    zip_code: "61325",

    ste_name: "IL",
  },
  {
    zip_code: "61329",

    ste_name: "IL",
  },
  {
    zip_code: "61460",

    ste_name: "IL",
  },
  {
    zip_code: "61469",

    ste_name: "IL",
  },
  {
    zip_code: "61477",

    ste_name: "IL",
  },
  {
    zip_code: "61724",

    ste_name: "IL",
  },
  {
    zip_code: "61736",

    ste_name: "IL",
  },
  {
    zip_code: "61764",

    ste_name: "IL",
  },
  {
    zip_code: "61851",

    ste_name: "IL",
  },
  {
    zip_code: "62223",

    ste_name: "IL",
  },
  {
    zip_code: "62253",

    ste_name: "IL",
  },
  {
    zip_code: "62255",

    ste_name: "IL",
  },
  {
    zip_code: "62262",

    ste_name: "IL",
  },
  {
    zip_code: "62341",

    ste_name: "IL",
  },
  {
    zip_code: "62343",

    ste_name: "IL",
  },
  {
    zip_code: "62422",

    ste_name: "IL",
  },
  {
    zip_code: "62431",

    ste_name: "IL",
  },
  {
    zip_code: "62438",

    ste_name: "IL",
  },
  {
    zip_code: "62454",

    ste_name: "IL",
  },
  {
    zip_code: "62532",

    ste_name: "IL",
  },
  {
    zip_code: "62556",

    ste_name: "IL",
  },
  {
    zip_code: "62571",

    ste_name: "IL",
  },
  {
    zip_code: "62958",

    ste_name: "IL",
  },
  {
    zip_code: "62988",

    ste_name: "IL",
  },
  {
    zip_code: "63015",

    ste_name: "MO",
  },
  {
    zip_code: "63069",

    ste_name: "MO",
  },
  {
    zip_code: "63101",

    ste_name: "MO",
  },
  {
    zip_code: "63432",

    ste_name: "MO",
  },
  {
    zip_code: "63530",

    ste_name: "MO",
  },
  {
    zip_code: "63624",

    ste_name: "MO",
  },
  {
    zip_code: "63648",

    ste_name: "MO",
  },
  {
    zip_code: "63665",

    ste_name: "MO",
  },
  {
    zip_code: "63673",

    ste_name: "MO",
  },
  {
    zip_code: "63743",

    ste_name: "MO",
  },
  {
    zip_code: "63755",

    ste_name: "MO",
  },
  {
    zip_code: "63781",

    ste_name: "MO",
  },
  {
    zip_code: "63940",

    ste_name: "MO",
  },
  {
    zip_code: "64040",

    ste_name: "MO",
  },
  {
    zip_code: "64092",

    ste_name: "MO",
  },
  {
    zip_code: "64114",

    ste_name: "MO",
  },
  {
    zip_code: "64153",

    ste_name: "MO",
  },
  {
    zip_code: "64166",

    ste_name: "MO",
  },
  {
    zip_code: "64637",

    ste_name: "MO",
  },
  {
    zip_code: "64639",

    ste_name: "MO",
  },
  {
    zip_code: "64683",

    ste_name: "MO",
  },
  {
    zip_code: "64745",

    ste_name: "MO",
  },
  {
    zip_code: "64756",

    ste_name: "MO",
  },
  {
    zip_code: "64854",

    ste_name: "MO",
  },
  {
    zip_code: "65014",

    ste_name: "MO",
  },
  {
    zip_code: "65062",

    ste_name: "MO",
  },
  {
    zip_code: "65076",

    ste_name: "MO",
  },
  {
    zip_code: "65202",

    ste_name: "MO",
  },
  {
    zip_code: "65265",

    ste_name: "MO",
  },
  {
    zip_code: "65280",

    ste_name: "MO",
  },
  {
    zip_code: "65340",

    ste_name: "MO",
  },
  {
    zip_code: "65456",

    ste_name: "MO",
  },
  {
    zip_code: "65483",

    ste_name: "MO",
  },
  {
    zip_code: "65637",

    ste_name: "MO",
  },
  {
    zip_code: "65654",

    ste_name: "MO",
  },
  {
    zip_code: "65663",

    ste_name: "MO",
  },
  {
    zip_code: "65728",

    ste_name: "MO",
  },
  {
    zip_code: "65735",

    ste_name: "MO",
  },
  {
    zip_code: "65754",

    ste_name: "MO",
  },
  {
    zip_code: "65793",

    ste_name: "MO",
  },
  {
    zip_code: "65809",

    ste_name: "MO",
  },
  {
    zip_code: "66010",

    ste_name: "KS",
  },
  {
    zip_code: "66013",

    ste_name: "KS",
  },
  {
    zip_code: "66035",

    ste_name: "KS",
  },
  {
    zip_code: "66072",

    ste_name: "KS",
  },
  {
    zip_code: "66085",

    ste_name: "KS",
  },
  {
    zip_code: "66088",

    ste_name: "KS",
  },
  {
    zip_code: "66216",

    ste_name: "KS",
  },
  {
    zip_code: "66406",

    ste_name: "KS",
  },
  {
    zip_code: "66413",

    ste_name: "KS",
  },
  {
    zip_code: "66425",

    ste_name: "KS",
  },
  {
    zip_code: "66441",

    ste_name: "KS",
  },
  {
    zip_code: "66523",

    ste_name: "KS",
  },
  {
    zip_code: "66533",

    ste_name: "KS",
  },
  {
    zip_code: "66711",

    ste_name: "KS",
  },
  {
    zip_code: "66740",

    ste_name: "KS",
  },
  {
    zip_code: "66755",

    ste_name: "KS",
  },
  {
    zip_code: "66834",

    ste_name: "KS",
  },
  {
    zip_code: "66843",

    ste_name: "KS",
  },
  {
    zip_code: "66849",

    ste_name: "KS",
  },
  {
    zip_code: "66865",

    ste_name: "KS",
  },
  {
    zip_code: "66939",

    ste_name: "KS",
  },
  {
    zip_code: "67001",

    ste_name: "KS",
  },
  {
    zip_code: "67022",

    ste_name: "KS",
  },
  {
    zip_code: "67070",

    ste_name: "KS",
  },
  {
    zip_code: "67134",

    ste_name: "KS",
  },
  {
    zip_code: "67143",

    ste_name: "KS",
  },
  {
    zip_code: "67355",

    ste_name: "KS",
  },
  {
    zip_code: "67420",

    ste_name: "KS",
  },
  {
    zip_code: "67450",

    ste_name: "KS",
  },
  {
    zip_code: "67464",

    ste_name: "KS",
  },
  {
    zip_code: "67483",

    ste_name: "KS",
  },
  {
    zip_code: "67485",

    ste_name: "KS",
  },
  {
    zip_code: "67521",

    ste_name: "KS",
  },
  {
    zip_code: "67556",

    ste_name: "KS",
  },
  {
    zip_code: "67581",

    ste_name: "KS",
  },
  {
    zip_code: "67672",

    ste_name: "KS",
  },
  {
    zip_code: "67841",

    ste_name: "KS",
  },
  {
    zip_code: "67859",

    ste_name: "KS",
  },
  {
    zip_code: "68018",

    ste_name: "NE",
  },
  {
    zip_code: "68324",

    ste_name: "NE",
  },
  {
    zip_code: "68345",

    ste_name: "NE",
  },
  {
    zip_code: "68428",

    ste_name: "NE",
  },
  {
    zip_code: "68454",

    ste_name: "NE",
  },
  {
    zip_code: "68532",

    ste_name: "NE",
  },
  {
    zip_code: "68601",

    ste_name: "NE",
  },
  {
    zip_code: "68627",

    ste_name: "NE",
  },
  {
    zip_code: "68629",

    ste_name: "NE",
  },
  {
    zip_code: "68638",

    ste_name: "NE",
  },
  {
    zip_code: "68751",

    ste_name: "NE",
  },
  {
    zip_code: "68815",

    ste_name: "NE",
  },
  {
    zip_code: "68869",

    ste_name: "NE",
  },
  {
    zip_code: "69032",

    ste_name: "NE",
  },
  {
    zip_code: "69037",

    ste_name: "NE",
  },
  {
    zip_code: "69044",

    ste_name: "NE",
  },
  {
    zip_code: "69132",

    ste_name: "NE",
  },
  {
    zip_code: "69171",

    ste_name: "NE",
  },
  {
    zip_code: "69341",

    ste_name: "NE",
  },
  {
    zip_code: "70057",

    ste_name: "LA",
  },
  {
    zip_code: "70112",

    ste_name: "LA",
  },
  {
    zip_code: "70395",

    ste_name: "LA",
  },
  {
    zip_code: "70397",

    ste_name: "LA",
  },
  {
    zip_code: "70401",

    ste_name: "LA",
  },
  {
    zip_code: "70454",

    ste_name: "LA",
  },
  {
    zip_code: "70563",

    ste_name: "LA",
  },
  {
    zip_code: "70584",

    ste_name: "LA",
  },
  {
    zip_code: "70632",

    ste_name: "LA",
  },
  {
    zip_code: "70639",

    ste_name: "LA",
  },
  {
    zip_code: "70644",

    ste_name: "LA",
  },
  {
    zip_code: "70725",

    ste_name: "LA",
  },
  {
    zip_code: "70806",

    ste_name: "LA",
  },
  {
    zip_code: "70818",

    ste_name: "LA",
  },
  {
    zip_code: "71021",

    ste_name: "LA",
  },
  {
    zip_code: "71119",

    ste_name: "LA",
  },
  {
    zip_code: "71243",

    ste_name: "LA",
  },
  {
    zip_code: "71259",

    ste_name: "LA",
  },
  {
    zip_code: "71270",

    ste_name: "LA",
  },
  {
    zip_code: "71822",

    ste_name: "AR",
  },
  {
    zip_code: "72002",

    ste_name: "AR",
  },
  {
    zip_code: "72022",

    ste_name: "AR",
  },
  {
    zip_code: "72055",

    ste_name: "AR",
  },
  {
    zip_code: "72057",

    ste_name: "AR",
  },
  {
    zip_code: "72063",

    ste_name: "AR",
  },
  {
    zip_code: "72073",

    ste_name: "AR",
  },
  {
    zip_code: "72108",

    ste_name: "AR",
  },
  {
    zip_code: "72118",

    ste_name: "AR",
  },
  {
    zip_code: "72131",

    ste_name: "AR",
  },
  {
    zip_code: "72166",

    ste_name: "AR",
  },
  {
    zip_code: "72435",

    ste_name: "AR",
  },
  {
    zip_code: "72464",

    ste_name: "AR",
  },
  {
    zip_code: "72522",

    ste_name: "AR",
  },
  {
    zip_code: "72556",

    ste_name: "AR",
  },
  {
    zip_code: "72645",

    ste_name: "AR",
  },
  {
    zip_code: "72703",

    ste_name: "AR",
  },
  {
    zip_code: "73103",

    ste_name: "OK",
  },
  {
    zip_code: "73169",

    ste_name: "OK",
  },
  {
    zip_code: "73432",

    ste_name: "OK",
  },
  {
    zip_code: "73453",

    ste_name: "OK",
  },
  {
    zip_code: "73541",

    ste_name: "OK",
  },
  {
    zip_code: "73627",

    ste_name: "OK",
  },
  {
    zip_code: "73655",

    ste_name: "OK",
  },
  {
    zip_code: "73834",

    ste_name: "OK",
  },
  {
    zip_code: "73931",

    ste_name: "OK",
  },
  {
    zip_code: "73933",

    ste_name: "OK",
  },
  {
    zip_code: "74010",

    ste_name: "OK",
  },
  {
    zip_code: "74016",

    ste_name: "OK",
  },
  {
    zip_code: "74085",

    ste_name: "OK",
  },
  {
    zip_code: "74534",

    ste_name: "OK",
  },
  {
    zip_code: "74840",

    ste_name: "OK",
  },
  {
    zip_code: "74854",

    ste_name: "OK",
  },
  {
    zip_code: "74884",

    ste_name: "OK",
  },
  {
    zip_code: "74931",

    ste_name: "OK",
  },
  {
    zip_code: "74941",

    ste_name: "OK",
  },
  {
    zip_code: "74956",

    ste_name: "OK",
  },
  {
    zip_code: "74960",

    ste_name: "OK",
  },
  {
    zip_code: "74966",

    ste_name: "OK",
  },
  {
    zip_code: "75180",

    ste_name: "TX",
  },
  {
    zip_code: "75189",

    ste_name: "TX",
  },
  {
    zip_code: "75401",

    ste_name: "TX",
  },
  {
    zip_code: "75706",

    ste_name: "TX",
  },
  {
    zip_code: "75754",

    ste_name: "TX",
  },
  {
    zip_code: "75936",

    ste_name: "TX",
  },
  {
    zip_code: "75949",

    ste_name: "TX",
  },
  {
    zip_code: "75961",

    ste_name: "TX",
  },
  {
    zip_code: "75969",

    ste_name: "TX",
  },
  {
    zip_code: "76006",

    ste_name: "TX",
  },
  {
    zip_code: "76017",

    ste_name: "TX",
  },
  {
    zip_code: "76177",

    ste_name: "TX",
  },
  {
    zip_code: "76179",

    ste_name: "TX",
  },
  {
    zip_code: "76301",

    ste_name: "TX",
  },
  {
    zip_code: "76364",

    ste_name: "TX",
  },
  {
    zip_code: "76401",

    ste_name: "TX",
  },
  {
    zip_code: "76630",

    ste_name: "TX",
  },
  {
    zip_code: "76654",

    ste_name: "TX",
  },
  {
    zip_code: "76824",

    ste_name: "TX",
  },
  {
    zip_code: "76825",

    ste_name: "TX",
  },
  {
    zip_code: "76849",

    ste_name: "TX",
  },
  {
    zip_code: "76933",

    ste_name: "TX",
  },
  {
    zip_code: "77027",

    ste_name: "TX",
  },
  {
    zip_code: "77050",

    ste_name: "TX",
  },
  {
    zip_code: "77053",

    ste_name: "TX",
  },
  {
    zip_code: "77055",

    ste_name: "TX",
  },
  {
    zip_code: "77079",

    ste_name: "TX",
  },
  {
    zip_code: "77388",

    ste_name: "TX",
  },
  {
    zip_code: "77419",

    ste_name: "TX",
  },
  {
    zip_code: "77546",

    ste_name: "TX",
  },
  {
    zip_code: "77630",

    ste_name: "TX",
  },
  {
    zip_code: "77878",

    ste_name: "TX",
  },
  {
    zip_code: "77962",

    ste_name: "TX",
  },
  {
    zip_code: "77971",

    ste_name: "TX",
  },
  {
    zip_code: "78015",

    ste_name: "TX",
  },
  {
    zip_code: "78063",

    ste_name: "TX",
  },
  {
    zip_code: "78207",

    ste_name: "TX",
  },
  {
    zip_code: "78224",

    ste_name: "TX",
  },
  {
    zip_code: "78240",

    ste_name: "TX",
  },
  {
    zip_code: "78244",

    ste_name: "TX",
  },
  {
    zip_code: "78254",

    ste_name: "TX",
  },
  {
    zip_code: "78341",

    ste_name: "TX",
  },
  {
    zip_code: "78379",

    ste_name: "TX",
  },
  {
    zip_code: "78384",

    ste_name: "TX",
  },
  {
    zip_code: "78542",

    ste_name: "TX",
  },
  {
    zip_code: "78578",

    ste_name: "TX",
  },
  {
    zip_code: "78594",

    ste_name: "TX",
  },
  {
    zip_code: "78615",

    ste_name: "TX",
  },
  {
    zip_code: "78621",

    ste_name: "TX",
  },
  {
    zip_code: "78641",

    ste_name: "TX",
  },
  {
    zip_code: "78656",

    ste_name: "TX",
  },
  {
    zip_code: "78748",

    ste_name: "TX",
  },
  {
    zip_code: "79109",

    ste_name: "TX",
  },
  {
    zip_code: "79424",

    ste_name: "TX",
  },
  {
    zip_code: "79508",

    ste_name: "TX",
  },
  {
    zip_code: "79766",

    ste_name: "TX",
  },
  {
    zip_code: "79836",

    ste_name: "TX",
  },
  {
    zip_code: "79842",

    ste_name: "TX",
  },
  {
    zip_code: "80128",

    ste_name: "CO",
  },
  {
    zip_code: "80218",

    ste_name: "CO",
  },
  {
    zip_code: "80424",

    ste_name: "CO",
  },
  {
    zip_code: "80452",

    ste_name: "CO",
  },
  {
    zip_code: "80477",

    ste_name: "CO",
  },
  {
    zip_code: "80480",

    ste_name: "CO",
  },
  {
    zip_code: "80532",

    ste_name: "CO",
  },
  {
    zip_code: "80602",

    ste_name: "CO",
  },
  {
    zip_code: "80722",

    ste_name: "CO",
  },
  {
    zip_code: "80749",

    ste_name: "CO",
  },
  {
    zip_code: "80810",

    ste_name: "CO",
  },
  {
    zip_code: "81003",

    ste_name: "CO",
  },
  {
    zip_code: "81006",

    ste_name: "CO",
  },
  {
    zip_code: "81041",

    ste_name: "CO",
  },
  {
    zip_code: "81069",

    ste_name: "CO",
  },
  {
    zip_code: "81226",

    ste_name: "CO",
  },
  {
    zip_code: "81413",

    ste_name: "CO",
  },
  {
    zip_code: "81416",

    ste_name: "CO",
  },
  {
    zip_code: "81422",

    ste_name: "CO",
  },
  {
    zip_code: "81424",

    ste_name: "CO",
  },
  {
    zip_code: "81507",

    ste_name: "CO",
  },
  {
    zip_code: "81623",

    ste_name: "CO",
  },
  {
    zip_code: "81657",

    ste_name: "CO",
  },
  {
    zip_code: "82084",

    ste_name: "WY",
  },
  {
    zip_code: "82327",

    ste_name: "WY",
  },
  {
    zip_code: "82423",

    ste_name: "WY",
  },
  {
    zip_code: "82513",

    ste_name: "WY",
  },
  {
    zip_code: "82604",

    ste_name: "WY",
  },
  {
    zip_code: "82935",

    ste_name: "WY",
  },
  {
    zip_code: "82944",

    ste_name: "WY",
  },
  {
    zip_code: "83124",

    ste_name: "WY",
  },
  {
    zip_code: "83245",

    ste_name: "ID",
  },
  {
    zip_code: "83250",

    ste_name: "ID",
  },
  {
    zip_code: "83255",

    ste_name: "ID",
  },
  {
    zip_code: "83272",

    ste_name: "ID",
  },
  {
    zip_code: "83283",

    ste_name: "ID",
  },
  {
    zip_code: "83353",

    ste_name: "ID",
  },
  {
    zip_code: "83446",

    ste_name: "ID",
  },
  {
    zip_code: "83452",

    ste_name: "ID",
  },
  {
    zip_code: "83602",

    ste_name: "ID",
  },
  {
    zip_code: "83639",

    ste_name: "ID",
  },
  {
    zip_code: "83647",

    ste_name: "ID",
  },
  {
    zip_code: "83842",

    ste_name: "ID",
  },
  {
    zip_code: "83870",

    ste_name: "ID",
  },
  {
    zip_code: "83871",

    ste_name: "ID",
  },
  {
    zip_code: "84020",

    ste_name: "UT",
  },
  {
    zip_code: "84029",

    ste_name: "UT",
  },
  {
    zip_code: "84046",

    ste_name: "UT",
  },
  {
    zip_code: "84051",

    ste_name: "UT",
  },
  {
    zip_code: "84078",

    ste_name: "UT",
  },
  {
    zip_code: "84314",

    ste_name: "UT",
  },
  {
    zip_code: "84329",

    ste_name: "UT",
  },
  {
    zip_code: "84623",

    ste_name: "UT",
  },
  {
    zip_code: "84647",

    ste_name: "UT",
  },
  {
    zip_code: "84738",

    ste_name: "UT",
  },
  {
    zip_code: "84756",

    ste_name: "UT",
  },
  {
    zip_code: "85132",

    ste_name: "AZ",
  },
  {
    zip_code: "85202",

    ste_name: "AZ",
  },
  {
    zip_code: "85215",

    ste_name: "AZ",
  },
  {
    zip_code: "85282",

    ste_name: "AZ",
  },
  {
    zip_code: "85302",

    ste_name: "AZ",
  },
  {
    zip_code: "85304",

    ste_name: "AZ",
  },
  {
    zip_code: "85552",

    ste_name: "AZ",
  },
  {
    zip_code: "85607",

    ste_name: "AZ",
  },
  {
    zip_code: "85609",

    ste_name: "AZ",
  },
  {
    zip_code: "85920",

    ste_name: "AZ",
  },
  {
    zip_code: "85927",

    ste_name: "AZ",
  },
  {
    zip_code: "85942",

    ste_name: "AZ",
  },
  {
    zip_code: "86034",

    ste_name: "AZ",
  },
  {
    zip_code: "86053",

    ste_name: "AZ",
  },
  {
    zip_code: "87044",

    ste_name: "NM",
  },
  {
    zip_code: "87113",

    ste_name: "NM",
  },
  {
    zip_code: "87510",

    ste_name: "NM",
  },
  {
    zip_code: "87515",

    ste_name: "NM",
  },
  {
    zip_code: "87562",

    ste_name: "NM",
  },
  {
    zip_code: "87575",

    ste_name: "NM",
  },
  {
    zip_code: "87701",

    ste_name: "NM",
  },
  {
    zip_code: "87735",

    ste_name: "NM",
  },
  {
    zip_code: "87740",

    ste_name: "NM",
  },
  {
    zip_code: "87746",

    ste_name: "NM",
  },
  {
    zip_code: "88028",

    ste_name: "NM",
  },
  {
    zip_code: "88203",

    ste_name: "NM",
  },
  {
    zip_code: "88419",

    ste_name: "NM",
  },
  {
    zip_code: "88431",

    ste_name: "NM",
  },
  {
    zip_code: "89007",

    ste_name: "NV",
  },
  {
    zip_code: "89017",

    ste_name: "NV",
  },
  {
    zip_code: "89019",

    ste_name: "NV",
  },
  {
    zip_code: "89032",

    ste_name: "NV",
  },
  {
    zip_code: "89135",

    ste_name: "NV",
  },
  {
    zip_code: "89412",

    ste_name: "NV",
  },
  {
    zip_code: "89450",

    ste_name: "NV",
  },
  {
    zip_code: "31018",

    ste_name: "GA",
  },
  {
    zip_code: "31072",

    ste_name: "GA",
  },
  {
    zip_code: "31213",

    ste_name: "GA",
  },
  {
    zip_code: "31302",

    ste_name: "GA",
  },
  {
    zip_code: "31548",

    ste_name: "GA",
  },
  {
    zip_code: "31631",

    ste_name: "GA",
  },
  {
    zip_code: "31639",

    ste_name: "GA",
  },
  {
    zip_code: "31701",

    ste_name: "GA",
  },
  {
    zip_code: "31788",

    ste_name: "GA",
  },
  {
    zip_code: "31796",

    ste_name: "GA",
  },
  {
    zip_code: "31823",

    ste_name: "GA",
  },
  {
    zip_code: "31901",

    ste_name: "GA",
  },
  {
    zip_code: "32033",

    ste_name: "FL",
  },
  {
    zip_code: "32102",

    ste_name: "FL",
  },
  {
    zip_code: "32113",

    ste_name: "FL",
  },
  {
    zip_code: "32224",

    ste_name: "FL",
  },
  {
    zip_code: "32346",

    ste_name: "FL",
  },
  {
    zip_code: "32348",

    ste_name: "FL",
  },
  {
    zip_code: "32413",

    ste_name: "FL",
  },
  {
    zip_code: "32641",

    ste_name: "FL",
  },
  {
    zip_code: "32683",

    ste_name: "FL",
  },
  {
    zip_code: "32735",

    ste_name: "FL",
  },
  {
    zip_code: "32738",

    ste_name: "FL",
  },
  {
    zip_code: "32962",

    ste_name: "FL",
  },
  {
    zip_code: "32967",

    ste_name: "FL",
  },
  {
    zip_code: "33001",

    ste_name: "FL",
  },
  {
    zip_code: "33069",

    ste_name: "FL",
  },
  {
    zip_code: "33411",

    ste_name: "FL",
  },
  {
    zip_code: "33434",

    ste_name: "FL",
  },
  {
    zip_code: "33476",

    ste_name: "FL",
  },
  {
    zip_code: "33538",

    ste_name: "FL",
  },
  {
    zip_code: "33565",

    ste_name: "FL",
  },
  {
    zip_code: "33634",

    ste_name: "FL",
  },
  {
    zip_code: "33805",

    ste_name: "FL",
  },
  {
    zip_code: "33873",

    ste_name: "FL",
  },
  {
    zip_code: "33982",

    ste_name: "FL",
  },
  {
    zip_code: "34222",

    ste_name: "FL",
  },
  {
    zip_code: "34449",

    ste_name: "FL",
  },
  {
    zip_code: "34698",

    ste_name: "FL",
  },
  {
    zip_code: "34762",

    ste_name: "FL",
  },
  {
    zip_code: "34950",

    ste_name: "FL",
  },
  {
    zip_code: "34984",

    ste_name: "FL",
  },
  {
    zip_code: "35131",

    ste_name: "AL",
  },
  {
    zip_code: "35160",

    ste_name: "AL",
  },
  {
    zip_code: "35171",

    ste_name: "AL",
  },
  {
    zip_code: "35173",

    ste_name: "AL",
  },
  {
    zip_code: "35175",

    ste_name: "AL",
  },
  {
    zip_code: "35222",

    ste_name: "AL",
  },
  {
    zip_code: "35226",

    ste_name: "AL",
  },
  {
    zip_code: "35234",

    ste_name: "AL",
  },
  {
    zip_code: "35474",

    ste_name: "AL",
  },
  {
    zip_code: "35542",

    ste_name: "AL",
  },
  {
    zip_code: "35614",

    ste_name: "AL",
  },
  {
    zip_code: "35756",

    ste_name: "AL",
  },
  {
    zip_code: "35775",

    ste_name: "AL",
  },
  {
    zip_code: "35953",

    ste_name: "AL",
  },
  {
    zip_code: "35975",

    ste_name: "AL",
  },
  {
    zip_code: "36022",

    ste_name: "AL",
  },
  {
    zip_code: "36031",

    ste_name: "AL",
  },
  {
    zip_code: "36047",

    ste_name: "AL",
  },
  {
    zip_code: "36319",

    ste_name: "AL",
  },
  {
    zip_code: "36340",

    ste_name: "AL",
  },
  {
    zip_code: "36442",

    ste_name: "AL",
  },
  {
    zip_code: "36454",

    ste_name: "AL",
  },
  {
    zip_code: "36512",

    ste_name: "AL",
  },
  {
    zip_code: "36611",

    ste_name: "AL",
  },
  {
    zip_code: "36784",

    ste_name: "AL",
  },
  {
    zip_code: "36790",

    ste_name: "AL",
  },
  {
    zip_code: "37010",

    ste_name: "TN",
  },
  {
    zip_code: "37080",

    ste_name: "TN",
  },
  {
    zip_code: "37095",

    ste_name: "TN",
  },
  {
    zip_code: "37134",

    ste_name: "TN",
  },
  {
    zip_code: "37142",

    ste_name: "TN",
  },
  {
    zip_code: "37303",

    ste_name: "TN",
  },
  {
    zip_code: "37333",

    ste_name: "TN",
  },
  {
    zip_code: "37357",

    ste_name: "TN",
  },
  {
    zip_code: "37370",

    ste_name: "TN",
  },
  {
    zip_code: "37394",

    ste_name: "TN",
  },
  {
    zip_code: "37709",

    ste_name: "TN",
  },
  {
    zip_code: "37723",

    ste_name: "TN",
  },
  {
    zip_code: "37830",

    ste_name: "TN",
  },
  {
    zip_code: "37885",

    ste_name: "TN",
  },
  {
    zip_code: "37890",

    ste_name: "TN",
  },
  {
    zip_code: "37923",

    ste_name: "TN",
  },
  {
    zip_code: "38002",

    ste_name: "TN",
  },
  {
    zip_code: "38015",

    ste_name: "TN",
  },
  {
    zip_code: "38023",

    ste_name: "TN",
  },
  {
    zip_code: "38105",

    ste_name: "TN",
  },
  {
    zip_code: "38120",

    ste_name: "TN",
  },
  {
    zip_code: "38125",

    ste_name: "TN",
  },
  {
    zip_code: "38231",

    ste_name: "TN",
  },
  {
    zip_code: "38357",

    ste_name: "TN",
  },
  {
    zip_code: "38369",

    ste_name: "TN",
  },
  {
    zip_code: "38587",

    ste_name: "TN",
  },
  {
    zip_code: "38617",

    ste_name: "MS",
  },
  {
    zip_code: "38618",

    ste_name: "MS",
  },
  {
    zip_code: "38661",

    ste_name: "MS",
  },
  {
    zip_code: "38721",

    ste_name: "MS",
  },
  {
    zip_code: "38756",

    ste_name: "MS",
  },
  {
    zip_code: "38768",

    ste_name: "MS",
  },
  {
    zip_code: "38966",

    ste_name: "MS",
  },
  {
    zip_code: "39063",

    ste_name: "MS",
  },
  {
    zip_code: "39069",

    ste_name: "MS",
  },
  {
    zip_code: "39180",

    ste_name: "MS",
  },
  {
    zip_code: "39481",

    ste_name: "MS",
  },
  {
    zip_code: "39641",

    ste_name: "MS",
  },
  {
    zip_code: "39663",

    ste_name: "MS",
  },
  {
    zip_code: "39736",

    ste_name: "MS",
  },
  {
    zip_code: "39737",

    ste_name: "MS",
  },
  {
    zip_code: "40006",

    ste_name: "KY",
  },
  {
    zip_code: "40041",

    ste_name: "KY",
  },
  {
    zip_code: "40440",

    ste_name: "KY",
  },
  {
    zip_code: "40442",

    ste_name: "KY",
  },
  {
    zip_code: "40513",

    ste_name: "KY",
  },
  {
    zip_code: "40729",

    ste_name: "KY",
  },
  {
    zip_code: "40856",

    ste_name: "KY",
  },
  {
    zip_code: "40863",

    ste_name: "KY",
  },
  {
    zip_code: "41034",

    ste_name: "KY",
  },
  {
    zip_code: "41179",

    ste_name: "KY",
  },
  {
    zip_code: "41274",

    ste_name: "KY",
  },
  {
    zip_code: "41701",

    ste_name: "KY",
  },
  {
    zip_code: "41775",

    ste_name: "KY",
  },
  {
    zip_code: "41831",

    ste_name: "KY",
  },
  {
    zip_code: "41862",

    ste_name: "KY",
  },
  {
    zip_code: "42054",

    ste_name: "KY",
  },
  {
    zip_code: "42133",

    ste_name: "KY",
  },
  {
    zip_code: "42157",

    ste_name: "KY",
  },
  {
    zip_code: "42339",

    ste_name: "KY",
  },
  {
    zip_code: "42368",

    ste_name: "KY",
  },
  {
    zip_code: "42453",

    ste_name: "KY",
  },
  {
    zip_code: "42567",

    ste_name: "KY",
  },
  {
    zip_code: "42647",

    ste_name: "KY",
  },
  {
    zip_code: "42716",

    ste_name: "KY",
  },
  {
    zip_code: "42753",

    ste_name: "KY",
  },
  {
    zip_code: "43030",

    ste_name: "OH",
  },
  {
    zip_code: "43116",

    ste_name: "OH",
  },
  {
    zip_code: "43204",

    ste_name: "OH",
  },
  {
    zip_code: "43358",

    ste_name: "OH",
  },
  {
    zip_code: "43433",

    ste_name: "OH",
  },
  {
    zip_code: "43515",

    ste_name: "OH",
  },
  {
    zip_code: "43548",

    ste_name: "OH",
  },
  {
    zip_code: "43557",

    ste_name: "OH",
  },
  {
    zip_code: "43725",

    ste_name: "OH",
  },
  {
    zip_code: "43735",

    ste_name: "OH",
  },
  {
    zip_code: "43756",

    ste_name: "OH",
  },
  {
    zip_code: "43767",

    ste_name: "OH",
  },
  {
    zip_code: "43783",

    ste_name: "OH",
  },
  {
    zip_code: "43788",

    ste_name: "OH",
  },
  {
    zip_code: "43944",

    ste_name: "OH",
  },
  {
    zip_code: "44001",

    ste_name: "OH",
  },
  {
    zip_code: "44081",

    ste_name: "OH",
  },
  {
    zip_code: "44092",

    ste_name: "OH",
  },
  {
    zip_code: "44260",

    ste_name: "OH",
  },
  {
    zip_code: "44445",

    ste_name: "OH",
  },
  {
    zip_code: "44473",

    ste_name: "OH",
  },
  {
    zip_code: "44643",

    ste_name: "OH",
  },
  {
    zip_code: "44651",

    ste_name: "OH",
  },
  {
    zip_code: "44681",

    ste_name: "OH",
  },
  {
    zip_code: "44685",

    ste_name: "OH",
  },
  {
    zip_code: "44705",

    ste_name: "OH",
  },
  {
    zip_code: "44814",

    ste_name: "OH",
  },
  {
    zip_code: "44820",

    ste_name: "OH",
  },
  {
    zip_code: "44838",

    ste_name: "OH",
  },
  {
    zip_code: "44844",

    ste_name: "OH",
  },
  {
    zip_code: "44846",

    ste_name: "OH",
  },
  {
    zip_code: "44865",

    ste_name: "OH",
  },
  {
    zip_code: "45030",

    ste_name: "OH",
  },
  {
    zip_code: "45041",

    ste_name: "OH",
  },
  {
    zip_code: "45111",

    ste_name: "OH",
  },
  {
    zip_code: "45233",

    ste_name: "OH",
  },
  {
    zip_code: "45240",

    ste_name: "OH",
  },
  {
    zip_code: "45307",

    ste_name: "OH",
  },
  {
    zip_code: "45310",

    ste_name: "OH",
  },
  {
    zip_code: "45324",

    ste_name: "OH",
  },
  {
    zip_code: "45373",

    ste_name: "OH",
  },
  {
    zip_code: "45383",

    ste_name: "OH",
  },
  {
    zip_code: "45417",

    ste_name: "OH",
  },
  {
    zip_code: "45715",

    ste_name: "OH",
  },
  {
    zip_code: "45727",

    ste_name: "OH",
  },
  {
    zip_code: "45779",

    ste_name: "OH",
  },
  {
    zip_code: "45816",

    ste_name: "OH",
  },
  {
    zip_code: "45832",

    ste_name: "OH",
  },
  {
    zip_code: "45858",

    ste_name: "OH",
  },
  {
    zip_code: "45859",

    ste_name: "OH",
  },
  {
    zip_code: "45897",

    ste_name: "OH",
  },
  {
    zip_code: "46071",

    ste_name: "IN",
  },
  {
    zip_code: "46113",

    ste_name: "IN",
  },
  {
    zip_code: "46124",

    ste_name: "IN",
  },
  {
    zip_code: "46160",

    ste_name: "IN",
  },
  {
    zip_code: "46168",

    ste_name: "IN",
  },
  {
    zip_code: "46184",

    ste_name: "IN",
  },
  {
    zip_code: "46203",

    ste_name: "IN",
  },
  {
    zip_code: "46259",

    ste_name: "IN",
  },
  {
    zip_code: "46327",

    ste_name: "IN",
  },
  {
    zip_code: "46542",

    ste_name: "IN",
  },
  {
    zip_code: "46730",

    ste_name: "IN",
  },
  {
    zip_code: "46740",

    ste_name: "IN",
  },
  {
    zip_code: "46766",

    ste_name: "IN",
  },
  {
    zip_code: "46776",

    ste_name: "IN",
  },
  {
    zip_code: "46818",

    ste_name: "IN",
  },
  {
    zip_code: "46984",

    ste_name: "IN",
  },
  {
    zip_code: "47035",

    ste_name: "IN",
  },
  {
    zip_code: "47060",

    ste_name: "IN",
  },
  {
    zip_code: "47106",

    ste_name: "IN",
  },
  {
    zip_code: "47162",

    ste_name: "IN",
  },
  {
    zip_code: "47167",

    ste_name: "IN",
  },
  {
    zip_code: "47240",

    ste_name: "IN",
  },
  {
    zip_code: "47250",

    ste_name: "IN",
  },
  {
    zip_code: "47336",

    ste_name: "IN",
  },
  {
    zip_code: "47357",

    ste_name: "IN",
  },
  {
    zip_code: "47524",

    ste_name: "IN",
  },
  {
    zip_code: "47528",

    ste_name: "IN",
  },
  {
    zip_code: "47631",

    ste_name: "IN",
  },
  {
    zip_code: "47637",

    ste_name: "IN",
  },
  {
    zip_code: "47804",

    ste_name: "IN",
  },
  {
    zip_code: "47832",

    ste_name: "IN",
  },
  {
    zip_code: "47880",

    ste_name: "IN",
  },
  {
    zip_code: "47946",

    ste_name: "IN",
  },
  {
    zip_code: "47948",

    ste_name: "IN",
  },
  {
    zip_code: "47987",

    ste_name: "IN",
  },
  {
    zip_code: "48035",

    ste_name: "MI",
  },
  {
    zip_code: "48040",

    ste_name: "MI",
  },
  {
    zip_code: "48111",

    ste_name: "MI",
  },
  {
    zip_code: "48116",

    ste_name: "MI",
  },
  {
    zip_code: "48134",

    ste_name: "MI",
  },
  {
    zip_code: "48239",

    ste_name: "MI",
  },
  {
    zip_code: "48302",

    ste_name: "MI",
  },
  {
    zip_code: "48381",

    ste_name: "MI",
  },
  {
    zip_code: "48415",

    ste_name: "MI",
  },
  {
    zip_code: "48426",

    ste_name: "MI",
  },
  {
    zip_code: "48445",

    ste_name: "MI",
  },
  {
    zip_code: "48464",

    ste_name: "MI",
  },
  {
    zip_code: "48623",

    ste_name: "MI",
  },
  {
    zip_code: "48638",

    ste_name: "MI",
  },
  {
    zip_code: "48877",

    ste_name: "MI",
  },
  {
    zip_code: "48880",

    ste_name: "MI",
  },
  {
    zip_code: "49014",

    ste_name: "MI",
  },
  {
    zip_code: "49051",

    ste_name: "MI",
  },
  {
    zip_code: "49057",

    ste_name: "MI",
  },
  {
    zip_code: "49060",

    ste_name: "MI",
  },
  {
    zip_code: "49097",

    ste_name: "MI",
  },
  {
    zip_code: "49103",

    ste_name: "MI",
  },
  {
    zip_code: "49130",

    ste_name: "MI",
  },
  {
    zip_code: "49254",

    ste_name: "MI",
  },
  {
    zip_code: "49268",

    ste_name: "MI",
  },
  {
    zip_code: "49286",

    ste_name: "MI",
  },
  {
    zip_code: "49302",

    ste_name: "MI",
  },
  {
    zip_code: "49304",

    ste_name: "MI",
  },
  {
    zip_code: "49441",

    ste_name: "MI",
  },
  {
    zip_code: "49448",

    ste_name: "MI",
  },
  {
    zip_code: "49449",

    ste_name: "MI",
  },
  {
    zip_code: "49457",

    ste_name: "MI",
  },
  {
    zip_code: "49643",

    ste_name: "MI",
  },
  {
    zip_code: "49683",

    ste_name: "MI",
  },
  {
    zip_code: "49743",

    ste_name: "MI",
  },
  {
    zip_code: "49783",

    ste_name: "MI",
  },
  {
    zip_code: "49834",

    ste_name: "MI",
  },
  {
    zip_code: "49930",

    ste_name: "MI",
  },
  {
    zip_code: "50048",

    ste_name: "IA",
  },
  {
    zip_code: "50049",

    ste_name: "IA",
  },
  {
    zip_code: "50102",

    ste_name: "IA",
  },
  {
    zip_code: "50136",

    ste_name: "IA",
  },
  {
    zip_code: "50254",

    ste_name: "IA",
  },
  {
    zip_code: "50314",

    ste_name: "IA",
  },
  {
    zip_code: "50438",

    ste_name: "IA",
  },
  {
    zip_code: "50510",

    ste_name: "IA",
  },
  {
    zip_code: "50525",

    ste_name: "IA",
  },
  {
    zip_code: "50560",

    ste_name: "IA",
  },
  {
    zip_code: "50573",

    ste_name: "IA",
  },
  {
    zip_code: "50627",

    ste_name: "IA",
  },
  {
    zip_code: "50635",

    ste_name: "IA",
  },
  {
    zip_code: "51014",

    ste_name: "IA",
  },
  {
    zip_code: "51029",

    ste_name: "IA",
  },
  {
    zip_code: "51055",

    ste_name: "IA",
  },
  {
    zip_code: "51442",

    ste_name: "IA",
  },
  {
    zip_code: "51447",

    ste_name: "IA",
  },
  {
    zip_code: "51523",

    ste_name: "IA",
  },
  {
    zip_code: "51540",

    ste_name: "IA",
  },
  {
    zip_code: "51578",

    ste_name: "IA",
  },
  {
    zip_code: "52160",

    ste_name: "IA",
  },
  {
    zip_code: "52175",

    ste_name: "IA",
  },
  {
    zip_code: "52237",

    ste_name: "IA",
  },
  {
    zip_code: "52302",

    ste_name: "IA",
  },
  {
    zip_code: "52315",

    ste_name: "IA",
  },
  {
    zip_code: "52317",

    ste_name: "IA",
  },
  {
    zip_code: "52334",

    ste_name: "IA",
  },
  {
    zip_code: "52336",

    ste_name: "IA",
  },
  {
    zip_code: "52356",

    ste_name: "IA",
  },
  {
    zip_code: "52359",

    ste_name: "IA",
  },
  {
    zip_code: "52531",

    ste_name: "IA",
  },
  {
    zip_code: "52570",

    ste_name: "IA",
  },
  {
    zip_code: "52638",

    ste_name: "IA",
  },
  {
    zip_code: "52641",

    ste_name: "IA",
  },
  {
    zip_code: "52647",

    ste_name: "IA",
  },
  {
    zip_code: "52777",

    ste_name: "IA",
  },
  {
    zip_code: "53039",

    ste_name: "WI",
  },
  {
    zip_code: "53074",

    ste_name: "WI",
  },
  {
    zip_code: "53128",

    ste_name: "WI",
  },
  {
    zip_code: "53502",

    ste_name: "WI",
  },
  {
    zip_code: "53575",

    ste_name: "WI",
  },
  {
    zip_code: "53576",

    ste_name: "WI",
  },
  {
    zip_code: "53719",

    ste_name: "WI",
  },
  {
    zip_code: "53826",

    ste_name: "WI",
  },
  {
    zip_code: "53951",

    ste_name: "WI",
  },
  {
    zip_code: "54027",

    ste_name: "WI",
  },
  {
    zip_code: "54235",

    ste_name: "WI",
  },
  {
    zip_code: "54245",

    ste_name: "WI",
  },
  {
    zip_code: "54246",

    ste_name: "WI",
  },
  {
    zip_code: "54302",

    ste_name: "WI",
  },
  {
    zip_code: "54412",

    ste_name: "WI",
  },
  {
    zip_code: "54437",

    ste_name: "WI",
  },
  {
    zip_code: "54471",

    ste_name: "WI",
  },
  {
    zip_code: "54545",

    ste_name: "WI",
  },
  {
    zip_code: "54562",

    ste_name: "WI",
  },
  {
    zip_code: "54610",

    ste_name: "WI",
  },
  {
    zip_code: "54669",

    ste_name: "WI",
  },
  {
    zip_code: "54703",

    ste_name: "WI",
  },
  {
    zip_code: "54756",

    ste_name: "WI",
  },
  {
    zip_code: "54846",

    ste_name: "WI",
  },
  {
    zip_code: "54945",

    ste_name: "WI",
  },
  {
    zip_code: "54961",

    ste_name: "WI",
  },
  {
    zip_code: "55014",

    ste_name: "MN",
  },
  {
    zip_code: "55126",

    ste_name: "MN",
  },
  {
    zip_code: "55130",

    ste_name: "MN",
  },
  {
    zip_code: "55388",

    ste_name: "MN",
  },
  {
    zip_code: "55445",

    ste_name: "MN",
  },
  {
    zip_code: "55454",

    ste_name: "MN",
  },
  {
    zip_code: "55703",

    ste_name: "MN",
  },
  {
    zip_code: "55713",

    ste_name: "MN",
  },
  {
    zip_code: "55733",

    ste_name: "MN",
  },
  {
    zip_code: "55756",

    ste_name: "MN",
  },
  {
    zip_code: "55766",

    ste_name: "MN",
  },
  {
    zip_code: "55772",

    ste_name: "MN",
  },
  {
    zip_code: "55936",

    ste_name: "MN",
  },
  {
    zip_code: "55957",

    ste_name: "MN",
  },
  {
    zip_code: "55975",

    ste_name: "MN",
  },
  {
    zip_code: "56033",

    ste_name: "MN",
  },
  {
    zip_code: "56034",

    ste_name: "MN",
  },
  {
    zip_code: "56071",

    ste_name: "MN",
  },
  {
    zip_code: "56172",

    ste_name: "MN",
  },
  {
    zip_code: "56224",

    ste_name: "MN",
  },
  {
    zip_code: "56243",

    ste_name: "MN",
  },
  {
    zip_code: "56310",

    ste_name: "MN",
  },
  {
    zip_code: "56329",

    ste_name: "MN",
  },
  {
    zip_code: "56354",

    ste_name: "MN",
  },
  {
    zip_code: "56387",

    ste_name: "MN",
  },
  {
    zip_code: "56443",

    ste_name: "MN",
  },
  {
    zip_code: "56458",

    ste_name: "MN",
  },
  {
    zip_code: "56468",

    ste_name: "MN",
  },
  {
    zip_code: "56514",

    ste_name: "MN",
  },
  {
    zip_code: "56575",

    ste_name: "MN",
  },
  {
    zip_code: "56593",

    ste_name: "MN",
  },
  {
    zip_code: "56594",

    ste_name: "MN",
  },
  {
    zip_code: "56629",

    ste_name: "MN",
  },
  {
    zip_code: "56670",

    ste_name: "MN",
  },
  {
    zip_code: "56671",

    ste_name: "MN",
  },
  {
    zip_code: "56678",

    ste_name: "MN",
  },
  {
    zip_code: "57017",

    ste_name: "SD",
  },
  {
    zip_code: "57050",

    ste_name: "SD",
  },
  {
    zip_code: "57073",

    ste_name: "SD",
  },
  {
    zip_code: "57216",

    ste_name: "SD",
  },
  {
    zip_code: "57220",

    ste_name: "SD",
  },
  {
    zip_code: "57231",

    ste_name: "SD",
  },
  {
    zip_code: "57252",

    ste_name: "SD",
  },
  {
    zip_code: "57255",

    ste_name: "SD",
  },
  {
    zip_code: "57334",

    ste_name: "SD",
  },
  {
    zip_code: "57349",

    ste_name: "SD",
  },
  {
    zip_code: "57373",

    ste_name: "SD",
  },
  {
    zip_code: "57445",

    ste_name: "SD",
  },
  {
    zip_code: "57523",

    ste_name: "SD",
  },
  {
    zip_code: "57529",

    ste_name: "SD",
  },
  {
    zip_code: "57532",

    ste_name: "SD",
  },
  {
    zip_code: "57553",

    ste_name: "SD",
  },
  {
    zip_code: "57574",

    ste_name: "SD",
  },
  {
    zip_code: "57579",

    ste_name: "SD",
  },
  {
    zip_code: "57640",

    ste_name: "SD",
  },
  {
    zip_code: "57759",

    ste_name: "SD",
  },
  {
    zip_code: "57760",

    ste_name: "SD",
  },
  {
    zip_code: "58005",

    ste_name: "ND",
  },
  {
    zip_code: "58065",

    ste_name: "ND",
  },
  {
    zip_code: "58078",

    ste_name: "ND",
  },
  {
    zip_code: "58235",

    ste_name: "ND",
  },
  {
    zip_code: "58258",

    ste_name: "ND",
  },
  {
    zip_code: "58311",

    ste_name: "ND",
  },
  {
    zip_code: "58355",

    ste_name: "ND",
  },
  {
    zip_code: "58384",

    ste_name: "ND",
  },
  {
    zip_code: "58422",

    ste_name: "ND",
  },
  {
    zip_code: "58472",

    ste_name: "ND",
  },
  {
    zip_code: "58541",

    ste_name: "ND",
  },
  {
    zip_code: "58554",

    ste_name: "ND",
  },
  {
    zip_code: "58650",

    ste_name: "ND",
  },
  {
    zip_code: "58653",

    ste_name: "ND",
  },
  {
    zip_code: "90011",

    ste_name: "CA",
  },
  {
    zip_code: "90037",

    ste_name: "CA",
  },
  {
    zip_code: "90095",

    ste_name: "CA",
  },
  {
    zip_code: "90212",

    ste_name: "CA",
  },
  {
    zip_code: "90290",

    ste_name: "CA",
  },
  {
    zip_code: "90706",

    ste_name: "CA",
  },
  {
    zip_code: "90813",

    ste_name: "CA",
  },
  {
    zip_code: "91024",

    ste_name: "CA",
  },
  {
    zip_code: "91046",

    ste_name: "CA",
  },
  {
    zip_code: "91104",

    ste_name: "CA",
  },
  {
    zip_code: "91106",

    ste_name: "CA",
  },
  {
    zip_code: "91402",

    ste_name: "CA",
  },
  {
    zip_code: "91505",

    ste_name: "CA",
  },
  {
    zip_code: "91745",

    ste_name: "CA",
  },
  {
    zip_code: "91746",

    ste_name: "CA",
  },
  {
    zip_code: "91980",

    ste_name: "CA",
  },
  {
    zip_code: "92025",

    ste_name: "CA",
  },
  {
    zip_code: "92078",

    ste_name: "CA",
  },
  {
    zip_code: "92140",

    ste_name: "CA",
  },
  {
    zip_code: "92239",

    ste_name: "CA",
  },
  {
    zip_code: "92241",

    ste_name: "CA",
  },
  {
    zip_code: "92341",

    ste_name: "CA",
  },
  {
    zip_code: "92354",

    ste_name: "CA",
  },
  {
    zip_code: "92364",

    ste_name: "CA",
  },
  {
    zip_code: "93010",

    ste_name: "CA",
  },
  {
    zip_code: "93065",

    ste_name: "CA",
  },
  {
    zip_code: "93240",

    ste_name: "CA",
  },
  {
    zip_code: "93250",

    ste_name: "CA",
  },
  {
    zip_code: "93276",

    ste_name: "CA",
  },
  {
    zip_code: "94123",

    ste_name: "CA",
  },
  {
    zip_code: "94505",

    ste_name: "CA",
  },
  {
    zip_code: "94517",

    ste_name: "CA",
  },
  {
    zip_code: "94607",

    ste_name: "CA",
  },
  {
    zip_code: "94805",

    ste_name: "CA",
  },
  {
    zip_code: "95131",

    ste_name: "CA",
  },
  {
    zip_code: "95133",

    ste_name: "CA",
  },
  {
    zip_code: "95139",

    ste_name: "CA",
  },
  {
    zip_code: "95233",

    ste_name: "CA",
  },
  {
    zip_code: "95337",

    ste_name: "CA",
  },
  {
    zip_code: "95340",

    ste_name: "CA",
  },
  {
    zip_code: "95454",

    ste_name: "CA",
  },
  {
    zip_code: "95460",

    ste_name: "CA",
  },
  {
    zip_code: "95528",

    ste_name: "CA",
  },
  {
    zip_code: "95646",

    ste_name: "CA",
  },
  {
    zip_code: "95939",

    ste_name: "CA",
  },
  {
    zip_code: "96006",

    ste_name: "CA",
  },
  {
    zip_code: "96057",

    ste_name: "CA",
  },
  {
    zip_code: "96061",

    ste_name: "CA",
  },
  {
    zip_code: "96067",

    ste_name: "CA",
  },
  {
    zip_code: "96107",

    ste_name: "CA",
  },
  {
    zip_code: "96710",

    ste_name: "HI",
  },
  {
    zip_code: "96765",

    ste_name: "HI",
  },
  {
    zip_code: "96779",

    ste_name: "HI",
  },
  {
    zip_code: "96789",

    ste_name: "HI",
  },
  {
    zip_code: "96822",

    ste_name: "HI",
  },
  {
    zip_code: "96825",

    ste_name: "HI",
  },
  {
    zip_code: "97002",

    ste_name: "OR",
  },
  {
    zip_code: "97016",

    ste_name: "OR",
  },
  {
    zip_code: "97028",

    ste_name: "OR",
  },
  {
    zip_code: "97051",

    ste_name: "OR",
  },
  {
    zip_code: "97132",

    ste_name: "OR",
  },
  {
    zip_code: "97201",

    ste_name: "OR",
  },
  {
    zip_code: "97215",

    ste_name: "OR",
  },
  {
    zip_code: "97330",

    ste_name: "OR",
  },
  {
    zip_code: "97345",

    ste_name: "OR",
  },
  {
    zip_code: "97532",

    ste_name: "OR",
  },
  {
    zip_code: "97633",

    ste_name: "OR",
  },
  {
    zip_code: "97814",

    ste_name: "OR",
  },
  {
    zip_code: "97824",

    ste_name: "OR",
  },
  {
    zip_code: "97827",

    ste_name: "OR",
  },
  {
    zip_code: "97876",

    ste_name: "OR",
  },
  {
    zip_code: "97880",

    ste_name: "OR",
  },
  {
    zip_code: "97882",

    ste_name: "OR",
  },
  {
    zip_code: "97886",

    ste_name: "OR",
  },
  {
    zip_code: "98007",

    ste_name: "WA",
  },
  {
    zip_code: "98188",

    ste_name: "WA",
  },
  {
    zip_code: "98252",

    ste_name: "WA",
  },
  {
    zip_code: "98266",

    ste_name: "WA",
  },
  {
    zip_code: "98314",

    ste_name: "WA",
  },
  {
    zip_code: "92567",

    ste_name: "CA",
  },
  {
    zip_code: "92637",

    ste_name: "CA",
  },
  {
    zip_code: "92707",

    ste_name: "CA",
  },
  {
    zip_code: "93280",

    ste_name: "CA",
  },
  {
    zip_code: "93453",

    ste_name: "CA",
  },
  {
    zip_code: "93652",

    ste_name: "CA",
  },
  {
    zip_code: "93669",

    ste_name: "CA",
  },
  {
    zip_code: "93675",

    ste_name: "CA",
  },
  {
    zip_code: "93704",

    ste_name: "CA",
  },
  {
    zip_code: "93923",

    ste_name: "CA",
  },
  {
    zip_code: "94027",

    ste_name: "CA",
  },
  {
    zip_code: "94044",

    ste_name: "CA",
  },
  {
    zip_code: "98402",

    ste_name: "WA",
  },
  {
    zip_code: "98406",

    ste_name: "WA",
  },
  {
    zip_code: "98439",

    ste_name: "WA",
  },
  {
    zip_code: "98502",

    ste_name: "WA",
  },
  {
    zip_code: "98606",

    ste_name: "WA",
  },
  {
    zip_code: "98614",

    ste_name: "WA",
  },
  {
    zip_code: "98682",

    ste_name: "WA",
  },
  {
    zip_code: "98815",

    ste_name: "WA",
  },
  {
    zip_code: "98921",

    ste_name: "WA",
  },
  {
    zip_code: "98940",

    ste_name: "WA",
  },
  {
    zip_code: "99023",

    ste_name: "WA",
  },
  {
    zip_code: "99174",

    ste_name: "WA",
  },
  {
    zip_code: "99185",

    ste_name: "WA",
  },
  {
    zip_code: "99352",

    ste_name: "WA",
  },
  {
    zip_code: "99363",

    ste_name: "WA",
  },
  {
    zip_code: "99513",

    ste_name: "AK",
  },
  {
    zip_code: "99558",

    ste_name: "AK",
  },
  {
    zip_code: "99620",

    ste_name: "AK",
  },
  {
    zip_code: "99654",

    ste_name: "AK",
  },
  {
    zip_code: "99662",

    ste_name: "AK",
  },
  {
    zip_code: "99681",

    ste_name: "AK",
  },
  {
    zip_code: "99688",

    ste_name: "AK",
  },
  {
    zip_code: "99724",

    ste_name: "AK",
  },
  {
    zip_code: "99782",

    ste_name: "AK",
  },
  {
    zip_code: "99791",

    ste_name: "AK",
  },
  {
    zip_code: "99901",

    ste_name: "AK",
  },
  {
    zip_code: "59031",

    ste_name: "MT",
  },
  {
    zip_code: "59087",

    ste_name: "MT",
  },
  {
    zip_code: "59276",

    ste_name: "MT",
  },
  {
    zip_code: "59337",

    ste_name: "MT",
  },
  {
    zip_code: "59430",

    ste_name: "MT",
  },
  {
    zip_code: "59537",

    ste_name: "MT",
  },
  {
    zip_code: "59703",

    ste_name: "MT",
  },
  {
    zip_code: "59743",

    ste_name: "MT",
  },
  {
    zip_code: "59848",

    ste_name: "MT",
  },
  {
    zip_code: "59920",

    ste_name: "MT",
  },
  {
    zip_code: "59922",

    ste_name: "MT",
  },
  {
    zip_code: "60008",

    ste_name: "IL",
  },
  {
    zip_code: "60087",

    ste_name: "IL",
  },
  {
    zip_code: "60404",

    ste_name: "IL",
  },
  {
    zip_code: "60466",

    ste_name: "IL",
  },
  {
    zip_code: "60491",

    ste_name: "IL",
  },
  {
    zip_code: "60515",

    ste_name: "IL",
  },
  {
    zip_code: "60530",

    ste_name: "IL",
  },
  {
    zip_code: "60546",

    ste_name: "IL",
  },
  {
    zip_code: "60931",

    ste_name: "IL",
  },
  {
    zip_code: "61021",

    ste_name: "IL",
  },
  {
    zip_code: "61030",

    ste_name: "IL",
  },
  {
    zip_code: "61057",

    ste_name: "IL",
  },
  {
    zip_code: "61079",

    ste_name: "IL",
  },
  {
    zip_code: "61084",

    ste_name: "IL",
  },
  {
    zip_code: "61238",

    ste_name: "IL",
  },
  {
    zip_code: "61326",

    ste_name: "IL",
  },
  {
    zip_code: "61348",

    ste_name: "IL",
  },
  {
    zip_code: "61353",

    ste_name: "IL",
  },
  {
    zip_code: "61410",

    ste_name: "IL",
  },
  {
    zip_code: "61451",

    ste_name: "IL",
  },
  {
    zip_code: "61479",

    ste_name: "IL",
  },
  {
    zip_code: "61533",

    ste_name: "IL",
  },
  {
    zip_code: "61560",

    ste_name: "IL",
  },
  {
    zip_code: "61603",

    ste_name: "IL",
  },
  {
    zip_code: "61625",

    ste_name: "IL",
  },
  {
    zip_code: "61743",

    ste_name: "IL",
  },
  {
    zip_code: "61830",

    ste_name: "IL",
  },
  {
    zip_code: "61917",

    ste_name: "IL",
  },
  {
    zip_code: "62078",

    ste_name: "IL",
  },
  {
    zip_code: "62091",

    ste_name: "IL",
  },
  {
    zip_code: "62285",

    ste_name: "IL",
  },
  {
    zip_code: "62345",

    ste_name: "IL",
  },
  {
    zip_code: "62478",

    ste_name: "IL",
  },
  {
    zip_code: "62534",

    ste_name: "IL",
  },
  {
    zip_code: "62538",

    ste_name: "IL",
  },
  {
    zip_code: "62549",

    ste_name: "IL",
  },
  {
    zip_code: "62621",

    ste_name: "IL",
  },
  {
    zip_code: "62810",

    ste_name: "IL",
  },
  {
    zip_code: "62820",

    ste_name: "IL",
  },
  {
    zip_code: "62824",

    ste_name: "IL",
  },
  {
    zip_code: "62858",

    ste_name: "IL",
  },
  {
    zip_code: "62859",

    ste_name: "IL",
  },
  {
    zip_code: "62861",

    ste_name: "IL",
  },
  {
    zip_code: "62883",

    ste_name: "IL",
  },
  {
    zip_code: "62888",

    ste_name: "IL",
  },
  {
    zip_code: "62898",

    ste_name: "IL",
  },
  {
    zip_code: "62905",

    ste_name: "IL",
  },
  {
    zip_code: "62935",

    ste_name: "IL",
  },
  {
    zip_code: "62947",

    ste_name: "IL",
  },
  {
    zip_code: "62949",

    ste_name: "IL",
  },
  {
    zip_code: "62992",

    ste_name: "IL",
  },
  {
    zip_code: "63016",

    ste_name: "MO",
  },
  {
    zip_code: "63034",

    ste_name: "MO",
  },
  {
    zip_code: "63051",

    ste_name: "MO",
  },
  {
    zip_code: "63056",

    ste_name: "MO",
  },
  {
    zip_code: "63057",

    ste_name: "MO",
  },
  {
    zip_code: "63454",

    ste_name: "MO",
  },
  {
    zip_code: "63628",

    ste_name: "MO",
  },
  {
    zip_code: "63703",

    ste_name: "MO",
  },
  {
    zip_code: "64012",

    ste_name: "MO",
  },
  {
    zip_code: "64048",

    ste_name: "MO",
  },
  {
    zip_code: "64060",

    ste_name: "MO",
  },
  {
    zip_code: "64111",

    ste_name: "MO",
  },
  {
    zip_code: "64118",

    ste_name: "MO",
  },
  {
    zip_code: "64163",

    ste_name: "MO",
  },
  {
    zip_code: "64456",

    ste_name: "MO",
  },
  {
    zip_code: "64726",

    ste_name: "MO",
  },
  {
    zip_code: "64738",

    ste_name: "MO",
  },
  {
    zip_code: "64746",

    ste_name: "MO",
  },
  {
    zip_code: "64831",

    ste_name: "MO",
  },
  {
    zip_code: "64835",

    ste_name: "MO",
  },
  {
    zip_code: "65025",

    ste_name: "MO",
  },
  {
    zip_code: "65109",

    ste_name: "MO",
  },
  {
    zip_code: "65321",

    ste_name: "MO",
  },
  {
    zip_code: "65334",

    ste_name: "MO",
  },
  {
    zip_code: "65664",

    ste_name: "MO",
  },
  {
    zip_code: "65668",

    ste_name: "MO",
  },
  {
    zip_code: "65710",

    ste_name: "MO",
  },
  {
    zip_code: "65713",

    ste_name: "MO",
  },
  {
    zip_code: "65744",

    ste_name: "MO",
  },
  {
    zip_code: "65771",

    ste_name: "MO",
  },
  {
    zip_code: "66041",

    ste_name: "KS",
  },
  {
    zip_code: "66205",

    ste_name: "KS",
  },
  {
    zip_code: "66213",

    ste_name: "KS",
  },
  {
    zip_code: "66416",

    ste_name: "KS",
  },
  {
    zip_code: "66434",

    ste_name: "KS",
  },
  {
    zip_code: "66521",

    ste_name: "KS",
  },
  {
    zip_code: "66541",

    ste_name: "KS",
  },
  {
    zip_code: "66542",

    ste_name: "KS",
  },
  {
    zip_code: "66549",

    ste_name: "KS",
  },
  {
    zip_code: "66734",

    ste_name: "KS",
  },
  {
    zip_code: "66771",

    ste_name: "KS",
  },
  {
    zip_code: "66868",

    ste_name: "KS",
  },
  {
    zip_code: "66955",

    ste_name: "KS",
  },
  {
    zip_code: "67003",

    ste_name: "KS",
  },
  {
    zip_code: "67016",

    ste_name: "KS",
  },
  {
    zip_code: "67054",

    ste_name: "KS",
  },
  {
    zip_code: "67117",

    ste_name: "KS",
  },
  {
    zip_code: "67235",

    ste_name: "KS",
  },
  {
    zip_code: "67344",

    ste_name: "KS",
  },
  {
    zip_code: "67430",

    ste_name: "KS",
  },
  {
    zip_code: "67514",

    ste_name: "KS",
  },
  {
    zip_code: "67553",

    ste_name: "KS",
  },
  {
    zip_code: "67567",

    ste_name: "KS",
  },
  {
    zip_code: "67844",

    ste_name: "KS",
  },
  {
    zip_code: "67882",

    ste_name: "KS",
  },
  {
    zip_code: "68004",

    ste_name: "NE",
  },
  {
    zip_code: "68025",

    ste_name: "NE",
  },
  {
    zip_code: "68037",

    ste_name: "NE",
  },
  {
    zip_code: "68142",

    ste_name: "NE",
  },
  {
    zip_code: "68352",

    ste_name: "NE",
  },
  {
    zip_code: "68360",

    ste_name: "NE",
  },
  {
    zip_code: "68362",

    ste_name: "NE",
  },
  {
    zip_code: "68364",

    ste_name: "NE",
  },
  {
    zip_code: "68422",

    ste_name: "NE",
  },
  {
    zip_code: "68445",

    ste_name: "NE",
  },
  {
    zip_code: "68448",

    ste_name: "NE",
  },
  {
    zip_code: "68505",

    ste_name: "NE",
  },
  {
    zip_code: "68620",

    ste_name: "NE",
  },
  {
    zip_code: "68719",

    ste_name: "NE",
  },
  {
    zip_code: "68760",

    ste_name: "NE",
  },
  {
    zip_code: "68941",

    ste_name: "NE",
  },
  {
    zip_code: "69367",

    ste_name: "NE",
  },
  {
    zip_code: "70079",

    ste_name: "LA",
  },
  {
    zip_code: "70085",

    ste_name: "LA",
  },
  {
    zip_code: "70118",

    ste_name: "LA",
  },
  {
    zip_code: "70354",

    ste_name: "LA",
  },
  {
    zip_code: "70380",

    ste_name: "LA",
  },
  {
    zip_code: "70570",

    ste_name: "LA",
  },
  {
    zip_code: "70759",

    ste_name: "LA",
  },
  {
    zip_code: "70815",

    ste_name: "LA",
  },
  {
    zip_code: "71044",

    ste_name: "LA",
  },
  {
    zip_code: "71105",

    ste_name: "LA",
  },
  {
    zip_code: "71301",

    ste_name: "LA",
  },
  {
    zip_code: "71342",

    ste_name: "LA",
  },
  {
    zip_code: "71378",

    ste_name: "LA",
  },
  {
    zip_code: "71401",

    ste_name: "LA",
  },
  {
    zip_code: "71419",

    ste_name: "LA",
  },
  {
    zip_code: "71469",

    ste_name: "LA",
  },
  {
    zip_code: "71630",

    ste_name: "AR",
  },
  {
    zip_code: "71667",

    ste_name: "AR",
  },
  {
    zip_code: "71845",

    ste_name: "AR",
  },
  {
    zip_code: "71854",

    ste_name: "AR",
  },
  {
    zip_code: "71929",

    ste_name: "AR",
  },
  {
    zip_code: "71970",

    ste_name: "AR",
  },
  {
    zip_code: "71972",

    ste_name: "AR",
  },
  {
    zip_code: "72029",

    ste_name: "AR",
  },
  {
    zip_code: "72037",

    ste_name: "AR",
  },
  {
    zip_code: "72059",

    ste_name: "AR",
  },
  {
    zip_code: "72064",

    ste_name: "AR",
  },
  {
    zip_code: "72082",

    ste_name: "AR",
  },
  {
    zip_code: "72103",

    ste_name: "AR",
  },
  {
    zip_code: "72126",

    ste_name: "AR",
  },
  {
    zip_code: "72137",

    ste_name: "AR",
  },
  {
    zip_code: "72167",

    ste_name: "AR",
  },
  {
    zip_code: "72426",

    ste_name: "AR",
  },
  {
    zip_code: "72427",

    ste_name: "AR",
  },
  {
    zip_code: "72438",

    ste_name: "AR",
  },
  {
    zip_code: "72447",

    ste_name: "AR",
  },
  {
    zip_code: "72550",

    ste_name: "AR",
  },
  {
    zip_code: "72587",

    ste_name: "AR",
  },
  {
    zip_code: "72630",

    ste_name: "AR",
  },
  {
    zip_code: "72642",

    ste_name: "AR",
  },
  {
    zip_code: "72734",

    ste_name: "AR",
  },
  {
    zip_code: "72745",

    ste_name: "AR",
  },
  {
    zip_code: "72842",

    ste_name: "AR",
  },
  {
    zip_code: "73005",

    ste_name: "OK",
  },
  {
    zip_code: "73034",

    ste_name: "OK",
  },
  {
    zip_code: "73107",

    ste_name: "OK",
  },
  {
    zip_code: "73112",

    ste_name: "OK",
  },
  {
    zip_code: "73121",

    ste_name: "OK",
  },
  {
    zip_code: "73131",

    ste_name: "OK",
  },
  {
    zip_code: "73173",

    ste_name: "OK",
  },
  {
    zip_code: "73439",

    ste_name: "OK",
  },
  {
    zip_code: "73456",

    ste_name: "OK",
  },
  {
    zip_code: "73572",

    ste_name: "OK",
  },
  {
    zip_code: "73644",

    ste_name: "OK",
  },
  {
    zip_code: "73763",

    ste_name: "OK",
  },
  {
    zip_code: "73852",

    ste_name: "OK",
  },
  {
    zip_code: "73938",

    ste_name: "OK",
  },
  {
    zip_code: "74030",

    ste_name: "OK",
  },
  {
    zip_code: "74038",

    ste_name: "OK",
  },
  {
    zip_code: "74058",

    ste_name: "OK",
  },
  {
    zip_code: "74330",

    ste_name: "OK",
  },
  {
    zip_code: "74458",

    ste_name: "OK",
  },
  {
    zip_code: "74530",

    ste_name: "OK",
  },
  {
    zip_code: "74557",

    ste_name: "OK",
  },
  {
    zip_code: "74560",

    ste_name: "OK",
  },
  {
    zip_code: "74565",

    ste_name: "OK",
  },
  {
    zip_code: "74569",

    ste_name: "OK",
  },
  {
    zip_code: "74724",

    ste_name: "OK",
  },
  {
    zip_code: "74729",

    ste_name: "OK",
  },
  {
    zip_code: "74736",

    ste_name: "OK",
  },
  {
    zip_code: "75062",

    ste_name: "TX",
  },
  {
    zip_code: "75070",

    ste_name: "TX",
  },
  {
    zip_code: "75082",

    ste_name: "TX",
  },
  {
    zip_code: "75407",

    ste_name: "TX",
  },
  {
    zip_code: "75424",

    ste_name: "TX",
  },
  {
    zip_code: "75561",

    ste_name: "TX",
  },
  {
    zip_code: "75602",

    ste_name: "TX",
  },
  {
    zip_code: "75759",

    ste_name: "TX",
  },
  {
    zip_code: "75840",

    ste_name: "TX",
  },
  {
    zip_code: "75959",

    ste_name: "TX",
  },
  {
    zip_code: "76043",

    ste_name: "TX",
  },
  {
    zip_code: "76044",

    ste_name: "TX",
  },
  {
    zip_code: "76088",

    ste_name: "TX",
  },
  {
    zip_code: "76108",

    ste_name: "TX",
  },
  {
    zip_code: "76126",

    ste_name: "TX",
  },
  {
    zip_code: "76148",

    ste_name: "TX",
  },
  {
    zip_code: "76471",

    ste_name: "TX",
  },
  {
    zip_code: "76491",

    ste_name: "TX",
  },
  {
    zip_code: "76556",

    ste_name: "TX",
  },
  {
    zip_code: "76656",

    ste_name: "TX",
  },
  {
    zip_code: "76661",

    ste_name: "TX",
  },
  {
    zip_code: "76708",

    ste_name: "TX",
  },
  {
    zip_code: "76869",

    ste_name: "TX",
  },
  {
    zip_code: "76939",

    ste_name: "TX",
  },
  {
    zip_code: "77015",

    ste_name: "TX",
  },
  {
    zip_code: "77040",

    ste_name: "TX",
  },
  {
    zip_code: "77089",

    ste_name: "TX",
  },
  {
    zip_code: "77360",

    ste_name: "TX",
  },
  {
    zip_code: "77362",

    ste_name: "TX",
  },
  {
    zip_code: "77479",

    ste_name: "TX",
  },
  {
    zip_code: "77590",

    ste_name: "TX",
  },
  {
    zip_code: "77871",

    ste_name: "TX",
  },
  {
    zip_code: "78008",

    ste_name: "TX",
  },
  {
    zip_code: "78060",

    ste_name: "TX",
  },
  {
    zip_code: "78150",

    ste_name: "TX",
  },
  {
    zip_code: "78209",

    ste_name: "TX",
  },
  {
    zip_code: "78214",

    ste_name: "TX",
  },
  {
    zip_code: "78343",

    ste_name: "TX",
  },
  {
    zip_code: "78504",

    ste_name: "TX",
  },
  {
    zip_code: "78606",

    ste_name: "TX",
  },
  {
    zip_code: "78645",

    ste_name: "TX",
  },
  {
    zip_code: "78663",

    ste_name: "TX",
  },
  {
    zip_code: "78739",

    ste_name: "TX",
  },
  {
    zip_code: "78872",

    ste_name: "TX",
  },
  {
    zip_code: "78873",

    ste_name: "TX",
  },
  {
    zip_code: "79003",

    ste_name: "TX",
  },
  {
    zip_code: "79072",

    ste_name: "TX",
  },
  {
    zip_code: "79356",

    ste_name: "TX",
  },
  {
    zip_code: "79512",

    ste_name: "TX",
  },
  {
    zip_code: "79735",

    ste_name: "TX",
  },
  {
    zip_code: "79902",

    ste_name: "TX",
  },
  {
    zip_code: "80204",

    ste_name: "CO",
  },
  {
    zip_code: "80238",

    ste_name: "CO",
  },
  {
    zip_code: "80481",

    ste_name: "CO",
  },
  {
    zip_code: "80482",

    ste_name: "CO",
  },
  {
    zip_code: "80545",

    ste_name: "CO",
  },
  {
    zip_code: "80624",

    ste_name: "CO",
  },
  {
    zip_code: "80742",

    ste_name: "CO",
  },
  {
    zip_code: "80827",

    ste_name: "CO",
  },
  {
    zip_code: "81038",

    ste_name: "CO",
  },
  {
    zip_code: "81057",

    ste_name: "CO",
  },
  {
    zip_code: "81071",

    ste_name: "CO",
  },
  {
    zip_code: "81128",

    ste_name: "CO",
  },
  {
    zip_code: "81129",

    ste_name: "CO",
  },
  {
    zip_code: "81130",

    ste_name: "CO",
  },
  {
    zip_code: "81132",

    ste_name: "CO",
  },
  {
    zip_code: "81235",

    ste_name: "CO",
  },
  {
    zip_code: "81237",

    ste_name: "CO",
  },
  {
    zip_code: "81431",

    ste_name: "CO",
  },
  {
    zip_code: "81645",

    ste_name: "CO",
  },
  {
    zip_code: "82217",

    ste_name: "WY",
  },
  {
    zip_code: "82432",

    ste_name: "WY",
  },
  {
    zip_code: "82731",

    ste_name: "WY",
  },
  {
    zip_code: "83236",

    ste_name: "ID",
  },
  {
    zip_code: "83262",

    ste_name: "ID",
  },
  {
    zip_code: "83414",

    ste_name: "WY",
  },
  {
    zip_code: "83420",

    ste_name: "ID",
  },
  {
    zip_code: "83423",

    ste_name: "ID",
  },
  {
    zip_code: "83425",

    ste_name: "ID",
  },
  {
    zip_code: "83670",

    ste_name: "ID",
  },
  {
    zip_code: "83814",

    ste_name: "ID",
  },
  {
    zip_code: "83864",

    ste_name: "ID",
  },
  {
    zip_code: "84022",

    ste_name: "UT",
  },
  {
    zip_code: "84053",

    ste_name: "UT",
  },
  {
    zip_code: "84057",

    ste_name: "UT",
  },
  {
    zip_code: "84086",

    ste_name: "UT",
  },
  {
    zip_code: "84404",

    ste_name: "UT",
  },
  {
    zip_code: "84515",

    ste_name: "UT",
  },
  {
    zip_code: "84520",

    ste_name: "UT",
  },
  {
    zip_code: "84540",

    ste_name: "UT",
  },
  {
    zip_code: "84626",

    ste_name: "UT",
  },
  {
    zip_code: "84631",

    ste_name: "UT",
  },
  {
    zip_code: "84653",

    ste_name: "UT",
  },
  {
    zip_code: "84719",

    ste_name: "UT",
  },
  {
    zip_code: "84746",

    ste_name: "UT",
  },
  {
    zip_code: "85031",

    ste_name: "AZ",
  },
  {
    zip_code: "85053",

    ste_name: "AZ",
  },
  {
    zip_code: "85224",

    ste_name: "AZ",
  },
  {
    zip_code: "85251",

    ste_name: "AZ",
  },
  {
    zip_code: "85531",

    ste_name: "AZ",
  },
  {
    zip_code: "85602",

    ste_name: "AZ",
  },
  {
    zip_code: "85626",

    ste_name: "AZ",
  },
  {
    zip_code: "85631",

    ste_name: "AZ",
  },
  {
    zip_code: "85926",

    ste_name: "AZ",
  },
  {
    zip_code: "86003",

    ste_name: "AZ",
  },
  {
    zip_code: "86015",

    ste_name: "AZ",
  },
  {
    zip_code: "87052",

    ste_name: "NM",
  },
  {
    zip_code: "87056",

    ste_name: "NM",
  },
  {
    zip_code: "87410",

    ste_name: "NM",
  },
  {
    zip_code: "87539",

    ste_name: "NM",
  },
  {
    zip_code: "87569",

    ste_name: "NM",
  },
  {
    zip_code: "87574",

    ste_name: "NM",
  },
  {
    zip_code: "87736",

    ste_name: "NM",
  },
  {
    zip_code: "87943",

    ste_name: "NM",
  },
  {
    zip_code: "88046",

    ste_name: "NM",
  },
  {
    zip_code: "88081",

    ste_name: "NM",
  },
  {
    zip_code: "88201",

    ste_name: "NM",
  },
  {
    zip_code: "88346",

    ste_name: "NM",
  },
  {
    zip_code: "88352",

    ste_name: "NM",
  },
  {
    zip_code: "88411",

    ste_name: "NM",
  },
  {
    zip_code: "88417",

    ste_name: "NM",
  },
  {
    zip_code: "88430",

    ste_name: "NM",
  },
  {
    zip_code: "89104",

    ste_name: "NV",
  },
  {
    zip_code: "89134",

    ste_name: "NV",
  },
  {
    zip_code: "89445",

    ste_name: "NV",
  },
  {
    zip_code: "89446",

    ste_name: "NV",
  },
  {
    zip_code: "89506",

    ste_name: "NV",
  },
  {
    zip_code: "89702",

    ste_name: "NV",
  },
  {
    zip_code: "89820",

    ste_name: "NV",
  },
  {
    zip_code: "90043",

    ste_name: "CA",
  },
  {
    zip_code: "90211",

    ste_name: "CA",
  },
  {
    zip_code: "90280",

    ste_name: "CA",
  },
  {
    zip_code: "90501",

    ste_name: "CA",
  },
  {
    zip_code: "90506",

    ste_name: "CA",
  },
  {
    zip_code: "90605",

    ste_name: "CA",
  },
  {
    zip_code: "90680",

    ste_name: "CA",
  },
  {
    zip_code: "91202",

    ste_name: "CA",
  },
  {
    zip_code: "91208",

    ste_name: "CA",
  },
  {
    zip_code: "91303",

    ste_name: "CA",
  },
  {
    zip_code: "91342",

    ste_name: "CA",
  },
  {
    zip_code: "91501",

    ste_name: "CA",
  },
  {
    zip_code: "91607",

    ste_name: "CA",
  },
  {
    zip_code: "91740",

    ste_name: "CA",
  },
  {
    zip_code: "91786",

    ste_name: "CA",
  },
  {
    zip_code: "91931",

    ste_name: "CA",
  },
  {
    zip_code: "92009",

    ste_name: "CA",
  },
  {
    zip_code: "92069",

    ste_name: "CA",
  },
  {
    zip_code: "92082",

    ste_name: "CA",
  },
  {
    zip_code: "92106",

    ste_name: "CA",
  },
  {
    zip_code: "92332",

    ste_name: "CA",
  },
  {
    zip_code: "92358",

    ste_name: "CA",
  },
  {
    zip_code: "92382",

    ste_name: "CA",
  },
  {
    zip_code: "92505",

    ste_name: "CA",
  },
  {
    zip_code: "92548",

    ste_name: "CA",
  },
  {
    zip_code: "92602",

    ste_name: "CA",
  },
  {
    zip_code: "92649",

    ste_name: "CA",
  },
  {
    zip_code: "92672",

    ste_name: "CA",
  },
  {
    zip_code: "92861",

    ste_name: "CA",
  },
  {
    zip_code: "93042",

    ste_name: "CA",
  },
  {
    zip_code: "93218",

    ste_name: "CA",
  },
  {
    zip_code: "93242",

    ste_name: "CA",
  },
  {
    zip_code: "93312",

    ste_name: "CA",
  },
  {
    zip_code: "93512",

    ste_name: "CA",
  },
  {
    zip_code: "93611",

    ste_name: "CA",
  },
  {
    zip_code: "93627",

    ste_name: "CA",
  },
  {
    zip_code: "93637",

    ste_name: "CA",
  },
  {
    zip_code: "93646",

    ste_name: "CA",
  },
  {
    zip_code: "94128",

    ste_name: "CA",
  },
  {
    zip_code: "94134",

    ste_name: "CA",
  },
  {
    zip_code: "94403",

    ste_name: "CA",
  },
  {
    zip_code: "94548",

    ste_name: "CA",
  },
  {
    zip_code: "94806",

    ste_name: "CA",
  },
  {
    zip_code: "94922",

    ste_name: "CA",
  },
  {
    zip_code: "94960",

    ste_name: "CA",
  },
  {
    zip_code: "95060",

    ste_name: "CA",
  },
  {
    zip_code: "95126",

    ste_name: "CA",
  },
  {
    zip_code: "95251",

    ste_name: "CA",
  },
  {
    zip_code: "95311",

    ste_name: "CA",
  },
  {
    zip_code: "95370",

    ste_name: "CA",
  },
  {
    zip_code: "95465",

    ste_name: "CA",
  },
  {
    zip_code: "95639",

    ste_name: "CA",
  },
  {
    zip_code: "95648",

    ste_name: "CA",
  },
  {
    zip_code: "95661",

    ste_name: "CA",
  },
  {
    zip_code: "95662",

    ste_name: "CA",
  },
  {
    zip_code: "95699",

    ste_name: "CA",
  },
  {
    zip_code: "95742",

    ste_name: "CA",
  },
  {
    zip_code: "95922",

    ste_name: "CA",
  },
  {
    zip_code: "95953",

    ste_name: "CA",
  },
  {
    zip_code: "95961",

    ste_name: "CA",
  },
  {
    zip_code: "95988",

    ste_name: "CA",
  },
  {
    zip_code: "96059",

    ste_name: "CA",
  },
  {
    zip_code: "96738",

    ste_name: "HI",
  },
  {
    zip_code: "96819",

    ste_name: "HI",
  },
  {
    zip_code: "97006",

    ste_name: "OR",
  },
  {
    zip_code: "97103",

    ste_name: "OR",
  },
  {
    zip_code: "97303",

    ste_name: "OR",
  },
  {
    zip_code: "97329",

    ste_name: "OR",
  },
  {
    zip_code: "97346",

    ste_name: "OR",
  },
  {
    zip_code: "97470",

    ste_name: "OR",
  },
  {
    zip_code: "97626",

    ste_name: "OR",
  },
  {
    zip_code: "97634",

    ste_name: "OR",
  },
  {
    zip_code: "97836",

    ste_name: "OR",
  },
  {
    zip_code: "97904",

    ste_name: "OR",
  },
  {
    zip_code: "98125",

    ste_name: "WA",
  },
  {
    zip_code: "98240",

    ste_name: "WA",
  },
  {
    zip_code: "98241",

    ste_name: "WA",
  },
  {
    zip_code: "21770",

    ste_name: "MD",
  },
  {
    zip_code: "21872",

    ste_name: "MD",
  },
  {
    zip_code: "21875",

    ste_name: "MD",
  },
  {
    zip_code: "21915",

    ste_name: "MD",
  },
  {
    zip_code: "22043",

    ste_name: "VA",
  },
  {
    zip_code: "22203",

    ste_name: "VA",
  },
  {
    zip_code: "22509",

    ste_name: "VA",
  },
  {
    zip_code: "22630",

    ste_name: "VA",
  },
  {
    zip_code: "22646",

    ste_name: "VA",
  },
  {
    zip_code: "22664",

    ste_name: "VA",
  },
  {
    zip_code: "22801",

    ste_name: "VA",
  },
  {
    zip_code: "23011",

    ste_name: "VA",
  },
  {
    zip_code: "23030",

    ste_name: "VA",
  },
  {
    zip_code: "23043",

    ste_name: "VA",
  },
  {
    zip_code: "23093",

    ste_name: "VA",
  },
  {
    zip_code: "23119",

    ste_name: "VA",
  },
  {
    zip_code: "23175",

    ste_name: "VA",
  },
  {
    zip_code: "23430",

    ste_name: "VA",
  },
  {
    zip_code: "23460",

    ste_name: "VA",
  },
  {
    zip_code: "23831",

    ste_name: "VA",
  },
  {
    zip_code: "23901",

    ste_name: "VA",
  },
  {
    zip_code: "23964",

    ste_name: "VA",
  },
  {
    zip_code: "23970",

    ste_name: "VA",
  },
  {
    zip_code: "24070",

    ste_name: "VA",
  },
  {
    zip_code: "24141",

    ste_name: "VA",
  },
  {
    zip_code: "24176",

    ste_name: "VA",
  },
  {
    zip_code: "24216",

    ste_name: "VA",
  },
  {
    zip_code: "24270",

    ste_name: "VA",
  },
  {
    zip_code: "24316",

    ste_name: "VA",
  },
  {
    zip_code: "24343",

    ste_name: "VA",
  },
  {
    zip_code: "24348",

    ste_name: "VA",
  },
  {
    zip_code: "24528",

    ste_name: "VA",
  },
  {
    zip_code: "24538",

    ste_name: "VA",
  },
  {
    zip_code: "24701",

    ste_name: "WV",
  },
  {
    zip_code: "24935",

    ste_name: "WV",
  },
  {
    zip_code: "24951",

    ste_name: "WV",
  },
  {
    zip_code: "25007",

    ste_name: "WV",
  },
  {
    zip_code: "25019",

    ste_name: "WV",
  },
  {
    zip_code: "25082",

    ste_name: "WV",
  },
  {
    zip_code: "25162",

    ste_name: "WV",
  },
  {
    zip_code: "25320",

    ste_name: "WV",
  },
  {
    zip_code: "25428",

    ste_name: "WV",
  },
  {
    zip_code: "25521",

    ste_name: "WV",
  },
  {
    zip_code: "25555",

    ste_name: "WV",
  },
  {
    zip_code: "25573",

    ste_name: "WV",
  },
  {
    zip_code: "25611",

    ste_name: "WV",
  },
  {
    zip_code: "25692",

    ste_name: "WV",
  },
  {
    zip_code: "25839",

    ste_name: "WV",
  },
  {
    zip_code: "25848",

    ste_name: "WV",
  },
  {
    zip_code: "25853",

    ste_name: "WV",
  },
  {
    zip_code: "25902",

    ste_name: "WV",
  },
  {
    zip_code: "25958",

    ste_name: "WV",
  },
  {
    zip_code: "26056",

    ste_name: "WV",
  },
  {
    zip_code: "26167",

    ste_name: "WV",
  },
  {
    zip_code: "26291",

    ste_name: "WV",
  },
  {
    zip_code: "26325",

    ste_name: "WV",
  },
  {
    zip_code: "26337",

    ste_name: "WV",
  },
  {
    zip_code: "26348",

    ste_name: "WV",
  },
  {
    zip_code: "26521",

    ste_name: "WV",
  },
  {
    zip_code: "26563",

    ste_name: "WV",
  },
  {
    zip_code: "26629",

    ste_name: "WV",
  },
  {
    zip_code: "26636",

    ste_name: "WV",
  },
  {
    zip_code: "26750",

    ste_name: "WV",
  },
  {
    zip_code: "27283",

    ste_name: "NC",
  },
  {
    zip_code: "27284",

    ste_name: "NC",
  },
  {
    zip_code: "27330",

    ste_name: "NC",
  },
  {
    zip_code: "27371",

    ste_name: "NC",
  },
  {
    zip_code: "27406",

    ste_name: "NC",
  },
  {
    zip_code: "27407",

    ste_name: "NC",
  },
  {
    zip_code: "27531",

    ste_name: "NC",
  },
  {
    zip_code: "27534",

    ste_name: "NC",
  },
  {
    zip_code: "27614",

    ste_name: "NC",
  },
  {
    zip_code: "27817",

    ste_name: "NC",
  },
  {
    zip_code: "27886",

    ste_name: "NC",
  },
  {
    zip_code: "27943",

    ste_name: "NC",
  },
  {
    zip_code: "27962",

    ste_name: "NC",
  },
  {
    zip_code: "28071",

    ste_name: "NC",
  },
  {
    zip_code: "28090",

    ste_name: "NC",
  },
  {
    zip_code: "28112",

    ste_name: "NC",
  },
  {
    zip_code: "28147",

    ste_name: "NC",
  },
  {
    zip_code: "28167",

    ste_name: "NC",
  },
  {
    zip_code: "28207",

    ste_name: "NC",
  },
  {
    zip_code: "28273",

    ste_name: "NC",
  },
  {
    zip_code: "28277",

    ste_name: "NC",
  },
  {
    zip_code: "28390",

    ste_name: "NC",
  },
  {
    zip_code: "28450",

    ste_name: "NC",
  },
  {
    zip_code: "28466",

    ste_name: "NC",
  },
  {
    zip_code: "28638",

    ste_name: "NC",
  },
  {
    zip_code: "28678",

    ste_name: "NC",
  },
  {
    zip_code: "28681",

    ste_name: "NC",
  },
  {
    zip_code: "28689",

    ste_name: "NC",
  },
  {
    zip_code: "28748",

    ste_name: "NC",
  },
  {
    zip_code: "28757",

    ste_name: "NC",
  },
  {
    zip_code: "28768",

    ste_name: "NC",
  },
  {
    zip_code: "28785",

    ste_name: "NC",
  },
  {
    zip_code: "29009",

    ste_name: "SC",
  },
  {
    zip_code: "29118",

    ste_name: "SC",
  },
  {
    zip_code: "29355",

    ste_name: "SC",
  },
  {
    zip_code: "29714",

    ste_name: "SC",
  },
  {
    zip_code: "30021",

    ste_name: "GA",
  },
  {
    zip_code: "30068",

    ste_name: "GA",
  },
  {
    zip_code: "30101",

    ste_name: "GA",
  },
  {
    zip_code: "30113",

    ste_name: "GA",
  },
  {
    zip_code: "30234",

    ste_name: "GA",
  },
  {
    zip_code: "30236",

    ste_name: "GA",
  },
  {
    zip_code: "30328",

    ste_name: "GA",
  },
  {
    zip_code: "30455",

    ste_name: "GA",
  },
  {
    zip_code: "30511",

    ste_name: "GA",
  },
  {
    zip_code: "30517",

    ste_name: "GA",
  },
  {
    zip_code: "30571",

    ste_name: "GA",
  },
  {
    zip_code: "30648",

    ste_name: "GA",
  },
  {
    zip_code: "30734",

    ste_name: "GA",
  },
  {
    zip_code: "98385",

    ste_name: "WA",
  },
  {
    zip_code: "98405",

    ste_name: "WA",
  },
  {
    zip_code: "98467",

    ste_name: "WA",
  },
  {
    zip_code: "98530",

    ste_name: "WA",
  },
  {
    zip_code: "98555",

    ste_name: "WA",
  },
  {
    zip_code: "98597",

    ste_name: "WA",
  },
  {
    zip_code: "98628",

    ste_name: "WA",
  },
  {
    zip_code: "98814",

    ste_name: "WA",
  },
  {
    zip_code: "98822",

    ste_name: "WA",
  },
  {
    zip_code: "98840",

    ste_name: "WA",
  },
  {
    zip_code: "98926",

    ste_name: "WA",
  },
  {
    zip_code: "99153",

    ste_name: "WA",
  },
  {
    zip_code: "99159",

    ste_name: "WA",
  },
  {
    zip_code: "99203",

    ste_name: "WA",
  },
  {
    zip_code: "99322",

    ste_name: "WA",
  },
  {
    zip_code: "99579",

    ste_name: "AK",
  },
  {
    zip_code: "99634",

    ste_name: "AK",
  },
  {
    zip_code: "99801",

    ste_name: "AK",
  },
  {
    zip_code: "99825",

    ste_name: "AK",
  },
  {
    zip_code: "99830",

    ste_name: "AK",
  },
  {
    zip_code: "610",

    ste_name: "PR",
  },
  {
    zip_code: "674",

    ste_name: "PR",
  },
  {
    zip_code: "851",

    ste_name: "VI",
  },
  {
    zip_code: "912",

    ste_name: "PR",
  },
  {
    zip_code: "925",

    ste_name: "PR",
  },
  {
    zip_code: "934",

    ste_name: "PR",
  },
  {
    zip_code: "1031",

    ste_name: "MA",
  },
  {
    zip_code: "1060",

    ste_name: "MA",
  },
  {
    zip_code: "1085",

    ste_name: "MA",
  },
  {
    zip_code: "1088",

    ste_name: "MA",
  },
  {
    zip_code: "1259",

    ste_name: "MA",
  },
  {
    zip_code: "1337",

    ste_name: "MA",
  },
  {
    zip_code: "1529",

    ste_name: "MA",
  },
  {
    zip_code: "1532",

    ste_name: "MA",
  },
  {
    zip_code: "1562",

    ste_name: "MA",
  },
  {
    zip_code: "1608",

    ste_name: "MA",
  },
  {
    zip_code: "1611",

    ste_name: "MA",
  },
  {
    zip_code: "1901",

    ste_name: "MA",
  },
  {
    zip_code: "1944",

    ste_name: "MA",
  },
  {
    zip_code: "2026",

    ste_name: "MA",
  },
  {
    zip_code: "2081",

    ste_name: "MA",
  },
  {
    zip_code: "2191",

    ste_name: "MA",
  },
  {
    zip_code: "2562",

    ste_name: "MA",
  },
  {
    zip_code: "2668",

    ste_name: "MA",
  },
  {
    zip_code: "2673",

    ste_name: "MA",
  },
  {
    zip_code: "2725",

    ste_name: "MA",
  },
  {
    zip_code: "2780",

    ste_name: "MA",
  },
  {
    zip_code: "2791",

    ste_name: "MA",
  },
  {
    zip_code: "2815",

    ste_name: "RI",
  },
  {
    zip_code: "2904",

    ste_name: "RI",
  },
  {
    zip_code: "2920",

    ste_name: "RI",
  },
  {
    zip_code: "3109",

    ste_name: "NH",
  },
  {
    zip_code: "3285",

    ste_name: "NH",
  },
  {
    zip_code: "3750",

    ste_name: "NH",
  },
  {
    zip_code: "3813",

    ste_name: "NH",
  },
  {
    zip_code: "3833",

    ste_name: "NH",
  },
  {
    zip_code: "3839",

    ste_name: "NH",
  },
  {
    zip_code: "3848",

    ste_name: "NH",
  },
  {
    zip_code: "4079",

    ste_name: "ME",
  },
  {
    zip_code: "4090",

    ste_name: "ME",
  },
  {
    zip_code: "4102",

    ste_name: "ME",
  },
  {
    zip_code: "4210",

    ste_name: "ME",
  },
  {
    zip_code: "4216",

    ste_name: "ME",
  },
  {
    zip_code: "4282",

    ste_name: "ME",
  },
  {
    zip_code: "4348",

    ste_name: "ME",
  },
  {
    zip_code: "4350",

    ste_name: "ME",
  },
  {
    zip_code: "4478",

    ste_name: "ME",
  },
  {
    zip_code: "4551",

    ste_name: "ME",
  },
  {
    zip_code: "4623",

    ste_name: "ME",
  },
  {
    zip_code: "4642",

    ste_name: "ME",
  },
  {
    zip_code: "4679",

    ste_name: "ME",
  },
  {
    zip_code: "4684",

    ste_name: "ME",
  },
  {
    zip_code: "4730",

    ste_name: "ME",
  },
  {
    zip_code: "4740",

    ste_name: "ME",
  },
  {
    zip_code: "4901",

    ste_name: "ME",
  },
  {
    zip_code: "4936",

    ste_name: "ME",
  },
  {
    zip_code: "4944",

    ste_name: "ME",
  },
  {
    zip_code: "4952",

    ste_name: "ME",
  },
  {
    zip_code: "5055",

    ste_name: "VT",
  },
  {
    zip_code: "5153",

    ste_name: "VT",
  },
  {
    zip_code: "5401",

    ste_name: "VT",
  },
  {
    zip_code: "5447",

    ste_name: "VT",
  },
  {
    zip_code: "5473",

    ste_name: "VT",
  },
  {
    zip_code: "5648",

    ste_name: "VT",
  },
  {
    zip_code: "5760",

    ste_name: "VT",
  },
  {
    zip_code: "5766",

    ste_name: "VT",
  },
  {
    zip_code: "5774",

    ste_name: "VT",
  },
  {
    zip_code: "5828",

    ste_name: "VT",
  },
  {
    zip_code: "6016",

    ste_name: "CT",
  },
  {
    zip_code: "6103",

    ste_name: "CT",
  },
  {
    zip_code: "6357",

    ste_name: "CT",
  },
  {
    zip_code: "6375",

    ste_name: "CT",
  },
  {
    zip_code: "6384",

    ste_name: "CT",
  },
  {
    zip_code: "6456",

    ste_name: "CT",
  },
  {
    zip_code: "6514",

    ste_name: "CT",
  },
  {
    zip_code: "6702",

    ste_name: "CT",
  },
  {
    zip_code: "6756",

    ste_name: "CT",
  },
  {
    zip_code: "6851",

    ste_name: "CT",
  },
  {
    zip_code: "7017",

    ste_name: "NJ",
  },
  {
    zip_code: "7078",

    ste_name: "NJ",
  },
  {
    zip_code: "7082",

    ste_name: "NJ",
  },
  {
    zip_code: "7401",

    ste_name: "NJ",
  },
  {
    zip_code: "7626",

    ste_name: "NJ",
  },
  {
    zip_code: "7660",

    ste_name: "NJ",
  },
  {
    zip_code: "7703",

    ste_name: "NJ",
  },
  {
    zip_code: "7758",

    ste_name: "NJ",
  },
  {
    zip_code: "8007",

    ste_name: "NJ",
  },
  {
    zip_code: "8079",

    ste_name: "NJ",
  },
  {
    zip_code: "8324",

    ste_name: "NJ",
  },
  {
    zip_code: "8853",

    ste_name: "NJ",
  },
  {
    zip_code: "10011",

    ste_name: "NY",
  },
  {
    zip_code: "10019",

    ste_name: "NY",
  },
  {
    zip_code: "10022",

    ste_name: "NY",
  },
  {
    zip_code: "10040",

    ste_name: "NY",
  },
  {
    zip_code: "10312",

    ste_name: "NY",
  },
  {
    zip_code: "10528",

    ste_name: "NY",
  },
  {
    zip_code: "10962",

    ste_name: "NY",
  },
  {
    zip_code: "11238",

    ste_name: "NY",
  },
  {
    zip_code: "11351",

    ste_name: "NY",
  },
  {
    zip_code: "11554",

    ste_name: "NY",
  },
  {
    zip_code: "11598",

    ste_name: "NY",
  },
  {
    zip_code: "11693",

    ste_name: "NY",
  },
  {
    zip_code: "11701",

    ste_name: "NY",
  },
  {
    zip_code: "11706",

    ste_name: "NY",
  },
  {
    zip_code: "11769",

    ste_name: "NY",
  },
  {
    zip_code: "11931",

    ste_name: "NY",
  },
  {
    zip_code: "12029",

    ste_name: "NY",
  },
  {
    zip_code: "12047",

    ste_name: "NY",
  },
  {
    zip_code: "12068",

    ste_name: "NY",
  },
  {
    zip_code: "12173",

    ste_name: "NY",
  },
  {
    zip_code: "12470",

    ste_name: "NY",
  },
  {
    zip_code: "12517",

    ste_name: "NY",
  },
  {
    zip_code: "12521",

    ste_name: "NY",
  },
  {
    zip_code: "12729",

    ste_name: "NY",
  },
  {
    zip_code: "12749",

    ste_name: "NY",
  },
  {
    zip_code: "12791",

    ste_name: "NY",
  },
  {
    zip_code: "12803",

    ste_name: "NY",
  },
  {
    zip_code: "12847",

    ste_name: "NY",
  },
  {
    zip_code: "12864",

    ste_name: "NY",
  },
  {
    zip_code: "12923",

    ste_name: "NY",
  },
  {
    zip_code: "12993",

    ste_name: "NY",
  },
  {
    zip_code: "12996",

    ste_name: "NY",
  },
  {
    zip_code: "13035",

    ste_name: "NY",
  },
  {
    zip_code: "13052",

    ste_name: "NY",
  },
  {
    zip_code: "13134",

    ste_name: "NY",
  },
  {
    zip_code: "13146",

    ste_name: "NY",
  },
  {
    zip_code: "13209",

    ste_name: "NY",
  },
  {
    zip_code: "13319",

    ste_name: "NY",
  },
  {
    zip_code: "13461",

    ste_name: "NY",
  },
  {
    zip_code: "13602",

    ste_name: "NY",
  },
  {
    zip_code: "13608",

    ste_name: "NY",
  },
  {
    zip_code: "13617",

    ste_name: "NY",
  },
  {
    zip_code: "13641",

    ste_name: "NY",
  },
  {
    zip_code: "13647",

    ste_name: "NY",
  },
  {
    zip_code: "13676",

    ste_name: "NY",
  },
  {
    zip_code: "13681",

    ste_name: "NY",
  },
  {
    zip_code: "13833",

    ste_name: "NY",
  },
  {
    zip_code: "13834",

    ste_name: "NY",
  },
  {
    zip_code: "14058",

    ste_name: "NY",
  },
  {
    zip_code: "14223",

    ste_name: "NY",
  },
  {
    zip_code: "14441",

    ste_name: "NY",
  },
  {
    zip_code: "14539",

    ste_name: "NY",
  },
  {
    zip_code: "14627",

    ste_name: "NY",
  },
  {
    zip_code: "14781",

    ste_name: "NY",
  },
  {
    zip_code: "14788",

    ste_name: "NY",
  },
  {
    zip_code: "14861",

    ste_name: "NY",
  },
  {
    zip_code: "14867",

    ste_name: "NY",
  },
  {
    zip_code: "15087",

    ste_name: "PA",
  },
  {
    zip_code: "15202",

    ste_name: "PA",
  },
  {
    zip_code: "15310",

    ste_name: "PA",
  },
  {
    zip_code: "15420",

    ste_name: "PA",
  },
  {
    zip_code: "15436",

    ste_name: "PA",
  },
  {
    zip_code: "15447",

    ste_name: "PA",
  },
  {
    zip_code: "15464",

    ste_name: "PA",
  },
  {
    zip_code: "15482",

    ste_name: "PA",
  },
  {
    zip_code: "15520",

    ste_name: "PA",
  },
  {
    zip_code: "15532",

    ste_name: "PA",
  },
  {
    zip_code: "15552",

    ste_name: "PA",
  },
  {
    zip_code: "15561",

    ste_name: "PA",
  },
  {
    zip_code: "15695",

    ste_name: "PA",
  },
  {
    zip_code: "15765",

    ste_name: "PA",
  },
  {
    zip_code: "15775",

    ste_name: "PA",
  },
  {
    zip_code: "15904",

    ste_name: "PA",
  },
  {
    zip_code: "15957",

    ste_name: "PA",
  },
  {
    zip_code: "15962",

    ste_name: "PA",
  },
  {
    zip_code: "16033",

    ste_name: "PA",
  },
  {
    zip_code: "16061",

    ste_name: "PA",
  },
  {
    zip_code: "16154",

    ste_name: "PA",
  },
  {
    zip_code: "16323",

    ste_name: "PA",
  },
  {
    zip_code: "16331",

    ste_name: "PA",
  },
  {
    zip_code: "16416",

    ste_name: "PA",
  },
  {
    zip_code: "16420",

    ste_name: "PA",
  },
  {
    zip_code: "16625",

    ste_name: "PA",
  },
  {
    zip_code: "16692",

    ste_name: "PA",
  },
  {
    zip_code: "16701",

    ste_name: "PA",
  },
  {
    zip_code: "16820",

    ste_name: "PA",
  },
  {
    zip_code: "16821",

    ste_name: "PA",
  },
  {
    zip_code: "16836",

    ste_name: "PA",
  },
  {
    zip_code: "16854",

    ste_name: "PA",
  },
  {
    zip_code: "16939",

    ste_name: "PA",
  },
  {
    zip_code: "17022",

    ste_name: "PA",
  },
  {
    zip_code: "17037",

    ste_name: "PA",
  },
  {
    zip_code: "17045",

    ste_name: "PA",
  },
  {
    zip_code: "17255",

    ste_name: "PA",
  },
  {
    zip_code: "17262",

    ste_name: "PA",
  },
  {
    zip_code: "17265",

    ste_name: "PA",
  },
  {
    zip_code: "17324",

    ste_name: "PA",
  },
  {
    zip_code: "17325",

    ste_name: "PA",
  },
  {
    zip_code: "17551",

    ste_name: "PA",
  },
  {
    zip_code: "17822",

    ste_name: "PA",
  },
  {
    zip_code: "18046",

    ste_name: "PA",
  },
  {
    zip_code: "18062",

    ste_name: "PA",
  },
  {
    zip_code: "18072",

    ste_name: "PA",
  },
  {
    zip_code: "18324",

    ste_name: "PA",
  },
  {
    zip_code: "18357",

    ste_name: "PA",
  },
  {
    zip_code: "18407",

    ste_name: "PA",
  },
  {
    zip_code: "18616",

    ste_name: "PA",
  },
  {
    zip_code: "18631",

    ste_name: "PA",
  },
  {
    zip_code: "18655",

    ste_name: "PA",
  },
  {
    zip_code: "18823",

    ste_name: "PA",
  },
  {
    zip_code: "18825",

    ste_name: "PA",
  },
  {
    zip_code: "18850",

    ste_name: "PA",
  },
  {
    zip_code: "19001",

    ste_name: "PA",
  },
  {
    zip_code: "19124",

    ste_name: "PA",
  },
  {
    zip_code: "19125",

    ste_name: "PA",
  },
  {
    zip_code: "19335",

    ste_name: "PA",
  },
  {
    zip_code: "19555",

    ste_name: "PA",
  },
  {
    zip_code: "19735",

    ste_name: "DE",
  },
  {
    zip_code: "19810",

    ste_name: "DE",
  },
  {
    zip_code: "19960",

    ste_name: "DE",
  },
  {
    zip_code: "20012",

    ste_name: "DC",
  },
  {
    zip_code: "20036",

    ste_name: "DC",
  },
  {
    zip_code: "20111",

    ste_name: "VA",
  },
  {
    zip_code: "20152",

    ste_name: "VA",
  },
  {
    zip_code: "20165",

    ste_name: "VA",
  },
  {
    zip_code: "20565",

    ste_name: "DC",
  },
  {
    zip_code: "20607",

    ste_name: "MD",
  },
  {
    zip_code: "20636",

    ste_name: "MD",
  },
  {
    zip_code: "20720",

    ste_name: "MD",
  },
  {
    zip_code: "20769",

    ste_name: "MD",
  },
  {
    zip_code: "20850",

    ste_name: "MD",
  },
  {
    zip_code: "20880",

    ste_name: "MD",
  },
  {
    zip_code: "20899",

    ste_name: "MD",
  },
  {
    zip_code: "21131",

    ste_name: "MD",
  },
  {
    zip_code: "21161",

    ste_name: "MD",
  },
  {
    zip_code: "21402",

    ste_name: "MD",
  },
  {
    zip_code: "21543",

    ste_name: "MD",
  },
  {
    zip_code: "21757",

    ste_name: "MD",
  },
  {
    zip_code: "31005",

    ste_name: "GA",
  },
  {
    zip_code: "31068",

    ste_name: "GA",
  },
  {
    zip_code: "31318",

    ste_name: "GA",
  },
  {
    zip_code: "31606",

    ste_name: "GA",
  },
  {
    zip_code: "31720",

    ste_name: "GA",
  },
  {
    zip_code: "31810",

    ste_name: "GA",
  },
  {
    zip_code: "32308",

    ste_name: "FL",
  },
  {
    zip_code: "32309",

    ste_name: "FL",
  },
  {
    zip_code: "32311",

    ste_name: "FL",
  },
  {
    zip_code: "32333",

    ste_name: "FL",
  },
  {
    zip_code: "32350",

    ste_name: "FL",
  },
  {
    zip_code: "32445",

    ste_name: "FL",
  },
  {
    zip_code: "32455",

    ste_name: "FL",
  },
  {
    zip_code: "32603",

    ste_name: "FL",
  },
  {
    zip_code: "32707",

    ste_name: "FL",
  },
  {
    zip_code: "32796",

    ste_name: "FL",
  },
  {
    zip_code: "32820",

    ste_name: "FL",
  },
  {
    zip_code: "32832",

    ste_name: "FL",
  },
  {
    zip_code: "32835",

    ste_name: "FL",
  },
  {
    zip_code: "33024",

    ste_name: "FL",
  },
  {
    zip_code: "33139",

    ste_name: "FL",
  },
  {
    zip_code: "33196",

    ste_name: "FL",
  },
  {
    zip_code: "33334",

    ste_name: "FL",
  },
  {
    zip_code: "33407",

    ste_name: "FL",
  },
  {
    zip_code: "33471",

    ste_name: "FL",
  },
  {
    zip_code: "33487",

    ste_name: "FL",
  },
  {
    zip_code: "33540",

    ste_name: "FL",
  },
  {
    zip_code: "33578",

    ste_name: "FL",
  },
  {
    zip_code: "33776",

    ste_name: "FL",
  },
  {
    zip_code: "33931",

    ste_name: "FL",
  },
  {
    zip_code: "34141",

    ste_name: "FL",
  },
  {
    zip_code: "34465",

    ste_name: "FL",
  },
  {
    zip_code: "34479",

    ste_name: "FL",
  },
  {
    zip_code: "34639",

    ste_name: "FL",
  },
  {
    zip_code: "34739",

    ste_name: "FL",
  },
  {
    zip_code: "34772",

    ste_name: "FL",
  },
  {
    zip_code: "34786",

    ste_name: "FL",
  },
  {
    zip_code: "34997",

    ste_name: "FL",
  },
  {
    zip_code: "35004",

    ste_name: "AL",
  },
  {
    zip_code: "35014",

    ste_name: "AL",
  },
  {
    zip_code: "35035",

    ste_name: "AL",
  },
  {
    zip_code: "35112",

    ste_name: "AL",
  },
  {
    zip_code: "35183",

    ste_name: "AL",
  },
  {
    zip_code: "35205",

    ste_name: "AL",
  },
  {
    zip_code: "35224",

    ste_name: "AL",
  },
  {
    zip_code: "35254",

    ste_name: "AL",
  },
  {
    zip_code: "35453",

    ste_name: "AL",
  },
  {
    zip_code: "35764",

    ste_name: "AL",
  },
  {
    zip_code: "35950",

    ste_name: "AL",
  },
  {
    zip_code: "36035",

    ste_name: "AL",
  },
  {
    zip_code: "36106",

    ste_name: "AL",
  },
  {
    zip_code: "36107",

    ste_name: "AL",
  },
  {
    zip_code: "36272",

    ste_name: "AL",
  },
  {
    zip_code: "36277",

    ste_name: "AL",
  },
  {
    zip_code: "36446",

    ste_name: "AL",
  },
  {
    zip_code: "36483",

    ste_name: "AL",
  },
  {
    zip_code: "36567",

    ste_name: "AL",
  },
  {
    zip_code: "36603",

    ste_name: "AL",
  },
  {
    zip_code: "36867",

    ste_name: "AL",
  },
  {
    zip_code: "37015",

    ste_name: "TN",
  },
  {
    zip_code: "37036",

    ste_name: "TN",
  },
  {
    zip_code: "37079",

    ste_name: "TN",
  },
  {
    zip_code: "37166",

    ste_name: "TN",
  },
  {
    zip_code: "37178",

    ste_name: "TN",
  },
  {
    zip_code: "37203",

    ste_name: "TN",
  },
  {
    zip_code: "37310",

    ste_name: "TN",
  },
  {
    zip_code: "37338",

    ste_name: "TN",
  },
  {
    zip_code: "37412",

    ste_name: "TN",
  },
  {
    zip_code: "37731",

    ste_name: "TN",
  },
  {
    zip_code: "37745",

    ste_name: "TN",
  },
  {
    zip_code: "37765",

    ste_name: "TN",
  },
  {
    zip_code: "37888",

    ste_name: "TN",
  },
  {
    zip_code: "37932",

    ste_name: "TN",
  },
  {
    zip_code: "38001",

    ste_name: "TN",
  },
  {
    zip_code: "38024",

    ste_name: "TN",
  },
  {
    zip_code: "38029",

    ste_name: "TN",
  },
  {
    zip_code: "38076",

    ste_name: "TN",
  },
  {
    zip_code: "38351",

    ste_name: "TN",
  },
  {
    zip_code: "38361",

    ste_name: "TN",
  },
  {
    zip_code: "38451",

    ste_name: "TN",
  },
  {
    zip_code: "38476",

    ste_name: "TN",
  },
  {
    zip_code: "38611",

    ste_name: "MS",
  },
  {
    zip_code: "38620",

    ste_name: "MS",
  },
  {
    zip_code: "38626",

    ste_name: "MS",
  },
  {
    zip_code: "38627",

    ste_name: "MS",
  },
  {
    zip_code: "38655",

    ste_name: "MS",
  },
  {
    zip_code: "38723",

    ste_name: "MS",
  },
  {
    zip_code: "38859",

    ste_name: "MS",
  },
  {
    zip_code: "38869",

    ste_name: "MS",
  },
  {
    zip_code: "38947",

    ste_name: "MS",
  },
  {
    zip_code: "39057",

    ste_name: "MS",
  },
  {
    zip_code: "39061",

    ste_name: "MS",
  },
  {
    zip_code: "39150",

    ste_name: "MS",
  },
  {
    zip_code: "39167",

    ste_name: "MS",
  },
  {
    zip_code: "39169",

    ste_name: "MS",
  },
  {
    zip_code: "39216",

    ste_name: "MS",
  },
  {
    zip_code: "39366",

    ste_name: "MS",
  },
  {
    zip_code: "39401",

    ste_name: "MS",
  },
  {
    zip_code: "39465",

    ste_name: "MS",
  },
  {
    zip_code: "39466",

    ste_name: "MS",
  },
  {
    zip_code: "39567",

    ste_name: "MS",
  },
  {
    zip_code: "39638",

    ste_name: "MS",
  },
  {
    zip_code: "39750",

    ste_name: "MS",
  },
  {
    zip_code: "39815",

    ste_name: "GA",
  },
  {
    zip_code: "39862",

    ste_name: "GA",
  },
  {
    zip_code: "39877",

    ste_name: "GA",
  },
  {
    zip_code: "40104",

    ste_name: "KY",
  },
  {
    zip_code: "40178",

    ste_name: "KY",
  },
  {
    zip_code: "40311",

    ste_name: "KY",
  },
  {
    zip_code: "40348",

    ste_name: "KY",
  },
  {
    zip_code: "40827",

    ste_name: "KY",
  },
  {
    zip_code: "41007",

    ste_name: "KY",
  },
  {
    zip_code: "41524",

    ste_name: "KY",
  },
  {
    zip_code: "41615",

    ste_name: "KY",
  },
  {
    zip_code: "41721",

    ste_name: "KY",
  },
  {
    zip_code: "42122",

    ste_name: "KY",
  },
  {
    zip_code: "42167",

    ste_name: "KY",
  },
  {
    zip_code: "42171",

    ste_name: "KY",
  },
  {
    zip_code: "42232",

    ste_name: "KY",
  },
  {
    zip_code: "42326",

    ste_name: "KY",
  },
  {
    zip_code: "42757",

    ste_name: "KY",
  },
  {
    zip_code: "43033",

    ste_name: "OH",
  },
  {
    zip_code: "43078",

    ste_name: "OH",
  },
  {
    zip_code: "43080",

    ste_name: "OH",
  },
  {
    zip_code: "43130",

    ste_name: "OH",
  },
  {
    zip_code: "43157",

    ste_name: "OH",
  },
  {
    zip_code: "43469",

    ste_name: "OH",
  },
  {
    zip_code: "43501",

    ste_name: "OH",
  },
  {
    zip_code: "43502",

    ste_name: "OH",
  },
  {
    zip_code: "43512",

    ste_name: "OH",
  },
  {
    zip_code: "43545",

    ste_name: "OH",
  },
  {
    zip_code: "43551",

    ste_name: "OH",
  },
  {
    zip_code: "43747",

    ste_name: "OH",
  },
  {
    zip_code: "43768",

    ste_name: "OH",
  },
  {
    zip_code: "43902",

    ste_name: "OH",
  },
  {
    zip_code: "43907",

    ste_name: "OH",
  },
  {
    zip_code: "43908",

    ste_name: "OH",
  },
  {
    zip_code: "43942",

    ste_name: "OH",
  },
  {
    zip_code: "44041",

    ste_name: "OH",
  },
  {
    zip_code: "44118",

    ste_name: "OH",
  },
  {
    zip_code: "44125",

    ste_name: "OH",
  },
  {
    zip_code: "44140",

    ste_name: "OH",
  },
  {
    zip_code: "44147",

    ste_name: "OH",
  },
  {
    zip_code: "44240",

    ste_name: "OH",
  },
  {
    zip_code: "44255",

    ste_name: "OH",
  },
  {
    zip_code: "44305",

    ste_name: "OH",
  },
  {
    zip_code: "44411",

    ste_name: "OH",
  },
  {
    zip_code: "44455",

    ste_name: "OH",
  },
  {
    zip_code: "44514",

    ste_name: "OH",
  },
  {
    zip_code: "44624",

    ste_name: "OH",
  },
  {
    zip_code: "44644",

    ste_name: "OH",
  },
  {
    zip_code: "44647",

    ste_name: "OH",
  },
  {
    zip_code: "44659",

    ste_name: "OH",
  },
  {
    zip_code: "44670",

    ste_name: "OH",
  },
  {
    zip_code: "44689",

    ste_name: "OH",
  },
  {
    zip_code: "44804",

    ste_name: "OH",
  },
  {
    zip_code: "44859",

    ste_name: "OH",
  },
  {
    zip_code: "44907",

    ste_name: "OH",
  },
  {
    zip_code: "45036",

    ste_name: "OH",
  },
  {
    zip_code: "45053",

    ste_name: "OH",
  },
  {
    zip_code: "45226",

    ste_name: "OH",
  },
  {
    zip_code: "45350",

    ste_name: "OH",
  },
  {
    zip_code: "45410",

    ste_name: "OH",
  },
  {
    zip_code: "45690",

    ste_name: "OH",
  },
  {
    zip_code: "45711",

    ste_name: "OH",
  },
  {
    zip_code: "45716",

    ste_name: "OH",
  },
  {
    zip_code: "45732",

    ste_name: "OH",
  },
  {
    zip_code: "45734",

    ste_name: "OH",
  },
  {
    zip_code: "45899",

    ste_name: "OH",
  },
  {
    zip_code: "46031",

    ste_name: "IN",
  },
  {
    zip_code: "46034",

    ste_name: "IN",
  },
  {
    zip_code: "46072",

    ste_name: "IN",
  },
  {
    zip_code: "46142",

    ste_name: "IN",
  },
  {
    zip_code: "46278",

    ste_name: "IN",
  },
  {
    zip_code: "46376",

    ste_name: "IN",
  },
  {
    zip_code: "46615",

    ste_name: "IN",
  },
  {
    zip_code: "46748",

    ste_name: "IN",
  },
  {
    zip_code: "46760",

    ste_name: "IN",
  },
  {
    zip_code: "46767",

    ste_name: "IN",
  },
  {
    zip_code: "46794",

    ste_name: "IN",
  },
  {
    zip_code: "46814",

    ste_name: "IN",
  },
  {
    zip_code: "46990",

    ste_name: "IN",
  },
  {
    zip_code: "47136",

    ste_name: "IN",
  },
  {
    zip_code: "47324",

    ste_name: "IN",
  },
  {
    zip_code: "47367",

    ste_name: "IN",
  },
  {
    zip_code: "47470",

    ste_name: "IN",
  },
  {
    zip_code: "47551",

    ste_name: "IN",
  },
  {
    zip_code: "47568",

    ste_name: "IN",
  },
  {
    zip_code: "47597",

    ste_name: "IN",
  },
  {
    zip_code: "47639",

    ste_name: "IN",
  },
  {
    zip_code: "47710",

    ste_name: "IN",
  },
  {
    zip_code: "47833",

    ste_name: "IN",
  },
  {
    zip_code: "47950",

    ste_name: "IN",
  },
  {
    zip_code: "48075",

    ste_name: "MI",
  },
  {
    zip_code: "48098",

    ste_name: "MI",
  },
  {
    zip_code: "48108",

    ste_name: "MI",
  },
  {
    zip_code: "48138",

    ste_name: "MI",
  },
  {
    zip_code: "48165",

    ste_name: "MI",
  },
  {
    zip_code: "48225",

    ste_name: "MI",
  },
  {
    zip_code: "48240",

    ste_name: "MI",
  },
  {
    zip_code: "48386",

    ste_name: "MI",
  },
  {
    zip_code: "48435",

    ste_name: "MI",
  },
  {
    zip_code: "48465",

    ste_name: "MI",
  },
  {
    zip_code: "48503",

    ste_name: "MI",
  },
  {
    zip_code: "48551",

    ste_name: "MI",
  },
  {
    zip_code: "48741",

    ste_name: "MI",
  },
  {
    zip_code: "48815",

    ste_name: "MI",
  },
  {
    zip_code: "48878",

    ste_name: "MI",
  },
  {
    zip_code: "48888",

    ste_name: "MI",
  },
  {
    zip_code: "48897",

    ste_name: "MI",
  },
  {
    zip_code: "48917",

    ste_name: "MI",
  },
  {
    zip_code: "49055",

    ste_name: "MI",
  },
  {
    zip_code: "49067",

    ste_name: "MI",
  },
  {
    zip_code: "49256",

    ste_name: "MI",
  },
  {
    zip_code: "49264",

    ste_name: "MI",
  },
  {
    zip_code: "49329",

    ste_name: "MI",
  },
  {
    zip_code: "49405",

    ste_name: "MI",
  },
  {
    zip_code: "49426",

    ste_name: "MI",
  },
  {
    zip_code: "49459",

    ste_name: "MI",
  },
  {
    zip_code: "49627",

    ste_name: "MI",
  },
  {
    zip_code: "49740",

    ste_name: "MI",
  },
  {
    zip_code: "49762",

    ste_name: "MI",
  },
  {
    zip_code: "49802",

    ste_name: "MI",
  },
  {
    zip_code: "49894",

    ste_name: "MI",
  },
  {
    zip_code: "50029",

    ste_name: "IA",
  },
  {
    zip_code: "50108",

    ste_name: "IA",
  },
  {
    zip_code: "50153",

    ste_name: "IA",
  },
  {
    zip_code: "50174",

    ste_name: "IA",
  },
  {
    zip_code: "50211",

    ste_name: "IA",
  },
  {
    zip_code: "50244",

    ste_name: "IA",
  },
  {
    zip_code: "50426",

    ste_name: "IA",
  },
  {
    zip_code: "50449",

    ste_name: "IA",
  },
  {
    zip_code: "50460",

    ste_name: "IA",
  },
  {
    zip_code: "50461",

    ste_name: "IA",
  },
  {
    zip_code: "50515",

    ste_name: "IA",
  },
  {
    zip_code: "50522",

    ste_name: "IA",
  },
  {
    zip_code: "50558",

    ste_name: "IA",
  },
  {
    zip_code: "50641",

    ste_name: "IA",
  },
  {
    zip_code: "50835",

    ste_name: "IA",
  },
  {
    zip_code: "51010",

    ste_name: "IA",
  },
  {
    zip_code: "51242",

    ste_name: "IA",
  },
  {
    zip_code: "51249",

    ste_name: "IA",
  },
  {
    zip_code: "51334",

    ste_name: "IA",
  },
  {
    zip_code: "51347",

    ste_name: "IA",
  },
  {
    zip_code: "51350",

    ste_name: "IA",
  },
  {
    zip_code: "51354",

    ste_name: "IA",
  },
  {
    zip_code: "51358",

    ste_name: "IA",
  },
  {
    zip_code: "51543",

    ste_name: "IA",
  },
  {
    zip_code: "51546",

    ste_name: "IA",
  },
  {
    zip_code: "51556",

    ste_name: "IA",
  },
  {
    zip_code: "51570",

    ste_name: "IA",
  },
  {
    zip_code: "51601",

    ste_name: "IA",
  },
  {
    zip_code: "52076",

    ste_name: "IA",
  },
  {
    zip_code: "52236",

    ste_name: "IA",
  },
  {
    zip_code: "52248",

    ste_name: "IA",
  },
  {
    zip_code: "52313",

    ste_name: "IA",
  },
  {
    zip_code: "52341",

    ste_name: "IA",
  },
  {
    zip_code: "52536",

    ste_name: "IA",
  },
  {
    zip_code: "52543",

    ste_name: "IA",
  },
  {
    zip_code: "52549",

    ste_name: "IA",
  },
  {
    zip_code: "52803",

    ste_name: "IA",
  },
  {
    zip_code: "53032",

    ste_name: "WI",
  },
  {
    zip_code: "53210",

    ste_name: "WI",
  },
  {
    zip_code: "53235",

    ste_name: "WI",
  },
  {
    zip_code: "53511",

    ste_name: "WI",
  },
  {
    zip_code: "53521",

    ste_name: "WI",
  },
  {
    zip_code: "53527",

    ste_name: "WI",
  },
  {
    zip_code: "53555",

    ste_name: "WI",
  },
  {
    zip_code: "53811",

    ste_name: "WI",
  },
  {
    zip_code: "53928",

    ste_name: "WI",
  },
  {
    zip_code: "53929",

    ste_name: "WI",
  },
  {
    zip_code: "54202",

    ste_name: "WI",
  },
  {
    zip_code: "54421",

    ste_name: "WI",
  },
  {
    zip_code: "54433",

    ste_name: "WI",
  },
  {
    zip_code: "54436",

    ste_name: "WI",
  },
  {
    zip_code: "54485",

    ste_name: "WI",
  },
  {
    zip_code: "54490",

    ste_name: "WI",
  },
  {
    zip_code: "54629",

    ste_name: "WI",
  },
  {
    zip_code: "54634",

    ste_name: "WI",
  },
  {
    zip_code: "54641",

    ste_name: "WI",
  },
  {
    zip_code: "54652",

    ste_name: "WI",
  },
  {
    zip_code: "54736",

    ste_name: "WI",
  },
  {
    zip_code: "54773",

    ste_name: "WI",
  },
  {
    zip_code: "54838",

    ste_name: "WI",
  },
  {
    zip_code: "54904",

    ste_name: "WI",
  },
  {
    zip_code: "54970",

    ste_name: "WI",
  },
  {
    zip_code: "55047",

    ste_name: "MN",
  },
  {
    zip_code: "55063",

    ste_name: "MN",
  },
  {
    zip_code: "55321",

    ste_name: "MN",
  },
  {
    zip_code: "55325",

    ste_name: "MN",
  },
  {
    zip_code: "55332",

    ste_name: "MN",
  },
  {
    zip_code: "55333",

    ste_name: "MN",
  },
  {
    zip_code: "55369",

    ste_name: "MN",
  },
  {
    zip_code: "55423",

    ste_name: "MN",
  },
  {
    zip_code: "55720",

    ste_name: "MN",
  },
  {
    zip_code: "55764",

    ste_name: "MN",
  },
  {
    zip_code: "55909",

    ste_name: "MN",
  },
  {
    zip_code: "55953",

    ste_name: "MN",
  },
  {
    zip_code: "55983",

    ste_name: "MN",
  },
  {
    zip_code: "56009",

    ste_name: "MN",
  },
  {
    zip_code: "56039",

    ste_name: "MN",
  },
  {
    zip_code: "56044",

    ste_name: "MN",
  },
  {
    zip_code: "56072",

    ste_name: "MN",
  },
  {
    zip_code: "56074",

    ste_name: "MN",
  },
  {
    zip_code: "56091",

    ste_name: "MN",
  },
  {
    zip_code: "56122",

    ste_name: "MN",
  },
  {
    zip_code: "56142",

    ste_name: "MN",
  },
  {
    zip_code: "56150",

    ste_name: "MN",
  },
  {
    zip_code: "56174",

    ste_name: "MN",
  },
  {
    zip_code: "56209",

    ste_name: "MN",
  },
  {
    zip_code: "56221",

    ste_name: "MN",
  },
  {
    zip_code: "56282",

    ste_name: "MN",
  },
  {
    zip_code: "56288",

    ste_name: "MN",
  },
  {
    zip_code: "56332",

    ste_name: "MN",
  },
  {
    zip_code: "56374",

    ste_name: "MN",
  },
  {
    zip_code: "56456",

    ste_name: "MN",
  },
  {
    zip_code: "56520",

    ste_name: "MN",
  },
  {
    zip_code: "56537",

    ste_name: "MN",
  },
  {
    zip_code: "56549",

    ste_name: "MN",
  },
  {
    zip_code: "56663",

    ste_name: "MN",
  },
  {
    zip_code: "56711",

    ste_name: "MN",
  },
  {
    zip_code: "56741",

    ste_name: "MN",
  },
  {
    zip_code: "57039",

    ste_name: "SD",
  },
  {
    zip_code: "57052",

    ste_name: "SD",
  },
  {
    zip_code: "57106",

    ste_name: "SD",
  },
  {
    zip_code: "57221",

    ste_name: "SD",
  },
  {
    zip_code: "57440",

    ste_name: "SD",
  },
  {
    zip_code: "57446",

    ste_name: "SD",
  },
  {
    zip_code: "57451",

    ste_name: "SD",
  },
  {
    zip_code: "57468",

    ste_name: "SD",
  },
  {
    zip_code: "57472",

    ste_name: "SD",
  },
  {
    zip_code: "57534",

    ste_name: "SD",
  },
  {
    zip_code: "57601",

    ste_name: "SD",
  },
  {
    zip_code: "57623",

    ste_name: "SD",
  },
  {
    zip_code: "57632",

    ste_name: "SD",
  },
  {
    zip_code: "57702",

    ste_name: "SD",
  },
  {
    zip_code: "57773",

    ste_name: "SD",
  },
  {
    zip_code: "57780",

    ste_name: "SD",
  },
  {
    zip_code: "58057",

    ste_name: "ND",
  },
  {
    zip_code: "58058",

    ste_name: "ND",
  },
  {
    zip_code: "58059",

    ste_name: "ND",
  },
  {
    zip_code: "58104",

    ste_name: "ND",
  },
  {
    zip_code: "58204",

    ste_name: "ND",
  },
  {
    zip_code: "58224",

    ste_name: "ND",
  },
  {
    zip_code: "58240",

    ste_name: "ND",
  },
  {
    zip_code: "58260",

    ste_name: "ND",
  },
  {
    zip_code: "58278",

    ste_name: "ND",
  },
  {
    zip_code: "58348",

    ste_name: "ND",
  },
  {
    zip_code: "58356",

    ste_name: "ND",
  },
  {
    zip_code: "58357",

    ste_name: "ND",
  },
  {
    zip_code: "58458",

    ste_name: "ND",
  },
  {
    zip_code: "58461",

    ste_name: "ND",
  },
  {
    zip_code: "58566",

    ste_name: "ND",
  },
  {
    zip_code: "58568",

    ste_name: "ND",
  },
  {
    zip_code: "58601",

    ste_name: "ND",
  },
  {
    zip_code: "58722",

    ste_name: "ND",
  },
  {
    zip_code: "652",

    ste_name: "PR",
  },
  {
    zip_code: "683",

    ste_name: "PR",
  },
  {
    zip_code: "730",

    ste_name: "PR",
  },
  {
    zip_code: "767",

    ste_name: "PR",
  },
  {
    zip_code: "911",

    ste_name: "PR",
  },
  {
    zip_code: "917",

    ste_name: "PR",
  },
  {
    zip_code: "960",

    ste_name: "PR",
  },
  {
    zip_code: "976",

    ste_name: "PR",
  },
  {
    zip_code: "1039",

    ste_name: "MA",
  },
  {
    zip_code: "1053",

    ste_name: "MA",
  },
  {
    zip_code: "1095",

    ste_name: "MA",
  },
  {
    zip_code: "1107",

    ste_name: "MA",
  },
  {
    zip_code: "1225",

    ste_name: "MA",
  },
  {
    zip_code: "1438",

    ste_name: "MA",
  },
  {
    zip_code: "1730",

    ste_name: "MA",
  },
  {
    zip_code: "1845",

    ste_name: "MA",
  },
  {
    zip_code: "1867",

    ste_name: "MA",
  },
  {
    zip_code: "2053",

    ste_name: "MA",
  },
  {
    zip_code: "2141",

    ste_name: "MA",
  },
  {
    zip_code: "2445",

    ste_name: "MA",
  },
  {
    zip_code: "2482",

    ste_name: "MA",
  },
  {
    zip_code: "2536",

    ste_name: "MA",
  },
  {
    zip_code: "2539",

    ste_name: "MA",
  },
  {
    zip_code: "2649",

    ste_name: "MA",
  },
  {
    zip_code: "2865",

    ste_name: "RI",
  },
  {
    zip_code: "2876",

    ste_name: "RI",
  },
  {
    zip_code: "2893",

    ste_name: "RI",
  },
  {
    zip_code: "2894",

    ste_name: "RI",
  },
  {
    zip_code: "3086",

    ste_name: "NH",
  },
  {
    zip_code: "3276",

    ste_name: "NH",
  },
  {
    zip_code: "3301",

    ste_name: "NH",
  },
  {
    zip_code: "3455",

    ste_name: "NH",
  },
  {
    zip_code: "3603",

    ste_name: "NH",
  },
  {
    zip_code: "3830",

    ste_name: "NH",
  },
  {
    zip_code: "3869",

    ste_name: "NH",
  },
  {
    zip_code: "4003",

    ste_name: "ME",
  },
  {
    zip_code: "4019",

    ste_name: "ME",
  },
  {
    zip_code: "4047",

    ste_name: "ME",
  },
  {
    zip_code: "4064",

    ste_name: "ME",
  },
  {
    zip_code: "4093",

    ste_name: "ME",
  },
  {
    zip_code: "4220",

    ste_name: "ME",
  },
  {
    zip_code: "4231",

    ste_name: "ME",
  },
  {
    zip_code: "4267",

    ste_name: "ME",
  },
  {
    zip_code: "4271",

    ste_name: "ME",
  },
  {
    zip_code: "4347",

    ste_name: "ME",
  },
  {
    zip_code: "4410",

    ste_name: "ME",
  },
  {
    zip_code: "4421",

    ste_name: "ME",
  },
  {
    zip_code: "4457",

    ste_name: "ME",
  },
  {
    zip_code: "4543",

    ste_name: "ME",
  },
  {
    zip_code: "4573",

    ste_name: "ME",
  },
  {
    zip_code: "4735",

    ste_name: "ME",
  },
  {
    zip_code: "4781",

    ste_name: "ME",
  },
  {
    zip_code: "4862",

    ste_name: "ME",
  },
  {
    zip_code: "4957",

    ste_name: "ME",
  },
  {
    zip_code: "4985",

    ste_name: "ME",
  },
  {
    zip_code: "5070",

    ste_name: "VT",
  },
  {
    zip_code: "5350",

    ste_name: "VT",
  },
  {
    zip_code: "5464",

    ste_name: "VT",
  },
  {
    zip_code: "5476",

    ste_name: "VT",
  },
  {
    zip_code: "5487",

    ste_name: "VT",
  },
  {
    zip_code: "5847",

    ste_name: "VT",
  },
  {
    zip_code: "5868",

    ste_name: "VT",
  },
  {
    zip_code: "5904",

    ste_name: "VT",
  },
  {
    zip_code: "6039",

    ste_name: "CT",
  },
  {
    zip_code: "6071",

    ste_name: "CT",
  },
  {
    zip_code: "6455",

    ste_name: "CT",
  },
  {
    zip_code: "6754",

    ste_name: "CT",
  },
  {
    zip_code: "6824",

    ste_name: "CT",
  },
  {
    zip_code: "6854",

    ste_name: "CT",
  },
  {
    zip_code: "6883",

    ste_name: "CT",
  },
  {
    zip_code: "6905",

    ste_name: "CT",
  },
  {
    zip_code: "7076",

    ste_name: "NJ",
  },
  {
    zip_code: "7302",

    ste_name: "NJ",
  },
  {
    zip_code: "7407",

    ste_name: "NJ",
  },
  {
    zip_code: "7440",

    ste_name: "NJ",
  },
  {
    zip_code: "7630",

    ste_name: "NJ",
  },
  {
    zip_code: "7751",

    ste_name: "NJ",
  },
  {
    zip_code: "7939",

    ste_name: "NJ",
  },
  {
    zip_code: "8012",

    ste_name: "NJ",
  },
  {
    zip_code: "8042",

    ste_name: "NJ",
  },
  {
    zip_code: "8066",

    ste_name: "NJ",
  },
  {
    zip_code: "8081",

    ste_name: "NJ",
  },
  {
    zip_code: "8202",

    ste_name: "NJ",
  },
  {
    zip_code: "8312",

    ste_name: "NJ",
  },
  {
    zip_code: "8512",

    ste_name: "NJ",
  },
  {
    zip_code: "8535",

    ste_name: "NJ",
  },
  {
    zip_code: "8609",

    ste_name: "NJ",
  },
  {
    zip_code: "8618",

    ste_name: "NJ",
  },
  {
    zip_code: "8628",

    ste_name: "NJ",
  },
  {
    zip_code: "8757",

    ste_name: "NJ",
  },
  {
    zip_code: "8807",

    ste_name: "NJ",
  },
  {
    zip_code: "8809",

    ste_name: "NJ",
  },
  {
    zip_code: "8828",

    ste_name: "NJ",
  },
  {
    zip_code: "8835",

    ste_name: "NJ",
  },
  {
    zip_code: "8867",

    ste_name: "NJ",
  },
  {
    zip_code: "8880",

    ste_name: "NJ",
  },
  {
    zip_code: "10010",

    ste_name: "NY",
  },
  {
    zip_code: "10030",

    ste_name: "NY",
  },
  {
    zip_code: "10034",

    ste_name: "NY",
  },
  {
    zip_code: "10103",

    ste_name: "NY",
  },
  {
    zip_code: "10475",

    ste_name: "NY",
  },
  {
    zip_code: "10704",

    ste_name: "NY",
  },
  {
    zip_code: "10913",

    ste_name: "NY",
  },
  {
    zip_code: "10919",

    ste_name: "NY",
  },
  {
    zip_code: "10968",

    ste_name: "NY",
  },
  {
    zip_code: "10985",

    ste_name: "NY",
  },
  {
    zip_code: "11208",

    ste_name: "NY",
  },
  {
    zip_code: "11379",

    ste_name: "NY",
  },
  {
    zip_code: "11428",

    ste_name: "NY",
  },
  {
    zip_code: "11501",

    ste_name: "NY",
  },
  {
    zip_code: "11509",

    ste_name: "NY",
  },
  {
    zip_code: "11749",

    ste_name: "NY",
  },
  {
    zip_code: "11756",

    ste_name: "NY",
  },
  {
    zip_code: "11770",

    ste_name: "NY",
  },
  {
    zip_code: "11949",

    ste_name: "NY",
  },
  {
    zip_code: "11959",

    ste_name: "NY",
  },
  {
    zip_code: "11960",

    ste_name: "NY",
  },
  {
    zip_code: "12134",

    ste_name: "NY",
  },
  {
    zip_code: "12143",

    ste_name: "NY",
  },
  {
    zip_code: "12186",

    ste_name: "NY",
  },
  {
    zip_code: "12190",

    ste_name: "NY",
  },
  {
    zip_code: "12433",

    ste_name: "NY",
  },
  {
    zip_code: "12458",

    ste_name: "NY",
  },
  {
    zip_code: "12461",

    ste_name: "NY",
  },
  {
    zip_code: "12507",

    ste_name: "NY",
  },
  {
    zip_code: "12513",

    ste_name: "NY",
  },
  {
    zip_code: "12542",

    ste_name: "NY",
  },
  {
    zip_code: "12575",

    ste_name: "NY",
  },
  {
    zip_code: "12603",

    ste_name: "NY",
  },
  {
    zip_code: "12747",

    ste_name: "NY",
  },
  {
    zip_code: "12814",

    ste_name: "NY",
  },
  {
    zip_code: "12843",

    ste_name: "NY",
  },
  {
    zip_code: "12862",

    ste_name: "NY",
  },
  {
    zip_code: "12865",

    ste_name: "NY",
  },
  {
    zip_code: "12866",

    ste_name: "NY",
  },
  {
    zip_code: "12981",

    ste_name: "NY",
  },
  {
    zip_code: "13365",

    ste_name: "NY",
  },
  {
    zip_code: "13420",

    ste_name: "NY",
  },
  {
    zip_code: "13478",

    ste_name: "NY",
  },
  {
    zip_code: "13619",

    ste_name: "NY",
  },
  {
    zip_code: "13731",

    ste_name: "NY",
  },
  {
    zip_code: "13760",

    ste_name: "NY",
  },
  {
    zip_code: "13786",

    ste_name: "NY",
  },
  {
    zip_code: "13804",

    ste_name: "NY",
  },
  {
    zip_code: "13863",

    ste_name: "NY",
  },
  {
    zip_code: "14013",

    ste_name: "NY",
  },
  {
    zip_code: "14136",

    ste_name: "NY",
  },
  {
    zip_code: "14173",

    ste_name: "NY",
  },
  {
    zip_code: "14227",

    ste_name: "NY",
  },
  {
    zip_code: "14304",

    ste_name: "NY",
  },
  {
    zip_code: "14420",

    ste_name: "NY",
  },
  {
    zip_code: "14550",

    ste_name: "NY",
  },
  {
    zip_code: "14619",

    ste_name: "NY",
  },
  {
    zip_code: "14772",

    ste_name: "NY",
  },
  {
    zip_code: "15047",

    ste_name: "PA",
  },
  {
    zip_code: "15066",

    ste_name: "PA",
  },
  {
    zip_code: "15072",

    ste_name: "PA",
  },
  {
    zip_code: "15106",

    ste_name: "PA",
  },
  {
    zip_code: "15110",

    ste_name: "PA",
  },
  {
    zip_code: "15456",

    ste_name: "PA",
  },
  {
    zip_code: "15476",

    ste_name: "PA",
  },
  {
    zip_code: "15483",

    ste_name: "PA",
  },
  {
    zip_code: "15534",

    ste_name: "PA",
  },
  {
    zip_code: "15542",

    ste_name: "PA",
  },
  {
    zip_code: "15544",

    ste_name: "PA",
  },
  {
    zip_code: "15656",

    ste_name: "PA",
  },
  {
    zip_code: "15724",

    ste_name: "PA",
  },
  {
    zip_code: "15736",

    ste_name: "PA",
  },
  {
    zip_code: "15764",

    ste_name: "PA",
  },
  {
    zip_code: "15931",

    ste_name: "PA",
  },
  {
    zip_code: "15945",

    ste_name: "PA",
  },
  {
    zip_code: "16030",

    ste_name: "PA",
  },
  {
    zip_code: "16036",

    ste_name: "PA",
  },
  {
    zip_code: "16113",

    ste_name: "PA",
  },
  {
    zip_code: "16114",

    ste_name: "PA",
  },
  {
    zip_code: "16230",

    ste_name: "PA",
  },
  {
    zip_code: "16352",

    ste_name: "PA",
  },
  {
    zip_code: "16364",

    ste_name: "PA",
  },
  {
    zip_code: "16405",

    ste_name: "PA",
  },
  {
    zip_code: "16406",

    ste_name: "PA",
  },
  {
    zip_code: "16441",

    ste_name: "PA",
  },
  {
    zip_code: "16624",

    ste_name: "PA",
  },
  {
    zip_code: "16635",

    ste_name: "PA",
  },
  {
    zip_code: "16725",

    ste_name: "PA",
  },
  {
    zip_code: "16803",

    ste_name: "PA",
  },
  {
    zip_code: "16858",

    ste_name: "PA",
  },
  {
    zip_code: "16874",

    ste_name: "PA",
  },
  {
    zip_code: "16937",

    ste_name: "PA",
  },
  {
    zip_code: "17049",

    ste_name: "PA",
  },
  {
    zip_code: "17070",

    ste_name: "PA",
  },
  {
    zip_code: "17074",

    ste_name: "PA",
  },
  {
    zip_code: "17077",

    ste_name: "PA",
  },
  {
    zip_code: "17220",

    ste_name: "PA",
  },
  {
    zip_code: "17271",

    ste_name: "PA",
  },
  {
    zip_code: "17320",

    ste_name: "PA",
  },
  {
    zip_code: "17321",

    ste_name: "PA",
  },
  {
    zip_code: "17584",

    ste_name: "PA",
  },
  {
    zip_code: "17744",

    ste_name: "PA",
  },
  {
    zip_code: "17847",

    ste_name: "PA",
  },
  {
    zip_code: "17881",

    ste_name: "PA",
  },
  {
    zip_code: "17961",

    ste_name: "PA",
  },
  {
    zip_code: "17972",

    ste_name: "PA",
  },
  {
    zip_code: "17980",

    ste_name: "PA",
  },
  {
    zip_code: "17982",

    ste_name: "PA",
  },
  {
    zip_code: "18330",

    ste_name: "PA",
  },
  {
    zip_code: "18342",

    ste_name: "PA",
  },
  {
    zip_code: "18460",

    ste_name: "PA",
  },
  {
    zip_code: "18463",

    ste_name: "PA",
  },
  {
    zip_code: "18653",

    ste_name: "PA",
  },
  {
    zip_code: "18851",

    ste_name: "PA",
  },
  {
    zip_code: "19015",

    ste_name: "PA",
  },
  {
    zip_code: "19026",

    ste_name: "PA",
  },
  {
    zip_code: "19038",

    ste_name: "PA",
  },
  {
    zip_code: "19083",

    ste_name: "PA",
  },
  {
    zip_code: "19120",

    ste_name: "PA",
  },
  {
    zip_code: "19138",

    ste_name: "PA",
  },
  {
    zip_code: "19154",

    ste_name: "PA",
  },
  {
    zip_code: "19540",

    ste_name: "PA",
  },
  {
    zip_code: "19545",

    ste_name: "PA",
  },
  {
    zip_code: "19717",

    ste_name: "DE",
  },
  {
    zip_code: "20037",

    ste_name: "DC",
  },
  {
    zip_code: "20057",

    ste_name: "DC",
  },
  {
    zip_code: "20187",

    ste_name: "VA",
  },
  {
    zip_code: "20260",

    ste_name: "DC",
  },
  {
    zip_code: "20602",

    ste_name: "MD",
  },
  {
    zip_code: "20609",

    ste_name: "MD",
  },
  {
    zip_code: "20701",

    ste_name: "MD",
  },
  {
    zip_code: "20711",

    ste_name: "MD",
  },
  {
    zip_code: "20751",

    ste_name: "MD",
  },
  {
    zip_code: "21046",

    ste_name: "MD",
  },
  {
    zip_code: "21113",

    ste_name: "MD",
  },
  {
    zip_code: "21228",

    ste_name: "MD",
  },
  {
    zip_code: "21230",

    ste_name: "MD",
  },
  {
    zip_code: "21532",

    ste_name: "MD",
  },
  {
    zip_code: "21545",

    ste_name: "MD",
  },
  {
    zip_code: "21561",

    ste_name: "MD",
  },
  {
    zip_code: "21635",

    ste_name: "MD",
  },
  {
    zip_code: "21671",

    ste_name: "MD",
  },
  {
    zip_code: "21783",

    ste_name: "MD",
  },
  {
    zip_code: "21838",

    ste_name: "MD",
  },
  {
    zip_code: "22625",

    ste_name: "VA",
  },
  {
    zip_code: "22722",

    ste_name: "VA",
  },
  {
    zip_code: "22821",

    ste_name: "VA",
  },
  {
    zip_code: "58757",

    ste_name: "ND",
  },
  {
    zip_code: "58758",

    ste_name: "ND",
  },
  {
    zip_code: "58772",

    ste_name: "ND",
  },
  {
    zip_code: "59201",

    ste_name: "MT",
  },
  {
    zip_code: "59315",

    ste_name: "MT",
  },
  {
    zip_code: "59416",

    ste_name: "MT",
  },
  {
    zip_code: "59469",

    ste_name: "MT",
  },
  {
    zip_code: "59710",

    ste_name: "MT",
  },
  {
    zip_code: "59732",

    ste_name: "MT",
  },
  {
    zip_code: "59748",

    ste_name: "MT",
  },
  {
    zip_code: "59846",

    ste_name: "MT",
  },
  {
    zip_code: "60010",

    ste_name: "IL",
  },
  {
    zip_code: "60020",

    ste_name: "IL",
  },
  {
    zip_code: "60029",

    ste_name: "IL",
  },
  {
    zip_code: "60050",

    ste_name: "IL",
  },
  {
    zip_code: "60090",

    ste_name: "IL",
  },
  {
    zip_code: "60185",

    ste_name: "IL",
  },
  {
    zip_code: "60415",

    ste_name: "IL",
  },
  {
    zip_code: "60426",

    ste_name: "IL",
  },
  {
    zip_code: "60457",

    ste_name: "IL",
  },
  {
    zip_code: "60502",

    ste_name: "IL",
  },
  {
    zip_code: "60541",

    ste_name: "IL",
  },
  {
    zip_code: "60550",

    ste_name: "IL",
  },
  {
    zip_code: "60559",

    ste_name: "IL",
  },
  {
    zip_code: "60610",

    ste_name: "IL",
  },
  {
    zip_code: "60624",

    ste_name: "IL",
  },
  {
    zip_code: "60707",

    ste_name: "IL",
  },
  {
    zip_code: "60911",

    ste_name: "IL",
  },
  {
    zip_code: "60973",

    ste_name: "IL",
  },
  {
    zip_code: "61001",

    ste_name: "IL",
  },
  {
    zip_code: "61006",

    ste_name: "IL",
  },
  {
    zip_code: "61262",

    ste_name: "IL",
  },
  {
    zip_code: "61278",

    ste_name: "IL",
  },
  {
    zip_code: "61340",

    ste_name: "IL",
  },
  {
    zip_code: "61344",

    ste_name: "IL",
  },
  {
    zip_code: "61364",

    ste_name: "IL",
  },
  {
    zip_code: "61440",

    ste_name: "IL",
  },
  {
    zip_code: "61442",

    ste_name: "IL",
  },
  {
    zip_code: "61485",

    ste_name: "IL",
  },
  {
    zip_code: "61530",

    ste_name: "IL",
  },
  {
    zip_code: "61610",

    ste_name: "IL",
  },
  {
    zip_code: "61737",

    ste_name: "IL",
  },
  {
    zip_code: "62015",

    ste_name: "IL",
  },
  {
    zip_code: "62048",

    ste_name: "IL",
  },
  {
    zip_code: "62054",

    ste_name: "IL",
  },
  {
    zip_code: "62217",

    ste_name: "IL",
  },
  {
    zip_code: "62243",

    ste_name: "IL",
  },
  {
    zip_code: "62245",

    ste_name: "IL",
  },
  {
    zip_code: "62246",

    ste_name: "IL",
  },
  {
    zip_code: "62273",

    ste_name: "IL",
  },
  {
    zip_code: "62288",

    ste_name: "IL",
  },
  {
    zip_code: "62321",

    ste_name: "IL",
  },
  {
    zip_code: "62334",

    ste_name: "IL",
  },
  {
    zip_code: "62347",

    ste_name: "IL",
  },
  {
    zip_code: "62449",

    ste_name: "IL",
  },
  {
    zip_code: "62452",

    ste_name: "IL",
  },
  {
    zip_code: "62531",

    ste_name: "IL",
  },
  {
    zip_code: "62536",

    ste_name: "IL",
  },
  {
    zip_code: "62558",

    ste_name: "IL",
  },
  {
    zip_code: "62618",

    ste_name: "IL",
  },
  {
    zip_code: "62812",

    ste_name: "IL",
  },
  {
    zip_code: "62868",

    ste_name: "IL",
  },
  {
    zip_code: "62897",

    ste_name: "IL",
  },
  {
    zip_code: "62933",

    ste_name: "IL",
  },
  {
    zip_code: "62941",

    ste_name: "IL",
  },
  {
    zip_code: "62995",

    ste_name: "IL",
  },
  {
    zip_code: "63019",

    ste_name: "MO",
  },
  {
    zip_code: "63026",

    ste_name: "MO",
  },
  {
    zip_code: "63048",

    ste_name: "MO",
  },
  {
    zip_code: "63367",

    ste_name: "MO",
  },
  {
    zip_code: "63446",

    ste_name: "MO",
  },
  {
    zip_code: "63450",

    ste_name: "MO",
  },
  {
    zip_code: "63469",

    ste_name: "MO",
  },
  {
    zip_code: "63551",

    ste_name: "MO",
  },
  {
    zip_code: "63623",

    ste_name: "MO",
  },
  {
    zip_code: "63638",

    ste_name: "MO",
  },
  {
    zip_code: "63655",

    ste_name: "MO",
  },
  {
    zip_code: "63745",

    ste_name: "MO",
  },
  {
    zip_code: "63820",

    ste_name: "MO",
  },
  {
    zip_code: "63848",

    ste_name: "MO",
  },
  {
    zip_code: "63867",

    ste_name: "MO",
  },
  {
    zip_code: "63937",

    ste_name: "MO",
  },
  {
    zip_code: "64067",

    ste_name: "MO",
  },
  {
    zip_code: "64079",

    ste_name: "MO",
  },
  {
    zip_code: "64156",

    ste_name: "MO",
  },
  {
    zip_code: "64725",

    ste_name: "MO",
  },
  {
    zip_code: "64767",

    ste_name: "MO",
  },
  {
    zip_code: "64776",

    ste_name: "MO",
  },
  {
    zip_code: "64788",

    ste_name: "MO",
  },
  {
    zip_code: "64836",

    ste_name: "MO",
  },
  {
    zip_code: "65041",

    ste_name: "MO",
  },
  {
    zip_code: "65049",

    ste_name: "MO",
  },
  {
    zip_code: "65067",

    ste_name: "MO",
  },
  {
    zip_code: "65230",

    ste_name: "MO",
  },
  {
    zip_code: "65276",

    ste_name: "MO",
  },
  {
    zip_code: "65279",

    ste_name: "MO",
  },
  {
    zip_code: "65325",

    ste_name: "MO",
  },
  {
    zip_code: "65457",

    ste_name: "MO",
  },
  {
    zip_code: "65470",

    ste_name: "MO",
  },
  {
    zip_code: "65559",

    ste_name: "MO",
  },
  {
    zip_code: "65604",

    ste_name: "MO",
  },
  {
    zip_code: "65619",

    ste_name: "MO",
  },
  {
    zip_code: "65632",

    ste_name: "MO",
  },
  {
    zip_code: "65640",

    ste_name: "MO",
  },
  {
    zip_code: "65778",

    ste_name: "MO",
  },
  {
    zip_code: "65783",

    ste_name: "MO",
  },
  {
    zip_code: "66007",

    ste_name: "KS",
  },
  {
    zip_code: "66008",

    ste_name: "KS",
  },
  {
    zip_code: "66080",

    ste_name: "KS",
  },
  {
    zip_code: "66111",

    ste_name: "KS",
  },
  {
    zip_code: "66423",

    ste_name: "KS",
  },
  {
    zip_code: "66520",

    ste_name: "KS",
  },
  {
    zip_code: "66712",

    ste_name: "KS",
  },
  {
    zip_code: "66716",

    ste_name: "KS",
  },
  {
    zip_code: "66762",

    ste_name: "KS",
  },
  {
    zip_code: "66775",

    ste_name: "KS",
  },
  {
    zip_code: "66777",

    ste_name: "KS",
  },
  {
    zip_code: "67060",

    ste_name: "KS",
  },
  {
    zip_code: "67067",

    ste_name: "KS",
  },
  {
    zip_code: "67230",

    ste_name: "KS",
  },
  {
    zip_code: "67330",

    ste_name: "KS",
  },
  {
    zip_code: "67333",

    ste_name: "KS",
  },
  {
    zip_code: "67418",

    ste_name: "KS",
  },
  {
    zip_code: "67437",

    ste_name: "KS",
  },
  {
    zip_code: "67449",

    ste_name: "KS",
  },
  {
    zip_code: "67451",

    ste_name: "KS",
  },
  {
    zip_code: "67516",

    ste_name: "KS",
  },
  {
    zip_code: "67523",

    ste_name: "KS",
  },
  {
    zip_code: "67601",

    ste_name: "KS",
  },
  {
    zip_code: "67637",

    ste_name: "KS",
  },
  {
    zip_code: "67640",

    ste_name: "KS",
  },
  {
    zip_code: "67654",

    ste_name: "KS",
  },
  {
    zip_code: "67737",

    ste_name: "KS",
  },
  {
    zip_code: "67869",

    ste_name: "KS",
  },
  {
    zip_code: "67901",

    ste_name: "KS",
  },
  {
    zip_code: "68007",

    ste_name: "NE",
  },
  {
    zip_code: "68010",

    ste_name: "NE",
  },
  {
    zip_code: "68023",

    ste_name: "NE",
  },
  {
    zip_code: "68124",

    ste_name: "NE",
  },
  {
    zip_code: "68343",

    ste_name: "NE",
  },
  {
    zip_code: "68367",

    ste_name: "NE",
  },
  {
    zip_code: "68379",

    ste_name: "NE",
  },
  {
    zip_code: "68381",

    ste_name: "NE",
  },
  {
    zip_code: "68440",

    ste_name: "NE",
  },
  {
    zip_code: "68441",

    ste_name: "NE",
  },
  {
    zip_code: "68446",

    ste_name: "NE",
  },
  {
    zip_code: "68461",

    ste_name: "NE",
  },
  {
    zip_code: "68526",

    ste_name: "NE",
  },
  {
    zip_code: "68633",

    ste_name: "NE",
  },
  {
    zip_code: "68652",

    ste_name: "NE",
  },
  {
    zip_code: "68717",

    ste_name: "NE",
  },
  {
    zip_code: "68730",

    ste_name: "NE",
  },
  {
    zip_code: "68870",

    ste_name: "NE",
  },
  {
    zip_code: "68936",

    ste_name: "NE",
  },
  {
    zip_code: "68949",

    ste_name: "NE",
  },
  {
    zip_code: "68982",

    ste_name: "NE",
  },
  {
    zip_code: "69038",

    ste_name: "NE",
  },
  {
    zip_code: "69039",

    ste_name: "NE",
  },
  {
    zip_code: "69153",

    ste_name: "NE",
  },
  {
    zip_code: "69340",

    ste_name: "NE",
  },
  {
    zip_code: "70031",

    ste_name: "LA",
  },
  {
    zip_code: "70086",

    ste_name: "LA",
  },
  {
    zip_code: "70343",

    ste_name: "LA",
  },
  {
    zip_code: "70520",

    ste_name: "LA",
  },
  {
    zip_code: "70533",

    ste_name: "LA",
  },
  {
    zip_code: "70558",

    ste_name: "LA",
  },
  {
    zip_code: "70634",

    ste_name: "LA",
  },
  {
    zip_code: "70658",

    ste_name: "LA",
  },
  {
    zip_code: "70787",

    ste_name: "LA",
  },
  {
    zip_code: "71003",

    ste_name: "LA",
  },
  {
    zip_code: "71031",

    ste_name: "LA",
  },
  {
    zip_code: "71063",

    ste_name: "LA",
  },
  {
    zip_code: "71333",

    ste_name: "LA",
  },
  {
    zip_code: "71362",

    ste_name: "LA",
  },
  {
    zip_code: "71424",

    ste_name: "LA",
  },
  {
    zip_code: "71640",

    ste_name: "AR",
  },
  {
    zip_code: "71832",

    ste_name: "AR",
  },
  {
    zip_code: "72024",

    ste_name: "AR",
  },
  {
    zip_code: "72068",

    ste_name: "AR",
  },
  {
    zip_code: "72134",

    ste_name: "AR",
  },
  {
    zip_code: "72366",

    ste_name: "AR",
  },
  {
    zip_code: "72386",

    ste_name: "AR",
  },
  {
    zip_code: "72454",

    ste_name: "AR",
  },
  {
    zip_code: "72467",

    ste_name: "AR",
  },
  {
    zip_code: "72718",

    ste_name: "AR",
  },
  {
    zip_code: "72933",

    ste_name: "AR",
  },
  {
    zip_code: "72938",

    ste_name: "AR",
  },
  {
    zip_code: "73018",

    ste_name: "OK",
  },
  {
    zip_code: "73058",

    ste_name: "OK",
  },
  {
    zip_code: "73074",

    ste_name: "OK",
  },
  {
    zip_code: "73093",

    ste_name: "OK",
  },
  {
    zip_code: "73102",

    ste_name: "OK",
  },
  {
    zip_code: "73130",

    ste_name: "OK",
  },
  {
    zip_code: "73450",

    ste_name: "OK",
  },
  {
    zip_code: "73556",

    ste_name: "OK",
  },
  {
    zip_code: "73559",

    ste_name: "OK",
  },
  {
    zip_code: "73650",

    ste_name: "OK",
  },
  {
    zip_code: "73663",

    ste_name: "OK",
  },
  {
    zip_code: "73669",

    ste_name: "OK",
  },
  {
    zip_code: "73757",

    ste_name: "OK",
  },
  {
    zip_code: "74046",

    ste_name: "OK",
  },
  {
    zip_code: "74117",

    ste_name: "OK",
  },
  {
    zip_code: "74129",

    ste_name: "OK",
  },
  {
    zip_code: "74131",

    ste_name: "OK",
  },
  {
    zip_code: "74133",

    ste_name: "OK",
  },
  {
    zip_code: "74136",

    ste_name: "OK",
  },
  {
    zip_code: "74146",

    ste_name: "OK",
  },
  {
    zip_code: "74342",

    ste_name: "OK",
  },
  {
    zip_code: "74451",

    ste_name: "OK",
  },
  {
    zip_code: "74469",

    ste_name: "OK",
  },
  {
    zip_code: "74528",

    ste_name: "OK",
  },
  {
    zip_code: "74533",

    ste_name: "OK",
  },
  {
    zip_code: "74577",

    ste_name: "OK",
  },
  {
    zip_code: "74636",

    ste_name: "OK",
  },
  {
    zip_code: "74864",

    ste_name: "OK",
  },
  {
    zip_code: "74943",

    ste_name: "OK",
  },
  {
    zip_code: "74953",

    ste_name: "OK",
  },
  {
    zip_code: "75023",

    ste_name: "TX",
  },
  {
    zip_code: "75048",

    ste_name: "TX",
  },
  {
    zip_code: "75141",

    ste_name: "TX",
  },
  {
    zip_code: "75202",

    ste_name: "TX",
  },
  {
    zip_code: "75204",

    ste_name: "TX",
  },
  {
    zip_code: "75212",

    ste_name: "TX",
  },
  {
    zip_code: "75416",

    ste_name: "TX",
  },
  {
    zip_code: "75479",

    ste_name: "TX",
  },
  {
    zip_code: "75490",

    ste_name: "TX",
  },
  {
    zip_code: "75551",

    ste_name: "TX",
  },
  {
    zip_code: "75563",

    ste_name: "TX",
  },
  {
    zip_code: "75701",

    ste_name: "TX",
  },
  {
    zip_code: "75757",

    ste_name: "TX",
  },
  {
    zip_code: "75765",

    ste_name: "TX",
  },
  {
    zip_code: "75831",

    ste_name: "TX",
  },
  {
    zip_code: "75856",

    ste_name: "TX",
  },
  {
    zip_code: "75978",

    ste_name: "TX",
  },
  {
    zip_code: "76010",

    ste_name: "TX",
  },
  {
    zip_code: "76041",

    ste_name: "TX",
  },
  {
    zip_code: "76055",

    ste_name: "TX",
  },
  {
    zip_code: "76104",

    ste_name: "TX",
  },
  {
    zip_code: "76109",

    ste_name: "TX",
  },
  {
    zip_code: "76115",

    ste_name: "TX",
  },
  {
    zip_code: "76209",

    ste_name: "TX",
  },
  {
    zip_code: "76251",

    ste_name: "TX",
  },
  {
    zip_code: "76271",

    ste_name: "TX",
  },
  {
    zip_code: "76306",

    ste_name: "TX",
  },
  {
    zip_code: "76366",

    ste_name: "TX",
  },
  {
    zip_code: "76450",

    ste_name: "TX",
  },
  {
    zip_code: "76490",

    ste_name: "TX",
  },
  {
    zip_code: "76549",

    ste_name: "TX",
  },
  {
    zip_code: "76624",

    ste_name: "TX",
  },
  {
    zip_code: "76629",

    ste_name: "TX",
  },
  {
    zip_code: "76798",

    ste_name: "TX",
  },
  {
    zip_code: "76844",

    ste_name: "TX",
  },
  {
    zip_code: "76864",

    ste_name: "TX",
  },
  {
    zip_code: "76882",

    ste_name: "TX",
  },
  {
    zip_code: "77043",

    ste_name: "TX",
  },
  {
    zip_code: "77058",

    ste_name: "TX",
  },
  {
    zip_code: "77301",

    ste_name: "TX",
  },
  {
    zip_code: "77358",

    ste_name: "TX",
  },
  {
    zip_code: "77359",

    ste_name: "TX",
  },
  {
    zip_code: "77470",

    ste_name: "TX",
  },
  {
    zip_code: "77473",

    ste_name: "TX",
  },
  {
    zip_code: "77510",

    ste_name: "TX",
  },
  {
    zip_code: "77521",

    ste_name: "TX",
  },
  {
    zip_code: "77530",

    ste_name: "TX",
  },
  {
    zip_code: "77565",

    ste_name: "TX",
  },
  {
    zip_code: "77573",

    ste_name: "TX",
  },
  {
    zip_code: "77614",

    ste_name: "TX",
  },
  {
    zip_code: "77656",

    ste_name: "TX",
  },
  {
    zip_code: "77663",

    ste_name: "TX",
  },
  {
    zip_code: "77872",

    ste_name: "TX",
  },
  {
    zip_code: "77963",

    ste_name: "TX",
  },
  {
    zip_code: "77973",

    ste_name: "TX",
  },
  {
    zip_code: "77976",

    ste_name: "TX",
  },
  {
    zip_code: "77988",

    ste_name: "TX",
  },
  {
    zip_code: "78002",

    ste_name: "TX",
  },
  {
    zip_code: "78073",

    ste_name: "TX",
  },
  {
    zip_code: "78104",

    ste_name: "TX",
  },
  {
    zip_code: "78210",

    ste_name: "TX",
  },
  {
    zip_code: "78212",

    ste_name: "TX",
  },
  {
    zip_code: "78230",

    ste_name: "TX",
  },
  {
    zip_code: "78234",

    ste_name: "TX",
  },
  {
    zip_code: "78352",

    ste_name: "TX",
  },
  {
    zip_code: "78380",

    ste_name: "TX",
  },
  {
    zip_code: "78624",

    ste_name: "TX",
  },
  {
    zip_code: "78634",

    ste_name: "TX",
  },
  {
    zip_code: "78636",

    ste_name: "TX",
  },
  {
    zip_code: "78643",

    ste_name: "TX",
  },
  {
    zip_code: "78670",

    ste_name: "TX",
  },
  {
    zip_code: "78802",

    ste_name: "TX",
  },
  {
    zip_code: "78860",

    ste_name: "TX",
  },
  {
    zip_code: "78879",

    ste_name: "TX",
  },
  {
    zip_code: "79018",

    ste_name: "TX",
  },
  {
    zip_code: "79027",

    ste_name: "TX",
  },
  {
    zip_code: "79054",

    ste_name: "TX",
  },
  {
    zip_code: "79251",

    ste_name: "TX",
  },
  {
    zip_code: "79255",

    ste_name: "TX",
  },
  {
    zip_code: "79511",

    ste_name: "TX",
  },
  {
    zip_code: "79533",

    ste_name: "TX",
  },
  {
    zip_code: "79846",

    ste_name: "TX",
  },
  {
    zip_code: "79849",

    ste_name: "TX",
  },
  {
    zip_code: "79924",

    ste_name: "TX",
  },
  {
    zip_code: "79930",

    ste_name: "TX",
  },
  {
    zip_code: "80019",

    ste_name: "CO",
  },
  {
    zip_code: "80102",

    ste_name: "CO",
  },
  {
    zip_code: "80107",

    ste_name: "CO",
  },
  {
    zip_code: "80136",

    ste_name: "CO",
  },
  {
    zip_code: "80202",

    ste_name: "CO",
  },
  {
    zip_code: "80210",

    ste_name: "CO",
  },
  {
    zip_code: "80214",

    ste_name: "CO",
  },
  {
    zip_code: "80442",

    ste_name: "CO",
  },
  {
    zip_code: "80446",

    ste_name: "CO",
  },
  {
    zip_code: "80473",

    ste_name: "CO",
  },
  {
    zip_code: "80651",

    ste_name: "CO",
  },
  {
    zip_code: "80731",

    ste_name: "CO",
  },
  {
    zip_code: "80860",

    ste_name: "CO",
  },
  {
    zip_code: "80862",

    ste_name: "CO",
  },
  {
    zip_code: "80908",

    ste_name: "CO",
  },
  {
    zip_code: "81023",

    ste_name: "CO",
  },
  {
    zip_code: "81050",

    ste_name: "CO",
  },
  {
    zip_code: "81327",

    ste_name: "CO",
  },
  {
    zip_code: "81332",

    ste_name: "CO",
  },
  {
    zip_code: "81334",

    ste_name: "CO",
  },
  {
    zip_code: "81403",

    ste_name: "CO",
  },
  {
    zip_code: "81653",

    ste_name: "CO",
  },
  {
    zip_code: "82638",

    ste_name: "WY",
  },
  {
    zip_code: "82832",

    ste_name: "WY",
  },
  {
    zip_code: "82833",

    ste_name: "WY",
  },
  {
    zip_code: "82925",

    ste_name: "WY",
  },
  {
    zip_code: "83123",

    ste_name: "WY",
  },
  {
    zip_code: "83642",

    ste_name: "ID",
  },
  {
    zip_code: "83661",

    ste_name: "ID",
  },
  {
    zip_code: "83686",

    ste_name: "ID",
  },
  {
    zip_code: "84005",

    ste_name: "UT",
  },
  {
    zip_code: "84017",

    ste_name: "UT",
  },
  {
    zip_code: "84036",

    ste_name: "UT",
  },
  {
    zip_code: "84075",

    ste_name: "UT",
  },
  {
    zip_code: "84534",

    ste_name: "UT",
  },
  {
    zip_code: "84624",

    ste_name: "UT",
  },
  {
    zip_code: "84667",

    ste_name: "UT",
  },
  {
    zip_code: "84741",

    ste_name: "UT",
  },
  {
    zip_code: "85083",

    ste_name: "AZ",
  },
  {
    zip_code: "85331",

    ste_name: "AZ",
  },
  {
    zip_code: "85352",

    ste_name: "AZ",
  },
  {
    zip_code: "85533",

    ste_name: "AZ",
  },
  {
    zip_code: "85635",

    ste_name: "AZ",
  },
  {
    zip_code: "85648",

    ste_name: "AZ",
  },
  {
    zip_code: "85701",

    ste_name: "AZ",
  },
  {
    zip_code: "85743",

    ste_name: "AZ",
  },
  {
    zip_code: "85750",

    ste_name: "AZ",
  },
  {
    zip_code: "86011",

    ste_name: "AZ",
  },
  {
    zip_code: "86321",

    ste_name: "AZ",
  },
  {
    zip_code: "86535",

    ste_name: "AZ",
  },
  {
    zip_code: "87008",

    ste_name: "NM",
  },
  {
    zip_code: "87024",

    ste_name: "NM",
  },
  {
    zip_code: "87028",

    ste_name: "NM",
  },
  {
    zip_code: "87083",

    ste_name: "NM",
  },
  {
    zip_code: "87322",

    ste_name: "NM",
  },
  {
    zip_code: "87549",

    ste_name: "NM",
  },
  {
    zip_code: "87723",

    ste_name: "NM",
  },
  {
    zip_code: "87747",

    ste_name: "NM",
  },
  {
    zip_code: "87821",

    ste_name: "NM",
  },
  {
    zip_code: "87901",

    ste_name: "NM",
  },
  {
    zip_code: "88020",

    ste_name: "NM",
  },
  {
    zip_code: "88033",

    ste_name: "NM",
  },
  {
    zip_code: "88051",

    ste_name: "NM",
  },
  {
    zip_code: "88052",

    ste_name: "NM",
  },
  {
    zip_code: "88056",

    ste_name: "NM",
  },
  {
    zip_code: "88324",

    ste_name: "NM",
  },
  {
    zip_code: "88344",

    ste_name: "NM",
  },
  {
    zip_code: "89060",

    ste_name: "NV",
  },
  {
    zip_code: "89130",

    ste_name: "NV",
  },
  {
    zip_code: "89183",

    ste_name: "NV",
  },
  {
    zip_code: "89413",

    ste_name: "NV",
  },
  {
    zip_code: "90073",

    ste_name: "CA",
  },
  {
    zip_code: "90089",

    ste_name: "CA",
  },
  {
    zip_code: "90263",

    ste_name: "CA",
  },
  {
    zip_code: "90292",

    ste_name: "CA",
  },
  {
    zip_code: "90293",

    ste_name: "CA",
  },
  {
    zip_code: "90305",

    ste_name: "CA",
  },
  {
    zip_code: "90720",

    ste_name: "CA",
  },
  {
    zip_code: "91008",

    ste_name: "CA",
  },
  {
    zip_code: "91307",

    ste_name: "CA",
  },
  {
    zip_code: "91436",

    ste_name: "CA",
  },
  {
    zip_code: "91711",

    ste_name: "CA",
  },
  {
    zip_code: "91724",

    ste_name: "CA",
  },
  {
    zip_code: "92040",

    ste_name: "CA",
  },
  {
    zip_code: "92067",

    ste_name: "CA",
  },
  {
    zip_code: "92086",

    ste_name: "CA",
  },
  {
    zip_code: "92116",

    ste_name: "CA",
  },
  {
    zip_code: "92145",

    ste_name: "CA",
  },
  {
    zip_code: "92273",

    ste_name: "CA",
  },
  {
    zip_code: "92314",

    ste_name: "CA",
  },
  {
    zip_code: "92346",

    ste_name: "CA",
  },
  {
    zip_code: "92504",

    ste_name: "CA",
  },
  {
    zip_code: "92507",

    ste_name: "CA",
  },
  {
    zip_code: "92518",

    ste_name: "CA",
  },
  {
    zip_code: "92536",

    ste_name: "CA",
  },
  {
    zip_code: "92844",

    ste_name: "CA",
  },
  {
    zip_code: "92867",

    ste_name: "CA",
  },
  {
    zip_code: "93015",

    ste_name: "CA",
  },
  {
    zip_code: "93105",

    ste_name: "CA",
  },
  {
    zip_code: "93239",

    ste_name: "CA",
  },
  {
    zip_code: "93258",

    ste_name: "CA",
  },
  {
    zip_code: "93277",

    ste_name: "CA",
  },
  {
    zip_code: "93292",

    ste_name: "CA",
  },
  {
    zip_code: "93410",

    ste_name: "CA",
  },
  {
    zip_code: "93501",

    ste_name: "CA",
  },
  {
    zip_code: "93527",

    ste_name: "CA",
  },
  {
    zip_code: "93531",

    ste_name: "CA",
  },
  {
    zip_code: "93622",

    ste_name: "CA",
  },
  {
    zip_code: "93635",

    ste_name: "CA",
  },
  {
    zip_code: "93647",

    ste_name: "CA",
  },
  {
    zip_code: "93654",

    ste_name: "CA",
  },
  {
    zip_code: "93725",

    ste_name: "CA",
  },
  {
    zip_code: "93908",

    ste_name: "CA",
  },
  {
    zip_code: "93940",

    ste_name: "CA",
  },
  {
    zip_code: "94065",

    ste_name: "CA",
  },
  {
    zip_code: "94066",

    ste_name: "CA",
  },
  {
    zip_code: "94112",

    ste_name: "CA",
  },
  {
    zip_code: "94525",

    ste_name: "CA",
  },
  {
    zip_code: "94539",

    ste_name: "CA",
  },
  {
    zip_code: "94574",

    ste_name: "CA",
  },
  {
    zip_code: "94703",

    ste_name: "CA",
  },
  {
    zip_code: "94903",

    ste_name: "CA",
  },
  {
    zip_code: "94956",

    ste_name: "CA",
  },
  {
    zip_code: "95128",

    ste_name: "CA",
  },
  {
    zip_code: "95205",

    ste_name: "CA",
  },
  {
    zip_code: "95348",

    ste_name: "CA",
  },
  {
    zip_code: "95425",

    ste_name: "CA",
  },
  {
    zip_code: "95449",

    ste_name: "CA",
  },
  {
    zip_code: "95461",

    ste_name: "CA",
  },
  {
    zip_code: "95527",

    ste_name: "CA",
  },
  {
    zip_code: "95698",

    ste_name: "CA",
  },
  {
    zip_code: "95762",

    ste_name: "CA",
  },
  {
    zip_code: "95925",

    ste_name: "CA",
  },
  {
    zip_code: "96094",

    ste_name: "CA",
  },
  {
    zip_code: "96760",

    ste_name: "HI",
  },
  {
    zip_code: "96863",

    ste_name: "HI",
  },
  {
    zip_code: "97013",

    ste_name: "OR",
  },
  {
    zip_code: "97030",

    ste_name: "OR",
  },
  {
    zip_code: "97056",

    ste_name: "OR",
  },
  {
    zip_code: "97060",

    ste_name: "OR",
  },
  {
    zip_code: "97223",

    ste_name: "OR",
  },
  {
    zip_code: "97367",

    ste_name: "OR",
  },
  {
    zip_code: "97391",

    ste_name: "OR",
  },
  {
    zip_code: "97404",

    ste_name: "OR",
  },
  {
    zip_code: "97620",

    ste_name: "OR",
  },
  {
    zip_code: "97710",

    ste_name: "OR",
  },
  {
    zip_code: "97813",

    ste_name: "OR",
  },
  {
    zip_code: "97835",

    ste_name: "OR",
  },
  {
    zip_code: "97867",

    ste_name: "OR",
  },
  {
    zip_code: "98056",

    ste_name: "WA",
  },
  {
    zip_code: "98115",

    ste_name: "WA",
  },
  {
    zip_code: "98155",

    ste_name: "WA",
  },
  {
    zip_code: "98251",

    ste_name: "WA",
  },
  {
    zip_code: "98260",

    ste_name: "WA",
  },
  {
    zip_code: "98278",

    ste_name: "WA",
  },
  {
    zip_code: "98371",

    ste_name: "WA",
  },
  {
    zip_code: "98513",

    ste_name: "WA",
  },
  {
    zip_code: "98538",

    ste_name: "WA",
  },
  {
    zip_code: "98548",

    ste_name: "WA",
  },
  {
    zip_code: "98552",

    ste_name: "WA",
  },
  {
    zip_code: "98558",

    ste_name: "WA",
  },
  {
    zip_code: "98560",

    ste_name: "WA",
  },
  {
    zip_code: "98632",

    ste_name: "WA",
  },
  {
    zip_code: "98813",

    ste_name: "WA",
  },
  {
    zip_code: "98902",

    ste_name: "WA",
  },
  {
    zip_code: "98939",

    ste_name: "WA",
  },
  {
    zip_code: "99003",

    ste_name: "WA",
  },
  {
    zip_code: "99006",

    ste_name: "WA",
  },
  {
    zip_code: "99034",

    ste_name: "WA",
  },
  {
    zip_code: "99208",

    ste_name: "WA",
  },
  {
    zip_code: "99329",

    ste_name: "WA",
  },
  {
    zip_code: "99517",

    ste_name: "AK",
  },
  {
    zip_code: "99586",

    ste_name: "AK",
  },
  {
    zip_code: "99651",

    ste_name: "AK",
  },
  {
    zip_code: "99656",

    ste_name: "AK",
  },
  {
    zip_code: "99671",

    ste_name: "AK",
  },
  {
    zip_code: "31047",

    ste_name: "GA",
  },
  {
    zip_code: "31304",

    ste_name: "GA",
  },
  {
    zip_code: "31561",

    ste_name: "GA",
  },
  {
    zip_code: "31637",

    ste_name: "GA",
  },
  {
    zip_code: "31650",

    ste_name: "GA",
  },
  {
    zip_code: "31815",

    ste_name: "GA",
  },
  {
    zip_code: "32066",

    ste_name: "FL",
  },
  {
    zip_code: "32112",

    ste_name: "FL",
  },
  {
    zip_code: "32117",

    ste_name: "FL",
  },
  {
    zip_code: "32179",

    ste_name: "FL",
  },
  {
    zip_code: "32331",

    ste_name: "FL",
  },
  {
    zip_code: "32509",

    ste_name: "FL",
  },
  {
    zip_code: "32544",

    ste_name: "FL",
  },
  {
    zip_code: "32548",

    ste_name: "FL",
  },
  {
    zip_code: "32776",

    ste_name: "FL",
  },
  {
    zip_code: "32808",

    ste_name: "FL",
  },
  {
    zip_code: "33039",

    ste_name: "FL",
  },
  {
    zip_code: "33064",

    ste_name: "FL",
  },
  {
    zip_code: "33067",

    ste_name: "FL",
  },
  {
    zip_code: "33131",

    ste_name: "FL",
  },
  {
    zip_code: "33177",

    ste_name: "FL",
  },
  {
    zip_code: "33190",

    ste_name: "FL",
  },
  {
    zip_code: "33483",

    ste_name: "FL",
  },
  {
    zip_code: "33484",

    ste_name: "FL",
  },
  {
    zip_code: "33543",

    ste_name: "FL",
  },
  {
    zip_code: "33604",

    ste_name: "FL",
  },
  {
    zip_code: "33624",

    ste_name: "FL",
  },
  {
    zip_code: "33713",

    ste_name: "FL",
  },
  {
    zip_code: "33760",

    ste_name: "FL",
  },
  {
    zip_code: "34134",

    ste_name: "FL",
  },
  {
    zip_code: "34210",

    ste_name: "FL",
  },
  {
    zip_code: "34429",

    ste_name: "FL",
  },
  {
    zip_code: "34638",

    ste_name: "FL",
  },
  {
    zip_code: "34689",

    ste_name: "FL",
  },
  {
    zip_code: "34731",

    ste_name: "FL",
  },
  {
    zip_code: "34951",

    ste_name: "FL",
  },
  {
    zip_code: "35064",

    ste_name: "AL",
  },
  {
    zip_code: "35068",

    ste_name: "AL",
  },
  {
    zip_code: "35117",

    ste_name: "AL",
  },
  {
    zip_code: "35446",

    ste_name: "AL",
  },
  {
    zip_code: "35470",

    ste_name: "AL",
  },
  {
    zip_code: "35592",

    ste_name: "AL",
  },
  {
    zip_code: "35601",

    ste_name: "AL",
  },
  {
    zip_code: "35671",

    ste_name: "AL",
  },
  {
    zip_code: "35803",

    ste_name: "AL",
  },
  {
    zip_code: "35901",

    ste_name: "AL",
  },
  {
    zip_code: "35968",

    ste_name: "AL",
  },
  {
    zip_code: "35980",

    ste_name: "AL",
  },
  {
    zip_code: "36006",

    ste_name: "AL",
  },
  {
    zip_code: "36040",

    ste_name: "AL",
  },
  {
    zip_code: "36041",

    ste_name: "AL",
  },
  {
    zip_code: "36551",

    ste_name: "AL",
  },
  {
    zip_code: "36569",

    ste_name: "AL",
  },
  {
    zip_code: "36723",

    ste_name: "AL",
  },
  {
    zip_code: "36775",

    ste_name: "AL",
  },
  {
    zip_code: "37025",

    ste_name: "TN",
  },
  {
    zip_code: "37057",

    ste_name: "TN",
  },
  {
    zip_code: "37058",

    ste_name: "TN",
  },
  {
    zip_code: "37064",

    ste_name: "TN",
  },
  {
    zip_code: "37138",

    ste_name: "TN",
  },
  {
    zip_code: "37351",

    ste_name: "TN",
  },
  {
    zip_code: "37367",

    ste_name: "TN",
  },
  {
    zip_code: "37377",

    ste_name: "TN",
  },
  {
    zip_code: "37385",

    ste_name: "TN",
  },
  {
    zip_code: "37732",

    ste_name: "TN",
  },
  {
    zip_code: "37764",

    ste_name: "TN",
  },
  {
    zip_code: "37825",

    ste_name: "TN",
  },
  {
    zip_code: "37843",

    ste_name: "TN",
  },
  {
    zip_code: "37845",

    ste_name: "TN",
  },
  {
    zip_code: "37924",

    ste_name: "TN",
  },
  {
    zip_code: "38012",

    ste_name: "TN",
  },
  {
    zip_code: "38133",

    ste_name: "TN",
  },
  {
    zip_code: "38201",

    ste_name: "TN",
  },
  {
    zip_code: "38256",

    ste_name: "TN",
  },
  {
    zip_code: "38318",

    ste_name: "TN",
  },
  {
    zip_code: "38326",

    ste_name: "TN",
  },
  {
    zip_code: "38333",

    ste_name: "TN",
  },
  {
    zip_code: "38347",

    ste_name: "TN",
  },
  {
    zip_code: "38463",

    ste_name: "TN",
  },
  {
    zip_code: "38471",

    ste_name: "TN",
  },
  {
    zip_code: "38542",

    ste_name: "TN",
  },
  {
    zip_code: "38554",

    ste_name: "TN",
  },
  {
    zip_code: "38622",

    ste_name: "MS",
  },
  {
    zip_code: "38670",

    ste_name: "MS",
  },
  {
    zip_code: "38674",

    ste_name: "MS",
  },
  {
    zip_code: "38761",

    ste_name: "MS",
  },
  {
    zip_code: "38764",

    ste_name: "MS",
  },
  {
    zip_code: "38824",

    ste_name: "MS",
  },
  {
    zip_code: "39066",

    ste_name: "MS",
  },
  {
    zip_code: "39078",

    ste_name: "MS",
  },
  {
    zip_code: "39154",

    ste_name: "MS",
  },
  {
    zip_code: "39201",

    ste_name: "MS",
  },
  {
    zip_code: "39212",

    ste_name: "MS",
  },
  {
    zip_code: "39423",

    ste_name: "MS",
  },
  {
    zip_code: "39426",

    ste_name: "MS",
  },
  {
    zip_code: "39635",

    ste_name: "MS",
  },
  {
    zip_code: "39669",

    ste_name: "MS",
  },
  {
    zip_code: "39759",

    ste_name: "MS",
  },
  {
    zip_code: "39885",

    ste_name: "GA",
  },
  {
    zip_code: "40010",

    ste_name: "KY",
  },
  {
    zip_code: "40033",

    ste_name: "KY",
  },
  {
    zip_code: "40063",

    ste_name: "KY",
  },
  {
    zip_code: "40160",

    ste_name: "KY",
  },
  {
    zip_code: "40219",

    ste_name: "KY",
  },
  {
    zip_code: "40280",

    ste_name: "KY",
  },
  {
    zip_code: "40380",

    ste_name: "KY",
  },
  {
    zip_code: "40409",

    ste_name: "KY",
  },
  {
    zip_code: "40502",

    ste_name: "KY",
  },
  {
    zip_code: "40953",

    ste_name: "KY",
  },
  {
    zip_code: "41002",

    ste_name: "KY",
  },
  {
    zip_code: "41062",

    ste_name: "KY",
  },
  {
    zip_code: "41159",

    ste_name: "KY",
  },
  {
    zip_code: "41222",

    ste_name: "KY",
  },
  {
    zip_code: "41250",

    ste_name: "KY",
  },
  {
    zip_code: "41267",

    ste_name: "KY",
  },
  {
    zip_code: "41425",

    ste_name: "KY",
  },
  {
    zip_code: "41526",

    ste_name: "KY",
  },
  {
    zip_code: "41571",

    ste_name: "KY",
  },
  {
    zip_code: "41804",

    ste_name: "KY",
  },
  {
    zip_code: "42023",

    ste_name: "KY",
  },
  {
    zip_code: "42349",

    ste_name: "KY",
  },
  {
    zip_code: "42420",

    ste_name: "KY",
  },
  {
    zip_code: "42445",

    ste_name: "KY",
  },
  {
    zip_code: "42462",

    ste_name: "KY",
  },
  {
    zip_code: "42503",

    ste_name: "KY",
  },
  {
    zip_code: "42715",

    ste_name: "KY",
  },
  {
    zip_code: "42733",

    ste_name: "KY",
  },
  {
    zip_code: "42765",

    ste_name: "KY",
  },
  {
    zip_code: "42776",

    ste_name: "KY",
  },
  {
    zip_code: "43006",

    ste_name: "OH",
  },
  {
    zip_code: "43037",

    ste_name: "OH",
  },
  {
    zip_code: "43040",

    ste_name: "OH",
  },
  {
    zip_code: "43061",

    ste_name: "OH",
  },
  {
    zip_code: "43082",

    ste_name: "OH",
  },
  {
    zip_code: "43147",

    ste_name: "OH",
  },
  {
    zip_code: "43604",

    ste_name: "OH",
  },
  {
    zip_code: "43738",

    ste_name: "OH",
  },
  {
    zip_code: "43762",

    ste_name: "OH",
  },
  {
    zip_code: "43780",

    ste_name: "OH",
  },
  {
    zip_code: "44265",

    ste_name: "OH",
  },
  {
    zip_code: "44423",

    ste_name: "OH",
  },
  {
    zip_code: "44672",

    ste_name: "OH",
  },
  {
    zip_code: "44677",

    ste_name: "OH",
  },
  {
    zip_code: "44850",

    ste_name: "OH",
  },
  {
    zip_code: "44881",

    ste_name: "OH",
  },
  {
    zip_code: "45040",

    ste_name: "OH",
  },
  {
    zip_code: "45062",

    ste_name: "OH",
  },
  {
    zip_code: "45207",

    ste_name: "OH",
  },
  {
    zip_code: "45227",

    ste_name: "OH",
  },
  {
    zip_code: "45231",

    ste_name: "OH",
  },
  {
    zip_code: "45241",

    ste_name: "OH",
  },
  {
    zip_code: "45316",

    ste_name: "OH",
  },
  {
    zip_code: "45333",

    ste_name: "OH",
  },
  {
    zip_code: "45370",

    ste_name: "OH",
  },
  {
    zip_code: "45789",

    ste_name: "OH",
  },
  {
    zip_code: "45819",

    ste_name: "OH",
  },
  {
    zip_code: "45838",

    ste_name: "OH",
  },
  {
    zip_code: "45843",

    ste_name: "OH",
  },
  {
    zip_code: "45870",

    ste_name: "OH",
  },
  {
    zip_code: "45886",

    ste_name: "OH",
  },
  {
    zip_code: "45895",

    ste_name: "OH",
  },
  {
    zip_code: "46030",

    ste_name: "IN",
  },
  {
    zip_code: "46035",

    ste_name: "IN",
  },
  {
    zip_code: "46065",

    ste_name: "IN",
  },
  {
    zip_code: "46166",

    ste_name: "IN",
  },
  {
    zip_code: "46183",

    ste_name: "IN",
  },
  {
    zip_code: "46307",

    ste_name: "IN",
  },
  {
    zip_code: "46323",

    ste_name: "IN",
  },
  {
    zip_code: "46340",

    ste_name: "IN",
  },
  {
    zip_code: "46350",

    ste_name: "IN",
  },
  {
    zip_code: "46366",

    ste_name: "IN",
  },
  {
    zip_code: "46368",

    ste_name: "IN",
  },
  {
    zip_code: "46402",

    ste_name: "IN",
  },
  {
    zip_code: "46409",

    ste_name: "IN",
  },
  {
    zip_code: "46504",

    ste_name: "IN",
  },
  {
    zip_code: "46511",

    ste_name: "IN",
  },
  {
    zip_code: "46721",

    ste_name: "IN",
  },
  {
    zip_code: "46763",

    ste_name: "IN",
  },
  {
    zip_code: "46819",

    ste_name: "IN",
  },
  {
    zip_code: "46920",

    ste_name: "IN",
  },
  {
    zip_code: "46923",

    ste_name: "IN",
  },
  {
    zip_code: "46929",

    ste_name: "IN",
  },
  {
    zip_code: "46933",

    ste_name: "IN",
  },
  {
    zip_code: "46953",

    ste_name: "IN",
  },
  {
    zip_code: "46958",

    ste_name: "IN",
  },
  {
    zip_code: "47003",

    ste_name: "IN",
  },
  {
    zip_code: "47108",

    ste_name: "IN",
  },
  {
    zip_code: "47170",

    ste_name: "IN",
  },
  {
    zip_code: "47352",

    ste_name: "IN",
  },
  {
    zip_code: "47384",

    ste_name: "IN",
  },
  {
    zip_code: "47513",

    ste_name: "IN",
  },
  {
    zip_code: "47596",

    ste_name: "IN",
  },
  {
    zip_code: "47837",

    ste_name: "IN",
  },
  {
    zip_code: "47904",

    ste_name: "IN",
  },
  {
    zip_code: "47974",

    ste_name: "IN",
  },
  {
    zip_code: "48009",

    ste_name: "MI",
  },
  {
    zip_code: "48146",

    ste_name: "MI",
  },
  {
    zip_code: "48157",

    ste_name: "MI",
  },
  {
    zip_code: "48186",

    ste_name: "MI",
  },
  {
    zip_code: "48188",

    ste_name: "MI",
  },
  {
    zip_code: "48193",

    ste_name: "MI",
  },
  {
    zip_code: "48195",

    ste_name: "MI",
  },
  {
    zip_code: "48234",

    ste_name: "MI",
  },
  {
    zip_code: "48242",

    ste_name: "MI",
  },
  {
    zip_code: "48370",

    ste_name: "MI",
  },
  {
    zip_code: "48375",

    ste_name: "MI",
  },
  {
    zip_code: "48430",

    ste_name: "MI",
  },
  {
    zip_code: "48722",

    ste_name: "MI",
  },
  {
    zip_code: "48739",

    ste_name: "MI",
  },
  {
    zip_code: "48765",

    ste_name: "MI",
  },
  {
    zip_code: "48806",

    ste_name: "MI",
  },
  {
    zip_code: "48823",

    ste_name: "MI",
  },
  {
    zip_code: "48827",

    ste_name: "MI",
  },
  {
    zip_code: "49026",

    ste_name: "MI",
  },
  {
    zip_code: "49031",

    ste_name: "MI",
  },
  {
    zip_code: "49084",

    ste_name: "MI",
  },
  {
    zip_code: "49252",

    ste_name: "MI",
  },
  {
    zip_code: "49255",

    ste_name: "MI",
  },
  {
    zip_code: "49331",

    ste_name: "MI",
  },
  {
    zip_code: "49347",

    ste_name: "MI",
  },
  {
    zip_code: "49423",

    ste_name: "MI",
  },
  {
    zip_code: "49425",

    ste_name: "MI",
  },
  {
    zip_code: "49428",

    ste_name: "MI",
  },
  {
    zip_code: "49431",

    ste_name: "MI",
  },
  {
    zip_code: "49453",

    ste_name: "MI",
  },
  {
    zip_code: "49534",

    ste_name: "MI",
  },
  {
    zip_code: "49640",

    ste_name: "MI",
  },
  {
    zip_code: "49646",

    ste_name: "MI",
  },
  {
    zip_code: "49663",

    ste_name: "MI",
  },
  {
    zip_code: "49682",

    ste_name: "MI",
  },
  {
    zip_code: "49720",

    ste_name: "MI",
  },
  {
    zip_code: "49770",

    ste_name: "MI",
  },
  {
    zip_code: "49847",

    ste_name: "MI",
  },
  {
    zip_code: "49861",

    ste_name: "MI",
  },
  {
    zip_code: "50023",

    ste_name: "IA",
  },
  {
    zip_code: "50073",

    ste_name: "IA",
  },
  {
    zip_code: "50127",

    ste_name: "IA",
  },
  {
    zip_code: "50130",

    ste_name: "IA",
  },
  {
    zip_code: "50226",

    ste_name: "IA",
  },
  {
    zip_code: "50246",

    ste_name: "IA",
  },
  {
    zip_code: "50256",

    ste_name: "IA",
  },
  {
    zip_code: "50586",

    ste_name: "IA",
  },
  {
    zip_code: "50602",

    ste_name: "IA",
  },
  {
    zip_code: "50647",

    ste_name: "IA",
  },
  {
    zip_code: "50854",

    ste_name: "IA",
  },
  {
    zip_code: "51003",

    ste_name: "IA",
  },
  {
    zip_code: "51006",

    ste_name: "IA",
  },
  {
    zip_code: "51012",

    ste_name: "IA",
  },
  {
    zip_code: "51016",

    ste_name: "IA",
  },
  {
    zip_code: "51053",

    ste_name: "IA",
  },
  {
    zip_code: "51245",

    ste_name: "IA",
  },
  {
    zip_code: "51246",

    ste_name: "IA",
  },
  {
    zip_code: "51341",

    ste_name: "IA",
  },
  {
    zip_code: "51365",

    ste_name: "IA",
  },
  {
    zip_code: "51449",

    ste_name: "IA",
  },
  {
    zip_code: "51536",

    ste_name: "IA",
  },
  {
    zip_code: "52048",

    ste_name: "IA",
  },
  {
    zip_code: "52053",

    ste_name: "IA",
  },
  {
    zip_code: "52066",

    ste_name: "IA",
  },
  {
    zip_code: "52070",

    ste_name: "IA",
  },
  {
    zip_code: "52155",

    ste_name: "IA",
  },
  {
    zip_code: "52257",

    ste_name: "IA",
  },
  {
    zip_code: "52361",

    ste_name: "IA",
  },
  {
    zip_code: "52362",

    ste_name: "IA",
  },
  {
    zip_code: "52405",

    ste_name: "IA",
  },
  {
    zip_code: "52581",

    ste_name: "IA",
  },
  {
    zip_code: "52651",

    ste_name: "IA",
  },
  {
    zip_code: "52727",

    ste_name: "IA",
  },
  {
    zip_code: "53146",

    ste_name: "WI",
  },
  {
    zip_code: "53149",

    ste_name: "WI",
  },
  {
    zip_code: "53167",

    ste_name: "WI",
  },
  {
    zip_code: "53183",

    ste_name: "WI",
  },
  {
    zip_code: "53191",

    ste_name: "WI",
  },
  {
    zip_code: "53195",

    ste_name: "WI",
  },
  {
    zip_code: "53566",

    ste_name: "WI",
  },
  {
    zip_code: "53571",

    ste_name: "WI",
  },
  {
    zip_code: "53580",

    ste_name: "WI",
  },
  {
    zip_code: "53599",

    ste_name: "WI",
  },
  {
    zip_code: "53703",

    ste_name: "WI",
  },
  {
    zip_code: "53711",

    ste_name: "WI",
  },
  {
    zip_code: "53717",

    ste_name: "WI",
  },
  {
    zip_code: "53801",

    ste_name: "WI",
  },
  {
    zip_code: "54229",

    ste_name: "WI",
  },
  {
    zip_code: "54473",

    ste_name: "WI",
  },
  {
    zip_code: "54537",

    ste_name: "WI",
  },
  {
    zip_code: "54540",

    ste_name: "WI",
  },
  {
    zip_code: "54656",

    ste_name: "WI",
  },
  {
    zip_code: "54726",

    ste_name: "WI",
  },
  {
    zip_code: "54848",

    ste_name: "WI",
  },
  {
    zip_code: "54853",

    ste_name: "WI",
  },
  {
    zip_code: "54865",

    ste_name: "WI",
  },
  {
    zip_code: "54870",

    ste_name: "WI",
  },
  {
    zip_code: "54871",

    ste_name: "WI",
  },
  {
    zip_code: "54933",

    ste_name: "WI",
  },
  {
    zip_code: "54966",

    ste_name: "WI",
  },
  {
    zip_code: "54967",

    ste_name: "WI",
  },
  {
    zip_code: "54968",

    ste_name: "WI",
  },
  {
    zip_code: "54979",

    ste_name: "WI",
  },
  {
    zip_code: "55006",

    ste_name: "MN",
  },
  {
    zip_code: "55020",

    ste_name: "MN",
  },
  {
    zip_code: "55054",

    ste_name: "MN",
  },
  {
    zip_code: "55358",

    ste_name: "MN",
  },
  {
    zip_code: "55364",

    ste_name: "MN",
  },
  {
    zip_code: "55374",

    ste_name: "MN",
  },
  {
    zip_code: "55402",

    ste_name: "MN",
  },
  {
    zip_code: "55410",

    ste_name: "MN",
  },
  {
    zip_code: "55444",

    ste_name: "MN",
  },
  {
    zip_code: "55602",

    ste_name: "MN",
  },
  {
    zip_code: "55609",

    ste_name: "MN",
  },
  {
    zip_code: "55616",

    ste_name: "MN",
  },
  {
    zip_code: "55710",

    ste_name: "MN",
  },
  {
    zip_code: "55716",

    ste_name: "MN",
  },
  {
    zip_code: "55741",

    ste_name: "MN",
  },
  {
    zip_code: "55769",

    ste_name: "MN",
  },
  {
    zip_code: "55811",

    ste_name: "MN",
  },
  {
    zip_code: "56020",

    ste_name: "MN",
  },
  {
    zip_code: "56058",

    ste_name: "MN",
  },
  {
    zip_code: "56127",

    ste_name: "MN",
  },
  {
    zip_code: "56140",

    ste_name: "MN",
  },
  {
    zip_code: "56147",

    ste_name: "MN",
  },
  {
    zip_code: "56166",

    ste_name: "MN",
  },
  {
    zip_code: "56215",

    ste_name: "MN",
  },
  {
    zip_code: "56270",

    ste_name: "MN",
  },
  {
    zip_code: "56292",

    ste_name: "MN",
  },
  {
    zip_code: "56311",

    ste_name: "MN",
  },
  {
    zip_code: "56321",

    ste_name: "MN",
  },
  {
    zip_code: "56324",

    ste_name: "MN",
  },
  {
    zip_code: "56330",

    ste_name: "MN",
  },
  {
    zip_code: "56379",

    ste_name: "MN",
  },
  {
    zip_code: "56381",

    ste_name: "MN",
  },
  {
    zip_code: "56518",

    ste_name: "MN",
  },
  {
    zip_code: "56551",

    ste_name: "MN",
  },
  {
    zip_code: "56553",

    ste_name: "MN",
  },
  {
    zip_code: "56585",

    ste_name: "MN",
  },
  {
    zip_code: "56591",

    ste_name: "MN",
  },
  {
    zip_code: "56647",

    ste_name: "MN",
  },
  {
    zip_code: "56668",

    ste_name: "MN",
  },
  {
    zip_code: "56754",

    ste_name: "MN",
  },
  {
    zip_code: "56760",

    ste_name: "MN",
  },
  {
    zip_code: "57057",

    ste_name: "SD",
  },
  {
    zip_code: "57065",

    ste_name: "SD",
  },
  {
    zip_code: "57067",

    ste_name: "SD",
  },
  {
    zip_code: "57071",

    ste_name: "SD",
  },
  {
    zip_code: "57213",

    ste_name: "SD",
  },
  {
    zip_code: "57245",

    ste_name: "SD",
  },
  {
    zip_code: "57278",

    ste_name: "SD",
  },
  {
    zip_code: "57367",

    ste_name: "SD",
  },
  {
    zip_code: "57379",

    ste_name: "SD",
  },
  {
    zip_code: "57426",

    ste_name: "SD",
  },
  {
    zip_code: "57474",

    ste_name: "SD",
  },
  {
    zip_code: "57531",

    ste_name: "SD",
  },
  {
    zip_code: "57562",

    ste_name: "SD",
  },
  {
    zip_code: "57568",

    ste_name: "SD",
  },
  {
    zip_code: "57652",

    ste_name: "SD",
  },
  {
    zip_code: "57657",

    ste_name: "SD",
  },
  {
    zip_code: "57661",

    ste_name: "SD",
  },
  {
    zip_code: "57758",

    ste_name: "SD",
  },
  {
    zip_code: "57772",

    ste_name: "SD",
  },
  {
    zip_code: "58064",

    ste_name: "ND",
  },
  {
    zip_code: "58282",

    ste_name: "ND",
  },
  {
    zip_code: "58345",

    ste_name: "ND",
  },
  {
    zip_code: "58352",

    ste_name: "ND",
  },
  {
    zip_code: "58429",

    ste_name: "ND",
  },
  {
    zip_code: "58441",

    ste_name: "ND",
  },
  {
    zip_code: "58454",

    ste_name: "ND",
  },
  {
    zip_code: "58475",

    ste_name: "ND",
  },
  {
    zip_code: "58563",

    ste_name: "ND",
  },
  {
    zip_code: "58645",

    ste_name: "ND",
  },
  {
    zip_code: "22181",

    ste_name: "VA",
  },
  {
    zip_code: "22567",

    ste_name: "VA",
  },
  {
    zip_code: "22922",

    ste_name: "VA",
  },
  {
    zip_code: "22943",

    ste_name: "VA",
  },
  {
    zip_code: "23002",

    ste_name: "VA",
  },
  {
    zip_code: "23009",

    ste_name: "VA",
  },
  {
    zip_code: "23117",

    ste_name: "VA",
  },
  {
    zip_code: "23128",

    ste_name: "VA",
  },
  {
    zip_code: "23228",

    ste_name: "VA",
  },
  {
    zip_code: "23356",

    ste_name: "VA",
  },
  {
    zip_code: "23440",

    ste_name: "VA",
  },
  {
    zip_code: "23480",

    ste_name: "VA",
  },
  {
    zip_code: "23603",

    ste_name: "VA",
  },
  {
    zip_code: "23606",

    ste_name: "VA",
  },
  {
    zip_code: "23690",

    ste_name: "VA",
  },
  {
    zip_code: "23878",

    ste_name: "VA",
  },
  {
    zip_code: "23882",

    ste_name: "VA",
  },
  {
    zip_code: "23943",

    ste_name: "VA",
  },
  {
    zip_code: "23950",

    ste_name: "VA",
  },
  {
    zip_code: "23976",

    ste_name: "VA",
  },
  {
    zip_code: "24084",

    ste_name: "VA",
  },
  {
    zip_code: "24225",

    ste_name: "VA",
  },
  {
    zip_code: "24245",

    ste_name: "VA",
  },
  {
    zip_code: "24279",

    ste_name: "VA",
  },
  {
    zip_code: "24281",

    ste_name: "VA",
  },
  {
    zip_code: "24401",

    ste_name: "VA",
  },
  {
    zip_code: "24426",

    ste_name: "VA",
  },
  {
    zip_code: "24517",

    ste_name: "VA",
  },
  {
    zip_code: "24813",

    ste_name: "WV",
  },
  {
    zip_code: "24817",

    ste_name: "WV",
  },
  {
    zip_code: "24834",

    ste_name: "WV",
  },
  {
    zip_code: "25009",

    ste_name: "WV",
  },
  {
    zip_code: "25030",

    ste_name: "WV",
  },
  {
    zip_code: "25061",

    ste_name: "WV",
  },
  {
    zip_code: "25103",

    ste_name: "WV",
  },
  {
    zip_code: "25211",

    ste_name: "WV",
  },
  {
    zip_code: "25313",

    ste_name: "WV",
  },
  {
    zip_code: "25540",

    ste_name: "WV",
  },
  {
    zip_code: "25836",

    ste_name: "WV",
  },
  {
    zip_code: "25971",

    ste_name: "WV",
  },
  {
    zip_code: "26151",

    ste_name: "WV",
  },
  {
    zip_code: "26282",

    ste_name: "WV",
  },
  {
    zip_code: "26378",

    ste_name: "WV",
  },
  {
    zip_code: "26448",

    ste_name: "WV",
  },
  {
    zip_code: "26631",

    ste_name: "WV",
  },
  {
    zip_code: "26676",

    ste_name: "WV",
  },
  {
    zip_code: "26814",

    ste_name: "WV",
  },
  {
    zip_code: "26817",

    ste_name: "WV",
  },
  {
    zip_code: "26818",

    ste_name: "WV",
  },
  {
    zip_code: "27054",

    ste_name: "NC",
  },
  {
    zip_code: "27212",

    ste_name: "NC",
  },
  {
    zip_code: "27235",

    ste_name: "NC",
  },
  {
    zip_code: "27242",

    ste_name: "NC",
  },
  {
    zip_code: "27248",

    ste_name: "NC",
  },
  {
    zip_code: "27299",

    ste_name: "NC",
  },
  {
    zip_code: "27341",

    ste_name: "NC",
  },
  {
    zip_code: "27349",

    ste_name: "NC",
  },
  {
    zip_code: "27807",

    ste_name: "NC",
  },
  {
    zip_code: "27823",

    ste_name: "NC",
  },
  {
    zip_code: "27872",

    ste_name: "NC",
  },
  {
    zip_code: "27916",

    ste_name: "NC",
  },
  {
    zip_code: "27924",

    ste_name: "NC",
  },
  {
    zip_code: "27927",

    ste_name: "NC",
  },
  {
    zip_code: "27929",

    ste_name: "NC",
  },
  {
    zip_code: "27985",

    ste_name: "NC",
  },
  {
    zip_code: "28075",

    ste_name: "NC",
  },
  {
    zip_code: "28097",

    ste_name: "NC",
  },
  {
    zip_code: "28104",

    ste_name: "NC",
  },
  {
    zip_code: "28110",

    ste_name: "NC",
  },
  {
    zip_code: "28133",

    ste_name: "NC",
  },
  {
    zip_code: "28206",

    ste_name: "NC",
  },
  {
    zip_code: "28338",

    ste_name: "NC",
  },
  {
    zip_code: "28341",

    ste_name: "NC",
  },
  {
    zip_code: "28521",

    ste_name: "NC",
  },
  {
    zip_code: "28526",

    ste_name: "NC",
  },
  {
    zip_code: "28646",

    ste_name: "NC",
  },
  {
    zip_code: "28657",

    ste_name: "NC",
  },
  {
    zip_code: "28732",

    ste_name: "NC",
  },
  {
    zip_code: "28787",

    ste_name: "NC",
  },
  {
    zip_code: "28791",

    ste_name: "NC",
  },
  {
    zip_code: "29053",

    ste_name: "SC",
  },
  {
    zip_code: "29104",

    ste_name: "SC",
  },
  {
    zip_code: "29107",

    ste_name: "SC",
  },
  {
    zip_code: "29209",

    ste_name: "SC",
  },
  {
    zip_code: "29365",

    ste_name: "SC",
  },
  {
    zip_code: "29434",

    ste_name: "SC",
  },
  {
    zip_code: "29479",

    ste_name: "SC",
  },
  {
    zip_code: "29649",

    ste_name: "SC",
  },
  {
    zip_code: "29680",

    ste_name: "SC",
  },
  {
    zip_code: "29829",

    ste_name: "SC",
  },
  {
    zip_code: "29928",

    ste_name: "SC",
  },
  {
    zip_code: "30055",

    ste_name: "GA",
  },
  {
    zip_code: "30092",

    ste_name: "GA",
  },
  {
    zip_code: "30105",

    ste_name: "GA",
  },
  {
    zip_code: "30147",

    ste_name: "GA",
  },
  {
    zip_code: "30276",

    ste_name: "GA",
  },
  {
    zip_code: "30305",

    ste_name: "GA",
  },
  {
    zip_code: "30317",

    ste_name: "GA",
  },
  {
    zip_code: "30341",

    ste_name: "GA",
  },
  {
    zip_code: "30445",

    ste_name: "GA",
  },
  {
    zip_code: "30451",

    ste_name: "GA",
  },
  {
    zip_code: "30453",

    ste_name: "GA",
  },
  {
    zip_code: "30531",

    ste_name: "GA",
  },
  {
    zip_code: "30535",

    ste_name: "GA",
  },
  {
    zip_code: "30541",

    ste_name: "GA",
  },
  {
    zip_code: "30566",

    ste_name: "GA",
  },
  {
    zip_code: "30641",

    ste_name: "GA",
  },
  {
    zip_code: "30664",

    ste_name: "GA",
  },
  {
    zip_code: "30668",

    ste_name: "GA",
  },
  {
    zip_code: "30733",

    ste_name: "GA",
  },
  {
    zip_code: "30735",

    ste_name: "GA",
  },
  {
    zip_code: "30752",

    ste_name: "GA",
  },
  {
    zip_code: "58736",

    ste_name: "ND",
  },
  {
    zip_code: "21502",

    ste_name: "MD",
  },
  {
    zip_code: "21626",

    ste_name: "MD",
  },
  {
    zip_code: "21648",

    ste_name: "MD",
  },
  {
    zip_code: "21780",

    ste_name: "MD",
  },
  {
    zip_code: "21791",

    ste_name: "MD",
  },
  {
    zip_code: "21864",

    ste_name: "MD",
  },
  {
    zip_code: "22046",

    ste_name: "VA",
  },
  {
    zip_code: "22172",

    ste_name: "VA",
  },
  {
    zip_code: "22185",

    ste_name: "VA",
  },
  {
    zip_code: "22211",

    ste_name: "VA",
  },
  {
    zip_code: "22454",

    ste_name: "VA",
  },
  {
    zip_code: "22663",

    ste_name: "VA",
  },
  {
    zip_code: "22712",

    ste_name: "VA",
  },
  {
    zip_code: "22730",

    ste_name: "VA",
  },
  {
    zip_code: "22740",

    ste_name: "VA",
  },
  {
    zip_code: "22824",

    ste_name: "VA",
  },
  {
    zip_code: "22827",

    ste_name: "VA",
  },
  {
    zip_code: "31007",

    ste_name: "GA",
  },
  {
    zip_code: "31028",

    ste_name: "GA",
  },
  {
    zip_code: "31071",

    ste_name: "GA",
  },
  {
    zip_code: "31207",

    ste_name: "GA",
  },
  {
    zip_code: "31510",

    ste_name: "GA",
  },
  {
    zip_code: "31519",

    ste_name: "GA",
  },
  {
    zip_code: "31565",

    ste_name: "GA",
  },
  {
    zip_code: "31620",

    ste_name: "GA",
  },
  {
    zip_code: "31643",

    ste_name: "GA",
  },
  {
    zip_code: "31648",

    ste_name: "GA",
  },
  {
    zip_code: "31719",

    ste_name: "GA",
  },
  {
    zip_code: "31783",

    ste_name: "GA",
  },
  {
    zip_code: "32044",

    ste_name: "FL",
  },
  {
    zip_code: "32124",

    ste_name: "FL",
  },
  {
    zip_code: "32127",

    ste_name: "FL",
  },
  {
    zip_code: "32206",

    ste_name: "FL",
  },
  {
    zip_code: "32448",

    ste_name: "FL",
  },
  {
    zip_code: "32561",

    ste_name: "FL",
  },
  {
    zip_code: "32578",

    ste_name: "FL",
  },
  {
    zip_code: "32789",

    ste_name: "FL",
  },
  {
    zip_code: "32905",

    ste_name: "FL",
  },
  {
    zip_code: "32907",

    ste_name: "FL",
  },
  {
    zip_code: "33019",

    ste_name: "FL",
  },
  {
    zip_code: "33169",

    ste_name: "FL",
  },
  {
    zip_code: "33301",

    ste_name: "FL",
  },
  {
    zip_code: "33311",

    ste_name: "FL",
  },
  {
    zip_code: "33462",

    ste_name: "FL",
  },
  {
    zip_code: "33472",

    ste_name: "FL",
  },
  {
    zip_code: "33542",

    ste_name: "FL",
  },
  {
    zip_code: "33609",

    ste_name: "FL",
  },
  {
    zip_code: "33625",

    ste_name: "FL",
  },
  {
    zip_code: "33786",

    ste_name: "FL",
  },
  {
    zip_code: "33843",

    ste_name: "FL",
  },
  {
    zip_code: "33851",

    ste_name: "FL",
  },
  {
    zip_code: "33853",

    ste_name: "FL",
  },
  {
    zip_code: "33881",

    ste_name: "FL",
  },
  {
    zip_code: "33901",

    ste_name: "FL",
  },
  {
    zip_code: "33921",

    ste_name: "FL",
  },
  {
    zip_code: "33965",

    ste_name: "FL",
  },
  {
    zip_code: "34113",

    ste_name: "FL",
  },
  {
    zip_code: "34202",

    ste_name: "FL",
  },
  {
    zip_code: "34292",

    ste_name: "FL",
  },
  {
    zip_code: "34661",

    ste_name: "FL",
  },
  {
    zip_code: "34668",

    ste_name: "FL",
  },
  {
    zip_code: "34737",

    ste_name: "FL",
  },
  {
    zip_code: "34744",

    ste_name: "FL",
  },
  {
    zip_code: "34797",

    ste_name: "FL",
  },
  {
    zip_code: "34986",

    ste_name: "FL",
  },
  {
    zip_code: "35007",

    ste_name: "AL",
  },
  {
    zip_code: "35127",

    ste_name: "AL",
  },
  {
    zip_code: "35210",

    ste_name: "AL",
  },
  {
    zip_code: "35404",

    ste_name: "AL",
  },
  {
    zip_code: "35582",

    ste_name: "AL",
  },
  {
    zip_code: "35740",

    ste_name: "AL",
  },
  {
    zip_code: "35745",

    ste_name: "AL",
  },
  {
    zip_code: "35766",

    ste_name: "AL",
  },
  {
    zip_code: "35769",

    ste_name: "AL",
  },
  {
    zip_code: "35967",

    ste_name: "AL",
  },
  {
    zip_code: "36048",

    ste_name: "AL",
  },
  {
    zip_code: "36075",

    ste_name: "AL",
  },
  {
    zip_code: "36316",

    ste_name: "AL",
  },
  {
    zip_code: "36317",

    ste_name: "AL",
  },
  {
    zip_code: "36582",

    ste_name: "AL",
  },
  {
    zip_code: "36720",

    ste_name: "AL",
  },
  {
    zip_code: "36858",

    ste_name: "AL",
  },
  {
    zip_code: "37018",

    ste_name: "TN",
  },
  {
    zip_code: "37042",

    ste_name: "TN",
  },
  {
    zip_code: "37074",

    ste_name: "TN",
  },
  {
    zip_code: "37145",

    ste_name: "TN",
  },
  {
    zip_code: "37165",

    ste_name: "TN",
  },
  {
    zip_code: "37220",

    ste_name: "TN",
  },
  {
    zip_code: "37221",

    ste_name: "TN",
  },
  {
    zip_code: "37307",

    ste_name: "TN",
  },
  {
    zip_code: "37355",

    ste_name: "TN",
  },
  {
    zip_code: "37359",

    ste_name: "TN",
  },
  {
    zip_code: "37617",

    ste_name: "TN",
  },
  {
    zip_code: "37691",

    ste_name: "TN",
  },
  {
    zip_code: "37851",

    ste_name: "TN",
  },
  {
    zip_code: "37860",

    ste_name: "TN",
  },
  {
    zip_code: "37863",

    ste_name: "TN",
  },
  {
    zip_code: "37865",

    ste_name: "TN",
  },
  {
    zip_code: "37872",

    ste_name: "TN",
  },
  {
    zip_code: "37915",

    ste_name: "TN",
  },
  {
    zip_code: "38008",

    ste_name: "TN",
  },
  {
    zip_code: "38011",

    ste_name: "TN",
  },
  {
    zip_code: "38040",

    ste_name: "TN",
  },
  {
    zip_code: "38127",

    ste_name: "TN",
  },
  {
    zip_code: "38362",

    ste_name: "TN",
  },
  {
    zip_code: "38475",

    ste_name: "TN",
  },
  {
    zip_code: "38589",

    ste_name: "TN",
  },
  {
    zip_code: "38677",

    ste_name: "MS",
  },
  {
    zip_code: "38744",

    ste_name: "MS",
  },
  {
    zip_code: "38772",

    ste_name: "MS",
  },
  {
    zip_code: "38844",

    ste_name: "MS",
  },
  {
    zip_code: "38901",

    ste_name: "MS",
  },
  {
    zip_code: "38914",

    ste_name: "MS",
  },
  {
    zip_code: "38962",

    ste_name: "MS",
  },
  {
    zip_code: "39039",

    ste_name: "MS",
  },
  {
    zip_code: "39044",

    ste_name: "MS",
  },
  {
    zip_code: "39054",

    ste_name: "MS",
  },
  {
    zip_code: "39272",

    ste_name: "MS",
  },
  {
    zip_code: "39335",

    ste_name: "MS",
  },
  {
    zip_code: "39341",

    ste_name: "MS",
  },
  {
    zip_code: "39361",

    ste_name: "MS",
  },
  {
    zip_code: "39645",

    ste_name: "MS",
  },
  {
    zip_code: "39661",

    ste_name: "MS",
  },
  {
    zip_code: "39747",

    ste_name: "MS",
  },
  {
    zip_code: "40011",

    ste_name: "KY",
  },
  {
    zip_code: "40057",

    ste_name: "KY",
  },
  {
    zip_code: "40108",

    ste_name: "KY",
  },
  {
    zip_code: "40242",

    ste_name: "KY",
  },
  {
    zip_code: "40403",

    ste_name: "KY",
  },
  {
    zip_code: "40737",

    ste_name: "KY",
  },
  {
    zip_code: "40824",

    ste_name: "KY",
  },
  {
    zip_code: "40829",

    ste_name: "KY",
  },
  {
    zip_code: "40906",

    ste_name: "KY",
  },
  {
    zip_code: "40988",

    ste_name: "KY",
  },
  {
    zip_code: "41041",

    ste_name: "KY",
  },
  {
    zip_code: "41091",

    ste_name: "KY",
  },
  {
    zip_code: "41097",

    ste_name: "KY",
  },
  {
    zip_code: "41121",

    ste_name: "KY",
  },
  {
    zip_code: "41132",

    ste_name: "KY",
  },
  {
    zip_code: "41139",

    ste_name: "KY",
  },
  {
    zip_code: "41543",

    ste_name: "KY",
  },
  {
    zip_code: "41616",

    ste_name: "KY",
  },
  {
    zip_code: "41762",

    ste_name: "KY",
  },
  {
    zip_code: "41776",

    ste_name: "KY",
  },
  {
    zip_code: "42047",

    ste_name: "KY",
  },
  {
    zip_code: "42124",

    ste_name: "KY",
  },
  {
    zip_code: "42254",

    ste_name: "KY",
  },
  {
    zip_code: "42273",

    ste_name: "KY",
  },
  {
    zip_code: "42350",

    ste_name: "KY",
  },
  {
    zip_code: "42458",

    ste_name: "KY",
  },
  {
    zip_code: "42732",

    ste_name: "KY",
  },
  {
    zip_code: "42743",

    ste_name: "KY",
  },
  {
    zip_code: "43029",

    ste_name: "OH",
  },
  {
    zip_code: "43156",

    ste_name: "OH",
  },
  {
    zip_code: "43212",

    ste_name: "OH",
  },
  {
    zip_code: "43310",

    ste_name: "OH",
  },
  {
    zip_code: "43408",

    ste_name: "OH",
  },
  {
    zip_code: "43416",

    ste_name: "OH",
  },
  {
    zip_code: "43435",

    ste_name: "OH",
  },
  {
    zip_code: "43463",

    ste_name: "OH",
  },
  {
    zip_code: "43560",

    ste_name: "OH",
  },
  {
    zip_code: "43772",

    ste_name: "OH",
  },
  {
    zip_code: "43967",

    ste_name: "OH",
  },
  {
    zip_code: "44003",

    ste_name: "OH",
  },
  {
    zip_code: "44062",

    ste_name: "OH",
  },
  {
    zip_code: "44105",

    ste_name: "OH",
  },
  {
    zip_code: "44117",

    ste_name: "OH",
  },
  {
    zip_code: "44131",

    ste_name: "OH",
  },
  {
    zip_code: "44138",

    ste_name: "OH",
  },
  {
    zip_code: "44241",

    ste_name: "OH",
  },
  {
    zip_code: "44430",

    ste_name: "OH",
  },
  {
    zip_code: "44609",

    ste_name: "OH",
  },
  {
    zip_code: "44621",

    ste_name: "OH",
  },
  {
    zip_code: "44661",

    ste_name: "OH",
  },
  {
    zip_code: "44666",

    ste_name: "OH",
  },
  {
    zip_code: "44671",

    ste_name: "OH",
  },
  {
    zip_code: "44678",

    ste_name: "OH",
  },
  {
    zip_code: "44833",

    ste_name: "OH",
  },
  {
    zip_code: "45067",

    ste_name: "OH",
  },
  {
    zip_code: "45106",

    ste_name: "OH",
  },
  {
    zip_code: "45112",

    ste_name: "OH",
  },
  {
    zip_code: "45118",

    ste_name: "OH",
  },
  {
    zip_code: "45120",

    ste_name: "OH",
  },
  {
    zip_code: "45132",

    ste_name: "OH",
  },
  {
    zip_code: "45140",

    ste_name: "OH",
  },
  {
    zip_code: "45352",

    ste_name: "OH",
  },
  {
    zip_code: "45353",

    ste_name: "OH",
  },
  {
    zip_code: "45384",

    ste_name: "OH",
  },
  {
    zip_code: "45780",

    ste_name: "OH",
  },
  {
    zip_code: "45782",

    ste_name: "OH",
  },
  {
    zip_code: "45836",

    ste_name: "OH",
  },
  {
    zip_code: "45850",

    ste_name: "OH",
  },
  {
    zip_code: "45872",

    ste_name: "OH",
  },
  {
    zip_code: "46122",

    ste_name: "IN",
  },
  {
    zip_code: "46131",

    ste_name: "IN",
  },
  {
    zip_code: "46158",

    ste_name: "IN",
  },
  {
    zip_code: "46161",

    ste_name: "IN",
  },
  {
    zip_code: "46231",

    ste_name: "IN",
  },
  {
    zip_code: "46550",

    ste_name: "IN",
  },
  {
    zip_code: "46989",

    ste_name: "IN",
  },
  {
    zip_code: "47041",

    ste_name: "IN",
  },
  {
    zip_code: "47042",

    ste_name: "IN",
  },
  {
    zip_code: "47243",

    ste_name: "IN",
  },
  {
    zip_code: "47326",

    ste_name: "IN",
  },
  {
    zip_code: "47355",

    ste_name: "IN",
  },
  {
    zip_code: "47421",

    ste_name: "IN",
  },
  {
    zip_code: "47427",

    ste_name: "IN",
  },
  {
    zip_code: "47438",

    ste_name: "IN",
  },
  {
    zip_code: "47458",

    ste_name: "IN",
  },
  {
    zip_code: "47542",

    ste_name: "IN",
  },
  {
    zip_code: "47558",

    ste_name: "IN",
  },
  {
    zip_code: "47590",

    ste_name: "IN",
  },
  {
    zip_code: "47640",

    ste_name: "IN",
  },
  {
    zip_code: "48043",

    ste_name: "MI",
  },
  {
    zip_code: "48159",

    ste_name: "MI",
  },
  {
    zip_code: "48189",

    ste_name: "MI",
  },
  {
    zip_code: "48205",

    ste_name: "MI",
  },
  {
    zip_code: "48235",

    ste_name: "MI",
  },
  {
    zip_code: "48346",

    ste_name: "MI",
  },
  {
    zip_code: "48463",

    ste_name: "MI",
  },
  {
    zip_code: "48622",

    ste_name: "MI",
  },
  {
    zip_code: "48763",

    ste_name: "MI",
  },
  {
    zip_code: "48817",

    ste_name: "MI",
  },
  {
    zip_code: "48829",

    ste_name: "MI",
  },
  {
    zip_code: "48834",

    ste_name: "MI",
  },
  {
    zip_code: "48864",

    ste_name: "MI",
  },
  {
    zip_code: "48875",

    ste_name: "MI",
  },
  {
    zip_code: "49011",

    ste_name: "MI",
  },
  {
    zip_code: "49033",

    ste_name: "MI",
  },
  {
    zip_code: "49076",

    ste_name: "MI",
  },
  {
    zip_code: "49082",

    ste_name: "MI",
  },
  {
    zip_code: "49112",

    ste_name: "MI",
  },
  {
    zip_code: "49128",

    ste_name: "MI",
  },
  {
    zip_code: "49411",

    ste_name: "MI",
  },
  {
    zip_code: "49417",

    ste_name: "MI",
  },
  {
    zip_code: "49613",

    ste_name: "MI",
  },
  {
    zip_code: "49633",

    ste_name: "MI",
  },
  {
    zip_code: "49674",

    ste_name: "MI",
  },
  {
    zip_code: "49712",

    ste_name: "MI",
  },
  {
    zip_code: "49759",

    ste_name: "MI",
  },
  {
    zip_code: "49816",

    ste_name: "MI",
  },
  {
    zip_code: "49833",

    ste_name: "MI",
  },
  {
    zip_code: "49873",

    ste_name: "MI",
  },
  {
    zip_code: "49947",

    ste_name: "MI",
  },
  {
    zip_code: "50060",

    ste_name: "IA",
  },
  {
    zip_code: "50069",

    ste_name: "IA",
  },
  {
    zip_code: "50111",

    ste_name: "IA",
  },
  {
    zip_code: "50129",

    ste_name: "IA",
  },
  {
    zip_code: "50146",

    ste_name: "IA",
  },
  {
    zip_code: "50165",

    ste_name: "IA",
  },
  {
    zip_code: "50276",

    ste_name: "IA",
  },
  {
    zip_code: "50440",

    ste_name: "IA",
  },
  {
    zip_code: "50446",

    ste_name: "IA",
  },
  {
    zip_code: "50478",

    ste_name: "IA",
  },
  {
    zip_code: "50514",

    ste_name: "IA",
  },
  {
    zip_code: "50527",

    ste_name: "IA",
  },
  {
    zip_code: "50652",

    ste_name: "IA",
  },
  {
    zip_code: "50858",

    ste_name: "IA",
  },
  {
    zip_code: "51048",

    ste_name: "IA",
  },
  {
    zip_code: "51060",

    ste_name: "IA",
  },
  {
    zip_code: "51450",

    ste_name: "IA",
  },
  {
    zip_code: "51526",

    ste_name: "IA",
  },
  {
    zip_code: "51653",

    ste_name: "IA",
  },
  {
    zip_code: "52210",

    ste_name: "IA",
  },
  {
    zip_code: "52223",

    ste_name: "IA",
  },
  {
    zip_code: "52232",

    ste_name: "IA",
  },
  {
    zip_code: "52301",

    ste_name: "IA",
  },
  {
    zip_code: "52337",

    ste_name: "IA",
  },
  {
    zip_code: "52346",

    ste_name: "IA",
  },
  {
    zip_code: "52411",

    ste_name: "IA",
  },
  {
    zip_code: "52560",

    ste_name: "IA",
  },
  {
    zip_code: "52563",

    ste_name: "IA",
  },
  {
    zip_code: "52590",

    ste_name: "IA",
  },
  {
    zip_code: "52619",

    ste_name: "IA",
  },
  {
    zip_code: "52659",

    ste_name: "IA",
  },
  {
    zip_code: "52746",

    ste_name: "IA",
  },
  {
    zip_code: "52761",

    ste_name: "IA",
  },
  {
    zip_code: "52776",

    ste_name: "IA",
  },
  {
    zip_code: "53020",

    ste_name: "WI",
  },
  {
    zip_code: "53061",

    ste_name: "WI",
  },
  {
    zip_code: "53224",

    ste_name: "WI",
  },
  {
    zip_code: "53406",

    ste_name: "WI",
  },
  {
    zip_code: "53520",

    ste_name: "WI",
  },
  {
    zip_code: "53531",

    ste_name: "WI",
  },
  {
    zip_code: "53534",

    ste_name: "WI",
  },
  {
    zip_code: "53550",

    ste_name: "WI",
  },
  {
    zip_code: "53588",

    ste_name: "WI",
  },
  {
    zip_code: "53706",

    ste_name: "WI",
  },
  {
    zip_code: "53911",

    ste_name: "WI",
  },
  {
    zip_code: "53946",

    ste_name: "WI",
  },
  {
    zip_code: "54082",

    ste_name: "WI",
  },
  {
    zip_code: "54115",

    ste_name: "WI",
  },
  {
    zip_code: "54139",

    ste_name: "WI",
  },
  {
    zip_code: "54204",

    ste_name: "WI",
  },
  {
    zip_code: "54230",

    ste_name: "WI",
  },
  {
    zip_code: "54455",

    ste_name: "WI",
  },
  {
    zip_code: "54456",

    ste_name: "WI",
  },
  {
    zip_code: "54458",

    ste_name: "WI",
  },
  {
    zip_code: "54552",

    ste_name: "WI",
  },
  {
    zip_code: "54564",

    ste_name: "WI",
  },
  {
    zip_code: "54653",

    ste_name: "WI",
  },
  {
    zip_code: "54732",

    ste_name: "WI",
  },
  {
    zip_code: "54771",

    ste_name: "WI",
  },
  {
    zip_code: "54839",

    ste_name: "WI",
  },
  {
    zip_code: "55084",

    ste_name: "MN",
  },
  {
    zip_code: "55319",

    ste_name: "MN",
  },
  {
    zip_code: "55329",

    ste_name: "MN",
  },
  {
    zip_code: "55331",

    ste_name: "MN",
  },
  {
    zip_code: "55334",

    ste_name: "MN",
  },
  {
    zip_code: "55356",

    ste_name: "MN",
  },
  {
    zip_code: "55379",

    ste_name: "MN",
  },
  {
    zip_code: "55418",

    ste_name: "MN",
  },
  {
    zip_code: "55433",

    ste_name: "MN",
  },
  {
    zip_code: "55441",

    ste_name: "MN",
  },
  {
    zip_code: "55442",

    ste_name: "MN",
  },
  {
    zip_code: "55712",

    ste_name: "MN",
  },
  {
    zip_code: "55757",

    ste_name: "MN",
  },
  {
    zip_code: "55783",

    ste_name: "MN",
  },
  {
    zip_code: "55812",

    ste_name: "MN",
  },
  {
    zip_code: "55917",

    ste_name: "MN",
  },
  {
    zip_code: "55919",

    ste_name: "MN",
  },
  {
    zip_code: "55950",

    ste_name: "MN",
  },
  {
    zip_code: "55979",

    ste_name: "MN",
  },
  {
    zip_code: "56029",

    ste_name: "MN",
  },
  {
    zip_code: "56054",

    ste_name: "MN",
  },
  {
    zip_code: "56116",

    ste_name: "MN",
  },
  {
    zip_code: "56131",

    ste_name: "MN",
  },
  {
    zip_code: "56168",

    ste_name: "MN",
  },
  {
    zip_code: "56257",

    ste_name: "MN",
  },
  {
    zip_code: "56277",

    ste_name: "MN",
  },
  {
    zip_code: "56303",

    ste_name: "MN",
  },
  {
    zip_code: "56358",

    ste_name: "MN",
  },
  {
    zip_code: "56360",

    ste_name: "MN",
  },
  {
    zip_code: "56450",

    ste_name: "MN",
  },
  {
    zip_code: "56452",

    ste_name: "MN",
  },
  {
    zip_code: "56466",

    ste_name: "MN",
  },
  {
    zip_code: "56534",

    ste_name: "MN",
  },
  {
    zip_code: "56535",

    ste_name: "MN",
  },
  {
    zip_code: "56547",

    ste_name: "MN",
  },
  {
    zip_code: "56574",

    ste_name: "MN",
  },
  {
    zip_code: "56654",

    ste_name: "MN",
  },
  {
    zip_code: "56735",

    ste_name: "MN",
  },
  {
    zip_code: "57005",

    ste_name: "SD",
  },
  {
    zip_code: "57041",

    ste_name: "SD",
  },
  {
    zip_code: "57236",

    ste_name: "SD",
  },
  {
    zip_code: "57257",

    ste_name: "SD",
  },
  {
    zip_code: "57329",

    ste_name: "SD",
  },
  {
    zip_code: "57330",

    ste_name: "SD",
  },
  {
    zip_code: "57422",

    ste_name: "SD",
  },
  {
    zip_code: "57461",

    ste_name: "SD",
  },
  {
    zip_code: "57634",

    ste_name: "SD",
  },
  {
    zip_code: "57720",

    ste_name: "SD",
  },
  {
    zip_code: "57738",

    ste_name: "SD",
  },
  {
    zip_code: "57763",

    ste_name: "SD",
  },
  {
    zip_code: "58056",

    ste_name: "ND",
  },
  {
    zip_code: "58219",

    ste_name: "ND",
  },
  {
    zip_code: "58259",

    ste_name: "ND",
  },
  {
    zip_code: "58274",

    ste_name: "ND",
  },
  {
    zip_code: "58424",

    ste_name: "ND",
  },
  {
    zip_code: "58490",

    ste_name: "ND",
  },
  {
    zip_code: "58528",

    ste_name: "ND",
  },
  {
    zip_code: "58638",

    ste_name: "ND",
  },
  {
    zip_code: "58656",

    ste_name: "ND",
  },
  {
    zip_code: "58704",

    ste_name: "ND",
  },
  {
    zip_code: "58721",

    ste_name: "ND",
  },
  {
    zip_code: "58790",

    ste_name: "ND",
  },
  {
    zip_code: "59018",

    ste_name: "MT",
  },
  {
    zip_code: "59067",

    ste_name: "MT",
  },
  {
    zip_code: "59075",

    ste_name: "MT",
  },
  {
    zip_code: "59077",

    ste_name: "MT",
  },
  {
    zip_code: "59247",

    ste_name: "MT",
  },
  {
    zip_code: "59254",

    ste_name: "MT",
  },
  {
    zip_code: "59419",

    ste_name: "MT",
  },
  {
    zip_code: "59441",

    ste_name: "MT",
  },
  {
    zip_code: "59461",

    ste_name: "MT",
  },
  {
    zip_code: "59547",

    ste_name: "MT",
  },
  {
    zip_code: "59632",

    ste_name: "MT",
  },
  {
    zip_code: "59645",

    ste_name: "MT",
  },
  {
    zip_code: "59715",

    ste_name: "MT",
  },
  {
    zip_code: "59716",

    ste_name: "MT",
  },
  {
    zip_code: "59720",

    ste_name: "MT",
  },
  {
    zip_code: "59745",

    ste_name: "MT",
  },
  {
    zip_code: "59751",

    ste_name: "MT",
  },
  {
    zip_code: "60046",

    ste_name: "IL",
  },
  {
    zip_code: "60160",

    ste_name: "IL",
  },
  {
    zip_code: "60180",

    ste_name: "IL",
  },
  {
    zip_code: "60407",

    ste_name: "IL",
  },
  {
    zip_code: "60623",

    ste_name: "IL",
  },
  {
    zip_code: "60631",

    ste_name: "IL",
  },
  {
    zip_code: "60651",

    ste_name: "IL",
  },
  {
    zip_code: "60706",

    ste_name: "IL",
  },
  {
    zip_code: "60803",

    ste_name: "IL",
  },
  {
    zip_code: "61011",

    ste_name: "IL",
  },
  {
    zip_code: "61014",

    ste_name: "IL",
  },
  {
    zip_code: "61024",

    ste_name: "IL",
  },
  {
    zip_code: "61046",

    ste_name: "IL",
  },
  {
    zip_code: "61052",

    ste_name: "IL",
  },
  {
    zip_code: "61062",

    ste_name: "IL",
  },
  {
    zip_code: "61072",

    ste_name: "IL",
  },
  {
    zip_code: "61089",

    ste_name: "IL",
  },
  {
    zip_code: "61108",

    ste_name: "IL",
  },
  {
    zip_code: "61263",

    ste_name: "IL",
  },
  {
    zip_code: "61283",

    ste_name: "IL",
  },
  {
    zip_code: "61516",

    ste_name: "IL",
  },
  {
    zip_code: "61571",

    ste_name: "IL",
  },
  {
    zip_code: "61878",

    ste_name: "IL",
  },
  {
    zip_code: "61880",

    ste_name: "IL",
  },
  {
    zip_code: "61883",

    ste_name: "IL",
  },
  {
    zip_code: "61884",

    ste_name: "IL",
  },
  {
    zip_code: "62050",

    ste_name: "IL",
  },
  {
    zip_code: "62052",

    ste_name: "IL",
  },
  {
    zip_code: "62067",

    ste_name: "IL",
  },
  {
    zip_code: "62098",

    ste_name: "IL",
  },
  {
    zip_code: "62278",

    ste_name: "IL",
  },
  {
    zip_code: "62313",

    ste_name: "IL",
  },
  {
    zip_code: "62338",

    ste_name: "IL",
  },
  {
    zip_code: "62340",

    ste_name: "IL",
  },
  {
    zip_code: "62357",

    ste_name: "IL",
  },
  {
    zip_code: "62375",

    ste_name: "IL",
  },
  {
    zip_code: "62441",

    ste_name: "IL",
  },
  {
    zip_code: "62545",

    ste_name: "IL",
  },
  {
    zip_code: "62547",

    ste_name: "IL",
  },
  {
    zip_code: "62551",

    ste_name: "IL",
  },
  {
    zip_code: "62631",

    ste_name: "IL",
  },
  {
    zip_code: "62633",

    ste_name: "IL",
  },
  {
    zip_code: "62666",

    ste_name: "IL",
  },
  {
    zip_code: "62672",

    ste_name: "IL",
  },
  {
    zip_code: "62832",

    ste_name: "IL",
  },
  {
    zip_code: "62882",

    ste_name: "IL",
  },
  {
    zip_code: "62894",

    ste_name: "IL",
  },
  {
    zip_code: "63012",

    ste_name: "MO",
  },
  {
    zip_code: "63036",

    ste_name: "MO",
  },
  {
    zip_code: "63139",

    ste_name: "MO",
  },
  {
    zip_code: "63431",

    ste_name: "MO",
  },
  {
    zip_code: "63457",

    ste_name: "MO",
  },
  {
    zip_code: "63465",

    ste_name: "MO",
  },
  {
    zip_code: "63547",

    ste_name: "MO",
  },
  {
    zip_code: "63662",

    ste_name: "MO",
  },
  {
    zip_code: "63670",

    ste_name: "MO",
  },
  {
    zip_code: "63751",

    ste_name: "MO",
  },
  {
    zip_code: "63769",

    ste_name: "MO",
  },
  {
    zip_code: "63849",

    ste_name: "MO",
  },
  {
    zip_code: "63851",

    ste_name: "MO",
  },
  {
    zip_code: "63869",

    ste_name: "MO",
  },
  {
    zip_code: "63966",

    ste_name: "MO",
  },
  {
    zip_code: "64021",

    ste_name: "MO",
  },
  {
    zip_code: "64058",

    ste_name: "MO",
  },
  {
    zip_code: "64131",

    ste_name: "MO",
  },
  {
    zip_code: "64439",

    ste_name: "MO",
  },
  {
    zip_code: "64454",

    ste_name: "MO",
  },
  {
    zip_code: "64649",

    ste_name: "MO",
  },
  {
    zip_code: "64661",

    ste_name: "MO",
  },
  {
    zip_code: "64834",

    ste_name: "MO",
  },
  {
    zip_code: "65043",

    ste_name: "MO",
  },
  {
    zip_code: "65282",

    ste_name: "MO",
  },
  {
    zip_code: "65335",

    ste_name: "MO",
  },
  {
    zip_code: "65347",

    ste_name: "MO",
  },
  {
    zip_code: "65449",

    ste_name: "MO",
  },
  {
    zip_code: "65464",

    ste_name: "MO",
  },
  {
    zip_code: "65555",

    ste_name: "MO",
  },
  {
    zip_code: "65626",

    ste_name: "MO",
  },
  {
    zip_code: "65661",

    ste_name: "MO",
  },
  {
    zip_code: "65781",

    ste_name: "MO",
  },
  {
    zip_code: "65788",

    ste_name: "MO",
  },
  {
    zip_code: "66042",

    ste_name: "KS",
  },
  {
    zip_code: "66058",

    ste_name: "KS",
  },
  {
    zip_code: "66104",

    ste_name: "KS",
  },
  {
    zip_code: "66106",

    ste_name: "KS",
  },
  {
    zip_code: "66207",

    ste_name: "KS",
  },
  {
    zip_code: "66439",

    ste_name: "KS",
  },
  {
    zip_code: "66510",

    ste_name: "KS",
  },
  {
    zip_code: "66524",

    ste_name: "KS",
  },
  {
    zip_code: "66608",

    ste_name: "KS",
  },
  {
    zip_code: "66609",

    ste_name: "KS",
  },
  {
    zip_code: "66756",

    ste_name: "KS",
  },
  {
    zip_code: "66757",

    ste_name: "KS",
  },
  {
    zip_code: "66779",

    ste_name: "KS",
  },
  {
    zip_code: "66901",

    ste_name: "KS",
  },
  {
    zip_code: "66966",

    ste_name: "KS",
  },
  {
    zip_code: "66967",

    ste_name: "KS",
  },
  {
    zip_code: "67068",

    ste_name: "KS",
  },
  {
    zip_code: "67110",

    ste_name: "KS",
  },
  {
    zip_code: "67337",

    ste_name: "KS",
  },
  {
    zip_code: "67353",

    ste_name: "KS",
  },
  {
    zip_code: "67363",

    ste_name: "KS",
  },
  {
    zip_code: "67447",

    ste_name: "KS",
  },
  {
    zip_code: "67547",

    ste_name: "KS",
  },
  {
    zip_code: "67629",

    ste_name: "KS",
  },
  {
    zip_code: "67642",

    ste_name: "KS",
  },
  {
    zip_code: "67650",

    ste_name: "KS",
  },
  {
    zip_code: "67744",

    ste_name: "KS",
  },
  {
    zip_code: "67849",

    ste_name: "KS",
  },
  {
    zip_code: "68003",

    ste_name: "NE",
  },
  {
    zip_code: "68036",

    ste_name: "NE",
  },
  {
    zip_code: "68047",

    ste_name: "NE",
  },
  {
    zip_code: "68133",

    ste_name: "NE",
  },
  {
    zip_code: "68310",

    ste_name: "NE",
  },
  {
    zip_code: "68326",

    ste_name: "NE",
  },
  {
    zip_code: "68359",

    ste_name: "NE",
  },
  {
    zip_code: "68517",

    ste_name: "NE",
  },
  {
    zip_code: "68520",

    ste_name: "NE",
  },
  {
    zip_code: "68524",

    ste_name: "NE",
  },
  {
    zip_code: "68653",

    ste_name: "NE",
  },
  {
    zip_code: "68726",

    ste_name: "NE",
  },
  {
    zip_code: "68779",

    ste_name: "NE",
  },
  {
    zip_code: "68801",

    ste_name: "NE",
  },
  {
    zip_code: "68822",

    ste_name: "NE",
  },
  {
    zip_code: "68842",

    ste_name: "NE",
  },
  {
    zip_code: "68861",

    ste_name: "NE",
  },
  {
    zip_code: "68940",

    ste_name: "NE",
  },
  {
    zip_code: "68948",

    ste_name: "NE",
  },
  {
    zip_code: "68950",

    ste_name: "NE",
  },
  {
    zip_code: "68954",

    ste_name: "NE",
  },
  {
    zip_code: "69146",

    ste_name: "NE",
  },
  {
    zip_code: "69165",

    ste_name: "NE",
  },
  {
    zip_code: "69169",

    ste_name: "NE",
  },
  {
    zip_code: "69218",

    ste_name: "NE",
  },
  {
    zip_code: "70070",

    ste_name: "LA",
  },
  {
    zip_code: "70087",

    ste_name: "LA",
  },
  {
    zip_code: "70113",

    ste_name: "LA",
  },
  {
    zip_code: "70124",

    ste_name: "LA",
  },
  {
    zip_code: "70441",

    ste_name: "LA",
  },
  {
    zip_code: "70507",

    ste_name: "LA",
  },
  {
    zip_code: "70576",

    ste_name: "LA",
  },
  {
    zip_code: "70650",

    ste_name: "LA",
  },
  {
    zip_code: "70783",

    ste_name: "LA",
  },
  {
    zip_code: "71103",

    ste_name: "LA",
  },
  {
    zip_code: "71110",

    ste_name: "LA",
  },
  {
    zip_code: "71201",

    ste_name: "LA",
  },
  {
    zip_code: "71202",

    ste_name: "LA",
  },
  {
    zip_code: "71275",

    ste_name: "LA",
  },
  {
    zip_code: "71340",

    ste_name: "LA",
  },
  {
    zip_code: "71450",

    ste_name: "LA",
  },
  {
    zip_code: "71462",

    ste_name: "LA",
  },
  {
    zip_code: "71665",

    ste_name: "AR",
  },
  {
    zip_code: "71730",

    ste_name: "AR",
  },
  {
    zip_code: "71758",

    ste_name: "AR",
  },
  {
    zip_code: "71921",

    ste_name: "AR",
  },
  {
    zip_code: "71949",

    ste_name: "AR",
  },
  {
    zip_code: "71965",

    ste_name: "AR",
  },
  {
    zip_code: "72007",

    ste_name: "AR",
  },
  {
    zip_code: "72012",

    ste_name: "AR",
  },
  {
    zip_code: "72020",

    ste_name: "AR",
  },
  {
    zip_code: "72113",

    ste_name: "AR",
  },
  {
    zip_code: "72212",

    ste_name: "AR",
  },
  {
    zip_code: "72223",

    ste_name: "AR",
  },
  {
    zip_code: "72341",

    ste_name: "AR",
  },
  {
    zip_code: "72414",

    ste_name: "AR",
  },
  {
    zip_code: "72441",

    ste_name: "AR",
  },
  {
    zip_code: "72473",

    ste_name: "AR",
  },
  {
    zip_code: "72553",

    ste_name: "AR",
  },
  {
    zip_code: "72572",

    ste_name: "AR",
  },
  {
    zip_code: "72685",

    ste_name: "AR",
  },
  {
    zip_code: "72715",

    ste_name: "AR",
  },
  {
    zip_code: "72761",

    ste_name: "AR",
  },
  {
    zip_code: "72852",

    ste_name: "AR",
  },
  {
    zip_code: "72854",

    ste_name: "AR",
  },
  {
    zip_code: "73012",

    ste_name: "OK",
  },
  {
    zip_code: "73042",

    ste_name: "OK",
  },
  {
    zip_code: "73099",

    ste_name: "OK",
  },
  {
    zip_code: "73135",

    ste_name: "OK",
  },
  {
    zip_code: "73430",

    ste_name: "OK",
  },
  {
    zip_code: "73565",

    ste_name: "OK",
  },
  {
    zip_code: "73566",

    ste_name: "OK",
  },
  {
    zip_code: "73703",

    ste_name: "OK",
  },
  {
    zip_code: "73705",

    ste_name: "OK",
  },
  {
    zip_code: "73766",

    ste_name: "OK",
  },
  {
    zip_code: "73944",

    ste_name: "OK",
  },
  {
    zip_code: "74036",

    ste_name: "OK",
  },
  {
    zip_code: "74561",

    ste_name: "OK",
  },
  {
    zip_code: "75042",

    ste_name: "TX",
  },
  {
    zip_code: "75043",

    ste_name: "TX",
  },
  {
    zip_code: "75116",

    ste_name: "TX",
  },
  {
    zip_code: "75460",

    ste_name: "TX",
  },
  {
    zip_code: "75487",

    ste_name: "TX",
  },
  {
    zip_code: "75488",

    ste_name: "TX",
  },
  {
    zip_code: "75494",

    ste_name: "TX",
  },
  {
    zip_code: "75496",

    ste_name: "TX",
  },
  {
    zip_code: "75559",

    ste_name: "TX",
  },
  {
    zip_code: "75570",

    ste_name: "TX",
  },
  {
    zip_code: "75670",

    ste_name: "TX",
  },
  {
    zip_code: "75756",

    ste_name: "TX",
  },
  {
    zip_code: "75762",

    ste_name: "TX",
  },
  {
    zip_code: "75791",

    ste_name: "TX",
  },
  {
    zip_code: "75946",

    ste_name: "TX",
  },
  {
    zip_code: "75956",

    ste_name: "TX",
  },
  {
    zip_code: "76092",

    ste_name: "TX",
  },
  {
    zip_code: "76105",

    ste_name: "TX",
  },
  {
    zip_code: "76270",

    ste_name: "TX",
  },
  {
    zip_code: "76272",

    ste_name: "TX",
  },
  {
    zip_code: "76446",

    ste_name: "TX",
  },
  {
    zip_code: "76475",

    ste_name: "TX",
  },
  {
    zip_code: "76508",

    ste_name: "TX",
  },
  {
    zip_code: "76627",

    ste_name: "TX",
  },
  {
    zip_code: "76682",

    ste_name: "TX",
  },
  {
    zip_code: "76687",

    ste_name: "TX",
  },
  {
    zip_code: "76862",

    ste_name: "TX",
  },
  {
    zip_code: "76874",

    ste_name: "TX",
  },
  {
    zip_code: "76949",

    ste_name: "TX",
  },
  {
    zip_code: "77002",

    ste_name: "TX",
  },
  {
    zip_code: "77010",

    ste_name: "TX",
  },
  {
    zip_code: "77061",

    ste_name: "TX",
  },
  {
    zip_code: "77071",

    ste_name: "TX",
  },
  {
    zip_code: "77073",

    ste_name: "TX",
  },
  {
    zip_code: "77328",

    ste_name: "TX",
  },
  {
    zip_code: "77338",

    ste_name: "TX",
  },
  {
    zip_code: "77442",

    ste_name: "TX",
  },
  {
    zip_code: "77467",

    ste_name: "TX",
  },
  {
    zip_code: "77483",

    ste_name: "TX",
  },
  {
    zip_code: "77511",

    ste_name: "TX",
  },
  {
    zip_code: "77520",

    ste_name: "TX",
  },
  {
    zip_code: "77534",

    ste_name: "TX",
  },
  {
    zip_code: "77578",

    ste_name: "TX",
  },
  {
    zip_code: "77632",

    ste_name: "TX",
  },
  {
    zip_code: "77802",

    ste_name: "TX",
  },
  {
    zip_code: "77856",

    ste_name: "TX",
  },
  {
    zip_code: "78010",

    ste_name: "TX",
  },
  {
    zip_code: "78161",

    ste_name: "TX",
  },
  {
    zip_code: "78216",

    ste_name: "TX",
  },
  {
    zip_code: "78336",

    ste_name: "TX",
  },
  {
    zip_code: "78536",

    ste_name: "TX",
  },
  {
    zip_code: "78596",

    ste_name: "TX",
  },
  {
    zip_code: "78617",

    ste_name: "TX",
  },
  {
    zip_code: "78622",

    ste_name: "TX",
  },
  {
    zip_code: "78626",

    ste_name: "TX",
  },
  {
    zip_code: "78635",

    ste_name: "TX",
  },
  {
    zip_code: "78657",

    ste_name: "TX",
  },
  {
    zip_code: "78723",

    ste_name: "TX",
  },
  {
    zip_code: "78729",

    ste_name: "TX",
  },
  {
    zip_code: "78730",

    ste_name: "TX",
  },
  {
    zip_code: "78734",

    ste_name: "TX",
  },
  {
    zip_code: "78940",

    ste_name: "TX",
  },
  {
    zip_code: "78943",

    ste_name: "TX",
  },
  {
    zip_code: "78951",

    ste_name: "TX",
  },
  {
    zip_code: "79097",

    ste_name: "TX",
  },
  {
    zip_code: "79101",

    ste_name: "TX",
  },
  {
    zip_code: "79106",

    ste_name: "TX",
  },
  {
    zip_code: "79111",

    ste_name: "TX",
  },
  {
    zip_code: "79244",

    ste_name: "TX",
  },
  {
    zip_code: "79250",

    ste_name: "TX",
  },
  {
    zip_code: "79313",

    ste_name: "TX",
  },
  {
    zip_code: "79331",

    ste_name: "TX",
  },
  {
    zip_code: "79339",

    ste_name: "TX",
  },
  {
    zip_code: "79517",

    ste_name: "TX",
  },
  {
    zip_code: "79553",

    ste_name: "TX",
  },
  {
    zip_code: "79602",

    ste_name: "TX",
  },
  {
    zip_code: "79605",

    ste_name: "TX",
  },
  {
    zip_code: "79778",

    ste_name: "TX",
  },
  {
    zip_code: "79781",

    ste_name: "TX",
  },
  {
    zip_code: "79855",

    ste_name: "TX",
  },
  {
    zip_code: "79901",

    ste_name: "TX",
  },
  {
    zip_code: "80131",

    ste_name: "CO",
  },
  {
    zip_code: "80133",

    ste_name: "CO",
  },
  {
    zip_code: "80623",

    ste_name: "CO",
  },
  {
    zip_code: "80746",

    ste_name: "CO",
  },
  {
    zip_code: "80754",

    ste_name: "CO",
  },
  {
    zip_code: "80816",

    ste_name: "CO",
  },
  {
    zip_code: "80820",

    ste_name: "CO",
  },
  {
    zip_code: "80913",

    ste_name: "CO",
  },
  {
    zip_code: "81124",

    ste_name: "CO",
  },
  {
    zip_code: "81140",

    ste_name: "CO",
  },
  {
    zip_code: "81240",

    ste_name: "CO",
  },
  {
    zip_code: "81330",

    ste_name: "CO",
  },
  {
    zip_code: "81649",

    ste_name: "CO",
  },
  {
    zip_code: "81652",

    ste_name: "CO",
  },
  {
    zip_code: "82054",

    ste_name: "WY",
  },
  {
    zip_code: "82060",

    ste_name: "WY",
  },
  {
    zip_code: "82072",

    ste_name: "WY",
  },
  {
    zip_code: "82215",

    ste_name: "WY",
  },
  {
    zip_code: "82222",

    ste_name: "WY",
  },
  {
    zip_code: "82428",

    ste_name: "WY",
  },
  {
    zip_code: "82441",

    ste_name: "WY",
  },
  {
    zip_code: "82601",

    ste_name: "WY",
  },
  {
    zip_code: "83119",

    ste_name: "WY",
  },
  {
    zip_code: "83211",

    ste_name: "ID",
  },
  {
    zip_code: "83239",

    ste_name: "ID",
  },
  {
    zip_code: "83246",

    ste_name: "ID",
  },
  {
    zip_code: "83286",

    ste_name: "ID",
  },
  {
    zip_code: "83301",

    ste_name: "ID",
  },
  {
    zip_code: "83321",

    ste_name: "ID",
  },
  {
    zip_code: "83325",

    ste_name: "ID",
  },
  {
    zip_code: "83354",

    ste_name: "ID",
  },
  {
    zip_code: "83406",

    ste_name: "ID",
  },
  {
    zip_code: "83623",

    ste_name: "ID",
  },
  {
    zip_code: "83706",

    ste_name: "ID",
  },
  {
    zip_code: "83812",

    ste_name: "ID",
  },
  {
    zip_code: "83850",

    ste_name: "ID",
  },
  {
    zip_code: "84040",

    ste_name: "UT",
  },
  {
    zip_code: "84058",

    ste_name: "UT",
  },
  {
    zip_code: "84103",

    ste_name: "UT",
  },
  {
    zip_code: "84111",

    ste_name: "UT",
  },
  {
    zip_code: "84116",

    ste_name: "UT",
  },
  {
    zip_code: "84307",

    ste_name: "UT",
  },
  {
    zip_code: "84310",

    ste_name: "UT",
  },
  {
    zip_code: "84403",

    ste_name: "UT",
  },
  {
    zip_code: "84723",

    ste_name: "UT",
  },
  {
    zip_code: "84730",

    ste_name: "UT",
  },
  {
    zip_code: "84734",

    ste_name: "UT",
  },
  {
    zip_code: "84761",

    ste_name: "UT",
  },
  {
    zip_code: "84762",

    ste_name: "UT",
  },
  {
    zip_code: "85029",

    ste_name: "AZ",
  },
  {
    zip_code: "85143",

    ste_name: "AZ",
  },
  {
    zip_code: "85260",

    ste_name: "AZ",
  },
  {
    zip_code: "85620",

    ste_name: "AZ",
  },
  {
    zip_code: "85625",

    ste_name: "AZ",
  },
  {
    zip_code: "85640",

    ste_name: "AZ",
  },
  {
    zip_code: "85650",

    ste_name: "AZ",
  },
  {
    zip_code: "85707",

    ste_name: "AZ",
  },
  {
    zip_code: "85746",

    ste_name: "AZ",
  },
  {
    zip_code: "85749",

    ste_name: "AZ",
  },
  {
    zip_code: "86047",

    ste_name: "AZ",
  },
  {
    zip_code: "86406",

    ste_name: "AZ",
  },
  {
    zip_code: "86409",

    ste_name: "AZ",
  },
  {
    zip_code: "87020",

    ste_name: "NM",
  },
  {
    zip_code: "87025",

    ste_name: "NM",
  },
  {
    zip_code: "87041",

    ste_name: "NM",
  },
  {
    zip_code: "87046",

    ste_name: "NM",
  },
  {
    zip_code: "87566",

    ste_name: "NM",
  },
  {
    zip_code: "87733",

    ste_name: "NM",
  },
  {
    zip_code: "87936",

    ste_name: "NM",
  },
  {
    zip_code: "88012",

    ste_name: "NM",
  },
  {
    zip_code: "88038",

    ste_name: "NM",
  },
  {
    zip_code: "88047",

    ste_name: "NM",
  },
  {
    zip_code: "88130",

    ste_name: "NM",
  },
  {
    zip_code: "88132",

    ste_name: "NM",
  },
  {
    zip_code: "88325",

    ste_name: "NM",
  },
  {
    zip_code: "88330",

    ste_name: "NM",
  },
  {
    zip_code: "88348",

    ste_name: "NM",
  },
  {
    zip_code: "89010",

    ste_name: "NV",
  },
  {
    zip_code: "89081",

    ste_name: "NV",
  },
  {
    zip_code: "89115",

    ste_name: "NV",
  },
  {
    zip_code: "89406",

    ste_name: "NV",
  },
  {
    zip_code: "89414",

    ste_name: "NV",
  },
  {
    zip_code: "89436",

    ste_name: "NV",
  },
  {
    zip_code: "89451",

    ste_name: "NV",
  },
  {
    zip_code: "89503",

    ste_name: "NV",
  },
  {
    zip_code: "89508",

    ste_name: "NV",
  },
  {
    zip_code: "89821",

    ste_name: "NV",
  },
  {
    zip_code: "89833",

    ste_name: "NV",
  },
  {
    zip_code: "90015",

    ste_name: "CA",
  },
  {
    zip_code: "90036",

    ste_name: "CA",
  },
  {
    zip_code: "90044",

    ste_name: "CA",
  },
  {
    zip_code: "90090",

    ste_name: "CA",
  },
  {
    zip_code: "90301",

    ste_name: "CA",
  },
  {
    zip_code: "90660",

    ste_name: "CA",
  },
  {
    zip_code: "90803",

    ste_name: "CA",
  },
  {
    zip_code: "91352",

    ste_name: "CA",
  },
  {
    zip_code: "91732",

    ste_name: "CA",
  },
  {
    zip_code: "91748",

    ste_name: "CA",
  },
  {
    zip_code: "91754",

    ste_name: "CA",
  },
  {
    zip_code: "91755",

    ste_name: "CA",
  },
  {
    zip_code: "91759",

    ste_name: "CA",
  },
  {
    zip_code: "92014",

    ste_name: "CA",
  },
  {
    zip_code: "92026",

    ste_name: "CA",
  },
  {
    zip_code: "92108",

    ste_name: "CA",
  },
  {
    zip_code: "92111",

    ste_name: "CA",
  },
  {
    zip_code: "92126",

    ste_name: "CA",
  },
  {
    zip_code: "92155",

    ste_name: "CA",
  },
  {
    zip_code: "92285",

    ste_name: "CA",
  },
  {
    zip_code: "92309",

    ste_name: "CA",
  },
  {
    zip_code: "92391",

    ste_name: "CA",
  },
  {
    zip_code: "92398",

    ste_name: "CA",
  },
  {
    zip_code: "92399",

    ste_name: "CA",
  },
  {
    zip_code: "92405",

    ste_name: "CA",
  },
  {
    zip_code: "92614",

    ste_name: "CA",
  },
  {
    zip_code: "92860",

    ste_name: "CA",
  },
  {
    zip_code: "93245",

    ste_name: "CA",
  },
  {
    zip_code: "93249",

    ste_name: "CA",
  },
  {
    zip_code: "93256",

    ste_name: "CA",
  },
  {
    zip_code: "93287",

    ste_name: "CA",
  },
  {
    zip_code: "93311",

    ste_name: "CA",
  },
  {
    zip_code: "93524",

    ste_name: "CA",
  },
  {
    zip_code: "93603",

    ste_name: "CA",
  },
  {
    zip_code: "93621",

    ste_name: "CA",
  },
  {
    zip_code: "93630",

    ste_name: "CA",
  },
  {
    zip_code: "93932",

    ste_name: "CA",
  },
  {
    zip_code: "94158",

    ste_name: "CA",
  },
  {
    zip_code: "94401",

    ste_name: "CA",
  },
  {
    zip_code: "94402",

    ste_name: "CA",
  },
  {
    zip_code: "94518",

    ste_name: "CA",
  },
  {
    zip_code: "94555",

    ste_name: "CA",
  },
  {
    zip_code: "94577",

    ste_name: "CA",
  },
  {
    zip_code: "94605",

    ste_name: "CA",
  },
  {
    zip_code: "94929",

    ste_name: "CA",
  },
  {
    zip_code: "95125",

    ste_name: "CA",
  },
  {
    zip_code: "95136",

    ste_name: "CA",
  },
  {
    zip_code: "95209",

    ste_name: "CA",
  },
  {
    zip_code: "95215",

    ste_name: "CA",
  },
  {
    zip_code: "95232",

    ste_name: "CA",
  },
  {
    zip_code: "95303",

    ste_name: "CA",
  },
  {
    zip_code: "95459",

    ste_name: "CA",
  },
  {
    zip_code: "95486",

    ste_name: "CA",
  },
  {
    zip_code: "95546",

    ste_name: "CA",
  },
  {
    zip_code: "95602",

    ste_name: "CA",
  },
  {
    zip_code: "95640",

    ste_name: "CA",
  },
  {
    zip_code: "95660",

    ste_name: "CA",
  },
  {
    zip_code: "95693",

    ste_name: "CA",
  },
  {
    zip_code: "95721",

    ste_name: "CA",
  },
  {
    zip_code: "95815",

    ste_name: "CA",
  },
  {
    zip_code: "95932",

    ste_name: "CA",
  },
  {
    zip_code: "96023",

    ste_name: "CA",
  },
  {
    zip_code: "96069",

    ste_name: "CA",
  },
  {
    zip_code: "96103",

    ste_name: "CA",
  },
  {
    zip_code: "96116",

    ste_name: "CA",
  },
  {
    zip_code: "96124",

    ste_name: "CA",
  },
  {
    zip_code: "96125",

    ste_name: "CA",
  },
  {
    zip_code: "96136",

    ste_name: "CA",
  },
  {
    zip_code: "96712",

    ste_name: "HI",
  },
  {
    zip_code: "96716",

    ste_name: "HI",
  },
  {
    zip_code: "96725",

    ste_name: "HI",
  },
  {
    zip_code: "96744",

    ste_name: "HI",
  },
  {
    zip_code: "96755",

    ste_name: "HI",
  },
  {
    zip_code: "96790",

    ste_name: "HI",
  },
  {
    zip_code: "97011",

    ste_name: "OR",
  },
  {
    zip_code: "97024",

    ste_name: "OR",
  },
  {
    zip_code: "97146",

    ste_name: "OR",
  },
  {
    zip_code: "97214",

    ste_name: "OR",
  },
  {
    zip_code: "97239",

    ste_name: "OR",
  },
  {
    zip_code: "97357",

    ste_name: "OR",
  },
  {
    zip_code: "97360",

    ste_name: "OR",
  },
  {
    zip_code: "97386",

    ste_name: "OR",
  },
  {
    zip_code: "97389",

    ste_name: "OR",
  },
  {
    zip_code: "97439",

    ste_name: "OR",
  },
  {
    zip_code: "97466",

    ste_name: "OR",
  },
  {
    zip_code: "97522",

    ste_name: "OR",
  },
  {
    zip_code: "97536",

    ste_name: "OR",
  },
  {
    zip_code: "97756",

    ste_name: "OR",
  },
  {
    zip_code: "97825",

    ste_name: "OR",
  },
  {
    zip_code: "97833",

    ste_name: "OR",
  },
  {
    zip_code: "97842",

    ste_name: "OR",
  },
  {
    zip_code: "97885",

    ste_name: "OR",
  },
  {
    zip_code: "98134",

    ste_name: "WA",
  },
  {
    zip_code: "98235",

    ste_name: "WA",
  },
  {
    zip_code: "98245",

    ste_name: "WA",
  },
  {
    zip_code: "98290",

    ste_name: "WA",
  },
  {
    zip_code: "98304",

    ste_name: "WA",
  },
  {
    zip_code: "98330",

    ste_name: "WA",
  },
  {
    zip_code: "98374",

    ste_name: "WA",
  },
  {
    zip_code: "98421",

    ste_name: "WA",
  },
  {
    zip_code: "98447",

    ste_name: "WA",
  },
  {
    zip_code: "98506",

    ste_name: "WA",
  },
  {
    zip_code: "98546",

    ste_name: "WA",
  },
  {
    zip_code: "98562",

    ste_name: "WA",
  },
  {
    zip_code: "98593",

    ste_name: "WA",
  },
  {
    zip_code: "98617",

    ste_name: "WA",
  },
  {
    zip_code: "98832",

    ste_name: "WA",
  },
  {
    zip_code: "98860",

    ste_name: "WA",
  },
  {
    zip_code: "99109",

    ste_name: "WA",
  },
  {
    zip_code: "99126",

    ste_name: "WA",
  },
  {
    zip_code: "99345",

    ste_name: "WA",
  },
  {
    zip_code: "99501",

    ste_name: "AK",
  },
  {
    zip_code: "99507",

    ste_name: "AK",
  },
  {
    zip_code: "99510",

    ste_name: "AK",
  },
  {
    zip_code: "99555",

    ste_name: "AK",
  },
  {
    zip_code: "99561",

    ste_name: "AK",
  },
  {
    zip_code: "99591",

    ste_name: "AK",
  },
  {
    zip_code: "99628",

    ste_name: "AK",
  },
  {
    zip_code: "99665",

    ste_name: "AK",
  },
  {
    zip_code: "99684",

    ste_name: "AK",
  },
  {
    zip_code: "99686",

    ste_name: "AK",
  },
  {
    zip_code: "99701",

    ste_name: "AK",
  },
  {
    zip_code: "99745",

    ste_name: "AK",
  },
  {
    zip_code: "99748",

    ste_name: "AK",
  },
  {
    zip_code: "99759",

    ste_name: "AK",
  },
  {
    zip_code: "99921",

    ste_name: "AK",
  },
  {
    zip_code: "99926",

    ste_name: "AK",
  },
  {
    zip_code: "676",

    ste_name: "PR",
  },
  {
    zip_code: "685",

    ste_name: "PR",
  },
  {
    zip_code: "801",

    ste_name: "VI",
  },
  {
    zip_code: "959",

    ste_name: "PR",
  },
  {
    zip_code: "962",

    ste_name: "PR",
  },
  {
    zip_code: "1082",

    ste_name: "MA",
  },
  {
    zip_code: "1089",

    ste_name: "MA",
  },
  {
    zip_code: "1094",

    ste_name: "MA",
  },
  {
    zip_code: "1103",

    ste_name: "MA",
  },
  {
    zip_code: "1238",

    ste_name: "MA",
  },
  {
    zip_code: "1338",

    ste_name: "MA",
  },
  {
    zip_code: "1349",

    ste_name: "MA",
  },
  {
    zip_code: "1351",

    ste_name: "MA",
  },
  {
    zip_code: "1469",

    ste_name: "MA",
  },
  {
    zip_code: "1503",

    ste_name: "MA",
  },
  {
    zip_code: "1540",

    ste_name: "MA",
  },
  {
    zip_code: "1581",

    ste_name: "MA",
  },
  {
    zip_code: "1770",

    ste_name: "MA",
  },
  {
    zip_code: "1778",

    ste_name: "MA",
  },
  {
    zip_code: "1834",

    ste_name: "MA",
  },
  {
    zip_code: "1951",

    ste_name: "MA",
  },
  {
    zip_code: "2113",

    ste_name: "MA",
  },
  {
    zip_code: "2129",

    ste_name: "MA",
  },
  {
    zip_code: "2135",

    ste_name: "MA",
  },
  {
    zip_code: "2188",

    ste_name: "MA",
  },
  {
    zip_code: "2215",

    ste_name: "MA",
  },
  {
    zip_code: "2367",

    ste_name: "MA",
  },
  {
    zip_code: "2558",

    ste_name: "MA",
  },
  {
    zip_code: "2575",

    ste_name: "MA",
  },
  {
    zip_code: "2601",

    ste_name: "MA",
  },
  {
    zip_code: "2702",

    ste_name: "MA",
  },
  {
    zip_code: "2861",

    ste_name: "RI",
  },
  {
    zip_code: "2874",

    ste_name: "RI",
  },
  {
    zip_code: "2882",

    ste_name: "RI",
  },
  {
    zip_code: "2888",

    ste_name: "RI",
  },
  {
    zip_code: "2895",

    ste_name: "RI",
  },
  {
    zip_code: "3043",

    ste_name: "NH",
  },
  {
    zip_code: "3048",

    ste_name: "NH",
  },
  {
    zip_code: "3079",

    ste_name: "NH",
  },
  {
    zip_code: "3106",

    ste_name: "NH",
  },
  {
    zip_code: "3240",

    ste_name: "NH",
  },
  {
    zip_code: "3278",

    ste_name: "NH",
  },
  {
    zip_code: "3581",

    ste_name: "NH",
  },
  {
    zip_code: "3595",

    ste_name: "NH",
  },
  {
    zip_code: "3604",

    ste_name: "NH",
  },
  {
    zip_code: "3781",

    ste_name: "NH",
  },
  {
    zip_code: "3814",

    ste_name: "NH",
  },
  {
    zip_code: "3826",

    ste_name: "NH",
  },
  {
    zip_code: "3902",

    ste_name: "ME",
  },
  {
    zip_code: "4105",

    ste_name: "ME",
  },
  {
    zip_code: "4416",

    ste_name: "ME",
  },
  {
    zip_code: "4441",

    ste_name: "ME",
  },
  {
    zip_code: "4538",

    ste_name: "ME",
  },
  {
    zip_code: "4648",

    ste_name: "ME",
  },
  {
    zip_code: "4655",

    ste_name: "ME",
  },
  {
    zip_code: "4673",

    ste_name: "ME",
  },
  {
    zip_code: "4783",

    ste_name: "ME",
  },
  {
    zip_code: "4861",

    ste_name: "ME",
  },
  {
    zip_code: "4910",

    ste_name: "ME",
  },
  {
    zip_code: "4932",

    ste_name: "ME",
  },
  {
    zip_code: "5045",

    ste_name: "VT",
  },
  {
    zip_code: "5050",

    ste_name: "VT",
  },
  {
    zip_code: "5069",

    ste_name: "VT",
  },
  {
    zip_code: "5250",

    ste_name: "VT",
  },
  {
    zip_code: "5405",

    ste_name: "VT",
  },
  {
    zip_code: "5457",

    ste_name: "VT",
  },
  {
    zip_code: "5483",

    ste_name: "VT",
  },
  {
    zip_code: "5485",

    ste_name: "VT",
  },
  {
    zip_code: "5488",

    ste_name: "VT",
  },
  {
    zip_code: "5657",

    ste_name: "VT",
  },
  {
    zip_code: "5661",

    ste_name: "VT",
  },
  {
    zip_code: "5770",

    ste_name: "VT",
  },
  {
    zip_code: "5827",

    ste_name: "VT",
  },
  {
    zip_code: "5846",

    ste_name: "VT",
  },
  {
    zip_code: "6013",

    ste_name: "CT",
  },
  {
    zip_code: "6085",

    ste_name: "CT",
  },
  {
    zip_code: "6239",

    ste_name: "CT",
  },
  {
    zip_code: "6480",

    ste_name: "CT",
  },
  {
    zip_code: "6810",

    ste_name: "CT",
  },
  {
    zip_code: "7066",

    ste_name: "NJ",
  },
  {
    zip_code: "7073",

    ste_name: "NJ",
  },
  {
    zip_code: "7080",

    ste_name: "NJ",
  },
  {
    zip_code: "7423",

    ste_name: "NJ",
  },
  {
    zip_code: "7480",

    ste_name: "NJ",
  },
  {
    zip_code: "7524",

    ste_name: "NJ",
  },
  {
    zip_code: "7649",

    ste_name: "NJ",
  },
  {
    zip_code: "7704",

    ste_name: "NJ",
  },
  {
    zip_code: "7740",

    ste_name: "NJ",
  },
  {
    zip_code: "7865",

    ste_name: "NJ",
  },
  {
    zip_code: "7880",

    ste_name: "NJ",
  },
  {
    zip_code: "7946",

    ste_name: "NJ",
  },
  {
    zip_code: "7974",

    ste_name: "NJ",
  },
  {
    zip_code: "8003",

    ste_name: "NJ",
  },
  {
    zip_code: "8057",

    ste_name: "NJ",
  },
  {
    zip_code: "8401",

    ste_name: "NJ",
  },
  {
    zip_code: "8640",

    ste_name: "NJ",
  },
  {
    zip_code: "8751",

    ste_name: "NJ",
  },
  {
    zip_code: "8837",

    ste_name: "NJ",
  },
  {
    zip_code: "8889",

    ste_name: "NJ",
  },
  {
    zip_code: "10027",

    ste_name: "NY",
  },
  {
    zip_code: "10029",

    ste_name: "NY",
  },
  {
    zip_code: "10115",

    ste_name: "NY",
  },
  {
    zip_code: "10473",

    ste_name: "NY",
  },
  {
    zip_code: "10530",

    ste_name: "NY",
  },
  {
    zip_code: "10597",

    ste_name: "NY",
  },
  {
    zip_code: "10901",

    ste_name: "NY",
  },
  {
    zip_code: "10910",

    ste_name: "NY",
  },
  {
    zip_code: "10926",

    ste_name: "NY",
  },
  {
    zip_code: "10958",

    ste_name: "NY",
  },
  {
    zip_code: "10964",

    ste_name: "NY",
  },
  {
    zip_code: "11023",

    ste_name: "NY",
  },
  {
    zip_code: "11217",

    ste_name: "NY",
  },
  {
    zip_code: "11229",

    ste_name: "NY",
  },
  {
    zip_code: "11358",

    ste_name: "NY",
  },
  {
    zip_code: "11366",

    ste_name: "NY",
  },
  {
    zip_code: "11542",

    ste_name: "NY",
  },
  {
    zip_code: "11553",

    ste_name: "NY",
  },
  {
    zip_code: "11575",

    ste_name: "NY",
  },
  {
    zip_code: "11935",

    ste_name: "NY",
  },
  {
    zip_code: "11971",

    ste_name: "NY",
  },
  {
    zip_code: "12031",

    ste_name: "NY",
  },
  {
    zip_code: "12059",

    ste_name: "NY",
  },
  {
    zip_code: "12065",

    ste_name: "NY",
  },
  {
    zip_code: "12131",

    ste_name: "NY",
  },
  {
    zip_code: "12165",

    ste_name: "NY",
  },
  {
    zip_code: "12182",

    ste_name: "NY",
  },
  {
    zip_code: "12205",

    ste_name: "NY",
  },
  {
    zip_code: "12416",

    ste_name: "NY",
  },
  {
    zip_code: "12429",

    ste_name: "NY",
  },
  {
    zip_code: "12459",

    ste_name: "NY",
  },
  {
    zip_code: "12475",

    ste_name: "NY",
  },
  {
    zip_code: "12495",

    ste_name: "NY",
  },
  {
    zip_code: "12549",

    ste_name: "NY",
  },
  {
    zip_code: "12720",

    ste_name: "NY",
  },
  {
    zip_code: "12748",

    ste_name: "NY",
  },
  {
    zip_code: "12767",

    ste_name: "NY",
  },
  {
    zip_code: "12770",

    ste_name: "NY",
  },
  {
    zip_code: "12920",

    ste_name: "NY",
  },
  {
    zip_code: "12927",

    ste_name: "NY",
  },
  {
    zip_code: "12933",

    ste_name: "NY",
  },
  {
    zip_code: "12942",

    ste_name: "NY",
  },
  {
    zip_code: "12977",

    ste_name: "NY",
  },
  {
    zip_code: "13076",

    ste_name: "NY",
  },
  {
    zip_code: "13108",

    ste_name: "NY",
  },
  {
    zip_code: "13138",

    ste_name: "NY",
  },
  {
    zip_code: "13140",

    ste_name: "NY",
  },
  {
    zip_code: "13157",

    ste_name: "NY",
  },
  {
    zip_code: "13207",

    ste_name: "NY",
  },
  {
    zip_code: "13323",

    ste_name: "NY",
  },
  {
    zip_code: "13357",

    ste_name: "NY",
  },
  {
    zip_code: "13360",

    ste_name: "NY",
  },
  {
    zip_code: "13613",

    ste_name: "NY",
  },
  {
    zip_code: "13662",

    ste_name: "NY",
  },
  {
    zip_code: "13668",

    ste_name: "NY",
  },
  {
    zip_code: "13691",

    ste_name: "NY",
  },
  {
    zip_code: "13694",

    ste_name: "NY",
  },
  {
    zip_code: "13820",

    ste_name: "NY",
  },
  {
    zip_code: "13902",

    ste_name: "NY",
  },
  {
    zip_code: "14047",

    ste_name: "NY",
  },
  {
    zip_code: "14103",

    ste_name: "NY",
  },
  {
    zip_code: "14135",

    ste_name: "NY",
  },
  {
    zip_code: "14225",

    ste_name: "NY",
  },
  {
    zip_code: "14475",

    ste_name: "NY",
  },
  {
    zip_code: "14714",

    ste_name: "NY",
  },
  {
    zip_code: "14757",

    ste_name: "NY",
  },
  {
    zip_code: "14777",

    ste_name: "NY",
  },
  {
    zip_code: "15045",

    ste_name: "PA",
  },
  {
    zip_code: "15062",

    ste_name: "PA",
  },
  {
    zip_code: "15076",

    ste_name: "PA",
  },
  {
    zip_code: "15136",

    ste_name: "PA",
  },
  {
    zip_code: "15143",

    ste_name: "PA",
  },
  {
    zip_code: "15203",

    ste_name: "PA",
  },
  {
    zip_code: "15313",

    ste_name: "PA",
  },
  {
    zip_code: "15352",

    ste_name: "PA",
  },
  {
    zip_code: "15421",

    ste_name: "PA",
  },
  {
    zip_code: "15448",

    ste_name: "PA",
  },
  {
    zip_code: "15479",

    ste_name: "PA",
  },
  {
    zip_code: "15530",

    ste_name: "PA",
  },
  {
    zip_code: "15613",

    ste_name: "PA",
  },
  {
    zip_code: "15624",

    ste_name: "PA",
  },
  {
    zip_code: "15655",

    ste_name: "PA",
  },
  {
    zip_code: "15687",

    ste_name: "PA",
  },
  {
    zip_code: "15738",

    ste_name: "PA",
  },
  {
    zip_code: "15761",

    ste_name: "PA",
  },
  {
    zip_code: "15829",

    ste_name: "PA",
  },
  {
    zip_code: "16038",

    ste_name: "PA",
  },
  {
    zip_code: "16685",

    ste_name: "PA",
  },
  {
    zip_code: "16840",

    ste_name: "PA",
  },
  {
    zip_code: "16941",

    ste_name: "PA",
  },
  {
    zip_code: "17015",

    ste_name: "PA",
  },
  {
    zip_code: "17048",

    ste_name: "PA",
  },
  {
    zip_code: "17053",

    ste_name: "PA",
  },
  {
    zip_code: "17113",

    ste_name: "PA",
  },
  {
    zip_code: "17257",

    ste_name: "PA",
  },
  {
    zip_code: "17402",

    ste_name: "PA",
  },
  {
    zip_code: "17501",

    ste_name: "PA",
  },
  {
    zip_code: "17535",

    ste_name: "PA",
  },
  {
    zip_code: "17570",

    ste_name: "PA",
  },
  {
    zip_code: "17756",

    ste_name: "PA",
  },
  {
    zip_code: "17779",

    ste_name: "PA",
  },
  {
    zip_code: "17823",

    ste_name: "PA",
  },
  {
    zip_code: "17827",

    ste_name: "PA",
  },
  {
    zip_code: "17834",

    ste_name: "PA",
  },
  {
    zip_code: "17845",

    ste_name: "PA",
  },
  {
    zip_code: "17921",

    ste_name: "PA",
  },
  {
    zip_code: "17935",

    ste_name: "PA",
  },
  {
    zip_code: "18032",

    ste_name: "PA",
  },
  {
    zip_code: "18058",

    ste_name: "PA",
  },
  {
    zip_code: "18087",

    ste_name: "PA",
  },
  {
    zip_code: "18092",

    ste_name: "PA",
  },
  {
    zip_code: "18241",

    ste_name: "PA",
  },
  {
    zip_code: "18331",

    ste_name: "PA",
  },
  {
    zip_code: "18347",

    ste_name: "PA",
  },
  {
    zip_code: "18427",

    ste_name: "PA",
  },
  {
    zip_code: "18519",

    ste_name: "PA",
  },
  {
    zip_code: "18619",

    ste_name: "PA",
  },
  {
    zip_code: "18636",

    ste_name: "PA",
  },
  {
    zip_code: "18642",

    ste_name: "PA",
  },
  {
    zip_code: "18705",

    ste_name: "PA",
  },
  {
    zip_code: "18832",

    ste_name: "PA",
  },
  {
    zip_code: "19056",

    ste_name: "PA",
  },
  {
    zip_code: "19095",

    ste_name: "PA",
  },
  {
    zip_code: "19440",

    ste_name: "PA",
  },
  {
    zip_code: "19472",

    ste_name: "PA",
  },
  {
    zip_code: "19506",

    ste_name: "PA",
  },
  {
    zip_code: "19956",

    ste_name: "DE",
  },
  {
    zip_code: "19973",

    ste_name: "DE",
  },
  {
    zip_code: "20045",

    ste_name: "DC",
  },
  {
    zip_code: "20137",

    ste_name: "VA",
  },
  {
    zip_code: "20618",

    ste_name: "MD",
  },
  {
    zip_code: "20693",

    ste_name: "MD",
  },
  {
    zip_code: "20740",

    ste_name: "MD",
  },
  {
    zip_code: "20774",

    ste_name: "MD",
  },
  {
    zip_code: "20812",

    ste_name: "MD",
  },
  {
    zip_code: "21005",

    ste_name: "MD",
  },
  {
    zip_code: "21034",

    ste_name: "MD",
  },
  {
    zip_code: "21214",

    ste_name: "MD",
  },
  {
    zip_code: "22964",

    ste_name: "VA",
  },
  {
    zip_code: "23038",

    ste_name: "VA",
  },
  {
    zip_code: "23045",

    ste_name: "VA",
  },
  {
    zip_code: "23061",

    ste_name: "VA",
  },
  {
    zip_code: "23071",

    ste_name: "VA",
  },
  {
    zip_code: "23451",

    ste_name: "VA",
  },
  {
    zip_code: "23608",

    ste_name: "VA",
  },
  {
    zip_code: "23669",

    ste_name: "VA",
  },
  {
    zip_code: "23708",

    ste_name: "VA",
  },
  {
    zip_code: "23876",

    ste_name: "VA",
  },
  {
    zip_code: "23967",

    ste_name: "VA",
  },
  {
    zip_code: "23968",

    ste_name: "VA",
  },
  {
    zip_code: "24018",

    ste_name: "VA",
  },
  {
    zip_code: "24020",

    ste_name: "VA",
  },
  {
    zip_code: "24059",

    ste_name: "VA",
  },
  {
    zip_code: "24095",

    ste_name: "VA",
  },
  {
    zip_code: "24148",

    ste_name: "VA",
  },
  {
    zip_code: "24165",

    ste_name: "VA",
  },
  {
    zip_code: "24185",

    ste_name: "VA",
  },
  {
    zip_code: "24244",

    ste_name: "VA",
  },
  {
    zip_code: "24248",

    ste_name: "VA",
  },
  {
    zip_code: "24290",

    ste_name: "VA",
  },
  {
    zip_code: "24326",

    ste_name: "VA",
  },
  {
    zip_code: "24360",

    ste_name: "VA",
  },
  {
    zip_code: "24474",

    ste_name: "VA",
  },
  {
    zip_code: "24566",

    ste_name: "VA",
  },
  {
    zip_code: "24733",

    ste_name: "WV",
  },
  {
    zip_code: "24827",

    ste_name: "WV",
  },
  {
    zip_code: "24867",

    ste_name: "WV",
  },
  {
    zip_code: "24870",

    ste_name: "WV",
  },
  {
    zip_code: "24954",

    ste_name: "WV",
  },
  {
    zip_code: "25049",

    ste_name: "WV",
  },
  {
    zip_code: "25123",

    ste_name: "WV",
  },
  {
    zip_code: "25156",

    ste_name: "WV",
  },
  {
    zip_code: "25187",

    ste_name: "WV",
  },
  {
    zip_code: "25260",

    ste_name: "WV",
  },
  {
    zip_code: "25285",

    ste_name: "WV",
  },
  {
    zip_code: "25444",

    ste_name: "WV",
  },
  {
    zip_code: "25524",

    ste_name: "WV",
  },
  {
    zip_code: "25534",

    ste_name: "WV",
  },
  {
    zip_code: "25705",

    ste_name: "WV",
  },
  {
    zip_code: "25817",

    ste_name: "WV",
  },
  {
    zip_code: "25978",

    ste_name: "WV",
  },
  {
    zip_code: "26038",

    ste_name: "WV",
  },
  {
    zip_code: "26104",

    ste_name: "WV",
  },
  {
    zip_code: "26148",

    ste_name: "WV",
  },
  {
    zip_code: "26205",

    ste_name: "WV",
  },
  {
    zip_code: "26218",

    ste_name: "WV",
  },
  {
    zip_code: "26374",

    ste_name: "WV",
  },
  {
    zip_code: "26385",

    ste_name: "WV",
  },
  {
    zip_code: "26386",

    ste_name: "WV",
  },
  {
    zip_code: "26619",

    ste_name: "WV",
  },
  {
    zip_code: "26624",

    ste_name: "WV",
  },
  {
    zip_code: "27231",

    ste_name: "NC",
  },
  {
    zip_code: "27281",

    ste_name: "NC",
  },
  {
    zip_code: "27291",

    ste_name: "NC",
  },
  {
    zip_code: "27295",

    ste_name: "NC",
  },
  {
    zip_code: "27377",

    ste_name: "NC",
  },
  {
    zip_code: "27545",

    ste_name: "NC",
  },
  {
    zip_code: "27559",

    ste_name: "NC",
  },
  {
    zip_code: "27569",

    ste_name: "NC",
  },
  {
    zip_code: "27589",

    ste_name: "NC",
  },
  {
    zip_code: "27818",

    ste_name: "NC",
  },
  {
    zip_code: "27875",

    ste_name: "NC",
  },
  {
    zip_code: "27919",

    ste_name: "NC",
  },
  {
    zip_code: "27946",

    ste_name: "NC",
  },
  {
    zip_code: "27966",

    ste_name: "NC",
  },
  {
    zip_code: "27973",

    ste_name: "NC",
  },
  {
    zip_code: "28017",

    ste_name: "NC",
  },
  {
    zip_code: "28105",

    ste_name: "NC",
  },
  {
    zip_code: "28262",

    ste_name: "NC",
  },
  {
    zip_code: "28314",

    ste_name: "NC",
  },
  {
    zip_code: "28358",

    ste_name: "NC",
  },
  {
    zip_code: "28451",

    ste_name: "NC",
  },
  {
    zip_code: "28504",

    ste_name: "NC",
  },
  {
    zip_code: "28531",

    ste_name: "NC",
  },
  {
    zip_code: "28538",

    ste_name: "NC",
  },
  {
    zip_code: "28571",

    ste_name: "NC",
  },
  {
    zip_code: "28745",

    ste_name: "NC",
  },
  {
    zip_code: "29161",

    ste_name: "SC",
  },
  {
    zip_code: "29170",

    ste_name: "SC",
  },
  {
    zip_code: "29203",

    ste_name: "SC",
  },
  {
    zip_code: "29353",

    ste_name: "SC",
  },
  {
    zip_code: "29512",

    ste_name: "SC",
  },
  {
    zip_code: "29527",

    ste_name: "SC",
  },
  {
    zip_code: "29560",

    ste_name: "SC",
  },
  {
    zip_code: "29583",

    ste_name: "SC",
  },
  {
    zip_code: "29645",

    ste_name: "SC",
  },
  {
    zip_code: "29710",

    ste_name: "SC",
  },
  {
    zip_code: "29726",

    ste_name: "SC",
  },
  {
    zip_code: "29909",

    ste_name: "SC",
  },
  {
    zip_code: "30028",

    ste_name: "GA",
  },
  {
    zip_code: "30035",

    ste_name: "GA",
  },
  {
    zip_code: "30054",

    ste_name: "GA",
  },
  {
    zip_code: "30102",

    ste_name: "GA",
  },
  {
    zip_code: "30118",

    ste_name: "GA",
  },
  {
    zip_code: "30216",

    ste_name: "GA",
  },
  {
    zip_code: "30252",

    ste_name: "GA",
  },
  {
    zip_code: "30269",

    ste_name: "GA",
  },
  {
    zip_code: "30316",

    ste_name: "GA",
  },
  {
    zip_code: "30319",

    ste_name: "GA",
  },
  {
    zip_code: "30507",

    ste_name: "GA",
  },
  {
    zip_code: "30520",

    ste_name: "GA",
  },
  {
    zip_code: "30625",

    ste_name: "GA",
  },
  {
    zip_code: "30635",

    ste_name: "GA",
  },
  {
    zip_code: "30683",

    ste_name: "GA",
  },
  {
    zip_code: "30805",

    ste_name: "GA",
  },
  {
    zip_code: "30807",

    ste_name: "GA",
  },
  {
    zip_code: "30903",

    ste_name: "GA",
  },
  {
    zip_code: "30907",

    ste_name: "GA",
  },
  {
    zip_code: "31217",

    ste_name: "GA",
  },
  {
    zip_code: "31307",

    ste_name: "GA",
  },
  {
    zip_code: "31323",

    ste_name: "GA",
  },
  {
    zip_code: "31749",

    ste_name: "GA",
  },
  {
    zip_code: "31824",

    ste_name: "GA",
  },
  {
    zip_code: "32061",

    ste_name: "FL",
  },
  {
    zip_code: "32132",

    ste_name: "FL",
  },
  {
    zip_code: "32140",

    ste_name: "FL",
  },
  {
    zip_code: "32159",

    ste_name: "FL",
  },
  {
    zip_code: "32187",

    ste_name: "FL",
  },
  {
    zip_code: "32321",

    ste_name: "FL",
  },
  {
    zip_code: "32322",

    ste_name: "FL",
  },
  {
    zip_code: "32355",

    ste_name: "FL",
  },
  {
    zip_code: "32426",

    ste_name: "FL",
  },
  {
    zip_code: "32459",

    ste_name: "FL",
  },
  {
    zip_code: "32601",

    ste_name: "FL",
  },
  {
    zip_code: "32605",

    ste_name: "FL",
  },
  {
    zip_code: "32667",

    ste_name: "FL",
  },
  {
    zip_code: "32784",

    ste_name: "FL",
  },
  {
    zip_code: "32814",

    ste_name: "FL",
  },
  {
    zip_code: "32828",

    ste_name: "FL",
  },
  {
    zip_code: "32931",

    ste_name: "FL",
  },
  {
    zip_code: "33012",

    ste_name: "FL",
  },
  {
    zip_code: "33013",

    ste_name: "FL",
  },
  {
    zip_code: "33021",

    ste_name: "FL",
  },
  {
    zip_code: "33128",

    ste_name: "FL",
  },
  {
    zip_code: "33143",

    ste_name: "FL",
  },
  {
    zip_code: "33145",

    ste_name: "FL",
  },
  {
    zip_code: "33317",

    ste_name: "FL",
  },
  {
    zip_code: "33406",

    ste_name: "FL",
  },
  {
    zip_code: "33417",

    ste_name: "FL",
  },
  {
    zip_code: "33426",

    ste_name: "FL",
  },
  {
    zip_code: "33428",

    ste_name: "FL",
  },
  {
    zip_code: "33444",

    ste_name: "FL",
  },
  {
    zip_code: "33525",

    ste_name: "FL",
  },
  {
    zip_code: "33563",

    ste_name: "FL",
  },
  {
    zip_code: "33813",

    ste_name: "FL",
  },
  {
    zip_code: "33837",

    ste_name: "FL",
  },
  {
    zip_code: "33877",

    ste_name: "FL",
  },
  {
    zip_code: "33913",

    ste_name: "FL",
  },
  {
    zip_code: "33922",

    ste_name: "FL",
  },
  {
    zip_code: "33957",

    ste_name: "FL",
  },
  {
    zip_code: "33967",

    ste_name: "FL",
  },
  {
    zip_code: "34207",

    ste_name: "FL",
  },
  {
    zip_code: "34224",

    ste_name: "FL",
  },
  {
    zip_code: "34286",

    ste_name: "FL",
  },
  {
    zip_code: "34442",

    ste_name: "FL",
  },
  {
    zip_code: "34446",

    ste_name: "FL",
  },
  {
    zip_code: "34471",

    ste_name: "FL",
  },
  {
    zip_code: "34747",

    ste_name: "FL",
  },
  {
    zip_code: "35032",

    ste_name: "AL",
  },
  {
    zip_code: "35046",

    ste_name: "AL",
  },
  {
    zip_code: "35070",

    ste_name: "AL",
  },
  {
    zip_code: "35146",

    ste_name: "AL",
  },
  {
    zip_code: "35184",

    ste_name: "AL",
  },
  {
    zip_code: "35186",

    ste_name: "AL",
  },
  {
    zip_code: "35213",

    ste_name: "AL",
  },
  {
    zip_code: "35214",

    ste_name: "AL",
  },
  {
    zip_code: "35215",

    ste_name: "AL",
  },
  {
    zip_code: "35477",

    ste_name: "AL",
  },
  {
    zip_code: "35480",

    ste_name: "AL",
  },
  {
    zip_code: "35578",

    ste_name: "AL",
  },
  {
    zip_code: "35610",

    ste_name: "AL",
  },
  {
    zip_code: "35619",

    ste_name: "AL",
  },
  {
    zip_code: "35622",

    ste_name: "AL",
  },
  {
    zip_code: "35905",

    ste_name: "AL",
  },
  {
    zip_code: "35957",

    ste_name: "AL",
  },
  {
    zip_code: "35959",

    ste_name: "AL",
  },
  {
    zip_code: "36016",

    ste_name: "AL",
  },
  {
    zip_code: "36108",

    ste_name: "AL",
  },
  {
    zip_code: "36250",

    ste_name: "AL",
  },
  {
    zip_code: "36265",

    ste_name: "AL",
  },
  {
    zip_code: "36321",

    ste_name: "AL",
  },
  {
    zip_code: "36376",

    ste_name: "AL",
  },
  {
    zip_code: "36460",

    ste_name: "AL",
  },
  {
    zip_code: "36535",

    ste_name: "AL",
  },
  {
    zip_code: "36726",

    ste_name: "AL",
  },
  {
    zip_code: "36736",

    ste_name: "AL",
  },
  {
    zip_code: "36763",

    ste_name: "AL",
  },
  {
    zip_code: "36766",

    ste_name: "AL",
  },
  {
    zip_code: "36850",

    ste_name: "AL",
  },
  {
    zip_code: "36870",

    ste_name: "AL",
  },
  {
    zip_code: "36912",

    ste_name: "AL",
  },
  {
    zip_code: "37149",

    ste_name: "TN",
  },
  {
    zip_code: "37179",

    ste_name: "TN",
  },
  {
    zip_code: "37189",

    ste_name: "TN",
  },
  {
    zip_code: "37332",

    ste_name: "TN",
  },
  {
    zip_code: "37347",

    ste_name: "TN",
  },
  {
    zip_code: "37407",

    ste_name: "TN",
  },
  {
    zip_code: "37716",

    ste_name: "TN",
  },
  {
    zip_code: "37806",

    ste_name: "TN",
  },
  {
    zip_code: "37938",

    ste_name: "TN",
  },
  {
    zip_code: "38042",

    ste_name: "TN",
  },
  {
    zip_code: "38251",

    ste_name: "TN",
  },
  {
    zip_code: "38316",

    ste_name: "TN",
  },
  {
    zip_code: "38332",

    ste_name: "TN",
  },
  {
    zip_code: "38473",

    ste_name: "TN",
  },
  {
    zip_code: "38567",

    ste_name: "TN",
  },
  {
    zip_code: "38632",

    ste_name: "MS",
  },
  {
    zip_code: "38738",

    ste_name: "MS",
  },
  {
    zip_code: "38753",

    ste_name: "MS",
  },
  {
    zip_code: "38754",

    ste_name: "MS",
  },
  {
    zip_code: "38804",

    ste_name: "MS",
  },
  {
    zip_code: "38871",

    ste_name: "MS",
  },
  {
    zip_code: "38878",

    ste_name: "MS",
  },
  {
    zip_code: "38963",

    ste_name: "MS",
  },
  {
    zip_code: "39071",

    ste_name: "MS",
  },
  {
    zip_code: "39119",

    ste_name: "MS",
  },
  {
    zip_code: "39359",

    ste_name: "MS",
  },
  {
    zip_code: "39540",

    ste_name: "MS",
  },
  {
    zip_code: "39561",

    ste_name: "MS",
  },
  {
    zip_code: "39662",

    ste_name: "MS",
  },
  {
    zip_code: "39743",

    ste_name: "MS",
  },
  {
    zip_code: "39772",

    ste_name: "MS",
  },
  {
    zip_code: "40222",

    ste_name: "KY",
  },
  {
    zip_code: "40353",

    ste_name: "KY",
  },
  {
    zip_code: "40447",

    ste_name: "KY",
  },
  {
    zip_code: "40810",

    ste_name: "KY",
  },
  {
    zip_code: "40858",

    ste_name: "KY",
  },
  {
    zip_code: "40902",

    ste_name: "KY",
  },
  {
    zip_code: "40923",

    ste_name: "KY",
  },
  {
    zip_code: "40941",

    ste_name: "KY",
  },
  {
    zip_code: "41008",

    ste_name: "KY",
  },
  {
    zip_code: "41056",

    ste_name: "KY",
  },
  {
    zip_code: "41141",

    ste_name: "KY",
  },
  {
    zip_code: "41271",

    ste_name: "KY",
  },
  {
    zip_code: "41332",

    ste_name: "KY",
  },
  {
    zip_code: "41517",

    ste_name: "KY",
  },
  {
    zip_code: "41519",

    ste_name: "KY",
  },
  {
    zip_code: "41547",

    ste_name: "KY",
  },
  {
    zip_code: "41560",

    ste_name: "KY",
  },
  {
    zip_code: "41606",

    ste_name: "KY",
  },
  {
    zip_code: "41607",

    ste_name: "KY",
  },
  {
    zip_code: "41631",

    ste_name: "KY",
  },
  {
    zip_code: "42056",

    ste_name: "KY",
  },
  {
    zip_code: "42101",

    ste_name: "KY",
  },
  {
    zip_code: "42286",

    ste_name: "KY",
  },
  {
    zip_code: "42748",

    ste_name: "KY",
  },
  {
    zip_code: "43211",

    ste_name: "OH",
  },
  {
    zip_code: "43223",

    ste_name: "OH",
  },
  {
    zip_code: "43345",

    ste_name: "OH",
  },
  {
    zip_code: "43711",

    ste_name: "OH",
  },
  {
    zip_code: "43717",

    ste_name: "OH",
  },
  {
    zip_code: "43734",

    ste_name: "OH",
  },
  {
    zip_code: "43903",

    ste_name: "OH",
  },
  {
    zip_code: "44030",

    ste_name: "OH",
  },
  {
    zip_code: "44035",

    ste_name: "OH",
  },
  {
    zip_code: "44110",

    ste_name: "OH",
  },
  {
    zip_code: "44216",

    ste_name: "OH",
  },
  {
    zip_code: "44304",

    ste_name: "OH",
  },
  {
    zip_code: "44413",

    ste_name: "OH",
  },
  {
    zip_code: "44622",

    ste_name: "OH",
  },
  {
    zip_code: "44638",

    ste_name: "OH",
  },
  {
    zip_code: "44702",

    ste_name: "OH",
  },
  {
    zip_code: "44828",

    ste_name: "OH",
  },
  {
    zip_code: "45050",

    ste_name: "OH",
  },
  {
    zip_code: "45218",

    ste_name: "OH",
  },
  {
    zip_code: "45238",

    ste_name: "OH",
  },
  {
    zip_code: "45318",

    ste_name: "OH",
  },
  {
    zip_code: "45371",

    ste_name: "OH",
  },
  {
    zip_code: "45430",

    ste_name: "OH",
  },
  {
    zip_code: "45613",

    ste_name: "OH",
  },
  {
    zip_code: "45634",

    ste_name: "OH",
  },
  {
    zip_code: "45735",

    ste_name: "OH",
  },
  {
    zip_code: "45745",

    ste_name: "OH",
  },
  {
    zip_code: "45775",

    ste_name: "OH",
  },
  {
    zip_code: "45809",

    ste_name: "OH",
  },
  {
    zip_code: "45833",

    ste_name: "OH",
  },
  {
    zip_code: "46001",

    ste_name: "IN",
  },
  {
    zip_code: "46117",

    ste_name: "IN",
  },
  {
    zip_code: "46144",

    ste_name: "IN",
  },
  {
    zip_code: "46156",

    ste_name: "IN",
  },
  {
    zip_code: "46241",

    ste_name: "IN",
  },
  {
    zip_code: "46303",

    ste_name: "IN",
  },
  {
    zip_code: "46365",

    ste_name: "IN",
  },
  {
    zip_code: "46543",

    ste_name: "IN",
  },
  {
    zip_code: "46570",

    ste_name: "IN",
  },
  {
    zip_code: "46705",

    ste_name: "IN",
  },
  {
    zip_code: "46774",

    ste_name: "IN",
  },
  {
    zip_code: "46816",

    ste_name: "IN",
  },
  {
    zip_code: "46825",

    ste_name: "IN",
  },
  {
    zip_code: "47012",

    ste_name: "IN",
  },
  {
    zip_code: "47030",

    ste_name: "IN",
  },
  {
    zip_code: "47124",

    ste_name: "IN",
  },
  {
    zip_code: "47260",

    ste_name: "IN",
  },
  {
    zip_code: "47306",

    ste_name: "IN",
  },
  {
    zip_code: "47385",

    ste_name: "IN",
  },
  {
    zip_code: "47457",

    ste_name: "IN",
  },
  {
    zip_code: "47531",

    ste_name: "IN",
  },
  {
    zip_code: "47541",

    ste_name: "IN",
  },
  {
    zip_code: "47553",

    ste_name: "IN",
  },
  {
    zip_code: "47580",

    ste_name: "IN",
  },
  {
    zip_code: "47611",

    ste_name: "IN",
  },
  {
    zip_code: "47613",

    ste_name: "IN",
  },
  {
    zip_code: "47620",

    ste_name: "IN",
  },
  {
    zip_code: "47805",

    ste_name: "IN",
  },
  {
    zip_code: "47809",

    ste_name: "IN",
  },
  {
    zip_code: "47853",

    ste_name: "IN",
  },
  {
    zip_code: "47923",

    ste_name: "IN",
  },
  {
    zip_code: "47960",

    ste_name: "IN",
  },
  {
    zip_code: "48001",

    ste_name: "MI",
  },
  {
    zip_code: "48144",

    ste_name: "MI",
  },
  {
    zip_code: "48154",

    ste_name: "MI",
  },
  {
    zip_code: "48226",

    ste_name: "MI",
  },
  {
    zip_code: "48341",

    ste_name: "MI",
  },
  {
    zip_code: "48433",

    ste_name: "MI",
  },
  {
    zip_code: "48454",

    ste_name: "MI",
  },
  {
    zip_code: "48468",

    ste_name: "MI",
  },
  {
    zip_code: "48519",

    ste_name: "MI",
  },
  {
    zip_code: "48637",

    ste_name: "MI",
  },
  {
    zip_code: "48720",

    ste_name: "MI",
  },
  {
    zip_code: "48743",

    ste_name: "MI",
  },
  {
    zip_code: "48835",

    ste_name: "MI",
  },
  {
    zip_code: "48847",

    ste_name: "MI",
  },
  {
    zip_code: "48858",

    ste_name: "MI",
  },
  {
    zip_code: "48912",

    ste_name: "MI",
  },
  {
    zip_code: "49022",

    ste_name: "MI",
  },
  {
    zip_code: "49028",

    ste_name: "MI",
  },
  {
    zip_code: "49089",

    ste_name: "MI",
  },
  {
    zip_code: "49235",

    ste_name: "MI",
  },
  {
    zip_code: "49325",

    ste_name: "MI",
  },
  {
    zip_code: "49330",

    ste_name: "MI",
  },
  {
    zip_code: "49338",

    ste_name: "MI",
  },
  {
    zip_code: "49343",

    ste_name: "MI",
  },
  {
    zip_code: "49507",

    ste_name: "MI",
  },
  {
    zip_code: "49508",

    ste_name: "MI",
  },
  {
    zip_code: "49617",

    ste_name: "MI",
  },
  {
    zip_code: "49716",

    ste_name: "MI",
  },
  {
    zip_code: "49746",

    ste_name: "MI",
  },
  {
    zip_code: "49751",

    ste_name: "MI",
  },
  {
    zip_code: "49793",

    ste_name: "MI",
  },
  {
    zip_code: "49799",

    ste_name: "MI",
  },
  {
    zip_code: "49822",

    ste_name: "MI",
  },
  {
    zip_code: "49885",

    ste_name: "MI",
  },
  {
    zip_code: "49935",

    ste_name: "MI",
  },
  {
    zip_code: "49946",

    ste_name: "MI",
  },
  {
    zip_code: "50044",

    ste_name: "IA",
  },
  {
    zip_code: "50258",

    ste_name: "IA",
  },
  {
    zip_code: "50324",

    ste_name: "IA",
  },
  {
    zip_code: "50451",

    ste_name: "IA",
  },
  {
    zip_code: "50464",

    ste_name: "IA",
  },
  {
    zip_code: "50529",

    ste_name: "IA",
  },
  {
    zip_code: "50574",

    ste_name: "IA",
  },
  {
    zip_code: "50621",

    ste_name: "IA",
  },
  {
    zip_code: "50634",

    ste_name: "IA",
  },
  {
    zip_code: "50665",

    ste_name: "IA",
  },
  {
    zip_code: "50670",

    ste_name: "IA",
  },
  {
    zip_code: "51009",

    ste_name: "IA",
  },
  {
    zip_code: "51232",

    ste_name: "IA",
  },
  {
    zip_code: "51240",

    ste_name: "IA",
  },
  {
    zip_code: "51351",

    ste_name: "IA",
  },
  {
    zip_code: "51445",

    ste_name: "IA",
  },
  {
    zip_code: "51448",

    ste_name: "IA",
  },
  {
    zip_code: "51531",

    ste_name: "IA",
  },
  {
    zip_code: "51549",

    ste_name: "IA",
  },
  {
    zip_code: "51563",

    ste_name: "IA",
  },
  {
    zip_code: "51575",

    ste_name: "IA",
  },
  {
    zip_code: "51647",

    ste_name: "IA",
  },
  {
    zip_code: "52158",

    ste_name: "IA",
  },
  {
    zip_code: "52163",

    ste_name: "IA",
  },
  {
    zip_code: "52166",

    ste_name: "IA",
  },
  {
    zip_code: "52314",

    ste_name: "IA",
  },
  {
    zip_code: "52403",

    ste_name: "IA",
  },
  {
    zip_code: "52573",

    ste_name: "IA",
  },
  {
    zip_code: "52574",

    ste_name: "IA",
  },
  {
    zip_code: "52644",

    ste_name: "IA",
  },
  {
    zip_code: "52656",

    ste_name: "IA",
  },
  {
    zip_code: "52701",

    ste_name: "IA",
  },
  {
    zip_code: "52732",

    ste_name: "IA",
  },
  {
    zip_code: "52738",

    ste_name: "IA",
  },
  {
    zip_code: "52749",

    ste_name: "IA",
  },
  {
    zip_code: "52767",

    ste_name: "IA",
  },
  {
    zip_code: "53105",

    ste_name: "WI",
  },
  {
    zip_code: "53108",

    ste_name: "WI",
  },
  {
    zip_code: "53170",

    ste_name: "WI",
  },
  {
    zip_code: "53537",

    ste_name: "WI",
  },
  {
    zip_code: "53716",

    ste_name: "WI",
  },
  {
    zip_code: "53941",

    ste_name: "WI",
  },
  {
    zip_code: "53950",

    ste_name: "WI",
  },
  {
    zip_code: "53953",

    ste_name: "WI",
  },
  {
    zip_code: "54110",

    ste_name: "WI",
  },
  {
    zip_code: "54150",

    ste_name: "WI",
  },
  {
    zip_code: "54160",

    ste_name: "WI",
  },
  {
    zip_code: "54170",

    ste_name: "WI",
  },
  {
    zip_code: "54217",

    ste_name: "WI",
  },
  {
    zip_code: "54228",

    ste_name: "WI",
  },
  {
    zip_code: "54407",

    ste_name: "WI",
  },
  {
    zip_code: "54512",

    ste_name: "WI",
  },
  {
    zip_code: "54531",

    ste_name: "WI",
  },
  {
    zip_code: "54560",

    ste_name: "WI",
  },
  {
    zip_code: "54631",

    ste_name: "WI",
  },
  {
    zip_code: "54747",

    ste_name: "WI",
  },
  {
    zip_code: "54766",

    ste_name: "WI",
  },
  {
    zip_code: "54819",

    ste_name: "WI",
  },
  {
    zip_code: "54935",

    ste_name: "WI",
  },
  {
    zip_code: "54942",

    ste_name: "WI",
  },
  {
    zip_code: "54952",

    ste_name: "WI",
  },
  {
    zip_code: "54974",

    ste_name: "WI",
  },
  {
    zip_code: "55044",

    ste_name: "MN",
  },
  {
    zip_code: "55052",

    ste_name: "MN",
  },
  {
    zip_code: "55072",

    ste_name: "MN",
  },
  {
    zip_code: "55104",

    ste_name: "MN",
  },
  {
    zip_code: "55310",

    ste_name: "MN",
  },
  {
    zip_code: "55614",

    ste_name: "MN",
  },
  {
    zip_code: "55722",

    ste_name: "MN",
  },
  {
    zip_code: "56045",

    ste_name: "MN",
  },
  {
    zip_code: "56156",

    ste_name: "MN",
  },
  {
    zip_code: "56181",

    ste_name: "MN",
  },
  {
    zip_code: "56255",

    ste_name: "MN",
  },
  {
    zip_code: "56260",

    ste_name: "MN",
  },
  {
    zip_code: "56285",

    ste_name: "MN",
  },
  {
    zip_code: "56331",

    ste_name: "MN",
  },
  {
    zip_code: "56376",

    ste_name: "MN",
  },
  {
    zip_code: "56434",

    ste_name: "MN",
  },
  {
    zip_code: "56436",

    ste_name: "MN",
  },
  {
    zip_code: "56442",

    ste_name: "MN",
  },
  {
    zip_code: "56525",

    ste_name: "MN",
  },
  {
    zip_code: "56533",

    ste_name: "MN",
  },
  {
    zip_code: "56571",

    ste_name: "MN",
  },
  {
    zip_code: "56652",

    ste_name: "MN",
  },
  {
    zip_code: "56731",

    ste_name: "MN",
  },
  {
    zip_code: "56750",

    ste_name: "MN",
  },
  {
    zip_code: "57002",

    ste_name: "SD",
  },
  {
    zip_code: "57014",

    ste_name: "SD",
  },
  {
    zip_code: "57031",

    ste_name: "SD",
  },
  {
    zip_code: "57046",

    ste_name: "SD",
  },
  {
    zip_code: "57104",

    ste_name: "SD",
  },
  {
    zip_code: "57107",

    ste_name: "SD",
  },
  {
    zip_code: "57258",

    ste_name: "SD",
  },
  {
    zip_code: "57268",

    ste_name: "SD",
  },
  {
    zip_code: "57479",

    ste_name: "SD",
  },
  {
    zip_code: "57520",

    ste_name: "SD",
  },
  {
    zip_code: "57572",

    ste_name: "SD",
  },
  {
    zip_code: "57656",

    ste_name: "SD",
  },
  {
    zip_code: "58077",

    ste_name: "ND",
  },
  {
    zip_code: "58079",

    ste_name: "ND",
  },
  {
    zip_code: "58238",

    ste_name: "ND",
  },
  {
    zip_code: "58256",

    ste_name: "ND",
  },
  {
    zip_code: "58262",

    ste_name: "ND",
  },
  {
    zip_code: "58327",

    ste_name: "ND",
  },
  {
    zip_code: "58382",

    ste_name: "ND",
  },
  {
    zip_code: "58421",

    ste_name: "ND",
  },
  {
    zip_code: "58532",

    ste_name: "ND",
  },
  {
    zip_code: "58571",

    ste_name: "ND",
  },
  {
    zip_code: "58576",

    ste_name: "ND",
  },
  {
    zip_code: "58577",

    ste_name: "ND",
  },
  {
    zip_code: "58622",

    ste_name: "ND",
  },
  {
    zip_code: "58630",

    ste_name: "ND",
  },
  {
    zip_code: "58713",

    ste_name: "ND",
  },
  {
    zip_code: "653",

    ste_name: "PR",
  },
  {
    zip_code: "656",

    ste_name: "PR",
  },
  {
    zip_code: "687",

    ste_name: "PR",
  },
  {
    zip_code: "729",

    ste_name: "PR",
  },
  {
    zip_code: "731",

    ste_name: "PR",
  },
  {
    zip_code: "775",

    ste_name: "PR",
  },
  {
    zip_code: "950",

    ste_name: "PR",
  },
  {
    zip_code: "1040",

    ste_name: "MA",
  },
  {
    zip_code: "1062",

    ste_name: "MA",
  },
  {
    zip_code: "1229",

    ste_name: "MA",
  },
  {
    zip_code: "1245",

    ste_name: "MA",
  },
  {
    zip_code: "1346",

    ste_name: "MA",
  },
  {
    zip_code: "1364",

    ste_name: "MA",
  },
  {
    zip_code: "1430",

    ste_name: "MA",
  },
  {
    zip_code: "1515",

    ste_name: "MA",
  },
  {
    zip_code: "1516",

    ste_name: "MA",
  },
  {
    zip_code: "1569",

    ste_name: "MA",
  },
  {
    zip_code: "1850",

    ste_name: "MA",
  },
  {
    zip_code: "1929",

    ste_name: "MA",
  },
  {
    zip_code: "2066",

    ste_name: "MA",
  },
  {
    zip_code: "2114",

    ste_name: "MA",
  },
  {
    zip_code: "2189",

    ste_name: "MA",
  },
  {
    zip_code: "2324",

    ste_name: "MA",
  },
  {
    zip_code: "2347",

    ste_name: "MA",
  },
  {
    zip_code: "2453",

    ste_name: "MA",
  },
  {
    zip_code: "2468",

    ste_name: "MA",
  },
  {
    zip_code: "2637",

    ste_name: "MA",
  },
  {
    zip_code: "2650",

    ste_name: "MA",
  },
  {
    zip_code: "2664",

    ste_name: "MA",
  },
  {
    zip_code: "2817",

    ste_name: "RI",
  },
  {
    zip_code: "2825",

    ste_name: "RI",
  },
  {
    zip_code: "2885",

    ste_name: "RI",
  },
  {
    zip_code: "2889",

    ste_name: "RI",
  },
  {
    zip_code: "3242",

    ste_name: "NH",
  },
  {
    zip_code: "3284",

    ste_name: "NH",
  },
  {
    zip_code: "3458",

    ste_name: "NH",
  },
  {
    zip_code: "3605",

    ste_name: "NH",
  },
  {
    zip_code: "3608",

    ste_name: "NH",
  },
  {
    zip_code: "3784",

    ste_name: "NH",
  },
  {
    zip_code: "3835",

    ste_name: "NH",
  },
  {
    zip_code: "3850",

    ste_name: "NH",
  },
  {
    zip_code: "4046",

    ste_name: "ME",
  },
  {
    zip_code: "4255",

    ste_name: "ME",
  },
  {
    zip_code: "4355",

    ste_name: "ME",
  },
  {
    zip_code: "4411",

    ste_name: "ME",
  },
  {
    zip_code: "4448",

    ste_name: "ME",
  },
  {
    zip_code: "4493",

    ste_name: "ME",
  },
  {
    zip_code: "4548",

    ste_name: "ME",
  },
  {
    zip_code: "4568",

    ste_name: "ME",
  },
  {
    zip_code: "4609",

    ste_name: "ME",
  },
  {
    zip_code: "4626",

    ste_name: "ME",
  },
  {
    zip_code: "4631",

    ste_name: "ME",
  },
  {
    zip_code: "4694",

    ste_name: "ME",
  },
  {
    zip_code: "4760",

    ste_name: "ME",
  },
  {
    zip_code: "4854",

    ste_name: "ME",
  },
  {
    zip_code: "4856",

    ste_name: "ME",
  },
  {
    zip_code: "4961",

    ste_name: "ME",
  },
  {
    zip_code: "4962",

    ste_name: "ME",
  },
  {
    zip_code: "5040",

    ste_name: "VT",
  },
  {
    zip_code: "5053",

    ste_name: "VT",
  },
  {
    zip_code: "5150",

    ste_name: "VT",
  },
  {
    zip_code: "5492",

    ste_name: "VT",
  },
  {
    zip_code: "5649",

    ste_name: "VT",
  },
  {
    zip_code: "5762",

    ste_name: "VT",
  },
  {
    zip_code: "5763",

    ste_name: "VT",
  },
  {
    zip_code: "5867",

    ste_name: "VT",
  },
  {
    zip_code: "5907",

    ste_name: "VT",
  },
  {
    zip_code: "6001",

    ste_name: "CT",
  },
  {
    zip_code: "6031",

    ste_name: "CT",
  },
  {
    zip_code: "6084",

    ste_name: "CT",
  },
  {
    zip_code: "6119",

    ste_name: "CT",
  },
  {
    zip_code: "6333",

    ste_name: "CT",
  },
  {
    zip_code: "6403",

    ste_name: "CT",
  },
  {
    zip_code: "6441",

    ste_name: "CT",
  },
  {
    zip_code: "6798",

    ste_name: "CT",
  },
  {
    zip_code: "7043",

    ste_name: "NJ",
  },
  {
    zip_code: "7045",

    ste_name: "NJ",
  },
  {
    zip_code: "7204",

    ste_name: "NJ",
  },
  {
    zip_code: "7418",

    ste_name: "NJ",
  },
  {
    zip_code: "7458",

    ste_name: "NJ",
  },
  {
    zip_code: "7646",

    ste_name: "NJ",
  },
  {
    zip_code: "7647",

    ste_name: "NJ",
  },
  {
    zip_code: "7662",

    ste_name: "NJ",
  },
  {
    zip_code: "7723",

    ste_name: "NJ",
  },
  {
    zip_code: "7728",

    ste_name: "NJ",
  },
  {
    zip_code: "7755",

    ste_name: "NJ",
  },
  {
    zip_code: "7842",

    ste_name: "NJ",
  },
  {
    zip_code: "7931",

    ste_name: "NJ",
  },
  {
    zip_code: "8001",

    ste_name: "NJ",
  },
  {
    zip_code: "8075",

    ste_name: "NJ",
  },
  {
    zip_code: "8201",

    ste_name: "NJ",
  },
  {
    zip_code: "8321",

    ste_name: "NJ",
  },
  {
    zip_code: "8327",

    ste_name: "NJ",
  },
  {
    zip_code: "8332",

    ste_name: "NJ",
  },
  {
    zip_code: "8360",

    ste_name: "NJ",
  },
  {
    zip_code: "8553",

    ste_name: "NJ",
  },
  {
    zip_code: "8619",

    ste_name: "NJ",
  },
  {
    zip_code: "8732",

    ste_name: "NJ",
  },
  {
    zip_code: "8817",

    ste_name: "NJ",
  },
  {
    zip_code: "8824",

    ste_name: "NJ",
  },
  {
    zip_code: "8827",

    ste_name: "NJ",
  },
  {
    zip_code: "8836",

    ste_name: "NJ",
  },
  {
    zip_code: "8884",

    ste_name: "NJ",
  },
  {
    zip_code: "10012",

    ste_name: "NY",
  },
  {
    zip_code: "10110",

    ste_name: "NY",
  },
  {
    zip_code: "10165",

    ste_name: "NY",
  },
  {
    zip_code: "10304",

    ste_name: "NY",
  },
  {
    zip_code: "10457",

    ste_name: "NY",
  },
  {
    zip_code: "10560",

    ste_name: "NY",
  },
  {
    zip_code: "10923",

    ste_name: "NY",
  },
  {
    zip_code: "10930",

    ste_name: "NY",
  },
  {
    zip_code: "10950",

    ste_name: "NY",
  },
  {
    zip_code: "11372",

    ste_name: "NY",
  },
  {
    zip_code: "11560",

    ste_name: "NY",
  },
  {
    zip_code: "11577",

    ste_name: "NY",
  },
  {
    zip_code: "11590",

    ste_name: "NY",
  },
  {
    zip_code: "11795",

    ste_name: "NY",
  },
  {
    zip_code: "11934",

    ste_name: "NY",
  },
  {
    zip_code: "11964",

    ste_name: "NY",
  },
  {
    zip_code: "11967",

    ste_name: "NY",
  },
  {
    zip_code: "11980",

    ste_name: "NY",
  },
  {
    zip_code: "12008",

    ste_name: "NY",
  },
  {
    zip_code: "12020",

    ste_name: "NY",
  },
  {
    zip_code: "12025",

    ste_name: "NY",
  },
  {
    zip_code: "12147",

    ste_name: "NY",
  },
  {
    zip_code: "12202",

    ste_name: "NY",
  },
  {
    zip_code: "12211",

    ste_name: "NY",
  },
  {
    zip_code: "12434",

    ste_name: "NY",
  },
  {
    zip_code: "12436",

    ste_name: "NY",
  },
  {
    zip_code: "12448",

    ste_name: "NY",
  },
  {
    zip_code: "12455",

    ste_name: "NY",
  },
  {
    zip_code: "12465",

    ste_name: "NY",
  },
  {
    zip_code: "12523",

    ste_name: "NY",
  },
  {
    zip_code: "12533",

    ste_name: "NY",
  },
  {
    zip_code: "12572",

    ste_name: "NY",
  },
  {
    zip_code: "12580",

    ste_name: "NY",
  },
  {
    zip_code: "12592",

    ste_name: "NY",
  },
  {
    zip_code: "12760",

    ste_name: "NY",
  },
  {
    zip_code: "12801",

    ste_name: "NY",
  },
  {
    zip_code: "12832",

    ste_name: "NY",
  },
  {
    zip_code: "12842",

    ste_name: "NY",
  },
  {
    zip_code: "12860",

    ste_name: "NY",
  },
  {
    zip_code: "12958",

    ste_name: "NY",
  },
  {
    zip_code: "12979",

    ste_name: "NY",
  },
  {
    zip_code: "12985",

    ste_name: "NY",
  },
  {
    zip_code: "13039",

    ste_name: "NY",
  },
  {
    zip_code: "13090",

    ste_name: "NY",
  },
  {
    zip_code: "13219",

    ste_name: "NY",
  },
  {
    zip_code: "13341",

    ste_name: "NY",
  },
  {
    zip_code: "13411",

    ste_name: "NY",
  },
  {
    zip_code: "13436",

    ste_name: "NY",
  },
  {
    zip_code: "13475",

    ste_name: "NY",
  },
  {
    zip_code: "13606",

    ste_name: "NY",
  },
  {
    zip_code: "13616",

    ste_name: "NY",
  },
  {
    zip_code: "13643",

    ste_name: "NY",
  },
  {
    zip_code: "13655",

    ste_name: "NY",
  },
  {
    zip_code: "13670",

    ste_name: "NY",
  },
  {
    zip_code: "13807",

    ste_name: "NY",
  },
  {
    zip_code: "14091",

    ste_name: "NY",
  },
  {
    zip_code: "14510",

    ste_name: "NY",
  },
  {
    zip_code: "14511",

    ste_name: "NY",
  },
  {
    zip_code: "14560",

    ste_name: "NY",
  },
  {
    zip_code: "14592",

    ste_name: "NY",
  },
  {
    zip_code: "14616",

    ste_name: "NY",
  },
  {
    zip_code: "14624",

    ste_name: "NY",
  },
  {
    zip_code: "14726",

    ste_name: "NY",
  },
  {
    zip_code: "14738",

    ste_name: "NY",
  },
  {
    zip_code: "14815",

    ste_name: "NY",
  },
  {
    zip_code: "14826",

    ste_name: "NY",
  },
  {
    zip_code: "15034",

    ste_name: "PA",
  },
  {
    zip_code: "15038",

    ste_name: "PA",
  },
  {
    zip_code: "15052",

    ste_name: "PA",
  },
  {
    zip_code: "15057",

    ste_name: "PA",
  },
  {
    zip_code: "15222",

    ste_name: "PA",
  },
  {
    zip_code: "15226",

    ste_name: "PA",
  },
  {
    zip_code: "15290",

    ste_name: "PA",
  },
  {
    zip_code: "15437",

    ste_name: "PA",
  },
  {
    zip_code: "15455",

    ste_name: "PA",
  },
  {
    zip_code: "15522",

    ste_name: "PA",
  },
  {
    zip_code: "15560",

    ste_name: "PA",
  },
  {
    zip_code: "15632",

    ste_name: "PA",
  },
  {
    zip_code: "15638",

    ste_name: "PA",
  },
  {
    zip_code: "15642",

    ste_name: "PA",
  },
  {
    zip_code: "15663",

    ste_name: "PA",
  },
  {
    zip_code: "15683",

    ste_name: "PA",
  },
  {
    zip_code: "15691",

    ste_name: "PA",
  },
  {
    zip_code: "15781",

    ste_name: "PA",
  },
  {
    zip_code: "15905",

    ste_name: "PA",
  },
  {
    zip_code: "15921",

    ste_name: "PA",
  },
  {
    zip_code: "16112",

    ste_name: "PA",
  },
  {
    zip_code: "16116",

    ste_name: "PA",
  },
  {
    zip_code: "16254",

    ste_name: "PA",
  },
  {
    zip_code: "16263",

    ste_name: "PA",
  },
  {
    zip_code: "16340",

    ste_name: "PA",
  },
  {
    zip_code: "16351",

    ste_name: "PA",
  },
  {
    zip_code: "16613",

    ste_name: "PA",
  },
  {
    zip_code: "16731",

    ste_name: "PA",
  },
  {
    zip_code: "16801",

    ste_name: "PA",
  },
  {
    zip_code: "16837",

    ste_name: "PA",
  },
  {
    zip_code: "16855",

    ste_name: "PA",
  },
  {
    zip_code: "16878",

    ste_name: "PA",
  },
  {
    zip_code: "16882",

    ste_name: "PA",
  },
  {
    zip_code: "16933",

    ste_name: "PA",
  },
  {
    zip_code: "17005",

    ste_name: "PA",
  },
  {
    zip_code: "17039",

    ste_name: "PA",
  },
  {
    zip_code: "17090",

    ste_name: "PA",
  },
  {
    zip_code: "17104",

    ste_name: "PA",
  },
  {
    zip_code: "17211",

    ste_name: "PA",
  },
  {
    zip_code: "17212",

    ste_name: "PA",
  },
  {
    zip_code: "17225",

    ste_name: "PA",
  },
  {
    zip_code: "17361",

    ste_name: "PA",
  },
  {
    zip_code: "17365",

    ste_name: "PA",
  },
  {
    zip_code: "17509",

    ste_name: "PA",
  },
  {
    zip_code: "17529",

    ste_name: "PA",
  },
  {
    zip_code: "17727",

    ste_name: "PA",
  },
  {
    zip_code: "17763",

    ste_name: "PA",
  },
  {
    zip_code: "17941",

    ste_name: "PA",
  },
  {
    zip_code: "17965",

    ste_name: "PA",
  },
  {
    zip_code: "17985",

    ste_name: "PA",
  },
  {
    zip_code: "18321",

    ste_name: "PA",
  },
  {
    zip_code: "18405",

    ste_name: "PA",
  },
  {
    zip_code: "18417",

    ste_name: "PA",
  },
  {
    zip_code: "18433",

    ste_name: "PA",
  },
  {
    zip_code: "18443",

    ste_name: "PA",
  },
  {
    zip_code: "18512",

    ste_name: "PA",
  },
  {
    zip_code: "18617",

    ste_name: "PA",
  },
  {
    zip_code: "18848",

    ste_name: "PA",
  },
  {
    zip_code: "18915",

    ste_name: "PA",
  },
  {
    zip_code: "18938",

    ste_name: "PA",
  },
  {
    zip_code: "18944",

    ste_name: "PA",
  },
  {
    zip_code: "18970",

    ste_name: "PA",
  },
  {
    zip_code: "18980",

    ste_name: "PA",
  },
  {
    zip_code: "19043",

    ste_name: "PA",
  },
  {
    zip_code: "19075",

    ste_name: "PA",
  },
  {
    zip_code: "19109",

    ste_name: "PA",
  },
  {
    zip_code: "19341",

    ste_name: "PA",
  },
  {
    zip_code: "19375",

    ste_name: "PA",
  },
  {
    zip_code: "19731",

    ste_name: "DE",
  },
  {
    zip_code: "19902",

    ste_name: "DE",
  },
  {
    zip_code: "19946",

    ste_name: "DE",
  },
  {
    zip_code: "20007",

    ste_name: "DC",
  },
  {
    zip_code: "20024",

    ste_name: "DC",
  },
  {
    zip_code: "20228",

    ste_name: "DC",
  },
  {
    zip_code: "20418",

    ste_name: "DC",
  },
  {
    zip_code: "20706",

    ste_name: "MD",
  },
  {
    zip_code: "20742",

    ste_name: "MD",
  },
  {
    zip_code: "20783",

    ste_name: "MD",
  },
  {
    zip_code: "20906",

    ste_name: "MD",
  },
  {
    zip_code: "21036",

    ste_name: "MD",
  },
  {
    zip_code: "21037",

    ste_name: "MD",
  },
  {
    zip_code: "21163",

    ste_name: "MD",
  },
  {
    zip_code: "21210",

    ste_name: "MD",
  },
  {
    zip_code: "21216",

    ste_name: "MD",
  },
  {
    zip_code: "21218",

    ste_name: "MD",
  },
  {
    zip_code: "21542",

    ste_name: "MD",
  },
  {
    zip_code: "21632",

    ste_name: "MD",
  },
  {
    zip_code: "21704",

    ste_name: "MD",
  },
  {
    zip_code: "21754",

    ste_name: "MD",
  },
  {
    zip_code: "21851",

    ste_name: "MD",
  },
  {
    zip_code: "21856",

    ste_name: "MD",
  },
  {
    zip_code: "22709",

    ste_name: "VA",
  },
  {
    zip_code: "58771",

    ste_name: "ND",
  },
  {
    zip_code: "58845",

    ste_name: "ND",
  },
  {
    zip_code: "58847",

    ste_name: "ND",
  },
  {
    zip_code: "59034",

    ste_name: "MT",
  },
  {
    zip_code: "59052",

    ste_name: "MT",
  },
  {
    zip_code: "59076",

    ste_name: "MT",
  },
  {
    zip_code: "59260",

    ste_name: "MT",
  },
  {
    zip_code: "59318",

    ste_name: "MT",
  },
  {
    zip_code: "59436",

    ste_name: "MT",
  },
  {
    zip_code: "59501",

    ste_name: "MT",
  },
  {
    zip_code: "59749",

    ste_name: "MT",
  },
  {
    zip_code: "59758",

    ste_name: "MT",
  },
  {
    zip_code: "59802",

    ste_name: "MT",
  },
  {
    zip_code: "59854",

    ste_name: "MT",
  },
  {
    zip_code: "59858",

    ste_name: "MT",
  },
  {
    zip_code: "59864",

    ste_name: "MT",
  },
  {
    zip_code: "59913",

    ste_name: "MT",
  },
  {
    zip_code: "59915",

    ste_name: "MT",
  },
  {
    zip_code: "60115",

    ste_name: "IL",
  },
  {
    zip_code: "60120",

    ste_name: "IL",
  },
  {
    zip_code: "60172",

    ste_name: "IL",
  },
  {
    zip_code: "60440",

    ste_name: "IL",
  },
  {
    zip_code: "60481",

    ste_name: "IL",
  },
  {
    zip_code: "60490",

    ste_name: "IL",
  },
  {
    zip_code: "60505",

    ste_name: "IL",
  },
  {
    zip_code: "60520",

    ste_name: "IL",
  },
  {
    zip_code: "60537",

    ste_name: "IL",
  },
  {
    zip_code: "60564",

    ste_name: "IL",
  },
  {
    zip_code: "60613",

    ste_name: "IL",
  },
  {
    zip_code: "60622",

    ste_name: "IL",
  },
  {
    zip_code: "60639",

    ste_name: "IL",
  },
  {
    zip_code: "60646",

    ste_name: "IL",
  },
  {
    zip_code: "60924",

    ste_name: "IL",
  },
  {
    zip_code: "61073",

    ste_name: "IL",
  },
  {
    zip_code: "61311",

    ste_name: "IL",
  },
  {
    zip_code: "61336",

    ste_name: "IL",
  },
  {
    zip_code: "61435",

    ste_name: "IL",
  },
  {
    zip_code: "61471",

    ste_name: "IL",
  },
  {
    zip_code: "61488",

    ste_name: "IL",
  },
  {
    zip_code: "61523",

    ste_name: "IL",
  },
  {
    zip_code: "61532",

    ste_name: "IL",
  },
  {
    zip_code: "61536",

    ste_name: "IL",
  },
  {
    zip_code: "61561",

    ste_name: "IL",
  },
  {
    zip_code: "61565",

    ste_name: "IL",
  },
  {
    zip_code: "61739",

    ste_name: "IL",
  },
  {
    zip_code: "61756",

    ste_name: "IL",
  },
  {
    zip_code: "61811",

    ste_name: "IL",
  },
  {
    zip_code: "61941",

    ste_name: "IL",
  },
  {
    zip_code: "62044",

    ste_name: "IL",
  },
  {
    zip_code: "62065",

    ste_name: "IL",
  },
  {
    zip_code: "62069",

    ste_name: "IL",
  },
  {
    zip_code: "62087",

    ste_name: "IL",
  },
  {
    zip_code: "62207",

    ste_name: "IL",
  },
  {
    zip_code: "62220",

    ste_name: "IL",
  },
  {
    zip_code: "62221",

    ste_name: "IL",
  },
  {
    zip_code: "62249",

    ste_name: "IL",
  },
  {
    zip_code: "62263",

    ste_name: "IL",
  },
  {
    zip_code: "62293",

    ste_name: "IL",
  },
  {
    zip_code: "62294",

    ste_name: "IL",
  },
  {
    zip_code: "62360",

    ste_name: "IL",
  },
  {
    zip_code: "62361",

    ste_name: "IL",
  },
  {
    zip_code: "62521",

    ste_name: "IL",
  },
  {
    zip_code: "62539",

    ste_name: "IL",
  },
  {
    zip_code: "62568",

    ste_name: "IL",
  },
  {
    zip_code: "62628",

    ste_name: "IL",
  },
  {
    zip_code: "62639",

    ste_name: "IL",
  },
  {
    zip_code: "62664",

    ste_name: "IL",
  },
  {
    zip_code: "62703",

    ste_name: "IL",
  },
  {
    zip_code: "62959",

    ste_name: "IL",
  },
  {
    zip_code: "63017",

    ste_name: "MO",
  },
  {
    zip_code: "63088",

    ste_name: "MO",
  },
  {
    zip_code: "63138",

    ste_name: "MO",
  },
  {
    zip_code: "63155",

    ste_name: "MO",
  },
  {
    zip_code: "63430",

    ste_name: "MO",
  },
  {
    zip_code: "63451",

    ste_name: "MO",
  },
  {
    zip_code: "63472",

    ste_name: "MO",
  },
  {
    zip_code: "63544",

    ste_name: "MO",
  },
  {
    zip_code: "63557",

    ste_name: "MO",
  },
  {
    zip_code: "63675",

    ste_name: "MO",
  },
  {
    zip_code: "63738",

    ste_name: "MO",
  },
  {
    zip_code: "63739",

    ste_name: "MO",
  },
  {
    zip_code: "63833",

    ste_name: "MO",
  },
  {
    zip_code: "63853",

    ste_name: "MO",
  },
  {
    zip_code: "63878",

    ste_name: "MO",
  },
  {
    zip_code: "64015",

    ste_name: "MO",
  },
  {
    zip_code: "64016",

    ste_name: "MO",
  },
  {
    zip_code: "64071",

    ste_name: "MO",
  },
  {
    zip_code: "64108",

    ste_name: "MO",
  },
  {
    zip_code: "64130",

    ste_name: "MO",
  },
  {
    zip_code: "64145",

    ste_name: "MO",
  },
  {
    zip_code: "64150",

    ste_name: "MO",
  },
  {
    zip_code: "64442",

    ste_name: "MO",
  },
  {
    zip_code: "64506",

    ste_name: "MO",
  },
  {
    zip_code: "64623",

    ste_name: "MO",
  },
  {
    zip_code: "64633",

    ste_name: "MO",
  },
  {
    zip_code: "64655",

    ste_name: "MO",
  },
  {
    zip_code: "64668",

    ste_name: "MO",
  },
  {
    zip_code: "64720",

    ste_name: "MO",
  },
  {
    zip_code: "64771",

    ste_name: "MO",
  },
  {
    zip_code: "64784",

    ste_name: "MO",
  },
  {
    zip_code: "64830",

    ste_name: "MO",
  },
  {
    zip_code: "64847",

    ste_name: "MO",
  },
  {
    zip_code: "64857",

    ste_name: "MO",
  },
  {
    zip_code: "64870",

    ste_name: "MO",
  },
  {
    zip_code: "65048",

    ste_name: "MO",
  },
  {
    zip_code: "65246",

    ste_name: "MO",
  },
  {
    zip_code: "65263",

    ste_name: "MO",
  },
  {
    zip_code: "65283",

    ste_name: "MO",
  },
  {
    zip_code: "65322",

    ste_name: "MO",
  },
  {
    zip_code: "65552",

    ste_name: "MO",
  },
  {
    zip_code: "65567",

    ste_name: "MO",
  },
  {
    zip_code: "65605",

    ste_name: "MO",
  },
  {
    zip_code: "65614",

    ste_name: "MO",
  },
  {
    zip_code: "65617",

    ste_name: "MO",
  },
  {
    zip_code: "65708",

    ste_name: "MO",
  },
  {
    zip_code: "65739",

    ste_name: "MO",
  },
  {
    zip_code: "65810",

    ste_name: "MO",
  },
  {
    zip_code: "66049",

    ste_name: "KS",
  },
  {
    zip_code: "66070",

    ste_name: "KS",
  },
  {
    zip_code: "66078",

    ste_name: "KS",
  },
  {
    zip_code: "66102",

    ste_name: "KS",
  },
  {
    zip_code: "66407",

    ste_name: "KS",
  },
  {
    zip_code: "66539",

    ste_name: "KS",
  },
  {
    zip_code: "66543",

    ste_name: "KS",
  },
  {
    zip_code: "66732",

    ste_name: "KS",
  },
  {
    zip_code: "67021",

    ste_name: "KS",
  },
  {
    zip_code: "67050",

    ste_name: "KS",
  },
  {
    zip_code: "67053",

    ste_name: "KS",
  },
  {
    zip_code: "67101",

    ste_name: "KS",
  },
  {
    zip_code: "67124",

    ste_name: "KS",
  },
  {
    zip_code: "67210",

    ste_name: "KS",
  },
  {
    zip_code: "67217",

    ste_name: "KS",
  },
  {
    zip_code: "67341",

    ste_name: "KS",
  },
  {
    zip_code: "67346",

    ste_name: "KS",
  },
  {
    zip_code: "67410",

    ste_name: "KS",
  },
  {
    zip_code: "67482",

    ste_name: "KS",
  },
  {
    zip_code: "67584",

    ste_name: "KS",
  },
  {
    zip_code: "67739",

    ste_name: "KS",
  },
  {
    zip_code: "67743",

    ste_name: "KS",
  },
  {
    zip_code: "67756",

    ste_name: "KS",
  },
  {
    zip_code: "67840",

    ste_name: "KS",
  },
  {
    zip_code: "67851",

    ste_name: "KS",
  },
  {
    zip_code: "68042",

    ste_name: "NE",
  },
  {
    zip_code: "68050",

    ste_name: "NE",
  },
  {
    zip_code: "68316",

    ste_name: "NE",
  },
  {
    zip_code: "68409",

    ste_name: "NE",
  },
  {
    zip_code: "68510",

    ste_name: "NE",
  },
  {
    zip_code: "68531",

    ste_name: "NE",
  },
  {
    zip_code: "68637",

    ste_name: "NE",
  },
  {
    zip_code: "68649",

    ste_name: "NE",
  },
  {
    zip_code: "68659",

    ste_name: "NE",
  },
  {
    zip_code: "68727",

    ste_name: "NE",
  },
  {
    zip_code: "68732",

    ste_name: "NE",
  },
  {
    zip_code: "68767",

    ste_name: "NE",
  },
  {
    zip_code: "68770",

    ste_name: "NE",
  },
  {
    zip_code: "68863",

    ste_name: "NE",
  },
  {
    zip_code: "68866",

    ste_name: "NE",
  },
  {
    zip_code: "68957",

    ste_name: "NE",
  },
  {
    zip_code: "69036",

    ste_name: "NE",
  },
  {
    zip_code: "69040",

    ste_name: "NE",
  },
  {
    zip_code: "69335",

    ste_name: "NE",
  },
  {
    zip_code: "69361",

    ste_name: "NE",
  },
  {
    zip_code: "69365",

    ste_name: "NE",
  },
  {
    zip_code: "70344",

    ste_name: "LA",
  },
  {
    zip_code: "70436",

    ste_name: "LA",
  },
  {
    zip_code: "70524",

    ste_name: "LA",
  },
  {
    zip_code: "70544",

    ste_name: "LA",
  },
  {
    zip_code: "70723",

    ste_name: "LA",
  },
  {
    zip_code: "70785",

    ste_name: "LA",
  },
  {
    zip_code: "71004",

    ste_name: "LA",
  },
  {
    zip_code: "71027",

    ste_name: "LA",
  },
  {
    zip_code: "71268",

    ste_name: "LA",
  },
  {
    zip_code: "71322",

    ste_name: "LA",
  },
  {
    zip_code: "71328",

    ste_name: "LA",
  },
  {
    zip_code: "71331",

    ste_name: "LA",
  },
  {
    zip_code: "71368",

    ste_name: "LA",
  },
  {
    zip_code: "71429",

    ste_name: "LA",
  },
  {
    zip_code: "71726",

    ste_name: "AR",
  },
  {
    zip_code: "71753",

    ste_name: "AR",
  },
  {
    zip_code: "71772",

    ste_name: "AR",
  },
  {
    zip_code: "71839",

    ste_name: "AR",
  },
  {
    zip_code: "71842",

    ste_name: "AR",
  },
  {
    zip_code: "71847",

    ste_name: "AR",
  },
  {
    zip_code: "71866",

    ste_name: "AR",
  },
  {
    zip_code: "71950",

    ste_name: "AR",
  },
  {
    zip_code: "71962",

    ste_name: "AR",
  },
  {
    zip_code: "72010",

    ste_name: "AR",
  },
  {
    zip_code: "72016",

    ste_name: "AR",
  },
  {
    zip_code: "72047",

    ste_name: "AR",
  },
  {
    zip_code: "72076",

    ste_name: "AR",
  },
  {
    zip_code: "72110",

    ste_name: "AR",
  },
  {
    zip_code: "72160",

    ste_name: "AR",
  },
  {
    zip_code: "72329",

    ste_name: "AR",
  },
  {
    zip_code: "72335",

    ste_name: "AR",
  },
  {
    zip_code: "72424",

    ste_name: "AR",
  },
  {
    zip_code: "72432",

    ste_name: "AR",
  },
  {
    zip_code: "72501",

    ste_name: "AR",
  },
  {
    zip_code: "72526",

    ste_name: "AR",
  },
  {
    zip_code: "72546",

    ste_name: "AR",
  },
  {
    zip_code: "72680",

    ste_name: "AR",
  },
  {
    zip_code: "72729",

    ste_name: "AR",
  },
  {
    zip_code: "72764",

    ste_name: "AR",
  },
  {
    zip_code: "72846",

    ste_name: "AR",
  },
  {
    zip_code: "72935",

    ste_name: "AR",
  },
  {
    zip_code: "72940",

    ste_name: "AR",
  },
  {
    zip_code: "72944",

    ste_name: "AR",
  },
  {
    zip_code: "72947",

    ste_name: "AR",
  },
  {
    zip_code: "73014",

    ste_name: "OK",
  },
  {
    zip_code: "73016",

    ste_name: "OK",
  },
  {
    zip_code: "73026",

    ste_name: "OK",
  },
  {
    zip_code: "73065",

    ste_name: "OK",
  },
  {
    zip_code: "73069",

    ste_name: "OK",
  },
  {
    zip_code: "73110",

    ste_name: "OK",
  },
  {
    zip_code: "73150",

    ste_name: "OK",
  },
  {
    zip_code: "73160",

    ste_name: "OK",
  },
  {
    zip_code: "73736",

    ste_name: "OK",
  },
  {
    zip_code: "73737",

    ste_name: "OK",
  },
  {
    zip_code: "73758",

    ste_name: "OK",
  },
  {
    zip_code: "73771",

    ste_name: "OK",
  },
  {
    zip_code: "73945",

    ste_name: "OK",
  },
  {
    zip_code: "74001",

    ste_name: "OK",
  },
  {
    zip_code: "74019",

    ste_name: "OK",
  },
  {
    zip_code: "74059",

    ste_name: "OK",
  },
  {
    zip_code: "74060",

    ste_name: "OK",
  },
  {
    zip_code: "74108",

    ste_name: "OK",
  },
  {
    zip_code: "74110",

    ste_name: "OK",
  },
  {
    zip_code: "74340",

    ste_name: "OK",
  },
  {
    zip_code: "74501",

    ste_name: "OK",
  },
  {
    zip_code: "74641",

    ste_name: "OK",
  },
  {
    zip_code: "74733",

    ste_name: "OK",
  },
  {
    zip_code: "74760",

    ste_name: "OK",
  },
  {
    zip_code: "74855",

    ste_name: "OK",
  },
  {
    zip_code: "74901",

    ste_name: "OK",
  },
  {
    zip_code: "74964",

    ste_name: "OK",
  },
  {
    zip_code: "75025",

    ste_name: "TX",
  },
  {
    zip_code: "75039",

    ste_name: "TX",
  },
  {
    zip_code: "75115",

    ste_name: "TX",
  },
  {
    zip_code: "75143",

    ste_name: "TX",
  },
  {
    zip_code: "75156",

    ste_name: "TX",
  },
  {
    zip_code: "75219",

    ste_name: "TX",
  },
  {
    zip_code: "75243",

    ste_name: "TX",
  },
  {
    zip_code: "75435",

    ste_name: "TX",
  },
  {
    zip_code: "75469",

    ste_name: "TX",
  },
  {
    zip_code: "75555",

    ste_name: "TX",
  },
  {
    zip_code: "75651",

    ste_name: "TX",
  },
  {
    zip_code: "75686",

    ste_name: "TX",
  },
  {
    zip_code: "75691",

    ste_name: "TX",
  },
  {
    zip_code: "75707",

    ste_name: "TX",
  },
  {
    zip_code: "75708",

    ste_name: "TX",
  },
  {
    zip_code: "75751",

    ste_name: "TX",
  },
  {
    zip_code: "75752",

    ste_name: "TX",
  },
  {
    zip_code: "75760",

    ste_name: "TX",
  },
  {
    zip_code: "75835",

    ste_name: "TX",
  },
  {
    zip_code: "75861",

    ste_name: "TX",
  },
  {
    zip_code: "75928",

    ste_name: "TX",
  },
  {
    zip_code: "75929",

    ste_name: "TX",
  },
  {
    zip_code: "76233",

    ste_name: "TX",
  },
  {
    zip_code: "76264",

    ste_name: "TX",
  },
  {
    zip_code: "76388",

    ste_name: "TX",
  },
  {
    zip_code: "76453",

    ste_name: "TX",
  },
  {
    zip_code: "76474",

    ste_name: "TX",
  },
  {
    zip_code: "76557",

    ste_name: "TX",
  },
  {
    zip_code: "76665",

    ste_name: "TX",
  },
  {
    zip_code: "76705",

    ste_name: "TX",
  },
  {
    zip_code: "76937",

    ste_name: "TX",
  },
  {
    zip_code: "77076",

    ste_name: "TX",
  },
  {
    zip_code: "77093",

    ste_name: "TX",
  },
  {
    zip_code: "77375",

    ste_name: "TX",
  },
  {
    zip_code: "77377",

    ste_name: "TX",
  },
  {
    zip_code: "77415",

    ste_name: "TX",
  },
  {
    zip_code: "77482",

    ste_name: "TX",
  },
  {
    zip_code: "77523",

    ste_name: "TX",
  },
  {
    zip_code: "77539",

    ste_name: "TX",
  },
  {
    zip_code: "77560",

    ste_name: "TX",
  },
  {
    zip_code: "77950",

    ste_name: "TX",
  },
  {
    zip_code: "77987",

    ste_name: "TX",
  },
  {
    zip_code: "78043",

    ste_name: "TX",
  },
  {
    zip_code: "78071",

    ste_name: "TX",
  },
  {
    zip_code: "78108",

    ste_name: "TX",
  },
  {
    zip_code: "78202",

    ste_name: "TX",
  },
  {
    zip_code: "78215",

    ste_name: "TX",
  },
  {
    zip_code: "78221",

    ste_name: "TX",
  },
  {
    zip_code: "78232",

    ste_name: "TX",
  },
  {
    zip_code: "78251",

    ste_name: "TX",
  },
  {
    zip_code: "78503",

    ste_name: "TX",
  },
  {
    zip_code: "78585",

    ste_name: "TX",
  },
  {
    zip_code: "78612",

    ste_name: "TX",
  },
  {
    zip_code: "78613",

    ste_name: "TX",
  },
  {
    zip_code: "78650",

    ste_name: "TX",
  },
  {
    zip_code: "78722",

    ste_name: "TX",
  },
  {
    zip_code: "78837",

    ste_name: "TX",
  },
  {
    zip_code: "79057",

    ste_name: "TX",
  },
  {
    zip_code: "79080",

    ste_name: "TX",
  },
  {
    zip_code: "79346",

    ste_name: "TX",
  },
  {
    zip_code: "79521",

    ste_name: "TX",
  },
  {
    zip_code: "79526",

    ste_name: "TX",
  },
  {
    zip_code: "79527",

    ste_name: "TX",
  },
  {
    zip_code: "79534",

    ste_name: "TX",
  },
  {
    zip_code: "79541",

    ste_name: "TX",
  },
  {
    zip_code: "80004",

    ste_name: "CO",
  },
  {
    zip_code: "80027",

    ste_name: "CO",
  },
  {
    zip_code: "80310",

    ste_name: "CO",
  },
  {
    zip_code: "80435",

    ste_name: "CO",
  },
  {
    zip_code: "80471",

    ste_name: "CO",
  },
  {
    zip_code: "80640",

    ste_name: "CO",
  },
  {
    zip_code: "80648",

    ste_name: "CO",
  },
  {
    zip_code: "80705",

    ste_name: "CO",
  },
  {
    zip_code: "80821",

    ste_name: "CO",
  },
  {
    zip_code: "80831",

    ste_name: "CO",
  },
  {
    zip_code: "80927",

    ste_name: "CO",
  },
  {
    zip_code: "80930",

    ste_name: "CO",
  },
  {
    zip_code: "81155",

    ste_name: "CO",
  },
  {
    zip_code: "81211",

    ste_name: "CO",
  },
  {
    zip_code: "81248",

    ste_name: "CO",
  },
  {
    zip_code: "82213",

    ste_name: "WY",
  },
  {
    zip_code: "82219",

    ste_name: "WY",
  },
  {
    zip_code: "82225",

    ste_name: "WY",
  },
  {
    zip_code: "82322",

    ste_name: "WY",
  },
  {
    zip_code: "82422",

    ste_name: "WY",
  },
  {
    zip_code: "82430",

    ste_name: "WY",
  },
  {
    zip_code: "82714",

    ste_name: "WY",
  },
  {
    zip_code: "82936",

    ste_name: "WY",
  },
  {
    zip_code: "82941",

    ste_name: "WY",
  },
  {
    zip_code: "83209",

    ste_name: "ID",
  },
  {
    zip_code: "83212",

    ste_name: "ID",
  },
  {
    zip_code: "83302",

    ste_name: "ID",
  },
  {
    zip_code: "83352",

    ste_name: "ID",
  },
  {
    zip_code: "83427",

    ste_name: "ID",
  },
  {
    zip_code: "83434",

    ste_name: "ID",
  },
  {
    zip_code: "83436",

    ste_name: "ID",
  },
  {
    zip_code: "83555",

    ste_name: "ID",
  },
  {
    zip_code: "83616",

    ste_name: "ID",
  },
  {
    zip_code: "83856",

    ste_name: "ID",
  },
  {
    zip_code: "84001",

    ste_name: "UT",
  },
  {
    zip_code: "84003",

    ste_name: "UT",
  },
  {
    zip_code: "84045",

    ste_name: "UT",
  },
  {
    zip_code: "84066",

    ste_name: "UT",
  },
  {
    zip_code: "84083",

    ste_name: "UT",
  },
  {
    zip_code: "84304",

    ste_name: "UT",
  },
  {
    zip_code: "84337",

    ste_name: "UT",
  },
  {
    zip_code: "84523",

    ste_name: "UT",
  },
  {
    zip_code: "84711",

    ste_name: "UT",
  },
  {
    zip_code: "84713",

    ste_name: "UT",
  },
  {
    zip_code: "84751",

    ste_name: "UT",
  },
  {
    zip_code: "85004",

    ste_name: "AZ",
  },
  {
    zip_code: "85023",

    ste_name: "AZ",
  },
  {
    zip_code: "85305",

    ste_name: "AZ",
  },
  {
    zip_code: "85306",

    ste_name: "AZ",
  },
  {
    zip_code: "85339",

    ste_name: "AZ",
  },
  {
    zip_code: "85342",

    ste_name: "AZ",
  },
  {
    zip_code: "85383",

    ste_name: "AZ",
  },
  {
    zip_code: "85629",

    ste_name: "AZ",
  },
  {
    zip_code: "85632",

    ste_name: "AZ",
  },
  {
    zip_code: "85641",

    ste_name: "AZ",
  },
  {
    zip_code: "86031",

    ste_name: "AZ",
  },
  {
    zip_code: "86042",

    ste_name: "AZ",
  },
  {
    zip_code: "86329",

    ste_name: "AZ",
  },
  {
    zip_code: "86444",

    ste_name: "AZ",
  },
  {
    zip_code: "86502",

    ste_name: "AZ",
  },
  {
    zip_code: "87014",

    ste_name: "NM",
  },
  {
    zip_code: "87021",

    ste_name: "NM",
  },
  {
    zip_code: "87037",

    ste_name: "NM",
  },
  {
    zip_code: "87117",

    ste_name: "NM",
  },
  {
    zip_code: "87124",

    ste_name: "NM",
  },
  {
    zip_code: "87315",

    ste_name: "NM",
  },
  {
    zip_code: "87364",

    ste_name: "NM",
  },
  {
    zip_code: "87512",

    ste_name: "NM",
  },
  {
    zip_code: "87520",

    ste_name: "NM",
  },
  {
    zip_code: "87558",

    ste_name: "NM",
  },
  {
    zip_code: "87578",

    ste_name: "NM",
  },
  {
    zip_code: "87734",

    ste_name: "NM",
  },
  {
    zip_code: "87750",

    ste_name: "NM",
  },
  {
    zip_code: "87801",

    ste_name: "NM",
  },
  {
    zip_code: "88039",

    ste_name: "NM",
  },
  {
    zip_code: "88103",

    ste_name: "NM",
  },
  {
    zip_code: "88231",

    ste_name: "NM",
  },
  {
    zip_code: "88267",

    ste_name: "NM",
  },
  {
    zip_code: "88340",

    ste_name: "NM",
  },
  {
    zip_code: "88345",

    ste_name: "NM",
  },
  {
    zip_code: "88347",

    ste_name: "NM",
  },
  {
    zip_code: "89004",

    ste_name: "NV",
  },
  {
    zip_code: "89011",

    ste_name: "NV",
  },
  {
    zip_code: "89040",

    ste_name: "NV",
  },
  {
    zip_code: "89142",

    ste_name: "NV",
  },
  {
    zip_code: "89178",

    ste_name: "NV",
  },
  {
    zip_code: "89703",

    ste_name: "NV",
  },
  {
    zip_code: "90056",

    ste_name: "CA",
  },
  {
    zip_code: "90061",

    ste_name: "CA",
  },
  {
    zip_code: "90079",

    ste_name: "CA",
  },
  {
    zip_code: "90278",

    ste_name: "CA",
  },
  {
    zip_code: "90704",

    ste_name: "CA",
  },
  {
    zip_code: "90805",

    ste_name: "CA",
  },
  {
    zip_code: "91207",

    ste_name: "CA",
  },
  {
    zip_code: "91306",

    ste_name: "CA",
  },
  {
    zip_code: "91506",

    ste_name: "CA",
  },
  {
    zip_code: "91708",

    ste_name: "CA",
  },
  {
    zip_code: "91731",

    ste_name: "CA",
  },
  {
    zip_code: "91906",

    ste_name: "CA",
  },
  {
    zip_code: "92003",

    ste_name: "CA",
  },
  {
    zip_code: "92128",

    ste_name: "CA",
  },
  {
    zip_code: "92283",

    ste_name: "CA",
  },
  {
    zip_code: "92407",

    ste_name: "CA",
  },
  {
    zip_code: "92557",

    ste_name: "CA",
  },
  {
    zip_code: "92656",

    ste_name: "CA",
  },
  {
    zip_code: "92688",

    ste_name: "CA",
  },
  {
    zip_code: "92821",

    ste_name: "CA",
  },
  {
    zip_code: "92845",

    ste_name: "CA",
  },
  {
    zip_code: "93012",

    ste_name: "CA",
  },
  {
    zip_code: "93022",

    ste_name: "CA",
  },
  {
    zip_code: "93272",

    ste_name: "CA",
  },
  {
    zip_code: "93286",

    ste_name: "CA",
  },
  {
    zip_code: "93309",

    ste_name: "CA",
  },
  {
    zip_code: "93313",

    ste_name: "CA",
  },
  {
    zip_code: "93405",

    ste_name: "CA",
  },
  {
    zip_code: "93426",

    ste_name: "CA",
  },
  {
    zip_code: "93665",

    ste_name: "CA",
  },
  {
    zip_code: "93728",

    ste_name: "CA",
  },
  {
    zip_code: "94022",

    ste_name: "CA",
  },
  {
    zip_code: "94037",

    ste_name: "CA",
  },
  {
    zip_code: "94116",

    ste_name: "CA",
  },
  {
    zip_code: "94521",

    ste_name: "CA",
  },
  {
    zip_code: "94563",

    ste_name: "CA",
  },
  {
    zip_code: "94564",

    ste_name: "CA",
  },
  {
    zip_code: "94579",

    ste_name: "CA",
  },
  {
    zip_code: "94611",

    ste_name: "CA",
  },
  {
    zip_code: "94708",

    ste_name: "CA",
  },
  {
    zip_code: "95051",

    ste_name: "CA",
  },
  {
    zip_code: "95118",

    ste_name: "CA",
  },
  {
    zip_code: "95254",

    ste_name: "CA",
  },
  {
    zip_code: "95316",

    ste_name: "CA",
  },
  {
    zip_code: "95431",

    ste_name: "CA",
  },
  {
    zip_code: "95443",

    ste_name: "CA",
  },
  {
    zip_code: "95547",

    ste_name: "CA",
  },
  {
    zip_code: "95635",

    ste_name: "CA",
  },
  {
    zip_code: "95652",

    ste_name: "CA",
  },
  {
    zip_code: "95923",

    ste_name: "CA",
  },
  {
    zip_code: "95930",

    ste_name: "CA",
  },
  {
    zip_code: "95935",

    ste_name: "CA",
  },
  {
    zip_code: "95957",

    ste_name: "CA",
  },
  {
    zip_code: "95984",

    ste_name: "CA",
  },
  {
    zip_code: "96014",

    ste_name: "CA",
  },
  {
    zip_code: "96015",

    ste_name: "CA",
  },
  {
    zip_code: "96087",

    ste_name: "CA",
  },
  {
    zip_code: "96118",

    ste_name: "CA",
  },
  {
    zip_code: "96120",

    ste_name: "CA",
  },
  {
    zip_code: "96137",

    ste_name: "CA",
  },
  {
    zip_code: "96764",

    ste_name: "HI",
  },
  {
    zip_code: "96771",

    ste_name: "HI",
  },
  {
    zip_code: "96781",

    ste_name: "HI",
  },
  {
    zip_code: "96791",

    ste_name: "HI",
  },
  {
    zip_code: "96796",

    ste_name: "HI",
  },
  {
    zip_code: "96950",

    ste_name: "MP",
  },
  {
    zip_code: "97007",

    ste_name: "OR",
  },
  {
    zip_code: "97017",

    ste_name: "OR",
  },
  {
    zip_code: "97029",

    ste_name: "OR",
  },
  {
    zip_code: "97057",

    ste_name: "OR",
  },
  {
    zip_code: "97067",

    ste_name: "OR",
  },
  {
    zip_code: "97206",

    ste_name: "OR",
  },
  {
    zip_code: "97232",

    ste_name: "OR",
  },
  {
    zip_code: "97324",

    ste_name: "OR",
  },
  {
    zip_code: "97344",

    ste_name: "OR",
  },
  {
    zip_code: "97408",

    ste_name: "OR",
  },
  {
    zip_code: "97453",

    ste_name: "OR",
  },
  {
    zip_code: "97622",

    ste_name: "OR",
  },
  {
    zip_code: "97750",

    ste_name: "OR",
  },
  {
    zip_code: "97759",

    ste_name: "OR",
  },
  {
    zip_code: "97760",

    ste_name: "OR",
  },
  {
    zip_code: "97884",

    ste_name: "OR",
  },
  {
    zip_code: "97906",

    ste_name: "OR",
  },
  {
    zip_code: "97908",

    ste_name: "OR",
  },
  {
    zip_code: "98005",

    ste_name: "WA",
  },
  {
    zip_code: "98012",

    ste_name: "WA",
  },
  {
    zip_code: "98077",

    ste_name: "WA",
  },
  {
    zip_code: "98106",

    ste_name: "WA",
  },
  {
    zip_code: "98112",

    ste_name: "WA",
  },
  {
    zip_code: "98195",

    ste_name: "WA",
  },
  {
    zip_code: "98198",

    ste_name: "WA",
  },
  {
    zip_code: "98303",

    ste_name: "WA",
  },
  {
    zip_code: "22840",

    ste_name: "VA",
  },
  {
    zip_code: "22904",

    ste_name: "VA",
  },
  {
    zip_code: "22939",

    ste_name: "VA",
  },
  {
    zip_code: "22946",

    ste_name: "VA",
  },
  {
    zip_code: "22976",

    ste_name: "VA",
  },
  {
    zip_code: "23055",

    ste_name: "VA",
  },
  {
    zip_code: "23063",

    ste_name: "VA",
  },
  {
    zip_code: "23307",

    ste_name: "VA",
  },
  {
    zip_code: "23441",

    ste_name: "VA",
  },
  {
    zip_code: "23455",

    ste_name: "VA",
  },
  {
    zip_code: "23456",

    ste_name: "VA",
  },
  {
    zip_code: "23923",

    ste_name: "VA",
  },
  {
    zip_code: "23944",

    ste_name: "VA",
  },
  {
    zip_code: "23959",

    ste_name: "VA",
  },
  {
    zip_code: "24064",

    ste_name: "VA",
  },
  {
    zip_code: "24147",

    ste_name: "VA",
  },
  {
    zip_code: "24226",

    ste_name: "VA",
  },
  {
    zip_code: "24237",

    ste_name: "VA",
  },
  {
    zip_code: "24361",

    ste_name: "VA",
  },
  {
    zip_code: "24366",

    ste_name: "VA",
  },
  {
    zip_code: "24550",

    ste_name: "VA",
  },
  {
    zip_code: "24590",

    ste_name: "VA",
  },
  {
    zip_code: "24831",

    ste_name: "WV",
  },
  {
    zip_code: "25102",

    ste_name: "WV",
  },
  {
    zip_code: "25119",

    ste_name: "WV",
  },
  {
    zip_code: "25121",

    ste_name: "WV",
  },
  {
    zip_code: "25180",

    ste_name: "WV",
  },
  {
    zip_code: "25186",

    ste_name: "WV",
  },
  {
    zip_code: "25243",

    ste_name: "WV",
  },
  {
    zip_code: "25501",

    ste_name: "WV",
  },
  {
    zip_code: "25515",

    ste_name: "WV",
  },
  {
    zip_code: "25649",

    ste_name: "WV",
  },
  {
    zip_code: "25650",

    ste_name: "WV",
  },
  {
    zip_code: "25661",

    ste_name: "WV",
  },
  {
    zip_code: "25831",

    ste_name: "WV",
  },
  {
    zip_code: "25849",

    ste_name: "WV",
  },
  {
    zip_code: "25916",

    ste_name: "WV",
  },
  {
    zip_code: "25981",

    ste_name: "WV",
  },
  {
    zip_code: "26059",

    ste_name: "WV",
  },
  {
    zip_code: "26137",

    ste_name: "WV",
  },
  {
    zip_code: "26283",

    ste_name: "WV",
  },
  {
    zip_code: "26320",

    ste_name: "WV",
  },
  {
    zip_code: "26354",

    ste_name: "WV",
  },
  {
    zip_code: "26419",

    ste_name: "WV",
  },
  {
    zip_code: "26656",

    ste_name: "WV",
  },
  {
    zip_code: "26704",

    ste_name: "WV",
  },
  {
    zip_code: "26815",

    ste_name: "WV",
  },
  {
    zip_code: "27209",

    ste_name: "NC",
  },
  {
    zip_code: "27288",

    ste_name: "NC",
  },
  {
    zip_code: "27313",

    ste_name: "NC",
  },
  {
    zip_code: "27343",

    ste_name: "NC",
  },
  {
    zip_code: "27582",

    ste_name: "NC",
  },
  {
    zip_code: "27591",

    ste_name: "NC",
  },
  {
    zip_code: "27804",

    ste_name: "NC",
  },
  {
    zip_code: "27909",

    ste_name: "NC",
  },
  {
    zip_code: "27935",

    ste_name: "NC",
  },
  {
    zip_code: "28033",

    ste_name: "NC",
  },
  {
    zip_code: "28144",

    ste_name: "NC",
  },
  {
    zip_code: "28217",

    ste_name: "NC",
  },
  {
    zip_code: "28310",

    ste_name: "NC",
  },
  {
    zip_code: "28320",

    ste_name: "NC",
  },
  {
    zip_code: "28376",

    ste_name: "NC",
  },
  {
    zip_code: "28403",

    ste_name: "NC",
  },
  {
    zip_code: "28530",

    ste_name: "NC",
  },
  {
    zip_code: "28537",

    ste_name: "NC",
  },
  {
    zip_code: "28544",

    ste_name: "NC",
  },
  {
    zip_code: "28612",

    ste_name: "NC",
  },
  {
    zip_code: "28666",

    ste_name: "NC",
  },
  {
    zip_code: "28679",

    ste_name: "NC",
  },
  {
    zip_code: "28730",

    ste_name: "NC",
  },
  {
    zip_code: "28747",

    ste_name: "NC",
  },
  {
    zip_code: "28751",

    ste_name: "NC",
  },
  {
    zip_code: "29006",

    ste_name: "SC",
  },
  {
    zip_code: "29033",

    ste_name: "SC",
  },
  {
    zip_code: "29105",

    ste_name: "SC",
  },
  {
    zip_code: "29146",

    ste_name: "SC",
  },
  {
    zip_code: "29148",

    ste_name: "SC",
  },
  {
    zip_code: "29321",

    ste_name: "SC",
  },
  {
    zip_code: "29322",

    ste_name: "SC",
  },
  {
    zip_code: "29431",

    ste_name: "SC",
  },
  {
    zip_code: "29438",

    ste_name: "SC",
  },
  {
    zip_code: "29472",

    ste_name: "SC",
  },
  {
    zip_code: "29477",

    ste_name: "SC",
  },
  {
    zip_code: "29572",

    ste_name: "SC",
  },
  {
    zip_code: "29588",

    ste_name: "SC",
  },
  {
    zip_code: "29590",

    ste_name: "SC",
  },
  {
    zip_code: "29617",

    ste_name: "SC",
  },
  {
    zip_code: "29671",

    ste_name: "SC",
  },
  {
    zip_code: "29676",

    ste_name: "SC",
  },
  {
    zip_code: "29689",

    ste_name: "SC",
  },
  {
    zip_code: "29724",

    ste_name: "SC",
  },
  {
    zip_code: "29810",

    ste_name: "SC",
  },
  {
    zip_code: "29824",

    ste_name: "SC",
  },
  {
    zip_code: "29845",

    ste_name: "SC",
  },
  {
    zip_code: "30017",

    ste_name: "GA",
  },
  {
    zip_code: "30058",

    ste_name: "GA",
  },
  {
    zip_code: "30060",

    ste_name: "GA",
  },
  {
    zip_code: "30082",

    ste_name: "GA",
  },
  {
    zip_code: "30230",

    ste_name: "GA",
  },
  {
    zip_code: "30310",

    ste_name: "GA",
  },
  {
    zip_code: "30327",

    ste_name: "GA",
  },
  {
    zip_code: "30426",

    ste_name: "GA",
  },
  {
    zip_code: "30506",

    ste_name: "GA",
  },
  {
    zip_code: "30537",

    ste_name: "GA",
  },
  {
    zip_code: "30660",

    ste_name: "GA",
  },
  {
    zip_code: "30666",

    ste_name: "GA",
  },
  {
    zip_code: "30905",

    ste_name: "GA",
  },
  {
    zip_code: "31003",

    ste_name: "GA",
  },
  {
    zip_code: "98576",

    ste_name: "WA",
  },
  {
    zip_code: "98647",

    ste_name: "WA",
  },
  {
    zip_code: "98812",

    ste_name: "WA",
  },
  {
    zip_code: "98841",

    ste_name: "WA",
  },
  {
    zip_code: "99020",

    ste_name: "WA",
  },
  {
    zip_code: "99027",

    ste_name: "WA",
  },
  {
    zip_code: "99349",

    ste_name: "WA",
  },
  {
    zip_code: "99353",

    ste_name: "WA",
  },
  {
    zip_code: "99563",

    ste_name: "AK",
  },
  {
    zip_code: "99640",

    ste_name: "AK",
  },
  {
    zip_code: "99652",

    ste_name: "AK",
  },
  {
    zip_code: "99664",

    ste_name: "AK",
  },
  {
    zip_code: "99729",

    ste_name: "AK",
  },
  {
    zip_code: "99766",

    ste_name: "AK",
  },
  {
    zip_code: "99775",

    ste_name: "AK",
  },
  {
    zip_code: "31017",

    ste_name: "GA",
  },
  {
    zip_code: "31057",

    ste_name: "GA",
  },
  {
    zip_code: "31075",

    ste_name: "GA",
  },
  {
    zip_code: "31220",

    ste_name: "GA",
  },
  {
    zip_code: "31550",

    ste_name: "GA",
  },
  {
    zip_code: "31551",

    ste_name: "GA",
  },
  {
    zip_code: "31716",

    ste_name: "GA",
  },
  {
    zip_code: "31764",

    ste_name: "GA",
  },
  {
    zip_code: "31795",

    ste_name: "GA",
  },
  {
    zip_code: "32083",

    ste_name: "FL",
  },
  {
    zip_code: "32131",

    ste_name: "FL",
  },
  {
    zip_code: "32174",

    ste_name: "FL",
  },
  {
    zip_code: "32202",

    ste_name: "FL",
  },
  {
    zip_code: "32233",

    ste_name: "FL",
  },
  {
    zip_code: "32266",

    ste_name: "FL",
  },
  {
    zip_code: "32317",

    ste_name: "FL",
  },
  {
    zip_code: "32504",

    ste_name: "FL",
  },
  {
    zip_code: "32609",

    ste_name: "FL",
  },
  {
    zip_code: "32612",

    ste_name: "FL",
  },
  {
    zip_code: "32746",

    ste_name: "FL",
  },
  {
    zip_code: "32757",

    ste_name: "FL",
  },
  {
    zip_code: "32825",

    ste_name: "FL",
  },
  {
    zip_code: "32831",

    ste_name: "FL",
  },
  {
    zip_code: "32963",

    ste_name: "FL",
  },
  {
    zip_code: "33070",

    ste_name: "FL",
  },
  {
    zip_code: "33076",

    ste_name: "FL",
  },
  {
    zip_code: "33129",

    ste_name: "FL",
  },
  {
    zip_code: "33156",

    ste_name: "FL",
  },
  {
    zip_code: "33405",

    ste_name: "FL",
  },
  {
    zip_code: "33408",

    ste_name: "FL",
  },
  {
    zip_code: "33432",

    ste_name: "FL",
  },
  {
    zip_code: "33438",

    ste_name: "FL",
  },
  {
    zip_code: "33549",

    ste_name: "FL",
  },
  {
    zip_code: "33602",

    ste_name: "FL",
  },
  {
    zip_code: "33716",

    ste_name: "FL",
  },
  {
    zip_code: "33801",

    ste_name: "FL",
  },
  {
    zip_code: "34229",

    ste_name: "FL",
  },
  {
    zip_code: "34236",

    ste_name: "FL",
  },
  {
    zip_code: "34251",

    ste_name: "FL",
  },
  {
    zip_code: "34607",

    ste_name: "FL",
  },
  {
    zip_code: "34684",

    ste_name: "FL",
  },
  {
    zip_code: "34695",

    ste_name: "FL",
  },
  {
    zip_code: "34711",

    ste_name: "FL",
  },
  {
    zip_code: "34788",

    ste_name: "FL",
  },
  {
    zip_code: "34946",

    ste_name: "FL",
  },
  {
    zip_code: "35078",

    ste_name: "AL",
  },
  {
    zip_code: "35188",

    ste_name: "AL",
  },
  {
    zip_code: "35208",

    ste_name: "AL",
  },
  {
    zip_code: "35442",

    ste_name: "AL",
  },
  {
    zip_code: "35543",

    ste_name: "AL",
  },
  {
    zip_code: "35549",

    ste_name: "AL",
  },
  {
    zip_code: "35615",

    ste_name: "AL",
  },
  {
    zip_code: "35618",

    ste_name: "AL",
  },
  {
    zip_code: "35649",

    ste_name: "AL",
  },
  {
    zip_code: "36470",

    ste_name: "AL",
  },
  {
    zip_code: "36529",

    ste_name: "AL",
  },
  {
    zip_code: "36532",

    ste_name: "AL",
  },
  {
    zip_code: "36559",

    ste_name: "AL",
  },
  {
    zip_code: "36579",

    ste_name: "AL",
  },
  {
    zip_code: "36605",

    ste_name: "AL",
  },
  {
    zip_code: "36922",

    ste_name: "AL",
  },
  {
    zip_code: "37035",

    ste_name: "TN",
  },
  {
    zip_code: "37075",

    ste_name: "TN",
  },
  {
    zip_code: "37128",

    ste_name: "TN",
  },
  {
    zip_code: "37153",

    ste_name: "TN",
  },
  {
    zip_code: "37321",

    ste_name: "TN",
  },
  {
    zip_code: "37322",

    ste_name: "TN",
  },
  {
    zip_code: "37365",

    ste_name: "TN",
  },
  {
    zip_code: "37411",

    ste_name: "TN",
  },
  {
    zip_code: "37657",

    ste_name: "TN",
  },
  {
    zip_code: "37730",

    ste_name: "TN",
  },
  {
    zip_code: "37854",

    ste_name: "TN",
  },
  {
    zip_code: "37892",

    ste_name: "TN",
  },
  {
    zip_code: "38016",

    ste_name: "TN",
  },
  {
    zip_code: "38233",

    ste_name: "TN",
  },
  {
    zip_code: "38241",

    ste_name: "TN",
  },
  {
    zip_code: "38255",

    ste_name: "TN",
  },
  {
    zip_code: "38380",

    ste_name: "TN",
  },
  {
    zip_code: "38388",

    ste_name: "TN",
  },
  {
    zip_code: "38390",

    ste_name: "TN",
  },
  {
    zip_code: "38588",

    ste_name: "TN",
  },
  {
    zip_code: "38664",

    ste_name: "MS",
  },
  {
    zip_code: "38943",

    ste_name: "MS",
  },
  {
    zip_code: "38949",

    ste_name: "MS",
  },
  {
    zip_code: "39083",

    ste_name: "MS",
  },
  {
    zip_code: "39153",

    ste_name: "MS",
  },
  {
    zip_code: "39170",

    ste_name: "MS",
  },
  {
    zip_code: "39402",

    ste_name: "MS",
  },
  {
    zip_code: "39461",

    ste_name: "MS",
  },
  {
    zip_code: "39520",

    ste_name: "MS",
  },
  {
    zip_code: "39652",

    ste_name: "MS",
  },
  {
    zip_code: "39752",

    ste_name: "MS",
  },
  {
    zip_code: "40077",

    ste_name: "KY",
  },
  {
    zip_code: "40078",

    ste_name: "KY",
  },
  {
    zip_code: "40140",

    ste_name: "KY",
  },
  {
    zip_code: "40213",

    ste_name: "KY",
  },
  {
    zip_code: "40359",

    ste_name: "KY",
  },
  {
    zip_code: "40374",

    ste_name: "KY",
  },
  {
    zip_code: "40448",

    ste_name: "KY",
  },
  {
    zip_code: "40461",

    ste_name: "KY",
  },
  {
    zip_code: "40511",

    ste_name: "KY",
  },
  {
    zip_code: "40816",

    ste_name: "KY",
  },
  {
    zip_code: "40828",

    ste_name: "KY",
  },
  {
    zip_code: "40958",

    ste_name: "KY",
  },
  {
    zip_code: "41051",

    ste_name: "KY",
  },
  {
    zip_code: "41063",

    ste_name: "KY",
  },
  {
    zip_code: "41101",

    ste_name: "KY",
  },
  {
    zip_code: "41214",

    ste_name: "KY",
  },
  {
    zip_code: "41538",

    ste_name: "KY",
  },
  {
    zip_code: "41659",

    ste_name: "KY",
  },
  {
    zip_code: "41719",

    ste_name: "KY",
  },
  {
    zip_code: "41815",

    ste_name: "KY",
  },
  {
    zip_code: "41817",

    ste_name: "KY",
  },
  {
    zip_code: "41824",

    ste_name: "KY",
  },
  {
    zip_code: "41855",

    ste_name: "KY",
  },
  {
    zip_code: "42079",

    ste_name: "KY",
  },
  {
    zip_code: "42280",

    ste_name: "KY",
  },
  {
    zip_code: "42338",

    ste_name: "KY",
  },
  {
    zip_code: "42345",

    ste_name: "KY",
  },
  {
    zip_code: "42404",

    ste_name: "KY",
  },
  {
    zip_code: "42553",

    ste_name: "KY",
  },
  {
    zip_code: "42740",

    ste_name: "KY",
  },
  {
    zip_code: "42754",

    ste_name: "KY",
  },
  {
    zip_code: "43219",

    ste_name: "OH",
  },
  {
    zip_code: "43338",

    ste_name: "OH",
  },
  {
    zip_code: "43430",

    ste_name: "OH",
  },
  {
    zip_code: "43439",

    ste_name: "OH",
  },
  {
    zip_code: "43458",

    ste_name: "OH",
  },
  {
    zip_code: "43571",

    ste_name: "OH",
  },
  {
    zip_code: "43754",

    ste_name: "OH",
  },
  {
    zip_code: "43778",

    ste_name: "OH",
  },
  {
    zip_code: "43927",

    ste_name: "OH",
  },
  {
    zip_code: "43983",

    ste_name: "OH",
  },
  {
    zip_code: "44120",

    ste_name: "OH",
  },
  {
    zip_code: "44285",

    ste_name: "OH",
  },
  {
    zip_code: "44303",

    ste_name: "OH",
  },
  {
    zip_code: "44429",

    ste_name: "OH",
  },
  {
    zip_code: "44842",

    ste_name: "OH",
  },
  {
    zip_code: "44889",

    ste_name: "OH",
  },
  {
    zip_code: "45002",

    ste_name: "OH",
  },
  {
    zip_code: "45160",

    ste_name: "OH",
  },
  {
    zip_code: "45176",

    ste_name: "OH",
  },
  {
    zip_code: "45246",

    ste_name: "OH",
  },
  {
    zip_code: "45312",

    ste_name: "OH",
  },
  {
    zip_code: "45504",

    ste_name: "OH",
  },
  {
    zip_code: "45619",

    ste_name: "OH",
  },
  {
    zip_code: "45638",

    ste_name: "OH",
  },
  {
    zip_code: "45685",

    ste_name: "OH",
  },
  {
    zip_code: "45810",

    ste_name: "OH",
  },
  {
    zip_code: "45867",

    ste_name: "OH",
  },
  {
    zip_code: "45885",

    ste_name: "OH",
  },
  {
    zip_code: "46033",

    ste_name: "IN",
  },
  {
    zip_code: "46038",

    ste_name: "IN",
  },
  {
    zip_code: "46047",

    ste_name: "IN",
  },
  {
    zip_code: "46076",

    ste_name: "IN",
  },
  {
    zip_code: "46077",

    ste_name: "IN",
  },
  {
    zip_code: "46103",

    ste_name: "IN",
  },
  {
    zip_code: "46163",

    ste_name: "IN",
  },
  {
    zip_code: "46164",

    ste_name: "IN",
  },
  {
    zip_code: "46173",

    ste_name: "IN",
  },
  {
    zip_code: "46227",

    ste_name: "IN",
  },
  {
    zip_code: "46235",

    ste_name: "IN",
  },
  {
    zip_code: "46342",

    ste_name: "IN",
  },
  {
    zip_code: "46345",

    ste_name: "IN",
  },
  {
    zip_code: "46381",

    ste_name: "IN",
  },
  {
    zip_code: "46507",

    ste_name: "IN",
  },
  {
    zip_code: "46534",

    ste_name: "IN",
  },
  {
    zip_code: "46554",

    ste_name: "IN",
  },
  {
    zip_code: "46702",

    ste_name: "IN",
  },
  {
    zip_code: "46773",

    ste_name: "IN",
  },
  {
    zip_code: "46784",

    ste_name: "IN",
  },
  {
    zip_code: "46799",

    ste_name: "IN",
  },
  {
    zip_code: "46804",

    ste_name: "IN",
  },
  {
    zip_code: "46926",

    ste_name: "IN",
  },
  {
    zip_code: "46988",

    ste_name: "IN",
  },
  {
    zip_code: "46991",

    ste_name: "IN",
  },
  {
    zip_code: "47163",

    ste_name: "IN",
  },
  {
    zip_code: "47273",

    ste_name: "IN",
  },
  {
    zip_code: "47283",

    ste_name: "IN",
  },
  {
    zip_code: "47338",

    ste_name: "IN",
  },
  {
    zip_code: "47368",

    ste_name: "IN",
  },
  {
    zip_code: "47396",

    ste_name: "IN",
  },
  {
    zip_code: "47420",

    ste_name: "IN",
  },
  {
    zip_code: "47519",

    ste_name: "IN",
  },
  {
    zip_code: "47525",

    ste_name: "IN",
  },
  {
    zip_code: "47601",

    ste_name: "IN",
  },
  {
    zip_code: "47610",

    ste_name: "IN",
  },
  {
    zip_code: "47616",

    ste_name: "IN",
  },
  {
    zip_code: "47858",

    ste_name: "IN",
  },
  {
    zip_code: "47861",

    ste_name: "IN",
  },
  {
    zip_code: "47885",

    ste_name: "IN",
  },
  {
    zip_code: "48005",

    ste_name: "MI",
  },
  {
    zip_code: "48017",

    ste_name: "MI",
  },
  {
    zip_code: "48064",

    ste_name: "MI",
  },
  {
    zip_code: "48162",

    ste_name: "MI",
  },
  {
    zip_code: "48177",

    ste_name: "MI",
  },
  {
    zip_code: "48203",

    ste_name: "MI",
  },
  {
    zip_code: "48207",

    ste_name: "MI",
  },
  {
    zip_code: "48215",

    ste_name: "MI",
  },
  {
    zip_code: "48233",

    ste_name: "MI",
  },
  {
    zip_code: "48310",

    ste_name: "MI",
  },
  {
    zip_code: "48329",

    ste_name: "MI",
  },
  {
    zip_code: "48393",

    ste_name: "MI",
  },
  {
    zip_code: "48420",

    ste_name: "MI",
  },
  {
    zip_code: "48422",

    ste_name: "MI",
  },
  {
    zip_code: "48461",

    ste_name: "MI",
  },
  {
    zip_code: "48476",

    ste_name: "MI",
  },
  {
    zip_code: "48655",

    ste_name: "MI",
  },
  {
    zip_code: "48749",

    ste_name: "MI",
  },
  {
    zip_code: "48820",

    ste_name: "MI",
  },
  {
    zip_code: "48837",

    ste_name: "MI",
  },
  {
    zip_code: "48872",

    ste_name: "MI",
  },
  {
    zip_code: "48874",

    ste_name: "MI",
  },
  {
    zip_code: "49021",

    ste_name: "MI",
  },
  {
    zip_code: "49090",

    ste_name: "MI",
  },
  {
    zip_code: "49096",

    ste_name: "MI",
  },
  {
    zip_code: "49107",

    ste_name: "MI",
  },
  {
    zip_code: "49116",

    ste_name: "MI",
  },
  {
    zip_code: "49229",

    ste_name: "MI",
  },
  {
    zip_code: "49272",

    ste_name: "MI",
  },
  {
    zip_code: "49285",

    ste_name: "MI",
  },
  {
    zip_code: "49337",

    ste_name: "MI",
  },
  {
    zip_code: "49339",

    ste_name: "MI",
  },
  {
    zip_code: "49408",

    ste_name: "MI",
  },
  {
    zip_code: "49504",

    ste_name: "MI",
  },
  {
    zip_code: "49505",

    ste_name: "MI",
  },
  {
    zip_code: "49634",

    ste_name: "MI",
  },
  {
    zip_code: "49707",

    ste_name: "MI",
  },
  {
    zip_code: "49893",

    ste_name: "MI",
  },
  {
    zip_code: "49934",

    ste_name: "MI",
  },
  {
    zip_code: "49945",

    ste_name: "MI",
  },
  {
    zip_code: "49971",

    ste_name: "MI",
  },
  {
    zip_code: "50003",

    ste_name: "IA",
  },
  {
    zip_code: "50010",

    ste_name: "IA",
  },
  {
    zip_code: "50021",

    ste_name: "IA",
  },
  {
    zip_code: "50104",

    ste_name: "IA",
  },
  {
    zip_code: "50143",

    ste_name: "IA",
  },
  {
    zip_code: "50156",

    ste_name: "IA",
  },
  {
    zip_code: "50233",

    ste_name: "IA",
  },
  {
    zip_code: "50238",

    ste_name: "IA",
  },
  {
    zip_code: "50263",

    ste_name: "IA",
  },
  {
    zip_code: "50453",

    ste_name: "IA",
  },
  {
    zip_code: "50466",

    ste_name: "IA",
  },
  {
    zip_code: "50541",

    ste_name: "IA",
  },
  {
    zip_code: "50565",

    ste_name: "IA",
  },
  {
    zip_code: "50609",

    ste_name: "IA",
  },
  {
    zip_code: "50626",

    ste_name: "IA",
  },
  {
    zip_code: "51005",

    ste_name: "IA",
  },
  {
    zip_code: "51008",

    ste_name: "IA",
  },
  {
    zip_code: "51051",

    ste_name: "IA",
  },
  {
    zip_code: "51364",

    ste_name: "IA",
  },
  {
    zip_code: "51366",

    ste_name: "IA",
  },
  {
    zip_code: "51446",

    ste_name: "IA",
  },
  {
    zip_code: "51462",

    ste_name: "IA",
  },
  {
    zip_code: "51551",

    ste_name: "IA",
  },
  {
    zip_code: "51639",

    ste_name: "IA",
  },
  {
    zip_code: "52147",

    ste_name: "IA",
  },
  {
    zip_code: "52201",

    ste_name: "IA",
  },
  {
    zip_code: "52229",

    ste_name: "IA",
  },
  {
    zip_code: "52310",

    ste_name: "IA",
  },
  {
    zip_code: "52323",

    ste_name: "IA",
  },
  {
    zip_code: "52349",

    ste_name: "IA",
  },
  {
    zip_code: "52540",

    ste_name: "IA",
  },
  {
    zip_code: "52620",

    ste_name: "IA",
  },
  {
    zip_code: "52750",

    ste_name: "IA",
  },
  {
    zip_code: "52753",

    ste_name: "IA",
  },
  {
    zip_code: "52807",

    ste_name: "IA",
  },
  {
    zip_code: "53046",

    ste_name: "WI",
  },
  {
    zip_code: "53103",

    ste_name: "WI",
  },
  {
    zip_code: "53114",

    ste_name: "WI",
  },
  {
    zip_code: "53142",

    ste_name: "WI",
  },
  {
    zip_code: "53541",

    ste_name: "WI",
  },
  {
    zip_code: "53549",

    ste_name: "WI",
  },
  {
    zip_code: "53585",

    ste_name: "WI",
  },
  {
    zip_code: "53818",

    ste_name: "WI",
  },
  {
    zip_code: "53916",

    ste_name: "WI",
  },
  {
    zip_code: "53926",

    ste_name: "WI",
  },
  {
    zip_code: "53955",

    ste_name: "WI",
  },
  {
    zip_code: "54003",

    ste_name: "WI",
  },
  {
    zip_code: "54106",

    ste_name: "WI",
  },
  {
    zip_code: "54126",

    ste_name: "WI",
  },
  {
    zip_code: "54425",

    ste_name: "WI",
  },
  {
    zip_code: "54460",

    ste_name: "WI",
  },
  {
    zip_code: "54514",

    ste_name: "WI",
  },
  {
    zip_code: "54517",

    ste_name: "WI",
  },
  {
    zip_code: "54541",

    ste_name: "WI",
  },
  {
    zip_code: "54621",

    ste_name: "WI",
  },
  {
    zip_code: "54622",

    ste_name: "WI",
  },
  {
    zip_code: "54659",

    ste_name: "WI",
  },
  {
    zip_code: "54758",

    ste_name: "WI",
  },
  {
    zip_code: "54762",

    ste_name: "WI",
  },
  {
    zip_code: "54810",

    ste_name: "WI",
  },
  {
    zip_code: "54888",

    ste_name: "WI",
  },
  {
    zip_code: "55012",

    ste_name: "MN",
  },
  {
    zip_code: "55070",

    ste_name: "MN",
  },
  {
    zip_code: "55071",

    ste_name: "MN",
  },
  {
    zip_code: "55114",

    ste_name: "MN",
  },
  {
    zip_code: "55337",

    ste_name: "MN",
  },
  {
    zip_code: "55349",

    ste_name: "MN",
  },
  {
    zip_code: "55354",

    ste_name: "MN",
  },
  {
    zip_code: "55368",

    ste_name: "MN",
  },
  {
    zip_code: "55389",

    ste_name: "MN",
  },
  {
    zip_code: "55409",

    ste_name: "MN",
  },
  {
    zip_code: "55605",

    ste_name: "MN",
  },
  {
    zip_code: "55924",

    ste_name: "MN",
  },
  {
    zip_code: "55926",

    ste_name: "MN",
  },
  {
    zip_code: "55970",

    ste_name: "MN",
  },
  {
    zip_code: "56025",

    ste_name: "MN",
  },
  {
    zip_code: "56155",

    ste_name: "MN",
  },
  {
    zip_code: "56231",

    ste_name: "MN",
  },
  {
    zip_code: "56235",

    ste_name: "MN",
  },
  {
    zip_code: "56264",

    ste_name: "MN",
  },
  {
    zip_code: "56283",

    ste_name: "MN",
  },
  {
    zip_code: "56352",

    ste_name: "MN",
  },
  {
    zip_code: "56510",

    ste_name: "MN",
  },
  {
    zip_code: "56587",

    ste_name: "MN",
  },
  {
    zip_code: "56589",

    ste_name: "MN",
  },
  {
    zip_code: "56734",

    ste_name: "MN",
  },
  {
    zip_code: "57026",

    ste_name: "SD",
  },
  {
    zip_code: "57078",

    ste_name: "SD",
  },
  {
    zip_code: "57227",

    ste_name: "SD",
  },
  {
    zip_code: "57233",

    ste_name: "SD",
  },
  {
    zip_code: "57235",

    ste_name: "SD",
  },
  {
    zip_code: "57273",

    ste_name: "SD",
  },
  {
    zip_code: "57311",

    ste_name: "SD",
  },
  {
    zip_code: "57322",

    ste_name: "SD",
  },
  {
    zip_code: "57331",

    ste_name: "SD",
  },
  {
    zip_code: "57465",

    ste_name: "SD",
  },
  {
    zip_code: "57501",

    ste_name: "SD",
  },
  {
    zip_code: "58006",

    ste_name: "ND",
  },
  {
    zip_code: "58007",

    ste_name: "ND",
  },
  {
    zip_code: "58068",

    ste_name: "ND",
  },
  {
    zip_code: "58331",

    ste_name: "ND",
  },
  {
    zip_code: "58474",

    ste_name: "ND",
  },
  {
    zip_code: "58497",

    ste_name: "ND",
  },
  {
    zip_code: "58569",

    ste_name: "ND",
  },
  {
    zip_code: "58652",

    ste_name: "ND",
  },
  {
    zip_code: "58731",

    ste_name: "ND",
  },
  {
    zip_code: "58856",

    ste_name: "ND",
  },
  {
    zip_code: "59032",

    ste_name: "MT",
  },
  {
    zip_code: "59071",

    ste_name: "MT",
  },
  {
    zip_code: "59221",

    ste_name: "MT",
  },
  {
    zip_code: "59243",

    ste_name: "MT",
  },
  {
    zip_code: "59262",

    ste_name: "MT",
  },
  {
    zip_code: "59718",

    ste_name: "MT",
  },
  {
    zip_code: "59724",

    ste_name: "MT",
  },
  {
    zip_code: "59759",

    ste_name: "MT",
  },
  {
    zip_code: "59760",

    ste_name: "MT",
  },
  {
    zip_code: "59804",

    ste_name: "MT",
  },
  {
    zip_code: "59832",

    ste_name: "MT",
  },
  {
    zip_code: "59843",

    ste_name: "MT",
  },
  {
    zip_code: "59935",

    ste_name: "MT",
  },
  {
    zip_code: "60004",

    ste_name: "IL",
  },
  {
    zip_code: "60005",

    ste_name: "IL",
  },
  {
    zip_code: "60107",

    ste_name: "IL",
  },
  {
    zip_code: "60162",

    ste_name: "IL",
  },
  {
    zip_code: "60195",

    ste_name: "IL",
  },
  {
    zip_code: "60451",

    ste_name: "IL",
  },
  {
    zip_code: "60484",

    ste_name: "IL",
  },
  {
    zip_code: "60521",

    ste_name: "IL",
  },
  {
    zip_code: "60527",

    ste_name: "IL",
  },
  {
    zip_code: "60603",

    ste_name: "IL",
  },
  {
    zip_code: "60621",

    ste_name: "IL",
  },
  {
    zip_code: "60636",

    ste_name: "IL",
  },
  {
    zip_code: "60655",

    ste_name: "IL",
  },
  {
    zip_code: "60940",

    ste_name: "IL",
  },
  {
    zip_code: "60961",

    ste_name: "IL",
  },
  {
    zip_code: "61037",

    ste_name: "IL",
  },
  {
    zip_code: "61047",

    ste_name: "IL",
  },
  {
    zip_code: "61071",

    ste_name: "IL",
  },
  {
    zip_code: "61081",

    ste_name: "IL",
  },
  {
    zip_code: "61234",

    ste_name: "IL",
  },
  {
    zip_code: "61273",

    ste_name: "IL",
  },
  {
    zip_code: "61279",

    ste_name: "IL",
  },
  {
    zip_code: "61322",

    ste_name: "IL",
  },
  {
    zip_code: "61333",

    ste_name: "IL",
  },
  {
    zip_code: "61368",

    ste_name: "IL",
  },
  {
    zip_code: "61417",

    ste_name: "IL",
  },
  {
    zip_code: "61425",

    ste_name: "IL",
  },
  {
    zip_code: "61554",

    ste_name: "IL",
  },
  {
    zip_code: "61604",

    ste_name: "IL",
  },
  {
    zip_code: "61738",

    ste_name: "IL",
  },
  {
    zip_code: "61741",

    ste_name: "IL",
  },
  {
    zip_code: "61752",

    ste_name: "IL",
  },
  {
    zip_code: "61772",

    ste_name: "IL",
  },
  {
    zip_code: "61832",

    ste_name: "IL",
  },
  {
    zip_code: "61865",

    ste_name: "IL",
  },
  {
    zip_code: "61924",

    ste_name: "IL",
  },
  {
    zip_code: "62017",

    ste_name: "IL",
  },
  {
    zip_code: "62062",

    ste_name: "IL",
  },
  {
    zip_code: "62090",

    ste_name: "IL",
  },
  {
    zip_code: "62219",

    ste_name: "IL",
  },
  {
    zip_code: "62298",

    ste_name: "IL",
  },
  {
    zip_code: "62356",

    ste_name: "IL",
  },
  {
    zip_code: "62410",

    ste_name: "IL",
  },
  {
    zip_code: "62411",

    ste_name: "IL",
  },
  {
    zip_code: "62427",

    ste_name: "IL",
  },
  {
    zip_code: "62533",

    ste_name: "IL",
  },
  {
    zip_code: "62560",

    ste_name: "IL",
  },
  {
    zip_code: "62565",

    ste_name: "IL",
  },
  {
    zip_code: "62612",

    ste_name: "IL",
  },
  {
    zip_code: "62643",

    ste_name: "IL",
  },
  {
    zip_code: "62849",

    ste_name: "IL",
  },
  {
    zip_code: "62938",

    ste_name: "IL",
  },
  {
    zip_code: "63031",

    ste_name: "MO",
  },
  {
    zip_code: "63089",

    ste_name: "MO",
  },
  {
    zip_code: "63091",

    ste_name: "MO",
  },
  {
    zip_code: "63120",

    ste_name: "MO",
  },
  {
    zip_code: "63438",

    ste_name: "MO",
  },
  {
    zip_code: "63467",

    ste_name: "MO",
  },
  {
    zip_code: "63471",

    ste_name: "MO",
  },
  {
    zip_code: "63474",

    ste_name: "MO",
  },
  {
    zip_code: "63857",

    ste_name: "MO",
  },
  {
    zip_code: "63874",

    ste_name: "MO",
  },
  {
    zip_code: "64019",

    ste_name: "MO",
  },
  {
    zip_code: "64401",

    ste_name: "MO",
  },
  {
    zip_code: "64431",

    ste_name: "MO",
  },
  {
    zip_code: "64438",

    ste_name: "MO",
  },
  {
    zip_code: "64446",

    ste_name: "MO",
  },
  {
    zip_code: "64469",

    ste_name: "MO",
  },
  {
    zip_code: "64620",

    ste_name: "MO",
  },
  {
    zip_code: "64741",

    ste_name: "MO",
  },
  {
    zip_code: "64801",

    ste_name: "MO",
  },
  {
    zip_code: "64848",

    ste_name: "MO",
  },
  {
    zip_code: "64861",

    ste_name: "MO",
  },
  {
    zip_code: "65023",

    ste_name: "MO",
  },
  {
    zip_code: "65047",

    ste_name: "MO",
  },
  {
    zip_code: "65078",

    ste_name: "MO",
  },
  {
    zip_code: "65084",

    ste_name: "MO",
  },
  {
    zip_code: "65255",

    ste_name: "MO",
  },
  {
    zip_code: "65262",

    ste_name: "MO",
  },
  {
    zip_code: "65625",

    ste_name: "MO",
  },
  {
    zip_code: "65720",

    ste_name: "MO",
  },
  {
    zip_code: "65722",

    ste_name: "MO",
  },
  {
    zip_code: "65740",

    ste_name: "MO",
  },
  {
    zip_code: "65755",

    ste_name: "MO",
  },
  {
    zip_code: "65785",

    ste_name: "MO",
  },
  {
    zip_code: "66017",

    ste_name: "KS",
  },
  {
    zip_code: "66030",

    ste_name: "KS",
  },
  {
    zip_code: "66066",

    ste_name: "KS",
  },
  {
    zip_code: "66401",

    ste_name: "KS",
  },
  {
    zip_code: "66409",

    ste_name: "KS",
  },
  {
    zip_code: "66417",

    ste_name: "KS",
  },
  {
    zip_code: "66537",

    ste_name: "KS",
  },
  {
    zip_code: "66554",

    ste_name: "KS",
  },
  {
    zip_code: "66622",

    ste_name: "KS",
  },
  {
    zip_code: "66738",

    ste_name: "KS",
  },
  {
    zip_code: "66944",

    ste_name: "KS",
  },
  {
    zip_code: "67071",

    ste_name: "KS",
  },
  {
    zip_code: "67159",

    ste_name: "KS",
  },
  {
    zip_code: "67214",

    ste_name: "KS",
  },
  {
    zip_code: "67360",

    ste_name: "KS",
  },
  {
    zip_code: "67575",

    ste_name: "KS",
  },
  {
    zip_code: "67647",

    ste_name: "KS",
  },
  {
    zip_code: "67730",

    ste_name: "KS",
  },
  {
    zip_code: "67745",

    ste_name: "KS",
  },
  {
    zip_code: "68070",

    ste_name: "NE",
  },
  {
    zip_code: "68118",

    ste_name: "NE",
  },
  {
    zip_code: "68138",

    ste_name: "NE",
  },
  {
    zip_code: "68307",

    ste_name: "NE",
  },
  {
    zip_code: "68342",

    ste_name: "NE",
  },
  {
    zip_code: "68355",

    ste_name: "NE",
  },
  {
    zip_code: "68370",

    ste_name: "NE",
  },
  {
    zip_code: "68430",

    ste_name: "NE",
  },
  {
    zip_code: "68438",

    ste_name: "NE",
  },
  {
    zip_code: "68444",

    ste_name: "NE",
  },
  {
    zip_code: "68661",

    ste_name: "NE",
  },
  {
    zip_code: "68746",

    ste_name: "NE",
  },
  {
    zip_code: "68748",

    ste_name: "NE",
  },
  {
    zip_code: "68765",

    ste_name: "NE",
  },
  {
    zip_code: "68836",

    ste_name: "NE",
  },
  {
    zip_code: "68853",

    ste_name: "NE",
  },
  {
    zip_code: "68923",

    ste_name: "NE",
  },
  {
    zip_code: "68971",

    ste_name: "NE",
  },
  {
    zip_code: "69046",

    ste_name: "NE",
  },
  {
    zip_code: "70005",

    ste_name: "LA",
  },
  {
    zip_code: "70422",

    ste_name: "LA",
  },
  {
    zip_code: "70453",

    ste_name: "LA",
  },
  {
    zip_code: "70508",

    ste_name: "LA",
  },
  {
    zip_code: "70526",

    ste_name: "LA",
  },
  {
    zip_code: "70554",

    ste_name: "LA",
  },
  {
    zip_code: "70712",

    ste_name: "LA",
  },
  {
    zip_code: "70803",

    ste_name: "LA",
  },
  {
    zip_code: "70809",

    ste_name: "LA",
  },
  {
    zip_code: "71016",

    ste_name: "LA",
  },
  {
    zip_code: "71047",

    ste_name: "LA",
  },
  {
    zip_code: "71118",

    ste_name: "LA",
  },
  {
    zip_code: "71203",

    ste_name: "LA",
  },
  {
    zip_code: "71432",

    ste_name: "LA",
  },
  {
    zip_code: "71655",

    ste_name: "AR",
  },
  {
    zip_code: "71711",

    ste_name: "AR",
  },
  {
    zip_code: "71744",

    ste_name: "AR",
  },
  {
    zip_code: "71766",

    ste_name: "AR",
  },
  {
    zip_code: "71922",

    ste_name: "AR",
  },
  {
    zip_code: "71943",

    ste_name: "AR",
  },
  {
    zip_code: "72065",

    ste_name: "AR",
  },
  {
    zip_code: "72142",

    ste_name: "AR",
  },
  {
    zip_code: "72168",

    ste_name: "AR",
  },
  {
    zip_code: "72202",

    ste_name: "AR",
  },
  {
    zip_code: "72204",

    ste_name: "AR",
  },
  {
    zip_code: "72301",

    ste_name: "AR",
  },
  {
    zip_code: "72350",

    ste_name: "AR",
  },
  {
    zip_code: "72370",

    ste_name: "AR",
  },
  {
    zip_code: "72425",

    ste_name: "AR",
  },
  {
    zip_code: "72443",

    ste_name: "AR",
  },
  {
    zip_code: "72449",

    ste_name: "AR",
  },
  {
    zip_code: "72450",

    ste_name: "AR",
  },
  {
    zip_code: "72540",

    ste_name: "AR",
  },
  {
    zip_code: "72629",

    ste_name: "AR",
  },
  {
    zip_code: "72640",

    ste_name: "AR",
  },
  {
    zip_code: "72736",

    ste_name: "AR",
  },
  {
    zip_code: "72768",

    ste_name: "AR",
  },
  {
    zip_code: "72774",

    ste_name: "AR",
  },
  {
    zip_code: "72945",

    ste_name: "AR",
  },
  {
    zip_code: "73027",

    ste_name: "OK",
  },
  {
    zip_code: "73067",

    ste_name: "OK",
  },
  {
    zip_code: "73116",

    ste_name: "OK",
  },
  {
    zip_code: "73401",

    ste_name: "OK",
  },
  {
    zip_code: "73437",

    ste_name: "OK",
  },
  {
    zip_code: "73443",

    ste_name: "OK",
  },
  {
    zip_code: "73569",

    ste_name: "OK",
  },
  {
    zip_code: "73642",

    ste_name: "OK",
  },
  {
    zip_code: "73645",

    ste_name: "OK",
  },
  {
    zip_code: "73667",

    ste_name: "OK",
  },
  {
    zip_code: "73719",

    ste_name: "OK",
  },
  {
    zip_code: "73746",

    ste_name: "OK",
  },
  {
    zip_code: "73747",

    ste_name: "OK",
  },
  {
    zip_code: "74008",

    ste_name: "OK",
  },
  {
    zip_code: "74026",

    ste_name: "OK",
  },
  {
    zip_code: "74039",

    ste_name: "OK",
  },
  {
    zip_code: "74079",

    ste_name: "OK",
  },
  {
    zip_code: "74333",

    ste_name: "OK",
  },
  {
    zip_code: "74344",

    ste_name: "OK",
  },
  {
    zip_code: "74460",

    ste_name: "OK",
  },
  {
    zip_code: "74574",

    ste_name: "OK",
  },
  {
    zip_code: "74604",

    ste_name: "OK",
  },
  {
    zip_code: "74825",

    ste_name: "OK",
  },
  {
    zip_code: "74859",

    ste_name: "OK",
  },
  {
    zip_code: "74930",

    ste_name: "OK",
  },
  {
    zip_code: "75050",

    ste_name: "TX",
  },
  {
    zip_code: "75060",

    ste_name: "TX",
  },
  {
    zip_code: "75161",

    ste_name: "TX",
  },
  {
    zip_code: "75167",

    ste_name: "TX",
  },
  {
    zip_code: "75210",

    ste_name: "TX",
  },
  {
    zip_code: "75226",

    ste_name: "TX",
  },
  {
    zip_code: "75390",

    ste_name: "TX",
  },
  {
    zip_code: "75418",

    ste_name: "TX",
  },
  {
    zip_code: "75572",

    ste_name: "TX",
  },
  {
    zip_code: "75574",

    ste_name: "TX",
  },
  {
    zip_code: "75925",

    ste_name: "TX",
  },
  {
    zip_code: "75941",

    ste_name: "TX",
  },
  {
    zip_code: "76011",

    ste_name: "TX",
  },
  {
    zip_code: "76086",

    ste_name: "TX",
  },
  {
    zip_code: "76093",

    ste_name: "TX",
  },
  {
    zip_code: "76117",

    ste_name: "TX",
  },
  {
    zip_code: "76120",

    ste_name: "TX",
  },
  {
    zip_code: "76137",

    ste_name: "TX",
  },
  {
    zip_code: "76255",

    ste_name: "TX",
  },
  {
    zip_code: "76261",

    ste_name: "TX",
  },
  {
    zip_code: "76266",

    ste_name: "TX",
  },
  {
    zip_code: "76373",

    ste_name: "TX",
  },
  {
    zip_code: "76374",

    ste_name: "TX",
  },
  {
    zip_code: "76432",

    ste_name: "TX",
  },
  {
    zip_code: "76522",

    ste_name: "TX",
  },
  {
    zip_code: "76544",

    ste_name: "TX",
  },
  {
    zip_code: "76651",

    ste_name: "TX",
  },
  {
    zip_code: "76673",

    ste_name: "TX",
  },
  {
    zip_code: "76678",

    ste_name: "TX",
  },
  {
    zip_code: "76852",

    ste_name: "TX",
  },
  {
    zip_code: "76872",

    ste_name: "TX",
  },
  {
    zip_code: "77018",

    ste_name: "TX",
  },
  {
    zip_code: "77054",

    ste_name: "TX",
  },
  {
    zip_code: "77069",

    ste_name: "TX",
  },
  {
    zip_code: "77326",

    ste_name: "TX",
  },
  {
    zip_code: "77450",

    ste_name: "TX",
  },
  {
    zip_code: "77474",

    ste_name: "TX",
  },
  {
    zip_code: "77867",

    ste_name: "TX",
  },
  {
    zip_code: "78011",

    ste_name: "TX",
  },
  {
    zip_code: "78021",

    ste_name: "TX",
  },
  {
    zip_code: "78117",

    ste_name: "TX",
  },
  {
    zip_code: "78147",

    ste_name: "TX",
  },
  {
    zip_code: "78220",

    ste_name: "TX",
  },
  {
    zip_code: "78223",

    ste_name: "TX",
  },
  {
    zip_code: "78577",

    ste_name: "TX",
  },
  {
    zip_code: "78871",

    ste_name: "TX",
  },
  {
    zip_code: "79005",

    ste_name: "TX",
  },
  {
    zip_code: "79025",

    ste_name: "TX",
  },
  {
    zip_code: "79031",

    ste_name: "TX",
  },
  {
    zip_code: "79068",

    ste_name: "TX",
  },
  {
    zip_code: "79237",

    ste_name: "TX",
  },
  {
    zip_code: "79351",

    ste_name: "TX",
  },
  {
    zip_code: "79525",

    ste_name: "TX",
  },
  {
    zip_code: "79547",

    ste_name: "TX",
  },
  {
    zip_code: "79556",

    ste_name: "TX",
  },
  {
    zip_code: "79701",

    ste_name: "TX",
  },
  {
    zip_code: "79719",

    ste_name: "TX",
  },
  {
    zip_code: "79742",

    ste_name: "TX",
  },
  {
    zip_code: "79770",

    ste_name: "TX",
  },
  {
    zip_code: "79821",

    ste_name: "TX",
  },
  {
    zip_code: "79838",

    ste_name: "TX",
  },
  {
    zip_code: "79912",

    ste_name: "TX",
  },
  {
    zip_code: "79915",

    ste_name: "TX",
  },
  {
    zip_code: "80126",

    ste_name: "CO",
  },
  {
    zip_code: "80129",

    ste_name: "CO",
  },
  {
    zip_code: "80223",

    ste_name: "CO",
  },
  {
    zip_code: "80440",

    ste_name: "CO",
  },
  {
    zip_code: "80457",

    ste_name: "CO",
  },
  {
    zip_code: "80534",

    ste_name: "CO",
  },
  {
    zip_code: "80720",

    ste_name: "CO",
  },
  {
    zip_code: "80759",

    ste_name: "CO",
  },
  {
    zip_code: "80808",

    ste_name: "CO",
  },
  {
    zip_code: "80822",

    ste_name: "CO",
  },
  {
    zip_code: "80915",

    ste_name: "CO",
  },
  {
    zip_code: "80917",

    ste_name: "CO",
  },
  {
    zip_code: "80951",

    ste_name: "CO",
  },
  {
    zip_code: "81122",

    ste_name: "CO",
  },
  {
    zip_code: "81131",

    ste_name: "CO",
  },
  {
    zip_code: "81146",

    ste_name: "CO",
  },
  {
    zip_code: "81524",

    ste_name: "CO",
  },
  {
    zip_code: "81601",

    ste_name: "CO",
  },
  {
    zip_code: "82412",

    ste_name: "WY",
  },
  {
    zip_code: "82414",

    ste_name: "WY",
  },
  {
    zip_code: "82434",

    ste_name: "WY",
  },
  {
    zip_code: "82635",

    ste_name: "WY",
  },
  {
    zip_code: "82831",

    ste_name: "WY",
  },
  {
    zip_code: "82836",

    ste_name: "WY",
  },
  {
    zip_code: "82932",

    ste_name: "WY",
  },
  {
    zip_code: "82934",

    ste_name: "WY",
  },
  {
    zip_code: "83228",

    ste_name: "ID",
  },
  {
    zip_code: "83278",

    ste_name: "ID",
  },
  {
    zip_code: "83349",

    ste_name: "ID",
  },
  {
    zip_code: "83350",

    ste_name: "ID",
  },
  {
    zip_code: "83460",

    ste_name: "ID",
  },
  {
    zip_code: "83520",

    ste_name: "ID",
  },
  {
    zip_code: "83830",

    ste_name: "ID",
  },
  {
    zip_code: "83867",

    ste_name: "ID",
  },
  {
    zip_code: "84002",

    ste_name: "UT",
  },
  {
    zip_code: "84054",

    ste_name: "UT",
  },
  {
    zip_code: "84128",

    ste_name: "UT",
  },
  {
    zip_code: "84305",

    ste_name: "UT",
  },
  {
    zip_code: "84405",

    ste_name: "UT",
  },
  {
    zip_code: "84529",

    ste_name: "UT",
  },
  {
    zip_code: "84542",

    ste_name: "UT",
  },
  {
    zip_code: "84744",

    ste_name: "UT",
  },
  {
    zip_code: "84780",

    ste_name: "UT",
  },
  {
    zip_code: "85254",

    ste_name: "AZ",
  },
  {
    zip_code: "85337",

    ste_name: "AZ",
  },
  {
    zip_code: "85350",

    ste_name: "AZ",
  },
  {
    zip_code: "85355",

    ste_name: "AZ",
  },
  {
    zip_code: "85748",

    ste_name: "AZ",
  },
  {
    zip_code: "86036",

    ste_name: "AZ",
  },
  {
    zip_code: "86336",

    ste_name: "AZ",
  },
  {
    zip_code: "86433",

    ste_name: "AZ",
  },
  {
    zip_code: "86443",

    ste_name: "AZ",
  },
  {
    zip_code: "87029",

    ste_name: "NM",
  },
  {
    zip_code: "87051",

    ste_name: "NM",
  },
  {
    zip_code: "87064",

    ste_name: "NM",
  },
  {
    zip_code: "87120",

    ste_name: "NM",
  },
  {
    zip_code: "87419",

    ste_name: "NM",
  },
  {
    zip_code: "87524",

    ste_name: "NM",
  },
  {
    zip_code: "87577",

    ste_name: "NM",
  },
  {
    zip_code: "87937",

    ste_name: "NM",
  },
  {
    zip_code: "88032",

    ste_name: "NM",
  },
  {
    zip_code: "88115",

    ste_name: "NM",
  },
  {
    zip_code: "88135",

    ste_name: "NM",
  },
  {
    zip_code: "88252",

    ste_name: "NM",
  },
  {
    zip_code: "88337",

    ste_name: "NM",
  },
  {
    zip_code: "88410",

    ste_name: "NM",
  },
  {
    zip_code: "88414",

    ste_name: "NM",
  },
  {
    zip_code: "89085",

    ste_name: "NV",
  },
  {
    zip_code: "89119",

    ste_name: "NV",
  },
  {
    zip_code: "89402",

    ste_name: "NV",
  },
  {
    zip_code: "89834",

    ste_name: "NV",
  },
  {
    zip_code: "603",

    ste_name: "PR",
  },
  {
    zip_code: "606",

    ste_name: "PR",
  },
  {
    zip_code: "627",

    ste_name: "PR",
  },
  {
    zip_code: "669",

    ste_name: "PR",
  },
  {
    zip_code: "716",

    ste_name: "PR",
  },
  {
    zip_code: "956",

    ste_name: "PR",
  },
  {
    zip_code: "1070",

    ste_name: "MA",
  },
  {
    zip_code: "1431",

    ste_name: "MA",
  },
  {
    zip_code: "1535",

    ste_name: "MA",
  },
  {
    zip_code: "1537",

    ste_name: "MA",
  },
  {
    zip_code: "1550",

    ste_name: "MA",
  },
  {
    zip_code: "1746",

    ste_name: "MA",
  },
  {
    zip_code: "1801",

    ste_name: "MA",
  },
  {
    zip_code: "1827",

    ste_name: "MA",
  },
  {
    zip_code: "1863",

    ste_name: "MA",
  },
  {
    zip_code: "2125",

    ste_name: "MA",
  },
  {
    zip_code: "2152",

    ste_name: "MA",
  },
  {
    zip_code: "2382",

    ste_name: "MA",
  },
  {
    zip_code: "2559",

    ste_name: "MA",
  },
  {
    zip_code: "2563",

    ste_name: "MA",
  },
  {
    zip_code: "2839",

    ste_name: "RI",
  },
  {
    zip_code: "2840",

    ste_name: "RI",
  },
  {
    zip_code: "2859",

    ste_name: "RI",
  },
  {
    zip_code: "2914",

    ste_name: "RI",
  },
  {
    zip_code: "3052",

    ste_name: "NH",
  },
  {
    zip_code: "3087",

    ste_name: "NH",
  },
  {
    zip_code: "3227",

    ste_name: "NH",
  },
  {
    zip_code: "3255",

    ste_name: "NH",
  },
  {
    zip_code: "3585",

    ste_name: "NH",
  },
  {
    zip_code: "3753",

    ste_name: "NH",
  },
  {
    zip_code: "4001",

    ste_name: "ME",
  },
  {
    zip_code: "4002",

    ste_name: "ME",
  },
  {
    zip_code: "4032",

    ste_name: "ME",
  },
  {
    zip_code: "4039",

    ste_name: "ME",
  },
  {
    zip_code: "4091",

    ste_name: "ME",
  },
  {
    zip_code: "4221",

    ste_name: "ME",
  },
  {
    zip_code: "4258",

    ste_name: "ME",
  },
  {
    zip_code: "4449",

    ste_name: "ME",
  },
  {
    zip_code: "4468",

    ste_name: "ME",
  },
  {
    zip_code: "4491",

    ste_name: "ME",
  },
  {
    zip_code: "4649",

    ste_name: "ME",
  },
  {
    zip_code: "4693",

    ste_name: "ME",
  },
  {
    zip_code: "4766",

    ste_name: "ME",
  },
  {
    zip_code: "4769",

    ste_name: "ME",
  },
  {
    zip_code: "4786",

    ste_name: "ME",
  },
  {
    zip_code: "4915",

    ste_name: "ME",
  },
  {
    zip_code: "5041",

    ste_name: "VT",
  },
  {
    zip_code: "5048",

    ste_name: "VT",
  },
  {
    zip_code: "5065",

    ste_name: "VT",
  },
  {
    zip_code: "5257",

    ste_name: "VT",
  },
  {
    zip_code: "5260",

    ste_name: "VT",
  },
  {
    zip_code: "5732",

    ste_name: "VT",
  },
  {
    zip_code: "5739",

    ste_name: "VT",
  },
  {
    zip_code: "5825",

    ste_name: "VT",
  },
  {
    zip_code: "5836",

    ste_name: "VT",
  },
  {
    zip_code: "6026",

    ste_name: "CT",
  },
  {
    zip_code: "6040",

    ste_name: "CT",
  },
  {
    zip_code: "6053",

    ste_name: "CT",
  },
  {
    zip_code: "6069",

    ste_name: "CT",
  },
  {
    zip_code: "6109",

    ste_name: "CT",
  },
  {
    zip_code: "6332",

    ste_name: "CT",
  },
  {
    zip_code: "6350",

    ste_name: "CT",
  },
  {
    zip_code: "6472",

    ste_name: "CT",
  },
  {
    zip_code: "6605",

    ste_name: "CT",
  },
  {
    zip_code: "6751",

    ste_name: "CT",
  },
  {
    zip_code: "6907",

    ste_name: "CT",
  },
  {
    zip_code: "7013",

    ste_name: "NJ",
  },
  {
    zip_code: "7419",

    ste_name: "NJ",
  },
  {
    zip_code: "7446",

    ste_name: "NJ",
  },
  {
    zip_code: "7606",

    ste_name: "NJ",
  },
  {
    zip_code: "7720",

    ste_name: "NJ",
  },
  {
    zip_code: "7733",

    ste_name: "NJ",
  },
  {
    zip_code: "7926",

    ste_name: "NJ",
  },
  {
    zip_code: "7970",

    ste_name: "NJ",
  },
  {
    zip_code: "8029",

    ste_name: "NJ",
  },
  {
    zip_code: "8225",

    ste_name: "NJ",
  },
  {
    zip_code: "8326",

    ste_name: "NJ",
  },
  {
    zip_code: "8340",

    ste_name: "NJ",
  },
  {
    zip_code: "8555",

    ste_name: "NJ",
  },
  {
    zip_code: "8721",

    ste_name: "NJ",
  },
  {
    zip_code: "8723",

    ste_name: "NJ",
  },
  {
    zip_code: "10004",

    ste_name: "NY",
  },
  {
    zip_code: "10309",

    ste_name: "NY",
  },
  {
    zip_code: "10514",

    ste_name: "NY",
  },
  {
    zip_code: "10537",

    ste_name: "NY",
  },
  {
    zip_code: "10550",

    ste_name: "NY",
  },
  {
    zip_code: "10578",

    ste_name: "NY",
  },
  {
    zip_code: "11204",

    ste_name: "NY",
  },
  {
    zip_code: "11206",

    ste_name: "NY",
  },
  {
    zip_code: "11367",

    ste_name: "NY",
  },
  {
    zip_code: "11368",

    ste_name: "NY",
  },
  {
    zip_code: "11415",

    ste_name: "NY",
  },
  {
    zip_code: "11561",

    ste_name: "NY",
  },
  {
    zip_code: "11694",

    ste_name: "NY",
  },
  {
    zip_code: "11720",

    ste_name: "NY",
  },
  {
    zip_code: "11746",

    ste_name: "NY",
  },
  {
    zip_code: "11776",

    ste_name: "NY",
  },
  {
    zip_code: "11777",

    ste_name: "NY",
  },
  {
    zip_code: "11797",

    ste_name: "NY",
  },
  {
    zip_code: "11941",

    ste_name: "NY",
  },
  {
    zip_code: "12009",

    ste_name: "NY",
  },
  {
    zip_code: "12019",

    ste_name: "NY",
  },
  {
    zip_code: "12161",

    ste_name: "NY",
  },
  {
    zip_code: "12204",

    ste_name: "NY",
  },
  {
    zip_code: "12504",

    ste_name: "NY",
  },
  {
    zip_code: "12543",

    ste_name: "NY",
  },
  {
    zip_code: "12548",

    ste_name: "NY",
  },
  {
    zip_code: "12752",

    ste_name: "NY",
  },
  {
    zip_code: "12804",

    ste_name: "NY",
  },
  {
    zip_code: "12871",

    ste_name: "NY",
  },
  {
    zip_code: "12921",

    ste_name: "NY",
  },
  {
    zip_code: "12930",

    ste_name: "NY",
  },
  {
    zip_code: "12939",

    ste_name: "NY",
  },
  {
    zip_code: "12962",

    ste_name: "NY",
  },
  {
    zip_code: "13020",

    ste_name: "NY",
  },
  {
    zip_code: "13087",

    ste_name: "NY",
  },
  {
    zip_code: "13112",

    ste_name: "NY",
  },
  {
    zip_code: "13122",

    ste_name: "NY",
  },
  {
    zip_code: "13136",

    ste_name: "NY",
  },
  {
    zip_code: "13317",

    ste_name: "NY",
  },
  {
    zip_code: "13350",

    ste_name: "NY",
  },
  {
    zip_code: "13367",

    ste_name: "NY",
  },
  {
    zip_code: "13483",

    ste_name: "NY",
  },
  {
    zip_code: "13485",

    ste_name: "NY",
  },
  {
    zip_code: "13659",

    ste_name: "NY",
  },
  {
    zip_code: "13678",

    ste_name: "NY",
  },
  {
    zip_code: "13752",

    ste_name: "NY",
  },
  {
    zip_code: "13862",

    ste_name: "NY",
  },
  {
    zip_code: "14034",

    ste_name: "NY",
  },
  {
    zip_code: "14062",

    ste_name: "NY",
  },
  {
    zip_code: "14113",

    ste_name: "NY",
  },
  {
    zip_code: "14224",

    ste_name: "NY",
  },
  {
    zip_code: "14414",

    ste_name: "NY",
  },
  {
    zip_code: "14533",

    ste_name: "NY",
  },
  {
    zip_code: "14569",

    ste_name: "NY",
  },
  {
    zip_code: "14571",

    ste_name: "NY",
  },
  {
    zip_code: "14580",

    ste_name: "NY",
  },
  {
    zip_code: "14718",

    ste_name: "NY",
  },
  {
    zip_code: "14721",

    ste_name: "NY",
  },
  {
    zip_code: "14802",

    ste_name: "NY",
  },
  {
    zip_code: "14818",

    ste_name: "NY",
  },
  {
    zip_code: "14825",

    ste_name: "NY",
  },
  {
    zip_code: "14872",

    ste_name: "NY",
  },
  {
    zip_code: "14885",

    ste_name: "NY",
  },
  {
    zip_code: "14891",

    ste_name: "NY",
  },
  {
    zip_code: "14903",

    ste_name: "NY",
  },
  {
    zip_code: "15067",

    ste_name: "PA",
  },
  {
    zip_code: "15085",

    ste_name: "PA",
  },
  {
    zip_code: "15239",

    ste_name: "PA",
  },
  {
    zip_code: "15329",

    ste_name: "PA",
  },
  {
    zip_code: "15345",

    ste_name: "PA",
  },
  {
    zip_code: "15423",

    ste_name: "PA",
  },
  {
    zip_code: "15428",

    ste_name: "PA",
  },
  {
    zip_code: "15554",

    ste_name: "PA",
  },
  {
    zip_code: "15610",

    ste_name: "PA",
  },
  {
    zip_code: "15672",

    ste_name: "PA",
  },
  {
    zip_code: "15760",

    ste_name: "PA",
  },
  {
    zip_code: "15848",

    ste_name: "PA",
  },
  {
    zip_code: "15853",

    ste_name: "PA",
  },
  {
    zip_code: "15948",

    ste_name: "PA",
  },
  {
    zip_code: "16024",

    ste_name: "PA",
  },
  {
    zip_code: "16034",

    ste_name: "PA",
  },
  {
    zip_code: "16222",

    ste_name: "PA",
  },
  {
    zip_code: "16333",

    ste_name: "PA",
  },
  {
    zip_code: "16344",

    ste_name: "PA",
  },
  {
    zip_code: "16407",

    ste_name: "PA",
  },
  {
    zip_code: "16410",

    ste_name: "PA",
  },
  {
    zip_code: "16428",

    ste_name: "PA",
  },
  {
    zip_code: "16825",

    ste_name: "PA",
  },
  {
    zip_code: "16870",

    ste_name: "PA",
  },
  {
    zip_code: "16872",

    ste_name: "PA",
  },
  {
    zip_code: "16921",

    ste_name: "PA",
  },
  {
    zip_code: "17006",

    ste_name: "PA",
  },
  {
    zip_code: "17044",

    ste_name: "PA",
  },
  {
    zip_code: "17056",

    ste_name: "PA",
  },
  {
    zip_code: "17060",

    ste_name: "PA",
  },
  {
    zip_code: "17240",

    ste_name: "PA",
  },
  {
    zip_code: "17532",

    ste_name: "PA",
  },
  {
    zip_code: "17543",

    ste_name: "PA",
  },
  {
    zip_code: "17557",

    ste_name: "PA",
  },
  {
    zip_code: "17771",

    ste_name: "PA",
  },
  {
    zip_code: "17931",

    ste_name: "PA",
  },
  {
    zip_code: "17943",

    ste_name: "PA",
  },
  {
    zip_code: "17953",

    ste_name: "PA",
  },
  {
    zip_code: "17964",

    ste_name: "PA",
  },
  {
    zip_code: "17979",

    ste_name: "PA",
  },
  {
    zip_code: "18018",

    ste_name: "PA",
  },
  {
    zip_code: "18201",

    ste_name: "PA",
  },
  {
    zip_code: "18211",

    ste_name: "PA",
  },
  {
    zip_code: "18252",

    ste_name: "PA",
  },
  {
    zip_code: "18254",

    ste_name: "PA",
  },
  {
    zip_code: "18425",

    ste_name: "PA",
  },
  {
    zip_code: "18464",

    ste_name: "PA",
  },
  {
    zip_code: "18470",

    ste_name: "PA",
  },
  {
    zip_code: "18612",

    ste_name: "PA",
  },
  {
    zip_code: "18821",

    ste_name: "PA",
  },
  {
    zip_code: "18828",

    ste_name: "PA",
  },
  {
    zip_code: "18844",

    ste_name: "PA",
  },
  {
    zip_code: "18950",

    ste_name: "PA",
  },
  {
    zip_code: "18969",

    ste_name: "PA",
  },
  {
    zip_code: "19014",

    ste_name: "PA",
  },
  {
    zip_code: "19032",

    ste_name: "PA",
  },
  {
    zip_code: "19035",

    ste_name: "PA",
  },
  {
    zip_code: "19074",

    ste_name: "PA",
  },
  {
    zip_code: "19094",

    ste_name: "PA",
  },
  {
    zip_code: "19119",

    ste_name: "PA",
  },
  {
    zip_code: "19148",

    ste_name: "PA",
  },
  {
    zip_code: "19343",

    ste_name: "PA",
  },
  {
    zip_code: "19365",

    ste_name: "PA",
  },
  {
    zip_code: "19374",

    ste_name: "PA",
  },
  {
    zip_code: "19464",

    ste_name: "PA",
  },
  {
    zip_code: "19707",

    ste_name: "DE",
  },
  {
    zip_code: "19930",

    ste_name: "DE",
  },
  {
    zip_code: "19979",

    ste_name: "DE",
  },
  {
    zip_code: "20115",

    ste_name: "VA",
  },
  {
    zip_code: "20175",

    ste_name: "VA",
  },
  {
    zip_code: "20551",

    ste_name: "DC",
  },
  {
    zip_code: "20593",

    ste_name: "DC",
  },
  {
    zip_code: "20675",

    ste_name: "MD",
  },
  {
    zip_code: "20710",

    ste_name: "MD",
  },
  {
    zip_code: "20762",

    ste_name: "MD",
  },
  {
    zip_code: "20912",

    ste_name: "MD",
  },
  {
    zip_code: "21209",

    ste_name: "MD",
  },
  {
    zip_code: "21524",

    ste_name: "MD",
  },
  {
    zip_code: "21607",

    ste_name: "MD",
  },
  {
    zip_code: "21624",

    ste_name: "MD",
  },
  {
    zip_code: "21673",

    ste_name: "MD",
  },
  {
    zip_code: "21679",

    ste_name: "MD",
  },
  {
    zip_code: "21710",

    ste_name: "MD",
  },
  {
    zip_code: "21850",

    ste_name: "MD",
  },
  {
    zip_code: "21913",

    ste_name: "MD",
  },
  {
    zip_code: "21916",

    ste_name: "MD",
  },
  {
    zip_code: "21920",

    ste_name: "MD",
  },
  {
    zip_code: "22042",

    ste_name: "VA",
  },
  {
    zip_code: "22153",

    ste_name: "VA",
  },
  {
    zip_code: "22641",

    ste_name: "VA",
  },
  {
    zip_code: "22657",

    ste_name: "VA",
  },
  {
    zip_code: "22732",

    ste_name: "VA",
  },
  {
    zip_code: "23139",

    ste_name: "VA",
  },
  {
    zip_code: "23187",

    ste_name: "VA",
  },
  {
    zip_code: "23294",

    ste_name: "VA",
  },
  {
    zip_code: "23324",

    ste_name: "VA",
  },
  {
    zip_code: "23401",

    ste_name: "VA",
  },
  {
    zip_code: "23709",

    ste_name: "VA",
  },
  {
    zip_code: "23824",

    ste_name: "VA",
  },
  {
    zip_code: "23832",

    ste_name: "VA",
  },
  {
    zip_code: "23846",

    ste_name: "VA",
  },
  {
    zip_code: "23960",

    ste_name: "VA",
  },
  {
    zip_code: "23966",

    ste_name: "VA",
  },
  {
    zip_code: "24171",

    ste_name: "VA",
  },
  {
    zip_code: "24266",

    ste_name: "VA",
  },
  {
    zip_code: "24269",

    ste_name: "VA",
  },
  {
    zip_code: "24277",

    ste_name: "VA",
  },
  {
    zip_code: "24411",

    ste_name: "VA",
  },
  {
    zip_code: "24439",

    ste_name: "VA",
  },
  {
    zip_code: "24442",

    ste_name: "VA",
  },
  {
    zip_code: "24557",

    ste_name: "VA",
  },
  {
    zip_code: "24565",

    ste_name: "VA",
  },
  {
    zip_code: "24586",

    ste_name: "VA",
  },
  {
    zip_code: "24589",

    ste_name: "VA",
  },
  {
    zip_code: "24597",

    ste_name: "VA",
  },
  {
    zip_code: "24651",

    ste_name: "VA",
  },
  {
    zip_code: "24657",

    ste_name: "VA",
  },
  {
    zip_code: "24736",

    ste_name: "WV",
  },
  {
    zip_code: "24811",

    ste_name: "WV",
  },
  {
    zip_code: "24861",

    ste_name: "WV",
  },
  {
    zip_code: "24915",

    ste_name: "WV",
  },
  {
    zip_code: "25005",

    ste_name: "WV",
  },
  {
    zip_code: "25031",

    ste_name: "WV",
  },
  {
    zip_code: "25040",

    ste_name: "WV",
  },
  {
    zip_code: "25142",

    ste_name: "WV",
  },
  {
    zip_code: "25185",

    ste_name: "WV",
  },
  {
    zip_code: "25244",

    ste_name: "WV",
  },
  {
    zip_code: "25252",

    ste_name: "WV",
  },
  {
    zip_code: "25306",

    ste_name: "WV",
  },
  {
    zip_code: "25432",

    ste_name: "WV",
  },
  {
    zip_code: "25443",

    ste_name: "WV",
  },
  {
    zip_code: "25517",

    ste_name: "WV",
  },
  {
    zip_code: "25567",

    ste_name: "WV",
  },
  {
    zip_code: "25606",

    ste_name: "WV",
  },
  {
    zip_code: "25857",

    ste_name: "WV",
  },
  {
    zip_code: "25870",

    ste_name: "WV",
  },
  {
    zip_code: "25932",

    ste_name: "WV",
  },
  {
    zip_code: "26201",

    ste_name: "WV",
  },
  {
    zip_code: "26268",

    ste_name: "WV",
  },
  {
    zip_code: "26372",

    ste_name: "WV",
  },
  {
    zip_code: "27028",

    ste_name: "NC",
  },
  {
    zip_code: "27052",

    ste_name: "NC",
  },
  {
    zip_code: "27109",

    ste_name: "NC",
  },
  {
    zip_code: "27302",

    ste_name: "NC",
  },
  {
    zip_code: "27405",

    ste_name: "NC",
  },
  {
    zip_code: "27521",

    ste_name: "NC",
  },
  {
    zip_code: "27530",

    ste_name: "NC",
  },
  {
    zip_code: "27541",

    ste_name: "NC",
  },
  {
    zip_code: "27546",

    ste_name: "NC",
  },
  {
    zip_code: "27583",

    ste_name: "NC",
  },
  {
    zip_code: "27601",

    ste_name: "NC",
  },
  {
    zip_code: "27603",

    ste_name: "NC",
  },
  {
    zip_code: "27606",

    ste_name: "NC",
  },
  {
    zip_code: "27610",

    ste_name: "NC",
  },
  {
    zip_code: "27713",

    ste_name: "NC",
  },
  {
    zip_code: "27820",

    ste_name: "NC",
  },
  {
    zip_code: "27829",

    ste_name: "NC",
  },
  {
    zip_code: "27928",

    ste_name: "NC",
  },
  {
    zip_code: "27960",

    ste_name: "NC",
  },
  {
    zip_code: "28036",

    ste_name: "NC",
  },
  {
    zip_code: "28102",

    ste_name: "NC",
  },
  {
    zip_code: "28107",

    ste_name: "NC",
  },
  {
    zip_code: "28120",

    ste_name: "NC",
  },
  {
    zip_code: "28134",

    ste_name: "NC",
  },
  {
    zip_code: "28323",

    ste_name: "NC",
  },
  {
    zip_code: "28382",

    ste_name: "NC",
  },
  {
    zip_code: "28398",

    ste_name: "NC",
  },
  {
    zip_code: "28421",

    ste_name: "NC",
  },
  {
    zip_code: "28422",

    ste_name: "NC",
  },
  {
    zip_code: "28464",

    ste_name: "NC",
  },
  {
    zip_code: "28520",

    ste_name: "NC",
  },
  {
    zip_code: "28555",

    ste_name: "NC",
  },
  {
    zip_code: "28585",

    ste_name: "NC",
  },
  {
    zip_code: "28634",

    ste_name: "NC",
  },
  {
    zip_code: "28682",

    ste_name: "NC",
  },
  {
    zip_code: "28804",

    ste_name: "NC",
  },
  {
    zip_code: "29122",

    ste_name: "SC",
  },
  {
    zip_code: "29142",

    ste_name: "SC",
  },
  {
    zip_code: "29306",

    ste_name: "SC",
  },
  {
    zip_code: "29581",

    ste_name: "SC",
  },
  {
    zip_code: "29628",

    ste_name: "SC",
  },
  {
    zip_code: "29643",

    ste_name: "SC",
  },
  {
    zip_code: "29706",

    ste_name: "SC",
  },
  {
    zip_code: "29727",

    ste_name: "SC",
  },
  {
    zip_code: "29803",

    ste_name: "SC",
  },
  {
    zip_code: "29809",

    ste_name: "SC",
  },
  {
    zip_code: "29835",

    ste_name: "SC",
  },
  {
    zip_code: "29899",

    ste_name: "SC",
  },
  {
    zip_code: "29945",

    ste_name: "SC",
  },
  {
    zip_code: "30005",

    ste_name: "GA",
  },
  {
    zip_code: "30014",

    ste_name: "GA",
  },
  {
    zip_code: "30041",

    ste_name: "GA",
  },
  {
    zip_code: "30076",

    ste_name: "GA",
  },
  {
    zip_code: "30103",

    ste_name: "GA",
  },
  {
    zip_code: "30187",

    ste_name: "GA",
  },
  {
    zip_code: "30248",

    ste_name: "GA",
  },
  {
    zip_code: "30265",

    ste_name: "GA",
  },
  {
    zip_code: "30296",

    ste_name: "GA",
  },
  {
    zip_code: "30334",

    ste_name: "GA",
  },
  {
    zip_code: "30410",

    ste_name: "GA",
  },
  {
    zip_code: "30415",

    ste_name: "GA",
  },
  {
    zip_code: "30429",

    ste_name: "GA",
  },
  {
    zip_code: "30527",

    ste_name: "GA",
  },
  {
    zip_code: "30546",

    ste_name: "GA",
  },
  {
    zip_code: "30708",

    ste_name: "GA",
  },
  {
    zip_code: "30710",

    ste_name: "GA",
  },
  {
    zip_code: "30741",

    ste_name: "GA",
  },
  {
    zip_code: "90023",

    ste_name: "CA",
  },
  {
    zip_code: "90250",

    ste_name: "CA",
  },
  {
    zip_code: "90404",

    ste_name: "CA",
  },
  {
    zip_code: "90650",

    ste_name: "CA",
  },
  {
    zip_code: "90744",

    ste_name: "CA",
  },
  {
    zip_code: "90747",

    ste_name: "CA",
  },
  {
    zip_code: "91010",

    ste_name: "CA",
  },
  {
    zip_code: "91107",

    ste_name: "CA",
  },
  {
    zip_code: "91325",

    ste_name: "CA",
  },
  {
    zip_code: "91356",

    ste_name: "CA",
  },
  {
    zip_code: "91401",

    ste_name: "CA",
  },
  {
    zip_code: "91801",

    ste_name: "CA",
  },
  {
    zip_code: "92004",

    ste_name: "CA",
  },
  {
    zip_code: "92028",

    ste_name: "CA",
  },
  {
    zip_code: "92036",

    ste_name: "CA",
  },
  {
    zip_code: "92084",

    ste_name: "CA",
  },
  {
    zip_code: "92105",

    ste_name: "CA",
  },
  {
    zip_code: "92134",

    ste_name: "CA",
  },
  {
    zip_code: "92222",

    ste_name: "CA",
  },
  {
    zip_code: "92268",

    ste_name: "CA",
  },
  {
    zip_code: "92328",

    ste_name: "CA",
  },
  {
    zip_code: "92544",

    ste_name: "CA",
  },
  {
    zip_code: "92617",

    ste_name: "CA",
  },
  {
    zip_code: "92782",

    ste_name: "CA",
  },
  {
    zip_code: "93283",

    ste_name: "CA",
  },
  {
    zip_code: "93402",

    ste_name: "CA",
  },
  {
    zip_code: "93518",

    ste_name: "CA",
  },
  {
    zip_code: "93519",

    ste_name: "CA",
  },
  {
    zip_code: "93532",

    ste_name: "CA",
  },
  {
    zip_code: "93558",

    ste_name: "CA",
  },
  {
    zip_code: "93591",

    ste_name: "CA",
  },
  {
    zip_code: "93619",

    ste_name: "CA",
  },
  {
    zip_code: "93628",

    ste_name: "CA",
  },
  {
    zip_code: "93651",

    ste_name: "CA",
  },
  {
    zip_code: "93656",

    ste_name: "CA",
  },
  {
    zip_code: "93706",

    ste_name: "CA",
  },
  {
    zip_code: "94030",

    ste_name: "CA",
  },
  {
    zip_code: "94127",

    ste_name: "CA",
  },
  {
    zip_code: "94544",

    ste_name: "CA",
  },
  {
    zip_code: "94558",

    ste_name: "CA",
  },
  {
    zip_code: "94565",

    ste_name: "CA",
  },
  {
    zip_code: "94583",

    ste_name: "CA",
  },
  {
    zip_code: "94590",

    ste_name: "CA",
  },
  {
    zip_code: "94613",

    ste_name: "CA",
  },
  {
    zip_code: "94954",

    ste_name: "CA",
  },
  {
    zip_code: "95019",

    ste_name: "CA",
  },
  {
    zip_code: "95073",

    ste_name: "CA",
  },
  {
    zip_code: "95075",

    ste_name: "CA",
  },
  {
    zip_code: "95227",

    ste_name: "CA",
  },
  {
    zip_code: "95231",

    ste_name: "CA",
  },
  {
    zip_code: "95382",

    ste_name: "CA",
  },
  {
    zip_code: "95448",

    ste_name: "CA",
  },
  {
    zip_code: "95519",

    ste_name: "CA",
  },
  {
    zip_code: "95655",

    ste_name: "CA",
  },
  {
    zip_code: "95669",

    ste_name: "CA",
  },
  {
    zip_code: "95686",

    ste_name: "CA",
  },
  {
    zip_code: "95827",

    ste_name: "CA",
  },
  {
    zip_code: "95938",

    ste_name: "CA",
  },
  {
    zip_code: "95956",

    ste_name: "CA",
  },
  {
    zip_code: "96058",

    ste_name: "CA",
  },
  {
    zip_code: "96112",

    ste_name: "CA",
  },
  {
    zip_code: "96135",

    ste_name: "CA",
  },
  {
    zip_code: "96727",

    ste_name: "HI",
  },
  {
    zip_code: "96741",

    ste_name: "HI",
  },
  {
    zip_code: "97023",

    ste_name: "OR",
  },
  {
    zip_code: "97035",

    ste_name: "OR",
  },
  {
    zip_code: "97086",

    ste_name: "OR",
  },
  {
    zip_code: "97107",

    ste_name: "OR",
  },
  {
    zip_code: "97118",

    ste_name: "OR",
  },
  {
    zip_code: "97267",

    ste_name: "OR",
  },
  {
    zip_code: "97388",

    ste_name: "OR",
  },
  {
    zip_code: "97429",

    ste_name: "OR",
  },
  {
    zip_code: "97436",

    ste_name: "OR",
  },
  {
    zip_code: "97456",

    ste_name: "OR",
  },
  {
    zip_code: "97817",

    ste_name: "OR",
  },
  {
    zip_code: "97844",

    ste_name: "OR",
  },
  {
    zip_code: "97910",

    ste_name: "OR",
  },
  {
    zip_code: "98030",

    ste_name: "WA",
  },
  {
    zip_code: "98102",

    ste_name: "WA",
  },
  {
    zip_code: "98239",

    ste_name: "WA",
  },
  {
    zip_code: "98276",

    ste_name: "WA",
  },
  {
    zip_code: "98353",

    ste_name: "WA",
  },
  {
    zip_code: "98368",

    ste_name: "WA",
  },
  {
    zip_code: "92831",

    ste_name: "CA",
  },
  {
    zip_code: "92881",

    ste_name: "CA",
  },
  {
    zip_code: "93035",

    ste_name: "CA",
  },
  {
    zip_code: "93260",

    ste_name: "CA",
  },
  {
    zip_code: "93505",

    ste_name: "CA",
  },
  {
    zip_code: "98422",

    ste_name: "WA",
  },
  {
    zip_code: "98498",

    ste_name: "WA",
  },
  {
    zip_code: "98516",

    ste_name: "WA",
  },
  {
    zip_code: "98572",

    ste_name: "WA",
  },
  {
    zip_code: "98580",

    ste_name: "WA",
  },
  {
    zip_code: "98584",

    ste_name: "WA",
  },
  {
    zip_code: "98602",

    ste_name: "WA",
  },
  {
    zip_code: "98670",

    ste_name: "WA",
  },
  {
    zip_code: "98672",

    ste_name: "WA",
  },
  {
    zip_code: "98817",

    ste_name: "WA",
  },
  {
    zip_code: "99101",

    ste_name: "WA",
  },
  {
    zip_code: "99152",

    ste_name: "WA",
  },
  {
    zip_code: "99170",

    ste_name: "WA",
  },
  {
    zip_code: "99223",

    ste_name: "WA",
  },
  {
    zip_code: "99320",

    ste_name: "WA",
  },
  {
    zip_code: "99321",

    ste_name: "WA",
  },
  {
    zip_code: "99324",

    ste_name: "WA",
  },
  {
    zip_code: "99566",

    ste_name: "AK",
  },
  {
    zip_code: "99581",

    ste_name: "AK",
  },
  {
    zip_code: "99588",

    ste_name: "AK",
  },
  {
    zip_code: "99644",

    ste_name: "AK",
  },
  {
    zip_code: "99661",

    ste_name: "AK",
  },
  {
    zip_code: "99663",

    ste_name: "AK",
  },
  {
    zip_code: "99732",

    ste_name: "AK",
  },
  {
    zip_code: "99770",

    ste_name: "AK",
  },
  {
    zip_code: "99785",

    ste_name: "AK",
  },
  {
    zip_code: "670",

    ste_name: "PR",
  },
  {
    zip_code: "677",

    ste_name: "PR",
  },
  {
    zip_code: "723",

    ste_name: "PR",
  },
  {
    zip_code: "740",

    ste_name: "PR",
  },
  {
    zip_code: "772",

    ste_name: "PR",
  },
  {
    zip_code: "773",

    ste_name: "PR",
  },
  {
    zip_code: "782",

    ste_name: "PR",
  },
  {
    zip_code: "841",

    ste_name: "VI",
  },
  {
    zip_code: "924",

    ste_name: "PR",
  },
  {
    zip_code: "1066",

    ste_name: "MA",
  },
  {
    zip_code: "1093",

    ste_name: "MA",
  },
  {
    zip_code: "1301",

    ste_name: "MA",
  },
  {
    zip_code: "1344",

    ste_name: "MA",
  },
  {
    zip_code: "1347",

    ste_name: "MA",
  },
  {
    zip_code: "1568",

    ste_name: "MA",
  },
  {
    zip_code: "1757",

    ste_name: "MA",
  },
  {
    zip_code: "1773",

    ste_name: "MA",
  },
  {
    zip_code: "1880",

    ste_name: "MA",
  },
  {
    zip_code: "1913",

    ste_name: "MA",
  },
  {
    zip_code: "1966",

    ste_name: "MA",
  },
  {
    zip_code: "2071",

    ste_name: "MA",
  },
  {
    zip_code: "2090",

    ste_name: "MA",
  },
  {
    zip_code: "2375",

    ste_name: "MA",
  },
  {
    zip_code: "2478",

    ste_name: "MA",
  },
  {
    zip_code: "2492",

    ste_name: "MA",
  },
  {
    zip_code: "2644",

    ste_name: "MA",
  },
  {
    zip_code: "2726",

    ste_name: "MA",
  },
  {
    zip_code: "2760",

    ste_name: "MA",
  },
  {
    zip_code: "2764",

    ste_name: "MA",
  },
  {
    zip_code: "2836",

    ste_name: "RI",
  },
  {
    zip_code: "2881",

    ste_name: "RI",
  },
  {
    zip_code: "2896",

    ste_name: "RI",
  },
  {
    zip_code: "2912",

    ste_name: "RI",
  },
  {
    zip_code: "3101",

    ste_name: "NH",
  },
  {
    zip_code: "3576",

    ste_name: "NH",
  },
  {
    zip_code: "3751",

    ste_name: "NH",
  },
  {
    zip_code: "3779",

    ste_name: "NH",
  },
  {
    zip_code: "3782",

    ste_name: "NH",
  },
  {
    zip_code: "3867",

    ste_name: "NH",
  },
  {
    zip_code: "4017",

    ste_name: "ME",
  },
  {
    zip_code: "4021",

    ste_name: "ME",
  },
  {
    zip_code: "4024",

    ste_name: "ME",
  },
  {
    zip_code: "4029",

    ste_name: "ME",
  },
  {
    zip_code: "4069",

    ste_name: "ME",
  },
  {
    zip_code: "4096",

    ste_name: "ME",
  },
  {
    zip_code: "4107",

    ste_name: "ME",
  },
  {
    zip_code: "4413",

    ste_name: "ME",
  },
  {
    zip_code: "4469",

    ste_name: "ME",
  },
  {
    zip_code: "4495",

    ste_name: "ME",
  },
  {
    zip_code: "4535",

    ste_name: "ME",
  },
  {
    zip_code: "4734",

    ste_name: "ME",
  },
  {
    zip_code: "4750",

    ste_name: "ME",
  },
  {
    zip_code: "4773",

    ste_name: "ME",
  },
  {
    zip_code: "4785",

    ste_name: "ME",
  },
  {
    zip_code: "4923",

    ste_name: "ME",
  },
  {
    zip_code: "4971",

    ste_name: "ME",
  },
  {
    zip_code: "4984",

    ste_name: "ME",
  },
  {
    zip_code: "4992",

    ste_name: "ME",
  },
  {
    zip_code: "5062",

    ste_name: "VT",
  },
  {
    zip_code: "5151",

    ste_name: "VT",
  },
  {
    zip_code: "5253",

    ste_name: "VT",
  },
  {
    zip_code: "5404",

    ste_name: "VT",
  },
  {
    zip_code: "5461",

    ste_name: "VT",
  },
  {
    zip_code: "5653",

    ste_name: "VT",
  },
  {
    zip_code: "5678",

    ste_name: "VT",
  },
  {
    zip_code: "5857",

    ste_name: "VT",
  },
  {
    zip_code: "6020",

    ste_name: "CT",
  },
  {
    zip_code: "6074",

    ste_name: "CT",
  },
  {
    zip_code: "6354",

    ste_name: "CT",
  },
  {
    zip_code: "6370",

    ste_name: "CT",
  },
  {
    zip_code: "6516",

    ste_name: "CT",
  },
  {
    zip_code: "6705",

    ste_name: "CT",
  },
  {
    zip_code: "6784",

    ste_name: "CT",
  },
  {
    zip_code: "7002",

    ste_name: "NJ",
  },
  {
    zip_code: "7310",

    ste_name: "NJ",
  },
  {
    zip_code: "7508",

    ste_name: "NJ",
  },
  {
    zip_code: "7701",

    ste_name: "NJ",
  },
  {
    zip_code: "7801",

    ste_name: "NJ",
  },
  {
    zip_code: "8015",

    ste_name: "NJ",
  },
  {
    zip_code: "8019",

    ste_name: "NJ",
  },
  {
    zip_code: "8021",

    ste_name: "NJ",
  },
  {
    zip_code: "8083",

    ste_name: "NJ",
  },
  {
    zip_code: "8558",

    ste_name: "NJ",
  },
  {
    zip_code: "8559",

    ste_name: "NJ",
  },
  {
    zip_code: "8561",

    ste_name: "NJ",
  },
  {
    zip_code: "8629",

    ste_name: "NJ",
  },
  {
    zip_code: "8648",

    ste_name: "NJ",
  },
  {
    zip_code: "8722",

    ste_name: "NJ",
  },
  {
    zip_code: "8820",

    ste_name: "NJ",
  },
  {
    zip_code: "8821",

    ste_name: "NJ",
  },
  {
    zip_code: "8825",

    ste_name: "NJ",
  },
  {
    zip_code: "10044",

    ste_name: "NY",
  },
  {
    zip_code: "10170",

    ste_name: "NY",
  },
  {
    zip_code: "10271",

    ste_name: "NY",
  },
  {
    zip_code: "10462",

    ste_name: "NY",
  },
  {
    zip_code: "10603",

    ste_name: "NY",
  },
  {
    zip_code: "10803",

    ste_name: "NY",
  },
  {
    zip_code: "10917",

    ste_name: "NY",
  },
  {
    zip_code: "10920",

    ste_name: "NY",
  },
  {
    zip_code: "10983",

    ste_name: "NY",
  },
  {
    zip_code: "11239",

    ste_name: "NY",
  },
  {
    zip_code: "11357",

    ste_name: "NY",
  },
  {
    zip_code: "11365",

    ste_name: "NY",
  },
  {
    zip_code: "11514",

    ste_name: "NY",
  },
  {
    zip_code: "11549",

    ste_name: "NY",
  },
  {
    zip_code: "11568",

    ste_name: "NY",
  },
  {
    zip_code: "11714",

    ste_name: "NY",
  },
  {
    zip_code: "11730",

    ste_name: "NY",
  },
  {
    zip_code: "11792",

    ste_name: "NY",
  },
  {
    zip_code: "11954",

    ste_name: "NY",
  },
  {
    zip_code: "12106",

    ste_name: "NY",
  },
  {
    zip_code: "12122",

    ste_name: "NY",
  },
  {
    zip_code: "12151",

    ste_name: "NY",
  },
  {
    zip_code: "12183",

    ste_name: "NY",
  },
  {
    zip_code: "12302",

    ste_name: "NY",
  },
  {
    zip_code: "12430",

    ste_name: "NY",
  },
  {
    zip_code: "12474",

    ste_name: "NY",
  },
  {
    zip_code: "12526",

    ste_name: "NY",
  },
  {
    zip_code: "12530",

    ste_name: "NY",
  },
  {
    zip_code: "12724",

    ste_name: "NY",
  },
  {
    zip_code: "12762",

    ste_name: "NY",
  },
  {
    zip_code: "12810",

    ste_name: "NY",
  },
  {
    zip_code: "12833",

    ste_name: "NY",
  },
  {
    zip_code: "12839",

    ste_name: "NY",
  },
  {
    zip_code: "12859",

    ste_name: "NY",
  },
  {
    zip_code: "12863",

    ste_name: "NY",
  },
  {
    zip_code: "12874",

    ste_name: "NY",
  },
  {
    zip_code: "12929",

    ste_name: "NY",
  },
  {
    zip_code: "12961",

    ste_name: "NY",
  },
  {
    zip_code: "12986",

    ste_name: "NY",
  },
  {
    zip_code: "13054",

    ste_name: "NY",
  },
  {
    zip_code: "13060",

    ste_name: "NY",
  },
  {
    zip_code: "13066",

    ste_name: "NY",
  },
  {
    zip_code: "13113",

    ste_name: "NY",
  },
  {
    zip_code: "13145",

    ste_name: "NY",
  },
  {
    zip_code: "13310",

    ste_name: "NY",
  },
  {
    zip_code: "13355",

    ste_name: "NY",
  },
  {
    zip_code: "13441",

    ste_name: "NY",
  },
  {
    zip_code: "13502",

    ste_name: "NY",
  },
  {
    zip_code: "13612",

    ste_name: "NY",
  },
  {
    zip_code: "13654",

    ste_name: "NY",
  },
  {
    zip_code: "13777",

    ste_name: "NY",
  },
  {
    zip_code: "13778",

    ste_name: "NY",
  },
  {
    zip_code: "13839",

    ste_name: "NY",
  },
  {
    zip_code: "14036",

    ste_name: "NY",
  },
  {
    zip_code: "14063",

    ste_name: "NY",
  },
  {
    zip_code: "14081",

    ste_name: "NY",
  },
  {
    zip_code: "14098",

    ste_name: "NY",
  },
  {
    zip_code: "14102",

    ste_name: "NY",
  },
  {
    zip_code: "14139",

    ste_name: "NY",
  },
  {
    zip_code: "14211",

    ste_name: "NY",
  },
  {
    zip_code: "14418",

    ste_name: "NY",
  },
  {
    zip_code: "14506",

    ste_name: "NY",
  },
  {
    zip_code: "14710",

    ste_name: "NY",
  },
  {
    zip_code: "14722",

    ste_name: "NY",
  },
  {
    zip_code: "14750",

    ste_name: "NY",
  },
  {
    zip_code: "14779",

    ste_name: "NY",
  },
  {
    zip_code: "14858",

    ste_name: "NY",
  },
  {
    zip_code: "14859",

    ste_name: "NY",
  },
  {
    zip_code: "15112",

    ste_name: "PA",
  },
  {
    zip_code: "15334",

    ste_name: "PA",
  },
  {
    zip_code: "15351",

    ste_name: "PA",
  },
  {
    zip_code: "15360",

    ste_name: "PA",
  },
  {
    zip_code: "15425",

    ste_name: "PA",
  },
  {
    zip_code: "15533",

    ste_name: "PA",
  },
  {
    zip_code: "15545",

    ste_name: "PA",
  },
  {
    zip_code: "15564",

    ste_name: "PA",
  },
  {
    zip_code: "15634",

    ste_name: "PA",
  },
  {
    zip_code: "15752",

    ste_name: "PA",
  },
  {
    zip_code: "15841",

    ste_name: "PA",
  },
  {
    zip_code: "15940",

    ste_name: "PA",
  },
  {
    zip_code: "15952",

    ste_name: "PA",
  },
  {
    zip_code: "16049",

    ste_name: "PA",
  },
  {
    zip_code: "16054",

    ste_name: "PA",
  },
  {
    zip_code: "16124",

    ste_name: "PA",
  },
  {
    zip_code: "16137",

    ste_name: "PA",
  },
  {
    zip_code: "16143",

    ste_name: "PA",
  },
  {
    zip_code: "16258",

    ste_name: "PA",
  },
  {
    zip_code: "16627",

    ste_name: "PA",
  },
  {
    zip_code: "16657",

    ste_name: "PA",
  },
  {
    zip_code: "16693",

    ste_name: "PA",
  },
  {
    zip_code: "17026",

    ste_name: "PA",
  },
  {
    zip_code: "17063",

    ste_name: "PA",
  },
  {
    zip_code: "17066",

    ste_name: "PA",
  },
  {
    zip_code: "17073",

    ste_name: "PA",
  },
  {
    zip_code: "17101",

    ste_name: "PA",
  },
  {
    zip_code: "17217",

    ste_name: "PA",
  },
  {
    zip_code: "17249",

    ste_name: "PA",
  },
  {
    zip_code: "17370",

    ste_name: "PA",
  },
  {
    zip_code: "17520",

    ste_name: "PA",
  },
  {
    zip_code: "17545",

    ste_name: "PA",
  },
  {
    zip_code: "17578",

    ste_name: "PA",
  },
  {
    zip_code: "17768",

    ste_name: "PA",
  },
  {
    zip_code: "17870",

    ste_name: "PA",
  },
  {
    zip_code: "18013",

    ste_name: "PA",
  },
  {
    zip_code: "18105",

    ste_name: "PA",
  },
  {
    zip_code: "18220",

    ste_name: "PA",
  },
  {
    zip_code: "18244",

    ste_name: "PA",
  },
  {
    zip_code: "18372",

    ste_name: "PA",
  },
  {
    zip_code: "18430",

    ste_name: "PA",
  },
  {
    zip_code: "18456",

    ste_name: "PA",
  },
  {
    zip_code: "18472",

    ste_name: "PA",
  },
  {
    zip_code: "18622",

    ste_name: "PA",
  },
  {
    zip_code: "18629",

    ste_name: "PA",
  },
  {
    zip_code: "18925",

    ste_name: "PA",
  },
  {
    zip_code: "18932",

    ste_name: "PA",
  },
  {
    zip_code: "19031",

    ste_name: "PA",
  },
  {
    zip_code: "19047",

    ste_name: "PA",
  },
  {
    zip_code: "19113",

    ste_name: "PA",
  },
  {
    zip_code: "19330",

    ste_name: "PA",
  },
  {
    zip_code: "19362",

    ste_name: "PA",
  },
  {
    zip_code: "19525",

    ste_name: "PA",
  },
  {
    zip_code: "19565",

    ste_name: "PA",
  },
  {
    zip_code: "19713",

    ste_name: "DE",
  },
  {
    zip_code: "19720",

    ste_name: "DE",
  },
  {
    zip_code: "19733",

    ste_name: "DE",
  },
  {
    zip_code: "19962",

    ste_name: "DE",
  },
  {
    zip_code: "20117",

    ste_name: "VA",
  },
  {
    zip_code: "20186",

    ste_name: "VA",
  },
  {
    zip_code: "20197",

    ste_name: "VA",
  },
  {
    zip_code: "20202",

    ste_name: "DC",
  },
  {
    zip_code: "20240",

    ste_name: "DC",
  },
  {
    zip_code: "20319",

    ste_name: "DC",
  },
  {
    zip_code: "20540",

    ste_name: "DC",
  },
  {
    zip_code: "20621",

    ste_name: "MD",
  },
  {
    zip_code: "20637",

    ste_name: "MD",
  },
  {
    zip_code: "20667",

    ste_name: "MD",
  },
  {
    zip_code: "20721",

    ste_name: "MD",
  },
  {
    zip_code: "20860",

    ste_name: "MD",
  },
  {
    zip_code: "20905",

    ste_name: "MD",
  },
  {
    zip_code: "21010",

    ste_name: "MD",
  },
  {
    zip_code: "21017",

    ste_name: "MD",
  },
  {
    zip_code: "21051",

    ste_name: "MD",
  },
  {
    zip_code: "21078",

    ste_name: "MD",
  },
  {
    zip_code: "21160",

    ste_name: "MD",
  },
  {
    zip_code: "21522",

    ste_name: "MD",
  },
  {
    zip_code: "21672",

    ste_name: "MD",
  },
  {
    zip_code: "21756",

    ste_name: "MD",
  },
  {
    zip_code: "21824",

    ste_name: "MD",
  },
  {
    zip_code: "21861",

    ste_name: "MD",
  },
  {
    zip_code: "21902",

    ste_name: "MD",
  },
  {
    zip_code: "21914",

    ste_name: "MD",
  },
  {
    zip_code: "22302",

    ste_name: "VA",
  },
  {
    zip_code: "22508",

    ste_name: "VA",
  },
  {
    zip_code: "22611",

    ste_name: "VA",
  },
  {
    zip_code: "22729",

    ste_name: "VA",
  },
  {
    zip_code: "22735",

    ste_name: "VA",
  },
  {
    zip_code: "22815",

    ste_name: "VA",
  },
  {
    zip_code: "22937",

    ste_name: "VA",
  },
  {
    zip_code: "22958",

    ste_name: "VA",
  },
  {
    zip_code: "23085",

    ste_name: "VA",
  },
  {
    zip_code: "23124",

    ste_name: "VA",
  },
  {
    zip_code: "23185",

    ste_name: "VA",
  },
  {
    zip_code: "23314",

    ste_name: "VA",
  },
  {
    zip_code: "23321",

    ste_name: "VA",
  },
  {
    zip_code: "23322",

    ste_name: "VA",
  },
  {
    zip_code: "23410",

    ste_name: "VA",
  },
  {
    zip_code: "23413",

    ste_name: "VA",
  },
  {
    zip_code: "23426",

    ste_name: "VA",
  },
  {
    zip_code: "23453",

    ste_name: "VA",
  },
  {
    zip_code: "23511",

    ste_name: "VA",
  },
  {
    zip_code: "23523",

    ste_name: "VA",
  },
  {
    zip_code: "23601",

    ste_name: "VA",
  },
  {
    zip_code: "23651",

    ste_name: "VA",
  },
  {
    zip_code: "23665",

    ste_name: "VA",
  },
  {
    zip_code: "23693",

    ste_name: "VA",
  },
  {
    zip_code: "23703",

    ste_name: "VA",
  },
  {
    zip_code: "23704",

    ste_name: "VA",
  },
  {
    zip_code: "23838",

    ste_name: "VA",
  },
  {
    zip_code: "23847",

    ste_name: "VA",
  },
  {
    zip_code: "23920",

    ste_name: "VA",
  },
  {
    zip_code: "23927",

    ste_name: "VA",
  },
  {
    zip_code: "24072",

    ste_name: "VA",
  },
  {
    zip_code: "24368",

    ste_name: "VA",
  },
  {
    zip_code: "24374",

    ste_name: "VA",
  },
  {
    zip_code: "24473",

    ste_name: "VA",
  },
  {
    zip_code: "24477",

    ste_name: "VA",
  },
  {
    zip_code: "24726",

    ste_name: "WV",
  },
  {
    zip_code: "24815",

    ste_name: "WV",
  },
  {
    zip_code: "24853",

    ste_name: "WV",
  },
  {
    zip_code: "24873",

    ste_name: "WV",
  },
  {
    zip_code: "24880",

    ste_name: "WV",
  },
  {
    zip_code: "24962",

    ste_name: "WV",
  },
  {
    zip_code: "25025",

    ste_name: "WV",
  },
  {
    zip_code: "25090",

    ste_name: "WV",
  },
  {
    zip_code: "25248",

    ste_name: "WV",
  },
  {
    zip_code: "25270",

    ste_name: "WV",
  },
  {
    zip_code: "25559",

    ste_name: "WV",
  },
  {
    zip_code: "25621",

    ste_name: "WV",
  },
  {
    zip_code: "25666",

    ste_name: "WV",
  },
  {
    zip_code: "25862",

    ste_name: "WV",
  },
  {
    zip_code: "26037",

    ste_name: "WV",
  },
  {
    zip_code: "26206",

    ste_name: "WV",
  },
  {
    zip_code: "26234",

    ste_name: "WV",
  },
  {
    zip_code: "26257",

    ste_name: "WV",
  },
  {
    zip_code: "26259",

    ste_name: "WV",
  },
  {
    zip_code: "26366",

    ste_name: "WV",
  },
  {
    zip_code: "26408",

    ste_name: "WV",
  },
  {
    zip_code: "26422",

    ste_name: "WV",
  },
  {
    zip_code: "26430",

    ste_name: "WV",
  },
  {
    zip_code: "26617",

    ste_name: "WV",
  },
  {
    zip_code: "27019",

    ste_name: "NC",
  },
  {
    zip_code: "27045",

    ste_name: "NC",
  },
  {
    zip_code: "27055",

    ste_name: "NC",
  },
  {
    zip_code: "27229",

    ste_name: "NC",
  },
  {
    zip_code: "27315",

    ste_name: "NC",
  },
  {
    zip_code: "27326",

    ste_name: "NC",
  },
  {
    zip_code: "27572",

    ste_name: "NC",
  },
  {
    zip_code: "27605",

    ste_name: "NC",
  },
  {
    zip_code: "27845",

    ste_name: "NC",
  },
  {
    zip_code: "27861",

    ste_name: "NC",
  },
  {
    zip_code: "27892",

    ste_name: "NC",
  },
  {
    zip_code: "27920",

    ste_name: "NC",
  },
  {
    zip_code: "27936",

    ste_name: "NC",
  },
  {
    zip_code: "27942",

    ste_name: "NC",
  },
  {
    zip_code: "27954",

    ste_name: "NC",
  },
  {
    zip_code: "27965",

    ste_name: "NC",
  },
  {
    zip_code: "27970",

    ste_name: "NC",
  },
  {
    zip_code: "28205",

    ste_name: "NC",
  },
  {
    zip_code: "28330",

    ste_name: "NC",
  },
  {
    zip_code: "28343",

    ste_name: "NC",
  },
  {
    zip_code: "28360",

    ste_name: "NC",
  },
  {
    zip_code: "28372",

    ste_name: "NC",
  },
  {
    zip_code: "28409",

    ste_name: "NC",
  },
  {
    zip_code: "28444",

    ste_name: "NC",
  },
  {
    zip_code: "28452",

    ste_name: "NC",
  },
  {
    zip_code: "28513",

    ste_name: "NC",
  },
  {
    zip_code: "28532",

    ste_name: "NC",
  },
  {
    zip_code: "28554",

    ste_name: "NC",
  },
  {
    zip_code: "28607",

    ste_name: "NC",
  },
  {
    zip_code: "28693",

    ste_name: "NC",
  },
  {
    zip_code: "28718",

    ste_name: "NC",
  },
  {
    zip_code: "28781",

    ste_name: "NC",
  },
  {
    zip_code: "29081",

    ste_name: "SC",
  },
  {
    zip_code: "29123",

    ste_name: "SC",
  },
  {
    zip_code: "29150",

    ste_name: "SC",
  },
  {
    zip_code: "29370",

    ste_name: "SC",
  },
  {
    zip_code: "29374",

    ste_name: "SC",
  },
  {
    zip_code: "29379",

    ste_name: "SC",
  },
  {
    zip_code: "29540",

    ste_name: "SC",
  },
  {
    zip_code: "29541",

    ste_name: "SC",
  },
  {
    zip_code: "29569",

    ste_name: "SC",
  },
  {
    zip_code: "29630",

    ste_name: "SC",
  },
  {
    zip_code: "29686",

    ste_name: "SC",
  },
  {
    zip_code: "29840",

    ste_name: "SC",
  },
  {
    zip_code: "29843",

    ste_name: "SC",
  },
  {
    zip_code: "29904",

    ste_name: "SC",
  },
  {
    zip_code: "30016",

    ste_name: "GA",
  },
  {
    zip_code: "30033",

    ste_name: "GA",
  },
  {
    zip_code: "30038",

    ste_name: "GA",
  },
  {
    zip_code: "30088",

    ste_name: "GA",
  },
  {
    zip_code: "30170",

    ste_name: "GA",
  },
  {
    zip_code: "30222",

    ste_name: "GA",
  },
  {
    zip_code: "30303",

    ste_name: "GA",
  },
  {
    zip_code: "30329",

    ste_name: "GA",
  },
  {
    zip_code: "30363",

    ste_name: "GA",
  },
  {
    zip_code: "30456",

    ste_name: "GA",
  },
  {
    zip_code: "30582",

    ste_name: "GA",
  },
  {
    zip_code: "30609",

    ste_name: "GA",
  },
  {
    zip_code: "30665",

    ste_name: "GA",
  },
  {
    zip_code: "30707",

    ste_name: "GA",
  },
  {
    zip_code: "30815",

    ste_name: "GA",
  },
  {
    zip_code: "30828",

    ste_name: "GA",
  },
  {
    zip_code: "30909",

    ste_name: "GA",
  },
  {
    zip_code: "30912",

    ste_name: "GA",
  },
  {
    zip_code: "31022",

    ste_name: "GA",
  },
  {
    zip_code: "31033",

    ste_name: "GA",
  },
  {
    zip_code: "31044",

    ste_name: "GA",
  },
  {
    zip_code: "31066",

    ste_name: "GA",
  },
  {
    zip_code: "31324",

    ste_name: "GA",
  },
  {
    zip_code: "31328",

    ste_name: "GA",
  },
  {
    zip_code: "31524",

    ste_name: "GA",
  },
  {
    zip_code: "31552",

    ste_name: "GA",
  },
  {
    zip_code: "31555",

    ste_name: "GA",
  },
  {
    zip_code: "31707",

    ste_name: "GA",
  },
  {
    zip_code: "31744",

    ste_name: "GA",
  },
  {
    zip_code: "31757",

    ste_name: "GA",
  },
  {
    zip_code: "31779",

    ste_name: "GA",
  },
  {
    zip_code: "31781",

    ste_name: "GA",
  },
  {
    zip_code: "31787",

    ste_name: "GA",
  },
  {
    zip_code: "31789",

    ste_name: "GA",
  },
  {
    zip_code: "31793",

    ste_name: "GA",
  },
  {
    zip_code: "31801",

    ste_name: "GA",
  },
  {
    zip_code: "32130",

    ste_name: "FL",
  },
  {
    zip_code: "32136",

    ste_name: "FL",
  },
  {
    zip_code: "32352",

    ste_name: "FL",
  },
  {
    zip_code: "32435",

    ste_name: "FL",
  },
  {
    zip_code: "32439",

    ste_name: "FL",
  },
  {
    zip_code: "32533",

    ste_name: "FL",
  },
  {
    zip_code: "32625",

    ste_name: "FL",
  },
  {
    zip_code: "32666",

    ste_name: "FL",
  },
  {
    zip_code: "32680",

    ste_name: "FL",
  },
  {
    zip_code: "33062",

    ste_name: "FL",
  },
  {
    zip_code: "33073",

    ste_name: "FL",
  },
  {
    zip_code: "33162",

    ste_name: "FL",
  },
  {
    zip_code: "33167",

    ste_name: "FL",
  },
  {
    zip_code: "33470",

    ste_name: "FL",
  },
  {
    zip_code: "33513",

    ste_name: "FL",
  },
  {
    zip_code: "33621",

    ste_name: "FL",
  },
  {
    zip_code: "33709",

    ste_name: "FL",
  },
  {
    zip_code: "33711",

    ste_name: "FL",
  },
  {
    zip_code: "33770",

    ste_name: "FL",
  },
  {
    zip_code: "33990",

    ste_name: "FL",
  },
  {
    zip_code: "34209",

    ste_name: "FL",
  },
  {
    zip_code: "34420",

    ste_name: "FL",
  },
  {
    zip_code: "34476",

    ste_name: "FL",
  },
  {
    zip_code: "34669",

    ste_name: "FL",
  },
  {
    zip_code: "34753",

    ste_name: "FL",
  },
  {
    zip_code: "34756",

    ste_name: "FL",
  },
  {
    zip_code: "34956",

    ste_name: "FL",
  },
  {
    zip_code: "35005",

    ste_name: "AL",
  },
  {
    zip_code: "35045",

    ste_name: "AL",
  },
  {
    zip_code: "35055",

    ste_name: "AL",
  },
  {
    zip_code: "35115",

    ste_name: "AL",
  },
  {
    zip_code: "35218",

    ste_name: "AL",
  },
  {
    zip_code: "35406",

    ste_name: "AL",
  },
  {
    zip_code: "35541",

    ste_name: "AL",
  },
  {
    zip_code: "35546",

    ste_name: "AL",
  },
  {
    zip_code: "35661",

    ste_name: "AL",
  },
  {
    zip_code: "35971",

    ste_name: "AL",
  },
  {
    zip_code: "36027",

    ste_name: "AL",
  },
  {
    zip_code: "36034",

    ste_name: "AL",
  },
  {
    zip_code: "36042",

    ste_name: "AL",
  },
  {
    zip_code: "36078",

    ste_name: "AL",
  },
  {
    zip_code: "36113",

    ste_name: "AL",
  },
  {
    zip_code: "36310",

    ste_name: "AL",
  },
  {
    zip_code: "36330",

    ste_name: "AL",
  },
  {
    zip_code: "36351",

    ste_name: "AL",
  },
  {
    zip_code: "36444",

    ste_name: "AL",
  },
  {
    zip_code: "36548",

    ste_name: "AL",
  },
  {
    zip_code: "36584",

    ste_name: "AL",
  },
  {
    zip_code: "36612",

    ste_name: "AL",
  },
  {
    zip_code: "36801",

    ste_name: "AL",
  },
  {
    zip_code: "36904",

    ste_name: "AL",
  },
  {
    zip_code: "37022",

    ste_name: "TN",
  },
  {
    zip_code: "37029",

    ste_name: "TN",
  },
  {
    zip_code: "37040",

    ste_name: "TN",
  },
  {
    zip_code: "37052",

    ste_name: "TN",
  },
  {
    zip_code: "37069",

    ste_name: "TN",
  },
  {
    zip_code: "37122",

    ste_name: "TN",
  },
  {
    zip_code: "37214",

    ste_name: "TN",
  },
  {
    zip_code: "37240",

    ste_name: "TN",
  },
  {
    zip_code: "37312",

    ste_name: "TN",
  },
  {
    zip_code: "37403",

    ste_name: "TN",
  },
  {
    zip_code: "37604",

    ste_name: "TN",
  },
  {
    zip_code: "37645",

    ste_name: "TN",
  },
  {
    zip_code: "37737",

    ste_name: "TN",
  },
  {
    zip_code: "37763",

    ste_name: "TN",
  },
  {
    zip_code: "38119",

    ste_name: "TN",
  },
  {
    zip_code: "38254",

    ste_name: "TN",
  },
  {
    zip_code: "38301",

    ste_name: "TN",
  },
  {
    zip_code: "38311",

    ste_name: "TN",
  },
  {
    zip_code: "38328",

    ste_name: "TN",
  },
  {
    zip_code: "38345",

    ste_name: "TN",
  },
  {
    zip_code: "38366",

    ste_name: "TN",
  },
  {
    zip_code: "38468",

    ste_name: "TN",
  },
  {
    zip_code: "38474",

    ste_name: "TN",
  },
  {
    zip_code: "38482",

    ste_name: "TN",
  },
  {
    zip_code: "38505",

    ste_name: "TN",
  },
  {
    zip_code: "38558",

    ste_name: "TN",
  },
  {
    zip_code: "38572",

    ste_name: "TN",
  },
  {
    zip_code: "38659",

    ste_name: "MS",
  },
  {
    zip_code: "38751",

    ste_name: "MS",
  },
  {
    zip_code: "38767",

    ste_name: "MS",
  },
  {
    zip_code: "38864",

    ste_name: "MS",
  },
  {
    zip_code: "38917",

    ste_name: "MS",
  },
  {
    zip_code: "38941",

    ste_name: "MS",
  },
  {
    zip_code: "39149",

    ste_name: "MS",
  },
  {
    zip_code: "39193",

    ste_name: "MS",
  },
  {
    zip_code: "39204",

    ste_name: "MS",
  },
  {
    zip_code: "39307",

    ste_name: "MS",
  },
  {
    zip_code: "39342",

    ste_name: "MS",
  },
  {
    zip_code: "39352",

    ste_name: "MS",
  },
  {
    zip_code: "39478",

    ste_name: "MS",
  },
  {
    zip_code: "39762",

    ste_name: "MS",
  },
  {
    zip_code: "39771",

    ste_name: "MS",
  },
  {
    zip_code: "39825",

    ste_name: "GA",
  },
  {
    zip_code: "39837",

    ste_name: "GA",
  },
  {
    zip_code: "39861",

    ste_name: "GA",
  },
  {
    zip_code: "40060",

    ste_name: "KY",
  },
  {
    zip_code: "40207",

    ste_name: "KY",
  },
  {
    zip_code: "40350",

    ste_name: "KY",
  },
  {
    zip_code: "40422",

    ste_name: "KY",
  },
  {
    zip_code: "40913",

    ste_name: "KY",
  },
  {
    zip_code: "40965",

    ste_name: "KY",
  },
  {
    zip_code: "41064",

    ste_name: "KY",
  },
  {
    zip_code: "41465",

    ste_name: "KY",
  },
  {
    zip_code: "41514",

    ste_name: "KY",
  },
  {
    zip_code: "41812",

    ste_name: "KY",
  },
  {
    zip_code: "41848",

    ste_name: "KY",
  },
  {
    zip_code: "42024",

    ste_name: "KY",
  },
  {
    zip_code: "42069",

    ste_name: "KY",
  },
  {
    zip_code: "42159",

    ste_name: "KY",
  },
  {
    zip_code: "42164",

    ste_name: "KY",
  },
  {
    zip_code: "42320",

    ste_name: "KY",
  },
  {
    zip_code: "42634",

    ste_name: "KY",
  },
  {
    zip_code: "42701",

    ste_name: "KY",
  },
  {
    zip_code: "42721",

    ste_name: "KY",
  },
  {
    zip_code: "43022",

    ste_name: "OH",
  },
  {
    zip_code: "43113",

    ste_name: "OH",
  },
  {
    zip_code: "43115",

    ste_name: "OH",
  },
  {
    zip_code: "43125",

    ste_name: "OH",
  },
  {
    zip_code: "43136",

    ste_name: "OH",
  },
  {
    zip_code: "43137",

    ste_name: "OH",
  },
  {
    zip_code: "43150",

    ste_name: "OH",
  },
  {
    zip_code: "43321",

    ste_name: "OH",
  },
  {
    zip_code: "43407",

    ste_name: "OH",
  },
  {
    zip_code: "43442",

    ste_name: "OH",
  },
  {
    zip_code: "43447",

    ste_name: "OH",
  },
  {
    zip_code: "43505",

    ste_name: "OH",
  },
  {
    zip_code: "43516",

    ste_name: "OH",
  },
  {
    zip_code: "43566",

    ste_name: "OH",
  },
  {
    zip_code: "43616",

    ste_name: "OH",
  },
  {
    zip_code: "43701",

    ste_name: "OH",
  },
  {
    zip_code: "43722",

    ste_name: "OH",
  },
  {
    zip_code: "43724",

    ste_name: "OH",
  },
  {
    zip_code: "43779",

    ste_name: "OH",
  },
  {
    zip_code: "43837",

    ste_name: "OH",
  },
  {
    zip_code: "43953",

    ste_name: "OH",
  },
  {
    zip_code: "43964",

    ste_name: "OH",
  },
  {
    zip_code: "43971",

    ste_name: "OH",
  },
  {
    zip_code: "44086",

    ste_name: "OH",
  },
  {
    zip_code: "44107",

    ste_name: "OH",
  },
  {
    zip_code: "44129",

    ste_name: "OH",
  },
  {
    zip_code: "44223",

    ste_name: "OH",
  },
  {
    zip_code: "44235",

    ste_name: "OH",
  },
  {
    zip_code: "44256",

    ste_name: "OH",
  },
  {
    zip_code: "44632",

    ste_name: "OH",
  },
  {
    zip_code: "44682",

    ste_name: "OH",
  },
  {
    zip_code: "44695",

    ste_name: "OH",
  },
  {
    zip_code: "45219",

    ste_name: "OH",
  },
  {
    zip_code: "45304",

    ste_name: "OH",
  },
  {
    zip_code: "45327",

    ste_name: "OH",
  },
  {
    zip_code: "45362",

    ste_name: "OH",
  },
  {
    zip_code: "45506",

    ste_name: "OH",
  },
  {
    zip_code: "45660",

    ste_name: "OH",
  },
  {
    zip_code: "45761",

    ste_name: "OH",
  },
  {
    zip_code: "45767",

    ste_name: "OH",
  },
  {
    zip_code: "45786",

    ste_name: "OH",
  },
  {
    zip_code: "45831",

    ste_name: "OH",
  },
  {
    zip_code: "46064",

    ste_name: "IN",
  },
  {
    zip_code: "46127",

    ste_name: "IN",
  },
  {
    zip_code: "46135",

    ste_name: "IN",
  },
  {
    zip_code: "46180",

    ste_name: "IN",
  },
  {
    zip_code: "46205",

    ste_name: "IN",
  },
  {
    zip_code: "46216",

    ste_name: "IN",
  },
  {
    zip_code: "46382",

    ste_name: "IN",
  },
  {
    zip_code: "46506",

    ste_name: "IN",
  },
  {
    zip_code: "46601",

    ste_name: "IN",
  },
  {
    zip_code: "47011",

    ste_name: "IN",
  },
  {
    zip_code: "47020",

    ste_name: "IN",
  },
  {
    zip_code: "47023",

    ste_name: "IN",
  },
  {
    zip_code: "47043",

    ste_name: "IN",
  },
  {
    zip_code: "47360",

    ste_name: "IN",
  },
  {
    zip_code: "47382",

    ste_name: "IN",
  },
  {
    zip_code: "47405",

    ste_name: "IN",
  },
  {
    zip_code: "47437",

    ste_name: "IN",
  },
  {
    zip_code: "47441",

    ste_name: "IN",
  },
  {
    zip_code: "47527",

    ste_name: "IN",
  },
  {
    zip_code: "47546",

    ste_name: "IN",
  },
  {
    zip_code: "47579",

    ste_name: "IN",
  },
  {
    zip_code: "47860",

    ste_name: "IN",
  },
  {
    zip_code: "47930",

    ste_name: "IN",
  },
  {
    zip_code: "48033",

    ste_name: "MI",
  },
  {
    zip_code: "48036",

    ste_name: "MI",
  },
  {
    zip_code: "48051",

    ste_name: "MI",
  },
  {
    zip_code: "48059",

    ste_name: "MI",
  },
  {
    zip_code: "48150",

    ste_name: "MI",
  },
  {
    zip_code: "48182",

    ste_name: "MI",
  },
  {
    zip_code: "48356",

    ste_name: "MI",
  },
  {
    zip_code: "48635",

    ste_name: "MI",
  },
  {
    zip_code: "48721",

    ste_name: "MI",
  },
  {
    zip_code: "48748",

    ste_name: "MI",
  },
  {
    zip_code: "48759",

    ste_name: "MI",
  },
  {
    zip_code: "48818",

    ste_name: "MI",
  },
  {
    zip_code: "48856",

    ste_name: "MI",
  },
  {
    zip_code: "49125",

    ste_name: "MI",
  },
  {
    zip_code: "49221",

    ste_name: "MI",
  },
  {
    zip_code: "49234",

    ste_name: "MI",
  },
  {
    zip_code: "49249",

    ste_name: "MI",
  },
  {
    zip_code: "49253",

    ste_name: "MI",
  },
  {
    zip_code: "49262",

    ste_name: "MI",
  },
  {
    zip_code: "49312",

    ste_name: "MI",
  },
  {
    zip_code: "49320",

    ste_name: "MI",
  },
  {
    zip_code: "49328",

    ste_name: "MI",
  },
  {
    zip_code: "49348",

    ste_name: "MI",
  },
  {
    zip_code: "49503",

    ste_name: "MI",
  },
  {
    zip_code: "49506",

    ste_name: "MI",
  },
  {
    zip_code: "49601",

    ste_name: "MI",
  },
  {
    zip_code: "49719",

    ste_name: "MI",
  },
  {
    zip_code: "49736",

    ste_name: "MI",
  },
  {
    zip_code: "49745",

    ste_name: "MI",
  },
  {
    zip_code: "49766",

    ste_name: "MI",
  },
  {
    zip_code: "49775",

    ste_name: "MI",
  },
  {
    zip_code: "49838",

    ste_name: "MI",
  },
  {
    zip_code: "49862",

    ste_name: "MI",
  },
  {
    zip_code: "49877",

    ste_name: "MI",
  },
  {
    zip_code: "49910",

    ste_name: "MI",
  },
  {
    zip_code: "49931",

    ste_name: "MI",
  },
  {
    zip_code: "50027",

    ste_name: "IA",
  },
  {
    zip_code: "50034",

    ste_name: "IA",
  },
  {
    zip_code: "50123",

    ste_name: "IA",
  },
  {
    zip_code: "50173",

    ste_name: "IA",
  },
  {
    zip_code: "50327",

    ste_name: "IA",
  },
  {
    zip_code: "50473",

    ste_name: "IA",
  },
  {
    zip_code: "50532",

    ste_name: "IA",
  },
  {
    zip_code: "50556",

    ste_name: "IA",
  },
  {
    zip_code: "50575",

    ste_name: "IA",
  },
  {
    zip_code: "50651",

    ste_name: "IA",
  },
  {
    zip_code: "50671",

    ste_name: "IA",
  },
  {
    zip_code: "50846",

    ste_name: "IA",
  },
  {
    zip_code: "50864",

    ste_name: "IA",
  },
  {
    zip_code: "51019",

    ste_name: "IA",
  },
  {
    zip_code: "51038",

    ste_name: "IA",
  },
  {
    zip_code: "51104",

    ste_name: "IA",
  },
  {
    zip_code: "51248",

    ste_name: "IA",
  },
  {
    zip_code: "51357",

    ste_name: "IA",
  },
  {
    zip_code: "51545",

    ste_name: "IA",
  },
  {
    zip_code: "52162",

    ste_name: "IA",
  },
  {
    zip_code: "52168",

    ste_name: "IA",
  },
  {
    zip_code: "52227",

    ste_name: "IA",
  },
  {
    zip_code: "52401",

    ste_name: "IA",
  },
  {
    zip_code: "52550",

    ste_name: "IA",
  },
  {
    zip_code: "52646",

    ste_name: "IA",
  },
  {
    zip_code: "52728",

    ste_name: "IA",
  },
  {
    zip_code: "52801",

    ste_name: "IA",
  },
  {
    zip_code: "53094",

    ste_name: "WI",
  },
  {
    zip_code: "53110",

    ste_name: "WI",
  },
  {
    zip_code: "53222",

    ste_name: "WI",
  },
  {
    zip_code: "53504",

    ste_name: "WI",
  },
  {
    zip_code: "53506",

    ste_name: "WI",
  },
  {
    zip_code: "53544",

    ste_name: "WI",
  },
  {
    zip_code: "53557",

    ste_name: "WI",
  },
  {
    zip_code: "53809",

    ste_name: "WI",
  },
  {
    zip_code: "53954",

    ste_name: "WI",
  },
  {
    zip_code: "54028",

    ste_name: "WI",
  },
  {
    zip_code: "54124",

    ste_name: "WI",
  },
  {
    zip_code: "54619",

    ste_name: "WI",
  },
  {
    zip_code: "54722",

    ste_name: "WI",
  },
  {
    zip_code: "54760",

    ste_name: "WI",
  },
  {
    zip_code: "54849",

    ste_name: "WI",
  },
  {
    zip_code: "54932",

    ste_name: "WI",
  },
  {
    zip_code: "54981",

    ste_name: "WI",
  },
  {
    zip_code: "55119",

    ste_name: "MN",
  },
  {
    zip_code: "55120",

    ste_name: "MN",
  },
  {
    zip_code: "55123",

    ste_name: "MN",
  },
  {
    zip_code: "55155",

    ste_name: "MN",
  },
  {
    zip_code: "55370",

    ste_name: "MN",
  },
  {
    zip_code: "55375",

    ste_name: "MN",
  },
  {
    zip_code: "55381",

    ste_name: "MN",
  },
  {
    zip_code: "55384",

    ste_name: "MN",
  },
  {
    zip_code: "55396",

    ste_name: "MN",
  },
  {
    zip_code: "55447",

    ste_name: "MN",
  },
  {
    zip_code: "55705",

    ste_name: "MN",
  },
  {
    zip_code: "55709",

    ste_name: "MN",
  },
  {
    zip_code: "55744",

    ste_name: "MN",
  },
  {
    zip_code: "55768",

    ste_name: "MN",
  },
  {
    zip_code: "55805",

    ste_name: "MN",
  },
  {
    zip_code: "55964",

    ste_name: "MN",
  },
  {
    zip_code: "55985",

    ste_name: "MN",
  },
  {
    zip_code: "56041",

    ste_name: "MN",
  },
  {
    zip_code: "56051",

    ste_name: "MN",
  },
  {
    zip_code: "56141",

    ste_name: "MN",
  },
  {
    zip_code: "56151",

    ste_name: "MN",
  },
  {
    zip_code: "56170",

    ste_name: "MN",
  },
  {
    zip_code: "56201",

    ste_name: "MN",
  },
  {
    zip_code: "56248",

    ste_name: "MN",
  },
  {
    zip_code: "56287",

    ste_name: "MN",
  },
  {
    zip_code: "56313",

    ste_name: "MN",
  },
  {
    zip_code: "56639",

    ste_name: "MN",
  },
  {
    zip_code: "56738",

    ste_name: "MN",
  },
  {
    zip_code: "56757",

    ste_name: "MN",
  },
  {
    zip_code: "56758",

    ste_name: "MN",
  },
  {
    zip_code: "57042",

    ste_name: "SD",
  },
  {
    zip_code: "57049",

    ste_name: "SD",
  },
  {
    zip_code: "57246",

    ste_name: "SD",
  },
  {
    zip_code: "57271",

    ste_name: "SD",
  },
  {
    zip_code: "57274",

    ste_name: "SD",
  },
  {
    zip_code: "57345",

    ste_name: "SD",
  },
  {
    zip_code: "57350",

    ste_name: "SD",
  },
  {
    zip_code: "57475",

    ste_name: "SD",
  },
  {
    zip_code: "57649",

    ste_name: "SD",
  },
  {
    zip_code: "57714",

    ste_name: "SD",
  },
  {
    zip_code: "57724",

    ste_name: "SD",
  },
  {
    zip_code: "57745",

    ste_name: "SD",
  },
  {
    zip_code: "57767",

    ste_name: "SD",
  },
  {
    zip_code: "57785",

    ste_name: "SD",
  },
  {
    zip_code: "58012",

    ste_name: "ND",
  },
  {
    zip_code: "58216",

    ste_name: "ND",
  },
  {
    zip_code: "58243",

    ste_name: "ND",
  },
  {
    zip_code: "58341",

    ste_name: "ND",
  },
  {
    zip_code: "58367",

    ste_name: "ND",
  },
  {
    zip_code: "58496",

    ste_name: "ND",
  },
  {
    zip_code: "58535",

    ste_name: "ND",
  },
  {
    zip_code: "58540",

    ste_name: "ND",
  },
  {
    zip_code: "58559",

    ste_name: "ND",
  },
  {
    zip_code: "58625",

    ste_name: "ND",
  },
  {
    zip_code: "58632",

    ste_name: "ND",
  },
  {
    zip_code: "58741",

    ste_name: "ND",
  },
  {
    zip_code: "58746",

    ste_name: "ND",
  },
  {
    zip_code: "58752",

    ste_name: "ND",
  },
  {
    zip_code: "58768",

    ste_name: "ND",
  },
  {
    zip_code: "58781",

    ste_name: "ND",
  },
  {
    zip_code: "59011",

    ste_name: "MT",
  },
  {
    zip_code: "59016",

    ste_name: "MT",
  },
  {
    zip_code: "59033",

    ste_name: "MT",
  },
  {
    zip_code: "59088",

    ste_name: "MT",
  },
  {
    zip_code: "59089",

    ste_name: "MT",
  },
  {
    zip_code: "59217",

    ste_name: "MT",
  },
  {
    zip_code: "59274",

    ste_name: "MT",
  },
  {
    zip_code: "59317",

    ste_name: "MT",
  },
  {
    zip_code: "59347",

    ste_name: "MT",
  },
  {
    zip_code: "59401",

    ste_name: "MT",
  },
  {
    zip_code: "59420",

    ste_name: "MT",
  },
  {
    zip_code: "59425",

    ste_name: "MT",
  },
  {
    zip_code: "59448",

    ste_name: "MT",
  },
  {
    zip_code: "59468",

    ste_name: "MT",
  },
  {
    zip_code: "59474",

    ste_name: "MT",
  },
  {
    zip_code: "59486",

    ste_name: "MT",
  },
  {
    zip_code: "59544",

    ste_name: "MT",
  },
  {
    zip_code: "59639",

    ste_name: "MT",
  },
  {
    zip_code: "59739",

    ste_name: "MT",
  },
  {
    zip_code: "59828",

    ste_name: "MT",
  },
  {
    zip_code: "59845",

    ste_name: "MT",
  },
  {
    zip_code: "59863",

    ste_name: "MT",
  },
  {
    zip_code: "59870",

    ste_name: "MT",
  },
  {
    zip_code: "59875",

    ste_name: "MT",
  },
  {
    zip_code: "60048",

    ste_name: "IL",
  },
  {
    zip_code: "60410",

    ste_name: "IL",
  },
  {
    zip_code: "60478",

    ste_name: "IL",
  },
  {
    zip_code: "60503",

    ste_name: "IL",
  },
  {
    zip_code: "60504",

    ste_name: "IL",
  },
  {
    zip_code: "60513",

    ste_name: "IL",
  },
  {
    zip_code: "60536",

    ste_name: "IL",
  },
  {
    zip_code: "60612",

    ste_name: "IL",
  },
  {
    zip_code: "60619",

    ste_name: "IL",
  },
  {
    zip_code: "60632",

    ste_name: "IL",
  },
  {
    zip_code: "60649",

    ste_name: "IL",
  },
  {
    zip_code: "60912",

    ste_name: "IL",
  },
  {
    zip_code: "61111",

    ste_name: "IL",
  },
  {
    zip_code: "61265",

    ste_name: "IL",
  },
  {
    zip_code: "61301",

    ste_name: "IL",
  },
  {
    zip_code: "61312",

    ste_name: "IL",
  },
  {
    zip_code: "61332",

    ste_name: "IL",
  },
  {
    zip_code: "61369",

    ste_name: "IL",
  },
  {
    zip_code: "61420",

    ste_name: "IL",
  },
  {
    zip_code: "61459",

    ste_name: "IL",
  },
  {
    zip_code: "61526",

    ste_name: "IL",
  },
  {
    zip_code: "61547",

    ste_name: "IL",
  },
  {
    zip_code: "61564",

    ste_name: "IL",
  },
  {
    zip_code: "61602",

    ste_name: "IL",
  },
  {
    zip_code: "61605",

    ste_name: "IL",
  },
  {
    zip_code: "61722",

    ste_name: "IL",
  },
  {
    zip_code: "61726",

    ste_name: "IL",
  },
  {
    zip_code: "61730",

    ste_name: "IL",
  },
  {
    zip_code: "61754",

    ste_name: "IL",
  },
  {
    zip_code: "61814",

    ste_name: "IL",
  },
  {
    zip_code: "61846",

    ste_name: "IL",
  },
  {
    zip_code: "61914",

    ste_name: "IL",
  },
  {
    zip_code: "61949",

    ste_name: "IL",
  },
  {
    zip_code: "62046",

    ste_name: "IL",
  },
  {
    zip_code: "62092",

    ste_name: "IL",
  },
  {
    zip_code: "62230",

    ste_name: "IL",
  },
  {
    zip_code: "62238",

    ste_name: "IL",
  },
  {
    zip_code: "62323",

    ste_name: "IL",
  },
  {
    zip_code: "62370",

    ste_name: "IL",
  },
  {
    zip_code: "62433",

    ste_name: "IL",
  },
  {
    zip_code: "62515",

    ste_name: "IL",
  },
  {
    zip_code: "62535",

    ste_name: "IL",
  },
  {
    zip_code: "62640",

    ste_name: "IL",
  },
  {
    zip_code: "62695",

    ste_name: "IL",
  },
  {
    zip_code: "62702",

    ste_name: "IL",
  },
  {
    zip_code: "62872",

    ste_name: "IL",
  },
  {
    zip_code: "62906",

    ste_name: "IL",
  },
  {
    zip_code: "62954",

    ste_name: "IL",
  },
  {
    zip_code: "62967",

    ste_name: "IL",
  },
  {
    zip_code: "62972",

    ste_name: "IL",
  },
  {
    zip_code: "63025",

    ste_name: "MO",
  },
  {
    zip_code: "63028",

    ste_name: "MO",
  },
  {
    zip_code: "63052",

    ste_name: "MO",
  },
  {
    zip_code: "63060",

    ste_name: "MO",
  },
  {
    zip_code: "63105",

    ste_name: "MO",
  },
  {
    zip_code: "63118",

    ste_name: "MO",
  },
  {
    zip_code: "63350",

    ste_name: "MO",
  },
  {
    zip_code: "63448",

    ste_name: "MO",
  },
  {
    zip_code: "63468",

    ste_name: "MO",
  },
  {
    zip_code: "63561",

    ste_name: "MO",
  },
  {
    zip_code: "63650",

    ste_name: "MO",
  },
  {
    zip_code: "63784",

    ste_name: "MO",
  },
  {
    zip_code: "63862",

    ste_name: "MO",
  },
  {
    zip_code: "63935",

    ste_name: "MO",
  },
  {
    zip_code: "64017",

    ste_name: "MO",
  },
  {
    zip_code: "64086",

    ste_name: "MO",
  },
  {
    zip_code: "64402",

    ste_name: "MO",
  },
  {
    zip_code: "64422",

    ste_name: "MO",
  },
  {
    zip_code: "64490",

    ste_name: "MO",
  },
  {
    zip_code: "64492",

    ste_name: "MO",
  },
  {
    zip_code: "64601",

    ste_name: "MO",
  },
  {
    zip_code: "64651",

    ste_name: "MO",
  },
  {
    zip_code: "64688",

    ste_name: "MO",
  },
  {
    zip_code: "64761",

    ste_name: "MO",
  },
  {
    zip_code: "65040",

    ste_name: "MO",
  },
  {
    zip_code: "65074",

    ste_name: "MO",
  },
  {
    zip_code: "65203",

    ste_name: "MO",
  },
  {
    zip_code: "65301",

    ste_name: "MO",
  },
  {
    zip_code: "65344",

    ste_name: "MO",
  },
  {
    zip_code: "65349",

    ste_name: "MO",
  },
  {
    zip_code: "65611",

    ste_name: "MO",
  },
  {
    zip_code: "65648",

    ste_name: "MO",
  },
  {
    zip_code: "65658",

    ste_name: "MO",
  },
  {
    zip_code: "66016",

    ste_name: "KS",
  },
  {
    zip_code: "66018",

    ste_name: "KS",
  },
  {
    zip_code: "66083",

    ste_name: "KS",
  },
  {
    zip_code: "66507",

    ste_name: "KS",
  },
  {
    zip_code: "66512",

    ste_name: "KS",
  },
  {
    zip_code: "66603",

    ste_name: "KS",
  },
  {
    zip_code: "66741",

    ste_name: "KS",
  },
  {
    zip_code: "66940",

    ste_name: "KS",
  },
  {
    zip_code: "67042",

    ste_name: "KS",
  },
  {
    zip_code: "67103",

    ste_name: "KS",
  },
  {
    zip_code: "67120",

    ste_name: "KS",
  },
  {
    zip_code: "67137",

    ste_name: "KS",
  },
  {
    zip_code: "67151",

    ste_name: "KS",
  },
  {
    zip_code: "67212",

    ste_name: "KS",
  },
  {
    zip_code: "67354",

    ste_name: "KS",
  },
  {
    zip_code: "67401",

    ste_name: "KS",
  },
  {
    zip_code: "67431",

    ste_name: "KS",
  },
  {
    zip_code: "67446",

    ste_name: "KS",
  },
  {
    zip_code: "67457",

    ste_name: "KS",
  },
  {
    zip_code: "67490",

    ste_name: "KS",
  },
  {
    zip_code: "67501",

    ste_name: "KS",
  },
  {
    zip_code: "67512",

    ste_name: "KS",
  },
  {
    zip_code: "67550",

    ste_name: "KS",
  },
  {
    zip_code: "67572",

    ste_name: "KS",
  },
  {
    zip_code: "67646",

    ste_name: "KS",
  },
  {
    zip_code: "67648",

    ste_name: "KS",
  },
  {
    zip_code: "67653",

    ste_name: "KS",
  },
  {
    zip_code: "67665",

    ste_name: "KS",
  },
  {
    zip_code: "67733",

    ste_name: "KS",
  },
  {
    zip_code: "67762",

    ste_name: "KS",
  },
  {
    zip_code: "67876",

    ste_name: "KS",
  },
  {
    zip_code: "68111",

    ste_name: "NE",
  },
  {
    zip_code: "68304",

    ste_name: "NE",
  },
  {
    zip_code: "68317",

    ste_name: "NE",
  },
  {
    zip_code: "68320",

    ste_name: "NE",
  },
  {
    zip_code: "68351",

    ste_name: "NE",
  },
  {
    zip_code: "68404",

    ste_name: "NE",
  },
  {
    zip_code: "68623",

    ste_name: "NE",
  },
  {
    zip_code: "68655",

    ste_name: "NE",
  },
  {
    zip_code: "68714",

    ste_name: "NE",
  },
  {
    zip_code: "68742",

    ste_name: "NE",
  },
  {
    zip_code: "68781",

    ste_name: "NE",
  },
  {
    zip_code: "68812",

    ste_name: "NE",
  },
  {
    zip_code: "68821",

    ste_name: "NE",
  },
  {
    zip_code: "68827",

    ste_name: "NE",
  },
  {
    zip_code: "68832",

    ste_name: "NE",
  },
  {
    zip_code: "68854",

    ste_name: "NE",
  },
  {
    zip_code: "68881",

    ste_name: "NE",
  },
  {
    zip_code: "68928",

    ste_name: "NE",
  },
  {
    zip_code: "68947",

    ste_name: "NE",
  },
  {
    zip_code: "68960",

    ste_name: "NE",
  },
  {
    zip_code: "69042",

    ste_name: "NE",
  },
  {
    zip_code: "69130",

    ste_name: "NE",
  },
  {
    zip_code: "69134",

    ste_name: "NE",
  },
  {
    zip_code: "69138",

    ste_name: "NE",
  },
  {
    zip_code: "69161",

    ste_name: "NE",
  },
  {
    zip_code: "69331",

    ste_name: "NE",
  },
  {
    zip_code: "69350",

    ste_name: "NE",
  },
  {
    zip_code: "69366",

    ste_name: "NE",
  },
  {
    zip_code: "70030",

    ste_name: "LA",
  },
  {
    zip_code: "70053",

    ste_name: "LA",
  },
  {
    zip_code: "70067",

    ste_name: "LA",
  },
  {
    zip_code: "70091",

    ste_name: "LA",
  },
  {
    zip_code: "70122",

    ste_name: "LA",
  },
  {
    zip_code: "70501",

    ste_name: "LA",
  },
  {
    zip_code: "70514",

    ste_name: "LA",
  },
  {
    zip_code: "70534",

    ste_name: "LA",
  },
  {
    zip_code: "70706",

    ste_name: "LA",
  },
  {
    zip_code: "71008",

    ste_name: "LA",
  },
  {
    zip_code: "71028",

    ste_name: "LA",
  },
  {
    zip_code: "71032",

    ste_name: "LA",
  },
  {
    zip_code: "71061",

    ste_name: "LA",
  },
  {
    zip_code: "71254",

    ste_name: "LA",
  },
  {
    zip_code: "71292",

    ste_name: "LA",
  },
  {
    zip_code: "71375",

    ste_name: "LA",
  },
  {
    zip_code: "71433",

    ste_name: "LA",
  },
  {
    zip_code: "71651",

    ste_name: "AR",
  },
  {
    zip_code: "71838",

    ste_name: "AR",
  },
  {
    zip_code: "72011",

    ste_name: "AR",
  },
  {
    zip_code: "72081",

    ste_name: "AR",
  },
  {
    zip_code: "72141",

    ste_name: "AR",
  },
  {
    zip_code: "72152",

    ste_name: "AR",
  },
  {
    zip_code: "72176",

    ste_name: "AR",
  },
  {
    zip_code: "72211",

    ste_name: "AR",
  },
  {
    zip_code: "72373",

    ste_name: "AR",
  },
  {
    zip_code: "72517",

    ste_name: "AR",
  },
  {
    zip_code: "72521",

    ste_name: "AR",
  },
  {
    zip_code: "72536",

    ste_name: "AR",
  },
  {
    zip_code: "72554",

    ste_name: "AR",
  },
  {
    zip_code: "72568",

    ste_name: "AR",
  },
  {
    zip_code: "72581",

    ste_name: "AR",
  },
  {
    zip_code: "72583",

    ste_name: "AR",
  },
  {
    zip_code: "72584",

    ste_name: "AR",
  },
  {
    zip_code: "72651",

    ste_name: "AR",
  },
  {
    zip_code: "72653",

    ste_name: "AR",
  },
  {
    zip_code: "72776",

    ste_name: "AR",
  },
  {
    zip_code: "72823",

    ste_name: "AR",
  },
  {
    zip_code: "72857",

    ste_name: "AR",
  },
  {
    zip_code: "72865",

    ste_name: "AR",
  },
  {
    zip_code: "72903",

    ste_name: "AR",
  },
  {
    zip_code: "72908",

    ste_name: "AR",
  },
  {
    zip_code: "72930",

    ste_name: "AR",
  },
  {
    zip_code: "72956",

    ste_name: "AR",
  },
  {
    zip_code: "73117",

    ste_name: "OK",
  },
  {
    zip_code: "73179",

    ste_name: "OK",
  },
  {
    zip_code: "73481",

    ste_name: "OK",
  },
  {
    zip_code: "73546",

    ste_name: "OK",
  },
  {
    zip_code: "73651",

    ste_name: "OK",
  },
  {
    zip_code: "73734",

    ste_name: "OK",
  },
  {
    zip_code: "73756",

    ste_name: "OK",
  },
  {
    zip_code: "73857",

    ste_name: "OK",
  },
  {
    zip_code: "74050",

    ste_name: "OK",
  },
  {
    zip_code: "74080",

    ste_name: "OK",
  },
  {
    zip_code: "74084",

    ste_name: "OK",
  },
  {
    zip_code: "74339",

    ste_name: "OK",
  },
  {
    zip_code: "74456",

    ste_name: "OK",
  },
  {
    zip_code: "74727",

    ste_name: "OK",
  },
  {
    zip_code: "74801",

    ste_name: "OK",
  },
  {
    zip_code: "75013",

    ste_name: "TX",
  },
  {
    zip_code: "75041",

    ste_name: "TX",
  },
  {
    zip_code: "75402",

    ste_name: "TX",
  },
  {
    zip_code: "75423",

    ste_name: "TX",
  },
  {
    zip_code: "75431",

    ste_name: "TX",
  },
  {
    zip_code: "75457",

    ste_name: "TX",
  },
  {
    zip_code: "75486",

    ste_name: "TX",
  },
  {
    zip_code: "75771",

    ste_name: "TX",
  },
  {
    zip_code: "75933",

    ste_name: "TX",
  },
  {
    zip_code: "75962",

    ste_name: "TX",
  },
  {
    zip_code: "76065",

    ste_name: "TX",
  },
  {
    zip_code: "76084",

    ste_name: "TX",
  },
  {
    zip_code: "76245",

    ste_name: "TX",
  },
  {
    zip_code: "76247",

    ste_name: "TX",
  },
  {
    zip_code: "76259",

    ste_name: "TX",
  },
  {
    zip_code: "76379",

    ste_name: "TX",
  },
  {
    zip_code: "76554",

    ste_name: "TX",
  },
  {
    zip_code: "76689",

    ste_name: "TX",
  },
  {
    zip_code: "76692",

    ste_name: "TX",
  },
  {
    zip_code: "76701",

    ste_name: "TX",
  },
  {
    zip_code: "76831",

    ste_name: "TX",
  },
  {
    zip_code: "76845",

    ste_name: "TX",
  },
  {
    zip_code: "76884",

    ste_name: "TX",
  },
  {
    zip_code: "76888",

    ste_name: "TX",
  },
  {
    zip_code: "77049",

    ste_name: "TX",
  },
  {
    zip_code: "77082",

    ste_name: "TX",
  },
  {
    zip_code: "77318",

    ste_name: "TX",
  },
  {
    zip_code: "77334",

    ste_name: "TX",
  },
  {
    zip_code: "77350",

    ste_name: "TX",
  },
  {
    zip_code: "77371",

    ste_name: "TX",
  },
  {
    zip_code: "77380",

    ste_name: "TX",
  },
  {
    zip_code: "77437",

    ste_name: "TX",
  },
  {
    zip_code: "77459",

    ste_name: "TX",
  },
  {
    zip_code: "77468",

    ste_name: "TX",
  },
  {
    zip_code: "77475",

    ste_name: "TX",
  },
  {
    zip_code: "77476",

    ste_name: "TX",
  },
  {
    zip_code: "77655",

    ste_name: "TX",
  },
  {
    zip_code: "78017",

    ste_name: "TX",
  },
  {
    zip_code: "78022",

    ste_name: "TX",
  },
  {
    zip_code: "78124",

    ste_name: "TX",
  },
  {
    zip_code: "78143",

    ste_name: "TX",
  },
  {
    zip_code: "78155",

    ste_name: "TX",
  },
  {
    zip_code: "78201",

    ste_name: "TX",
  },
  {
    zip_code: "78203",

    ste_name: "TX",
  },
  {
    zip_code: "78257",

    ste_name: "TX",
  },
  {
    zip_code: "78332",

    ste_name: "TX",
  },
  {
    zip_code: "78389",

    ste_name: "TX",
  },
  {
    zip_code: "78543",

    ste_name: "TX",
  },
  {
    zip_code: "78562",

    ste_name: "TX",
  },
  {
    zip_code: "78662",

    ste_name: "TX",
  },
  {
    zip_code: "78704",

    ste_name: "TX",
  },
  {
    zip_code: "78731",

    ste_name: "TX",
  },
  {
    zip_code: "78850",

    ste_name: "TX",
  },
  {
    zip_code: "79013",

    ste_name: "TX",
  },
  {
    zip_code: "79019",

    ste_name: "TX",
  },
  {
    zip_code: "79079",

    ste_name: "TX",
  },
  {
    zip_code: "79124",

    ste_name: "TX",
  },
  {
    zip_code: "79329",

    ste_name: "TX",
  },
  {
    zip_code: "79370",

    ste_name: "TX",
  },
  {
    zip_code: "79376",

    ste_name: "TX",
  },
  {
    zip_code: "79601",

    ste_name: "TX",
  },
  {
    zip_code: "79703",

    ste_name: "TX",
  },
  {
    zip_code: "79759",

    ste_name: "TX",
  },
  {
    zip_code: "79831",

    ste_name: "TX",
  },
  {
    zip_code: "79851",

    ste_name: "TX",
  },
  {
    zip_code: "79936",

    ste_name: "TX",
  },
  {
    zip_code: "80010",

    ste_name: "CO",
  },
  {
    zip_code: "80021",

    ste_name: "CO",
  },
  {
    zip_code: "80103",

    ste_name: "CO",
  },
  {
    zip_code: "80110",

    ste_name: "CO",
  },
  {
    zip_code: "80116",

    ste_name: "CO",
  },
  {
    zip_code: "80209",

    ste_name: "CO",
  },
  {
    zip_code: "80222",

    ste_name: "CO",
  },
  {
    zip_code: "80293",

    ste_name: "CO",
  },
  {
    zip_code: "80433",

    ste_name: "CO",
  },
  {
    zip_code: "80611",

    ste_name: "CO",
  },
  {
    zip_code: "80634",

    ste_name: "CO",
  },
  {
    zip_code: "80757",

    ste_name: "CO",
  },
  {
    zip_code: "80812",

    ste_name: "CO",
  },
  {
    zip_code: "80815",

    ste_name: "CO",
  },
  {
    zip_code: "80828",

    ste_name: "CO",
  },
  {
    zip_code: "80918",

    ste_name: "CO",
  },
  {
    zip_code: "81143",

    ste_name: "CO",
  },
  {
    zip_code: "81154",

    ste_name: "CO",
  },
  {
    zip_code: "81221",

    ste_name: "CO",
  },
  {
    zip_code: "81233",

    ste_name: "CO",
  },
  {
    zip_code: "81505",

    ste_name: "CO",
  },
  {
    zip_code: "82055",

    ste_name: "WY",
  },
  {
    zip_code: "82321",

    ste_name: "WY",
  },
  {
    zip_code: "82325",

    ste_name: "WY",
  },
  {
    zip_code: "82633",

    ste_name: "WY",
  },
  {
    zip_code: "82721",

    ste_name: "WY",
  },
  {
    zip_code: "82845",

    ste_name: "WY",
  },
  {
    zip_code: "82937",

    ste_name: "WY",
  },
  {
    zip_code: "82939",

    ste_name: "WY",
  },
  {
    zip_code: "83128",

    ste_name: "WY",
  },
  {
    zip_code: "83203",

    ste_name: "ID",
  },
  {
    zip_code: "83271",

    ste_name: "ID",
  },
  {
    zip_code: "83311",

    ste_name: "ID",
  },
  {
    zip_code: "83422",

    ste_name: "ID",
  },
  {
    zip_code: "83449",

    ste_name: "ID",
  },
  {
    zip_code: "83542",

    ste_name: "ID",
  },
  {
    zip_code: "83543",

    ste_name: "ID",
  },
  {
    zip_code: "83546",

    ste_name: "ID",
  },
  {
    zip_code: "83633",

    ste_name: "ID",
  },
  {
    zip_code: "83645",

    ste_name: "ID",
  },
  {
    zip_code: "83655",

    ste_name: "ID",
  },
  {
    zip_code: "83703",

    ste_name: "ID",
  },
  {
    zip_code: "83840",

    ste_name: "ID",
  },
  {
    zip_code: "83872",

    ste_name: "ID",
  },
  {
    zip_code: "84033",

    ste_name: "UT",
  },
  {
    zip_code: "84096",

    ste_name: "UT",
  },
  {
    zip_code: "84120",

    ste_name: "UT",
  },
  {
    zip_code: "84312",

    ste_name: "UT",
  },
  {
    zip_code: "84333",

    ste_name: "UT",
  },
  {
    zip_code: "84339",

    ste_name: "UT",
  },
  {
    zip_code: "84511",

    ste_name: "UT",
  },
  {
    zip_code: "84533",

    ste_name: "UT",
  },
  {
    zip_code: "84630",

    ste_name: "UT",
  },
  {
    zip_code: "84742",

    ste_name: "UT",
  },
  {
    zip_code: "84783",

    ste_name: "UT",
  },
  {
    zip_code: "85037",

    ste_name: "AZ",
  },
  {
    zip_code: "85040",

    ste_name: "AZ",
  },
  {
    zip_code: "85043",

    ste_name: "AZ",
  },
  {
    zip_code: "85085",

    ste_name: "AZ",
  },
  {
    zip_code: "85118",

    ste_name: "AZ",
  },
  {
    zip_code: "85119",

    ste_name: "AZ",
  },
  {
    zip_code: "85121",

    ste_name: "AZ",
  },
  {
    zip_code: "85122",

    ste_name: "AZ",
  },
  {
    zip_code: "85139",

    ste_name: "AZ",
  },
  {
    zip_code: "85194",

    ste_name: "AZ",
  },
  {
    zip_code: "85345",

    ste_name: "AZ",
  },
  {
    zip_code: "85379",

    ste_name: "AZ",
  },
  {
    zip_code: "85633",

    ste_name: "AZ",
  },
  {
    zip_code: "85713",

    ste_name: "AZ",
  },
  {
    zip_code: "85737",

    ste_name: "AZ",
  },
  {
    zip_code: "85911",

    ste_name: "AZ",
  },
  {
    zip_code: "86039",

    ste_name: "AZ",
  },
  {
    zip_code: "86507",

    ste_name: "AZ",
  },
  {
    zip_code: "87061",

    ste_name: "NM",
  },
  {
    zip_code: "87107",

    ste_name: "NM",
  },
  {
    zip_code: "87109",

    ste_name: "NM",
  },
  {
    zip_code: "87325",

    ste_name: "NM",
  },
  {
    zip_code: "87556",

    ste_name: "NM",
  },
  {
    zip_code: "87931",

    ste_name: "NM",
  },
  {
    zip_code: "88112",

    ste_name: "NM",
  },
  {
    zip_code: "88254",

    ste_name: "NM",
  },
  {
    zip_code: "88263",

    ste_name: "NM",
  },
  {
    zip_code: "88427",

    ste_name: "NM",
  },
  {
    zip_code: "89042",

    ste_name: "NV",
  },
  {
    zip_code: "89826",

    ste_name: "NV",
  },
  {
    zip_code: "7035",

    ste_name: "NJ",
  },
  {
    zip_code: "7046",

    ste_name: "NJ",
  },
  {
    zip_code: "7106",

    ste_name: "NJ",
  },
  {
    zip_code: "7114",

    ste_name: "NJ",
  },
  {
    zip_code: "8501",

    ste_name: "NJ",
  },
  {
    zip_code: "90014",

    ste_name: "CA",
  },
  {
    zip_code: "90033",

    ste_name: "CA",
  },
  {
    zip_code: "90069",

    ste_name: "CA",
  },
  {
    zip_code: "90275",

    ste_name: "CA",
  },
  {
    zip_code: "90606",

    ste_name: "CA",
  },
  {
    zip_code: "90746",

    ste_name: "CA",
  },
  {
    zip_code: "91030",

    ste_name: "CA",
  },
  {
    zip_code: "91326",

    ste_name: "CA",
  },
  {
    zip_code: "91764",

    ste_name: "CA",
  },
  {
    zip_code: "91934",

    ste_name: "CA",
  },
  {
    zip_code: "91948",

    ste_name: "CA",
  },
  {
    zip_code: "92083",

    ste_name: "CA",
  },
  {
    zip_code: "92132",

    ste_name: "CA",
  },
  {
    zip_code: "92223",

    ste_name: "CA",
  },
  {
    zip_code: "92231",

    ste_name: "CA",
  },
  {
    zip_code: "92266",

    ste_name: "CA",
  },
  {
    zip_code: "92376",

    ste_name: "CA",
  },
  {
    zip_code: "92394",

    ste_name: "CA",
  },
  {
    zip_code: "92397",

    ste_name: "CA",
  },
  {
    zip_code: "92551",

    ste_name: "CA",
  },
  {
    zip_code: "92595",

    ste_name: "CA",
  },
  {
    zip_code: "92603",

    ste_name: "CA",
  },
  {
    zip_code: "92604",

    ste_name: "CA",
  },
  {
    zip_code: "92661",

    ste_name: "CA",
  },
  {
    zip_code: "92705",

    ste_name: "CA",
  },
  {
    zip_code: "92804",

    ste_name: "CA",
  },
  {
    zip_code: "93063",

    ste_name: "CA",
  },
  {
    zip_code: "93110",

    ste_name: "CA",
  },
  {
    zip_code: "93201",

    ste_name: "CA",
  },
  {
    zip_code: "93225",

    ste_name: "CA",
  },
  {
    zip_code: "93230",

    ste_name: "CA",
  },
  {
    zip_code: "93255",

    ste_name: "CA",
  },
  {
    zip_code: "93305",

    ste_name: "CA",
  },
  {
    zip_code: "93308",

    ste_name: "CA",
  },
  {
    zip_code: "93602",

    ste_name: "CA",
  },
  {
    zip_code: "93610",

    ste_name: "CA",
  },
  {
    zip_code: "93612",

    ste_name: "CA",
  },
  {
    zip_code: "93667",

    ste_name: "CA",
  },
  {
    zip_code: "93668",

    ste_name: "CA",
  },
  {
    zip_code: "93703",

    ste_name: "CA",
  },
  {
    zip_code: "93953",

    ste_name: "CA",
  },
  {
    zip_code: "94010",

    ste_name: "CA",
  },
  {
    zip_code: "94080",

    ste_name: "CA",
  },
  {
    zip_code: "94087",

    ste_name: "CA",
  },
  {
    zip_code: "94133",

    ste_name: "CA",
  },
  {
    zip_code: "94512",

    ste_name: "CA",
  },
  {
    zip_code: "94534",

    ste_name: "CA",
  },
  {
    zip_code: "94571",

    ste_name: "CA",
  },
  {
    zip_code: "94971",

    ste_name: "CA",
  },
  {
    zip_code: "95010",

    ste_name: "CA",
  },
  {
    zip_code: "95023",

    ste_name: "CA",
  },
  {
    zip_code: "95062",

    ste_name: "CA",
  },
  {
    zip_code: "95324",

    ste_name: "CA",
  },
  {
    zip_code: "95366",

    ste_name: "CA",
  },
  {
    zip_code: "95386",

    ste_name: "CA",
  },
  {
    zip_code: "95417",

    ste_name: "CA",
  },
  {
    zip_code: "95446",

    ste_name: "CA",
  },
  {
    zip_code: "95453",

    ste_name: "CA",
  },
  {
    zip_code: "95501",

    ste_name: "CA",
  },
  {
    zip_code: "95573",

    ste_name: "CA",
  },
  {
    zip_code: "95658",

    ste_name: "CA",
  },
  {
    zip_code: "95746",

    ste_name: "CA",
  },
  {
    zip_code: "95817",

    ste_name: "CA",
  },
  {
    zip_code: "95864",

    ste_name: "CA",
  },
  {
    zip_code: "95944",

    ste_name: "CA",
  },
  {
    zip_code: "95951",

    ste_name: "CA",
  },
  {
    zip_code: "95954",

    ste_name: "CA",
  },
  {
    zip_code: "95969",

    ste_name: "CA",
  },
  {
    zip_code: "96007",

    ste_name: "CA",
  },
  {
    zip_code: "96024",

    ste_name: "CA",
  },
  {
    zip_code: "96091",

    ste_name: "CA",
  },
  {
    zip_code: "96708",

    ste_name: "HI",
  },
  {
    zip_code: "96740",

    ste_name: "HI",
  },
  {
    zip_code: "96747",

    ste_name: "HI",
  },
  {
    zip_code: "96756",

    ste_name: "HI",
  },
  {
    zip_code: "96817",

    ste_name: "HI",
  },
  {
    zip_code: "96913",

    ste_name: "GU",
  },
  {
    zip_code: "97106",

    ste_name: "OR",
  },
  {
    zip_code: "97144",

    ste_name: "OR",
  },
  {
    zip_code: "97222",

    ste_name: "OR",
  },
  {
    zip_code: "97229",

    ste_name: "OR",
  },
  {
    zip_code: "97461",

    ste_name: "OR",
  },
  {
    zip_code: "97487",

    ste_name: "OR",
  },
  {
    zip_code: "97524",

    ste_name: "OR",
  },
  {
    zip_code: "97527",

    ste_name: "OR",
  },
  {
    zip_code: "97531",

    ste_name: "OR",
  },
  {
    zip_code: "97712",

    ste_name: "OR",
  },
  {
    zip_code: "97736",

    ste_name: "OR",
  },
  {
    zip_code: "97810",

    ste_name: "OR",
  },
  {
    zip_code: "97840",

    ste_name: "OR",
  },
  {
    zip_code: "98027",

    ste_name: "WA",
  },
  {
    zip_code: "98038",

    ste_name: "WA",
  },
  {
    zip_code: "98059",

    ste_name: "WA",
  },
  {
    zip_code: "98177",

    ste_name: "WA",
  },
  {
    zip_code: "98286",

    ste_name: "WA",
  },
  {
    zip_code: "98325",

    ste_name: "WA",
  },
  {
    zip_code: "98381",

    ste_name: "WA",
  },
  {
    zip_code: "98465",

    ste_name: "WA",
  },
  {
    zip_code: "98589",

    ste_name: "WA",
  },
  {
    zip_code: "98591",

    ste_name: "WA",
  },
  {
    zip_code: "98811",

    ste_name: "WA",
  },
  {
    zip_code: "98823",

    ste_name: "WA",
  },
  {
    zip_code: "98935",

    ste_name: "WA",
  },
  {
    zip_code: "98943",

    ste_name: "WA",
  },
  {
    zip_code: "98952",

    ste_name: "WA",
  },
  {
    zip_code: "99008",

    ste_name: "WA",
  },
  {
    zip_code: "99019",

    ste_name: "WA",
  },
  {
    zip_code: "99026",

    ste_name: "WA",
  },
  {
    zip_code: "99205",

    ste_name: "WA",
  },
  {
    zip_code: "99341",

    ste_name: "WA",
  },
  {
    zip_code: "99557",

    ste_name: "AK",
  },
  {
    zip_code: "99583",

    ste_name: "AK",
  },
  {
    zip_code: "99693",

    ste_name: "AK",
  },
  {
    zip_code: "99734",

    ste_name: "AK",
  },
  {
    zip_code: "99750",

    ste_name: "AK",
  },
  {
    zip_code: "99774",

    ste_name: "AK",
  },
  {
    zip_code: "99777",

    ste_name: "AK",
  },
  {
    zip_code: "7039",

    ste_name: "NJ",
  },
  {
    zip_code: "7075",

    ste_name: "NJ",
  },
  {
    zip_code: "7110",

    ste_name: "NJ",
  },
  {
    zip_code: "7305",

    ste_name: "NJ",
  },
  {
    zip_code: "7422",

    ste_name: "NJ",
  },
  {
    zip_code: "7675",

    ste_name: "NJ",
  },
  {
    zip_code: "7822",

    ste_name: "NJ",
  },
  {
    zip_code: "8511",

    ste_name: "NJ",
  },
  {
    zip_code: "8518",

    ste_name: "NJ",
  },
  {
    zip_code: "8551",

    ste_name: "NJ",
  },
  {
    zip_code: "8608",

    ste_name: "NJ",
  },
  {
    zip_code: "10001",

    ste_name: "NY",
  },
  {
    zip_code: "10014",

    ste_name: "NY",
  },
  {
    zip_code: "10024",

    ste_name: "NY",
  },
  {
    zip_code: "10033",

    ste_name: "NY",
  },
  {
    zip_code: "10154",

    ste_name: "NY",
  },
  {
    zip_code: "10310",

    ste_name: "NY",
  },
  {
    zip_code: "10516",

    ste_name: "NY",
  },
  {
    zip_code: "10547",

    ste_name: "NY",
  },
  {
    zip_code: "10548",

    ste_name: "NY",
  },
  {
    zip_code: "10577",

    ste_name: "NY",
  },
  {
    zip_code: "10583",

    ste_name: "NY",
  },
  {
    zip_code: "10595",

    ste_name: "NY",
  },
  {
    zip_code: "10703",

    ste_name: "NY",
  },
  {
    zip_code: "10927",

    ste_name: "NY",
  },
  {
    zip_code: "10979",

    ste_name: "NY",
  },
  {
    zip_code: "11207",

    ste_name: "NY",
  },
  {
    zip_code: "11226",

    ste_name: "NY",
  },
  {
    zip_code: "11232",

    ste_name: "NY",
  },
  {
    zip_code: "11359",

    ste_name: "NY",
  },
  {
    zip_code: "11362",

    ste_name: "NY",
  },
  {
    zip_code: "11414",

    ste_name: "NY",
  },
  {
    zip_code: "11427",

    ste_name: "NY",
  },
  {
    zip_code: "11548",

    ste_name: "NY",
  },
  {
    zip_code: "11566",

    ste_name: "NY",
  },
  {
    zip_code: "11721",

    ste_name: "NY",
  },
  {
    zip_code: "11747",

    ste_name: "NY",
  },
  {
    zip_code: "11793",

    ste_name: "NY",
  },
  {
    zip_code: "11794",

    ste_name: "NY",
  },
  {
    zip_code: "11796",

    ste_name: "NY",
  },
  {
    zip_code: "11957",

    ste_name: "NY",
  },
  {
    zip_code: "11970",

    ste_name: "NY",
  },
  {
    zip_code: "11973",

    ste_name: "NY",
  },
  {
    zip_code: "11976",

    ste_name: "NY",
  },
  {
    zip_code: "12023",

    ste_name: "NY",
  },
  {
    zip_code: "12070",

    ste_name: "NY",
  },
  {
    zip_code: "12115",

    ste_name: "NY",
  },
  {
    zip_code: "12120",

    ste_name: "NY",
  },
  {
    zip_code: "12144",

    ste_name: "NY",
  },
  {
    zip_code: "12188",

    ste_name: "NY",
  },
  {
    zip_code: "12203",

    ste_name: "NY",
  },
  {
    zip_code: "12222",

    ste_name: "NY",
  },
  {
    zip_code: "12439",

    ste_name: "NY",
  },
  {
    zip_code: "12482",

    ste_name: "NY",
  },
  {
    zip_code: "12496",

    ste_name: "NY",
  },
  {
    zip_code: "12546",

    ste_name: "NY",
  },
  {
    zip_code: "12582",

    ste_name: "NY",
  },
  {
    zip_code: "12589",

    ste_name: "NY",
  },
  {
    zip_code: "12765",

    ste_name: "NY",
  },
  {
    zip_code: "12926",

    ste_name: "NY",
  },
  {
    zip_code: "12960",

    ste_name: "NY",
  },
  {
    zip_code: "12992",

    ste_name: "NY",
  },
  {
    zip_code: "12997",

    ste_name: "NY",
  },
  {
    zip_code: "13033",

    ste_name: "NY",
  },
  {
    zip_code: "13123",

    ste_name: "NY",
  },
  {
    zip_code: "13305",

    ste_name: "NY",
  },
  {
    zip_code: "13471",

    ste_name: "NY",
  },
  {
    zip_code: "13637",

    ste_name: "NY",
  },
  {
    zip_code: "13640",

    ste_name: "NY",
  },
  {
    zip_code: "13660",

    ste_name: "NY",
  },
  {
    zip_code: "13740",

    ste_name: "NY",
  },
  {
    zip_code: "13743",

    ste_name: "NY",
  },
  {
    zip_code: "13751",

    ste_name: "NY",
  },
  {
    zip_code: "13780",

    ste_name: "NY",
  },
  {
    zip_code: "14150",

    ste_name: "NY",
  },
  {
    zip_code: "14219",

    ste_name: "NY",
  },
  {
    zip_code: "14302",

    ste_name: "NY",
  },
  {
    zip_code: "14537",

    ste_name: "NY",
  },
  {
    zip_code: "14586",

    ste_name: "NY",
  },
  {
    zip_code: "14613",

    ste_name: "NY",
  },
  {
    zip_code: "14723",

    ste_name: "NY",
  },
  {
    zip_code: "14847",

    ste_name: "NY",
  },
  {
    zip_code: "14871",

    ste_name: "NY",
  },
  {
    zip_code: "15031",

    ste_name: "PA",
  },
  {
    zip_code: "15037",

    ste_name: "PA",
  },
  {
    zip_code: "15044",

    ste_name: "PA",
  },
  {
    zip_code: "15049",

    ste_name: "PA",
  },
  {
    zip_code: "15074",

    ste_name: "PA",
  },
  {
    zip_code: "15205",

    ste_name: "PA",
  },
  {
    zip_code: "15317",

    ste_name: "PA",
  },
  {
    zip_code: "15445",

    ste_name: "PA",
  },
  {
    zip_code: "15521",

    ste_name: "PA",
  },
  {
    zip_code: "15531",

    ste_name: "PA",
  },
  {
    zip_code: "15611",

    ste_name: "PA",
  },
  {
    zip_code: "15646",

    ste_name: "PA",
  },
  {
    zip_code: "15742",

    ste_name: "PA",
  },
  {
    zip_code: "15745",

    ste_name: "PA",
  },
  {
    zip_code: "15840",

    ste_name: "PA",
  },
  {
    zip_code: "15857",

    ste_name: "PA",
  },
  {
    zip_code: "16115",

    ste_name: "PA",
  },
  {
    zip_code: "16140",

    ste_name: "PA",
  },
  {
    zip_code: "16217",

    ste_name: "PA",
  },
  {
    zip_code: "16256",

    ste_name: "PA",
  },
  {
    zip_code: "16443",

    ste_name: "PA",
  },
  {
    zip_code: "16504",

    ste_name: "PA",
  },
  {
    zip_code: "16677",

    ste_name: "PA",
  },
  {
    zip_code: "16680",

    ste_name: "PA",
  },
  {
    zip_code: "16826",

    ste_name: "PA",
  },
  {
    zip_code: "16843",

    ste_name: "PA",
  },
  {
    zip_code: "16865",

    ste_name: "PA",
  },
  {
    zip_code: "16914",

    ste_name: "PA",
  },
  {
    zip_code: "16917",

    ste_name: "PA",
  },
  {
    zip_code: "16946",

    ste_name: "PA",
  },
  {
    zip_code: "17003",

    ste_name: "PA",
  },
  {
    zip_code: "17024",

    ste_name: "PA",
  },
  {
    zip_code: "17087",

    ste_name: "PA",
  },
  {
    zip_code: "17088",

    ste_name: "PA",
  },
  {
    zip_code: "17110",

    ste_name: "PA",
  },
  {
    zip_code: "17268",

    ste_name: "PA",
  },
  {
    zip_code: "17347",

    ste_name: "PA",
  },
  {
    zip_code: "17350",

    ste_name: "PA",
  },
  {
    zip_code: "17547",

    ste_name: "PA",
  },
  {
    zip_code: "17563",

    ste_name: "PA",
  },
  {
    zip_code: "17728",

    ste_name: "PA",
  },
  {
    zip_code: "17772",

    ste_name: "PA",
  },
  {
    zip_code: "17812",

    ste_name: "PA",
  },
  {
    zip_code: "17844",

    ste_name: "PA",
  },
  {
    zip_code: "17934",

    ste_name: "PA",
  },
  {
    zip_code: "17954",

    ste_name: "PA",
  },
  {
    zip_code: "18011",

    ste_name: "PA",
  },
  {
    zip_code: "18035",

    ste_name: "PA",
  },
  {
    zip_code: "18056",

    ste_name: "PA",
  },
  {
    zip_code: "18334",

    ste_name: "PA",
  },
  {
    zip_code: "18354",

    ste_name: "PA",
  },
  {
    zip_code: "18424",

    ste_name: "PA",
  },
  {
    zip_code: "18439",

    ste_name: "PA",
  },
  {
    zip_code: "18843",

    ste_name: "PA",
  },
  {
    zip_code: "19107",

    ste_name: "PA",
  },
  {
    zip_code: "19150",

    ste_name: "PA",
  },
  {
    zip_code: "19405",

    ste_name: "PA",
  },
  {
    zip_code: "19442",

    ste_name: "PA",
  },
  {
    zip_code: "19523",

    ste_name: "PA",
  },
  {
    zip_code: "19534",

    ste_name: "PA",
  },
  {
    zip_code: "19535",

    ste_name: "PA",
  },
  {
    zip_code: "19706",

    ste_name: "DE",
  },
  {
    zip_code: "19710",

    ste_name: "DE",
  },
  {
    zip_code: "19732",

    ste_name: "DE",
  },
  {
    zip_code: "20003",

    ste_name: "DC",
  },
  {
    zip_code: "20008",

    ste_name: "DC",
  },
  {
    zip_code: "20018",

    ste_name: "DC",
  },
  {
    zip_code: "20121",

    ste_name: "VA",
  },
  {
    zip_code: "20603",

    ste_name: "MD",
  },
  {
    zip_code: "20613",

    ste_name: "MD",
  },
  {
    zip_code: "20743",

    ste_name: "MD",
  },
  {
    zip_code: "20763",

    ste_name: "MD",
  },
  {
    zip_code: "20781",

    ste_name: "MD",
  },
  {
    zip_code: "20855",

    ste_name: "MD",
  },
  {
    zip_code: "20903",

    ste_name: "MD",
  },
  {
    zip_code: "21136",

    ste_name: "MD",
  },
  {
    zip_code: "21140",

    ste_name: "MD",
  },
  {
    zip_code: "21155",

    ste_name: "MD",
  },
  {
    zip_code: "21217",

    ste_name: "MD",
  },
  {
    zip_code: "21401",

    ste_name: "MD",
  },
  {
    zip_code: "21523",

    ste_name: "MD",
  },
  {
    zip_code: "21531",

    ste_name: "MD",
  },
  {
    zip_code: "21634",

    ste_name: "MD",
  },
  {
    zip_code: "21655",

    ste_name: "MD",
  },
  {
    zip_code: "21719",

    ste_name: "MD",
  },
  {
    zip_code: "21750",

    ste_name: "MD",
  },
  {
    zip_code: "21793",

    ste_name: "MD",
  },
  {
    zip_code: "22041",

    ste_name: "VA",
  },
  {
    zip_code: "22204",

    ste_name: "VA",
  },
  {
    zip_code: "22305",

    ste_name: "VA",
  },
  {
    zip_code: "22624",

    ste_name: "VA",
  },
  {
    zip_code: "22810",

    ste_name: "VA",
  },
  {
    zip_code: "22845",

    ste_name: "VA",
  },
  {
    zip_code: "22903",

    ste_name: "VA",
  },
  {
    zip_code: "22911",

    ste_name: "VA",
  },
  {
    zip_code: "23146",

    ste_name: "VA",
  },
  {
    zip_code: "23301",

    ste_name: "VA",
  },
  {
    zip_code: "23313",

    ste_name: "VA",
  },
  {
    zip_code: "23315",

    ste_name: "VA",
  },
  {
    zip_code: "23336",

    ste_name: "VA",
  },
  {
    zip_code: "23358",

    ste_name: "VA",
  },
  {
    zip_code: "23416",

    ste_name: "VA",
  },
  {
    zip_code: "23502",

    ste_name: "VA",
  },
  {
    zip_code: "23510",

    ste_name: "VA",
  },
  {
    zip_code: "23602",

    ste_name: "VA",
  },
  {
    zip_code: "23661",

    ste_name: "VA",
  },
  {
    zip_code: "23841",

    ste_name: "VA",
  },
  {
    zip_code: "23883",

    ste_name: "VA",
  },
  {
    zip_code: "23915",

    ste_name: "VA",
  },
  {
    zip_code: "23924",

    ste_name: "VA",
  },
  {
    zip_code: "23930",

    ste_name: "VA",
  },
  {
    zip_code: "23974",

    ste_name: "VA",
  },
  {
    zip_code: "24202",

    ste_name: "VA",
  },
  {
    zip_code: "24292",

    ste_name: "VA",
  },
  {
    zip_code: "24333",

    ste_name: "VA",
  },
  {
    zip_code: "24464",

    ste_name: "VA",
  },
  {
    zip_code: "24471",

    ste_name: "VA",
  },
  {
    zip_code: "24592",

    ste_name: "VA",
  },
  {
    zip_code: "24646",

    ste_name: "VA",
  },
  {
    zip_code: "24878",

    ste_name: "WV",
  },
  {
    zip_code: "24898",

    ste_name: "WV",
  },
  {
    zip_code: "24920",

    ste_name: "WV",
  },
  {
    zip_code: "24931",

    ste_name: "WV",
  },
  {
    zip_code: "25043",

    ste_name: "WV",
  },
  {
    zip_code: "25067",

    ste_name: "WV",
  },
  {
    zip_code: "25107",

    ste_name: "WV",
  },
  {
    zip_code: "25411",

    ste_name: "WV",
  },
  {
    zip_code: "25437",

    ste_name: "WV",
  },
  {
    zip_code: "25571",

    ste_name: "WV",
  },
  {
    zip_code: "25976",

    ste_name: "WV",
  },
  {
    zip_code: "25989",

    ste_name: "WV",
  },
  {
    zip_code: "26031",

    ste_name: "WV",
  },
  {
    zip_code: "26101",

    ste_name: "WV",
  },
  {
    zip_code: "26136",

    ste_name: "WV",
  },
  {
    zip_code: "26260",

    ste_name: "WV",
  },
  {
    zip_code: "26261",

    ste_name: "WV",
  },
  {
    zip_code: "26267",

    ste_name: "WV",
  },
  {
    zip_code: "26280",

    ste_name: "WV",
  },
  {
    zip_code: "26351",

    ste_name: "WV",
  },
  {
    zip_code: "26415",

    ste_name: "WV",
  },
  {
    zip_code: "26559",

    ste_name: "WV",
  },
  {
    zip_code: "26587",

    ste_name: "WV",
  },
  {
    zip_code: "26590",

    ste_name: "WV",
  },
  {
    zip_code: "26621",

    ste_name: "WV",
  },
  {
    zip_code: "26681",

    ste_name: "WV",
  },
  {
    zip_code: "27106",

    ste_name: "NC",
  },
  {
    zip_code: "27355",

    ste_name: "NC",
  },
  {
    zip_code: "27505",

    ste_name: "NC",
  },
  {
    zip_code: "27537",

    ste_name: "NC",
  },
  {
    zip_code: "27562",

    ste_name: "NC",
  },
  {
    zip_code: "27597",

    ste_name: "NC",
  },
  {
    zip_code: "27705",

    ste_name: "NC",
  },
  {
    zip_code: "27834",

    ste_name: "NC",
  },
  {
    zip_code: "27856",

    ste_name: "NC",
  },
  {
    zip_code: "27862",

    ste_name: "NC",
  },
  {
    zip_code: "27880",

    ste_name: "NC",
  },
  {
    zip_code: "28108",

    ste_name: "NC",
  },
  {
    zip_code: "28127",

    ste_name: "NC",
  },
  {
    zip_code: "28159",

    ste_name: "NC",
  },
  {
    zip_code: "28163",

    ste_name: "NC",
  },
  {
    zip_code: "28168",

    ste_name: "NC",
  },
  {
    zip_code: "28306",

    ste_name: "NC",
  },
  {
    zip_code: "28394",

    ste_name: "NC",
  },
  {
    zip_code: "28435",

    ste_name: "NC",
  },
  {
    zip_code: "28438",

    ste_name: "NC",
  },
  {
    zip_code: "28611",

    ste_name: "NC",
  },
  {
    zip_code: "28626",

    ste_name: "NC",
  },
  {
    zip_code: "28672",

    ste_name: "NC",
  },
  {
    zip_code: "28711",

    ste_name: "NC",
  },
  {
    zip_code: "28721",

    ste_name: "NC",
  },
  {
    zip_code: "28733",

    ste_name: "NC",
  },
  {
    zip_code: "28734",

    ste_name: "NC",
  },
  {
    zip_code: "29001",

    ste_name: "SC",
  },
  {
    zip_code: "29032",

    ste_name: "SC",
  },
  {
    zip_code: "29323",

    ste_name: "SC",
  },
  {
    zip_code: "29331",

    ste_name: "SC",
  },
  {
    zip_code: "29364",

    ste_name: "SC",
  },
  {
    zip_code: "29451",

    ste_name: "SC",
  },
  {
    zip_code: "29456",

    ste_name: "SC",
  },
  {
    zip_code: "29485",

    ste_name: "SC",
  },
  {
    zip_code: "29492",

    ste_name: "SC",
  },
  {
    zip_code: "29591",

    ste_name: "SC",
  },
  {
    zip_code: "29609",

    ste_name: "SC",
  },
  {
    zip_code: "29635",

    ste_name: "SC",
  },
  {
    zip_code: "29812",

    ste_name: "SC",
  },
  {
    zip_code: "29856",

    ste_name: "SC",
  },
  {
    zip_code: "30164",

    ste_name: "GA",
  },
  {
    zip_code: "30220",

    ste_name: "GA",
  },
  {
    zip_code: "30224",

    ste_name: "GA",
  },
  {
    zip_code: "30257",

    ste_name: "GA",
  },
  {
    zip_code: "30258",

    ste_name: "GA",
  },
  {
    zip_code: "30277",

    ste_name: "GA",
  },
  {
    zip_code: "30308",

    ste_name: "GA",
  },
  {
    zip_code: "30346",

    ste_name: "GA",
  },
  {
    zip_code: "30471",

    ste_name: "GA",
  },
  {
    zip_code: "30552",

    ste_name: "GA",
  },
  {
    zip_code: "30607",

    ste_name: "GA",
  },
  {
    zip_code: "30650",

    ste_name: "GA",
  },
  {
    zip_code: "30656",

    ste_name: "GA",
  },
  {
    zip_code: "30701",

    ste_name: "GA",
  },
  {
    zip_code: "30901",

    ste_name: "GA",
  },
  {
    zip_code: "728",

    ste_name: "PR",
  },
  {
    zip_code: "780",

    ste_name: "PR",
  },
  {
    zip_code: "936",

    ste_name: "PR",
  },
  {
    zip_code: "949",

    ste_name: "PR",
  },
  {
    zip_code: "1007",

    ste_name: "MA",
  },
  {
    zip_code: "1057",

    ste_name: "MA",
  },
  {
    zip_code: "1105",

    ste_name: "MA",
  },
  {
    zip_code: "1339",

    ste_name: "MA",
  },
  {
    zip_code: "1360",

    ste_name: "MA",
  },
  {
    zip_code: "1368",

    ste_name: "MA",
  },
  {
    zip_code: "1452",

    ste_name: "MA",
  },
  {
    zip_code: "1752",

    ste_name: "MA",
  },
  {
    zip_code: "1930",

    ste_name: "MA",
  },
  {
    zip_code: "2025",

    ste_name: "MA",
  },
  {
    zip_code: "2176",

    ste_name: "MA",
  },
  {
    zip_code: "2301",

    ste_name: "MA",
  },
  {
    zip_code: "2338",

    ste_name: "MA",
  },
  {
    zip_code: "2494",

    ste_name: "MA",
  },
  {
    zip_code: "2642",

    ste_name: "MA",
  },
  {
    zip_code: "2646",

    ste_name: "MA",
  },
  {
    zip_code: "2804",

    ste_name: "RI",
  },
  {
    zip_code: "3036",

    ste_name: "NH",
  },
  {
    zip_code: "3223",

    ste_name: "NH",
  },
  {
    zip_code: "3304",

    ste_name: "NH",
  },
  {
    zip_code: "3602",

    ste_name: "NH",
  },
  {
    zip_code: "3771",

    ste_name: "NH",
  },
  {
    zip_code: "3773",

    ste_name: "NH",
  },
  {
    zip_code: "3884",

    ste_name: "NH",
  },
  {
    zip_code: "4006",

    ste_name: "ME",
  },
  {
    zip_code: "4027",

    ste_name: "ME",
  },
  {
    zip_code: "4074",

    ste_name: "ME",
  },
  {
    zip_code: "4084",

    ste_name: "ME",
  },
  {
    zip_code: "4219",

    ste_name: "ME",
  },
  {
    zip_code: "4281",

    ste_name: "ME",
  },
  {
    zip_code: "4364",

    ste_name: "ME",
  },
  {
    zip_code: "4412",

    ste_name: "ME",
  },
  {
    zip_code: "4539",

    ste_name: "ME",
  },
  {
    zip_code: "4578",

    ste_name: "ME",
  },
  {
    zip_code: "4628",

    ste_name: "ME",
  },
  {
    zip_code: "4640",

    ste_name: "ME",
  },
  {
    zip_code: "4745",

    ste_name: "ME",
  },
  {
    zip_code: "4746",

    ste_name: "ME",
  },
  {
    zip_code: "4851",

    ste_name: "ME",
  },
  {
    zip_code: "4926",

    ste_name: "ME",
  },
  {
    zip_code: "4929",

    ste_name: "ME",
  },
  {
    zip_code: "4939",

    ste_name: "ME",
  },
  {
    zip_code: "4978",

    ste_name: "ME",
  },
  {
    zip_code: "4987",

    ste_name: "ME",
  },
  {
    zip_code: "5454",

    ste_name: "VT",
  },
  {
    zip_code: "5489",

    ste_name: "VT",
  },
  {
    zip_code: "5663",

    ste_name: "VT",
  },
  {
    zip_code: "5740",

    ste_name: "VT",
  },
  {
    zip_code: "5822",

    ste_name: "VT",
  },
  {
    zip_code: "5873",

    ste_name: "VT",
  },
  {
    zip_code: "6066",

    ste_name: "CT",
  },
  {
    zip_code: "6082",

    ste_name: "CT",
  },
  {
    zip_code: "6110",

    ste_name: "CT",
  },
  {
    zip_code: "6234",

    ste_name: "CT",
  },
  {
    zip_code: "6373",

    ste_name: "CT",
  },
  {
    zip_code: "6378",

    ste_name: "CT",
  },
  {
    zip_code: "6385",

    ste_name: "CT",
  },
  {
    zip_code: "6451",

    ste_name: "CT",
  },
  {
    zip_code: "6475",

    ste_name: "CT",
  },
  {
    zip_code: "6498",

    ste_name: "CT",
  },
  {
    zip_code: "6796",

    ste_name: "CT",
  },
  {
    zip_code: "6906",

    ste_name: "CT",
  },
  {
    zip_code: "7001",

    ste_name: "NJ",
  },
  {
    zip_code: "7405",

    ste_name: "NJ",
  },
  {
    zip_code: "7869",

    ste_name: "NJ",
  },
  {
    zip_code: "8009",

    ste_name: "NJ",
  },
  {
    zip_code: "8028",

    ste_name: "NJ",
  },
  {
    zip_code: "8243",

    ste_name: "NJ",
  },
  {
    zip_code: "8346",

    ste_name: "NJ",
  },
  {
    zip_code: "8350",

    ste_name: "NJ",
  },
  {
    zip_code: "8736",

    ste_name: "NJ",
  },
  {
    zip_code: "59025",

    ste_name: "MT",
  },
  {
    zip_code: "59028",

    ste_name: "MT",
  },
  {
    zip_code: "59242",

    ste_name: "MT",
  },
  {
    zip_code: "59339",

    ste_name: "MT",
  },
  {
    zip_code: "59353",

    ste_name: "MT",
  },
  {
    zip_code: "59433",

    ste_name: "MT",
  },
  {
    zip_code: "59472",

    ste_name: "MT",
  },
  {
    zip_code: "59522",

    ste_name: "MT",
  },
  {
    zip_code: "59636",

    ste_name: "MT",
  },
  {
    zip_code: "59825",

    ste_name: "MT",
  },
  {
    zip_code: "59925",

    ste_name: "MT",
  },
  {
    zip_code: "59929",

    ste_name: "MT",
  },
  {
    zip_code: "60030",

    ste_name: "IL",
  },
  {
    zip_code: "60031",

    ste_name: "IL",
  },
  {
    zip_code: "60034",

    ste_name: "IL",
  },
  {
    zip_code: "60084",

    ste_name: "IL",
  },
  {
    zip_code: "60452",

    ste_name: "IL",
  },
  {
    zip_code: "60543",

    ste_name: "IL",
  },
  {
    zip_code: "60551",

    ste_name: "IL",
  },
  {
    zip_code: "60553",

    ste_name: "IL",
  },
  {
    zip_code: "60607",

    ste_name: "IL",
  },
  {
    zip_code: "60634",

    ste_name: "IL",
  },
  {
    zip_code: "60654",

    ste_name: "IL",
  },
  {
    zip_code: "60913",

    ste_name: "IL",
  },
  {
    zip_code: "60918",

    ste_name: "IL",
  },
  {
    zip_code: "60964",

    ste_name: "IL",
  },
  {
    zip_code: "61044",

    ste_name: "IL",
  },
  {
    zip_code: "61050",

    ste_name: "IL",
  },
  {
    zip_code: "61054",

    ste_name: "IL",
  },
  {
    zip_code: "61230",

    ste_name: "IL",
  },
  {
    zip_code: "61256",

    ste_name: "IL",
  },
  {
    zip_code: "61337",

    ste_name: "IL",
  },
  {
    zip_code: "61341",

    ste_name: "IL",
  },
  {
    zip_code: "61430",

    ste_name: "IL",
  },
  {
    zip_code: "61450",

    ste_name: "IL",
  },
  {
    zip_code: "61491",

    ste_name: "IL",
  },
  {
    zip_code: "61553",

    ste_name: "IL",
  },
  {
    zip_code: "61606",

    ste_name: "IL",
  },
  {
    zip_code: "61701",

    ste_name: "IL",
  },
  {
    zip_code: "61777",

    ste_name: "IL",
  },
  {
    zip_code: "61875",

    ste_name: "IL",
  },
  {
    zip_code: "61913",

    ste_name: "IL",
  },
  {
    zip_code: "61943",

    ste_name: "IL",
  },
  {
    zip_code: "61944",

    ste_name: "IL",
  },
  {
    zip_code: "62023",

    ste_name: "IL",
  },
  {
    zip_code: "62024",

    ste_name: "IL",
  },
  {
    zip_code: "62034",

    ste_name: "IL",
  },
  {
    zip_code: "62075",

    ste_name: "IL",
  },
  {
    zip_code: "62206",

    ste_name: "IL",
  },
  {
    zip_code: "62241",

    ste_name: "IL",
  },
  {
    zip_code: "62244",

    ste_name: "IL",
  },
  {
    zip_code: "62355",

    ste_name: "IL",
  },
  {
    zip_code: "62421",

    ste_name: "IL",
  },
  {
    zip_code: "62444",

    ste_name: "IL",
  },
  {
    zip_code: "62450",

    ste_name: "IL",
  },
  {
    zip_code: "62514",

    ste_name: "IL",
  },
  {
    zip_code: "62570",

    ste_name: "IL",
  },
  {
    zip_code: "62638",

    ste_name: "IL",
  },
  {
    zip_code: "62830",

    ste_name: "IL",
  },
  {
    zip_code: "62842",

    ste_name: "IL",
  },
  {
    zip_code: "62864",

    ste_name: "IL",
  },
  {
    zip_code: "62895",

    ste_name: "IL",
  },
  {
    zip_code: "62917",

    ste_name: "IL",
  },
  {
    zip_code: "62990",

    ste_name: "IL",
  },
  {
    zip_code: "62997",

    ste_name: "IL",
  },
  {
    zip_code: "63005",

    ste_name: "MO",
  },
  {
    zip_code: "63033",

    ste_name: "MO",
  },
  {
    zip_code: "63068",

    ste_name: "MO",
  },
  {
    zip_code: "63080",

    ste_name: "MO",
  },
  {
    zip_code: "63102",

    ste_name: "MO",
  },
  {
    zip_code: "63130",

    ste_name: "MO",
  },
  {
    zip_code: "63133",

    ste_name: "MO",
  },
  {
    zip_code: "63348",

    ste_name: "MO",
  },
  {
    zip_code: "63366",

    ste_name: "MO",
  },
  {
    zip_code: "63443",

    ste_name: "MO",
  },
  {
    zip_code: "63447",

    ste_name: "MO",
  },
  {
    zip_code: "63534",

    ste_name: "MO",
  },
  {
    zip_code: "63666",

    ste_name: "MO",
  },
  {
    zip_code: "63760",

    ste_name: "MO",
  },
  {
    zip_code: "63934",

    ste_name: "MO",
  },
  {
    zip_code: "64052",

    ste_name: "MO",
  },
  {
    zip_code: "64076",

    ste_name: "MO",
  },
  {
    zip_code: "64138",

    ste_name: "MO",
  },
  {
    zip_code: "64154",

    ste_name: "MO",
  },
  {
    zip_code: "64444",

    ste_name: "MO",
  },
  {
    zip_code: "64480",

    ste_name: "MO",
  },
  {
    zip_code: "64652",

    ste_name: "MO",
  },
  {
    zip_code: "64744",

    ste_name: "MO",
  },
  {
    zip_code: "64842",

    ste_name: "MO",
  },
  {
    zip_code: "65065",

    ste_name: "MO",
  },
  {
    zip_code: "65231",

    ste_name: "MO",
  },
  {
    zip_code: "65248",

    ste_name: "MO",
  },
  {
    zip_code: "65609",

    ste_name: "MO",
  },
  {
    zip_code: "65620",

    ste_name: "MO",
  },
  {
    zip_code: "65641",

    ste_name: "MO",
  },
  {
    zip_code: "65802",

    ste_name: "MO",
  },
  {
    zip_code: "66093",

    ste_name: "KS",
  },
  {
    zip_code: "66211",

    ste_name: "KS",
  },
  {
    zip_code: "66212",

    ste_name: "KS",
  },
  {
    zip_code: "66432",

    ste_name: "KS",
  },
  {
    zip_code: "66438",

    ste_name: "KS",
  },
  {
    zip_code: "66451",

    ste_name: "KS",
  },
  {
    zip_code: "66514",

    ste_name: "KS",
  },
  {
    zip_code: "66518",

    ste_name: "KS",
  },
  {
    zip_code: "66526",

    ste_name: "KS",
  },
  {
    zip_code: "66538",

    ste_name: "KS",
  },
  {
    zip_code: "66540",

    ste_name: "KS",
  },
  {
    zip_code: "66615",

    ste_name: "KS",
  },
  {
    zip_code: "66748",

    ste_name: "KS",
  },
  {
    zip_code: "66773",

    ste_name: "KS",
  },
  {
    zip_code: "66852",

    ste_name: "KS",
  },
  {
    zip_code: "66857",

    ste_name: "KS",
  },
  {
    zip_code: "66941",

    ste_name: "KS",
  },
  {
    zip_code: "66948",

    ste_name: "KS",
  },
  {
    zip_code: "66970",

    ste_name: "KS",
  },
  {
    zip_code: "67030",

    ste_name: "KS",
  },
  {
    zip_code: "67037",

    ste_name: "KS",
  },
  {
    zip_code: "67066",

    ste_name: "KS",
  },
  {
    zip_code: "67112",

    ste_name: "KS",
  },
  {
    zip_code: "67347",

    ste_name: "KS",
  },
  {
    zip_code: "67448",

    ste_name: "KS",
  },
  {
    zip_code: "67484",

    ste_name: "KS",
  },
  {
    zip_code: "67491",

    ste_name: "KS",
  },
  {
    zip_code: "67651",

    ste_name: "KS",
  },
  {
    zip_code: "67657",

    ste_name: "KS",
  },
  {
    zip_code: "67659",

    ste_name: "KS",
  },
  {
    zip_code: "67661",

    ste_name: "KS",
  },
  {
    zip_code: "67757",

    ste_name: "KS",
  },
  {
    zip_code: "67863",

    ste_name: "KS",
  },
  {
    zip_code: "67953",

    ste_name: "KS",
  },
  {
    zip_code: "68033",

    ste_name: "NE",
  },
  {
    zip_code: "68064",

    ste_name: "NE",
  },
  {
    zip_code: "68072",

    ste_name: "NE",
  },
  {
    zip_code: "68157",

    ste_name: "NE",
  },
  {
    zip_code: "68318",

    ste_name: "NE",
  },
  {
    zip_code: "68328",

    ste_name: "NE",
  },
  {
    zip_code: "68329",

    ste_name: "NE",
  },
  {
    zip_code: "68337",

    ste_name: "NE",
  },
  {
    zip_code: "68347",

    ste_name: "NE",
  },
  {
    zip_code: "68366",

    ste_name: "NE",
  },
  {
    zip_code: "68416",

    ste_name: "NE",
  },
  {
    zip_code: "68417",

    ste_name: "NE",
  },
  {
    zip_code: "68423",

    ste_name: "NE",
  },
  {
    zip_code: "68439",

    ste_name: "NE",
  },
  {
    zip_code: "68447",

    ste_name: "NE",
  },
  {
    zip_code: "68711",

    ste_name: "NE",
  },
  {
    zip_code: "68780",

    ste_name: "NE",
  },
  {
    zip_code: "68876",

    ste_name: "NE",
  },
  {
    zip_code: "68922",

    ste_name: "NE",
  },
  {
    zip_code: "68927",

    ste_name: "NE",
  },
  {
    zip_code: "69351",

    ste_name: "NE",
  },
  {
    zip_code: "70393",

    ste_name: "LA",
  },
  {
    zip_code: "70458",

    ste_name: "LA",
  },
  {
    zip_code: "70525",

    ste_name: "LA",
  },
  {
    zip_code: "70528",

    ste_name: "LA",
  },
  {
    zip_code: "70586",

    ste_name: "LA",
  },
  {
    zip_code: "70631",

    ste_name: "LA",
  },
  {
    zip_code: "70646",

    ste_name: "LA",
  },
  {
    zip_code: "70654",

    ste_name: "LA",
  },
  {
    zip_code: "70736",

    ste_name: "LA",
  },
  {
    zip_code: "70760",

    ste_name: "LA",
  },
  {
    zip_code: "70782",

    ste_name: "LA",
  },
  {
    zip_code: "71108",

    ste_name: "LA",
  },
  {
    zip_code: "71223",

    ste_name: "LA",
  },
  {
    zip_code: "71233",

    ste_name: "LA",
  },
  {
    zip_code: "71272",

    ste_name: "LA",
  },
  {
    zip_code: "71403",

    ste_name: "LA",
  },
  {
    zip_code: "71409",

    ste_name: "LA",
  },
  {
    zip_code: "71439",

    ste_name: "LA",
  },
  {
    zip_code: "71602",

    ste_name: "AR",
  },
  {
    zip_code: "71740",

    ste_name: "AR",
  },
  {
    zip_code: "71745",

    ste_name: "AR",
  },
  {
    zip_code: "71858",

    ste_name: "AR",
  },
  {
    zip_code: "71937",

    ste_name: "AR",
  },
  {
    zip_code: "71999",

    ste_name: "AR",
  },
  {
    zip_code: "72030",

    ste_name: "AR",
  },
  {
    zip_code: "72044",

    ste_name: "AR",
  },
  {
    zip_code: "72130",

    ste_name: "AR",
  },
  {
    zip_code: "72169",

    ste_name: "AR",
  },
  {
    zip_code: "72322",

    ste_name: "AR",
  },
  {
    zip_code: "72415",

    ste_name: "AR",
  },
  {
    zip_code: "72416",

    ste_name: "AR",
  },
  {
    zip_code: "72429",

    ste_name: "AR",
  },
  {
    zip_code: "72437",

    ste_name: "AR",
  },
  {
    zip_code: "72532",

    ste_name: "AR",
  },
  {
    zip_code: "72567",

    ste_name: "AR",
  },
  {
    zip_code: "72714",

    ste_name: "AR",
  },
  {
    zip_code: "72738",

    ste_name: "AR",
  },
  {
    zip_code: "72756",

    ste_name: "AR",
  },
  {
    zip_code: "72801",

    ste_name: "AR",
  },
  {
    zip_code: "72838",

    ste_name: "AR",
  },
  {
    zip_code: "72943",

    ste_name: "AR",
  },
  {
    zip_code: "73015",

    ste_name: "OK",
  },
  {
    zip_code: "73033",

    ste_name: "OK",
  },
  {
    zip_code: "73041",

    ste_name: "OK",
  },
  {
    zip_code: "73073",

    ste_name: "OK",
  },
  {
    zip_code: "73111",

    ste_name: "OK",
  },
  {
    zip_code: "73165",

    ste_name: "OK",
  },
  {
    zip_code: "73442",

    ste_name: "OK",
  },
  {
    zip_code: "73444",

    ste_name: "OK",
  },
  {
    zip_code: "73459",

    ste_name: "OK",
  },
  {
    zip_code: "73555",

    ste_name: "OK",
  },
  {
    zip_code: "73568",

    ste_name: "OK",
  },
  {
    zip_code: "73662",

    ste_name: "OK",
  },
  {
    zip_code: "73738",

    ste_name: "OK",
  },
  {
    zip_code: "73739",

    ste_name: "OK",
  },
  {
    zip_code: "74003",

    ste_name: "OK",
  },
  {
    zip_code: "74132",

    ste_name: "OK",
  },
  {
    zip_code: "74365",

    ste_name: "OK",
  },
  {
    zip_code: "74434",

    ste_name: "OK",
  },
  {
    zip_code: "74470",

    ste_name: "OK",
  },
  {
    zip_code: "74633",

    ste_name: "OK",
  },
  {
    zip_code: "74730",

    ste_name: "OK",
  },
  {
    zip_code: "74829",

    ste_name: "OK",
  },
  {
    zip_code: "74834",

    ste_name: "OK",
  },
  {
    zip_code: "74875",

    ste_name: "OK",
  },
  {
    zip_code: "74883",

    ste_name: "OK",
  },
  {
    zip_code: "75063",

    ste_name: "TX",
  },
  {
    zip_code: "75101",

    ste_name: "TX",
  },
  {
    zip_code: "75155",

    ste_name: "TX",
  },
  {
    zip_code: "75216",

    ste_name: "TX",
  },
  {
    zip_code: "75244",

    ste_name: "TX",
  },
  {
    zip_code: "75246",

    ste_name: "TX",
  },
  {
    zip_code: "75413",

    ste_name: "TX",
  },
  {
    zip_code: "75480",

    ste_name: "TX",
  },
  {
    zip_code: "75604",

    ste_name: "TX",
  },
  {
    zip_code: "75785",

    ste_name: "TX",
  },
  {
    zip_code: "76001",

    ste_name: "TX",
  },
  {
    zip_code: "76070",

    ste_name: "TX",
  },
  {
    zip_code: "76103",

    ste_name: "TX",
  },
  {
    zip_code: "76210",

    ste_name: "TX",
  },
  {
    zip_code: "76238",

    ste_name: "TX",
  },
  {
    zip_code: "76239",

    ste_name: "TX",
  },
  {
    zip_code: "76250",

    ste_name: "TX",
  },
  {
    zip_code: "76357",

    ste_name: "TX",
  },
  {
    zip_code: "76448",

    ste_name: "TX",
  },
  {
    zip_code: "76484",

    ste_name: "TX",
  },
  {
    zip_code: "76502",

    ste_name: "TX",
  },
  {
    zip_code: "76541",

    ste_name: "TX",
  },
  {
    zip_code: "76542",

    ste_name: "TX",
  },
  {
    zip_code: "76543",

    ste_name: "TX",
  },
  {
    zip_code: "76571",

    ste_name: "TX",
  },
  {
    zip_code: "76622",

    ste_name: "TX",
  },
  {
    zip_code: "77005",

    ste_name: "TX",
  },
  {
    zip_code: "77025",

    ste_name: "TX",
  },
  {
    zip_code: "77047",

    ste_name: "TX",
  },
  {
    zip_code: "77068",

    ste_name: "TX",
  },
  {
    zip_code: "77070",

    ste_name: "TX",
  },
  {
    zip_code: "77074",

    ste_name: "TX",
  },
  {
    zip_code: "77336",

    ste_name: "TX",
  },
  {
    zip_code: "77345",

    ste_name: "TX",
  },
  {
    zip_code: "77498",

    ste_name: "TX",
  },
  {
    zip_code: "77551",

    ste_name: "TX",
  },
  {
    zip_code: "77615",

    ste_name: "TX",
  },
  {
    zip_code: "77661",

    ste_name: "TX",
  },
  {
    zip_code: "77865",

    ste_name: "TX",
  },
  {
    zip_code: "77982",

    ste_name: "TX",
  },
  {
    zip_code: "77983",

    ste_name: "TX",
  },
  {
    zip_code: "78058",

    ste_name: "TX",
  },
  {
    zip_code: "78152",

    ste_name: "TX",
  },
  {
    zip_code: "78208",

    ste_name: "TX",
  },
  {
    zip_code: "78338",

    ste_name: "TX",
  },
  {
    zip_code: "78393",

    ste_name: "TX",
  },
  {
    zip_code: "78412",

    ste_name: "TX",
  },
  {
    zip_code: "78569",

    ste_name: "TX",
  },
  {
    zip_code: "78586",

    ste_name: "TX",
  },
  {
    zip_code: "78593",

    ste_name: "TX",
  },
  {
    zip_code: "78602",

    ste_name: "TX",
  },
  {
    zip_code: "78628",

    ste_name: "TX",
  },
  {
    zip_code: "78640",

    ste_name: "TX",
  },
  {
    zip_code: "78676",

    ste_name: "TX",
  },
  {
    zip_code: "78727",

    ste_name: "TX",
  },
  {
    zip_code: "78752",

    ste_name: "TX",
  },
  {
    zip_code: "78843",

    ste_name: "TX",
  },
  {
    zip_code: "78941",

    ste_name: "TX",
  },
  {
    zip_code: "79016",

    ste_name: "TX",
  },
  {
    zip_code: "79110",

    ste_name: "TX",
  },
  {
    zip_code: "79229",

    ste_name: "TX",
  },
  {
    zip_code: "79325",

    ste_name: "TX",
  },
  {
    zip_code: "79355",

    ste_name: "TX",
  },
  {
    zip_code: "79357",

    ste_name: "TX",
  },
  {
    zip_code: "79366",

    ste_name: "TX",
  },
  {
    zip_code: "79535",

    ste_name: "TX",
  },
  {
    zip_code: "79764",

    ste_name: "TX",
  },
  {
    zip_code: "80013",

    ste_name: "CO",
  },
  {
    zip_code: "80246",

    ste_name: "CO",
  },
  {
    zip_code: "80260",

    ste_name: "CO",
  },
  {
    zip_code: "80426",

    ste_name: "CO",
  },
  {
    zip_code: "80475",

    ste_name: "CO",
  },
  {
    zip_code: "80504",

    ste_name: "CO",
  },
  {
    zip_code: "80538",

    ste_name: "CO",
  },
  {
    zip_code: "80621",

    ste_name: "CO",
  },
  {
    zip_code: "80642",

    ste_name: "CO",
  },
  {
    zip_code: "80727",

    ste_name: "CO",
  },
  {
    zip_code: "80728",

    ste_name: "CO",
  },
  {
    zip_code: "80805",

    ste_name: "CO",
  },
  {
    zip_code: "80834",

    ste_name: "CO",
  },
  {
    zip_code: "80902",

    ste_name: "CO",
  },
  {
    zip_code: "81007",

    ste_name: "CO",
  },
  {
    zip_code: "81052",

    ste_name: "CO",
  },
  {
    zip_code: "81073",

    ste_name: "CO",
  },
  {
    zip_code: "81212",

    ste_name: "CO",
  },
  {
    zip_code: "81227",

    ste_name: "CO",
  },
  {
    zip_code: "81610",

    ste_name: "CO",
  },
  {
    zip_code: "82223",

    ste_name: "WY",
  },
  {
    zip_code: "82523",

    ste_name: "WY",
  },
  {
    zip_code: "82620",

    ste_name: "WY",
  },
  {
    zip_code: "83253",

    ste_name: "ID",
  },
  {
    zip_code: "83323",

    ste_name: "ID",
  },
  {
    zip_code: "83332",

    ste_name: "ID",
  },
  {
    zip_code: "83404",

    ste_name: "ID",
  },
  {
    zip_code: "83424",

    ste_name: "ID",
  },
  {
    zip_code: "83530",

    ste_name: "ID",
  },
  {
    zip_code: "83677",

    ste_name: "ID",
  },
  {
    zip_code: "83709",

    ste_name: "ID",
  },
  {
    zip_code: "83712",

    ste_name: "ID",
  },
  {
    zip_code: "84038",

    ste_name: "UT",
  },
  {
    zip_code: "84041",

    ste_name: "UT",
  },
  {
    zip_code: "84064",

    ste_name: "UT",
  },
  {
    zip_code: "84087",

    ste_name: "UT",
  },
  {
    zip_code: "84112",

    ste_name: "UT",
  },
  {
    zip_code: "84401",

    ste_name: "UT",
  },
  {
    zip_code: "84724",

    ste_name: "UT",
  },
  {
    zip_code: "84752",

    ste_name: "UT",
  },
  {
    zip_code: "85022",

    ste_name: "AZ",
  },
  {
    zip_code: "85256",

    ste_name: "AZ",
  },
  {
    zip_code: "85308",

    ste_name: "AZ",
  },
  {
    zip_code: "85323",

    ste_name: "AZ",
  },
  {
    zip_code: "85354",

    ste_name: "AZ",
  },
  {
    zip_code: "85362",

    ste_name: "AZ",
  },
  {
    zip_code: "85373",

    ste_name: "AZ",
  },
  {
    zip_code: "85390",

    ste_name: "AZ",
  },
  {
    zip_code: "85541",

    ste_name: "AZ",
  },
  {
    zip_code: "85616",

    ste_name: "AZ",
  },
  {
    zip_code: "85715",

    ste_name: "AZ",
  },
  {
    zip_code: "85936",

    ste_name: "AZ",
  },
  {
    zip_code: "86320",

    ste_name: "AZ",
  },
  {
    zip_code: "86334",

    ste_name: "AZ",
  },
  {
    zip_code: "86403",

    ste_name: "AZ",
  },
  {
    zip_code: "87112",

    ste_name: "NM",
  },
  {
    zip_code: "87316",

    ste_name: "NM",
  },
  {
    zip_code: "87357",

    ste_name: "NM",
  },
  {
    zip_code: "88008",

    ste_name: "NM",
  },
  {
    zip_code: "88242",

    ste_name: "NM",
  },
  {
    zip_code: "89001",

    ste_name: "NV",
  },
  {
    zip_code: "89002",

    ste_name: "NV",
  },
  {
    zip_code: "89311",

    ste_name: "NV",
  },
  {
    zip_code: "89415",

    ste_name: "NV",
  },
  {
    zip_code: "89423",

    ste_name: "NV",
  },
  {
    zip_code: "89424",

    ste_name: "NV",
  },
  {
    zip_code: "89502",

    ste_name: "NV",
  },
  {
    zip_code: "89832",

    ste_name: "NV",
  },
  {
    zip_code: "31020",

    ste_name: "GA",
  },
  {
    zip_code: "31036",

    ste_name: "GA",
  },
  {
    zip_code: "31051",

    ste_name: "GA",
  },
  {
    zip_code: "31060",

    ste_name: "GA",
  },
  {
    zip_code: "31076",

    ste_name: "GA",
  },
  {
    zip_code: "31512",

    ste_name: "GA",
  },
  {
    zip_code: "31513",

    ste_name: "GA",
  },
  {
    zip_code: "31569",

    ste_name: "GA",
  },
  {
    zip_code: "31627",

    ste_name: "GA",
  },
  {
    zip_code: "31649",

    ste_name: "GA",
  },
  {
    zip_code: "31738",

    ste_name: "GA",
  },
  {
    zip_code: "31780",

    ste_name: "GA",
  },
  {
    zip_code: "31807",

    ste_name: "GA",
  },
  {
    zip_code: "31808",

    ste_name: "GA",
  },
  {
    zip_code: "31829",

    ste_name: "GA",
  },
  {
    zip_code: "32068",

    ste_name: "FL",
  },
  {
    zip_code: "32080",

    ste_name: "FL",
  },
  {
    zip_code: "32087",

    ste_name: "FL",
  },
  {
    zip_code: "32110",

    ste_name: "FL",
  },
  {
    zip_code: "32147",

    ste_name: "FL",
  },
  {
    zip_code: "32176",

    ste_name: "FL",
  },
  {
    zip_code: "32256",

    ste_name: "FL",
  },
  {
    zip_code: "32420",

    ste_name: "FL",
  },
  {
    zip_code: "32425",

    ste_name: "FL",
  },
  {
    zip_code: "32446",

    ste_name: "FL",
  },
  {
    zip_code: "32607",

    ste_name: "FL",
  },
  {
    zip_code: "32639",

    ste_name: "FL",
  },
  {
    zip_code: "32732",

    ste_name: "FL",
  },
  {
    zip_code: "32778",

    ste_name: "FL",
  },
  {
    zip_code: "32801",

    ste_name: "FL",
  },
  {
    zip_code: "32807",

    ste_name: "FL",
  },
  {
    zip_code: "32817",

    ste_name: "FL",
  },
  {
    zip_code: "32934",

    ste_name: "FL",
  },
  {
    zip_code: "33010",

    ste_name: "FL",
  },
  {
    zip_code: "33018",

    ste_name: "FL",
  },
  {
    zip_code: "33043",

    ste_name: "FL",
  },
  {
    zip_code: "33122",

    ste_name: "FL",
  },
  {
    zip_code: "33127",

    ste_name: "FL",
  },
  {
    zip_code: "33316",

    ste_name: "FL",
  },
  {
    zip_code: "33351",

    ste_name: "FL",
  },
  {
    zip_code: "33610",

    ste_name: "FL",
  },
  {
    zip_code: "33626",

    ste_name: "FL",
  },
  {
    zip_code: "33705",

    ste_name: "FL",
  },
  {
    zip_code: "33823",

    ste_name: "FL",
  },
  {
    zip_code: "33860",

    ste_name: "FL",
  },
  {
    zip_code: "33966",

    ste_name: "FL",
  },
  {
    zip_code: "34120",

    ste_name: "FL",
  },
  {
    zip_code: "34431",

    ste_name: "FL",
  },
  {
    zip_code: "34758",

    ste_name: "FL",
  },
  {
    zip_code: "34994",

    ste_name: "FL",
  },
  {
    zip_code: "35079",

    ste_name: "AL",
  },
  {
    zip_code: "35179",

    ste_name: "AL",
  },
  {
    zip_code: "35464",

    ste_name: "AL",
  },
  {
    zip_code: "35501",

    ste_name: "AL",
  },
  {
    zip_code: "35564",

    ste_name: "AL",
  },
  {
    zip_code: "35759",

    ste_name: "AL",
  },
  {
    zip_code: "35765",

    ste_name: "AL",
  },
  {
    zip_code: "35956",

    ste_name: "AL",
  },
  {
    zip_code: "35962",

    ste_name: "AL",
  },
  {
    zip_code: "36020",

    ste_name: "AL",
  },
  {
    zip_code: "36082",

    ste_name: "AL",
  },
  {
    zip_code: "36256",

    ste_name: "AL",
  },
  {
    zip_code: "36320",

    ste_name: "AL",
  },
  {
    zip_code: "36374",

    ste_name: "AL",
  },
  {
    zip_code: "36420",

    ste_name: "AL",
  },
  {
    zip_code: "36425",

    ste_name: "AL",
  },
  {
    zip_code: "36432",

    ste_name: "AL",
  },
  {
    zip_code: "36436",

    ste_name: "AL",
  },
  {
    zip_code: "36453",

    ste_name: "AL",
  },
  {
    zip_code: "36480",

    ste_name: "AL",
  },
  {
    zip_code: "36539",

    ste_name: "AL",
  },
  {
    zip_code: "36550",

    ste_name: "AL",
  },
  {
    zip_code: "36562",

    ste_name: "AL",
  },
  {
    zip_code: "36581",

    ste_name: "AL",
  },
  {
    zip_code: "36607",

    ste_name: "AL",
  },
  {
    zip_code: "36701",

    ste_name: "AL",
  },
  {
    zip_code: "36756",

    ste_name: "AL",
  },
  {
    zip_code: "36761",

    ste_name: "AL",
  },
  {
    zip_code: "36768",

    ste_name: "AL",
  },
  {
    zip_code: "36861",

    ste_name: "AL",
  },
  {
    zip_code: "36865",

    ste_name: "AL",
  },
  {
    zip_code: "37013",

    ste_name: "TN",
  },
  {
    zip_code: "37031",

    ste_name: "TN",
  },
  {
    zip_code: "37050",

    ste_name: "TN",
  },
  {
    zip_code: "37078",

    ste_name: "TN",
  },
  {
    zip_code: "37086",

    ste_name: "TN",
  },
  {
    zip_code: "37110",

    ste_name: "TN",
  },
  {
    zip_code: "37211",

    ste_name: "TN",
  },
  {
    zip_code: "37308",

    ste_name: "TN",
  },
  {
    zip_code: "37352",

    ste_name: "TN",
  },
  {
    zip_code: "37756",

    ste_name: "TN",
  },
  {
    zip_code: "37814",

    ste_name: "TN",
  },
  {
    zip_code: "37848",

    ste_name: "TN",
  },
  {
    zip_code: "37852",

    ste_name: "TN",
  },
  {
    zip_code: "37857",

    ste_name: "TN",
  },
  {
    zip_code: "38004",

    ste_name: "TN",
  },
  {
    zip_code: "38060",

    ste_name: "TN",
  },
  {
    zip_code: "38069",

    ste_name: "TN",
  },
  {
    zip_code: "38111",

    ste_name: "TN",
  },
  {
    zip_code: "38134",

    ste_name: "TN",
  },
  {
    zip_code: "38574",

    ste_name: "TN",
  },
  {
    zip_code: "38635",

    ste_name: "MS",
  },
  {
    zip_code: "38821",

    ste_name: "MS",
  },
  {
    zip_code: "38849",

    ste_name: "MS",
  },
  {
    zip_code: "38866",

    ste_name: "MS",
  },
  {
    zip_code: "38870",

    ste_name: "MS",
  },
  {
    zip_code: "57435",

    ste_name: "SD",
  },
  {
    zip_code: "57564",

    ste_name: "SD",
  },
  {
    zip_code: "57747",

    ste_name: "SD",
  },
  {
    zip_code: "57783",

    ste_name: "SD",
  },
  {
    zip_code: "57794",

    ste_name: "SD",
  },
  {
    zip_code: "58008",

    ste_name: "ND",
  },
  {
    zip_code: "58075",

    ste_name: "ND",
  },
  {
    zip_code: "58325",

    ste_name: "ND",
  },
  {
    zip_code: "58344",

    ste_name: "ND",
  },
  {
    zip_code: "58365",

    ste_name: "ND",
  },
  {
    zip_code: "58476",

    ste_name: "ND",
  },
  {
    zip_code: "58562",

    ste_name: "ND",
  },
  {
    zip_code: "58564",

    ste_name: "ND",
  },
  {
    zip_code: "38879",

    ste_name: "MS",
  },
  {
    zip_code: "38913",

    ste_name: "MS",
  },
  {
    zip_code: "39073",

    ste_name: "MS",
  },
  {
    zip_code: "39111",

    ste_name: "MS",
  },
  {
    zip_code: "39144",

    ste_name: "MS",
  },
  {
    zip_code: "39191",

    ste_name: "MS",
  },
  {
    zip_code: "39211",

    ste_name: "MS",
  },
  {
    zip_code: "39232",

    ste_name: "MS",
  },
  {
    zip_code: "39365",

    ste_name: "MS",
  },
  {
    zip_code: "39425",

    ste_name: "MS",
  },
  {
    zip_code: "39456",

    ste_name: "MS",
  },
  {
    zip_code: "39653",

    ste_name: "MS",
  },
  {
    zip_code: "39769",

    ste_name: "MS",
  },
  {
    zip_code: "39824",

    ste_name: "GA",
  },
  {
    zip_code: "39851",

    ste_name: "GA",
  },
  {
    zip_code: "40013",

    ste_name: "KY",
  },
  {
    zip_code: "40019",

    ste_name: "KY",
  },
  {
    zip_code: "40076",

    ste_name: "KY",
  },
  {
    zip_code: "40310",

    ste_name: "KY",
  },
  {
    zip_code: "40840",

    ste_name: "KY",
  },
  {
    zip_code: "40845",

    ste_name: "KY",
  },
  {
    zip_code: "40854",

    ste_name: "KY",
  },
  {
    zip_code: "40977",

    ste_name: "KY",
  },
  {
    zip_code: "41042",

    ste_name: "KY",
  },
  {
    zip_code: "41095",

    ste_name: "KY",
  },
  {
    zip_code: "41164",

    ste_name: "KY",
  },
  {
    zip_code: "41203",

    ste_name: "KY",
  },
  {
    zip_code: "41263",

    ste_name: "KY",
  },
  {
    zip_code: "41385",

    ste_name: "KY",
  },
  {
    zip_code: "41464",

    ste_name: "KY",
  },
  {
    zip_code: "41563",

    ste_name: "KY",
  },
  {
    zip_code: "41653",

    ste_name: "KY",
  },
  {
    zip_code: "41714",

    ste_name: "KY",
  },
  {
    zip_code: "41731",

    ste_name: "KY",
  },
  {
    zip_code: "42120",

    ste_name: "KY",
  },
  {
    zip_code: "42343",

    ste_name: "KY",
  },
  {
    zip_code: "42372",

    ste_name: "KY",
  },
  {
    zip_code: "42459",

    ste_name: "KY",
  },
  {
    zip_code: "42539",

    ste_name: "KY",
  },
  {
    zip_code: "42713",

    ste_name: "KY",
  },
  {
    zip_code: "42758",

    ste_name: "KY",
  },
  {
    zip_code: "43004",

    ste_name: "OH",
  },
  {
    zip_code: "43023",

    ste_name: "OH",
  },
  {
    zip_code: "43107",

    ste_name: "OH",
  },
  {
    zip_code: "43151",

    ste_name: "OH",
  },
  {
    zip_code: "43410",

    ste_name: "OH",
  },
  {
    zip_code: "43434",

    ste_name: "OH",
  },
  {
    zip_code: "43522",

    ste_name: "OH",
  },
  {
    zip_code: "43523",

    ste_name: "OH",
  },
  {
    zip_code: "43533",

    ste_name: "OH",
  },
  {
    zip_code: "43543",

    ste_name: "OH",
  },
  {
    zip_code: "43547",

    ste_name: "OH",
  },
  {
    zip_code: "43620",

    ste_name: "OH",
  },
  {
    zip_code: "43760",

    ste_name: "OH",
  },
  {
    zip_code: "43905",

    ste_name: "OH",
  },
  {
    zip_code: "43917",

    ste_name: "OH",
  },
  {
    zip_code: "43930",

    ste_name: "OH",
  },
  {
    zip_code: "43951",

    ste_name: "OH",
  },
  {
    zip_code: "44113",

    ste_name: "OH",
  },
  {
    zip_code: "44114",

    ste_name: "OH",
  },
  {
    zip_code: "44133",

    ste_name: "OH",
  },
  {
    zip_code: "44250",

    ste_name: "OH",
  },
  {
    zip_code: "44251",

    ste_name: "OH",
  },
  {
    zip_code: "44280",

    ste_name: "OH",
  },
  {
    zip_code: "44281",

    ste_name: "OH",
  },
  {
    zip_code: "44320",

    ste_name: "OH",
  },
  {
    zip_code: "44441",

    ste_name: "OH",
  },
  {
    zip_code: "44452",

    ste_name: "OH",
  },
  {
    zip_code: "44512",

    ste_name: "OH",
  },
  {
    zip_code: "44656",

    ste_name: "OH",
  },
  {
    zip_code: "44703",

    ste_name: "OH",
  },
  {
    zip_code: "44811",

    ste_name: "OH",
  },
  {
    zip_code: "44813",

    ste_name: "OH",
  },
  {
    zip_code: "44824",

    ste_name: "OH",
  },
  {
    zip_code: "44874",

    ste_name: "OH",
  },
  {
    zip_code: "45064",

    ste_name: "OH",
  },
  {
    zip_code: "45148",

    ste_name: "OH",
  },
  {
    zip_code: "45248",

    ste_name: "OH",
  },
  {
    zip_code: "45340",

    ste_name: "OH",
  },
  {
    zip_code: "45424",

    ste_name: "OH",
  },
  {
    zip_code: "45439",

    ste_name: "OH",
  },
  {
    zip_code: "45616",

    ste_name: "OH",
  },
  {
    zip_code: "45644",

    ste_name: "OH",
  },
  {
    zip_code: "45768",

    ste_name: "OH",
  },
  {
    zip_code: "45772",

    ste_name: "OH",
  },
  {
    zip_code: "45817",

    ste_name: "OH",
  },
  {
    zip_code: "45865",

    ste_name: "OH",
  },
  {
    zip_code: "45874",

    ste_name: "OH",
  },
  {
    zip_code: "45881",

    ste_name: "OH",
  },
  {
    zip_code: "45887",

    ste_name: "OH",
  },
  {
    zip_code: "46039",

    ste_name: "IN",
  },
  {
    zip_code: "46069",

    ste_name: "IN",
  },
  {
    zip_code: "46165",

    ste_name: "IN",
  },
  {
    zip_code: "46225",

    ste_name: "IN",
  },
  {
    zip_code: "46617",

    ste_name: "IN",
  },
  {
    zip_code: "46704",

    ste_name: "IN",
  },
  {
    zip_code: "46761",

    ste_name: "IN",
  },
  {
    zip_code: "46771",

    ste_name: "IN",
  },
  {
    zip_code: "46915",

    ste_name: "IN",
  },
  {
    zip_code: "46986",

    ste_name: "IN",
  },
  {
    zip_code: "46992",

    ste_name: "IN",
  },
  {
    zip_code: "47018",

    ste_name: "IN",
  },
  {
    zip_code: "47116",

    ste_name: "IN",
  },
  {
    zip_code: "47172",

    ste_name: "IN",
  },
  {
    zip_code: "47246",

    ste_name: "IN",
  },
  {
    zip_code: "47247",

    ste_name: "IN",
  },
  {
    zip_code: "47281",

    ste_name: "IN",
  },
  {
    zip_code: "47380",

    ste_name: "IN",
  },
  {
    zip_code: "47394",

    ste_name: "IN",
  },
  {
    zip_code: "47404",

    ste_name: "IN",
  },
  {
    zip_code: "47433",

    ste_name: "IN",
  },
  {
    zip_code: "47449",

    ste_name: "IN",
  },
  {
    zip_code: "47451",

    ste_name: "IN",
  },
  {
    zip_code: "47501",

    ste_name: "IN",
  },
  {
    zip_code: "47598",

    ste_name: "IN",
  },
  {
    zip_code: "47633",

    ste_name: "IN",
  },
  {
    zip_code: "47715",

    ste_name: "IN",
  },
  {
    zip_code: "47836",

    ste_name: "IN",
  },
  {
    zip_code: "47854",

    ste_name: "IN",
  },
  {
    zip_code: "47862",

    ste_name: "IN",
  },
  {
    zip_code: "47932",

    ste_name: "IN",
  },
  {
    zip_code: "47942",

    ste_name: "IN",
  },
  {
    zip_code: "47971",

    ste_name: "IN",
  },
  {
    zip_code: "47991",

    ste_name: "IN",
  },
  {
    zip_code: "48082",

    ste_name: "MI",
  },
  {
    zip_code: "48135",

    ste_name: "MI",
  },
  {
    zip_code: "48160",

    ste_name: "MI",
  },
  {
    zip_code: "48173",

    ste_name: "MI",
  },
  {
    zip_code: "48202",

    ste_name: "MI",
  },
  {
    zip_code: "48320",

    ste_name: "MI",
  },
  {
    zip_code: "48328",

    ste_name: "MI",
  },
  {
    zip_code: "48502",

    ste_name: "MI",
  },
  {
    zip_code: "48506",

    ste_name: "MI",
  },
  {
    zip_code: "48609",

    ste_name: "MI",
  },
  {
    zip_code: "48755",

    ste_name: "MI",
  },
  {
    zip_code: "48836",

    ste_name: "MI",
  },
  {
    zip_code: "49047",

    ste_name: "MI",
  },
  {
    zip_code: "49098",

    ste_name: "MI",
  },
  {
    zip_code: "49129",

    ste_name: "MI",
  },
  {
    zip_code: "49310",

    ste_name: "MI",
  },
  {
    zip_code: "49349",

    ste_name: "MI",
  },
  {
    zip_code: "49656",

    ste_name: "MI",
  },
  {
    zip_code: "49677",

    ste_name: "MI",
  },
  {
    zip_code: "49825",

    ste_name: "MI",
  },
  {
    zip_code: "49908",

    ste_name: "MI",
  },
  {
    zip_code: "49912",

    ste_name: "MI",
  },
  {
    zip_code: "49925",

    ste_name: "MI",
  },
  {
    zip_code: "50261",

    ste_name: "IA",
  },
  {
    zip_code: "50311",

    ste_name: "IA",
  },
  {
    zip_code: "50439",

    ste_name: "IA",
  },
  {
    zip_code: "50452",

    ste_name: "IA",
  },
  {
    zip_code: "50457",

    ste_name: "IA",
  },
  {
    zip_code: "50516",

    ste_name: "IA",
  },
  {
    zip_code: "50528",

    ste_name: "IA",
  },
  {
    zip_code: "50530",

    ste_name: "IA",
  },
  {
    zip_code: "50593",

    ste_name: "IA",
  },
  {
    zip_code: "50612",

    ste_name: "IA",
  },
  {
    zip_code: "50619",

    ste_name: "IA",
  },
  {
    zip_code: "50674",

    ste_name: "IA",
  },
  {
    zip_code: "51007",

    ste_name: "IA",
  },
  {
    zip_code: "51018",

    ste_name: "IA",
  },
  {
    zip_code: "51023",

    ste_name: "IA",
  },
  {
    zip_code: "51033",

    ste_name: "IA",
  },
  {
    zip_code: "51054",

    ste_name: "IA",
  },
  {
    zip_code: "51333",

    ste_name: "IA",
  },
  {
    zip_code: "51439",

    ste_name: "IA",
  },
  {
    zip_code: "51535",

    ste_name: "IA",
  },
  {
    zip_code: "51541",

    ste_name: "IA",
  },
  {
    zip_code: "51544",

    ste_name: "IA",
  },
  {
    zip_code: "51548",

    ste_name: "IA",
  },
  {
    zip_code: "51559",

    ste_name: "IA",
  },
  {
    zip_code: "51576",

    ste_name: "IA",
  },
  {
    zip_code: "51631",

    ste_name: "IA",
  },
  {
    zip_code: "52072",

    ste_name: "IA",
  },
  {
    zip_code: "52212",

    ste_name: "IA",
  },
  {
    zip_code: "52307",

    ste_name: "IA",
  },
  {
    zip_code: "52404",

    ste_name: "IA",
  },
  {
    zip_code: "52655",

    ste_name: "IA",
  },
  {
    zip_code: "52726",

    ste_name: "IA",
  },
  {
    zip_code: "53007",

    ste_name: "WI",
  },
  {
    zip_code: "53018",

    ste_name: "WI",
  },
  {
    zip_code: "53092",

    ste_name: "WI",
  },
  {
    zip_code: "53168",

    ste_name: "WI",
  },
  {
    zip_code: "53192",

    ste_name: "WI",
  },
  {
    zip_code: "53202",

    ste_name: "WI",
  },
  {
    zip_code: "53515",

    ste_name: "WI",
  },
  {
    zip_code: "53536",

    ste_name: "WI",
  },
  {
    zip_code: "53545",

    ste_name: "WI",
  },
  {
    zip_code: "53556",

    ste_name: "WI",
  },
  {
    zip_code: "53573",

    ste_name: "WI",
  },
  {
    zip_code: "53704",

    ste_name: "WI",
  },
  {
    zip_code: "53718",

    ste_name: "WI",
  },
  {
    zip_code: "53937",

    ste_name: "WI",
  },
  {
    zip_code: "54011",

    ste_name: "WI",
  },
  {
    zip_code: "54173",

    ste_name: "WI",
  },
  {
    zip_code: "54411",

    ste_name: "WI",
  },
  {
    zip_code: "54435",

    ste_name: "WI",
  },
  {
    zip_code: "54467",

    ste_name: "WI",
  },
  {
    zip_code: "54534",

    ste_name: "WI",
  },
  {
    zip_code: "54615",

    ste_name: "WI",
  },
  {
    zip_code: "54616",

    ste_name: "WI",
  },
  {
    zip_code: "54643",

    ste_name: "WI",
  },
  {
    zip_code: "54654",

    ste_name: "WI",
  },
  {
    zip_code: "54670",

    ste_name: "WI",
  },
  {
    zip_code: "54801",

    ste_name: "WI",
  },
  {
    zip_code: "54822",

    ste_name: "WI",
  },
  {
    zip_code: "54858",

    ste_name: "WI",
  },
  {
    zip_code: "55016",

    ste_name: "MN",
  },
  {
    zip_code: "55027",

    ste_name: "MN",
  },
  {
    zip_code: "55037",

    ste_name: "MN",
  },
  {
    zip_code: "55074",

    ste_name: "MN",
  },
  {
    zip_code: "55077",

    ste_name: "MN",
  },
  {
    zip_code: "55111",

    ste_name: "MN",
  },
  {
    zip_code: "55115",

    ste_name: "MN",
  },
  {
    zip_code: "55122",

    ste_name: "MN",
  },
  {
    zip_code: "55128",

    ste_name: "MN",
  },
  {
    zip_code: "55366",

    ste_name: "MN",
  },
  {
    zip_code: "55387",

    ste_name: "MN",
  },
  {
    zip_code: "55414",

    ste_name: "MN",
  },
  {
    zip_code: "55438",

    ste_name: "MN",
  },
  {
    zip_code: "55601",

    ste_name: "MN",
  },
  {
    zip_code: "55613",

    ste_name: "MN",
  },
  {
    zip_code: "55775",

    ste_name: "MN",
  },
  {
    zip_code: "55802",

    ste_name: "MN",
  },
  {
    zip_code: "55806",

    ste_name: "MN",
  },
  {
    zip_code: "55918",

    ste_name: "MN",
  },
  {
    zip_code: "55946",

    ste_name: "MN",
  },
  {
    zip_code: "56011",

    ste_name: "MN",
  },
  {
    zip_code: "56062",

    ste_name: "MN",
  },
  {
    zip_code: "56069",

    ste_name: "MN",
  },
  {
    zip_code: "56096",

    ste_name: "MN",
  },
  {
    zip_code: "56143",

    ste_name: "MN",
  },
  {
    zip_code: "56186",

    ste_name: "MN",
  },
  {
    zip_code: "56262",

    ste_name: "MN",
  },
  {
    zip_code: "56293",

    ste_name: "MN",
  },
  {
    zip_code: "56294",

    ste_name: "MN",
  },
  {
    zip_code: "56325",

    ste_name: "MN",
  },
  {
    zip_code: "56334",

    ste_name: "MN",
  },
  {
    zip_code: "56338",

    ste_name: "MN",
  },
  {
    zip_code: "56378",

    ste_name: "MN",
  },
  {
    zip_code: "56481",

    ste_name: "MN",
  },
  {
    zip_code: "56528",

    ste_name: "MN",
  },
  {
    zip_code: "56636",

    ste_name: "MN",
  },
  {
    zip_code: "56650",

    ste_name: "MN",
  },
  {
    zip_code: "56684",

    ste_name: "MN",
  },
  {
    zip_code: "56737",

    ste_name: "MN",
  },
  {
    zip_code: "57001",

    ste_name: "SD",
  },
  {
    zip_code: "92835",

    ste_name: "CA",
  },
  {
    zip_code: "93901",

    ste_name: "CA",
  },
  {
    zip_code: "94070",

    ste_name: "CA",
  },
  {
    zip_code: "94533",

    ste_name: "CA",
  },
  {
    zip_code: "94575",

    ste_name: "CA",
  },
  {
    zip_code: "94603",

    ste_name: "CA",
  },
  {
    zip_code: "94952",

    ste_name: "CA",
  },
  {
    zip_code: "95030",

    ste_name: "CA",
  },
  {
    zip_code: "95032",

    ste_name: "CA",
  },
  {
    zip_code: "95039",

    ste_name: "CA",
  },
  {
    zip_code: "95041",

    ste_name: "CA",
  },
  {
    zip_code: "95076",

    ste_name: "CA",
  },
  {
    zip_code: "95228",

    ste_name: "CA",
  },
  {
    zip_code: "95247",

    ste_name: "CA",
  },
  {
    zip_code: "95463",

    ste_name: "CA",
  },
  {
    zip_code: "95464",

    ste_name: "CA",
  },
  {
    zip_code: "95468",

    ste_name: "CA",
  },
  {
    zip_code: "95524",

    ste_name: "CA",
  },
  {
    zip_code: "95552",

    ste_name: "CA",
  },
  {
    zip_code: "95614",

    ste_name: "CA",
  },
  {
    zip_code: "95631",

    ste_name: "CA",
  },
  {
    zip_code: "95673",

    ste_name: "CA",
  },
  {
    zip_code: "95747",

    ste_name: "CA",
  },
  {
    zip_code: "95829",

    ste_name: "CA",
  },
  {
    zip_code: "95971",

    ste_name: "CA",
  },
  {
    zip_code: "96002",

    ste_name: "CA",
  },
  {
    zip_code: "96016",

    ste_name: "CA",
  },
  {
    zip_code: "96129",

    ste_name: "CA",
  },
  {
    zip_code: "96773",

    ste_name: "HI",
  },
  {
    zip_code: "96786",

    ste_name: "HI",
  },
  {
    zip_code: "97041",

    ste_name: "OR",
  },
  {
    zip_code: "97062",

    ste_name: "OR",
  },
  {
    zip_code: "97065",

    ste_name: "OR",
  },
  {
    zip_code: "97131",

    ste_name: "OR",
  },
  {
    zip_code: "97450",

    ste_name: "OR",
  },
  {
    zip_code: "98224",

    ste_name: "WA",
  },
  {
    zip_code: "98236",

    ste_name: "WA",
  },
  {
    zip_code: "98250",

    ste_name: "WA",
  },
  {
    zip_code: "98292",

    ste_name: "WA",
  },
  {
    zip_code: "98337",

    ste_name: "WA",
  },
  {
    zip_code: "98354",

    ste_name: "WA",
  },
  {
    zip_code: "90047",

    ste_name: "CA",
  },
  {
    zip_code: "90057",

    ste_name: "CA",
  },
  {
    zip_code: "90062",

    ste_name: "CA",
  },
  {
    zip_code: "90254",

    ste_name: "CA",
  },
  {
    zip_code: "90601",

    ste_name: "CA",
  },
  {
    zip_code: "90712",

    ste_name: "CA",
  },
  {
    zip_code: "90745",

    ste_name: "CA",
  },
  {
    zip_code: "90815",

    ste_name: "CA",
  },
  {
    zip_code: "91210",

    ste_name: "CA",
  },
  {
    zip_code: "91343",

    ste_name: "CA",
  },
  {
    zip_code: "91733",

    ste_name: "CA",
  },
  {
    zip_code: "91791",

    ste_name: "CA",
  },
  {
    zip_code: "91913",

    ste_name: "CA",
  },
  {
    zip_code: "92008",

    ste_name: "CA",
  },
  {
    zip_code: "92037",

    ste_name: "CA",
  },
  {
    zip_code: "92119",

    ste_name: "CA",
  },
  {
    zip_code: "92225",

    ste_name: "CA",
  },
  {
    zip_code: "92304",

    ste_name: "CA",
  },
  {
    zip_code: "92315",

    ste_name: "CA",
  },
  {
    zip_code: "92322",

    ste_name: "CA",
  },
  {
    zip_code: "92325",

    ste_name: "CA",
  },
  {
    zip_code: "92392",

    ste_name: "CA",
  },
  {
    zip_code: "92587",

    ste_name: "CA",
  },
  {
    zip_code: "92646",

    ste_name: "CA",
  },
  {
    zip_code: "92706",

    ste_name: "CA",
  },
  {
    zip_code: "92708",

    ste_name: "CA",
  },
  {
    zip_code: "92832",

    ste_name: "CA",
  },
  {
    zip_code: "92879",

    ste_name: "CA",
  },
  {
    zip_code: "93036",

    ste_name: "CA",
  },
  {
    zip_code: "93040",

    ste_name: "CA",
  },
  {
    zip_code: "93285",

    ste_name: "CA",
  },
  {
    zip_code: "93434",

    ste_name: "CA",
  },
  {
    zip_code: "93460",

    ste_name: "CA",
  },
  {
    zip_code: "93463",

    ste_name: "CA",
  },
  {
    zip_code: "93541",

    ste_name: "CA",
  },
  {
    zip_code: "93631",

    ste_name: "CA",
  },
  {
    zip_code: "93641",

    ste_name: "CA",
  },
  {
    zip_code: "93710",

    ste_name: "CA",
  },
  {
    zip_code: "97266",

    ste_name: "OR",
  },
  {
    zip_code: "97305",

    ste_name: "OR",
  },
  {
    zip_code: "97358",

    ste_name: "OR",
  },
  {
    zip_code: "97378",

    ste_name: "OR",
  },
  {
    zip_code: "97434",

    ste_name: "OR",
  },
  {
    zip_code: "97473",

    ste_name: "OR",
  },
  {
    zip_code: "97753",

    ste_name: "OR",
  },
  {
    zip_code: "97754",

    ste_name: "OR",
  },
  {
    zip_code: "97873",

    ste_name: "OR",
  },
  {
    zip_code: "98004",

    ste_name: "WA",
  },
  {
    zip_code: "98136",

    ste_name: "WA",
  },
  {
    zip_code: "98396",

    ste_name: "WA",
  },
  {
    zip_code: "98643",

    ste_name: "WA",
  },
  {
    zip_code: "98673",

    ste_name: "WA",
  },
  {
    zip_code: "98908",

    ste_name: "WA",
  },
  {
    zip_code: "98938",

    ste_name: "WA",
  },
  {
    zip_code: "99018",

    ste_name: "WA",
  },
  {
    zip_code: "99131",

    ste_name: "WA",
  },
  {
    zip_code: "99169",

    ste_name: "WA",
  },
  {
    zip_code: "99402",

    ste_name: "WA",
  },
  {
    zip_code: "99508",

    ste_name: "AK",
  },
  {
    zip_code: "99568",

    ste_name: "AK",
  },
  {
    zip_code: "99633",

    ste_name: "AK",
  },
  {
    zip_code: "99762",

    ste_name: "AK",
  },
  {
    zip_code: "99763",

    ste_name: "AK",
  },
  {
    zip_code: "98416",

    ste_name: "WA",
  },
  {
    zip_code: "98520",

    ste_name: "WA",
  },
  {
    zip_code: "98588",

    ste_name: "WA",
  },
  {
    zip_code: "98604",

    ste_name: "WA",
  },
  {
    zip_code: "98819",

    ste_name: "WA",
  },
  {
    zip_code: "98828",

    ste_name: "WA",
  },
  {
    zip_code: "98829",

    ste_name: "WA",
  },
  {
    zip_code: "98923",

    ste_name: "WA",
  },
  {
    zip_code: "99032",

    ste_name: "WA",
  },
  {
    zip_code: "99212",

    ste_name: "WA",
  },
  {
    zip_code: "99362",

    ste_name: "WA",
  },
  {
    zip_code: "99403",

    ste_name: "WA",
  },
  {
    zip_code: "99565",

    ste_name: "AK",
  },
  {
    zip_code: "99615",

    ste_name: "AK",
  },
  {
    zip_code: "99648",

    ste_name: "AK",
  },
  {
    zip_code: "99737",

    ste_name: "AK",
  },
  {
    zip_code: "99922",

    ste_name: "AK",
  },
  {
    zip_code: "741",

    ste_name: "PR",
  },
  {
    zip_code: "745",

    ste_name: "PR",
  },
  {
    zip_code: "757",

    ste_name: "PR",
  },
  {
    zip_code: "769",

    ste_name: "PR",
  },
  {
    zip_code: "777",

    ste_name: "PR",
  },
  {
    zip_code: "831",

    ste_name: "VI",
  },
  {
    zip_code: "983",

    ste_name: "PR",
  },
  {
    zip_code: "1128",

    ste_name: "MA",
  },
  {
    zip_code: "1506",

    ste_name: "MA",
  },
  {
    zip_code: "1908",

    ste_name: "MA",
  },
  {
    zip_code: "1915",

    ste_name: "MA",
  },
  {
    zip_code: "1945",

    ste_name: "MA",
  },
  {
    zip_code: "2050",

    ste_name: "MA",
  },
  {
    zip_code: "2072",

    ste_name: "MA",
  },
  {
    zip_code: "2140",

    ste_name: "MA",
  },
  {
    zip_code: "2145",

    ste_name: "MA",
  },
  {
    zip_code: "2148",

    ste_name: "MA",
  },
  {
    zip_code: "2151",

    ste_name: "MA",
  },
  {
    zip_code: "2341",

    ste_name: "MA",
  },
  {
    zip_code: "2476",

    ste_name: "MA",
  },
  {
    zip_code: "2554",

    ste_name: "MA",
  },
  {
    zip_code: "2643",

    ste_name: "MA",
  },
  {
    zip_code: "2666",

    ste_name: "MA",
  },
  {
    zip_code: "2842",

    ste_name: "RI",
  },
  {
    zip_code: "2905",

    ste_name: "RI",
  },
  {
    zip_code: "3054",

    ste_name: "NH",
  },
  {
    zip_code: "3224",

    ste_name: "NH",
  },
  {
    zip_code: "3444",

    ste_name: "NH",
  },
  {
    zip_code: "3448",

    ste_name: "NH",
  },
  {
    zip_code: "3452",

    ste_name: "NH",
  },
  {
    zip_code: "3579",

    ste_name: "NH",
  },
  {
    zip_code: "3586",

    ste_name: "NH",
  },
  {
    zip_code: "3801",

    ste_name: "NH",
  },
  {
    zip_code: "3810",

    ste_name: "NH",
  },
  {
    zip_code: "3857",

    ste_name: "NH",
  },
  {
    zip_code: "3901",

    ste_name: "ME",
  },
  {
    zip_code: "4042",

    ste_name: "ME",
  },
  {
    zip_code: "4265",

    ste_name: "ME",
  },
  {
    zip_code: "4422",

    ste_name: "ME",
  },
  {
    zip_code: "4456",

    ste_name: "ME",
  },
  {
    zip_code: "4671",

    ste_name: "ME",
  },
  {
    zip_code: "4772",

    ste_name: "ME",
  },
  {
    zip_code: "4937",

    ste_name: "ME",
  },
  {
    zip_code: "5154",

    ste_name: "VT",
  },
  {
    zip_code: "5355",

    ste_name: "VT",
  },
  {
    zip_code: "5442",

    ste_name: "VT",
  },
  {
    zip_code: "5477",

    ste_name: "VT",
  },
  {
    zip_code: "5742",

    ste_name: "VT",
  },
  {
    zip_code: "5759",

    ste_name: "VT",
  },
  {
    zip_code: "5761",

    ste_name: "VT",
  },
  {
    zip_code: "5773",

    ste_name: "VT",
  },
  {
    zip_code: "5777",

    ste_name: "VT",
  },
  {
    zip_code: "6019",

    ste_name: "CT",
  },
  {
    zip_code: "6117",

    ste_name: "CT",
  },
  {
    zip_code: "6120",

    ste_name: "CT",
  },
  {
    zip_code: "6256",

    ste_name: "CT",
  },
  {
    zip_code: "6330",

    ste_name: "CT",
  },
  {
    zip_code: "6473",

    ste_name: "CT",
  },
  {
    zip_code: "6762",

    ste_name: "CT",
  },
  {
    zip_code: "6778",

    ste_name: "CT",
  },
  {
    zip_code: "6794",

    ste_name: "CT",
  },
  {
    zip_code: "6877",

    ste_name: "CT",
  },
  {
    zip_code: "7088",

    ste_name: "NJ",
  },
  {
    zip_code: "7093",

    ste_name: "NJ",
  },
  {
    zip_code: "7457",

    ste_name: "NJ",
  },
  {
    zip_code: "7642",

    ste_name: "NJ",
  },
  {
    zip_code: "7750",

    ste_name: "NJ",
  },
  {
    zip_code: "8052",

    ste_name: "NJ",
  },
  {
    zip_code: "8065",

    ste_name: "NJ",
  },
  {
    zip_code: "8093",

    ste_name: "NJ",
  },
  {
    zip_code: "8203",

    ste_name: "NJ",
  },
  {
    zip_code: "8302",

    ste_name: "NJ",
  },
  {
    zip_code: "8317",

    ste_name: "NJ",
  },
  {
    zip_code: "8348",

    ste_name: "NJ",
  },
  {
    zip_code: "8738",

    ste_name: "NJ",
  },
  {
    zip_code: "8861",

    ste_name: "NJ",
  },
  {
    zip_code: "8876",

    ste_name: "NJ",
  },
  {
    zip_code: "8887",

    ste_name: "NJ",
  },
  {
    zip_code: "10168",

    ste_name: "NY",
  },
  {
    zip_code: "10174",

    ste_name: "NY",
  },
  {
    zip_code: "10519",

    ste_name: "NY",
  },
  {
    zip_code: "10596",

    ste_name: "NY",
  },
  {
    zip_code: "10960",

    ste_name: "NY",
  },
  {
    zip_code: "11209",

    ste_name: "NY",
  },
  {
    zip_code: "11237",

    ste_name: "NY",
  },
  {
    zip_code: "11767",

    ste_name: "NY",
  },
  {
    zip_code: "12045",

    ste_name: "NY",
  },
  {
    zip_code: "12074",

    ste_name: "NY",
  },
  {
    zip_code: "12124",

    ste_name: "NY",
  },
  {
    zip_code: "12156",

    ste_name: "NY",
  },
  {
    zip_code: "12192",

    ste_name: "NY",
  },
  {
    zip_code: "12466",

    ste_name: "NY",
  },
  {
    zip_code: "12494",

    ste_name: "NY",
  },
  {
    zip_code: "12601",

    ste_name: "NY",
  },
  {
    zip_code: "12723",

    ste_name: "NY",
  },
  {
    zip_code: "12742",

    ste_name: "NY",
  },
  {
    zip_code: "12750",

    ste_name: "NY",
  },
  {
    zip_code: "12828",

    ste_name: "NY",
  },
  {
    zip_code: "12850",

    ste_name: "NY",
  },
  {
    zip_code: "12943",

    ste_name: "NY",
  },
  {
    zip_code: "12955",

    ste_name: "NY",
  },
  {
    zip_code: "12965",

    ste_name: "NY",
  },
  {
    zip_code: "13051",

    ste_name: "NY",
  },
  {
    zip_code: "13077",

    ste_name: "NY",
  },
  {
    zip_code: "13078",

    ste_name: "NY",
  },
  {
    zip_code: "13159",

    ste_name: "NY",
  },
  {
    zip_code: "13212",

    ste_name: "NY",
  },
  {
    zip_code: "13314",

    ste_name: "NY",
  },
  {
    zip_code: "13318",

    ste_name: "NY",
  },
  {
    zip_code: "13331",

    ste_name: "NY",
  },
  {
    zip_code: "13361",

    ste_name: "NY",
  },
  {
    zip_code: "13413",

    ste_name: "NY",
  },
  {
    zip_code: "13634",

    ste_name: "NY",
  },
  {
    zip_code: "13666",

    ste_name: "NY",
  },
  {
    zip_code: "13672",

    ste_name: "NY",
  },
  {
    zip_code: "13684",

    ste_name: "NY",
  },
  {
    zip_code: "13784",

    ste_name: "NY",
  },
  {
    zip_code: "13825",

    ste_name: "NY",
  },
  {
    zip_code: "13842",

    ste_name: "NY",
  },
  {
    zip_code: "13850",

    ste_name: "NY",
  },
  {
    zip_code: "13864",

    ste_name: "NY",
  },
  {
    zip_code: "14008",

    ste_name: "NY",
  },
  {
    zip_code: "14054",

    ste_name: "NY",
  },
  {
    zip_code: "14080",

    ste_name: "NY",
  },
  {
    zip_code: "14167",

    ste_name: "NY",
  },
  {
    zip_code: "14202",

    ste_name: "NY",
  },
  {
    zip_code: "14218",

    ste_name: "NY",
  },
  {
    zip_code: "14424",

    ste_name: "NY",
  },
  {
    zip_code: "14543",

    ste_name: "NY",
  },
  {
    zip_code: "14545",

    ste_name: "NY",
  },
  {
    zip_code: "14706",

    ste_name: "NY",
  },
  {
    zip_code: "14755",

    ste_name: "NY",
  },
  {
    zip_code: "14769",

    ste_name: "NY",
  },
  {
    zip_code: "14807",

    ste_name: "NY",
  },
  {
    zip_code: "14838",

    ste_name: "NY",
  },
  {
    zip_code: "14854",

    ste_name: "NY",
  },
  {
    zip_code: "14874",

    ste_name: "NY",
  },
  {
    zip_code: "14882",

    ste_name: "NY",
  },
  {
    zip_code: "15050",

    ste_name: "PA",
  },
  {
    zip_code: "15211",

    ste_name: "PA",
  },
  {
    zip_code: "15214",

    ste_name: "PA",
  },
  {
    zip_code: "15260",

    ste_name: "PA",
  },
  {
    zip_code: "15314",

    ste_name: "PA",
  },
  {
    zip_code: "15346",

    ste_name: "PA",
  },
  {
    zip_code: "15367",

    ste_name: "PA",
  },
  {
    zip_code: "15440",

    ste_name: "PA",
  },
  {
    zip_code: "15469",

    ste_name: "PA",
  },
  {
    zip_code: "15628",

    ste_name: "PA",
  },
  {
    zip_code: "15629",

    ste_name: "PA",
  },
  {
    zip_code: "15668",

    ste_name: "PA",
  },
  {
    zip_code: "15759",

    ste_name: "PA",
  },
  {
    zip_code: "15777",

    ste_name: "PA",
  },
  {
    zip_code: "15909",

    ste_name: "PA",
  },
  {
    zip_code: "15958",

    ste_name: "PA",
  },
  {
    zip_code: "16105",

    ste_name: "PA",
  },
  {
    zip_code: "16157",

    ste_name: "PA",
  },
  {
    zip_code: "16255",

    ste_name: "PA",
  },
  {
    zip_code: "16361",

    ste_name: "PA",
  },
  {
    zip_code: "16403",

    ste_name: "PA",
  },
  {
    zip_code: "16415",

    ste_name: "PA",
  },
  {
    zip_code: "16438",

    ste_name: "PA",
  },
  {
    zip_code: "16619",

    ste_name: "PA",
  },
  {
    zip_code: "16620",

    ste_name: "PA",
  },
  {
    zip_code: "16623",

    ste_name: "PA",
  },
  {
    zip_code: "16641",

    ste_name: "PA",
  },
  {
    zip_code: "16835",

    ste_name: "PA",
  },
  {
    zip_code: "16868",

    ste_name: "PA",
  },
  {
    zip_code: "16871",

    ste_name: "PA",
  },
  {
    zip_code: "17034",

    ste_name: "PA",
  },
  {
    zip_code: "17042",

    ste_name: "PA",
  },
  {
    zip_code: "17083",

    ste_name: "PA",
  },
  {
    zip_code: "17229",

    ste_name: "PA",
  },
  {
    zip_code: "17239",

    ste_name: "PA",
  },
  {
    zip_code: "17243",

    ste_name: "PA",
  },
  {
    zip_code: "17254",

    ste_name: "PA",
  },
  {
    zip_code: "17304",

    ste_name: "PA",
  },
  {
    zip_code: "17318",

    ste_name: "PA",
  },
  {
    zip_code: "17538",

    ste_name: "PA",
  },
  {
    zip_code: "17723",

    ste_name: "PA",
  },
  {
    zip_code: "17765",

    ste_name: "PA",
  },
  {
    zip_code: "17864",

    ste_name: "PA",
  },
  {
    zip_code: "17885",

    ste_name: "PA",
  },
  {
    zip_code: "18237",

    ste_name: "PA",
  },
  {
    zip_code: "18436",

    ste_name: "PA",
  },
  {
    zip_code: "18614",

    ste_name: "PA",
  },
  {
    zip_code: "18822",

    ste_name: "PA",
  },
  {
    zip_code: "18847",

    ste_name: "PA",
  },
  {
    zip_code: "18920",

    ste_name: "PA",
  },
  {
    zip_code: "18955",

    ste_name: "PA",
  },
  {
    zip_code: "19078",

    ste_name: "PA",
  },
  {
    zip_code: "19118",

    ste_name: "PA",
  },
  {
    zip_code: "19147",

    ste_name: "PA",
  },
  {
    zip_code: "19373",

    ste_name: "PA",
  },
  {
    zip_code: "19474",

    ste_name: "PA",
  },
  {
    zip_code: "19503",

    ste_name: "PA",
  },
  {
    zip_code: "19504",

    ste_name: "PA",
  },
  {
    zip_code: "19601",

    ste_name: "PA",
  },
  {
    zip_code: "19716",

    ste_name: "DE",
  },
  {
    zip_code: "19808",

    ste_name: "DE",
  },
  {
    zip_code: "20020",

    ste_name: "DC",
  },
  {
    zip_code: "20147",

    ste_name: "VA",
  },
  {
    zip_code: "20180",

    ste_name: "VA",
  },
  {
    zip_code: "20190",

    ste_name: "VA",
  },
  {
    zip_code: "20620",

    ste_name: "MD",
  },
  {
    zip_code: "20737",

    ste_name: "MD",
  },
  {
    zip_code: "20746",

    ste_name: "MD",
  },
  {
    zip_code: "20852",

    ste_name: "MD",
  },
  {
    zip_code: "20879",

    ste_name: "MD",
  },
  {
    zip_code: "20895",

    ste_name: "MD",
  },
  {
    zip_code: "21093",

    ste_name: "MD",
  },
  {
    zip_code: "21158",

    ste_name: "MD",
  },
  {
    zip_code: "21201",

    ste_name: "MD",
  },
  {
    zip_code: "21231",

    ste_name: "MD",
  },
  {
    zip_code: "21639",

    ste_name: "MD",
  },
  {
    zip_code: "21802",

    ste_name: "MD",
  },
  {
    zip_code: "21804",

    ste_name: "MD",
  },
  {
    zip_code: "21813",

    ste_name: "MD",
  },
  {
    zip_code: "21829",

    ste_name: "MD",
  },
  {
    zip_code: "21849",

    ste_name: "MD",
  },
  {
    zip_code: "22311",

    ste_name: "VA",
  },
  {
    zip_code: "22539",

    ste_name: "VA",
  },
  {
    zip_code: "22556",

    ste_name: "VA",
  },
  {
    zip_code: "22572",

    ste_name: "VA",
  },
  {
    zip_code: "22652",

    ste_name: "VA",
  },
  {
    zip_code: "22656",

    ste_name: "VA",
  },
  {
    zip_code: "22747",

    ste_name: "VA",
  },
  {
    zip_code: "22960",

    ste_name: "VA",
  },
  {
    zip_code: "22972",

    ste_name: "VA",
  },
  {
    zip_code: "23079",

    ste_name: "VA",
  },
  {
    zip_code: "23120",

    ste_name: "VA",
  },
  {
    zip_code: "23126",

    ste_name: "VA",
  },
  {
    zip_code: "23153",

    ste_name: "VA",
  },
  {
    zip_code: "23169",

    ste_name: "VA",
  },
  {
    zip_code: "23395",

    ste_name: "VA",
  },
  {
    zip_code: "23427",

    ste_name: "VA",
  },
  {
    zip_code: "23663",

    ste_name: "VA",
  },
  {
    zip_code: "23860",

    ste_name: "VA",
  },
  {
    zip_code: "23889",

    ste_name: "VA",
  },
  {
    zip_code: "23938",

    ste_name: "VA",
  },
  {
    zip_code: "24120",

    ste_name: "VA",
  },
  {
    zip_code: "24174",

    ste_name: "VA",
  },
  {
    zip_code: "24522",

    ste_name: "VA",
  },
  {
    zip_code: "24540",

    ste_name: "VA",
  },
  {
    zip_code: "24595",

    ste_name: "VA",
  },
  {
    zip_code: "24622",

    ste_name: "VA",
  },
  {
    zip_code: "24729",

    ste_name: "WV",
  },
  {
    zip_code: "24862",

    ste_name: "WV",
  },
  {
    zip_code: "24934",

    ste_name: "WV",
  },
  {
    zip_code: "24966",

    ste_name: "WV",
  },
  {
    zip_code: "24970",

    ste_name: "WV",
  },
  {
    zip_code: "25022",

    ste_name: "WV",
  },
  {
    zip_code: "25088",

    ste_name: "WV",
  },
  {
    zip_code: "25111",

    ste_name: "WV",
  },
  {
    zip_code: "25154",

    ste_name: "WV",
  },
  {
    zip_code: "25209",

    ste_name: "WV",
  },
  {
    zip_code: "25507",

    ste_name: "WV",
  },
  {
    zip_code: "25510",

    ste_name: "WV",
  },
  {
    zip_code: "25628",

    ste_name: "WV",
  },
  {
    zip_code: "25630",

    ste_name: "WV",
  },
  {
    zip_code: "25632",

    ste_name: "WV",
  },
  {
    zip_code: "25639",

    ste_name: "WV",
  },
  {
    zip_code: "25823",

    ste_name: "WV",
  },
  {
    zip_code: "25879",

    ste_name: "WV",
  },
  {
    zip_code: "26035",

    ste_name: "WV",
  },
  {
    zip_code: "26050",

    ste_name: "WV",
  },
  {
    zip_code: "26074",

    ste_name: "WV",
  },
  {
    zip_code: "26217",

    ste_name: "WV",
  },
  {
    zip_code: "26271",

    ste_name: "WV",
  },
  {
    zip_code: "26343",

    ste_name: "WV",
  },
  {
    zip_code: "26369",

    ste_name: "WV",
  },
  {
    zip_code: "26421",

    ste_name: "WV",
  },
  {
    zip_code: "26508",

    ste_name: "WV",
  },
  {
    zip_code: "26581",

    ste_name: "WV",
  },
  {
    zip_code: "26720",

    ste_name: "WV",
  },
  {
    zip_code: "27018",

    ste_name: "NC",
  },
  {
    zip_code: "27047",

    ste_name: "NC",
  },
  {
    zip_code: "27048",

    ste_name: "NC",
  },
  {
    zip_code: "27201",

    ste_name: "NC",
  },
  {
    zip_code: "27214",

    ste_name: "NC",
  },
  {
    zip_code: "27253",

    ste_name: "NC",
  },
  {
    zip_code: "27358",

    ste_name: "NC",
  },
  {
    zip_code: "27511",

    ste_name: "NC",
  },
  {
    zip_code: "27846",

    ste_name: "NC",
  },
  {
    zip_code: "27885",

    ste_name: "NC",
  },
  {
    zip_code: "27896",

    ste_name: "NC",
  },
  {
    zip_code: "27910",

    ste_name: "NC",
  },
  {
    zip_code: "27926",

    ste_name: "NC",
  },
  {
    zip_code: "27978",

    ste_name: "NC",
  },
  {
    zip_code: "28021",

    ste_name: "NC",
  },
  {
    zip_code: "28077",

    ste_name: "NC",
  },
  {
    zip_code: "28209",

    ste_name: "NC",
  },
  {
    zip_code: "28226",

    ste_name: "NC",
  },
  {
    zip_code: "28337",

    ste_name: "NC",
  },
  {
    zip_code: "28387",

    ste_name: "NC",
  },
  {
    zip_code: "28393",

    ste_name: "NC",
  },
  {
    zip_code: "28448",

    ste_name: "NC",
  },
  {
    zip_code: "28456",

    ste_name: "NC",
  },
  {
    zip_code: "28465",

    ste_name: "NC",
  },
  {
    zip_code: "28511",

    ste_name: "NC",
  },
  {
    zip_code: "28572",

    ste_name: "NC",
  },
  {
    zip_code: "28575",

    ste_name: "NC",
  },
  {
    zip_code: "28583",

    ste_name: "NC",
  },
  {
    zip_code: "28605",

    ste_name: "NC",
  },
  {
    zip_code: "28720",

    ste_name: "NC",
  },
  {
    zip_code: "28743",

    ste_name: "NC",
  },
  {
    zip_code: "28763",

    ste_name: "NC",
  },
  {
    zip_code: "28771",

    ste_name: "NC",
  },
  {
    zip_code: "28786",

    ste_name: "NC",
  },
  {
    zip_code: "28904",

    ste_name: "NC",
  },
  {
    zip_code: "29047",

    ste_name: "SC",
  },
  {
    zip_code: "29135",

    ste_name: "SC",
  },
  {
    zip_code: "29153",

    ste_name: "SC",
  },
  {
    zip_code: "29377",

    ste_name: "SC",
  },
  {
    zip_code: "29388",

    ste_name: "SC",
  },
  {
    zip_code: "29401",

    ste_name: "SC",
  },
  {
    zip_code: "29423",

    ste_name: "SC",
  },
  {
    zip_code: "29435",

    ste_name: "SC",
  },
  {
    zip_code: "29440",

    ste_name: "SC",
  },
  {
    zip_code: "29450",

    ste_name: "SC",
  },
  {
    zip_code: "29469",

    ste_name: "SC",
  },
  {
    zip_code: "29556",

    ste_name: "SC",
  },
  {
    zip_code: "29568",

    ste_name: "SC",
  },
  {
    zip_code: "29594",

    ste_name: "SC",
  },
  {
    zip_code: "29614",

    ste_name: "SC",
  },
  {
    zip_code: "29682",

    ste_name: "SC",
  },
  {
    zip_code: "29828",

    ste_name: "SC",
  },
  {
    zip_code: "29832",

    ste_name: "SC",
  },
  {
    zip_code: "29921",

    ste_name: "SC",
  },
  {
    zip_code: "30093",

    ste_name: "GA",
  },
  {
    zip_code: "30161",

    ste_name: "GA",
  },
  {
    zip_code: "30293",

    ste_name: "GA",
  },
  {
    zip_code: "30442",

    ste_name: "GA",
  },
  {
    zip_code: "30449",

    ste_name: "GA",
  },
  {
    zip_code: "30523",

    ste_name: "GA",
  },
  {
    zip_code: "30560",

    ste_name: "GA",
  },
  {
    zip_code: "30606",

    ste_name: "GA",
  },
  {
    zip_code: "30808",

    ste_name: "GA",
  },
  {
    zip_code: "30812",

    ste_name: "GA",
  },
  {
    zip_code: "31002",

    ste_name: "GA",
  },
  {
    zip_code: "39040",

    ste_name: "MS",
  },
  {
    zip_code: "39152",

    ste_name: "MS",
  },
  {
    zip_code: "39168",

    ste_name: "MS",
  },
  {
    zip_code: "39573",

    ste_name: "MS",
  },
  {
    zip_code: "39667",

    ste_name: "MS",
  },
  {
    zip_code: "39739",

    ste_name: "MS",
  },
  {
    zip_code: "39842",

    ste_name: "GA",
  },
  {
    zip_code: "39866",

    ste_name: "GA",
  },
  {
    zip_code: "40008",

    ste_name: "KY",
  },
  {
    zip_code: "40220",

    ste_name: "KY",
  },
  {
    zip_code: "40229",

    ste_name: "KY",
  },
  {
    zip_code: "40328",

    ste_name: "KY",
  },
  {
    zip_code: "40383",

    ste_name: "KY",
  },
  {
    zip_code: "40504",

    ste_name: "KY",
  },
  {
    zip_code: "40517",

    ste_name: "KY",
  },
  {
    zip_code: "40855",

    ste_name: "KY",
  },
  {
    zip_code: "41174",

    ste_name: "KY",
  },
  {
    zip_code: "41201",

    ste_name: "KY",
  },
  {
    zip_code: "41365",

    ste_name: "KY",
  },
  {
    zip_code: "41397",

    ste_name: "KY",
  },
  {
    zip_code: "41567",

    ste_name: "KY",
  },
  {
    zip_code: "41635",

    ste_name: "KY",
  },
  {
    zip_code: "41669",

    ste_name: "KY",
  },
  {
    zip_code: "41727",

    ste_name: "KY",
  },
  {
    zip_code: "41834",

    ste_name: "KY",
  },
  {
    zip_code: "42021",

    ste_name: "KY",
  },
  {
    zip_code: "42134",

    ste_name: "KY",
  },
  {
    zip_code: "42214",

    ste_name: "KY",
  },
  {
    zip_code: "42325",

    ste_name: "KY",
  },
  {
    zip_code: "42327",

    ste_name: "KY",
  },
  {
    zip_code: "42501",

    ste_name: "KY",
  },
  {
    zip_code: "43008",

    ste_name: "OH",
  },
  {
    zip_code: "43067",

    ste_name: "OH",
  },
  {
    zip_code: "43076",

    ste_name: "OH",
  },
  {
    zip_code: "43102",

    ste_name: "OH",
  },
  {
    zip_code: "43142",

    ste_name: "OH",
  },
  {
    zip_code: "43230",

    ste_name: "OH",
  },
  {
    zip_code: "43311",

    ste_name: "OH",
  },
  {
    zip_code: "43336",

    ste_name: "OH",
  },
  {
    zip_code: "43348",

    ste_name: "OH",
  },
  {
    zip_code: "43402",

    ste_name: "OH",
  },
  {
    zip_code: "43535",

    ste_name: "OH",
  },
  {
    zip_code: "43558",

    ste_name: "OH",
  },
  {
    zip_code: "43608",

    ste_name: "OH",
  },
  {
    zip_code: "43713",

    ste_name: "OH",
  },
  {
    zip_code: "43732",

    ste_name: "OH",
  },
  {
    zip_code: "43824",

    ste_name: "OH",
  },
  {
    zip_code: "43840",

    ste_name: "OH",
  },
  {
    zip_code: "43938",

    ste_name: "OH",
  },
  {
    zip_code: "44017",

    ste_name: "OH",
  },
  {
    zip_code: "44115",

    ste_name: "OH",
  },
  {
    zip_code: "44122",

    ste_name: "OH",
  },
  {
    zip_code: "44224",

    ste_name: "OH",
  },
  {
    zip_code: "44262",

    ste_name: "OH",
  },
  {
    zip_code: "44274",

    ste_name: "OH",
  },
  {
    zip_code: "44412",

    ste_name: "OH",
  },
  {
    zip_code: "44432",

    ste_name: "OH",
  },
  {
    zip_code: "44437",

    ste_name: "OH",
  },
  {
    zip_code: "44493",

    ste_name: "OH",
  },
  {
    zip_code: "44503",

    ste_name: "OH",
  },
  {
    zip_code: "44607",

    ste_name: "OH",
  },
  {
    zip_code: "44697",

    ste_name: "OH",
  },
  {
    zip_code: "44699",

    ste_name: "OH",
  },
  {
    zip_code: "44906",

    ste_name: "OH",
  },
  {
    zip_code: "45147",

    ste_name: "OH",
  },
  {
    zip_code: "45213",

    ste_name: "OH",
  },
  {
    zip_code: "45217",

    ste_name: "OH",
  },
  {
    zip_code: "45345",

    ste_name: "OH",
  },
  {
    zip_code: "45369",

    ste_name: "OH",
  },
  {
    zip_code: "45382",

    ste_name: "OH",
  },
  {
    zip_code: "45404",

    ste_name: "OH",
  },
  {
    zip_code: "45657",

    ste_name: "OH",
  },
  {
    zip_code: "45701",

    ste_name: "OH",
  },
  {
    zip_code: "45822",

    ste_name: "OH",
  },
  {
    zip_code: "45862",

    ste_name: "OH",
  },
  {
    zip_code: "45873",

    ste_name: "OH",
  },
  {
    zip_code: "46112",

    ste_name: "IN",
  },
  {
    zip_code: "46133",

    ste_name: "IN",
  },
  {
    zip_code: "46167",

    ste_name: "IN",
  },
  {
    zip_code: "46171",

    ste_name: "IN",
  },
  {
    zip_code: "46175",

    ste_name: "IN",
  },
  {
    zip_code: "46176",

    ste_name: "IN",
  },
  {
    zip_code: "46204",

    ste_name: "IN",
  },
  {
    zip_code: "46260",

    ste_name: "IN",
  },
  {
    zip_code: "46373",

    ste_name: "IN",
  },
  {
    zip_code: "46383",

    ste_name: "IN",
  },
  {
    zip_code: "46539",

    ste_name: "IN",
  },
  {
    zip_code: "46797",

    ste_name: "IN",
  },
  {
    zip_code: "46932",

    ste_name: "IN",
  },
  {
    zip_code: "46941",

    ste_name: "IN",
  },
  {
    zip_code: "46950",

    ste_name: "IN",
  },
  {
    zip_code: "46974",

    ste_name: "IN",
  },
  {
    zip_code: "47346",

    ste_name: "IN",
  },
  {
    zip_code: "47436",

    ste_name: "IN",
  },
  {
    zip_code: "47615",

    ste_name: "IN",
  },
  {
    zip_code: "47660",

    ste_name: "IN",
  },
  {
    zip_code: "47846",

    ste_name: "IN",
  },
  {
    zip_code: "47859",

    ste_name: "IN",
  },
  {
    zip_code: "47952",

    ste_name: "IN",
  },
  {
    zip_code: "47954",

    ste_name: "IN",
  },
  {
    zip_code: "47957",

    ste_name: "IN",
  },
  {
    zip_code: "47964",

    ste_name: "IN",
  },
  {
    zip_code: "47981",

    ste_name: "IN",
  },
  {
    zip_code: "48045",

    ste_name: "MI",
  },
  {
    zip_code: "48062",

    ste_name: "MI",
  },
  {
    zip_code: "48063",

    ste_name: "MI",
  },
  {
    zip_code: "48069",

    ste_name: "MI",
  },
  {
    zip_code: "48152",

    ste_name: "MI",
  },
  {
    zip_code: "48214",

    ste_name: "MI",
  },
  {
    zip_code: "48416",

    ste_name: "MI",
  },
  {
    zip_code: "48460",

    ste_name: "MI",
  },
  {
    zip_code: "48618",

    ste_name: "MI",
  },
  {
    zip_code: "48621",

    ste_name: "MI",
  },
  {
    zip_code: "48636",

    ste_name: "MI",
  },
  {
    zip_code: "48767",

    ste_name: "MI",
  },
  {
    zip_code: "48819",

    ste_name: "MI",
  },
  {
    zip_code: "48822",

    ste_name: "MI",
  },
  {
    zip_code: "49017",

    ste_name: "MI",
  },
  {
    zip_code: "49024",

    ste_name: "MI",
  },
  {
    zip_code: "49074",

    ste_name: "MI",
  },
  {
    zip_code: "49075",

    ste_name: "MI",
  },
  {
    zip_code: "49085",

    ste_name: "MI",
  },
  {
    zip_code: "49106",

    ste_name: "MI",
  },
  {
    zip_code: "49246",

    ste_name: "MI",
  },
  {
    zip_code: "49316",

    ste_name: "MI",
  },
  {
    zip_code: "49345",

    ste_name: "MI",
  },
  {
    zip_code: "49410",

    ste_name: "MI",
  },
  {
    zip_code: "49628",

    ste_name: "MI",
  },
  {
    zip_code: "49629",

    ste_name: "MI",
  },
  {
    zip_code: "49638",

    ste_name: "MI",
  },
  {
    zip_code: "49639",

    ste_name: "MI",
  },
  {
    zip_code: "49642",

    ste_name: "MI",
  },
  {
    zip_code: "49655",

    ste_name: "MI",
  },
  {
    zip_code: "49756",

    ste_name: "MI",
  },
  {
    zip_code: "49768",

    ste_name: "MI",
  },
  {
    zip_code: "49886",

    ste_name: "MI",
  },
  {
    zip_code: "49953",

    ste_name: "MI",
  },
  {
    zip_code: "49968",

    ste_name: "MI",
  },
  {
    zip_code: "50011",

    ste_name: "IA",
  },
  {
    zip_code: "50149",

    ste_name: "IA",
  },
  {
    zip_code: "50164",

    ste_name: "IA",
  },
  {
    zip_code: "50227",

    ste_name: "IA",
  },
  {
    zip_code: "50316",

    ste_name: "IA",
  },
  {
    zip_code: "50317",

    ste_name: "IA",
  },
  {
    zip_code: "50433",

    ste_name: "IA",
  },
  {
    zip_code: "50518",

    ste_name: "IA",
  },
  {
    zip_code: "50563",

    ste_name: "IA",
  },
  {
    zip_code: "50597",

    ste_name: "IA",
  },
  {
    zip_code: "50681",

    ste_name: "IA",
  },
  {
    zip_code: "50703",

    ste_name: "IA",
  },
  {
    zip_code: "50847",

    ste_name: "IA",
  },
  {
    zip_code: "51101",

    ste_name: "IA",
  },
  {
    zip_code: "51237",

    ste_name: "IA",
  },
  {
    zip_code: "51343",

    ste_name: "IA",
  },
  {
    zip_code: "51467",

    ste_name: "IA",
  },
  {
    zip_code: "51503",

    ste_name: "IA",
  },
  {
    zip_code: "51525",

    ste_name: "IA",
  },
  {
    zip_code: "51552",

    ste_name: "IA",
  },
  {
    zip_code: "52156",

    ste_name: "IA",
  },
  {
    zip_code: "52157",

    ste_name: "IA",
  },
  {
    zip_code: "52170",

    ste_name: "IA",
  },
  {
    zip_code: "52224",

    ste_name: "IA",
  },
  {
    zip_code: "52305",

    ste_name: "IA",
  },
  {
    zip_code: "52358",

    ste_name: "IA",
  },
  {
    zip_code: "52569",

    ste_name: "IA",
  },
  {
    zip_code: "52657",

    ste_name: "IA",
  },
  {
    zip_code: "52754",

    ste_name: "IA",
  },
  {
    zip_code: "52765",

    ste_name: "IA",
  },
  {
    zip_code: "53051",

    ste_name: "WI",
  },
  {
    zip_code: "53070",

    ste_name: "WI",
  },
  {
    zip_code: "53088",

    ste_name: "WI",
  },
  {
    zip_code: "53189",

    ste_name: "WI",
  },
  {
    zip_code: "53228",

    ste_name: "WI",
  },
  {
    zip_code: "53405",

    ste_name: "WI",
  },
  {
    zip_code: "53533",

    ste_name: "WI",
  },
  {
    zip_code: "53574",

    ste_name: "WI",
  },
  {
    zip_code: "53577",

    ste_name: "WI",
  },
  {
    zip_code: "53581",

    ste_name: "WI",
  },
  {
    zip_code: "53805",

    ste_name: "WI",
  },
  {
    zip_code: "53816",

    ste_name: "WI",
  },
  {
    zip_code: "53910",

    ste_name: "WI",
  },
  {
    zip_code: "53934",

    ste_name: "WI",
  },
  {
    zip_code: "53943",

    ste_name: "WI",
  },
  {
    zip_code: "53960",

    ste_name: "WI",
  },
  {
    zip_code: "54311",

    ste_name: "WI",
  },
  {
    zip_code: "54547",

    ste_name: "WI",
  },
  {
    zip_code: "54613",

    ste_name: "WI",
  },
  {
    zip_code: "54651",

    ste_name: "WI",
  },
  {
    zip_code: "54720",

    ste_name: "WI",
  },
  {
    zip_code: "54746",

    ste_name: "WI",
  },
  {
    zip_code: "54750",

    ste_name: "WI",
  },
  {
    zip_code: "54763",

    ste_name: "WI",
  },
  {
    zip_code: "54806",

    ste_name: "WI",
  },
  {
    zip_code: "54855",

    ste_name: "WI",
  },
  {
    zip_code: "54873",

    ste_name: "WI",
  },
  {
    zip_code: "54956",

    ste_name: "WI",
  },
  {
    zip_code: "55005",

    ste_name: "MN",
  },
  {
    zip_code: "55042",

    ste_name: "MN",
  },
  {
    zip_code: "55108",

    ste_name: "MN",
  },
  {
    zip_code: "55109",

    ste_name: "MN",
  },
  {
    zip_code: "55316",

    ste_name: "MN",
  },
  {
    zip_code: "55322",

    ste_name: "MN",
  },
  {
    zip_code: "55339",

    ste_name: "MN",
  },
  {
    zip_code: "55346",

    ste_name: "MN",
  },
  {
    zip_code: "55362",

    ste_name: "MN",
  },
  {
    zip_code: "55376",

    ste_name: "MN",
  },
  {
    zip_code: "55390",

    ste_name: "MN",
  },
  {
    zip_code: "55397",

    ste_name: "MN",
  },
  {
    zip_code: "55406",

    ste_name: "MN",
  },
  {
    zip_code: "55427",

    ste_name: "MN",
  },
  {
    zip_code: "55450",

    ste_name: "MN",
  },
  {
    zip_code: "55708",

    ste_name: "MN",
  },
  {
    zip_code: "55748",

    ste_name: "MN",
  },
  {
    zip_code: "55782",

    ste_name: "MN",
  },
  {
    zip_code: "55790",

    ste_name: "MN",
  },
  {
    zip_code: "55992",

    ste_name: "MN",
  },
  {
    zip_code: "56001",

    ste_name: "MN",
  },
  {
    zip_code: "56031",

    ste_name: "MN",
  },
  {
    zip_code: "56032",

    ste_name: "MN",
  },
  {
    zip_code: "56078",

    ste_name: "MN",
  },
  {
    zip_code: "56087",

    ste_name: "MN",
  },
  {
    zip_code: "56110",

    ste_name: "MN",
  },
  {
    zip_code: "56119",

    ste_name: "MN",
  },
  {
    zip_code: "56212",

    ste_name: "MN",
  },
  {
    zip_code: "56266",

    ste_name: "MN",
  },
  {
    zip_code: "56355",

    ste_name: "MN",
  },
  {
    zip_code: "56364",

    ste_name: "MN",
  },
  {
    zip_code: "56375",

    ste_name: "MN",
  },
  {
    zip_code: "56441",

    ste_name: "MN",
  },
  {
    zip_code: "56501",

    ste_name: "MN",
  },
  {
    zip_code: "56544",

    ste_name: "MN",
  },
  {
    zip_code: "56545",

    ste_name: "MN",
  },
  {
    zip_code: "56560",

    ste_name: "MN",
  },
  {
    zip_code: "56592",

    ste_name: "MN",
  },
  {
    zip_code: "56623",

    ste_name: "MN",
  },
  {
    zip_code: "56727",

    ste_name: "MN",
  },
  {
    zip_code: "57055",

    ste_name: "SD",
  },
  {
    zip_code: "57077",

    ste_name: "SD",
  },
  {
    zip_code: "57237",

    ste_name: "SD",
  },
  {
    zip_code: "57264",

    ste_name: "SD",
  },
  {
    zip_code: "57276",

    ste_name: "SD",
  },
  {
    zip_code: "57344",

    ste_name: "SD",
  },
  {
    zip_code: "57353",

    ste_name: "SD",
  },
  {
    zip_code: "57437",

    ste_name: "SD",
  },
  {
    zip_code: "57454",

    ste_name: "SD",
  },
  {
    zip_code: "57476",

    ste_name: "SD",
  },
  {
    zip_code: "59035",

    ste_name: "MT",
  },
  {
    zip_code: "59412",

    ste_name: "MT",
  },
  {
    zip_code: "59520",

    ste_name: "MT",
  },
  {
    zip_code: "59545",

    ste_name: "MT",
  },
  {
    zip_code: "59808",

    ste_name: "MT",
  },
  {
    zip_code: "60025",

    ste_name: "IL",
  },
  {
    zip_code: "60083",

    ste_name: "IL",
  },
  {
    zip_code: "60097",

    ste_name: "IL",
  },
  {
    zip_code: "60099",

    ste_name: "IL",
  },
  {
    zip_code: "60106",

    ste_name: "IL",
  },
  {
    zip_code: "60194",

    ste_name: "IL",
  },
  {
    zip_code: "60201",

    ste_name: "IL",
  },
  {
    zip_code: "60433",

    ste_name: "IL",
  },
  {
    zip_code: "60443",

    ste_name: "IL",
  },
  {
    zip_code: "60459",

    ste_name: "IL",
  },
  {
    zip_code: "60468",

    ste_name: "IL",
  },
  {
    zip_code: "60558",

    ste_name: "IL",
  },
  {
    zip_code: "60602",

    ste_name: "IL",
  },
  {
    zip_code: "60608",

    ste_name: "IL",
  },
  {
    zip_code: "60628",

    ste_name: "IL",
  },
  {
    zip_code: "60656",

    ste_name: "IL",
  },
  {
    zip_code: "60919",

    ste_name: "IL",
  },
  {
    zip_code: "60945",

    ste_name: "IL",
  },
  {
    zip_code: "60959",

    ste_name: "IL",
  },
  {
    zip_code: "60962",

    ste_name: "IL",
  },
  {
    zip_code: "61007",

    ste_name: "IL",
  },
  {
    zip_code: "61016",

    ste_name: "IL",
  },
  {
    zip_code: "61063",

    ste_name: "IL",
  },
  {
    zip_code: "61433",

    ste_name: "IL",
  },
  {
    zip_code: "61466",

    ste_name: "IL",
  },
  {
    zip_code: "61535",

    ste_name: "IL",
  },
  {
    zip_code: "61567",

    ste_name: "IL",
  },
  {
    zip_code: "61615",

    ste_name: "IL",
  },
  {
    zip_code: "61705",

    ste_name: "IL",
  },
  {
    zip_code: "61735",

    ste_name: "IL",
  },
  {
    zip_code: "61841",

    ste_name: "IL",
  },
  {
    zip_code: "61849",

    ste_name: "IL",
  },
  {
    zip_code: "61866",

    ste_name: "IL",
  },
  {
    zip_code: "61929",

    ste_name: "IL",
  },
  {
    zip_code: "61931",

    ste_name: "IL",
  },
  {
    zip_code: "61951",

    ste_name: "IL",
  },
  {
    zip_code: "62035",

    ste_name: "IL",
  },
  {
    zip_code: "62203",

    ste_name: "IL",
  },
  {
    zip_code: "62295",

    ste_name: "IL",
  },
  {
    zip_code: "62312",

    ste_name: "IL",
  },
  {
    zip_code: "62358",

    ste_name: "IL",
  },
  {
    zip_code: "62359",

    ste_name: "IL",
  },
  {
    zip_code: "62363",

    ste_name: "IL",
  },
  {
    zip_code: "62380",

    ste_name: "IL",
  },
  {
    zip_code: "62434",

    ste_name: "IL",
  },
  {
    zip_code: "62448",

    ste_name: "IL",
  },
  {
    zip_code: "62476",

    ste_name: "IL",
  },
  {
    zip_code: "62523",

    ste_name: "IL",
  },
  {
    zip_code: "62613",

    ste_name: "IL",
  },
  {
    zip_code: "62667",

    ste_name: "IL",
  },
  {
    zip_code: "62690",

    ste_name: "IL",
  },
  {
    zip_code: "62816",

    ste_name: "IL",
  },
  {
    zip_code: "62850",

    ste_name: "IL",
  },
  {
    zip_code: "62853",

    ste_name: "IL",
  },
  {
    zip_code: "62863",

    ste_name: "IL",
  },
  {
    zip_code: "62965",

    ste_name: "IL",
  },
  {
    zip_code: "63039",

    ste_name: "MO",
  },
  {
    zip_code: "63071",

    ste_name: "MO",
  },
  {
    zip_code: "63072",

    ste_name: "MO",
  },
  {
    zip_code: "63079",

    ste_name: "MO",
  },
  {
    zip_code: "63146",

    ste_name: "MO",
  },
  {
    zip_code: "63373",

    ste_name: "MO",
  },
  {
    zip_code: "63434",

    ste_name: "MO",
  },
  {
    zip_code: "63440",

    ste_name: "MO",
  },
  {
    zip_code: "63473",

    ste_name: "MO",
  },
  {
    zip_code: "63555",

    ste_name: "MO",
  },
  {
    zip_code: "63829",

    ste_name: "MO",
  },
  {
    zip_code: "63845",

    ste_name: "MO",
  },
  {
    zip_code: "63860",

    ste_name: "MO",
  },
  {
    zip_code: "64030",

    ste_name: "MO",
  },
  {
    zip_code: "64055",

    ste_name: "MO",
  },
  {
    zip_code: "64057",

    ste_name: "MO",
  },
  {
    zip_code: "64065",

    ste_name: "MO",
  },
  {
    zip_code: "64074",

    ste_name: "MO",
  },
  {
    zip_code: "64077",

    ste_name: "MO",
  },
  {
    zip_code: "64109",

    ste_name: "MO",
  },
  {
    zip_code: "64123",

    ste_name: "MO",
  },
  {
    zip_code: "64133",

    ste_name: "MO",
  },
  {
    zip_code: "64139",

    ste_name: "MO",
  },
  {
    zip_code: "64149",

    ste_name: "MO",
  },
  {
    zip_code: "64152",

    ste_name: "MO",
  },
  {
    zip_code: "64423",

    ste_name: "MO",
  },
  {
    zip_code: "64473",

    ste_name: "MO",
  },
  {
    zip_code: "64643",

    ste_name: "MO",
  },
  {
    zip_code: "64656",

    ste_name: "MO",
  },
  {
    zip_code: "64747",

    ste_name: "MO",
  },
  {
    zip_code: "64780",

    ste_name: "MO",
  },
  {
    zip_code: "65001",

    ste_name: "MO",
  },
  {
    zip_code: "65332",

    ste_name: "MO",
  },
  {
    zip_code: "65550",

    ste_name: "MO",
  },
  {
    zip_code: "65565",

    ste_name: "MO",
  },
  {
    zip_code: "65586",

    ste_name: "MO",
  },
  {
    zip_code: "65590",

    ste_name: "MO",
  },
  {
    zip_code: "65704",

    ste_name: "MO",
  },
  {
    zip_code: "65721",

    ste_name: "MO",
  },
  {
    zip_code: "65729",

    ste_name: "MO",
  },
  {
    zip_code: "65762",

    ste_name: "MO",
  },
  {
    zip_code: "65764",

    ste_name: "MO",
  },
  {
    zip_code: "66056",

    ste_name: "KS",
  },
  {
    zip_code: "66061",

    ste_name: "KS",
  },
  {
    zip_code: "66094",

    ste_name: "KS",
  },
  {
    zip_code: "66204",

    ste_name: "KS",
  },
  {
    zip_code: "66221",

    ste_name: "KS",
  },
  {
    zip_code: "66428",

    ste_name: "KS",
  },
  {
    zip_code: "66547",

    ste_name: "KS",
  },
  {
    zip_code: "66714",

    ste_name: "KS",
  },
  {
    zip_code: "66845",

    ste_name: "KS",
  },
  {
    zip_code: "66953",

    ste_name: "KS",
  },
  {
    zip_code: "66960",

    ste_name: "KS",
  },
  {
    zip_code: "67012",

    ste_name: "KS",
  },
  {
    zip_code: "67023",

    ste_name: "KS",
  },
  {
    zip_code: "67028",

    ste_name: "KS",
  },
  {
    zip_code: "67029",

    ste_name: "KS",
  },
  {
    zip_code: "67122",

    ste_name: "KS",
  },
  {
    zip_code: "67123",

    ste_name: "KS",
  },
  {
    zip_code: "67147",

    ste_name: "KS",
  },
  {
    zip_code: "67154",

    ste_name: "KS",
  },
  {
    zip_code: "67156",

    ste_name: "KS",
  },
  {
    zip_code: "67205",

    ste_name: "KS",
  },
  {
    zip_code: "67228",

    ste_name: "KS",
  },
  {
    zip_code: "67361",

    ste_name: "KS",
  },
  {
    zip_code: "67466",

    ste_name: "KS",
  },
  {
    zip_code: "67468",

    ste_name: "KS",
  },
  {
    zip_code: "67576",

    ste_name: "KS",
  },
  {
    zip_code: "67649",

    ste_name: "KS",
  },
  {
    zip_code: "67660",

    ste_name: "KS",
  },
  {
    zip_code: "67740",

    ste_name: "KS",
  },
  {
    zip_code: "68029",

    ste_name: "NE",
  },
  {
    zip_code: "68130",

    ste_name: "NE",
  },
  {
    zip_code: "68131",

    ste_name: "NE",
  },
  {
    zip_code: "68152",

    ste_name: "NE",
  },
  {
    zip_code: "68178",

    ste_name: "NE",
  },
  {
    zip_code: "68305",

    ste_name: "NE",
  },
  {
    zip_code: "68313",

    ste_name: "NE",
  },
  {
    zip_code: "68403",

    ste_name: "NE",
  },
  {
    zip_code: "68405",

    ste_name: "NE",
  },
  {
    zip_code: "68414",

    ste_name: "NE",
  },
  {
    zip_code: "68418",

    ste_name: "NE",
  },
  {
    zip_code: "68424",

    ste_name: "NE",
  },
  {
    zip_code: "68463",

    ste_name: "NE",
  },
  {
    zip_code: "68640",

    ste_name: "NE",
  },
  {
    zip_code: "68766",

    ste_name: "NE",
  },
  {
    zip_code: "68784",

    ste_name: "NE",
  },
  {
    zip_code: "68871",

    ste_name: "NE",
  },
  {
    zip_code: "68874",

    ste_name: "NE",
  },
  {
    zip_code: "68977",

    ste_name: "NE",
  },
  {
    zip_code: "69122",

    ste_name: "NE",
  },
  {
    zip_code: "69149",

    ste_name: "NE",
  },
  {
    zip_code: "69301",

    ste_name: "NE",
  },
  {
    zip_code: "69357",

    ste_name: "NE",
  },
  {
    zip_code: "70131",

    ste_name: "LA",
  },
  {
    zip_code: "70373",

    ste_name: "LA",
  },
  {
    zip_code: "70464",

    ste_name: "LA",
  },
  {
    zip_code: "70659",

    ste_name: "LA",
  },
  {
    zip_code: "70714",

    ste_name: "LA",
  },
  {
    zip_code: "70744",

    ste_name: "LA",
  },
  {
    zip_code: "70761",

    ste_name: "LA",
  },
  {
    zip_code: "71354",

    ste_name: "LA",
  },
  {
    zip_code: "71355",

    ste_name: "LA",
  },
  {
    zip_code: "71371",

    ste_name: "LA",
  },
  {
    zip_code: "71411",

    ste_name: "LA",
  },
  {
    zip_code: "71430",

    ste_name: "LA",
  },
  {
    zip_code: "71722",

    ste_name: "AR",
  },
  {
    zip_code: "72006",

    ste_name: "AR",
  },
  {
    zip_code: "72036",

    ste_name: "AR",
  },
  {
    zip_code: "72061",

    ste_name: "AR",
  },
  {
    zip_code: "72080",

    ste_name: "AR",
  },
  {
    zip_code: "72088",

    ste_name: "AR",
  },
  {
    zip_code: "72327",

    ste_name: "AR",
  },
  {
    zip_code: "72367",

    ste_name: "AR",
  },
  {
    zip_code: "72368",

    ste_name: "AR",
  },
  {
    zip_code: "72379",

    ste_name: "AR",
  },
  {
    zip_code: "72413",

    ste_name: "AR",
  },
  {
    zip_code: "72419",

    ste_name: "AR",
  },
  {
    zip_code: "72431",

    ste_name: "AR",
  },
  {
    zip_code: "72523",

    ste_name: "AR",
  },
  {
    zip_code: "72529",

    ste_name: "AR",
  },
  {
    zip_code: "72576",

    ste_name: "AR",
  },
  {
    zip_code: "72578",

    ste_name: "AR",
  },
  {
    zip_code: "72579",

    ste_name: "AR",
  },
  {
    zip_code: "72611",

    ste_name: "AR",
  },
  {
    zip_code: "72644",

    ste_name: "AR",
  },
  {
    zip_code: "72834",

    ste_name: "AR",
  },
  {
    zip_code: "72916",

    ste_name: "AR",
  },
  {
    zip_code: "72951",

    ste_name: "AR",
  },
  {
    zip_code: "73020",

    ste_name: "OK",
  },
  {
    zip_code: "73089",

    ste_name: "OK",
  },
  {
    zip_code: "73098",

    ste_name: "OK",
  },
  {
    zip_code: "73141",

    ste_name: "OK",
  },
  {
    zip_code: "73491",

    ste_name: "OK",
  },
  {
    zip_code: "73542",

    ste_name: "OK",
  },
  {
    zip_code: "73557",

    ste_name: "OK",
  },
  {
    zip_code: "73638",

    ste_name: "OK",
  },
  {
    zip_code: "73742",

    ste_name: "OK",
  },
  {
    zip_code: "74028",

    ste_name: "OK",
  },
  {
    zip_code: "74083",

    ste_name: "OK",
  },
  {
    zip_code: "74145",

    ste_name: "OK",
  },
  {
    zip_code: "74354",

    ste_name: "OK",
  },
  {
    zip_code: "74748",

    ste_name: "OK",
  },
  {
    zip_code: "74849",

    ste_name: "OK",
  },
  {
    zip_code: "75028",

    ste_name: "TX",
  },
  {
    zip_code: "75061",

    ste_name: "TX",
  },
  {
    zip_code: "75142",

    ste_name: "TX",
  },
  {
    zip_code: "75230",

    ste_name: "TX",
  },
  {
    zip_code: "75247",

    ste_name: "TX",
  },
  {
    zip_code: "75409",

    ste_name: "TX",
  },
  {
    zip_code: "75411",

    ste_name: "TX",
  },
  {
    zip_code: "75449",

    ste_name: "TX",
  },
  {
    zip_code: "75472",

    ste_name: "TX",
  },
  {
    zip_code: "75554",

    ste_name: "TX",
  },
  {
    zip_code: "75654",

    ste_name: "TX",
  },
  {
    zip_code: "75682",

    ste_name: "TX",
  },
  {
    zip_code: "75773",

    ste_name: "TX",
  },
  {
    zip_code: "75803",

    ste_name: "TX",
  },
  {
    zip_code: "75858",

    ste_name: "TX",
  },
  {
    zip_code: "75926",

    ste_name: "TX",
  },
  {
    zip_code: "75942",

    ste_name: "TX",
  },
  {
    zip_code: "75943",

    ste_name: "TX",
  },
  {
    zip_code: "75980",

    ste_name: "TX",
  },
  {
    zip_code: "76014",

    ste_name: "TX",
  },
  {
    zip_code: "76023",

    ste_name: "TX",
  },
  {
    zip_code: "76036",

    ste_name: "TX",
  },
  {
    zip_code: "76111",

    ste_name: "TX",
  },
  {
    zip_code: "76116",

    ste_name: "TX",
  },
  {
    zip_code: "76273",

    ste_name: "TX",
  },
  {
    zip_code: "76462",

    ste_name: "TX",
  },
  {
    zip_code: "76463",

    ste_name: "TX",
  },
  {
    zip_code: "76464",

    ste_name: "TX",
  },
  {
    zip_code: "76476",

    ste_name: "TX",
  },
  {
    zip_code: "76486",

    ste_name: "TX",
  },
  {
    zip_code: "76511",

    ste_name: "TX",
  },
  {
    zip_code: "76524",

    ste_name: "TX",
  },
  {
    zip_code: "76528",

    ste_name: "TX",
  },
  {
    zip_code: "76598",

    ste_name: "TX",
  },
  {
    zip_code: "76638",

    ste_name: "TX",
  },
  {
    zip_code: "76706",

    ste_name: "TX",
  },
  {
    zip_code: "76801",

    ste_name: "TX",
  },
  {
    zip_code: "76836",

    ste_name: "TX",
  },
  {
    zip_code: "76857",

    ste_name: "TX",
  },
  {
    zip_code: "76905",

    ste_name: "TX",
  },
  {
    zip_code: "76951",

    ste_name: "TX",
  },
  {
    zip_code: "77032",

    ste_name: "TX",
  },
  {
    zip_code: "77051",

    ste_name: "TX",
  },
  {
    zip_code: "77306",

    ste_name: "TX",
  },
  {
    zip_code: "77346",

    ste_name: "TX",
  },
  {
    zip_code: "77356",

    ste_name: "TX",
  },
  {
    zip_code: "77365",

    ste_name: "TX",
  },
  {
    zip_code: "77372",

    ste_name: "TX",
  },
  {
    zip_code: "77429",

    ste_name: "TX",
  },
  {
    zip_code: "77435",

    ste_name: "TX",
  },
  {
    zip_code: "77444",

    ste_name: "TX",
  },
  {
    zip_code: "77447",

    ste_name: "TX",
  },
  {
    zip_code: "77545",

    ste_name: "TX",
  },
  {
    zip_code: "77584",

    ste_name: "TX",
  },
  {
    zip_code: "77591",

    ste_name: "TX",
  },
  {
    zip_code: "77625",

    ste_name: "TX",
  },
  {
    zip_code: "77861",

    ste_name: "TX",
  },
  {
    zip_code: "77961",

    ste_name: "TX",
  },
  {
    zip_code: "77968",

    ste_name: "TX",
  },
  {
    zip_code: "78027",

    ste_name: "TX",
  },
  {
    zip_code: "78040",

    ste_name: "TX",
  },
  {
    zip_code: "78211",

    ste_name: "TX",
  },
  {
    zip_code: "78242",

    ste_name: "TX",
  },
  {
    zip_code: "78521",

    ste_name: "TX",
  },
  {
    zip_code: "78545",

    ste_name: "TX",
  },
  {
    zip_code: "78579",

    ste_name: "TX",
  },
  {
    zip_code: "78592",

    ste_name: "TX",
  },
  {
    zip_code: "78595",

    ste_name: "TX",
  },
  {
    zip_code: "78631",

    ste_name: "TX",
  },
  {
    zip_code: "78833",

    ste_name: "TX",
  },
  {
    zip_code: "78885",

    ste_name: "TX",
  },
  {
    zip_code: "78946",

    ste_name: "TX",
  },
  {
    zip_code: "79009",

    ste_name: "TX",
  },
  {
    zip_code: "79029",

    ste_name: "TX",
  },
  {
    zip_code: "79042",

    ste_name: "TX",
  },
  {
    zip_code: "79103",

    ste_name: "TX",
  },
  {
    zip_code: "79261",

    ste_name: "TX",
  },
  {
    zip_code: "79312",

    ste_name: "TX",
  },
  {
    zip_code: "79324",

    ste_name: "TX",
  },
  {
    zip_code: "79342",

    ste_name: "TX",
  },
  {
    zip_code: "79606",

    ste_name: "TX",
  },
  {
    zip_code: "79785",

    ste_name: "TX",
  },
  {
    zip_code: "79788",

    ste_name: "TX",
  },
  {
    zip_code: "79845",

    ste_name: "TX",
  },
  {
    zip_code: "79927",

    ste_name: "TX",
  },
  {
    zip_code: "80002",

    ste_name: "CO",
  },
  {
    zip_code: "80011",

    ste_name: "CO",
  },
  {
    zip_code: "80104",

    ste_name: "CO",
  },
  {
    zip_code: "80124",

    ste_name: "CO",
  },
  {
    zip_code: "80239",

    ste_name: "CO",
  },
  {
    zip_code: "80303",

    ste_name: "CO",
  },
  {
    zip_code: "80466",

    ste_name: "CO",
  },
  {
    zip_code: "80479",

    ste_name: "CO",
  },
  {
    zip_code: "80650",

    ste_name: "CO",
  },
  {
    zip_code: "80818",

    ste_name: "CO",
  },
  {
    zip_code: "80923",

    ste_name: "CO",
  },
  {
    zip_code: "80928",

    ste_name: "CO",
  },
  {
    zip_code: "81077",

    ste_name: "CO",
  },
  {
    zip_code: "81141",

    ste_name: "CO",
  },
  {
    zip_code: "81415",

    ste_name: "CO",
  },
  {
    zip_code: "81426",

    ste_name: "CO",
  },
  {
    zip_code: "81526",

    ste_name: "CO",
  },
  {
    zip_code: "81621",

    ste_name: "CO",
  },
  {
    zip_code: "81625",

    ste_name: "CO",
  },
  {
    zip_code: "81641",

    ste_name: "CO",
  },
  {
    zip_code: "81643",

    ste_name: "CO",
  },
  {
    zip_code: "82411",

    ste_name: "WY",
  },
  {
    zip_code: "82421",

    ste_name: "WY",
  },
  {
    zip_code: "82646",

    ste_name: "WY",
  },
  {
    zip_code: "82716",

    ste_name: "WY",
  },
  {
    zip_code: "83215",

    ste_name: "ID",
  },
  {
    zip_code: "83243",

    ste_name: "ID",
  },
  {
    zip_code: "83523",

    ste_name: "ID",
  },
  {
    zip_code: "83554",

    ste_name: "ID",
  },
  {
    zip_code: "83604",

    ste_name: "ID",
  },
  {
    zip_code: "83636",

    ste_name: "ID",
  },
  {
    zip_code: "83802",

    ste_name: "ID",
  },
  {
    zip_code: "83843",

    ste_name: "ID",
  },
  {
    zip_code: "83848",

    ste_name: "ID",
  },
  {
    zip_code: "83866",

    ste_name: "ID",
  },
  {
    zip_code: "84080",

    ste_name: "UT",
  },
  {
    zip_code: "84108",

    ste_name: "UT",
  },
  {
    zip_code: "84118",

    ste_name: "UT",
  },
  {
    zip_code: "84313",

    ste_name: "UT",
  },
  {
    zip_code: "84326",

    ste_name: "UT",
  },
  {
    zip_code: "84335",

    ste_name: "UT",
  },
  {
    zip_code: "84530",

    ste_name: "UT",
  },
  {
    zip_code: "84532",

    ste_name: "UT",
  },
  {
    zip_code: "84536",

    ste_name: "UT",
  },
  {
    zip_code: "84636",

    ste_name: "UT",
  },
  {
    zip_code: "84652",

    ste_name: "UT",
  },
  {
    zip_code: "84714",

    ste_name: "UT",
  },
  {
    zip_code: "84718",

    ste_name: "UT",
  },
  {
    zip_code: "84725",

    ste_name: "UT",
  },
  {
    zip_code: "84766",

    ste_name: "UT",
  },
  {
    zip_code: "84773",

    ste_name: "UT",
  },
  {
    zip_code: "84779",

    ste_name: "UT",
  },
  {
    zip_code: "84782",

    ste_name: "UT",
  },
  {
    zip_code: "85012",

    ste_name: "AZ",
  },
  {
    zip_code: "85020",

    ste_name: "AZ",
  },
  {
    zip_code: "85268",

    ste_name: "AZ",
  },
  {
    zip_code: "85367",

    ste_name: "AZ",
  },
  {
    zip_code: "85396",

    ste_name: "AZ",
  },
  {
    zip_code: "85940",

    ste_name: "AZ",
  },
  {
    zip_code: "86436",

    ste_name: "AZ",
  },
  {
    zip_code: "86505",

    ste_name: "AZ",
  },
  {
    zip_code: "87110",

    ste_name: "NM",
  },
  {
    zip_code: "87312",

    ste_name: "NM",
  },
  {
    zip_code: "87518",

    ste_name: "NM",
  },
  {
    zip_code: "87525",

    ste_name: "NM",
  },
  {
    zip_code: "87742",

    ste_name: "NM",
  },
  {
    zip_code: "87743",

    ste_name: "NM",
  },
  {
    zip_code: "87749",

    ste_name: "NM",
  },
  {
    zip_code: "88009",

    ste_name: "NM",
  },
  {
    zip_code: "88041",

    ste_name: "NM",
  },
  {
    zip_code: "88049",

    ste_name: "NM",
  },
  {
    zip_code: "88120",

    ste_name: "NM",
  },
  {
    zip_code: "88268",

    ste_name: "NM",
  },
  {
    zip_code: "89014",

    ste_name: "NV",
  },
  {
    zip_code: "89015",

    ste_name: "NV",
  },
  {
    zip_code: "89047",

    ste_name: "NV",
  },
  {
    zip_code: "89049",

    ste_name: "NV",
  },
  {
    zip_code: "89319",

    ste_name: "NV",
  },
  {
    zip_code: "89521",

    ste_name: "NV",
  },
  {
    zip_code: "89830",

    ste_name: "NV",
  },
  {
    zip_code: "90012",

    ste_name: "CA",
  },
  {
    zip_code: "90013",

    ste_name: "CA",
  },
  {
    zip_code: "90094",

    ste_name: "CA",
  },
  {
    zip_code: "90201",

    ste_name: "CA",
  },
  {
    zip_code: "90210",

    ste_name: "CA",
  },
  {
    zip_code: "90245",

    ste_name: "CA",
  },
  {
    zip_code: "90703",

    ste_name: "CA",
  },
  {
    zip_code: "91602",

    ste_name: "CA",
  },
  {
    zip_code: "91608",

    ste_name: "CA",
  },
  {
    zip_code: "92010",

    ste_name: "CA",
  },
  {
    zip_code: "92011",

    ste_name: "CA",
  },
  {
    zip_code: "92060",

    ste_name: "CA",
  },
  {
    zip_code: "92110",

    ste_name: "CA",
  },
  {
    zip_code: "92251",

    ste_name: "CA",
  },
  {
    zip_code: "92258",

    ste_name: "CA",
  },
  {
    zip_code: "92260",

    ste_name: "CA",
  },
  {
    zip_code: "92264",

    ste_name: "CA",
  },
  {
    zip_code: "92280",

    ste_name: "CA",
  },
  {
    zip_code: "92373",

    ste_name: "CA",
  },
  {
    zip_code: "92503",

    ste_name: "CA",
  },
  {
    zip_code: "92648",

    ste_name: "CA",
  },
  {
    zip_code: "92651",

    ste_name: "CA",
  },
  {
    zip_code: "92833",

    ste_name: "CA",
  },
  {
    zip_code: "92841",

    ste_name: "CA",
  },
  {
    zip_code: "93001",

    ste_name: "CA",
  },
  {
    zip_code: "93204",

    ste_name: "CA",
  },
  {
    zip_code: "93241",

    ste_name: "CA",
  },
  {
    zip_code: "93266",

    ste_name: "CA",
  },
  {
    zip_code: "93429",

    ste_name: "CA",
  },
  {
    zip_code: "93530",

    ste_name: "CA",
  },
  {
    zip_code: "94089",

    ste_name: "CA",
  },
  {
    zip_code: "94108",

    ste_name: "CA",
  },
  {
    zip_code: "94511",

    ste_name: "CA",
  },
  {
    zip_code: "94569",

    ste_name: "CA",
  },
  {
    zip_code: "94580",

    ste_name: "CA",
  },
  {
    zip_code: "94704",

    ste_name: "CA",
  },
  {
    zip_code: "94705",

    ste_name: "CA",
  },
  {
    zip_code: "94941",

    ste_name: "CA",
  },
  {
    zip_code: "94964",

    ste_name: "CA",
  },
  {
    zip_code: "95018",

    ste_name: "CA",
  },
  {
    zip_code: "95035",

    ste_name: "CA",
  },
  {
    zip_code: "95322",

    ste_name: "CA",
  },
  {
    zip_code: "95341",

    ste_name: "CA",
  },
  {
    zip_code: "95462",

    ste_name: "CA",
  },
  {
    zip_code: "95645",

    ste_name: "CA",
  },
  {
    zip_code: "95720",

    ste_name: "CA",
  },
  {
    zip_code: "95826",

    ste_name: "CA",
  },
  {
    zip_code: "96033",

    ste_name: "CA",
  },
  {
    zip_code: "96106",

    ste_name: "CA",
  },
  {
    zip_code: "96110",

    ste_name: "CA",
  },
  {
    zip_code: "96133",

    ste_name: "CA",
  },
  {
    zip_code: "96143",

    ste_name: "CA",
  },
  {
    zip_code: "96707",

    ste_name: "HI",
  },
  {
    zip_code: "96732",

    ste_name: "HI",
  },
  {
    zip_code: "96799",

    ste_name: "AS",
  },
  {
    zip_code: "97001",

    ste_name: "OR",
  },
  {
    zip_code: "97021",

    ste_name: "OR",
  },
  {
    zip_code: "97027",

    ste_name: "OR",
  },
  {
    zip_code: "97149",

    ste_name: "OR",
  },
  {
    zip_code: "97219",

    ste_name: "OR",
  },
  {
    zip_code: "97225",

    ste_name: "OR",
  },
  {
    zip_code: "97370",

    ste_name: "OR",
  },
  {
    zip_code: "97385",

    ste_name: "OR",
  },
  {
    zip_code: "97411",

    ste_name: "OR",
  },
  {
    zip_code: "97420",

    ste_name: "OR",
  },
  {
    zip_code: "97486",

    ste_name: "OR",
  },
  {
    zip_code: "97640",

    ste_name: "OR",
  },
  {
    zip_code: "97734",

    ste_name: "OR",
  },
  {
    zip_code: "97739",

    ste_name: "OR",
  },
  {
    zip_code: "97830",

    ste_name: "OR",
  },
  {
    zip_code: "97911",

    ste_name: "OR",
  },
  {
    zip_code: "98020",

    ste_name: "WA",
  },
  {
    zip_code: "98031",

    ste_name: "WA",
  },
  {
    zip_code: "98058",

    ste_name: "WA",
  },
  {
    zip_code: "98104",

    ste_name: "WA",
  },
  {
    zip_code: "98223",

    ste_name: "WA",
  },
  {
    zip_code: "98248",

    ste_name: "WA",
  },
  {
    zip_code: "98264",

    ste_name: "WA",
  },
  {
    zip_code: "98277",

    ste_name: "WA",
  },
  {
    zip_code: "98305",

    ste_name: "WA",
  },
  {
    zip_code: "98326",

    ste_name: "WA",
  },
  {
    zip_code: "31042",

    ste_name: "GA",
  },
  {
    zip_code: "31078",

    ste_name: "GA",
  },
  {
    zip_code: "31093",

    ste_name: "GA",
  },
  {
    zip_code: "31201",

    ste_name: "GA",
  },
  {
    zip_code: "31522",

    ste_name: "GA",
  },
  {
    zip_code: "31831",

    ste_name: "GA",
  },
  {
    zip_code: "31904",

    ste_name: "GA",
  },
  {
    zip_code: "32040",

    ste_name: "FL",
  },
  {
    zip_code: "32062",

    ste_name: "FL",
  },
  {
    zip_code: "32082",

    ste_name: "FL",
  },
  {
    zip_code: "32091",

    ste_name: "FL",
  },
  {
    zip_code: "32094",

    ste_name: "FL",
  },
  {
    zip_code: "32219",

    ste_name: "FL",
  },
  {
    zip_code: "32405",

    ste_name: "FL",
  },
  {
    zip_code: "32506",

    ste_name: "FL",
  },
  {
    zip_code: "32725",

    ste_name: "FL",
  },
  {
    zip_code: "32730",

    ste_name: "FL",
  },
  {
    zip_code: "32804",

    ste_name: "FL",
  },
  {
    zip_code: "32809",

    ste_name: "FL",
  },
  {
    zip_code: "32925",

    ste_name: "FL",
  },
  {
    zip_code: "32950",

    ste_name: "FL",
  },
  {
    zip_code: "32960",

    ste_name: "FL",
  },
  {
    zip_code: "33158",

    ste_name: "FL",
  },
  {
    zip_code: "33170",

    ste_name: "FL",
  },
  {
    zip_code: "33173",

    ste_name: "FL",
  },
  {
    zip_code: "33181",

    ste_name: "FL",
  },
  {
    zip_code: "33332",

    ste_name: "FL",
  },
  {
    zip_code: "33605",

    ste_name: "FL",
  },
  {
    zip_code: "33756",

    ste_name: "FL",
  },
  {
    zip_code: "33857",

    ste_name: "FL",
  },
  {
    zip_code: "33924",

    ste_name: "FL",
  },
  {
    zip_code: "34109",

    ste_name: "FL",
  },
  {
    zip_code: "34269",

    ste_name: "FL",
  },
  {
    zip_code: "34474",

    ste_name: "FL",
  },
  {
    zip_code: "34604",

    ste_name: "FL",
  },
  {
    zip_code: "34667",

    ste_name: "FL",
  },
  {
    zip_code: "34679",

    ste_name: "FL",
  },
  {
    zip_code: "35052",

    ste_name: "AL",
  },
  {
    zip_code: "35053",

    ste_name: "AL",
  },
  {
    zip_code: "35128",

    ste_name: "AL",
  },
  {
    zip_code: "35149",

    ste_name: "AL",
  },
  {
    zip_code: "35572",

    ste_name: "AL",
  },
  {
    zip_code: "35611",

    ste_name: "AL",
  },
  {
    zip_code: "35643",

    ste_name: "AL",
  },
  {
    zip_code: "35758",

    ste_name: "AL",
  },
  {
    zip_code: "35802",

    ste_name: "AL",
  },
  {
    zip_code: "35810",

    ste_name: "AL",
  },
  {
    zip_code: "35816",

    ste_name: "AL",
  },
  {
    zip_code: "35966",

    ste_name: "AL",
  },
  {
    zip_code: "36009",

    ste_name: "AL",
  },
  {
    zip_code: "36017",

    ste_name: "AL",
  },
  {
    zip_code: "36043",

    ste_name: "AL",
  },
  {
    zip_code: "36046",

    ste_name: "AL",
  },
  {
    zip_code: "36109",

    ste_name: "AL",
  },
  {
    zip_code: "36117",

    ste_name: "AL",
  },
  {
    zip_code: "36262",

    ste_name: "AL",
  },
  {
    zip_code: "36312",

    ste_name: "AL",
  },
  {
    zip_code: "36323",

    ste_name: "AL",
  },
  {
    zip_code: "36346",

    ste_name: "AL",
  },
  {
    zip_code: "36439",

    ste_name: "AL",
  },
  {
    zip_code: "36451",

    ste_name: "AL",
  },
  {
    zip_code: "36541",

    ste_name: "AL",
  },
  {
    zip_code: "36568",

    ste_name: "AL",
  },
  {
    zip_code: "36613",

    ste_name: "AL",
  },
  {
    zip_code: "36615",

    ste_name: "AL",
  },
  {
    zip_code: "36910",

    ste_name: "AL",
  },
  {
    zip_code: "37020",

    ste_name: "TN",
  },
  {
    zip_code: "37060",

    ste_name: "TN",
  },
  {
    zip_code: "37186",

    ste_name: "TN",
  },
  {
    zip_code: "37191",

    ste_name: "TN",
  },
  {
    zip_code: "37201",

    ste_name: "TN",
  },
  {
    zip_code: "37325",

    ste_name: "TN",
  },
  {
    zip_code: "37327",

    ste_name: "TN",
  },
  {
    zip_code: "37343",

    ste_name: "TN",
  },
  {
    zip_code: "37353",

    ste_name: "TN",
  },
  {
    zip_code: "37397",

    ste_name: "TN",
  },
  {
    zip_code: "37658",

    ste_name: "TN",
  },
  {
    zip_code: "37779",

    ste_name: "TN",
  },
  {
    zip_code: "37841",

    ste_name: "TN",
  },
  {
    zip_code: "37879",

    ste_name: "TN",
  },
  {
    zip_code: "37880",

    ste_name: "TN",
  },
  {
    zip_code: "38061",

    ste_name: "TN",
  },
  {
    zip_code: "38080",

    ste_name: "TN",
  },
  {
    zip_code: "38114",

    ste_name: "TN",
  },
  {
    zip_code: "38320",

    ste_name: "TN",
  },
  {
    zip_code: "38327",

    ste_name: "TN",
  },
  {
    zip_code: "38329",

    ste_name: "TN",
  },
  {
    zip_code: "38365",

    ste_name: "TN",
  },
  {
    zip_code: "38565",

    ste_name: "TN",
  },
  {
    zip_code: "38737",

    ste_name: "MS",
  },
  {
    zip_code: "38740",

    ste_name: "MS",
  },
  {
    zip_code: "57559",

    ste_name: "SD",
  },
  {
    zip_code: "57620",

    ste_name: "SD",
  },
  {
    zip_code: "57701",

    ste_name: "SD",
  },
  {
    zip_code: "57791",

    ste_name: "SD",
  },
  {
    zip_code: "58069",

    ste_name: "ND",
  },
  {
    zip_code: "58223",

    ste_name: "ND",
  },
  {
    zip_code: "58257",

    ste_name: "ND",
  },
  {
    zip_code: "58361",

    ste_name: "ND",
  },
  {
    zip_code: "58401",

    ste_name: "ND",
  },
  {
    zip_code: "58430",

    ste_name: "ND",
  },
  {
    zip_code: "58442",

    ste_name: "ND",
  },
  {
    zip_code: "58445",

    ste_name: "ND",
  },
  {
    zip_code: "58481",

    ste_name: "ND",
  },
  {
    zip_code: "58504",

    ste_name: "ND",
  },
  {
    zip_code: "58570",

    ste_name: "ND",
  },
  {
    zip_code: "58572",

    ste_name: "ND",
  },
  {
    zip_code: "58649",

    ste_name: "ND",
  },
  {
    zip_code: "58654",

    ste_name: "ND",
  },
  {
    zip_code: "58730",

    ste_name: "ND",
  },
  {
    zip_code: "97321",

    ste_name: "OR",
  },
  {
    zip_code: "97451",

    ste_name: "OR",
  },
  {
    zip_code: "97467",

    ste_name: "OR",
  },
  {
    zip_code: "97477",

    ste_name: "OR",
  },
  {
    zip_code: "97497",

    ste_name: "OR",
  },
  {
    zip_code: "97544",

    ste_name: "OR",
  },
  {
    zip_code: "97621",

    ste_name: "OR",
  },
  {
    zip_code: "21071",

    ste_name: "MD",
  },
  {
    zip_code: "21084",

    ste_name: "MD",
  },
  {
    zip_code: "31082",

    ste_name: "GA",
  },
  {
    zip_code: "31091",

    ste_name: "GA",
  },
  {
    zip_code: "31322",

    ste_name: "GA",
  },
  {
    zip_code: "31408",

    ste_name: "GA",
  },
  {
    zip_code: "31566",

    ste_name: "GA",
  },
  {
    zip_code: "31568",

    ste_name: "GA",
  },
  {
    zip_code: "32009",

    ste_name: "FL",
  },
  {
    zip_code: "32177",

    ste_name: "FL",
  },
  {
    zip_code: "32193",

    ste_name: "FL",
  },
  {
    zip_code: "32361",

    ste_name: "FL",
  },
  {
    zip_code: "32409",

    ste_name: "FL",
  },
  {
    zip_code: "32428",

    ste_name: "FL",
  },
  {
    zip_code: "32442",

    ste_name: "FL",
  },
  {
    zip_code: "32461",

    ste_name: "FL",
  },
  {
    zip_code: "32564",

    ste_name: "FL",
  },
  {
    zip_code: "32567",

    ste_name: "FL",
  },
  {
    zip_code: "32570",

    ste_name: "FL",
  },
  {
    zip_code: "32720",

    ste_name: "FL",
  },
  {
    zip_code: "32779",

    ste_name: "FL",
  },
  {
    zip_code: "32811",

    ste_name: "FL",
  },
  {
    zip_code: "32940",

    ste_name: "FL",
  },
  {
    zip_code: "32955",

    ste_name: "FL",
  },
  {
    zip_code: "33031",

    ste_name: "FL",
  },
  {
    zip_code: "33051",

    ste_name: "FL",
  },
  {
    zip_code: "33140",

    ste_name: "FL",
  },
  {
    zip_code: "33149",

    ste_name: "FL",
  },
  {
    zip_code: "33187",

    ste_name: "FL",
  },
  {
    zip_code: "33401",

    ste_name: "FL",
  },
  {
    zip_code: "33541",

    ste_name: "FL",
  },
  {
    zip_code: "33585",

    ste_name: "FL",
  },
  {
    zip_code: "33618",

    ste_name: "FL",
  },
  {
    zip_code: "33715",

    ste_name: "FL",
  },
  {
    zip_code: "33759",

    ste_name: "FL",
  },
  {
    zip_code: "33773",

    ste_name: "FL",
  },
  {
    zip_code: "33774",

    ste_name: "FL",
  },
  {
    zip_code: "33785",

    ste_name: "FL",
  },
  {
    zip_code: "33834",

    ste_name: "FL",
  },
  {
    zip_code: "33896",

    ste_name: "FL",
  },
  {
    zip_code: "33905",

    ste_name: "FL",
  },
  {
    zip_code: "33944",

    ste_name: "FL",
  },
  {
    zip_code: "33948",

    ste_name: "FL",
  },
  {
    zip_code: "33991",

    ste_name: "FL",
  },
  {
    zip_code: "34268",

    ste_name: "FL",
  },
  {
    zip_code: "34275",

    ste_name: "FL",
  },
  {
    zip_code: "34434",

    ste_name: "FL",
  },
  {
    zip_code: "34688",

    ste_name: "FL",
  },
  {
    zip_code: "34715",

    ste_name: "FL",
  },
  {
    zip_code: "34945",

    ste_name: "FL",
  },
  {
    zip_code: "35051",

    ste_name: "AL",
  },
  {
    zip_code: "35054",

    ste_name: "AL",
  },
  {
    zip_code: "35057",

    ste_name: "AL",
  },
  {
    zip_code: "35060",

    ste_name: "AL",
  },
  {
    zip_code: "35176",

    ste_name: "AL",
  },
  {
    zip_code: "35580",

    ste_name: "AL",
  },
  {
    zip_code: "35581",

    ste_name: "AL",
  },
  {
    zip_code: "35585",

    ste_name: "AL",
  },
  {
    zip_code: "35763",

    ste_name: "AL",
  },
  {
    zip_code: "35776",

    ste_name: "AL",
  },
  {
    zip_code: "36037",

    ste_name: "AL",
  },
  {
    zip_code: "36054",

    ste_name: "AL",
  },
  {
    zip_code: "36066",

    ste_name: "AL",
  },
  {
    zip_code: "36079",

    ste_name: "AL",
  },
  {
    zip_code: "36263",

    ste_name: "AL",
  },
  {
    zip_code: "36301",

    ste_name: "AL",
  },
  {
    zip_code: "36303",

    ste_name: "AL",
  },
  {
    zip_code: "36311",

    ste_name: "AL",
  },
  {
    zip_code: "36353",

    ste_name: "AL",
  },
  {
    zip_code: "36502",

    ste_name: "AL",
  },
  {
    zip_code: "36572",

    ste_name: "AL",
  },
  {
    zip_code: "36616",

    ste_name: "AL",
  },
  {
    zip_code: "36742",

    ste_name: "AL",
  },
  {
    zip_code: "36776",

    ste_name: "AL",
  },
  {
    zip_code: "36856",

    ste_name: "AL",
  },
  {
    zip_code: "36874",

    ste_name: "AL",
  },
  {
    zip_code: "37098",

    ste_name: "TN",
  },
  {
    zip_code: "37140",

    ste_name: "TN",
  },
  {
    zip_code: "37172",

    ste_name: "TN",
  },
  {
    zip_code: "37421",

    ste_name: "TN",
  },
  {
    zip_code: "37620",

    ste_name: "TN",
  },
  {
    zip_code: "37641",

    ste_name: "TN",
  },
  {
    zip_code: "37690",

    ste_name: "TN",
  },
  {
    zip_code: "37771",

    ste_name: "TN",
  },
  {
    zip_code: "37862",

    ste_name: "TN",
  },
  {
    zip_code: "38049",

    ste_name: "TN",
  },
  {
    zip_code: "38054",

    ste_name: "TN",
  },
  {
    zip_code: "38104",

    ste_name: "TN",
  },
  {
    zip_code: "38313",

    ste_name: "TN",
  },
  {
    zip_code: "38367",

    ste_name: "TN",
  },
  {
    zip_code: "38376",

    ste_name: "TN",
  },
  {
    zip_code: "38453",

    ste_name: "TN",
  },
  {
    zip_code: "38477",

    ste_name: "TN",
  },
  {
    zip_code: "38506",

    ste_name: "TN",
  },
  {
    zip_code: "38577",

    ste_name: "TN",
  },
  {
    zip_code: "38580",

    ste_name: "TN",
  },
  {
    zip_code: "38623",

    ste_name: "MS",
  },
  {
    zip_code: "38658",

    ste_name: "MS",
  },
  {
    zip_code: "38731",

    ste_name: "MS",
  },
  {
    zip_code: "38773",

    ste_name: "MS",
  },
  {
    zip_code: "38851",

    ste_name: "MS",
  },
  {
    zip_code: "38916",

    ste_name: "MS",
  },
  {
    zip_code: "38923",

    ste_name: "MS",
  },
  {
    zip_code: "38946",

    ste_name: "MS",
  },
  {
    zip_code: "38948",

    ste_name: "MS",
  },
  {
    zip_code: "39159",

    ste_name: "MS",
  },
  {
    zip_code: "39475",

    ste_name: "MS",
  },
  {
    zip_code: "39477",

    ste_name: "MS",
  },
  {
    zip_code: "39577",

    ste_name: "MS",
  },
  {
    zip_code: "39666",

    ste_name: "MS",
  },
  {
    zip_code: "39746",

    ste_name: "MS",
  },
  {
    zip_code: "39751",

    ste_name: "MS",
  },
  {
    zip_code: "39836",

    ste_name: "GA",
  },
  {
    zip_code: "39841",

    ste_name: "GA",
  },
  {
    zip_code: "39846",

    ste_name: "GA",
  },
  {
    zip_code: "40022",

    ste_name: "KY",
  },
  {
    zip_code: "40050",

    ste_name: "KY",
  },
  {
    zip_code: "40075",

    ste_name: "KY",
  },
  {
    zip_code: "40211",

    ste_name: "KY",
  },
  {
    zip_code: "40214",

    ste_name: "KY",
  },
  {
    zip_code: "40291",

    ste_name: "KY",
  },
  {
    zip_code: "40356",

    ste_name: "KY",
  },
  {
    zip_code: "40743",

    ste_name: "KY",
  },
  {
    zip_code: "40874",

    ste_name: "KY",
  },
  {
    zip_code: "40927",

    ste_name: "KY",
  },
  {
    zip_code: "40995",

    ste_name: "KY",
  },
  {
    zip_code: "41005",

    ste_name: "KY",
  },
  {
    zip_code: "41014",

    ste_name: "KY",
  },
  {
    zip_code: "41049",

    ste_name: "KY",
  },
  {
    zip_code: "41099",

    ste_name: "KY",
  },
  {
    zip_code: "41224",

    ste_name: "KY",
  },
  {
    zip_code: "41650",

    ste_name: "KY",
  },
  {
    zip_code: "42053",

    ste_name: "KY",
  },
  {
    zip_code: "42154",

    ste_name: "KY",
  },
  {
    zip_code: "42211",

    ste_name: "KY",
  },
  {
    zip_code: "42262",

    ste_name: "KY",
  },
  {
    zip_code: "42275",

    ste_name: "KY",
  },
  {
    zip_code: "42728",

    ste_name: "KY",
  },
  {
    zip_code: "43044",

    ste_name: "OH",
  },
  {
    zip_code: "43128",

    ste_name: "OH",
  },
  {
    zip_code: "43227",

    ste_name: "OH",
  },
  {
    zip_code: "43235",

    ste_name: "OH",
  },
  {
    zip_code: "43331",

    ste_name: "OH",
  },
  {
    zip_code: "43431",

    ste_name: "OH",
  },
  {
    zip_code: "43452",

    ste_name: "OH",
  },
  {
    zip_code: "43525",

    ste_name: "OH",
  },
  {
    zip_code: "43623",

    ste_name: "OH",
  },
  {
    zip_code: "43731",

    ste_name: "OH",
  },
  {
    zip_code: "43832",

    ste_name: "OH",
  },
  {
    zip_code: "43842",

    ste_name: "OH",
  },
  {
    zip_code: "43920",

    ste_name: "OH",
  },
  {
    zip_code: "43943",

    ste_name: "OH",
  },
  {
    zip_code: "44022",

    ste_name: "OH",
  },
  {
    zip_code: "44028",

    ste_name: "OH",
  },
  {
    zip_code: "44090",

    ste_name: "OH",
  },
  {
    zip_code: "44104",

    ste_name: "OH",
  },
  {
    zip_code: "44212",

    ste_name: "OH",
  },
  {
    zip_code: "44333",

    ste_name: "OH",
  },
  {
    zip_code: "44449",

    ste_name: "OH",
  },
  {
    zip_code: "44483",

    ste_name: "OH",
  },
  {
    zip_code: "44491",

    ste_name: "OH",
  },
  {
    zip_code: "44676",

    ste_name: "OH",
  },
  {
    zip_code: "44851",

    ste_name: "OH",
  },
  {
    zip_code: "45220",

    ste_name: "OH",
  },
  {
    zip_code: "45320",

    ste_name: "OH",
  },
  {
    zip_code: "45335",

    ste_name: "OH",
  },
  {
    zip_code: "45381",

    ste_name: "OH",
  },
  {
    zip_code: "45388",

    ste_name: "OH",
  },
  {
    zip_code: "45420",

    ste_name: "OH",
  },
  {
    zip_code: "45433",

    ste_name: "OH",
  },
  {
    zip_code: "45650",

    ste_name: "OH",
  },
  {
    zip_code: "45855",

    ste_name: "OH",
  },
  {
    zip_code: "46013",

    ste_name: "IN",
  },
  {
    zip_code: "46110",

    ste_name: "IN",
  },
  {
    zip_code: "46118",

    ste_name: "IN",
  },
  {
    zip_code: "46181",

    ste_name: "IN",
  },
  {
    zip_code: "46234",

    ste_name: "IN",
  },
  {
    zip_code: "46268",

    ste_name: "IN",
  },
  {
    zip_code: "46319",

    ste_name: "IN",
  },
  {
    zip_code: "46531",

    ste_name: "IN",
  },
  {
    zip_code: "46532",

    ste_name: "IN",
  },
  {
    zip_code: "46555",

    ste_name: "IN",
  },
  {
    zip_code: "46590",

    ste_name: "IN",
  },
  {
    zip_code: "46595",

    ste_name: "IN",
  },
  {
    zip_code: "46628",

    ste_name: "IN",
  },
  {
    zip_code: "46710",

    ste_name: "IN",
  },
  {
    zip_code: "46732",

    ste_name: "IN",
  },
  {
    zip_code: "46743",

    ste_name: "IN",
  },
  {
    zip_code: "46765",

    ste_name: "IN",
  },
  {
    zip_code: "46777",

    ste_name: "IN",
  },
  {
    zip_code: "46939",

    ste_name: "IN",
  },
  {
    zip_code: "46943",

    ste_name: "IN",
  },
  {
    zip_code: "47032",

    ste_name: "IN",
  },
  {
    zip_code: "47141",

    ste_name: "IN",
  },
  {
    zip_code: "47201",

    ste_name: "IN",
  },
  {
    zip_code: "47223",

    ste_name: "IN",
  },
  {
    zip_code: "47337",

    ste_name: "IN",
  },
  {
    zip_code: "47339",

    ste_name: "IN",
  },
  {
    zip_code: "47564",

    ste_name: "IN",
  },
  {
    zip_code: "47577",

    ste_name: "IN",
  },
  {
    zip_code: "47648",

    ste_name: "IN",
  },
  {
    zip_code: "47649",

    ste_name: "IN",
  },
  {
    zip_code: "47803",

    ste_name: "IN",
  },
  {
    zip_code: "47807",

    ste_name: "IN",
  },
  {
    zip_code: "47848",

    ste_name: "IN",
  },
  {
    zip_code: "47920",

    ste_name: "IN",
  },
  {
    zip_code: "47944",

    ste_name: "IN",
  },
  {
    zip_code: "47995",

    ste_name: "IN",
  },
  {
    zip_code: "48066",

    ste_name: "MI",
  },
  {
    zip_code: "48103",

    ste_name: "MI",
  },
  {
    zip_code: "48131",

    ste_name: "MI",
  },
  {
    zip_code: "48174",

    ste_name: "MI",
  },
  {
    zip_code: "48348",

    ste_name: "MI",
  },
  {
    zip_code: "48441",

    ste_name: "MI",
  },
  {
    zip_code: "48615",

    ste_name: "MI",
  },
  {
    zip_code: "48738",

    ste_name: "MI",
  },
  {
    zip_code: "48768",

    ste_name: "MI",
  },
  {
    zip_code: "48801",

    ste_name: "MI",
  },
  {
    zip_code: "48807",

    ste_name: "MI",
  },
  {
    zip_code: "48851",

    ste_name: "MI",
  },
  {
    zip_code: "48915",

    ste_name: "MI",
  },
  {
    zip_code: "49065",

    ste_name: "MI",
  },
  {
    zip_code: "49115",

    ste_name: "MI",
  },
  {
    zip_code: "49201",

    ste_name: "MI",
  },
  {
    zip_code: "49247",

    ste_name: "MI",
  },
  {
    zip_code: "49263",

    ste_name: "MI",
  },
  {
    zip_code: "49305",

    ste_name: "MI",
  },
  {
    zip_code: "49402",

    ste_name: "MI",
  },
  {
    zip_code: "49454",

    ste_name: "MI",
  },
  {
    zip_code: "49455",

    ste_name: "MI",
  },
  {
    zip_code: "49630",

    ste_name: "MI",
  },
  {
    zip_code: "49644",

    ste_name: "MI",
  },
  {
    zip_code: "49649",

    ste_name: "MI",
  },
  {
    zip_code: "49684",

    ste_name: "MI",
  },
  {
    zip_code: "49721",

    ste_name: "MI",
  },
  {
    zip_code: "49757",

    ste_name: "MI",
  },
  {
    zip_code: "49764",

    ste_name: "MI",
  },
  {
    zip_code: "49796",

    ste_name: "MI",
  },
  {
    zip_code: "49878",

    ste_name: "MI",
  },
  {
    zip_code: "49883",

    ste_name: "MI",
  },
  {
    zip_code: "49929",

    ste_name: "MI",
  },
  {
    zip_code: "49952",

    ste_name: "MI",
  },
  {
    zip_code: "49955",

    ste_name: "MI",
  },
  {
    zip_code: "50025",

    ste_name: "IA",
  },
  {
    zip_code: "50032",

    ste_name: "IA",
  },
  {
    zip_code: "50068",

    ste_name: "IA",
  },
  {
    zip_code: "50106",

    ste_name: "IA",
  },
  {
    zip_code: "50150",

    ste_name: "IA",
  },
  {
    zip_code: "50236",

    ste_name: "IA",
  },
  {
    zip_code: "50469",

    ste_name: "IA",
  },
  {
    zip_code: "50482",

    ste_name: "IA",
  },
  {
    zip_code: "50599",

    ste_name: "IA",
  },
  {
    zip_code: "50660",

    ste_name: "IA",
  },
  {
    zip_code: "50682",

    ste_name: "IA",
  },
  {
    zip_code: "50701",

    ste_name: "IA",
  },
  {
    zip_code: "50857",

    ste_name: "IA",
  },
  {
    zip_code: "51024",

    ste_name: "IA",
  },
  {
    zip_code: "51063",

    ste_name: "IA",
  },
  {
    zip_code: "51454",

    ste_name: "IA",
  },
  {
    zip_code: "51455",

    ste_name: "IA",
  },
  {
    zip_code: "51501",

    ste_name: "IA",
  },
  {
    zip_code: "52038",

    ste_name: "IA",
  },
  {
    zip_code: "52133",

    ste_name: "IA",
  },
  {
    zip_code: "52151",

    ste_name: "IA",
  },
  {
    zip_code: "52161",

    ste_name: "IA",
  },
  {
    zip_code: "52164",

    ste_name: "IA",
  },
  {
    zip_code: "52235",

    ste_name: "IA",
  },
  {
    zip_code: "52309",

    ste_name: "IA",
  },
  {
    zip_code: "52318",

    ste_name: "IA",
  },
  {
    zip_code: "52345",

    ste_name: "IA",
  },
  {
    zip_code: "52566",

    ste_name: "IA",
  },
  {
    zip_code: "52730",

    ste_name: "IA",
  },
  {
    zip_code: "52806",

    ste_name: "IA",
  },
  {
    zip_code: "53013",

    ste_name: "WI",
  },
  {
    zip_code: "53015",

    ste_name: "WI",
  },
  {
    zip_code: "53027",

    ste_name: "WI",
  },
  {
    zip_code: "53036",

    ste_name: "WI",
  },
  {
    zip_code: "53186",

    ste_name: "WI",
  },
  {
    zip_code: "53517",

    ste_name: "WI",
  },
  {
    zip_code: "53528",

    ste_name: "WI",
  },
  {
    zip_code: "53561",

    ste_name: "WI",
  },
  {
    zip_code: "53569",

    ste_name: "WI",
  },
  {
    zip_code: "53820",

    ste_name: "WI",
  },
  {
    zip_code: "53923",

    ste_name: "WI",
  },
  {
    zip_code: "54007",

    ste_name: "WI",
  },
  {
    zip_code: "54113",

    ste_name: "WI",
  },
  {
    zip_code: "54129",

    ste_name: "WI",
  },
  {
    zip_code: "54153",

    ste_name: "WI",
  },
  {
    zip_code: "54157",

    ste_name: "WI",
  },
  {
    zip_code: "54210",

    ste_name: "WI",
  },
  {
    zip_code: "54216",

    ste_name: "WI",
  },
  {
    zip_code: "54417",

    ste_name: "WI",
  },
  {
    zip_code: "54452",

    ste_name: "WI",
  },
  {
    zip_code: "54481",

    ste_name: "WI",
  },
  {
    zip_code: "54488",

    ste_name: "WI",
  },
  {
    zip_code: "54489",

    ste_name: "WI",
  },
  {
    zip_code: "54565",

    ste_name: "WI",
  },
  {
    zip_code: "54638",

    ste_name: "WI",
  },
  {
    zip_code: "54723",

    ste_name: "WI",
  },
  {
    zip_code: "54767",

    ste_name: "WI",
  },
  {
    zip_code: "54835",

    ste_name: "WI",
  },
  {
    zip_code: "54857",

    ste_name: "WI",
  },
  {
    zip_code: "54914",

    ste_name: "WI",
  },
  {
    zip_code: "54960",

    ste_name: "WI",
  },
  {
    zip_code: "55088",

    ste_name: "MN",
  },
  {
    zip_code: "55305",

    ste_name: "MN",
  },
  {
    zip_code: "55359",

    ste_name: "MN",
  },
  {
    zip_code: "55435",

    ste_name: "MN",
  },
  {
    zip_code: "55449",

    ste_name: "MN",
  },
  {
    zip_code: "55607",

    ste_name: "MN",
  },
  {
    zip_code: "55724",

    ste_name: "MN",
  },
  {
    zip_code: "55736",

    ste_name: "MN",
  },
  {
    zip_code: "55751",

    ste_name: "MN",
  },
  {
    zip_code: "55939",

    ste_name: "MN",
  },
  {
    zip_code: "55944",

    ste_name: "MN",
  },
  {
    zip_code: "55961",

    ste_name: "MN",
  },
  {
    zip_code: "55962",

    ste_name: "MN",
  },
  {
    zip_code: "56021",

    ste_name: "MN",
  },
  {
    zip_code: "56024",

    ste_name: "MN",
  },
  {
    zip_code: "56082",

    ste_name: "MN",
  },
  {
    zip_code: "56097",

    ste_name: "MN",
  },
  {
    zip_code: "56289",

    ste_name: "MN",
  },
  {
    zip_code: "56318",

    ste_name: "MN",
  },
  {
    zip_code: "56320",

    ste_name: "MN",
  },
  {
    zip_code: "56326",

    ste_name: "MN",
  },
  {
    zip_code: "56386",

    ste_name: "MN",
  },
  {
    zip_code: "56467",

    ste_name: "MN",
  },
  {
    zip_code: "56475",

    ste_name: "MN",
  },
  {
    zip_code: "56511",

    ste_name: "MN",
  },
  {
    zip_code: "56588",

    ste_name: "MN",
  },
  {
    zip_code: "56651",

    ste_name: "MN",
  },
  {
    zip_code: "56669",

    ste_name: "MN",
  },
  {
    zip_code: "56673",

    ste_name: "MN",
  },
  {
    zip_code: "56676",

    ste_name: "MN",
  },
  {
    zip_code: "56683",

    ste_name: "MN",
  },
  {
    zip_code: "56728",

    ste_name: "MN",
  },
  {
    zip_code: "57076",

    ste_name: "SD",
  },
  {
    zip_code: "57218",

    ste_name: "SD",
  },
  {
    zip_code: "57261",

    ste_name: "SD",
  },
  {
    zip_code: "57321",

    ste_name: "SD",
  },
  {
    zip_code: "57369",

    ste_name: "SD",
  },
  {
    zip_code: "57374",

    ste_name: "SD",
  },
  {
    zip_code: "57424",

    ste_name: "SD",
  },
  {
    zip_code: "57448",

    ste_name: "SD",
  },
  {
    zip_code: "57456",

    ste_name: "SD",
  },
  {
    zip_code: "57481",

    ste_name: "SD",
  },
  {
    zip_code: "57547",

    ste_name: "SD",
  },
  {
    zip_code: "57641",

    ste_name: "SD",
  },
  {
    zip_code: "57645",

    ste_name: "SD",
  },
  {
    zip_code: "57732",

    ste_name: "SD",
  },
  {
    zip_code: "57788",

    ste_name: "SD",
  },
  {
    zip_code: "58047",

    ste_name: "ND",
  },
  {
    zip_code: "751",

    ste_name: "PR",
  },
  {
    zip_code: "786",

    ste_name: "PR",
  },
  {
    zip_code: "1003",

    ste_name: "MA",
  },
  {
    zip_code: "1050",

    ste_name: "MA",
  },
  {
    zip_code: "1256",

    ste_name: "MA",
  },
  {
    zip_code: "1266",

    ste_name: "MA",
  },
  {
    zip_code: "1270",

    ste_name: "MA",
  },
  {
    zip_code: "1560",

    ste_name: "MA",
  },
  {
    zip_code: "1843",

    ste_name: "MA",
  },
  {
    zip_code: "1906",

    ste_name: "MA",
  },
  {
    zip_code: "2124",

    ste_name: "MA",
  },
  {
    zip_code: "2210",

    ste_name: "MA",
  },
  {
    zip_code: "2465",

    ste_name: "MA",
  },
  {
    zip_code: "2655",

    ste_name: "MA",
  },
  {
    zip_code: "2763",

    ste_name: "MA",
  },
  {
    zip_code: "2857",

    ste_name: "RI",
  },
  {
    zip_code: "2871",

    ste_name: "RI",
  },
  {
    zip_code: "2903",

    ste_name: "RI",
  },
  {
    zip_code: "2907",

    ste_name: "RI",
  },
  {
    zip_code: "3071",

    ste_name: "NH",
  },
  {
    zip_code: "3082",

    ste_name: "NH",
  },
  {
    zip_code: "3110",

    ste_name: "NH",
  },
  {
    zip_code: "3235",

    ste_name: "NH",
  },
  {
    zip_code: "3238",

    ste_name: "NH",
  },
  {
    zip_code: "3275",

    ste_name: "NH",
  },
  {
    zip_code: "3593",

    ste_name: "NH",
  },
  {
    zip_code: "3770",

    ste_name: "NH",
  },
  {
    zip_code: "3832",

    ste_name: "NH",
  },
  {
    zip_code: "3856",

    ste_name: "NH",
  },
  {
    zip_code: "3878",

    ste_name: "NH",
  },
  {
    zip_code: "4010",

    ste_name: "ME",
  },
  {
    zip_code: "4073",

    ste_name: "ME",
  },
  {
    zip_code: "4268",

    ste_name: "ME",
  },
  {
    zip_code: "4435",

    ste_name: "ME",
  },
  {
    zip_code: "4451",

    ste_name: "ME",
  },
  {
    zip_code: "4464",

    ste_name: "ME",
  },
  {
    zip_code: "4488",

    ste_name: "ME",
  },
  {
    zip_code: "4575",

    ste_name: "ME",
  },
  {
    zip_code: "4607",

    ste_name: "ME",
  },
  {
    zip_code: "4629",

    ste_name: "ME",
  },
  {
    zip_code: "5032",

    ste_name: "VT",
  },
  {
    zip_code: "5034",

    ste_name: "VT",
  },
  {
    zip_code: "5071",

    ste_name: "VT",
  },
  {
    zip_code: "5072",

    ste_name: "VT",
  },
  {
    zip_code: "5101",

    ste_name: "VT",
  },
  {
    zip_code: "5142",

    ste_name: "VT",
  },
  {
    zip_code: "5149",

    ste_name: "VT",
  },
  {
    zip_code: "5152",

    ste_name: "VT",
  },
  {
    zip_code: "5156",

    ste_name: "VT",
  },
  {
    zip_code: "5343",

    ste_name: "VT",
  },
  {
    zip_code: "5345",

    ste_name: "VT",
  },
  {
    zip_code: "5352",

    ste_name: "VT",
  },
  {
    zip_code: "5354",

    ste_name: "VT",
  },
  {
    zip_code: "5441",

    ste_name: "VT",
  },
  {
    zip_code: "5481",

    ste_name: "VT",
  },
  {
    zip_code: "5680",

    ste_name: "VT",
  },
  {
    zip_code: "5843",

    ste_name: "VT",
  },
  {
    zip_code: "6021",

    ste_name: "CT",
  },
  {
    zip_code: "6105",

    ste_name: "CT",
  },
  {
    zip_code: "6107",

    ste_name: "CT",
  },
  {
    zip_code: "6268",

    ste_name: "CT",
  },
  {
    zip_code: "6277",

    ste_name: "CT",
  },
  {
    zip_code: "6426",

    ste_name: "CT",
  },
  {
    zip_code: "6615",

    ste_name: "CT",
  },
  {
    zip_code: "6811",

    ste_name: "CT",
  },
  {
    zip_code: "7009",

    ste_name: "NJ",
  },
  {
    zip_code: "7026",

    ste_name: "NJ",
  },
  {
    zip_code: "7040",

    ste_name: "NJ",
  },
  {
    zip_code: "7047",

    ste_name: "NJ",
  },
  {
    zip_code: "7092",

    ste_name: "NJ",
  },
  {
    zip_code: "7202",

    ste_name: "NJ",
  },
  {
    zip_code: "7604",

    ste_name: "NJ",
  },
  {
    zip_code: "7657",

    ste_name: "NJ",
  },
  {
    zip_code: "7757",

    ste_name: "NJ",
  },
  {
    zip_code: "7764",

    ste_name: "NJ",
  },
  {
    zip_code: "7834",

    ste_name: "NJ",
  },
  {
    zip_code: "8037",

    ste_name: "NJ",
  },
  {
    zip_code: "8048",

    ste_name: "NJ",
  },
  {
    zip_code: "8072",

    ste_name: "NJ",
  },
  {
    zip_code: "8096",

    ste_name: "NJ",
  },
  {
    zip_code: "8109",

    ste_name: "NJ",
  },
  {
    zip_code: "8204",

    ste_name: "NJ",
  },
  {
    zip_code: "8210",

    ste_name: "NJ",
  },
  {
    zip_code: "8212",

    ste_name: "NJ",
  },
  {
    zip_code: "8223",

    ste_name: "NJ",
  },
  {
    zip_code: "8316",

    ste_name: "NJ",
  },
  {
    zip_code: "8353",

    ste_name: "NJ",
  },
  {
    zip_code: "8361",

    ste_name: "NJ",
  },
  {
    zip_code: "8528",

    ste_name: "NJ",
  },
  {
    zip_code: "8530",

    ste_name: "NJ",
  },
  {
    zip_code: "8872",

    ste_name: "NJ",
  },
  {
    zip_code: "10013",

    ste_name: "NY",
  },
  {
    zip_code: "10075",

    ste_name: "NY",
  },
  {
    zip_code: "10474",

    ste_name: "NY",
  },
  {
    zip_code: "10518",

    ste_name: "NY",
  },
  {
    zip_code: "10801",

    ste_name: "NY",
  },
  {
    zip_code: "10914",

    ste_name: "NY",
  },
  {
    zip_code: "10932",

    ste_name: "NY",
  },
  {
    zip_code: "10986",

    ste_name: "NY",
  },
  {
    zip_code: "11003",

    ste_name: "NY",
  },
  {
    zip_code: "11370",

    ste_name: "NY",
  },
  {
    zip_code: "11378",

    ste_name: "NY",
  },
  {
    zip_code: "11433",

    ste_name: "NY",
  },
  {
    zip_code: "11530",

    ste_name: "NY",
  },
  {
    zip_code: "11563",

    ste_name: "NY",
  },
  {
    zip_code: "11576",

    ste_name: "NY",
  },
  {
    zip_code: "11579",

    ste_name: "NY",
  },
  {
    zip_code: "11726",

    ste_name: "NY",
  },
  {
    zip_code: "11738",

    ste_name: "NY",
  },
  {
    zip_code: "11752",

    ste_name: "NY",
  },
  {
    zip_code: "11782",

    ste_name: "NY",
  },
  {
    zip_code: "11784",

    ste_name: "NY",
  },
  {
    zip_code: "11786",

    ste_name: "NY",
  },
  {
    zip_code: "11804",

    ste_name: "NY",
  },
  {
    zip_code: "11962",

    ste_name: "NY",
  },
  {
    zip_code: "12042",

    ste_name: "NY",
  },
  {
    zip_code: "12116",

    ste_name: "NY",
  },
  {
    zip_code: "12118",

    ste_name: "NY",
  },
  {
    zip_code: "12209",

    ste_name: "NY",
  },
  {
    zip_code: "12308",

    ste_name: "NY",
  },
  {
    zip_code: "12477",

    ste_name: "NY",
  },
  {
    zip_code: "12514",

    ste_name: "NY",
  },
  {
    zip_code: "12583",

    ste_name: "NY",
  },
  {
    zip_code: "12701",

    ste_name: "NY",
  },
  {
    zip_code: "12738",

    ste_name: "NY",
  },
  {
    zip_code: "12746",

    ste_name: "NY",
  },
  {
    zip_code: "12809",

    ste_name: "NY",
  },
  {
    zip_code: "12953",

    ste_name: "NY",
  },
  {
    zip_code: "13034",

    ste_name: "NY",
  },
  {
    zip_code: "13040",

    ste_name: "NY",
  },
  {
    zip_code: "13142",

    ste_name: "NY",
  },
  {
    zip_code: "13143",

    ste_name: "NY",
  },
  {
    zip_code: "13334",

    ste_name: "NY",
  },
  {
    zip_code: "13338",

    ste_name: "NY",
  },
  {
    zip_code: "13343",

    ste_name: "NY",
  },
  {
    zip_code: "13352",

    ste_name: "NY",
  },
  {
    zip_code: "13464",

    ste_name: "NY",
  },
  {
    zip_code: "13492",

    ste_name: "NY",
  },
  {
    zip_code: "13493",

    ste_name: "NY",
  },
  {
    zip_code: "13623",

    ste_name: "NY",
  },
  {
    zip_code: "13732",

    ste_name: "NY",
  },
  {
    zip_code: "13733",

    ste_name: "NY",
  },
  {
    zip_code: "13746",

    ste_name: "NY",
  },
  {
    zip_code: "13748",

    ste_name: "NY",
  },
  {
    zip_code: "13846",

    ste_name: "NY",
  },
  {
    zip_code: "13904",

    ste_name: "NY",
  },
  {
    zip_code: "14030",

    ste_name: "NY",
  },
  {
    zip_code: "14126",

    ste_name: "NY",
  },
  {
    zip_code: "14482",

    ste_name: "NY",
  },
  {
    zip_code: "14782",

    ste_name: "NY",
  },
  {
    zip_code: "14823",

    ste_name: "NY",
  },
  {
    zip_code: "14841",

    ste_name: "NY",
  },
  {
    zip_code: "14842",

    ste_name: "NY",
  },
  {
    zip_code: "14846",

    ste_name: "NY",
  },
  {
    zip_code: "14905",

    ste_name: "NY",
  },
  {
    zip_code: "15082",

    ste_name: "PA",
  },
  {
    zip_code: "15209",

    ste_name: "PA",
  },
  {
    zip_code: "15210",

    ste_name: "PA",
  },
  {
    zip_code: "15234",

    ste_name: "PA",
  },
  {
    zip_code: "15236",

    ste_name: "PA",
  },
  {
    zip_code: "15237",

    ste_name: "PA",
  },
  {
    zip_code: "15347",

    ste_name: "PA",
  },
  {
    zip_code: "15349",

    ste_name: "PA",
  },
  {
    zip_code: "15357",

    ste_name: "PA",
  },
  {
    zip_code: "15368",

    ste_name: "PA",
  },
  {
    zip_code: "15462",

    ste_name: "PA",
  },
  {
    zip_code: "15647",

    ste_name: "PA",
  },
  {
    zip_code: "15670",

    ste_name: "PA",
  },
  {
    zip_code: "15731",

    ste_name: "PA",
  },
  {
    zip_code: "15762",

    ste_name: "PA",
  },
  {
    zip_code: "15801",

    ste_name: "PA",
  },
  {
    zip_code: "15845",

    ste_name: "PA",
  },
  {
    zip_code: "15864",

    ste_name: "PA",
  },
  {
    zip_code: "15866",

    ste_name: "PA",
  },
  {
    zip_code: "15944",

    ste_name: "PA",
  },
  {
    zip_code: "15956",

    ste_name: "PA",
  },
  {
    zip_code: "16035",

    ste_name: "PA",
  },
  {
    zip_code: "16037",

    ste_name: "PA",
  },
  {
    zip_code: "16142",

    ste_name: "PA",
  },
  {
    zip_code: "16213",

    ste_name: "PA",
  },
  {
    zip_code: "16260",

    ste_name: "PA",
  },
  {
    zip_code: "16301",

    ste_name: "PA",
  },
  {
    zip_code: "16329",

    ste_name: "PA",
  },
  {
    zip_code: "16360",

    ste_name: "PA",
  },
  {
    zip_code: "16421",

    ste_name: "PA",
  },
  {
    zip_code: "16426",

    ste_name: "PA",
  },
  {
    zip_code: "16501",

    ste_name: "PA",
  },
  {
    zip_code: "16661",

    ste_name: "PA",
  },
  {
    zip_code: "16668",

    ste_name: "PA",
  },
  {
    zip_code: "16670",

    ste_name: "PA",
  },
  {
    zip_code: "16689",

    ste_name: "PA",
  },
  {
    zip_code: "16727",

    ste_name: "PA",
  },
  {
    zip_code: "16745",

    ste_name: "PA",
  },
  {
    zip_code: "16948",

    ste_name: "PA",
  },
  {
    zip_code: "17058",

    ste_name: "PA",
  },
  {
    zip_code: "17094",

    ste_name: "PA",
  },
  {
    zip_code: "17103",

    ste_name: "PA",
  },
  {
    zip_code: "17221",

    ste_name: "PA",
  },
  {
    zip_code: "17241",

    ste_name: "PA",
  },
  {
    zip_code: "17244",

    ste_name: "PA",
  },
  {
    zip_code: "17552",

    ste_name: "PA",
  },
  {
    zip_code: "17776",

    ste_name: "PA",
  },
  {
    zip_code: "17820",

    ste_name: "PA",
  },
  {
    zip_code: "17821",

    ste_name: "PA",
  },
  {
    zip_code: "17876",

    ste_name: "PA",
  },
  {
    zip_code: "17922",

    ste_name: "PA",
  },
  {
    zip_code: "18055",

    ste_name: "PA",
  },
  {
    zip_code: "18239",

    ste_name: "PA",
  },
  {
    zip_code: "18346",

    ste_name: "PA",
  },
  {
    zip_code: "18351",

    ste_name: "PA",
  },
  {
    zip_code: "18353",

    ste_name: "PA",
  },
  {
    zip_code: "18461",

    ste_name: "PA",
  },
  {
    zip_code: "18505",

    ste_name: "PA",
  },
  {
    zip_code: "18509",

    ste_name: "PA",
  },
  {
    zip_code: "18623",

    ste_name: "PA",
  },
  {
    zip_code: "18812",

    ste_name: "PA",
  },
  {
    zip_code: "18816",

    ste_name: "PA",
  },
  {
    zip_code: "18854",

    ste_name: "PA",
  },
  {
    zip_code: "19012",

    ste_name: "PA",
  },
  {
    zip_code: "19013",

    ste_name: "PA",
  },
  {
    zip_code: "19057",

    ste_name: "PA",
  },
  {
    zip_code: "19132",

    ste_name: "PA",
  },
  {
    zip_code: "19137",

    ste_name: "PA",
  },
  {
    zip_code: "19149",

    ste_name: "PA",
  },
  {
    zip_code: "19320",

    ste_name: "PA",
  },
  {
    zip_code: "19344",

    ste_name: "PA",
  },
  {
    zip_code: "19363",

    ste_name: "PA",
  },
  {
    zip_code: "19380",

    ste_name: "PA",
  },
  {
    zip_code: "19505",

    ste_name: "PA",
  },
  {
    zip_code: "19607",

    ste_name: "PA",
  },
  {
    zip_code: "19702",

    ste_name: "DE",
  },
  {
    zip_code: "20004",

    ste_name: "DC",
  },
  {
    zip_code: "20064",

    ste_name: "DC",
  },
  {
    zip_code: "20118",

    ste_name: "VA",
  },
  {
    zip_code: "20612",

    ste_name: "MD",
  },
  {
    zip_code: "20684",

    ste_name: "MD",
  },
  {
    zip_code: "20748",

    ste_name: "MD",
  },
  {
    zip_code: "20770",

    ste_name: "MD",
  },
  {
    zip_code: "20838",

    ste_name: "MD",
  },
  {
    zip_code: "21075",

    ste_name: "MD",
  },
  {
    zip_code: "21157",

    ste_name: "MD",
  },
  {
    zip_code: "21220",

    ste_name: "MD",
  },
  {
    zip_code: "21223",

    ste_name: "MD",
  },
  {
    zip_code: "22469",

    ste_name: "VA",
  },
  {
    zip_code: "22480",

    ste_name: "VA",
  },
  {
    zip_code: "22542",

    ste_name: "VA",
  },
  {
    zip_code: "58762",

    ste_name: "ND",
  },
  {
    zip_code: "58770",

    ste_name: "ND",
  },
  {
    zip_code: "58779",

    ste_name: "ND",
  },
  {
    zip_code: "59338",

    ste_name: "MT",
  },
  {
    zip_code: "59405",

    ste_name: "MT",
  },
  {
    zip_code: "59451",

    ste_name: "MT",
  },
  {
    zip_code: "59471",

    ste_name: "MT",
  },
  {
    zip_code: "59489",

    ste_name: "MT",
  },
  {
    zip_code: "59701",

    ste_name: "MT",
  },
  {
    zip_code: "59853",

    ste_name: "MT",
  },
  {
    zip_code: "59917",

    ste_name: "MT",
  },
  {
    zip_code: "59927",

    ste_name: "MT",
  },
  {
    zip_code: "60041",

    ste_name: "IL",
  },
  {
    zip_code: "60056",

    ste_name: "IL",
  },
  {
    zip_code: "60072",

    ste_name: "IL",
  },
  {
    zip_code: "60077",

    ste_name: "IL",
  },
  {
    zip_code: "60131",

    ste_name: "IL",
  },
  {
    zip_code: "60152",

    ste_name: "IL",
  },
  {
    zip_code: "60193",

    ste_name: "IL",
  },
  {
    zip_code: "60403",

    ste_name: "IL",
  },
  {
    zip_code: "60446",

    ste_name: "IL",
  },
  {
    zip_code: "60479",

    ste_name: "IL",
  },
  {
    zip_code: "60506",

    ste_name: "IL",
  },
  {
    zip_code: "60606",

    ste_name: "IL",
  },
  {
    zip_code: "60609",

    ste_name: "IL",
  },
  {
    zip_code: "60629",

    ste_name: "IL",
  },
  {
    zip_code: "60920",

    ste_name: "IL",
  },
  {
    zip_code: "60946",

    ste_name: "IL",
  },
  {
    zip_code: "60955",

    ste_name: "IL",
  },
  {
    zip_code: "61018",

    ste_name: "IL",
  },
  {
    zip_code: "61061",

    ste_name: "IL",
  },
  {
    zip_code: "61080",

    ste_name: "IL",
  },
  {
    zip_code: "61115",

    ste_name: "IL",
  },
  {
    zip_code: "61257",

    ste_name: "IL",
  },
  {
    zip_code: "61260",

    ste_name: "IL",
  },
  {
    zip_code: "61281",

    ste_name: "IL",
  },
  {
    zip_code: "61320",

    ste_name: "IL",
  },
  {
    zip_code: "61413",

    ste_name: "IL",
  },
  {
    zip_code: "61432",

    ste_name: "IL",
  },
  {
    zip_code: "61437",

    ste_name: "IL",
  },
  {
    zip_code: "61443",

    ste_name: "IL",
  },
  {
    zip_code: "61520",

    ste_name: "IL",
  },
  {
    zip_code: "61541",

    ste_name: "IL",
  },
  {
    zip_code: "61542",

    ste_name: "IL",
  },
  {
    zip_code: "61744",

    ste_name: "IL",
  },
  {
    zip_code: "61770",

    ste_name: "IL",
  },
  {
    zip_code: "61882",

    ste_name: "IL",
  },
  {
    zip_code: "61940",

    ste_name: "IL",
  },
  {
    zip_code: "62002",

    ste_name: "IL",
  },
  {
    zip_code: "62009",

    ste_name: "IL",
  },
  {
    zip_code: "62022",

    ste_name: "IL",
  },
  {
    zip_code: "62074",

    ste_name: "IL",
  },
  {
    zip_code: "62089",

    ste_name: "IL",
  },
  {
    zip_code: "62214",

    ste_name: "IL",
  },
  {
    zip_code: "62239",

    ste_name: "IL",
  },
  {
    zip_code: "62349",

    ste_name: "IL",
  },
  {
    zip_code: "62373",

    ste_name: "IL",
  },
  {
    zip_code: "62428",

    ste_name: "IL",
  },
  {
    zip_code: "62468",

    ste_name: "IL",
  },
  {
    zip_code: "62635",

    ste_name: "IL",
  },
  {
    zip_code: "62692",

    ste_name: "IL",
  },
  {
    zip_code: "62839",

    ste_name: "IL",
  },
  {
    zip_code: "62851",

    ste_name: "IL",
  },
  {
    zip_code: "62926",

    ste_name: "IL",
  },
  {
    zip_code: "63049",

    ste_name: "MO",
  },
  {
    zip_code: "63053",

    ste_name: "MO",
  },
  {
    zip_code: "63070",

    ste_name: "MO",
  },
  {
    zip_code: "63103",

    ste_name: "MO",
  },
  {
    zip_code: "63334",

    ste_name: "MO",
  },
  {
    zip_code: "63344",

    ste_name: "MO",
  },
  {
    zip_code: "63357",

    ste_name: "MO",
  },
  {
    zip_code: "63390",

    ste_name: "MO",
  },
  {
    zip_code: "63458",

    ste_name: "MO",
  },
  {
    zip_code: "63764",

    ste_name: "MO",
  },
  {
    zip_code: "63774",

    ste_name: "MO",
  },
  {
    zip_code: "63877",

    ste_name: "MO",
  },
  {
    zip_code: "63880",

    ste_name: "MO",
  },
  {
    zip_code: "63961",

    ste_name: "MO",
  },
  {
    zip_code: "64050",

    ste_name: "MO",
  },
  {
    zip_code: "64070",

    ste_name: "MO",
  },
  {
    zip_code: "64119",

    ste_name: "MO",
  },
  {
    zip_code: "64146",

    ste_name: "MO",
  },
  {
    zip_code: "64465",

    ste_name: "MO",
  },
  {
    zip_code: "64476",

    ste_name: "MO",
  },
  {
    zip_code: "64505",

    ste_name: "MO",
  },
  {
    zip_code: "64636",

    ste_name: "MO",
  },
  {
    zip_code: "64641",

    ste_name: "MO",
  },
  {
    zip_code: "64654",

    ste_name: "MO",
  },
  {
    zip_code: "64722",

    ste_name: "MO",
  },
  {
    zip_code: "64855",

    ste_name: "MO",
  },
  {
    zip_code: "64873",

    ste_name: "MO",
  },
  {
    zip_code: "65016",

    ste_name: "MO",
  },
  {
    zip_code: "65024",

    ste_name: "MO",
  },
  {
    zip_code: "65075",

    ste_name: "MO",
  },
  {
    zip_code: "65082",

    ste_name: "MO",
  },
  {
    zip_code: "65233",

    ste_name: "MO",
  },
  {
    zip_code: "65329",

    ste_name: "MO",
  },
  {
    zip_code: "65536",

    ste_name: "MO",
  },
  {
    zip_code: "65571",

    ste_name: "MO",
  },
  {
    zip_code: "65589",

    ste_name: "MO",
  },
  {
    zip_code: "65676",

    ste_name: "MO",
  },
  {
    zip_code: "65682",

    ste_name: "MO",
  },
  {
    zip_code: "65707",

    ste_name: "MO",
  },
  {
    zip_code: "65732",

    ste_name: "MO",
  },
  {
    zip_code: "66079",

    ste_name: "KS",
  },
  {
    zip_code: "66090",

    ste_name: "KS",
  },
  {
    zip_code: "66442",

    ste_name: "KS",
  },
  {
    zip_code: "66536",

    ste_name: "KS",
  },
  {
    zip_code: "66621",

    ste_name: "KS",
  },
  {
    zip_code: "66751",

    ste_name: "KS",
  },
  {
    zip_code: "66781",

    ste_name: "KS",
  },
  {
    zip_code: "66932",

    ste_name: "KS",
  },
  {
    zip_code: "67002",

    ste_name: "KS",
  },
  {
    zip_code: "67013",

    ste_name: "KS",
  },
  {
    zip_code: "67059",

    ste_name: "KS",
  },
  {
    zip_code: "67213",

    ste_name: "KS",
  },
  {
    zip_code: "67574",

    ste_name: "KS",
  },
  {
    zip_code: "68015",

    ste_name: "NE",
  },
  {
    zip_code: "68022",

    ste_name: "NE",
  },
  {
    zip_code: "68040",

    ste_name: "NE",
  },
  {
    zip_code: "68333",

    ste_name: "NE",
  },
  {
    zip_code: "68346",

    ste_name: "NE",
  },
  {
    zip_code: "68354",

    ste_name: "NE",
  },
  {
    zip_code: "68521",

    ste_name: "NE",
  },
  {
    zip_code: "68626",

    ste_name: "NE",
  },
  {
    zip_code: "68718",

    ste_name: "NE",
  },
  {
    zip_code: "68757",

    ste_name: "NE",
  },
  {
    zip_code: "68813",

    ste_name: "NE",
  },
  {
    zip_code: "68825",

    ste_name: "NE",
  },
  {
    zip_code: "68835",

    ste_name: "NE",
  },
  {
    zip_code: "68860",

    ste_name: "NE",
  },
  {
    zip_code: "68878",

    ste_name: "NE",
  },
  {
    zip_code: "68925",

    ste_name: "NE",
  },
  {
    zip_code: "68970",

    ste_name: "NE",
  },
  {
    zip_code: "69125",

    ste_name: "NE",
  },
  {
    zip_code: "69140",

    ste_name: "NE",
  },
  {
    zip_code: "69144",

    ste_name: "NE",
  },
  {
    zip_code: "69150",

    ste_name: "NE",
  },
  {
    zip_code: "69151",

    ste_name: "NE",
  },
  {
    zip_code: "69356",

    ste_name: "NE",
  },
  {
    zip_code: "70052",

    ste_name: "LA",
  },
  {
    zip_code: "70139",

    ste_name: "LA",
  },
  {
    zip_code: "70375",

    ste_name: "LA",
  },
  {
    zip_code: "70653",

    ste_name: "LA",
  },
  {
    zip_code: "70805",

    ste_name: "LA",
  },
  {
    zip_code: "71023",

    ste_name: "LA",
  },
  {
    zip_code: "71068",

    ste_name: "LA",
  },
  {
    zip_code: "71104",

    ste_name: "LA",
  },
  {
    zip_code: "71112",

    ste_name: "LA",
  },
  {
    zip_code: "71234",

    ste_name: "LA",
  },
  {
    zip_code: "71245",

    ste_name: "LA",
  },
  {
    zip_code: "71468",

    ste_name: "LA",
  },
  {
    zip_code: "71474",

    ste_name: "LA",
  },
  {
    zip_code: "71659",

    ste_name: "AR",
  },
  {
    zip_code: "71676",

    ste_name: "AR",
  },
  {
    zip_code: "71801",

    ste_name: "AR",
  },
  {
    zip_code: "71833",

    ste_name: "AR",
  },
  {
    zip_code: "72005",

    ste_name: "AR",
  },
  {
    zip_code: "72086",

    ste_name: "AR",
  },
  {
    zip_code: "72106",

    ste_name: "AR",
  },
  {
    zip_code: "72117",

    ste_name: "AR",
  },
  {
    zip_code: "72459",

    ste_name: "AR",
  },
  {
    zip_code: "72573",

    ste_name: "AR",
  },
  {
    zip_code: "72635",

    ste_name: "AR",
  },
  {
    zip_code: "72663",

    ste_name: "AR",
  },
  {
    zip_code: "72752",

    ste_name: "AR",
  },
  {
    zip_code: "72826",

    ste_name: "AR",
  },
  {
    zip_code: "72847",

    ste_name: "AR",
  },
  {
    zip_code: "72941",

    ste_name: "AR",
  },
  {
    zip_code: "72958",

    ste_name: "AR",
  },
  {
    zip_code: "73008",

    ste_name: "OK",
  },
  {
    zip_code: "73114",

    ste_name: "OK",
  },
  {
    zip_code: "73446",

    ste_name: "OK",
  },
  {
    zip_code: "73544",

    ste_name: "OK",
  },
  {
    zip_code: "73552",

    ste_name: "OK",
  },
  {
    zip_code: "73946",

    ste_name: "OK",
  },
  {
    zip_code: "74071",

    ste_name: "OK",
  },
  {
    zip_code: "74074",

    ste_name: "OK",
  },
  {
    zip_code: "74081",

    ste_name: "OK",
  },
  {
    zip_code: "74563",

    ste_name: "OK",
  },
  {
    zip_code: "74735",

    ste_name: "OK",
  },
  {
    zip_code: "74766",

    ste_name: "OK",
  },
  {
    zip_code: "75034",

    ste_name: "TX",
  },
  {
    zip_code: "75125",

    ste_name: "TX",
  },
  {
    zip_code: "75135",

    ste_name: "TX",
  },
  {
    zip_code: "75149",

    ste_name: "TX",
  },
  {
    zip_code: "75163",

    ste_name: "TX",
  },
  {
    zip_code: "75182",

    ste_name: "TX",
  },
  {
    zip_code: "75203",

    ste_name: "TX",
  },
  {
    zip_code: "75454",

    ste_name: "TX",
  },
  {
    zip_code: "75475",

    ste_name: "TX",
  },
  {
    zip_code: "75550",

    ste_name: "TX",
  },
  {
    zip_code: "75702",

    ste_name: "TX",
  },
  {
    zip_code: "75770",

    ste_name: "TX",
  },
  {
    zip_code: "75833",

    ste_name: "TX",
  },
  {
    zip_code: "75850",

    ste_name: "TX",
  },
  {
    zip_code: "75859",

    ste_name: "TX",
  },
  {
    zip_code: "75934",

    ste_name: "TX",
  },
  {
    zip_code: "75944",

    ste_name: "TX",
  },
  {
    zip_code: "76008",

    ste_name: "TX",
  },
  {
    zip_code: "76050",

    ste_name: "TX",
  },
  {
    zip_code: "76054",

    ste_name: "TX",
  },
  {
    zip_code: "76060",

    ste_name: "TX",
  },
  {
    zip_code: "76061",

    ste_name: "TX",
  },
  {
    zip_code: "76063",

    ste_name: "TX",
  },
  {
    zip_code: "76071",

    ste_name: "TX",
  },
  {
    zip_code: "76123",

    ste_name: "TX",
  },
  {
    zip_code: "76201",

    ste_name: "TX",
  },
  {
    zip_code: "76230",

    ste_name: "TX",
  },
  {
    zip_code: "76443",

    ste_name: "TX",
  },
  {
    zip_code: "76623",

    ste_name: "TX",
  },
  {
    zip_code: "76648",

    ste_name: "TX",
  },
  {
    zip_code: "76821",

    ste_name: "TX",
  },
  {
    zip_code: "76856",

    ste_name: "TX",
  },
  {
    zip_code: "76861",

    ste_name: "TX",
  },
  {
    zip_code: "76866",

    ste_name: "TX",
  },
  {
    zip_code: "76871",

    ste_name: "TX",
  },
  {
    zip_code: "76955",

    ste_name: "TX",
  },
  {
    zip_code: "76958",

    ste_name: "TX",
  },
  {
    zip_code: "77020",

    ste_name: "TX",
  },
  {
    zip_code: "77041",

    ste_name: "TX",
  },
  {
    zip_code: "77086",

    ste_name: "TX",
  },
  {
    zip_code: "77090",

    ste_name: "TX",
  },
  {
    zip_code: "77099",

    ste_name: "TX",
  },
  {
    zip_code: "77316",

    ste_name: "TX",
  },
  {
    zip_code: "77367",

    ste_name: "TX",
  },
  {
    zip_code: "77384",

    ste_name: "TX",
  },
  {
    zip_code: "77406",

    ste_name: "TX",
  },
  {
    zip_code: "77426",

    ste_name: "TX",
  },
  {
    zip_code: "77455",

    ste_name: "TX",
  },
  {
    zip_code: "77457",

    ste_name: "TX",
  },
  {
    zip_code: "77465",

    ste_name: "TX",
  },
  {
    zip_code: "77623",

    ste_name: "TX",
  },
  {
    zip_code: "77705",

    ste_name: "TX",
  },
  {
    zip_code: "77964",

    ste_name: "TX",
  },
  {
    zip_code: "77984",

    ste_name: "TX",
  },
  {
    zip_code: "78066",

    ste_name: "TX",
  },
  {
    zip_code: "78109",

    ste_name: "TX",
  },
  {
    zip_code: "78130",

    ste_name: "TX",
  },
  {
    zip_code: "78148",

    ste_name: "TX",
  },
  {
    zip_code: "78225",

    ste_name: "TX",
  },
  {
    zip_code: "78335",

    ste_name: "TX",
  },
  {
    zip_code: "78358",

    ste_name: "TX",
  },
  {
    zip_code: "78383",

    ste_name: "TX",
  },
  {
    zip_code: "78582",

    ste_name: "TX",
  },
  {
    zip_code: "78620",

    ste_name: "TX",
  },
  {
    zip_code: "78638",

    ste_name: "TX",
  },
  {
    zip_code: "78717",

    ste_name: "TX",
  },
  {
    zip_code: "78747",

    ste_name: "TX",
  },
  {
    zip_code: "78751",

    ste_name: "TX",
  },
  {
    zip_code: "78832",

    ste_name: "TX",
  },
  {
    zip_code: "78836",

    ste_name: "TX",
  },
  {
    zip_code: "78956",

    ste_name: "TX",
  },
  {
    zip_code: "79014",

    ste_name: "TX",
  },
  {
    zip_code: "79033",

    ste_name: "TX",
  },
  {
    zip_code: "79104",

    ste_name: "TX",
  },
  {
    zip_code: "79108",

    ste_name: "TX",
  },
  {
    zip_code: "79220",

    ste_name: "TX",
  },
  {
    zip_code: "79231",

    ste_name: "TX",
  },
  {
    zip_code: "79243",

    ste_name: "TX",
  },
  {
    zip_code: "79510",

    ste_name: "TX",
  },
  {
    zip_code: "80221",

    ste_name: "CO",
  },
  {
    zip_code: "80228",

    ste_name: "CO",
  },
  {
    zip_code: "80232",

    ste_name: "CO",
  },
  {
    zip_code: "80249",

    ste_name: "CO",
  },
  {
    zip_code: "80451",

    ste_name: "CO",
  },
  {
    zip_code: "80528",

    ste_name: "CO",
  },
  {
    zip_code: "80610",

    ste_name: "CO",
  },
  {
    zip_code: "80612",

    ste_name: "CO",
  },
  {
    zip_code: "80723",

    ste_name: "CO",
  },
  {
    zip_code: "81121",

    ste_name: "CO",
  },
  {
    zip_code: "81210",

    ste_name: "CO",
  },
  {
    zip_code: "81223",

    ste_name: "CO",
  },
  {
    zip_code: "81324",

    ste_name: "CO",
  },
  {
    zip_code: "81612",

    ste_name: "CO",
  },
  {
    zip_code: "81650",

    ste_name: "CO",
  },
  {
    zip_code: "82009",

    ste_name: "WY",
  },
  {
    zip_code: "82059",

    ste_name: "WY",
  },
  {
    zip_code: "82073",

    ste_name: "WY",
  },
  {
    zip_code: "82201",

    ste_name: "WY",
  },
  {
    zip_code: "82334",

    ste_name: "WY",
  },
  {
    zip_code: "82442",

    ste_name: "WY",
  },
  {
    zip_code: "82515",

    ste_name: "WY",
  },
  {
    zip_code: "82644",

    ste_name: "WY",
  },
  {
    zip_code: "82930",

    ste_name: "WY",
  },
  {
    zip_code: "83227",

    ste_name: "ID",
  },
  {
    zip_code: "83276",

    ste_name: "ID",
  },
  {
    zip_code: "83330",

    ste_name: "ID",
  },
  {
    zip_code: "83429",

    ste_name: "ID",
  },
  {
    zip_code: "83624",

    ste_name: "ID",
  },
  {
    zip_code: "83634",

    ste_name: "ID",
  },
  {
    zip_code: "83657",

    ste_name: "ID",
  },
  {
    zip_code: "83660",

    ste_name: "ID",
  },
  {
    zip_code: "83713",

    ste_name: "ID",
  },
  {
    zip_code: "83834",

    ste_name: "ID",
  },
  {
    zip_code: "83836",

    ste_name: "ID",
  },
  {
    zip_code: "83874",

    ste_name: "ID",
  },
  {
    zip_code: "84007",

    ste_name: "UT",
  },
  {
    zip_code: "84014",

    ste_name: "UT",
  },
  {
    zip_code: "84043",

    ste_name: "UT",
  },
  {
    zip_code: "84097",

    ste_name: "UT",
  },
  {
    zip_code: "84109",

    ste_name: "UT",
  },
  {
    zip_code: "84319",

    ste_name: "UT",
  },
  {
    zip_code: "84512",

    ste_name: "UT",
  },
  {
    zip_code: "84525",

    ste_name: "UT",
  },
  {
    zip_code: "84646",

    ste_name: "UT",
  },
  {
    zip_code: "84712",

    ste_name: "UT",
  },
  {
    zip_code: "84720",

    ste_name: "UT",
  },
  {
    zip_code: "84722",

    ste_name: "UT",
  },
  {
    zip_code: "84729",

    ste_name: "UT",
  },
  {
    zip_code: "85257",

    ste_name: "AZ",
  },
  {
    zip_code: "85328",

    ste_name: "AZ",
  },
  {
    zip_code: "85333",

    ste_name: "AZ",
  },
  {
    zip_code: "85356",

    ste_name: "AZ",
  },
  {
    zip_code: "85364",

    ste_name: "AZ",
  },
  {
    zip_code: "85530",

    ste_name: "AZ",
  },
  {
    zip_code: "85542",

    ste_name: "AZ",
  },
  {
    zip_code: "85653",

    ste_name: "AZ",
  },
  {
    zip_code: "85723",

    ste_name: "AZ",
  },
  {
    zip_code: "86018",

    ste_name: "AZ",
  },
  {
    zip_code: "86303",

    ste_name: "AZ",
  },
  {
    zip_code: "86343",

    ste_name: "AZ",
  },
  {
    zip_code: "87027",

    ste_name: "NM",
  },
  {
    zip_code: "87053",

    ste_name: "NM",
  },
  {
    zip_code: "87059",

    ste_name: "NM",
  },
  {
    zip_code: "87506",

    ste_name: "NM",
  },
  {
    zip_code: "87511",

    ste_name: "NM",
  },
  {
    zip_code: "87540",

    ste_name: "NM",
  },
  {
    zip_code: "87552",

    ste_name: "NM",
  },
  {
    zip_code: "87715",

    ste_name: "NM",
  },
  {
    zip_code: "88002",

    ste_name: "NM",
  },
  {
    zip_code: "88119",

    ste_name: "NM",
  },
  {
    zip_code: "88125",

    ste_name: "NM",
  },
  {
    zip_code: "88126",

    ste_name: "NM",
  },
  {
    zip_code: "88351",

    ste_name: "NM",
  },
  {
    zip_code: "88355",

    ste_name: "NM",
  },
  {
    zip_code: "89128",

    ste_name: "NV",
  },
  {
    zip_code: "89131",

    ste_name: "NV",
  },
  {
    zip_code: "89166",

    ste_name: "NV",
  },
  {
    zip_code: "89316",

    ste_name: "NV",
  },
  {
    zip_code: "89318",

    ste_name: "NV",
  },
  {
    zip_code: "89828",

    ste_name: "NV",
  },
  {
    zip_code: "89835",

    ste_name: "NV",
  },
  {
    zip_code: "90028",

    ste_name: "CA",
  },
  {
    zip_code: "90031",

    ste_name: "CA",
  },
  {
    zip_code: "90065",

    ste_name: "CA",
  },
  {
    zip_code: "90071",

    ste_name: "CA",
  },
  {
    zip_code: "90241",

    ste_name: "CA",
  },
  {
    zip_code: "90242",

    ste_name: "CA",
  },
  {
    zip_code: "90502",

    ste_name: "CA",
  },
  {
    zip_code: "90710",

    ste_name: "CA",
  },
  {
    zip_code: "90713",

    ste_name: "CA",
  },
  {
    zip_code: "90743",

    ste_name: "CA",
  },
  {
    zip_code: "91205",

    ste_name: "CA",
  },
  {
    zip_code: "91311",

    ste_name: "CA",
  },
  {
    zip_code: "91768",

    ste_name: "CA",
  },
  {
    zip_code: "91950",

    ste_name: "CA",
  },
  {
    zip_code: "92057",

    ste_name: "CA",
  },
  {
    zip_code: "92064",

    ste_name: "CA",
  },
  {
    zip_code: "92120",

    ste_name: "CA",
  },
  {
    zip_code: "92154",

    ste_name: "CA",
  },
  {
    zip_code: "92242",

    ste_name: "CA",
  },
  {
    zip_code: "92281",

    ste_name: "CA",
  },
  {
    zip_code: "97752",

    ste_name: "OR",
  },
  {
    zip_code: "97834",

    ste_name: "OR",
  },
  {
    zip_code: "98045",

    ste_name: "WA",
  },
  {
    zip_code: "98072",

    ste_name: "WA",
  },
  {
    zip_code: "21225",

    ste_name: "MD",
  },
  {
    zip_code: "21667",

    ste_name: "MD",
  },
  {
    zip_code: "21717",

    ste_name: "MD",
  },
  {
    zip_code: "21921",

    ste_name: "MD",
  },
  {
    zip_code: "22134",

    ste_name: "VA",
  },
  {
    zip_code: "22180",

    ste_name: "VA",
  },
  {
    zip_code: "22731",

    ste_name: "VA",
  },
  {
    zip_code: "22853",

    ste_name: "VA",
  },
  {
    zip_code: "23027",

    ste_name: "VA",
  },
  {
    zip_code: "23050",

    ste_name: "VA",
  },
  {
    zip_code: "23062",

    ste_name: "VA",
  },
  {
    zip_code: "23106",

    ste_name: "VA",
  },
  {
    zip_code: "23109",

    ste_name: "VA",
  },
  {
    zip_code: "23141",

    ste_name: "VA",
  },
  {
    zip_code: "23188",

    ste_name: "VA",
  },
  {
    zip_code: "23220",

    ste_name: "VA",
  },
  {
    zip_code: "23237",

    ste_name: "VA",
  },
  {
    zip_code: "23325",

    ste_name: "VA",
  },
  {
    zip_code: "23407",

    ste_name: "VA",
  },
  {
    zip_code: "23421",

    ste_name: "VA",
  },
  {
    zip_code: "23487",

    ste_name: "VA",
  },
  {
    zip_code: "23839",

    ste_name: "VA",
  },
  {
    zip_code: "23844",

    ste_name: "VA",
  },
  {
    zip_code: "23856",

    ste_name: "VA",
  },
  {
    zip_code: "23893",

    ste_name: "VA",
  },
  {
    zip_code: "23897",

    ste_name: "VA",
  },
  {
    zip_code: "24087",

    ste_name: "VA",
  },
  {
    zip_code: "24088",

    ste_name: "VA",
  },
  {
    zip_code: "24340",

    ste_name: "VA",
  },
  {
    zip_code: "24520",

    ste_name: "VA",
  },
  {
    zip_code: "24541",

    ste_name: "VA",
  },
  {
    zip_code: "24714",

    ste_name: "WV",
  },
  {
    zip_code: "24738",

    ste_name: "WV",
  },
  {
    zip_code: "24839",

    ste_name: "WV",
  },
  {
    zip_code: "24843",

    ste_name: "WV",
  },
  {
    zip_code: "24857",

    ste_name: "WV",
  },
  {
    zip_code: "24938",

    ste_name: "WV",
  },
  {
    zip_code: "24977",

    ste_name: "WV",
  },
  {
    zip_code: "25060",

    ste_name: "WV",
  },
  {
    zip_code: "25134",

    ste_name: "WV",
  },
  {
    zip_code: "25141",

    ste_name: "WV",
  },
  {
    zip_code: "25405",

    ste_name: "WV",
  },
  {
    zip_code: "25438",

    ste_name: "WV",
  },
  {
    zip_code: "25526",

    ste_name: "WV",
  },
  {
    zip_code: "25537",

    ste_name: "WV",
  },
  {
    zip_code: "25674",

    ste_name: "WV",
  },
  {
    zip_code: "25913",

    ste_name: "WV",
  },
  {
    zip_code: "25915",

    ste_name: "WV",
  },
  {
    zip_code: "25942",

    ste_name: "WV",
  },
  {
    zip_code: "26208",

    ste_name: "WV",
  },
  {
    zip_code: "26230",

    ste_name: "WV",
  },
  {
    zip_code: "26250",

    ste_name: "WV",
  },
  {
    zip_code: "26254",

    ste_name: "WV",
  },
  {
    zip_code: "26294",

    ste_name: "WV",
  },
  {
    zip_code: "26298",

    ste_name: "WV",
  },
  {
    zip_code: "26610",

    ste_name: "WV",
  },
  {
    zip_code: "26711",

    ste_name: "WV",
  },
  {
    zip_code: "26764",

    ste_name: "WV",
  },
  {
    zip_code: "27020",

    ste_name: "NC",
  },
  {
    zip_code: "27306",

    ste_name: "NC",
  },
  {
    zip_code: "27325",

    ste_name: "NC",
  },
  {
    zip_code: "27501",

    ste_name: "NC",
  },
  {
    zip_code: "27536",

    ste_name: "NC",
  },
  {
    zip_code: "27612",

    ste_name: "NC",
  },
  {
    zip_code: "27805",

    ste_name: "NC",
  },
  {
    zip_code: "27821",

    ste_name: "NC",
  },
  {
    zip_code: "27832",

    ste_name: "NC",
  },
  {
    zip_code: "27873",

    ste_name: "NC",
  },
  {
    zip_code: "27897",

    ste_name: "NC",
  },
  {
    zip_code: "27917",

    ste_name: "NC",
  },
  {
    zip_code: "27959",

    ste_name: "NC",
  },
  {
    zip_code: "28365",

    ste_name: "NC",
  },
  {
    zip_code: "28552",

    ste_name: "NC",
  },
  {
    zip_code: "28606",

    ste_name: "NC",
  },
  {
    zip_code: "28617",

    ste_name: "NC",
  },
  {
    zip_code: "28619",

    ste_name: "NC",
  },
  {
    zip_code: "28671",

    ste_name: "NC",
  },
  {
    zip_code: "28675",

    ste_name: "NC",
  },
  {
    zip_code: "28736",

    ste_name: "NC",
  },
  {
    zip_code: "28805",

    ste_name: "NC",
  },
  {
    zip_code: "29044",

    ste_name: "SC",
  },
  {
    zip_code: "29065",

    ste_name: "SC",
  },
  {
    zip_code: "29112",

    ste_name: "SC",
  },
  {
    zip_code: "29207",

    ste_name: "SC",
  },
  {
    zip_code: "29210",

    ste_name: "SC",
  },
  {
    zip_code: "29325",

    ste_name: "SC",
  },
  {
    zip_code: "29404",

    ste_name: "SC",
  },
  {
    zip_code: "29426",

    ste_name: "SC",
  },
  {
    zip_code: "29446",

    ste_name: "SC",
  },
  {
    zip_code: "29474",

    ste_name: "SC",
  },
  {
    zip_code: "29511",

    ste_name: "SC",
  },
  {
    zip_code: "29585",

    ste_name: "SC",
  },
  {
    zip_code: "29642",

    ste_name: "SC",
  },
  {
    zip_code: "29702",

    ste_name: "SC",
  },
  {
    zip_code: "29720",

    ste_name: "SC",
  },
  {
    zip_code: "29849",

    ste_name: "SC",
  },
  {
    zip_code: "29934",

    ste_name: "SC",
  },
  {
    zip_code: "29935",

    ste_name: "SC",
  },
  {
    zip_code: "30030",

    ste_name: "GA",
  },
  {
    zip_code: "30040",

    ste_name: "GA",
  },
  {
    zip_code: "30078",

    ste_name: "GA",
  },
  {
    zip_code: "30117",

    ste_name: "GA",
  },
  {
    zip_code: "30122",

    ste_name: "GA",
  },
  {
    zip_code: "30144",

    ste_name: "GA",
  },
  {
    zip_code: "30268",

    ste_name: "GA",
  },
  {
    zip_code: "30291",

    ste_name: "GA",
  },
  {
    zip_code: "30439",

    ste_name: "GA",
  },
  {
    zip_code: "30522",

    ste_name: "GA",
  },
  {
    zip_code: "30568",

    ste_name: "GA",
  },
  {
    zip_code: "30601",

    ste_name: "GA",
  },
  {
    zip_code: "30646",

    ste_name: "GA",
  },
  {
    zip_code: "30669",

    ste_name: "GA",
  },
  {
    zip_code: "30802",

    ste_name: "GA",
  },
  {
    zip_code: "30830",

    ste_name: "GA",
  },
  {
    zip_code: "30906",

    ste_name: "GA",
  },
  {
    zip_code: "92701",

    ste_name: "CA",
  },
  {
    zip_code: "92780",

    ste_name: "CA",
  },
  {
    zip_code: "93212",

    ste_name: "CA",
  },
  {
    zip_code: "93235",

    ste_name: "CA",
  },
  {
    zip_code: "93601",

    ste_name: "CA",
  },
  {
    zip_code: "93653",

    ste_name: "CA",
  },
  {
    zip_code: "93925",

    ste_name: "CA",
  },
  {
    zip_code: "94002",

    ste_name: "CA",
  },
  {
    zip_code: "94015",

    ste_name: "CA",
  },
  {
    zip_code: "94019",

    ste_name: "CA",
  },
  {
    zip_code: "94130",

    ste_name: "CA",
  },
  {
    zip_code: "94502",

    ste_name: "CA",
  },
  {
    zip_code: "94514",

    ste_name: "CA",
  },
  {
    zip_code: "94547",

    ste_name: "CA",
  },
  {
    zip_code: "94568",

    ste_name: "CA",
  },
  {
    zip_code: "94573",

    ste_name: "CA",
  },
  {
    zip_code: "94608",

    ste_name: "CA",
  },
  {
    zip_code: "94610",

    ste_name: "CA",
  },
  {
    zip_code: "94801",

    ste_name: "CA",
  },
  {
    zip_code: "94804",

    ste_name: "CA",
  },
  {
    zip_code: "95033",

    ste_name: "CA",
  },
  {
    zip_code: "95134",

    ste_name: "CA",
  },
  {
    zip_code: "95202",

    ste_name: "CA",
  },
  {
    zip_code: "95203",

    ste_name: "CA",
  },
  {
    zip_code: "95206",

    ste_name: "CA",
  },
  {
    zip_code: "95211",

    ste_name: "CA",
  },
  {
    zip_code: "95240",

    ste_name: "CA",
  },
  {
    zip_code: "95246",

    ste_name: "CA",
  },
  {
    zip_code: "95374",

    ste_name: "CA",
  },
  {
    zip_code: "95380",

    ste_name: "CA",
  },
  {
    zip_code: "95412",

    ste_name: "CA",
  },
  {
    zip_code: "95415",

    ste_name: "CA",
  },
  {
    zip_code: "95439",

    ste_name: "CA",
  },
  {
    zip_code: "95444",

    ste_name: "CA",
  },
  {
    zip_code: "95568",

    ste_name: "CA",
  },
  {
    zip_code: "95569",

    ste_name: "CA",
  },
  {
    zip_code: "95757",

    ste_name: "CA",
  },
  {
    zip_code: "95828",

    ste_name: "CA",
  },
  {
    zip_code: "95838",

    ste_name: "CA",
  },
  {
    zip_code: "95918",

    ste_name: "CA",
  },
  {
    zip_code: "95919",

    ste_name: "CA",
  },
  {
    zip_code: "95950",

    ste_name: "CA",
  },
  {
    zip_code: "95960",

    ste_name: "CA",
  },
  {
    zip_code: "95968",

    ste_name: "CA",
  },
  {
    zip_code: "95983",

    ste_name: "CA",
  },
  {
    zip_code: "96031",

    ste_name: "CA",
  },
  {
    zip_code: "96050",

    ste_name: "CA",
  },
  {
    zip_code: "96073",

    ste_name: "CA",
  },
  {
    zip_code: "96088",

    ste_name: "CA",
  },
  {
    zip_code: "96104",

    ste_name: "CA",
  },
  {
    zip_code: "96105",

    ste_name: "CA",
  },
  {
    zip_code: "96111",

    ste_name: "CA",
  },
  {
    zip_code: "96746",

    ste_name: "HI",
  },
  {
    zip_code: "96753",

    ste_name: "HI",
  },
  {
    zip_code: "96792",

    ste_name: "HI",
  },
  {
    zip_code: "96797",

    ste_name: "HI",
  },
  {
    zip_code: "96853",

    ste_name: "HI",
  },
  {
    zip_code: "97032",

    ste_name: "OR",
  },
  {
    zip_code: "97038",

    ste_name: "OR",
  },
  {
    zip_code: "97203",

    ste_name: "OR",
  },
  {
    zip_code: "97208",

    ste_name: "OR",
  },
  {
    zip_code: "97327",

    ste_name: "OR",
  },
  {
    zip_code: "97355",

    ste_name: "OR",
  },
  {
    zip_code: "97362",

    ste_name: "OR",
  },
  {
    zip_code: "97384",

    ste_name: "OR",
  },
  {
    zip_code: "97448",

    ste_name: "OR",
  },
  {
    zip_code: "97449",

    ste_name: "OR",
  },
  {
    zip_code: "97465",

    ste_name: "OR",
  },
  {
    zip_code: "97624",

    ste_name: "OR",
  },
  {
    zip_code: "97635",

    ste_name: "OR",
  },
  {
    zip_code: "98121",

    ste_name: "WA",
  },
  {
    zip_code: "98296",

    ste_name: "WA",
  },
  {
    zip_code: "98331",

    ste_name: "WA",
  },
  {
    zip_code: "98358",

    ste_name: "WA",
  },
  {
    zip_code: "98372",

    ste_name: "WA",
  },
  {
    zip_code: "58061",

    ste_name: "ND",
  },
  {
    zip_code: "58076",

    ste_name: "ND",
  },
  {
    zip_code: "58233",

    ste_name: "ND",
  },
  {
    zip_code: "58267",

    ste_name: "ND",
  },
  {
    zip_code: "58270",

    ste_name: "ND",
  },
  {
    zip_code: "58273",

    ste_name: "ND",
  },
  {
    zip_code: "58277",

    ste_name: "ND",
  },
  {
    zip_code: "58301",

    ste_name: "ND",
  },
  {
    zip_code: "58353",

    ste_name: "ND",
  },
  {
    zip_code: "58438",

    ste_name: "ND",
  },
  {
    zip_code: "58483",

    ste_name: "ND",
  },
  {
    zip_code: "58484",

    ste_name: "ND",
  },
  {
    zip_code: "58505",

    ste_name: "ND",
  },
  {
    zip_code: "58524",

    ste_name: "ND",
  },
  {
    zip_code: "58560",

    ste_name: "ND",
  },
  {
    zip_code: "58623",

    ste_name: "ND",
  },
  {
    zip_code: "58646",

    ste_name: "ND",
  },
  {
    zip_code: "58701",

    ste_name: "ND",
  },
  {
    zip_code: "58707",

    ste_name: "ND",
  },
  {
    zip_code: "58711",

    ste_name: "ND",
  },
  {
    zip_code: "58733",

    ste_name: "ND",
  },
  {
    zip_code: "98438",

    ste_name: "WA",
  },
  {
    zip_code: "98524",

    ste_name: "WA",
  },
  {
    zip_code: "98531",

    ste_name: "WA",
  },
  {
    zip_code: "98575",

    ste_name: "WA",
  },
  {
    zip_code: "98624",

    ste_name: "WA",
  },
  {
    zip_code: "98625",

    ste_name: "WA",
  },
  {
    zip_code: "98642",

    ste_name: "WA",
  },
  {
    zip_code: "98683",

    ste_name: "WA",
  },
  {
    zip_code: "98845",

    ste_name: "WA",
  },
  {
    zip_code: "98930",

    ste_name: "WA",
  },
  {
    zip_code: "98951",

    ste_name: "WA",
  },
  {
    zip_code: "99102",

    ste_name: "WA",
  },
  {
    zip_code: "99139",

    ste_name: "WA",
  },
  {
    zip_code: "99180",

    ste_name: "WA",
  },
  {
    zip_code: "99505",

    ste_name: "AK",
  },
  {
    zip_code: "99506",

    ste_name: "AK",
  },
  {
    zip_code: "99516",

    ste_name: "AK",
  },
  {
    zip_code: "99610",

    ste_name: "AK",
  },
  {
    zip_code: "99674",

    ste_name: "AK",
  },
  {
    zip_code: "99677",

    ste_name: "AK",
  },
  {
    zip_code: "99704",

    ste_name: "AK",
  },
  {
    zip_code: "99720",

    ste_name: "AK",
  },
  {
    zip_code: "99733",

    ste_name: "AK",
  },
  {
    zip_code: "99741",

    ste_name: "AK",
  },
  {
    zip_code: "99751",

    ste_name: "AK",
  },
  {
    zip_code: "99761",

    ste_name: "AK",
  },
  {
    zip_code: "99767",

    ste_name: "AK",
  },
  {
    zip_code: "7095",

    ste_name: "NJ",
  },
  {
    zip_code: "7621",

    ste_name: "NJ",
  },
  {
    zip_code: "7631",

    ste_name: "NJ",
  },
  {
    zip_code: "7746",

    ste_name: "NJ",
  },
  {
    zip_code: "7825",

    ste_name: "NJ",
  },
  {
    zip_code: "7843",

    ste_name: "NJ",
  },
  {
    zip_code: "7863",

    ste_name: "NJ",
  },
  {
    zip_code: "7920",

    ste_name: "NJ",
  },
  {
    zip_code: "7945",

    ste_name: "NJ",
  },
  {
    zip_code: "8542",

    ste_name: "NJ",
  },
  {
    zip_code: "21776",

    ste_name: "MD",
  },
  {
    zip_code: "22214",

    ste_name: "VA",
  },
  {
    zip_code: "22520",

    ste_name: "VA",
  },
  {
    zip_code: "22553",

    ste_name: "VA",
  },
  {
    zip_code: "22554",

    ste_name: "VA",
  },
  {
    zip_code: "22660",

    ste_name: "VA",
  },
  {
    zip_code: "22749",

    ste_name: "VA",
  },
  {
    zip_code: "22847",

    ste_name: "VA",
  },
  {
    zip_code: "58759",

    ste_name: "ND",
  },
  {
    zip_code: "58763",

    ste_name: "ND",
  },
  {
    zip_code: "58831",

    ste_name: "ND",
  },
  {
    zip_code: "59020",

    ste_name: "MT",
  },
  {
    zip_code: "59043",

    ste_name: "MT",
  },
  {
    zip_code: "59211",

    ste_name: "MT",
  },
  {
    zip_code: "59226",

    ste_name: "MT",
  },
  {
    zip_code: "59323",

    ste_name: "MT",
  },
  {
    zip_code: "59456",

    ste_name: "MT",
  },
  {
    zip_code: "59523",

    ste_name: "MT",
  },
  {
    zip_code: "59631",

    ste_name: "MT",
  },
  {
    zip_code: "59635",

    ste_name: "MT",
  },
  {
    zip_code: "59722",

    ste_name: "MT",
  },
  {
    zip_code: "59837",

    ste_name: "MT",
  },
  {
    zip_code: "59840",

    ste_name: "MT",
  },
  {
    zip_code: "59844",

    ste_name: "MT",
  },
  {
    zip_code: "59851",

    ste_name: "MT",
  },
  {
    zip_code: "60007",

    ste_name: "IL",
  },
  {
    zip_code: "60042",

    ste_name: "IL",
  },
  {
    zip_code: "60073",

    ste_name: "IL",
  },
  {
    zip_code: "60112",

    ste_name: "IL",
  },
  {
    zip_code: "60135",

    ste_name: "IL",
  },
  {
    zip_code: "60144",

    ste_name: "IL",
  },
  {
    zip_code: "60192",

    ste_name: "IL",
  },
  {
    zip_code: "60409",

    ste_name: "IL",
  },
  {
    zip_code: "60421",

    ste_name: "IL",
  },
  {
    zip_code: "60542",

    ste_name: "IL",
  },
  {
    zip_code: "60548",

    ste_name: "IL",
  },
  {
    zip_code: "60641",

    ste_name: "IL",
  },
  {
    zip_code: "60712",

    ste_name: "IL",
  },
  {
    zip_code: "60804",

    ste_name: "IL",
  },
  {
    zip_code: "60901",

    ste_name: "IL",
  },
  {
    zip_code: "60948",

    ste_name: "IL",
  },
  {
    zip_code: "61008",

    ste_name: "IL",
  },
  {
    zip_code: "61020",

    ste_name: "IL",
  },
  {
    zip_code: "61031",

    ste_name: "IL",
  },
  {
    zip_code: "61036",

    ste_name: "IL",
  },
  {
    zip_code: "61078",

    ste_name: "IL",
  },
  {
    zip_code: "61101",

    ste_name: "IL",
  },
  {
    zip_code: "61102",

    ste_name: "IL",
  },
  {
    zip_code: "61240",

    ste_name: "IL",
  },
  {
    zip_code: "61244",

    ste_name: "IL",
  },
  {
    zip_code: "61338",

    ste_name: "IL",
  },
  {
    zip_code: "61358",

    ste_name: "IL",
  },
  {
    zip_code: "61426",

    ste_name: "IL",
  },
  {
    zip_code: "61427",

    ste_name: "IL",
  },
  {
    zip_code: "61447",

    ste_name: "IL",
  },
  {
    zip_code: "61462",

    ste_name: "IL",
  },
  {
    zip_code: "61484",

    ste_name: "IL",
  },
  {
    zip_code: "61550",

    ste_name: "IL",
  },
  {
    zip_code: "61723",

    ste_name: "IL",
  },
  {
    zip_code: "61953",

    ste_name: "IL",
  },
  {
    zip_code: "62047",

    ste_name: "IL",
  },
  {
    zip_code: "62082",

    ste_name: "IL",
  },
  {
    zip_code: "62216",

    ste_name: "IL",
  },
  {
    zip_code: "62277",

    ste_name: "IL",
  },
  {
    zip_code: "62344",

    ste_name: "IL",
  },
  {
    zip_code: "62352",

    ste_name: "IL",
  },
  {
    zip_code: "62362",

    ste_name: "IL",
  },
  {
    zip_code: "62413",

    ste_name: "IL",
  },
  {
    zip_code: "62461",

    ste_name: "IL",
  },
  {
    zip_code: "62544",

    ste_name: "IL",
  },
  {
    zip_code: "62563",

    ste_name: "IL",
  },
  {
    zip_code: "62567",

    ste_name: "IL",
  },
  {
    zip_code: "62823",

    ste_name: "IL",
  },
  {
    zip_code: "62852",

    ste_name: "IL",
  },
  {
    zip_code: "62877",

    ste_name: "IL",
  },
  {
    zip_code: "62987",

    ste_name: "IL",
  },
  {
    zip_code: "63134",

    ste_name: "MO",
  },
  {
    zip_code: "63144",

    ste_name: "MO",
  },
  {
    zip_code: "63456",

    ste_name: "MO",
  },
  {
    zip_code: "63460",

    ste_name: "MO",
  },
  {
    zip_code: "63545",

    ste_name: "MO",
  },
  {
    zip_code: "63640",

    ste_name: "MO",
  },
  {
    zip_code: "63645",

    ste_name: "MO",
  },
  {
    zip_code: "63664",

    ste_name: "MO",
  },
  {
    zip_code: "63787",

    ste_name: "MO",
  },
  {
    zip_code: "63933",

    ste_name: "MO",
  },
  {
    zip_code: "63943",

    ste_name: "MO",
  },
  {
    zip_code: "63952",

    ste_name: "MO",
  },
  {
    zip_code: "63957",

    ste_name: "MO",
  },
  {
    zip_code: "64020",

    ste_name: "MO",
  },
  {
    zip_code: "64024",

    ste_name: "MO",
  },
  {
    zip_code: "64085",

    ste_name: "MO",
  },
  {
    zip_code: "64120",

    ste_name: "MO",
  },
  {
    zip_code: "64128",

    ste_name: "MO",
  },
  {
    zip_code: "64748",

    ste_name: "MO",
  },
  {
    zip_code: "65066",

    ste_name: "MO",
  },
  {
    zip_code: "65101",

    ste_name: "MO",
  },
  {
    zip_code: "65215",

    ste_name: "MO",
  },
  {
    zip_code: "65354",

    ste_name: "MO",
  },
  {
    zip_code: "65459",

    ste_name: "MO",
  },
  {
    zip_code: "65570",

    ste_name: "MO",
  },
  {
    zip_code: "65657",

    ste_name: "MO",
  },
  {
    zip_code: "65686",

    ste_name: "MO",
  },
  {
    zip_code: "65725",

    ste_name: "MO",
  },
  {
    zip_code: "65746",

    ste_name: "MO",
  },
  {
    zip_code: "65761",

    ste_name: "MO",
  },
  {
    zip_code: "65779",

    ste_name: "MO",
  },
  {
    zip_code: "66044",

    ste_name: "KS",
  },
  {
    zip_code: "66103",

    ste_name: "KS",
  },
  {
    zip_code: "66616",

    ste_name: "KS",
  },
  {
    zip_code: "66728",

    ste_name: "KS",
  },
  {
    zip_code: "66749",

    ste_name: "KS",
  },
  {
    zip_code: "66761",

    ste_name: "KS",
  },
  {
    zip_code: "66862",

    ste_name: "KS",
  },
  {
    zip_code: "67010",

    ste_name: "KS",
  },
  {
    zip_code: "67038",

    ste_name: "KS",
  },
  {
    zip_code: "67045",

    ste_name: "KS",
  },
  {
    zip_code: "67107",

    ste_name: "KS",
  },
  {
    zip_code: "67202",

    ste_name: "KS",
  },
  {
    zip_code: "67215",

    ste_name: "KS",
  },
  {
    zip_code: "67428",

    ste_name: "KS",
  },
  {
    zip_code: "67467",

    ste_name: "KS",
  },
  {
    zip_code: "67526",

    ste_name: "KS",
  },
  {
    zip_code: "67529",

    ste_name: "KS",
  },
  {
    zip_code: "67543",

    ste_name: "KS",
  },
  {
    zip_code: "67621",

    ste_name: "KS",
  },
  {
    zip_code: "67622",

    ste_name: "KS",
  },
  {
    zip_code: "68008",

    ste_name: "NE",
  },
  {
    zip_code: "68019",

    ste_name: "NE",
  },
  {
    zip_code: "68057",

    ste_name: "NE",
  },
  {
    zip_code: "68350",

    ste_name: "NE",
  },
  {
    zip_code: "68415",

    ste_name: "NE",
  },
  {
    zip_code: "68434",

    ste_name: "NE",
  },
  {
    zip_code: "68516",

    ste_name: "NE",
  },
  {
    zip_code: "68728",

    ste_name: "NE",
  },
  {
    zip_code: "68739",

    ste_name: "NE",
  },
  {
    zip_code: "69020",

    ste_name: "NE",
  },
  {
    zip_code: "69141",

    ste_name: "NE",
  },
  {
    zip_code: "69212",

    ste_name: "NE",
  },
  {
    zip_code: "69216",

    ste_name: "NE",
  },
  {
    zip_code: "69336",

    ste_name: "NE",
  },
  {
    zip_code: "69352",

    ste_name: "NE",
  },
  {
    zip_code: "69360",

    ste_name: "NE",
  },
  {
    zip_code: "70003",

    ste_name: "LA",
  },
  {
    zip_code: "70050",

    ste_name: "LA",
  },
  {
    zip_code: "70403",

    ste_name: "LA",
  },
  {
    zip_code: "70448",

    ste_name: "LA",
  },
  {
    zip_code: "70503",

    ste_name: "LA",
  },
  {
    zip_code: "70515",

    ste_name: "LA",
  },
  {
    zip_code: "70519",

    ste_name: "LA",
  },
  {
    zip_code: "70542",

    ste_name: "LA",
  },
  {
    zip_code: "70729",

    ste_name: "LA",
  },
  {
    zip_code: "70733",

    ste_name: "LA",
  },
  {
    zip_code: "70754",

    ste_name: "LA",
  },
  {
    zip_code: "70773",

    ste_name: "LA",
  },
  {
    zip_code: "70777",

    ste_name: "LA",
  },
  {
    zip_code: "70816",

    ste_name: "LA",
  },
  {
    zip_code: "71019",

    ste_name: "LA",
  },
  {
    zip_code: "71049",

    ste_name: "LA",
  },
  {
    zip_code: "71316",

    ste_name: "LA",
  },
  {
    zip_code: "71414",

    ste_name: "LA",
  },
  {
    zip_code: "71466",

    ste_name: "LA",
  },
  {
    zip_code: "71483",

    ste_name: "LA",
  },
  {
    zip_code: "71486",

    ste_name: "LA",
  },
  {
    zip_code: "71747",

    ste_name: "AR",
  },
  {
    zip_code: "71853",

    ste_name: "AR",
  },
  {
    zip_code: "71861",

    ste_name: "AR",
  },
  {
    zip_code: "72021",

    ste_name: "AR",
  },
  {
    zip_code: "72079",

    ste_name: "AR",
  },
  {
    zip_code: "72122",

    ste_name: "AR",
  },
  {
    zip_code: "72135",

    ste_name: "AR",
  },
  {
    zip_code: "72140",

    ste_name: "AR",
  },
  {
    zip_code: "72150",

    ste_name: "AR",
  },
  {
    zip_code: "72321",

    ste_name: "AR",
  },
  {
    zip_code: "72333",

    ste_name: "AR",
  },
  {
    zip_code: "72412",

    ste_name: "AR",
  },
  {
    zip_code: "72527",

    ste_name: "AR",
  },
  {
    zip_code: "72617",

    ste_name: "AR",
  },
  {
    zip_code: "72619",

    ste_name: "AR",
  },
  {
    zip_code: "72648",

    ste_name: "AR",
  },
  {
    zip_code: "72677",

    ste_name: "AR",
  },
  {
    zip_code: "72827",

    ste_name: "AR",
  },
  {
    zip_code: "73047",

    ste_name: "OK",
  },
  {
    zip_code: "73115",

    ste_name: "OK",
  },
  {
    zip_code: "73526",

    ste_name: "OK",
  },
  {
    zip_code: "73538",

    ste_name: "OK",
  },
  {
    zip_code: "73539",

    ste_name: "OK",
  },
  {
    zip_code: "73543",

    ste_name: "OK",
  },
  {
    zip_code: "73547",

    ste_name: "OK",
  },
  {
    zip_code: "73548",

    ste_name: "OK",
  },
  {
    zip_code: "73729",

    ste_name: "OK",
  },
  {
    zip_code: "74035",

    ste_name: "OK",
  },
  {
    zip_code: "74052",

    ste_name: "OK",
  },
  {
    zip_code: "74070",

    ste_name: "OK",
  },
  {
    zip_code: "74073",

    ste_name: "OK",
  },
  {
    zip_code: "74332",

    ste_name: "OK",
  },
  {
    zip_code: "74367",

    ste_name: "OK",
  },
  {
    zip_code: "74462",

    ste_name: "OK",
  },
  {
    zip_code: "74477",

    ste_name: "OK",
  },
  {
    zip_code: "74546",

    ste_name: "OK",
  },
  {
    zip_code: "74556",

    ste_name: "OK",
  },
  {
    zip_code: "74572",

    ste_name: "OK",
  },
  {
    zip_code: "74647",

    ste_name: "OK",
  },
  {
    zip_code: "74743",

    ste_name: "OK",
  },
  {
    zip_code: "74750",

    ste_name: "OK",
  },
  {
    zip_code: "74831",

    ste_name: "OK",
  },
  {
    zip_code: "74833",

    ste_name: "OK",
  },
  {
    zip_code: "74878",

    ste_name: "OK",
  },
  {
    zip_code: "74949",

    ste_name: "OK",
  },
  {
    zip_code: "74962",

    ste_name: "OK",
  },
  {
    zip_code: "75010",

    ste_name: "TX",
  },
  {
    zip_code: "75020",

    ste_name: "TX",
  },
  {
    zip_code: "75040",

    ste_name: "TX",
  },
  {
    zip_code: "75124",

    ste_name: "TX",
  },
  {
    zip_code: "75173",

    ste_name: "TX",
  },
  {
    zip_code: "75227",

    ste_name: "TX",
  },
  {
    zip_code: "75238",

    ste_name: "TX",
  },
  {
    zip_code: "75468",

    ste_name: "TX",
  },
  {
    zip_code: "75495",

    ste_name: "TX",
  },
  {
    zip_code: "75633",

    ste_name: "TX",
  },
  {
    zip_code: "75669",

    ste_name: "TX",
  },
  {
    zip_code: "75693",

    ste_name: "TX",
  },
  {
    zip_code: "75845",

    ste_name: "TX",
  },
  {
    zip_code: "75976",

    ste_name: "TX",
  },
  {
    zip_code: "75979",

    ste_name: "TX",
  },
  {
    zip_code: "76020",

    ste_name: "TX",
  },
  {
    zip_code: "76073",

    ste_name: "TX",
  },
  {
    zip_code: "76180",

    ste_name: "TX",
  },
  {
    zip_code: "76308",

    ste_name: "TX",
  },
  {
    zip_code: "76459",

    ste_name: "TX",
  },
  {
    zip_code: "76539",

    ste_name: "TX",
  },
  {
    zip_code: "76671",

    ste_name: "TX",
  },
  {
    zip_code: "76681",

    ste_name: "TX",
  },
  {
    zip_code: "76690",

    ste_name: "TX",
  },
  {
    zip_code: "76841",

    ste_name: "TX",
  },
  {
    zip_code: "77095",

    ste_name: "TX",
  },
  {
    zip_code: "77363",

    ste_name: "TX",
  },
  {
    zip_code: "77379",

    ste_name: "TX",
  },
  {
    zip_code: "77554",

    ste_name: "TX",
  },
  {
    zip_code: "77566",

    ste_name: "TX",
  },
  {
    zip_code: "77577",

    ste_name: "TX",
  },
  {
    zip_code: "77581",

    ste_name: "TX",
  },
  {
    zip_code: "77616",

    ste_name: "TX",
  },
  {
    zip_code: "77840",

    ste_name: "TX",
  },
  {
    zip_code: "77969",

    ste_name: "TX",
  },
  {
    zip_code: "78025",

    ste_name: "TX",
  },
  {
    zip_code: "78059",

    ste_name: "TX",
  },
  {
    zip_code: "78264",

    ste_name: "TX",
  },
  {
    zip_code: "78390",

    ste_name: "TX",
  },
  {
    zip_code: "78416",

    ste_name: "TX",
  },
  {
    zip_code: "78575",

    ste_name: "TX",
  },
  {
    zip_code: "78648",

    ste_name: "TX",
  },
  {
    zip_code: "78931",

    ste_name: "TX",
  },
  {
    zip_code: "78932",

    ste_name: "TX",
  },
  {
    zip_code: "78954",

    ste_name: "TX",
  },
  {
    zip_code: "79063",

    ste_name: "TX",
  },
  {
    zip_code: "79087",

    ste_name: "TX",
  },
  {
    zip_code: "79107",

    ste_name: "TX",
  },
  {
    zip_code: "79252",

    ste_name: "TX",
  },
  {
    zip_code: "79360",

    ste_name: "TX",
  },
  {
    zip_code: "79367",

    ste_name: "TX",
  },
  {
    zip_code: "79413",

    ste_name: "TX",
  },
  {
    zip_code: "79505",

    ste_name: "TX",
  },
  {
    zip_code: "79519",

    ste_name: "TX",
  },
  {
    zip_code: "79532",

    ste_name: "TX",
  },
  {
    zip_code: "79755",

    ste_name: "TX",
  },
  {
    zip_code: "79758",

    ste_name: "TX",
  },
  {
    zip_code: "79847",

    ste_name: "TX",
  },
  {
    zip_code: "79854",

    ste_name: "TX",
  },
  {
    zip_code: "79903",

    ste_name: "TX",
  },
  {
    zip_code: "80101",

    ste_name: "CO",
  },
  {
    zip_code: "80401",

    ste_name: "CO",
  },
  {
    zip_code: "80631",

    ste_name: "CO",
  },
  {
    zip_code: "80733",

    ste_name: "CO",
  },
  {
    zip_code: "80825",

    ste_name: "CO",
  },
  {
    zip_code: "80835",

    ste_name: "CO",
  },
  {
    zip_code: "80861",

    ste_name: "CO",
  },
  {
    zip_code: "80903",

    ste_name: "CO",
  },
  {
    zip_code: "80910",

    ste_name: "CO",
  },
  {
    zip_code: "80922",

    ste_name: "CO",
  },
  {
    zip_code: "81040",

    ste_name: "CO",
  },
  {
    zip_code: "81058",

    ste_name: "CO",
  },
  {
    zip_code: "81092",

    ste_name: "CO",
  },
  {
    zip_code: "81123",

    ste_name: "CO",
  },
  {
    zip_code: "81504",

    ste_name: "CO",
  },
  {
    zip_code: "82242",

    ste_name: "WY",
  },
  {
    zip_code: "82329",

    ste_name: "WY",
  },
  {
    zip_code: "82715",

    ste_name: "WY",
  },
  {
    zip_code: "83025",

    ste_name: "WY",
  },
  {
    zip_code: "83114",

    ste_name: "WY",
  },
  {
    zip_code: "83261",

    ste_name: "ID",
  },
  {
    zip_code: "83312",

    ste_name: "ID",
  },
  {
    zip_code: "83402",

    ste_name: "ID",
  },
  {
    zip_code: "83632",

    ste_name: "ID",
  },
  {
    zip_code: "83641",

    ste_name: "ID",
  },
  {
    zip_code: "83644",

    ste_name: "ID",
  },
  {
    zip_code: "83702",

    ste_name: "ID",
  },
  {
    zip_code: "83809",

    ste_name: "ID",
  },
  {
    zip_code: "83811",

    ste_name: "ID",
  },
  {
    zip_code: "83839",

    ste_name: "ID",
  },
  {
    zip_code: "83847",

    ste_name: "ID",
  },
  {
    zip_code: "83854",

    ste_name: "ID",
  },
  {
    zip_code: "83876",

    ste_name: "ID",
  },
  {
    zip_code: "84061",

    ste_name: "UT",
  },
  {
    zip_code: "84325",

    ste_name: "UT",
  },
  {
    zip_code: "84341",

    ste_name: "UT",
  },
  {
    zip_code: "84620",

    ste_name: "UT",
  },
  {
    zip_code: "84745",

    ste_name: "UT",
  },
  {
    zip_code: "84757",

    ste_name: "UT",
  },
  {
    zip_code: "85003",

    ste_name: "AZ",
  },
  {
    zip_code: "85128",

    ste_name: "AZ",
  },
  {
    zip_code: "85253",

    ste_name: "AZ",
  },
  {
    zip_code: "85298",

    ste_name: "AZ",
  },
  {
    zip_code: "85322",

    ste_name: "AZ",
  },
  {
    zip_code: "85326",

    ste_name: "AZ",
  },
  {
    zip_code: "85347",

    ste_name: "AZ",
  },
  {
    zip_code: "85501",

    ste_name: "AZ",
  },
  {
    zip_code: "85544",

    ste_name: "AZ",
  },
  {
    zip_code: "85606",

    ste_name: "AZ",
  },
  {
    zip_code: "85611",

    ste_name: "AZ",
  },
  {
    zip_code: "85741",

    ste_name: "AZ",
  },
  {
    zip_code: "85756",

    ste_name: "AZ",
  },
  {
    zip_code: "85923",

    ste_name: "AZ",
  },
  {
    zip_code: "85932",

    ste_name: "AZ",
  },
  {
    zip_code: "86313",

    ste_name: "AZ",
  },
  {
    zip_code: "86411",

    ste_name: "AZ",
  },
  {
    zip_code: "87031",

    ste_name: "NM",
  },
  {
    zip_code: "87116",

    ste_name: "NM",
  },
  {
    zip_code: "87421",

    ste_name: "NM",
  },
  {
    zip_code: "87564",

    ste_name: "NM",
  },
  {
    zip_code: "87830",

    ste_name: "NM",
  },
  {
    zip_code: "88027",

    ste_name: "NM",
  },
  {
    zip_code: "88314",

    ste_name: "NM",
  },
  {
    zip_code: "88353",

    ste_name: "NM",
  },
  {
    zip_code: "88415",

    ste_name: "NM",
  },
  {
    zip_code: "88426",

    ste_name: "NM",
  },
  {
    zip_code: "89107",

    ste_name: "NV",
  },
  {
    zip_code: "89147",

    ste_name: "NV",
  },
  {
    zip_code: "89403",

    ste_name: "NV",
  },
  {
    zip_code: "89440",

    ste_name: "NV",
  },
  {
    zip_code: "89510",

    ste_name: "NV",
  },
  {
    zip_code: "89511",

    ste_name: "NV",
  },
  {
    zip_code: "89823",

    ste_name: "NV",
  },
  {
    zip_code: "624",

    ste_name: "PR",
  },
  {
    zip_code: "667",

    ste_name: "PR",
  },
  {
    zip_code: "718",

    ste_name: "PR",
  },
  {
    zip_code: "727",

    ste_name: "PR",
  },
  {
    zip_code: "766",

    ste_name: "PR",
  },
  {
    zip_code: "794",

    ste_name: "PR",
  },
  {
    zip_code: "915",

    ste_name: "PR",
  },
  {
    zip_code: "918",

    ste_name: "PR",
  },
  {
    zip_code: "969",

    ste_name: "PR",
  },
  {
    zip_code: "1077",

    ste_name: "MA",
  },
  {
    zip_code: "1236",

    ste_name: "MA",
  },
  {
    zip_code: "1247",

    ste_name: "MA",
  },
  {
    zip_code: "1366",

    ste_name: "MA",
  },
  {
    zip_code: "1603",

    ste_name: "MA",
  },
  {
    zip_code: "1702",

    ste_name: "MA",
  },
  {
    zip_code: "1876",

    ste_name: "MA",
  },
  {
    zip_code: "2203",

    ste_name: "MA",
  },
  {
    zip_code: "2333",

    ste_name: "MA",
  },
  {
    zip_code: "2343",

    ste_name: "MA",
  },
  {
    zip_code: "2534",

    ste_name: "MA",
  },
  {
    zip_code: "2645",

    ste_name: "MA",
  },
  {
    zip_code: "2813",

    ste_name: "RI",
  },
  {
    zip_code: "2814",

    ste_name: "RI",
  },
  {
    zip_code: "2864",

    ste_name: "RI",
  },
  {
    zip_code: "2911",

    ste_name: "RI",
  },
  {
    zip_code: "3044",

    ste_name: "NH",
  },
  {
    zip_code: "3245",

    ste_name: "NH",
  },
  {
    zip_code: "3307",

    ste_name: "NH",
  },
  {
    zip_code: "3445",

    ste_name: "NH",
  },
  {
    zip_code: "3607",

    ste_name: "NH",
  },
  {
    zip_code: "3740",

    ste_name: "NH",
  },
  {
    zip_code: "3755",

    ste_name: "NH",
  },
  {
    zip_code: "4260",

    ste_name: "ME",
  },
  {
    zip_code: "4274",

    ste_name: "ME",
  },
  {
    zip_code: "4285",

    ste_name: "ME",
  },
  {
    zip_code: "4419",

    ste_name: "ME",
  },
  {
    zip_code: "4424",

    ste_name: "ME",
  },
  {
    zip_code: "4473",

    ste_name: "ME",
  },
  {
    zip_code: "4634",

    ste_name: "ME",
  },
  {
    zip_code: "4762",

    ste_name: "ME",
  },
  {
    zip_code: "4847",

    ste_name: "ME",
  },
  {
    zip_code: "4955",

    ste_name: "ME",
  },
  {
    zip_code: "4988",

    ste_name: "ME",
  },
  {
    zip_code: "5031",

    ste_name: "VT",
  },
  {
    zip_code: "5261",

    ste_name: "VT",
  },
  {
    zip_code: "5474",

    ste_name: "VT",
  },
  {
    zip_code: "5660",

    ste_name: "VT",
  },
  {
    zip_code: "5772",

    ste_name: "VT",
  },
  {
    zip_code: "5837",

    ste_name: "VT",
  },
  {
    zip_code: "5842",

    ste_name: "VT",
  },
  {
    zip_code: "5845",

    ste_name: "VT",
  },
  {
    zip_code: "5866",

    ste_name: "VT",
  },
  {
    zip_code: "6022",

    ste_name: "CT",
  },
  {
    zip_code: "6024",

    ste_name: "CT",
  },
  {
    zip_code: "6043",

    ste_name: "CT",
  },
  {
    zip_code: "6060",

    ste_name: "CT",
  },
  {
    zip_code: "6112",

    ste_name: "CT",
  },
  {
    zip_code: "6226",

    ste_name: "CT",
  },
  {
    zip_code: "6371",

    ste_name: "CT",
  },
  {
    zip_code: "6401",

    ste_name: "CT",
  },
  {
    zip_code: "6607",

    ste_name: "CT",
  },
  {
    zip_code: "6706",

    ste_name: "CT",
  },
  {
    zip_code: "6750",

    ste_name: "CT",
  },
  {
    zip_code: "6763",

    ste_name: "CT",
  },
  {
    zip_code: "6850",

    ste_name: "CT",
  },
  {
    zip_code: "7030",

    ste_name: "NJ",
  },
  {
    zip_code: "7104",

    ste_name: "NJ",
  },
  {
    zip_code: "7463",

    ste_name: "NJ",
  },
  {
    zip_code: "7501",

    ste_name: "NJ",
  },
  {
    zip_code: "7514",

    ste_name: "NJ",
  },
  {
    zip_code: "7976",

    ste_name: "NJ",
  },
  {
    zip_code: "8006",

    ste_name: "NJ",
  },
  {
    zip_code: "8217",

    ste_name: "NJ",
  },
  {
    zip_code: "8232",

    ste_name: "NJ",
  },
  {
    zip_code: "8244",

    ste_name: "NJ",
  },
  {
    zip_code: "8260",

    ste_name: "NJ",
  },
  {
    zip_code: "8840",

    ste_name: "NJ",
  },
  {
    zip_code: "10016",

    ste_name: "NY",
  },
  {
    zip_code: "10169",

    ste_name: "NY",
  },
  {
    zip_code: "10307",

    ste_name: "NY",
  },
  {
    zip_code: "10311",

    ste_name: "NY",
  },
  {
    zip_code: "10470",

    ste_name: "NY",
  },
  {
    zip_code: "10506",

    ste_name: "NY",
  },
  {
    zip_code: "10552",

    ste_name: "NY",
  },
  {
    zip_code: "10984",

    ste_name: "NY",
  },
  {
    zip_code: "10988",

    ste_name: "NY",
  },
  {
    zip_code: "10994",

    ste_name: "NY",
  },
  {
    zip_code: "11001",

    ste_name: "NY",
  },
  {
    zip_code: "11021",

    ste_name: "NY",
  },
  {
    zip_code: "11024",

    ste_name: "NY",
  },
  {
    zip_code: "11205",

    ste_name: "NY",
  },
  {
    zip_code: "11225",

    ste_name: "NY",
  },
  {
    zip_code: "11371",

    ste_name: "NY",
  },
  {
    zip_code: "11375",

    ste_name: "NY",
  },
  {
    zip_code: "11451",

    ste_name: "NY",
  },
  {
    zip_code: "11520",

    ste_name: "NY",
  },
  {
    zip_code: "11772",

    ste_name: "NY",
  },
  {
    zip_code: "11790",

    ste_name: "NY",
  },
  {
    zip_code: "11965",

    ste_name: "NY",
  },
  {
    zip_code: "11972",

    ste_name: "NY",
  },
  {
    zip_code: "11975",

    ste_name: "NY",
  },
  {
    zip_code: "12028",

    ste_name: "NY",
  },
  {
    zip_code: "12033",

    ste_name: "NY",
  },
  {
    zip_code: "12072",

    ste_name: "NY",
  },
  {
    zip_code: "12078",

    ste_name: "NY",
  },
  {
    zip_code: "12092",

    ste_name: "NY",
  },
  {
    zip_code: "12095",

    ste_name: "NY",
  },
  {
    zip_code: "12155",

    ste_name: "NY",
  },
  {
    zip_code: "12158",

    ste_name: "NY",
  },
  {
    zip_code: "12210",

    ste_name: "NY",
  },
  {
    zip_code: "12306",

    ste_name: "NY",
  },
  {
    zip_code: "12401",

    ste_name: "NY",
  },
  {
    zip_code: "12438",

    ste_name: "NY",
  },
  {
    zip_code: "12450",

    ste_name: "NY",
  },
  {
    zip_code: "12453",

    ste_name: "NY",
  },
  {
    zip_code: "12456",

    ste_name: "NY",
  },
  {
    zip_code: "12471",

    ste_name: "NY",
  },
  {
    zip_code: "12483",

    ste_name: "NY",
  },
  {
    zip_code: "12490",

    ste_name: "NY",
  },
  {
    zip_code: "12538",

    ste_name: "NY",
  },
  {
    zip_code: "12740",

    ste_name: "NY",
  },
  {
    zip_code: "12766",

    ste_name: "NY",
  },
  {
    zip_code: "12779",

    ste_name: "NY",
  },
  {
    zip_code: "12789",

    ste_name: "NY",
  },
  {
    zip_code: "12824",

    ste_name: "NY",
  },
  {
    zip_code: "12845",

    ste_name: "NY",
  },
  {
    zip_code: "12910",

    ste_name: "NY",
  },
  {
    zip_code: "12917",

    ste_name: "NY",
  },
  {
    zip_code: "12924",

    ste_name: "NY",
  },
  {
    zip_code: "12928",

    ste_name: "NY",
  },
  {
    zip_code: "12936",

    ste_name: "NY",
  },
  {
    zip_code: "13114",

    ste_name: "NY",
  },
  {
    zip_code: "13148",

    ste_name: "NY",
  },
  {
    zip_code: "13418",

    ste_name: "NY",
  },
  {
    zip_code: "13437",

    ste_name: "NY",
  },
  {
    zip_code: "13456",

    ste_name: "NY",
  },
  {
    zip_code: "13468",

    ste_name: "NY",
  },
  {
    zip_code: "13501",

    ste_name: "NY",
  },
  {
    zip_code: "13601",

    ste_name: "NY",
  },
  {
    zip_code: "13622",

    ste_name: "NY",
  },
  {
    zip_code: "13635",

    ste_name: "NY",
  },
  {
    zip_code: "13690",

    ste_name: "NY",
  },
  {
    zip_code: "13865",

    ste_name: "NY",
  },
  {
    zip_code: "14094",

    ste_name: "NY",
  },
  {
    zip_code: "14120",

    ste_name: "NY",
  },
  {
    zip_code: "14130",

    ste_name: "NY",
  },
  {
    zip_code: "14143",

    ste_name: "NY",
  },
  {
    zip_code: "14201",

    ste_name: "NY",
  },
  {
    zip_code: "14216",

    ste_name: "NY",
  },
  {
    zip_code: "14411",

    ste_name: "NY",
  },
  {
    zip_code: "14435",

    ste_name: "NY",
  },
  {
    zip_code: "14472",

    ste_name: "NY",
  },
  {
    zip_code: "14479",

    ste_name: "NY",
  },
  {
    zip_code: "14481",

    ste_name: "NY",
  },
  {
    zip_code: "14534",

    ste_name: "NY",
  },
  {
    zip_code: "14591",

    ste_name: "NY",
  },
  {
    zip_code: "14607",

    ste_name: "NY",
  },
  {
    zip_code: "14612",

    ste_name: "NY",
  },
  {
    zip_code: "14729",

    ste_name: "NY",
  },
  {
    zip_code: "14783",

    ste_name: "NY",
  },
  {
    zip_code: "14879",

    ste_name: "NY",
  },
  {
    zip_code: "15028",

    ste_name: "PA",
  },
  {
    zip_code: "15030",

    ste_name: "PA",
  },
  {
    zip_code: "15055",

    ste_name: "PA",
  },
  {
    zip_code: "15075",

    ste_name: "PA",
  },
  {
    zip_code: "15104",

    ste_name: "PA",
  },
  {
    zip_code: "15131",

    ste_name: "PA",
  },
  {
    zip_code: "15148",

    ste_name: "PA",
  },
  {
    zip_code: "15201",

    ste_name: "PA",
  },
  {
    zip_code: "15223",

    ste_name: "PA",
  },
  {
    zip_code: "15229",

    ste_name: "PA",
  },
  {
    zip_code: "15427",

    ste_name: "PA",
  },
  {
    zip_code: "15446",

    ste_name: "PA",
  },
  {
    zip_code: "15615",

    ste_name: "PA",
  },
  {
    zip_code: "15623",

    ste_name: "PA",
  },
  {
    zip_code: "15625",

    ste_name: "PA",
  },
  {
    zip_code: "15626",

    ste_name: "PA",
  },
  {
    zip_code: "15675",

    ste_name: "PA",
  },
  {
    zip_code: "15684",

    ste_name: "PA",
  },
  {
    zip_code: "15784",

    ste_name: "PA",
  },
  {
    zip_code: "16059",

    ste_name: "PA",
  },
  {
    zip_code: "16120",

    ste_name: "PA",
  },
  {
    zip_code: "16121",

    ste_name: "PA",
  },
  {
    zip_code: "16125",

    ste_name: "PA",
  },
  {
    zip_code: "16161",

    ste_name: "PA",
  },
  {
    zip_code: "16214",

    ste_name: "PA",
  },
  {
    zip_code: "16262",

    ste_name: "PA",
  },
  {
    zip_code: "16332",

    ste_name: "PA",
  },
  {
    zip_code: "16354",

    ste_name: "PA",
  },
  {
    zip_code: "16427",

    ste_name: "PA",
  },
  {
    zip_code: "16509",

    ste_name: "PA",
  },
  {
    zip_code: "16622",

    ste_name: "PA",
  },
  {
    zip_code: "16630",

    ste_name: "PA",
  },
  {
    zip_code: "16646",

    ste_name: "PA",
  },
  {
    zip_code: "16651",

    ste_name: "PA",
  },
  {
    zip_code: "16746",

    ste_name: "PA",
  },
  {
    zip_code: "16947",

    ste_name: "PA",
  },
  {
    zip_code: "16950",

    ste_name: "PA",
  },
  {
    zip_code: "17025",

    ste_name: "PA",
  },
  {
    zip_code: "17032",

    ste_name: "PA",
  },
  {
    zip_code: "17036",

    ste_name: "PA",
  },
  {
    zip_code: "17061",

    ste_name: "PA",
  },
  {
    zip_code: "17247",

    ste_name: "PA",
  },
  {
    zip_code: "17251",

    ste_name: "PA",
  },
  {
    zip_code: "17517",

    ste_name: "PA",
  },
  {
    zip_code: "17601",

    ste_name: "PA",
  },
  {
    zip_code: "17814",

    ste_name: "PA",
  },
  {
    zip_code: "17832",

    ste_name: "PA",
  },
  {
    zip_code: "17842",

    ste_name: "PA",
  },
  {
    zip_code: "17850",

    ste_name: "PA",
  },
  {
    zip_code: "17855",

    ste_name: "PA",
  },
  {
    zip_code: "17930",

    ste_name: "PA",
  },
  {
    zip_code: "18034",

    ste_name: "PA",
  },
  {
    zip_code: "18070",

    ste_name: "PA",
  },
  {
    zip_code: "18212",

    ste_name: "PA",
  },
  {
    zip_code: "18360",

    ste_name: "PA",
  },
  {
    zip_code: "18426",

    ste_name: "PA",
  },
  {
    zip_code: "18466",

    ste_name: "PA",
  },
  {
    zip_code: "18603",

    ste_name: "PA",
  },
  {
    zip_code: "18814",

    ste_name: "PA",
  },
  {
    zip_code: "18917",

    ste_name: "PA",
  },
  {
    zip_code: "18962",

    ste_name: "PA",
  },
  {
    zip_code: "19022",

    ste_name: "PA",
  },
  {
    zip_code: "19146",

    ste_name: "PA",
  },
  {
    zip_code: "19152",

    ste_name: "PA",
  },
  {
    zip_code: "19422",

    ste_name: "PA",
  },
  {
    zip_code: "19465",

    ste_name: "PA",
  },
  {
    zip_code: "19522",

    ste_name: "PA",
  },
  {
    zip_code: "19536",

    ste_name: "PA",
  },
  {
    zip_code: "19544",

    ste_name: "PA",
  },
  {
    zip_code: "19559",

    ste_name: "PA",
  },
  {
    zip_code: "19609",

    ste_name: "PA",
  },
  {
    zip_code: "19709",

    ste_name: "DE",
  },
  {
    zip_code: "20053",

    ste_name: "DC",
  },
  {
    zip_code: "20124",

    ste_name: "VA",
  },
  {
    zip_code: "20405",

    ste_name: "DC",
  },
  {
    zip_code: "20851",

    ste_name: "MD",
  },
  {
    zip_code: "20902",

    ste_name: "MD",
  },
  {
    zip_code: "21030",

    ste_name: "MD",
  },
  {
    zip_code: "21040",

    ste_name: "MD",
  },
  {
    zip_code: "21054",

    ste_name: "MD",
  },
  {
    zip_code: "21557",

    ste_name: "MD",
  },
  {
    zip_code: "21714",

    ste_name: "MD",
  },
  {
    zip_code: "21766",

    ste_name: "MD",
  },
  {
    zip_code: "21841",

    ste_name: "MD",
  },
  {
    zip_code: "22124",

    ste_name: "VA",
  },
  {
    zip_code: "22314",

    ste_name: "VA",
  },
  {
    zip_code: "22437",

    ste_name: "VA",
  },
  {
    zip_code: "22438",

    ste_name: "VA",
  },
  {
    zip_code: "23022",

    ste_name: "VA",
  },
  {
    zip_code: "23110",

    ste_name: "VA",
  },
  {
    zip_code: "23130",

    ste_name: "VA",
  },
  {
    zip_code: "23149",

    ste_name: "VA",
  },
  {
    zip_code: "23350",

    ste_name: "VA",
  },
  {
    zip_code: "23517",

    ste_name: "VA",
  },
  {
    zip_code: "23866",

    ste_name: "VA",
  },
  {
    zip_code: "23899",

    ste_name: "VA",
  },
  {
    zip_code: "24085",

    ste_name: "VA",
  },
  {
    zip_code: "24122",

    ste_name: "VA",
  },
  {
    zip_code: "24280",

    ste_name: "VA",
  },
  {
    zip_code: "24324",

    ste_name: "VA",
  },
  {
    zip_code: "24363",

    ste_name: "VA",
  },
  {
    zip_code: "24502",

    ste_name: "VA",
  },
  {
    zip_code: "24570",

    ste_name: "VA",
  },
  {
    zip_code: "24612",

    ste_name: "VA",
  },
  {
    zip_code: "24850",

    ste_name: "WV",
  },
  {
    zip_code: "24854",

    ste_name: "WV",
  },
  {
    zip_code: "25002",

    ste_name: "WV",
  },
  {
    zip_code: "25112",

    ste_name: "WV",
  },
  {
    zip_code: "25181",

    ste_name: "WV",
  },
  {
    zip_code: "25241",

    ste_name: "WV",
  },
  {
    zip_code: "25265",

    ste_name: "WV",
  },
  {
    zip_code: "25303",

    ste_name: "WV",
  },
  {
    zip_code: "25529",

    ste_name: "WV",
  },
  {
    zip_code: "25653",

    ste_name: "WV",
  },
  {
    zip_code: "25678",

    ste_name: "WV",
  },
  {
    zip_code: "25826",

    ste_name: "WV",
  },
  {
    zip_code: "25827",

    ste_name: "WV",
  },
  {
    zip_code: "26141",

    ste_name: "WV",
  },
  {
    zip_code: "26149",

    ste_name: "WV",
  },
  {
    zip_code: "26330",

    ste_name: "WV",
  },
  {
    zip_code: "26335",

    ste_name: "WV",
  },
  {
    zip_code: "26342",

    ste_name: "WV",
  },
  {
    zip_code: "26411",

    ste_name: "WV",
  },
  {
    zip_code: "26615",

    ste_name: "WV",
  },
  {
    zip_code: "26705",

    ste_name: "WV",
  },
  {
    zip_code: "26714",

    ste_name: "WV",
  },
  {
    zip_code: "26757",

    ste_name: "WV",
  },
  {
    zip_code: "26852",

    ste_name: "WV",
  },
  {
    zip_code: "26866",

    ste_name: "WV",
  },
  {
    zip_code: "27043",

    ste_name: "NC",
  },
  {
    zip_code: "27203",

    ste_name: "NC",
  },
  {
    zip_code: "27311",

    ste_name: "NC",
  },
  {
    zip_code: "27344",

    ste_name: "NC",
  },
  {
    zip_code: "27409",

    ste_name: "NC",
  },
  {
    zip_code: "27455",

    ste_name: "NC",
  },
  {
    zip_code: "27513",

    ste_name: "NC",
  },
  {
    zip_code: "27514",

    ste_name: "NC",
  },
  {
    zip_code: "27560",

    ste_name: "NC",
  },
  {
    zip_code: "27808",

    ste_name: "NC",
  },
  {
    zip_code: "27813",

    ste_name: "NC",
  },
  {
    zip_code: "27825",

    ste_name: "NC",
  },
  {
    zip_code: "27830",

    ste_name: "NC",
  },
  {
    zip_code: "27840",

    ste_name: "NC",
  },
  {
    zip_code: "27843",

    ste_name: "NC",
  },
  {
    zip_code: "27865",

    ste_name: "NC",
  },
  {
    zip_code: "27871",

    ste_name: "NC",
  },
  {
    zip_code: "27882",

    ste_name: "NC",
  },
  {
    zip_code: "28092",

    ste_name: "NC",
  },
  {
    zip_code: "28202",

    ste_name: "NC",
  },
  {
    zip_code: "28244",

    ste_name: "NC",
  },
  {
    zip_code: "28282",

    ste_name: "NC",
  },
  {
    zip_code: "28342",

    ste_name: "NC",
  },
  {
    zip_code: "28352",

    ste_name: "NC",
  },
  {
    zip_code: "28395",

    ste_name: "NC",
  },
  {
    zip_code: "28432",

    ste_name: "NC",
  },
  {
    zip_code: "28441",

    ste_name: "NC",
  },
  {
    zip_code: "28442",

    ste_name: "NC",
  },
  {
    zip_code: "28501",

    ste_name: "NC",
  },
  {
    zip_code: "28523",

    ste_name: "NC",
  },
  {
    zip_code: "28644",

    ste_name: "NC",
  },
  {
    zip_code: "28708",

    ste_name: "NC",
  },
  {
    zip_code: "28729",

    ste_name: "NC",
  },
  {
    zip_code: "28766",

    ste_name: "NC",
  },
  {
    zip_code: "29178",

    ste_name: "SC",
  },
  {
    zip_code: "29338",

    ste_name: "SC",
  },
  {
    zip_code: "29349",

    ste_name: "SC",
  },
  {
    zip_code: "29575",

    ste_name: "SC",
  },
  {
    zip_code: "29584",

    ste_name: "SC",
  },
  {
    zip_code: "29742",

    ste_name: "SC",
  },
  {
    zip_code: "29745",

    ste_name: "SC",
  },
  {
    zip_code: "29801",

    ste_name: "SC",
  },
  {
    zip_code: "29838",

    ste_name: "SC",
  },
  {
    zip_code: "29850",

    ste_name: "SC",
  },
  {
    zip_code: "29940",

    ste_name: "SC",
  },
  {
    zip_code: "30011",

    ste_name: "GA",
  },
  {
    zip_code: "30013",

    ste_name: "GA",
  },
  {
    zip_code: "30152",

    ste_name: "GA",
  },
  {
    zip_code: "30184",

    ste_name: "GA",
  },
  {
    zip_code: "30240",

    ste_name: "GA",
  },
  {
    zip_code: "30289",

    ste_name: "GA",
  },
  {
    zip_code: "30312",

    ste_name: "GA",
  },
  {
    zip_code: "30349",

    ste_name: "GA",
  },
  {
    zip_code: "31050",

    ste_name: "GA",
  },
  {
    zip_code: "31089",

    ste_name: "GA",
  },
  {
    zip_code: "31303",

    ste_name: "GA",
  },
  {
    zip_code: "31406",

    ste_name: "GA",
  },
  {
    zip_code: "31407",

    ste_name: "GA",
  },
  {
    zip_code: "31503",

    ste_name: "GA",
  },
  {
    zip_code: "31525",

    ste_name: "GA",
  },
  {
    zip_code: "31554",

    ste_name: "GA",
  },
  {
    zip_code: "31743",

    ste_name: "GA",
  },
  {
    zip_code: "32058",

    ste_name: "FL",
  },
  {
    zip_code: "32244",

    ste_name: "FL",
  },
  {
    zip_code: "32431",

    ste_name: "FL",
  },
  {
    zip_code: "32447",

    ste_name: "FL",
  },
  {
    zip_code: "32463",

    ste_name: "FL",
  },
  {
    zip_code: "32502",

    ste_name: "FL",
  },
  {
    zip_code: "32615",

    ste_name: "FL",
  },
  {
    zip_code: "32619",

    ste_name: "FL",
  },
  {
    zip_code: "33020",

    ste_name: "FL",
  },
  {
    zip_code: "33033",

    ste_name: "FL",
  },
  {
    zip_code: "33184",

    ste_name: "FL",
  },
  {
    zip_code: "33313",

    ste_name: "FL",
  },
  {
    zip_code: "33410",

    ste_name: "FL",
  },
  {
    zip_code: "33431",

    ste_name: "FL",
  },
  {
    zip_code: "33433",

    ste_name: "FL",
  },
  {
    zip_code: "33445",

    ste_name: "FL",
  },
  {
    zip_code: "33704",

    ste_name: "FL",
  },
  {
    zip_code: "33771",

    ste_name: "FL",
  },
  {
    zip_code: "33811",

    ste_name: "FL",
  },
  {
    zip_code: "33854",

    ste_name: "FL",
  },
  {
    zip_code: "33867",

    ste_name: "FL",
  },
  {
    zip_code: "33956",

    ste_name: "FL",
  },
  {
    zip_code: "33960",

    ste_name: "FL",
  },
  {
    zip_code: "34137",

    ste_name: "FL",
  },
  {
    zip_code: "34228",

    ste_name: "FL",
  },
  {
    zip_code: "34432",

    ste_name: "FL",
  },
  {
    zip_code: "34448",

    ste_name: "FL",
  },
  {
    zip_code: "34450",

    ste_name: "FL",
  },
  {
    zip_code: "34482",

    ste_name: "FL",
  },
  {
    zip_code: "35034",

    ste_name: "AL",
  },
  {
    zip_code: "35071",

    ste_name: "AL",
  },
  {
    zip_code: "35244",

    ste_name: "AL",
  },
  {
    zip_code: "35401",

    ste_name: "AL",
  },
  {
    zip_code: "35443",

    ste_name: "AL",
  },
  {
    zip_code: "35650",

    ste_name: "AL",
  },
  {
    zip_code: "35673",

    ste_name: "AL",
  },
  {
    zip_code: "35674",

    ste_name: "AL",
  },
  {
    zip_code: "35774",

    ste_name: "AL",
  },
  {
    zip_code: "36039",

    ste_name: "AL",
  },
  {
    zip_code: "36052",

    ste_name: "AL",
  },
  {
    zip_code: "36206",

    ste_name: "AL",
  },
  {
    zip_code: "36511",

    ste_name: "AL",
  },
  {
    zip_code: "36513",

    ste_name: "AL",
  },
  {
    zip_code: "36542",

    ste_name: "AL",
  },
  {
    zip_code: "36576",

    ste_name: "AL",
  },
  {
    zip_code: "36619",

    ste_name: "AL",
  },
  {
    zip_code: "36732",

    ste_name: "AL",
  },
  {
    zip_code: "36853",

    ste_name: "AL",
  },
  {
    zip_code: "36866",

    ste_name: "AL",
  },
  {
    zip_code: "37047",

    ste_name: "TN",
  },
  {
    zip_code: "37171",

    ste_name: "TN",
  },
  {
    zip_code: "37187",

    ste_name: "TN",
  },
  {
    zip_code: "37219",

    ste_name: "TN",
  },
  {
    zip_code: "37656",

    ste_name: "TN",
  },
  {
    zip_code: "37659",

    ste_name: "TN",
  },
  {
    zip_code: "37724",

    ste_name: "TN",
  },
  {
    zip_code: "37725",

    ste_name: "TN",
  },
  {
    zip_code: "37755",

    ste_name: "TN",
  },
  {
    zip_code: "37809",

    ste_name: "TN",
  },
  {
    zip_code: "37820",

    ste_name: "TN",
  },
  {
    zip_code: "37886",

    ste_name: "TN",
  },
  {
    zip_code: "38018",

    ste_name: "TN",
  },
  {
    zip_code: "38019",

    ste_name: "TN",
  },
  {
    zip_code: "38122",

    ste_name: "TN",
  },
  {
    zip_code: "38128",

    ste_name: "TN",
  },
  {
    zip_code: "38138",

    ste_name: "TN",
  },
  {
    zip_code: "38258",

    ste_name: "TN",
  },
  {
    zip_code: "38330",

    ste_name: "TN",
  },
  {
    zip_code: "38358",

    ste_name: "TN",
  },
  {
    zip_code: "38368",

    ste_name: "TN",
  },
  {
    zip_code: "38455",

    ste_name: "TN",
  },
  {
    zip_code: "38501",

    ste_name: "TN",
  },
  {
    zip_code: "38555",

    ste_name: "TN",
  },
  {
    zip_code: "38559",

    ste_name: "TN",
  },
  {
    zip_code: "38568",

    ste_name: "TN",
  },
  {
    zip_code: "38569",

    ste_name: "TN",
  },
  {
    zip_code: "38760",

    ste_name: "MS",
  },
  {
    zip_code: "38855",

    ste_name: "MS",
  },
  {
    zip_code: "39067",

    ste_name: "MS",
  },
  {
    zip_code: "39096",

    ste_name: "MS",
  },
  {
    zip_code: "39110",

    ste_name: "MS",
  },
  {
    zip_code: "39203",

    ste_name: "MS",
  },
  {
    zip_code: "39428",

    ste_name: "MS",
  },
  {
    zip_code: "39534",

    ste_name: "MS",
  },
  {
    zip_code: "39633",

    ste_name: "MS",
  },
  {
    zip_code: "39766",

    ste_name: "MS",
  },
  {
    zip_code: "40023",

    ste_name: "KY",
  },
  {
    zip_code: "40036",

    ste_name: "KY",
  },
  {
    zip_code: "40068",

    ste_name: "KY",
  },
  {
    zip_code: "40119",

    ste_name: "KY",
  },
  {
    zip_code: "40216",

    ste_name: "KY",
  },
  {
    zip_code: "40402",

    ste_name: "KY",
  },
  {
    zip_code: "40506",

    ste_name: "KY",
  },
  {
    zip_code: "40740",

    ste_name: "KY",
  },
  {
    zip_code: "40769",

    ste_name: "KY",
  },
  {
    zip_code: "41004",

    ste_name: "KY",
  },
  {
    zip_code: "41015",

    ste_name: "KY",
  },
  {
    zip_code: "41033",

    ste_name: "KY",
  },
  {
    zip_code: "41083",

    ste_name: "KY",
  },
  {
    zip_code: "41092",

    ste_name: "KY",
  },
  {
    zip_code: "41255",

    ste_name: "KY",
  },
  {
    zip_code: "41314",

    ste_name: "KY",
  },
  {
    zip_code: "41348",

    ste_name: "KY",
  },
  {
    zip_code: "41408",

    ste_name: "KY",
  },
  {
    zip_code: "41421",

    ste_name: "KY",
  },
  {
    zip_code: "41527",

    ste_name: "KY",
  },
  {
    zip_code: "41562",

    ste_name: "KY",
  },
  {
    zip_code: "41568",

    ste_name: "KY",
  },
  {
    zip_code: "41666",

    ste_name: "KY",
  },
  {
    zip_code: "41764",

    ste_name: "KY",
  },
  {
    zip_code: "41825",

    ste_name: "KY",
  },
  {
    zip_code: "41847",

    ste_name: "KY",
  },
  {
    zip_code: "42001",

    ste_name: "KY",
  },
  {
    zip_code: "42049",

    ste_name: "KY",
  },
  {
    zip_code: "42064",

    ste_name: "KY",
  },
  {
    zip_code: "42442",

    ste_name: "KY",
  },
  {
    zip_code: "42455",

    ste_name: "KY",
  },
  {
    zip_code: "42712",

    ste_name: "KY",
  },
  {
    zip_code: "42749",

    ste_name: "KY",
  },
  {
    zip_code: "43055",

    ste_name: "OH",
  },
  {
    zip_code: "43146",

    ste_name: "OH",
  },
  {
    zip_code: "43149",

    ste_name: "OH",
  },
  {
    zip_code: "43209",

    ste_name: "OH",
  },
  {
    zip_code: "43220",

    ste_name: "OH",
  },
  {
    zip_code: "43437",

    ste_name: "OH",
  },
  {
    zip_code: "43540",

    ste_name: "OH",
  },
  {
    zip_code: "43607",

    ste_name: "OH",
  },
  {
    zip_code: "43610",

    ste_name: "OH",
  },
  {
    zip_code: "43619",

    ste_name: "OH",
  },
  {
    zip_code: "43718",

    ste_name: "OH",
  },
  {
    zip_code: "43727",

    ste_name: "OH",
  },
  {
    zip_code: "43759",

    ste_name: "OH",
  },
  {
    zip_code: "43901",

    ste_name: "OH",
  },
  {
    zip_code: "44023",

    ste_name: "OH",
  },
  {
    zip_code: "44048",

    ste_name: "OH",
  },
  {
    zip_code: "44065",

    ste_name: "OH",
  },
  {
    zip_code: "44070",

    ste_name: "OH",
  },
  {
    zip_code: "44099",

    ste_name: "OH",
  },
  {
    zip_code: "44202",

    ste_name: "OH",
  },
  {
    zip_code: "44231",

    ste_name: "OH",
  },
  {
    zip_code: "44234",

    ste_name: "OH",
  },
  {
    zip_code: "44254",

    ste_name: "OH",
  },
  {
    zip_code: "44286",

    ste_name: "OH",
  },
  {
    zip_code: "44427",

    ste_name: "OH",
  },
  {
    zip_code: "44444",

    ste_name: "OH",
  },
  {
    zip_code: "44505",

    ste_name: "OH",
  },
  {
    zip_code: "44611",

    ste_name: "OH",
  },
  {
    zip_code: "44612",

    ste_name: "OH",
  },
  {
    zip_code: "44693",

    ste_name: "OH",
  },
  {
    zip_code: "44730",

    ste_name: "OH",
  },
  {
    zip_code: "44809",

    ste_name: "OH",
  },
  {
    zip_code: "44830",

    ste_name: "OH",
  },
  {
    zip_code: "45005",

    ste_name: "OH",
  },
  {
    zip_code: "45065",

    ste_name: "OH",
  },
  {
    zip_code: "45133",

    ste_name: "OH",
  },
  {
    zip_code: "45167",

    ste_name: "OH",
  },
  {
    zip_code: "45202",

    ste_name: "OH",
  },
  {
    zip_code: "45251",

    ste_name: "OH",
  },
  {
    zip_code: "45647",

    ste_name: "OH",
  },
  {
    zip_code: "45656",

    ste_name: "OH",
  },
  {
    zip_code: "45658",

    ste_name: "OH",
  },
  {
    zip_code: "45853",

    ste_name: "OH",
  },
  {
    zip_code: "46011",

    ste_name: "IN",
  },
  {
    zip_code: "46063",

    ste_name: "IN",
  },
  {
    zip_code: "46123",

    ste_name: "IN",
  },
  {
    zip_code: "46151",

    ste_name: "IN",
  },
  {
    zip_code: "46201",

    ste_name: "IN",
  },
  {
    zip_code: "46408",

    ste_name: "IN",
  },
  {
    zip_code: "46510",

    ste_name: "IN",
  },
  {
    zip_code: "46514",

    ste_name: "IN",
  },
  {
    zip_code: "46613",

    ste_name: "IN",
  },
  {
    zip_code: "46703",

    ste_name: "IN",
  },
  {
    zip_code: "46706",

    ste_name: "IN",
  },
  {
    zip_code: "46759",

    ste_name: "IN",
  },
  {
    zip_code: "46936",

    ste_name: "IN",
  },
  {
    zip_code: "46959",

    ste_name: "IN",
  },
  {
    zip_code: "47034",

    ste_name: "IN",
  },
  {
    zip_code: "47122",

    ste_name: "IN",
  },
  {
    zip_code: "47161",

    ste_name: "IN",
  },
  {
    zip_code: "47165",

    ste_name: "IN",
  },
  {
    zip_code: "47341",

    ste_name: "IN",
  },
  {
    zip_code: "47351",

    ste_name: "IN",
  },
  {
    zip_code: "47358",

    ste_name: "IN",
  },
  {
    zip_code: "47369",

    ste_name: "IN",
  },
  {
    zip_code: "47388",

    ste_name: "IN",
  },
  {
    zip_code: "47460",

    ste_name: "IN",
  },
  {
    zip_code: "47512",

    ste_name: "IN",
  },
  {
    zip_code: "47535",

    ste_name: "IN",
  },
  {
    zip_code: "47584",

    ste_name: "IN",
  },
  {
    zip_code: "47849",

    ste_name: "IN",
  },
  {
    zip_code: "48003",

    ste_name: "MI",
  },
  {
    zip_code: "48025",

    ste_name: "MI",
  },
  {
    zip_code: "48050",

    ste_name: "MI",
  },
  {
    zip_code: "48117",

    ste_name: "MI",
  },
  {
    zip_code: "48125",

    ste_name: "MI",
  },
  {
    zip_code: "48127",

    ste_name: "MI",
  },
  {
    zip_code: "48140",

    ste_name: "MI",
  },
  {
    zip_code: "48209",

    ste_name: "MI",
  },
  {
    zip_code: "48223",

    ste_name: "MI",
  },
  {
    zip_code: "48414",

    ste_name: "MI",
  },
  {
    zip_code: "48462",

    ste_name: "MI",
  },
  {
    zip_code: "48553",

    ste_name: "MI",
  },
  {
    zip_code: "48612",

    ste_name: "MI",
  },
  {
    zip_code: "48613",

    ste_name: "MI",
  },
  {
    zip_code: "48649",

    ste_name: "MI",
  },
  {
    zip_code: "48754",

    ste_name: "MI",
  },
  {
    zip_code: "48756",

    ste_name: "MI",
  },
  {
    zip_code: "48893",

    ste_name: "MI",
  },
  {
    zip_code: "49008",

    ste_name: "MI",
  },
  {
    zip_code: "49088",

    ste_name: "MI",
  },
  {
    zip_code: "49202",

    ste_name: "MI",
  },
  {
    zip_code: "49303",

    ste_name: "MI",
  },
  {
    zip_code: "49333",

    ste_name: "MI",
  },
  {
    zip_code: "49346",

    ste_name: "MI",
  },
  {
    zip_code: "49415",

    ste_name: "MI",
  },
  {
    zip_code: "49442",

    ste_name: "MI",
  },
  {
    zip_code: "49445",

    ste_name: "MI",
  },
  {
    zip_code: "49650",

    ste_name: "MI",
  },
  {
    zip_code: "49657",

    ste_name: "MI",
  },
  {
    zip_code: "49713",

    ste_name: "MI",
  },
  {
    zip_code: "49727",

    ste_name: "MI",
  },
  {
    zip_code: "49730",

    ste_name: "MI",
  },
  {
    zip_code: "49744",

    ste_name: "MI",
  },
  {
    zip_code: "49774",

    ste_name: "MI",
  },
  {
    zip_code: "49801",

    ste_name: "MI",
  },
  {
    zip_code: "49807",

    ste_name: "MI",
  },
  {
    zip_code: "49814",

    ste_name: "MI",
  },
  {
    zip_code: "49839",

    ste_name: "MI",
  },
  {
    zip_code: "49895",

    ste_name: "MI",
  },
  {
    zip_code: "50005",

    ste_name: "IA",
  },
  {
    zip_code: "50007",

    ste_name: "IA",
  },
  {
    zip_code: "50028",

    ste_name: "IA",
  },
  {
    zip_code: "50036",

    ste_name: "IA",
  },
  {
    zip_code: "50067",

    ste_name: "IA",
  },
  {
    zip_code: "50144",

    ste_name: "IA",
  },
  {
    zip_code: "50243",

    ste_name: "IA",
  },
  {
    zip_code: "50313",

    ste_name: "IA",
  },
  {
    zip_code: "50465",

    ste_name: "IA",
  },
  {
    zip_code: "50501",

    ste_name: "IA",
  },
  {
    zip_code: "50607",

    ste_name: "IA",
  },
  {
    zip_code: "50638",

    ste_name: "IA",
  },
  {
    zip_code: "50664",

    ste_name: "IA",
  },
  {
    zip_code: "50841",

    ste_name: "IA",
  },
  {
    zip_code: "50861",

    ste_name: "IA",
  },
  {
    zip_code: "51022",

    ste_name: "IA",
  },
  {
    zip_code: "51046",

    ste_name: "IA",
  },
  {
    zip_code: "51049",

    ste_name: "IA",
  },
  {
    zip_code: "51108",

    ste_name: "IA",
  },
  {
    zip_code: "51234",

    ste_name: "IA",
  },
  {
    zip_code: "51241",

    ste_name: "IA",
  },
  {
    zip_code: "51342",

    ste_name: "IA",
  },
  {
    zip_code: "51431",

    ste_name: "IA",
  },
  {
    zip_code: "51441",

    ste_name: "IA",
  },
  {
    zip_code: "51451",

    ste_name: "IA",
  },
  {
    zip_code: "51453",

    ste_name: "IA",
  },
  {
    zip_code: "51465",

    ste_name: "IA",
  },
  {
    zip_code: "52001",

    ste_name: "IA",
  },
  {
    zip_code: "52060",

    ste_name: "IA",
  },
  {
    zip_code: "52134",

    ste_name: "IA",
  },
  {
    zip_code: "52240",

    ste_name: "IA",
  },
  {
    zip_code: "52253",

    ste_name: "IA",
  },
  {
    zip_code: "52330",

    ste_name: "IA",
  },
  {
    zip_code: "52530",

    ste_name: "IA",
  },
  {
    zip_code: "52548",

    ste_name: "IA",
  },
  {
    zip_code: "52742",

    ste_name: "IA",
  },
  {
    zip_code: "52804",

    ste_name: "IA",
  },
  {
    zip_code: "53006",

    ste_name: "WI",
  },
  {
    zip_code: "53011",

    ste_name: "WI",
  },
  {
    zip_code: "53017",

    ste_name: "WI",
  },
  {
    zip_code: "53063",

    ste_name: "WI",
  },
  {
    zip_code: "53081",

    ste_name: "WI",
  },
  {
    zip_code: "53086",

    ste_name: "WI",
  },
  {
    zip_code: "53126",

    ste_name: "WI",
  },
  {
    zip_code: "53140",

    ste_name: "WI",
  },
  {
    zip_code: "53205",

    ste_name: "WI",
  },
  {
    zip_code: "53215",

    ste_name: "WI",
  },
  {
    zip_code: "53508",

    ste_name: "WI",
  },
  {
    zip_code: "53554",

    ste_name: "WI",
  },
  {
    zip_code: "53590",

    ste_name: "WI",
  },
  {
    zip_code: "53705",

    ste_name: "WI",
  },
  {
    zip_code: "53920",

    ste_name: "WI",
  },
  {
    zip_code: "54013",

    ste_name: "WI",
  },
  {
    zip_code: "54021",

    ste_name: "WI",
  },
  {
    zip_code: "54102",

    ste_name: "WI",
  },
  {
    zip_code: "54112",

    ste_name: "WI",
  },
  {
    zip_code: "54140",

    ste_name: "WI",
  },
  {
    zip_code: "54175",

    ste_name: "WI",
  },
  {
    zip_code: "54484",

    ste_name: "WI",
  },
  {
    zip_code: "54499",

    ste_name: "WI",
  },
  {
    zip_code: "54614",

    ste_name: "WI",
  },
  {
    zip_code: "54648",

    ste_name: "WI",
  },
  {
    zip_code: "54701",

    ste_name: "WI",
  },
  {
    zip_code: "54731",

    ste_name: "WI",
  },
  {
    zip_code: "54755",

    ste_name: "WI",
  },
  {
    zip_code: "54843",

    ste_name: "WI",
  },
  {
    zip_code: "54944",

    ste_name: "WI",
  },
  {
    zip_code: "54949",

    ste_name: "WI",
  },
  {
    zip_code: "54982",

    ste_name: "WI",
  },
  {
    zip_code: "55025",

    ste_name: "MN",
  },
  {
    zip_code: "55026",

    ste_name: "MN",
  },
  {
    zip_code: "55045",

    ste_name: "MN",
  },
  {
    zip_code: "55066",

    ste_name: "MN",
  },
  {
    zip_code: "55090",

    ste_name: "MN",
  },
  {
    zip_code: "55101",

    ste_name: "MN",
  },
  {
    zip_code: "55308",

    ste_name: "MN",
  },
  {
    zip_code: "55318",

    ste_name: "MN",
  },
  {
    zip_code: "55320",

    ste_name: "MN",
  },
  {
    zip_code: "55345",

    ste_name: "MN",
  },
  {
    zip_code: "55424",

    ste_name: "MN",
  },
  {
    zip_code: "55448",

    ste_name: "MN",
  },
  {
    zip_code: "55711",

    ste_name: "MN",
  },
  {
    zip_code: "55742",

    ste_name: "MN",
  },
  {
    zip_code: "55905",

    ste_name: "MN",
  },
  {
    zip_code: "55920",

    ste_name: "MN",
  },
  {
    zip_code: "55965",

    ste_name: "MN",
  },
  {
    zip_code: "55974",

    ste_name: "MN",
  },
  {
    zip_code: "56010",

    ste_name: "MN",
  },
  {
    zip_code: "56052",

    ste_name: "MN",
  },
  {
    zip_code: "56080",

    ste_name: "MN",
  },
  {
    zip_code: "56123",

    ste_name: "MN",
  },
  {
    zip_code: "56138",

    ste_name: "MN",
  },
  {
    zip_code: "56165",

    ste_name: "MN",
  },
  {
    zip_code: "56173",

    ste_name: "MN",
  },
  {
    zip_code: "56178",

    ste_name: "MN",
  },
  {
    zip_code: "56239",

    ste_name: "MN",
  },
  {
    zip_code: "56253",

    ste_name: "MN",
  },
  {
    zip_code: "56276",

    ste_name: "MN",
  },
  {
    zip_code: "56278",

    ste_name: "MN",
  },
  {
    zip_code: "56291",

    ste_name: "MN",
  },
  {
    zip_code: "56357",

    ste_name: "MN",
  },
  {
    zip_code: "56367",

    ste_name: "MN",
  },
  {
    zip_code: "56440",

    ste_name: "MN",
  },
  {
    zip_code: "56447",

    ste_name: "MN",
  },
  {
    zip_code: "56453",

    ste_name: "MN",
  },
  {
    zip_code: "56568",

    ste_name: "MN",
  },
  {
    zip_code: "56584",

    ste_name: "MN",
  },
  {
    zip_code: "56672",

    ste_name: "MN",
  },
  {
    zip_code: "57047",

    ste_name: "SD",
  },
  {
    zip_code: "57059",

    ste_name: "SD",
  },
  {
    zip_code: "57103",

    ste_name: "SD",
  },
  {
    zip_code: "57232",

    ste_name: "SD",
  },
  {
    zip_code: "57337",

    ste_name: "SD",
  },
  {
    zip_code: "57569",

    ste_name: "SD",
  },
  {
    zip_code: "57622",

    ste_name: "SD",
  },
  {
    zip_code: "57750",

    ste_name: "SD",
  },
  {
    zip_code: "58013",

    ste_name: "ND",
  },
  {
    zip_code: "58051",

    ste_name: "ND",
  },
  {
    zip_code: "58081",

    ste_name: "ND",
  },
  {
    zip_code: "58492",

    ste_name: "ND",
  },
  {
    zip_code: "58626",

    ste_name: "ND",
  },
  {
    zip_code: "58643",

    ste_name: "ND",
  },
  {
    zip_code: "58702",

    ste_name: "ND",
  },
  {
    zip_code: "90007",

    ste_name: "CA",
  },
  {
    zip_code: "90017",

    ste_name: "CA",
  },
  {
    zip_code: "90019",

    ste_name: "CA",
  },
  {
    zip_code: "90063",

    ste_name: "CA",
  },
  {
    zip_code: "90222",

    ste_name: "CA",
  },
  {
    zip_code: "90603",

    ste_name: "CA",
  },
  {
    zip_code: "90630",

    ste_name: "CA",
  },
  {
    zip_code: "90638",

    ste_name: "CA",
  },
  {
    zip_code: "91377",

    ste_name: "CA",
  },
  {
    zip_code: "91761",

    ste_name: "CA",
  },
  {
    zip_code: "91767",

    ste_name: "CA",
  },
  {
    zip_code: "92058",

    ste_name: "CA",
  },
  {
    zip_code: "92061",

    ste_name: "CA",
  },
  {
    zip_code: "92109",

    ste_name: "CA",
  },
  {
    zip_code: "92129",

    ste_name: "CA",
  },
  {
    zip_code: "92147",

    ste_name: "CA",
  },
  {
    zip_code: "92243",

    ste_name: "CA",
  },
  {
    zip_code: "92274",

    ste_name: "CA",
  },
  {
    zip_code: "92320",

    ste_name: "CA",
  },
  {
    zip_code: "92372",

    ste_name: "CA",
  },
  {
    zip_code: "92563",

    ste_name: "CA",
  },
  {
    zip_code: "92606",

    ste_name: "CA",
  },
  {
    zip_code: "92882",

    ste_name: "CA",
  },
  {
    zip_code: "93013",

    ste_name: "CA",
  },
  {
    zip_code: "93030",

    ste_name: "CA",
  },
  {
    zip_code: "94566",

    ste_name: "CA",
  },
  {
    zip_code: "94587",

    ste_name: "CA",
  },
  {
    zip_code: "94612",

    ste_name: "CA",
  },
  {
    zip_code: "94925",

    ste_name: "CA",
  },
  {
    zip_code: "94940",

    ste_name: "CA",
  },
  {
    zip_code: "94973",

    ste_name: "CA",
  },
  {
    zip_code: "95013",

    ste_name: "CA",
  },
  {
    zip_code: "95319",

    ste_name: "CA",
  },
  {
    zip_code: "95321",

    ste_name: "CA",
  },
  {
    zip_code: "95326",

    ste_name: "CA",
  },
  {
    zip_code: "95457",

    ste_name: "CA",
  },
  {
    zip_code: "95490",

    ste_name: "CA",
  },
  {
    zip_code: "95493",

    ste_name: "CA",
  },
  {
    zip_code: "95503",

    ste_name: "CA",
  },
  {
    zip_code: "95542",

    ste_name: "CA",
  },
  {
    zip_code: "95603",

    ste_name: "CA",
  },
  {
    zip_code: "95607",

    ste_name: "CA",
  },
  {
    zip_code: "95616",

    ste_name: "CA",
  },
  {
    zip_code: "95683",

    ste_name: "CA",
  },
  {
    zip_code: "95695",

    ste_name: "CA",
  },
  {
    zip_code: "95701",

    ste_name: "CA",
  },
  {
    zip_code: "95724",

    ste_name: "CA",
  },
  {
    zip_code: "95946",

    ste_name: "CA",
  },
  {
    zip_code: "95966",

    ste_name: "CA",
  },
  {
    zip_code: "95982",

    ste_name: "CA",
  },
  {
    zip_code: "96019",

    ste_name: "CA",
  },
  {
    zip_code: "96048",

    ste_name: "CA",
  },
  {
    zip_code: "96051",

    ste_name: "CA",
  },
  {
    zip_code: "96096",

    ste_name: "CA",
  },
  {
    zip_code: "96141",

    ste_name: "CA",
  },
  {
    zip_code: "96148",

    ste_name: "CA",
  },
  {
    zip_code: "96759",

    ste_name: "HI",
  },
  {
    zip_code: "96795",

    ste_name: "HI",
  },
  {
    zip_code: "96814",

    ste_name: "HI",
  },
  {
    zip_code: "96859",

    ste_name: "HI",
  },
  {
    zip_code: "97004",

    ste_name: "OR",
  },
  {
    zip_code: "97005",

    ste_name: "OR",
  },
  {
    zip_code: "97033",

    ste_name: "OR",
  },
  {
    zip_code: "97110",

    ste_name: "OR",
  },
  {
    zip_code: "97135",

    ste_name: "OR",
  },
  {
    zip_code: "97361",

    ste_name: "OR",
  },
  {
    zip_code: "97423",

    ste_name: "OR",
  },
  {
    zip_code: "97499",

    ste_name: "OR",
  },
  {
    zip_code: "97623",

    ste_name: "OR",
  },
  {
    zip_code: "97638",

    ste_name: "OR",
  },
  {
    zip_code: "97720",

    ste_name: "OR",
  },
  {
    zip_code: "97738",

    ste_name: "OR",
  },
  {
    zip_code: "97828",

    ste_name: "OR",
  },
  {
    zip_code: "97839",

    ste_name: "OR",
  },
  {
    zip_code: "97864",

    ste_name: "OR",
  },
  {
    zip_code: "98032",

    ste_name: "WA",
  },
  {
    zip_code: "98034",

    ste_name: "WA",
  },
  {
    zip_code: "98133",

    ste_name: "WA",
  },
  {
    zip_code: "98146",

    ste_name: "WA",
  },
  {
    zip_code: "98253",

    ste_name: "WA",
  },
  {
    zip_code: "98310",

    ste_name: "WA",
  },
  {
    zip_code: "98338",

    ste_name: "WA",
  },
  {
    zip_code: "98345",

    ste_name: "WA",
  },
  {
    zip_code: "98373",

    ste_name: "WA",
  },
  {
    zip_code: "93268",

    ste_name: "CA",
  },
  {
    zip_code: "93440",

    ste_name: "CA",
  },
  {
    zip_code: "93526",

    ste_name: "CA",
  },
  {
    zip_code: "93555",

    ste_name: "CA",
  },
  {
    zip_code: "93960",

    ste_name: "CA",
  },
  {
    zip_code: "94021",

    ste_name: "CA",
  },
  {
    zip_code: "94025",

    ste_name: "CA",
  },
  {
    zip_code: "94060",

    ste_name: "CA",
  },
  {
    zip_code: "94121",

    ste_name: "CA",
  },
  {
    zip_code: "94305",

    ste_name: "CA",
  },
  {
    zip_code: "98377",

    ste_name: "WA",
  },
  {
    zip_code: "98388",

    ste_name: "WA",
  },
  {
    zip_code: "98390",

    ste_name: "WA",
  },
  {
    zip_code: "98407",

    ste_name: "WA",
  },
  {
    zip_code: "98586",

    ste_name: "WA",
  },
  {
    zip_code: "98635",

    ste_name: "WA",
  },
  {
    zip_code: "98650",

    ste_name: "WA",
  },
  {
    zip_code: "98685",

    ste_name: "WA",
  },
  {
    zip_code: "98850",

    ste_name: "WA",
  },
  {
    zip_code: "98925",

    ste_name: "WA",
  },
  {
    zip_code: "99017",

    ste_name: "WA",
  },
  {
    zip_code: "99040",

    ste_name: "WA",
  },
  {
    zip_code: "99114",

    ste_name: "WA",
  },
  {
    zip_code: "99121",

    ste_name: "WA",
  },
  {
    zip_code: "99149",

    ste_name: "WA",
  },
  {
    zip_code: "99154",

    ste_name: "WA",
  },
  {
    zip_code: "99354",

    ste_name: "WA",
  },
  {
    zip_code: "99357",

    ste_name: "WA",
  },
  {
    zip_code: "99577",

    ste_name: "AK",
  },
  {
    zip_code: "99647",

    ste_name: "AK",
  },
  {
    zip_code: "99653",

    ste_name: "AK",
  },
  {
    zip_code: "99683",

    ste_name: "AK",
  },
  {
    zip_code: "99685",

    ste_name: "AK",
  },
  {
    zip_code: "99702",

    ste_name: "AK",
  },
  {
    zip_code: "99776",

    ste_name: "AK",
  },
  {
    zip_code: "99925",

    ste_name: "AK",
  },
  {
    zip_code: "623",

    ste_name: "PR",
  },
  {
    zip_code: "791",

    ste_name: "PR",
  },
  {
    zip_code: "820",

    ste_name: "VI",
  },
  {
    zip_code: "840",

    ste_name: "VI",
  },
  {
    zip_code: "923",

    ste_name: "PR",
  },
  {
    zip_code: "1092",

    ste_name: "MA",
  },
  {
    zip_code: "1119",

    ste_name: "MA",
  },
  {
    zip_code: "1220",

    ste_name: "MA",
  },
  {
    zip_code: "1432",

    ste_name: "MA",
  },
  {
    zip_code: "1475",

    ste_name: "MA",
  },
  {
    zip_code: "1505",

    ste_name: "MA",
  },
  {
    zip_code: "1534",

    ste_name: "MA",
  },
  {
    zip_code: "1610",

    ste_name: "MA",
  },
  {
    zip_code: "1731",

    ste_name: "MA",
  },
  {
    zip_code: "1862",

    ste_name: "MA",
  },
  {
    zip_code: "1982",

    ste_name: "MA",
  },
  {
    zip_code: "2108",

    ste_name: "MA",
  },
  {
    zip_code: "2120",

    ste_name: "MA",
  },
  {
    zip_code: "2467",

    ste_name: "MA",
  },
  {
    zip_code: "2639",

    ste_name: "MA",
  },
  {
    zip_code: "2641",

    ste_name: "MA",
  },
  {
    zip_code: "2858",

    ste_name: "RI",
  },
  {
    zip_code: "2919",

    ste_name: "RI",
  },
  {
    zip_code: "3215",

    ste_name: "NH",
  },
  {
    zip_code: "3220",

    ste_name: "NH",
  },
  {
    zip_code: "3231",

    ste_name: "NH",
  },
  {
    zip_code: "3258",

    ste_name: "NH",
  },
  {
    zip_code: "3431",

    ste_name: "NH",
  },
  {
    zip_code: "3451",

    ste_name: "NH",
  },
  {
    zip_code: "3456",

    ste_name: "NH",
  },
  {
    zip_code: "3464",

    ste_name: "NH",
  },
  {
    zip_code: "3470",

    ste_name: "NH",
  },
  {
    zip_code: "3590",

    ste_name: "NH",
  },
  {
    zip_code: "3741",

    ste_name: "NH",
  },
  {
    zip_code: "3819",

    ste_name: "NH",
  },
  {
    zip_code: "4083",

    ste_name: "ME",
  },
  {
    zip_code: "4103",

    ste_name: "ME",
  },
  {
    zip_code: "4217",

    ste_name: "ME",
  },
  {
    zip_code: "4252",

    ste_name: "ME",
  },
  {
    zip_code: "4256",

    ste_name: "ME",
  },
  {
    zip_code: "4344",

    ste_name: "ME",
  },
  {
    zip_code: "4401",

    ste_name: "ME",
  },
  {
    zip_code: "4443",

    ste_name: "ME",
  },
  {
    zip_code: "4455",

    ste_name: "ME",
  },
  {
    zip_code: "4570",

    ste_name: "ME",
  },
  {
    zip_code: "4572",

    ste_name: "ME",
  },
  {
    zip_code: "4611",

    ste_name: "ME",
  },
  {
    zip_code: "4613",

    ste_name: "ME",
  },
  {
    zip_code: "4733",

    ste_name: "ME",
  },
  {
    zip_code: "4758",

    ste_name: "ME",
  },
  {
    zip_code: "4943",

    ste_name: "ME",
  },
  {
    zip_code: "4966",

    ste_name: "ME",
  },
  {
    zip_code: "5039",

    ste_name: "VT",
  },
  {
    zip_code: "5161",

    ste_name: "VT",
  },
  {
    zip_code: "5458",

    ste_name: "VT",
  },
  {
    zip_code: "5672",

    ste_name: "VT",
  },
  {
    zip_code: "5677",

    ste_name: "VT",
  },
  {
    zip_code: "5743",

    ste_name: "VT",
  },
  {
    zip_code: "5748",

    ste_name: "VT",
  },
  {
    zip_code: "5751",

    ste_name: "VT",
  },
  {
    zip_code: "5839",

    ste_name: "VT",
  },
  {
    zip_code: "6076",

    ste_name: "CT",
  },
  {
    zip_code: "6090",

    ste_name: "CT",
  },
  {
    zip_code: "6095",

    ste_name: "CT",
  },
  {
    zip_code: "6098",

    ste_name: "CT",
  },
  {
    zip_code: "6232",

    ste_name: "CT",
  },
  {
    zip_code: "6365",

    ste_name: "CT",
  },
  {
    zip_code: "6414",

    ste_name: "CT",
  },
  {
    zip_code: "6423",

    ste_name: "CT",
  },
  {
    zip_code: "6467",

    ste_name: "CT",
  },
  {
    zip_code: "7005",

    ste_name: "NJ",
  },
  {
    zip_code: "7022",

    ste_name: "NJ",
  },
  {
    zip_code: "7028",

    ste_name: "NJ",
  },
  {
    zip_code: "7033",

    ste_name: "NJ",
  },
  {
    zip_code: "7069",

    ste_name: "NJ",
  },
  {
    zip_code: "7108",

    ste_name: "NJ",
  },
  {
    zip_code: "7206",

    ste_name: "NJ",
  },
  {
    zip_code: "7416",

    ste_name: "NJ",
  },
  {
    zip_code: "7436",

    ste_name: "NJ",
  },
  {
    zip_code: "7450",

    ste_name: "NJ",
  },
  {
    zip_code: "7506",

    ste_name: "NJ",
  },
  {
    zip_code: "7628",

    ste_name: "NJ",
  },
  {
    zip_code: "7753",

    ste_name: "NJ",
  },
  {
    zip_code: "7882",

    ste_name: "NJ",
  },
  {
    zip_code: "7932",

    ste_name: "NJ",
  },
  {
    zip_code: "8011",

    ste_name: "NJ",
  },
  {
    zip_code: "8027",

    ste_name: "NJ",
  },
  {
    zip_code: "8049",

    ste_name: "NJ",
  },
  {
    zip_code: "8050",

    ste_name: "NJ",
  },
  {
    zip_code: "8060",

    ste_name: "NJ",
  },
  {
    zip_code: "8087",

    ste_name: "NJ",
  },
  {
    zip_code: "8107",

    ste_name: "NJ",
  },
  {
    zip_code: "8318",

    ste_name: "NJ",
  },
  {
    zip_code: "8341",

    ste_name: "NJ",
  },
  {
    zip_code: "8690",

    ste_name: "NJ",
  },
  {
    zip_code: "8731",

    ste_name: "NJ",
  },
  {
    zip_code: "8753",

    ste_name: "NJ",
  },
  {
    zip_code: "8802",

    ste_name: "NJ",
  },
  {
    zip_code: "8829",

    ste_name: "NJ",
  },
  {
    zip_code: "8902",

    ste_name: "NJ",
  },
  {
    zip_code: "10278",

    ste_name: "NY",
  },
  {
    zip_code: "10453",

    ste_name: "NY",
  },
  {
    zip_code: "10468",

    ste_name: "NY",
  },
  {
    zip_code: "10546",

    ste_name: "NY",
  },
  {
    zip_code: "10707",

    ste_name: "NY",
  },
  {
    zip_code: "10924",

    ste_name: "NY",
  },
  {
    zip_code: "11020",

    ste_name: "NY",
  },
  {
    zip_code: "11050",

    ste_name: "NY",
  },
  {
    zip_code: "11385",

    ste_name: "NY",
  },
  {
    zip_code: "11435",

    ste_name: "NY",
  },
  {
    zip_code: "11731",

    ste_name: "NY",
  },
  {
    zip_code: "11735",

    ste_name: "NY",
  },
  {
    zip_code: "11741",

    ste_name: "NY",
  },
  {
    zip_code: "11765",

    ste_name: "NY",
  },
  {
    zip_code: "11937",

    ste_name: "NY",
  },
  {
    zip_code: "11963",

    ste_name: "NY",
  },
  {
    zip_code: "11968",

    ste_name: "NY",
  },
  {
    zip_code: "11977",

    ste_name: "NY",
  },
  {
    zip_code: "11978",

    ste_name: "NY",
  },
  {
    zip_code: "12427",

    ste_name: "NY",
  },
  {
    zip_code: "12431",

    ste_name: "NY",
  },
  {
    zip_code: "12449",

    ste_name: "NY",
  },
  {
    zip_code: "12508",

    ste_name: "NY",
  },
  {
    zip_code: "12515",

    ste_name: "NY",
  },
  {
    zip_code: "12565",

    ste_name: "NY",
  },
  {
    zip_code: "12743",

    ste_name: "NY",
  },
  {
    zip_code: "12775",

    ste_name: "NY",
  },
  {
    zip_code: "12823",

    ste_name: "NY",
  },
  {
    zip_code: "13036",

    ste_name: "NY",
  },
  {
    zip_code: "13103",

    ste_name: "NY",
  },
  {
    zip_code: "13135",

    ste_name: "NY",
  },
  {
    zip_code: "13144",

    ste_name: "NY",
  },
  {
    zip_code: "13205",

    ste_name: "NY",
  },
  {
    zip_code: "13332",

    ste_name: "NY",
  },
  {
    zip_code: "13335",

    ste_name: "NY",
  },
  {
    zip_code: "13438",

    ste_name: "NY",
  },
  {
    zip_code: "13450",

    ste_name: "NY",
  },
  {
    zip_code: "13452",

    ste_name: "NY",
  },
  {
    zip_code: "13624",

    ste_name: "NY",
  },
  {
    zip_code: "13639",

    ste_name: "NY",
  },
  {
    zip_code: "13648",

    ste_name: "NY",
  },
  {
    zip_code: "13658",

    ste_name: "NY",
  },
  {
    zip_code: "13664",

    ste_name: "NY",
  },
  {
    zip_code: "13753",

    ste_name: "NY",
  },
  {
    zip_code: "13787",

    ste_name: "NY",
  },
  {
    zip_code: "14031",

    ste_name: "NY",
  },
  {
    zip_code: "14033",

    ste_name: "NY",
  },
  {
    zip_code: "14035",

    ste_name: "NY",
  },
  {
    zip_code: "14101",

    ste_name: "NY",
  },
  {
    zip_code: "14141",

    ste_name: "NY",
  },
  {
    zip_code: "14471",

    ste_name: "NY",
  },
  {
    zip_code: "14480",

    ste_name: "NY",
  },
  {
    zip_code: "14489",

    ste_name: "NY",
  },
  {
    zip_code: "14754",

    ste_name: "NY",
  },
  {
    zip_code: "14809",

    ste_name: "NY",
  },
  {
    zip_code: "15122",

    ste_name: "PA",
  },
  {
    zip_code: "15126",

    ste_name: "PA",
  },
  {
    zip_code: "15311",

    ste_name: "PA",
  },
  {
    zip_code: "15378",

    ste_name: "PA",
  },
  {
    zip_code: "15460",

    ste_name: "PA",
  },
  {
    zip_code: "15470",

    ste_name: "PA",
  },
  {
    zip_code: "15558",

    ste_name: "PA",
  },
  {
    zip_code: "15715",

    ste_name: "PA",
  },
  {
    zip_code: "15746",

    ste_name: "PA",
  },
  {
    zip_code: "15828",

    ste_name: "PA",
  },
  {
    zip_code: "15834",

    ste_name: "PA",
  },
  {
    zip_code: "15847",

    ste_name: "PA",
  },
  {
    zip_code: "15870",

    ste_name: "PA",
  },
  {
    zip_code: "15928",

    ste_name: "PA",
  },
  {
    zip_code: "16057",

    ste_name: "PA",
  },
  {
    zip_code: "16101",

    ste_name: "PA",
  },
  {
    zip_code: "16131",

    ste_name: "PA",
  },
  {
    zip_code: "16218",

    ste_name: "PA",
  },
  {
    zip_code: "16250",

    ste_name: "PA",
  },
  {
    zip_code: "16321",

    ste_name: "PA",
  },
  {
    zip_code: "16328",

    ste_name: "PA",
  },
  {
    zip_code: "16346",

    ste_name: "PA",
  },
  {
    zip_code: "16353",

    ste_name: "PA",
  },
  {
    zip_code: "16374",

    ste_name: "PA",
  },
  {
    zip_code: "16422",

    ste_name: "PA",
  },
  {
    zip_code: "16442",

    ste_name: "PA",
  },
  {
    zip_code: "16602",

    ste_name: "PA",
  },
  {
    zip_code: "16621",

    ste_name: "PA",
  },
  {
    zip_code: "16678",

    ste_name: "PA",
  },
  {
    zip_code: "16720",

    ste_name: "PA",
  },
  {
    zip_code: "16732",

    ste_name: "PA",
  },
  {
    zip_code: "16734",

    ste_name: "PA",
  },
  {
    zip_code: "16743",

    ste_name: "PA",
  },
  {
    zip_code: "16849",

    ste_name: "PA",
  },
  {
    zip_code: "16853",

    ste_name: "PA",
  },
  {
    zip_code: "16875",

    ste_name: "PA",
  },
  {
    zip_code: "16930",

    ste_name: "PA",
  },
  {
    zip_code: "16938",

    ste_name: "PA",
  },
  {
    zip_code: "17047",

    ste_name: "PA",
  },
  {
    zip_code: "17082",

    ste_name: "PA",
  },
  {
    zip_code: "17099",

    ste_name: "PA",
  },
  {
    zip_code: "17109",

    ste_name: "PA",
  },
  {
    zip_code: "17256",

    ste_name: "PA",
  },
  {
    zip_code: "17313",

    ste_name: "PA",
  },
  {
    zip_code: "17316",

    ste_name: "PA",
  },
  {
    zip_code: "17566",

    ste_name: "PA",
  },
  {
    zip_code: "17603",

    ste_name: "PA",
  },
  {
    zip_code: "17721",

    ste_name: "PA",
  },
  {
    zip_code: "17739",

    ste_name: "PA",
  },
  {
    zip_code: "17748",

    ste_name: "PA",
  },
  {
    zip_code: "18067",

    ste_name: "PA",
  },
  {
    zip_code: "18103",

    ste_name: "PA",
  },
  {
    zip_code: "18202",

    ste_name: "PA",
  },
  {
    zip_code: "18234",

    ste_name: "PA",
  },
  {
    zip_code: "18240",

    ste_name: "PA",
  },
  {
    zip_code: "18245",

    ste_name: "PA",
  },
  {
    zip_code: "18458",

    ste_name: "PA",
  },
  {
    zip_code: "18615",

    ste_name: "PA",
  },
  {
    zip_code: "18618",

    ste_name: "PA",
  },
  {
    zip_code: "18837",

    ste_name: "PA",
  },
  {
    zip_code: "18901",

    ste_name: "PA",
  },
  {
    zip_code: "19060",

    ste_name: "PA",
  },
  {
    zip_code: "19082",

    ste_name: "PA",
  },
  {
    zip_code: "19090",

    ste_name: "PA",
  },
  {
    zip_code: "19128",

    ste_name: "PA",
  },
  {
    zip_code: "19130",

    ste_name: "PA",
  },
  {
    zip_code: "19136",

    ste_name: "PA",
  },
  {
    zip_code: "19312",

    ste_name: "PA",
  },
  {
    zip_code: "19382",

    ste_name: "PA",
  },
  {
    zip_code: "19425",

    ste_name: "PA",
  },
  {
    zip_code: "19453",

    ste_name: "PA",
  },
  {
    zip_code: "19529",

    ste_name: "PA",
  },
  {
    zip_code: "19953",

    ste_name: "DE",
  },
  {
    zip_code: "20001",

    ste_name: "DC",
  },
  {
    zip_code: "20005",

    ste_name: "DC",
  },
  {
    zip_code: "20032",

    ste_name: "DC",
  },
  {
    zip_code: "20646",

    ste_name: "MD",
  },
  {
    zip_code: "20687",

    ste_name: "MD",
  },
  {
    zip_code: "20744",

    ste_name: "MD",
  },
  {
    zip_code: "20755",

    ste_name: "MD",
  },
  {
    zip_code: "20853",

    ste_name: "MD",
  },
  {
    zip_code: "20877",

    ste_name: "MD",
  },
  {
    zip_code: "21001",

    ste_name: "MD",
  },
  {
    zip_code: "21028",

    ste_name: "MD",
  },
  {
    zip_code: "21032",

    ste_name: "MD",
  },
  {
    zip_code: "21074",

    ste_name: "MD",
  },
  {
    zip_code: "21128",

    ste_name: "MD",
  },
  {
    zip_code: "21156",

    ste_name: "MD",
  },
  {
    zip_code: "21239",

    ste_name: "MD",
  },
  {
    zip_code: "21520",

    ste_name: "MD",
  },
  {
    zip_code: "21779",

    ste_name: "MD",
  },
  {
    zip_code: "21788",

    ste_name: "MD",
  },
  {
    zip_code: "21801",

    ste_name: "MD",
  },
  {
    zip_code: "21903",

    ste_name: "MD",
  },
  {
    zip_code: "21911",

    ste_name: "MD",
  },
  {
    zip_code: "22151",

    ste_name: "VA",
  },
  {
    zip_code: "22304",

    ste_name: "VA",
  },
  {
    zip_code: "22427",

    ste_name: "VA",
  },
  {
    zip_code: "22432",

    ste_name: "VA",
  },
  {
    zip_code: "22482",

    ste_name: "VA",
  },
  {
    zip_code: "22503",

    ste_name: "VA",
  },
  {
    zip_code: "22844",

    ste_name: "VA",
  },
  {
    zip_code: "22936",

    ste_name: "VA",
  },
  {
    zip_code: "22974",

    ste_name: "VA",
  },
  {
    zip_code: "22989",

    ste_name: "VA",
  },
  {
    zip_code: "23040",

    ste_name: "VA",
  },
  {
    zip_code: "23103",

    ste_name: "VA",
  },
  {
    zip_code: "23111",

    ste_name: "VA",
  },
  {
    zip_code: "23156",

    ste_name: "VA",
  },
  {
    zip_code: "23161",

    ste_name: "VA",
  },
  {
    zip_code: "23168",

    ste_name: "VA",
  },
  {
    zip_code: "23423",

    ste_name: "VA",
  },
  {
    zip_code: "23432",

    ste_name: "VA",
  },
  {
    zip_code: "23464",

    ste_name: "VA",
  },
  {
    zip_code: "23692",

    ste_name: "VA",
  },
  {
    zip_code: "23707",

    ste_name: "VA",
  },
  {
    zip_code: "23821",

    ste_name: "VA",
  },
  {
    zip_code: "23843",

    ste_name: "VA",
  },
  {
    zip_code: "23867",

    ste_name: "VA",
  },
  {
    zip_code: "23884",

    ste_name: "VA",
  },
  {
    zip_code: "23887",

    ste_name: "VA",
  },
  {
    zip_code: "23919",

    ste_name: "VA",
  },
  {
    zip_code: "24019",

    ste_name: "VA",
  },
  {
    zip_code: "24136",

    ste_name: "VA",
  },
  {
    zip_code: "24153",

    ste_name: "VA",
  },
  {
    zip_code: "24243",

    ste_name: "VA",
  },
  {
    zip_code: "24271",

    ste_name: "VA",
  },
  {
    zip_code: "24375",

    ste_name: "VA",
  },
  {
    zip_code: "24740",

    ste_name: "WV",
  },
  {
    zip_code: "24818",

    ste_name: "WV",
  },
  {
    zip_code: "24848",

    ste_name: "WV",
  },
  {
    zip_code: "24910",

    ste_name: "WV",
  },
  {
    zip_code: "24924",

    ste_name: "WV",
  },
  {
    zip_code: "24925",

    ste_name: "WV",
  },
  {
    zip_code: "24941",

    ste_name: "WV",
  },
  {
    zip_code: "25083",

    ste_name: "WV",
  },
  {
    zip_code: "25177",

    ste_name: "WV",
  },
  {
    zip_code: "25276",

    ste_name: "WV",
  },
  {
    zip_code: "25312",

    ste_name: "WV",
  },
  {
    zip_code: "25403",

    ste_name: "WV",
  },
  {
    zip_code: "25414",

    ste_name: "WV",
  },
  {
    zip_code: "25607",

    ste_name: "WV",
  },
  {
    zip_code: "25646",

    ste_name: "WV",
  },
  {
    zip_code: "25865",

    ste_name: "WV",
  },
  {
    zip_code: "25920",

    ste_name: "WV",
  },
  {
    zip_code: "26146",

    ste_name: "WV",
  },
  {
    zip_code: "26236",

    ste_name: "WV",
  },
  {
    zip_code: "26323",

    ste_name: "WV",
  },
  {
    zip_code: "26339",

    ste_name: "WV",
  },
  {
    zip_code: "26377",

    ste_name: "WV",
  },
  {
    zip_code: "26437",

    ste_name: "WV",
  },
  {
    zip_code: "26444",

    ste_name: "WV",
  },
  {
    zip_code: "26519",

    ste_name: "WV",
  },
  {
    zip_code: "26525",

    ste_name: "WV",
  },
  {
    zip_code: "26576",

    ste_name: "WV",
  },
  {
    zip_code: "26662",

    ste_name: "WV",
  },
  {
    zip_code: "26743",

    ste_name: "WV",
  },
  {
    zip_code: "27243",

    ste_name: "NC",
  },
  {
    zip_code: "27244",

    ste_name: "NC",
  },
  {
    zip_code: "27249",

    ste_name: "NC",
  },
  {
    zip_code: "27517",

    ste_name: "NC",
  },
  {
    zip_code: "27540",

    ste_name: "NC",
  },
  {
    zip_code: "27542",

    ste_name: "NC",
  },
  {
    zip_code: "27549",

    ste_name: "NC",
  },
  {
    zip_code: "27555",

    ste_name: "NC",
  },
  {
    zip_code: "27568",

    ste_name: "NC",
  },
  {
    zip_code: "27874",

    ste_name: "NC",
  },
  {
    zip_code: "27932",

    ste_name: "NC",
  },
  {
    zip_code: "28016",

    ste_name: "NC",
  },
  {
    zip_code: "28031",

    ste_name: "NC",
  },
  {
    zip_code: "28043",

    ste_name: "NC",
  },
  {
    zip_code: "28124",

    ste_name: "NC",
  },
  {
    zip_code: "28125",

    ste_name: "NC",
  },
  {
    zip_code: "28137",

    ste_name: "NC",
  },
  {
    zip_code: "28160",

    ste_name: "NC",
  },
  {
    zip_code: "28170",

    ste_name: "NC",
  },
  {
    zip_code: "28213",

    ste_name: "NC",
  },
  {
    zip_code: "28304",

    ste_name: "NC",
  },
  {
    zip_code: "28312",

    ste_name: "NC",
  },
  {
    zip_code: "28339",

    ste_name: "NC",
  },
  {
    zip_code: "28420",

    ste_name: "NC",
  },
  {
    zip_code: "28433",

    ste_name: "NC",
  },
  {
    zip_code: "28587",

    ste_name: "NC",
  },
  {
    zip_code: "28690",

    ste_name: "NC",
  },
  {
    zip_code: "28761",

    ste_name: "NC",
  },
  {
    zip_code: "28790",

    ste_name: "NC",
  },
  {
    zip_code: "29039",

    ste_name: "SC",
  },
  {
    zip_code: "29040",

    ste_name: "SC",
  },
  {
    zip_code: "29073",

    ste_name: "SC",
  },
  {
    zip_code: "29113",

    ste_name: "SC",
  },
  {
    zip_code: "29127",

    ste_name: "SC",
  },
  {
    zip_code: "29152",

    ste_name: "SC",
  },
  {
    zip_code: "29329",

    ste_name: "SC",
  },
  {
    zip_code: "29439",

    ste_name: "SC",
  },
  {
    zip_code: "29455",

    ste_name: "SC",
  },
  {
    zip_code: "29481",

    ste_name: "SC",
  },
  {
    zip_code: "29564",

    ste_name: "SC",
  },
  {
    zip_code: "29624",

    ste_name: "SC",
  },
  {
    zip_code: "29646",

    ste_name: "SC",
  },
  {
    zip_code: "29669",

    ste_name: "SC",
  },
  {
    zip_code: "29672",

    ste_name: "SC",
  },
  {
    zip_code: "29693",

    ste_name: "SC",
  },
  {
    zip_code: "29732",

    ste_name: "SC",
  },
  {
    zip_code: "29741",

    ste_name: "SC",
  },
  {
    zip_code: "29817",

    ste_name: "SC",
  },
  {
    zip_code: "29821",

    ste_name: "SC",
  },
  {
    zip_code: "29918",

    ste_name: "SC",
  },
  {
    zip_code: "30044",

    ste_name: "GA",
  },
  {
    zip_code: "30106",

    ste_name: "GA",
  },
  {
    zip_code: "30290",

    ste_name: "GA",
  },
  {
    zip_code: "30294",

    ste_name: "GA",
  },
  {
    zip_code: "30338",

    ste_name: "GA",
  },
  {
    zip_code: "30345",

    ste_name: "GA",
  },
  {
    zip_code: "30354",

    ste_name: "GA",
  },
  {
    zip_code: "30446",

    ste_name: "GA",
  },
  {
    zip_code: "30464",

    ste_name: "GA",
  },
  {
    zip_code: "30473",

    ste_name: "GA",
  },
  {
    zip_code: "30540",

    ste_name: "GA",
  },
  {
    zip_code: "30820",

    ste_name: "GA",
  },
  {
    zip_code: "59001",

    ste_name: "MT",
  },
  {
    zip_code: "59027",

    ste_name: "MT",
  },
  {
    zip_code: "59068",

    ste_name: "MT",
  },
  {
    zip_code: "59231",

    ste_name: "MT",
  },
  {
    zip_code: "59327",

    ste_name: "MT",
  },
  {
    zip_code: "59410",

    ste_name: "MT",
  },
  {
    zip_code: "59452",

    ste_name: "MT",
  },
  {
    zip_code: "59462",

    ste_name: "MT",
  },
  {
    zip_code: "59464",

    ste_name: "MT",
  },
  {
    zip_code: "59479",

    ste_name: "MT",
  },
  {
    zip_code: "59532",

    ste_name: "MT",
  },
  {
    zip_code: "59540",

    ste_name: "MT",
  },
  {
    zip_code: "59634",

    ste_name: "MT",
  },
  {
    zip_code: "59829",

    ste_name: "MT",
  },
  {
    zip_code: "60068",

    ste_name: "IL",
  },
  {
    zip_code: "60096",

    ste_name: "IL",
  },
  {
    zip_code: "60169",

    ste_name: "IL",
  },
  {
    zip_code: "60188",

    ste_name: "IL",
  },
  {
    zip_code: "60417",

    ste_name: "IL",
  },
  {
    zip_code: "60464",

    ste_name: "IL",
  },
  {
    zip_code: "60467",

    ste_name: "IL",
  },
  {
    zip_code: "60487",

    ste_name: "IL",
  },
  {
    zip_code: "60615",

    ste_name: "IL",
  },
  {
    zip_code: "60657",

    ste_name: "IL",
  },
  {
    zip_code: "61019",

    ste_name: "IL",
  },
  {
    zip_code: "61041",

    ste_name: "IL",
  },
  {
    zip_code: "61114",

    ste_name: "IL",
  },
  {
    zip_code: "61361",

    ste_name: "IL",
  },
  {
    zip_code: "61422",

    ste_name: "IL",
  },
  {
    zip_code: "61455",

    ste_name: "IL",
  },
  {
    zip_code: "61458",

    ste_name: "IL",
  },
  {
    zip_code: "61465",

    ste_name: "IL",
  },
  {
    zip_code: "61467",

    ste_name: "IL",
  },
  {
    zip_code: "61474",

    ste_name: "IL",
  },
  {
    zip_code: "61747",

    ste_name: "IL",
  },
  {
    zip_code: "61776",

    ste_name: "IL",
  },
  {
    zip_code: "61840",

    ste_name: "IL",
  },
  {
    zip_code: "61863",

    ste_name: "IL",
  },
  {
    zip_code: "62036",

    ste_name: "IL",
  },
  {
    zip_code: "62061",

    ste_name: "IL",
  },
  {
    zip_code: "62248",

    ste_name: "IL",
  },
  {
    zip_code: "62269",

    ste_name: "IL",
  },
  {
    zip_code: "62325",

    ste_name: "IL",
  },
  {
    zip_code: "62463",

    ste_name: "IL",
  },
  {
    zip_code: "62471",

    ste_name: "IL",
  },
  {
    zip_code: "62473",

    ste_name: "IL",
  },
  {
    zip_code: "62513",

    ste_name: "IL",
  },
  {
    zip_code: "62522",

    ste_name: "IL",
  },
  {
    zip_code: "62875",

    ste_name: "IL",
  },
  {
    zip_code: "62977",

    ste_name: "IL",
  },
  {
    zip_code: "62999",

    ste_name: "IL",
  },
  {
    zip_code: "63077",

    ste_name: "MO",
  },
  {
    zip_code: "63363",

    ste_name: "MO",
  },
  {
    zip_code: "63377",

    ste_name: "MO",
  },
  {
    zip_code: "63389",

    ste_name: "MO",
  },
  {
    zip_code: "63461",

    ste_name: "MO",
  },
  {
    zip_code: "63463",

    ste_name: "MO",
  },
  {
    zip_code: "63549",

    ste_name: "MO",
  },
  {
    zip_code: "63552",

    ste_name: "MO",
  },
  {
    zip_code: "63873",

    ste_name: "MO",
  },
  {
    zip_code: "64084",

    ste_name: "MO",
  },
  {
    zip_code: "64105",

    ste_name: "MO",
  },
  {
    zip_code: "64147",

    ste_name: "MO",
  },
  {
    zip_code: "64426",

    ste_name: "MO",
  },
  {
    zip_code: "64432",

    ste_name: "MO",
  },
  {
    zip_code: "64440",

    ste_name: "MO",
  },
  {
    zip_code: "64457",

    ste_name: "MO",
  },
  {
    zip_code: "64486",

    ste_name: "MO",
  },
  {
    zip_code: "64631",

    ste_name: "MO",
  },
  {
    zip_code: "64667",

    ste_name: "MO",
  },
  {
    zip_code: "64670",

    ste_name: "MO",
  },
  {
    zip_code: "64778",

    ste_name: "MO",
  },
  {
    zip_code: "64781",

    ste_name: "MO",
  },
  {
    zip_code: "64783",

    ste_name: "MO",
  },
  {
    zip_code: "64833",

    ste_name: "MO",
  },
  {
    zip_code: "65072",

    ste_name: "MO",
  },
  {
    zip_code: "65257",

    ste_name: "MO",
  },
  {
    zip_code: "65264",

    ste_name: "MO",
  },
  {
    zip_code: "65281",

    ste_name: "MO",
  },
  {
    zip_code: "65286",

    ste_name: "MO",
  },
  {
    zip_code: "65337",

    ste_name: "MO",
  },
  {
    zip_code: "65339",

    ste_name: "MO",
  },
  {
    zip_code: "65446",

    ste_name: "MO",
  },
  {
    zip_code: "65453",

    ste_name: "MO",
  },
  {
    zip_code: "65556",

    ste_name: "MO",
  },
  {
    zip_code: "65608",

    ste_name: "MO",
  },
  {
    zip_code: "65655",

    ste_name: "MO",
  },
  {
    zip_code: "65690",

    ste_name: "MO",
  },
  {
    zip_code: "65737",

    ste_name: "MO",
  },
  {
    zip_code: "65756",

    ste_name: "MO",
  },
  {
    zip_code: "66047",

    ste_name: "KS",
  },
  {
    zip_code: "66091",

    ste_name: "KS",
  },
  {
    zip_code: "66227",

    ste_name: "KS",
  },
  {
    zip_code: "66503",

    ste_name: "KS",
  },
  {
    zip_code: "66535",

    ste_name: "KS",
  },
  {
    zip_code: "66548",

    ste_name: "KS",
  },
  {
    zip_code: "66617",

    ste_name: "KS",
  },
  {
    zip_code: "66713",

    ste_name: "KS",
  },
  {
    zip_code: "66780",

    ste_name: "KS",
  },
  {
    zip_code: "67036",

    ste_name: "KS",
  },
  {
    zip_code: "67133",

    ste_name: "KS",
  },
  {
    zip_code: "67135",

    ste_name: "KS",
  },
  {
    zip_code: "67423",

    ste_name: "KS",
  },
  {
    zip_code: "67519",

    ste_name: "KS",
  },
  {
    zip_code: "67530",

    ste_name: "KS",
  },
  {
    zip_code: "67578",

    ste_name: "KS",
  },
  {
    zip_code: "67635",

    ste_name: "KS",
  },
  {
    zip_code: "67836",

    ste_name: "KS",
  },
  {
    zip_code: "67838",

    ste_name: "KS",
  },
  {
    zip_code: "68002",

    ste_name: "NE",
  },
  {
    zip_code: "68348",

    ste_name: "NE",
  },
  {
    zip_code: "68643",

    ste_name: "NE",
  },
  {
    zip_code: "68669",

    ste_name: "NE",
  },
  {
    zip_code: "68778",

    ste_name: "NE",
  },
  {
    zip_code: "68820",

    ste_name: "NE",
  },
  {
    zip_code: "68838",

    ste_name: "NE",
  },
  {
    zip_code: "68850",

    ste_name: "NE",
  },
  {
    zip_code: "69024",

    ste_name: "NE",
  },
  {
    zip_code: "69028",

    ste_name: "NE",
  },
  {
    zip_code: "69163",

    ste_name: "NE",
  },
  {
    zip_code: "70038",

    ste_name: "LA",
  },
  {
    zip_code: "70058",

    ste_name: "LA",
  },
  {
    zip_code: "70075",

    ste_name: "LA",
  },
  {
    zip_code: "70345",

    ste_name: "LA",
  },
  {
    zip_code: "70391",

    ste_name: "LA",
  },
  {
    zip_code: "70392",

    ste_name: "LA",
  },
  {
    zip_code: "70420",

    ste_name: "LA",
  },
  {
    zip_code: "70455",

    ste_name: "LA",
  },
  {
    zip_code: "70460",

    ste_name: "LA",
  },
  {
    zip_code: "70529",

    ste_name: "LA",
  },
  {
    zip_code: "70541",

    ste_name: "LA",
  },
  {
    zip_code: "70580",

    ste_name: "LA",
  },
  {
    zip_code: "70633",

    ste_name: "LA",
  },
  {
    zip_code: "70749",

    ste_name: "LA",
  },
  {
    zip_code: "70752",

    ste_name: "LA",
  },
  {
    zip_code: "70820",

    ste_name: "LA",
  },
  {
    zip_code: "71034",

    ste_name: "LA",
  },
  {
    zip_code: "71039",

    ste_name: "LA",
  },
  {
    zip_code: "71106",

    ste_name: "LA",
  },
  {
    zip_code: "71260",

    ste_name: "LA",
  },
  {
    zip_code: "71269",

    ste_name: "LA",
  },
  {
    zip_code: "71276",

    ste_name: "LA",
  },
  {
    zip_code: "71341",

    ste_name: "LA",
  },
  {
    zip_code: "71377",

    ste_name: "LA",
  },
  {
    zip_code: "71422",

    ste_name: "LA",
  },
  {
    zip_code: "71446",

    ste_name: "LA",
  },
  {
    zip_code: "71635",

    ste_name: "AR",
  },
  {
    zip_code: "71654",

    ste_name: "AR",
  },
  {
    zip_code: "71770",

    ste_name: "AR",
  },
  {
    zip_code: "72017",

    ste_name: "AR",
  },
  {
    zip_code: "72032",

    ste_name: "AR",
  },
  {
    zip_code: "72121",

    ste_name: "AR",
  },
  {
    zip_code: "72123",

    ste_name: "AR",
  },
  {
    zip_code: "72153",

    ste_name: "AR",
  },
  {
    zip_code: "72342",

    ste_name: "AR",
  },
  {
    zip_code: "72377",

    ste_name: "AR",
  },
  {
    zip_code: "72440",

    ste_name: "AR",
  },
  {
    zip_code: "72513",

    ste_name: "AR",
  },
  {
    zip_code: "72519",

    ste_name: "AR",
  },
  {
    zip_code: "72531",

    ste_name: "AR",
  },
  {
    zip_code: "72670",

    ste_name: "AR",
  },
  {
    zip_code: "72701",

    ste_name: "AR",
  },
  {
    zip_code: "72730",

    ste_name: "AR",
  },
  {
    zip_code: "72747",

    ste_name: "AR",
  },
  {
    zip_code: "72833",

    ste_name: "AR",
  },
  {
    zip_code: "72839",

    ste_name: "AR",
  },
  {
    zip_code: "73075",

    ste_name: "OK",
  },
  {
    zip_code: "73082",

    ste_name: "OK",
  },
  {
    zip_code: "73086",

    ste_name: "OK",
  },
  {
    zip_code: "73104",

    ste_name: "OK",
  },
  {
    zip_code: "73129",

    ste_name: "OK",
  },
  {
    zip_code: "73461",

    ste_name: "OK",
  },
  {
    zip_code: "73521",

    ste_name: "OK",
  },
  {
    zip_code: "73533",

    ste_name: "OK",
  },
  {
    zip_code: "73628",

    ste_name: "OK",
  },
  {
    zip_code: "73760",

    ste_name: "OK",
  },
  {
    zip_code: "74045",

    ste_name: "OK",
  },
  {
    zip_code: "74137",

    ste_name: "OK",
  },
  {
    zip_code: "74301",

    ste_name: "OK",
  },
  {
    zip_code: "74446",

    ste_name: "OK",
  },
  {
    zip_code: "74630",

    ste_name: "OK",
  },
  {
    zip_code: "74755",

    ste_name: "OK",
  },
  {
    zip_code: "75032",

    ste_name: "TX",
  },
  {
    zip_code: "75076",

    ste_name: "TX",
  },
  {
    zip_code: "75081",

    ste_name: "TX",
  },
  {
    zip_code: "75144",

    ste_name: "TX",
  },
  {
    zip_code: "75217",

    ste_name: "TX",
  },
  {
    zip_code: "75229",

    ste_name: "TX",
  },
  {
    zip_code: "75240",

    ste_name: "TX",
  },
  {
    zip_code: "75451",

    ste_name: "TX",
  },
  {
    zip_code: "75650",

    ste_name: "TX",
  },
  {
    zip_code: "75672",

    ste_name: "TX",
  },
  {
    zip_code: "75977",

    ste_name: "TX",
  },
  {
    zip_code: "76087",

    ste_name: "TX",
  },
  {
    zip_code: "76118",

    ste_name: "TX",
  },
  {
    zip_code: "76360",

    ste_name: "TX",
  },
  {
    zip_code: "76458",

    ste_name: "TX",
  },
  {
    zip_code: "76520",

    ste_name: "TX",
  },
  {
    zip_code: "76538",

    ste_name: "TX",
  },
  {
    zip_code: "76550",

    ste_name: "TX",
  },
  {
    zip_code: "76597",

    ste_name: "TX",
  },
  {
    zip_code: "76691",

    ste_name: "TX",
  },
  {
    zip_code: "76858",

    ste_name: "TX",
  },
  {
    zip_code: "76878",

    ste_name: "TX",
  },
  {
    zip_code: "76936",

    ste_name: "TX",
  },
  {
    zip_code: "77012",

    ste_name: "TX",
  },
  {
    zip_code: "77056",

    ste_name: "TX",
  },
  {
    zip_code: "77340",

    ste_name: "TX",
  },
  {
    zip_code: "77417",

    ste_name: "TX",
  },
  {
    zip_code: "77420",

    ste_name: "TX",
  },
  {
    zip_code: "77443",

    ste_name: "TX",
  },
  {
    zip_code: "77478",

    ste_name: "TX",
  },
  {
    zip_code: "77488",

    ste_name: "TX",
  },
  {
    zip_code: "77538",

    ste_name: "TX",
  },
  {
    zip_code: "77561",

    ste_name: "TX",
  },
  {
    zip_code: "77598",

    ste_name: "TX",
  },
  {
    zip_code: "77640",

    ste_name: "TX",
  },
  {
    zip_code: "77864",

    ste_name: "TX",
  },
  {
    zip_code: "78144",

    ste_name: "TX",
  },
  {
    zip_code: "78256",

    ste_name: "TX",
  },
  {
    zip_code: "78260",

    ste_name: "TX",
  },
  {
    zip_code: "78349",

    ste_name: "TX",
  },
  {
    zip_code: "78355",

    ste_name: "TX",
  },
  {
    zip_code: "78370",

    ste_name: "TX",
  },
  {
    zip_code: "78373",

    ste_name: "TX",
  },
  {
    zip_code: "78376",

    ste_name: "TX",
  },
  {
    zip_code: "78564",

    ste_name: "TX",
  },
  {
    zip_code: "78572",

    ste_name: "TX",
  },
  {
    zip_code: "78580",

    ste_name: "TX",
  },
  {
    zip_code: "78666",

    ste_name: "TX",
  },
  {
    zip_code: "78738",

    ste_name: "TX",
  },
  {
    zip_code: "78745",

    ste_name: "TX",
  },
  {
    zip_code: "78840",

    ste_name: "TX",
  },
  {
    zip_code: "79102",

    ste_name: "TX",
  },
  {
    zip_code: "79358",

    ste_name: "TX",
  },
  {
    zip_code: "79415",

    ste_name: "TX",
  },
  {
    zip_code: "79546",

    ste_name: "TX",
  },
  {
    zip_code: "79562",

    ste_name: "TX",
  },
  {
    zip_code: "79563",

    ste_name: "TX",
  },
  {
    zip_code: "79730",

    ste_name: "TX",
  },
  {
    zip_code: "79741",

    ste_name: "TX",
  },
  {
    zip_code: "79748",

    ste_name: "TX",
  },
  {
    zip_code: "79780",

    ste_name: "TX",
  },
  {
    zip_code: "79932",

    ste_name: "TX",
  },
  {
    zip_code: "80138",

    ste_name: "CO",
  },
  {
    zip_code: "80215",

    ste_name: "CO",
  },
  {
    zip_code: "80216",

    ste_name: "CO",
  },
  {
    zip_code: "80302",

    ste_name: "CO",
  },
  {
    zip_code: "80420",

    ste_name: "CO",
  },
  {
    zip_code: "80422",

    ste_name: "CO",
  },
  {
    zip_code: "80432",

    ste_name: "CO",
  },
  {
    zip_code: "80444",

    ste_name: "CO",
  },
  {
    zip_code: "80463",

    ste_name: "CO",
  },
  {
    zip_code: "80643",

    ste_name: "CO",
  },
  {
    zip_code: "80741",

    ste_name: "CO",
  },
  {
    zip_code: "80744",

    ste_name: "CO",
  },
  {
    zip_code: "80819",

    ste_name: "CO",
  },
  {
    zip_code: "80904",

    ste_name: "CO",
  },
  {
    zip_code: "80909",

    ste_name: "CO",
  },
  {
    zip_code: "81044",

    ste_name: "CO",
  },
  {
    zip_code: "81045",

    ste_name: "CO",
  },
  {
    zip_code: "81082",

    ste_name: "CO",
  },
  {
    zip_code: "81091",

    ste_name: "CO",
  },
  {
    zip_code: "81241",

    ste_name: "CO",
  },
  {
    zip_code: "81423",

    ste_name: "CO",
  },
  {
    zip_code: "81427",

    ste_name: "CO",
  },
  {
    zip_code: "81633",

    ste_name: "CO",
  },
  {
    zip_code: "82083",

    ste_name: "WY",
  },
  {
    zip_code: "82431",

    ste_name: "WY",
  },
  {
    zip_code: "82723",

    ste_name: "WY",
  },
  {
    zip_code: "82730",

    ste_name: "WY",
  },
  {
    zip_code: "82732",

    ste_name: "WY",
  },
  {
    zip_code: "82942",

    ste_name: "WY",
  },
  {
    zip_code: "82945",

    ste_name: "WY",
  },
  {
    zip_code: "83001",

    ste_name: "WY",
  },
  {
    zip_code: "83111",

    ste_name: "WY",
  },
  {
    zip_code: "83355",

    ste_name: "ID",
  },
  {
    zip_code: "83421",

    ste_name: "ID",
  },
  {
    zip_code: "83442",

    ste_name: "ID",
  },
  {
    zip_code: "83540",

    ste_name: "ID",
  },
  {
    zip_code: "83615",

    ste_name: "ID",
  },
  {
    zip_code: "83631",

    ste_name: "ID",
  },
  {
    zip_code: "83801",

    ste_name: "ID",
  },
  {
    zip_code: "83815",

    ste_name: "ID",
  },
  {
    zip_code: "83855",

    ste_name: "ID",
  },
  {
    zip_code: "83868",

    ste_name: "ID",
  },
  {
    zip_code: "83869",

    ste_name: "ID",
  },
  {
    zip_code: "84004",

    ste_name: "UT",
  },
  {
    zip_code: "84028",

    ste_name: "UT",
  },
  {
    zip_code: "84062",

    ste_name: "UT",
  },
  {
    zip_code: "84092",

    ste_name: "UT",
  },
  {
    zip_code: "84104",

    ste_name: "UT",
  },
  {
    zip_code: "84107",

    ste_name: "UT",
  },
  {
    zip_code: "84315",

    ste_name: "UT",
  },
  {
    zip_code: "84513",

    ste_name: "UT",
  },
  {
    zip_code: "84715",

    ste_name: "UT",
  },
  {
    zip_code: "84731",

    ste_name: "UT",
  },
  {
    zip_code: "84743",

    ste_name: "UT",
  },
  {
    zip_code: "84760",

    ste_name: "UT",
  },
  {
    zip_code: "85131",

    ste_name: "AZ",
  },
  {
    zip_code: "85201",

    ste_name: "AZ",
  },
  {
    zip_code: "85209",

    ste_name: "AZ",
  },
  {
    zip_code: "85210",

    ste_name: "AZ",
  },
  {
    zip_code: "85226",

    ste_name: "AZ",
  },
  {
    zip_code: "85335",

    ste_name: "AZ",
  },
  {
    zip_code: "85353",

    ste_name: "AZ",
  },
  {
    zip_code: "85540",

    ste_name: "AZ",
  },
  {
    zip_code: "85553",

    ste_name: "AZ",
  },
  {
    zip_code: "85622",

    ste_name: "AZ",
  },
  {
    zip_code: "85637",

    ste_name: "AZ",
  },
  {
    zip_code: "85706",

    ste_name: "AZ",
  },
  {
    zip_code: "85757",

    ste_name: "AZ",
  },
  {
    zip_code: "85912",

    ste_name: "AZ",
  },
  {
    zip_code: "85925",

    ste_name: "AZ",
  },
  {
    zip_code: "86024",

    ste_name: "AZ",
  },
  {
    zip_code: "86040",

    ste_name: "AZ",
  },
  {
    zip_code: "86052",

    ste_name: "AZ",
  },
  {
    zip_code: "86323",

    ste_name: "AZ",
  },
  {
    zip_code: "86514",

    ste_name: "AZ",
  },
  {
    zip_code: "86515",

    ste_name: "AZ",
  },
  {
    zip_code: "87004",

    ste_name: "NM",
  },
  {
    zip_code: "87016",

    ste_name: "NM",
  },
  {
    zip_code: "87045",

    ste_name: "NM",
  },
  {
    zip_code: "87347",

    ste_name: "NM",
  },
  {
    zip_code: "87413",

    ste_name: "NM",
  },
  {
    zip_code: "87420",

    ste_name: "NM",
  },
  {
    zip_code: "87538",

    ste_name: "NM",
  },
  {
    zip_code: "87560",

    ste_name: "NM",
  },
  {
    zip_code: "87579",

    ste_name: "NM",
  },
  {
    zip_code: "87581",

    ste_name: "NM",
  },
  {
    zip_code: "87824",

    ste_name: "NM",
  },
  {
    zip_code: "88025",

    ste_name: "NM",
  },
  {
    zip_code: "88116",

    ste_name: "NM",
  },
  {
    zip_code: "88301",

    ste_name: "NM",
  },
  {
    zip_code: "88316",

    ste_name: "NM",
  },
  {
    zip_code: "88323",

    ste_name: "NM",
  },
  {
    zip_code: "88339",

    ste_name: "NM",
  },
  {
    zip_code: "89013",

    ste_name: "NV",
  },
  {
    zip_code: "89021",

    ste_name: "NV",
  },
  {
    zip_code: "89061",

    ste_name: "NV",
  },
  {
    zip_code: "89110",

    ste_name: "NV",
  },
  {
    zip_code: "89117",

    ste_name: "NV",
  },
  {
    zip_code: "89121",

    ste_name: "NV",
  },
  {
    zip_code: "89138",

    ste_name: "NV",
  },
  {
    zip_code: "89419",

    ste_name: "NV",
  },
  {
    zip_code: "40009",

    ste_name: "KY",
  },
  {
    zip_code: "40065",

    ste_name: "KY",
  },
  {
    zip_code: "40171",

    ste_name: "KY",
  },
  {
    zip_code: "40209",

    ste_name: "KY",
  },
  {
    zip_code: "40376",

    ste_name: "KY",
  },
  {
    zip_code: "40404",

    ste_name: "KY",
  },
  {
    zip_code: "40489",

    ste_name: "KY",
  },
  {
    zip_code: "40744",

    ste_name: "KY",
  },
  {
    zip_code: "40870",

    ste_name: "KY",
  },
  {
    zip_code: "40921",

    ste_name: "KY",
  },
  {
    zip_code: "41006",

    ste_name: "KY",
  },
  {
    zip_code: "41011",

    ste_name: "KY",
  },
  {
    zip_code: "41073",

    ste_name: "KY",
  },
  {
    zip_code: "41086",

    ste_name: "KY",
  },
  {
    zip_code: "41102",

    ste_name: "KY",
  },
  {
    zip_code: "41180",

    ste_name: "KY",
  },
  {
    zip_code: "41232",

    ste_name: "KY",
  },
  {
    zip_code: "41234",

    ste_name: "KY",
  },
  {
    zip_code: "41512",

    ste_name: "KY",
  },
  {
    zip_code: "41540",

    ste_name: "KY",
  },
  {
    zip_code: "41605",

    ste_name: "KY",
  },
  {
    zip_code: "42003",

    ste_name: "KY",
  },
  {
    zip_code: "42029",

    ste_name: "KY",
  },
  {
    zip_code: "42036",

    ste_name: "KY",
  },
  {
    zip_code: "42202",

    ste_name: "KY",
  },
  {
    zip_code: "42330",

    ste_name: "KY",
  },
  {
    zip_code: "42354",

    ste_name: "KY",
  },
  {
    zip_code: "42463",

    ste_name: "KY",
  },
  {
    zip_code: "43046",

    ste_name: "OH",
  },
  {
    zip_code: "43064",

    ste_name: "OH",
  },
  {
    zip_code: "43117",

    ste_name: "OH",
  },
  {
    zip_code: "43148",

    ste_name: "OH",
  },
  {
    zip_code: "43205",

    ste_name: "OH",
  },
  {
    zip_code: "43222",

    ste_name: "OH",
  },
  {
    zip_code: "43332",

    ste_name: "OH",
  },
  {
    zip_code: "43356",

    ste_name: "OH",
  },
  {
    zip_code: "43413",

    ste_name: "OH",
  },
  {
    zip_code: "43445",

    ste_name: "OH",
  },
  {
    zip_code: "43446",

    ste_name: "OH",
  },
  {
    zip_code: "43519",

    ste_name: "OH",
  },
  {
    zip_code: "43529",

    ste_name: "OH",
  },
  {
    zip_code: "43541",

    ste_name: "OH",
  },
  {
    zip_code: "43782",

    ste_name: "OH",
  },
  {
    zip_code: "43804",

    ste_name: "OH",
  },
  {
    zip_code: "43836",

    ste_name: "OH",
  },
  {
    zip_code: "43947",

    ste_name: "OH",
  },
  {
    zip_code: "43973",

    ste_name: "OH",
  },
  {
    zip_code: "44026",

    ste_name: "OH",
  },
  {
    zip_code: "44064",

    ste_name: "OH",
  },
  {
    zip_code: "44101",

    ste_name: "OH",
  },
  {
    zip_code: "44111",

    ste_name: "OH",
  },
  {
    zip_code: "44119",

    ste_name: "OH",
  },
  {
    zip_code: "44130",

    ste_name: "OH",
  },
  {
    zip_code: "44420",

    ste_name: "OH",
  },
  {
    zip_code: "44450",

    ste_name: "OH",
  },
  {
    zip_code: "44451",

    ste_name: "OH",
  },
  {
    zip_code: "44504",

    ste_name: "OH",
  },
  {
    zip_code: "44634",

    ste_name: "OH",
  },
  {
    zip_code: "44646",

    ste_name: "OH",
  },
  {
    zip_code: "44654",

    ste_name: "OH",
  },
  {
    zip_code: "44816",

    ste_name: "OH",
  },
  {
    zip_code: "44861",

    ste_name: "OH",
  },
  {
    zip_code: "44878",

    ste_name: "OH",
  },
  {
    zip_code: "45032",

    ste_name: "OH",
  },
  {
    zip_code: "45103",

    ste_name: "OH",
  },
  {
    zip_code: "45142",

    ste_name: "OH",
  },
  {
    zip_code: "45212",

    ste_name: "OH",
  },
  {
    zip_code: "45230",

    ste_name: "OH",
  },
  {
    zip_code: "45309",

    ste_name: "OH",
  },
  {
    zip_code: "45311",

    ste_name: "OH",
  },
  {
    zip_code: "45339",

    ste_name: "OH",
  },
  {
    zip_code: "45344",

    ste_name: "OH",
  },
  {
    zip_code: "45505",

    ste_name: "OH",
  },
  {
    zip_code: "45620",

    ste_name: "OH",
  },
  {
    zip_code: "45629",

    ste_name: "OH",
  },
  {
    zip_code: "45662",

    ste_name: "OH",
  },
  {
    zip_code: "45684",

    ste_name: "OH",
  },
  {
    zip_code: "45879",

    ste_name: "OH",
  },
  {
    zip_code: "45882",

    ste_name: "OH",
  },
  {
    zip_code: "46032",

    ste_name: "IN",
  },
  {
    zip_code: "46346",

    ste_name: "IN",
  },
  {
    zip_code: "46385",

    ste_name: "IN",
  },
  {
    zip_code: "46536",

    ste_name: "IN",
  },
  {
    zip_code: "46619",

    ste_name: "IN",
  },
  {
    zip_code: "46725",

    ste_name: "IN",
  },
  {
    zip_code: "46755",

    ste_name: "IN",
  },
  {
    zip_code: "46791",

    ste_name: "IN",
  },
  {
    zip_code: "46979",

    ste_name: "IN",
  },
  {
    zip_code: "47334",

    ste_name: "IN",
  },
  {
    zip_code: "47340",

    ste_name: "IN",
  },
  {
    zip_code: "47348",

    ste_name: "IN",
  },
  {
    zip_code: "47386",

    ste_name: "IN",
  },
  {
    zip_code: "47459",

    ste_name: "IN",
  },
  {
    zip_code: "47537",

    ste_name: "IN",
  },
  {
    zip_code: "47630",

    ste_name: "IN",
  },
  {
    zip_code: "47711",

    ste_name: "IN",
  },
  {
    zip_code: "47712",

    ste_name: "IN",
  },
  {
    zip_code: "47720",

    ste_name: "IN",
  },
  {
    zip_code: "47869",

    ste_name: "IN",
  },
  {
    zip_code: "47874",

    ste_name: "IN",
  },
  {
    zip_code: "47901",

    ste_name: "IN",
  },
  {
    zip_code: "47963",

    ste_name: "IN",
  },
  {
    zip_code: "47969",

    ste_name: "IN",
  },
  {
    zip_code: "47978",

    ste_name: "IN",
  },
  {
    zip_code: "47992",

    ste_name: "IN",
  },
  {
    zip_code: "47993",

    ste_name: "IN",
  },
  {
    zip_code: "48006",

    ste_name: "MI",
  },
  {
    zip_code: "48060",

    ste_name: "MI",
  },
  {
    zip_code: "48074",

    ste_name: "MI",
  },
  {
    zip_code: "48089",

    ste_name: "MI",
  },
  {
    zip_code: "48164",

    ste_name: "MI",
  },
  {
    zip_code: "48216",

    ste_name: "MI",
  },
  {
    zip_code: "48220",

    ste_name: "MI",
  },
  {
    zip_code: "48221",

    ste_name: "MI",
  },
  {
    zip_code: "48243",

    ste_name: "MI",
  },
  {
    zip_code: "48309",

    ste_name: "MI",
  },
  {
    zip_code: "48357",

    ste_name: "MI",
  },
  {
    zip_code: "48380",

    ste_name: "MI",
  },
  {
    zip_code: "48457",

    ste_name: "MI",
  },
  {
    zip_code: "48625",

    ste_name: "MI",
  },
  {
    zip_code: "48659",

    ste_name: "MI",
  },
  {
    zip_code: "48661",

    ste_name: "MI",
  },
  {
    zip_code: "48703",

    ste_name: "MI",
  },
  {
    zip_code: "48731",

    ste_name: "MI",
  },
  {
    zip_code: "48757",

    ste_name: "MI",
  },
  {
    zip_code: "48865",

    ste_name: "MI",
  },
  {
    zip_code: "48883",

    ste_name: "MI",
  },
  {
    zip_code: "49113",

    ste_name: "MI",
  },
  {
    zip_code: "49126",

    ste_name: "MI",
  },
  {
    zip_code: "49326",

    ste_name: "MI",
  },
  {
    zip_code: "49435",

    ste_name: "MI",
  },
  {
    zip_code: "49451",

    ste_name: "MI",
  },
  {
    zip_code: "49458",

    ste_name: "MI",
  },
  {
    zip_code: "49525",

    ste_name: "MI",
  },
  {
    zip_code: "49548",

    ste_name: "MI",
  },
  {
    zip_code: "49666",

    ste_name: "MI",
  },
  {
    zip_code: "49753",

    ste_name: "MI",
  },
  {
    zip_code: "49779",

    ste_name: "MI",
  },
  {
    zip_code: "49815",

    ste_name: "MI",
  },
  {
    zip_code: "49821",

    ste_name: "MI",
  },
  {
    zip_code: "49835",

    ste_name: "MI",
  },
  {
    zip_code: "50042",

    ste_name: "IA",
  },
  {
    zip_code: "50056",

    ste_name: "IA",
  },
  {
    zip_code: "50070",

    ste_name: "IA",
  },
  {
    zip_code: "50076",

    ste_name: "IA",
  },
  {
    zip_code: "50105",

    ste_name: "IA",
  },
  {
    zip_code: "50118",

    ste_name: "IA",
  },
  {
    zip_code: "50128",

    ste_name: "IA",
  },
  {
    zip_code: "50148",

    ste_name: "IA",
  },
  {
    zip_code: "50170",

    ste_name: "IA",
  },
  {
    zip_code: "50213",

    ste_name: "IA",
  },
  {
    zip_code: "50229",

    ste_name: "IA",
  },
  {
    zip_code: "50271",

    ste_name: "IA",
  },
  {
    zip_code: "50319",

    ste_name: "IA",
  },
  {
    zip_code: "50323",

    ste_name: "IA",
  },
  {
    zip_code: "50428",

    ste_name: "IA",
  },
  {
    zip_code: "50476",

    ste_name: "IA",
  },
  {
    zip_code: "50479",

    ste_name: "IA",
  },
  {
    zip_code: "50554",

    ste_name: "IA",
  },
  {
    zip_code: "50569",

    ste_name: "IA",
  },
  {
    zip_code: "50588",

    ste_name: "IA",
  },
  {
    zip_code: "50633",

    ste_name: "IA",
  },
  {
    zip_code: "50645",

    ste_name: "IA",
  },
  {
    zip_code: "50659",

    ste_name: "IA",
  },
  {
    zip_code: "50848",

    ste_name: "IA",
  },
  {
    zip_code: "50859",

    ste_name: "IA",
  },
  {
    zip_code: "51111",

    ste_name: "IA",
  },
  {
    zip_code: "51355",

    ste_name: "IA",
  },
  {
    zip_code: "51558",

    ste_name: "IA",
  },
  {
    zip_code: "51579",

    ste_name: "IA",
  },
  {
    zip_code: "52054",

    ste_name: "IA",
  },
  {
    zip_code: "52154",

    ste_name: "IA",
  },
  {
    zip_code: "52171",

    ste_name: "IA",
  },
  {
    zip_code: "52172",

    ste_name: "IA",
  },
  {
    zip_code: "52225",

    ste_name: "IA",
  },
  {
    zip_code: "52254",

    ste_name: "IA",
  },
  {
    zip_code: "52347",

    ste_name: "IA",
  },
  {
    zip_code: "52351",

    ste_name: "IA",
  },
  {
    zip_code: "52561",

    ste_name: "IA",
  },
  {
    zip_code: "52637",

    ste_name: "IA",
  },
  {
    zip_code: "52639",

    ste_name: "IA",
  },
  {
    zip_code: "52802",

    ste_name: "IA",
  },
  {
    zip_code: "53050",

    ste_name: "WI",
  },
  {
    zip_code: "53075",

    ste_name: "WI",
  },
  {
    zip_code: "53078",

    ste_name: "WI",
  },
  {
    zip_code: "53079",

    ste_name: "WI",
  },
  {
    zip_code: "53098",

    ste_name: "WI",
  },
  {
    zip_code: "53206",

    ste_name: "WI",
  },
  {
    zip_code: "53223",

    ste_name: "WI",
  },
  {
    zip_code: "53225",

    ste_name: "WI",
  },
  {
    zip_code: "53226",

    ste_name: "WI",
  },
  {
    zip_code: "53578",

    ste_name: "WI",
  },
  {
    zip_code: "53715",

    ste_name: "WI",
  },
  {
    zip_code: "53901",

    ste_name: "WI",
  },
  {
    zip_code: "53949",

    ste_name: "WI",
  },
  {
    zip_code: "53965",

    ste_name: "WI",
  },
  {
    zip_code: "54025",

    ste_name: "WI",
  },
  {
    zip_code: "54123",

    ste_name: "WI",
  },
  {
    zip_code: "54135",

    ste_name: "WI",
  },
  {
    zip_code: "54136",

    ste_name: "WI",
  },
  {
    zip_code: "54165",

    ste_name: "WI",
  },
  {
    zip_code: "54220",

    ste_name: "WI",
  },
  {
    zip_code: "54401",

    ste_name: "WI",
  },
  {
    zip_code: "54469",

    ste_name: "WI",
  },
  {
    zip_code: "54476",

    ste_name: "WI",
  },
  {
    zip_code: "54479",

    ste_name: "WI",
  },
  {
    zip_code: "54494",

    ste_name: "WI",
  },
  {
    zip_code: "54501",

    ste_name: "WI",
  },
  {
    zip_code: "54519",

    ste_name: "WI",
  },
  {
    zip_code: "54539",

    ste_name: "WI",
  },
  {
    zip_code: "54611",

    ste_name: "WI",
  },
  {
    zip_code: "54636",

    ste_name: "WI",
  },
  {
    zip_code: "54637",

    ste_name: "WI",
  },
  {
    zip_code: "54660",

    ste_name: "WI",
  },
  {
    zip_code: "54739",

    ste_name: "WI",
  },
  {
    zip_code: "54741",

    ste_name: "WI",
  },
  {
    zip_code: "54812",

    ste_name: "WI",
  },
  {
    zip_code: "54832",

    ste_name: "WI",
  },
  {
    zip_code: "54845",

    ste_name: "WI",
  },
  {
    zip_code: "54859",

    ste_name: "WI",
  },
  {
    zip_code: "54893",

    ste_name: "WI",
  },
  {
    zip_code: "54909",

    ste_name: "WI",
  },
  {
    zip_code: "54922",

    ste_name: "WI",
  },
  {
    zip_code: "54962",

    ste_name: "WI",
  },
  {
    zip_code: "55013",

    ste_name: "MN",
  },
  {
    zip_code: "55017",

    ste_name: "MN",
  },
  {
    zip_code: "55030",

    ste_name: "MN",
  },
  {
    zip_code: "55036",

    ste_name: "MN",
  },
  {
    zip_code: "55302",

    ste_name: "MN",
  },
  {
    zip_code: "55327",

    ste_name: "MN",
  },
  {
    zip_code: "55386",

    ste_name: "MN",
  },
  {
    zip_code: "55404",

    ste_name: "MN",
  },
  {
    zip_code: "55437",

    ste_name: "MN",
  },
  {
    zip_code: "55750",

    ste_name: "MN",
  },
  {
    zip_code: "55758",

    ste_name: "MN",
  },
  {
    zip_code: "55933",

    ste_name: "MN",
  },
  {
    zip_code: "56042",

    ste_name: "MN",
  },
  {
    zip_code: "56050",

    ste_name: "MN",
  },
  {
    zip_code: "56256",

    ste_name: "MN",
  },
  {
    zip_code: "56301",

    ste_name: "MN",
  },
  {
    zip_code: "56304",

    ste_name: "MN",
  },
  {
    zip_code: "56327",

    ste_name: "MN",
  },
  {
    zip_code: "56345",

    ste_name: "MN",
  },
  {
    zip_code: "56363",

    ste_name: "MN",
  },
  {
    zip_code: "56371",

    ste_name: "MN",
  },
  {
    zip_code: "56455",

    ste_name: "MN",
  },
  {
    zip_code: "56477",

    ste_name: "MN",
  },
  {
    zip_code: "56516",

    ste_name: "MN",
  },
  {
    zip_code: "56527",

    ste_name: "MN",
  },
  {
    zip_code: "56529",

    ste_name: "MN",
  },
  {
    zip_code: "56627",

    ste_name: "MN",
  },
  {
    zip_code: "57024",

    ste_name: "SD",
  },
  {
    zip_code: "57260",

    ste_name: "SD",
  },
  {
    zip_code: "57265",

    ste_name: "SD",
  },
  {
    zip_code: "57317",

    ste_name: "SD",
  },
  {
    zip_code: "57433",

    ste_name: "SD",
  },
  {
    zip_code: "57450",

    ste_name: "SD",
  },
  {
    zip_code: "57470",

    ste_name: "SD",
  },
  {
    zip_code: "57522",

    ste_name: "SD",
  },
  {
    zip_code: "57528",

    ste_name: "SD",
  },
  {
    zip_code: "57533",

    ste_name: "SD",
  },
  {
    zip_code: "57560",

    ste_name: "SD",
  },
  {
    zip_code: "57576",

    ste_name: "SD",
  },
  {
    zip_code: "57584",

    ste_name: "SD",
  },
  {
    zip_code: "57631",

    ste_name: "SD",
  },
  {
    zip_code: "57638",

    ste_name: "SD",
  },
  {
    zip_code: "57642",

    ste_name: "SD",
  },
  {
    zip_code: "57660",

    ste_name: "SD",
  },
  {
    zip_code: "57761",

    ste_name: "SD",
  },
  {
    zip_code: "57782",

    ste_name: "SD",
  },
  {
    zip_code: "58045",

    ste_name: "ND",
  },
  {
    zip_code: "58222",

    ste_name: "ND",
  },
  {
    zip_code: "58254",

    ste_name: "ND",
  },
  {
    zip_code: "58332",

    ste_name: "ND",
  },
  {
    zip_code: "58478",

    ste_name: "ND",
  },
  {
    zip_code: "58487",

    ste_name: "ND",
  },
  {
    zip_code: "58581",

    ste_name: "ND",
  },
  {
    zip_code: "31025",

    ste_name: "GA",
  },
  {
    zip_code: "31039",

    ste_name: "GA",
  },
  {
    zip_code: "31087",

    ste_name: "GA",
  },
  {
    zip_code: "31632",

    ste_name: "GA",
  },
  {
    zip_code: "31721",

    ste_name: "GA",
  },
  {
    zip_code: "31733",

    ste_name: "GA",
  },
  {
    zip_code: "31791",

    ste_name: "GA",
  },
  {
    zip_code: "31803",

    ste_name: "GA",
  },
  {
    zip_code: "31806",

    ste_name: "GA",
  },
  {
    zip_code: "32024",

    ste_name: "FL",
  },
  {
    zip_code: "32034",

    ste_name: "FL",
  },
  {
    zip_code: "32046",

    ste_name: "FL",
  },
  {
    zip_code: "32055",

    ste_name: "FL",
  },
  {
    zip_code: "32079",

    ste_name: "FL",
  },
  {
    zip_code: "32157",

    ste_name: "FL",
  },
  {
    zip_code: "32205",

    ste_name: "FL",
  },
  {
    zip_code: "32212",

    ste_name: "FL",
  },
  {
    zip_code: "32223",

    ste_name: "FL",
  },
  {
    zip_code: "32234",

    ste_name: "FL",
  },
  {
    zip_code: "32310",

    ste_name: "FL",
  },
  {
    zip_code: "32621",

    ste_name: "FL",
  },
  {
    zip_code: "32640",

    ste_name: "FL",
  },
  {
    zip_code: "32643",

    ste_name: "FL",
  },
  {
    zip_code: "32658",

    ste_name: "FL",
  },
  {
    zip_code: "32692",

    ste_name: "FL",
  },
  {
    zip_code: "32767",

    ste_name: "FL",
  },
  {
    zip_code: "32821",

    ste_name: "FL",
  },
  {
    zip_code: "32966",

    ste_name: "FL",
  },
  {
    zip_code: "33055",

    ste_name: "FL",
  },
  {
    zip_code: "33166",

    ste_name: "FL",
  },
  {
    zip_code: "33182",

    ste_name: "FL",
  },
  {
    zip_code: "33189",

    ste_name: "FL",
  },
  {
    zip_code: "33430",

    ste_name: "FL",
  },
  {
    zip_code: "33458",

    ste_name: "FL",
  },
  {
    zip_code: "33503",

    ste_name: "FL",
  },
  {
    zip_code: "33534",

    ste_name: "FL",
  },
  {
    zip_code: "33545",

    ste_name: "FL",
  },
  {
    zip_code: "33548",

    ste_name: "FL",
  },
  {
    zip_code: "33614",

    ste_name: "FL",
  },
  {
    zip_code: "33859",

    ste_name: "FL",
  },
  {
    zip_code: "33880",

    ste_name: "FL",
  },
  {
    zip_code: "33897",

    ste_name: "FL",
  },
  {
    zip_code: "33909",

    ste_name: "FL",
  },
  {
    zip_code: "34216",

    ste_name: "FL",
  },
  {
    zip_code: "34239",

    ste_name: "FL",
  },
  {
    zip_code: "34288",

    ste_name: "FL",
  },
  {
    zip_code: "34677",

    ste_name: "FL",
  },
  {
    zip_code: "34685",

    ste_name: "FL",
  },
  {
    zip_code: "34714",

    ste_name: "FL",
  },
  {
    zip_code: "34734",

    ste_name: "FL",
  },
  {
    zip_code: "34957",

    ste_name: "FL",
  },
  {
    zip_code: "35114",

    ste_name: "AL",
  },
  {
    zip_code: "35119",

    ste_name: "AL",
  },
  {
    zip_code: "35126",

    ste_name: "AL",
  },
  {
    zip_code: "35405",

    ste_name: "AL",
  },
  {
    zip_code: "35447",

    ste_name: "AL",
  },
  {
    zip_code: "35469",

    ste_name: "AL",
  },
  {
    zip_code: "35751",

    ste_name: "AL",
  },
  {
    zip_code: "35757",

    ste_name: "AL",
  },
  {
    zip_code: "35773",

    ste_name: "AL",
  },
  {
    zip_code: "35896",

    ste_name: "AL",
  },
  {
    zip_code: "35904",

    ste_name: "AL",
  },
  {
    zip_code: "35952",

    ste_name: "AL",
  },
  {
    zip_code: "35963",

    ste_name: "AL",
  },
  {
    zip_code: "35974",

    ste_name: "AL",
  },
  {
    zip_code: "35983",

    ste_name: "AL",
  },
  {
    zip_code: "36273",

    ste_name: "AL",
  },
  {
    zip_code: "36278",

    ste_name: "AL",
  },
  {
    zip_code: "36318",

    ste_name: "AL",
  },
  {
    zip_code: "36481",

    ste_name: "AL",
  },
  {
    zip_code: "36549",

    ste_name: "AL",
  },
  {
    zip_code: "36606",

    ste_name: "AL",
  },
  {
    zip_code: "36608",

    ste_name: "AL",
  },
  {
    zip_code: "36618",

    ste_name: "AL",
  },
  {
    zip_code: "36727",

    ste_name: "AL",
  },
  {
    zip_code: "36862",

    ste_name: "AL",
  },
  {
    zip_code: "36915",

    ste_name: "AL",
  },
  {
    zip_code: "37033",

    ste_name: "TN",
  },
  {
    zip_code: "37087",

    ste_name: "TN",
  },
  {
    zip_code: "37101",

    ste_name: "TN",
  },
  {
    zip_code: "37118",

    ste_name: "TN",
  },
  {
    zip_code: "37141",

    ste_name: "TN",
  },
  {
    zip_code: "37184",

    ste_name: "TN",
  },
  {
    zip_code: "37228",

    ste_name: "TN",
  },
  {
    zip_code: "37302",

    ste_name: "TN",
  },
  {
    zip_code: "37311",

    ste_name: "TN",
  },
  {
    zip_code: "37354",

    ste_name: "TN",
  },
  {
    zip_code: "37369",

    ste_name: "TN",
  },
  {
    zip_code: "37415",

    ste_name: "TN",
  },
  {
    zip_code: "37640",

    ste_name: "TN",
  },
  {
    zip_code: "37642",

    ste_name: "TN",
  },
  {
    zip_code: "37687",

    ste_name: "TN",
  },
  {
    zip_code: "37813",

    ste_name: "TN",
  },
  {
    zip_code: "37876",

    ste_name: "TN",
  },
  {
    zip_code: "38021",

    ste_name: "TN",
  },
  {
    zip_code: "38028",

    ste_name: "TN",
  },
  {
    zip_code: "38046",

    ste_name: "TN",
  },
  {
    zip_code: "38103",

    ste_name: "TN",
  },
  {
    zip_code: "38381",

    ste_name: "TN",
  },
  {
    zip_code: "38391",

    ste_name: "TN",
  },
  {
    zip_code: "38481",

    ste_name: "TN",
  },
  {
    zip_code: "38560",

    ste_name: "TN",
  },
  {
    zip_code: "38571",

    ste_name: "TN",
  },
  {
    zip_code: "38639",

    ste_name: "MS",
  },
  {
    zip_code: "38732",

    ste_name: "MS",
  },
  {
    zip_code: "38762",

    ste_name: "MS",
  },
  {
    zip_code: "38781",

    ste_name: "MS",
  },
  {
    zip_code: "38834",

    ste_name: "MS",
  },
  {
    zip_code: "38841",

    ste_name: "MS",
  },
  {
    zip_code: "38848",

    ste_name: "MS",
  },
  {
    zip_code: "38856",

    ste_name: "MS",
  },
  {
    zip_code: "38925",

    ste_name: "MS",
  },
  {
    zip_code: "38929",

    ste_name: "MS",
  },
  {
    zip_code: "39166",

    ste_name: "MS",
  },
  {
    zip_code: "39218",

    ste_name: "MS",
  },
  {
    zip_code: "39360",

    ste_name: "MS",
  },
  {
    zip_code: "39531",

    ste_name: "MS",
  },
  {
    zip_code: "39556",

    ste_name: "MS",
  },
  {
    zip_code: "39730",

    ste_name: "MS",
  },
  {
    zip_code: "39827",

    ste_name: "GA",
  },
  {
    zip_code: "93066",

    ste_name: "CA",
  },
  {
    zip_code: "93224",

    ste_name: "CA",
  },
  {
    zip_code: "93449",

    ste_name: "CA",
  },
  {
    zip_code: "93454",

    ste_name: "CA",
  },
  {
    zip_code: "93523",

    ste_name: "CA",
  },
  {
    zip_code: "94020",

    ste_name: "CA",
  },
  {
    zip_code: "94024",

    ste_name: "CA",
  },
  {
    zip_code: "94063",

    ste_name: "CA",
  },
  {
    zip_code: "94129",

    ste_name: "CA",
  },
  {
    zip_code: "94304",

    ste_name: "CA",
  },
  {
    zip_code: "94515",

    ste_name: "CA",
  },
  {
    zip_code: "94530",

    ste_name: "CA",
  },
  {
    zip_code: "94586",

    ste_name: "CA",
  },
  {
    zip_code: "94599",

    ste_name: "CA",
  },
  {
    zip_code: "94945",

    ste_name: "CA",
  },
  {
    zip_code: "94970",

    ste_name: "CA",
  },
  {
    zip_code: "95007",

    ste_name: "CA",
  },
  {
    zip_code: "95014",

    ste_name: "CA",
  },
  {
    zip_code: "95017",

    ste_name: "CA",
  },
  {
    zip_code: "95120",

    ste_name: "CA",
  },
  {
    zip_code: "95249",

    ste_name: "CA",
  },
  {
    zip_code: "95329",

    ste_name: "CA",
  },
  {
    zip_code: "95354",

    ste_name: "CA",
  },
  {
    zip_code: "95391",

    ste_name: "CA",
  },
  {
    zip_code: "95428",

    ste_name: "CA",
  },
  {
    zip_code: "95476",

    ste_name: "CA",
  },
  {
    zip_code: "95488",

    ste_name: "CA",
  },
  {
    zip_code: "95545",

    ste_name: "CA",
  },
  {
    zip_code: "95548",

    ste_name: "CA",
  },
  {
    zip_code: "95605",

    ste_name: "CA",
  },
  {
    zip_code: "95619",

    ste_name: "CA",
  },
  {
    zip_code: "95633",

    ste_name: "CA",
  },
  {
    zip_code: "95677",

    ste_name: "CA",
  },
  {
    zip_code: "95680",

    ste_name: "CA",
  },
  {
    zip_code: "95682",

    ste_name: "CA",
  },
  {
    zip_code: "95831",

    ste_name: "CA",
  },
  {
    zip_code: "95835",

    ste_name: "CA",
  },
  {
    zip_code: "95947",

    ste_name: "CA",
  },
  {
    zip_code: "95979",

    ste_name: "CA",
  },
  {
    zip_code: "96108",

    ste_name: "CA",
  },
  {
    zip_code: "96114",

    ste_name: "CA",
  },
  {
    zip_code: "96155",

    ste_name: "CA",
  },
  {
    zip_code: "96728",

    ste_name: "HI",
  },
  {
    zip_code: "96731",

    ste_name: "HI",
  },
  {
    zip_code: "96750",

    ste_name: "HI",
  },
  {
    zip_code: "96783",

    ste_name: "HI",
  },
  {
    zip_code: "96818",

    ste_name: "HI",
  },
  {
    zip_code: "96951",

    ste_name: "MP",
  },
  {
    zip_code: "97014",

    ste_name: "OR",
  },
  {
    zip_code: "97031",

    ste_name: "OR",
  },
  {
    zip_code: "97037",

    ste_name: "OR",
  },
  {
    zip_code: "97063",

    ste_name: "OR",
  },
  {
    zip_code: "97116",

    ste_name: "OR",
  },
  {
    zip_code: "97212",

    ste_name: "OR",
  },
  {
    zip_code: "97233",

    ste_name: "OR",
  },
  {
    zip_code: "97306",

    ste_name: "OR",
  },
  {
    zip_code: "97347",

    ste_name: "OR",
  },
  {
    zip_code: "97412",

    ste_name: "OR",
  },
  {
    zip_code: "97459",

    ste_name: "OR",
  },
  {
    zip_code: "97481",

    ste_name: "OR",
  },
  {
    zip_code: "97627",

    ste_name: "OR",
  },
  {
    zip_code: "97636",

    ste_name: "OR",
  },
  {
    zip_code: "97877",

    ste_name: "OR",
  },
  {
    zip_code: "97920",

    ste_name: "OR",
  },
  {
    zip_code: "98006",

    ste_name: "WA",
  },
  {
    zip_code: "98024",

    ste_name: "WA",
  },
  {
    zip_code: "98033",

    ste_name: "WA",
  },
  {
    zip_code: "98057",

    ste_name: "WA",
  },
  {
    zip_code: "98122",

    ste_name: "WA",
  },
  {
    zip_code: "98363",

    ste_name: "WA",
  },
  {
    zip_code: "90016",

    ste_name: "CA",
  },
  {
    zip_code: "90077",

    ste_name: "CA",
  },
  {
    zip_code: "90266",

    ste_name: "CA",
  },
  {
    zip_code: "91101",

    ste_name: "CA",
  },
  {
    zip_code: "91406",

    ste_name: "CA",
  },
  {
    zip_code: "91504",

    ste_name: "CA",
  },
  {
    zip_code: "91901",

    ste_name: "CA",
  },
  {
    zip_code: "91978",

    ste_name: "CA",
  },
  {
    zip_code: "92066",

    ste_name: "CA",
  },
  {
    zip_code: "92091",

    ste_name: "CA",
  },
  {
    zip_code: "92102",

    ste_name: "CA",
  },
  {
    zip_code: "92104",

    ste_name: "CA",
  },
  {
    zip_code: "92313",

    ste_name: "CA",
  },
  {
    zip_code: "92532",

    ste_name: "CA",
  },
  {
    zip_code: "92561",

    ste_name: "CA",
  },
  {
    zip_code: "92585",

    ste_name: "CA",
  },
  {
    zip_code: "92612",

    ste_name: "CA",
  },
  {
    zip_code: "93003",

    ste_name: "CA",
  },
  {
    zip_code: "93608",

    ste_name: "CA",
  },
  {
    zip_code: "93634",

    ste_name: "CA",
  },
  {
    zip_code: "93954",

    ste_name: "CA",
  },
  {
    zip_code: "98527",

    ste_name: "WA",
  },
  {
    zip_code: "98662",

    ste_name: "WA",
  },
  {
    zip_code: "98831",

    ste_name: "WA",
  },
  {
    zip_code: "98834",

    ste_name: "WA",
  },
  {
    zip_code: "99004",

    ste_name: "WA",
  },
  {
    zip_code: "99036",

    ste_name: "WA",
  },
  {
    zip_code: "99105",

    ste_name: "WA",
  },
  {
    zip_code: "99151",

    ste_name: "WA",
  },
  {
    zip_code: "99157",

    ste_name: "WA",
  },
  {
    zip_code: "99181",

    ste_name: "WA",
  },
  {
    zip_code: "99519",

    ste_name: "AK",
  },
  {
    zip_code: "99575",

    ste_name: "AK",
  },
  {
    zip_code: "99580",

    ste_name: "AK",
  },
  {
    zip_code: "99643",

    ste_name: "AK",
  },
  {
    zip_code: "99680",

    ste_name: "AK",
  },
  {
    zip_code: "31045",

    ste_name: "GA",
  },
  {
    zip_code: "31090",

    ste_name: "GA",
  },
  {
    zip_code: "31098",

    ste_name: "GA",
  },
  {
    zip_code: "31308",

    ste_name: "GA",
  },
  {
    zip_code: "31410",

    ste_name: "GA",
  },
  {
    zip_code: "31532",

    ste_name: "GA",
  },
  {
    zip_code: "31533",

    ste_name: "GA",
  },
  {
    zip_code: "31544",

    ste_name: "GA",
  },
  {
    zip_code: "31546",

    ste_name: "GA",
  },
  {
    zip_code: "31553",

    ste_name: "GA",
  },
  {
    zip_code: "31563",

    ste_name: "GA",
  },
  {
    zip_code: "31624",

    ste_name: "GA",
  },
  {
    zip_code: "31722",

    ste_name: "GA",
  },
  {
    zip_code: "31790",

    ste_name: "GA",
  },
  {
    zip_code: "31816",

    ste_name: "GA",
  },
  {
    zip_code: "31836",

    ste_name: "GA",
  },
  {
    zip_code: "32053",

    ste_name: "FL",
  },
  {
    zip_code: "32059",

    ste_name: "FL",
  },
  {
    zip_code: "32064",

    ste_name: "FL",
  },
  {
    zip_code: "32065",

    ste_name: "FL",
  },
  {
    zip_code: "32190",

    ste_name: "FL",
  },
  {
    zip_code: "32301",

    ste_name: "FL",
  },
  {
    zip_code: "32327",

    ste_name: "FL",
  },
  {
    zip_code: "32408",

    ste_name: "FL",
  },
  {
    zip_code: "32423",

    ste_name: "FL",
  },
  {
    zip_code: "32430",

    ste_name: "FL",
  },
  {
    zip_code: "32449",

    ste_name: "FL",
  },
  {
    zip_code: "32464",

    ste_name: "FL",
  },
  {
    zip_code: "32530",

    ste_name: "FL",
  },
  {
    zip_code: "32608",

    ste_name: "FL",
  },
  {
    zip_code: "32631",

    ste_name: "FL",
  },
  {
    zip_code: "32656",

    ste_name: "FL",
  },
  {
    zip_code: "32812",

    ste_name: "FL",
  },
  {
    zip_code: "32830",

    ste_name: "FL",
  },
  {
    zip_code: "32922",

    ste_name: "FL",
  },
  {
    zip_code: "32953",

    ste_name: "FL",
  },
  {
    zip_code: "33034",

    ste_name: "FL",
  },
  {
    zip_code: "33036",

    ste_name: "FL",
  },
  {
    zip_code: "33133",

    ste_name: "FL",
  },
  {
    zip_code: "33138",

    ste_name: "FL",
  },
  {
    zip_code: "33180",

    ste_name: "FL",
  },
  {
    zip_code: "33478",

    ste_name: "FL",
  },
  {
    zip_code: "33496",

    ste_name: "FL",
  },
  {
    zip_code: "33584",

    ste_name: "FL",
  },
  {
    zip_code: "33606",

    ste_name: "FL",
  },
  {
    zip_code: "33607",

    ste_name: "FL",
  },
  {
    zip_code: "33615",

    ste_name: "FL",
  },
  {
    zip_code: "33744",

    ste_name: "FL",
  },
  {
    zip_code: "33765",

    ste_name: "FL",
  },
  {
    zip_code: "33839",

    ste_name: "FL",
  },
  {
    zip_code: "33947",

    ste_name: "FL",
  },
  {
    zip_code: "34231",

    ste_name: "FL",
  },
  {
    zip_code: "35058",

    ste_name: "AL",
  },
  {
    zip_code: "35125",

    ste_name: "AL",
  },
  {
    zip_code: "35207",

    ste_name: "AL",
  },
  {
    zip_code: "35459",

    ste_name: "AL",
  },
  {
    zip_code: "35579",

    ste_name: "AL",
  },
  {
    zip_code: "35752",

    ste_name: "AL",
  },
  {
    zip_code: "35954",

    ste_name: "AL",
  },
  {
    zip_code: "36026",

    ste_name: "AL",
  },
  {
    zip_code: "36036",

    ste_name: "AL",
  },
  {
    zip_code: "36080",

    ste_name: "AL",
  },
  {
    zip_code: "36083",

    ste_name: "AL",
  },
  {
    zip_code: "36110",

    ste_name: "AL",
  },
  {
    zip_code: "36112",

    ste_name: "AL",
  },
  {
    zip_code: "36267",

    ste_name: "AL",
  },
  {
    zip_code: "36373",

    ste_name: "AL",
  },
  {
    zip_code: "36455",

    ste_name: "AL",
  },
  {
    zip_code: "36521",

    ste_name: "AL",
  },
  {
    zip_code: "36525",

    ste_name: "AL",
  },
  {
    zip_code: "36553",

    ste_name: "AL",
  },
  {
    zip_code: "36556",

    ste_name: "AL",
  },
  {
    zip_code: "36578",

    ste_name: "AL",
  },
  {
    zip_code: "36767",

    ste_name: "AL",
  },
  {
    zip_code: "36792",

    ste_name: "AL",
  },
  {
    zip_code: "36860",

    ste_name: "AL",
  },
  {
    zip_code: "36875",

    ste_name: "AL",
  },
  {
    zip_code: "37051",

    ste_name: "TN",
  },
  {
    zip_code: "37055",

    ste_name: "TN",
  },
  {
    zip_code: "37066",

    ste_name: "TN",
  },
  {
    zip_code: "37090",

    ste_name: "TN",
  },
  {
    zip_code: "37137",

    ste_name: "TN",
  },
  {
    zip_code: "37188",

    ste_name: "TN",
  },
  {
    zip_code: "37309",

    ste_name: "TN",
  },
  {
    zip_code: "37323",

    ste_name: "TN",
  },
  {
    zip_code: "37350",

    ste_name: "TN",
  },
  {
    zip_code: "37405",

    ste_name: "TN",
  },
  {
    zip_code: "37650",

    ste_name: "TN",
  },
  {
    zip_code: "37663",

    ste_name: "TN",
  },
  {
    zip_code: "37688",

    ste_name: "TN",
  },
  {
    zip_code: "37705",

    ste_name: "TN",
  },
  {
    zip_code: "37742",

    ste_name: "TN",
  },
  {
    zip_code: "37757",

    ste_name: "TN",
  },
  {
    zip_code: "37912",

    ste_name: "TN",
  },
  {
    zip_code: "38041",

    ste_name: "TN",
  },
  {
    zip_code: "38066",

    ste_name: "TN",
  },
  {
    zip_code: "38118",

    ste_name: "TN",
  },
  {
    zip_code: "38221",

    ste_name: "TN",
  },
  {
    zip_code: "38229",

    ste_name: "TN",
  },
  {
    zip_code: "38344",

    ste_name: "TN",
  },
  {
    zip_code: "38456",

    ste_name: "TN",
  },
  {
    zip_code: "38459",

    ste_name: "TN",
  },
  {
    zip_code: "38583",

    ste_name: "TN",
  },
  {
    zip_code: "38663",

    ste_name: "MS",
  },
  {
    zip_code: "38680",

    ste_name: "MS",
  },
  {
    zip_code: "38730",

    ste_name: "MS",
  },
  {
    zip_code: "38829",

    ste_name: "MS",
  },
  {
    zip_code: "38847",

    ste_name: "MS",
  },
  {
    zip_code: "38940",

    ste_name: "MS",
  },
  {
    zip_code: "39097",

    ste_name: "MS",
  },
  {
    zip_code: "39183",

    ste_name: "MS",
  },
  {
    zip_code: "39301",

    ste_name: "MS",
  },
  {
    zip_code: "39337",

    ste_name: "MS",
  },
  {
    zip_code: "39346",

    ste_name: "MS",
  },
  {
    zip_code: "39347",

    ste_name: "MS",
  },
  {
    zip_code: "39348",

    ste_name: "MS",
  },
  {
    zip_code: "39479",

    ste_name: "MS",
  },
  {
    zip_code: "39643",

    ste_name: "MS",
  },
  {
    zip_code: "39648",

    ste_name: "MS",
  },
  {
    zip_code: "39776",

    ste_name: "MS",
  },
  {
    zip_code: "39817",

    ste_name: "GA",
  },
  {
    zip_code: "39826",

    ste_name: "GA",
  },
  {
    zip_code: "39845",

    ste_name: "GA",
  },
  {
    zip_code: "40059",

    ste_name: "KY",
  },
  {
    zip_code: "40110",

    ste_name: "KY",
  },
  {
    zip_code: "40150",

    ste_name: "KY",
  },
  {
    zip_code: "40175",

    ste_name: "KY",
  },
  {
    zip_code: "40204",

    ste_name: "KY",
  },
  {
    zip_code: "40210",

    ste_name: "KY",
  },
  {
    zip_code: "40322",

    ste_name: "KY",
  },
  {
    zip_code: "40363",

    ste_name: "KY",
  },
  {
    zip_code: "40391",

    ste_name: "KY",
  },
  {
    zip_code: "40741",

    ste_name: "KY",
  },
  {
    zip_code: "41030",

    ste_name: "KY",
  },
  {
    zip_code: "41031",

    ste_name: "KY",
  },
  {
    zip_code: "41260",

    ste_name: "KY",
  },
  {
    zip_code: "41360",

    ste_name: "KY",
  },
  {
    zip_code: "41501",

    ste_name: "KY",
  },
  {
    zip_code: "41826",

    ste_name: "KY",
  },
  {
    zip_code: "42078",

    ste_name: "KY",
  },
  {
    zip_code: "42087",

    ste_name: "KY",
  },
  {
    zip_code: "42104",

    ste_name: "KY",
  },
  {
    zip_code: "42156",

    ste_name: "KY",
  },
  {
    zip_code: "42204",

    ste_name: "KY",
  },
  {
    zip_code: "42206",

    ste_name: "KY",
  },
  {
    zip_code: "42348",

    ste_name: "KY",
  },
  {
    zip_code: "42367",

    ste_name: "KY",
  },
  {
    zip_code: "43009",

    ste_name: "OH",
  },
  {
    zip_code: "43054",

    ste_name: "OH",
  },
  {
    zip_code: "43071",

    ste_name: "OH",
  },
  {
    zip_code: "43072",

    ste_name: "OH",
  },
  {
    zip_code: "43077",

    ste_name: "OH",
  },
  {
    zip_code: "43106",

    ste_name: "OH",
  },
  {
    zip_code: "43153",

    ste_name: "OH",
  },
  {
    zip_code: "43164",

    ste_name: "OH",
  },
  {
    zip_code: "43317",

    ste_name: "OH",
  },
  {
    zip_code: "43359",

    ste_name: "OH",
  },
  {
    zip_code: "43606",

    ste_name: "OH",
  },
  {
    zip_code: "43609",

    ste_name: "OH",
  },
  {
    zip_code: "43612",

    ste_name: "OH",
  },
  {
    zip_code: "43613",

    ste_name: "OH",
  },
  {
    zip_code: "43812",

    ste_name: "OH",
  },
  {
    zip_code: "43945",

    ste_name: "OH",
  },
  {
    zip_code: "43950",

    ste_name: "OH",
  },
  {
    zip_code: "43974",

    ste_name: "OH",
  },
  {
    zip_code: "44045",

    ste_name: "OH",
  },
  {
    zip_code: "44047",

    ste_name: "OH",
  },
  {
    zip_code: "44087",

    ste_name: "OH",
  },
  {
    zip_code: "44102",

    ste_name: "OH",
  },
  {
    zip_code: "44128",

    ste_name: "OH",
  },
  {
    zip_code: "44137",

    ste_name: "OH",
  },
  {
    zip_code: "44141",

    ste_name: "OH",
  },
  {
    zip_code: "44142",

    ste_name: "OH",
  },
  {
    zip_code: "44288",

    ste_name: "OH",
  },
  {
    zip_code: "44460",

    ste_name: "OH",
  },
  {
    zip_code: "44502",

    ste_name: "OH",
  },
  {
    zip_code: "44601",

    ste_name: "OH",
  },
  {
    zip_code: "44669",

    ste_name: "OH",
  },
  {
    zip_code: "44837",

    ste_name: "OH",
  },
  {
    zip_code: "45154",

    ste_name: "OH",
  },
  {
    zip_code: "45157",

    ste_name: "OH",
  },
  {
    zip_code: "45168",

    ste_name: "OH",
  },
  {
    zip_code: "45223",

    ste_name: "OH",
  },
  {
    zip_code: "45326",

    ste_name: "OH",
  },
  {
    zip_code: "45372",

    ste_name: "OH",
  },
  {
    zip_code: "45672",

    ste_name: "OH",
  },
  {
    zip_code: "45719",

    ste_name: "OH",
  },
  {
    zip_code: "45721",

    ste_name: "OH",
  },
  {
    zip_code: "45750",

    ste_name: "OH",
  },
  {
    zip_code: "45771",

    ste_name: "OH",
  },
  {
    zip_code: "45849",

    ste_name: "OH",
  },
  {
    zip_code: "46041",

    ste_name: "IN",
  },
  {
    zip_code: "46058",

    ste_name: "IN",
  },
  {
    zip_code: "46106",

    ste_name: "IN",
  },
  {
    zip_code: "46148",

    ste_name: "IN",
  },
  {
    zip_code: "46208",

    ste_name: "IN",
  },
  {
    zip_code: "46236",

    ste_name: "IN",
  },
  {
    zip_code: "46375",

    ste_name: "IN",
  },
  {
    zip_code: "46394",

    ste_name: "IN",
  },
  {
    zip_code: "46770",

    ste_name: "IN",
  },
  {
    zip_code: "46783",

    ste_name: "IN",
  },
  {
    zip_code: "46809",

    ste_name: "IN",
  },
  {
    zip_code: "46960",

    ste_name: "IN",
  },
  {
    zip_code: "46961",

    ste_name: "IN",
  },
  {
    zip_code: "46975",

    ste_name: "IN",
  },
  {
    zip_code: "46996",

    ste_name: "IN",
  },
  {
    zip_code: "47135",

    ste_name: "IN",
  },
  {
    zip_code: "47362",

    ste_name: "IN",
  },
  {
    zip_code: "47381",

    ste_name: "IN",
  },
  {
    zip_code: "47514",

    ste_name: "IN",
  },
  {
    zip_code: "47557",

    ste_name: "IN",
  },
  {
    zip_code: "47876",

    ste_name: "IN",
  },
  {
    zip_code: "47997",

    ste_name: "IN",
  },
  {
    zip_code: "48047",

    ste_name: "MI",
  },
  {
    zip_code: "48076",

    ste_name: "MI",
  },
  {
    zip_code: "48120",

    ste_name: "MI",
  },
  {
    zip_code: "48168",

    ste_name: "MI",
  },
  {
    zip_code: "48229",

    ste_name: "MI",
  },
  {
    zip_code: "48304",

    ste_name: "MI",
  },
  {
    zip_code: "48317",

    ste_name: "MI",
  },
  {
    zip_code: "48353",

    ste_name: "MI",
  },
  {
    zip_code: "48377",

    ste_name: "MI",
  },
  {
    zip_code: "48423",

    ste_name: "MI",
  },
  {
    zip_code: "48451",

    ste_name: "MI",
  },
  {
    zip_code: "48456",

    ste_name: "MI",
  },
  {
    zip_code: "48614",

    ste_name: "MI",
  },
  {
    zip_code: "48651",

    ste_name: "MI",
  },
  {
    zip_code: "48710",

    ste_name: "MI",
  },
  {
    zip_code: "48725",

    ste_name: "MI",
  },
  {
    zip_code: "48728",

    ste_name: "MI",
  },
  {
    zip_code: "48762",

    ste_name: "MI",
  },
  {
    zip_code: "48849",

    ste_name: "MI",
  },
  {
    zip_code: "48894",

    ste_name: "MI",
  },
  {
    zip_code: "49072",

    ste_name: "MI",
  },
  {
    zip_code: "49073",

    ste_name: "MI",
  },
  {
    zip_code: "49227",

    ste_name: "MI",
  },
  {
    zip_code: "49270",

    ste_name: "MI",
  },
  {
    zip_code: "49279",

    ste_name: "MI",
  },
  {
    zip_code: "49319",

    ste_name: "MI",
  },
  {
    zip_code: "49344",

    ste_name: "MI",
  },
  {
    zip_code: "49434",

    ste_name: "MI",
  },
  {
    zip_code: "49631",

    ste_name: "MI",
  },
  {
    zip_code: "49725",

    ste_name: "MI",
  },
  {
    zip_code: "49805",

    ste_name: "MI",
  },
  {
    zip_code: "49896",

    ste_name: "MI",
  },
  {
    zip_code: "49913",

    ste_name: "MI",
  },
  {
    zip_code: "49916",

    ste_name: "MI",
  },
  {
    zip_code: "50057",

    ste_name: "IA",
  },
  {
    zip_code: "50101",

    ste_name: "IA",
  },
  {
    zip_code: "50139",

    ste_name: "IA",
  },
  {
    zip_code: "50220",

    ste_name: "IA",
  },
  {
    zip_code: "50277",

    ste_name: "IA",
  },
  {
    zip_code: "50278",

    ste_name: "IA",
  },
  {
    zip_code: "50310",

    ste_name: "IA",
  },
  {
    zip_code: "50421",

    ste_name: "IA",
  },
  {
    zip_code: "50456",

    ste_name: "IA",
  },
  {
    zip_code: "50472",

    ste_name: "IA",
  },
  {
    zip_code: "50480",

    ste_name: "IA",
  },
  {
    zip_code: "50531",

    ste_name: "IA",
  },
  {
    zip_code: "50542",

    ste_name: "IA",
  },
  {
    zip_code: "51103",

    ste_name: "IA",
  },
  {
    zip_code: "51345",

    ste_name: "IA",
  },
  {
    zip_code: "51560",

    ste_name: "IA",
  },
  {
    zip_code: "51645",

    ste_name: "IA",
  },
  {
    zip_code: "52002",

    ste_name: "IA",
  },
  {
    zip_code: "52049",

    ste_name: "IA",
  },
  {
    zip_code: "52073",

    ste_name: "IA",
  },
  {
    zip_code: "52255",

    ste_name: "IA",
  },
  {
    zip_code: "52328",

    ste_name: "IA",
  },
  {
    zip_code: "52630",

    ste_name: "IA",
  },
  {
    zip_code: "52654",

    ste_name: "IA",
  },
  {
    zip_code: "53035",

    ste_name: "WI",
  },
  {
    zip_code: "53095",

    ste_name: "WI",
  },
  {
    zip_code: "53115",

    ste_name: "WI",
  },
  {
    zip_code: "53204",

    ste_name: "WI",
  },
  {
    zip_code: "53208",

    ste_name: "WI",
  },
  {
    zip_code: "53218",

    ste_name: "WI",
  },
  {
    zip_code: "53507",

    ste_name: "WI",
  },
  {
    zip_code: "53518",

    ste_name: "WI",
  },
  {
    zip_code: "53546",

    ste_name: "WI",
  },
  {
    zip_code: "53968",

    ste_name: "WI",
  },
  {
    zip_code: "54023",

    ste_name: "WI",
  },
  {
    zip_code: "54119",

    ste_name: "WI",
  },
  {
    zip_code: "54211",

    ste_name: "WI",
  },
  {
    zip_code: "54241",

    ste_name: "WI",
  },
  {
    zip_code: "54416",

    ste_name: "WI",
  },
  {
    zip_code: "54418",

    ste_name: "WI",
  },
  {
    zip_code: "54487",

    ste_name: "WI",
  },
  {
    zip_code: "54625",

    ste_name: "WI",
  },
  {
    zip_code: "54824",

    ste_name: "WI",
  },
  {
    zip_code: "54948",

    ste_name: "WI",
  },
  {
    zip_code: "54971",

    ste_name: "WI",
  },
  {
    zip_code: "54980",

    ste_name: "WI",
  },
  {
    zip_code: "55103",

    ste_name: "MN",
  },
  {
    zip_code: "55342",

    ste_name: "MN",
  },
  {
    zip_code: "55426",

    ste_name: "MN",
  },
  {
    zip_code: "55429",

    ste_name: "MN",
  },
  {
    zip_code: "55749",

    ste_name: "MN",
  },
  {
    zip_code: "55780",

    ste_name: "MN",
  },
  {
    zip_code: "55987",

    ste_name: "MN",
  },
  {
    zip_code: "56023",

    ste_name: "MN",
  },
  {
    zip_code: "56144",

    ste_name: "MN",
  },
  {
    zip_code: "56187",

    ste_name: "MN",
  },
  {
    zip_code: "56335",

    ste_name: "MN",
  },
  {
    zip_code: "56356",

    ste_name: "MN",
  },
  {
    zip_code: "56361",

    ste_name: "MN",
  },
  {
    zip_code: "56401",

    ste_name: "MN",
  },
  {
    zip_code: "56469",

    ste_name: "MN",
  },
  {
    zip_code: "56482",

    ste_name: "MN",
  },
  {
    zip_code: "56517",

    ste_name: "MN",
  },
  {
    zip_code: "56548",

    ste_name: "MN",
  },
  {
    zip_code: "56567",

    ste_name: "MN",
  },
  {
    zip_code: "56660",

    ste_name: "MN",
  },
  {
    zip_code: "56667",

    ste_name: "MN",
  },
  {
    zip_code: "56723",

    ste_name: "MN",
  },
  {
    zip_code: "57058",

    ste_name: "SD",
  },
  {
    zip_code: "57332",

    ste_name: "SD",
  },
  {
    zip_code: "57339",

    ste_name: "SD",
  },
  {
    zip_code: "57358",

    ste_name: "SD",
  },
  {
    zip_code: "57359",

    ste_name: "SD",
  },
  {
    zip_code: "57381",

    ste_name: "SD",
  },
  {
    zip_code: "57385",

    ste_name: "SD",
  },
  {
    zip_code: "58324",

    ste_name: "ND",
  },
  {
    zip_code: "58440",

    ste_name: "ND",
  },
  {
    zip_code: "58455",

    ste_name: "ND",
  },
  {
    zip_code: "58495",

    ste_name: "ND",
  },
  {
    zip_code: "58634",

    ste_name: "ND",
  },
  {
    zip_code: "58748",

    ste_name: "ND",
  },
  {
    zip_code: "58792",

    ste_name: "ND",
  },
  {
    zip_code: "58795",

    ste_name: "ND",
  },
  {
    zip_code: "58801",

    ste_name: "ND",
  },
  {
    zip_code: "58830",

    ste_name: "ND",
  },
  {
    zip_code: "59010",

    ste_name: "MT",
  },
  {
    zip_code: "59014",

    ste_name: "MT",
  },
  {
    zip_code: "59044",

    ste_name: "MT",
  },
  {
    zip_code: "59250",

    ste_name: "MT",
  },
  {
    zip_code: "59255",

    ste_name: "MT",
  },
  {
    zip_code: "59322",

    ste_name: "MT",
  },
  {
    zip_code: "59324",

    ste_name: "MT",
  },
  {
    zip_code: "59351",

    ste_name: "MT",
  },
  {
    zip_code: "59427",

    ste_name: "MT",
  },
  {
    zip_code: "59735",

    ste_name: "MT",
  },
  {
    zip_code: "59820",

    ste_name: "MT",
  },
  {
    zip_code: "59830",

    ste_name: "MT",
  },
  {
    zip_code: "59934",

    ste_name: "MT",
  },
  {
    zip_code: "60176",

    ste_name: "IL",
  },
  {
    zip_code: "60302",

    ste_name: "IL",
  },
  {
    zip_code: "60420",

    ste_name: "IL",
  },
  {
    zip_code: "60429",

    ste_name: "IL",
  },
  {
    zip_code: "60436",

    ste_name: "IL",
  },
  {
    zip_code: "60471",

    ste_name: "IL",
  },
  {
    zip_code: "60552",

    ste_name: "IL",
  },
  {
    zip_code: "60604",

    ste_name: "IL",
  },
  {
    zip_code: "60644",

    ste_name: "IL",
  },
  {
    zip_code: "60645",

    ste_name: "IL",
  },
  {
    zip_code: "60653",

    ste_name: "IL",
  },
  {
    zip_code: "60915",

    ste_name: "IL",
  },
  {
    zip_code: "60932",

    ste_name: "IL",
  },
  {
    zip_code: "60949",

    ste_name: "IL",
  },
  {
    zip_code: "61012",

    ste_name: "IL",
  },
  {
    zip_code: "61048",

    ste_name: "IL",
  },
  {
    zip_code: "61070",

    ste_name: "IL",
  },
  {
    zip_code: "61088",

    ste_name: "IL",
  },
  {
    zip_code: "61250",

    ste_name: "IL",
  },
  {
    zip_code: "61252",

    ste_name: "IL",
  },
  {
    zip_code: "61264",

    ste_name: "IL",
  },
  {
    zip_code: "61313",

    ste_name: "IL",
  },
  {
    zip_code: "61342",

    ste_name: "IL",
  },
  {
    zip_code: "61401",

    ste_name: "IL",
  },
  {
    zip_code: "61411",

    ste_name: "IL",
  },
  {
    zip_code: "61478",

    ste_name: "IL",
  },
  {
    zip_code: "61525",

    ste_name: "IL",
  },
  {
    zip_code: "61570",

    ste_name: "IL",
  },
  {
    zip_code: "61616",

    ste_name: "IL",
  },
  {
    zip_code: "61704",

    ste_name: "IL",
  },
  {
    zip_code: "61721",

    ste_name: "IL",
  },
  {
    zip_code: "61727",

    ste_name: "IL",
  },
  {
    zip_code: "61728",

    ste_name: "IL",
  },
  {
    zip_code: "61745",

    ste_name: "IL",
  },
  {
    zip_code: "61748",

    ste_name: "IL",
  },
  {
    zip_code: "61750",

    ste_name: "IL",
  },
  {
    zip_code: "61769",

    ste_name: "IL",
  },
  {
    zip_code: "61802",

    ste_name: "IL",
  },
  {
    zip_code: "61850",

    ste_name: "IL",
  },
  {
    zip_code: "62025",

    ste_name: "IL",
  },
  {
    zip_code: "62085",

    ste_name: "IL",
  },
  {
    zip_code: "62218",

    ste_name: "IL",
  },
  {
    zip_code: "62240",

    ste_name: "IL",
  },
  {
    zip_code: "62257",

    ste_name: "IL",
  },
  {
    zip_code: "62258",

    ste_name: "IL",
  },
  {
    zip_code: "62268",

    ste_name: "IL",
  },
  {
    zip_code: "62348",

    ste_name: "IL",
  },
  {
    zip_code: "62526",

    ste_name: "IL",
  },
  {
    zip_code: "62615",

    ste_name: "IL",
  },
  {
    zip_code: "62617",

    ste_name: "IL",
  },
  {
    zip_code: "62704",

    ste_name: "IL",
  },
  {
    zip_code: "62712",

    ste_name: "IL",
  },
  {
    zip_code: "62809",

    ste_name: "IL",
  },
  {
    zip_code: "62829",

    ste_name: "IL",
  },
  {
    zip_code: "62860",

    ste_name: "IL",
  },
  {
    zip_code: "62874",

    ste_name: "IL",
  },
  {
    zip_code: "62879",

    ste_name: "IL",
  },
  {
    zip_code: "62920",

    ste_name: "IL",
  },
  {
    zip_code: "62950",

    ste_name: "IL",
  },
  {
    zip_code: "62952",

    ste_name: "IL",
  },
  {
    zip_code: "62974",

    ste_name: "IL",
  },
  {
    zip_code: "63108",

    ste_name: "MO",
  },
  {
    zip_code: "63114",

    ste_name: "MO",
  },
  {
    zip_code: "63333",

    ste_name: "MO",
  },
  {
    zip_code: "63336",

    ste_name: "MO",
  },
  {
    zip_code: "63347",

    ste_name: "MO",
  },
  {
    zip_code: "63560",

    ste_name: "MO",
  },
  {
    zip_code: "63766",

    ste_name: "MO",
  },
  {
    zip_code: "63783",

    ste_name: "MO",
  },
  {
    zip_code: "63785",

    ste_name: "MO",
  },
  {
    zip_code: "63824",

    ste_name: "MO",
  },
  {
    zip_code: "63827",

    ste_name: "MO",
  },
  {
    zip_code: "63847",

    ste_name: "MO",
  },
  {
    zip_code: "64014",

    ste_name: "MO",
  },
  {
    zip_code: "64018",

    ste_name: "MO",
  },
  {
    zip_code: "64106",

    ste_name: "MO",
  },
  {
    zip_code: "64110",

    ste_name: "MO",
  },
  {
    zip_code: "64116",

    ste_name: "MO",
  },
  {
    zip_code: "64117",

    ste_name: "MO",
  },
  {
    zip_code: "64134",

    ste_name: "MO",
  },
  {
    zip_code: "64157",

    ste_name: "MO",
  },
  {
    zip_code: "64158",

    ste_name: "MO",
  },
  {
    zip_code: "64647",

    ste_name: "MO",
  },
  {
    zip_code: "64672",

    ste_name: "MO",
  },
  {
    zip_code: "64755",

    ste_name: "MO",
  },
  {
    zip_code: "64765",

    ste_name: "MO",
  },
  {
    zip_code: "64779",

    ste_name: "MO",
  },
  {
    zip_code: "64844",

    ste_name: "MO",
  },
  {
    zip_code: "64866",

    ste_name: "MO",
  },
  {
    zip_code: "65013",

    ste_name: "MO",
  },
  {
    zip_code: "65080",

    ste_name: "MO",
  },
  {
    zip_code: "65256",

    ste_name: "MO",
  },
  {
    zip_code: "65330",

    ste_name: "MO",
  },
  {
    zip_code: "65473",

    ste_name: "MO",
  },
  {
    zip_code: "65542",

    ste_name: "MO",
  },
  {
    zip_code: "65588",

    ste_name: "MO",
  },
  {
    zip_code: "65727",

    ste_name: "MO",
  },
  {
    zip_code: "65734",

    ste_name: "MO",
  },
  {
    zip_code: "66006",

    ste_name: "KS",
  },
  {
    zip_code: "66052",

    ste_name: "KS",
  },
  {
    zip_code: "66067",

    ste_name: "KS",
  },
  {
    zip_code: "66076",

    ste_name: "KS",
  },
  {
    zip_code: "66105",

    ste_name: "KS",
  },
  {
    zip_code: "66206",

    ste_name: "KS",
  },
  {
    zip_code: "66411",

    ste_name: "KS",
  },
  {
    zip_code: "66733",

    ste_name: "KS",
  },
  {
    zip_code: "66854",

    ste_name: "KS",
  },
  {
    zip_code: "66938",

    ste_name: "KS",
  },
  {
    zip_code: "66958",

    ste_name: "KS",
  },
  {
    zip_code: "67039",

    ste_name: "KS",
  },
  {
    zip_code: "67108",

    ste_name: "KS",
  },
  {
    zip_code: "67111",

    ste_name: "KS",
  },
  {
    zip_code: "67119",

    ste_name: "KS",
  },
  {
    zip_code: "67335",

    ste_name: "KS",
  },
  {
    zip_code: "67349",

    ste_name: "KS",
  },
  {
    zip_code: "67454",

    ste_name: "KS",
  },
  {
    zip_code: "67502",

    ste_name: "KS",
  },
  {
    zip_code: "67564",

    ste_name: "KS",
  },
  {
    zip_code: "67857",

    ste_name: "KS",
  },
  {
    zip_code: "67878",

    ste_name: "KS",
  },
  {
    zip_code: "68016",

    ste_name: "NE",
  },
  {
    zip_code: "68055",

    ste_name: "NE",
  },
  {
    zip_code: "68062",

    ste_name: "NE",
  },
  {
    zip_code: "68110",

    ste_name: "NE",
  },
  {
    zip_code: "68132",

    ste_name: "NE",
  },
  {
    zip_code: "68134",

    ste_name: "NE",
  },
  {
    zip_code: "68315",

    ste_name: "NE",
  },
  {
    zip_code: "68344",

    ste_name: "NE",
  },
  {
    zip_code: "68376",

    ste_name: "NE",
  },
  {
    zip_code: "68433",

    ste_name: "NE",
  },
  {
    zip_code: "68442",

    ste_name: "NE",
  },
  {
    zip_code: "68507",

    ste_name: "NE",
  },
  {
    zip_code: "68634",

    ste_name: "NE",
  },
  {
    zip_code: "68710",

    ste_name: "NE",
  },
  {
    zip_code: "68733",

    ste_name: "NE",
  },
  {
    zip_code: "68935",

    ste_name: "NE",
  },
  {
    zip_code: "68975",

    ste_name: "NE",
  },
  {
    zip_code: "69001",

    ste_name: "NE",
  },
  {
    zip_code: "69027",

    ste_name: "NE",
  },
  {
    zip_code: "69029",

    ste_name: "NE",
  },
  {
    zip_code: "69211",

    ste_name: "NE",
  },
  {
    zip_code: "69339",

    ste_name: "NE",
  },
  {
    zip_code: "69355",

    ste_name: "NE",
  },
  {
    zip_code: "69358",

    ste_name: "NE",
  },
  {
    zip_code: "70374",

    ste_name: "LA",
  },
  {
    zip_code: "70390",

    ste_name: "LA",
  },
  {
    zip_code: "70510",

    ste_name: "LA",
  },
  {
    zip_code: "70512",

    ste_name: "LA",
  },
  {
    zip_code: "70531",

    ste_name: "LA",
  },
  {
    zip_code: "70546",

    ste_name: "LA",
  },
  {
    zip_code: "70721",

    ste_name: "LA",
  },
  {
    zip_code: "70732",

    ste_name: "LA",
  },
  {
    zip_code: "70776",

    ste_name: "LA",
  },
  {
    zip_code: "70778",

    ste_name: "LA",
  },
  {
    zip_code: "71037",

    ste_name: "LA",
  },
  {
    zip_code: "71048",

    ste_name: "LA",
  },
  {
    zip_code: "71237",

    ste_name: "LA",
  },
  {
    zip_code: "71343",

    ste_name: "LA",
  },
  {
    zip_code: "71467",

    ste_name: "LA",
  },
  {
    zip_code: "71631",

    ste_name: "AR",
  },
  {
    zip_code: "71652",

    ste_name: "AR",
  },
  {
    zip_code: "71663",

    ste_name: "AR",
  },
  {
    zip_code: "71742",

    ste_name: "AR",
  },
  {
    zip_code: "71743",

    ste_name: "AR",
  },
  {
    zip_code: "71762",

    ste_name: "AR",
  },
  {
    zip_code: "71835",

    ste_name: "AR",
  },
  {
    zip_code: "71841",

    ste_name: "AR",
  },
  {
    zip_code: "72034",

    ste_name: "AR",
  },
  {
    zip_code: "72074",

    ste_name: "AR",
  },
  {
    zip_code: "72083",

    ste_name: "AR",
  },
  {
    zip_code: "72339",

    ste_name: "AR",
  },
  {
    zip_code: "72353",

    ste_name: "AR",
  },
  {
    zip_code: "72404",

    ste_name: "AR",
  },
  {
    zip_code: "72520",

    ste_name: "AR",
  },
  {
    zip_code: "72631",

    ste_name: "AR",
  },
  {
    zip_code: "72675",

    ste_name: "AR",
  },
  {
    zip_code: "72679",

    ste_name: "AR",
  },
  {
    zip_code: "72837",

    ste_name: "AR",
  },
  {
    zip_code: "72845",

    ste_name: "AR",
  },
  {
    zip_code: "72860",

    ste_name: "AR",
  },
  {
    zip_code: "72948",

    ste_name: "AR",
  },
  {
    zip_code: "73003",

    ste_name: "OK",
  },
  {
    zip_code: "73061",

    ste_name: "OK",
  },
  {
    zip_code: "73080",

    ste_name: "OK",
  },
  {
    zip_code: "73092",

    ste_name: "OK",
  },
  {
    zip_code: "73105",

    ste_name: "OK",
  },
  {
    zip_code: "73109",

    ste_name: "OK",
  },
  {
    zip_code: "73530",

    ste_name: "OK",
  },
  {
    zip_code: "73717",

    ste_name: "OK",
  },
  {
    zip_code: "73744",

    ste_name: "OK",
  },
  {
    zip_code: "73841",

    ste_name: "OK",
  },
  {
    zip_code: "74032",

    ste_name: "OK",
  },
  {
    zip_code: "74033",

    ste_name: "OK",
  },
  {
    zip_code: "74048",

    ste_name: "OK",
  },
  {
    zip_code: "74062",

    ste_name: "OK",
  },
  {
    zip_code: "74116",

    ste_name: "OK",
  },
  {
    zip_code: "74421",

    ste_name: "OK",
  },
  {
    zip_code: "74455",

    ste_name: "OK",
  },
  {
    zip_code: "74525",

    ste_name: "OK",
  },
  {
    zip_code: "74576",

    ste_name: "OK",
  },
  {
    zip_code: "74839",

    ste_name: "OK",
  },
  {
    zip_code: "74868",

    ste_name: "OK",
  },
  {
    zip_code: "74871",

    ste_name: "OK",
  },
  {
    zip_code: "74881",

    ste_name: "OK",
  },
  {
    zip_code: "75009",

    ste_name: "TX",
  },
  {
    zip_code: "75094",

    ste_name: "TX",
  },
  {
    zip_code: "75165",

    ste_name: "TX",
  },
  {
    zip_code: "75169",

    ste_name: "TX",
  },
  {
    zip_code: "75205",

    ste_name: "TX",
  },
  {
    zip_code: "75209",

    ste_name: "TX",
  },
  {
    zip_code: "75287",

    ste_name: "TX",
  },
  {
    zip_code: "75601",

    ste_name: "TX",
  },
  {
    zip_code: "75638",

    ste_name: "TX",
  },
  {
    zip_code: "75778",

    ste_name: "TX",
  },
  {
    zip_code: "75784",

    ste_name: "TX",
  },
  {
    zip_code: "75853",

    ste_name: "TX",
  },
  {
    zip_code: "75960",

    ste_name: "TX",
  },
  {
    zip_code: "75975",

    ste_name: "TX",
  },
  {
    zip_code: "76114",

    ste_name: "TX",
  },
  {
    zip_code: "76205",

    ste_name: "TX",
  },
  {
    zip_code: "76263",

    ste_name: "TX",
  },
  {
    zip_code: "76310",

    ste_name: "TX",
  },
  {
    zip_code: "76380",

    ste_name: "TX",
  },
  {
    zip_code: "76389",

    ste_name: "TX",
  },
  {
    zip_code: "76454",

    ste_name: "TX",
  },
  {
    zip_code: "76626",

    ste_name: "TX",
  },
  {
    zip_code: "76631",

    ste_name: "TX",
  },
  {
    zip_code: "76820",

    ste_name: "TX",
  },
  {
    zip_code: "76887",

    ste_name: "TX",
  },
  {
    zip_code: "77023",

    ste_name: "TX",
  },
  {
    zip_code: "77063",

    ste_name: "TX",
  },
  {
    zip_code: "77066",

    ste_name: "TX",
  },
  {
    zip_code: "77088",

    ste_name: "TX",
  },
  {
    zip_code: "77304",

    ste_name: "TX",
  },
  {
    zip_code: "77327",

    ste_name: "TX",
  },
  {
    zip_code: "77335",

    ste_name: "TX",
  },
  {
    zip_code: "77432",

    ste_name: "TX",
  },
  {
    zip_code: "77436",

    ste_name: "TX",
  },
  {
    zip_code: "77445",

    ste_name: "TX",
  },
  {
    zip_code: "77449",

    ste_name: "TX",
  },
  {
    zip_code: "77494",

    ste_name: "TX",
  },
  {
    zip_code: "77517",

    ste_name: "TX",
  },
  {
    zip_code: "77533",

    ste_name: "TX",
  },
  {
    zip_code: "77624",

    ste_name: "TX",
  },
  {
    zip_code: "77660",

    ste_name: "TX",
  },
  {
    zip_code: "77713",

    ste_name: "TX",
  },
  {
    zip_code: "77831",

    ste_name: "TX",
  },
  {
    zip_code: "77833",

    ste_name: "TX",
  },
  {
    zip_code: "77880",

    ste_name: "TX",
  },
  {
    zip_code: "78023",

    ste_name: "TX",
  },
  {
    zip_code: "78041",

    ste_name: "TX",
  },
  {
    zip_code: "78044",

    ste_name: "TX",
  },
  {
    zip_code: "78045",

    ste_name: "TX",
  },
  {
    zip_code: "78057",

    ste_name: "TX",
  },
  {
    zip_code: "78069",

    ste_name: "TX",
  },
  {
    zip_code: "78228",

    ste_name: "TX",
  },
  {
    zip_code: "78236",

    ste_name: "TX",
  },
  {
    zip_code: "78259",

    ste_name: "TX",
  },
  {
    zip_code: "78406",

    ste_name: "TX",
  },
  {
    zip_code: "78516",

    ste_name: "TX",
  },
  {
    zip_code: "78559",

    ste_name: "TX",
  },
  {
    zip_code: "78566",

    ste_name: "TX",
  },
  {
    zip_code: "78719",

    ste_name: "TX",
  },
  {
    zip_code: "78732",

    ste_name: "TX",
  },
  {
    zip_code: "78736",

    ste_name: "TX",
  },
  {
    zip_code: "78861",

    ste_name: "TX",
  },
  {
    zip_code: "79041",

    ste_name: "TX",
  },
  {
    zip_code: "79118",

    ste_name: "TX",
  },
  {
    zip_code: "79230",

    ste_name: "TX",
  },
  {
    zip_code: "79234",

    ste_name: "TX",
  },
  {
    zip_code: "79245",

    ste_name: "TX",
  },
  {
    zip_code: "79247",

    ste_name: "TX",
  },
  {
    zip_code: "79248",

    ste_name: "TX",
  },
  {
    zip_code: "79377",

    ste_name: "TX",
  },
  {
    zip_code: "79543",

    ste_name: "TX",
  },
  {
    zip_code: "79731",

    ste_name: "TX",
  },
  {
    zip_code: "79922",

    ste_name: "TX",
  },
  {
    zip_code: "80005",

    ste_name: "CO",
  },
  {
    zip_code: "80023",

    ste_name: "CO",
  },
  {
    zip_code: "80127",

    ste_name: "CO",
  },
  {
    zip_code: "80132",

    ste_name: "CO",
  },
  {
    zip_code: "80220",

    ste_name: "CO",
  },
  {
    zip_code: "80233",

    ste_name: "CO",
  },
  {
    zip_code: "80454",

    ste_name: "CO",
  },
  {
    zip_code: "80470",

    ste_name: "CO",
  },
  {
    zip_code: "80478",

    ste_name: "CO",
  },
  {
    zip_code: "80497",

    ste_name: "CO",
  },
  {
    zip_code: "80515",

    ste_name: "CO",
  },
  {
    zip_code: "80516",

    ste_name: "CO",
  },
  {
    zip_code: "80525",

    ste_name: "CO",
  },
  {
    zip_code: "80645",

    ste_name: "CO",
  },
  {
    zip_code: "80654",

    ste_name: "CO",
  },
  {
    zip_code: "80740",

    ste_name: "CO",
  },
  {
    zip_code: "80823",

    ste_name: "CO",
  },
  {
    zip_code: "80836",

    ste_name: "CO",
  },
  {
    zip_code: "80840",

    ste_name: "CO",
  },
  {
    zip_code: "80938",

    ste_name: "CO",
  },
  {
    zip_code: "81001",

    ste_name: "CO",
  },
  {
    zip_code: "81090",

    ste_name: "CO",
  },
  {
    zip_code: "81242",

    ste_name: "CO",
  },
  {
    zip_code: "81243",

    ste_name: "CO",
  },
  {
    zip_code: "81251",

    ste_name: "CO",
  },
  {
    zip_code: "81501",

    ste_name: "CO",
  },
  {
    zip_code: "82051",

    ste_name: "WY",
  },
  {
    zip_code: "82710",

    ste_name: "WY",
  },
  {
    zip_code: "82718",

    ste_name: "WY",
  },
  {
    zip_code: "83113",

    ste_name: "WY",
  },
  {
    zip_code: "83445",

    ste_name: "ID",
  },
  {
    zip_code: "83803",

    ste_name: "ID",
  },
  {
    zip_code: "83804",

    ste_name: "ID",
  },
  {
    zip_code: "83822",

    ste_name: "ID",
  },
  {
    zip_code: "83844",

    ste_name: "ID",
  },
  {
    zip_code: "83845",

    ste_name: "ID",
  },
  {
    zip_code: "83851",

    ste_name: "ID",
  },
  {
    zip_code: "84035",

    ste_name: "UT",
  },
  {
    zip_code: "84071",

    ste_name: "UT",
  },
  {
    zip_code: "84321",

    ste_name: "UT",
  },
  {
    zip_code: "84334",

    ste_name: "UT",
  },
  {
    zip_code: "84526",

    ste_name: "UT",
  },
  {
    zip_code: "84539",

    ste_name: "UT",
  },
  {
    zip_code: "84635",

    ste_name: "UT",
  },
  {
    zip_code: "84640",

    ste_name: "UT",
  },
  {
    zip_code: "84733",

    ste_name: "UT",
  },
  {
    zip_code: "84784",

    ste_name: "UT",
  },
  {
    zip_code: "85033",

    ste_name: "AZ",
  },
  {
    zip_code: "85054",

    ste_name: "AZ",
  },
  {
    zip_code: "85138",

    ste_name: "AZ",
  },
  {
    zip_code: "85193",

    ste_name: "AZ",
  },
  {
    zip_code: "85321",

    ste_name: "AZ",
  },
  {
    zip_code: "85363",

    ste_name: "AZ",
  },
  {
    zip_code: "85377",

    ste_name: "AZ",
  },
  {
    zip_code: "85608",

    ste_name: "AZ",
  },
  {
    zip_code: "85617",

    ste_name: "AZ",
  },
  {
    zip_code: "85621",

    ste_name: "AZ",
  },
  {
    zip_code: "85930",

    ste_name: "AZ",
  },
  {
    zip_code: "86033",

    ste_name: "AZ",
  },
  {
    zip_code: "86301",

    ste_name: "AZ",
  },
  {
    zip_code: "86322",

    ste_name: "AZ",
  },
  {
    zip_code: "86508",

    ste_name: "AZ",
  },
  {
    zip_code: "87006",

    ste_name: "NM",
  },
  {
    zip_code: "87018",

    ste_name: "NM",
  },
  {
    zip_code: "87121",

    ste_name: "NM",
  },
  {
    zip_code: "87305",

    ste_name: "NM",
  },
  {
    zip_code: "87323",

    ste_name: "NM",
  },
  {
    zip_code: "87328",

    ste_name: "NM",
  },
  {
    zip_code: "87505",

    ste_name: "NM",
  },
  {
    zip_code: "87527",

    ste_name: "NM",
  },
  {
    zip_code: "87531",

    ste_name: "NM",
  },
  {
    zip_code: "87823",

    ste_name: "NM",
  },
  {
    zip_code: "87829",

    ste_name: "NM",
  },
  {
    zip_code: "88034",

    ste_name: "NM",
  },
  {
    zip_code: "88061",

    ste_name: "NM",
  },
  {
    zip_code: "88113",

    ste_name: "NM",
  },
  {
    zip_code: "88401",

    ste_name: "NM",
  },
  {
    zip_code: "89003",

    ste_name: "NV",
  },
  {
    zip_code: "89018",

    ste_name: "NV",
  },
  {
    zip_code: "89149",

    ste_name: "NV",
  },
  {
    zip_code: "89314",

    ste_name: "NV",
  },
  {
    zip_code: "89409",

    ste_name: "NV",
  },
  {
    zip_code: "89439",

    ste_name: "NV",
  },
  {
    zip_code: "89831",

    ste_name: "NV",
  },
  {
    zip_code: "90064",

    ste_name: "CA",
  },
  {
    zip_code: "90270",

    ste_name: "CA",
  },
  {
    zip_code: "91105",

    ste_name: "CA",
  },
  {
    zip_code: "91203",

    ste_name: "CA",
  },
  {
    zip_code: "91403",

    ste_name: "CA",
  },
  {
    zip_code: "91502",

    ste_name: "CA",
  },
  {
    zip_code: "91606",

    ste_name: "CA",
  },
  {
    zip_code: "91739",

    ste_name: "CA",
  },
  {
    zip_code: "91763",

    ste_name: "CA",
  },
  {
    zip_code: "91780",

    ste_name: "CA",
  },
  {
    zip_code: "91911",

    ste_name: "CA",
  },
  {
    zip_code: "91932",

    ste_name: "CA",
  },
  {
    zip_code: "92020",

    ste_name: "CA",
  },
  {
    zip_code: "92027",

    ste_name: "CA",
  },
  {
    zip_code: "92101",

    ste_name: "CA",
  },
  {
    zip_code: "92257",

    ste_name: "CA",
  },
  {
    zip_code: "92307",

    ste_name: "CA",
  },
  {
    zip_code: "92352",

    ste_name: "CA",
  },
  {
    zip_code: "92389",

    ste_name: "CA",
  },
  {
    zip_code: "92506",

    ste_name: "CA",
  },
  {
    zip_code: "92802",

    ste_name: "CA",
  },
  {
    zip_code: "93023",

    ste_name: "CA",
  },
  {
    zip_code: "93267",

    ste_name: "CA",
  },
  {
    zip_code: "93433",

    ste_name: "CA",
  },
  {
    zip_code: "93544",

    ste_name: "CA",
  },
  {
    zip_code: "93549",

    ste_name: "CA",
  },
  {
    zip_code: "93726",

    ste_name: "CA",
  },
  {
    zip_code: "93950",

    ste_name: "CA",
  },
  {
    zip_code: "94503",

    ste_name: "CA",
  },
  {
    zip_code: "94531",

    ste_name: "CA",
  },
  {
    zip_code: "94549",

    ste_name: "CA",
  },
  {
    zip_code: "94619",

    ste_name: "CA",
  },
  {
    zip_code: "94709",

    ste_name: "CA",
  },
  {
    zip_code: "94710",

    ste_name: "CA",
  },
  {
    zip_code: "94720",

    ste_name: "CA",
  },
  {
    zip_code: "94933",

    ste_name: "CA",
  },
  {
    zip_code: "94951",

    ste_name: "CA",
  },
  {
    zip_code: "95037",

    ste_name: "CA",
  },
  {
    zip_code: "95050",

    ste_name: "CA",
  },
  {
    zip_code: "95110",

    ste_name: "CA",
  },
  {
    zip_code: "95121",

    ste_name: "CA",
  },
  {
    zip_code: "95140",

    ste_name: "CA",
  },
  {
    zip_code: "95234",

    ste_name: "CA",
  },
  {
    zip_code: "95252",

    ste_name: "CA",
  },
  {
    zip_code: "95310",

    ste_name: "CA",
  },
  {
    zip_code: "95320",

    ste_name: "CA",
  },
  {
    zip_code: "95363",

    ste_name: "CA",
  },
  {
    zip_code: "95470",

    ste_name: "CA",
  },
  {
    zip_code: "95511",

    ste_name: "CA",
  },
  {
    zip_code: "95521",

    ste_name: "CA",
  },
  {
    zip_code: "95556",

    ste_name: "CA",
  },
  {
    zip_code: "95564",

    ste_name: "CA",
  },
  {
    zip_code: "95608",

    ste_name: "CA",
  },
  {
    zip_code: "95612",

    ste_name: "CA",
  },
  {
    zip_code: "95624",

    ste_name: "CA",
  },
  {
    zip_code: "95632",

    ste_name: "CA",
  },
  {
    zip_code: "95675",

    ste_name: "CA",
  },
  {
    zip_code: "95811",

    ste_name: "CA",
  },
  {
    zip_code: "95816",

    ste_name: "CA",
  },
  {
    zip_code: "95824",

    ste_name: "CA",
  },
  {
    zip_code: "95959",

    ste_name: "CA",
  },
  {
    zip_code: "96010",

    ste_name: "CA",
  },
  {
    zip_code: "96035",

    ste_name: "CA",
  },
  {
    zip_code: "96037",

    ste_name: "CA",
  },
  {
    zip_code: "96039",

    ste_name: "CA",
  },
  {
    zip_code: "96068",

    ste_name: "CA",
  },
  {
    zip_code: "96703",

    ste_name: "HI",
  },
  {
    zip_code: "96774",

    ste_name: "HI",
  },
  {
    zip_code: "97138",

    ste_name: "OR",
  },
  {
    zip_code: "97220",

    ste_name: "OR",
  },
  {
    zip_code: "97325",

    ste_name: "OR",
  },
  {
    zip_code: "97348",

    ste_name: "OR",
  },
  {
    zip_code: "97377",

    ste_name: "OR",
  },
  {
    zip_code: "97413",

    ste_name: "OR",
  },
  {
    zip_code: "97446",

    ste_name: "OR",
  },
  {
    zip_code: "97476",

    ste_name: "OR",
  },
  {
    zip_code: "97489",

    ste_name: "OR",
  },
  {
    zip_code: "97523",

    ste_name: "OR",
  },
  {
    zip_code: "97639",

    ste_name: "OR",
  },
  {
    zip_code: "97907",

    ste_name: "OR",
  },
  {
    zip_code: "97918",

    ste_name: "OR",
  },
  {
    zip_code: "98050",

    ste_name: "WA",
  },
  {
    zip_code: "98075",

    ste_name: "WA",
  },
  {
    zip_code: "98092",

    ste_name: "WA",
  },
  {
    zip_code: "98144",

    ste_name: "WA",
  },
  {
    zip_code: "98270",

    ste_name: "WA",
  },
  {
    zip_code: "98340",

    ste_name: "WA",
  },
  {
    zip_code: "57457",

    ste_name: "SD",
  },
  {
    zip_code: "57703",

    ste_name: "SD",
  },
  {
    zip_code: "57769",

    ste_name: "SD",
  },
  {
    zip_code: "58049",

    ste_name: "ND",
  },
  {
    zip_code: "58063",

    ste_name: "ND",
  },
  {
    zip_code: "58205",

    ste_name: "ND",
  },
  {
    zip_code: "58237",

    ste_name: "ND",
  },
  {
    zip_code: "58351",

    ste_name: "ND",
  },
  {
    zip_code: "58460",

    ste_name: "ND",
  },
  {
    zip_code: "98383",

    ste_name: "WA",
  },
  {
    zip_code: "98581",

    ste_name: "WA",
  },
  {
    zip_code: "98674",

    ste_name: "WA",
  },
  {
    zip_code: "98830",

    ste_name: "WA",
  },
  {
    zip_code: "98853",

    ste_name: "WA",
  },
  {
    zip_code: "98922",

    ste_name: "WA",
  },
  {
    zip_code: "99009",

    ste_name: "WA",
  },
  {
    zip_code: "99113",

    ste_name: "WA",
  },
  {
    zip_code: "99130",

    ste_name: "WA",
  },
  {
    zip_code: "99164",

    ste_name: "WA",
  },
  {
    zip_code: "99202",

    ste_name: "WA",
  },
  {
    zip_code: "99204",

    ste_name: "WA",
  },
  {
    zip_code: "99335",

    ste_name: "WA",
  },
  {
    zip_code: "99336",

    ste_name: "WA",
  },
  {
    zip_code: "99401",

    ste_name: "WA",
  },
  {
    zip_code: "99622",

    ste_name: "AK",
  },
  {
    zip_code: "99669",

    ste_name: "AK",
  },
  {
    zip_code: "99746",

    ste_name: "AK",
  },
  {
    zip_code: "99747",

    ste_name: "AK",
  },
  {
    zip_code: "99757",

    ste_name: "AK",
  },
  {
    zip_code: "99833",

    ste_name: "AK",
  },
  {
    zip_code: "99919",

    ste_name: "AK",
  },
  {
    zip_code: "647",

    ste_name: "PR",
  },
  {
    zip_code: "688",

    ste_name: "PR",
  },
  {
    zip_code: "693",

    ste_name: "PR",
  },
  {
    zip_code: "754",

    ste_name: "PR",
  },
  {
    zip_code: "778",

    ste_name: "PR",
  },
  {
    zip_code: "913",

    ste_name: "PR",
  },
  {
    zip_code: "926",

    ste_name: "PR",
  },
  {
    zip_code: "1054",

    ste_name: "MA",
  },
  {
    zip_code: "1072",

    ste_name: "MA",
  },
  {
    zip_code: "1084",

    ste_name: "MA",
  },
  {
    zip_code: "1109",

    ste_name: "MA",
  },
  {
    zip_code: "1226",

    ste_name: "MA",
  },
  {
    zip_code: "1242",

    ste_name: "MA",
  },
  {
    zip_code: "1257",

    ste_name: "MA",
  },
  {
    zip_code: "1370",

    ste_name: "MA",
  },
  {
    zip_code: "1373",

    ste_name: "MA",
  },
  {
    zip_code: "1609",

    ste_name: "MA",
  },
  {
    zip_code: "1740",

    ste_name: "MA",
  },
  {
    zip_code: "1904",

    ste_name: "MA",
  },
  {
    zip_code: "2047",

    ste_name: "MA",
  },
  {
    zip_code: "2048",

    ste_name: "MA",
  },
  {
    zip_code: "2067",

    ste_name: "MA",
  },
  {
    zip_code: "2169",

    ste_name: "MA",
  },
  {
    zip_code: "2199",

    ste_name: "MA",
  },
  {
    zip_code: "2370",

    ste_name: "MA",
  },
  {
    zip_code: "2561",

    ste_name: "MA",
  },
  {
    zip_code: "2723",

    ste_name: "MA",
  },
  {
    zip_code: "2767",

    ste_name: "MA",
  },
  {
    zip_code: "2835",

    ste_name: "RI",
  },
  {
    zip_code: "2886",

    ste_name: "RI",
  },
  {
    zip_code: "2892",

    ste_name: "RI",
  },
  {
    zip_code: "3032",

    ste_name: "NH",
  },
  {
    zip_code: "3060",

    ste_name: "NH",
  },
  {
    zip_code: "3244",

    ste_name: "NH",
  },
  {
    zip_code: "3582",

    ste_name: "NH",
  },
  {
    zip_code: "3592",

    ste_name: "NH",
  },
  {
    zip_code: "3768",

    ste_name: "NH",
  },
  {
    zip_code: "3816",

    ste_name: "NH",
  },
  {
    zip_code: "3827",

    ste_name: "NH",
  },
  {
    zip_code: "3858",

    ste_name: "NH",
  },
  {
    zip_code: "3862",

    ste_name: "NH",
  },
  {
    zip_code: "3903",

    ste_name: "ME",
  },
  {
    zip_code: "4009",

    ste_name: "ME",
  },
  {
    zip_code: "4048",

    ste_name: "ME",
  },
  {
    zip_code: "4057",

    ste_name: "ME",
  },
  {
    zip_code: "4250",

    ste_name: "ME",
  },
  {
    zip_code: "4290",

    ste_name: "ME",
  },
  {
    zip_code: "4354",

    ste_name: "ME",
  },
  {
    zip_code: "4358",

    ste_name: "ME",
  },
  {
    zip_code: "4453",

    ste_name: "ME",
  },
  {
    zip_code: "4475",

    ste_name: "ME",
  },
  {
    zip_code: "4571",

    ste_name: "ME",
  },
  {
    zip_code: "4645",

    ste_name: "ME",
  },
  {
    zip_code: "4667",

    ste_name: "ME",
  },
  {
    zip_code: "4736",

    ste_name: "ME",
  },
  {
    zip_code: "4951",

    ste_name: "ME",
  },
  {
    zip_code: "4979",

    ste_name: "ME",
  },
  {
    zip_code: "5035",

    ste_name: "VT",
  },
  {
    zip_code: "5091",

    ste_name: "VT",
  },
  {
    zip_code: "5251",

    ste_name: "VT",
  },
  {
    zip_code: "5359",

    ste_name: "VT",
  },
  {
    zip_code: "5650",

    ste_name: "VT",
  },
  {
    zip_code: "5651",

    ste_name: "VT",
  },
  {
    zip_code: "5658",

    ste_name: "VT",
  },
  {
    zip_code: "5736",

    ste_name: "VT",
  },
  {
    zip_code: "6018",

    ste_name: "CT",
  },
  {
    zip_code: "6035",

    ste_name: "CT",
  },
  {
    zip_code: "6065",

    ste_name: "CT",
  },
  {
    zip_code: "6070",

    ste_name: "CT",
  },
  {
    zip_code: "6249",

    ste_name: "CT",
  },
  {
    zip_code: "6260",

    ste_name: "CT",
  },
  {
    zip_code: "6461",

    ste_name: "CT",
  },
  {
    zip_code: "6489",

    ste_name: "CT",
  },
  {
    zip_code: "6525",

    ste_name: "CT",
  },
  {
    zip_code: "6608",

    ste_name: "CT",
  },
  {
    zip_code: "6752",

    ste_name: "CT",
  },
  {
    zip_code: "6777",

    ste_name: "CT",
  },
  {
    zip_code: "6812",

    ste_name: "CT",
  },
  {
    zip_code: "6825",

    ste_name: "CT",
  },
  {
    zip_code: "7062",

    ste_name: "NJ",
  },
  {
    zip_code: "7203",

    ste_name: "NJ",
  },
  {
    zip_code: "7208",

    ste_name: "NJ",
  },
  {
    zip_code: "7432",

    ste_name: "NJ",
  },
  {
    zip_code: "7495",

    ste_name: "NJ",
  },
  {
    zip_code: "7505",

    ste_name: "NJ",
  },
  {
    zip_code: "7666",

    ste_name: "NJ",
  },
  {
    zip_code: "7732",

    ste_name: "NJ",
  },
  {
    zip_code: "7820",

    ste_name: "NJ",
  },
  {
    zip_code: "7852",

    ste_name: "NJ",
  },
  {
    zip_code: "7934",

    ste_name: "NJ",
  },
  {
    zip_code: "8036",

    ste_name: "NJ",
  },
  {
    zip_code: "8059",

    ste_name: "NJ",
  },
  {
    zip_code: "8097",

    ste_name: "NJ",
  },
  {
    zip_code: "8102",

    ste_name: "NJ",
  },
  {
    zip_code: "8234",

    ste_name: "NJ",
  },
  {
    zip_code: "8352",

    ste_name: "NJ",
  },
  {
    zip_code: "8515",

    ste_name: "NJ",
  },
  {
    zip_code: "8550",

    ste_name: "NJ",
  },
  {
    zip_code: "8724",

    ste_name: "NJ",
  },
  {
    zip_code: "8759",

    ste_name: "NJ",
  },
  {
    zip_code: "8808",

    ste_name: "NJ",
  },
  {
    zip_code: "10017",

    ste_name: "NY",
  },
  {
    zip_code: "10038",

    ste_name: "NY",
  },
  {
    zip_code: "10173",

    ste_name: "NY",
  },
  {
    zip_code: "10509",

    ste_name: "NY",
  },
  {
    zip_code: "10545",

    ste_name: "NY",
  },
  {
    zip_code: "10562",

    ste_name: "NY",
  },
  {
    zip_code: "10566",

    ste_name: "NY",
  },
  {
    zip_code: "10918",

    ste_name: "NY",
  },
  {
    zip_code: "10925",

    ste_name: "NY",
  },
  {
    zip_code: "10963",

    ste_name: "NY",
  },
  {
    zip_code: "11210",

    ste_name: "NY",
  },
  {
    zip_code: "11222",

    ste_name: "NY",
  },
  {
    zip_code: "11233",

    ste_name: "NY",
  },
  {
    zip_code: "11373",

    ste_name: "NY",
  },
  {
    zip_code: "11421",

    ste_name: "NY",
  },
  {
    zip_code: "11434",

    ste_name: "NY",
  },
  {
    zip_code: "11722",

    ste_name: "NY",
  },
  {
    zip_code: "11740",

    ste_name: "NY",
  },
  {
    zip_code: "11758",

    ste_name: "NY",
  },
  {
    zip_code: "11801",

    ste_name: "NY",
  },
  {
    zip_code: "11940",

    ste_name: "NY",
  },
  {
    zip_code: "11947",

    ste_name: "NY",
  },
  {
    zip_code: "12035",

    ste_name: "NY",
  },
  {
    zip_code: "12040",

    ste_name: "NY",
  },
  {
    zip_code: "12054",

    ste_name: "NY",
  },
  {
    zip_code: "12089",

    ste_name: "NY",
  },
  {
    zip_code: "12149",

    ste_name: "NY",
  },
  {
    zip_code: "12160",

    ste_name: "NY",
  },
  {
    zip_code: "12193",

    ste_name: "NY",
  },
  {
    zip_code: "12304",

    ste_name: "NY",
  },
  {
    zip_code: "12435",

    ste_name: "NY",
  },
  {
    zip_code: "12472",

    ste_name: "NY",
  },
  {
    zip_code: "12473",

    ste_name: "NY",
  },
  {
    zip_code: "12512",

    ste_name: "NY",
  },
  {
    zip_code: "12531",

    ste_name: "NY",
  },
  {
    zip_code: "12785",

    ste_name: "NY",
  },
  {
    zip_code: "12835",

    ste_name: "NY",
  },
  {
    zip_code: "12852",

    ste_name: "NY",
  },
  {
    zip_code: "12989",

    ste_name: "NY",
  },
  {
    zip_code: "13032",

    ste_name: "NY",
  },
  {
    zip_code: "13084",

    ste_name: "NY",
  },
  {
    zip_code: "13141",

    ste_name: "NY",
  },
  {
    zip_code: "13308",

    ste_name: "NY",
  },
  {
    zip_code: "13321",

    ste_name: "NY",
  },
  {
    zip_code: "13333",

    ste_name: "NY",
  },
  {
    zip_code: "13363",

    ste_name: "NY",
  },
  {
    zip_code: "13421",

    ste_name: "NY",
  },
  {
    zip_code: "13618",

    ste_name: "NY",
  },
  {
    zip_code: "13679",

    ste_name: "NY",
  },
  {
    zip_code: "13692",

    ste_name: "NY",
  },
  {
    zip_code: "13802",

    ste_name: "NY",
  },
  {
    zip_code: "13803",

    ste_name: "NY",
  },
  {
    zip_code: "13838",

    ste_name: "NY",
  },
  {
    zip_code: "13841",

    ste_name: "NY",
  },
  {
    zip_code: "13901",

    ste_name: "NY",
  },
  {
    zip_code: "13905",

    ste_name: "NY",
  },
  {
    zip_code: "14048",

    ste_name: "NY",
  },
  {
    zip_code: "14070",

    ste_name: "NY",
  },
  {
    zip_code: "14127",

    ste_name: "NY",
  },
  {
    zip_code: "14203",

    ste_name: "NY",
  },
  {
    zip_code: "14208",

    ste_name: "NY",
  },
  {
    zip_code: "14432",

    ste_name: "NY",
  },
  {
    zip_code: "14450",

    ste_name: "NY",
  },
  {
    zip_code: "14504",

    ste_name: "NY",
  },
  {
    zip_code: "14589",

    ste_name: "NY",
  },
  {
    zip_code: "14614",

    ste_name: "NY",
  },
  {
    zip_code: "14711",

    ste_name: "NY",
  },
  {
    zip_code: "14736",

    ste_name: "NY",
  },
  {
    zip_code: "14806",

    ste_name: "NY",
  },
  {
    zip_code: "14814",

    ste_name: "NY",
  },
  {
    zip_code: "14821",

    ste_name: "NY",
  },
  {
    zip_code: "14865",

    ste_name: "NY",
  },
  {
    zip_code: "14869",

    ste_name: "NY",
  },
  {
    zip_code: "15003",

    ste_name: "PA",
  },
  {
    zip_code: "15014",

    ste_name: "PA",
  },
  {
    zip_code: "15064",

    ste_name: "PA",
  },
  {
    zip_code: "15081",

    ste_name: "PA",
  },
  {
    zip_code: "15102",

    ste_name: "PA",
  },
  {
    zip_code: "15137",

    ste_name: "PA",
  },
  {
    zip_code: "15204",

    ste_name: "PA",
  },
  {
    zip_code: "15221",

    ste_name: "PA",
  },
  {
    zip_code: "15333",

    ste_name: "PA",
  },
  {
    zip_code: "15340",

    ste_name: "PA",
  },
  {
    zip_code: "15370",

    ste_name: "PA",
  },
  {
    zip_code: "15377",

    ste_name: "PA",
  },
  {
    zip_code: "15480",

    ste_name: "PA",
  },
  {
    zip_code: "15640",

    ste_name: "PA",
  },
  {
    zip_code: "15660",

    ste_name: "PA",
  },
  {
    zip_code: "15680",

    ste_name: "PA",
  },
  {
    zip_code: "15690",

    ste_name: "PA",
  },
  {
    zip_code: "15701",

    ste_name: "PA",
  },
  {
    zip_code: "15712",

    ste_name: "PA",
  },
  {
    zip_code: "15754",

    ste_name: "PA",
  },
  {
    zip_code: "15756",

    ste_name: "PA",
  },
  {
    zip_code: "15851",

    ste_name: "PA",
  },
  {
    zip_code: "15955",

    ste_name: "PA",
  },
  {
    zip_code: "16040",

    ste_name: "PA",
  },
  {
    zip_code: "16211",

    ste_name: "PA",
  },
  {
    zip_code: "16232",

    ste_name: "PA",
  },
  {
    zip_code: "16343",

    ste_name: "PA",
  },
  {
    zip_code: "16667",

    ste_name: "PA",
  },
  {
    zip_code: "16694",

    ste_name: "PA",
  },
  {
    zip_code: "16748",

    ste_name: "PA",
  },
  {
    zip_code: "16823",

    ste_name: "PA",
  },
  {
    zip_code: "16859",

    ste_name: "PA",
  },
  {
    zip_code: "16926",

    ste_name: "PA",
  },
  {
    zip_code: "16928",

    ste_name: "PA",
  },
  {
    zip_code: "16936",

    ste_name: "PA",
  },
  {
    zip_code: "17004",

    ste_name: "PA",
  },
  {
    zip_code: "17050",

    ste_name: "PA",
  },
  {
    zip_code: "17057",

    ste_name: "PA",
  },
  {
    zip_code: "17064",

    ste_name: "PA",
  },
  {
    zip_code: "17069",

    ste_name: "PA",
  },
  {
    zip_code: "17071",

    ste_name: "PA",
  },
  {
    zip_code: "17084",

    ste_name: "PA",
  },
  {
    zip_code: "17202",

    ste_name: "PA",
  },
  {
    zip_code: "17250",

    ste_name: "PA",
  },
  {
    zip_code: "17315",

    ste_name: "PA",
  },
  {
    zip_code: "17356",

    ste_name: "PA",
  },
  {
    zip_code: "17404",

    ste_name: "PA",
  },
  {
    zip_code: "17702",

    ste_name: "PA",
  },
  {
    zip_code: "17777",

    ste_name: "PA",
  },
  {
    zip_code: "17778",

    ste_name: "PA",
  },
  {
    zip_code: "17936",

    ste_name: "PA",
  },
  {
    zip_code: "17963",

    ste_name: "PA",
  },
  {
    zip_code: "18222",

    ste_name: "PA",
  },
  {
    zip_code: "18230",

    ste_name: "PA",
  },
  {
    zip_code: "18249",

    ste_name: "PA",
  },
  {
    zip_code: "18371",

    ste_name: "PA",
  },
  {
    zip_code: "18431",

    ste_name: "PA",
  },
  {
    zip_code: "18435",

    ste_name: "PA",
  },
  {
    zip_code: "18517",

    ste_name: "PA",
  },
  {
    zip_code: "18826",

    ste_name: "PA",
  },
  {
    zip_code: "18830",

    ste_name: "PA",
  },
  {
    zip_code: "18834",

    ste_name: "PA",
  },
  {
    zip_code: "18853",

    ste_name: "PA",
  },
  {
    zip_code: "18966",

    ste_name: "PA",
  },
  {
    zip_code: "19040",

    ste_name: "PA",
  },
  {
    zip_code: "19342",

    ste_name: "PA",
  },
  {
    zip_code: "19475",

    ste_name: "PA",
  },
  {
    zip_code: "19501",

    ste_name: "PA",
  },
  {
    zip_code: "19562",

    ste_name: "PA",
  },
  {
    zip_code: "19567",

    ste_name: "PA",
  },
  {
    zip_code: "19806",

    ste_name: "DE",
  },
  {
    zip_code: "19931",

    ste_name: "DE",
  },
  {
    zip_code: "19958",

    ste_name: "DE",
  },
  {
    zip_code: "19970",

    ste_name: "DE",
  },
  {
    zip_code: "20139",

    ste_name: "VA",
  },
  {
    zip_code: "20155",

    ste_name: "VA",
  },
  {
    zip_code: "20184",

    ste_name: "VA",
  },
  {
    zip_code: "20708",

    ste_name: "MD",
  },
  {
    zip_code: "20723",

    ste_name: "MD",
  },
  {
    zip_code: "20745",

    ste_name: "MD",
  },
  {
    zip_code: "20785",

    ste_name: "MD",
  },
  {
    zip_code: "21057",

    ste_name: "MD",
  },
  {
    zip_code: "21120",

    ste_name: "MD",
  },
  {
    zip_code: "21229",

    ste_name: "MD",
  },
  {
    zip_code: "21234",

    ste_name: "MD",
  },
  {
    zip_code: "21237",

    ste_name: "MD",
  },
  {
    zip_code: "21641",

    ste_name: "MD",
  },
  {
    zip_code: "21649",

    ste_name: "MD",
  },
  {
    zip_code: "21790",

    ste_name: "MD",
  },
  {
    zip_code: "21810",

    ste_name: "MD",
  },
  {
    zip_code: "21814",

    ste_name: "MD",
  },
  {
    zip_code: "22026",

    ste_name: "VA",
  },
  {
    zip_code: "22039",

    ste_name: "VA",
  },
  {
    zip_code: "22315",

    ste_name: "VA",
  },
  {
    zip_code: "22935",

    ste_name: "VA",
  },
  {
    zip_code: "23024",

    ste_name: "VA",
  },
  {
    zip_code: "23108",

    ste_name: "VA",
  },
  {
    zip_code: "23148",

    ste_name: "VA",
  },
  {
    zip_code: "23181",

    ste_name: "VA",
  },
  {
    zip_code: "23420",

    ste_name: "VA",
  },
  {
    zip_code: "23462",

    ste_name: "VA",
  },
  {
    zip_code: "23691",

    ste_name: "VA",
  },
  {
    zip_code: "23805",

    ste_name: "VA",
  },
  {
    zip_code: "23806",

    ste_name: "VA",
  },
  {
    zip_code: "23837",

    ste_name: "VA",
  },
  {
    zip_code: "23879",

    ste_name: "VA",
  },
  {
    zip_code: "24016",

    ste_name: "VA",
  },
  {
    zip_code: "24055",

    ste_name: "VA",
  },
  {
    zip_code: "24105",

    ste_name: "VA",
  },
  {
    zip_code: "24201",

    ste_name: "VA",
  },
  {
    zip_code: "24221",

    ste_name: "VA",
  },
  {
    zip_code: "24230",

    ste_name: "VA",
  },
  {
    zip_code: "24246",

    ste_name: "VA",
  },
  {
    zip_code: "24377",

    ste_name: "VA",
  },
  {
    zip_code: "24479",

    ste_name: "VA",
  },
  {
    zip_code: "24530",

    ste_name: "VA",
  },
  {
    zip_code: "24593",

    ste_name: "VA",
  },
  {
    zip_code: "24613",

    ste_name: "VA",
  },
  {
    zip_code: "24656",

    ste_name: "VA",
  },
  {
    zip_code: "24866",

    ste_name: "WV",
  },
  {
    zip_code: "24963",

    ste_name: "WV",
  },
  {
    zip_code: "24984",

    ste_name: "WV",
  },
  {
    zip_code: "25085",

    ste_name: "WV",
  },
  {
    zip_code: "25113",

    ste_name: "WV",
  },
  {
    zip_code: "25201",

    ste_name: "WV",
  },
  {
    zip_code: "25214",

    ste_name: "WV",
  },
  {
    zip_code: "25431",

    ste_name: "WV",
  },
  {
    zip_code: "25541",

    ste_name: "WV",
  },
  {
    zip_code: "25625",

    ste_name: "WV",
  },
  {
    zip_code: "25810",

    ste_name: "WV",
  },
  {
    zip_code: "25875",

    ste_name: "WV",
  },
  {
    zip_code: "26187",

    ste_name: "WV",
  },
  {
    zip_code: "26349",

    ste_name: "WV",
  },
  {
    zip_code: "26412",

    ste_name: "WV",
  },
  {
    zip_code: "26425",

    ste_name: "WV",
  },
  {
    zip_code: "26543",

    ste_name: "WV",
  },
  {
    zip_code: "26547",

    ste_name: "WV",
  },
  {
    zip_code: "26623",

    ste_name: "WV",
  },
  {
    zip_code: "26638",

    ste_name: "WV",
  },
  {
    zip_code: "26651",

    ste_name: "WV",
  },
  {
    zip_code: "26680",

    ste_name: "WV",
  },
  {
    zip_code: "27009",

    ste_name: "NC",
  },
  {
    zip_code: "27025",

    ste_name: "NC",
  },
  {
    zip_code: "27239",

    ste_name: "NC",
  },
  {
    zip_code: "27260",

    ste_name: "NC",
  },
  {
    zip_code: "27356",

    ste_name: "NC",
  },
  {
    zip_code: "27519",

    ste_name: "NC",
  },
  {
    zip_code: "27523",

    ste_name: "NC",
  },
  {
    zip_code: "27576",

    ste_name: "NC",
  },
  {
    zip_code: "28020",

    ste_name: "NC",
  },
  {
    zip_code: "28080",

    ste_name: "NC",
  },
  {
    zip_code: "28215",

    ste_name: "NC",
  },
  {
    zip_code: "28392",

    ste_name: "NC",
  },
  {
    zip_code: "28429",

    ste_name: "NC",
  },
  {
    zip_code: "28462",

    ste_name: "NC",
  },
  {
    zip_code: "28472",

    ste_name: "NC",
  },
  {
    zip_code: "28553",

    ste_name: "NC",
  },
  {
    zip_code: "28635",

    ste_name: "NC",
  },
  {
    zip_code: "28645",

    ste_name: "NC",
  },
  {
    zip_code: "28667",

    ste_name: "NC",
  },
  {
    zip_code: "28773",

    ste_name: "NC",
  },
  {
    zip_code: "28778",

    ste_name: "NC",
  },
  {
    zip_code: "29031",

    ste_name: "SC",
  },
  {
    zip_code: "29114",

    ste_name: "SC",
  },
  {
    zip_code: "29130",

    ste_name: "SC",
  },
  {
    zip_code: "29202",

    ste_name: "SC",
  },
  {
    zip_code: "29205",

    ste_name: "SC",
  },
  {
    zip_code: "29212",

    ste_name: "SC",
  },
  {
    zip_code: "29229",

    ste_name: "SC",
  },
  {
    zip_code: "29332",

    ste_name: "SC",
  },
  {
    zip_code: "29372",

    ste_name: "SC",
  },
  {
    zip_code: "29471",

    ste_name: "SC",
  },
  {
    zip_code: "29526",

    ste_name: "SC",
  },
  {
    zip_code: "29536",

    ste_name: "SC",
  },
  {
    zip_code: "29611",

    ste_name: "SC",
  },
  {
    zip_code: "29697",

    ste_name: "SC",
  },
  {
    zip_code: "29906",

    ste_name: "SC",
  },
  {
    zip_code: "29911",

    ste_name: "SC",
  },
  {
    zip_code: "29922",

    ste_name: "SC",
  },
  {
    zip_code: "30002",

    ste_name: "GA",
  },
  {
    zip_code: "30032",

    ste_name: "GA",
  },
  {
    zip_code: "30062",

    ste_name: "GA",
  },
  {
    zip_code: "30079",

    ste_name: "GA",
  },
  {
    zip_code: "30110",

    ste_name: "GA",
  },
  {
    zip_code: "30121",

    ste_name: "GA",
  },
  {
    zip_code: "30157",

    ste_name: "GA",
  },
  {
    zip_code: "30165",

    ste_name: "GA",
  },
  {
    zip_code: "30342",

    ste_name: "GA",
  },
  {
    zip_code: "30420",

    ste_name: "GA",
  },
  {
    zip_code: "30434",

    ste_name: "GA",
  },
  {
    zip_code: "30738",

    ste_name: "GA",
  },
  {
    zip_code: "58251",

    ste_name: "ND",
  },
  {
    zip_code: "58370",

    ste_name: "ND",
  },
  {
    zip_code: "58402",

    ste_name: "ND",
  },
  {
    zip_code: "58538",

    ste_name: "ND",
  },
  {
    zip_code: "58621",

    ste_name: "ND",
  },
  {
    zip_code: "58647",

    ste_name: "ND",
  },
  {
    zip_code: "631",

    ste_name: "PR",
  },
  {
    zip_code: "824",

    ste_name: "VI",
  },
  {
    zip_code: "920",

    ste_name: "PR",
  },
  {
    zip_code: "953",

    ste_name: "PR",
  },
  {
    zip_code: "965",

    ste_name: "PR",
  },
  {
    zip_code: "1032",

    ste_name: "MA",
  },
  {
    zip_code: "1073",

    ste_name: "MA",
  },
  {
    zip_code: "1237",

    ste_name: "MA",
  },
  {
    zip_code: "1440",

    ste_name: "MA",
  },
  {
    zip_code: "1474",

    ste_name: "MA",
  },
  {
    zip_code: "1520",

    ste_name: "MA",
  },
  {
    zip_code: "1612",

    ste_name: "MA",
  },
  {
    zip_code: "1852",

    ste_name: "MA",
  },
  {
    zip_code: "2184",

    ste_name: "MA",
  },
  {
    zip_code: "2302",

    ste_name: "MA",
  },
  {
    zip_code: "2360",

    ste_name: "MA",
  },
  {
    zip_code: "2464",

    ste_name: "MA",
  },
  {
    zip_code: "2748",

    ste_name: "MA",
  },
  {
    zip_code: "2852",

    ste_name: "RI",
  },
  {
    zip_code: "2921",

    ste_name: "RI",
  },
  {
    zip_code: "3063",

    ste_name: "NH",
  },
  {
    zip_code: "3102",

    ste_name: "NH",
  },
  {
    zip_code: "3104",

    ste_name: "NH",
  },
  {
    zip_code: "3262",

    ste_name: "NH",
  },
  {
    zip_code: "3266",

    ste_name: "NH",
  },
  {
    zip_code: "3443",

    ste_name: "NH",
  },
  {
    zip_code: "3450",

    ste_name: "NH",
  },
  {
    zip_code: "3809",

    ste_name: "NH",
  },
  {
    zip_code: "3820",

    ste_name: "NH",
  },
  {
    zip_code: "3845",

    ste_name: "NH",
  },
  {
    zip_code: "3846",

    ste_name: "NH",
  },
  {
    zip_code: "4008",

    ste_name: "ME",
  },
  {
    zip_code: "4020",

    ste_name: "ME",
  },
  {
    zip_code: "4261",

    ste_name: "ME",
  },
  {
    zip_code: "4275",

    ste_name: "ME",
  },
  {
    zip_code: "4415",

    ste_name: "ME",
  },
  {
    zip_code: "4426",

    ste_name: "ME",
  },
  {
    zip_code: "4547",

    ste_name: "ME",
  },
  {
    zip_code: "4616",

    ste_name: "ME",
  },
  {
    zip_code: "4619",

    ste_name: "ME",
  },
  {
    zip_code: "4643",

    ste_name: "ME",
  },
  {
    zip_code: "4652",

    ste_name: "ME",
  },
  {
    zip_code: "4681",

    ste_name: "ME",
  },
  {
    zip_code: "4911",

    ste_name: "ME",
  },
  {
    zip_code: "4941",

    ste_name: "ME",
  },
  {
    zip_code: "4949",

    ste_name: "ME",
  },
  {
    zip_code: "4969",

    ste_name: "ME",
  },
  {
    zip_code: "5038",

    ste_name: "VT",
  },
  {
    zip_code: "5141",

    ste_name: "VT",
  },
  {
    zip_code: "5148",

    ste_name: "VT",
  },
  {
    zip_code: "5362",

    ste_name: "VT",
  },
  {
    zip_code: "5363",

    ste_name: "VT",
  },
  {
    zip_code: "5444",

    ste_name: "VT",
  },
  {
    zip_code: "5491",

    ste_name: "VT",
  },
  {
    zip_code: "5655",

    ste_name: "VT",
  },
  {
    zip_code: "5767",

    ste_name: "VT",
  },
  {
    zip_code: "5820",

    ste_name: "VT",
  },
  {
    zip_code: "6010",

    ste_name: "CT",
  },
  {
    zip_code: "6059",

    ste_name: "CT",
  },
  {
    zip_code: "6081",

    ste_name: "CT",
  },
  {
    zip_code: "6280",

    ste_name: "CT",
  },
  {
    zip_code: "6351",

    ste_name: "CT",
  },
  {
    zip_code: "6410",

    ste_name: "CT",
  },
  {
    zip_code: "6443",

    ste_name: "CT",
  },
  {
    zip_code: "6447",

    ste_name: "CT",
  },
  {
    zip_code: "6513",

    ste_name: "CT",
  },
  {
    zip_code: "6776",

    ste_name: "CT",
  },
  {
    zip_code: "6820",

    ste_name: "CT",
  },
  {
    zip_code: "6897",

    ste_name: "CT",
  },
  {
    zip_code: "7012",

    ste_name: "NJ",
  },
  {
    zip_code: "7071",

    ste_name: "NJ",
  },
  {
    zip_code: "7083",

    ste_name: "NJ",
  },
  {
    zip_code: "7410",

    ste_name: "NJ",
  },
  {
    zip_code: "7650",

    ste_name: "NJ",
  },
  {
    zip_code: "7676",

    ste_name: "NJ",
  },
  {
    zip_code: "7677",

    ste_name: "NJ",
  },
  {
    zip_code: "7717",

    ste_name: "NJ",
  },
  {
    zip_code: "7718",

    ste_name: "NJ",
  },
  {
    zip_code: "7721",

    ste_name: "NJ",
  },
  {
    zip_code: "7724",

    ste_name: "NJ",
  },
  {
    zip_code: "7833",

    ste_name: "NJ",
  },
  {
    zip_code: "8034",

    ste_name: "NJ",
  },
  {
    zip_code: "8038",

    ste_name: "NJ",
  },
  {
    zip_code: "8054",

    ste_name: "NJ",
  },
  {
    zip_code: "8056",

    ste_name: "NJ",
  },
  {
    zip_code: "8068",

    ste_name: "NJ",
  },
  {
    zip_code: "8070",

    ste_name: "NJ",
  },
  {
    zip_code: "8078",

    ste_name: "NJ",
  },
  {
    zip_code: "8085",

    ste_name: "NJ",
  },
  {
    zip_code: "8089",

    ste_name: "NJ",
  },
  {
    zip_code: "8554",

    ste_name: "NJ",
  },
  {
    zip_code: "8804",

    ste_name: "NJ",
  },
  {
    zip_code: "8816",

    ste_name: "NJ",
  },
  {
    zip_code: "8846",

    ste_name: "NJ",
  },
  {
    zip_code: "10167",

    ste_name: "NY",
  },
  {
    zip_code: "10463",

    ste_name: "NY",
  },
  {
    zip_code: "10469",

    ste_name: "NY",
  },
  {
    zip_code: "10708",

    ste_name: "NY",
  },
  {
    zip_code: "10805",

    ste_name: "NY",
  },
  {
    zip_code: "10928",

    ste_name: "NY",
  },
  {
    zip_code: "10931",

    ste_name: "NY",
  },
  {
    zip_code: "10980",

    ste_name: "NY",
  },
  {
    zip_code: "11201",

    ste_name: "NY",
  },
  {
    zip_code: "11369",

    ste_name: "NY",
  },
  {
    zip_code: "11556",

    ste_name: "NY",
  },
  {
    zip_code: "11739",

    ste_name: "NY",
  },
  {
    zip_code: "11743",

    ste_name: "NY",
  },
  {
    zip_code: "11762",

    ste_name: "NY",
  },
  {
    zip_code: "11771",

    ste_name: "NY",
  },
  {
    zip_code: "11939",

    ste_name: "NY",
  },
  {
    zip_code: "12018",

    ste_name: "NY",
  },
  {
    zip_code: "12024",

    ste_name: "NY",
  },
  {
    zip_code: "12027",

    ste_name: "NY",
  },
  {
    zip_code: "12167",

    ste_name: "NY",
  },
  {
    zip_code: "12207",

    ste_name: "NY",
  },
  {
    zip_code: "12412",

    ste_name: "NY",
  },
  {
    zip_code: "12418",

    ste_name: "NY",
  },
  {
    zip_code: "12421",

    ste_name: "NY",
  },
  {
    zip_code: "12469",

    ste_name: "NY",
  },
  {
    zip_code: "12545",

    ste_name: "NY",
  },
  {
    zip_code: "12581",

    ste_name: "NY",
  },
  {
    zip_code: "12594",

    ste_name: "NY",
  },
  {
    zip_code: "12725",

    ste_name: "NY",
  },
  {
    zip_code: "12758",

    ste_name: "NY",
  },
  {
    zip_code: "12777",

    ste_name: "NY",
  },
  {
    zip_code: "12780",

    ste_name: "NY",
  },
  {
    zip_code: "12846",

    ste_name: "NY",
  },
  {
    zip_code: "12901",

    ste_name: "NY",
  },
  {
    zip_code: "12903",

    ste_name: "NY",
  },
  {
    zip_code: "12941",

    ste_name: "NY",
  },
  {
    zip_code: "13024",

    ste_name: "NY",
  },
  {
    zip_code: "13163",

    ste_name: "NY",
  },
  {
    zip_code: "13204",

    ste_name: "NY",
  },
  {
    zip_code: "13433",

    ste_name: "NY",
  },
  {
    zip_code: "13459",

    ste_name: "NY",
  },
  {
    zip_code: "13491",

    ste_name: "NY",
  },
  {
    zip_code: "13615",

    ste_name: "NY",
  },
  {
    zip_code: "13669",

    ste_name: "NY",
  },
  {
    zip_code: "13782",

    ste_name: "NY",
  },
  {
    zip_code: "13783",

    ste_name: "NY",
  },
  {
    zip_code: "13797",

    ste_name: "NY",
  },
  {
    zip_code: "13812",

    ste_name: "NY",
  },
  {
    zip_code: "14041",

    ste_name: "NY",
  },
  {
    zip_code: "14057",

    ste_name: "NY",
  },
  {
    zip_code: "14069",

    ste_name: "NY",
  },
  {
    zip_code: "14209",

    ste_name: "NY",
  },
  {
    zip_code: "14213",

    ste_name: "NY",
  },
  {
    zip_code: "14214",

    ste_name: "NY",
  },
  {
    zip_code: "14228",

    ste_name: "NY",
  },
  {
    zip_code: "14422",

    ste_name: "NY",
  },
  {
    zip_code: "14517",

    ste_name: "NY",
  },
  {
    zip_code: "14572",

    ste_name: "NY",
  },
  {
    zip_code: "14590",

    ste_name: "NY",
  },
  {
    zip_code: "14623",

    ste_name: "NY",
  },
  {
    zip_code: "14778",

    ste_name: "NY",
  },
  {
    zip_code: "14845",

    ste_name: "NY",
  },
  {
    zip_code: "14889",

    ste_name: "NY",
  },
  {
    zip_code: "14898",

    ste_name: "NY",
  },
  {
    zip_code: "14901",

    ste_name: "NY",
  },
  {
    zip_code: "15022",

    ste_name: "PA",
  },
  {
    zip_code: "15056",

    ste_name: "PA",
  },
  {
    zip_code: "15060",

    ste_name: "PA",
  },
  {
    zip_code: "15065",

    ste_name: "PA",
  },
  {
    zip_code: "15078",

    ste_name: "PA",
  },
  {
    zip_code: "15086",

    ste_name: "PA",
  },
  {
    zip_code: "15215",

    ste_name: "PA",
  },
  {
    zip_code: "15320",

    ste_name: "PA",
  },
  {
    zip_code: "15366",

    ste_name: "PA",
  },
  {
    zip_code: "15474",

    ste_name: "PA",
  },
  {
    zip_code: "15490",

    ste_name: "PA",
  },
  {
    zip_code: "15539",

    ste_name: "PA",
  },
  {
    zip_code: "15666",

    ste_name: "PA",
  },
  {
    zip_code: "15677",

    ste_name: "PA",
  },
  {
    zip_code: "15711",

    ste_name: "PA",
  },
  {
    zip_code: "15723",

    ste_name: "PA",
  },
  {
    zip_code: "15868",

    ste_name: "PA",
  },
  {
    zip_code: "15927",

    ste_name: "PA",
  },
  {
    zip_code: "15929",

    ste_name: "PA",
  },
  {
    zip_code: "15946",

    ste_name: "PA",
  },
  {
    zip_code: "16066",

    ste_name: "PA",
  },
  {
    zip_code: "16111",

    ste_name: "PA",
  },
  {
    zip_code: "16148",

    ste_name: "PA",
  },
  {
    zip_code: "16327",

    ste_name: "PA",
  },
  {
    zip_code: "16342",

    ste_name: "PA",
  },
  {
    zip_code: "16411",

    ste_name: "PA",
  },
  {
    zip_code: "16505",

    ste_name: "PA",
  },
  {
    zip_code: "16617",

    ste_name: "PA",
  },
  {
    zip_code: "16672",

    ste_name: "PA",
  },
  {
    zip_code: "16679",

    ste_name: "PA",
  },
  {
    zip_code: "16682",

    ste_name: "PA",
  },
  {
    zip_code: "16695",

    ste_name: "PA",
  },
  {
    zip_code: "16802",

    ste_name: "PA",
  },
  {
    zip_code: "16822",

    ste_name: "PA",
  },
  {
    zip_code: "17013",

    ste_name: "PA",
  },
  {
    zip_code: "17016",

    ste_name: "PA",
  },
  {
    zip_code: "17021",

    ste_name: "PA",
  },
  {
    zip_code: "17033",

    ste_name: "PA",
  },
  {
    zip_code: "17072",

    ste_name: "PA",
  },
  {
    zip_code: "17266",

    ste_name: "PA",
  },
  {
    zip_code: "17311",

    ste_name: "PA",
  },
  {
    zip_code: "17352",

    ste_name: "PA",
  },
  {
    zip_code: "17401",

    ste_name: "PA",
  },
  {
    zip_code: "17403",

    ste_name: "PA",
  },
  {
    zip_code: "17406",

    ste_name: "PA",
  },
  {
    zip_code: "17884",

    ste_name: "PA",
  },
  {
    zip_code: "17949",

    ste_name: "PA",
  },
  {
    zip_code: "18017",

    ste_name: "PA",
  },
  {
    zip_code: "18045",

    ste_name: "PA",
  },
  {
    zip_code: "18071",

    ste_name: "PA",
  },
  {
    zip_code: "18078",

    ste_name: "PA",
  },
  {
    zip_code: "18085",

    ste_name: "PA",
  },
  {
    zip_code: "18086",

    ste_name: "PA",
  },
  {
    zip_code: "18109",

    ste_name: "PA",
  },
  {
    zip_code: "18336",

    ste_name: "PA",
  },
  {
    zip_code: "18411",

    ste_name: "PA",
  },
  {
    zip_code: "18414",

    ste_name: "PA",
  },
  {
    zip_code: "18437",

    ste_name: "PA",
  },
  {
    zip_code: "18610",

    ste_name: "PA",
  },
  {
    zip_code: "18630",

    ste_name: "PA",
  },
  {
    zip_code: "18929",

    ste_name: "PA",
  },
  {
    zip_code: "19070",

    ste_name: "PA",
  },
  {
    zip_code: "19112",

    ste_name: "PA",
  },
  {
    zip_code: "19144",

    ste_name: "PA",
  },
  {
    zip_code: "19367",

    ste_name: "PA",
  },
  {
    zip_code: "19372",

    ste_name: "PA",
  },
  {
    zip_code: "19444",

    ste_name: "PA",
  },
  {
    zip_code: "19605",

    ste_name: "PA",
  },
  {
    zip_code: "19608",

    ste_name: "PA",
  },
  {
    zip_code: "19610",

    ste_name: "PA",
  },
  {
    zip_code: "19944",

    ste_name: "DE",
  },
  {
    zip_code: "20006",

    ste_name: "DC",
  },
  {
    zip_code: "20112",

    ste_name: "VA",
  },
  {
    zip_code: "20136",

    ste_name: "VA",
  },
  {
    zip_code: "20144",

    ste_name: "VA",
  },
  {
    zip_code: "20148",

    ste_name: "VA",
  },
  {
    zip_code: "20619",

    ste_name: "MD",
  },
  {
    zip_code: "20658",

    ste_name: "MD",
  },
  {
    zip_code: "20676",

    ste_name: "MD",
  },
  {
    zip_code: "20690",

    ste_name: "MD",
  },
  {
    zip_code: "20724",

    ste_name: "MD",
  },
  {
    zip_code: "20758",

    ste_name: "MD",
  },
  {
    zip_code: "20837",

    ste_name: "MD",
  },
  {
    zip_code: "20841",

    ste_name: "MD",
  },
  {
    zip_code: "21539",

    ste_name: "MD",
  },
  {
    zip_code: "21702",

    ste_name: "MD",
  },
  {
    zip_code: "21773",

    ste_name: "MD",
  },
  {
    zip_code: "22511",

    ste_name: "VA",
  },
  {
    zip_code: "22551",

    ste_name: "VA",
  },
  {
    zip_code: "22654",

    ste_name: "VA",
  },
  {
    zip_code: "22741",

    ste_name: "VA",
  },
  {
    zip_code: "22811",

    ste_name: "VA",
  },
  {
    zip_code: "22832",

    ste_name: "VA",
  },
  {
    zip_code: "22973",

    ste_name: "VA",
  },
  {
    zip_code: "22980",

    ste_name: "VA",
  },
  {
    zip_code: "23005",

    ste_name: "VA",
  },
  {
    zip_code: "23112",

    ste_name: "VA",
  },
  {
    zip_code: "23150",

    ste_name: "VA",
  },
  {
    zip_code: "23224",

    ste_name: "VA",
  },
  {
    zip_code: "23452",

    ste_name: "VA",
  },
  {
    zip_code: "23662",

    ste_name: "VA",
  },
  {
    zip_code: "23836",

    ste_name: "VA",
  },
  {
    zip_code: "23845",

    ste_name: "VA",
  },
  {
    zip_code: "23872",

    ste_name: "VA",
  },
  {
    zip_code: "24058",

    ste_name: "VA",
  },
  {
    zip_code: "24210",

    ste_name: "VA",
  },
  {
    zip_code: "24380",

    ste_name: "VA",
  },
  {
    zip_code: "24467",

    ste_name: "VA",
  },
  {
    zip_code: "24529",

    ste_name: "VA",
  },
  {
    zip_code: "24536",

    ste_name: "VA",
  },
  {
    zip_code: "24630",

    ste_name: "VA",
  },
  {
    zip_code: "24715",

    ste_name: "WV",
  },
  {
    zip_code: "24836",

    ste_name: "WV",
  },
  {
    zip_code: "24851",

    ste_name: "WV",
  },
  {
    zip_code: "24871",

    ste_name: "WV",
  },
  {
    zip_code: "24976",

    ste_name: "WV",
  },
  {
    zip_code: "25108",

    ste_name: "WV",
  },
  {
    zip_code: "25109",

    ste_name: "WV",
  },
  {
    zip_code: "25173",

    ste_name: "WV",
  },
  {
    zip_code: "25425",

    ste_name: "WV",
  },
  {
    zip_code: "25608",

    ste_name: "WV",
  },
  {
    zip_code: "25644",

    ste_name: "WV",
  },
  {
    zip_code: "25820",

    ste_name: "WV",
  },
  {
    zip_code: "25837",

    ste_name: "WV",
  },
  {
    zip_code: "25871",

    ste_name: "WV",
  },
  {
    zip_code: "25906",

    ste_name: "WV",
  },
  {
    zip_code: "25977",

    ste_name: "WV",
  },
  {
    zip_code: "26039",

    ste_name: "WV",
  },
  {
    zip_code: "26169",

    ste_name: "WV",
  },
  {
    zip_code: "26180",

    ste_name: "WV",
  },
  {
    zip_code: "26270",

    ste_name: "WV",
  },
  {
    zip_code: "26293",

    ste_name: "WV",
  },
  {
    zip_code: "26362",

    ste_name: "WV",
  },
  {
    zip_code: "26431",

    ste_name: "WV",
  },
  {
    zip_code: "26438",

    ste_name: "WV",
  },
  {
    zip_code: "26554",

    ste_name: "WV",
  },
  {
    zip_code: "26731",

    ste_name: "WV",
  },
  {
    zip_code: "26823",

    ste_name: "WV",
  },
  {
    zip_code: "26845",

    ste_name: "WV",
  },
  {
    zip_code: "27012",

    ste_name: "NC",
  },
  {
    zip_code: "27021",

    ste_name: "NC",
  },
  {
    zip_code: "27051",

    ste_name: "NC",
  },
  {
    zip_code: "27103",

    ste_name: "NC",
  },
  {
    zip_code: "27105",

    ste_name: "NC",
  },
  {
    zip_code: "27258",

    ste_name: "NC",
  },
  {
    zip_code: "27298",

    ste_name: "NC",
  },
  {
    zip_code: "27563",

    ste_name: "NC",
  },
  {
    zip_code: "27831",

    ste_name: "NC",
  },
  {
    zip_code: "27855",

    ste_name: "NC",
  },
  {
    zip_code: "27858",

    ste_name: "NC",
  },
  {
    zip_code: "27979",

    ste_name: "NC",
  },
  {
    zip_code: "28040",

    ste_name: "NC",
  },
  {
    zip_code: "28073",

    ste_name: "NC",
  },
  {
    zip_code: "28139",

    ste_name: "NC",
  },
  {
    zip_code: "28150",

    ste_name: "NC",
  },
  {
    zip_code: "28173",

    ste_name: "NC",
  },
  {
    zip_code: "28212",

    ste_name: "NC",
  },
  {
    zip_code: "28308",

    ste_name: "NC",
  },
  {
    zip_code: "28326",

    ste_name: "NC",
  },
  {
    zip_code: "28375",

    ste_name: "NC",
  },
  {
    zip_code: "28454",

    ste_name: "NC",
  },
  {
    zip_code: "28512",

    ste_name: "NC",
  },
  {
    zip_code: "28518",

    ste_name: "NC",
  },
  {
    zip_code: "28527",

    ste_name: "NC",
  },
  {
    zip_code: "28539",

    ste_name: "NC",
  },
  {
    zip_code: "28577",

    ste_name: "NC",
  },
  {
    zip_code: "28581",

    ste_name: "NC",
  },
  {
    zip_code: "28628",

    ste_name: "NC",
  },
  {
    zip_code: "28685",

    ste_name: "NC",
  },
  {
    zip_code: "28714",

    ste_name: "NC",
  },
  {
    zip_code: "28777",

    ste_name: "NC",
  },
  {
    zip_code: "28782",

    ste_name: "NC",
  },
  {
    zip_code: "28806",

    ste_name: "NC",
  },
  {
    zip_code: "29010",

    ste_name: "SC",
  },
  {
    zip_code: "29346",

    ste_name: "SC",
  },
  {
    zip_code: "29385",

    ste_name: "SC",
  },
  {
    zip_code: "29516",

    ste_name: "SC",
  },
  {
    zip_code: "29519",

    ste_name: "SC",
  },
  {
    zip_code: "29615",

    ste_name: "SC",
  },
  {
    zip_code: "29667",

    ste_name: "SC",
  },
  {
    zip_code: "29730",

    ste_name: "SC",
  },
  {
    zip_code: "29907",

    ste_name: "SC",
  },
  {
    zip_code: "30047",

    ste_name: "GA",
  },
  {
    zip_code: "30080",

    ste_name: "GA",
  },
  {
    zip_code: "30097",

    ste_name: "GA",
  },
  {
    zip_code: "30153",

    ste_name: "GA",
  },
  {
    zip_code: "30168",

    ste_name: "GA",
  },
  {
    zip_code: "30263",

    ste_name: "GA",
  },
  {
    zip_code: "30285",

    ste_name: "GA",
  },
  {
    zip_code: "30339",

    ste_name: "GA",
  },
  {
    zip_code: "30423",

    ste_name: "GA",
  },
  {
    zip_code: "30454",

    ste_name: "GA",
  },
  {
    zip_code: "30555",

    ste_name: "GA",
  },
  {
    zip_code: "30559",

    ste_name: "GA",
  },
  {
    zip_code: "30630",

    ste_name: "GA",
  },
  {
    zip_code: "30720",

    ste_name: "GA",
  },
  {
    zip_code: "30739",

    ste_name: "GA",
  },
  {
    zip_code: "92543",

    ste_name: "CA",
  },
  {
    zip_code: "92570",

    ste_name: "CA",
  },
  {
    zip_code: "92592",

    ste_name: "CA",
  },
  {
    zip_code: "92673",

    ste_name: "CA",
  },
  {
    zip_code: "92683",

    ste_name: "CA",
  },
  {
    zip_code: "92869",

    ste_name: "CA",
  },
  {
    zip_code: "93101",

    ste_name: "CA",
  },
  {
    zip_code: "93206",

    ste_name: "CA",
  },
  {
    zip_code: "93226",

    ste_name: "CA",
  },
  {
    zip_code: "93304",

    ste_name: "CA",
  },
  {
    zip_code: "93420",

    ste_name: "CA",
  },
  {
    zip_code: "93943",

    ste_name: "CA",
  },
  {
    zip_code: "94306",

    ste_name: "CA",
  },
  {
    zip_code: "94506",

    ste_name: "CA",
  },
  {
    zip_code: "94546",

    ste_name: "CA",
  },
  {
    zip_code: "94559",

    ste_name: "CA",
  },
  {
    zip_code: "94560",

    ste_name: "CA",
  },
  {
    zip_code: "94588",

    ste_name: "CA",
  },
  {
    zip_code: "94595",

    ste_name: "CA",
  },
  {
    zip_code: "94923",

    ste_name: "CA",
  },
  {
    zip_code: "95020",

    ste_name: "CA",
  },
  {
    zip_code: "95043",

    ste_name: "CA",
  },
  {
    zip_code: "95054",

    ste_name: "CA",
  },
  {
    zip_code: "95119",

    ste_name: "CA",
  },
  {
    zip_code: "95130",

    ste_name: "CA",
  },
  {
    zip_code: "95236",

    ste_name: "CA",
  },
  {
    zip_code: "95257",

    ste_name: "CA",
  },
  {
    zip_code: "95258",

    ste_name: "CA",
  },
  {
    zip_code: "95377",

    ste_name: "CA",
  },
  {
    zip_code: "95401",

    ste_name: "CA",
  },
  {
    zip_code: "95458",

    ste_name: "CA",
  },
  {
    zip_code: "95469",

    ste_name: "CA",
  },
  {
    zip_code: "95620",

    ste_name: "CA",
  },
  {
    zip_code: "95653",

    ste_name: "CA",
  },
  {
    zip_code: "95736",

    ste_name: "CA",
  },
  {
    zip_code: "95758",

    ste_name: "CA",
  },
  {
    zip_code: "95820",

    ste_name: "CA",
  },
  {
    zip_code: "95832",

    ste_name: "CA",
  },
  {
    zip_code: "96013",

    ste_name: "CA",
  },
  {
    zip_code: "96038",

    ste_name: "CA",
  },
  {
    zip_code: "96054",

    ste_name: "CA",
  },
  {
    zip_code: "96101",

    ste_name: "CA",
  },
  {
    zip_code: "96123",

    ste_name: "CA",
  },
  {
    zip_code: "96780",

    ste_name: "HI",
  },
  {
    zip_code: "96850",

    ste_name: "HI",
  },
  {
    zip_code: "97039",

    ste_name: "OR",
  },
  {
    zip_code: "97101",

    ste_name: "OR",
  },
  {
    zip_code: "97140",

    ste_name: "OR",
  },
  {
    zip_code: "97141",

    ste_name: "OR",
  },
  {
    zip_code: "97202",

    ste_name: "OR",
  },
  {
    zip_code: "97211",

    ste_name: "OR",
  },
  {
    zip_code: "97218",

    ste_name: "OR",
  },
  {
    zip_code: "97236",

    ste_name: "OR",
  },
  {
    zip_code: "97374",

    ste_name: "OR",
  },
  {
    zip_code: "97375",

    ste_name: "OR",
  },
  {
    zip_code: "97431",

    ste_name: "OR",
  },
  {
    zip_code: "97502",

    ste_name: "OR",
  },
  {
    zip_code: "97535",

    ste_name: "OR",
  },
  {
    zip_code: "97543",

    ste_name: "OR",
  },
  {
    zip_code: "97630",

    ste_name: "OR",
  },
  {
    zip_code: "97707",

    ste_name: "OR",
  },
  {
    zip_code: "97731",

    ste_name: "OR",
  },
  {
    zip_code: "97826",

    ste_name: "OR",
  },
  {
    zip_code: "97841",

    ste_name: "OR",
  },
  {
    zip_code: "97846",

    ste_name: "OR",
  },
  {
    zip_code: "97848",

    ste_name: "OR",
  },
  {
    zip_code: "97856",

    ste_name: "OR",
  },
  {
    zip_code: "98101",

    ste_name: "WA",
  },
  {
    zip_code: "98158",

    ste_name: "WA",
  },
  {
    zip_code: "98221",

    ste_name: "WA",
  },
  {
    zip_code: "98225",

    ste_name: "WA",
  },
  {
    zip_code: "98262",

    ste_name: "WA",
  },
  {
    zip_code: "98263",

    ste_name: "WA",
  },
  {
    zip_code: "98320",

    ste_name: "WA",
  },
  {
    zip_code: "90002",

    ste_name: "CA",
  },
  {
    zip_code: "90048",

    ste_name: "CA",
  },
  {
    zip_code: "90302",

    ste_name: "CA",
  },
  {
    zip_code: "90620",

    ste_name: "CA",
  },
  {
    zip_code: "90640",

    ste_name: "CA",
  },
  {
    zip_code: "90740",

    ste_name: "CA",
  },
  {
    zip_code: "90755",

    ste_name: "CA",
  },
  {
    zip_code: "91316",

    ste_name: "CA",
  },
  {
    zip_code: "91367",

    ste_name: "CA",
  },
  {
    zip_code: "91381",

    ste_name: "CA",
  },
  {
    zip_code: "91710",

    ste_name: "CA",
  },
  {
    zip_code: "91792",

    ste_name: "CA",
  },
  {
    zip_code: "92075",

    ste_name: "CA",
  },
  {
    zip_code: "92227",

    ste_name: "CA",
  },
  {
    zip_code: "92230",

    ste_name: "CA",
  },
  {
    zip_code: "92259",

    ste_name: "CA",
  },
  {
    zip_code: "93452",

    ste_name: "CA",
  },
  {
    zip_code: "93554",

    ste_name: "CA",
  },
  {
    zip_code: "93924",

    ste_name: "CA",
  },
  {
    zip_code: "98391",

    ste_name: "WA",
  },
  {
    zip_code: "98418",

    ste_name: "WA",
  },
  {
    zip_code: "98443",

    ste_name: "WA",
  },
  {
    zip_code: "98528",

    ste_name: "WA",
  },
  {
    zip_code: "98544",

    ste_name: "WA",
  },
  {
    zip_code: "98577",

    ste_name: "WA",
  },
  {
    zip_code: "98603",

    ste_name: "WA",
  },
  {
    zip_code: "98621",

    ste_name: "WA",
  },
  {
    zip_code: "98824",

    ste_name: "WA",
  },
  {
    zip_code: "98953",

    ste_name: "WA",
  },
  {
    zip_code: "99039",

    ste_name: "WA",
  },
  {
    zip_code: "99143",

    ste_name: "WA",
  },
  {
    zip_code: "99503",

    ste_name: "AK",
  },
  {
    zip_code: "99546",

    ste_name: "AK",
  },
  {
    zip_code: "99627",

    ste_name: "AK",
  },
  {
    zip_code: "99641",

    ste_name: "AK",
  },
  {
    zip_code: "99780",

    ste_name: "AK",
  },
  {
    zip_code: "99827",

    ste_name: "AK",
  },
  {
    zip_code: "99832",

    ste_name: "AK",
  },
  {
    zip_code: "99840",

    ste_name: "AK",
  },
  {
    zip_code: "59007",

    ste_name: "MT",
  },
  {
    zip_code: "59053",

    ste_name: "MT",
  },
  {
    zip_code: "59063",

    ste_name: "MT",
  },
  {
    zip_code: "59214",

    ste_name: "MT",
  },
  {
    zip_code: "59225",

    ste_name: "MT",
  },
  {
    zip_code: "59241",

    ste_name: "MT",
  },
  {
    zip_code: "59270",

    ste_name: "MT",
  },
  {
    zip_code: "59312",

    ste_name: "MT",
  },
  {
    zip_code: "59417",

    ste_name: "MT",
  },
  {
    zip_code: "59528",

    ste_name: "MT",
  },
  {
    zip_code: "59644",

    ste_name: "MT",
  },
  {
    zip_code: "59730",

    ste_name: "MT",
  },
  {
    zip_code: "59762",

    ste_name: "MT",
  },
  {
    zip_code: "59916",

    ste_name: "MT",
  },
  {
    zip_code: "60044",

    ste_name: "IL",
  },
  {
    zip_code: "60047",

    ste_name: "IL",
  },
  {
    zip_code: "60101",

    ste_name: "IL",
  },
  {
    zip_code: "60141",

    ste_name: "IL",
  },
  {
    zip_code: "60150",

    ste_name: "IL",
  },
  {
    zip_code: "60164",

    ste_name: "IL",
  },
  {
    zip_code: "60473",

    ste_name: "IL",
  },
  {
    zip_code: "60511",

    ste_name: "IL",
  },
  {
    zip_code: "60544",

    ste_name: "IL",
  },
  {
    zip_code: "60620",

    ste_name: "IL",
  },
  {
    zip_code: "60934",

    ste_name: "IL",
  },
  {
    zip_code: "61028",

    ste_name: "IL",
  },
  {
    zip_code: "61085",

    ste_name: "IL",
  },
  {
    zip_code: "61232",

    ste_name: "IL",
  },
  {
    zip_code: "61314",

    ste_name: "IL",
  },
  {
    zip_code: "61321",

    ste_name: "IL",
  },
  {
    zip_code: "61438",

    ste_name: "IL",
  },
  {
    zip_code: "61454",

    ste_name: "IL",
  },
  {
    zip_code: "61482",

    ste_name: "IL",
  },
  {
    zip_code: "61543",

    ste_name: "IL",
  },
  {
    zip_code: "61810",

    ste_name: "IL",
  },
  {
    zip_code: "61817",

    ste_name: "IL",
  },
  {
    zip_code: "61831",

    ste_name: "IL",
  },
  {
    zip_code: "61842",

    ste_name: "IL",
  },
  {
    zip_code: "61845",

    ste_name: "IL",
  },
  {
    zip_code: "61852",

    ste_name: "IL",
  },
  {
    zip_code: "61864",

    ste_name: "IL",
  },
  {
    zip_code: "61912",

    ste_name: "IL",
  },
  {
    zip_code: "61919",

    ste_name: "IL",
  },
  {
    zip_code: "61930",

    ste_name: "IL",
  },
  {
    zip_code: "62033",

    ste_name: "IL",
  },
  {
    zip_code: "62094",

    ste_name: "IL",
  },
  {
    zip_code: "62097",

    ste_name: "IL",
  },
  {
    zip_code: "62260",

    ste_name: "IL",
  },
  {
    zip_code: "62264",

    ste_name: "IL",
  },
  {
    zip_code: "62266",

    ste_name: "IL",
  },
  {
    zip_code: "62272",

    ste_name: "IL",
  },
  {
    zip_code: "62282",

    ste_name: "IL",
  },
  {
    zip_code: "62320",

    ste_name: "IL",
  },
  {
    zip_code: "62469",

    ste_name: "IL",
  },
  {
    zip_code: "62510",

    ste_name: "IL",
  },
  {
    zip_code: "62519",

    ste_name: "IL",
  },
  {
    zip_code: "62520",

    ste_name: "IL",
  },
  {
    zip_code: "62665",

    ste_name: "IL",
  },
  {
    zip_code: "62670",

    ste_name: "IL",
  },
  {
    zip_code: "62675",

    ste_name: "IL",
  },
  {
    zip_code: "62814",

    ste_name: "IL",
  },
  {
    zip_code: "62862",

    ste_name: "IL",
  },
  {
    zip_code: "62869",

    ste_name: "IL",
  },
  {
    zip_code: "62916",

    ste_name: "IL",
  },
  {
    zip_code: "62927",

    ste_name: "IL",
  },
  {
    zip_code: "62928",

    ste_name: "IL",
  },
  {
    zip_code: "62940",

    ste_name: "IL",
  },
  {
    zip_code: "63011",

    ste_name: "MO",
  },
  {
    zip_code: "63104",

    ste_name: "MO",
  },
  {
    zip_code: "63115",

    ste_name: "MO",
  },
  {
    zip_code: "63124",

    ste_name: "MO",
  },
  {
    zip_code: "63129",

    ste_name: "MO",
  },
  {
    zip_code: "63332",

    ste_name: "MO",
  },
  {
    zip_code: "63339",

    ste_name: "MO",
  },
  {
    zip_code: "63384",

    ste_name: "MO",
  },
  {
    zip_code: "63441",

    ste_name: "MO",
  },
  {
    zip_code: "63462",

    ste_name: "MO",
  },
  {
    zip_code: "63538",

    ste_name: "MO",
  },
  {
    zip_code: "63621",

    ste_name: "MO",
  },
  {
    zip_code: "63627",

    ste_name: "MO",
  },
  {
    zip_code: "63633",

    ste_name: "MO",
  },
  {
    zip_code: "63701",

    ste_name: "MO",
  },
  {
    zip_code: "63830",

    ste_name: "MO",
  },
  {
    zip_code: "63870",

    ste_name: "MO",
  },
  {
    zip_code: "64036",

    ste_name: "MO",
  },
  {
    zip_code: "64064",

    ste_name: "MO",
  },
  {
    zip_code: "64082",

    ste_name: "MO",
  },
  {
    zip_code: "64102",

    ste_name: "MO",
  },
  {
    zip_code: "64161",

    ste_name: "MO",
  },
  {
    zip_code: "64443",

    ste_name: "MO",
  },
  {
    zip_code: "64482",

    ste_name: "MO",
  },
  {
    zip_code: "64728",

    ste_name: "MO",
  },
  {
    zip_code: "64859",

    ste_name: "MO",
  },
  {
    zip_code: "65046",

    ste_name: "MO",
  },
  {
    zip_code: "65350",

    ste_name: "MO",
  },
  {
    zip_code: "65401",

    ste_name: "MO",
  },
  {
    zip_code: "65582",

    ste_name: "MO",
  },
  {
    zip_code: "65584",

    ste_name: "MO",
  },
  {
    zip_code: "65622",

    ste_name: "MO",
  },
  {
    zip_code: "65647",

    ste_name: "MO",
  },
  {
    zip_code: "65730",

    ste_name: "MO",
  },
  {
    zip_code: "65773",

    ste_name: "MO",
  },
  {
    zip_code: "65804",

    ste_name: "MO",
  },
  {
    zip_code: "66014",

    ste_name: "KS",
  },
  {
    zip_code: "66021",

    ste_name: "KS",
  },
  {
    zip_code: "66053",

    ste_name: "KS",
  },
  {
    zip_code: "66219",

    ste_name: "KS",
  },
  {
    zip_code: "66419",

    ste_name: "KS",
  },
  {
    zip_code: "66782",

    ste_name: "KS",
  },
  {
    zip_code: "66850",

    ste_name: "KS",
  },
  {
    zip_code: "66866",

    ste_name: "KS",
  },
  {
    zip_code: "66943",

    ste_name: "KS",
  },
  {
    zip_code: "66956",

    ste_name: "KS",
  },
  {
    zip_code: "67061",

    ste_name: "KS",
  },
  {
    zip_code: "67226",

    ste_name: "KS",
  },
  {
    zip_code: "67356",

    ste_name: "KS",
  },
  {
    zip_code: "67445",

    ste_name: "KS",
  },
  {
    zip_code: "67487",

    ste_name: "KS",
  },
  {
    zip_code: "67563",

    ste_name: "KS",
  },
  {
    zip_code: "67566",

    ste_name: "KS",
  },
  {
    zip_code: "67638",

    ste_name: "KS",
  },
  {
    zip_code: "67639",

    ste_name: "KS",
  },
  {
    zip_code: "67865",

    ste_name: "KS",
  },
  {
    zip_code: "68001",

    ste_name: "NE",
  },
  {
    zip_code: "68014",

    ste_name: "NE",
  },
  {
    zip_code: "68030",

    ste_name: "NE",
  },
  {
    zip_code: "68071",

    ste_name: "NE",
  },
  {
    zip_code: "68108",

    ste_name: "NE",
  },
  {
    zip_code: "68116",

    ste_name: "NE",
  },
  {
    zip_code: "68431",

    ste_name: "NE",
  },
  {
    zip_code: "68631",

    ste_name: "NE",
  },
  {
    zip_code: "68773",

    ste_name: "NE",
  },
  {
    zip_code: "68788",

    ste_name: "NE",
  },
  {
    zip_code: "68818",

    ste_name: "NE",
  },
  {
    zip_code: "68828",

    ste_name: "NE",
  },
  {
    zip_code: "68856",

    ste_name: "NE",
  },
  {
    zip_code: "68933",

    ste_name: "NE",
  },
  {
    zip_code: "68978",

    ste_name: "NE",
  },
  {
    zip_code: "69023",

    ste_name: "NE",
  },
  {
    zip_code: "69129",

    ste_name: "NE",
  },
  {
    zip_code: "69142",

    ste_name: "NE",
  },
  {
    zip_code: "69221",

    ste_name: "NE",
  },
  {
    zip_code: "70043",

    ste_name: "LA",
  },
  {
    zip_code: "70116",

    ste_name: "LA",
  },
  {
    zip_code: "70340",

    ste_name: "LA",
  },
  {
    zip_code: "70346",

    ste_name: "LA",
  },
  {
    zip_code: "70363",

    ste_name: "LA",
  },
  {
    zip_code: "70437",

    ste_name: "LA",
  },
  {
    zip_code: "70444",

    ste_name: "LA",
  },
  {
    zip_code: "70517",

    ste_name: "LA",
  },
  {
    zip_code: "70552",

    ste_name: "LA",
  },
  {
    zip_code: "70560",

    ste_name: "LA",
  },
  {
    zip_code: "70592",

    ste_name: "LA",
  },
  {
    zip_code: "70726",

    ste_name: "LA",
  },
  {
    zip_code: "70750",

    ste_name: "LA",
  },
  {
    zip_code: "70775",

    ste_name: "LA",
  },
  {
    zip_code: "70812",

    ste_name: "LA",
  },
  {
    zip_code: "71051",

    ste_name: "LA",
  },
  {
    zip_code: "71055",

    ste_name: "LA",
  },
  {
    zip_code: "71065",

    ste_name: "LA",
  },
  {
    zip_code: "71238",

    ste_name: "LA",
  },
  {
    zip_code: "71282",

    ste_name: "LA",
  },
  {
    zip_code: "71418",

    ste_name: "LA",
  },
  {
    zip_code: "71425",

    ste_name: "LA",
  },
  {
    zip_code: "71435",

    ste_name: "LA",
  },
  {
    zip_code: "71601",

    ste_name: "AR",
  },
  {
    zip_code: "71675",

    ste_name: "AR",
  },
  {
    zip_code: "71677",

    ste_name: "AR",
  },
  {
    zip_code: "71953",

    ste_name: "AR",
  },
  {
    zip_code: "72014",

    ste_name: "AR",
  },
  {
    zip_code: "72070",

    ste_name: "AR",
  },
  {
    zip_code: "72087",

    ste_name: "AR",
  },
  {
    zip_code: "72119",

    ste_name: "AR",
  },
  {
    zip_code: "72374",

    ste_name: "AR",
  },
  {
    zip_code: "72422",

    ste_name: "AR",
  },
  {
    zip_code: "72560",

    ste_name: "AR",
  },
  {
    zip_code: "72641",

    ste_name: "AR",
  },
  {
    zip_code: "72742",

    ste_name: "AR",
  },
  {
    zip_code: "72773",

    ste_name: "AR",
  },
  {
    zip_code: "72856",

    ste_name: "AR",
  },
  {
    zip_code: "72904",

    ste_name: "AR",
  },
  {
    zip_code: "73053",

    ste_name: "OK",
  },
  {
    zip_code: "73077",

    ste_name: "OK",
  },
  {
    zip_code: "73106",

    ste_name: "OK",
  },
  {
    zip_code: "73622",

    ste_name: "OK",
  },
  {
    zip_code: "73624",

    ste_name: "OK",
  },
  {
    zip_code: "73626",

    ste_name: "OK",
  },
  {
    zip_code: "73664",

    ste_name: "OK",
  },
  {
    zip_code: "73768",

    ste_name: "OK",
  },
  {
    zip_code: "73843",

    ste_name: "OK",
  },
  {
    zip_code: "73859",

    ste_name: "OK",
  },
  {
    zip_code: "73950",

    ste_name: "OK",
  },
  {
    zip_code: "74002",

    ste_name: "OK",
  },
  {
    zip_code: "74023",

    ste_name: "OK",
  },
  {
    zip_code: "74063",

    ste_name: "OK",
  },
  {
    zip_code: "74128",

    ste_name: "OK",
  },
  {
    zip_code: "74135",

    ste_name: "OK",
  },
  {
    zip_code: "74337",

    ste_name: "OK",
  },
  {
    zip_code: "74358",

    ste_name: "OK",
  },
  {
    zip_code: "74523",

    ste_name: "OK",
  },
  {
    zip_code: "74651",

    ste_name: "OK",
  },
  {
    zip_code: "74754",

    ste_name: "OK",
  },
  {
    zip_code: "75134",

    ste_name: "TX",
  },
  {
    zip_code: "75251",

    ste_name: "TX",
  },
  {
    zip_code: "75252",

    ste_name: "TX",
  },
  {
    zip_code: "75415",

    ste_name: "TX",
  },
  {
    zip_code: "75446",

    ste_name: "TX",
  },
  {
    zip_code: "75459",

    ste_name: "TX",
  },
  {
    zip_code: "75462",

    ste_name: "TX",
  },
  {
    zip_code: "75639",

    ste_name: "TX",
  },
  {
    zip_code: "75642",

    ste_name: "TX",
  },
  {
    zip_code: "75750",

    ste_name: "TX",
  },
  {
    zip_code: "75763",

    ste_name: "TX",
  },
  {
    zip_code: "75852",

    ste_name: "TX",
  },
  {
    zip_code: "75966",

    ste_name: "TX",
  },
  {
    zip_code: "75968",

    ste_name: "TX",
  },
  {
    zip_code: "76021",

    ste_name: "TX",
  },
  {
    zip_code: "76034",

    ste_name: "TX",
  },
  {
    zip_code: "76051",

    ste_name: "TX",
  },
  {
    zip_code: "76110",

    ste_name: "TX",
  },
  {
    zip_code: "76155",

    ste_name: "TX",
  },
  {
    zip_code: "76262",

    ste_name: "TX",
  },
  {
    zip_code: "76384",

    ste_name: "TX",
  },
  {
    zip_code: "76431",

    ste_name: "TX",
  },
  {
    zip_code: "76437",

    ste_name: "TX",
  },
  {
    zip_code: "76470",

    ste_name: "TX",
  },
  {
    zip_code: "76596",

    ste_name: "TX",
  },
  {
    zip_code: "76639",

    ste_name: "TX",
  },
  {
    zip_code: "76686",

    ste_name: "TX",
  },
  {
    zip_code: "77006",

    ste_name: "TX",
  },
  {
    zip_code: "77024",

    ste_name: "TX",
  },
  {
    zip_code: "77042",

    ste_name: "TX",
  },
  {
    zip_code: "77085",

    ste_name: "TX",
  },
  {
    zip_code: "77364",

    ste_name: "TX",
  },
  {
    zip_code: "77418",

    ste_name: "TX",
  },
  {
    zip_code: "77493",

    ste_name: "TX",
  },
  {
    zip_code: "77504",

    ste_name: "TX",
  },
  {
    zip_code: "77519",

    ste_name: "TX",
  },
  {
    zip_code: "77531",

    ste_name: "TX",
  },
  {
    zip_code: "77575",

    ste_name: "TX",
  },
  {
    zip_code: "77587",

    ste_name: "TX",
  },
  {
    zip_code: "77619",

    ste_name: "TX",
  },
  {
    zip_code: "77627",

    ste_name: "TX",
  },
  {
    zip_code: "77701",

    ste_name: "TX",
  },
  {
    zip_code: "77808",

    ste_name: "TX",
  },
  {
    zip_code: "77859",

    ste_name: "TX",
  },
  {
    zip_code: "77974",

    ste_name: "TX",
  },
  {
    zip_code: "77975",

    ste_name: "TX",
  },
  {
    zip_code: "78003",

    ste_name: "TX",
  },
  {
    zip_code: "78052",

    ste_name: "TX",
  },
  {
    zip_code: "78141",

    ste_name: "TX",
  },
  {
    zip_code: "78142",

    ste_name: "TX",
  },
  {
    zip_code: "78229",

    ste_name: "TX",
  },
  {
    zip_code: "78344",

    ste_name: "TX",
  },
  {
    zip_code: "78371",

    ste_name: "TX",
  },
  {
    zip_code: "78574",

    ste_name: "TX",
  },
  {
    zip_code: "78665",

    ste_name: "TX",
  },
  {
    zip_code: "78672",

    ste_name: "TX",
  },
  {
    zip_code: "78754",

    ste_name: "TX",
  },
  {
    zip_code: "78829",

    ste_name: "TX",
  },
  {
    zip_code: "78953",

    ste_name: "TX",
  },
  {
    zip_code: "79032",

    ste_name: "TX",
  },
  {
    zip_code: "79058",

    ste_name: "TX",
  },
  {
    zip_code: "79064",

    ste_name: "TX",
  },
  {
    zip_code: "79330",

    ste_name: "TX",
  },
  {
    zip_code: "79380",

    ste_name: "TX",
  },
  {
    zip_code: "79406",

    ste_name: "TX",
  },
  {
    zip_code: "79410",

    ste_name: "TX",
  },
  {
    zip_code: "79412",

    ste_name: "TX",
  },
  {
    zip_code: "79567",

    ste_name: "TX",
  },
  {
    zip_code: "79839",

    ste_name: "TX",
  },
  {
    zip_code: "79848",

    ste_name: "TX",
  },
  {
    zip_code: "80017",

    ste_name: "CO",
  },
  {
    zip_code: "80033",

    ste_name: "CO",
  },
  {
    zip_code: "80112",

    ste_name: "CO",
  },
  {
    zip_code: "80134",

    ste_name: "CO",
  },
  {
    zip_code: "80229",

    ste_name: "CO",
  },
  {
    zip_code: "80234",

    ste_name: "CO",
  },
  {
    zip_code: "80304",

    ste_name: "CO",
  },
  {
    zip_code: "80403",

    ste_name: "CO",
  },
  {
    zip_code: "80439",

    ste_name: "CO",
  },
  {
    zip_code: "80448",

    ste_name: "CO",
  },
  {
    zip_code: "80449",

    ste_name: "CO",
  },
  {
    zip_code: "80453",

    ste_name: "CO",
  },
  {
    zip_code: "80456",

    ste_name: "CO",
  },
  {
    zip_code: "80833",

    ste_name: "CO",
  },
  {
    zip_code: "80911",

    ste_name: "CO",
  },
  {
    zip_code: "81005",

    ste_name: "CO",
  },
  {
    zip_code: "81019",

    ste_name: "CO",
  },
  {
    zip_code: "81151",

    ste_name: "CO",
  },
  {
    zip_code: "81201",

    ste_name: "CO",
  },
  {
    zip_code: "81244",

    ste_name: "CO",
  },
  {
    zip_code: "81323",

    ste_name: "CO",
  },
  {
    zip_code: "81432",

    ste_name: "CO",
  },
  {
    zip_code: "81435",

    ste_name: "CO",
  },
  {
    zip_code: "81521",

    ste_name: "CO",
  },
  {
    zip_code: "81642",

    ste_name: "CO",
  },
  {
    zip_code: "81646",

    ste_name: "CO",
  },
  {
    zip_code: "81648",

    ste_name: "CO",
  },
  {
    zip_code: "82053",

    ste_name: "WY",
  },
  {
    zip_code: "82221",

    ste_name: "WY",
  },
  {
    zip_code: "82224",

    ste_name: "WY",
  },
  {
    zip_code: "82323",

    ste_name: "WY",
  },
  {
    zip_code: "82336",

    ste_name: "WY",
  },
  {
    zip_code: "82514",

    ste_name: "WY",
  },
  {
    zip_code: "82720",

    ste_name: "WY",
  },
  {
    zip_code: "82835",

    ste_name: "WY",
  },
  {
    zip_code: "83011",

    ste_name: "WY",
  },
  {
    zip_code: "83214",

    ste_name: "ID",
  },
  {
    zip_code: "83263",

    ste_name: "ID",
  },
  {
    zip_code: "83324",

    ste_name: "ID",
  },
  {
    zip_code: "83444",

    ste_name: "ID",
  },
  {
    zip_code: "83464",

    ste_name: "ID",
  },
  {
    zip_code: "83548",

    ste_name: "ID",
  },
  {
    zip_code: "83607",

    ste_name: "ID",
  },
  {
    zip_code: "83617",

    ste_name: "ID",
  },
  {
    zip_code: "83666",

    ste_name: "ID",
  },
  {
    zip_code: "83714",

    ste_name: "ID",
  },
  {
    zip_code: "83832",

    ste_name: "ID",
  },
  {
    zip_code: "84024",

    ste_name: "UT",
  },
  {
    zip_code: "84056",

    ste_name: "UT",
  },
  {
    zip_code: "84311",

    ste_name: "UT",
  },
  {
    zip_code: "84739",

    ste_name: "UT",
  },
  {
    zip_code: "84764",

    ste_name: "UT",
  },
  {
    zip_code: "85007",

    ste_name: "AZ",
  },
  {
    zip_code: "85015",

    ste_name: "AZ",
  },
  {
    zip_code: "85034",

    ste_name: "AZ",
  },
  {
    zip_code: "85206",

    ste_name: "AZ",
  },
  {
    zip_code: "85212",

    ste_name: "AZ",
  },
  {
    zip_code: "85303",

    ste_name: "AZ",
  },
  {
    zip_code: "85340",

    ste_name: "AZ",
  },
  {
    zip_code: "85374",

    ste_name: "AZ",
  },
  {
    zip_code: "85714",

    ste_name: "AZ",
  },
  {
    zip_code: "85922",

    ste_name: "AZ",
  },
  {
    zip_code: "85931",

    ste_name: "AZ",
  },
  {
    zip_code: "86046",

    ste_name: "AZ",
  },
  {
    zip_code: "86326",

    ste_name: "AZ",
  },
  {
    zip_code: "86331",

    ste_name: "AZ",
  },
  {
    zip_code: "86401",

    ste_name: "AZ",
  },
  {
    zip_code: "86404",

    ste_name: "AZ",
  },
  {
    zip_code: "87022",

    ste_name: "NM",
  },
  {
    zip_code: "87327",

    ste_name: "NM",
  },
  {
    zip_code: "87417",

    ste_name: "NM",
  },
  {
    zip_code: "87573",

    ste_name: "NM",
  },
  {
    zip_code: "87713",

    ste_name: "NM",
  },
  {
    zip_code: "87722",

    ste_name: "NM",
  },
  {
    zip_code: "88021",

    ste_name: "NM",
  },
  {
    zip_code: "88250",

    ste_name: "NM",
  },
  {
    zip_code: "88262",

    ste_name: "NM",
  },
  {
    zip_code: "88318",

    ste_name: "NM",
  },
  {
    zip_code: "88350",

    ste_name: "NM",
  },
  {
    zip_code: "89026",

    ste_name: "NV",
  },
  {
    zip_code: "89052",

    ste_name: "NV",
  },
  {
    zip_code: "89129",

    ste_name: "NV",
  },
  {
    zip_code: "89161",

    ste_name: "NV",
  },
  {
    zip_code: "89169",

    ste_name: "NV",
  },
  {
    zip_code: "89460",

    ste_name: "NV",
  },
  {
    zip_code: "89501",

    ste_name: "NV",
  },
  {
    zip_code: "31067",

    ste_name: "GA",
  },
  {
    zip_code: "31094",

    ste_name: "GA",
  },
  {
    zip_code: "31305",

    ste_name: "GA",
  },
  {
    zip_code: "31537",

    ste_name: "GA",
  },
  {
    zip_code: "31542",

    ste_name: "GA",
  },
  {
    zip_code: "31645",

    ste_name: "GA",
  },
  {
    zip_code: "31763",

    ste_name: "GA",
  },
  {
    zip_code: "31792",

    ste_name: "GA",
  },
  {
    zip_code: "31798",

    ste_name: "GA",
  },
  {
    zip_code: "31906",

    ste_name: "GA",
  },
  {
    zip_code: "32114",

    ste_name: "FL",
  },
  {
    zip_code: "32148",

    ste_name: "FL",
  },
  {
    zip_code: "32211",

    ste_name: "FL",
  },
  {
    zip_code: "32312",

    ste_name: "FL",
  },
  {
    zip_code: "32437",

    ste_name: "FL",
  },
  {
    zip_code: "32542",

    ste_name: "FL",
  },
  {
    zip_code: "32568",

    ste_name: "FL",
  },
  {
    zip_code: "32648",

    ste_name: "FL",
  },
  {
    zip_code: "32701",

    ste_name: "FL",
  },
  {
    zip_code: "32712",

    ste_name: "FL",
  },
  {
    zip_code: "32744",

    ste_name: "FL",
  },
  {
    zip_code: "33016",

    ste_name: "FL",
  },
  {
    zip_code: "33023",

    ste_name: "FL",
  },
  {
    zip_code: "33060",

    ste_name: "FL",
  },
  {
    zip_code: "33068",

    ste_name: "FL",
  },
  {
    zip_code: "33137",

    ste_name: "FL",
  },
  {
    zip_code: "33305",

    ste_name: "FL",
  },
  {
    zip_code: "33323",

    ste_name: "FL",
  },
  {
    zip_code: "33325",

    ste_name: "FL",
  },
  {
    zip_code: "33328",

    ste_name: "FL",
  },
  {
    zip_code: "33413",

    ste_name: "FL",
  },
  {
    zip_code: "33567",

    ste_name: "FL",
  },
  {
    zip_code: "33572",

    ste_name: "FL",
  },
  {
    zip_code: "33635",

    ste_name: "FL",
  },
  {
    zip_code: "33810",

    ste_name: "FL",
  },
  {
    zip_code: "33903",

    ste_name: "FL",
  },
  {
    zip_code: "33954",

    ste_name: "FL",
  },
  {
    zip_code: "33955",

    ste_name: "FL",
  },
  {
    zip_code: "34139",

    ste_name: "FL",
  },
  {
    zip_code: "34212",

    ste_name: "FL",
  },
  {
    zip_code: "34240",

    ste_name: "FL",
  },
  {
    zip_code: "34243",

    ste_name: "FL",
  },
  {
    zip_code: "34428",

    ste_name: "FL",
  },
  {
    zip_code: "34608",

    ste_name: "FL",
  },
  {
    zip_code: "34990",

    ste_name: "FL",
  },
  {
    zip_code: "35006",

    ste_name: "AL",
  },
  {
    zip_code: "35036",

    ste_name: "AL",
  },
  {
    zip_code: "35473",

    ste_name: "AL",
  },
  {
    zip_code: "35550",

    ste_name: "AL",
  },
  {
    zip_code: "35571",

    ste_name: "AL",
  },
  {
    zip_code: "35653",

    ste_name: "AL",
  },
  {
    zip_code: "35741",

    ste_name: "AL",
  },
  {
    zip_code: "35748",

    ste_name: "AL",
  },
  {
    zip_code: "35771",

    ste_name: "AL",
  },
  {
    zip_code: "35960",

    ste_name: "AL",
  },
  {
    zip_code: "36049",

    ste_name: "AL",
  },
  {
    zip_code: "36064",

    ste_name: "AL",
  },
  {
    zip_code: "36092",

    ste_name: "AL",
  },
  {
    zip_code: "36201",

    ste_name: "AL",
  },
  {
    zip_code: "36255",

    ste_name: "AL",
  },
  {
    zip_code: "36370",

    ste_name: "AL",
  },
  {
    zip_code: "36609",

    ste_name: "AL",
  },
  {
    zip_code: "36859",

    ste_name: "AL",
  },
  {
    zip_code: "36863",

    ste_name: "AL",
  },
  {
    zip_code: "36913",

    ste_name: "AL",
  },
  {
    zip_code: "36925",

    ste_name: "AL",
  },
  {
    zip_code: "37028",

    ste_name: "TN",
  },
  {
    zip_code: "37246",

    ste_name: "TN",
  },
  {
    zip_code: "37317",

    ste_name: "TN",
  },
  {
    zip_code: "37336",

    ste_name: "TN",
  },
  {
    zip_code: "37366",

    ste_name: "TN",
  },
  {
    zip_code: "37375",

    ste_name: "TN",
  },
  {
    zip_code: "37391",

    ste_name: "TN",
  },
  {
    zip_code: "37715",

    ste_name: "TN",
  },
  {
    zip_code: "37738",

    ste_name: "TN",
  },
  {
    zip_code: "37804",

    ste_name: "TN",
  },
  {
    zip_code: "37818",

    ste_name: "TN",
  },
  {
    zip_code: "37840",

    ste_name: "TN",
  },
  {
    zip_code: "37869",

    ste_name: "TN",
  },
  {
    zip_code: "38047",

    ste_name: "TN",
  },
  {
    zip_code: "38053",

    ste_name: "TN",
  },
  {
    zip_code: "38109",

    ste_name: "TN",
  },
  {
    zip_code: "38236",

    ste_name: "TN",
  },
  {
    zip_code: "38242",

    ste_name: "TN",
  },
  {
    zip_code: "38310",

    ste_name: "TN",
  },
  {
    zip_code: "38337",

    ste_name: "TN",
  },
  {
    zip_code: "38452",

    ste_name: "TN",
  },
  {
    zip_code: "38461",

    ste_name: "TN",
  },
  {
    zip_code: "38485",

    ste_name: "TN",
  },
  {
    zip_code: "38488",

    ste_name: "TN",
  },
  {
    zip_code: "38553",

    ste_name: "TN",
  },
  {
    zip_code: "38606",

    ste_name: "MS",
  },
  {
    zip_code: "38720",

    ste_name: "MS",
  },
  {
    zip_code: "38725",

    ste_name: "MS",
  },
  {
    zip_code: "38745",

    ste_name: "MS",
  },
  {
    zip_code: "38838",

    ste_name: "MS",
  },
  {
    zip_code: "38865",

    ste_name: "MS",
  },
  {
    zip_code: "38952",

    ste_name: "MS",
  },
  {
    zip_code: "39095",

    ste_name: "MS",
  },
  {
    zip_code: "39162",

    ste_name: "MS",
  },
  {
    zip_code: "39202",

    ste_name: "MS",
  },
  {
    zip_code: "39647",

    ste_name: "MS",
  },
  {
    zip_code: "39756",

    ste_name: "MS",
  },
  {
    zip_code: "39760",

    ste_name: "MS",
  },
  {
    zip_code: "40051",

    ste_name: "KY",
  },
  {
    zip_code: "40070",

    ste_name: "KY",
  },
  {
    zip_code: "40107",

    ste_name: "KY",
  },
  {
    zip_code: "40121",

    ste_name: "KY",
  },
  {
    zip_code: "40202",

    ste_name: "KY",
  },
  {
    zip_code: "40205",

    ste_name: "KY",
  },
  {
    zip_code: "40337",

    ste_name: "KY",
  },
  {
    zip_code: "40361",

    ste_name: "KY",
  },
  {
    zip_code: "40370",

    ste_name: "KY",
  },
  {
    zip_code: "40371",

    ste_name: "KY",
  },
  {
    zip_code: "40444",

    ste_name: "KY",
  },
  {
    zip_code: "40460",

    ste_name: "KY",
  },
  {
    zip_code: "40481",

    ste_name: "KY",
  },
  {
    zip_code: "40510",

    ste_name: "KY",
  },
  {
    zip_code: "40604",

    ste_name: "KY",
  },
  {
    zip_code: "40962",

    ste_name: "KY",
  },
  {
    zip_code: "40979",

    ste_name: "KY",
  },
  {
    zip_code: "40982",

    ste_name: "KY",
  },
  {
    zip_code: "40997",

    ste_name: "KY",
  },
  {
    zip_code: "41045",

    ste_name: "KY",
  },
  {
    zip_code: "41071",

    ste_name: "KY",
  },
  {
    zip_code: "41603",

    ste_name: "KY",
  },
  {
    zip_code: "41621",

    ste_name: "KY",
  },
  {
    zip_code: "41630",

    ste_name: "KY",
  },
  {
    zip_code: "41647",

    ste_name: "KY",
  },
  {
    zip_code: "41713",

    ste_name: "KY",
  },
  {
    zip_code: "41725",

    ste_name: "KY",
  },
  {
    zip_code: "41837",

    ste_name: "KY",
  },
  {
    zip_code: "41839",

    ste_name: "KY",
  },
  {
    zip_code: "42032",

    ste_name: "KY",
  },
  {
    zip_code: "42060",

    ste_name: "KY",
  },
  {
    zip_code: "42210",

    ste_name: "KY",
  },
  {
    zip_code: "42259",

    ste_name: "KY",
  },
  {
    zip_code: "42261",

    ste_name: "KY",
  },
  {
    zip_code: "42410",

    ste_name: "KY",
  },
  {
    zip_code: "42635",

    ste_name: "KY",
  },
  {
    zip_code: "42764",

    ste_name: "KY",
  },
  {
    zip_code: "43013",

    ste_name: "OH",
  },
  {
    zip_code: "43110",

    ste_name: "OH",
  },
  {
    zip_code: "43302",

    ste_name: "OH",
  },
  {
    zip_code: "43343",

    ste_name: "OH",
  },
  {
    zip_code: "43462",

    ste_name: "OH",
  },
  {
    zip_code: "43518",

    ste_name: "OH",
  },
  {
    zip_code: "43526",

    ste_name: "OH",
  },
  {
    zip_code: "43528",

    ste_name: "OH",
  },
  {
    zip_code: "43758",

    ste_name: "OH",
  },
  {
    zip_code: "43985",

    ste_name: "OH",
  },
  {
    zip_code: "44080",

    ste_name: "OH",
  },
  {
    zip_code: "44109",

    ste_name: "OH",
  },
  {
    zip_code: "44127",

    ste_name: "OH",
  },
  {
    zip_code: "44144",

    ste_name: "OH",
  },
  {
    zip_code: "44217",

    ste_name: "OH",
  },
  {
    zip_code: "44278",

    ste_name: "OH",
  },
  {
    zip_code: "44402",

    ste_name: "OH",
  },
  {
    zip_code: "44405",

    ste_name: "OH",
  },
  {
    zip_code: "44618",

    ste_name: "OH",
  },
  {
    zip_code: "44620",

    ste_name: "OH",
  },
  {
    zip_code: "44641",

    ste_name: "OH",
  },
  {
    zip_code: "44691",

    ste_name: "OH",
  },
  {
    zip_code: "44815",

    ste_name: "OH",
  },
  {
    zip_code: "44826",

    ste_name: "OH",
  },
  {
    zip_code: "45034",

    ste_name: "OH",
  },
  {
    zip_code: "45107",

    ste_name: "OH",
  },
  {
    zip_code: "45164",

    ste_name: "OH",
  },
  {
    zip_code: "45214",

    ste_name: "OH",
  },
  {
    zip_code: "45215",

    ste_name: "OH",
  },
  {
    zip_code: "45330",

    ste_name: "OH",
  },
  {
    zip_code: "45347",

    ste_name: "OH",
  },
  {
    zip_code: "45360",

    ste_name: "OH",
  },
  {
    zip_code: "45387",

    ste_name: "OH",
  },
  {
    zip_code: "45419",

    ste_name: "OH",
  },
  {
    zip_code: "45429",

    ste_name: "OH",
  },
  {
    zip_code: "45601",

    ste_name: "OH",
  },
  {
    zip_code: "45776",

    ste_name: "OH",
  },
  {
    zip_code: "45805",

    ste_name: "OH",
  },
  {
    zip_code: "46074",

    ste_name: "IN",
  },
  {
    zip_code: "46155",

    ste_name: "IN",
  },
  {
    zip_code: "46377",

    ste_name: "IN",
  },
  {
    zip_code: "46410",

    ste_name: "IN",
  },
  {
    zip_code: "46501",

    ste_name: "IN",
  },
  {
    zip_code: "46524",

    ste_name: "IN",
  },
  {
    zip_code: "46538",

    ste_name: "IN",
  },
  {
    zip_code: "46571",

    ste_name: "IN",
  },
  {
    zip_code: "46733",

    ste_name: "IN",
  },
  {
    zip_code: "46741",

    ste_name: "IN",
  },
  {
    zip_code: "46795",

    ste_name: "IN",
  },
  {
    zip_code: "46901",

    ste_name: "IN",
  },
  {
    zip_code: "46911",

    ste_name: "IN",
  },
  {
    zip_code: "47006",

    ste_name: "IN",
  },
  {
    zip_code: "47022",

    ste_name: "IN",
  },
  {
    zip_code: "47137",

    ste_name: "IN",
  },
  {
    zip_code: "47150",

    ste_name: "IN",
  },
  {
    zip_code: "47232",

    ste_name: "IN",
  },
  {
    zip_code: "47359",

    ste_name: "IN",
  },
  {
    zip_code: "47452",

    ste_name: "IN",
  },
  {
    zip_code: "47464",

    ste_name: "IN",
  },
  {
    zip_code: "47654",

    ste_name: "IN",
  },
  {
    zip_code: "47683",

    ste_name: "IN",
  },
  {
    zip_code: "47855",

    ste_name: "IN",
  },
  {
    zip_code: "47868",

    ste_name: "IN",
  },
  {
    zip_code: "47871",

    ste_name: "IN",
  },
  {
    zip_code: "47965",

    ste_name: "IN",
  },
  {
    zip_code: "48026",

    ste_name: "MI",
  },
  {
    zip_code: "48027",

    ste_name: "MI",
  },
  {
    zip_code: "48091",

    ste_name: "MI",
  },
  {
    zip_code: "48092",

    ste_name: "MI",
  },
  {
    zip_code: "48128",

    ste_name: "MI",
  },
  {
    zip_code: "48139",

    ste_name: "MI",
  },
  {
    zip_code: "48211",

    ste_name: "MI",
  },
  {
    zip_code: "48312",

    ste_name: "MI",
  },
  {
    zip_code: "48322",

    ste_name: "MI",
  },
  {
    zip_code: "48323",

    ste_name: "MI",
  },
  {
    zip_code: "48455",

    ste_name: "MI",
  },
  {
    zip_code: "48737",

    ste_name: "MI",
  },
  {
    zip_code: "48760",

    ste_name: "MI",
  },
  {
    zip_code: "48770",

    ste_name: "MI",
  },
  {
    zip_code: "48852",

    ste_name: "MI",
  },
  {
    zip_code: "49007",

    ste_name: "MI",
  },
  {
    zip_code: "49015",

    ste_name: "MI",
  },
  {
    zip_code: "49037",

    ste_name: "MI",
  },
  {
    zip_code: "49050",

    ste_name: "MI",
  },
  {
    zip_code: "49056",

    ste_name: "MI",
  },
  {
    zip_code: "49236",

    ste_name: "MI",
  },
  {
    zip_code: "49301",

    ste_name: "MI",
  },
  {
    zip_code: "49616",

    ste_name: "MI",
  },
  {
    zip_code: "49645",

    ste_name: "MI",
  },
  {
    zip_code: "49675",

    ste_name: "MI",
  },
  {
    zip_code: "49718",

    ste_name: "MI",
  },
  {
    zip_code: "49854",

    ste_name: "MI",
  },
  {
    zip_code: "49855",

    ste_name: "MI",
  },
  {
    zip_code: "49911",

    ste_name: "MI",
  },
  {
    zip_code: "50012",

    ste_name: "IA",
  },
  {
    zip_code: "50046",

    ste_name: "IA",
  },
  {
    zip_code: "50054",

    ste_name: "IA",
  },
  {
    zip_code: "50078",

    ste_name: "IA",
  },
  {
    zip_code: "50206",

    ste_name: "IA",
  },
  {
    zip_code: "50257",

    ste_name: "IA",
  },
  {
    zip_code: "50312",

    ste_name: "IA",
  },
  {
    zip_code: "50322",

    ste_name: "IA",
  },
  {
    zip_code: "50477",

    ste_name: "IA",
  },
  {
    zip_code: "50517",

    ste_name: "IA",
  },
  {
    zip_code: "50523",

    ste_name: "IA",
  },
  {
    zip_code: "50536",

    ste_name: "IA",
  },
  {
    zip_code: "50559",

    ste_name: "IA",
  },
  {
    zip_code: "50570",

    ste_name: "IA",
  },
  {
    zip_code: "50577",

    ste_name: "IA",
  },
  {
    zip_code: "50611",

    ste_name: "IA",
  },
  {
    zip_code: "50673",

    ste_name: "IA",
  },
  {
    zip_code: "50842",

    ste_name: "IA",
  },
  {
    zip_code: "50843",

    ste_name: "IA",
  },
  {
    zip_code: "51025",

    ste_name: "IA",
  },
  {
    zip_code: "51039",

    ste_name: "IA",
  },
  {
    zip_code: "51040",

    ste_name: "IA",
  },
  {
    zip_code: "51244",

    ste_name: "IA",
  },
  {
    zip_code: "51459",

    ste_name: "IA",
  },
  {
    zip_code: "51461",

    ste_name: "IA",
  },
  {
    zip_code: "51529",

    ste_name: "IA",
  },
  {
    zip_code: "51550",

    ste_name: "IA",
  },
  {
    zip_code: "52031",

    ste_name: "IA",
  },
  {
    zip_code: "52208",

    ste_name: "IA",
  },
  {
    zip_code: "52219",

    ste_name: "IA",
  },
  {
    zip_code: "52222",

    ste_name: "IA",
  },
  {
    zip_code: "52228",

    ste_name: "IA",
  },
  {
    zip_code: "52533",

    ste_name: "IA",
  },
  {
    zip_code: "52542",

    ste_name: "IA",
  },
  {
    zip_code: "52593",

    ste_name: "IA",
  },
  {
    zip_code: "52721",

    ste_name: "IA",
  },
  {
    zip_code: "52756",

    ste_name: "IA",
  },
  {
    zip_code: "52757",

    ste_name: "IA",
  },
  {
    zip_code: "52774",

    ste_name: "IA",
  },
  {
    zip_code: "53001",

    ste_name: "WI",
  },
  {
    zip_code: "53004",

    ste_name: "WI",
  },
  {
    zip_code: "53069",

    ste_name: "WI",
  },
  {
    zip_code: "53120",

    ste_name: "WI",
  },
  {
    zip_code: "53147",

    ste_name: "WI",
  },
  {
    zip_code: "53177",

    ste_name: "WI",
  },
  {
    zip_code: "53188",

    ste_name: "WI",
  },
  {
    zip_code: "53403",

    ste_name: "WI",
  },
  {
    zip_code: "53525",

    ste_name: "WI",
  },
  {
    zip_code: "53538",

    ste_name: "WI",
  },
  {
    zip_code: "53726",

    ste_name: "WI",
  },
  {
    zip_code: "53802",

    ste_name: "WI",
  },
  {
    zip_code: "53936",

    ste_name: "WI",
  },
  {
    zip_code: "53963",

    ste_name: "WI",
  },
  {
    zip_code: "54171",

    ste_name: "WI",
  },
  {
    zip_code: "54174",

    ste_name: "WI",
  },
  {
    zip_code: "54414",

    ste_name: "WI",
  },
  {
    zip_code: "54442",

    ste_name: "WI",
  },
  {
    zip_code: "54447",

    ste_name: "WI",
  },
  {
    zip_code: "54450",

    ste_name: "WI",
  },
  {
    zip_code: "54474",

    ste_name: "WI",
  },
  {
    zip_code: "54554",

    ste_name: "WI",
  },
  {
    zip_code: "54561",

    ste_name: "WI",
  },
  {
    zip_code: "54646",

    ste_name: "WI",
  },
  {
    zip_code: "54657",

    ste_name: "WI",
  },
  {
    zip_code: "54730",

    ste_name: "WI",
  },
  {
    zip_code: "54850",

    ste_name: "WI",
  },
  {
    zip_code: "54861",

    ste_name: "WI",
  },
  {
    zip_code: "54874",

    ste_name: "WI",
  },
  {
    zip_code: "54889",

    ste_name: "WI",
  },
  {
    zip_code: "54911",

    ste_name: "WI",
  },
  {
    zip_code: "54930",

    ste_name: "WI",
  },
  {
    zip_code: "55040",

    ste_name: "MN",
  },
  {
    zip_code: "55053",

    ste_name: "MN",
  },
  {
    zip_code: "55069",

    ste_name: "MN",
  },
  {
    zip_code: "55082",

    ste_name: "MN",
  },
  {
    zip_code: "55360",

    ste_name: "MN",
  },
  {
    zip_code: "55382",

    ste_name: "MN",
  },
  {
    zip_code: "55415",

    ste_name: "MN",
  },
  {
    zip_code: "55419",

    ste_name: "MN",
  },
  {
    zip_code: "55422",

    ste_name: "MN",
  },
  {
    zip_code: "55735",

    ste_name: "MN",
  },
  {
    zip_code: "55779",

    ste_name: "MN",
  },
  {
    zip_code: "55781",

    ste_name: "MN",
  },
  {
    zip_code: "55797",

    ste_name: "MN",
  },
  {
    zip_code: "55810",

    ste_name: "MN",
  },
  {
    zip_code: "55959",

    ste_name: "MN",
  },
  {
    zip_code: "55960",

    ste_name: "MN",
  },
  {
    zip_code: "55976",

    ste_name: "MN",
  },
  {
    zip_code: "55982",

    ste_name: "MN",
  },
  {
    zip_code: "56057",

    ste_name: "MN",
  },
  {
    zip_code: "56129",

    ste_name: "MN",
  },
  {
    zip_code: "56249",

    ste_name: "MN",
  },
  {
    zip_code: "56316",

    ste_name: "MN",
  },
  {
    zip_code: "56373",

    ste_name: "MN",
  },
  {
    zip_code: "56536",

    ste_name: "MN",
  },
  {
    zip_code: "56586",

    ste_name: "MN",
  },
  {
    zip_code: "56601",

    ste_name: "MN",
  },
  {
    zip_code: "56716",

    ste_name: "MN",
  },
  {
    zip_code: "57012",

    ste_name: "SD",
  },
  {
    zip_code: "57040",

    ste_name: "SD",
  },
  {
    zip_code: "57051",

    ste_name: "SD",
  },
  {
    zip_code: "57069",

    ste_name: "SD",
  },
  {
    zip_code: "57279",

    ste_name: "SD",
  },
  {
    zip_code: "57323",

    ste_name: "SD",
  },
  {
    zip_code: "57371",

    ste_name: "SD",
  },
  {
    zip_code: "57646",

    ste_name: "SD",
  },
  {
    zip_code: "57717",

    ste_name: "SD",
  },
  {
    zip_code: "58027",

    ste_name: "ND",
  },
  {
    zip_code: "58031",

    ste_name: "ND",
  },
  {
    zip_code: "58042",

    ste_name: "ND",
  },
  {
    zip_code: "58231",

    ste_name: "ND",
  },
  {
    zip_code: "58444",

    ste_name: "ND",
  },
  {
    zip_code: "58712",

    ste_name: "ND",
  },
  {
    zip_code: "617",

    ste_name: "PR",
  },
  {
    zip_code: "704",

    ste_name: "PR",
  },
  {
    zip_code: "735",

    ste_name: "PR",
  },
  {
    zip_code: "771",

    ste_name: "PR",
  },
  {
    zip_code: "783",

    ste_name: "PR",
  },
  {
    zip_code: "1083",

    ste_name: "MA",
  },
  {
    zip_code: "1098",

    ste_name: "MA",
  },
  {
    zip_code: "1106",

    ste_name: "MA",
  },
  {
    zip_code: "1108",

    ste_name: "MA",
  },
  {
    zip_code: "1367",

    ste_name: "MA",
  },
  {
    zip_code: "1451",

    ste_name: "MA",
  },
  {
    zip_code: "1460",

    ste_name: "MA",
  },
  {
    zip_code: "1504",

    ste_name: "MA",
  },
  {
    zip_code: "1536",

    ste_name: "MA",
  },
  {
    zip_code: "1543",

    ste_name: "MA",
  },
  {
    zip_code: "1583",

    ste_name: "MA",
  },
  {
    zip_code: "1604",

    ste_name: "MA",
  },
  {
    zip_code: "1747",

    ste_name: "MA",
  },
  {
    zip_code: "1772",

    ste_name: "MA",
  },
  {
    zip_code: "1854",

    ste_name: "MA",
  },
  {
    zip_code: "1937",

    ste_name: "MA",
  },
  {
    zip_code: "1940",

    ste_name: "MA",
  },
  {
    zip_code: "2038",

    ste_name: "MA",
  },
  {
    zip_code: "2138",

    ste_name: "MA",
  },
  {
    zip_code: "2659",

    ste_name: "MA",
  },
  {
    zip_code: "2669",

    ste_name: "MA",
  },
  {
    zip_code: "2703",

    ste_name: "MA",
  },
  {
    zip_code: "2713",

    ste_name: "MA",
  },
  {
    zip_code: "2715",

    ste_name: "MA",
  },
  {
    zip_code: "2790",

    ste_name: "MA",
  },
  {
    zip_code: "2827",

    ste_name: "RI",
  },
  {
    zip_code: "2872",

    ste_name: "RI",
  },
  {
    zip_code: "2878",

    ste_name: "RI",
  },
  {
    zip_code: "2916",

    ste_name: "RI",
  },
  {
    zip_code: "3042",

    ste_name: "NH",
  },
  {
    zip_code: "3303",

    ste_name: "NH",
  },
  {
    zip_code: "3442",

    ste_name: "NH",
  },
  {
    zip_code: "3583",

    ste_name: "NH",
  },
  {
    zip_code: "3765",

    ste_name: "NH",
  },
  {
    zip_code: "3871",

    ste_name: "NH",
  },
  {
    zip_code: "3873",

    ste_name: "NH",
  },
  {
    zip_code: "4011",

    ste_name: "ME",
  },
  {
    zip_code: "4030",

    ste_name: "ME",
  },
  {
    zip_code: "4055",

    ste_name: "ME",
  },
  {
    zip_code: "4222",

    ste_name: "ME",
  },
  {
    zip_code: "4253",

    ste_name: "ME",
  },
  {
    zip_code: "4276",

    ste_name: "ME",
  },
  {
    zip_code: "4414",

    ste_name: "ME",
  },
  {
    zip_code: "4417",

    ste_name: "ME",
  },
  {
    zip_code: "4454",

    ste_name: "ME",
  },
  {
    zip_code: "4544",

    ste_name: "ME",
  },
  {
    zip_code: "4564",

    ste_name: "ME",
  },
  {
    zip_code: "4644",

    ste_name: "ME",
  },
  {
    zip_code: "4646",

    ste_name: "ME",
  },
  {
    zip_code: "4660",

    ste_name: "ME",
  },
  {
    zip_code: "4757",

    ste_name: "ME",
  },
  {
    zip_code: "4777",

    ste_name: "ME",
  },
  {
    zip_code: "4787",

    ste_name: "ME",
  },
  {
    zip_code: "4983",

    ste_name: "ME",
  },
  {
    zip_code: "5360",

    ste_name: "VT",
  },
  {
    zip_code: "5456",

    ste_name: "VT",
  },
  {
    zip_code: "5463",

    ste_name: "VT",
  },
  {
    zip_code: "5734",

    ste_name: "VT",
  },
  {
    zip_code: "5735",

    ste_name: "VT",
  },
  {
    zip_code: "5738",

    ste_name: "VT",
  },
  {
    zip_code: "5744",

    ste_name: "VT",
  },
  {
    zip_code: "6027",

    ste_name: "CT",
  },
  {
    zip_code: "6061",

    ste_name: "CT",
  },
  {
    zip_code: "6255",

    ste_name: "CT",
  },
  {
    zip_code: "6262",

    ste_name: "CT",
  },
  {
    zip_code: "6331",

    ste_name: "CT",
  },
  {
    zip_code: "6457",

    ste_name: "CT",
  },
  {
    zip_code: "6492",

    ste_name: "CT",
  },
  {
    zip_code: "6515",

    ste_name: "CT",
  },
  {
    zip_code: "6518",

    ste_name: "CT",
  },
  {
    zip_code: "6604",

    ste_name: "CT",
  },
  {
    zip_code: "6755",

    ste_name: "CT",
  },
  {
    zip_code: "6758",

    ste_name: "CT",
  },
  {
    zip_code: "6759",

    ste_name: "CT",
  },
  {
    zip_code: "6782",

    ste_name: "CT",
  },
  {
    zip_code: "6870",

    ste_name: "CT",
  },
  {
    zip_code: "6896",

    ste_name: "CT",
  },
  {
    zip_code: "7014",

    ste_name: "NJ",
  },
  {
    zip_code: "7029",

    ste_name: "NJ",
  },
  {
    zip_code: "7420",

    ste_name: "NJ",
  },
  {
    zip_code: "7465",

    ste_name: "NJ",
  },
  {
    zip_code: "7727",

    ste_name: "NJ",
  },
  {
    zip_code: "7827",

    ste_name: "NJ",
  },
  {
    zip_code: "8067",

    ste_name: "NJ",
  },
  {
    zip_code: "8094",

    ste_name: "NJ",
  },
  {
    zip_code: "8224",

    ste_name: "NJ",
  },
  {
    zip_code: "8322",

    ste_name: "NJ",
  },
  {
    zip_code: "8534",

    ste_name: "NJ",
  },
  {
    zip_code: "10002",

    ste_name: "NY",
  },
  {
    zip_code: "10018",

    ste_name: "NY",
  },
  {
    zip_code: "10028",

    ste_name: "NY",
  },
  {
    zip_code: "10303",

    ste_name: "NY",
  },
  {
    zip_code: "10520",

    ste_name: "NY",
  },
  {
    zip_code: "10553",

    ste_name: "NY",
  },
  {
    zip_code: "10576",

    ste_name: "NY",
  },
  {
    zip_code: "10973",

    ste_name: "NY",
  },
  {
    zip_code: "11096",

    ste_name: "NY",
  },
  {
    zip_code: "11215",

    ste_name: "NY",
  },
  {
    zip_code: "11228",

    ste_name: "NY",
  },
  {
    zip_code: "11374",

    ste_name: "NY",
  },
  {
    zip_code: "11422",

    ste_name: "NY",
  },
  {
    zip_code: "11436",

    ste_name: "NY",
  },
  {
    zip_code: "11550",

    ste_name: "NY",
  },
  {
    zip_code: "11559",

    ste_name: "NY",
  },
  {
    zip_code: "11757",

    ste_name: "NY",
  },
  {
    zip_code: "11789",

    ste_name: "NY",
  },
  {
    zip_code: "12015",

    ste_name: "NY",
  },
  {
    zip_code: "12022",

    ste_name: "NY",
  },
  {
    zip_code: "12032",

    ste_name: "NY",
  },
  {
    zip_code: "12085",

    ste_name: "NY",
  },
  {
    zip_code: "12094",

    ste_name: "NY",
  },
  {
    zip_code: "12170",

    ste_name: "NY",
  },
  {
    zip_code: "12413",

    ste_name: "NY",
  },
  {
    zip_code: "12420",

    ste_name: "NY",
  },
  {
    zip_code: "12424",

    ste_name: "NY",
  },
  {
    zip_code: "12432",

    ste_name: "NY",
  },
  {
    zip_code: "12528",

    ste_name: "NY",
  },
  {
    zip_code: "12604",

    ste_name: "NY",
  },
  {
    zip_code: "12754",

    ste_name: "NY",
  },
  {
    zip_code: "12857",

    ste_name: "NY",
  },
  {
    zip_code: "12886",

    ste_name: "NY",
  },
  {
    zip_code: "12914",

    ste_name: "NY",
  },
  {
    zip_code: "12970",

    ste_name: "NY",
  },
  {
    zip_code: "13072",

    ste_name: "NY",
  },
  {
    zip_code: "13080",

    ste_name: "NY",
  },
  {
    zip_code: "13102",

    ste_name: "NY",
  },
  {
    zip_code: "13110",

    ste_name: "NY",
  },
  {
    zip_code: "13126",

    ste_name: "NY",
  },
  {
    zip_code: "13206",

    ste_name: "NY",
  },
  {
    zip_code: "13329",

    ste_name: "NY",
  },
  {
    zip_code: "13476",

    ste_name: "NY",
  },
  {
    zip_code: "13633",

    ste_name: "NY",
  },
  {
    zip_code: "13642",

    ste_name: "NY",
  },
  {
    zip_code: "13667",

    ste_name: "NY",
  },
  {
    zip_code: "13673",

    ste_name: "NY",
  },
  {
    zip_code: "13674",

    ste_name: "NY",
  },
  {
    zip_code: "13795",

    ste_name: "NY",
  },
  {
    zip_code: "14068",

    ste_name: "NY",
  },
  {
    zip_code: "14082",

    ste_name: "NY",
  },
  {
    zip_code: "14092",

    ste_name: "NY",
  },
  {
    zip_code: "14138",

    ste_name: "NY",
  },
  {
    zip_code: "14207",

    ste_name: "NY",
  },
  {
    zip_code: "14301",

    ste_name: "NY",
  },
  {
    zip_code: "14462",

    ste_name: "NY",
  },
  {
    zip_code: "14512",

    ste_name: "NY",
  },
  {
    zip_code: "14559",

    ste_name: "NY",
  },
  {
    zip_code: "14605",

    ste_name: "NY",
  },
  {
    zip_code: "14727",

    ste_name: "NY",
  },
  {
    zip_code: "14741",

    ste_name: "NY",
  },
  {
    zip_code: "14748",

    ste_name: "NY",
  },
  {
    zip_code: "14804",

    ste_name: "NY",
  },
  {
    zip_code: "14837",

    ste_name: "NY",
  },
  {
    zip_code: "15001",

    ste_name: "PA",
  },
  {
    zip_code: "15009",

    ste_name: "PA",
  },
  {
    zip_code: "15088",

    ste_name: "PA",
  },
  {
    zip_code: "15101",

    ste_name: "PA",
  },
  {
    zip_code: "15132",

    ste_name: "PA",
  },
  {
    zip_code: "15238",

    ste_name: "PA",
  },
  {
    zip_code: "15325",

    ste_name: "PA",
  },
  {
    zip_code: "15338",

    ste_name: "PA",
  },
  {
    zip_code: "15342",

    ste_name: "PA",
  },
  {
    zip_code: "15454",

    ste_name: "PA",
  },
  {
    zip_code: "15475",

    ste_name: "PA",
  },
  {
    zip_code: "15535",

    ste_name: "PA",
  },
  {
    zip_code: "15665",

    ste_name: "PA",
  },
  {
    zip_code: "15692",

    ste_name: "PA",
  },
  {
    zip_code: "15821",

    ste_name: "PA",
  },
  {
    zip_code: "15856",

    ste_name: "PA",
  },
  {
    zip_code: "15949",

    ste_name: "PA",
  },
  {
    zip_code: "16053",

    ste_name: "PA",
  },
  {
    zip_code: "16133",

    ste_name: "PA",
  },
  {
    zip_code: "16236",

    ste_name: "PA",
  },
  {
    zip_code: "16326",

    ste_name: "PA",
  },
  {
    zip_code: "16434",

    ste_name: "PA",
  },
  {
    zip_code: "16503",

    ste_name: "PA",
  },
  {
    zip_code: "16563",

    ste_name: "PA",
  },
  {
    zip_code: "16839",

    ste_name: "PA",
  },
  {
    zip_code: "16841",

    ste_name: "PA",
  },
  {
    zip_code: "16863",

    ste_name: "PA",
  },
  {
    zip_code: "16920",

    ste_name: "PA",
  },
  {
    zip_code: "17041",

    ste_name: "PA",
  },
  {
    zip_code: "17306",

    ste_name: "PA",
  },
  {
    zip_code: "17502",

    ste_name: "PA",
  },
  {
    zip_code: "17813",

    ste_name: "PA",
  },
  {
    zip_code: "17946",

    ste_name: "PA",
  },
  {
    zip_code: "18036",

    ste_name: "PA",
  },
  {
    zip_code: "18066",

    ste_name: "PA",
  },
  {
    zip_code: "18232",

    ste_name: "PA",
  },
  {
    zip_code: "18352",

    ste_name: "PA",
  },
  {
    zip_code: "18465",

    ste_name: "PA",
  },
  {
    zip_code: "18508",

    ste_name: "PA",
  },
  {
    zip_code: "18644",

    ste_name: "PA",
  },
  {
    zip_code: "18651",

    ste_name: "PA",
  },
  {
    zip_code: "18657",

    ste_name: "PA",
  },
  {
    zip_code: "18702",

    ste_name: "PA",
  },
  {
    zip_code: "18709",

    ste_name: "PA",
  },
  {
    zip_code: "19102",

    ste_name: "PA",
  },
  {
    zip_code: "19103",

    ste_name: "PA",
  },
  {
    zip_code: "19114",

    ste_name: "PA",
  },
  {
    zip_code: "19133",

    ste_name: "PA",
  },
  {
    zip_code: "19403",

    ste_name: "PA",
  },
  {
    zip_code: "19457",

    ste_name: "PA",
  },
  {
    zip_code: "19564",

    ste_name: "PA",
  },
  {
    zip_code: "19804",

    ste_name: "DE",
  },
  {
    zip_code: "19809",

    ste_name: "DE",
  },
  {
    zip_code: "20109",

    ste_name: "VA",
  },
  {
    zip_code: "20120",

    ste_name: "VA",
  },
  {
    zip_code: "20623",

    ste_name: "MD",
  },
  {
    zip_code: "20630",

    ste_name: "MD",
  },
  {
    zip_code: "20692",

    ste_name: "MD",
  },
  {
    zip_code: "20695",

    ste_name: "MD",
  },
  {
    zip_code: "20707",

    ste_name: "MD",
  },
  {
    zip_code: "20716",

    ste_name: "MD",
  },
  {
    zip_code: "20754",

    ste_name: "MD",
  },
  {
    zip_code: "20777",

    ste_name: "MD",
  },
  {
    zip_code: "20872",

    ste_name: "MD",
  },
  {
    zip_code: "20901",

    ste_name: "MD",
  },
  {
    zip_code: "21009",

    ste_name: "MD",
  },
  {
    zip_code: "21012",

    ste_name: "MD",
  },
  {
    zip_code: "21035",

    ste_name: "MD",
  },
  {
    zip_code: "21102",

    ste_name: "MD",
  },
  {
    zip_code: "21130",

    ste_name: "MD",
  },
  {
    zip_code: "21133",

    ste_name: "MD",
  },
  {
    zip_code: "21227",

    ste_name: "MD",
  },
  {
    zip_code: "21236",

    ste_name: "MD",
  },
  {
    zip_code: "21664",

    ste_name: "MD",
  },
  {
    zip_code: "21703",

    ste_name: "MD",
  },
  {
    zip_code: "21865",

    ste_name: "MD",
  },
  {
    zip_code: "22125",

    ste_name: "VA",
  },
  {
    zip_code: "22303",

    ste_name: "VA",
  },
  {
    zip_code: "22435",

    ste_name: "VA",
  },
  {
    zip_code: "22473",

    ste_name: "VA",
  },
  {
    zip_code: "22579",

    ste_name: "VA",
  },
  {
    zip_code: "22602",

    ste_name: "VA",
  },
  {
    zip_code: "22734",

    ste_name: "VA",
  },
  {
    zip_code: "22920",

    ste_name: "VA",
  },
  {
    zip_code: "23039",

    ste_name: "VA",
  },
  {
    zip_code: "23116",

    ste_name: "VA",
  },
  {
    zip_code: "23163",

    ste_name: "VA",
  },
  {
    zip_code: "23231",

    ste_name: "VA",
  },
  {
    zip_code: "23408",

    ste_name: "VA",
  },
  {
    zip_code: "23409",

    ste_name: "VA",
  },
  {
    zip_code: "23438",

    ste_name: "VA",
  },
  {
    zip_code: "23513",

    ste_name: "VA",
  },
  {
    zip_code: "24012",

    ste_name: "VA",
  },
  {
    zip_code: "24054",

    ste_name: "VA",
  },
  {
    zip_code: "24060",

    ste_name: "VA",
  },
  {
    zip_code: "24086",

    ste_name: "VA",
  },
  {
    zip_code: "24112",

    ste_name: "VA",
  },
  {
    zip_code: "24130",

    ste_name: "VA",
  },
  {
    zip_code: "24151",

    ste_name: "VA",
  },
  {
    zip_code: "24251",

    ste_name: "VA",
  },
  {
    zip_code: "24330",

    ste_name: "VA",
  },
  {
    zip_code: "24370",

    ste_name: "VA",
  },
  {
    zip_code: "24551",

    ste_name: "VA",
  },
  {
    zip_code: "24634",

    ste_name: "VA",
  },
  {
    zip_code: "24637",

    ste_name: "VA",
  },
  {
    zip_code: "24712",

    ste_name: "WV",
  },
  {
    zip_code: "24716",

    ste_name: "WV",
  },
  {
    zip_code: "24846",

    ste_name: "WV",
  },
  {
    zip_code: "24884",

    ste_name: "WV",
  },
  {
    zip_code: "24892",

    ste_name: "WV",
  },
  {
    zip_code: "25053",

    ste_name: "WV",
  },
  {
    zip_code: "25063",

    ste_name: "WV",
  },
  {
    zip_code: "25075",

    ste_name: "WV",
  },
  {
    zip_code: "25262",

    ste_name: "WV",
  },
  {
    zip_code: "25508",

    ste_name: "WV",
  },
  {
    zip_code: "25514",

    ste_name: "WV",
  },
  {
    zip_code: "25564",

    ste_name: "WV",
  },
  {
    zip_code: "25601",

    ste_name: "WV",
  },
  {
    zip_code: "25855",

    ste_name: "WV",
  },
  {
    zip_code: "25864",

    ste_name: "WV",
  },
  {
    zip_code: "25868",

    ste_name: "WV",
  },
  {
    zip_code: "25938",

    ste_name: "WV",
  },
  {
    zip_code: "25969",

    ste_name: "WV",
  },
  {
    zip_code: "26150",

    ste_name: "WV",
  },
  {
    zip_code: "26160",

    ste_name: "WV",
  },
  {
    zip_code: "26222",

    ste_name: "WV",
  },
  {
    zip_code: "26273",

    ste_name: "WV",
  },
  {
    zip_code: "26288",

    ste_name: "WV",
  },
  {
    zip_code: "26292",

    ste_name: "WV",
  },
  {
    zip_code: "26296",

    ste_name: "WV",
  },
  {
    zip_code: "26346",

    ste_name: "WV",
  },
  {
    zip_code: "26574",

    ste_name: "WV",
  },
  {
    zip_code: "26726",

    ste_name: "WV",
  },
  {
    zip_code: "26755",

    ste_name: "WV",
  },
  {
    zip_code: "26865",

    ste_name: "WV",
  },
  {
    zip_code: "27282",

    ste_name: "NC",
  },
  {
    zip_code: "27520",

    ste_name: "NC",
  },
  {
    zip_code: "27613",

    ste_name: "NC",
  },
  {
    zip_code: "27810",

    ste_name: "NC",
  },
  {
    zip_code: "27844",

    ste_name: "NC",
  },
  {
    zip_code: "27891",

    ste_name: "NC",
  },
  {
    zip_code: "27921",

    ste_name: "NC",
  },
  {
    zip_code: "28025",

    ste_name: "NC",
  },
  {
    zip_code: "28078",

    ste_name: "NC",
  },
  {
    zip_code: "28164",

    ste_name: "NC",
  },
  {
    zip_code: "28345",

    ste_name: "NC",
  },
  {
    zip_code: "28373",

    ste_name: "NC",
  },
  {
    zip_code: "28461",

    ste_name: "NC",
  },
  {
    zip_code: "28508",

    ste_name: "NC",
  },
  {
    zip_code: "28560",

    ste_name: "NC",
  },
  {
    zip_code: "28630",

    ste_name: "NC",
  },
  {
    zip_code: "28647",

    ste_name: "NC",
  },
  {
    zip_code: "28655",

    ste_name: "NC",
  },
  {
    zip_code: "28694",

    ste_name: "NC",
  },
  {
    zip_code: "28715",

    ste_name: "NC",
  },
  {
    zip_code: "29055",

    ste_name: "SC",
  },
  {
    zip_code: "29056",

    ste_name: "SC",
  },
  {
    zip_code: "29154",

    ste_name: "SC",
  },
  {
    zip_code: "29160",

    ste_name: "SC",
  },
  {
    zip_code: "29175",

    ste_name: "SC",
  },
  {
    zip_code: "29320",

    ste_name: "SC",
  },
  {
    zip_code: "29360",

    ste_name: "SC",
  },
  {
    zip_code: "29505",

    ste_name: "SC",
  },
  {
    zip_code: "29530",

    ste_name: "SC",
  },
  {
    zip_code: "29625",

    ste_name: "SC",
  },
  {
    zip_code: "29659",

    ste_name: "SC",
  },
  {
    zip_code: "29696",

    ste_name: "SC",
  },
  {
    zip_code: "29936",

    ste_name: "SC",
  },
  {
    zip_code: "30039",

    ste_name: "GA",
  },
  {
    zip_code: "30108",

    ste_name: "GA",
  },
  {
    zip_code: "30137",

    ste_name: "GA",
  },
  {
    zip_code: "30148",

    ste_name: "GA",
  },
  {
    zip_code: "30228",

    ste_name: "GA",
  },
  {
    zip_code: "30288",

    ste_name: "GA",
  },
  {
    zip_code: "30309",

    ste_name: "GA",
  },
  {
    zip_code: "30344",

    ste_name: "GA",
  },
  {
    zip_code: "30475",

    ste_name: "GA",
  },
  {
    zip_code: "30542",

    ste_name: "GA",
  },
  {
    zip_code: "30810",

    ste_name: "GA",
  },
  {
    zip_code: "59006",

    ste_name: "MT",
  },
  {
    zip_code: "59012",

    ste_name: "MT",
  },
  {
    zip_code: "59261",

    ste_name: "MT",
  },
  {
    zip_code: "59434",

    ste_name: "MT",
  },
  {
    zip_code: "59466",

    ste_name: "MT",
  },
  {
    zip_code: "59521",

    ste_name: "MT",
  },
  {
    zip_code: "59756",

    ste_name: "MT",
  },
  {
    zip_code: "59801",

    ste_name: "MT",
  },
  {
    zip_code: "59823",

    ste_name: "MT",
  },
  {
    zip_code: "59827",

    ste_name: "MT",
  },
  {
    zip_code: "59871",

    ste_name: "MT",
  },
  {
    zip_code: "59911",

    ste_name: "MT",
  },
  {
    zip_code: "59931",

    ste_name: "MT",
  },
  {
    zip_code: "60088",

    ste_name: "IL",
  },
  {
    zip_code: "60119",

    ste_name: "IL",
  },
  {
    zip_code: "60163",

    ste_name: "IL",
  },
  {
    zip_code: "60174",

    ste_name: "IL",
  },
  {
    zip_code: "60203",

    ste_name: "IL",
  },
  {
    zip_code: "60301",

    ste_name: "IL",
  },
  {
    zip_code: "60305",

    ste_name: "IL",
  },
  {
    zip_code: "60460",

    ste_name: "IL",
  },
  {
    zip_code: "60461",

    ste_name: "IL",
  },
  {
    zip_code: "60501",

    ste_name: "IL",
  },
  {
    zip_code: "60525",

    ste_name: "IL",
  },
  {
    zip_code: "60565",

    ste_name: "IL",
  },
  {
    zip_code: "60585",

    ste_name: "IL",
  },
  {
    zip_code: "60652",

    ste_name: "IL",
  },
  {
    zip_code: "60938",

    ste_name: "IL",
  },
  {
    zip_code: "61064",

    ste_name: "IL",
  },
  {
    zip_code: "61285",

    ste_name: "IL",
  },
  {
    zip_code: "61330",

    ste_name: "IL",
  },
  {
    zip_code: "61350",

    ste_name: "IL",
  },
  {
    zip_code: "61359",

    ste_name: "IL",
  },
  {
    zip_code: "61468",

    ste_name: "IL",
  },
  {
    zip_code: "61473",

    ste_name: "IL",
  },
  {
    zip_code: "61517",

    ste_name: "IL",
  },
  {
    zip_code: "61859",

    ste_name: "IL",
  },
  {
    zip_code: "61876",

    ste_name: "IL",
  },
  {
    zip_code: "61937",

    ste_name: "IL",
  },
  {
    zip_code: "61938",

    ste_name: "IL",
  },
  {
    zip_code: "62016",

    ste_name: "IL",
  },
  {
    zip_code: "62040",

    ste_name: "IL",
  },
  {
    zip_code: "62056",

    ste_name: "IL",
  },
  {
    zip_code: "62070",

    ste_name: "IL",
  },
  {
    zip_code: "62208",

    ste_name: "IL",
  },
  {
    zip_code: "62275",

    ste_name: "IL",
  },
  {
    zip_code: "62297",

    ste_name: "IL",
  },
  {
    zip_code: "62379",

    ste_name: "IL",
  },
  {
    zip_code: "62432",

    ste_name: "IL",
  },
  {
    zip_code: "62467",

    ste_name: "IL",
  },
  {
    zip_code: "62475",

    ste_name: "IL",
  },
  {
    zip_code: "62479",

    ste_name: "IL",
  },
  {
    zip_code: "62553",

    ste_name: "IL",
  },
  {
    zip_code: "62642",

    ste_name: "IL",
  },
  {
    zip_code: "62694",

    ste_name: "IL",
  },
  {
    zip_code: "62837",

    ste_name: "IL",
  },
  {
    zip_code: "62908",

    ste_name: "IL",
  },
  {
    zip_code: "62919",

    ste_name: "IL",
  },
  {
    zip_code: "62923",

    ste_name: "IL",
  },
  {
    zip_code: "62951",

    ste_name: "IL",
  },
  {
    zip_code: "63038",

    ste_name: "MO",
  },
  {
    zip_code: "63135",

    ste_name: "MO",
  },
  {
    zip_code: "63383",

    ste_name: "MO",
  },
  {
    zip_code: "63401",

    ste_name: "MO",
  },
  {
    zip_code: "63437",

    ste_name: "MO",
  },
  {
    zip_code: "63567",

    ste_name: "MO",
  },
  {
    zip_code: "63674",

    ste_name: "MO",
  },
  {
    zip_code: "63736",

    ste_name: "MO",
  },
  {
    zip_code: "63740",

    ste_name: "MO",
  },
  {
    zip_code: "63758",

    ste_name: "MO",
  },
  {
    zip_code: "63770",

    ste_name: "MO",
  },
  {
    zip_code: "63821",

    ste_name: "MO",
  },
  {
    zip_code: "63822",

    ste_name: "MO",
  },
  {
    zip_code: "63855",

    ste_name: "MO",
  },
  {
    zip_code: "63866",

    ste_name: "MO",
  },
  {
    zip_code: "64097",

    ste_name: "MO",
  },
  {
    zip_code: "64124",

    ste_name: "MO",
  },
  {
    zip_code: "64449",

    ste_name: "MO",
  },
  {
    zip_code: "64466",

    ste_name: "MO",
  },
  {
    zip_code: "64487",

    ste_name: "MO",
  },
  {
    zip_code: "64622",

    ste_name: "MO",
  },
  {
    zip_code: "64689",

    ste_name: "MO",
  },
  {
    zip_code: "64743",

    ste_name: "MO",
  },
  {
    zip_code: "64865",

    ste_name: "MO",
  },
  {
    zip_code: "64867",

    ste_name: "MO",
  },
  {
    zip_code: "65011",

    ste_name: "MO",
  },
  {
    zip_code: "65085",

    ste_name: "MO",
  },
  {
    zip_code: "65243",

    ste_name: "MO",
  },
  {
    zip_code: "65274",

    ste_name: "MO",
  },
  {
    zip_code: "65323",

    ste_name: "MO",
  },
  {
    zip_code: "65461",

    ste_name: "MO",
  },
  {
    zip_code: "65463",

    ste_name: "MO",
  },
  {
    zip_code: "65534",

    ste_name: "MO",
  },
  {
    zip_code: "65606",

    ste_name: "MO",
  },
  {
    zip_code: "65644",

    ste_name: "MO",
  },
  {
    zip_code: "65681",

    ste_name: "MO",
  },
  {
    zip_code: "65774",

    ste_name: "MO",
  },
  {
    zip_code: "65790",

    ste_name: "MO",
  },
  {
    zip_code: "66015",

    ste_name: "KS",
  },
  {
    zip_code: "66024",

    ste_name: "KS",
  },
  {
    zip_code: "66112",

    ste_name: "KS",
  },
  {
    zip_code: "66210",

    ste_name: "KS",
  },
  {
    zip_code: "66429",

    ste_name: "KS",
  },
  {
    zip_code: "66502",

    ste_name: "KS",
  },
  {
    zip_code: "66606",

    ste_name: "KS",
  },
  {
    zip_code: "66710",

    ste_name: "KS",
  },
  {
    zip_code: "66746",

    ste_name: "KS",
  },
  {
    zip_code: "66936",

    ste_name: "KS",
  },
  {
    zip_code: "67063",

    ste_name: "KS",
  },
  {
    zip_code: "67150",

    ste_name: "KS",
  },
  {
    zip_code: "67203",

    ste_name: "KS",
  },
  {
    zip_code: "67206",

    ste_name: "KS",
  },
  {
    zip_code: "67510",

    ste_name: "KS",
  },
  {
    zip_code: "67518",

    ste_name: "KS",
  },
  {
    zip_code: "67524",

    ste_name: "KS",
  },
  {
    zip_code: "67546",

    ste_name: "KS",
  },
  {
    zip_code: "67568",

    ste_name: "KS",
  },
  {
    zip_code: "67663",

    ste_name: "KS",
  },
  {
    zip_code: "67861",

    ste_name: "KS",
  },
  {
    zip_code: "67862",

    ste_name: "KS",
  },
  {
    zip_code: "67867",

    ste_name: "KS",
  },
  {
    zip_code: "67870",

    ste_name: "KS",
  },
  {
    zip_code: "68041",

    ste_name: "NE",
  },
  {
    zip_code: "68058",

    ste_name: "NE",
  },
  {
    zip_code: "68105",

    ste_name: "NE",
  },
  {
    zip_code: "68323",

    ste_name: "NE",
  },
  {
    zip_code: "68338",

    ste_name: "NE",
  },
  {
    zip_code: "68358",

    ste_name: "NE",
  },
  {
    zip_code: "68378",

    ste_name: "NE",
  },
  {
    zip_code: "68450",

    ste_name: "NE",
  },
  {
    zip_code: "68508",

    ste_name: "NE",
  },
  {
    zip_code: "68512",

    ste_name: "NE",
  },
  {
    zip_code: "68628",

    ste_name: "NE",
  },
  {
    zip_code: "68636",

    ste_name: "NE",
  },
  {
    zip_code: "68665",

    ste_name: "NE",
  },
  {
    zip_code: "68736",

    ste_name: "NE",
  },
  {
    zip_code: "68743",

    ste_name: "NE",
  },
  {
    zip_code: "68764",

    ste_name: "NE",
  },
  {
    zip_code: "68777",

    ste_name: "NE",
  },
  {
    zip_code: "68787",

    ste_name: "NE",
  },
  {
    zip_code: "68865",

    ste_name: "NE",
  },
  {
    zip_code: "68875",

    ste_name: "NE",
  },
  {
    zip_code: "68942",

    ste_name: "NE",
  },
  {
    zip_code: "68952",

    ste_name: "NE",
  },
  {
    zip_code: "68969",

    ste_name: "NE",
  },
  {
    zip_code: "69021",

    ste_name: "NE",
  },
  {
    zip_code: "69170",

    ste_name: "NE",
  },
  {
    zip_code: "69214",

    ste_name: "NE",
  },
  {
    zip_code: "69219",

    ste_name: "NE",
  },
  {
    zip_code: "70056",

    ste_name: "LA",
  },
  {
    zip_code: "70062",

    ste_name: "LA",
  },
  {
    zip_code: "70084",

    ste_name: "LA",
  },
  {
    zip_code: "70092",

    ste_name: "LA",
  },
  {
    zip_code: "70123",

    ste_name: "LA",
  },
  {
    zip_code: "70353",

    ste_name: "LA",
  },
  {
    zip_code: "70360",

    ste_name: "LA",
  },
  {
    zip_code: "70433",

    ste_name: "LA",
  },
  {
    zip_code: "70450",

    ste_name: "LA",
  },
  {
    zip_code: "70710",

    ste_name: "LA",
  },
  {
    zip_code: "70743",

    ste_name: "LA",
  },
  {
    zip_code: "70764",

    ste_name: "LA",
  },
  {
    zip_code: "70772",

    ste_name: "LA",
  },
  {
    zip_code: "70811",

    ste_name: "LA",
  },
  {
    zip_code: "70836",

    ste_name: "LA",
  },
  {
    zip_code: "71107",

    ste_name: "LA",
  },
  {
    zip_code: "71226",

    ste_name: "LA",
  },
  {
    zip_code: "71256",

    ste_name: "LA",
  },
  {
    zip_code: "71334",

    ste_name: "LA",
  },
  {
    zip_code: "71336",

    ste_name: "LA",
  },
  {
    zip_code: "71441",

    ste_name: "LA",
  },
  {
    zip_code: "71447",

    ste_name: "LA",
  },
  {
    zip_code: "71603",

    ste_name: "AR",
  },
  {
    zip_code: "71674",

    ste_name: "AR",
  },
  {
    zip_code: "71725",

    ste_name: "AR",
  },
  {
    zip_code: "71859",

    ste_name: "AR",
  },
  {
    zip_code: "71860",

    ste_name: "AR",
  },
  {
    zip_code: "71923",

    ste_name: "AR",
  },
  {
    zip_code: "71952",

    ste_name: "AR",
  },
  {
    zip_code: "72072",

    ste_name: "AR",
  },
  {
    zip_code: "72104",

    ste_name: "AR",
  },
  {
    zip_code: "72107",

    ste_name: "AR",
  },
  {
    zip_code: "72346",

    ste_name: "AR",
  },
  {
    zip_code: "72384",

    ste_name: "AR",
  },
  {
    zip_code: "72455",

    ste_name: "AR",
  },
  {
    zip_code: "72462",

    ste_name: "AR",
  },
  {
    zip_code: "72544",

    ste_name: "AR",
  },
  {
    zip_code: "72601",

    ste_name: "AR",
  },
  {
    zip_code: "72623",

    ste_name: "AR",
  },
  {
    zip_code: "72633",

    ste_name: "AR",
  },
  {
    zip_code: "72636",

    ste_name: "AR",
  },
  {
    zip_code: "72661",

    ste_name: "AR",
  },
  {
    zip_code: "72769",

    ste_name: "AR",
  },
  {
    zip_code: "73050",

    ste_name: "OK",
  },
  {
    zip_code: "73062",

    ste_name: "OK",
  },
  {
    zip_code: "73079",

    ste_name: "OK",
  },
  {
    zip_code: "73095",

    ste_name: "OK",
  },
  {
    zip_code: "73119",

    ste_name: "OK",
  },
  {
    zip_code: "73134",

    ste_name: "OK",
  },
  {
    zip_code: "73528",

    ste_name: "OK",
  },
  {
    zip_code: "73724",

    ste_name: "OK",
  },
  {
    zip_code: "73741",

    ste_name: "OK",
  },
  {
    zip_code: "73759",

    ste_name: "OK",
  },
  {
    zip_code: "73772",

    ste_name: "OK",
  },
  {
    zip_code: "73901",

    ste_name: "OK",
  },
  {
    zip_code: "73947",

    ste_name: "OK",
  },
  {
    zip_code: "74103",

    ste_name: "OK",
  },
  {
    zip_code: "74106",

    ste_name: "OK",
  },
  {
    zip_code: "74112",

    ste_name: "OK",
  },
  {
    zip_code: "74350",

    ste_name: "OK",
  },
  {
    zip_code: "74363",

    ste_name: "OK",
  },
  {
    zip_code: "74426",

    ste_name: "OK",
  },
  {
    zip_code: "74429",

    ste_name: "OK",
  },
  {
    zip_code: "74437",

    ste_name: "OK",
  },
  {
    zip_code: "74463",

    ste_name: "OK",
  },
  {
    zip_code: "74567",

    ste_name: "OK",
  },
  {
    zip_code: "74820",

    ste_name: "OK",
  },
  {
    zip_code: "74937",

    ste_name: "OK",
  },
  {
    zip_code: "74940",

    ste_name: "OK",
  },
  {
    zip_code: "75414",

    ste_name: "TX",
  },
  {
    zip_code: "75422",

    ste_name: "TX",
  },
  {
    zip_code: "75438",

    ste_name: "TX",
  },
  {
    zip_code: "75448",

    ste_name: "TX",
  },
  {
    zip_code: "75470",

    ste_name: "TX",
  },
  {
    zip_code: "75573",

    ste_name: "TX",
  },
  {
    zip_code: "75643",

    ste_name: "TX",
  },
  {
    zip_code: "75652",

    ste_name: "TX",
  },
  {
    zip_code: "75662",

    ste_name: "TX",
  },
  {
    zip_code: "75849",

    ste_name: "TX",
  },
  {
    zip_code: "75851",

    ste_name: "TX",
  },
  {
    zip_code: "75939",

    ste_name: "TX",
  },
  {
    zip_code: "76031",

    ste_name: "TX",
  },
  {
    zip_code: "76365",

    ste_name: "TX",
  },
  {
    zip_code: "76531",

    ste_name: "TX",
  },
  {
    zip_code: "76559",

    ste_name: "TX",
  },
  {
    zip_code: "76567",

    ste_name: "TX",
  },
  {
    zip_code: "76578",

    ste_name: "TX",
  },
  {
    zip_code: "76877",

    ste_name: "TX",
  },
  {
    zip_code: "76943",

    ste_name: "TX",
  },
  {
    zip_code: "77003",

    ste_name: "TX",
  },
  {
    zip_code: "77007",

    ste_name: "TX",
  },
  {
    zip_code: "77017",

    ste_name: "TX",
  },
  {
    zip_code: "77045",

    ste_name: "TX",
  },
  {
    zip_code: "77067",

    ste_name: "TX",
  },
  {
    zip_code: "77077",

    ste_name: "TX",
  },
  {
    zip_code: "77369",

    ste_name: "TX",
  },
  {
    zip_code: "77441",

    ste_name: "TX",
  },
  {
    zip_code: "77448",

    ste_name: "TX",
  },
  {
    zip_code: "77486",

    ste_name: "TX",
  },
  {
    zip_code: "77507",

    ste_name: "TX",
  },
  {
    zip_code: "77978",

    ste_name: "TX",
  },
  {
    zip_code: "78050",

    ste_name: "TX",
  },
  {
    zip_code: "78116",

    ste_name: "TX",
  },
  {
    zip_code: "78140",

    ste_name: "TX",
  },
  {
    zip_code: "78233",

    ste_name: "TX",
  },
  {
    zip_code: "78266",

    ste_name: "TX",
  },
  {
    zip_code: "78342",

    ste_name: "TX",
  },
  {
    zip_code: "78391",

    ste_name: "TX",
  },
  {
    zip_code: "78418",

    ste_name: "TX",
  },
  {
    zip_code: "78526",

    ste_name: "TX",
  },
  {
    zip_code: "78607",

    ste_name: "TX",
  },
  {
    zip_code: "78642",

    ste_name: "TX",
  },
  {
    zip_code: "78728",

    ste_name: "TX",
  },
  {
    zip_code: "78948",

    ste_name: "TX",
  },
  {
    zip_code: "79001",

    ste_name: "TX",
  },
  {
    zip_code: "79084",

    ste_name: "TX",
  },
  {
    zip_code: "79093",

    ste_name: "TX",
  },
  {
    zip_code: "79098",

    ste_name: "TX",
  },
  {
    zip_code: "79105",

    ste_name: "TX",
  },
  {
    zip_code: "79236",

    ste_name: "TX",
  },
  {
    zip_code: "79256",

    ste_name: "TX",
  },
  {
    zip_code: "79323",

    ste_name: "TX",
  },
  {
    zip_code: "79326",

    ste_name: "TX",
  },
  {
    zip_code: "79343",

    ste_name: "TX",
  },
  {
    zip_code: "79378",

    ste_name: "TX",
  },
  {
    zip_code: "79537",

    ste_name: "TX",
  },
  {
    zip_code: "79561",

    ste_name: "TX",
  },
  {
    zip_code: "79607",

    ste_name: "TX",
  },
  {
    zip_code: "79714",

    ste_name: "TX",
  },
  {
    zip_code: "79720",

    ste_name: "TX",
  },
  {
    zip_code: "79761",

    ste_name: "TX",
  },
  {
    zip_code: "79837",

    ste_name: "TX",
  },
  {
    zip_code: "80024",

    ste_name: "CO",
  },
  {
    zip_code: "80026",

    ste_name: "CO",
  },
  {
    zip_code: "80031",

    ste_name: "CO",
  },
  {
    zip_code: "80045",

    ste_name: "CO",
  },
  {
    zip_code: "80122",

    ste_name: "CO",
  },
  {
    zip_code: "80211",

    ste_name: "CO",
  },
  {
    zip_code: "80231",

    ste_name: "CO",
  },
  {
    zip_code: "80419",

    ste_name: "CO",
  },
  {
    zip_code: "80421",

    ste_name: "CO",
  },
  {
    zip_code: "80536",

    ste_name: "CO",
  },
  {
    zip_code: "80615",

    ste_name: "CO",
  },
  {
    zip_code: "80751",

    ste_name: "CO",
  },
  {
    zip_code: "80758",

    ste_name: "CO",
  },
  {
    zip_code: "81025",

    ste_name: "CO",
  },
  {
    zip_code: "81033",

    ste_name: "CO",
  },
  {
    zip_code: "81064",

    ste_name: "CO",
  },
  {
    zip_code: "81144",

    ste_name: "CO",
  },
  {
    zip_code: "81328",

    ste_name: "CO",
  },
  {
    zip_code: "82052",

    ste_name: "WY",
  },
  {
    zip_code: "82081",

    ste_name: "WY",
  },
  {
    zip_code: "82426",

    ste_name: "WY",
  },
  {
    zip_code: "82516",

    ste_name: "WY",
  },
  {
    zip_code: "82637",

    ste_name: "WY",
  },
  {
    zip_code: "83122",

    ste_name: "WY",
  },
  {
    zip_code: "83127",

    ste_name: "WY",
  },
  {
    zip_code: "83251",

    ste_name: "ID",
  },
  {
    zip_code: "83287",

    ste_name: "ID",
  },
  {
    zip_code: "83316",

    ste_name: "ID",
  },
  {
    zip_code: "83338",

    ste_name: "ID",
  },
  {
    zip_code: "83347",

    ste_name: "ID",
  },
  {
    zip_code: "83433",

    ste_name: "ID",
  },
  {
    zip_code: "83466",

    ste_name: "ID",
  },
  {
    zip_code: "83535",

    ste_name: "ID",
  },
  {
    zip_code: "83612",

    ste_name: "ID",
  },
  {
    zip_code: "83626",

    ste_name: "ID",
  },
  {
    zip_code: "83716",

    ste_name: "ID",
  },
  {
    zip_code: "83813",

    ste_name: "ID",
  },
  {
    zip_code: "84025",

    ste_name: "UT",
  },
  {
    zip_code: "84034",

    ste_name: "UT",
  },
  {
    zip_code: "84076",

    ste_name: "UT",
  },
  {
    zip_code: "84085",

    ste_name: "UT",
  },
  {
    zip_code: "84093",

    ste_name: "UT",
  },
  {
    zip_code: "84316",

    ste_name: "UT",
  },
  {
    zip_code: "84516",

    ste_name: "UT",
  },
  {
    zip_code: "84621",

    ste_name: "UT",
  },
  {
    zip_code: "84632",

    ste_name: "UT",
  },
  {
    zip_code: "84655",

    ste_name: "UT",
  },
  {
    zip_code: "84662",

    ste_name: "UT",
  },
  {
    zip_code: "84663",

    ste_name: "UT",
  },
  {
    zip_code: "84767",

    ste_name: "UT",
  },
  {
    zip_code: "84776",

    ste_name: "UT",
  },
  {
    zip_code: "85008",

    ste_name: "AZ",
  },
  {
    zip_code: "85051",

    ste_name: "AZ",
  },
  {
    zip_code: "85203",

    ste_name: "AZ",
  },
  {
    zip_code: "85233",

    ste_name: "AZ",
  },
  {
    zip_code: "85295",

    ste_name: "AZ",
  },
  {
    zip_code: "85338",

    ste_name: "AZ",
  },
  {
    zip_code: "85341",

    ste_name: "AZ",
  },
  {
    zip_code: "85601",

    ste_name: "AZ",
  },
  {
    zip_code: "85638",

    ste_name: "AZ",
  },
  {
    zip_code: "85712",

    ste_name: "AZ",
  },
  {
    zip_code: "86021",

    ste_name: "AZ",
  },
  {
    zip_code: "86029",

    ste_name: "AZ",
  },
  {
    zip_code: "86305",

    ste_name: "AZ",
  },
  {
    zip_code: "86333",

    ste_name: "AZ",
  },
  {
    zip_code: "86445",

    ste_name: "AZ",
  },
  {
    zip_code: "86510",

    ste_name: "AZ",
  },
  {
    zip_code: "86547",

    ste_name: "AZ",
  },
  {
    zip_code: "87026",

    ste_name: "NM",
  },
  {
    zip_code: "87034",

    ste_name: "NM",
  },
  {
    zip_code: "87035",

    ste_name: "NM",
  },
  {
    zip_code: "87062",

    ste_name: "NM",
  },
  {
    zip_code: "87072",

    ste_name: "NM",
  },
  {
    zip_code: "87311",

    ste_name: "NM",
  },
  {
    zip_code: "87516",

    ste_name: "NM",
  },
  {
    zip_code: "87537",

    ste_name: "NM",
  },
  {
    zip_code: "87831",

    ste_name: "NM",
  },
  {
    zip_code: "88118",

    ste_name: "NM",
  },
  {
    zip_code: "88256",

    ste_name: "NM",
  },
  {
    zip_code: "88265",

    ste_name: "NM",
  },
  {
    zip_code: "88418",

    ste_name: "NM",
  },
  {
    zip_code: "88434",

    ste_name: "NM",
  },
  {
    zip_code: "89025",

    ste_name: "NV",
  },
  {
    zip_code: "89048",

    ste_name: "NV",
  },
  {
    zip_code: "89301",

    ste_name: "NV",
  },
  {
    zip_code: "89310",

    ste_name: "NV",
  },
  {
    zip_code: "89410",

    ste_name: "NV",
  },
  {
    zip_code: "89447",

    ste_name: "NV",
  },
  {
    zip_code: "89509",

    ste_name: "NV",
  },
  {
    zip_code: "89705",

    ste_name: "NV",
  },
  {
    zip_code: "39120",

    ste_name: "MS",
  },
  {
    zip_code: "39177",

    ste_name: "MS",
  },
  {
    zip_code: "39440",

    ste_name: "MS",
  },
  {
    zip_code: "39565",

    ste_name: "MS",
  },
  {
    zip_code: "39601",

    ste_name: "MS",
  },
  {
    zip_code: "39886",

    ste_name: "GA",
  },
  {
    zip_code: "39897",

    ste_name: "GA",
  },
  {
    zip_code: "40007",

    ste_name: "KY",
  },
  {
    zip_code: "40048",

    ste_name: "KY",
  },
  {
    zip_code: "40071",

    ste_name: "KY",
  },
  {
    zip_code: "40176",

    ste_name: "KY",
  },
  {
    zip_code: "40228",

    ste_name: "KY",
  },
  {
    zip_code: "40316",

    ste_name: "KY",
  },
  {
    zip_code: "40342",

    ste_name: "KY",
  },
  {
    zip_code: "40456",

    ste_name: "KY",
  },
  {
    zip_code: "40507",

    ste_name: "KY",
  },
  {
    zip_code: "40734",

    ste_name: "KY",
  },
  {
    zip_code: "40759",

    ste_name: "KY",
  },
  {
    zip_code: "40806",

    ste_name: "KY",
  },
  {
    zip_code: "40818",

    ste_name: "KY",
  },
  {
    zip_code: "40820",

    ste_name: "KY",
  },
  {
    zip_code: "41016",

    ste_name: "KY",
  },
  {
    zip_code: "41085",

    ste_name: "KY",
  },
  {
    zip_code: "41143",

    ste_name: "KY",
  },
  {
    zip_code: "41216",

    ste_name: "KY",
  },
  {
    zip_code: "41390",

    ste_name: "KY",
  },
  {
    zip_code: "41537",

    ste_name: "KY",
  },
  {
    zip_code: "41740",

    ste_name: "KY",
  },
  {
    zip_code: "42045",

    ste_name: "KY",
  },
  {
    zip_code: "42051",

    ste_name: "KY",
  },
  {
    zip_code: "42085",

    ste_name: "KY",
  },
  {
    zip_code: "42371",

    ste_name: "KY",
  },
  {
    zip_code: "42452",

    ste_name: "KY",
  },
  {
    zip_code: "42464",

    ste_name: "KY",
  },
  {
    zip_code: "42566",

    ste_name: "KY",
  },
  {
    zip_code: "42631",

    ste_name: "KY",
  },
  {
    zip_code: "42726",

    ste_name: "KY",
  },
  {
    zip_code: "43123",

    ste_name: "OH",
  },
  {
    zip_code: "43145",

    ste_name: "OH",
  },
  {
    zip_code: "43318",

    ste_name: "OH",
  },
  {
    zip_code: "43450",

    ste_name: "OH",
  },
  {
    zip_code: "43567",

    ste_name: "OH",
  },
  {
    zip_code: "43716",

    ste_name: "OH",
  },
  {
    zip_code: "43750",

    ste_name: "OH",
  },
  {
    zip_code: "43802",

    ste_name: "OH",
  },
  {
    zip_code: "43925",

    ste_name: "OH",
  },
  {
    zip_code: "43948",

    ste_name: "OH",
  },
  {
    zip_code: "43986",

    ste_name: "OH",
  },
  {
    zip_code: "44012",

    ste_name: "OH",
  },
  {
    zip_code: "44094",

    ste_name: "OH",
  },
  {
    zip_code: "44106",

    ste_name: "OH",
  },
  {
    zip_code: "44321",

    ste_name: "OH",
  },
  {
    zip_code: "44431",

    ste_name: "OH",
  },
  {
    zip_code: "44490",

    ste_name: "OH",
  },
  {
    zip_code: "44510",

    ste_name: "OH",
  },
  {
    zip_code: "44633",

    ste_name: "OH",
  },
  {
    zip_code: "44662",

    ste_name: "OH",
  },
  {
    zip_code: "44707",

    ste_name: "OH",
  },
  {
    zip_code: "44720",

    ste_name: "OH",
  },
  {
    zip_code: "44855",

    ste_name: "OH",
  },
  {
    zip_code: "44856",

    ste_name: "OH",
  },
  {
    zip_code: "44867",

    ste_name: "OH",
  },
  {
    zip_code: "45056",

    ste_name: "OH",
  },
  {
    zip_code: "45159",

    ste_name: "OH",
  },
  {
    zip_code: "45166",

    ste_name: "OH",
  },
  {
    zip_code: "45225",

    ste_name: "OH",
  },
  {
    zip_code: "45331",

    ste_name: "OH",
  },
  {
    zip_code: "45354",

    ste_name: "OH",
  },
  {
    zip_code: "45416",

    ste_name: "OH",
  },
  {
    zip_code: "45612",

    ste_name: "OH",
  },
  {
    zip_code: "45622",

    ste_name: "OH",
  },
  {
    zip_code: "45636",

    ste_name: "OH",
  },
  {
    zip_code: "45654",

    ste_name: "OH",
  },
  {
    zip_code: "45659",

    ste_name: "OH",
  },
  {
    zip_code: "45661",

    ste_name: "OH",
  },
  {
    zip_code: "45663",

    ste_name: "OH",
  },
  {
    zip_code: "45681",

    ste_name: "OH",
  },
  {
    zip_code: "45723",

    ste_name: "OH",
  },
  {
    zip_code: "45770",

    ste_name: "OH",
  },
  {
    zip_code: "45856",

    ste_name: "OH",
  },
  {
    zip_code: "45875",

    ste_name: "OH",
  },
  {
    zip_code: "45880",

    ste_name: "OH",
  },
  {
    zip_code: "46045",

    ste_name: "IN",
  },
  {
    zip_code: "46070",

    ste_name: "IN",
  },
  {
    zip_code: "46121",

    ste_name: "IN",
  },
  {
    zip_code: "46162",

    ste_name: "IN",
  },
  {
    zip_code: "46222",

    ste_name: "IN",
  },
  {
    zip_code: "46304",

    ste_name: "IN",
  },
  {
    zip_code: "46582",

    ste_name: "IN",
  },
  {
    zip_code: "46731",

    ste_name: "IN",
  },
  {
    zip_code: "46781",

    ste_name: "IN",
  },
  {
    zip_code: "46785",

    ste_name: "IN",
  },
  {
    zip_code: "46787",

    ste_name: "IN",
  },
  {
    zip_code: "46798",

    ste_name: "IN",
  },
  {
    zip_code: "46902",

    ste_name: "IN",
  },
  {
    zip_code: "46970",

    ste_name: "IN",
  },
  {
    zip_code: "47016",

    ste_name: "IN",
  },
  {
    zip_code: "47031",

    ste_name: "IN",
  },
  {
    zip_code: "47138",

    ste_name: "IN",
  },
  {
    zip_code: "47140",

    ste_name: "IN",
  },
  {
    zip_code: "47143",

    ste_name: "IN",
  },
  {
    zip_code: "47145",

    ste_name: "IN",
  },
  {
    zip_code: "47235",

    ste_name: "IN",
  },
  {
    zip_code: "47303",

    ste_name: "IN",
  },
  {
    zip_code: "47342",

    ste_name: "IN",
  },
  {
    zip_code: "47431",

    ste_name: "IN",
  },
  {
    zip_code: "47432",

    ste_name: "IN",
  },
  {
    zip_code: "47515",

    ste_name: "IN",
  },
  {
    zip_code: "47665",

    ste_name: "IN",
  },
  {
    zip_code: "47842",

    ste_name: "IN",
  },
  {
    zip_code: "47884",

    ste_name: "IN",
  },
  {
    zip_code: "47907",

    ste_name: "IN",
  },
  {
    zip_code: "47975",

    ste_name: "IN",
  },
  {
    zip_code: "48022",

    ste_name: "MI",
  },
  {
    zip_code: "48118",

    ste_name: "MI",
  },
  {
    zip_code: "48198",

    ste_name: "MI",
  },
  {
    zip_code: "48238",

    ste_name: "MI",
  },
  {
    zip_code: "48342",

    ste_name: "MI",
  },
  {
    zip_code: "48363",

    ste_name: "MI",
  },
  {
    zip_code: "48428",

    ste_name: "MI",
  },
  {
    zip_code: "48436",

    ste_name: "MI",
  },
  {
    zip_code: "48444",

    ste_name: "MI",
  },
  {
    zip_code: "48532",

    ste_name: "MI",
  },
  {
    zip_code: "48634",

    ste_name: "MI",
  },
  {
    zip_code: "48658",

    ste_name: "MI",
  },
  {
    zip_code: "48808",

    ste_name: "MI",
  },
  {
    zip_code: "48889",

    ste_name: "MI",
  },
  {
    zip_code: "49058",

    ste_name: "MI",
  },
  {
    zip_code: "49091",

    ste_name: "MI",
  },
  {
    zip_code: "49101",

    ste_name: "MI",
  },
  {
    zip_code: "49232",

    ste_name: "MI",
  },
  {
    zip_code: "49240",

    ste_name: "MI",
  },
  {
    zip_code: "49261",

    ste_name: "MI",
  },
  {
    zip_code: "49341",

    ste_name: "MI",
  },
  {
    zip_code: "49755",

    ste_name: "MI",
  },
  {
    zip_code: "49874",

    ste_name: "MI",
  },
  {
    zip_code: "49958",

    ste_name: "MI",
  },
  {
    zip_code: "50050",

    ste_name: "IA",
  },
  {
    zip_code: "50064",

    ste_name: "IA",
  },
  {
    zip_code: "50075",

    ste_name: "IA",
  },
  {
    zip_code: "50154",

    ste_name: "IA",
  },
  {
    zip_code: "50155",

    ste_name: "IA",
  },
  {
    zip_code: "50162",

    ste_name: "IA",
  },
  {
    zip_code: "50247",

    ste_name: "IA",
  },
  {
    zip_code: "50249",

    ste_name: "IA",
  },
  {
    zip_code: "50540",

    ste_name: "IA",
  },
  {
    zip_code: "50567",

    ste_name: "IA",
  },
  {
    zip_code: "50598",

    ste_name: "IA",
  },
  {
    zip_code: "50654",

    ste_name: "IA",
  },
  {
    zip_code: "50662",

    ste_name: "IA",
  },
  {
    zip_code: "50849",

    ste_name: "IA",
  },
  {
    zip_code: "51034",

    ste_name: "IA",
  },
  {
    zip_code: "51338",

    ste_name: "IA",
  },
  {
    zip_code: "51363",

    ste_name: "IA",
  },
  {
    zip_code: "51537",

    ste_name: "IA",
  },
  {
    zip_code: "52074",

    ste_name: "IA",
  },
  {
    zip_code: "52101",

    ste_name: "IA",
  },
  {
    zip_code: "52135",

    ste_name: "IA",
  },
  {
    zip_code: "52142",

    ste_name: "IA",
  },
  {
    zip_code: "52146",

    ste_name: "IA",
  },
  {
    zip_code: "52169",

    ste_name: "IA",
  },
  {
    zip_code: "52322",

    ste_name: "IA",
  },
  {
    zip_code: "52354",

    ste_name: "IA",
  },
  {
    zip_code: "52535",

    ste_name: "IA",
  },
  {
    zip_code: "52544",

    ste_name: "IA",
  },
  {
    zip_code: "52580",

    ste_name: "IA",
  },
  {
    zip_code: "52623",

    ste_name: "IA",
  },
  {
    zip_code: "52773",

    ste_name: "IA",
  },
  {
    zip_code: "53044",

    ste_name: "WI",
  },
  {
    zip_code: "53085",

    ste_name: "WI",
  },
  {
    zip_code: "53118",

    ste_name: "WI",
  },
  {
    zip_code: "53121",

    ste_name: "WI",
  },
  {
    zip_code: "53122",

    ste_name: "WI",
  },
  {
    zip_code: "53179",

    ste_name: "WI",
  },
  {
    zip_code: "53551",

    ste_name: "WI",
  },
  {
    zip_code: "53553",

    ste_name: "WI",
  },
  {
    zip_code: "53808",

    ste_name: "WI",
  },
  {
    zip_code: "53813",

    ste_name: "WI",
  },
  {
    zip_code: "54125",

    ste_name: "WI",
  },
  {
    zip_code: "54141",

    ste_name: "WI",
  },
  {
    zip_code: "54143",

    ste_name: "WI",
  },
  {
    zip_code: "54155",

    ste_name: "WI",
  },
  {
    zip_code: "54159",

    ste_name: "WI",
  },
  {
    zip_code: "54205",

    ste_name: "WI",
  },
  {
    zip_code: "54234",

    ste_name: "WI",
  },
  {
    zip_code: "54307",

    ste_name: "WI",
  },
  {
    zip_code: "54413",

    ste_name: "WI",
  },
  {
    zip_code: "54462",

    ste_name: "WI",
  },
  {
    zip_code: "54524",

    ste_name: "WI",
  },
  {
    zip_code: "54548",

    ste_name: "WI",
  },
  {
    zip_code: "54635",

    ste_name: "WI",
  },
  {
    zip_code: "54661",

    ste_name: "WI",
  },
  {
    zip_code: "54737",

    ste_name: "WI",
  },
  {
    zip_code: "54826",

    ste_name: "WI",
  },
  {
    zip_code: "54841",

    ste_name: "WI",
  },
  {
    zip_code: "54847",

    ste_name: "WI",
  },
  {
    zip_code: "54921",

    ste_name: "WI",
  },
  {
    zip_code: "54977",

    ste_name: "WI",
  },
  {
    zip_code: "54983",

    ste_name: "WI",
  },
  {
    zip_code: "55007",

    ste_name: "MN",
  },
  {
    zip_code: "55102",

    ste_name: "MN",
  },
  {
    zip_code: "55105",

    ste_name: "MN",
  },
  {
    zip_code: "55110",

    ste_name: "MN",
  },
  {
    zip_code: "55350",

    ste_name: "MN",
  },
  {
    zip_code: "55407",

    ste_name: "MN",
  },
  {
    zip_code: "55411",

    ste_name: "MN",
  },
  {
    zip_code: "55416",

    ste_name: "MN",
  },
  {
    zip_code: "55707",

    ste_name: "MN",
  },
  {
    zip_code: "55793",

    ste_name: "MN",
  },
  {
    zip_code: "55929",

    ste_name: "MN",
  },
  {
    zip_code: "55954",

    ste_name: "MN",
  },
  {
    zip_code: "55971",

    ste_name: "MN",
  },
  {
    zip_code: "56046",

    ste_name: "MN",
  },
  {
    zip_code: "56063",

    ste_name: "MN",
  },
  {
    zip_code: "56118",

    ste_name: "MN",
  },
  {
    zip_code: "56132",

    ste_name: "MN",
  },
  {
    zip_code: "56176",

    ste_name: "MN",
  },
  {
    zip_code: "56297",

    ste_name: "MN",
  },
  {
    zip_code: "56368",

    ste_name: "MN",
  },
  {
    zip_code: "56433",

    ste_name: "MN",
  },
  {
    zip_code: "56465",

    ste_name: "MN",
  },
  {
    zip_code: "56519",

    ste_name: "MN",
  },
  {
    zip_code: "56524",

    ste_name: "MN",
  },
  {
    zip_code: "56578",

    ste_name: "MN",
  },
  {
    zip_code: "56583",

    ste_name: "MN",
  },
  {
    zip_code: "56710",

    ste_name: "MN",
  },
  {
    zip_code: "57015",

    ste_name: "SD",
  },
  {
    zip_code: "57028",

    ste_name: "SD",
  },
  {
    zip_code: "57063",

    ste_name: "SD",
  },
  {
    zip_code: "57110",

    ste_name: "SD",
  },
  {
    zip_code: "57249",

    ste_name: "SD",
  },
  {
    zip_code: "57256",

    ste_name: "SD",
  },
  {
    zip_code: "57324",

    ste_name: "SD",
  },
  {
    zip_code: "57429",

    ste_name: "SD",
  },
  {
    zip_code: "57438",

    ste_name: "SD",
  },
  {
    zip_code: "57570",

    ste_name: "SD",
  },
  {
    zip_code: "57639",

    ste_name: "SD",
  },
  {
    zip_code: "57706",

    ste_name: "SD",
  },
  {
    zip_code: "57716",

    ste_name: "SD",
  },
  {
    zip_code: "57790",

    ste_name: "SD",
  },
  {
    zip_code: "58002",

    ste_name: "ND",
  },
  {
    zip_code: "58040",

    ste_name: "ND",
  },
  {
    zip_code: "58218",

    ste_name: "ND",
  },
  {
    zip_code: "58228",

    ste_name: "ND",
  },
  {
    zip_code: "58339",

    ste_name: "ND",
  },
  {
    zip_code: "58463",

    ste_name: "ND",
  },
  {
    zip_code: "98512",

    ste_name: "WA",
  },
  {
    zip_code: "98526",

    ste_name: "WA",
  },
  {
    zip_code: "98537",

    ste_name: "WA",
  },
  {
    zip_code: "98557",

    ste_name: "WA",
  },
  {
    zip_code: "98610",

    ste_name: "WA",
  },
  {
    zip_code: "98640",

    ste_name: "WA",
  },
  {
    zip_code: "98665",

    ste_name: "WA",
  },
  {
    zip_code: "98849",

    ste_name: "WA",
  },
  {
    zip_code: "98948",

    ste_name: "WA",
  },
  {
    zip_code: "99013",

    ste_name: "WA",
  },
  {
    zip_code: "99021",

    ste_name: "WA",
  },
  {
    zip_code: "99030",

    ste_name: "WA",
  },
  {
    zip_code: "99115",

    ste_name: "WA",
  },
  {
    zip_code: "99135",

    ste_name: "WA",
  },
  {
    zip_code: "99147",

    ste_name: "WA",
  },
  {
    zip_code: "99207",

    ste_name: "WA",
  },
  {
    zip_code: "99502",

    ste_name: "AK",
  },
  {
    zip_code: "99504",

    ste_name: "AK",
  },
  {
    zip_code: "99549",

    ste_name: "AK",
  },
  {
    zip_code: "99572",

    ste_name: "AK",
  },
  {
    zip_code: "99576",

    ste_name: "AK",
  },
  {
    zip_code: "99768",

    ste_name: "AK",
  },
  {
    zip_code: "99769",

    ste_name: "AK",
  },
  {
    zip_code: "99784",

    ste_name: "AK",
  },
  {
    zip_code: "99820",

    ste_name: "AK",
  },
  {
    zip_code: "31016",

    ste_name: "GA",
  },
  {
    zip_code: "31097",

    ste_name: "GA",
  },
  {
    zip_code: "31206",

    ste_name: "GA",
  },
  {
    zip_code: "31327",

    ste_name: "GA",
  },
  {
    zip_code: "31405",

    ste_name: "GA",
  },
  {
    zip_code: "31409",

    ste_name: "GA",
  },
  {
    zip_code: "31545",

    ste_name: "GA",
  },
  {
    zip_code: "31714",

    ste_name: "GA",
  },
  {
    zip_code: "32097",

    ste_name: "FL",
  },
  {
    zip_code: "32118",

    ste_name: "FL",
  },
  {
    zip_code: "32129",

    ste_name: "FL",
  },
  {
    zip_code: "32347",

    ste_name: "FL",
  },
  {
    zip_code: "32410",

    ste_name: "FL",
  },
  {
    zip_code: "32460",

    ste_name: "FL",
  },
  {
    zip_code: "32462",

    ste_name: "FL",
  },
  {
    zip_code: "32565",

    ste_name: "FL",
  },
  {
    zip_code: "32819",

    ste_name: "FL",
  },
  {
    zip_code: "33032",

    ste_name: "FL",
  },
  {
    zip_code: "33130",

    ste_name: "FL",
  },
  {
    zip_code: "33147",

    ste_name: "FL",
  },
  {
    zip_code: "33168",

    ste_name: "FL",
  },
  {
    zip_code: "33449",

    ste_name: "FL",
  },
  {
    zip_code: "33455",

    ste_name: "FL",
  },
  {
    zip_code: "33498",

    ste_name: "FL",
  },
  {
    zip_code: "33566",

    ste_name: "FL",
  },
  {
    zip_code: "33603",

    ste_name: "FL",
  },
  {
    zip_code: "33616",

    ste_name: "FL",
  },
  {
    zip_code: "33708",

    ste_name: "FL",
  },
  {
    zip_code: "33710",

    ste_name: "FL",
  },
  {
    zip_code: "33763",

    ste_name: "FL",
  },
  {
    zip_code: "33772",

    ste_name: "FL",
  },
  {
    zip_code: "33803",

    ste_name: "FL",
  },
  {
    zip_code: "33912",

    ste_name: "FL",
  },
  {
    zip_code: "33919",

    ste_name: "FL",
  },
  {
    zip_code: "33950",

    ste_name: "FL",
  },
  {
    zip_code: "33952",

    ste_name: "FL",
  },
  {
    zip_code: "33972",

    ste_name: "FL",
  },
  {
    zip_code: "34101",

    ste_name: "FL",
  },
  {
    zip_code: "34112",

    ste_name: "FL",
  },
  {
    zip_code: "34142",

    ste_name: "FL",
  },
  {
    zip_code: "34235",

    ste_name: "FL",
  },
  {
    zip_code: "34705",

    ste_name: "FL",
  },
  {
    zip_code: "34741",

    ste_name: "FL",
  },
  {
    zip_code: "34743",

    ste_name: "FL",
  },
  {
    zip_code: "34952",

    ste_name: "FL",
  },
  {
    zip_code: "35020",

    ste_name: "AL",
  },
  {
    zip_code: "35111",

    ste_name: "AL",
  },
  {
    zip_code: "35148",

    ste_name: "AL",
  },
  {
    zip_code: "35211",

    ste_name: "AL",
  },
  {
    zip_code: "35461",

    ste_name: "AL",
  },
  {
    zip_code: "35463",

    ste_name: "AL",
  },
  {
    zip_code: "35552",

    ste_name: "AL",
  },
  {
    zip_code: "36266",

    ste_name: "AL",
  },
  {
    zip_code: "36344",

    ste_name: "AL",
  },
  {
    zip_code: "36435",

    ste_name: "AL",
  },
  {
    zip_code: "36580",

    ste_name: "AL",
  },
  {
    zip_code: "36750",

    ste_name: "AL",
  },
  {
    zip_code: "36830",

    ste_name: "AL",
  },
  {
    zip_code: "37061",

    ste_name: "TN",
  },
  {
    zip_code: "37180",

    ste_name: "TN",
  },
  {
    zip_code: "37209",

    ste_name: "TN",
  },
  {
    zip_code: "37213",

    ste_name: "TN",
  },
  {
    zip_code: "37217",

    ste_name: "TN",
  },
  {
    zip_code: "37345",

    ste_name: "TN",
  },
  {
    zip_code: "37363",

    ste_name: "TN",
  },
  {
    zip_code: "37388",

    ste_name: "TN",
  },
  {
    zip_code: "37618",

    ste_name: "TN",
  },
  {
    zip_code: "37682",

    ste_name: "TN",
  },
  {
    zip_code: "37694",

    ste_name: "TN",
  },
  {
    zip_code: "37701",

    ste_name: "TN",
  },
  {
    zip_code: "37713",

    ste_name: "TN",
  },
  {
    zip_code: "37922",

    ste_name: "TN",
  },
  {
    zip_code: "38006",

    ste_name: "TN",
  },
  {
    zip_code: "38108",

    ste_name: "TN",
  },
  {
    zip_code: "38220",

    ste_name: "TN",
  },
  {
    zip_code: "38235",

    ste_name: "TN",
  },
  {
    zip_code: "38257",

    ste_name: "TN",
  },
  {
    zip_code: "38261",

    ste_name: "TN",
  },
  {
    zip_code: "38359",

    ste_name: "TN",
  },
  {
    zip_code: "38375",

    ste_name: "TN",
  },
  {
    zip_code: "38379",

    ste_name: "TN",
  },
  {
    zip_code: "38425",

    ste_name: "TN",
  },
  {
    zip_code: "38673",

    ste_name: "MS",
  },
  {
    zip_code: "38765",

    ste_name: "MS",
  },
  {
    zip_code: "38827",

    ste_name: "MS",
  },
  {
    zip_code: "38833",

    ste_name: "MS",
  },
  {
    zip_code: "38846",

    ste_name: "MS",
  },
  {
    zip_code: "38924",

    ste_name: "MS",
  },
  {
    zip_code: "38930",

    ste_name: "MS",
  },
  {
    zip_code: "39108",

    ste_name: "MS",
  },
  {
    zip_code: "90003",

    ste_name: "CA",
  },
  {
    zip_code: "90505",

    ste_name: "CA",
  },
  {
    zip_code: "91020",

    ste_name: "CA",
  },
  {
    zip_code: "91042",

    ste_name: "CA",
  },
  {
    zip_code: "91201",

    ste_name: "CA",
  },
  {
    zip_code: "91775",

    ste_name: "CA",
  },
  {
    zip_code: "91963",

    ste_name: "CA",
  },
  {
    zip_code: "92124",

    ste_name: "CA",
  },
  {
    zip_code: "92253",

    ste_name: "CA",
  },
  {
    zip_code: "92256",

    ste_name: "CA",
  },
  {
    zip_code: "92270",

    ste_name: "CA",
  },
  {
    zip_code: "92311",

    ste_name: "CA",
  },
  {
    zip_code: "92339",

    ste_name: "CA",
  },
  {
    zip_code: "92401",

    ste_name: "CA",
  },
  {
    zip_code: "92530",

    ste_name: "CA",
  },
  {
    zip_code: "92627",

    ste_name: "CA",
  },
  {
    zip_code: "92676",

    ste_name: "CA",
  },
  {
    zip_code: "92703",

    ste_name: "CA",
  },
  {
    zip_code: "93252",

    ste_name: "CA",
  },
  {
    zip_code: "93307",

    ste_name: "CA",
  },
  {
    zip_code: "93528",

    ste_name: "CA",
  },
  {
    zip_code: "93604",

    ste_name: "CA",
  },
  {
    zip_code: "93606",

    ste_name: "CA",
  },
  {
    zip_code: "93640",

    ste_name: "CA",
  },
  {
    zip_code: "94005",

    ste_name: "CA",
  },
  {
    zip_code: "94102",

    ste_name: "CA",
  },
  {
    zip_code: "94103",

    ste_name: "CA",
  },
  {
    zip_code: "94303",

    ste_name: "CA",
  },
  {
    zip_code: "94576",

    ste_name: "CA",
  },
  {
    zip_code: "94901",

    ste_name: "CA",
  },
  {
    zip_code: "94920",

    ste_name: "CA",
  },
  {
    zip_code: "94946",

    ste_name: "CA",
  },
  {
    zip_code: "95220",

    ste_name: "CA",
  },
  {
    zip_code: "95312",

    ste_name: "CA",
  },
  {
    zip_code: "95358",

    ste_name: "CA",
  },
  {
    zip_code: "95421",

    ste_name: "CA",
  },
  {
    zip_code: "95482",

    ste_name: "CA",
  },
  {
    zip_code: "95663",

    ste_name: "CA",
  },
  {
    zip_code: "95670",

    ste_name: "CA",
  },
  {
    zip_code: "95679",

    ste_name: "CA",
  },
  {
    zip_code: "95928",

    ste_name: "CA",
  },
  {
    zip_code: "95987",

    ste_name: "CA",
  },
  {
    zip_code: "96025",

    ste_name: "CA",
  },
  {
    zip_code: "96065",

    ste_name: "CA",
  },
  {
    zip_code: "96080",

    ste_name: "CA",
  },
  {
    zip_code: "96115",

    ste_name: "CA",
  },
  {
    zip_code: "96122",

    ste_name: "CA",
  },
  {
    zip_code: "96128",

    ste_name: "CA",
  },
  {
    zip_code: "96726",

    ste_name: "HI",
  },
  {
    zip_code: "96743",

    ste_name: "HI",
  },
  {
    zip_code: "96768",

    ste_name: "HI",
  },
  {
    zip_code: "96770",

    ste_name: "HI",
  },
  {
    zip_code: "96776",

    ste_name: "HI",
  },
  {
    zip_code: "96785",

    ste_name: "HI",
  },
  {
    zip_code: "97009",

    ste_name: "OR",
  },
  {
    zip_code: "97015",

    ste_name: "OR",
  },
  {
    zip_code: "97117",

    ste_name: "OR",
  },
  {
    zip_code: "97130",

    ste_name: "OR",
  },
  {
    zip_code: "97410",

    ste_name: "OR",
  },
  {
    zip_code: "97426",

    ste_name: "OR",
  },
  {
    zip_code: "97494",

    ste_name: "OR",
  },
  {
    zip_code: "97525",

    ste_name: "OR",
  },
  {
    zip_code: "97751",

    ste_name: "OR",
  },
  {
    zip_code: "97870",

    ste_name: "OR",
  },
  {
    zip_code: "98014",

    ste_name: "WA",
  },
  {
    zip_code: "98043",

    ste_name: "WA",
  },
  {
    zip_code: "98065",

    ste_name: "WA",
  },
  {
    zip_code: "98108",

    ste_name: "WA",
  },
  {
    zip_code: "98168",

    ste_name: "WA",
  },
  {
    zip_code: "97341",

    ste_name: "OR",
  },
  {
    zip_code: "97371",

    ste_name: "OR",
  },
  {
    zip_code: "97373",

    ste_name: "OR",
  },
  {
    zip_code: "97402",

    ste_name: "OR",
  },
  {
    zip_code: "97903",

    ste_name: "OR",
  },
  {
    zip_code: "98011",

    ste_name: "WA",
  },
  {
    zip_code: "98021",

    ste_name: "WA",
  },
  {
    zip_code: "98232",

    ste_name: "WA",
  },
  {
    zip_code: "98283",

    ste_name: "WA",
  },
  {
    zip_code: "98297",

    ste_name: "WA",
  },
  {
    zip_code: "98355",

    ste_name: "WA",
  },
  {
    zip_code: "98366",

    ste_name: "WA",
  },
  {
    zip_code: "90034",

    ste_name: "CA",
  },
  {
    zip_code: "90049",

    ste_name: "CA",
  },
  {
    zip_code: "90066",

    ste_name: "CA",
  },
  {
    zip_code: "90230",

    ste_name: "CA",
  },
  {
    zip_code: "90304",

    ste_name: "CA",
  },
  {
    zip_code: "90403",

    ste_name: "CA",
  },
  {
    zip_code: "90742",

    ste_name: "CA",
  },
  {
    zip_code: "91345",

    ste_name: "CA",
  },
  {
    zip_code: "91752",

    ste_name: "CA",
  },
  {
    zip_code: "91789",

    ste_name: "CA",
  },
  {
    zip_code: "91935",

    ste_name: "CA",
  },
  {
    zip_code: "92019",

    ste_name: "CA",
  },
  {
    zip_code: "92021",

    ste_name: "CA",
  },
  {
    zip_code: "92131",

    ste_name: "CA",
  },
  {
    zip_code: "92139",

    ste_name: "CA",
  },
  {
    zip_code: "92308",

    ste_name: "CA",
  },
  {
    zip_code: "92347",

    ste_name: "CA",
  },
  {
    zip_code: "92509",

    ste_name: "CA",
  },
  {
    zip_code: "92582",

    ste_name: "CA",
  },
  {
    zip_code: "92591",

    ste_name: "CA",
  },
  {
    zip_code: "92801",

    ste_name: "CA",
  },
  {
    zip_code: "92840",

    ste_name: "CA",
  },
  {
    zip_code: "92886",

    ste_name: "CA",
  },
  {
    zip_code: "93660",

    ste_name: "CA",
  },
  {
    zip_code: "93673",

    ste_name: "CA",
  },
  {
    zip_code: "93955",

    ste_name: "CA",
  },
  {
    zip_code: "94085",

    ste_name: "CA",
  },
  {
    zip_code: "94115",

    ste_name: "CA",
  },
  {
    zip_code: "94541",

    ste_name: "CA",
  },
  {
    zip_code: "94621",

    ste_name: "CA",
  },
  {
    zip_code: "94850",

    ste_name: "CA",
  },
  {
    zip_code: "95008",

    ste_name: "CA",
  },
  {
    zip_code: "95012",

    ste_name: "CA",
  },
  {
    zip_code: "95124",

    ste_name: "CA",
  },
  {
    zip_code: "95129",

    ste_name: "CA",
  },
  {
    zip_code: "95219",

    ste_name: "CA",
  },
  {
    zip_code: "95360",

    ste_name: "CA",
  },
  {
    zip_code: "95389",

    ste_name: "CA",
  },
  {
    zip_code: "95456",

    ste_name: "CA",
  },
  {
    zip_code: "95494",

    ste_name: "CA",
  },
  {
    zip_code: "95531",

    ste_name: "CA",
  },
  {
    zip_code: "95543",

    ste_name: "CA",
  },
  {
    zip_code: "95551",

    ste_name: "CA",
  },
  {
    zip_code: "95563",

    ste_name: "CA",
  },
  {
    zip_code: "95565",

    ste_name: "CA",
  },
  {
    zip_code: "95571",

    ste_name: "CA",
  },
  {
    zip_code: "95585",

    ste_name: "CA",
  },
  {
    zip_code: "95692",

    ste_name: "CA",
  },
  {
    zip_code: "95903",

    ste_name: "CA",
  },
  {
    zip_code: "95934",

    ste_name: "CA",
  },
  {
    zip_code: "95948",

    ste_name: "CA",
  },
  {
    zip_code: "96028",

    ste_name: "CA",
  },
  {
    zip_code: "96041",

    ste_name: "CA",
  },
  {
    zip_code: "96063",

    ste_name: "CA",
  },
  {
    zip_code: "96076",

    ste_name: "CA",
  },
  {
    zip_code: "96117",

    ste_name: "CA",
  },
  {
    zip_code: "96705",

    ste_name: "HI",
  },
  {
    zip_code: "96742",

    ste_name: "HI",
  },
  {
    zip_code: "96748",

    ste_name: "HI",
  },
  {
    zip_code: "96754",

    ste_name: "HI",
  },
  {
    zip_code: "96762",

    ste_name: "HI",
  },
  {
    zip_code: "96782",

    ste_name: "HI",
  },
  {
    zip_code: "96815",

    ste_name: "HI",
  },
  {
    zip_code: "96826",

    ste_name: "HI",
  },
  {
    zip_code: "96928",

    ste_name: "GU",
  },
  {
    zip_code: "97045",

    ste_name: "OR",
  },
  {
    zip_code: "97124",

    ste_name: "OR",
  },
  {
    zip_code: "97134",

    ste_name: "OR",
  },
  {
    zip_code: "97317",

    ste_name: "OR",
  },
  {
    zip_code: "97417",

    ste_name: "OR",
  },
  {
    zip_code: "97435",

    ste_name: "OR",
  },
  {
    zip_code: "97438",

    ste_name: "OR",
  },
  {
    zip_code: "97463",

    ste_name: "OR",
  },
  {
    zip_code: "97488",

    ste_name: "OR",
  },
  {
    zip_code: "97490",

    ste_name: "OR",
  },
  {
    zip_code: "97504",

    ste_name: "OR",
  },
  {
    zip_code: "97859",

    ste_name: "OR",
  },
  {
    zip_code: "97901",

    ste_name: "OR",
  },
  {
    zip_code: "97913",

    ste_name: "OR",
  },
  {
    zip_code: "98028",

    ste_name: "WA",
  },
  {
    zip_code: "98229",

    ste_name: "WA",
  },
  {
    zip_code: "98237",

    ste_name: "WA",
  },
  {
    zip_code: "98249",

    ste_name: "WA",
  },
  {
    zip_code: "98271",

    ste_name: "WA",
  },
  {
    zip_code: "98333",

    ste_name: "WA",
  },
  {
    zip_code: "98357",

    ste_name: "WA",
  },
  {
    zip_code: "98367",

    ste_name: "WA",
  },
  {
    zip_code: "98403",

    ste_name: "WA",
  },
  {
    zip_code: "98503",

    ste_name: "WA",
  },
  {
    zip_code: "98535",

    ste_name: "WA",
  },
  {
    zip_code: "98542",

    ste_name: "WA",
  },
  {
    zip_code: "98585",

    ste_name: "WA",
  },
  {
    zip_code: "98601",

    ste_name: "WA",
  },
  {
    zip_code: "98675",

    ste_name: "WA",
  },
  {
    zip_code: "98801",

    ste_name: "WA",
  },
  {
    zip_code: "98837",

    ste_name: "WA",
  },
  {
    zip_code: "98901",

    ste_name: "WA",
  },
  {
    zip_code: "98936",

    ste_name: "WA",
  },
  {
    zip_code: "99136",

    ste_name: "WA",
  },
  {
    zip_code: "99155",

    ste_name: "WA",
  },
  {
    zip_code: "99173",

    ste_name: "WA",
  },
  {
    zip_code: "99206",

    ste_name: "WA",
  },
  {
    zip_code: "99330",

    ste_name: "WA",
  },
  {
    zip_code: "99347",

    ste_name: "WA",
  },
  {
    zip_code: "99574",

    ste_name: "AK",
  },
  {
    zip_code: "99587",

    ste_name: "AK",
  },
  {
    zip_code: "99607",

    ste_name: "AK",
  },
  {
    zip_code: "99624",

    ste_name: "AK",
  },
  {
    zip_code: "99636",

    ste_name: "AK",
  },
  {
    zip_code: "99690",

    ste_name: "AK",
  },
  {
    zip_code: "99691",

    ste_name: "AK",
  },
  {
    zip_code: "99753",

    ste_name: "AK",
  },
  {
    zip_code: "99788",

    ste_name: "AK",
  },
  {
    zip_code: "99929",

    ste_name: "AK",
  },
  {
    zip_code: "660",

    ste_name: "PR",
  },
  {
    zip_code: "682",

    ste_name: "PR",
  },
  {
    zip_code: "738",

    ste_name: "PR",
  },
  {
    zip_code: "901",

    ste_name: "PR",
  },
  {
    zip_code: "952",

    ste_name: "PR",
  },
  {
    zip_code: "957",

    ste_name: "PR",
  },
  {
    zip_code: "966",

    ste_name: "PR",
  },
  {
    zip_code: "1009",

    ste_name: "MA",
  },
  {
    zip_code: "1350",

    ste_name: "MA",
  },
  {
    zip_code: "1354",

    ste_name: "MA",
  },
  {
    zip_code: "1721",

    ste_name: "MA",
  },
  {
    zip_code: "1879",

    ste_name: "MA",
  },
  {
    zip_code: "1890",

    ste_name: "MA",
  },
  {
    zip_code: "2121",

    ste_name: "MA",
  },
  {
    zip_code: "2130",

    ste_name: "MA",
  },
  {
    zip_code: "2136",

    ste_name: "MA",
  },
  {
    zip_code: "2143",

    ste_name: "MA",
  },
  {
    zip_code: "2144",

    ste_name: "MA",
  },
  {
    zip_code: "2346",

    ste_name: "MA",
  },
  {
    zip_code: "2357",

    ste_name: "MA",
  },
  {
    zip_code: "2542",

    ste_name: "MA",
  },
  {
    zip_code: "2568",

    ste_name: "MA",
  },
  {
    zip_code: "2635",

    ste_name: "MA",
  },
  {
    zip_code: "2746",

    ste_name: "MA",
  },
  {
    zip_code: "3034",

    ste_name: "NH",
  },
  {
    zip_code: "3064",

    ste_name: "NH",
  },
  {
    zip_code: "3216",

    ste_name: "NH",
  },
  {
    zip_code: "3263",

    ste_name: "NH",
  },
  {
    zip_code: "3281",

    ste_name: "NH",
  },
  {
    zip_code: "3282",

    ste_name: "NH",
  },
  {
    zip_code: "3561",

    ste_name: "NH",
  },
  {
    zip_code: "3817",

    ste_name: "NH",
  },
  {
    zip_code: "3851",

    ste_name: "NH",
  },
  {
    zip_code: "3855",

    ste_name: "NH",
  },
  {
    zip_code: "3865",

    ste_name: "NH",
  },
  {
    zip_code: "3868",

    ste_name: "NH",
  },
  {
    zip_code: "3875",

    ste_name: "NH",
  },
  {
    zip_code: "3908",

    ste_name: "ME",
  },
  {
    zip_code: "4015",

    ste_name: "ME",
  },
  {
    zip_code: "4062",

    ste_name: "ME",
  },
  {
    zip_code: "4227",

    ste_name: "ME",
  },
  {
    zip_code: "4280",

    ste_name: "ME",
  },
  {
    zip_code: "4292",

    ste_name: "ME",
  },
  {
    zip_code: "4438",

    ste_name: "ME",
  },
  {
    zip_code: "4476",

    ste_name: "ME",
  },
  {
    zip_code: "4479",

    ste_name: "ME",
  },
  {
    zip_code: "4617",

    ste_name: "ME",
  },
  {
    zip_code: "4742",

    ste_name: "ME",
  },
  {
    zip_code: "4858",

    ste_name: "ME",
  },
  {
    zip_code: "4976",

    ste_name: "ME",
  },
  {
    zip_code: "4986",

    ste_name: "ME",
  },
  {
    zip_code: "5051",

    ste_name: "VT",
  },
  {
    zip_code: "5059",

    ste_name: "VT",
  },
  {
    zip_code: "5262",

    ste_name: "VT",
  },
  {
    zip_code: "5462",

    ste_name: "VT",
  },
  {
    zip_code: "5495",

    ste_name: "VT",
  },
  {
    zip_code: "5675",

    ste_name: "VT",
  },
  {
    zip_code: "5775",

    ste_name: "VT",
  },
  {
    zip_code: "5819",

    ste_name: "VT",
  },
  {
    zip_code: "5855",

    ste_name: "VT",
  },
  {
    zip_code: "5871",

    ste_name: "VT",
  },
  {
    zip_code: "6073",

    ste_name: "CT",
  },
  {
    zip_code: "6078",

    ste_name: "CT",
  },
  {
    zip_code: "6259",

    ste_name: "CT",
  },
  {
    zip_code: "6334",

    ste_name: "CT",
  },
  {
    zip_code: "6419",

    ste_name: "CT",
  },
  {
    zip_code: "6612",

    ste_name: "CT",
  },
  {
    zip_code: "6840",

    ste_name: "CT",
  },
  {
    zip_code: "7006",

    ste_name: "NJ",
  },
  {
    zip_code: "7059",

    ste_name: "NJ",
  },
  {
    zip_code: "7070",

    ste_name: "NJ",
  },
  {
    zip_code: "7090",

    ste_name: "NJ",
  },
  {
    zip_code: "7094",

    ste_name: "NJ",
  },
  {
    zip_code: "7111",

    ste_name: "NJ",
  },
  {
    zip_code: "7304",

    ste_name: "NJ",
  },
  {
    zip_code: "7417",

    ste_name: "NJ",
  },
  {
    zip_code: "7643",

    ste_name: "NJ",
  },
  {
    zip_code: "7823",

    ste_name: "NJ",
  },
  {
    zip_code: "7832",

    ste_name: "NJ",
  },
  {
    zip_code: "8004",

    ste_name: "NJ",
  },
  {
    zip_code: "8063",

    ste_name: "NJ",
  },
  {
    zip_code: "8110",

    ste_name: "NJ",
  },
  {
    zip_code: "8241",

    ste_name: "NJ",
  },
  {
    zip_code: "8323",

    ste_name: "NJ",
  },
  {
    zip_code: "8540",

    ste_name: "NJ",
  },
  {
    zip_code: "8832",

    ste_name: "NJ",
  },
  {
    zip_code: "8863",

    ste_name: "NJ",
  },
  {
    zip_code: "10536",

    ste_name: "NY",
  },
  {
    zip_code: "10706",

    ste_name: "NY",
  },
  {
    zip_code: "10911",

    ste_name: "NY",
  },
  {
    zip_code: "10941",

    ste_name: "NY",
  },
  {
    zip_code: "10956",

    ste_name: "NY",
  },
  {
    zip_code: "10975",

    ste_name: "NY",
  },
  {
    zip_code: "11030",

    ste_name: "NY",
  },
  {
    zip_code: "11042",

    ste_name: "NY",
  },
  {
    zip_code: "11109",

    ste_name: "NY",
  },
  {
    zip_code: "11214",

    ste_name: "NY",
  },
  {
    zip_code: "11364",

    ste_name: "NY",
  },
  {
    zip_code: "11596",

    ste_name: "NY",
  },
  {
    zip_code: "11703",

    ste_name: "NY",
  },
  {
    zip_code: "11725",

    ste_name: "NY",
  },
  {
    zip_code: "11755",

    ste_name: "NY",
  },
  {
    zip_code: "11778",

    ste_name: "NY",
  },
  {
    zip_code: "11783",

    ste_name: "NY",
  },
  {
    zip_code: "11787",

    ste_name: "NY",
  },
  {
    zip_code: "11930",

    ste_name: "NY",
  },
  {
    zip_code: "11950",

    ste_name: "NY",
  },
  {
    zip_code: "11952",

    ste_name: "NY",
  },
  {
    zip_code: "11958",

    ste_name: "NY",
  },
  {
    zip_code: "12108",

    ste_name: "NY",
  },
  {
    zip_code: "12140",

    ste_name: "NY",
  },
  {
    zip_code: "12159",

    ste_name: "NY",
  },
  {
    zip_code: "12184",

    ste_name: "NY",
  },
  {
    zip_code: "12516",

    ste_name: "NY",
  },
  {
    zip_code: "12566",

    ste_name: "NY",
  },
  {
    zip_code: "12571",

    ste_name: "NY",
  },
  {
    zip_code: "12574",

    ste_name: "NY",
  },
  {
    zip_code: "12784",

    ste_name: "NY",
  },
  {
    zip_code: "12822",

    ste_name: "NY",
  },
  {
    zip_code: "12855",

    ste_name: "NY",
  },
  {
    zip_code: "12944",

    ste_name: "NY",
  },
  {
    zip_code: "12959",

    ste_name: "NY",
  },
  {
    zip_code: "12967",

    ste_name: "NY",
  },
  {
    zip_code: "12983",

    ste_name: "NY",
  },
  {
    zip_code: "13053",

    ste_name: "NY",
  },
  {
    zip_code: "13082",

    ste_name: "NY",
  },
  {
    zip_code: "13116",

    ste_name: "NY",
  },
  {
    zip_code: "13166",

    ste_name: "NY",
  },
  {
    zip_code: "13208",

    ste_name: "NY",
  },
  {
    zip_code: "13346",

    ste_name: "NY",
  },
  {
    zip_code: "13416",

    ste_name: "NY",
  },
  {
    zip_code: "13417",

    ste_name: "NY",
  },
  {
    zip_code: "13439",

    ste_name: "NY",
  },
  {
    zip_code: "13460",

    ste_name: "NY",
  },
  {
    zip_code: "13470",

    ste_name: "NY",
  },
  {
    zip_code: "13480",

    ste_name: "NY",
  },
  {
    zip_code: "13486",

    ste_name: "NY",
  },
  {
    zip_code: "13490",

    ste_name: "NY",
  },
  {
    zip_code: "13621",

    ste_name: "NY",
  },
  {
    zip_code: "13650",

    ste_name: "NY",
  },
  {
    zip_code: "13665",

    ste_name: "NY",
  },
  {
    zip_code: "13677",

    ste_name: "NY",
  },
  {
    zip_code: "13693",

    ste_name: "NY",
  },
  {
    zip_code: "13696",

    ste_name: "NY",
  },
  {
    zip_code: "13754",

    ste_name: "NY",
  },
  {
    zip_code: "13810",

    ste_name: "NY",
  },
  {
    zip_code: "14001",

    ste_name: "NY",
  },
  {
    zip_code: "14004",

    ste_name: "NY",
  },
  {
    zip_code: "14051",

    ste_name: "NY",
  },
  {
    zip_code: "14060",

    ste_name: "NY",
  },
  {
    zip_code: "14112",

    ste_name: "NY",
  },
  {
    zip_code: "14220",

    ste_name: "NY",
  },
  {
    zip_code: "14454",

    ste_name: "NY",
  },
  {
    zip_code: "14464",

    ste_name: "NY",
  },
  {
    zip_code: "14532",

    ste_name: "NY",
  },
  {
    zip_code: "14546",

    ste_name: "NY",
  },
  {
    zip_code: "14564",

    ste_name: "NY",
  },
  {
    zip_code: "14608",

    ste_name: "NY",
  },
  {
    zip_code: "14618",

    ste_name: "NY",
  },
  {
    zip_code: "14701",

    ste_name: "NY",
  },
  {
    zip_code: "14709",

    ste_name: "NY",
  },
  {
    zip_code: "14743",

    ste_name: "NY",
  },
  {
    zip_code: "14753",

    ste_name: "NY",
  },
  {
    zip_code: "14813",

    ste_name: "NY",
  },
  {
    zip_code: "14816",

    ste_name: "NY",
  },
  {
    zip_code: "14836",

    ste_name: "NY",
  },
  {
    zip_code: "14850",

    ste_name: "NY",
  },
  {
    zip_code: "14856",

    ste_name: "NY",
  },
  {
    zip_code: "15135",

    ste_name: "PA",
  },
  {
    zip_code: "15435",

    ste_name: "PA",
  },
  {
    zip_code: "15444",

    ste_name: "PA",
  },
  {
    zip_code: "15458",

    ste_name: "PA",
  },
  {
    zip_code: "15463",

    ste_name: "PA",
  },
  {
    zip_code: "15484",

    ste_name: "PA",
  },
  {
    zip_code: "15538",

    ste_name: "PA",
  },
  {
    zip_code: "15633",

    ste_name: "PA",
  },
  {
    zip_code: "15658",

    ste_name: "PA",
  },
  {
    zip_code: "15671",

    ste_name: "PA",
  },
  {
    zip_code: "15679",

    ste_name: "PA",
  },
  {
    zip_code: "15681",

    ste_name: "PA",
  },
  {
    zip_code: "15727",

    ste_name: "PA",
  },
  {
    zip_code: "15774",

    ste_name: "PA",
  },
  {
    zip_code: "15832",

    ste_name: "PA",
  },
  {
    zip_code: "15961",

    ste_name: "PA",
  },
  {
    zip_code: "16507",

    ste_name: "PA",
  },
  {
    zip_code: "16510",

    ste_name: "PA",
  },
  {
    zip_code: "16830",

    ste_name: "PA",
  },
  {
    zip_code: "16879",

    ste_name: "PA",
  },
  {
    zip_code: "17030",

    ste_name: "PA",
  },
  {
    zip_code: "17111",

    ste_name: "PA",
  },
  {
    zip_code: "17235",

    ste_name: "PA",
  },
  {
    zip_code: "17238",

    ste_name: "PA",
  },
  {
    zip_code: "17317",

    ste_name: "PA",
  },
  {
    zip_code: "17366",

    ste_name: "PA",
  },
  {
    zip_code: "17737",

    ste_name: "PA",
  },
  {
    zip_code: "17762",

    ste_name: "PA",
  },
  {
    zip_code: "17846",

    ste_name: "PA",
  },
  {
    zip_code: "17866",

    ste_name: "PA",
  },
  {
    zip_code: "17952",

    ste_name: "PA",
  },
  {
    zip_code: "18063",

    ste_name: "PA",
  },
  {
    zip_code: "18064",

    ste_name: "PA",
  },
  {
    zip_code: "18350",

    ste_name: "PA",
  },
  {
    zip_code: "18419",

    ste_name: "PA",
  },
  {
    zip_code: "18455",

    ste_name: "PA",
  },
  {
    zip_code: "18930",

    ste_name: "PA",
  },
  {
    zip_code: "19050",

    ste_name: "PA",
  },
  {
    zip_code: "19123",

    ste_name: "PA",
  },
  {
    zip_code: "19355",

    ste_name: "PA",
  },
  {
    zip_code: "19401",

    ste_name: "PA",
  },
  {
    zip_code: "19508",

    ste_name: "PA",
  },
  {
    zip_code: "19518",

    ste_name: "PA",
  },
  {
    zip_code: "19734",

    ste_name: "DE",
  },
  {
    zip_code: "19807",

    ste_name: "DE",
  },
  {
    zip_code: "19963",

    ste_name: "DE",
  },
  {
    zip_code: "19967",

    ste_name: "DE",
  },
  {
    zip_code: "20105",

    ste_name: "VA",
  },
  {
    zip_code: "20106",

    ste_name: "VA",
  },
  {
    zip_code: "20317",

    ste_name: "DC",
  },
  {
    zip_code: "20506",

    ste_name: "DC",
  },
  {
    zip_code: "20520",

    ste_name: "DC",
  },
  {
    zip_code: "20640",

    ste_name: "MD",
  },
  {
    zip_code: "20705",

    ste_name: "MD",
  },
  {
    zip_code: "20712",

    ste_name: "MD",
  },
  {
    zip_code: "20732",

    ste_name: "MD",
  },
  {
    zip_code: "20782",

    ste_name: "MD",
  },
  {
    zip_code: "20794",

    ste_name: "MD",
  },
  {
    zip_code: "20866",

    ste_name: "MD",
  },
  {
    zip_code: "20871",

    ste_name: "MD",
  },
  {
    zip_code: "20886",

    ste_name: "MD",
  },
  {
    zip_code: "21105",

    ste_name: "MD",
  },
  {
    zip_code: "21153",

    ste_name: "MD",
  },
  {
    zip_code: "21211",

    ste_name: "MD",
  },
  {
    zip_code: "21612",

    ste_name: "MD",
  },
  {
    zip_code: "21623",

    ste_name: "MD",
  },
  {
    zip_code: "21661",

    ste_name: "MD",
  },
  {
    zip_code: "21665",

    ste_name: "MD",
  },
  {
    zip_code: "21666",

    ste_name: "MD",
  },
  {
    zip_code: "21782",

    ste_name: "MD",
  },
  {
    zip_code: "21817",

    ste_name: "MD",
  },
  {
    zip_code: "22027",

    ste_name: "VA",
  },
  {
    zip_code: "22031",

    ste_name: "VA",
  },
  {
    zip_code: "22150",

    ste_name: "VA",
  },
  {
    zip_code: "22191",

    ste_name: "VA",
  },
  {
    zip_code: "22306",

    ste_name: "VA",
  },
  {
    zip_code: "22448",

    ste_name: "VA",
  },
  {
    zip_code: "22650",

    ste_name: "VA",
  },
  {
    zip_code: "22714",

    ste_name: "VA",
  },
  {
    zip_code: "22727",

    ste_name: "VA",
  },
  {
    zip_code: "22969",

    ste_name: "VA",
  },
  {
    zip_code: "23068",

    ste_name: "VA",
  },
  {
    zip_code: "23389",

    ste_name: "VA",
  },
  {
    zip_code: "23834",

    ste_name: "VA",
  },
  {
    zip_code: "23857",

    ste_name: "VA",
  },
  {
    zip_code: "23934",

    ste_name: "VA",
  },
  {
    zip_code: "24132",

    ste_name: "VA",
  },
  {
    zip_code: "24137",

    ste_name: "VA",
  },
  {
    zip_code: "24139",

    ste_name: "VA",
  },
  {
    zip_code: "24149",

    ste_name: "VA",
  },
  {
    zip_code: "24239",

    ste_name: "VA",
  },
  {
    zip_code: "24318",

    ste_name: "VA",
  },
  {
    zip_code: "24412",

    ste_name: "VA",
  },
  {
    zip_code: "24422",

    ste_name: "VA",
  },
  {
    zip_code: "24635",

    ste_name: "VA",
  },
  {
    zip_code: "24888",

    ste_name: "WV",
  },
  {
    zip_code: "24916",

    ste_name: "WV",
  },
  {
    zip_code: "25021",

    ste_name: "WV",
  },
  {
    zip_code: "25048",

    ste_name: "WV",
  },
  {
    zip_code: "25076",

    ste_name: "WV",
  },
  {
    zip_code: "25124",

    ste_name: "WV",
  },
  {
    zip_code: "25149",

    ste_name: "WV",
  },
  {
    zip_code: "25253",

    ste_name: "WV",
  },
  {
    zip_code: "25314",

    ste_name: "WV",
  },
  {
    zip_code: "25547",

    ste_name: "WV",
  },
  {
    zip_code: "25570",

    ste_name: "WV",
  },
  {
    zip_code: "25617",

    ste_name: "WV",
  },
  {
    zip_code: "25624",

    ste_name: "WV",
  },
  {
    zip_code: "25813",

    ste_name: "WV",
  },
  {
    zip_code: "25873",

    ste_name: "WV",
  },
  {
    zip_code: "26075",

    ste_name: "WV",
  },
  {
    zip_code: "26152",

    ste_name: "WV",
  },
  {
    zip_code: "26224",

    ste_name: "WV",
  },
  {
    zip_code: "26327",

    ste_name: "WV",
  },
  {
    zip_code: "26443",

    ste_name: "WV",
  },
  {
    zip_code: "26534",

    ste_name: "WV",
  },
  {
    zip_code: "26719",

    ste_name: "WV",
  },
  {
    zip_code: "26812",

    ste_name: "WV",
  },
  {
    zip_code: "26855",

    ste_name: "WV",
  },
  {
    zip_code: "27041",

    ste_name: "NC",
  },
  {
    zip_code: "27233",

    ste_name: "NC",
  },
  {
    zip_code: "27263",

    ste_name: "NC",
  },
  {
    zip_code: "27305",

    ste_name: "NC",
  },
  {
    zip_code: "27312",

    ste_name: "NC",
  },
  {
    zip_code: "27314",

    ste_name: "NC",
  },
  {
    zip_code: "27370",

    ste_name: "NC",
  },
  {
    zip_code: "27379",

    ste_name: "NC",
  },
  {
    zip_code: "27408",

    ste_name: "NC",
  },
  {
    zip_code: "27504",

    ste_name: "NC",
  },
  {
    zip_code: "27516",

    ste_name: "NC",
  },
  {
    zip_code: "27524",

    ste_name: "NC",
  },
  {
    zip_code: "27709",

    ste_name: "NC",
  },
  {
    zip_code: "27809",

    ste_name: "NC",
  },
  {
    zip_code: "27837",

    ste_name: "NC",
  },
  {
    zip_code: "27842",

    ste_name: "NC",
  },
  {
    zip_code: "27860",

    ste_name: "NC",
  },
  {
    zip_code: "27870",

    ste_name: "NC",
  },
  {
    zip_code: "27876",

    ste_name: "NC",
  },
  {
    zip_code: "27879",

    ste_name: "NC",
  },
  {
    zip_code: "27893",

    ste_name: "NC",
  },
  {
    zip_code: "27982",

    ste_name: "NC",
  },
  {
    zip_code: "28039",

    ste_name: "NC",
  },
  {
    zip_code: "28152",

    ste_name: "NC",
  },
  {
    zip_code: "28204",

    ste_name: "NC",
  },
  {
    zip_code: "28366",

    ste_name: "NC",
  },
  {
    zip_code: "28377",

    ste_name: "NC",
  },
  {
    zip_code: "28386",

    ste_name: "NC",
  },
  {
    zip_code: "28411",

    ste_name: "NC",
  },
  {
    zip_code: "28449",

    ste_name: "NC",
  },
  {
    zip_code: "28455",

    ste_name: "NC",
  },
  {
    zip_code: "28469",

    ste_name: "NC",
  },
  {
    zip_code: "28510",

    ste_name: "NC",
  },
  {
    zip_code: "28562",

    ste_name: "NC",
  },
  {
    zip_code: "28652",

    ste_name: "NC",
  },
  {
    zip_code: "28673",

    ste_name: "NC",
  },
  {
    zip_code: "28676",

    ste_name: "NC",
  },
  {
    zip_code: "28723",

    ste_name: "NC",
  },
  {
    zip_code: "28741",

    ste_name: "NC",
  },
  {
    zip_code: "29046",

    ste_name: "SC",
  },
  {
    zip_code: "29048",

    ste_name: "SC",
  },
  {
    zip_code: "29101",

    ste_name: "SC",
  },
  {
    zip_code: "29117",

    ste_name: "SC",
  },
  {
    zip_code: "29206",

    ste_name: "SC",
  },
  {
    zip_code: "29341",

    ste_name: "SC",
  },
  {
    zip_code: "29368",

    ste_name: "SC",
  },
  {
    zip_code: "29461",

    ste_name: "SC",
  },
  {
    zip_code: "29506",

    ste_name: "SC",
  },
  {
    zip_code: "29567",

    ste_name: "SC",
  },
  {
    zip_code: "29613",

    ste_name: "SC",
  },
  {
    zip_code: "29658",

    ste_name: "SC",
  },
  {
    zip_code: "29691",

    ste_name: "SC",
  },
  {
    zip_code: "29709",

    ste_name: "SC",
  },
  {
    zip_code: "29902",

    ste_name: "SC",
  },
  {
    zip_code: "30045",

    ste_name: "GA",
  },
  {
    zip_code: "30064",

    ste_name: "GA",
  },
  {
    zip_code: "30126",

    ste_name: "GA",
  },
  {
    zip_code: "30175",

    ste_name: "GA",
  },
  {
    zip_code: "30286",

    ste_name: "GA",
  },
  {
    zip_code: "30425",

    ste_name: "GA",
  },
  {
    zip_code: "30428",

    ste_name: "GA",
  },
  {
    zip_code: "30450",

    ste_name: "GA",
  },
  {
    zip_code: "30545",

    ste_name: "GA",
  },
  {
    zip_code: "30565",

    ste_name: "GA",
  },
  {
    zip_code: "30572",

    ste_name: "GA",
  },
  {
    zip_code: "30573",

    ste_name: "GA",
  },
  {
    zip_code: "30577",

    ste_name: "GA",
  },
  {
    zip_code: "30622",

    ste_name: "GA",
  },
  {
    zip_code: "30628",

    ste_name: "GA",
  },
  {
    zip_code: "30663",

    ste_name: "GA",
  },
  {
    zip_code: "30814",

    ste_name: "GA",
  },
  {
    zip_code: "30824",

    ste_name: "GA",
  },
  {
    zip_code: "31014",

    ste_name: "GA",
  },
  {
    zip_code: "31032",

    ste_name: "GA",
  },
  {
    zip_code: "31069",

    ste_name: "GA",
  },
  {
    zip_code: "31211",

    ste_name: "GA",
  },
  {
    zip_code: "31314",

    ste_name: "GA",
  },
  {
    zip_code: "31401",

    ste_name: "GA",
  },
  {
    zip_code: "31625",

    ste_name: "GA",
  },
  {
    zip_code: "31636",

    ste_name: "GA",
  },
  {
    zip_code: "31712",

    ste_name: "GA",
  },
  {
    zip_code: "31747",

    ste_name: "GA",
  },
  {
    zip_code: "31814",

    ste_name: "GA",
  },
  {
    zip_code: "31820",

    ste_name: "GA",
  },
  {
    zip_code: "31827",

    ste_name: "GA",
  },
  {
    zip_code: "32052",

    ste_name: "FL",
  },
  {
    zip_code: "32084",

    ste_name: "FL",
  },
  {
    zip_code: "32169",

    ste_name: "FL",
  },
  {
    zip_code: "32320",

    ste_name: "FL",
  },
  {
    zip_code: "32328",

    ste_name: "FL",
  },
  {
    zip_code: "32401",

    ste_name: "FL",
  },
  {
    zip_code: "32526",

    ste_name: "FL",
  },
  {
    zip_code: "32806",

    ste_name: "FL",
  },
  {
    zip_code: "32810",

    ste_name: "FL",
  },
  {
    zip_code: "32822",

    ste_name: "FL",
  },
  {
    zip_code: "32920",

    ste_name: "FL",
  },
  {
    zip_code: "33050",

    ste_name: "FL",
  },
  {
    zip_code: "33054",

    ste_name: "FL",
  },
  {
    zip_code: "33056",

    ste_name: "FL",
  },
  {
    zip_code: "33132",

    ste_name: "FL",
  },
  {
    zip_code: "33141",

    ste_name: "FL",
  },
  {
    zip_code: "33161",

    ste_name: "FL",
  },
  {
    zip_code: "33165",

    ste_name: "FL",
  },
  {
    zip_code: "33440",

    ste_name: "FL",
  },
  {
    zip_code: "33521",

    ste_name: "FL",
  },
  {
    zip_code: "33558",

    ste_name: "FL",
  },
  {
    zip_code: "33579",

    ste_name: "FL",
  },
  {
    zip_code: "33706",

    ste_name: "FL",
  },
  {
    zip_code: "33781",

    ste_name: "FL",
  },
  {
    zip_code: "33841",

    ste_name: "FL",
  },
  {
    zip_code: "33865",

    ste_name: "FL",
  },
  {
    zip_code: "33928",

    ste_name: "FL",
  },
  {
    zip_code: "34104",

    ste_name: "FL",
  },
  {
    zip_code: "34108",

    ste_name: "FL",
  },
  {
    zip_code: "34117",

    ste_name: "FL",
  },
  {
    zip_code: "34201",

    ste_name: "FL",
  },
  {
    zip_code: "34233",

    ste_name: "FL",
  },
  {
    zip_code: "34287",

    ste_name: "FL",
  },
  {
    zip_code: "34291",

    ste_name: "FL",
  },
  {
    zip_code: "34453",

    ste_name: "FL",
  },
  {
    zip_code: "34461",

    ste_name: "FL",
  },
  {
    zip_code: "34491",

    ste_name: "FL",
  },
  {
    zip_code: "34601",

    ste_name: "FL",
  },
  {
    zip_code: "34652",

    ste_name: "FL",
  },
  {
    zip_code: "34981",

    ste_name: "FL",
  },
  {
    zip_code: "35019",

    ste_name: "AL",
  },
  {
    zip_code: "35063",

    ste_name: "AL",
  },
  {
    zip_code: "35072",

    ste_name: "AL",
  },
  {
    zip_code: "35080",

    ste_name: "AL",
  },
  {
    zip_code: "35098",

    ste_name: "AL",
  },
  {
    zip_code: "35180",

    ste_name: "AL",
  },
  {
    zip_code: "35223",

    ste_name: "AL",
  },
  {
    zip_code: "35233",

    ste_name: "AL",
  },
  {
    zip_code: "35444",

    ste_name: "AL",
  },
  {
    zip_code: "35574",

    ste_name: "AL",
  },
  {
    zip_code: "35620",

    ste_name: "AL",
  },
  {
    zip_code: "35978",

    ste_name: "AL",
  },
  {
    zip_code: "36024",

    ste_name: "AL",
  },
  {
    zip_code: "36033",

    ste_name: "AL",
  },
  {
    zip_code: "36104",

    ste_name: "AL",
  },
  {
    zip_code: "36116",

    ste_name: "AL",
  },
  {
    zip_code: "36258",

    ste_name: "AL",
  },
  {
    zip_code: "36269",

    ste_name: "AL",
  },
  {
    zip_code: "36350",

    ste_name: "AL",
  },
  {
    zip_code: "36476",

    ste_name: "AL",
  },
  {
    zip_code: "36526",

    ste_name: "AL",
  },
  {
    zip_code: "36527",

    ste_name: "AL",
  },
  {
    zip_code: "36530",

    ste_name: "AL",
  },
  {
    zip_code: "36574",

    ste_name: "AL",
  },
  {
    zip_code: "36871",

    ste_name: "AL",
  },
  {
    zip_code: "37023",

    ste_name: "TN",
  },
  {
    zip_code: "37027",

    ste_name: "TN",
  },
  {
    zip_code: "37082",

    ste_name: "TN",
  },
  {
    zip_code: "37083",

    ste_name: "TN",
  },
  {
    zip_code: "37361",

    ste_name: "TN",
  },
  {
    zip_code: "37664",

    ste_name: "TN",
  },
  {
    zip_code: "37801",

    ste_name: "TN",
  },
  {
    zip_code: "37810",

    ste_name: "TN",
  },
  {
    zip_code: "37881",

    ste_name: "TN",
  },
  {
    zip_code: "37916",

    ste_name: "TN",
  },
  {
    zip_code: "38036",

    ste_name: "TN",
  },
  {
    zip_code: "38240",

    ste_name: "TN",
  },
  {
    zip_code: "38450",

    ste_name: "TN",
  },
  {
    zip_code: "38486",

    ste_name: "TN",
  },
  {
    zip_code: "38603",

    ste_name: "MS",
  },
  {
    zip_code: "38641",

    ste_name: "MS",
  },
  {
    zip_code: "38749",

    ste_name: "MS",
  },
  {
    zip_code: "38868",

    ste_name: "MS",
  },
  {
    zip_code: "38873",

    ste_name: "MS",
  },
  {
    zip_code: "39074",

    ste_name: "MS",
  },
  {
    zip_code: "39115",

    ste_name: "MS",
  },
  {
    zip_code: "39451",

    ste_name: "MS",
  },
  {
    zip_code: "39470",

    ste_name: "MS",
  },
  {
    zip_code: "39483",

    ste_name: "MS",
  },
  {
    zip_code: "39530",

    ste_name: "MS",
  },
  {
    zip_code: "39654",

    ste_name: "MS",
  },
  {
    zip_code: "39767",

    ste_name: "MS",
  },
  {
    zip_code: "40231",

    ste_name: "KY",
  },
  {
    zip_code: "40258",

    ste_name: "KY",
  },
  {
    zip_code: "40601",

    ste_name: "KY",
  },
  {
    zip_code: "40847",

    ste_name: "KY",
  },
  {
    zip_code: "40972",

    ste_name: "KY",
  },
  {
    zip_code: "41003",

    ste_name: "KY",
  },
  {
    zip_code: "41018",

    ste_name: "KY",
  },
  {
    zip_code: "41044",

    ste_name: "KY",
  },
  {
    zip_code: "41074",

    ste_name: "KY",
  },
  {
    zip_code: "41144",

    ste_name: "KY",
  },
  {
    zip_code: "41149",

    ste_name: "KY",
  },
  {
    zip_code: "41175",

    ste_name: "KY",
  },
  {
    zip_code: "41262",

    ste_name: "KY",
  },
  {
    zip_code: "41572",

    ste_name: "KY",
  },
  {
    zip_code: "41729",

    ste_name: "KY",
  },
  {
    zip_code: "41766",

    ste_name: "KY",
  },
  {
    zip_code: "41821",

    ste_name: "KY",
  },
  {
    zip_code: "41838",

    ste_name: "KY",
  },
  {
    zip_code: "42022",

    ste_name: "KY",
  },
  {
    zip_code: "42025",

    ste_name: "KY",
  },
  {
    zip_code: "42066",

    ste_name: "KY",
  },
  {
    zip_code: "42234",

    ste_name: "KY",
  },
  {
    zip_code: "42361",

    ste_name: "KY",
  },
  {
    zip_code: "42541",

    ste_name: "KY",
  },
  {
    zip_code: "42544",

    ste_name: "KY",
  },
  {
    zip_code: "42718",

    ste_name: "KY",
  },
  {
    zip_code: "43011",

    ste_name: "OH",
  },
  {
    zip_code: "43015",

    ste_name: "OH",
  },
  {
    zip_code: "43017",

    ste_name: "OH",
  },
  {
    zip_code: "43035",

    ste_name: "OH",
  },
  {
    zip_code: "43060",

    ste_name: "OH",
  },
  {
    zip_code: "43154",

    ste_name: "OH",
  },
  {
    zip_code: "43162",

    ste_name: "OH",
  },
  {
    zip_code: "43326",

    ste_name: "OH",
  },
  {
    zip_code: "43340",

    ste_name: "OH",
  },
  {
    zip_code: "43440",

    ste_name: "OH",
  },
  {
    zip_code: "43524",

    ste_name: "OH",
  },
  {
    zip_code: "43554",

    ste_name: "OH",
  },
  {
    zip_code: "43720",

    ste_name: "OH",
  },
  {
    zip_code: "43749",

    ste_name: "OH",
  },
  {
    zip_code: "43805",

    ste_name: "OH",
  },
  {
    zip_code: "44044",

    ste_name: "OH",
  },
  {
    zip_code: "44055",

    ste_name: "OH",
  },
  {
    zip_code: "44067",

    ste_name: "OH",
  },
  {
    zip_code: "44084",

    ste_name: "OH",
  },
  {
    zip_code: "44123",

    ste_name: "OH",
  },
  {
    zip_code: "44313",

    ste_name: "OH",
  },
  {
    zip_code: "44404",

    ste_name: "OH",
  },
  {
    zip_code: "44627",

    ste_name: "OH",
  },
  {
    zip_code: "44710",

    ste_name: "OH",
  },
  {
    zip_code: "45011",

    ste_name: "OH",
  },
  {
    zip_code: "45015",

    ste_name: "OH",
  },
  {
    zip_code: "45054",

    ste_name: "OH",
  },
  {
    zip_code: "45113",

    ste_name: "OH",
  },
  {
    zip_code: "45115",

    ste_name: "OH",
  },
  {
    zip_code: "45152",

    ste_name: "OH",
  },
  {
    zip_code: "45206",

    ste_name: "OH",
  },
  {
    zip_code: "45328",

    ste_name: "OH",
  },
  {
    zip_code: "45365",

    ste_name: "OH",
  },
  {
    zip_code: "45406",

    ste_name: "OH",
  },
  {
    zip_code: "45431",

    ste_name: "OH",
  },
  {
    zip_code: "45623",

    ste_name: "OH",
  },
  {
    zip_code: "45688",

    ste_name: "OH",
  },
  {
    zip_code: "45724",

    ste_name: "OH",
  },
  {
    zip_code: "45807",

    ste_name: "OH",
  },
  {
    zip_code: "45826",

    ste_name: "OH",
  },
  {
    zip_code: "45835",

    ste_name: "OH",
  },
  {
    zip_code: "46051",

    ste_name: "IN",
  },
  {
    zip_code: "46140",

    ste_name: "IN",
  },
  {
    zip_code: "46240",

    ste_name: "IN",
  },
  {
    zip_code: "46321",

    ste_name: "IN",
  },
  {
    zip_code: "46407",

    ste_name: "IN",
  },
  {
    zip_code: "46508",

    ste_name: "IN",
  },
  {
    zip_code: "46552",

    ste_name: "IN",
  },
  {
    zip_code: "46556",

    ste_name: "IN",
  },
  {
    zip_code: "46616",

    ste_name: "IN",
  },
  {
    zip_code: "46845",

    ste_name: "IN",
  },
  {
    zip_code: "46962",

    ste_name: "IN",
  },
  {
    zip_code: "47025",

    ste_name: "IN",
  },
  {
    zip_code: "47038",

    ste_name: "IN",
  },
  {
    zip_code: "47231",

    ste_name: "IN",
  },
  {
    zip_code: "47264",

    ste_name: "IN",
  },
  {
    zip_code: "47304",

    ste_name: "IN",
  },
  {
    zip_code: "47305",

    ste_name: "IN",
  },
  {
    zip_code: "47356",

    ste_name: "IN",
  },
  {
    zip_code: "47361",

    ste_name: "IN",
  },
  {
    zip_code: "47574",

    ste_name: "IN",
  },
  {
    zip_code: "47578",

    ste_name: "IN",
  },
  {
    zip_code: "47581",

    ste_name: "IN",
  },
  {
    zip_code: "47840",

    ste_name: "IN",
  },
  {
    zip_code: "47863",

    ste_name: "IN",
  },
  {
    zip_code: "47941",

    ste_name: "IN",
  },
  {
    zip_code: "47951",

    ste_name: "IN",
  },
  {
    zip_code: "47959",

    ste_name: "IN",
  },
  {
    zip_code: "48080",

    ste_name: "MI",
  },
  {
    zip_code: "48085",

    ste_name: "MI",
  },
  {
    zip_code: "48088",

    ste_name: "MI",
  },
  {
    zip_code: "48104",

    ste_name: "MI",
  },
  {
    zip_code: "48126",

    ste_name: "MI",
  },
  {
    zip_code: "48166",

    ste_name: "MI",
  },
  {
    zip_code: "48236",

    ste_name: "MI",
  },
  {
    zip_code: "48336",

    ste_name: "MI",
  },
  {
    zip_code: "48626",

    ste_name: "MI",
  },
  {
    zip_code: "48640",

    ste_name: "MI",
  },
  {
    zip_code: "48708",

    ste_name: "MI",
  },
  {
    zip_code: "48831",

    ste_name: "MI",
  },
  {
    zip_code: "48846",

    ste_name: "MI",
  },
  {
    zip_code: "48860",

    ste_name: "MI",
  },
  {
    zip_code: "48866",

    ste_name: "MI",
  },
  {
    zip_code: "48885",

    ste_name: "MI",
  },
  {
    zip_code: "49009",

    ste_name: "MI",
  },
  {
    zip_code: "49040",

    ste_name: "MI",
  },
  {
    zip_code: "49251",

    ste_name: "MI",
  },
  {
    zip_code: "49289",

    ste_name: "MI",
  },
  {
    zip_code: "49307",

    ste_name: "MI",
  },
  {
    zip_code: "49321",

    ste_name: "MI",
  },
  {
    zip_code: "49437",

    ste_name: "MI",
  },
  {
    zip_code: "49450",

    ste_name: "MI",
  },
  {
    zip_code: "49660",

    ste_name: "MI",
  },
  {
    zip_code: "49668",

    ste_name: "MI",
  },
  {
    zip_code: "49690",

    ste_name: "MI",
  },
  {
    zip_code: "49701",

    ste_name: "MI",
  },
  {
    zip_code: "49705",

    ste_name: "MI",
  },
  {
    zip_code: "49749",

    ste_name: "MI",
  },
  {
    zip_code: "49782",

    ste_name: "MI",
  },
  {
    zip_code: "49806",

    ste_name: "MI",
  },
  {
    zip_code: "49831",

    ste_name: "MI",
  },
  {
    zip_code: "49871",

    ste_name: "MI",
  },
  {
    zip_code: "49967",

    ste_name: "MI",
  },
  {
    zip_code: "50022",

    ste_name: "IA",
  },
  {
    zip_code: "50038",

    ste_name: "IA",
  },
  {
    zip_code: "50058",

    ste_name: "IA",
  },
  {
    zip_code: "50109",

    ste_name: "IA",
  },
  {
    zip_code: "50135",

    ste_name: "IA",
  },
  {
    zip_code: "50151",

    ste_name: "IA",
  },
  {
    zip_code: "50166",

    ste_name: "IA",
  },
  {
    zip_code: "50208",

    ste_name: "IA",
  },
  {
    zip_code: "50255",

    ste_name: "IA",
  },
  {
    zip_code: "50424",

    ste_name: "IA",
  },
  {
    zip_code: "50434",

    ste_name: "IA",
  },
  {
    zip_code: "50484",

    ste_name: "IA",
  },
  {
    zip_code: "50548",

    ste_name: "IA",
  },
  {
    zip_code: "50595",

    ste_name: "IA",
  },
  {
    zip_code: "50616",

    ste_name: "IA",
  },
  {
    zip_code: "50655",

    ste_name: "IA",
  },
  {
    zip_code: "51001",

    ste_name: "IA",
  },
  {
    zip_code: "51056",

    ste_name: "IA",
  },
  {
    zip_code: "51058",

    ste_name: "IA",
  },
  {
    zip_code: "51346",

    ste_name: "IA",
  },
  {
    zip_code: "51520",

    ste_name: "IA",
  },
  {
    zip_code: "51521",

    ste_name: "IA",
  },
  {
    zip_code: "51532",

    ste_name: "IA",
  },
  {
    zip_code: "51554",

    ste_name: "IA",
  },
  {
    zip_code: "51557",

    ste_name: "IA",
  },
  {
    zip_code: "51562",

    ste_name: "IA",
  },
  {
    zip_code: "52050",

    ste_name: "IA",
  },
  {
    zip_code: "52211",

    ste_name: "IA",
  },
  {
    zip_code: "52217",

    ste_name: "IA",
  },
  {
    zip_code: "52312",

    ste_name: "IA",
  },
  {
    zip_code: "52320",

    ste_name: "IA",
  },
  {
    zip_code: "52326",

    ste_name: "IA",
  },
  {
    zip_code: "52339",

    ste_name: "IA",
  },
  {
    zip_code: "52501",

    ste_name: "IA",
  },
  {
    zip_code: "52595",

    ste_name: "IA",
  },
  {
    zip_code: "52635",

    ste_name: "IA",
  },
  {
    zip_code: "52768",

    ste_name: "IA",
  },
  {
    zip_code: "53003",

    ste_name: "WI",
  },
  {
    zip_code: "53010",

    ste_name: "WI",
  },
  {
    zip_code: "53024",

    ste_name: "WI",
  },
  {
    zip_code: "53065",

    ste_name: "WI",
  },
  {
    zip_code: "53066",

    ste_name: "WI",
  },
  {
    zip_code: "53083",

    ste_name: "WI",
  },
  {
    zip_code: "53153",

    ste_name: "WI",
  },
  {
    zip_code: "53156",

    ste_name: "WI",
  },
  {
    zip_code: "53503",

    ste_name: "WI",
  },
  {
    zip_code: "53510",

    ste_name: "WI",
  },
  {
    zip_code: "53548",

    ste_name: "WI",
  },
  {
    zip_code: "53559",

    ste_name: "WI",
  },
  {
    zip_code: "53562",

    ste_name: "WI",
  },
  {
    zip_code: "53570",

    ste_name: "WI",
  },
  {
    zip_code: "53932",

    ste_name: "WI",
  },
  {
    zip_code: "54016",

    ste_name: "WI",
  },
  {
    zip_code: "54151",

    ste_name: "WI",
  },
  {
    zip_code: "54154",

    ste_name: "WI",
  },
  {
    zip_code: "54214",

    ste_name: "WI",
  },
  {
    zip_code: "54426",

    ste_name: "WI",
  },
  {
    zip_code: "54896",

    ste_name: "WI",
  },
  {
    zip_code: "54941",

    ste_name: "WI",
  },
  {
    zip_code: "55008",

    ste_name: "MN",
  },
  {
    zip_code: "55051",

    ste_name: "MN",
  },
  {
    zip_code: "55306",

    ste_name: "MN",
  },
  {
    zip_code: "55315",

    ste_name: "MN",
  },
  {
    zip_code: "55317",

    ste_name: "MN",
  },
  {
    zip_code: "55340",

    ste_name: "MN",
  },
  {
    zip_code: "55355",

    ste_name: "MN",
  },
  {
    zip_code: "55373",

    ste_name: "MN",
  },
  {
    zip_code: "55428",

    ste_name: "MN",
  },
  {
    zip_code: "55718",

    ste_name: "MN",
  },
  {
    zip_code: "55803",

    ste_name: "MN",
  },
  {
    zip_code: "55941",

    ste_name: "MN",
  },
  {
    zip_code: "55955",

    ste_name: "MN",
  },
  {
    zip_code: "55990",

    ste_name: "MN",
  },
  {
    zip_code: "56019",

    ste_name: "MN",
  },
  {
    zip_code: "56026",

    ste_name: "MN",
  },
  {
    zip_code: "56043",

    ste_name: "MN",
  },
  {
    zip_code: "56065",

    ste_name: "MN",
  },
  {
    zip_code: "56117",

    ste_name: "MN",
  },
  {
    zip_code: "56121",

    ste_name: "MN",
  },
  {
    zip_code: "56161",

    ste_name: "MN",
  },
  {
    zip_code: "56175",

    ste_name: "MN",
  },
  {
    zip_code: "56219",

    ste_name: "MN",
  },
  {
    zip_code: "56251",

    ste_name: "MN",
  },
  {
    zip_code: "56265",

    ste_name: "MN",
  },
  {
    zip_code: "56339",

    ste_name: "MN",
  },
  {
    zip_code: "56484",

    ste_name: "MN",
  },
  {
    zip_code: "56579",

    ste_name: "MN",
  },
  {
    zip_code: "56657",

    ste_name: "MN",
  },
  {
    zip_code: "56661",

    ste_name: "MN",
  },
  {
    zip_code: "56724",

    ste_name: "MN",
  },
  {
    zip_code: "56736",

    ste_name: "MN",
  },
  {
    zip_code: "57034",

    ste_name: "SD",
  },
  {
    zip_code: "57037",

    ste_name: "SD",
  },
  {
    zip_code: "57238",

    ste_name: "SD",
  },
  {
    zip_code: "57243",

    ste_name: "SD",
  },
  {
    zip_code: "57341",

    ste_name: "SD",
  },
  {
    zip_code: "57348",

    ste_name: "SD",
  },
  {
    zip_code: "57368",

    ste_name: "SD",
  },
  {
    zip_code: "57427",

    ste_name: "SD",
  },
  {
    zip_code: "57449",

    ste_name: "SD",
  },
  {
    zip_code: "57452",

    ste_name: "SD",
  },
  {
    zip_code: "57471",

    ste_name: "SD",
  },
  {
    zip_code: "57538",

    ste_name: "SD",
  },
  {
    zip_code: "57543",

    ste_name: "SD",
  },
  {
    zip_code: "57544",

    ste_name: "SD",
  },
  {
    zip_code: "57776",

    ste_name: "SD",
  },
  {
    zip_code: "57779",

    ste_name: "SD",
  },
  {
    zip_code: "57787",

    ste_name: "SD",
  },
  {
    zip_code: "58001",

    ste_name: "ND",
  },
  {
    zip_code: "58054",

    ste_name: "ND",
  },
  {
    zip_code: "58220",

    ste_name: "ND",
  },
  {
    zip_code: "58272",

    ste_name: "ND",
  },
  {
    zip_code: "58276",

    ste_name: "ND",
  },
  {
    zip_code: "58466",

    ste_name: "ND",
  },
  {
    zip_code: "58480",

    ste_name: "ND",
  },
  {
    zip_code: "58552",

    ste_name: "ND",
  },
  {
    zip_code: "58575",

    ste_name: "ND",
  },
  {
    zip_code: "58735",

    ste_name: "ND",
  },
  {
    zip_code: "59013",

    ste_name: "MT",
  },
  {
    zip_code: "59037",

    ste_name: "MT",
  },
  {
    zip_code: "59039",

    ste_name: "MT",
  },
  {
    zip_code: "59057",

    ste_name: "MT",
  },
  {
    zip_code: "59062",

    ste_name: "MT",
  },
  {
    zip_code: "59263",

    ste_name: "MT",
  },
  {
    zip_code: "59354",

    ste_name: "MT",
  },
  {
    zip_code: "59457",

    ste_name: "MT",
  },
  {
    zip_code: "59467",

    ste_name: "MT",
  },
  {
    zip_code: "59647",

    ste_name: "MT",
  },
  {
    zip_code: "59711",

    ste_name: "MT",
  },
  {
    zip_code: "59727",

    ste_name: "MT",
  },
  {
    zip_code: "59731",

    ste_name: "MT",
  },
  {
    zip_code: "59873",

    ste_name: "MT",
  },
  {
    zip_code: "59926",

    ste_name: "MT",
  },
  {
    zip_code: "59930",

    ste_name: "MT",
  },
  {
    zip_code: "60074",

    ste_name: "IL",
  },
  {
    zip_code: "60076",

    ste_name: "IL",
  },
  {
    zip_code: "60134",

    ste_name: "IL",
  },
  {
    zip_code: "60140",

    ste_name: "IL",
  },
  {
    zip_code: "60441",

    ste_name: "IL",
  },
  {
    zip_code: "60450",

    ste_name: "IL",
  },
  {
    zip_code: "60523",

    ste_name: "IL",
  },
  {
    zip_code: "60538",

    ste_name: "IL",
  },
  {
    zip_code: "60549",

    ste_name: "IL",
  },
  {
    zip_code: "60930",

    ste_name: "IL",
  },
  {
    zip_code: "61043",

    ste_name: "IL",
  },
  {
    zip_code: "61067",

    ste_name: "IL",
  },
  {
    zip_code: "61103",

    ste_name: "IL",
  },
  {
    zip_code: "61254",

    ste_name: "IL",
  },
  {
    zip_code: "61272",

    ste_name: "IL",
  },
  {
    zip_code: "61276",

    ste_name: "IL",
  },
  {
    zip_code: "61323",

    ste_name: "IL",
  },
  {
    zip_code: "61331",

    ste_name: "IL",
  },
  {
    zip_code: "61354",

    ste_name: "IL",
  },
  {
    zip_code: "61373",

    ste_name: "IL",
  },
  {
    zip_code: "61439",

    ste_name: "IL",
  },
  {
    zip_code: "61562",

    ste_name: "IL",
  },
  {
    zip_code: "61568",

    ste_name: "IL",
  },
  {
    zip_code: "61614",

    ste_name: "IL",
  },
  {
    zip_code: "61760",

    ste_name: "IL",
  },
  {
    zip_code: "61813",

    ste_name: "IL",
  },
  {
    zip_code: "61815",

    ste_name: "IL",
  },
  {
    zip_code: "61820",

    ste_name: "IL",
  },
  {
    zip_code: "61854",

    ste_name: "IL",
  },
  {
    zip_code: "61955",

    ste_name: "IL",
  },
  {
    zip_code: "62001",

    ste_name: "IL",
  },
  {
    zip_code: "62019",

    ste_name: "IL",
  },
  {
    zip_code: "62265",

    ste_name: "IL",
  },
  {
    zip_code: "62286",

    ste_name: "IL",
  },
  {
    zip_code: "62289",

    ste_name: "IL",
  },
  {
    zip_code: "62324",

    ste_name: "IL",
  },
  {
    zip_code: "62351",

    ste_name: "IL",
  },
  {
    zip_code: "62354",

    ste_name: "IL",
  },
  {
    zip_code: "62366",

    ste_name: "IL",
  },
  {
    zip_code: "62442",

    ste_name: "IL",
  },
  {
    zip_code: "62447",

    ste_name: "IL",
  },
  {
    zip_code: "62466",

    ste_name: "IL",
  },
  {
    zip_code: "62477",

    ste_name: "IL",
  },
  {
    zip_code: "62681",

    ste_name: "IL",
  },
  {
    zip_code: "62684",

    ste_name: "IL",
  },
  {
    zip_code: "62821",

    ste_name: "IL",
  },
  {
    zip_code: "62893",

    ste_name: "IL",
  },
  {
    zip_code: "62910",

    ste_name: "IL",
  },
  {
    zip_code: "62921",

    ste_name: "IL",
  },
  {
    zip_code: "62932",

    ste_name: "IL",
  },
  {
    zip_code: "62948",

    ste_name: "IL",
  },
  {
    zip_code: "63010",

    ste_name: "MO",
  },
  {
    zip_code: "63023",

    ste_name: "MO",
  },
  {
    zip_code: "63043",

    ste_name: "MO",
  },
  {
    zip_code: "63044",

    ste_name: "MO",
  },
  {
    zip_code: "63107",

    ste_name: "MO",
  },
  {
    zip_code: "63131",

    ste_name: "MO",
  },
  {
    zip_code: "63140",

    ste_name: "MO",
  },
  {
    zip_code: "63304",

    ste_name: "MO",
  },
  {
    zip_code: "63345",

    ste_name: "MO",
  },
  {
    zip_code: "63381",

    ste_name: "MO",
  },
  {
    zip_code: "63445",

    ste_name: "MO",
  },
  {
    zip_code: "63601",

    ste_name: "MO",
  },
  {
    zip_code: "63663",

    ste_name: "MO",
  },
  {
    zip_code: "63852",

    ste_name: "MO",
  },
  {
    zip_code: "63967",

    ste_name: "MO",
  },
  {
    zip_code: "64034",

    ste_name: "MO",
  },
  {
    zip_code: "64035",

    ste_name: "MO",
  },
  {
    zip_code: "64062",

    ste_name: "MO",
  },
  {
    zip_code: "64068",

    ste_name: "MO",
  },
  {
    zip_code: "64088",

    ste_name: "MO",
  },
  {
    zip_code: "64421",

    ste_name: "MO",
  },
  {
    zip_code: "64451",

    ste_name: "MO",
  },
  {
    zip_code: "64453",

    ste_name: "MO",
  },
  {
    zip_code: "64463",

    ste_name: "MO",
  },
  {
    zip_code: "64628",

    ste_name: "MO",
  },
  {
    zip_code: "64679",

    ste_name: "MO",
  },
  {
    zip_code: "64849",

    ste_name: "MO",
  },
  {
    zip_code: "65018",

    ste_name: "MO",
  },
  {
    zip_code: "65059",

    ste_name: "MO",
  },
  {
    zip_code: "65320",

    ste_name: "MO",
  },
  {
    zip_code: "65327",

    ste_name: "MO",
  },
  {
    zip_code: "65436",

    ste_name: "MO",
  },
  {
    zip_code: "65580",

    ste_name: "MO",
  },
  {
    zip_code: "65603",

    ste_name: "MO",
  },
  {
    zip_code: "65618",

    ste_name: "MO",
  },
  {
    zip_code: "65679",

    ste_name: "MO",
  },
  {
    zip_code: "65702",

    ste_name: "MO",
  },
  {
    zip_code: "65731",

    ste_name: "MO",
  },
  {
    zip_code: "66020",

    ste_name: "KS",
  },
  {
    zip_code: "66095",

    ste_name: "KS",
  },
  {
    zip_code: "66118",

    ste_name: "KS",
  },
  {
    zip_code: "66402",

    ste_name: "KS",
  },
  {
    zip_code: "66449",

    ste_name: "KS",
  },
  {
    zip_code: "66508",

    ste_name: "KS",
  },
  {
    zip_code: "66610",

    ste_name: "KS",
  },
  {
    zip_code: "66758",

    ste_name: "KS",
  },
  {
    zip_code: "66770",

    ste_name: "KS",
  },
  {
    zip_code: "66851",

    ste_name: "KS",
  },
  {
    zip_code: "67004",

    ste_name: "KS",
  },
  {
    zip_code: "67024",

    ste_name: "KS",
  },
  {
    zip_code: "67065",

    ste_name: "KS",
  },
  {
    zip_code: "67073",

    ste_name: "KS",
  },
  {
    zip_code: "67127",

    ste_name: "KS",
  },
  {
    zip_code: "67155",

    ste_name: "KS",
  },
  {
    zip_code: "67232",

    ste_name: "KS",
  },
  {
    zip_code: "67334",

    ste_name: "KS",
  },
  {
    zip_code: "67345",

    ste_name: "KS",
  },
  {
    zip_code: "67357",

    ste_name: "KS",
  },
  {
    zip_code: "67480",

    ste_name: "KS",
  },
  {
    zip_code: "67673",

    ste_name: "KS",
  },
  {
    zip_code: "67734",

    ste_name: "KS",
  },
  {
    zip_code: "67850",

    ste_name: "KS",
  },
  {
    zip_code: "67879",

    ste_name: "KS",
  },
  {
    zip_code: "68020",

    ste_name: "NE",
  },
  {
    zip_code: "68046",

    ste_name: "NE",
  },
  {
    zip_code: "68371",

    ste_name: "NE",
  },
  {
    zip_code: "68462",

    ste_name: "NE",
  },
  {
    zip_code: "68464",

    ste_name: "NE",
  },
  {
    zip_code: "68528",

    ste_name: "NE",
  },
  {
    zip_code: "68663",

    ste_name: "NE",
  },
  {
    zip_code: "68758",

    ste_name: "NE",
  },
  {
    zip_code: "68790",

    ste_name: "NE",
  },
  {
    zip_code: "68791",

    ste_name: "NE",
  },
  {
    zip_code: "68803",

    ste_name: "NE",
  },
  {
    zip_code: "68834",

    ste_name: "NE",
  },
  {
    zip_code: "68879",

    ste_name: "NE",
  },
  {
    zip_code: "68932",

    ste_name: "NE",
  },
  {
    zip_code: "68964",

    ste_name: "NE",
  },
  {
    zip_code: "68972",

    ste_name: "NE",
  },
  {
    zip_code: "69025",

    ste_name: "NE",
  },
  {
    zip_code: "70051",

    ste_name: "LA",
  },
  {
    zip_code: "70068",

    ste_name: "LA",
  },
  {
    zip_code: "70083",

    ste_name: "LA",
  },
  {
    zip_code: "70114",

    ste_name: "LA",
  },
  {
    zip_code: "70121",

    ste_name: "LA",
  },
  {
    zip_code: "70452",

    ste_name: "LA",
  },
  {
    zip_code: "70456",

    ste_name: "LA",
  },
  {
    zip_code: "70463",

    ste_name: "LA",
  },
  {
    zip_code: "70506",

    ste_name: "LA",
  },
  {
    zip_code: "70513",

    ste_name: "LA",
  },
  {
    zip_code: "70516",

    ste_name: "LA",
  },
  {
    zip_code: "70734",

    ste_name: "LA",
  },
  {
    zip_code: "70791",

    ste_name: "LA",
  },
  {
    zip_code: "70807",

    ste_name: "LA",
  },
  {
    zip_code: "71072",

    ste_name: "LA",
  },
  {
    zip_code: "71078",

    ste_name: "LA",
  },
  {
    zip_code: "71250",

    ste_name: "LA",
  },
  {
    zip_code: "71302",

    ste_name: "LA",
  },
  {
    zip_code: "71423",

    ste_name: "LA",
  },
  {
    zip_code: "71449",

    ste_name: "LA",
  },
  {
    zip_code: "71479",

    ste_name: "LA",
  },
  {
    zip_code: "71638",

    ste_name: "AR",
  },
  {
    zip_code: "71958",

    ste_name: "AR",
  },
  {
    zip_code: "71969",

    ste_name: "AR",
  },
  {
    zip_code: "72025",

    ste_name: "AR",
  },
  {
    zip_code: "72099",

    ste_name: "AR",
  },
  {
    zip_code: "72149",

    ste_name: "AR",
  },
  {
    zip_code: "72326",

    ste_name: "AR",
  },
  {
    zip_code: "72355",

    ste_name: "AR",
  },
  {
    zip_code: "72372",

    ste_name: "AR",
  },
  {
    zip_code: "72421",

    ste_name: "AR",
  },
  {
    zip_code: "72430",

    ste_name: "AR",
  },
  {
    zip_code: "72458",

    ste_name: "AR",
  },
  {
    zip_code: "72476",

    ste_name: "AR",
  },
  {
    zip_code: "72555",

    ste_name: "AR",
  },
  {
    zip_code: "72561",

    ste_name: "AR",
  },
  {
    zip_code: "72566",

    ste_name: "AR",
  },
  {
    zip_code: "72828",

    ste_name: "AR",
  },
  {
    zip_code: "72955",

    ste_name: "AR",
  },
  {
    zip_code: "72959",

    ste_name: "AR",
  },
  {
    zip_code: "73017",

    ste_name: "OK",
  },
  {
    zip_code: "73049",

    ste_name: "OK",
  },
  {
    zip_code: "73139",

    ste_name: "OK",
  },
  {
    zip_code: "73142",

    ste_name: "OK",
  },
  {
    zip_code: "73151",

    ste_name: "OK",
  },
  {
    zip_code: "73460",

    ste_name: "OK",
  },
  {
    zip_code: "73520",

    ste_name: "OK",
  },
  {
    zip_code: "73529",

    ste_name: "OK",
  },
  {
    zip_code: "73573",

    ste_name: "OK",
  },
  {
    zip_code: "73625",

    ste_name: "OK",
  },
  {
    zip_code: "73728",

    ste_name: "OK",
  },
  {
    zip_code: "73754",

    ste_name: "OK",
  },
  {
    zip_code: "73773",

    ste_name: "OK",
  },
  {
    zip_code: "73838",

    ste_name: "OK",
  },
  {
    zip_code: "73853",

    ste_name: "OK",
  },
  {
    zip_code: "73942",

    ste_name: "OK",
  },
  {
    zip_code: "74006",

    ste_name: "OK",
  },
  {
    zip_code: "74042",

    ste_name: "OK",
  },
  {
    zip_code: "74370",

    ste_name: "OK",
  },
  {
    zip_code: "74403",

    ste_name: "OK",
  },
  {
    zip_code: "74447",

    ste_name: "OK",
  },
  {
    zip_code: "74450",

    ste_name: "OK",
  },
  {
    zip_code: "74459",

    ste_name: "OK",
  },
  {
    zip_code: "74552",

    ste_name: "OK",
  },
  {
    zip_code: "74650",

    ste_name: "OK",
  },
  {
    zip_code: "74720",

    ste_name: "OK",
  },
  {
    zip_code: "74722",

    ste_name: "OK",
  },
  {
    zip_code: "74745",

    ste_name: "OK",
  },
  {
    zip_code: "74836",

    ste_name: "OK",
  },
  {
    zip_code: "74842",

    ste_name: "OK",
  },
  {
    zip_code: "74867",

    ste_name: "OK",
  },
  {
    zip_code: "75051",

    ste_name: "TX",
  },
  {
    zip_code: "75056",

    ste_name: "TX",
  },
  {
    zip_code: "75088",

    ste_name: "TX",
  },
  {
    zip_code: "75105",

    ste_name: "TX",
  },
  {
    zip_code: "75166",

    ste_name: "TX",
  },
  {
    zip_code: "75224",

    ste_name: "TX",
  },
  {
    zip_code: "75426",

    ste_name: "TX",
  },
  {
    zip_code: "75501",

    ste_name: "TX",
  },
  {
    zip_code: "75568",

    ste_name: "TX",
  },
  {
    zip_code: "75645",

    ste_name: "TX",
  },
  {
    zip_code: "75657",

    ste_name: "TX",
  },
  {
    zip_code: "75801",

    ste_name: "TX",
  },
  {
    zip_code: "75847",

    ste_name: "TX",
  },
  {
    zip_code: "76033",

    ste_name: "TX",
  },
  {
    zip_code: "76078",

    ste_name: "TX",
  },
  {
    zip_code: "76131",

    ste_name: "TX",
  },
  {
    zip_code: "76225",

    ste_name: "TX",
  },
  {
    zip_code: "76240",

    ste_name: "TX",
  },
  {
    zip_code: "76244",

    ste_name: "TX",
  },
  {
    zip_code: "76302",

    ste_name: "TX",
  },
  {
    zip_code: "76367",

    ste_name: "TX",
  },
  {
    zip_code: "76371",

    ste_name: "TX",
  },
  {
    zip_code: "76426",

    ste_name: "TX",
  },
  {
    zip_code: "76427",

    ste_name: "TX",
  },
  {
    zip_code: "76429",

    ste_name: "TX",
  },
  {
    zip_code: "76504",

    ste_name: "TX",
  },
  {
    zip_code: "76534",

    ste_name: "TX",
  },
  {
    zip_code: "76548",

    ste_name: "TX",
  },
  {
    zip_code: "76570",

    ste_name: "TX",
  },
  {
    zip_code: "76599",

    ste_name: "TX",
  },
  {
    zip_code: "76642",

    ste_name: "TX",
  },
  {
    zip_code: "76660",

    ste_name: "TX",
  },
  {
    zip_code: "76670",

    ste_name: "TX",
  },
  {
    zip_code: "76693",

    ste_name: "TX",
  },
  {
    zip_code: "76704",

    ste_name: "TX",
  },
  {
    zip_code: "76707",

    ste_name: "TX",
  },
  {
    zip_code: "76832",

    ste_name: "TX",
  },
  {
    zip_code: "77009",

    ste_name: "TX",
  },
  {
    zip_code: "77021",

    ste_name: "TX",
  },
  {
    zip_code: "77026",

    ste_name: "TX",
  },
  {
    zip_code: "77048",

    ste_name: "TX",
  },
  {
    zip_code: "77080",

    ste_name: "TX",
  },
  {
    zip_code: "77084",

    ste_name: "TX",
  },
  {
    zip_code: "77091",

    ste_name: "TX",
  },
  {
    zip_code: "77201",

    ste_name: "TX",
  },
  {
    zip_code: "77357",

    ste_name: "TX",
  },
  {
    zip_code: "77389",

    ste_name: "TX",
  },
  {
    zip_code: "77407",

    ste_name: "TX",
  },
  {
    zip_code: "77461",

    ste_name: "TX",
  },
  {
    zip_code: "77571",

    ste_name: "TX",
  },
  {
    zip_code: "77807",

    ste_name: "TX",
  },
  {
    zip_code: "77835",

    ste_name: "TX",
  },
  {
    zip_code: "77855",

    ste_name: "TX",
  },
  {
    zip_code: "77868",

    ste_name: "TX",
  },
  {
    zip_code: "77873",

    ste_name: "TX",
  },
  {
    zip_code: "78005",

    ste_name: "TX",
  },
  {
    zip_code: "78056",

    ste_name: "TX",
  },
  {
    zip_code: "78065",

    ste_name: "TX",
  },
  {
    zip_code: "78119",

    ste_name: "TX",
  },
  {
    zip_code: "78125",

    ste_name: "TX",
  },
  {
    zip_code: "78145",

    ste_name: "TX",
  },
  {
    zip_code: "78160",

    ste_name: "TX",
  },
  {
    zip_code: "78250",

    ste_name: "TX",
  },
  {
    zip_code: "78382",

    ste_name: "TX",
  },
  {
    zip_code: "78402",

    ste_name: "TX",
  },
  {
    zip_code: "78405",

    ste_name: "TX",
  },
  {
    zip_code: "78537",

    ste_name: "TX",
  },
  {
    zip_code: "78675",

    ste_name: "TX",
  },
  {
    zip_code: "78701",

    ste_name: "TX",
  },
  {
    zip_code: "78725",

    ste_name: "TX",
  },
  {
    zip_code: "78757",

    ste_name: "TX",
  },
  {
    zip_code: "78880",

    ste_name: "TX",
  },
  {
    zip_code: "78945",

    ste_name: "TX",
  },
  {
    zip_code: "78963",

    ste_name: "TX",
  },
  {
    zip_code: "79039",

    ste_name: "TX",
  },
  {
    zip_code: "79044",

    ste_name: "TX",
  },
  {
    zip_code: "79053",

    ste_name: "TX",
  },
  {
    zip_code: "79078",

    ste_name: "TX",
  },
  {
    zip_code: "79092",

    ste_name: "TX",
  },
  {
    zip_code: "79235",

    ste_name: "TX",
  },
  {
    zip_code: "79345",

    ste_name: "TX",
  },
  {
    zip_code: "79364",

    ste_name: "TX",
  },
  {
    zip_code: "79744",

    ste_name: "TX",
  },
  {
    zip_code: "79789",

    ste_name: "TX",
  },
  {
    zip_code: "79834",

    ste_name: "TX",
  },
  {
    zip_code: "80203",

    ste_name: "CO",
  },
  {
    zip_code: "80224",

    ste_name: "CO",
  },
  {
    zip_code: "80467",

    ste_name: "CO",
  },
  {
    zip_code: "80469",

    ste_name: "CO",
  },
  {
    zip_code: "80542",

    ste_name: "CO",
  },
  {
    zip_code: "80735",

    ste_name: "CO",
  },
  {
    zip_code: "80807",

    ste_name: "CO",
  },
  {
    zip_code: "80824",

    ste_name: "CO",
  },
  {
    zip_code: "81059",

    ste_name: "CO",
  },
  {
    zip_code: "81084",

    ste_name: "CO",
  },
  {
    zip_code: "81125",

    ste_name: "CO",
  },
  {
    zip_code: "81252",

    ste_name: "CO",
  },
  {
    zip_code: "81320",

    ste_name: "CO",
  },
  {
    zip_code: "81321",

    ste_name: "CO",
  },
  {
    zip_code: "81429",

    ste_name: "CO",
  },
  {
    zip_code: "81522",

    ste_name: "CO",
  },
  {
    zip_code: "81630",

    ste_name: "CO",
  },
  {
    zip_code: "82643",

    ste_name: "WY",
  },
  {
    zip_code: "82729",

    ste_name: "WY",
  },
  {
    zip_code: "82801",

    ste_name: "WY",
  },
  {
    zip_code: "83115",

    ste_name: "WY",
  },
  {
    zip_code: "83204",

    ste_name: "ID",
  },
  {
    zip_code: "83237",

    ste_name: "ID",
  },
  {
    zip_code: "83254",

    ste_name: "ID",
  },
  {
    zip_code: "83336",

    ste_name: "ID",
  },
  {
    zip_code: "83340",

    ste_name: "ID",
  },
  {
    zip_code: "83401",

    ste_name: "ID",
  },
  {
    zip_code: "83539",

    ste_name: "ID",
  },
  {
    zip_code: "83671",

    ste_name: "ID",
  },
  {
    zip_code: "83676",

    ste_name: "ID",
  },
  {
    zip_code: "84006",

    ste_name: "UT",
  },
  {
    zip_code: "84031",

    ste_name: "UT",
  },
  {
    zip_code: "84052",

    ste_name: "UT",
  },
  {
    zip_code: "84084",

    ste_name: "UT",
  },
  {
    zip_code: "84317",

    ste_name: "UT",
  },
  {
    zip_code: "84531",

    ste_name: "UT",
  },
  {
    zip_code: "84622",

    ste_name: "UT",
  },
  {
    zip_code: "84721",

    ste_name: "UT",
  },
  {
    zip_code: "84728",

    ste_name: "UT",
  },
  {
    zip_code: "84737",

    ste_name: "UT",
  },
  {
    zip_code: "84770",

    ste_name: "UT",
  },
  {
    zip_code: "85225",

    ste_name: "AZ",
  },
  {
    zip_code: "85263",

    ste_name: "AZ",
  },
  {
    zip_code: "85343",

    ste_name: "AZ",
  },
  {
    zip_code: "85534",

    ste_name: "AZ",
  },
  {
    zip_code: "85536",

    ste_name: "AZ",
  },
  {
    zip_code: "85554",

    ste_name: "AZ",
  },
  {
    zip_code: "85614",

    ste_name: "AZ",
  },
  {
    zip_code: "85705",

    ste_name: "AZ",
  },
  {
    zip_code: "85710",

    ste_name: "AZ",
  },
  {
    zip_code: "85718",

    ste_name: "AZ",
  },
  {
    zip_code: "86030",

    ste_name: "AZ",
  },
  {
    zip_code: "86440",

    ste_name: "AZ",
  },
  {
    zip_code: "87049",

    ste_name: "NM",
  },
  {
    zip_code: "87068",

    ste_name: "NM",
  },
  {
    zip_code: "87111",

    ste_name: "NM",
  },
  {
    zip_code: "87144",

    ste_name: "NM",
  },
  {
    zip_code: "87317",

    ste_name: "NM",
  },
  {
    zip_code: "87401",

    ste_name: "NM",
  },
  {
    zip_code: "87499",

    ste_name: "NM",
  },
  {
    zip_code: "87507",

    ste_name: "NM",
  },
  {
    zip_code: "87551",

    ste_name: "NM",
  },
  {
    zip_code: "87752",

    ste_name: "NM",
  },
  {
    zip_code: "87828",

    ste_name: "NM",
  },
  {
    zip_code: "88001",

    ste_name: "NM",
  },
  {
    zip_code: "88023",

    ste_name: "NM",
  },
  {
    zip_code: "88072",

    ste_name: "NM",
  },
  {
    zip_code: "88114",

    ste_name: "NM",
  },
  {
    zip_code: "88317",

    ste_name: "NM",
  },
  {
    zip_code: "88343",

    ste_name: "NM",
  },
  {
    zip_code: "88416",

    ste_name: "NM",
  },
  {
    zip_code: "89030",

    ste_name: "NV",
  },
  {
    zip_code: "89039",

    ste_name: "NV",
  },
  {
    zip_code: "89074",

    ste_name: "NV",
  },
  {
    zip_code: "89146",

    ste_name: "NV",
  },
  {
    zip_code: "89428",

    ste_name: "NV",
  },
  {
    zip_code: "89815",

    ste_name: "NV",
  },
  {
    zip_code: "907",

    ste_name: "PR",
  },
  {
    zip_code: "921",

    ste_name: "PR",
  },
  {
    zip_code: "1012",

    ste_name: "MA",
  },
  {
    zip_code: "1030",

    ste_name: "MA",
  },
  {
    zip_code: "1080",

    ste_name: "MA",
  },
  {
    zip_code: "1330",

    ste_name: "MA",
  },
  {
    zip_code: "1507",

    ste_name: "MA",
  },
  {
    zip_code: "1570",

    ste_name: "MA",
  },
  {
    zip_code: "1754",

    ste_name: "MA",
  },
  {
    zip_code: "1826",

    ste_name: "MA",
  },
  {
    zip_code: "1923",

    ste_name: "MA",
  },
  {
    zip_code: "1984",

    ste_name: "MA",
  },
  {
    zip_code: "2019",

    ste_name: "MA",
  },
  {
    zip_code: "2061",

    ste_name: "MA",
  },
  {
    zip_code: "2062",

    ste_name: "MA",
  },
  {
    zip_code: "2139",

    ste_name: "MA",
  },
  {
    zip_code: "2332",

    ste_name: "MA",
  },
  {
    zip_code: "2420",

    ste_name: "MA",
  },
  {
    zip_code: "2535",

    ste_name: "MA",
  },
  {
    zip_code: "2537",

    ste_name: "MA",
  },
  {
    zip_code: "2652",

    ste_name: "MA",
  },
  {
    zip_code: "2660",

    ste_name: "MA",
  },
  {
    zip_code: "2724",

    ste_name: "MA",
  },
  {
    zip_code: "2738",

    ste_name: "MA",
  },
  {
    zip_code: "2739",

    ste_name: "MA",
  },
  {
    zip_code: "2766",

    ste_name: "MA",
  },
  {
    zip_code: "2832",

    ste_name: "RI",
  },
  {
    zip_code: "3251",

    ste_name: "NH",
  },
  {
    zip_code: "3462",

    ste_name: "NH",
  },
  {
    zip_code: "3466",

    ste_name: "NH",
  },
  {
    zip_code: "3777",

    ste_name: "NH",
  },
  {
    zip_code: "3854",

    ste_name: "NH",
  },
  {
    zip_code: "3864",

    ste_name: "NH",
  },
  {
    zip_code: "3872",

    ste_name: "NH",
  },
  {
    zip_code: "3909",

    ste_name: "ME",
  },
  {
    zip_code: "4041",

    ste_name: "ME",
  },
  {
    zip_code: "4049",

    ste_name: "ME",
  },
  {
    zip_code: "4287",

    ste_name: "ME",
  },
  {
    zip_code: "4351",

    ste_name: "ME",
  },
  {
    zip_code: "4406",

    ste_name: "ME",
  },
  {
    zip_code: "4434",

    ste_name: "ME",
  },
  {
    zip_code: "4462",

    ste_name: "ME",
  },
  {
    zip_code: "4487",

    ste_name: "ME",
  },
  {
    zip_code: "4554",

    ste_name: "ME",
  },
  {
    zip_code: "4606",

    ste_name: "ME",
  },
  {
    zip_code: "4657",

    ste_name: "ME",
  },
  {
    zip_code: "4680",

    ste_name: "ME",
  },
  {
    zip_code: "4739",

    ste_name: "ME",
  },
  {
    zip_code: "4843",

    ste_name: "ME",
  },
  {
    zip_code: "4927",

    ste_name: "ME",
  },
  {
    zip_code: "4956",

    ste_name: "ME",
  },
  {
    zip_code: "4965",

    ste_name: "ME",
  },
  {
    zip_code: "4981",

    ste_name: "ME",
  },
  {
    zip_code: "5042",

    ste_name: "VT",
  },
  {
    zip_code: "5301",

    ste_name: "VT",
  },
  {
    zip_code: "5443",

    ste_name: "VT",
  },
  {
    zip_code: "5472",

    ste_name: "VT",
  },
  {
    zip_code: "5664",

    ste_name: "VT",
  },
  {
    zip_code: "5851",

    ste_name: "VT",
  },
  {
    zip_code: "6067",

    ste_name: "CT",
  },
  {
    zip_code: "6111",

    ste_name: "CT",
  },
  {
    zip_code: "6387",

    ste_name: "CT",
  },
  {
    zip_code: "6422",

    ste_name: "CT",
  },
  {
    zip_code: "6468",

    ste_name: "CT",
  },
  {
    zip_code: "6787",

    ste_name: "CT",
  },
  {
    zip_code: "6855",

    ste_name: "CT",
  },
  {
    zip_code: "7010",

    ste_name: "NJ",
  },
  {
    zip_code: "7042",

    ste_name: "NJ",
  },
  {
    zip_code: "7074",

    ste_name: "NJ",
  },
  {
    zip_code: "7081",

    ste_name: "NJ",
  },
  {
    zip_code: "7503",

    ste_name: "NJ",
  },
  {
    zip_code: "7620",

    ste_name: "NJ",
  },
  {
    zip_code: "7739",

    ste_name: "NJ",
  },
  {
    zip_code: "7803",

    ste_name: "NJ",
  },
  {
    zip_code: "7927",

    ste_name: "NJ",
  },
  {
    zip_code: "7960",

    ste_name: "NJ",
  },
  {
    zip_code: "8002",

    ste_name: "NJ",
  },
  {
    zip_code: "8246",

    ste_name: "NJ",
  },
  {
    zip_code: "8525",

    ste_name: "NJ",
  },
  {
    zip_code: "8562",

    ste_name: "NJ",
  },
  {
    zip_code: "8611",

    ste_name: "NJ",
  },
  {
    zip_code: "8720",

    ste_name: "NJ",
  },
  {
    zip_code: "8741",

    ste_name: "NJ",
  },
  {
    zip_code: "8854",

    ste_name: "NJ",
  },
  {
    zip_code: "8869",

    ste_name: "NJ",
  },
  {
    zip_code: "10280",

    ste_name: "NY",
  },
  {
    zip_code: "10306",

    ste_name: "NY",
  },
  {
    zip_code: "10524",

    ste_name: "NY",
  },
  {
    zip_code: "10541",

    ste_name: "NY",
  },
  {
    zip_code: "10579",

    ste_name: "NY",
  },
  {
    zip_code: "10710",

    ste_name: "NY",
  },
  {
    zip_code: "10940",

    ste_name: "NY",
  },
  {
    zip_code: "10953",

    ste_name: "NY",
  },
  {
    zip_code: "10992",

    ste_name: "NY",
  },
  {
    zip_code: "11010",

    ste_name: "NY",
  },
  {
    zip_code: "11213",

    ste_name: "NY",
  },
  {
    zip_code: "11234",

    ste_name: "NY",
  },
  {
    zip_code: "11235",

    ste_name: "NY",
  },
  {
    zip_code: "11419",

    ste_name: "NY",
  },
  {
    zip_code: "11697",

    ste_name: "NY",
  },
  {
    zip_code: "11705",

    ste_name: "NY",
  },
  {
    zip_code: "11713",

    ste_name: "NY",
  },
  {
    zip_code: "11724",

    ste_name: "NY",
  },
  {
    zip_code: "11732",

    ste_name: "NY",
  },
  {
    zip_code: "11742",

    ste_name: "NY",
  },
  {
    zip_code: "11791",

    ste_name: "NY",
  },
  {
    zip_code: "11932",

    ste_name: "NY",
  },
  {
    zip_code: "12041",

    ste_name: "NY",
  },
  {
    zip_code: "12176",

    ste_name: "NY",
  },
  {
    zip_code: "12195",

    ste_name: "NY",
  },
  {
    zip_code: "12410",

    ste_name: "NY",
  },
  {
    zip_code: "12452",

    ste_name: "NY",
  },
  {
    zip_code: "12534",

    ste_name: "NY",
  },
  {
    zip_code: "12745",

    ste_name: "NY",
  },
  {
    zip_code: "12759",

    ste_name: "NY",
  },
  {
    zip_code: "12764",

    ste_name: "NY",
  },
  {
    zip_code: "12768",

    ste_name: "NY",
  },
  {
    zip_code: "12786",

    ste_name: "NY",
  },
  {
    zip_code: "12858",

    ste_name: "NY",
  },
  {
    zip_code: "12872",

    ste_name: "NY",
  },
  {
    zip_code: "12878",

    ste_name: "NY",
  },
  {
    zip_code: "12957",

    ste_name: "NY",
  },
  {
    zip_code: "13081",

    ste_name: "NY",
  },
  {
    zip_code: "13124",

    ste_name: "NY",
  },
  {
    zip_code: "13156",

    ste_name: "NY",
  },
  {
    zip_code: "13158",

    ste_name: "NY",
  },
  {
    zip_code: "13214",

    ste_name: "NY",
  },
  {
    zip_code: "13316",

    ste_name: "NY",
  },
  {
    zip_code: "13342",

    ste_name: "NY",
  },
  {
    zip_code: "13402",

    ste_name: "NY",
  },
  {
    zip_code: "13440",

    ste_name: "NY",
  },
  {
    zip_code: "13472",

    ste_name: "NY",
  },
  {
    zip_code: "13473",

    ste_name: "NY",
  },
  {
    zip_code: "13603",

    ste_name: "NY",
  },
  {
    zip_code: "13614",

    ste_name: "NY",
  },
  {
    zip_code: "13625",

    ste_name: "NY",
  },
  {
    zip_code: "13697",

    ste_name: "NY",
  },
  {
    zip_code: "13808",

    ste_name: "NY",
  },
  {
    zip_code: "14009",

    ste_name: "NY",
  },
  {
    zip_code: "14028",

    ste_name: "NY",
  },
  {
    zip_code: "14052",

    ste_name: "NY",
  },
  {
    zip_code: "14059",

    ste_name: "NY",
  },
  {
    zip_code: "14206",

    ste_name: "NY",
  },
  {
    zip_code: "14226",

    ste_name: "NY",
  },
  {
    zip_code: "14427",

    ste_name: "NY",
  },
  {
    zip_code: "14445",

    ste_name: "NY",
  },
  {
    zip_code: "14456",

    ste_name: "NY",
  },
  {
    zip_code: "14469",

    ste_name: "NY",
  },
  {
    zip_code: "14507",

    ste_name: "NY",
  },
  {
    zip_code: "14542",

    ste_name: "NY",
  },
  {
    zip_code: "14712",

    ste_name: "NY",
  },
  {
    zip_code: "14728",

    ste_name: "NY",
  },
  {
    zip_code: "14774",

    ste_name: "NY",
  },
  {
    zip_code: "14801",

    ste_name: "NY",
  },
  {
    zip_code: "14881",

    ste_name: "NY",
  },
  {
    zip_code: "15006",

    ste_name: "PA",
  },
  {
    zip_code: "15017",

    ste_name: "PA",
  },
  {
    zip_code: "15077",

    ste_name: "PA",
  },
  {
    zip_code: "15217",

    ste_name: "PA",
  },
  {
    zip_code: "15227",

    ste_name: "PA",
  },
  {
    zip_code: "15344",

    ste_name: "PA",
  },
  {
    zip_code: "15432",

    ste_name: "PA",
  },
  {
    zip_code: "15467",

    ste_name: "PA",
  },
  {
    zip_code: "15486",

    ste_name: "PA",
  },
  {
    zip_code: "15601",

    ste_name: "PA",
  },
  {
    zip_code: "15637",

    ste_name: "PA",
  },
  {
    zip_code: "15676",

    ste_name: "PA",
  },
  {
    zip_code: "15923",

    ste_name: "PA",
  },
  {
    zip_code: "15936",

    ste_name: "PA",
  },
  {
    zip_code: "16048",

    ste_name: "PA",
  },
  {
    zip_code: "16051",

    ste_name: "PA",
  },
  {
    zip_code: "16055",

    ste_name: "PA",
  },
  {
    zip_code: "16102",

    ste_name: "PA",
  },
  {
    zip_code: "16136",

    ste_name: "PA",
  },
  {
    zip_code: "16153",

    ste_name: "PA",
  },
  {
    zip_code: "16249",

    ste_name: "PA",
  },
  {
    zip_code: "16319",

    ste_name: "PA",
  },
  {
    zip_code: "16347",

    ste_name: "PA",
  },
  {
    zip_code: "16404",

    ste_name: "PA",
  },
  {
    zip_code: "16508",

    ste_name: "PA",
  },
  {
    zip_code: "16656",

    ste_name: "PA",
  },
  {
    zip_code: "16726",

    ste_name: "PA",
  },
  {
    zip_code: "16749",

    ste_name: "PA",
  },
  {
    zip_code: "16881",

    ste_name: "PA",
  },
  {
    zip_code: "16922",

    ste_name: "PA",
  },
  {
    zip_code: "16932",

    ste_name: "PA",
  },
  {
    zip_code: "17112",

    ste_name: "PA",
  },
  {
    zip_code: "17219",

    ste_name: "PA",
  },
  {
    zip_code: "17236",

    ste_name: "PA",
  },
  {
    zip_code: "17272",

    ste_name: "PA",
  },
  {
    zip_code: "17536",

    ste_name: "PA",
  },
  {
    zip_code: "17579",

    ste_name: "PA",
  },
  {
    zip_code: "17742",

    ste_name: "PA",
  },
  {
    zip_code: "17749",

    ste_name: "PA",
  },
  {
    zip_code: "17810",

    ste_name: "PA",
  },
  {
    zip_code: "17851",

    ste_name: "PA",
  },
  {
    zip_code: "17925",

    ste_name: "PA",
  },
  {
    zip_code: "17974",

    ste_name: "PA",
  },
  {
    zip_code: "17983",

    ste_name: "PA",
  },
  {
    zip_code: "18040",

    ste_name: "PA",
  },
  {
    zip_code: "18081",

    ste_name: "PA",
  },
  {
    zip_code: "18301",

    ste_name: "PA",
  },
  {
    zip_code: "18349",

    ste_name: "PA",
  },
  {
    zip_code: "18415",

    ste_name: "PA",
  },
  {
    zip_code: "18421",

    ste_name: "PA",
  },
  {
    zip_code: "18444",

    ste_name: "PA",
  },
  {
    zip_code: "18446",

    ste_name: "PA",
  },
  {
    zip_code: "18624",

    ste_name: "PA",
  },
  {
    zip_code: "18632",

    ste_name: "PA",
  },
  {
    zip_code: "18661",

    ste_name: "PA",
  },
  {
    zip_code: "18801",

    ste_name: "PA",
  },
  {
    zip_code: "18833",

    ste_name: "PA",
  },
  {
    zip_code: "19004",

    ste_name: "PA",
  },
  {
    zip_code: "19072",

    ste_name: "PA",
  },
  {
    zip_code: "19111",

    ste_name: "PA",
  },
  {
    zip_code: "19135",

    ste_name: "PA",
  },
  {
    zip_code: "19141",

    ste_name: "PA",
  },
  {
    zip_code: "19317",

    ste_name: "PA",
  },
  {
    zip_code: "19460",

    ste_name: "PA",
  },
  {
    zip_code: "19512",

    ste_name: "PA",
  },
  {
    zip_code: "19539",

    ste_name: "PA",
  },
  {
    zip_code: "19938",

    ste_name: "DE",
  },
  {
    zip_code: "20158",

    ste_name: "VA",
  },
  {
    zip_code: "20170",

    ste_name: "VA",
  },
  {
    zip_code: "20566",

    ste_name: "DC",
  },
  {
    zip_code: "20626",

    ste_name: "MD",
  },
  {
    zip_code: "20639",

    ste_name: "MD",
  },
  {
    zip_code: "20650",

    ste_name: "MD",
  },
  {
    zip_code: "20779",

    ste_name: "MD",
  },
  {
    zip_code: "21043",

    ste_name: "MD",
  },
  {
    zip_code: "21044",

    ste_name: "MD",
  },
  {
    zip_code: "21114",

    ste_name: "MD",
  },
  {
    zip_code: "21204",

    ste_name: "MD",
  },
  {
    zip_code: "21222",

    ste_name: "MD",
  },
  {
    zip_code: "21250",

    ste_name: "MD",
  },
  {
    zip_code: "21405",

    ste_name: "MD",
  },
  {
    zip_code: "21536",

    ste_name: "MD",
  },
  {
    zip_code: "21613",

    ste_name: "MD",
  },
  {
    zip_code: "21627",

    ste_name: "MD",
  },
  {
    zip_code: "21645",

    ste_name: "MD",
  },
  {
    zip_code: "21716",

    ste_name: "MD",
  },
  {
    zip_code: "21758",

    ste_name: "MD",
  },
  {
    zip_code: "21762",

    ste_name: "MD",
  },
  {
    zip_code: "21777",

    ste_name: "MD",
  },
  {
    zip_code: "21835",

    ste_name: "MD",
  },
  {
    zip_code: "21869",

    ste_name: "MD",
  },
  {
    zip_code: "21871",

    ste_name: "MD",
  },
  {
    zip_code: "22032",

    ste_name: "VA",
  },
  {
    zip_code: "22310",

    ste_name: "VA",
  },
  {
    zip_code: "22514",

    ste_name: "VA",
  },
  {
    zip_code: "22610",

    ste_name: "VA",
  },
  {
    zip_code: "22655",

    ste_name: "VA",
  },
  {
    zip_code: "22720",

    ste_name: "VA",
  },
  {
    zip_code: "22724",

    ste_name: "VA",
  },
  {
    zip_code: "23091",

    ste_name: "VA",
  },
  {
    zip_code: "23222",

    ste_name: "VA",
  },
  {
    zip_code: "23223",

    ste_name: "VA",
  },
  {
    zip_code: "23422",

    ste_name: "VA",
  },
  {
    zip_code: "23435",

    ste_name: "VA",
  },
  {
    zip_code: "23442",

    ste_name: "VA",
  },
  {
    zip_code: "23457",

    ste_name: "VA",
  },
  {
    zip_code: "23803",

    ste_name: "VA",
  },
  {
    zip_code: "23827",

    ste_name: "VA",
  },
  {
    zip_code: "23881",

    ste_name: "VA",
  },
  {
    zip_code: "23922",

    ste_name: "VA",
  },
  {
    zip_code: "24065",

    ste_name: "VA",
  },
  {
    zip_code: "24066",

    ste_name: "VA",
  },
  {
    zip_code: "24069",

    ste_name: "VA",
  },
  {
    zip_code: "24127",

    ste_name: "VA",
  },
  {
    zip_code: "24556",

    ste_name: "VA",
  },
  {
    zip_code: "24562",

    ste_name: "VA",
  },
  {
    zip_code: "24563",

    ste_name: "VA",
  },
  {
    zip_code: "24598",

    ste_name: "VA",
  },
  {
    zip_code: "24609",

    ste_name: "VA",
  },
  {
    zip_code: "24801",

    ste_name: "WV",
  },
  {
    zip_code: "24808",

    ste_name: "WV",
  },
  {
    zip_code: "24816",

    ste_name: "WV",
  },
  {
    zip_code: "24849",

    ste_name: "WV",
  },
  {
    zip_code: "24860",

    ste_name: "WV",
  },
  {
    zip_code: "25064",

    ste_name: "WV",
  },
  {
    zip_code: "25071",

    ste_name: "WV",
  },
  {
    zip_code: "25125",

    ste_name: "WV",
  },
  {
    zip_code: "25213",

    ste_name: "WV",
  },
  {
    zip_code: "25234",

    ste_name: "WV",
  },
  {
    zip_code: "25247",

    ste_name: "WV",
  },
  {
    zip_code: "25259",

    ste_name: "WV",
  },
  {
    zip_code: "25702",

    ste_name: "WV",
  },
  {
    zip_code: "25704",

    ste_name: "WV",
  },
  {
    zip_code: "25844",

    ste_name: "WV",
  },
  {
    zip_code: "25918",

    ste_name: "WV",
  },
  {
    zip_code: "25921",

    ste_name: "WV",
  },
  {
    zip_code: "25928",

    ste_name: "WV",
  },
  {
    zip_code: "25951",

    ste_name: "WV",
  },
  {
    zip_code: "26047",

    ste_name: "WV",
  },
  {
    zip_code: "26264",

    ste_name: "WV",
  },
  {
    zip_code: "26338",

    ste_name: "WV",
  },
  {
    zip_code: "26405",

    ste_name: "WV",
  },
  {
    zip_code: "26562",

    ste_name: "WV",
  },
  {
    zip_code: "26739",

    ste_name: "WV",
  },
  {
    zip_code: "26804",

    ste_name: "WV",
  },
  {
    zip_code: "26836",

    ste_name: "WV",
  },
  {
    zip_code: "27050",

    ste_name: "NC",
  },
  {
    zip_code: "27252",

    ste_name: "NC",
  },
  {
    zip_code: "27265",

    ste_name: "NC",
  },
  {
    zip_code: "27503",

    ste_name: "NC",
  },
  {
    zip_code: "27571",

    ste_name: "NC",
  },
  {
    zip_code: "27596",

    ste_name: "NC",
  },
  {
    zip_code: "27609",

    ste_name: "NC",
  },
  {
    zip_code: "27712",

    ste_name: "NC",
  },
  {
    zip_code: "27806",

    ste_name: "NC",
  },
  {
    zip_code: "27937",

    ste_name: "NC",
  },
  {
    zip_code: "28019",

    ste_name: "NC",
  },
  {
    zip_code: "28088",

    ste_name: "NC",
  },
  {
    zip_code: "28101",

    ste_name: "NC",
  },
  {
    zip_code: "28115",

    ste_name: "NC",
  },
  {
    zip_code: "28318",

    ste_name: "NC",
  },
  {
    zip_code: "28328",

    ste_name: "NC",
  },
  {
    zip_code: "28351",

    ste_name: "NC",
  },
  {
    zip_code: "28399",

    ste_name: "NC",
  },
  {
    zip_code: "28428",

    ste_name: "NC",
  },
  {
    zip_code: "28430",

    ste_name: "NC",
  },
  {
    zip_code: "28478",

    ste_name: "NC",
  },
  {
    zip_code: "28578",

    ste_name: "NC",
  },
  {
    zip_code: "28624",

    ste_name: "NC",
  },
  {
    zip_code: "28629",

    ste_name: "NC",
  },
  {
    zip_code: "28662",

    ste_name: "NC",
  },
  {
    zip_code: "28701",

    ste_name: "NC",
  },
  {
    zip_code: "28726",

    ste_name: "NC",
  },
  {
    zip_code: "29125",

    ste_name: "SC",
  },
  {
    zip_code: "29128",

    ste_name: "SC",
  },
  {
    zip_code: "29145",

    ste_name: "SC",
  },
  {
    zip_code: "29303",

    ste_name: "SC",
  },
  {
    zip_code: "29403",

    ste_name: "SC",
  },
  {
    zip_code: "29424",

    ste_name: "SC",
  },
  {
    zip_code: "29432",

    ste_name: "SC",
  },
  {
    zip_code: "29445",

    ste_name: "SC",
  },
  {
    zip_code: "29483",

    ste_name: "SC",
  },
  {
    zip_code: "29518",

    ste_name: "SC",
  },
  {
    zip_code: "29620",

    ste_name: "SC",
  },
  {
    zip_code: "29655",

    ste_name: "SC",
  },
  {
    zip_code: "29657",

    ste_name: "SC",
  },
  {
    zip_code: "29681",

    ste_name: "SC",
  },
  {
    zip_code: "29831",

    ste_name: "SC",
  },
  {
    zip_code: "29834",

    ste_name: "SC",
  },
  {
    zip_code: "29848",

    ste_name: "SC",
  },
  {
    zip_code: "29944",

    ste_name: "SC",
  },
  {
    zip_code: "30012",

    ste_name: "GA",
  },
  {
    zip_code: "30094",

    ste_name: "GA",
  },
  {
    zip_code: "30132",

    ste_name: "GA",
  },
  {
    zip_code: "30173",

    ste_name: "GA",
  },
  {
    zip_code: "30180",

    ste_name: "GA",
  },
  {
    zip_code: "30183",

    ste_name: "GA",
  },
  {
    zip_code: "30218",

    ste_name: "GA",
  },
  {
    zip_code: "30253",

    ste_name: "GA",
  },
  {
    zip_code: "30411",

    ste_name: "GA",
  },
  {
    zip_code: "30441",

    ste_name: "GA",
  },
  {
    zip_code: "30516",

    ste_name: "GA",
  },
  {
    zip_code: "30518",

    ste_name: "GA",
  },
  {
    zip_code: "30525",

    ste_name: "GA",
  },
  {
    zip_code: "30534",

    ste_name: "GA",
  },
  {
    zip_code: "30575",

    ste_name: "GA",
  },
  {
    zip_code: "30605",

    ste_name: "GA",
  },
  {
    zip_code: "30623",

    ste_name: "GA",
  },
  {
    zip_code: "30655",

    ste_name: "GA",
  },
  {
    zip_code: "30680",

    ste_name: "GA",
  },
  {
    zip_code: "30731",

    ste_name: "GA",
  },
  {
    zip_code: "31064",

    ste_name: "GA",
  },
  {
    zip_code: "31065",

    ste_name: "GA",
  },
  {
    zip_code: "31083",

    ste_name: "GA",
  },
  {
    zip_code: "31315",

    ste_name: "GA",
  },
  {
    zip_code: "31539",

    ste_name: "GA",
  },
  {
    zip_code: "31556",

    ste_name: "GA",
  },
  {
    zip_code: "31605",

    ste_name: "GA",
  },
  {
    zip_code: "31705",

    ste_name: "GA",
  },
  {
    zip_code: "31822",

    ste_name: "GA",
  },
  {
    zip_code: "32003",

    ste_name: "FL",
  },
  {
    zip_code: "32060",

    ste_name: "FL",
  },
  {
    zip_code: "32096",

    ste_name: "FL",
  },
  {
    zip_code: "32134",

    ste_name: "FL",
  },
  {
    zip_code: "32324",

    ste_name: "FL",
  },
  {
    zip_code: "32340",

    ste_name: "FL",
  },
  {
    zip_code: "32432",

    ste_name: "FL",
  },
  {
    zip_code: "32438",

    ste_name: "FL",
  },
  {
    zip_code: "32456",

    ste_name: "FL",
  },
  {
    zip_code: "32505",

    ste_name: "FL",
  },
  {
    zip_code: "32531",

    ste_name: "FL",
  },
  {
    zip_code: "32539",

    ste_name: "FL",
  },
  {
    zip_code: "32566",

    ste_name: "FL",
  },
  {
    zip_code: "32580",

    ste_name: "FL",
  },
  {
    zip_code: "32606",

    ste_name: "FL",
  },
  {
    zip_code: "32702",

    ste_name: "FL",
  },
  {
    zip_code: "32736",

    ste_name: "FL",
  },
  {
    zip_code: "32765",

    ste_name: "FL",
  },
  {
    zip_code: "32771",

    ste_name: "FL",
  },
  {
    zip_code: "32818",

    ste_name: "FL",
  },
  {
    zip_code: "33026",

    ste_name: "FL",
  },
  {
    zip_code: "33101",

    ste_name: "FL",
  },
  {
    zip_code: "33136",

    ste_name: "FL",
  },
  {
    zip_code: "33174",

    ste_name: "FL",
  },
  {
    zip_code: "33183",

    ste_name: "FL",
  },
  {
    zip_code: "33480",

    ste_name: "FL",
  },
  {
    zip_code: "33486",

    ste_name: "FL",
  },
  {
    zip_code: "33782",

    ste_name: "FL",
  },
  {
    zip_code: "33827",

    ste_name: "FL",
  },
  {
    zip_code: "33946",

    ste_name: "FL",
  },
  {
    zip_code: "34102",

    ste_name: "FL",
  },
  {
    zip_code: "34105",

    ste_name: "FL",
  },
  {
    zip_code: "34138",

    ste_name: "FL",
  },
  {
    zip_code: "34452",

    ste_name: "FL",
  },
  {
    zip_code: "34602",

    ste_name: "FL",
  },
  {
    zip_code: "34760",

    ste_name: "FL",
  },
  {
    zip_code: "34761",

    ste_name: "FL",
  },
  {
    zip_code: "35082",

    ste_name: "AL",
  },
  {
    zip_code: "35087",

    ste_name: "AL",
  },
  {
    zip_code: "35096",

    ste_name: "AL",
  },
  {
    zip_code: "35130",

    ste_name: "AL",
  },
  {
    zip_code: "35212",

    ste_name: "AL",
  },
  {
    zip_code: "35243",

    ste_name: "AL",
  },
  {
    zip_code: "35460",

    ste_name: "AL",
  },
  {
    zip_code: "35475",

    ste_name: "AL",
  },
  {
    zip_code: "35503",

    ste_name: "AL",
  },
  {
    zip_code: "35634",

    ste_name: "AL",
  },
  {
    zip_code: "35654",

    ste_name: "AL",
  },
  {
    zip_code: "35749",

    ste_name: "AL",
  },
  {
    zip_code: "35801",

    ste_name: "AL",
  },
  {
    zip_code: "35972",

    ste_name: "AL",
  },
  {
    zip_code: "35976",

    ste_name: "AL",
  },
  {
    zip_code: "35984",

    ste_name: "AL",
  },
  {
    zip_code: "36010",

    ste_name: "AL",
  },
  {
    zip_code: "36053",

    ste_name: "AL",
  },
  {
    zip_code: "36091",

    ste_name: "AL",
  },
  {
    zip_code: "36111",

    ste_name: "AL",
  },
  {
    zip_code: "36421",

    ste_name: "AL",
  },
  {
    zip_code: "36441",

    ste_name: "AL",
  },
  {
    zip_code: "36456",

    ste_name: "AL",
  },
  {
    zip_code: "36471",

    ste_name: "AL",
  },
  {
    zip_code: "36543",

    ste_name: "AL",
  },
  {
    zip_code: "36590",

    ste_name: "AL",
  },
  {
    zip_code: "36783",

    ste_name: "AL",
  },
  {
    zip_code: "36793",

    ste_name: "AL",
  },
  {
    zip_code: "37048",

    ste_name: "TN",
  },
  {
    zip_code: "37097",

    ste_name: "TN",
  },
  {
    zip_code: "37208",

    ste_name: "TN",
  },
  {
    zip_code: "37301",

    ste_name: "TN",
  },
  {
    zip_code: "37305",

    ste_name: "TN",
  },
  {
    zip_code: "37315",

    ste_name: "TN",
  },
  {
    zip_code: "37396",

    ste_name: "TN",
  },
  {
    zip_code: "37402",

    ste_name: "TN",
  },
  {
    zip_code: "37419",

    ste_name: "TN",
  },
  {
    zip_code: "37614",

    ste_name: "TN",
  },
  {
    zip_code: "37708",

    ste_name: "TN",
  },
  {
    zip_code: "37753",

    ste_name: "TN",
  },
  {
    zip_code: "37829",

    ste_name: "TN",
  },
  {
    zip_code: "37847",

    ste_name: "TN",
  },
  {
    zip_code: "37871",

    ste_name: "TN",
  },
  {
    zip_code: "37931",

    ste_name: "TN",
  },
  {
    zip_code: "38106",

    ste_name: "TN",
  },
  {
    zip_code: "38222",

    ste_name: "TN",
  },
  {
    zip_code: "38348",

    ste_name: "TN",
  },
  {
    zip_code: "38374",

    ste_name: "TN",
  },
  {
    zip_code: "38551",

    ste_name: "TN",
  },
  {
    zip_code: "38570",

    ste_name: "TN",
  },
  {
    zip_code: "38631",

    ste_name: "MS",
  },
  {
    zip_code: "38722",

    ste_name: "MS",
  },
  {
    zip_code: "38726",

    ste_name: "MS",
  },
  {
    zip_code: "38954",

    ste_name: "MS",
  },
  {
    zip_code: "39062",

    ste_name: "MS",
  },
  {
    zip_code: "39140",

    ste_name: "MS",
  },
  {
    zip_code: "39350",

    ste_name: "MS",
  },
  {
    zip_code: "39355",

    ste_name: "MS",
  },
  {
    zip_code: "39422",

    ste_name: "MS",
  },
  {
    zip_code: "39525",

    ste_name: "MS",
  },
  {
    zip_code: "39562",

    ste_name: "MS",
  },
  {
    zip_code: "39630",

    ste_name: "MS",
  },
  {
    zip_code: "39665",

    ste_name: "MS",
  },
  {
    zip_code: "39859",

    ste_name: "GA",
  },
  {
    zip_code: "40004",

    ste_name: "KY",
  },
  {
    zip_code: "40031",

    ste_name: "KY",
  },
  {
    zip_code: "40045",

    ste_name: "KY",
  },
  {
    zip_code: "40046",

    ste_name: "KY",
  },
  {
    zip_code: "40062",

    ste_name: "KY",
  },
  {
    zip_code: "40145",

    ste_name: "KY",
  },
  {
    zip_code: "40241",

    ste_name: "KY",
  },
  {
    zip_code: "40313",

    ste_name: "KY",
  },
  {
    zip_code: "40419",

    ste_name: "KY",
  },
  {
    zip_code: "40486",

    ste_name: "KY",
  },
  {
    zip_code: "40808",

    ste_name: "KY",
  },
  {
    zip_code: "41043",

    ste_name: "KY",
  },
  {
    zip_code: "41059",

    ste_name: "KY",
  },
  {
    zip_code: "41129",

    ste_name: "KY",
  },
  {
    zip_code: "41240",

    ste_name: "KY",
  },
  {
    zip_code: "41256",

    ste_name: "KY",
  },
  {
    zip_code: "41602",

    ste_name: "KY",
  },
  {
    zip_code: "41649",

    ste_name: "KY",
  },
  {
    zip_code: "41760",

    ste_name: "KY",
  },
  {
    zip_code: "41836",

    ste_name: "KY",
  },
  {
    zip_code: "41844",

    ste_name: "KY",
  },
  {
    zip_code: "42020",

    ste_name: "KY",
  },
  {
    zip_code: "42027",

    ste_name: "KY",
  },
  {
    zip_code: "42037",

    ste_name: "KY",
  },
  {
    zip_code: "42088",

    ste_name: "KY",
  },
  {
    zip_code: "42274",

    ste_name: "KY",
  },
  {
    zip_code: "42722",

    ste_name: "KY",
  },
  {
    zip_code: "43036",

    ste_name: "OH",
  },
  {
    zip_code: "43050",

    ste_name: "OH",
  },
  {
    zip_code: "43056",

    ste_name: "OH",
  },
  {
    zip_code: "43084",

    ste_name: "OH",
  },
  {
    zip_code: "43210",

    ste_name: "OH",
  },
  {
    zip_code: "43217",

    ste_name: "OH",
  },
  {
    zip_code: "43344",

    ste_name: "OH",
  },
  {
    zip_code: "43766",

    ste_name: "OH",
  },
  {
    zip_code: "43821",

    ste_name: "OH",
  },
  {
    zip_code: "43845",

    ste_name: "OH",
  },
  {
    zip_code: "43931",

    ste_name: "OH",
  },
  {
    zip_code: "43932",

    ste_name: "OH",
  },
  {
    zip_code: "43952",

    ste_name: "OH",
  },
  {
    zip_code: "43988",

    ste_name: "OH",
  },
  {
    zip_code: "44021",

    ste_name: "OH",
  },
  {
    zip_code: "44049",

    ste_name: "OH",
  },
  {
    zip_code: "44052",

    ste_name: "OH",
  },
  {
    zip_code: "44112",

    ste_name: "OH",
  },
  {
    zip_code: "44264",

    ste_name: "OH",
  },
  {
    zip_code: "44272",

    ste_name: "OH",
  },
  {
    zip_code: "44273",

    ste_name: "OH",
  },
  {
    zip_code: "44436",

    ste_name: "OH",
  },
  {
    zip_code: "44507",

    ste_name: "OH",
  },
  {
    zip_code: "44613",

    ste_name: "OH",
  },
  {
    zip_code: "44628",

    ste_name: "OH",
  },
  {
    zip_code: "44640",

    ste_name: "OH",
  },
  {
    zip_code: "44657",

    ste_name: "OH",
  },
  {
    zip_code: "44825",

    ste_name: "OH",
  },
  {
    zip_code: "44840",

    ste_name: "OH",
  },
  {
    zip_code: "44890",

    ste_name: "OH",
  },
  {
    zip_code: "44902",

    ste_name: "OH",
  },
  {
    zip_code: "45123",

    ste_name: "OH",
  },
  {
    zip_code: "45144",

    ste_name: "OH",
  },
  {
    zip_code: "45203",

    ste_name: "OH",
  },
  {
    zip_code: "45361",

    ste_name: "OH",
  },
  {
    zip_code: "45403",

    ste_name: "OH",
  },
  {
    zip_code: "45458",

    ste_name: "OH",
  },
  {
    zip_code: "45679",

    ste_name: "OH",
  },
  {
    zip_code: "45680",

    ste_name: "OH",
  },
  {
    zip_code: "45696",

    ste_name: "OH",
  },
  {
    zip_code: "45801",

    ste_name: "OH",
  },
  {
    zip_code: "45808",

    ste_name: "OH",
  },
  {
    zip_code: "45840",

    ste_name: "OH",
  },
  {
    zip_code: "45844",

    ste_name: "OH",
  },
  {
    zip_code: "45854",

    ste_name: "OH",
  },
  {
    zip_code: "45868",

    ste_name: "OH",
  },
  {
    zip_code: "45884",

    ste_name: "OH",
  },
  {
    zip_code: "46012",

    ste_name: "IN",
  },
  {
    zip_code: "46044",

    ste_name: "IN",
  },
  {
    zip_code: "46057",

    ste_name: "IN",
  },
  {
    zip_code: "46301",

    ste_name: "IN",
  },
  {
    zip_code: "46341",

    ste_name: "IN",
  },
  {
    zip_code: "46379",

    ste_name: "IN",
  },
  {
    zip_code: "46392",

    ste_name: "IN",
  },
  {
    zip_code: "46545",

    ste_name: "IN",
  },
  {
    zip_code: "46711",

    ste_name: "IN",
  },
  {
    zip_code: "46792",

    ste_name: "IN",
  },
  {
    zip_code: "46802",

    ste_name: "IN",
  },
  {
    zip_code: "46808",

    ste_name: "IN",
  },
  {
    zip_code: "46815",

    ste_name: "IN",
  },
  {
    zip_code: "46835",

    ste_name: "IN",
  },
  {
    zip_code: "46940",

    ste_name: "IN",
  },
  {
    zip_code: "46998",

    ste_name: "IN",
  },
  {
    zip_code: "47102",

    ste_name: "IN",
  },
  {
    zip_code: "47104",

    ste_name: "IN",
  },
  {
    zip_code: "47110",

    ste_name: "IN",
  },
  {
    zip_code: "47125",

    ste_name: "IN",
  },
  {
    zip_code: "47335",

    ste_name: "IN",
  },
  {
    zip_code: "47353",

    ste_name: "IN",
  },
  {
    zip_code: "47408",

    ste_name: "IN",
  },
  {
    zip_code: "47456",

    ste_name: "IN",
  },
  {
    zip_code: "47467",

    ste_name: "IN",
  },
  {
    zip_code: "47468",

    ste_name: "IN",
  },
  {
    zip_code: "47958",

    ste_name: "IN",
  },
  {
    zip_code: "48030",

    ste_name: "MI",
  },
  {
    zip_code: "48094",

    ste_name: "MI",
  },
  {
    zip_code: "48145",

    ste_name: "MI",
  },
  {
    zip_code: "48169",

    ste_name: "MI",
  },
  {
    zip_code: "48183",

    ste_name: "MI",
  },
  {
    zip_code: "48210",

    ste_name: "MI",
  },
  {
    zip_code: "48230",

    ste_name: "MI",
  },
  {
    zip_code: "48307",

    ste_name: "MI",
  },
  {
    zip_code: "48316",

    ste_name: "MI",
  },
  {
    zip_code: "48324",

    ste_name: "MI",
  },
  {
    zip_code: "48331",

    ste_name: "MI",
  },
  {
    zip_code: "48340",

    ste_name: "MI",
  },
  {
    zip_code: "48383",

    ste_name: "MI",
  },
  {
    zip_code: "48427",

    ste_name: "MI",
  },
  {
    zip_code: "48429",

    ste_name: "MI",
  },
  {
    zip_code: "48472",

    ste_name: "MI",
  },
  {
    zip_code: "48652",

    ste_name: "MI",
  },
  {
    zip_code: "48723",

    ste_name: "MI",
  },
  {
    zip_code: "48742",

    ste_name: "MI",
  },
  {
    zip_code: "48761",

    ste_name: "MI",
  },
  {
    zip_code: "48825",

    ste_name: "MI",
  },
  {
    zip_code: "48884",

    ste_name: "MI",
  },
  {
    zip_code: "49029",

    ste_name: "MI",
  },
  {
    zip_code: "49034",

    ste_name: "MI",
  },
  {
    zip_code: "49099",

    ste_name: "MI",
  },
  {
    zip_code: "49224",

    ste_name: "MI",
  },
  {
    zip_code: "49245",

    ste_name: "MI",
  },
  {
    zip_code: "49259",

    ste_name: "MI",
  },
  {
    zip_code: "49271",

    ste_name: "MI",
  },
  {
    zip_code: "49418",

    ste_name: "MI",
  },
  {
    zip_code: "49460",

    ste_name: "MI",
  },
  {
    zip_code: "49614",

    ste_name: "MI",
  },
  {
    zip_code: "49729",

    ste_name: "MI",
  },
  {
    zip_code: "49848",

    ste_name: "MI",
  },
  {
    zip_code: "49852",

    ste_name: "MI",
  },
  {
    zip_code: "49853",

    ste_name: "MI",
  },
  {
    zip_code: "49858",

    ste_name: "MI",
  },
  {
    zip_code: "49864",

    ste_name: "MI",
  },
  {
    zip_code: "49881",

    ste_name: "MI",
  },
  {
    zip_code: "49915",

    ste_name: "MI",
  },
  {
    zip_code: "49948",

    ste_name: "MI",
  },
  {
    zip_code: "50002",

    ste_name: "IA",
  },
  {
    zip_code: "50035",

    ste_name: "IA",
  },
  {
    zip_code: "50103",

    ste_name: "IA",
  },
  {
    zip_code: "50107",

    ste_name: "IA",
  },
  {
    zip_code: "50134",

    ste_name: "IA",
  },
  {
    zip_code: "50231",

    ste_name: "IA",
  },
  {
    zip_code: "50262",

    ste_name: "IA",
  },
  {
    zip_code: "50581",

    ste_name: "IA",
  },
  {
    zip_code: "50648",

    ste_name: "IA",
  },
  {
    zip_code: "50851",

    ste_name: "IA",
  },
  {
    zip_code: "50863",

    ste_name: "IA",
  },
  {
    zip_code: "51020",

    ste_name: "IA",
  },
  {
    zip_code: "51028",

    ste_name: "IA",
  },
  {
    zip_code: "51041",

    ste_name: "IA",
  },
  {
    zip_code: "51238",

    ste_name: "IA",
  },
  {
    zip_code: "51243",

    ste_name: "IA",
  },
  {
    zip_code: "51440",

    ste_name: "IA",
  },
  {
    zip_code: "51463",

    ste_name: "IA",
  },
  {
    zip_code: "51527",

    ste_name: "IA",
  },
  {
    zip_code: "51571",

    ste_name: "IA",
  },
  {
    zip_code: "51640",

    ste_name: "IA",
  },
  {
    zip_code: "51649",

    ste_name: "IA",
  },
  {
    zip_code: "52032",

    ste_name: "IA",
  },
  {
    zip_code: "52216",

    ste_name: "IA",
  },
  {
    zip_code: "52220",

    ste_name: "IA",
  },
  {
    zip_code: "52251",

    ste_name: "IA",
  },
  {
    zip_code: "52355",

    ste_name: "IA",
  },
  {
    zip_code: "52586",

    ste_name: "IA",
  },
  {
    zip_code: "52645",

    ste_name: "IA",
  },
  {
    zip_code: "52751",

    ste_name: "IA",
  },
  {
    zip_code: "52758",

    ste_name: "IA",
  },
  {
    zip_code: "53002",

    ste_name: "WI",
  },
  {
    zip_code: "53034",

    ste_name: "WI",
  },
  {
    zip_code: "53057",

    ste_name: "WI",
  },
  {
    zip_code: "53130",

    ste_name: "WI",
  },
  {
    zip_code: "53178",

    ste_name: "WI",
  },
  {
    zip_code: "53295",

    ste_name: "WI",
  },
  {
    zip_code: "53825",

    ste_name: "WI",
  },
  {
    zip_code: "53922",

    ste_name: "WI",
  },
  {
    zip_code: "53933",

    ste_name: "WI",
  },
  {
    zip_code: "53959",

    ste_name: "WI",
  },
  {
    zip_code: "54114",

    ste_name: "WI",
  },
  {
    zip_code: "54161",

    ste_name: "WI",
  },
  {
    zip_code: "54212",

    ste_name: "WI",
  },
  {
    zip_code: "54213",

    ste_name: "WI",
  },
  {
    zip_code: "54227",

    ste_name: "WI",
  },
  {
    zip_code: "54408",

    ste_name: "WI",
  },
  {
    zip_code: "54459",

    ste_name: "WI",
  },
  {
    zip_code: "54493",

    ste_name: "WI",
  },
  {
    zip_code: "54525",

    ste_name: "WI",
  },
  {
    zip_code: "54530",

    ste_name: "WI",
  },
  {
    zip_code: "54550",

    ste_name: "WI",
  },
  {
    zip_code: "54557",

    ste_name: "WI",
  },
  {
    zip_code: "54618",

    ste_name: "WI",
  },
  {
    zip_code: "54664",

    ste_name: "WI",
  },
  {
    zip_code: "54721",

    ste_name: "WI",
  },
  {
    zip_code: "54728",

    ste_name: "WI",
  },
  {
    zip_code: "54738",

    ste_name: "WI",
  },
  {
    zip_code: "54754",

    ste_name: "WI",
  },
  {
    zip_code: "54830",

    ste_name: "WI",
  },
  {
    zip_code: "54837",

    ste_name: "WI",
  },
  {
    zip_code: "54880",

    ste_name: "WI",
  },
  {
    zip_code: "55041",

    ste_name: "MN",
  },
  {
    zip_code: "55076",

    ste_name: "MN",
  },
  {
    zip_code: "55080",

    ste_name: "MN",
  },
  {
    zip_code: "55116",

    ste_name: "MN",
  },
  {
    zip_code: "55118",

    ste_name: "MN",
  },
  {
    zip_code: "55121",

    ste_name: "MN",
  },
  {
    zip_code: "55324",

    ste_name: "MN",
  },
  {
    zip_code: "55347",

    ste_name: "MN",
  },
  {
    zip_code: "55785",

    ste_name: "MN",
  },
  {
    zip_code: "55808",

    ste_name: "MN",
  },
  {
    zip_code: "55902",

    ste_name: "MN",
  },
  {
    zip_code: "55910",

    ste_name: "MN",
  },
  {
    zip_code: "55949",

    ste_name: "MN",
  },
  {
    zip_code: "55968",

    ste_name: "MN",
  },
  {
    zip_code: "55972",

    ste_name: "MN",
  },
  {
    zip_code: "56036",

    ste_name: "MN",
  },
  {
    zip_code: "56060",

    ste_name: "MN",
  },
  {
    zip_code: "56090",

    ste_name: "MN",
  },
  {
    zip_code: "56115",

    ste_name: "MN",
  },
  {
    zip_code: "56273",

    ste_name: "MN",
  },
  {
    zip_code: "56295",

    ste_name: "MN",
  },
  {
    zip_code: "56523",

    ste_name: "MN",
  },
  {
    zip_code: "56570",

    ste_name: "MN",
  },
  {
    zip_code: "56576",

    ste_name: "MN",
  },
  {
    zip_code: "56633",

    ste_name: "MN",
  },
  {
    zip_code: "56748",

    ste_name: "MN",
  },
  {
    zip_code: "57061",

    ste_name: "SD",
  },
  {
    zip_code: "57105",

    ste_name: "SD",
  },
  {
    zip_code: "57262",

    ste_name: "SD",
  },
  {
    zip_code: "57428",

    ste_name: "SD",
  },
  {
    zip_code: "57537",

    ste_name: "SD",
  },
  {
    zip_code: "57630",

    ste_name: "SD",
  },
  {
    zip_code: "57648",

    ste_name: "SD",
  },
  {
    zip_code: "58011",

    ste_name: "ND",
  },
  {
    zip_code: "58015",

    ste_name: "ND",
  },
  {
    zip_code: "58229",

    ste_name: "ND",
  },
  {
    zip_code: "58269",

    ste_name: "ND",
  },
  {
    zip_code: "58368",

    ste_name: "ND",
  },
  {
    zip_code: "58423",

    ste_name: "ND",
  },
  {
    zip_code: "58436",

    ste_name: "ND",
  },
  {
    zip_code: "58486",

    ste_name: "ND",
  },
  {
    zip_code: "58501",

    ste_name: "ND",
  },
  {
    zip_code: "58640",

    ste_name: "ND",
  },
  {
    zip_code: "58655",

    ste_name: "ND",
  },
  {
    zip_code: "58727",

    ste_name: "ND",
  },
  {
    zip_code: "58849",

    ste_name: "ND",
  },
  {
    zip_code: "59085",

    ste_name: "MT",
  },
  {
    zip_code: "59213",

    ste_name: "MT",
  },
  {
    zip_code: "59244",

    ste_name: "MT",
  },
  {
    zip_code: "59248",

    ste_name: "MT",
  },
  {
    zip_code: "59258",

    ste_name: "MT",
  },
  {
    zip_code: "59344",

    ste_name: "MT",
  },
  {
    zip_code: "59542",

    ste_name: "MT",
  },
  {
    zip_code: "59746",

    ste_name: "MT",
  },
  {
    zip_code: "59834",

    ste_name: "MT",
  },
  {
    zip_code: "59914",

    ste_name: "MT",
  },
  {
    zip_code: "59919",

    ste_name: "MT",
  },
  {
    zip_code: "60071",

    ste_name: "IL",
  },
  {
    zip_code: "60145",

    ste_name: "IL",
  },
  {
    zip_code: "60148",

    ste_name: "IL",
  },
  {
    zip_code: "60151",

    ste_name: "IL",
  },
  {
    zip_code: "60157",

    ste_name: "IL",
  },
  {
    zip_code: "60402",

    ste_name: "IL",
  },
  {
    zip_code: "60455",

    ste_name: "IL",
  },
  {
    zip_code: "60462",

    ste_name: "IL",
  },
  {
    zip_code: "60539",

    ste_name: "IL",
  },
  {
    zip_code: "60616",

    ste_name: "IL",
  },
  {
    zip_code: "60660",

    ste_name: "IL",
  },
  {
    zip_code: "60970",

    ste_name: "IL",
  },
  {
    zip_code: "61053",

    ste_name: "IL",
  },
  {
    zip_code: "61074",

    ste_name: "IL",
  },
  {
    zip_code: "61327",

    ste_name: "IL",
  },
  {
    zip_code: "61372",

    ste_name: "IL",
  },
  {
    zip_code: "61375",

    ste_name: "IL",
  },
  {
    zip_code: "61434",

    ste_name: "IL",
  },
  {
    zip_code: "61540",

    ste_name: "IL",
  },
  {
    zip_code: "61546",

    ste_name: "IL",
  },
  {
    zip_code: "61733",

    ste_name: "IL",
  },
  {
    zip_code: "61812",

    ste_name: "IL",
  },
  {
    zip_code: "61873",

    ste_name: "IL",
  },
  {
    zip_code: "62031",

    ste_name: "IL",
  },
  {
    zip_code: "62201",

    ste_name: "IL",
  },
  {
    zip_code: "62279",

    ste_name: "IL",
  },
  {
    zip_code: "62316",

    ste_name: "IL",
  },
  {
    zip_code: "62365",

    ste_name: "IL",
  },
  {
    zip_code: "62418",

    ste_name: "IL",
  },
  {
    zip_code: "62474",

    ste_name: "IL",
  },
  {
    zip_code: "62501",

    ste_name: "IL",
  },
  {
    zip_code: "62630",

    ste_name: "IL",
  },
  {
    zip_code: "62649",

    ste_name: "IL",
  },
  {
    zip_code: "62663",

    ste_name: "IL",
  },
  {
    zip_code: "62807",

    ste_name: "IL",
  },
  {
    zip_code: "62841",

    ste_name: "IL",
  },
  {
    zip_code: "62843",

    ste_name: "IL",
  },
  {
    zip_code: "62865",

    ste_name: "IL",
  },
  {
    zip_code: "62867",

    ste_name: "IL",
  },
  {
    zip_code: "62912",

    ste_name: "IL",
  },
  {
    zip_code: "62961",

    ste_name: "IL",
  },
  {
    zip_code: "62970",

    ste_name: "IL",
  },
  {
    zip_code: "63055",

    ste_name: "MO",
  },
  {
    zip_code: "63368",

    ste_name: "MO",
  },
  {
    zip_code: "63539",

    ste_name: "MO",
  },
  {
    zip_code: "63546",

    ste_name: "MO",
  },
  {
    zip_code: "63656",

    ste_name: "MO",
  },
  {
    zip_code: "63775",

    ste_name: "MO",
  },
  {
    zip_code: "63825",

    ste_name: "MO",
  },
  {
    zip_code: "63828",

    ste_name: "MO",
  },
  {
    zip_code: "63945",

    ste_name: "MO",
  },
  {
    zip_code: "64089",

    ste_name: "MO",
  },
  {
    zip_code: "64129",

    ste_name: "MO",
  },
  {
    zip_code: "64136",

    ste_name: "MO",
  },
  {
    zip_code: "64151",

    ste_name: "MO",
  },
  {
    zip_code: "64436",

    ste_name: "MO",
  },
  {
    zip_code: "64467",

    ste_name: "MO",
  },
  {
    zip_code: "64644",

    ste_name: "MO",
  },
  {
    zip_code: "22931",

    ste_name: "VA",
  },
  {
    zip_code: "64653",

    ste_name: "MO",
  },
  {
    zip_code: "22949",

    ste_name: "VA",
  },
  {
    zip_code: "65037",

    ste_name: "MO",
  },
  {
    zip_code: "23015",

    ste_name: "VA",
  },
  {
    zip_code: "65061",

    ste_name: "MO",
  },
  {
    zip_code: "23047",

    ste_name: "VA",
  },
  {
    zip_code: "65236",

    ste_name: "MO",
  },
  {
    zip_code: "23072",

    ste_name: "VA",
  },
  {
    zip_code: "65439",

    ste_name: "MO",
  },
  {
    zip_code: "23219",

    ste_name: "VA",
  },
  {
    zip_code: "65543",

    ste_name: "MO",
  },
  {
    zip_code: "23304",

    ste_name: "VA",
  },
  {
    zip_code: "65616",

    ste_name: "MO",
  },
  {
    zip_code: "23434",

    ste_name: "VA",
  },
  {
    zip_code: "65633",

    ste_name: "MO",
  },
  {
    zip_code: "23454",

    ste_name: "VA",
  },
  {
    zip_code: "65656",

    ste_name: "MO",
  },
  {
    zip_code: "23607",

    ste_name: "VA",
  },
  {
    zip_code: "65706",

    ste_name: "MO",
  },
  {
    zip_code: "23875",

    ste_name: "VA",
  },
  {
    zip_code: "65784",

    ste_name: "MO",
  },
  {
    zip_code: "23936",

    ste_name: "VA",
  },
  {
    zip_code: "66097",

    ste_name: "KS",
  },
  {
    zip_code: "23958",

    ste_name: "VA",
  },
  {
    zip_code: "66501",

    ste_name: "KS",
  },
  {
    zip_code: "24089",

    ste_name: "VA",
  },
  {
    zip_code: "66517",

    ste_name: "KS",
  },
  {
    zip_code: "24104",

    ste_name: "VA",
  },
  {
    zip_code: "66522",

    ste_name: "KS",
  },
  {
    zip_code: "24121",

    ste_name: "VA",
  },
  {
    zip_code: "66531",

    ste_name: "KS",
  },
  {
    zip_code: "24131",

    ste_name: "VA",
  },
  {
    zip_code: "66607",

    ste_name: "KS",
  },
  {
    zip_code: "24224",

    ste_name: "VA",
  },
  {
    zip_code: "66776",

    ste_name: "KS",
  },
  {
    zip_code: "24228",

    ste_name: "VA",
  },
  {
    zip_code: "66959",

    ste_name: "KS",
  },
  {
    zip_code: "24260",

    ste_name: "VA",
  },
  {
    zip_code: "67025",

    ste_name: "KS",
  },
  {
    zip_code: "24293",

    ste_name: "VA",
  },
  {
    zip_code: "67051",

    ste_name: "KS",
  },
  {
    zip_code: "24378",

    ste_name: "VA",
  },
  {
    zip_code: "67332",

    ste_name: "KS",
  },
  {
    zip_code: "24457",

    ste_name: "VA",
  },
  {
    zip_code: "67481",

    ste_name: "KS",
  },
  {
    zip_code: "24458",

    ste_name: "VA",
  },
  {
    zip_code: "67631",

    ste_name: "KS",
  },
  {
    zip_code: "24459",

    ste_name: "VA",
  },
  {
    zip_code: "67667",

    ste_name: "KS",
  },
  {
    zip_code: "24527",

    ste_name: "VA",
  },
  {
    zip_code: "67671",

    ste_name: "KS",
  },
  {
    zip_code: "24539",

    ste_name: "VA",
  },
  {
    zip_code: "67801",

    ste_name: "KS",
  },
  {
    zip_code: "24569",

    ste_name: "VA",
  },
  {
    zip_code: "67831",

    ste_name: "KS",
  },
  {
    zip_code: "24628",

    ste_name: "VA",
  },
  {
    zip_code: "67860",

    ste_name: "KS",
  },
  {
    zip_code: "24719",

    ste_name: "WV",
  },
  {
    zip_code: "67864",

    ste_name: "KS",
  },
  {
    zip_code: "24872",

    ste_name: "WV",
  },
  {
    zip_code: "68031",

    ste_name: "NE",
  },
  {
    zip_code: "24991",

    ste_name: "WV",
  },
  {
    zip_code: "68067",

    ste_name: "NE",
  },
  {
    zip_code: "25008",

    ste_name: "WV",
  },
  {
    zip_code: "68144",

    ste_name: "NE",
  },
  {
    zip_code: "25070",

    ste_name: "WV",
  },
  {
    zip_code: "68319",

    ste_name: "NE",
  },
  {
    zip_code: "25110",

    ste_name: "WV",
  },
  {
    zip_code: "68332",

    ste_name: "NE",
  },
  {
    zip_code: "25148",

    ste_name: "WV",
  },
  {
    zip_code: "68336",

    ste_name: "NE",
  },
  {
    zip_code: "25159",

    ste_name: "WV",
  },
  {
    zip_code: "68339",

    ste_name: "NE",
  },
  {
    zip_code: "25193",

    ste_name: "WV",
  },
  {
    zip_code: "68349",

    ste_name: "NE",
  },
  {
    zip_code: "25205",

    ste_name: "WV",
  },
  {
    zip_code: "68406",

    ste_name: "NE",
  },
  {
    zip_code: "25401",

    ste_name: "WV",
  },
  {
    zip_code: "68419",

    ste_name: "NE",
  },
  {
    zip_code: "25430",

    ste_name: "WV",
  },
  {
    zip_code: "68466",

    ste_name: "NE",
  },
  {
    zip_code: "25434",

    ste_name: "WV",
  },
  {
    zip_code: "68647",

    ste_name: "NE",
  },
  {
    zip_code: "25512",

    ste_name: "WV",
  },
  {
    zip_code: "68729",

    ste_name: "NE",
  },
  {
    zip_code: "25535",

    ste_name: "WV",
  },
  {
    zip_code: "68740",

    ste_name: "NE",
  },
  {
    zip_code: "25638",

    ste_name: "WV",
  },
  {
    zip_code: "68745",

    ste_name: "NE",
  },
  {
    zip_code: "25652",

    ste_name: "WV",
  },
  {
    zip_code: "68763",

    ste_name: "NE",
  },
  {
    zip_code: "25672",

    ste_name: "WV",
  },
  {
    zip_code: "68823",

    ste_name: "NE",
  },
  {
    zip_code: "25812",

    ste_name: "WV",
  },
  {
    zip_code: "68901",

    ste_name: "NE",
  },
  {
    zip_code: "25854",

    ste_name: "WV",
  },
  {
    zip_code: "68945",

    ste_name: "NE",
  },
  {
    zip_code: "25901",

    ste_name: "WV",
  },
  {
    zip_code: "68973",

    ste_name: "NE",
  },
  {
    zip_code: "25984",

    ste_name: "WV",
  },
  {
    zip_code: "69127",

    ste_name: "NE",
  },
  {
    zip_code: "26161",

    ste_name: "WV",
  },
  {
    zip_code: "69145",

    ste_name: "NE",
  },
  {
    zip_code: "26585",

    ste_name: "WV",
  },
  {
    zip_code: "69201",

    ste_name: "NE",
  },
  {
    zip_code: "26684",

    ste_name: "WV",
  },
  {
    zip_code: "69345",

    ste_name: "NE",
  },
  {
    zip_code: "26763",

    ste_name: "WV",
  },
  {
    zip_code: "70001",

    ste_name: "LA",
  },
  {
    zip_code: "26767",

    ste_name: "WV",
  },
  {
    zip_code: "70036",

    ste_name: "LA",
  },
  {
    zip_code: "26851",

    ste_name: "WV",
  },
  {
    zip_code: "70039",

    ste_name: "LA",
  },
  {
    zip_code: "27046",

    ste_name: "NC",
  },
  {
    zip_code: "70402",

    ste_name: "LA",
  },
  {
    zip_code: "27320",

    ste_name: "NC",
  },
  {
    zip_code: "70518",

    ste_name: "LA",
  },
  {
    zip_code: "27376",

    ste_name: "NC",
  },
  {
    zip_code: "70601",

    ste_name: "LA",
  },
  {
    zip_code: "27518",

    ste_name: "NC",
  },
  {
    zip_code: "70615",

    ste_name: "LA",
  },
  {
    zip_code: "27527",

    ste_name: "NC",
  },
  {
    zip_code: "70660",

    ste_name: "LA",
  },
  {
    zip_code: "27551",

    ste_name: "NC",
  },
  {
    zip_code: "70662",

    ste_name: "LA",
  },
  {
    zip_code: "27573",

    ste_name: "NC",
  },
  {
    zip_code: "70722",

    ste_name: "LA",
  },
  {
    zip_code: "27577",

    ste_name: "NC",
  },
  {
    zip_code: "70739",

    ste_name: "LA",
  },
  {
    zip_code: "27814",

    ste_name: "NC",
  },
  {
    zip_code: "70802",

    ste_name: "LA",
  },
  {
    zip_code: "27850",

    ste_name: "NC",
  },
  {
    zip_code: "71111",

    ste_name: "LA",
  },
  {
    zip_code: "27883",

    ste_name: "NC",
  },
  {
    zip_code: "71115",

    ste_name: "LA",
  },
  {
    zip_code: "27884",

    ste_name: "NC",
  },
  {
    zip_code: "71280",

    ste_name: "LA",
  },
  {
    zip_code: "27949",

    ste_name: "NC",
  },
  {
    zip_code: "71295",

    ste_name: "LA",
  },
  {
    zip_code: "27957",

    ste_name: "NC",
  },
  {
    zip_code: "71416",

    ste_name: "LA",
  },
  {
    zip_code: "27968",

    ste_name: "NC",
  },
  {
    zip_code: "71427",

    ste_name: "LA",
  },
  {
    zip_code: "28018",

    ste_name: "NC",
  },
  {
    zip_code: "71662",

    ste_name: "AR",
  },
  {
    zip_code: "28034",

    ste_name: "NC",
  },
  {
    zip_code: "71940",

    ste_name: "AR",
  },
  {
    zip_code: "28301",

    ste_name: "NC",
  },
  {
    zip_code: "72026",

    ste_name: "AR",
  },
  {
    zip_code: "28357",

    ste_name: "NC",
  },
  {
    zip_code: "72038",

    ste_name: "AR",
  },
  {
    zip_code: "28396",

    ste_name: "NC",
  },
  {
    zip_code: "72111",

    ste_name: "AR",
  },
  {
    zip_code: "28439",

    ste_name: "NC",
  },
  {
    zip_code: "72114",

    ste_name: "AR",
  },
  {
    zip_code: "28525",

    ste_name: "NC",
  },
  {
    zip_code: "72209",

    ste_name: "AR",
  },
  {
    zip_code: "28590",

    ste_name: "NC",
  },
  {
    zip_code: "72210",

    ste_name: "AR",
  },
  {
    zip_code: "28610",

    ste_name: "NC",
  },
  {
    zip_code: "72311",

    ste_name: "AR",
  },
  {
    zip_code: "28615",

    ste_name: "NC",
  },
  {
    zip_code: "72324",

    ste_name: "AR",
  },
  {
    zip_code: "28637",

    ste_name: "NC",
  },
  {
    zip_code: "72390",

    ste_name: "AR",
  },
  {
    zip_code: "28705",

    ste_name: "NC",
  },
  {
    zip_code: "72469",

    ste_name: "AR",
  },
  {
    zip_code: "28713",

    ste_name: "NC",
  },
  {
    zip_code: "72538",

    ste_name: "AR",
  },
  {
    zip_code: "28719",

    ste_name: "NC",
  },
  {
    zip_code: "72577",

    ste_name: "AR",
  },
  {
    zip_code: "28754",

    ste_name: "NC",
  },
  {
    zip_code: "72624",

    ste_name: "AR",
  },
  {
    zip_code: "28792",

    ste_name: "NC",
  },
  {
    zip_code: "72638",

    ste_name: "AR",
  },
  {
    zip_code: "29052",

    ste_name: "SC",
  },
  {
    zip_code: "72658",

    ste_name: "AR",
  },
  {
    zip_code: "29079",

    ste_name: "SC",
  },
  {
    zip_code: "72739",

    ste_name: "AR",
  },
  {
    zip_code: "29126",

    ste_name: "SC",
  },
  {
    zip_code: "72751",

    ste_name: "AR",
  },
  {
    zip_code: "29147",

    ste_name: "SC",
  },
  {
    zip_code: "72824",

    ste_name: "AR",
  },
  {
    zip_code: "29164",

    ste_name: "SC",
  },
  {
    zip_code: "72851",

    ste_name: "AR",
  },
  {
    zip_code: "29166",

    ste_name: "SC",
  },
  {
    zip_code: "72923",

    ste_name: "AR",
  },
  {
    zip_code: "29180",

    ste_name: "SC",
  },
  {
    zip_code: "73028",

    ste_name: "OK",
  },
  {
    zip_code: "29333",

    ste_name: "SC",
  },
  {
    zip_code: "73038",

    ste_name: "OK",
  },
  {
    zip_code: "29334",

    ste_name: "SC",
  },
  {
    zip_code: "73068",

    ste_name: "OK",
  },
  {
    zip_code: "29375",

    ste_name: "SC",
  },
  {
    zip_code: "73118",

    ste_name: "OK",
  },
  {
    zip_code: "29436",

    ste_name: "SC",
  },
  {
    zip_code: "73132",

    ste_name: "OK",
  },
  {
    zip_code: "29453",

    ste_name: "SC",
  },
  {
    zip_code: "73170",

    ste_name: "OK",
  },
  {
    zip_code: "29468",

    ste_name: "SC",
  },
  {
    zip_code: "73440",

    ste_name: "OK",
  },
  {
    zip_code: "29525",

    ste_name: "SC",
  },
  {
    zip_code: "73564",

    ste_name: "OK",
  },
  {
    zip_code: "29554",

    ste_name: "SC",
  },
  {
    zip_code: "73860",

    ste_name: "OK",
  },
  {
    zip_code: "29579",

    ste_name: "SC",
  },
  {
    zip_code: "74011",

    ste_name: "OK",
  },
  {
    zip_code: "29580",

    ste_name: "SC",
  },
  {
    zip_code: "74068",

    ste_name: "OK",
  },
  {
    zip_code: "29621",

    ste_name: "SC",
  },
  {
    zip_code: "74347",

    ste_name: "OK",
  },
  {
    zip_code: "29640",

    ste_name: "SC",
  },
  {
    zip_code: "74364",

    ste_name: "OK",
  },
  {
    zip_code: "29712",

    ste_name: "SC",
  },
  {
    zip_code: "74432",

    ste_name: "OK",
  },
  {
    zip_code: "29743",

    ste_name: "SC",
  },
  {
    zip_code: "74445",

    ste_name: "OK",
  },
  {
    zip_code: "29805",

    ste_name: "SC",
  },
  {
    zip_code: "74467",

    ste_name: "OK",
  },
  {
    zip_code: "29816",

    ste_name: "SC",
  },
  {
    zip_code: "74723",

    ste_name: "OK",
  },
  {
    zip_code: "29912",

    ste_name: "SC",
  },
  {
    zip_code: "74845",

    ste_name: "OK",
  },
  {
    zip_code: "30024",

    ste_name: "GA",
  },
  {
    zip_code: "74850",

    ste_name: "OK",
  },
  {
    zip_code: "30025",

    ste_name: "GA",
  },
  {
    zip_code: "75068",

    ste_name: "TX",
  },
  {
    zip_code: "30052",

    ste_name: "GA",
  },
  {
    zip_code: "75102",

    ste_name: "TX",
  },
  {
    zip_code: "30107",

    ste_name: "GA",
  },
  {
    zip_code: "75127",

    ste_name: "TX",
  },
  {
    zip_code: "30145",

    ste_name: "GA",
  },
  {
    zip_code: "75147",

    ste_name: "TX",
  },
  {
    zip_code: "30233",

    ste_name: "GA",
  },
  {
    zip_code: "75223",

    ste_name: "TX",
  },
  {
    zip_code: "30336",

    ste_name: "GA",
  },
  {
    zip_code: "75225",

    ste_name: "TX",
  },
  {
    zip_code: "30350",

    ste_name: "GA",
  },
  {
    zip_code: "75428",

    ste_name: "TX",
  },
  {
    zip_code: "30458",

    ste_name: "GA",
  },
  {
    zip_code: "75562",

    ste_name: "TX",
  },
  {
    zip_code: "30460",

    ste_name: "GA",
  },
  {
    zip_code: "75683",

    ste_name: "TX",
  },
  {
    zip_code: "30533",

    ste_name: "GA",
  },
  {
    zip_code: "75704",

    ste_name: "TX",
  },
  {
    zip_code: "30557",

    ste_name: "GA",
  },
  {
    zip_code: "75764",

    ste_name: "TX",
  },
  {
    zip_code: "30667",

    ste_name: "GA",
  },
  {
    zip_code: "75848",

    ste_name: "TX",
  },
  {
    zip_code: "30813",

    ste_name: "GA",
  },
  {
    zip_code: "75937",

    ste_name: "TX",
  },
  {
    zip_code: "30816",

    ste_name: "GA",
  },
  {
    zip_code: "76022",

    ste_name: "TX",
  },
  {
    zip_code: "31001",

    ste_name: "GA",
  },
  {
    zip_code: "76102",

    ste_name: "TX",
  },
  {
    zip_code: "31015",

    ste_name: "GA",
  },
  {
    zip_code: "76129",

    ste_name: "TX",
  },
  {
    zip_code: "31055",

    ste_name: "GA",
  },
  {
    zip_code: "76182",

    ste_name: "TX",
  },
  {
    zip_code: "31063",

    ste_name: "GA",
  },
  {
    zip_code: "76252",

    ste_name: "TX",
  },
  {
    zip_code: "31543",

    ste_name: "GA",
  },
  {
    zip_code: "76258",

    ste_name: "TX",
  },
  {
    zip_code: "31549",

    ste_name: "GA",
  },
  {
    zip_code: "76402",

    ste_name: "TX",
  },
  {
    zip_code: "31567",

    ste_name: "GA",
  },
  {
    zip_code: "76455",

    ste_name: "TX",
  },
  {
    zip_code: "31638",

    ste_name: "GA",
  },
  {
    zip_code: "76460",

    ste_name: "TX",
  },
  {
    zip_code: "31642",

    ste_name: "GA",
  },
  {
    zip_code: "76655",

    ste_name: "TX",
  },
  {
    zip_code: "31699",

    ste_name: "GA",
  },
  {
    zip_code: "76802",

    ste_name: "TX",
  },
  {
    zip_code: "31711",

    ste_name: "GA",
  },
  {
    zip_code: "76823",

    ste_name: "TX",
  },
  {
    zip_code: "31765",

    ste_name: "GA",
  },
  {
    zip_code: "76885",

    ste_name: "TX",
  },
  {
    zip_code: "31811",

    ste_name: "GA",
  },
  {
    zip_code: "76901",

    ste_name: "TX",
  },
  {
    zip_code: "31821",

    ste_name: "GA",
  },
  {
    zip_code: "77019",

    ste_name: "TX",
  },
  {
    zip_code: "32162",

    ste_name: "FL",
  },
  {
    zip_code: "77046",

    ste_name: "TX",
  },
  {
    zip_code: "32277",

    ste_name: "FL",
  },
  {
    zip_code: "77062",

    ste_name: "TX",
  },
  {
    zip_code: "32569",

    ste_name: "FL",
  },
  {
    zip_code: "77081",

    ste_name: "TX",
  },
  {
    zip_code: "32664",

    ste_name: "FL",
  },
  {
    zip_code: "77096",

    ste_name: "TX",
  },
  {
    zip_code: "32697",

    ste_name: "FL",
  },
  {
    zip_code: "77339",

    ste_name: "TX",
  },
  {
    zip_code: "32773",

    ste_name: "FL",
  },
  {
    zip_code: "77355",

    ste_name: "TX",
  },
  {
    zip_code: "32901",

    ste_name: "FL",
  },
  {
    zip_code: "77376",

    ste_name: "TX",
  },
  {
    zip_code: "32908",

    ste_name: "FL",
  },
  {
    zip_code: "77460",

    ste_name: "TX",
  },
  {
    zip_code: "32949",

    ste_name: "FL",
  },
  {
    zip_code: "77489",

    ste_name: "TX",
  },
  {
    zip_code: "32951",

    ste_name: "FL",
  },
  {
    zip_code: "77518",

    ste_name: "TX",
  },
  {
    zip_code: "32976",

    ste_name: "FL",
  },
  {
    zip_code: "77535",

    ste_name: "TX",
  },
  {
    zip_code: "33009",

    ste_name: "FL",
  },
  {
    zip_code: "77585",

    ste_name: "TX",
  },
  {
    zip_code: "33029",

    ste_name: "FL",
  },
  {
    zip_code: "77659",

    ste_name: "TX",
  },
  {
    zip_code: "33146",

    ste_name: "FL",
  },
  {
    zip_code: "77708",

    ste_name: "TX",
  },
  {
    zip_code: "33194",

    ste_name: "FL",
  },
  {
    zip_code: "77853",

    ste_name: "TX",
  },
  {
    zip_code: "33436",

    ste_name: "FL",
  },
  {
    zip_code: "78112",

    ste_name: "TX",
  },
  {
    zip_code: "33460",

    ste_name: "FL",
  },
  {
    zip_code: "78121",

    ste_name: "TX",
  },
  {
    zip_code: "33511",

    ste_name: "FL",
  },
  {
    zip_code: "78163",

    ste_name: "TX",
  },
  {
    zip_code: "33592",

    ste_name: "FL",
  },
  {
    zip_code: "78217",

    ste_name: "TX",
  },
  {
    zip_code: "33637",

    ste_name: "FL",
  },
  {
    zip_code: "78237",

    ste_name: "TX",
  },
  {
    zip_code: "33647",

    ste_name: "FL",
  },
  {
    zip_code: "78245",

    ste_name: "TX",
  },
  {
    zip_code: "33702",

    ste_name: "FL",
  },
  {
    zip_code: "78248",

    ste_name: "TX",
  },
  {
    zip_code: "33764",

    ste_name: "FL",
  },
  {
    zip_code: "78252",

    ste_name: "TX",
  },
  {
    zip_code: "33830",

    ste_name: "FL",
  },
  {
    zip_code: "78263",

    ste_name: "TX",
  },
  {
    zip_code: "33849",

    ste_name: "FL",
  },
  {
    zip_code: "78359",

    ste_name: "TX",
  },
  {
    zip_code: "33872",

    ste_name: "FL",
  },
  {
    zip_code: "78563",

    ste_name: "TX",
  },
  {
    zip_code: "33875",

    ste_name: "FL",
  },
  {
    zip_code: "78583",

    ste_name: "TX",
  },
  {
    zip_code: "34110",

    ste_name: "FL",
  },
  {
    zip_code: "78724",

    ste_name: "TX",
  },
  {
    zip_code: "34140",

    ste_name: "FL",
  },
  {
    zip_code: "78742",

    ste_name: "TX",
  },
  {
    zip_code: "34215",

    ste_name: "FL",
  },
  {
    zip_code: "78756",

    ste_name: "TX",
  },
  {
    zip_code: "34217",

    ste_name: "FL",
  },
  {
    zip_code: "78877",

    ste_name: "TX",
  },
  {
    zip_code: "34242",

    ste_name: "FL",
  },
  {
    zip_code: "78883",

    ste_name: "TX",
  },
  {
    zip_code: "34436",

    ste_name: "FL",
  },
  {
    zip_code: "78957",

    ste_name: "TX",
  },
  {
    zip_code: "34472",

    ste_name: "FL",
  },
  {
    zip_code: "78959",

    ste_name: "TX",
  },
  {
    zip_code: "34653",

    ste_name: "FL",
  },
  {
    zip_code: "79085",

    ste_name: "TX",
  },
  {
    zip_code: "34681",

    ste_name: "FL",
  },
  {
    zip_code: "79258",

    ste_name: "TX",
  },
  {
    zip_code: "34691",

    ste_name: "FL",
  },
  {
    zip_code: "79353",

    ste_name: "TX",
  },
  {
    zip_code: "34953",

    ste_name: "FL",
  },
  {
    zip_code: "79382",

    ste_name: "TX",
  },
  {
    zip_code: "35061",

    ste_name: "AL",
  },
  {
    zip_code: "79539",

    ste_name: "TX",
  },
  {
    zip_code: "35074",

    ste_name: "AL",
  },
  {
    zip_code: "79733",

    ste_name: "TX",
  },
  {
    zip_code: "35124",

    ste_name: "AL",
  },
  {
    zip_code: "79734",

    ste_name: "TX",
  },
  {
    zip_code: "35151",

    ste_name: "AL",
  },
  {
    zip_code: "80018",

    ste_name: "CO",
  },
  {
    zip_code: "35228",

    ste_name: "AL",
  },
  {
    zip_code: "80025",

    ste_name: "CO",
  },
  {
    zip_code: "35476",

    ste_name: "AL",
  },
  {
    zip_code: "80108",

    ste_name: "CO",
  },
  {
    zip_code: "35648",

    ste_name: "AL",
  },
  {
    zip_code: "80305",

    ste_name: "CO",
  },
  {
    zip_code: "35744",

    ste_name: "AL",
  },
  {
    zip_code: "80498",

    ste_name: "CO",
  },
  {
    zip_code: "35808",

    ste_name: "AL",
  },
  {
    zip_code: "80550",

    ste_name: "CO",
  },
  {
    zip_code: "35990",

    ste_name: "AL",
  },
  {
    zip_code: "80601",

    ste_name: "CO",
  },
  {
    zip_code: "36003",

    ste_name: "AL",
  },
  {
    zip_code: "80745",

    ste_name: "CO",
  },
  {
    zip_code: "36005",

    ste_name: "AL",
  },
  {
    zip_code: "80817",

    ste_name: "CO",
  },
  {
    zip_code: "36028",

    ste_name: "AL",
  },
  {
    zip_code: "81054",

    ste_name: "CO",
  },
  {
    zip_code: "36030",

    ste_name: "AL",
  },
  {
    zip_code: "81081",

    ste_name: "CO",
  },
  {
    zip_code: "36051",

    ste_name: "AL",
  },
  {
    zip_code: "81230",

    ste_name: "CO",
  },
  {
    zip_code: "36203",

    ste_name: "AL",
  },
  {
    zip_code: "81239",

    ste_name: "CO",
  },
  {
    zip_code: "36276",

    ste_name: "AL",
  },
  {
    zip_code: "81632",

    ste_name: "CO",
  },
  {
    zip_code: "36401",

    ste_name: "AL",
  },
  {
    zip_code: "82212",

    ste_name: "WY",
  },
  {
    zip_code: "36524",

    ste_name: "AL",
  },
  {
    zip_code: "82842",

    ste_name: "WY",
  },
  {
    zip_code: "36544",

    ste_name: "AL",
  },
  {
    zip_code: "83101",

    ste_name: "WY",
  },
  {
    zip_code: "36765",

    ste_name: "AL",
  },
  {
    zip_code: "83110",

    ste_name: "WY",
  },
  {
    zip_code: "36782",

    ste_name: "AL",
  },
  {
    zip_code: "83118",

    ste_name: "WY",
  },
  {
    zip_code: "36785",

    ste_name: "AL",
  },
  {
    zip_code: "83202",

    ste_name: "ID",
  },
  {
    zip_code: "36804",

    ste_name: "AL",
  },
  {
    zip_code: "83220",

    ste_name: "ID",
  },
  {
    zip_code: "36854",

    ste_name: "AL",
  },
  {
    zip_code: "83334",

    ste_name: "ID",
  },
  {
    zip_code: "36921",

    ste_name: "AL",
  },
  {
    zip_code: "83440",

    ste_name: "ID",
  },
  {
    zip_code: "37016",

    ste_name: "TN",
  },
  {
    zip_code: "83501",

    ste_name: "ID",
  },
  {
    zip_code: "37026",

    ste_name: "TN",
  },
  {
    zip_code: "83622",

    ste_name: "ID",
  },
  {
    zip_code: "37146",

    ste_name: "TN",
  },
  {
    zip_code: "83827",

    ste_name: "ID",
  },
  {
    zip_code: "37151",

    ste_name: "TN",
  },
  {
    zip_code: "83857",

    ste_name: "ID",
  },
  {
    zip_code: "37160",

    ste_name: "TN",
  },
  {
    zip_code: "84027",

    ste_name: "UT",
  },
  {
    zip_code: "37218",

    ste_name: "TN",
  },
  {
    zip_code: "84072",

    ste_name: "UT",
  },
  {
    zip_code: "37306",

    ste_name: "TN",
  },
  {
    zip_code: "84106",

    ste_name: "UT",
  },
  {
    zip_code: "37362",

    ste_name: "TN",
  },
  {
    zip_code: "84629",

    ste_name: "UT",
  },
  {
    zip_code: "37374",

    ste_name: "TN",
  },
  {
    zip_code: "84654",

    ste_name: "UT",
  },
  {
    zip_code: "37387",

    ste_name: "TN",
  },
  {
    zip_code: "84726",

    ste_name: "UT",
  },
  {
    zip_code: "37686",

    ste_name: "TN",
  },
  {
    zip_code: "84735",

    ste_name: "UT",
  },
  {
    zip_code: "37719",

    ste_name: "TN",
  },
  {
    zip_code: "85006",

    ste_name: "AZ",
  },
  {
    zip_code: "37754",

    ste_name: "TN",
  },
  {
    zip_code: "85044",

    ste_name: "AZ",
  },
  {
    zip_code: "37772",

    ste_name: "TN",
  },
  {
    zip_code: "85120",

    ste_name: "AZ",
  },
  {
    zip_code: "37849",

    ste_name: "TN",
  },
  {
    zip_code: "85204",

    ste_name: "AZ",
  },
  {
    zip_code: "37882",

    ste_name: "TN",
  },
  {
    zip_code: "85208",

    ste_name: "AZ",
  },
  {
    zip_code: "38007",

    ste_name: "TN",
  },
  {
    zip_code: "85332",

    ste_name: "AZ",
  },
  {
    zip_code: "38034",

    ste_name: "TN",
  },
  {
    zip_code: "85610",

    ste_name: "AZ",
  },
  {
    zip_code: "38039",

    ste_name: "TN",
  },
  {
    zip_code: "85615",

    ste_name: "AZ",
  },
  {
    zip_code: "38044",

    ste_name: "TN",
  },
  {
    zip_code: "85730",

    ste_name: "AZ",
  },
  {
    zip_code: "38052",

    ste_name: "TN",
  },
  {
    zip_code: "85745",

    ste_name: "AZ",
  },
  {
    zip_code: "38543",

    ste_name: "TN",
  },
  {
    zip_code: "86004",

    ste_name: "AZ",
  },
  {
    zip_code: "38544",

    ste_name: "TN",
  },
  {
    zip_code: "86045",

    ste_name: "AZ",
  },
  {
    zip_code: "38549",

    ste_name: "TN",
  },
  {
    zip_code: "86512",

    ste_name: "AZ",
  },
  {
    zip_code: "38562",

    ste_name: "TN",
  },
  {
    zip_code: "87010",

    ste_name: "NM",
  },
  {
    zip_code: "38579",

    ste_name: "TN",
  },
  {
    zip_code: "87038",

    ste_name: "NM",
  },
  {
    zip_code: "38610",

    ste_name: "MS",
  },
  {
    zip_code: "87105",

    ste_name: "NM",
  },
  {
    zip_code: "38625",

    ste_name: "MS",
  },
  {
    zip_code: "87106",

    ste_name: "NM",
  },
  {
    zip_code: "38629",

    ste_name: "MS",
  },
  {
    zip_code: "87123",

    ste_name: "NM",
  },
  {
    zip_code: "38748",

    ste_name: "MS",
  },
  {
    zip_code: "87544",

    ste_name: "NM",
  },
  {
    zip_code: "38769",

    ste_name: "MS",
  },
  {
    zip_code: "87557",

    ste_name: "NM",
  },
  {
    zip_code: "38928",

    ste_name: "MS",
  },
  {
    zip_code: "87571",

    ste_name: "NM",
  },
  {
    zip_code: "38951",

    ste_name: "MS",
  },
  {
    zip_code: "87724",

    ste_name: "NM",
  },
  {
    zip_code: "38957",

    ste_name: "MS",
  },
  {
    zip_code: "87942",

    ste_name: "NM",
  },
  {
    zip_code: "39045",

    ste_name: "MS",
  },
  {
    zip_code: "88043",

    ste_name: "NM",
  },
  {
    zip_code: "39090",

    ste_name: "MS",
  },
  {
    zip_code: "88065",

    ste_name: "NM",
  },
  {
    zip_code: "39156",

    ste_name: "MS",
  },
  {
    zip_code: "88220",

    ste_name: "NM",
  },
  {
    zip_code: "39209",

    ste_name: "MS",
  },
  {
    zip_code: "88354",

    ste_name: "NM",
  },
  {
    zip_code: "39269",

    ste_name: "MS",
  },
  {
    zip_code: "89022",

    ste_name: "NV",
  },
  {
    zip_code: "39328",

    ste_name: "MS",
  },
  {
    zip_code: "89044",

    ste_name: "NV",
  },
  {
    zip_code: "39406",

    ste_name: "MS",
  },
  {
    zip_code: "89054",

    ste_name: "NV",
  },
  {
    zip_code: "39437",

    ste_name: "MS",
  },
  {
    zip_code: "89118",

    ste_name: "NV",
  },
  {
    zip_code: "39459",

    ste_name: "MS",
  },
  {
    zip_code: "89442",

    ste_name: "NV",
  },
  {
    zip_code: "39462",

    ste_name: "MS",
  },
  {
    zip_code: "89706",

    ste_name: "NV",
  },
  {
    zip_code: "39664",

    ste_name: "MS",
  },
  {
    zip_code: "89883",

    ste_name: "NV",
  },
  {
    zip_code: "39854",

    ste_name: "GA",
  },
  {
    zip_code: "90025",

    ste_name: "CA",
  },
  {
    zip_code: "40025",

    ste_name: "KY",
  },
  {
    zip_code: "90041",

    ste_name: "CA",
  },
  {
    zip_code: "40049",

    ste_name: "KY",
  },
  {
    zip_code: "90046",

    ste_name: "CA",
  },
  {
    zip_code: "40069",

    ste_name: "KY",
  },
  {
    zip_code: "90262",

    ste_name: "CA",
  },
  {
    zip_code: "40144",

    ste_name: "KY",
  },
  {
    zip_code: "90623",

    ste_name: "CA",
  },
  {
    zip_code: "40299",

    ste_name: "KY",
  },
  {
    zip_code: "90810",

    ste_name: "CA",
  },
  {
    zip_code: "40336",

    ste_name: "KY",
  },
  {
    zip_code: "91206",

    ste_name: "CA",
  },
  {
    zip_code: "40763",

    ste_name: "KY",
  },
  {
    zip_code: "91344",

    ste_name: "CA",
  },
  {
    zip_code: "40813",

    ste_name: "KY",
  },
  {
    zip_code: "91354",

    ste_name: "CA",
  },
  {
    zip_code: "40819",

    ste_name: "KY",
  },
  {
    zip_code: "91361",

    ste_name: "CA",
  },
  {
    zip_code: "40915",

    ste_name: "KY",
  },
  {
    zip_code: "91737",

    ste_name: "CA",
  },
  {
    zip_code: "40946",

    ste_name: "KY",
  },
  {
    zip_code: "91744",

    ste_name: "CA",
  },
  {
    zip_code: "41035",

    ste_name: "KY",
  },
  {
    zip_code: "91905",

    ste_name: "CA",
  },
  {
    zip_code: "41135",

    ste_name: "KY",
  },
  {
    zip_code: "92127",

    ste_name: "CA",
  },
  {
    zip_code: "41183",

    ste_name: "KY",
  },
  {
    zip_code: "92240",

    ste_name: "CA",
  },
  {
    zip_code: "41367",

    ste_name: "KY",
  },
  {
    zip_code: "92610",

    ste_name: "CA",
  },
  {
    zip_code: "41522",

    ste_name: "KY",
  },
  {
    zip_code: "92620",

    ste_name: "CA",
  },
  {
    zip_code: "41534",

    ste_name: "KY",
  },
  {
    zip_code: "92675",

    ste_name: "CA",
  },
  {
    zip_code: "41622",

    ste_name: "KY",
  },
  {
    zip_code: "93108",

    ste_name: "CA",
  },
  {
    zip_code: "41636",

    ste_name: "KY",
  },
  {
    zip_code: "93222",

    ste_name: "CA",
  },
  {
    zip_code: "41645",

    ste_name: "KY",
  },
  {
    zip_code: "93430",

    ste_name: "CA",
  },
  {
    zip_code: "41660",

    ste_name: "KY",
  },
  {
    zip_code: "93517",

    ste_name: "CA",
  },
  {
    zip_code: "41735",

    ste_name: "KY",
  },
  {
    zip_code: "93662",

    ste_name: "CA",
  },
  {
    zip_code: "41754",

    ste_name: "KY",
  },
  {
    zip_code: "94043",

    ste_name: "CA",
  },
  {
    zip_code: "41810",

    ste_name: "KY",
  },
  {
    zip_code: "94105",

    ste_name: "CA",
  },
  {
    zip_code: "41840",

    ste_name: "KY",
  },
  {
    zip_code: "94109",

    ste_name: "CA",
  },
  {
    zip_code: "42086",

    ste_name: "KY",
  },
  {
    zip_code: "94508",

    ste_name: "CA",
  },
  {
    zip_code: "42102",

    ste_name: "KY",
  },
  {
    zip_code: "94523",

    ste_name: "CA",
  },
  {
    zip_code: "42163",

    ste_name: "KY",
  },
  {
    zip_code: "94545",

    ste_name: "CA",
  },
  {
    zip_code: "42220",

    ste_name: "KY",
  },
  {
    zip_code: "94937",

    ste_name: "CA",
  },
  {
    zip_code: "42276",

    ste_name: "KY",
  },
  {
    zip_code: "94949",

    ste_name: "CA",
  },
  {
    zip_code: "42301",

    ste_name: "KY",
  },
  {
    zip_code: "94957",

    ste_name: "CA",
  },
  {
    zip_code: "42461",

    ste_name: "KY",
  },
  {
    zip_code: "94963",

    ste_name: "CA",
  },
  {
    zip_code: "42729",

    ste_name: "KY",
  },
  {
    zip_code: "95065",

    ste_name: "CA",
  },
  {
    zip_code: "42782",

    ste_name: "KY",
  },
  {
    zip_code: "95113",

    ste_name: "CA",
  },
  {
    zip_code: "42784",

    ste_name: "KY",
  },
  {
    zip_code: "95123",

    ste_name: "CA",
  },
  {
    zip_code: "43019",

    ste_name: "OH",
  },
  {
    zip_code: "95210",

    ste_name: "CA",
  },
  {
    zip_code: "43202",

    ste_name: "OH",
  },
  {
    zip_code: "95333",

    ste_name: "CA",
  },
  {
    zip_code: "43240",

    ste_name: "OH",
  },
  {
    zip_code: "95356",

    ste_name: "CA",
  },
  {
    zip_code: "43315",

    ste_name: "OH",
  },
  {
    zip_code: "95368",

    ste_name: "CA",
  },
  {
    zip_code: "43403",

    ste_name: "OH",
  },
  {
    zip_code: "95376",

    ste_name: "CA",
  },
  {
    zip_code: "43443",

    ste_name: "OH",
  },
  {
    zip_code: "95409",

    ste_name: "CA",
  },
  {
    zip_code: "43449",

    ste_name: "OH",
  },
  {
    zip_code: "95426",

    ste_name: "CA",
  },
  {
    zip_code: "43456",

    ste_name: "OH",
  },
  {
    zip_code: "95466",

    ste_name: "CA",
  },
  {
    zip_code: "43465",

    ste_name: "OH",
  },
  {
    zip_code: "95629",

    ste_name: "CA",
  },
  {
    zip_code: "43511",

    ste_name: "OH",
  },
  {
    zip_code: "95630",

    ste_name: "CA",
  },
  {
    zip_code: "43549",

    ste_name: "OH",
  },
  {
    zip_code: "95688",

    ste_name: "CA",
  },
  {
    zip_code: "43565",

    ste_name: "OH",
  },
  {
    zip_code: "95776",

    ste_name: "CA",
  },
  {
    zip_code: "43614",

    ste_name: "OH",
  },
  {
    zip_code: "95819",

    ste_name: "CA",
  },
  {
    zip_code: "43736",

    ste_name: "OH",
  },
  {
    zip_code: "95830",

    ste_name: "CA",
  },
  {
    zip_code: "43844",

    ste_name: "OH",
  },
  {
    zip_code: "95833",

    ste_name: "CA",
  },
  {
    zip_code: "43914",

    ste_name: "OH",
  },
  {
    zip_code: "95841",

    ste_name: "CA",
  },
  {
    zip_code: "43915",

    ste_name: "OH",
  },
  {
    zip_code: "95991",

    ste_name: "CA",
  },
  {
    zip_code: "43928",

    ste_name: "OH",
  },
  {
    zip_code: "96003",

    ste_name: "CA",
  },
  {
    zip_code: "43976",

    ste_name: "OH",
  },
  {
    zip_code: "96056",

    ste_name: "CA",
  },
  {
    zip_code: "44010",

    ste_name: "OH",
  },
  {
    zip_code: "96064",

    ste_name: "CA",
  },
  {
    zip_code: "44046",

    ste_name: "OH",
  },
  {
    zip_code: "96084",

    ste_name: "CA",
  },
  {
    zip_code: "44072",

    ste_name: "OH",
  },
  {
    zip_code: "96706",

    ste_name: "HI",
  },
  {
    zip_code: "44085",

    ste_name: "OH",
  },
  {
    zip_code: "96714",

    ste_name: "HI",
  },
  {
    zip_code: "44136",

    ste_name: "OH",
  },
  {
    zip_code: "96717",

    ste_name: "HI",
  },
  {
    zip_code: "44201",

    ste_name: "OH",
  },
  {
    zip_code: "96813",

    ste_name: "HI",
  },
  {
    zip_code: "44214",

    ste_name: "OH",
  },
  {
    zip_code: "97114",

    ste_name: "OR",
  },
  {
    zip_code: "44306",

    ste_name: "OH",
  },
  {
    zip_code: "97121",

    ste_name: "OR",
  },
  {
    zip_code: "44439",

    ste_name: "OH",
  },
  {
    zip_code: "97127",

    ste_name: "OR",
  },
  {
    zip_code: "44481",

    ste_name: "OH",
  },
  {
    zip_code: "97338",

    ste_name: "OR",
  },
  {
    zip_code: "44645",

    ste_name: "OH",
  },
  {
    zip_code: "97401",

    ste_name: "OR",
  },
  {
    zip_code: "44663",

    ste_name: "OH",
  },
  {
    zip_code: "97478",

    ste_name: "OR",
  },
  {
    zip_code: "44688",

    ste_name: "OH",
  },
  {
    zip_code: "97492",

    ste_name: "OR",
  },
  {
    zip_code: "44807",

    ste_name: "OH",
  },
  {
    zip_code: "97498",

    ste_name: "OR",
  },
  {
    zip_code: "44827",

    ste_name: "OH",
  },
  {
    zip_code: "97637",

    ste_name: "OR",
  },
  {
    zip_code: "45039",

    ste_name: "OH",
  },
  {
    zip_code: "97838",

    ste_name: "OR",
  },
  {
    zip_code: "45070",

    ste_name: "OH",
  },
  {
    zip_code: "98002",

    ste_name: "WA",
  },
  {
    zip_code: "45131",

    ste_name: "OH",
  },
  {
    zip_code: "98037",

    ste_name: "WA",
  },
  {
    zip_code: "45158",

    ste_name: "OH",
  },
  {
    zip_code: "98042",

    ste_name: "WA",
  },
  {
    zip_code: "45174",

    ste_name: "OH",
  },
  {
    zip_code: "98055",

    ste_name: "WA",
  },
  {
    zip_code: "45216",

    ste_name: "OH",
  },
  {
    zip_code: "98119",

    ste_name: "WA",
  },
  {
    zip_code: "45244",

    ste_name: "OH",
  },
  {
    zip_code: "98222",

    ste_name: "WA",
  },
  {
    zip_code: "45325",

    ste_name: "OH",
  },
  {
    zip_code: "98226",

    ste_name: "WA",
  },
  {
    zip_code: "45341",

    ste_name: "OH",
  },
  {
    zip_code: "98238",

    ste_name: "WA",
  },
  {
    zip_code: "45402",

    ste_name: "OH",
  },
  {
    zip_code: "98247",

    ste_name: "WA",
  },
  {
    zip_code: "45426",

    ste_name: "OH",
  },
  {
    zip_code: "98312",

    ste_name: "WA",
  },
  {
    zip_code: "45631",

    ste_name: "OH",
  },
  {
    zip_code: "98350",

    ste_name: "WA",
  },
  {
    zip_code: "45642",

    ste_name: "OH",
  },
  {
    zip_code: "98356",

    ste_name: "WA",
  },
  {
    zip_code: "45846",

    ste_name: "OH",
  },
  {
    zip_code: "98382",

    ste_name: "WA",
  },
  {
    zip_code: "45860",

    ste_name: "OH",
  },
  {
    zip_code: "98564",

    ste_name: "WA",
  },
  {
    zip_code: "45883",

    ste_name: "OH",
  },
  {
    zip_code: "98579",

    ste_name: "WA",
  },
  {
    zip_code: "46040",

    ste_name: "IN",
  },
  {
    zip_code: "99033",

    ste_name: "WA",
  },
  {
    zip_code: "46055",

    ste_name: "IN",
  },
  {
    zip_code: "99125",

    ste_name: "WA",
  },
  {
    zip_code: "46146",

    ste_name: "IN",
  },
  {
    zip_code: "99134",

    ste_name: "WA",
  },
  {
    zip_code: "46218",

    ste_name: "IN",
  },
  {
    zip_code: "99144",

    ste_name: "WA",
  },
  {
    zip_code: "46229",

    ste_name: "IN",
  },
  {
    zip_code: "99350",

    ste_name: "WA",
  },
  {
    zip_code: "46290",

    ste_name: "IN",
  },
  {
    zip_code: "99515",

    ste_name: "AK",
  },
  {
    zip_code: "46404",

    ste_name: "IN",
  },
  {
    zip_code: "99552",

    ste_name: "AK",
  },
  {
    zip_code: "46405",

    ste_name: "IN",
  },
  {
    zip_code: "99554",

    ste_name: "AK",
  },
  {
    zip_code: "46562",

    ste_name: "IN",
  },
  {
    zip_code: "99613",

    ste_name: "AK",
  },
  {
    zip_code: "46565",

    ste_name: "IN",
  },
  {
    zip_code: "99658",

    ste_name: "AK",
  },
  {
    zip_code: "46723",

    ste_name: "IN",
  },
  {
    zip_code: "99738",

    ste_name: "AK",
  },
  {
    zip_code: "46910",

    ste_name: "IN",
  },
  {
    zip_code: "99740",

    ste_name: "AK",
  },
  {
    zip_code: "46946",

    ste_name: "IN",
  },
  {
    zip_code: "99749",

    ste_name: "AK",
  },
  {
    zip_code: "46951",

    ste_name: "IN",
  },
  {
    zip_code: "93033",

    ste_name: "CA",
  },
  {
    zip_code: "47114",

    ste_name: "IN",
  },
  {
    zip_code: "93265",

    ste_name: "CA",
  },
  {
    zip_code: "47147",

    ste_name: "IN",
  },
  {
    zip_code: "47220",

    ste_name: "IN",
  },
  {
    zip_code: "47229",

    ste_name: "IN",
  },
  {
    zip_code: "47270",

    ste_name: "IN",
  },
  {
    zip_code: "47280",

    ste_name: "IN",
  },
  {
    zip_code: "47373",

    ste_name: "IN",
  },
  {
    zip_code: "47390",

    ste_name: "IN",
  },
  {
    zip_code: "47520",

    ste_name: "IN",
  },
  {
    zip_code: "47585",

    ste_name: "IN",
  },
  {
    zip_code: "47857",

    ste_name: "IN",
  },
  {
    zip_code: "47966",

    ste_name: "IN",
  },
  {
    zip_code: "48002",

    ste_name: "MI",
  },
  {
    zip_code: "48072",

    ste_name: "MI",
  },
  {
    zip_code: "48114",

    ste_name: "MI",
  },
  {
    zip_code: "48185",

    ste_name: "MI",
  },
  {
    zip_code: "48217",

    ste_name: "MI",
  },
  {
    zip_code: "48227",

    ste_name: "MI",
  },
  {
    zip_code: "48334",

    ste_name: "MI",
  },
  {
    zip_code: "48432",

    ste_name: "MI",
  },
  {
    zip_code: "48616",

    ste_name: "MI",
  },
  {
    zip_code: "48624",

    ste_name: "MI",
  },
  {
    zip_code: "48627",

    ste_name: "MI",
  },
  {
    zip_code: "48747",

    ste_name: "MI",
  },
  {
    zip_code: "48841",

    ste_name: "MI",
  },
  {
    zip_code: "48845",

    ste_name: "MI",
  },
  {
    zip_code: "48850",

    ste_name: "MI",
  },
  {
    zip_code: "48873",

    ste_name: "MI",
  },
  {
    zip_code: "48892",

    ste_name: "MI",
  },
  {
    zip_code: "48910",

    ste_name: "MI",
  },
  {
    zip_code: "49001",

    ste_name: "MI",
  },
  {
    zip_code: "49012",

    ste_name: "MI",
  },
  {
    zip_code: "49061",

    ste_name: "MI",
  },
  {
    zip_code: "49071",

    ste_name: "MI",
  },
  {
    zip_code: "49111",

    ste_name: "MI",
  },
  {
    zip_code: "49421",

    ste_name: "MI",
  },
  {
    zip_code: "49444",

    ste_name: "MI",
  },
  {
    zip_code: "49446",

    ste_name: "MI",
  },
  {
    zip_code: "49611",

    ste_name: "MI",
  },
  {
    zip_code: "49612",

    ste_name: "MI",
  },
  {
    zip_code: "49648",

    ste_name: "MI",
  },
  {
    zip_code: "49679",

    ste_name: "MI",
  },
  {
    zip_code: "49709",

    ste_name: "MI",
  },
  {
    zip_code: "49715",

    ste_name: "MI",
  },
  {
    zip_code: "49738",

    ste_name: "MI",
  },
  {
    zip_code: "49777",

    ste_name: "MI",
  },
  {
    zip_code: "49836",

    ste_name: "MI",
  },
  {
    zip_code: "49959",

    ste_name: "MI",
  },
  {
    zip_code: "49960",

    ste_name: "MI",
  },
  {
    zip_code: "50001",

    ste_name: "IA",
  },
  {
    zip_code: "50052",

    ste_name: "IA",
  },
  {
    zip_code: "50163",

    ste_name: "IA",
  },
  {
    zip_code: "50230",

    ste_name: "IA",
  },
  {
    zip_code: "50248",

    ste_name: "IA",
  },
  {
    zip_code: "50250",

    ste_name: "IA",
  },
  {
    zip_code: "50273",

    ste_name: "IA",
  },
  {
    zip_code: "50325",

    ste_name: "IA",
  },
  {
    zip_code: "50431",

    ste_name: "IA",
  },
  {
    zip_code: "50459",

    ste_name: "IA",
  },
  {
    zip_code: "50533",

    ste_name: "IA",
  },
  {
    zip_code: "50543",

    ste_name: "IA",
  },
  {
    zip_code: "50620",

    ste_name: "IA",
  },
  {
    zip_code: "50632",

    ste_name: "IA",
  },
  {
    zip_code: "50801",

    ste_name: "IA",
  },
  {
    zip_code: "51106",

    ste_name: "IA",
  },
  {
    zip_code: "51230",

    ste_name: "IA",
  },
  {
    zip_code: "51533",

    ste_name: "IA",
  },
  {
    zip_code: "51555",

    ste_name: "IA",
  },
  {
    zip_code: "51572",

    ste_name: "IA",
  },
  {
    zip_code: "51650",

    ste_name: "IA",
  },
  {
    zip_code: "52213",

    ste_name: "IA",
  },
  {
    zip_code: "52241",

    ste_name: "IA",
  },
  {
    zip_code: "52325",

    ste_name: "IA",
  },
  {
    zip_code: "52335",

    ste_name: "IA",
  },
  {
    zip_code: "52340",

    ste_name: "IA",
  },
  {
    zip_code: "52553",

    ste_name: "IA",
  },
  {
    zip_code: "52583",

    ste_name: "IA",
  },
  {
    zip_code: "52632",

    ste_name: "IA",
  },
  {
    zip_code: "52720",

    ste_name: "IA",
  },
  {
    zip_code: "52739",

    ste_name: "IA",
  },
  {
    zip_code: "53022",

    ste_name: "WI",
  },
  {
    zip_code: "53049",

    ste_name: "WI",
  },
  {
    zip_code: "53119",

    ste_name: "WI",
  },
  {
    zip_code: "53151",

    ste_name: "WI",
  },
  {
    zip_code: "53154",

    ste_name: "WI",
  },
  {
    zip_code: "53203",

    ste_name: "WI",
  },
  {
    zip_code: "53516",

    ste_name: "WI",
  },
  {
    zip_code: "53543",

    ste_name: "WI",
  },
  {
    zip_code: "53558",

    ste_name: "WI",
  },
  {
    zip_code: "53804",

    ste_name: "WI",
  },
  {
    zip_code: "53810",

    ste_name: "WI",
  },
  {
    zip_code: "54127",

    ste_name: "WI",
  },
  {
    zip_code: "54137",

    ste_name: "WI",
  },
  {
    zip_code: "54138",

    ste_name: "WI",
  },
  {
    zip_code: "54156",

    ste_name: "WI",
  },
  {
    zip_code: "54177",

    ste_name: "WI",
  },
  {
    zip_code: "54422",

    ste_name: "WI",
  },
  {
    zip_code: "54424",

    ste_name: "WI",
  },
  {
    zip_code: "54428",

    ste_name: "WI",
  },
  {
    zip_code: "54441",

    ste_name: "WI",
  },
  {
    zip_code: "54475",

    ste_name: "WI",
  },
  {
    zip_code: "54520",

    ste_name: "WI",
  },
  {
    zip_code: "54644",

    ste_name: "WI",
  },
  {
    zip_code: "54742",

    ste_name: "WI",
  },
  {
    zip_code: "54749",

    ste_name: "WI",
  },
  {
    zip_code: "54765",

    ste_name: "WI",
  },
  {
    zip_code: "54770",

    ste_name: "WI",
  },
  {
    zip_code: "54813",

    ste_name: "WI",
  },
  {
    zip_code: "54854",

    ste_name: "WI",
  },
  {
    zip_code: "55003",

    ste_name: "MN",
  },
  {
    zip_code: "55031",

    ste_name: "MN",
  },
  {
    zip_code: "55043",

    ste_name: "MN",
  },
  {
    zip_code: "55056",

    ste_name: "MN",
  },
  {
    zip_code: "55057",

    ste_name: "MN",
  },
  {
    zip_code: "55087",

    ste_name: "MN",
  },
  {
    zip_code: "55330",

    ste_name: "MN",
  },
  {
    zip_code: "55367",

    ste_name: "MN",
  },
  {
    zip_code: "55391",

    ste_name: "MN",
  },
  {
    zip_code: "55417",

    ste_name: "MN",
  },
  {
    zip_code: "55443",

    ste_name: "MN",
  },
  {
    zip_code: "56007",

    ste_name: "MN",
  },
  {
    zip_code: "56068",

    ste_name: "MN",
  },
  {
    zip_code: "56180",

    ste_name: "MN",
  },
  {
    zip_code: "56211",

    ste_name: "MN",
  },
  {
    zip_code: "56218",

    ste_name: "MN",
  },
  {
    zip_code: "56222",

    ste_name: "MN",
  },
  {
    zip_code: "56232",

    ste_name: "MN",
  },
  {
    zip_code: "56271",

    ste_name: "MN",
  },
  {
    zip_code: "56362",

    ste_name: "MN",
  },
  {
    zip_code: "56385",

    ste_name: "MN",
  },
  {
    zip_code: "56540",

    ste_name: "MN",
  },
  {
    zip_code: "56541",

    ste_name: "MN",
  },
  {
    zip_code: "56626",

    ste_name: "MN",
  },
  {
    zip_code: "56649",

    ste_name: "MN",
  },
  {
    zip_code: "56680",

    ste_name: "MN",
  },
  {
    zip_code: "56733",

    ste_name: "MN",
  },
  {
    zip_code: "56742",

    ste_name: "MN",
  },
  {
    zip_code: "57045",

    ste_name: "SD",
  },
  {
    zip_code: "57054",

    ste_name: "SD",
  },
  {
    zip_code: "57108",

    ste_name: "SD",
  },
  {
    zip_code: "57212",

    ste_name: "SD",
  },
  {
    zip_code: "57225",

    ste_name: "SD",
  },
  {
    zip_code: "57328",

    ste_name: "SD",
  },
  {
    zip_code: "57346",

    ste_name: "SD",
  },
  {
    zip_code: "57551",

    ste_name: "SD",
  },
  {
    zip_code: "57566",

    ste_name: "SD",
  },
  {
    zip_code: "57722",

    ste_name: "SD",
  },
  {
    zip_code: "57735",

    ste_name: "SD",
  },
  {
    zip_code: "57766",

    ste_name: "SD",
  },
  {
    zip_code: "57799",

    ste_name: "SD",
  },
  {
    zip_code: "58035",

    ste_name: "ND",
  },
  {
    zip_code: "58046",

    ste_name: "ND",
  },
  {
    zip_code: "58202",

    ste_name: "ND",
  },
  {
    zip_code: "58281",

    ste_name: "ND",
  },
  {
    zip_code: "58321",

    ste_name: "ND",
  },
  {
    zip_code: "58330",

    ste_name: "ND",
  },
  {
    zip_code: "58338",

    ste_name: "ND",
  },
  {
    zip_code: "58369",

    ste_name: "ND",
  },
  {
    zip_code: "58374",

    ste_name: "ND",
  },
  {
    zip_code: "58385",

    ste_name: "ND",
  },
  {
    zip_code: "58452",

    ste_name: "ND",
  },
  {
    zip_code: "58467",

    ste_name: "ND",
  },
  {
    zip_code: "58503",

    ste_name: "ND",
  },
  {
    zip_code: "58523",

    ste_name: "ND",
  },
  {
    zip_code: "58533",

    ste_name: "ND",
  },
  {
    zip_code: "58651",

    ste_name: "ND",
  },
  {
    zip_code: "830",

    ste_name: "VI",
  },
  {
    zip_code: "1008",

    ste_name: "MA",
  },
  {
    zip_code: "1450",

    ste_name: "MA",
  },
  {
    zip_code: "1571",

    ste_name: "MA",
  },
  {
    zip_code: "1585",

    ste_name: "MA",
  },
  {
    zip_code: "1830",

    ste_name: "MA",
  },
  {
    zip_code: "2043",

    ste_name: "MA",
  },
  {
    zip_code: "2459",

    ste_name: "MA",
  },
  {
    zip_code: "2481",

    ste_name: "MA",
  },
  {
    zip_code: "2571",

    ste_name: "MA",
  },
  {
    zip_code: "2672",

    ste_name: "MA",
  },
  {
    zip_code: "2719",

    ste_name: "MA",
  },
  {
    zip_code: "2720",

    ste_name: "MA",
  },
  {
    zip_code: "2777",

    ste_name: "MA",
  },
  {
    zip_code: "2833",

    ste_name: "RI",
  },
  {
    zip_code: "2838",

    ste_name: "RI",
  },
  {
    zip_code: "2898",

    ste_name: "RI",
  },
  {
    zip_code: "2909",

    ste_name: "RI",
  },
  {
    zip_code: "2910",

    ste_name: "RI",
  },
  {
    zip_code: "2915",

    ste_name: "RI",
  },
  {
    zip_code: "3038",

    ste_name: "NH",
  },
  {
    zip_code: "3046",

    ste_name: "NH",
  },
  {
    zip_code: "3051",

    ste_name: "NH",
  },
  {
    zip_code: "3077",

    ste_name: "NH",
  },
  {
    zip_code: "3218",

    ste_name: "NH",
  },
  {
    zip_code: "3440",

    ste_name: "NH",
  },
  {
    zip_code: "3885",

    ste_name: "NH",
  },
  {
    zip_code: "3907",

    ste_name: "ME",
  },
  {
    zip_code: "4076",

    ste_name: "ME",
  },
  {
    zip_code: "4237",

    ste_name: "ME",
  },
  {
    zip_code: "4428",

    ste_name: "ME",
  },
  {
    zip_code: "4485",

    ste_name: "ME",
  },
  {
    zip_code: "4614",

    ste_name: "ME",
  },
  {
    zip_code: "4630",

    ste_name: "ME",
  },
  {
    zip_code: "4637",

    ste_name: "ME",
  },
  {
    zip_code: "4674",

    ste_name: "ME",
  },
  {
    zip_code: "4675",

    ste_name: "ME",
  },
  {
    zip_code: "4677",

    ste_name: "ME",
  },
  {
    zip_code: "4756",

    ste_name: "ME",
  },
  {
    zip_code: "4764",

    ste_name: "ME",
  },
  {
    zip_code: "4768",

    ste_name: "ME",
  },
  {
    zip_code: "4864",

    ste_name: "ME",
  },
  {
    zip_code: "4933",

    ste_name: "ME",
  },
  {
    zip_code: "4950",

    ste_name: "ME",
  },
  {
    zip_code: "5001",

    ste_name: "VT",
  },
  {
    zip_code: "5052",

    ste_name: "VT",
  },
  {
    zip_code: "5067",

    ste_name: "VT",
  },
  {
    zip_code: "5084",

    ste_name: "VT",
  },
  {
    zip_code: "5201",

    ste_name: "VT",
  },
  {
    zip_code: "5641",

    ste_name: "VT",
  },
  {
    zip_code: "5667",

    ste_name: "VT",
  },
  {
    zip_code: "5733",

    ste_name: "VT",
  },
  {
    zip_code: "6037",

    ste_name: "CT",
  },
  {
    zip_code: "6160",

    ste_name: "CT",
  },
  {
    zip_code: "6416",

    ste_name: "CT",
  },
  {
    zip_code: "6417",

    ste_name: "CT",
  },
  {
    zip_code: "6420",

    ste_name: "CT",
  },
  {
    zip_code: "6606",

    ste_name: "CT",
  },
  {
    zip_code: "6790",

    ste_name: "CT",
  },
  {
    zip_code: "6795",

    ste_name: "CT",
  },
  {
    zip_code: "6856",

    ste_name: "CT",
  },
  {
    zip_code: "6878",

    ste_name: "CT",
  },
  {
    zip_code: "6901",

    ste_name: "CT",
  },
  {
    zip_code: "7052",

    ste_name: "NJ",
  },
  {
    zip_code: "7077",

    ste_name: "NJ",
  },
  {
    zip_code: "7435",

    ste_name: "NJ",
  },
  {
    zip_code: "7452",

    ste_name: "NJ",
  },
  {
    zip_code: "7470",

    ste_name: "NJ",
  },
  {
    zip_code: "7605",

    ste_name: "NJ",
  },
  {
    zip_code: "7624",

    ste_name: "NJ",
  },
  {
    zip_code: "7641",

    ste_name: "NJ",
  },
  {
    zip_code: "7711",

    ste_name: "NJ",
  },
  {
    zip_code: "7726",

    ste_name: "NJ",
  },
  {
    zip_code: "7828",

    ste_name: "NJ",
  },
  {
    zip_code: "7840",

    ste_name: "NJ",
  },
  {
    zip_code: "7856",

    ste_name: "NJ",
  },
  {
    zip_code: "7981",

    ste_name: "NJ",
  },
  {
    zip_code: "8020",

    ste_name: "NJ",
  },
  {
    zip_code: "8023",

    ste_name: "NJ",
  },
  {
    zip_code: "8088",

    ste_name: "NJ",
  },
  {
    zip_code: "8502",

    ste_name: "NJ",
  },
  {
    zip_code: "8520",

    ste_name: "NJ",
  },
  {
    zip_code: "8560",

    ste_name: "NJ",
  },
  {
    zip_code: "8886",

    ste_name: "NJ",
  },
  {
    zip_code: "10025",

    ste_name: "NY",
  },
  {
    zip_code: "10452",

    ste_name: "NY",
  },
  {
    zip_code: "10517",

    ste_name: "NY",
  },
  {
    zip_code: "10523",

    ste_name: "NY",
  },
  {
    zip_code: "10709",

    ste_name: "NY",
  },
  {
    zip_code: "10922",

    ste_name: "NY",
  },
  {
    zip_code: "11377",

    ste_name: "NY",
  },
  {
    zip_code: "11412",

    ste_name: "NY",
  },
  {
    zip_code: "11424",

    ste_name: "NY",
  },
  {
    zip_code: "11510",

    ste_name: "NY",
  },
  {
    zip_code: "11557",

    ste_name: "NY",
  },
  {
    zip_code: "11702",

    ste_name: "NY",
  },
  {
    zip_code: "11709",

    ste_name: "NY",
  },
  {
    zip_code: "11710",

    ste_name: "NY",
  },
  {
    zip_code: "11751",

    ste_name: "NY",
  },
  {
    zip_code: "12138",

    ste_name: "NY",
  },
  {
    zip_code: "12174",

    ste_name: "NY",
  },
  {
    zip_code: "12303",

    ste_name: "NY",
  },
  {
    zip_code: "12305",

    ste_name: "NY",
  },
  {
    zip_code: "12405",

    ste_name: "NY",
  },
  {
    zip_code: "12485",

    ste_name: "NY",
  },
  {
    zip_code: "12486",

    ste_name: "NY",
  },
  {
    zip_code: "12502",

    ste_name: "NY",
  },
  {
    zip_code: "12525",

    ste_name: "NY",
  },
  {
    zip_code: "12540",

    ste_name: "NY",
  },
  {
    zip_code: "12570",

    ste_name: "NY",
  },
  {
    zip_code: "12751",

    ste_name: "NY",
  },
  {
    zip_code: "12763",

    ste_name: "NY",
  },
  {
    zip_code: "12870",

    ste_name: "NY",
  },
  {
    zip_code: "12950",

    ste_name: "NY",
  },
  {
    zip_code: "12966",

    ste_name: "NY",
  },
  {
    zip_code: "13028",

    ste_name: "NY",
  },
  {
    zip_code: "13061",

    ste_name: "NY",
  },
  {
    zip_code: "13210",

    ste_name: "NY",
  },
  {
    zip_code: "13312",

    ste_name: "NY",
  },
  {
    zip_code: "13424",

    ste_name: "NY",
  },
  {
    zip_code: "13628",

    ste_name: "NY",
  },
  {
    zip_code: "13682",

    ste_name: "NY",
  },
  {
    zip_code: "13687",

    ste_name: "NY",
  },
  {
    zip_code: "13835",

    ste_name: "NY",
  },
  {
    zip_code: "14037",

    ste_name: "NY",
  },
  {
    zip_code: "14040",

    ste_name: "NY",
  },
  {
    zip_code: "14042",

    ste_name: "NY",
  },
  {
    zip_code: "14055",

    ste_name: "NY",
  },
  {
    zip_code: "14108",

    ste_name: "NY",
  },
  {
    zip_code: "14131",

    ste_name: "NY",
  },
  {
    zip_code: "14478",

    ste_name: "NY",
  },
  {
    zip_code: "14525",

    ste_name: "NY",
  },
  {
    zip_code: "14529",

    ste_name: "NY",
  },
  {
    zip_code: "14549",

    ste_name: "NY",
  },
  {
    zip_code: "14561",

    ste_name: "NY",
  },
  {
    zip_code: "14610",

    ste_name: "NY",
  },
  {
    zip_code: "14625",

    ste_name: "NY",
  },
  {
    zip_code: "14716",

    ste_name: "NY",
  },
  {
    zip_code: "14740",

    ste_name: "NY",
  },
  {
    zip_code: "14744",

    ste_name: "NY",
  },
  {
    zip_code: "14817",

    ste_name: "NY",
  },
  {
    zip_code: "14853",

    ste_name: "NY",
  },
  {
    zip_code: "15007",

    ste_name: "PA",
  },
  {
    zip_code: "15053",

    ste_name: "PA",
  },
  {
    zip_code: "15054",

    ste_name: "PA",
  },
  {
    zip_code: "15108",

    ste_name: "PA",
  },
  {
    zip_code: "15142",

    ste_name: "PA",
  },
  {
    zip_code: "15206",

    ste_name: "PA",
  },
  {
    zip_code: "15301",

    ste_name: "PA",
  },
  {
    zip_code: "15324",

    ste_name: "PA",
  },
  {
    zip_code: "15330",

    ste_name: "PA",
  },
  {
    zip_code: "15361",

    ste_name: "PA",
  },
  {
    zip_code: "15363",

    ste_name: "PA",
  },
  {
    zip_code: "15431",

    ste_name: "PA",
  },
  {
    zip_code: "15450",

    ste_name: "PA",
  },
  {
    zip_code: "15510",

    ste_name: "PA",
  },
  {
    zip_code: "15618",

    ste_name: "PA",
  },
  {
    zip_code: "15650",

    ste_name: "PA",
  },
  {
    zip_code: "15747",

    ste_name: "PA",
  },
  {
    zip_code: "15753",

    ste_name: "PA",
  },
  {
    zip_code: "15863",

    ste_name: "PA",
  },
  {
    zip_code: "15951",

    ste_name: "PA",
  },
  {
    zip_code: "15960",

    ste_name: "PA",
  },
  {
    zip_code: "16110",

    ste_name: "PA",
  },
  {
    zip_code: "16134",

    ste_name: "PA",
  },
  {
    zip_code: "16246",

    ste_name: "PA",
  },
  {
    zip_code: "16259",

    ste_name: "PA",
  },
  {
    zip_code: "16365",

    ste_name: "PA",
  },
  {
    zip_code: "16601",

    ste_name: "PA",
  },
  {
    zip_code: "16639",

    ste_name: "PA",
  },
  {
    zip_code: "16669",

    ste_name: "PA",
  },
  {
    zip_code: "16699",

    ste_name: "PA",
  },
  {
    zip_code: "16728",

    ste_name: "PA",
  },
  {
    zip_code: "16744",

    ste_name: "PA",
  },
  {
    zip_code: "16750",

    ste_name: "PA",
  },
  {
    zip_code: "16860",

    ste_name: "PA",
  },
  {
    zip_code: "16925",

    ste_name: "PA",
  },
  {
    zip_code: "17010",

    ste_name: "PA",
  },
  {
    zip_code: "17017",

    ste_name: "PA",
  },
  {
    zip_code: "17035",

    ste_name: "PA",
  },
  {
    zip_code: "17062",

    ste_name: "PA",
  },
  {
    zip_code: "17067",

    ste_name: "PA",
  },
  {
    zip_code: "17120",

    ste_name: "PA",
  },
  {
    zip_code: "17261",

    ste_name: "PA",
  },
  {
    zip_code: "17263",

    ste_name: "PA",
  },
  {
    zip_code: "17572",

    ste_name: "PA",
  },
  {
    zip_code: "17602",

    ste_name: "PA",
  },
  {
    zip_code: "17840",

    ste_name: "PA",
  },
  {
    zip_code: "18014",

    ste_name: "PA",
  },
  {
    zip_code: "18041",

    ste_name: "PA",
  },
  {
    zip_code: "18106",

    ste_name: "PA",
  },
  {
    zip_code: "18219",

    ste_name: "PA",
  },
  {
    zip_code: "18231",

    ste_name: "PA",
  },
  {
    zip_code: "18325",

    ste_name: "PA",
  },
  {
    zip_code: "18356",

    ste_name: "PA",
  },
  {
    zip_code: "18902",

    ste_name: "PA",
  },
  {
    zip_code: "18935",

    ste_name: "PA",
  },
  {
    zip_code: "18936",

    ste_name: "PA",
  },
  {
    zip_code: "19020",

    ste_name: "PA",
  },
  {
    zip_code: "19023",

    ste_name: "PA",
  },
  {
    zip_code: "19036",

    ste_name: "PA",
  },
  {
    zip_code: "19063",

    ste_name: "PA",
  },
  {
    zip_code: "19073",

    ste_name: "PA",
  },
  {
    zip_code: "19086",

    ste_name: "PA",
  },
  {
    zip_code: "19127",

    ste_name: "PA",
  },
  {
    zip_code: "19333",

    ste_name: "PA",
  },
  {
    zip_code: "19348",

    ste_name: "PA",
  },
  {
    zip_code: "19437",

    ste_name: "PA",
  },
  {
    zip_code: "19492",

    ste_name: "PA",
  },
  {
    zip_code: "19554",

    ste_name: "PA",
  },
  {
    zip_code: "19604",

    ste_name: "PA",
  },
  {
    zip_code: "19934",

    ste_name: "DE",
  },
  {
    zip_code: "19939",

    ste_name: "DE",
  },
  {
    zip_code: "19954",

    ste_name: "DE",
  },
  {
    zip_code: "20129",

    ste_name: "VA",
  },
  {
    zip_code: "20141",

    ste_name: "VA",
  },
  {
    zip_code: "20176",

    ste_name: "VA",
  },
  {
    zip_code: "20615",

    ste_name: "MD",
  },
  {
    zip_code: "20632",

    ste_name: "MD",
  },
  {
    zip_code: "20657",

    ste_name: "MD",
  },
  {
    zip_code: "20876",

    ste_name: "MD",
  },
  {
    zip_code: "20904",

    ste_name: "MD",
  },
  {
    zip_code: "21015",

    ste_name: "MD",
  },
  {
    zip_code: "21052",

    ste_name: "MD",
  },
  {
    zip_code: "21082",

    ste_name: "MD",
  },
  {
    zip_code: "21090",

    ste_name: "MD",
  },
  {
    zip_code: "21625",

    ste_name: "MD",
  },
  {
    zip_code: "21662",

    ste_name: "MD",
  },
  {
    zip_code: "21771",

    ste_name: "MD",
  },
  {
    zip_code: "21787",

    ste_name: "MD",
  },
  {
    zip_code: "21811",

    ste_name: "MD",
  },
  {
    zip_code: "21874",

    ste_name: "MD",
  },
  {
    zip_code: "21901",

    ste_name: "MD",
  },
  {
    zip_code: "22213",

    ste_name: "VA",
  },
  {
    zip_code: "22407",

    ste_name: "VA",
  },
  {
    zip_code: "22538",

    ste_name: "VA",
  },
  {
    zip_code: "22546",

    ste_name: "VA",
  },
  {
    zip_code: "22639",

    ste_name: "VA",
  },
  {
    zip_code: "22642",

    ste_name: "VA",
  },
  {
    zip_code: "22719",

    ste_name: "VA",
  },
  {
    zip_code: "22733",

    ste_name: "VA",
  },
  {
    zip_code: "22820",

    ste_name: "VA",
  },
  {
    zip_code: "22849",

    ste_name: "VA",
  },
  {
    zip_code: "22850",

    ste_name: "VA",
  },
  {
    zip_code: "22851",

    ste_name: "VA",
  },
  {
    zip_code: "22902",

    ste_name: "VA",
  },
  {
    zip_code: "58833",

    ste_name: "ND",
  },
  {
    zip_code: "58835",

    ste_name: "ND",
  },
  {
    zip_code: "59002",

    ste_name: "MT",
  },
  {
    zip_code: "59054",

    ste_name: "MT",
  },
  {
    zip_code: "59218",

    ste_name: "MT",
  },
  {
    zip_code: "59411",

    ste_name: "MT",
  },
  {
    zip_code: "59638",

    ste_name: "MT",
  },
  {
    zip_code: "59750",

    ste_name: "MT",
  },
  {
    zip_code: "59803",

    ste_name: "MT",
  },
  {
    zip_code: "59872",

    ste_name: "MT",
  },
  {
    zip_code: "59910",

    ste_name: "MT",
  },
  {
    zip_code: "59936",

    ste_name: "MT",
  },
  {
    zip_code: "60067",

    ste_name: "IL",
  },
  {
    zip_code: "60069",

    ste_name: "IL",
  },
  {
    zip_code: "60098",

    ste_name: "IL",
  },
  {
    zip_code: "60109",

    ste_name: "IL",
  },
  {
    zip_code: "60126",

    ste_name: "IL",
  },
  {
    zip_code: "60173",

    ste_name: "IL",
  },
  {
    zip_code: "60175",

    ste_name: "IL",
  },
  {
    zip_code: "60424",

    ste_name: "IL",
  },
  {
    zip_code: "60439",

    ste_name: "IL",
  },
  {
    zip_code: "60463",

    ste_name: "IL",
  },
  {
    zip_code: "60545",

    ste_name: "IL",
  },
  {
    zip_code: "60966",

    ste_name: "IL",
  },
  {
    zip_code: "61060",

    ste_name: "IL",
  },
  {
    zip_code: "61231",

    ste_name: "IL",
  },
  {
    zip_code: "61243",

    ste_name: "IL",
  },
  {
    zip_code: "61317",

    ste_name: "IL",
  },
  {
    zip_code: "61324",

    ste_name: "IL",
  },
  {
    zip_code: "61374",

    ste_name: "IL",
  },
  {
    zip_code: "61415",

    ste_name: "IL",
  },
  {
    zip_code: "61501",

    ste_name: "IL",
  },
  {
    zip_code: "61725",

    ste_name: "IL",
  },
  {
    zip_code: "61729",

    ste_name: "IL",
  },
  {
    zip_code: "61732",

    ste_name: "IL",
  },
  {
    zip_code: "61773",

    ste_name: "IL",
  },
  {
    zip_code: "61801",

    ste_name: "IL",
  },
  {
    zip_code: "61847",

    ste_name: "IL",
  },
  {
    zip_code: "61925",

    ste_name: "IL",
  },
  {
    zip_code: "62060",

    ste_name: "IL",
  },
  {
    zip_code: "62271",

    ste_name: "IL",
  },
  {
    zip_code: "62284",

    ste_name: "IL",
  },
  {
    zip_code: "62301",

    ste_name: "IL",
  },
  {
    zip_code: "62319",

    ste_name: "IL",
  },
  {
    zip_code: "62446",

    ste_name: "IL",
  },
  {
    zip_code: "62530",

    ste_name: "IL",
  },
  {
    zip_code: "62543",

    ste_name: "IL",
  },
  {
    zip_code: "62561",

    ste_name: "IL",
  },
  {
    zip_code: "62668",

    ste_name: "IL",
  },
  {
    zip_code: "62707",

    ste_name: "IL",
  },
  {
    zip_code: "62825",

    ste_name: "IL",
  },
  {
    zip_code: "62848",

    ste_name: "IL",
  },
  {
    zip_code: "62885",

    ste_name: "IL",
  },
  {
    zip_code: "62890",

    ste_name: "IL",
  },
  {
    zip_code: "62942",

    ste_name: "IL",
  },
  {
    zip_code: "62946",

    ste_name: "IL",
  },
  {
    zip_code: "62996",

    ste_name: "IL",
  },
  {
    zip_code: "63074",

    ste_name: "MO",
  },
  {
    zip_code: "63090",

    ste_name: "MO",
  },
  {
    zip_code: "63109",

    ste_name: "MO",
  },
  {
    zip_code: "63113",

    ste_name: "MO",
  },
  {
    zip_code: "63117",

    ste_name: "MO",
  },
  {
    zip_code: "63127",

    ste_name: "MO",
  },
  {
    zip_code: "63128",

    ste_name: "MO",
  },
  {
    zip_code: "63353",

    ste_name: "MO",
  },
  {
    zip_code: "63370",

    ste_name: "MO",
  },
  {
    zip_code: "63533",

    ste_name: "MO",
  },
  {
    zip_code: "63535",

    ste_name: "MO",
  },
  {
    zip_code: "63537",

    ste_name: "MO",
  },
  {
    zip_code: "63558",

    ste_name: "MO",
  },
  {
    zip_code: "63565",

    ste_name: "MO",
  },
  {
    zip_code: "63637",

    ste_name: "MO",
  },
  {
    zip_code: "64022",

    ste_name: "MO",
  },
  {
    zip_code: "64029",

    ste_name: "MO",
  },
  {
    zip_code: "64054",

    ste_name: "MO",
  },
  {
    zip_code: "64056",

    ste_name: "MO",
  },
  {
    zip_code: "64093",

    ste_name: "MO",
  },
  {
    zip_code: "64164",

    ste_name: "MO",
  },
  {
    zip_code: "64165",

    ste_name: "MO",
  },
  {
    zip_code: "64420",

    ste_name: "MO",
  },
  {
    zip_code: "64498",

    ste_name: "MO",
  },
  {
    zip_code: "64659",

    ste_name: "MO",
  },
  {
    zip_code: "64674",

    ste_name: "MO",
  },
  {
    zip_code: "64770",

    ste_name: "MO",
  },
  {
    zip_code: "64772",

    ste_name: "MO",
  },
  {
    zip_code: "65237",

    ste_name: "MO",
  },
  {
    zip_code: "65247",

    ste_name: "MO",
  },
  {
    zip_code: "65360",

    ste_name: "MO",
  },
  {
    zip_code: "65443",

    ste_name: "MO",
  },
  {
    zip_code: "65566",

    ste_name: "MO",
  },
  {
    zip_code: "65650",

    ste_name: "MO",
  },
  {
    zip_code: "65674",

    ste_name: "MO",
  },
  {
    zip_code: "65705",

    ste_name: "MO",
  },
  {
    zip_code: "65717",

    ste_name: "MO",
  },
  {
    zip_code: "65757",

    ste_name: "MO",
  },
  {
    zip_code: "65770",

    ste_name: "MO",
  },
  {
    zip_code: "65772",

    ste_name: "MO",
  },
  {
    zip_code: "65777",

    ste_name: "MO",
  },
  {
    zip_code: "65789",

    ste_name: "MO",
  },
  {
    zip_code: "66427",

    ste_name: "KS",
  },
  {
    zip_code: "66436",

    ste_name: "KS",
  },
  {
    zip_code: "66720",

    ste_name: "KS",
  },
  {
    zip_code: "66739",

    ste_name: "KS",
  },
  {
    zip_code: "66801",

    ste_name: "KS",
  },
  {
    zip_code: "66942",

    ste_name: "KS",
  },
  {
    zip_code: "67057",

    ste_name: "KS",
  },
  {
    zip_code: "67062",

    ste_name: "KS",
  },
  {
    zip_code: "67209",

    ste_name: "KS",
  },
  {
    zip_code: "67218",

    ste_name: "KS",
  },
  {
    zip_code: "67364",

    ste_name: "KS",
  },
  {
    zip_code: "67492",

    ste_name: "KS",
  },
  {
    zip_code: "67565",

    ste_name: "KS",
  },
  {
    zip_code: "67583",

    ste_name: "KS",
  },
  {
    zip_code: "67645",

    ste_name: "KS",
  },
  {
    zip_code: "67656",

    ste_name: "KS",
  },
  {
    zip_code: "67701",

    ste_name: "KS",
  },
  {
    zip_code: "67736",

    ste_name: "KS",
  },
  {
    zip_code: "67747",

    ste_name: "KS",
  },
  {
    zip_code: "67748",

    ste_name: "KS",
  },
  {
    zip_code: "67834",

    ste_name: "KS",
  },
  {
    zip_code: "67868",

    ste_name: "KS",
  },
  {
    zip_code: "68038",

    ste_name: "NE",
  },
  {
    zip_code: "68128",

    ste_name: "NE",
  },
  {
    zip_code: "68377",

    ste_name: "NE",
  },
  {
    zip_code: "68401",

    ste_name: "NE",
  },
  {
    zip_code: "68465",

    ste_name: "NE",
  },
  {
    zip_code: "68502",

    ste_name: "NE",
  },
  {
    zip_code: "68506",

    ste_name: "NE",
  },
  {
    zip_code: "68667",

    ste_name: "NE",
  },
  {
    zip_code: "68735",

    ste_name: "NE",
  },
  {
    zip_code: "68752",

    ste_name: "NE",
  },
  {
    zip_code: "68768",

    ste_name: "NE",
  },
  {
    zip_code: "68814",

    ste_name: "NE",
  },
  {
    zip_code: "68826",

    ste_name: "NE",
  },
  {
    zip_code: "68946",

    ste_name: "NE",
  },
  {
    zip_code: "68955",

    ste_name: "NE",
  },
  {
    zip_code: "69033",

    ste_name: "NE",
  },
  {
    zip_code: "69120",

    ste_name: "NE",
  },
  {
    zip_code: "69121",

    ste_name: "NE",
  },
  {
    zip_code: "69154",

    ste_name: "NE",
  },
  {
    zip_code: "69157",

    ste_name: "NE",
  },
  {
    zip_code: "69166",

    ste_name: "NE",
  },
  {
    zip_code: "69353",

    ste_name: "NE",
  },
  {
    zip_code: "70129",

    ste_name: "LA",
  },
  {
    zip_code: "70130",

    ste_name: "LA",
  },
  {
    zip_code: "70341",

    ste_name: "LA",
  },
  {
    zip_code: "70357",

    ste_name: "LA",
  },
  {
    zip_code: "70359",

    ste_name: "LA",
  },
  {
    zip_code: "70446",

    ste_name: "LA",
  },
  {
    zip_code: "70449",

    ste_name: "LA",
  },
  {
    zip_code: "70556",

    ste_name: "LA",
  },
  {
    zip_code: "70578",

    ste_name: "LA",
  },
  {
    zip_code: "70640",

    ste_name: "LA",
  },
  {
    zip_code: "70645",

    ste_name: "LA",
  },
  {
    zip_code: "70755",

    ste_name: "LA",
  },
  {
    zip_code: "70789",

    ste_name: "LA",
  },
  {
    zip_code: "71007",

    ste_name: "LA",
  },
  {
    zip_code: "71073",

    ste_name: "LA",
  },
  {
    zip_code: "71075",

    ste_name: "LA",
  },
  {
    zip_code: "71229",

    ste_name: "LA",
  },
  {
    zip_code: "71459",

    ste_name: "LA",
  },
  {
    zip_code: "71764",

    ste_name: "AR",
  },
  {
    zip_code: "71765",

    ste_name: "AR",
  },
  {
    zip_code: "71836",

    ste_name: "AR",
  },
  {
    zip_code: "71837",

    ste_name: "AR",
  },
  {
    zip_code: "71933",

    ste_name: "AR",
  },
  {
    zip_code: "71935",

    ste_name: "AR",
  },
  {
    zip_code: "72001",

    ste_name: "AR",
  },
  {
    zip_code: "72004",

    ste_name: "AR",
  },
  {
    zip_code: "72045",

    ste_name: "AR",
  },
  {
    zip_code: "72067",

    ste_name: "AR",
  },
  {
    zip_code: "72136",

    ste_name: "AR",
  },
  {
    zip_code: "72181",

    ste_name: "AR",
  },
  {
    zip_code: "72358",

    ste_name: "AR",
  },
  {
    zip_code: "72460",

    ste_name: "AR",
  },
  {
    zip_code: "72528",

    ste_name: "AR",
  },
  {
    zip_code: "72562",

    ste_name: "AR",
  },
  {
    zip_code: "72634",

    ste_name: "AR",
  },
  {
    zip_code: "72639",

    ste_name: "AR",
  },
  {
    zip_code: "72650",

    ste_name: "AR",
  },
  {
    zip_code: "72704",

    ste_name: "AR",
  },
  {
    zip_code: "72722",

    ste_name: "AR",
  },
  {
    zip_code: "72832",

    ste_name: "AR",
  },
  {
    zip_code: "72901",

    ste_name: "AR",
  },
  {
    zip_code: "72932",

    ste_name: "AR",
  },
  {
    zip_code: "72950",

    ste_name: "AR",
  },
  {
    zip_code: "73051",

    ste_name: "OK",
  },
  {
    zip_code: "73066",

    ste_name: "OK",
  },
  {
    zip_code: "73458",

    ste_name: "OK",
  },
  {
    zip_code: "73501",

    ste_name: "OK",
  },
  {
    zip_code: "73527",

    ste_name: "OK",
  },
  {
    zip_code: "73639",

    ste_name: "OK",
  },
  {
    zip_code: "73716",

    ste_name: "OK",
  },
  {
    zip_code: "73730",

    ste_name: "OK",
  },
  {
    zip_code: "73731",

    ste_name: "OK",
  },
  {
    zip_code: "73764",

    ste_name: "OK",
  },
  {
    zip_code: "73844",

    ste_name: "OK",
  },
  {
    zip_code: "73949",

    ste_name: "OK",
  },
  {
    zip_code: "74061",

    ste_name: "OK",
  },
  {
    zip_code: "74127",

    ste_name: "OK",
  },
  {
    zip_code: "74338",

    ste_name: "OK",
  },
  {
    zip_code: "74369",

    ste_name: "OK",
  },
  {
    zip_code: "74431",

    ste_name: "OK",
  },
  {
    zip_code: "74464",

    ste_name: "OK",
  },
  {
    zip_code: "74468",

    ste_name: "OK",
  },
  {
    zip_code: "74531",

    ste_name: "OK",
  },
  {
    zip_code: "74543",

    ste_name: "OK",
  },
  {
    zip_code: "74571",

    ste_name: "OK",
  },
  {
    zip_code: "74652",

    ste_name: "OK",
  },
  {
    zip_code: "74653",

    ste_name: "OK",
  },
  {
    zip_code: "74728",

    ste_name: "OK",
  },
  {
    zip_code: "74852",

    ste_name: "OK",
  },
  {
    zip_code: "74936",

    ste_name: "OK",
  },
  {
    zip_code: "75074",

    ste_name: "TX",
  },
  {
    zip_code: "75092",

    ste_name: "TX",
  },
  {
    zip_code: "75104",

    ste_name: "TX",
  },
  {
    zip_code: "75150",

    ste_name: "TX",
  },
  {
    zip_code: "75201",

    ste_name: "TX",
  },
  {
    zip_code: "75206",

    ste_name: "TX",
  },
  {
    zip_code: "75215",

    ste_name: "TX",
  },
  {
    zip_code: "75417",

    ste_name: "TX",
  },
  {
    zip_code: "75492",

    ste_name: "TX",
  },
  {
    zip_code: "75558",

    ste_name: "TX",
  },
  {
    zip_code: "75560",

    ste_name: "TX",
  },
  {
    zip_code: "75566",

    ste_name: "TX",
  },
  {
    zip_code: "75569",

    ste_name: "TX",
  },
  {
    zip_code: "75630",

    ste_name: "TX",
  },
  {
    zip_code: "75647",

    ste_name: "TX",
  },
  {
    zip_code: "75656",

    ste_name: "TX",
  },
  {
    zip_code: "75705",

    ste_name: "TX",
  },
  {
    zip_code: "76015",

    ste_name: "TX",
  },
  {
    zip_code: "76049",

    ste_name: "TX",
  },
  {
    zip_code: "76059",

    ste_name: "TX",
  },
  {
    zip_code: "76067",

    ste_name: "TX",
  },
  {
    zip_code: "76085",

    ste_name: "TX",
  },
  {
    zip_code: "76106",

    ste_name: "TX",
  },
  {
    zip_code: "76132",

    ste_name: "TX",
  },
  {
    zip_code: "76133",

    ste_name: "TX",
  },
  {
    zip_code: "76135",

    ste_name: "TX",
  },
  {
    zip_code: "76226",

    ste_name: "TX",
  },
  {
    zip_code: "76433",

    ste_name: "TX",
  },
  {
    zip_code: "76641",

    ste_name: "TX",
  },
  {
    zip_code: "76652",

    ste_name: "TX",
  },
  {
    zip_code: "76676",

    ste_name: "TX",
  },
  {
    zip_code: "76890",

    ste_name: "TX",
  },
  {
    zip_code: "77031",

    ste_name: "TX",
  },
  {
    zip_code: "77033",

    ste_name: "TX",
  },
  {
    zip_code: "77320",

    ste_name: "TX",
  },
  {
    zip_code: "77374",

    ste_name: "TX",
  },
  {
    zip_code: "77434",

    ste_name: "TX",
  },
  {
    zip_code: "77440",

    ste_name: "TX",
  },
  {
    zip_code: "77564",

    ste_name: "TX",
  },
  {
    zip_code: "77662",

    ste_name: "TX",
  },
  {
    zip_code: "77830",

    ste_name: "TX",
  },
  {
    zip_code: "77904",

    ste_name: "TX",
  },
  {
    zip_code: "77970",

    ste_name: "TX",
  },
  {
    zip_code: "78007",

    ste_name: "TX",
  },
  {
    zip_code: "78205",

    ste_name: "TX",
  },
  {
    zip_code: "78249",

    ste_name: "TX",
  },
  {
    zip_code: "78330",

    ste_name: "TX",
  },
  {
    zip_code: "78377",

    ste_name: "TX",
  },
  {
    zip_code: "78411",

    ste_name: "TX",
  },
  {
    zip_code: "78560",

    ste_name: "TX",
  },
  {
    zip_code: "78561",

    ste_name: "TX",
  },
  {
    zip_code: "78567",

    ste_name: "TX",
  },
  {
    zip_code: "78653",

    ste_name: "TX",
  },
  {
    zip_code: "78661",

    ste_name: "TX",
  },
  {
    zip_code: "78944",

    ste_name: "TX",
  },
  {
    zip_code: "78949",

    ste_name: "TX",
  },
  {
    zip_code: "79015",

    ste_name: "TX",
  },
  {
    zip_code: "79043",

    ste_name: "TX",
  },
  {
    zip_code: "79381",

    ste_name: "TX",
  },
  {
    zip_code: "79530",

    ste_name: "TX",
  },
  {
    zip_code: "79538",

    ste_name: "TX",
  },
  {
    zip_code: "79718",

    ste_name: "TX",
  },
  {
    zip_code: "79745",

    ste_name: "TX",
  },
  {
    zip_code: "80205",

    ste_name: "CO",
  },
  {
    zip_code: "80207",

    ste_name: "CO",
  },
  {
    zip_code: "80247",

    ste_name: "CO",
  },
  {
    zip_code: "80294",

    ste_name: "CO",
  },
  {
    zip_code: "80436",

    ste_name: "CO",
  },
  {
    zip_code: "80517",

    ste_name: "CO",
  },
  {
    zip_code: "80526",

    ste_name: "CO",
  },
  {
    zip_code: "80537",

    ste_name: "CO",
  },
  {
    zip_code: "80906",

    ste_name: "CO",
  },
  {
    zip_code: "80926",

    ste_name: "CO",
  },
  {
    zip_code: "81087",

    ste_name: "CO",
  },
  {
    zip_code: "81147",

    ste_name: "CO",
  },
  {
    zip_code: "81231",

    ste_name: "CO",
  },
  {
    zip_code: "81506",

    ste_name: "CO",
  },
  {
    zip_code: "81520",

    ste_name: "CO",
  },
  {
    zip_code: "81525",

    ste_name: "CO",
  },
  {
    zip_code: "81615",

    ste_name: "CO",
  },
  {
    zip_code: "81656",

    ste_name: "CO",
  },
  {
    zip_code: "82520",

    ste_name: "WY",
  },
  {
    zip_code: "82609",

    ste_name: "WY",
  },
  {
    zip_code: "82649",

    ste_name: "WY",
  },
  {
    zip_code: "82839",

    ste_name: "WY",
  },
  {
    zip_code: "83126",

    ste_name: "WY",
  },
  {
    zip_code: "83210",

    ste_name: "ID",
  },
  {
    zip_code: "83213",

    ste_name: "ID",
  },
  {
    zip_code: "83226",

    ste_name: "ID",
  },
  {
    zip_code: "83274",

    ste_name: "ID",
  },
  {
    zip_code: "83281",

    ste_name: "ID",
  },
  {
    zip_code: "83313",

    ste_name: "ID",
  },
  {
    zip_code: "83341",

    ste_name: "ID",
  },
  {
    zip_code: "83443",

    ste_name: "ID",
  },
  {
    zip_code: "83448",

    ste_name: "ID",
  },
  {
    zip_code: "83544",

    ste_name: "ID",
  },
  {
    zip_code: "83610",

    ste_name: "ID",
  },
  {
    zip_code: "83704",

    ste_name: "ID",
  },
  {
    zip_code: "83858",

    ste_name: "ID",
  },
  {
    zip_code: "84010",

    ste_name: "UT",
  },
  {
    zip_code: "84042",

    ste_name: "UT",
  },
  {
    zip_code: "84063",

    ste_name: "UT",
  },
  {
    zip_code: "84320",

    ste_name: "UT",
  },
  {
    zip_code: "84340",

    ste_name: "UT",
  },
  {
    zip_code: "84501",

    ste_name: "UT",
  },
  {
    zip_code: "84528",

    ste_name: "UT",
  },
  {
    zip_code: "84601",

    ste_name: "UT",
  },
  {
    zip_code: "84627",

    ste_name: "UT",
  },
  {
    zip_code: "84716",

    ste_name: "UT",
  },
  {
    zip_code: "84772",

    ste_name: "UT",
  },
  {
    zip_code: "85147",

    ste_name: "AZ",
  },
  {
    zip_code: "85192",

    ste_name: "AZ",
  },
  {
    zip_code: "85248",

    ste_name: "AZ",
  },
  {
    zip_code: "85255",

    ste_name: "AZ",
  },
  {
    zip_code: "85296",

    ste_name: "AZ",
  },
  {
    zip_code: "85297",

    ste_name: "AZ",
  },
  {
    zip_code: "85320",

    ste_name: "AZ",
  },
  {
    zip_code: "85371",

    ste_name: "AZ",
  },
  {
    zip_code: "85375",

    ste_name: "AZ",
  },
  {
    zip_code: "85539",

    ste_name: "AZ",
  },
  {
    zip_code: "85739",

    ste_name: "AZ",
  },
  {
    zip_code: "86017",

    ste_name: "AZ",
  },
  {
    zip_code: "86025",

    ste_name: "AZ",
  },
  {
    zip_code: "86054",

    ste_name: "AZ",
  },
  {
    zip_code: "87104",

    ste_name: "NM",
  },
  {
    zip_code: "87122",

    ste_name: "NM",
  },
  {
    zip_code: "87321",

    ste_name: "NM",
  },
  {
    zip_code: "87412",

    ste_name: "NM",
  },
  {
    zip_code: "87535",

    ste_name: "NM",
  },
  {
    zip_code: "87582",

    ste_name: "NM",
  },
  {
    zip_code: "87711",

    ste_name: "NM",
  },
  {
    zip_code: "87745",

    ste_name: "NM",
  },
  {
    zip_code: "87832",

    ste_name: "NM",
  },
  {
    zip_code: "88136",

    ste_name: "NM",
  },
  {
    zip_code: "88422",

    ste_name: "NM",
  },
  {
    zip_code: "88424",

    ste_name: "NM",
  },
  {
    zip_code: "89005",

    ste_name: "NV",
  },
  {
    zip_code: "89113",

    ste_name: "NV",
  },
  {
    zip_code: "89139",

    ste_name: "NV",
  },
  {
    zip_code: "89144",

    ste_name: "NV",
  },
  {
    zip_code: "89148",

    ste_name: "NV",
  },
  {
    zip_code: "89179",

    ste_name: "NV",
  },
  {
    zip_code: "89408",

    ste_name: "NV",
  },
  {
    zip_code: "89426",

    ste_name: "NV",
  },
  {
    zip_code: "89512",

    ste_name: "NV",
  },
  {
    zip_code: "90039",

    ste_name: "CA",
  },
  {
    zip_code: "90058",

    ste_name: "CA",
  },
  {
    zip_code: "90806",

    ste_name: "CA",
  },
  {
    zip_code: "91011",

    ste_name: "CA",
  },
  {
    zip_code: "91103",

    ste_name: "CA",
  },
  {
    zip_code: "91360",

    ste_name: "CA",
  },
  {
    zip_code: "91604",

    ste_name: "CA",
  },
  {
    zip_code: "92065",

    ste_name: "CA",
  },
  {
    zip_code: "92071",

    ste_name: "CA",
  },
  {
    zip_code: "92249",

    ste_name: "CA",
  },
  {
    zip_code: "92337",

    ste_name: "CA",
  },
  {
    zip_code: "92395",

    ste_name: "CA",
  },
  {
    zip_code: "92411",

    ste_name: "CA",
  },
  {
    zip_code: "92539",

    ste_name: "CA",
  },
  {
    zip_code: "92583",

    ste_name: "CA",
  },
  {
    zip_code: "92677",

    ste_name: "CA",
  },
  {
    zip_code: "92679",

    ste_name: "CA",
  },
  {
    zip_code: "92704",

    ste_name: "CA",
  },
  {
    zip_code: "92807",

    ste_name: "CA",
  },
  {
    zip_code: "92843",

    ste_name: "CA",
  },
  {
    zip_code: "92865",

    ste_name: "CA",
  },
  {
    zip_code: "93060",

    ste_name: "CA",
  },
  {
    zip_code: "93064",

    ste_name: "CA",
  },
  {
    zip_code: "93109",

    ste_name: "CA",
  },
  {
    zip_code: "93244",

    ste_name: "CA",
  },
  {
    zip_code: "93251",

    ste_name: "CA",
  },
  {
    zip_code: "93427",

    ste_name: "CA",
  },
  {
    zip_code: "93428",

    ste_name: "CA",
  },
  {
    zip_code: "93450",

    ste_name: "CA",
  },
  {
    zip_code: "93546",

    ste_name: "CA",
  },
  {
    zip_code: "93551",

    ste_name: "CA",
  },
  {
    zip_code: "93592",

    ste_name: "CA",
  },
  {
    zip_code: "93624",

    ste_name: "CA",
  },
  {
    zip_code: "93626",

    ste_name: "CA",
  },
  {
    zip_code: "93636",

    ste_name: "CA",
  },
  {
    zip_code: "93645",

    ste_name: "CA",
  },
  {
    zip_code: "93666",

    ste_name: "CA",
  },
  {
    zip_code: "93701",

    ste_name: "CA",
  },
  {
    zip_code: "93933",

    ste_name: "CA",
  },
  {
    zip_code: "94014",

    ste_name: "CA",
  },
  {
    zip_code: "94114",

    ste_name: "CA",
  },
  {
    zip_code: "94538",

    ste_name: "CA",
  },
  {
    zip_code: "94609",

    ste_name: "CA",
  },
  {
    zip_code: "95111",

    ste_name: "CA",
  },
  {
    zip_code: "95116",

    ste_name: "CA",
  },
  {
    zip_code: "95325",

    ste_name: "CA",
  },
  {
    zip_code: "95327",

    ste_name: "CA",
  },
  {
    zip_code: "95334",

    ste_name: "CA",
  },
  {
    zip_code: "95336",

    ste_name: "CA",
  },
  {
    zip_code: "95345",

    ste_name: "CA",
  },
  {
    zip_code: "95471",

    ste_name: "CA",
  },
  {
    zip_code: "95485",

    ste_name: "CA",
  },
  {
    zip_code: "95554",

    ste_name: "CA",
  },
  {
    zip_code: "95618",

    ste_name: "CA",
  },
  {
    zip_code: "95625",

    ste_name: "CA",
  },
  {
    zip_code: "95666",

    ste_name: "CA",
  },
  {
    zip_code: "95678",

    ste_name: "CA",
  },
  {
    zip_code: "95936",

    ste_name: "CA",
  },
  {
    zip_code: "95973",

    ste_name: "CA",
  },
  {
    zip_code: "96020",

    ste_name: "CA",
  },
  {
    zip_code: "96052",

    ste_name: "CA",
  },
  {
    zip_code: "96751",

    ste_name: "HI",
  },
  {
    zip_code: "96766",

    ste_name: "HI",
  },
  {
    zip_code: "96816",

    ste_name: "HI",
  },
  {
    zip_code: "96860",

    ste_name: "HI",
  },
  {
    zip_code: "96910",

    ste_name: "GU",
  },
  {
    zip_code: "97111",

    ste_name: "OR",
  },
  {
    zip_code: "97137",

    ste_name: "OR",
  },
  {
    zip_code: "97216",

    ste_name: "OR",
  },
  {
    zip_code: "97331",

    ste_name: "OR",
  },
  {
    zip_code: "97368",

    ste_name: "OR",
  },
  {
    zip_code: "97369",

    ste_name: "OR",
  },
  {
    zip_code: "97414",

    ste_name: "OR",
  },
  {
    zip_code: "97415",

    ste_name: "OR",
  },
  {
    zip_code: "97447",

    ste_name: "OR",
  },
  {
    zip_code: "97496",

    ste_name: "OR",
  },
  {
    zip_code: "97520",

    ste_name: "OR",
  },
  {
    zip_code: "97702",

    ste_name: "OR",
  },
  {
    zip_code: "97737",

    ste_name: "OR",
  },
  {
    zip_code: "97812",

    ste_name: "OR",
  },
  {
    zip_code: "98001",

    ste_name: "WA",
  },
  {
    zip_code: "98166",

    ste_name: "WA",
  },
  {
    zip_code: "98233",

    ste_name: "WA",
  },
  {
    zip_code: "98275",

    ste_name: "WA",
  },
  {
    zip_code: "98281",

    ste_name: "WA",
  },
  {
    zip_code: "98282",

    ste_name: "WA",
  },
  {
    zip_code: "98424",

    ste_name: "WA",
  },
  {
    zip_code: "98569",

    ste_name: "WA",
  },
  {
    zip_code: "98582",

    ste_name: "WA",
  },
  {
    zip_code: "98607",

    ste_name: "WA",
  },
  {
    zip_code: "98616",

    ste_name: "WA",
  },
  {
    zip_code: "98641",

    ste_name: "WA",
  },
  {
    zip_code: "98651",

    ste_name: "WA",
  },
  {
    zip_code: "98942",

    ste_name: "WA",
  },
  {
    zip_code: "99016",

    ste_name: "WA",
  },
  {
    zip_code: "99025",

    ste_name: "WA",
  },
  {
    zip_code: "99137",

    ste_name: "WA",
  },
  {
    zip_code: "99179",

    ste_name: "WA",
  },
  {
    zip_code: "99218",

    ste_name: "WA",
  },
  {
    zip_code: "99551",

    ste_name: "AK",
  },
  {
    zip_code: "99603",

    ste_name: "AK",
  },
  {
    zip_code: "99612",

    ste_name: "AK",
  },
  {
    zip_code: "99678",

    ste_name: "AK",
  },
  {
    zip_code: "99695",

    ste_name: "AK",
  },
  {
    zip_code: "99723",

    ste_name: "AK",
  },
  {
    zip_code: "99752",

    ste_name: "AK",
  },
  {
    zip_code: "98375",

    ste_name: "WA",
  },
  {
    zip_code: "98380",

    ste_name: "WA",
  },
  {
    zip_code: "98392",

    ste_name: "WA",
  },
  {
    zip_code: "98394",

    ste_name: "WA",
  },
  {
    zip_code: "98592",

    ste_name: "WA",
  },
  {
    zip_code: "98596",

    ste_name: "WA",
  },
  {
    zip_code: "98816",

    ste_name: "WA",
  },
  {
    zip_code: "98846",

    ste_name: "WA",
  },
  {
    zip_code: "99119",

    ste_name: "WA",
  },
  {
    zip_code: "99150",

    ste_name: "WA",
  },
  {
    zip_code: "99160",

    ste_name: "WA",
  },
  {
    zip_code: "99371",

    ste_name: "WA",
  },
  {
    zip_code: "99590",

    ste_name: "AK",
  },
  {
    zip_code: "99602",

    ste_name: "AK",
  },
  {
    zip_code: "99604",

    ste_name: "AK",
  },
  {
    zip_code: "99660",

    ste_name: "AK",
  },
  {
    zip_code: "99667",

    ste_name: "AK",
  },
  {
    zip_code: "99676",

    ste_name: "AK",
  },
  {
    zip_code: "99679",

    ste_name: "AK",
  },
  {
    zip_code: "99694",

    ste_name: "AK",
  },
  {
    zip_code: "99706",

    ste_name: "AK",
  },
  {
    zip_code: "99730",

    ste_name: "AK",
  },
  {
    zip_code: "99758",

    ste_name: "AK",
  },
  {
    zip_code: "99826",

    ste_name: "AK",
  },
  {
    zip_code: "31035",

    ste_name: "GA",
  },
  {
    zip_code: "31038",

    ste_name: "GA",
  },
  {
    zip_code: "31070",

    ste_name: "GA",
  },
  {
    zip_code: "31088",

    ste_name: "GA",
  },
  {
    zip_code: "31523",

    ste_name: "GA",
  },
  {
    zip_code: "31560",

    ste_name: "GA",
  },
  {
    zip_code: "31601",

    ste_name: "GA",
  },
  {
    zip_code: "31629",

    ste_name: "GA",
  },
  {
    zip_code: "31635",

    ste_name: "GA",
  },
  {
    zip_code: "31641",

    ste_name: "GA",
  },
  {
    zip_code: "31774",

    ste_name: "GA",
  },
  {
    zip_code: "31832",

    ste_name: "GA",
  },
  {
    zip_code: "32025",

    ste_name: "FL",
  },
  {
    zip_code: "32071",

    ste_name: "FL",
  },
  {
    zip_code: "32073",

    ste_name: "FL",
  },
  {
    zip_code: "32092",

    ste_name: "FL",
  },
  {
    zip_code: "32145",

    ste_name: "FL",
  },
  {
    zip_code: "32164",

    ste_name: "FL",
  },
  {
    zip_code: "32195",

    ste_name: "FL",
  },
  {
    zip_code: "32207",

    ste_name: "FL",
  },
  {
    zip_code: "32323",

    ste_name: "FL",
  },
  {
    zip_code: "32334",

    ste_name: "FL",
  },
  {
    zip_code: "32344",

    ste_name: "FL",
  },
  {
    zip_code: "32421",

    ste_name: "FL",
  },
  {
    zip_code: "32514",

    ste_name: "FL",
  },
  {
    zip_code: "32535",

    ste_name: "FL",
  },
  {
    zip_code: "32693",

    ste_name: "FL",
  },
  {
    zip_code: "32713",

    ste_name: "FL",
  },
  {
    zip_code: "32798",

    ste_name: "FL",
  },
  {
    zip_code: "33015",

    ste_name: "FL",
  },
  {
    zip_code: "33025",

    ste_name: "FL",
  },
  {
    zip_code: "33030",

    ste_name: "FL",
  },
  {
    zip_code: "33179",

    ste_name: "FL",
  },
  {
    zip_code: "33308",

    ste_name: "FL",
  },
  {
    zip_code: "33312",

    ste_name: "FL",
  },
  {
    zip_code: "33321",

    ste_name: "FL",
  },
  {
    zip_code: "33404",

    ste_name: "FL",
  },
  {
    zip_code: "33414",

    ste_name: "FL",
  },
  {
    zip_code: "33477",

    ste_name: "FL",
  },
  {
    zip_code: "33514",

    ste_name: "FL",
  },
  {
    zip_code: "33547",

    ste_name: "FL",
  },
  {
    zip_code: "33598",

    ste_name: "FL",
  },
  {
    zip_code: "33617",

    ste_name: "FL",
  },
  {
    zip_code: "33762",

    ste_name: "FL",
  },
  {
    zip_code: "33876",

    ste_name: "FL",
  },
  {
    zip_code: "33930",

    ste_name: "FL",
  },
  {
    zip_code: "33974",

    ste_name: "FL",
  },
  {
    zip_code: "33980",

    ste_name: "FL",
  },
  {
    zip_code: "34119",

    ste_name: "FL",
  },
  {
    zip_code: "34221",

    ste_name: "FL",
  },
  {
    zip_code: "34609",

    ste_name: "FL",
  },
  {
    zip_code: "35044",

    ste_name: "AL",
  },
  {
    zip_code: "35089",

    ste_name: "AL",
  },
  {
    zip_code: "35147",

    ste_name: "AL",
  },
  {
    zip_code: "35457",

    ste_name: "AL",
  },
  {
    zip_code: "35462",

    ste_name: "AL",
  },
  {
    zip_code: "35490",

    ste_name: "AL",
  },
  {
    zip_code: "35544",

    ste_name: "AL",
  },
  {
    zip_code: "35616",

    ste_name: "AL",
  },
  {
    zip_code: "35747",

    ste_name: "AL",
  },
  {
    zip_code: "36013",

    ste_name: "AL",
  },
  {
    zip_code: "36279",

    ste_name: "AL",
  },
  {
    zip_code: "36313",

    ste_name: "AL",
  },
  {
    zip_code: "36426",

    ste_name: "AL",
  },
  {
    zip_code: "36522",

    ste_name: "AL",
  },
  {
    zip_code: "36538",

    ste_name: "AL",
  },
  {
    zip_code: "36722",

    ste_name: "AL",
  },
  {
    zip_code: "36751",

    ste_name: "AL",
  },
  {
    zip_code: "36769",

    ste_name: "AL",
  },
  {
    zip_code: "36832",

    ste_name: "AL",
  },
  {
    zip_code: "37030",

    ste_name: "TN",
  },
  {
    zip_code: "37043",

    ste_name: "TN",
  },
  {
    zip_code: "37049",

    ste_name: "TN",
  },
  {
    zip_code: "37181",

    ste_name: "TN",
  },
  {
    zip_code: "37212",

    ste_name: "TN",
  },
  {
    zip_code: "37328",

    ste_name: "TN",
  },
  {
    zip_code: "37330",

    ste_name: "TN",
  },
  {
    zip_code: "37335",

    ste_name: "TN",
  },
  {
    zip_code: "37360",

    ste_name: "TN",
  },
  {
    zip_code: "37643",

    ste_name: "TN",
  },
  {
    zip_code: "37902",

    ste_name: "TN",
  },
  {
    zip_code: "38030",

    ste_name: "TN",
  },
  {
    zip_code: "38075",

    ste_name: "TN",
  },
  {
    zip_code: "38547",

    ste_name: "TN",
  },
  {
    zip_code: "38563",

    ste_name: "TN",
  },
  {
    zip_code: "38564",

    ste_name: "TN",
  },
  {
    zip_code: "38573",

    ste_name: "TN",
  },
  {
    zip_code: "38581",

    ste_name: "TN",
  },
  {
    zip_code: "38585",

    ste_name: "TN",
  },
  {
    zip_code: "38645",

    ste_name: "MS",
  },
  {
    zip_code: "38702",

    ste_name: "MS",
  },
  {
    zip_code: "38828",

    ste_name: "MS",
  },
  {
    zip_code: "38922",

    ste_name: "MS",
  },
  {
    zip_code: "38961",

    ste_name: "MS",
  },
  {
    zip_code: "39094",

    ste_name: "MS",
  },
  {
    zip_code: "39174",

    ste_name: "MS",
  },
  {
    zip_code: "39189",

    ste_name: "MS",
  },
  {
    zip_code: "39192",

    ste_name: "MS",
  },
  {
    zip_code: "39206",

    ste_name: "MS",
  },
  {
    zip_code: "58009",

    ste_name: "ND",
  },
  {
    zip_code: "58038",

    ste_name: "ND",
  },
  {
    zip_code: "58329",

    ste_name: "ND",
  },
  {
    zip_code: "58335",

    ste_name: "ND",
  },
  {
    zip_code: "58405",

    ste_name: "ND",
  },
  {
    zip_code: "58488",

    ste_name: "ND",
  },
  {
    zip_code: "58545",

    ste_name: "ND",
  },
  {
    zip_code: "58565",

    ste_name: "ND",
  },
  {
    zip_code: "58579",

    ste_name: "ND",
  },
  {
    zip_code: "58710",

    ste_name: "ND",
  },
  {
    zip_code: "58740",

    ste_name: "ND",
  },
  {
    zip_code: "58782",

    ste_name: "ND",
  },
  {
    zip_code: "58793",

    ste_name: "ND",
  },
  {
    zip_code: "58852",

    ste_name: "ND",
  },
  {
    zip_code: "58853",

    ste_name: "ND",
  },
  {
    zip_code: "59026",

    ste_name: "MT",
  },
  {
    zip_code: "59036",

    ste_name: "MT",
  },
  {
    zip_code: "59070",

    ste_name: "MT",
  },
  {
    zip_code: "59078",

    ste_name: "MT",
  },
  {
    zip_code: "59082",

    ste_name: "MT",
  },
  {
    zip_code: "59219",

    ste_name: "MT",
  },
  {
    zip_code: "59465",

    ste_name: "MT",
  },
  {
    zip_code: "59483",

    ste_name: "MT",
  },
  {
    zip_code: "59713",

    ste_name: "MT",
  },
  {
    zip_code: "59821",

    ste_name: "MT",
  },
  {
    zip_code: "59826",

    ste_name: "MT",
  },
  {
    zip_code: "59874",

    ste_name: "MT",
  },
  {
    zip_code: "59928",

    ste_name: "MT",
  },
  {
    zip_code: "60093",

    ste_name: "IL",
  },
  {
    zip_code: "60118",

    ste_name: "IL",
  },
  {
    zip_code: "60171",

    ste_name: "IL",
  },
  {
    zip_code: "60181",

    ste_name: "IL",
  },
  {
    zip_code: "60202",

    ste_name: "IL",
  },
  {
    zip_code: "60406",

    ste_name: "IL",
  },
  {
    zip_code: "60437",

    ste_name: "IL",
  },
  {
    zip_code: "60456",

    ste_name: "IL",
  },
  {
    zip_code: "60516",

    ste_name: "IL",
  },
  {
    zip_code: "60518",

    ste_name: "IL",
  },
  {
    zip_code: "60611",

    ste_name: "IL",
  },
  {
    zip_code: "60625",

    ste_name: "IL",
  },
  {
    zip_code: "60626",

    ste_name: "IL",
  },
  {
    zip_code: "60637",

    ste_name: "IL",
  },
  {
    zip_code: "60953",

    ste_name: "IL",
  },
  {
    zip_code: "60968",

    ste_name: "IL",
  },
  {
    zip_code: "61038",

    ste_name: "IL",
  },
  {
    zip_code: "61077",

    ste_name: "IL",
  },
  {
    zip_code: "61235",

    ste_name: "IL",
  },
  {
    zip_code: "61236",

    ste_name: "IL",
  },
  {
    zip_code: "61239",

    ste_name: "IL",
  },
  {
    zip_code: "61251",

    ste_name: "IL",
  },
  {
    zip_code: "61274",

    ste_name: "IL",
  },
  {
    zip_code: "61316",

    ste_name: "IL",
  },
  {
    zip_code: "61370",

    ste_name: "IL",
  },
  {
    zip_code: "61423",

    ste_name: "IL",
  },
  {
    zip_code: "61470",

    ste_name: "IL",
  },
  {
    zip_code: "61529",

    ste_name: "IL",
  },
  {
    zip_code: "61548",

    ste_name: "IL",
  },
  {
    zip_code: "61753",

    ste_name: "IL",
  },
  {
    zip_code: "61775",

    ste_name: "IL",
  },
  {
    zip_code: "61822",

    ste_name: "IL",
  },
  {
    zip_code: "61856",

    ste_name: "IL",
  },
  {
    zip_code: "61874",

    ste_name: "IL",
  },
  {
    zip_code: "61877",

    ste_name: "IL",
  },
  {
    zip_code: "62084",

    ste_name: "IL",
  },
  {
    zip_code: "62401",

    ste_name: "IL",
  },
  {
    zip_code: "62518",

    ste_name: "IL",
  },
  {
    zip_code: "62572",

    ste_name: "IL",
  },
  {
    zip_code: "62689",

    ste_name: "IL",
  },
  {
    zip_code: "62836",

    ste_name: "IL",
  },
  {
    zip_code: "62878",

    ste_name: "IL",
  },
  {
    zip_code: "62887",

    ste_name: "IL",
  },
  {
    zip_code: "62891",

    ste_name: "IL",
  },
  {
    zip_code: "62892",

    ste_name: "IL",
  },
  {
    zip_code: "62943",

    ste_name: "IL",
  },
  {
    zip_code: "62976",

    ste_name: "IL",
  },
  {
    zip_code: "63020",

    ste_name: "MO",
  },
  {
    zip_code: "63042",

    ste_name: "MO",
  },
  {
    zip_code: "63061",

    ste_name: "MO",
  },
  {
    zip_code: "63111",

    ste_name: "MO",
  },
  {
    zip_code: "63126",

    ste_name: "MO",
  },
  {
    zip_code: "63379",

    ste_name: "MO",
  },
  {
    zip_code: "63387",

    ste_name: "MO",
  },
  {
    zip_code: "63436",

    ste_name: "MO",
  },
  {
    zip_code: "63556",

    ste_name: "MO",
  },
  {
    zip_code: "63620",

    ste_name: "MO",
  },
  {
    zip_code: "63636",

    ste_name: "MO",
  },
  {
    zip_code: "63730",

    ste_name: "MO",
  },
  {
    zip_code: "63742",

    ste_name: "MO",
  },
  {
    zip_code: "63763",

    ste_name: "MO",
  },
  {
    zip_code: "63939",

    ste_name: "MO",
  },
  {
    zip_code: "63954",

    ste_name: "MO",
  },
  {
    zip_code: "63962",

    ste_name: "MO",
  },
  {
    zip_code: "63964",

    ste_name: "MO",
  },
  {
    zip_code: "64437",

    ste_name: "MO",
  },
  {
    zip_code: "64471",

    ste_name: "MO",
  },
  {
    zip_code: "64474",

    ste_name: "MO",
  },
  {
    zip_code: "64483",

    ste_name: "MO",
  },
  {
    zip_code: "64504",

    ste_name: "MO",
  },
  {
    zip_code: "64507",

    ste_name: "MO",
  },
  {
    zip_code: "64638",

    ste_name: "MO",
  },
  {
    zip_code: "64660",

    ste_name: "MO",
  },
  {
    zip_code: "64681",

    ste_name: "MO",
  },
  {
    zip_code: "64739",

    ste_name: "MO",
  },
  {
    zip_code: "64763",

    ste_name: "MO",
  },
  {
    zip_code: "64769",

    ste_name: "MO",
  },
  {
    zip_code: "65052",

    ste_name: "MO",
  },
  {
    zip_code: "65064",

    ste_name: "MO",
  },
  {
    zip_code: "65259",

    ste_name: "MO",
  },
  {
    zip_code: "65324",

    ste_name: "MO",
  },
  {
    zip_code: "65345",

    ste_name: "MO",
  },
  {
    zip_code: "65452",

    ste_name: "MO",
  },
  {
    zip_code: "65479",

    ste_name: "MO",
  },
  {
    zip_code: "65535",

    ste_name: "MO",
  },
  {
    zip_code: "65623",

    ste_name: "MO",
  },
  {
    zip_code: "65630",

    ste_name: "MO",
  },
  {
    zip_code: "65672",

    ste_name: "MO",
  },
  {
    zip_code: "65747",

    ste_name: "MO",
  },
  {
    zip_code: "65753",

    ste_name: "MO",
  },
  {
    zip_code: "65806",

    ste_name: "MO",
  },
  {
    zip_code: "66046",

    ste_name: "KS",
  },
  {
    zip_code: "66115",

    ste_name: "KS",
  },
  {
    zip_code: "66215",

    ste_name: "KS",
  },
  {
    zip_code: "66223",

    ste_name: "KS",
  },
  {
    zip_code: "66408",

    ste_name: "KS",
  },
  {
    zip_code: "66534",

    ste_name: "KS",
  },
  {
    zip_code: "66604",

    ste_name: "KS",
  },
  {
    zip_code: "66840",

    ste_name: "KS",
  },
  {
    zip_code: "66846",

    ste_name: "KS",
  },
  {
    zip_code: "66859",

    ste_name: "KS",
  },
  {
    zip_code: "66863",

    ste_name: "KS",
  },
  {
    zip_code: "66873",

    ste_name: "KS",
  },
  {
    zip_code: "66949",

    ste_name: "KS",
  },
  {
    zip_code: "67074",

    ste_name: "KS",
  },
  {
    zip_code: "67216",

    ste_name: "KS",
  },
  {
    zip_code: "67336",

    ste_name: "KS",
  },
  {
    zip_code: "67352",

    ste_name: "KS",
  },
  {
    zip_code: "67422",

    ste_name: "KS",
  },
  {
    zip_code: "67432",

    ste_name: "KS",
  },
  {
    zip_code: "67439",

    ste_name: "KS",
  },
  {
    zip_code: "67443",

    ste_name: "KS",
  },
  {
    zip_code: "67459",

    ste_name: "KS",
  },
  {
    zip_code: "67505",

    ste_name: "KS",
  },
  {
    zip_code: "67525",

    ste_name: "KS",
  },
  {
    zip_code: "67573",

    ste_name: "KS",
  },
  {
    zip_code: "67741",

    ste_name: "KS",
  },
  {
    zip_code: "67837",

    ste_name: "KS",
  },
  {
    zip_code: "68044",

    ste_name: "NE",
  },
  {
    zip_code: "68113",

    ste_name: "NE",
  },
  {
    zip_code: "68309",

    ste_name: "NE",
  },
  {
    zip_code: "68380",

    ste_name: "NE",
  },
  {
    zip_code: "68420",

    ste_name: "NE",
  },
  {
    zip_code: "68421",

    ste_name: "NE",
  },
  {
    zip_code: "68457",

    ste_name: "NE",
  },
  {
    zip_code: "68504",

    ste_name: "NE",
  },
  {
    zip_code: "68514",

    ste_name: "NE",
  },
  {
    zip_code: "68632",

    ste_name: "NE",
  },
  {
    zip_code: "68648",

    ste_name: "NE",
  },
  {
    zip_code: "68701",

    ste_name: "NE",
  },
  {
    zip_code: "68716",

    ste_name: "NE",
  },
  {
    zip_code: "68720",

    ste_name: "NE",
  },
  {
    zip_code: "68722",

    ste_name: "NE",
  },
  {
    zip_code: "68817",

    ste_name: "NE",
  },
  {
    zip_code: "68824",

    ste_name: "NE",
  },
  {
    zip_code: "68846",

    ste_name: "NE",
  },
  {
    zip_code: "68944",

    ste_name: "NE",
  },
  {
    zip_code: "69220",

    ste_name: "NE",
  },
  {
    zip_code: "69333",

    ste_name: "NE",
  },
  {
    zip_code: "69346",

    ste_name: "NE",
  },
  {
    zip_code: "69347",

    ste_name: "NE",
  },
  {
    zip_code: "70037",

    ste_name: "LA",
  },
  {
    zip_code: "70364",

    ste_name: "LA",
  },
  {
    zip_code: "70372",

    ste_name: "LA",
  },
  {
    zip_code: "70426",

    ste_name: "LA",
  },
  {
    zip_code: "70431",

    ste_name: "LA",
  },
  {
    zip_code: "70443",

    ste_name: "LA",
  },
  {
    zip_code: "70537",

    ste_name: "LA",
  },
  {
    zip_code: "70630",

    ste_name: "LA",
  },
  {
    zip_code: "70665",

    ste_name: "LA",
  },
  {
    zip_code: "70669",

    ste_name: "LA",
  },
  {
    zip_code: "70730",

    ste_name: "LA",
  },
  {
    zip_code: "71326",

    ste_name: "LA",
  },
  {
    zip_code: "71455",

    ste_name: "LA",
  },
  {
    zip_code: "71851",

    ste_name: "AR",
  },
  {
    zip_code: "71941",

    ste_name: "AR",
  },
  {
    zip_code: "72013",

    ste_name: "AR",
  },
  {
    zip_code: "72027",

    ste_name: "AR",
  },
  {
    zip_code: "72039",

    ste_name: "AR",
  },
  {
    zip_code: "72058",

    ste_name: "AR",
  },
  {
    zip_code: "72060",

    ste_name: "AR",
  },
  {
    zip_code: "72102",

    ste_name: "AR",
  },
  {
    zip_code: "72125",

    ste_name: "AR",
  },
  {
    zip_code: "72156",

    ste_name: "AR",
  },
  {
    zip_code: "72205",

    ste_name: "AR",
  },
  {
    zip_code: "72347",

    ste_name: "AR",
  },
  {
    zip_code: "72359",

    ste_name: "AR",
  },
  {
    zip_code: "72376",

    ste_name: "AR",
  },
  {
    zip_code: "72383",

    ste_name: "AR",
  },
  {
    zip_code: "72626",

    ste_name: "AR",
  },
  {
    zip_code: "72660",

    ste_name: "AR",
  },
  {
    zip_code: "72727",

    ste_name: "AR",
  },
  {
    zip_code: "72740",

    ste_name: "AR",
  },
  {
    zip_code: "72843",

    ste_name: "AR",
  },
  {
    zip_code: "72921",

    ste_name: "AR",
  },
  {
    zip_code: "73013",

    ste_name: "OK",
  },
  {
    zip_code: "73021",

    ste_name: "OK",
  },
  {
    zip_code: "73054",

    ste_name: "OK",
  },
  {
    zip_code: "73055",

    ste_name: "OK",
  },
  {
    zip_code: "73726",

    ste_name: "OK",
  },
  {
    zip_code: "73761",

    ste_name: "OK",
  },
  {
    zip_code: "74014",

    ste_name: "OK",
  },
  {
    zip_code: "74029",

    ste_name: "OK",
  },
  {
    zip_code: "74056",

    ste_name: "OK",
  },
  {
    zip_code: "74066",

    ste_name: "OK",
  },
  {
    zip_code: "74115",

    ste_name: "OK",
  },
  {
    zip_code: "74130",

    ste_name: "OK",
  },
  {
    zip_code: "74349",

    ste_name: "OK",
  },
  {
    zip_code: "74422",

    ste_name: "OK",
  },
  {
    zip_code: "74562",

    ste_name: "OK",
  },
  {
    zip_code: "74578",

    ste_name: "OK",
  },
  {
    zip_code: "74756",

    ste_name: "OK",
  },
  {
    zip_code: "74804",

    ste_name: "OK",
  },
  {
    zip_code: "74946",

    ste_name: "OK",
  },
  {
    zip_code: "74954",

    ste_name: "OK",
  },
  {
    zip_code: "74955",

    ste_name: "OK",
  },
  {
    zip_code: "75007",

    ste_name: "TX",
  },
  {
    zip_code: "75021",

    ste_name: "TX",
  },
  {
    zip_code: "75098",

    ste_name: "TX",
  },
  {
    zip_code: "75228",

    ste_name: "TX",
  },
  {
    zip_code: "75249",

    ste_name: "TX",
  },
  {
    zip_code: "75491",

    ste_name: "TX",
  },
  {
    zip_code: "75493",

    ste_name: "TX",
  },
  {
    zip_code: "75684",

    ste_name: "TX",
  },
  {
    zip_code: "75766",

    ste_name: "TX",
  },
  {
    zip_code: "75904",

    ste_name: "TX",
  },
  {
    zip_code: "75931",

    ste_name: "TX",
  },
  {
    zip_code: "76018",

    ste_name: "TX",
  },
  {
    zip_code: "76053",

    ste_name: "TX",
  },
  {
    zip_code: "76253",

    ste_name: "TX",
  },
  {
    zip_code: "76311",

    ste_name: "TX",
  },
  {
    zip_code: "76452",

    ste_name: "TX",
  },
  {
    zip_code: "76636",

    ste_name: "TX",
  },
  {
    zip_code: "76640",

    ste_name: "TX",
  },
  {
    zip_code: "76908",

    ste_name: "TX",
  },
  {
    zip_code: "77057",

    ste_name: "TX",
  },
  {
    zip_code: "77083",

    ste_name: "TX",
  },
  {
    zip_code: "77094",

    ste_name: "TX",
  },
  {
    zip_code: "77396",

    ste_name: "TX",
  },
  {
    zip_code: "77485",

    ste_name: "TX",
  },
  {
    zip_code: "77597",

    ste_name: "TX",
  },
  {
    zip_code: "77650",

    ste_name: "TX",
  },
  {
    zip_code: "77990",

    ste_name: "TX",
  },
  {
    zip_code: "78006",

    ste_name: "TX",
  },
  {
    zip_code: "78064",

    ste_name: "TX",
  },
  {
    zip_code: "78101",

    ste_name: "TX",
  },
  {
    zip_code: "78114",

    ste_name: "TX",
  },
  {
    zip_code: "78123",

    ste_name: "TX",
  },
  {
    zip_code: "78164",

    ste_name: "TX",
  },
  {
    zip_code: "78401",

    ste_name: "TX",
  },
  {
    zip_code: "78404",

    ste_name: "TX",
  },
  {
    zip_code: "78413",

    ste_name: "TX",
  },
  {
    zip_code: "78501",

    ste_name: "TX",
  },
  {
    zip_code: "78589",

    ste_name: "TX",
  },
  {
    zip_code: "78654",

    ste_name: "TX",
  },
  {
    zip_code: "78712",

    ste_name: "TX",
  },
  {
    zip_code: "78733",

    ste_name: "TX",
  },
  {
    zip_code: "78737",

    ste_name: "TX",
  },
  {
    zip_code: "78746",

    ste_name: "TX",
  },
  {
    zip_code: "78749",

    ste_name: "TX",
  },
  {
    zip_code: "78801",

    ste_name: "TX",
  },
  {
    zip_code: "78839",

    ste_name: "TX",
  },
  {
    zip_code: "79012",

    ste_name: "TX",
  },
  {
    zip_code: "79024",

    ste_name: "TX",
  },
  {
    zip_code: "79062",

    ste_name: "TX",
  },
  {
    zip_code: "79121",

    ste_name: "TX",
  },
  {
    zip_code: "79201",

    ste_name: "TX",
  },
  {
    zip_code: "79344",

    ste_name: "TX",
  },
  {
    zip_code: "79560",

    ste_name: "TX",
  },
  {
    zip_code: "79772",

    ste_name: "TX",
  },
  {
    zip_code: "79830",

    ste_name: "TX",
  },
  {
    zip_code: "79843",

    ste_name: "TX",
  },
  {
    zip_code: "79911",

    ste_name: "TX",
  },
  {
    zip_code: "79916",

    ste_name: "TX",
  },
  {
    zip_code: "79925",

    ste_name: "TX",
  },
  {
    zip_code: "79934",

    ste_name: "TX",
  },
  {
    zip_code: "80003",

    ste_name: "CO",
  },
  {
    zip_code: "80014",

    ste_name: "CO",
  },
  {
    zip_code: "80016",

    ste_name: "CO",
  },
  {
    zip_code: "80020",

    ste_name: "CO",
  },
  {
    zip_code: "80109",

    ste_name: "CO",
  },
  {
    zip_code: "80212",

    ste_name: "CO",
  },
  {
    zip_code: "80219",

    ste_name: "CO",
  },
  {
    zip_code: "80241",

    ste_name: "CO",
  },
  {
    zip_code: "80301",

    ste_name: "CO",
  },
  {
    zip_code: "80427",

    ste_name: "CO",
  },
  {
    zip_code: "80465",

    ste_name: "CO",
  },
  {
    zip_code: "80503",

    ste_name: "CO",
  },
  {
    zip_code: "80544",

    ste_name: "CO",
  },
  {
    zip_code: "80804",

    ste_name: "CO",
  },
  {
    zip_code: "80863",

    ste_name: "CO",
  },
  {
    zip_code: "80916",

    ste_name: "CO",
  },
  {
    zip_code: "80925",

    ste_name: "CO",
  },
  {
    zip_code: "80929",

    ste_name: "CO",
  },
  {
    zip_code: "81004",

    ste_name: "CO",
  },
  {
    zip_code: "81021",

    ste_name: "CO",
  },
  {
    zip_code: "81029",

    ste_name: "CO",
  },
  {
    zip_code: "81047",

    ste_name: "CO",
  },
  {
    zip_code: "81089",

    ste_name: "CO",
  },
  {
    zip_code: "81136",

    ste_name: "CO",
  },
  {
    zip_code: "81220",

    ste_name: "CO",
  },
  {
    zip_code: "81232",

    ste_name: "CO",
  },
  {
    zip_code: "81303",

    ste_name: "CO",
  },
  {
    zip_code: "81326",

    ste_name: "CO",
  },
  {
    zip_code: "81331",

    ste_name: "CO",
  },
  {
    zip_code: "81631",

    ste_name: "CO",
  },
  {
    zip_code: "81647",

    ste_name: "CO",
  },
  {
    zip_code: "82050",

    ste_name: "WY",
  },
  {
    zip_code: "82214",

    ste_name: "WY",
  },
  {
    zip_code: "82240",

    ste_name: "WY",
  },
  {
    zip_code: "82244",

    ste_name: "WY",
  },
  {
    zip_code: "82410",

    ste_name: "WY",
  },
  {
    zip_code: "82433",

    ste_name: "WY",
  },
  {
    zip_code: "82443",

    ste_name: "WY",
  },
  {
    zip_code: "82712",

    ste_name: "WY",
  },
  {
    zip_code: "82844",

    ste_name: "WY",
  },
  {
    zip_code: "83120",

    ste_name: "WY",
  },
  {
    zip_code: "83337",

    ste_name: "ID",
  },
  {
    zip_code: "83454",

    ste_name: "ID",
  },
  {
    zip_code: "83463",

    ste_name: "ID",
  },
  {
    zip_code: "83522",

    ste_name: "ID",
  },
  {
    zip_code: "83533",

    ste_name: "ID",
  },
  {
    zip_code: "83619",

    ste_name: "ID",
  },
  {
    zip_code: "83643",

    ste_name: "ID",
  },
  {
    zip_code: "83648",

    ste_name: "ID",
  },
  {
    zip_code: "83669",

    ste_name: "ID",
  },
  {
    zip_code: "83823",

    ste_name: "ID",
  },
  {
    zip_code: "84013",

    ste_name: "UT",
  },
  {
    zip_code: "84328",

    ste_name: "UT",
  },
  {
    zip_code: "84606",

    ste_name: "UT",
  },
  {
    zip_code: "84649",

    ste_name: "UT",
  },
  {
    zip_code: "84736",

    ste_name: "UT",
  },
  {
    zip_code: "84763",

    ste_name: "UT",
  },
  {
    zip_code: "84774",

    ste_name: "UT",
  },
  {
    zip_code: "85016",

    ste_name: "AZ",
  },
  {
    zip_code: "85032",

    ste_name: "AZ",
  },
  {
    zip_code: "85048",

    ste_name: "AZ",
  },
  {
    zip_code: "85173",

    ste_name: "AZ",
  },
  {
    zip_code: "85207",

    ste_name: "AZ",
  },
  {
    zip_code: "85213",

    ste_name: "AZ",
  },
  {
    zip_code: "85249",

    ste_name: "AZ",
  },
  {
    zip_code: "85258",

    ste_name: "AZ",
  },
  {
    zip_code: "85281",

    ste_name: "AZ",
  },
  {
    zip_code: "85301",

    ste_name: "AZ",
  },
  {
    zip_code: "85336",

    ste_name: "AZ",
  },
  {
    zip_code: "85349",

    ste_name: "AZ",
  },
  {
    zip_code: "85382",

    ste_name: "AZ",
  },
  {
    zip_code: "85388",

    ste_name: "AZ",
  },
  {
    zip_code: "85634",

    ste_name: "AZ",
  },
  {
    zip_code: "85704",

    ste_name: "AZ",
  },
  {
    zip_code: "85726",

    ste_name: "AZ",
  },
  {
    zip_code: "86020",

    ste_name: "AZ",
  },
  {
    zip_code: "86032",

    ste_name: "AZ",
  },
  {
    zip_code: "86325",

    ste_name: "AZ",
  },
  {
    zip_code: "86337",

    ste_name: "AZ",
  },
  {
    zip_code: "86429",

    ste_name: "AZ",
  },
  {
    zip_code: "86540",

    ste_name: "AZ",
  },
  {
    zip_code: "87007",

    ste_name: "NM",
  },
  {
    zip_code: "87042",

    ste_name: "NM",
  },
  {
    zip_code: "87102",

    ste_name: "NM",
  },
  {
    zip_code: "87320",

    ste_name: "NM",
  },
  {
    zip_code: "87326",

    ste_name: "NM",
  },
  {
    zip_code: "87375",

    ste_name: "NM",
  },
  {
    zip_code: "87519",

    ste_name: "NM",
  },
  {
    zip_code: "87530",

    ste_name: "NM",
  },
  {
    zip_code: "88029",

    ste_name: "NM",
  },
  {
    zip_code: "88230",

    ste_name: "NM",
  },
  {
    zip_code: "88421",

    ste_name: "NM",
  },
  {
    zip_code: "88435",

    ste_name: "NM",
  },
  {
    zip_code: "89045",

    ste_name: "NV",
  },
  {
    zip_code: "89108",

    ste_name: "NV",
  },
  {
    zip_code: "89120",

    ste_name: "NV",
  },
  {
    zip_code: "89411",

    ste_name: "NV",
  },
  {
    zip_code: "89420",

    ste_name: "NV",
  },
  {
    zip_code: "89434",

    ste_name: "NV",
  },
  {
    zip_code: "39322",

    ste_name: "MS",
  },
  {
    zip_code: "39362",

    ste_name: "MS",
  },
  {
    zip_code: "39480",

    ste_name: "MS",
  },
  {
    zip_code: "39501",

    ste_name: "MS",
  },
  {
    zip_code: "39560",

    ste_name: "MS",
  },
  {
    zip_code: "39574",

    ste_name: "MS",
  },
  {
    zip_code: "39581",

    ste_name: "MS",
  },
  {
    zip_code: "39656",

    ste_name: "MS",
  },
  {
    zip_code: "39819",

    ste_name: "GA",
  },
  {
    zip_code: "40117",

    ste_name: "KY",
  },
  {
    zip_code: "40206",

    ste_name: "KY",
  },
  {
    zip_code: "40245",

    ste_name: "KY",
  },
  {
    zip_code: "40312",

    ste_name: "KY",
  },
  {
    zip_code: "40390",

    ste_name: "KY",
  },
  {
    zip_code: "40445",

    ste_name: "KY",
  },
  {
    zip_code: "41098",

    ste_name: "KY",
  },
  {
    zip_code: "41204",

    ste_name: "KY",
  },
  {
    zip_code: "41230",

    ste_name: "KY",
  },
  {
    zip_code: "41548",

    ste_name: "KY",
  },
  {
    zip_code: "41663",

    ste_name: "KY",
  },
  {
    zip_code: "42039",

    ste_name: "KY",
  },
  {
    zip_code: "42076",

    ste_name: "KY",
  },
  {
    zip_code: "42151",

    ste_name: "KY",
  },
  {
    zip_code: "42236",

    ste_name: "KY",
  },
  {
    zip_code: "42303",

    ste_name: "KY",
  },
  {
    zip_code: "42322",

    ste_name: "KY",
  },
  {
    zip_code: "42337",

    ste_name: "KY",
  },
  {
    zip_code: "42409",

    ste_name: "KY",
  },
  {
    zip_code: "42741",

    ste_name: "KY",
  },
  {
    zip_code: "42746",

    ste_name: "KY",
  },
  {
    zip_code: "43005",

    ste_name: "OH",
  },
  {
    zip_code: "43025",

    ste_name: "OH",
  },
  {
    zip_code: "43081",

    ste_name: "OH",
  },
  {
    zip_code: "43135",

    ste_name: "OH",
  },
  {
    zip_code: "43140",

    ste_name: "OH",
  },
  {
    zip_code: "43232",

    ste_name: "OH",
  },
  {
    zip_code: "43323",

    ste_name: "OH",
  },
  {
    zip_code: "43457",

    ste_name: "OH",
  },
  {
    zip_code: "43739",

    ste_name: "OH",
  },
  {
    zip_code: "43755",

    ste_name: "OH",
  },
  {
    zip_code: "43933",

    ste_name: "OH",
  },
  {
    zip_code: "44004",

    ste_name: "OH",
  },
  {
    zip_code: "44145",

    ste_name: "OH",
  },
  {
    zip_code: "44687",

    ste_name: "OH",
  },
  {
    zip_code: "44818",

    ste_name: "OH",
  },
  {
    zip_code: "44853",

    ste_name: "OH",
  },
  {
    zip_code: "45013",

    ste_name: "OH",
  },
  {
    zip_code: "45102",

    ste_name: "OH",
  },
  {
    zip_code: "45150",

    ste_name: "OH",
  },
  {
    zip_code: "45171",

    ste_name: "OH",
  },
  {
    zip_code: "45209",

    ste_name: "OH",
  },
  {
    zip_code: "45239",

    ste_name: "OH",
  },
  {
    zip_code: "45249",

    ste_name: "OH",
  },
  {
    zip_code: "45252",

    ste_name: "OH",
  },
  {
    zip_code: "45302",

    ste_name: "OH",
  },
  {
    zip_code: "45305",

    ste_name: "OH",
  },
  {
    zip_code: "45617",

    ste_name: "OH",
  },
  {
    zip_code: "45630",

    ste_name: "OH",
  },
  {
    zip_code: "45695",

    ste_name: "OH",
  },
  {
    zip_code: "45698",

    ste_name: "OH",
  },
  {
    zip_code: "45710",

    ste_name: "OH",
  },
  {
    zip_code: "45740",

    ste_name: "OH",
  },
  {
    zip_code: "45806",

    ste_name: "OH",
  },
  {
    zip_code: "45820",

    ste_name: "OH",
  },
  {
    zip_code: "45869",

    ste_name: "OH",
  },
  {
    zip_code: "45891",

    ste_name: "OH",
  },
  {
    zip_code: "46037",

    ste_name: "IN",
  },
  {
    zip_code: "46105",

    ste_name: "IN",
  },
  {
    zip_code: "46143",

    ste_name: "IN",
  },
  {
    zip_code: "46147",

    ste_name: "IN",
  },
  {
    zip_code: "46221",

    ste_name: "IN",
  },
  {
    zip_code: "46224",

    ste_name: "IN",
  },
  {
    zip_code: "46250",

    ste_name: "IN",
  },
  {
    zip_code: "46347",

    ste_name: "IN",
  },
  {
    zip_code: "46356",

    ste_name: "IN",
  },
  {
    zip_code: "46393",

    ste_name: "IN",
  },
  {
    zip_code: "46919",

    ste_name: "IN",
  },
  {
    zip_code: "47120",

    ste_name: "IN",
  },
  {
    zip_code: "47123",

    ste_name: "IN",
  },
  {
    zip_code: "47234",

    ste_name: "IN",
  },
  {
    zip_code: "47327",

    ste_name: "IN",
  },
  {
    zip_code: "47345",

    ste_name: "IN",
  },
  {
    zip_code: "47387",

    ste_name: "IN",
  },
  {
    zip_code: "47406",

    ste_name: "IN",
  },
  {
    zip_code: "47465",

    ste_name: "IN",
  },
  {
    zip_code: "47550",

    ste_name: "IN",
  },
  {
    zip_code: "47575",

    ste_name: "IN",
  },
  {
    zip_code: "47708",

    ste_name: "IN",
  },
  {
    zip_code: "48014",

    ste_name: "MI",
  },
  {
    zip_code: "48032",

    ste_name: "MI",
  },
  {
    zip_code: "48065",

    ste_name: "MI",
  },
  {
    zip_code: "48137",

    ste_name: "MI",
  },
  {
    zip_code: "48143",

    ste_name: "MI",
  },
  {
    zip_code: "48190",

    ste_name: "MI",
  },
  {
    zip_code: "48204",

    ste_name: "MI",
  },
  {
    zip_code: "48326",

    ste_name: "MI",
  },
  {
    zip_code: "48327",

    ste_name: "MI",
  },
  {
    zip_code: "48359",

    ste_name: "MI",
  },
  {
    zip_code: "48374",

    ste_name: "MI",
  },
  {
    zip_code: "48382",

    ste_name: "MI",
  },
  {
    zip_code: "48411",

    ste_name: "MI",
  },
  {
    zip_code: "48419",

    ste_name: "MI",
  },
  {
    zip_code: "48604",

    ste_name: "MI",
  },
  {
    zip_code: "48607",

    ste_name: "MI",
  },
  {
    zip_code: "48744",

    ste_name: "MI",
  },
  {
    zip_code: "48838",

    ste_name: "MI",
  },
  {
    zip_code: "48842",

    ste_name: "MI",
  },
  {
    zip_code: "48867",

    ste_name: "MI",
  },
  {
    zip_code: "48876",

    ste_name: "MI",
  },
  {
    zip_code: "48886",

    ste_name: "MI",
  },
  {
    zip_code: "48891",

    ste_name: "MI",
  },
  {
    zip_code: "48906",

    ste_name: "MI",
  },
  {
    zip_code: "49010",

    ste_name: "MI",
  },
  {
    zip_code: "49046",

    ste_name: "MI",
  },
  {
    zip_code: "49066",

    ste_name: "MI",
  },
  {
    zip_code: "49242",

    ste_name: "MI",
  },
  {
    zip_code: "49267",

    ste_name: "MI",
  },
  {
    zip_code: "49403",

    ste_name: "MI",
  },
  {
    zip_code: "49412",

    ste_name: "MI",
  },
  {
    zip_code: "49546",

    ste_name: "MI",
  },
  {
    zip_code: "49618",

    ste_name: "MI",
  },
  {
    zip_code: "49636",

    ste_name: "MI",
  },
  {
    zip_code: "49717",

    ste_name: "MI",
  },
  {
    zip_code: "49722",

    ste_name: "MI",
  },
  {
    zip_code: "49788",

    ste_name: "MI",
  },
  {
    zip_code: "49863",

    ste_name: "MI",
  },
  {
    zip_code: "49917",

    ste_name: "MI",
  },
  {
    zip_code: "49918",

    ste_name: "MI",
  },
  {
    zip_code: "49969",

    ste_name: "MI",
  },
  {
    zip_code: "50061",

    ste_name: "IA",
  },
  {
    zip_code: "50126",

    ste_name: "IA",
  },
  {
    zip_code: "50167",

    ste_name: "IA",
  },
  {
    zip_code: "50321",

    ste_name: "IA",
  },
  {
    zip_code: "50401",

    ste_name: "IA",
  },
  {
    zip_code: "50420",

    ste_name: "IA",
  },
  {
    zip_code: "50475",

    ste_name: "IA",
  },
  {
    zip_code: "50511",

    ste_name: "IA",
  },
  {
    zip_code: "50535",

    ste_name: "IA",
  },
  {
    zip_code: "50557",

    ste_name: "IA",
  },
  {
    zip_code: "50583",

    ste_name: "IA",
  },
  {
    zip_code: "50591",

    ste_name: "IA",
  },
  {
    zip_code: "50601",

    ste_name: "IA",
  },
  {
    zip_code: "50624",

    ste_name: "IA",
  },
  {
    zip_code: "50628",

    ste_name: "IA",
  },
  {
    zip_code: "50642",

    ste_name: "IA",
  },
  {
    zip_code: "50676",

    ste_name: "IA",
  },
  {
    zip_code: "50853",

    ste_name: "IA",
  },
  {
    zip_code: "51436",

    ste_name: "IA",
  },
  {
    zip_code: "51444",

    ste_name: "IA",
  },
  {
    zip_code: "51530",

    ste_name: "IA",
  },
  {
    zip_code: "51565",

    ste_name: "IA",
  },
  {
    zip_code: "51566",

    ste_name: "IA",
  },
  {
    zip_code: "51646",

    ste_name: "IA",
  },
  {
    zip_code: "52045",

    ste_name: "IA",
  },
  {
    zip_code: "52079",

    ste_name: "IA",
  },
  {
    zip_code: "52140",

    ste_name: "IA",
  },
  {
    zip_code: "52144",

    ste_name: "IA",
  },
  {
    zip_code: "52215",

    ste_name: "IA",
  },
  {
    zip_code: "52247",

    ste_name: "IA",
  },
  {
    zip_code: "52249",

    ste_name: "IA",
  },
  {
    zip_code: "52327",

    ste_name: "IA",
  },
  {
    zip_code: "52348",

    ste_name: "IA",
  },
  {
    zip_code: "52551",

    ste_name: "IA",
  },
  {
    zip_code: "52567",

    ste_name: "IA",
  },
  {
    zip_code: "52594",

    ste_name: "IA",
  },
  {
    zip_code: "52601",

    ste_name: "IA",
  },
  {
    zip_code: "52640",

    ste_name: "IA",
  },
  {
    zip_code: "52660",

    ste_name: "IA",
  },
  {
    zip_code: "53037",

    ste_name: "WI",
  },
  {
    zip_code: "53048",

    ste_name: "WI",
  },
  {
    zip_code: "53073",

    ste_name: "WI",
  },
  {
    zip_code: "53104",

    ste_name: "WI",
  },
  {
    zip_code: "53144",

    ste_name: "WI",
  },
  {
    zip_code: "53181",

    ste_name: "WI",
  },
  {
    zip_code: "53522",

    ste_name: "WI",
  },
  {
    zip_code: "53526",

    ste_name: "WI",
  },
  {
    zip_code: "53530",

    ste_name: "WI",
  },
  {
    zip_code: "53598",

    ste_name: "WI",
  },
  {
    zip_code: "54002",

    ste_name: "WI",
  },
  {
    zip_code: "54024",

    ste_name: "WI",
  },
  {
    zip_code: "54180",

    ste_name: "WI",
  },
  {
    zip_code: "54208",

    ste_name: "WI",
  },
  {
    zip_code: "54420",

    ste_name: "WI",
  },
  {
    zip_code: "54446",

    ste_name: "WI",
  },
  {
    zip_code: "54542",

    ste_name: "WI",
  },
  {
    zip_code: "54563",

    ste_name: "WI",
  },
  {
    zip_code: "54632",

    ste_name: "WI",
  },
  {
    zip_code: "54740",

    ste_name: "WI",
  },
  {
    zip_code: "54757",

    ste_name: "WI",
  },
  {
    zip_code: "54814",

    ste_name: "WI",
  },
  {
    zip_code: "54842",

    ste_name: "WI",
  },
  {
    zip_code: "54844",

    ste_name: "WI",
  },
  {
    zip_code: "54876",

    ste_name: "WI",
  },
  {
    zip_code: "55018",

    ste_name: "MN",
  },
  {
    zip_code: "55113",

    ste_name: "MN",
  },
  {
    zip_code: "55328",

    ste_name: "MN",
  },
  {
    zip_code: "55341",

    ste_name: "MN",
  },
  {
    zip_code: "55343",

    ste_name: "MN",
  },
  {
    zip_code: "55408",

    ste_name: "MN",
  },
  {
    zip_code: "55763",

    ste_name: "MN",
  },
  {
    zip_code: "55767",

    ste_name: "MN",
  },
  {
    zip_code: "55795",

    ste_name: "MN",
  },
  {
    zip_code: "55923",

    ste_name: "MN",
  },
  {
    zip_code: "55973",

    ste_name: "MN",
  },
  {
    zip_code: "56013",

    ste_name: "MN",
  },
  {
    zip_code: "56028",

    ste_name: "MN",
  },
  {
    zip_code: "56048",

    ste_name: "MN",
  },
  {
    zip_code: "56083",

    ste_name: "MN",
  },
  {
    zip_code: "56101",

    ste_name: "MN",
  },
  {
    zip_code: "56167",

    ste_name: "MN",
  },
  {
    zip_code: "56228",

    ste_name: "MN",
  },
  {
    zip_code: "56240",

    ste_name: "MN",
  },
  {
    zip_code: "56314",

    ste_name: "MN",
  },
  {
    zip_code: "56377",

    ste_name: "MN",
  },
  {
    zip_code: "56382",

    ste_name: "MN",
  },
  {
    zip_code: "56473",

    ste_name: "MN",
  },
  {
    zip_code: "56515",

    ste_name: "MN",
  },
  {
    zip_code: "56531",

    ste_name: "MN",
  },
  {
    zip_code: "56566",

    ste_name: "MN",
  },
  {
    zip_code: "56628",

    ste_name: "MN",
  },
  {
    zip_code: "56630",

    ste_name: "MN",
  },
  {
    zip_code: "56720",

    ste_name: "MN",
  },
  {
    zip_code: "56729",

    ste_name: "MN",
  },
  {
    zip_code: "56756",

    ste_name: "MN",
  },
  {
    zip_code: "56761",

    ste_name: "MN",
  },
  {
    zip_code: "57029",

    ste_name: "SD",
  },
  {
    zip_code: "57048",

    ste_name: "SD",
  },
  {
    zip_code: "57064",

    ste_name: "SD",
  },
  {
    zip_code: "57223",

    ste_name: "SD",
  },
  {
    zip_code: "57247",

    ste_name: "SD",
  },
  {
    zip_code: "57340",

    ste_name: "SD",
  },
  {
    zip_code: "57356",

    ste_name: "SD",
  },
  {
    zip_code: "57382",

    ste_name: "SD",
  },
  {
    zip_code: "57420",

    ste_name: "SD",
  },
  {
    zip_code: "57421",

    ste_name: "SD",
  },
  {
    zip_code: "57460",

    ste_name: "SD",
  },
  {
    zip_code: "57467",

    ste_name: "SD",
  },
  {
    zip_code: "57541",

    ste_name: "SD",
  },
  {
    zip_code: "57563",

    ste_name: "SD",
  },
  {
    zip_code: "57651",

    ste_name: "SD",
  },
  {
    zip_code: "57719",

    ste_name: "SD",
  },
  {
    zip_code: "57754",

    ste_name: "SD",
  },
  {
    zip_code: "57770",

    ste_name: "SD",
  },
  {
    zip_code: "57775",

    ste_name: "SD",
  },
  {
    zip_code: "90020",

    ste_name: "CA",
  },
  {
    zip_code: "90026",

    ste_name: "CA",
  },
  {
    zip_code: "90042",

    ste_name: "CA",
  },
  {
    zip_code: "90067",

    ste_name: "CA",
  },
  {
    zip_code: "90602",

    ste_name: "CA",
  },
  {
    zip_code: "90670",

    ste_name: "CA",
  },
  {
    zip_code: "90802",

    ste_name: "CA",
  },
  {
    zip_code: "90814",

    ste_name: "CA",
  },
  {
    zip_code: "90831",

    ste_name: "CA",
  },
  {
    zip_code: "91321",

    ste_name: "CA",
  },
  {
    zip_code: "91335",

    ste_name: "CA",
  },
  {
    zip_code: "91362",

    ste_name: "CA",
  },
  {
    zip_code: "92029",

    ste_name: "CA",
  },
  {
    zip_code: "92201",

    ste_name: "CA",
  },
  {
    zip_code: "92252",

    ste_name: "CA",
  },
  {
    zip_code: "92282",

    ste_name: "CA",
  },
  {
    zip_code: "92301",

    ste_name: "CA",
  },
  {
    zip_code: "92336",

    ste_name: "CA",
  },
  {
    zip_code: "92344",

    ste_name: "CA",
  },
  {
    zip_code: "92371",

    ste_name: "CA",
  },
  {
    zip_code: "92549",

    ste_name: "CA",
  },
  {
    zip_code: "92553",

    ste_name: "CA",
  },
  {
    zip_code: "92555",

    ste_name: "CA",
  },
  {
    zip_code: "92655",

    ste_name: "CA",
  },
  {
    zip_code: "92692",

    ste_name: "CA",
  },
  {
    zip_code: "92823",

    ste_name: "CA",
  },
  {
    zip_code: "93004",

    ste_name: "CA",
  },
  {
    zip_code: "93219",

    ste_name: "CA",
  },
  {
    zip_code: "93306",

    ste_name: "CA",
  },
  {
    zip_code: "93436",

    ste_name: "CA",
  },
  {
    zip_code: "93444",

    ste_name: "CA",
  },
  {
    zip_code: "93451",

    ste_name: "CA",
  },
  {
    zip_code: "93553",

    ste_name: "CA",
  },
  {
    zip_code: "93605",

    ste_name: "CA",
  },
  {
    zip_code: "93614",

    ste_name: "CA",
  },
  {
    zip_code: "93648",

    ste_name: "CA",
  },
  {
    zip_code: "93720",

    ste_name: "CA",
  },
  {
    zip_code: "93920",

    ste_name: "CA",
  },
  {
    zip_code: "93921",

    ste_name: "CA",
  },
  {
    zip_code: "94040",

    ste_name: "CA",
  },
  {
    zip_code: "94513",

    ste_name: "CA",
  },
  {
    zip_code: "94536",

    ste_name: "CA",
  },
  {
    zip_code: "94551",

    ste_name: "CA",
  },
  {
    zip_code: "94706",

    ste_name: "CA",
  },
  {
    zip_code: "94930",

    ste_name: "CA",
  },
  {
    zip_code: "94938",

    ste_name: "CA",
  },
  {
    zip_code: "95112",

    ste_name: "CA",
  },
  {
    zip_code: "95117",

    ste_name: "CA",
  },
  {
    zip_code: "95204",

    ste_name: "CA",
  },
  {
    zip_code: "95222",

    ste_name: "CA",
  },
  {
    zip_code: "95361",

    ste_name: "CA",
  },
  {
    zip_code: "95429",

    ste_name: "CA",
  },
  {
    zip_code: "95604",

    ste_name: "CA",
  },
  {
    zip_code: "95606",

    ste_name: "CA",
  },
  {
    zip_code: "95634",

    ste_name: "CA",
  },
  {
    zip_code: "95664",

    ste_name: "CA",
  },
  {
    zip_code: "95674",

    ste_name: "CA",
  },
  {
    zip_code: "95685",

    ste_name: "CA",
  },
  {
    zip_code: "95689",

    ste_name: "CA",
  },
  {
    zip_code: "95715",

    ste_name: "CA",
  },
  {
    zip_code: "95726",

    ste_name: "CA",
  },
  {
    zip_code: "95821",

    ste_name: "CA",
  },
  {
    zip_code: "95822",

    ste_name: "CA",
  },
  {
    zip_code: "95914",

    ste_name: "CA",
  },
  {
    zip_code: "95962",

    ste_name: "CA",
  },
  {
    zip_code: "95970",

    ste_name: "CA",
  },
  {
    zip_code: "96017",

    ste_name: "CA",
  },
  {
    zip_code: "96032",

    ste_name: "CA",
  },
  {
    zip_code: "96086",

    ste_name: "CA",
  },
  {
    zip_code: "96097",

    ste_name: "CA",
  },
  {
    zip_code: "96749",

    ste_name: "HI",
  },
  {
    zip_code: "97034",

    ste_name: "OR",
  },
  {
    zip_code: "97050",

    ste_name: "OR",
  },
  {
    zip_code: "97058",

    ste_name: "OR",
  },
  {
    zip_code: "97108",

    ste_name: "OR",
  },
  {
    zip_code: "97227",

    ste_name: "OR",
  },
  {
    zip_code: "97342",

    ste_name: "OR",
  },
  {
    zip_code: "97390",

    ste_name: "OR",
  },
  {
    zip_code: "97455",

    ste_name: "OR",
  },
  {
    zip_code: "97469",

    ste_name: "OR",
  },
  {
    zip_code: "97471",

    ste_name: "OR",
  },
  {
    zip_code: "97625",

    ste_name: "OR",
  },
  {
    zip_code: "97801",

    ste_name: "OR",
  },
  {
    zip_code: "97820",

    ste_name: "OR",
  },
  {
    zip_code: "97850",

    ste_name: "OR",
  },
  {
    zip_code: "98148",

    ste_name: "WA",
  },
  {
    zip_code: "98199",

    ste_name: "WA",
  },
  {
    zip_code: "98230",

    ste_name: "WA",
  },
  {
    zip_code: "98255",

    ste_name: "WA",
  },
  {
    zip_code: "98261",

    ste_name: "WA",
  },
  {
    zip_code: "98280",

    ste_name: "WA",
  },
  {
    zip_code: "98328",

    ste_name: "WA",
  },
  {
    zip_code: "98339",

    ste_name: "WA",
  },
  {
    zip_code: "616",

    ste_name: "PR",
  },
  {
    zip_code: "850",

    ste_name: "VI",
  },
  {
    zip_code: "968",

    ste_name: "PR",
  },
  {
    zip_code: "1002",

    ste_name: "MA",
  },
  {
    zip_code: "1011",

    ste_name: "MA",
  },
  {
    zip_code: "1033",

    ste_name: "MA",
  },
  {
    zip_code: "1097",

    ste_name: "MA",
  },
  {
    zip_code: "1258",

    ste_name: "MA",
  },
  {
    zip_code: "1376",

    ste_name: "MA",
  },
  {
    zip_code: "1463",

    ste_name: "MA",
  },
  {
    zip_code: "1519",

    ste_name: "MA",
  },
  {
    zip_code: "1602",

    ste_name: "MA",
  },
  {
    zip_code: "1748",

    ste_name: "MA",
  },
  {
    zip_code: "1775",

    ste_name: "MA",
  },
  {
    zip_code: "1952",

    ste_name: "MA",
  },
  {
    zip_code: "1983",

    ste_name: "MA",
  },
  {
    zip_code: "2163",

    ste_name: "MA",
  },
  {
    zip_code: "2461",

    ste_name: "MA",
  },
  {
    zip_code: "2633",

    ste_name: "MA",
  },
  {
    zip_code: "2743",

    ste_name: "MA",
  },
  {
    zip_code: "3033",

    ste_name: "NH",
  },
  {
    zip_code: "3230",

    ste_name: "NH",
  },
  {
    zip_code: "3268",

    ste_name: "NH",
  },
  {
    zip_code: "3269",

    ste_name: "NH",
  },
  {
    zip_code: "3280",

    ste_name: "NH",
  },
  {
    zip_code: "3580",

    ste_name: "NH",
  },
  {
    zip_code: "3597",

    ste_name: "NH",
  },
  {
    zip_code: "3745",

    ste_name: "NH",
  },
  {
    zip_code: "3874",

    ste_name: "NH",
  },
  {
    zip_code: "3882",

    ste_name: "NH",
  },
  {
    zip_code: "3894",

    ste_name: "NH",
  },
  {
    zip_code: "4056",

    ste_name: "ME",
  },
  {
    zip_code: "4106",

    ste_name: "ME",
  },
  {
    zip_code: "4234",

    ste_name: "ME",
  },
  {
    zip_code: "4238",

    ste_name: "ME",
  },
  {
    zip_code: "4343",

    ste_name: "ME",
  },
  {
    zip_code: "4450",

    ste_name: "ME",
  },
  {
    zip_code: "4625",

    ste_name: "ME",
  },
  {
    zip_code: "4691",

    ste_name: "ME",
  },
  {
    zip_code: "4747",

    ste_name: "ME",
  },
  {
    zip_code: "4855",

    ste_name: "ME",
  },
  {
    zip_code: "4859",

    ste_name: "ME",
  },
  {
    zip_code: "4863",

    ste_name: "ME",
  },
  {
    zip_code: "4917",

    ste_name: "ME",
  },
  {
    zip_code: "5036",

    ste_name: "VT",
  },
  {
    zip_code: "5043",

    ste_name: "VT",
  },
  {
    zip_code: "5056",

    ste_name: "VT",
  },
  {
    zip_code: "5158",

    ste_name: "VT",
  },
  {
    zip_code: "5340",

    ste_name: "VT",
  },
  {
    zip_code: "5341",

    ste_name: "VT",
  },
  {
    zip_code: "5445",

    ste_name: "VT",
  },
  {
    zip_code: "5654",

    ste_name: "VT",
  },
  {
    zip_code: "5676",

    ste_name: "VT",
  },
  {
    zip_code: "5681",

    ste_name: "VT",
  },
  {
    zip_code: "5737",

    ste_name: "VT",
  },
  {
    zip_code: "5776",

    ste_name: "VT",
  },
  {
    zip_code: "5833",

    ste_name: "VT",
  },
  {
    zip_code: "6114",

    ste_name: "CT",
  },
  {
    zip_code: "6231",

    ste_name: "CT",
  },
  {
    zip_code: "6320",

    ste_name: "CT",
  },
  {
    zip_code: "6413",

    ste_name: "CT",
  },
  {
    zip_code: "6479",

    ste_name: "CT",
  },
  {
    zip_code: "6791",

    ste_name: "CT",
  },
  {
    zip_code: "6793",

    ste_name: "CT",
  },
  {
    zip_code: "6801",

    ste_name: "CT",
  },
  {
    zip_code: "7024",

    ste_name: "NJ",
  },
  {
    zip_code: "7041",

    ste_name: "NJ",
  },
  {
    zip_code: "7044",

    ste_name: "NJ",
  },
  {
    zip_code: "7054",

    ste_name: "NJ",
  },
  {
    zip_code: "7063",

    ste_name: "NJ",
  },
  {
    zip_code: "7442",

    ste_name: "NJ",
  },
  {
    zip_code: "7456",

    ste_name: "NJ",
  },
  {
    zip_code: "7461",

    ste_name: "NJ",
  },
  {
    zip_code: "7607",

    ste_name: "NJ",
  },
  {
    zip_code: "7648",

    ste_name: "NJ",
  },
  {
    zip_code: "7702",

    ste_name: "NJ",
  },
  {
    zip_code: "7730",

    ste_name: "NJ",
  },
  {
    zip_code: "7737",

    ste_name: "NJ",
  },
  {
    zip_code: "7847",

    ste_name: "NJ",
  },
  {
    zip_code: "7848",

    ste_name: "NJ",
  },
  {
    zip_code: "7878",

    ste_name: "NJ",
  },
  {
    zip_code: "7928",

    ste_name: "NJ",
  },
  {
    zip_code: "7935",

    ste_name: "NJ",
  },
  {
    zip_code: "8005",

    ste_name: "NJ",
  },
  {
    zip_code: "8016",

    ste_name: "NJ",
  },
  {
    zip_code: "8230",

    ste_name: "NJ",
  },
  {
    zip_code: "8320",

    ste_name: "NJ",
  },
  {
    zip_code: "8343",

    ste_name: "NJ",
  },
  {
    zip_code: "8701",

    ste_name: "NJ",
  },
  {
    zip_code: "8733",

    ste_name: "NJ",
  },
  {
    zip_code: "8822",

    ste_name: "NJ",
  },
  {
    zip_code: "8850",

    ste_name: "NJ",
  },
  {
    zip_code: "8882",

    ste_name: "NJ",
  },
  {
    zip_code: "10037",

    ste_name: "NY",
  },
  {
    zip_code: "10039",

    ste_name: "NY",
  },
  {
    zip_code: "10152",

    ste_name: "NY",
  },
  {
    zip_code: "10305",

    ste_name: "NY",
  },
  {
    zip_code: "10573",

    ste_name: "NY",
  },
  {
    zip_code: "10601",

    ste_name: "NY",
  },
  {
    zip_code: "10916",

    ste_name: "NY",
  },
  {
    zip_code: "10921",

    ste_name: "NY",
  },
  {
    zip_code: "10987",

    ste_name: "NY",
  },
  {
    zip_code: "11223",

    ste_name: "NY",
  },
  {
    zip_code: "11416",

    ste_name: "NY",
  },
  {
    zip_code: "11430",

    ste_name: "NY",
  },
  {
    zip_code: "11565",

    ste_name: "NY",
  },
  {
    zip_code: "11572",

    ste_name: "NY",
  },
  {
    zip_code: "11692",

    ste_name: "NY",
  },
  {
    zip_code: "11704",

    ste_name: "NY",
  },
  {
    zip_code: "11779",

    ste_name: "NY",
  },
  {
    zip_code: "11780",

    ste_name: "NY",
  },
  {
    zip_code: "11901",

    ste_name: "NY",
  },
  {
    zip_code: "11944",

    ste_name: "NY",
  },
  {
    zip_code: "12046",

    ste_name: "NY",
  },
  {
    zip_code: "12053",

    ste_name: "NY",
  },
  {
    zip_code: "12057",

    ste_name: "NY",
  },
  {
    zip_code: "12060",

    ste_name: "NY",
  },
  {
    zip_code: "12093",

    ste_name: "NY",
  },
  {
    zip_code: "12123",

    ste_name: "NY",
  },
  {
    zip_code: "12136",

    ste_name: "NY",
  },
  {
    zip_code: "12150",

    ste_name: "NY",
  },
  {
    zip_code: "12164",

    ste_name: "NY",
  },
  {
    zip_code: "12197",

    ste_name: "NY",
  },
  {
    zip_code: "12578",

    ste_name: "NY",
  },
  {
    zip_code: "12590",

    ste_name: "NY",
  },
  {
    zip_code: "12737",

    ste_name: "NY",
  },
  {
    zip_code: "12781",

    ste_name: "NY",
  },
  {
    zip_code: "12831",

    ste_name: "NY",
  },
  {
    zip_code: "12952",

    ste_name: "NY",
  },
  {
    zip_code: "12987",

    ste_name: "NY",
  },
  {
    zip_code: "13026",

    ste_name: "NY",
  },
  {
    zip_code: "13045",

    ste_name: "NY",
  },
  {
    zip_code: "13064",

    ste_name: "NY",
  },
  {
    zip_code: "13101",

    ste_name: "NY",
  },
  {
    zip_code: "13202",

    ste_name: "NY",
  },
  {
    zip_code: "13224",

    ste_name: "NY",
  },
  {
    zip_code: "13302",

    ste_name: "NY",
  },
  {
    zip_code: "13303",

    ste_name: "NY",
  },
  {
    zip_code: "13328",

    ste_name: "NY",
  },
  {
    zip_code: "13408",

    ste_name: "NY",
  },
  {
    zip_code: "13646",

    ste_name: "NY",
  },
  {
    zip_code: "13652",

    ste_name: "NY",
  },
  {
    zip_code: "13750",

    ste_name: "NY",
  },
  {
    zip_code: "13827",

    ste_name: "NY",
  },
  {
    zip_code: "13903",

    ste_name: "NY",
  },
  {
    zip_code: "14171",

    ste_name: "NY",
  },
  {
    zip_code: "14212",

    ste_name: "NY",
  },
  {
    zip_code: "14217",

    ste_name: "NY",
  },
  {
    zip_code: "14530",

    ste_name: "NY",
  },
  {
    zip_code: "14708",

    ste_name: "NY",
  },
  {
    zip_code: "14770",

    ste_name: "NY",
  },
  {
    zip_code: "14839",

    ste_name: "NY",
  },
  {
    zip_code: "14870",

    ste_name: "NY",
  },
  {
    zip_code: "15026",

    ste_name: "PA",
  },
  {
    zip_code: "15090",

    ste_name: "PA",
  },
  {
    zip_code: "15139",

    ste_name: "PA",
  },
  {
    zip_code: "15219",

    ste_name: "PA",
  },
  {
    zip_code: "15235",

    ste_name: "PA",
  },
  {
    zip_code: "15321",

    ste_name: "PA",
  },
  {
    zip_code: "15332",

    ste_name: "PA",
  },
  {
    zip_code: "15379",

    ste_name: "PA",
  },
  {
    zip_code: "15380",

    ste_name: "PA",
  },
  {
    zip_code: "15401",

    ste_name: "PA",
  },
  {
    zip_code: "15411",

    ste_name: "PA",
  },
  {
    zip_code: "15429",

    ste_name: "PA",
  },
  {
    zip_code: "15433",

    ste_name: "PA",
  },
  {
    zip_code: "15466",

    ste_name: "PA",
  },
  {
    zip_code: "15472",

    ste_name: "PA",
  },
  {
    zip_code: "15489",

    ste_name: "PA",
  },
  {
    zip_code: "15621",

    ste_name: "PA",
  },
  {
    zip_code: "15627",

    ste_name: "PA",
  },
  {
    zip_code: "15635",

    ste_name: "PA",
  },
  {
    zip_code: "15686",

    ste_name: "PA",
  },
  {
    zip_code: "15697",

    ste_name: "PA",
  },
  {
    zip_code: "15732",

    ste_name: "PA",
  },
  {
    zip_code: "15776",

    ste_name: "PA",
  },
  {
    zip_code: "15779",

    ste_name: "PA",
  },
  {
    zip_code: "15824",

    ste_name: "PA",
  },
  {
    zip_code: "16201",

    ste_name: "PA",
  },
  {
    zip_code: "16233",

    ste_name: "PA",
  },
  {
    zip_code: "16373",

    ste_name: "PA",
  },
  {
    zip_code: "16506",

    ste_name: "PA",
  },
  {
    zip_code: "16640",

    ste_name: "PA",
  },
  {
    zip_code: "16664",

    ste_name: "PA",
  },
  {
    zip_code: "16666",

    ste_name: "PA",
  },
  {
    zip_code: "16674",

    ste_name: "PA",
  },
  {
    zip_code: "16729",

    ste_name: "PA",
  },
  {
    zip_code: "16733",

    ste_name: "PA",
  },
  {
    zip_code: "16861",

    ste_name: "PA",
  },
  {
    zip_code: "17075",

    ste_name: "PA",
  },
  {
    zip_code: "17080",

    ste_name: "PA",
  },
  {
    zip_code: "17237",

    ste_name: "PA",
  },
  {
    zip_code: "17319",

    ste_name: "PA",
  },
  {
    zip_code: "17364",

    ste_name: "PA",
  },
  {
    zip_code: "17518",

    ste_name: "PA",
  },
  {
    zip_code: "17527",

    ste_name: "PA",
  },
  {
    zip_code: "17560",

    ste_name: "PA",
  },
  {
    zip_code: "17701",

    ste_name: "PA",
  },
  {
    zip_code: "17729",

    ste_name: "PA",
  },
  {
    zip_code: "17731",

    ste_name: "PA",
  },
  {
    zip_code: "17747",

    ste_name: "PA",
  },
  {
    zip_code: "17764",

    ste_name: "PA",
  },
  {
    zip_code: "17815",

    ste_name: "PA",
  },
  {
    zip_code: "17829",

    ste_name: "PA",
  },
  {
    zip_code: "17880",

    ste_name: "PA",
  },
  {
    zip_code: "17960",

    ste_name: "PA",
  },
  {
    zip_code: "18015",

    ste_name: "PA",
  },
  {
    zip_code: "18049",

    ste_name: "PA",
  },
  {
    zip_code: "18076",

    ste_name: "PA",
  },
  {
    zip_code: "18101",

    ste_name: "PA",
  },
  {
    zip_code: "18221",

    ste_name: "PA",
  },
  {
    zip_code: "18246",

    ste_name: "PA",
  },
  {
    zip_code: "18333",

    ste_name: "PA",
  },
  {
    zip_code: "18420",

    ste_name: "PA",
  },
  {
    zip_code: "18453",

    ste_name: "PA",
  },
  {
    zip_code: "18471",

    ste_name: "PA",
  },
  {
    zip_code: "18503",

    ste_name: "PA",
  },
  {
    zip_code: "18626",

    ste_name: "PA",
  },
  {
    zip_code: "18634",

    ste_name: "PA",
  },
  {
    zip_code: "18817",

    ste_name: "PA",
  },
  {
    zip_code: "18947",

    ste_name: "PA",
  },
  {
    zip_code: "18974",

    ste_name: "PA",
  },
  {
    zip_code: "19008",

    ste_name: "PA",
  },
  {
    zip_code: "19096",

    ste_name: "PA",
  },
  {
    zip_code: "19151",

    ste_name: "PA",
  },
  {
    zip_code: "19473",

    ste_name: "PA",
  },
  {
    zip_code: "19477",

    ste_name: "PA",
  },
  {
    zip_code: "19549",

    ste_name: "PA",
  },
  {
    zip_code: "19955",

    ste_name: "DE",
  },
  {
    zip_code: "19971",

    ste_name: "DE",
  },
  {
    zip_code: "20017",

    ste_name: "DC",
  },
  {
    zip_code: "20390",

    ste_name: "DC",
  },
  {
    zip_code: "20736",

    ste_name: "MD",
  },
  {
    zip_code: "20818",

    ste_name: "MD",
  },
  {
    zip_code: "20878",

    ste_name: "MD",
  },
  {
    zip_code: "21208",

    ste_name: "MD",
  },
  {
    zip_code: "21240",

    ste_name: "MD",
  },
  {
    zip_code: "21403",

    ste_name: "MD",
  },
  {
    zip_code: "21640",

    ste_name: "MD",
  },
  {
    zip_code: "21652",

    ste_name: "MD",
  },
  {
    zip_code: "21669",

    ste_name: "MD",
  },
  {
    zip_code: "21742",

    ste_name: "MD",
  },
  {
    zip_code: "21746",

    ste_name: "MD",
  },
  {
    zip_code: "21767",

    ste_name: "MD",
  },
  {
    zip_code: "21769",

    ste_name: "MD",
  },
  {
    zip_code: "21784",

    ste_name: "MD",
  },
  {
    zip_code: "21821",

    ste_name: "MD",
  },
  {
    zip_code: "21822",

    ste_name: "MD",
  },
  {
    zip_code: "21826",

    ste_name: "MD",
  },
  {
    zip_code: "21866",

    ste_name: "MD",
  },
  {
    zip_code: "22003",

    ste_name: "VA",
  },
  {
    zip_code: "22030",

    ste_name: "VA",
  },
  {
    zip_code: "22209",

    ste_name: "VA",
  },
  {
    zip_code: "22401",

    ste_name: "VA",
  },
  {
    zip_code: "22460",

    ste_name: "VA",
  },
  {
    zip_code: "22834",

    ste_name: "VA",
  },
  {
    zip_code: "22968",

    ste_name: "VA",
  },
  {
    zip_code: "22971",

    ste_name: "VA",
  },
  {
    zip_code: "23415",

    ste_name: "VA",
  },
  {
    zip_code: "23486",

    ste_name: "VA",
  },
  {
    zip_code: "23605",

    ste_name: "VA",
  },
  {
    zip_code: "23664",

    ste_name: "VA",
  },
  {
    zip_code: "23891",

    ste_name: "VA",
  },
  {
    zip_code: "24053",

    ste_name: "VA",
  },
  {
    zip_code: "24067",

    ste_name: "VA",
  },
  {
    zip_code: "24090",

    ste_name: "VA",
  },
  {
    zip_code: "24092",

    ste_name: "VA",
  },
  {
    zip_code: "24142",

    ste_name: "VA",
  },
  {
    zip_code: "24161",

    ste_name: "VA",
  },
  {
    zip_code: "24167",

    ste_name: "VA",
  },
  {
    zip_code: "24184",

    ste_name: "VA",
  },
  {
    zip_code: "24272",

    ste_name: "VA",
  },
  {
    zip_code: "24283",

    ste_name: "VA",
  },
  {
    zip_code: "24319",

    ste_name: "VA",
  },
  {
    zip_code: "24437",

    ste_name: "VA",
  },
  {
    zip_code: "24476",

    ste_name: "VA",
  },
  {
    zip_code: "24483",

    ste_name: "VA",
  },
  {
    zip_code: "24486",

    ste_name: "VA",
  },
  {
    zip_code: "24503",

    ste_name: "VA",
  },
  {
    zip_code: "24521",

    ste_name: "VA",
  },
  {
    zip_code: "24847",

    ste_name: "WV",
  },
  {
    zip_code: "24868",

    ste_name: "WV",
  },
  {
    zip_code: "24981",

    ste_name: "WV",
  },
  {
    zip_code: "25203",

    ste_name: "WV",
  },
  {
    zip_code: "25208",

    ste_name: "WV",
  },
  {
    zip_code: "25235",

    ste_name: "WV",
  },
  {
    zip_code: "25520",

    ste_name: "WV",
  },
  {
    zip_code: "25699",

    ste_name: "WV",
  },
  {
    zip_code: "25876",

    ste_name: "WV",
  },
  {
    zip_code: "25917",

    ste_name: "WV",
  },
  {
    zip_code: "26003",

    ste_name: "WV",
  },
  {
    zip_code: "26055",

    ste_name: "WV",
  },
  {
    zip_code: "26062",

    ste_name: "WV",
  },
  {
    zip_code: "26159",

    ste_name: "WV",
  },
  {
    zip_code: "26184",

    ste_name: "WV",
  },
  {
    zip_code: "26238",

    ste_name: "WV",
  },
  {
    zip_code: "26361",

    ste_name: "WV",
  },
  {
    zip_code: "26376",

    ste_name: "WV",
  },
  {
    zip_code: "26384",

    ste_name: "WV",
  },
  {
    zip_code: "26410",

    ste_name: "WV",
  },
  {
    zip_code: "26447",

    ste_name: "WV",
  },
  {
    zip_code: "26601",

    ste_name: "WV",
  },
  {
    zip_code: "26716",

    ste_name: "WV",
  },
  {
    zip_code: "26847",

    ste_name: "WV",
  },
  {
    zip_code: "27104",

    ste_name: "NC",
  },
  {
    zip_code: "27360",

    ste_name: "NC",
  },
  {
    zip_code: "27502",

    ste_name: "NC",
  },
  {
    zip_code: "27508",

    ste_name: "NC",
  },
  {
    zip_code: "27592",

    ste_name: "NC",
  },
  {
    zip_code: "27615",

    ste_name: "NC",
  },
  {
    zip_code: "27616",

    ste_name: "NC",
  },
  {
    zip_code: "27703",

    ste_name: "NC",
  },
  {
    zip_code: "27704",

    ste_name: "NC",
  },
  {
    zip_code: "27851",

    ste_name: "NC",
  },
  {
    zip_code: "27890",

    ste_name: "NC",
  },
  {
    zip_code: "27923",

    ste_name: "NC",
  },
  {
    zip_code: "27925",

    ste_name: "NC",
  },
  {
    zip_code: "27938",

    ste_name: "NC",
  },
  {
    zip_code: "27953",

    ste_name: "NC",
  },
  {
    zip_code: "28009",

    ste_name: "NC",
  },
  {
    zip_code: "28083",

    ste_name: "NC",
  },
  {
    zip_code: "28117",

    ste_name: "NC",
  },
  {
    zip_code: "28269",

    ste_name: "NC",
  },
  {
    zip_code: "28340",

    ste_name: "NC",
  },
  {
    zip_code: "28356",

    ste_name: "NC",
  },
  {
    zip_code: "28374",

    ste_name: "NC",
  },
  {
    zip_code: "28385",

    ste_name: "NC",
  },
  {
    zip_code: "28431",

    ste_name: "NC",
  },
  {
    zip_code: "28540",

    ste_name: "NC",
  },
  {
    zip_code: "28556",

    ste_name: "NC",
  },
  {
    zip_code: "28640",

    ste_name: "NC",
  },
  {
    zip_code: "28684",

    ste_name: "NC",
  },
  {
    zip_code: "28709",

    ste_name: "NC",
  },
  {
    zip_code: "29030",

    ste_name: "SC",
  },
  {
    zip_code: "29061",

    ste_name: "SC",
  },
  {
    zip_code: "29075",

    ste_name: "SC",
  },
  {
    zip_code: "29138",

    ste_name: "SC",
  },
  {
    zip_code: "29169",

    ste_name: "SC",
  },
  {
    zip_code: "29223",

    ste_name: "SC",
  },
  {
    zip_code: "29225",

    ste_name: "SC",
  },
  {
    zip_code: "29330",

    ste_name: "SC",
  },
  {
    zip_code: "29351",

    ste_name: "SC",
  },
  {
    zip_code: "29356",

    ste_name: "SC",
  },
  {
    zip_code: "29409",

    ste_name: "SC",
  },
  {
    zip_code: "29412",

    ste_name: "SC",
  },
  {
    zip_code: "29420",

    ste_name: "SC",
  },
  {
    zip_code: "29475",

    ste_name: "SC",
  },
  {
    zip_code: "29520",

    ste_name: "SC",
  },
  {
    zip_code: "29545",

    ste_name: "SC",
  },
  {
    zip_code: "29571",

    ste_name: "SC",
  },
  {
    zip_code: "29576",

    ste_name: "SC",
  },
  {
    zip_code: "29664",

    ste_name: "SC",
  },
  {
    zip_code: "29715",

    ste_name: "SC",
  },
  {
    zip_code: "29733",

    ste_name: "SC",
  },
  {
    zip_code: "29847",

    ste_name: "SC",
  },
  {
    zip_code: "29853",

    ste_name: "SC",
  },
  {
    zip_code: "29860",

    ste_name: "SC",
  },
  {
    zip_code: "29923",

    ste_name: "SC",
  },
  {
    zip_code: "29941",

    ste_name: "SC",
  },
  {
    zip_code: "30004",

    ste_name: "GA",
  },
  {
    zip_code: "30022",

    ste_name: "GA",
  },
  {
    zip_code: "30134",

    ste_name: "GA",
  },
  {
    zip_code: "30149",

    ste_name: "GA",
  },
  {
    zip_code: "30213",

    ste_name: "GA",
  },
  {
    zip_code: "30241",

    ste_name: "GA",
  },
  {
    zip_code: "30297",

    ste_name: "GA",
  },
  {
    zip_code: "30331",

    ste_name: "GA",
  },
  {
    zip_code: "30452",

    ste_name: "GA",
  },
  {
    zip_code: "30512",

    ste_name: "GA",
  },
  {
    zip_code: "30521",

    ste_name: "GA",
  },
  {
    zip_code: "30554",

    ste_name: "GA",
  },
  {
    zip_code: "30620",

    ste_name: "GA",
  },
  {
    zip_code: "30736",

    ste_name: "GA",
  },
  {
    zip_code: "30756",

    ste_name: "GA",
  },
  {
    zip_code: "30904",

    ste_name: "GA",
  },
  {
    zip_code: "31062",

    ste_name: "GA",
  },
  {
    zip_code: "31077",

    ste_name: "GA",
  },
  {
    zip_code: "31216",

    ste_name: "GA",
  },
  {
    zip_code: "31313",

    ste_name: "GA",
  },
  {
    zip_code: "31520",

    ste_name: "GA",
  },
  {
    zip_code: "31557",

    ste_name: "GA",
  },
  {
    zip_code: "31602",

    ste_name: "GA",
  },
  {
    zip_code: "31750",

    ste_name: "GA",
  },
  {
    zip_code: "31805",

    ste_name: "GA",
  },
  {
    zip_code: "32054",

    ste_name: "FL",
  },
  {
    zip_code: "32168",

    ste_name: "FL",
  },
  {
    zip_code: "32225",

    ste_name: "FL",
  },
  {
    zip_code: "32226",

    ste_name: "FL",
  },
  {
    zip_code: "32330",

    ste_name: "FL",
  },
  {
    zip_code: "32351",

    ste_name: "FL",
  },
  {
    zip_code: "32628",

    ste_name: "FL",
  },
  {
    zip_code: "32694",

    ste_name: "FL",
  },
  {
    zip_code: "32696",

    ste_name: "FL",
  },
  {
    zip_code: "32780",

    ste_name: "FL",
  },
  {
    zip_code: "32803",

    ste_name: "FL",
  },
  {
    zip_code: "32824",

    ste_name: "FL",
  },
  {
    zip_code: "32927",

    ste_name: "FL",
  },
  {
    zip_code: "33037",

    ste_name: "FL",
  },
  {
    zip_code: "33134",

    ste_name: "FL",
  },
  {
    zip_code: "33144",

    ste_name: "FL",
  },
  {
    zip_code: "33160",

    ste_name: "FL",
  },
  {
    zip_code: "33442",

    ste_name: "FL",
  },
  {
    zip_code: "33473",

    ste_name: "FL",
  },
  {
    zip_code: "33597",

    ste_name: "FL",
  },
  {
    zip_code: "33611",

    ste_name: "FL",
  },
  {
    zip_code: "33612",

    ste_name: "FL",
  },
  {
    zip_code: "33701",

    ste_name: "FL",
  },
  {
    zip_code: "33755",

    ste_name: "FL",
  },
  {
    zip_code: "33809",

    ste_name: "FL",
  },
  {
    zip_code: "33852",

    ste_name: "FL",
  },
  {
    zip_code: "33890",

    ste_name: "FL",
  },
  {
    zip_code: "34203",

    ste_name: "FL",
  },
  {
    zip_code: "34484",

    ste_name: "FL",
  },
  {
    zip_code: "34606",

    ste_name: "FL",
  },
  {
    zip_code: "34613",

    ste_name: "FL",
  },
  {
    zip_code: "34654",

    ste_name: "FL",
  },
  {
    zip_code: "34773",

    ste_name: "FL",
  },
  {
    zip_code: "34787",

    ste_name: "FL",
  },
  {
    zip_code: "35031",

    ste_name: "AL",
  },
  {
    zip_code: "35040",

    ste_name: "AL",
  },
  {
    zip_code: "35062",

    ste_name: "AL",
  },
  {
    zip_code: "35206",

    ste_name: "AL",
  },
  {
    zip_code: "35563",

    ste_name: "AL",
  },
  {
    zip_code: "35586",

    ste_name: "AL",
  },
  {
    zip_code: "35660",

    ste_name: "AL",
  },
  {
    zip_code: "35746",

    ste_name: "AL",
  },
  {
    zip_code: "35750",

    ste_name: "AL",
  },
  {
    zip_code: "35772",

    ste_name: "AL",
  },
  {
    zip_code: "35903",

    ste_name: "AL",
  },
  {
    zip_code: "35981",

    ste_name: "AL",
  },
  {
    zip_code: "36029",

    ste_name: "AL",
  },
  {
    zip_code: "36038",

    ste_name: "AL",
  },
  {
    zip_code: "36115",

    ste_name: "AL",
  },
  {
    zip_code: "36474",

    ste_name: "AL",
  },
  {
    zip_code: "36583",

    ste_name: "AL",
  },
  {
    zip_code: "36587",

    ste_name: "AL",
  },
  {
    zip_code: "36610",

    ste_name: "AL",
  },
  {
    zip_code: "36748",

    ste_name: "AL",
  },
  {
    zip_code: "36749",

    ste_name: "AL",
  },
  {
    zip_code: "36754",

    ste_name: "AL",
  },
  {
    zip_code: "36908",

    ste_name: "AL",
  },
  {
    zip_code: "37062",

    ste_name: "TN",
  },
  {
    zip_code: "37127",

    ste_name: "TN",
  },
  {
    zip_code: "37148",

    ste_name: "TN",
  },
  {
    zip_code: "37204",

    ste_name: "TN",
  },
  {
    zip_code: "37318",

    ste_name: "TN",
  },
  {
    zip_code: "37337",

    ste_name: "TN",
  },
  {
    zip_code: "37348",

    ste_name: "TN",
  },
  {
    zip_code: "37356",

    ste_name: "TN",
  },
  {
    zip_code: "37601",

    ste_name: "TN",
  },
  {
    zip_code: "37615",

    ste_name: "TN",
  },
  {
    zip_code: "37683",

    ste_name: "TN",
  },
  {
    zip_code: "37769",

    ste_name: "TN",
  },
  {
    zip_code: "37807",

    ste_name: "TN",
  },
  {
    zip_code: "37819",

    ste_name: "TN",
  },
  {
    zip_code: "37853",

    ste_name: "TN",
  },
  {
    zip_code: "37866",

    ste_name: "TN",
  },
  {
    zip_code: "37873",

    ste_name: "TN",
  },
  {
    zip_code: "37878",

    ste_name: "TN",
  },
  {
    zip_code: "37887",

    ste_name: "TN",
  },
  {
    zip_code: "37891",

    ste_name: "TN",
  },
  {
    zip_code: "37917",

    ste_name: "TN",
  },
  {
    zip_code: "38037",

    ste_name: "TN",
  },
  {
    zip_code: "38135",

    ste_name: "TN",
  },
  {
    zip_code: "38226",

    ste_name: "TN",
  },
  {
    zip_code: "38363",

    ste_name: "TN",
  },
  {
    zip_code: "38487",

    ste_name: "TN",
  },
  {
    zip_code: "39701",

    ste_name: "MS",
  },
  {
    zip_code: "39735",

    ste_name: "MS",
  },
  {
    zip_code: "39867",

    ste_name: "GA",
  },
  {
    zip_code: "40012",

    ste_name: "KY",
  },
  {
    zip_code: "601",

    ste_name: "PR",
  },
  {
    zip_code: "638",

    ste_name: "PR",
  },
  {
    zip_code: "678",

    ste_name: "PR",
  },
  {
    zip_code: "720",

    ste_name: "PR",
  },
  {
    zip_code: "909",

    ste_name: "PR",
  },
  {
    zip_code: "1028",

    ste_name: "MA",
  },
  {
    zip_code: "1074",

    ste_name: "MA",
  },
  {
    zip_code: "1118",

    ste_name: "MA",
  },
  {
    zip_code: "1223",

    ste_name: "MA",
  },
  {
    zip_code: "1260",

    ste_name: "MA",
  },
  {
    zip_code: "1262",

    ste_name: "MA",
  },
  {
    zip_code: "1355",

    ste_name: "MA",
  },
  {
    zip_code: "1566",

    ste_name: "MA",
  },
  {
    zip_code: "1719",

    ste_name: "MA",
  },
  {
    zip_code: "1921",

    ste_name: "MA",
  },
  {
    zip_code: "1949",

    ste_name: "MA",
  },
  {
    zip_code: "1960",

    ste_name: "MA",
  },
  {
    zip_code: "2021",

    ste_name: "MA",
  },
  {
    zip_code: "2052",

    ste_name: "MA",
  },
  {
    zip_code: "2118",

    ste_name: "MA",
  },
  {
    zip_code: "2128",

    ste_name: "MA",
  },
  {
    zip_code: "2142",

    ste_name: "MA",
  },
  {
    zip_code: "2368",

    ste_name: "MA",
  },
  {
    zip_code: "2584",

    ste_name: "MA",
  },
  {
    zip_code: "2632",

    ste_name: "MA",
  },
  {
    zip_code: "2807",

    ste_name: "RI",
  },
  {
    zip_code: "2841",

    ste_name: "RI",
  },
  {
    zip_code: "3237",

    ste_name: "NH",
  },
  {
    zip_code: "3467",

    ste_name: "NH",
  },
  {
    zip_code: "3584",

    ste_name: "NH",
  },
  {
    zip_code: "3837",

    ste_name: "NH",
  },
  {
    zip_code: "3842",

    ste_name: "NH",
  },
  {
    zip_code: "4040",

    ste_name: "ME",
  },
  {
    zip_code: "4085",

    ste_name: "ME",
  },
  {
    zip_code: "4553",

    ste_name: "ME",
  },
  {
    zip_code: "4579",

    ste_name: "ME",
  },
  {
    zip_code: "4624",

    ste_name: "ME",
  },
  {
    zip_code: "4650",

    ste_name: "ME",
  },
  {
    zip_code: "4668",

    ste_name: "ME",
  },
  {
    zip_code: "4669",

    ste_name: "ME",
  },
  {
    zip_code: "4741",

    ste_name: "ME",
  },
  {
    zip_code: "4841",

    ste_name: "ME",
  },
  {
    zip_code: "4920",

    ste_name: "ME",
  },
  {
    zip_code: "4924",

    ste_name: "ME",
  },
  {
    zip_code: "4942",

    ste_name: "ME",
  },
  {
    zip_code: "4947",

    ste_name: "ME",
  },
  {
    zip_code: "5061",

    ste_name: "VT",
  },
  {
    zip_code: "5439",

    ste_name: "VT",
  },
  {
    zip_code: "5446",

    ste_name: "VT",
  },
  {
    zip_code: "5669",

    ste_name: "VT",
  },
  {
    zip_code: "5674",

    ste_name: "VT",
  },
  {
    zip_code: "5747",

    ste_name: "VT",
  },
  {
    zip_code: "5858",

    ste_name: "VT",
  },
  {
    zip_code: "5859",

    ste_name: "VT",
  },
  {
    zip_code: "5901",

    ste_name: "VT",
  },
  {
    zip_code: "5903",

    ste_name: "VT",
  },
  {
    zip_code: "5906",

    ste_name: "VT",
  },
  {
    zip_code: "6029",

    ste_name: "CT",
  },
  {
    zip_code: "6051",

    ste_name: "CT",
  },
  {
    zip_code: "6335",

    ste_name: "CT",
  },
  {
    zip_code: "6339",

    ste_name: "CT",
  },
  {
    zip_code: "6379",

    ste_name: "CT",
  },
  {
    zip_code: "6380",

    ste_name: "CT",
  },
  {
    zip_code: "6481",

    ste_name: "CT",
  },
  {
    zip_code: "6614",

    ste_name: "CT",
  },
  {
    zip_code: "6770",

    ste_name: "CT",
  },
  {
    zip_code: "6902",

    ste_name: "CT",
  },
  {
    zip_code: "7036",

    ste_name: "NJ",
  },
  {
    zip_code: "7068",

    ste_name: "NJ",
  },
  {
    zip_code: "7424",

    ste_name: "NJ",
  },
  {
    zip_code: "7460",

    ste_name: "NJ",
  },
  {
    zip_code: "7670",

    ste_name: "NJ",
  },
  {
    zip_code: "7716",

    ste_name: "NJ",
  },
  {
    zip_code: "7747",

    ste_name: "NJ",
  },
  {
    zip_code: "7901",

    ste_name: "NJ",
  },
  {
    zip_code: "7924",

    ste_name: "NJ",
  },
  {
    zip_code: "7980",

    ste_name: "NJ",
  },
  {
    zip_code: "8014",

    ste_name: "NJ",
  },
  {
    zip_code: "8035",

    ste_name: "NJ",
  },
  {
    zip_code: "8046",

    ste_name: "NJ",
  },
  {
    zip_code: "8061",

    ste_name: "NJ",
  },
  {
    zip_code: "8098",

    ste_name: "NJ",
  },
  {
    zip_code: "8329",

    ste_name: "NJ",
  },
  {
    zip_code: "8344",

    ste_name: "NJ",
  },
  {
    zip_code: "8403",

    ste_name: "NJ",
  },
  {
    zip_code: "8852",

    ste_name: "NJ",
  },
  {
    zip_code: "8859",

    ste_name: "NJ",
  },
  {
    zip_code: "8865",

    ste_name: "NJ",
  },
  {
    zip_code: "10035",

    ste_name: "NY",
  },
  {
    zip_code: "10153",

    ste_name: "NY",
  },
  {
    zip_code: "10162",

    ste_name: "NY",
  },
  {
    zip_code: "10171",

    ste_name: "NY",
  },
  {
    zip_code: "10172",

    ste_name: "NY",
  },
  {
    zip_code: "10526",

    ste_name: "NY",
  },
  {
    zip_code: "10589",

    ste_name: "NY",
  },
  {
    zip_code: "10705",

    ste_name: "NY",
  },
  {
    zip_code: "11356",

    ste_name: "NY",
  },
  {
    zip_code: "11420",

    ste_name: "NY",
  },
  {
    zip_code: "11716",

    ste_name: "NY",
  },
  {
    zip_code: "11718",

    ste_name: "NY",
  },
  {
    zip_code: "11727",

    ste_name: "NY",
  },
  {
    zip_code: "11768",

    ste_name: "NY",
  },
  {
    zip_code: "11956",

    ste_name: "NY",
  },
  {
    zip_code: "12064",

    ste_name: "NY",
  },
  {
    zip_code: "12180",

    ste_name: "NY",
  },
  {
    zip_code: "12463",

    ste_name: "NY",
  },
  {
    zip_code: "12464",

    ste_name: "NY",
  },
  {
    zip_code: "12484",

    ste_name: "NY",
  },
  {
    zip_code: "12522",

    ste_name: "NY",
  },
  {
    zip_code: "12563",

    ste_name: "NY",
  },
  {
    zip_code: "12722",

    ste_name: "NY",
  },
  {
    zip_code: "12732",

    ste_name: "NY",
  },
  {
    zip_code: "12734",

    ste_name: "NY",
  },
  {
    zip_code: "12792",

    ste_name: "NY",
  },
  {
    zip_code: "12837",

    ste_name: "NY",
  },
  {
    zip_code: "12922",

    ste_name: "NY",
  },
  {
    zip_code: "12969",

    ste_name: "NY",
  },
  {
    zip_code: "12978",

    ste_name: "NY",
  },
  {
    zip_code: "13021",

    ste_name: "NY",
  },
  {
    zip_code: "13111",

    ste_name: "NY",
  },
  {
    zip_code: "13164",

    ste_name: "NY",
  },
  {
    zip_code: "13337",

    ste_name: "NY",
  },
  {
    zip_code: "13353",

    ste_name: "NY",
  },
  {
    zip_code: "13403",

    ste_name: "NY",
  },
  {
    zip_code: "13406",

    ste_name: "NY",
  },
  {
    zip_code: "13469",

    ste_name: "NY",
  },
  {
    zip_code: "13626",

    ste_name: "NY",
  },
  {
    zip_code: "13656",

    ste_name: "NY",
  },
  {
    zip_code: "13685",

    ste_name: "NY",
  },
  {
    zip_code: "13861",

    ste_name: "NY",
  },
  {
    zip_code: "14012",

    ste_name: "NY",
  },
  {
    zip_code: "14168",

    ste_name: "NY",
  },
  {
    zip_code: "14261",

    ste_name: "NY",
  },
  {
    zip_code: "14416",

    ste_name: "NY",
  },
  {
    zip_code: "14423",

    ste_name: "NY",
  },
  {
    zip_code: "14486",

    ste_name: "NY",
  },
  {
    zip_code: "14551",

    ste_name: "NY",
  },
  {
    zip_code: "14604",

    ste_name: "NY",
  },
  {
    zip_code: "14621",

    ste_name: "NY",
  },
  {
    zip_code: "14864",

    ste_name: "NY",
  },
  {
    zip_code: "14883",

    ste_name: "NY",
  },
  {
    zip_code: "14894",

    ste_name: "NY",
  },
  {
    zip_code: "15025",

    ste_name: "PA",
  },
  {
    zip_code: "15042",

    ste_name: "PA",
  },
  {
    zip_code: "15043",

    ste_name: "PA",
  },
  {
    zip_code: "15089",

    ste_name: "PA",
  },
  {
    zip_code: "15322",

    ste_name: "PA",
  },
  {
    zip_code: "15327",

    ste_name: "PA",
  },
  {
    zip_code: "15359",

    ste_name: "PA",
  },
  {
    zip_code: "15501",

    ste_name: "PA",
  },
  {
    zip_code: "15502",

    ste_name: "PA",
  },
  {
    zip_code: "15540",

    ste_name: "PA",
  },
  {
    zip_code: "15550",

    ste_name: "PA",
  },
  {
    zip_code: "15555",

    ste_name: "PA",
  },
  {
    zip_code: "15559",

    ste_name: "PA",
  },
  {
    zip_code: "15612",

    ste_name: "PA",
  },
  {
    zip_code: "15717",

    ste_name: "PA",
  },
  {
    zip_code: "15722",

    ste_name: "PA",
  },
  {
    zip_code: "15860",

    ste_name: "PA",
  },
  {
    zip_code: "15906",

    ste_name: "PA",
  },
  {
    zip_code: "15920",

    ste_name: "PA",
  },
  {
    zip_code: "16028",

    ste_name: "PA",
  },
  {
    zip_code: "16141",

    ste_name: "PA",
  },
  {
    zip_code: "16151",

    ste_name: "PA",
  },
  {
    zip_code: "16210",

    ste_name: "PA",
  },
  {
    zip_code: "16242",

    ste_name: "PA",
  },
  {
    zip_code: "16673",

    ste_name: "PA",
  },
  {
    zip_code: "16828",

    ste_name: "PA",
  },
  {
    zip_code: "16942",

    ste_name: "PA",
  },
  {
    zip_code: "17102",

    ste_name: "PA",
  },
  {
    zip_code: "17201",

    ste_name: "PA",
  },
  {
    zip_code: "17253",

    ste_name: "PA",
  },
  {
    zip_code: "17264",

    ste_name: "PA",
  },
  {
    zip_code: "17407",

    ste_name: "PA",
  },
  {
    zip_code: "17408",

    ste_name: "PA",
  },
  {
    zip_code: "17554",

    ste_name: "PA",
  },
  {
    zip_code: "17555",

    ste_name: "PA",
  },
  {
    zip_code: "17724",

    ste_name: "PA",
  },
  {
    zip_code: "17730",

    ste_name: "PA",
  },
  {
    zip_code: "17774",

    ste_name: "PA",
  },
  {
    zip_code: "17801",

    ste_name: "PA",
  },
  {
    zip_code: "17878",

    ste_name: "PA",
  },
  {
    zip_code: "17886",

    ste_name: "PA",
  },
  {
    zip_code: "17938",

    ste_name: "PA",
  },
  {
    zip_code: "17944",

    ste_name: "PA",
  },
  {
    zip_code: "18016",

    ste_name: "PA",
  },
  {
    zip_code: "18038",

    ste_name: "PA",
  },
  {
    zip_code: "18214",

    ste_name: "PA",
  },
  {
    zip_code: "18403",

    ste_name: "PA",
  },
  {
    zip_code: "18445",

    ste_name: "PA",
  },
  {
    zip_code: "18621",

    ste_name: "PA",
  },
  {
    zip_code: "18635",

    ste_name: "PA",
  },
  {
    zip_code: "18641",

    ste_name: "PA",
  },
  {
    zip_code: "18707",

    ste_name: "PA",
  },
  {
    zip_code: "18824",

    ste_name: "PA",
  },
  {
    zip_code: "18842",

    ste_name: "PA",
  },
  {
    zip_code: "19007",

    ste_name: "PA",
  },
  {
    zip_code: "19066",

    ste_name: "PA",
  },
  {
    zip_code: "19067",

    ste_name: "PA",
  },
  {
    zip_code: "19087",

    ste_name: "PA",
  },
  {
    zip_code: "19129",

    ste_name: "PA",
  },
  {
    zip_code: "19139",

    ste_name: "PA",
  },
  {
    zip_code: "19140",

    ste_name: "PA",
  },
  {
    zip_code: "19301",

    ste_name: "PA",
  },
  {
    zip_code: "19711",

    ste_name: "DE",
  },
  {
    zip_code: "20164",

    ste_name: "VA",
  },
  {
    zip_code: "20427",

    ste_name: "DC",
  },
  {
    zip_code: "20510",

    ste_name: "DC",
  },
  {
    zip_code: "20606",

    ste_name: "MD",
  },
  {
    zip_code: "20670",

    ste_name: "MD",
  },
  {
    zip_code: "20677",

    ste_name: "MD",
  },
  {
    zip_code: "20814",

    ste_name: "MD",
  },
  {
    zip_code: "21144",

    ste_name: "MD",
  },
  {
    zip_code: "21207",

    ste_name: "MD",
  },
  {
    zip_code: "21219",

    ste_name: "MD",
  },
  {
    zip_code: "21653",

    ste_name: "MD",
  },
  {
    zip_code: "21657",

    ste_name: "MD",
  },
  {
    zip_code: "21658",

    ste_name: "MD",
  },
  {
    zip_code: "21675",

    ste_name: "MD",
  },
  {
    zip_code: "21711",

    ste_name: "MD",
  },
  {
    zip_code: "21713",

    ste_name: "MD",
  },
  {
    zip_code: "21718",

    ste_name: "MD",
  },
  {
    zip_code: "21723",

    ste_name: "MD",
  },
  {
    zip_code: "21727",

    ste_name: "MD",
  },
  {
    zip_code: "21797",

    ste_name: "MD",
  },
  {
    zip_code: "21867",

    ste_name: "MD",
  },
  {
    zip_code: "22044",

    ste_name: "VA",
  },
  {
    zip_code: "22066",

    ste_name: "VA",
  },
  {
    zip_code: "22193",

    ste_name: "VA",
  },
  {
    zip_code: "22308",

    ste_name: "VA",
  },
  {
    zip_code: "22433",

    ste_name: "VA",
  },
  {
    zip_code: "22485",

    ste_name: "VA",
  },
  {
    zip_code: "22560",

    ste_name: "VA",
  },
  {
    zip_code: "22576",

    ste_name: "VA",
  },
  {
    zip_code: "22715",

    ste_name: "VA",
  },
  {
    zip_code: "22843",

    ste_name: "VA",
  },
  {
    zip_code: "22846",

    ste_name: "VA",
  },
  {
    zip_code: "22923",

    ste_name: "VA",
  },
  {
    zip_code: "22938",

    ste_name: "VA",
  },
  {
    zip_code: "23021",

    ste_name: "VA",
  },
  {
    zip_code: "23070",

    ste_name: "VA",
  },
  {
    zip_code: "23114",

    ste_name: "VA",
  },
  {
    zip_code: "23229",

    ste_name: "VA",
  },
  {
    zip_code: "23233",

    ste_name: "VA",
  },
  {
    zip_code: "23323",

    ste_name: "VA",
  },
  {
    zip_code: "23398",

    ste_name: "VA",
  },
  {
    zip_code: "23508",

    ste_name: "VA",
  },
  {
    zip_code: "23696",

    ste_name: "VA",
  },
  {
    zip_code: "23702",

    ste_name: "VA",
  },
  {
    zip_code: "23840",

    ste_name: "VA",
  },
  {
    zip_code: "23842",

    ste_name: "VA",
  },
  {
    zip_code: "23890",

    ste_name: "VA",
  },
  {
    zip_code: "23921",

    ste_name: "VA",
  },
  {
    zip_code: "24133",

    ste_name: "VA",
  },
  {
    zip_code: "24323",

    ste_name: "VA",
  },
  {
    zip_code: "24350",

    ste_name: "VA",
  },
  {
    zip_code: "24415",

    ste_name: "VA",
  },
  {
    zip_code: "24430",

    ste_name: "VA",
  },
  {
    zip_code: "24441",

    ste_name: "VA",
  },
  {
    zip_code: "24484",

    ste_name: "VA",
  },
  {
    zip_code: "24526",

    ste_name: "VA",
  },
  {
    zip_code: "24549",

    ste_name: "VA",
  },
  {
    zip_code: "24594",

    ste_name: "VA",
  },
  {
    zip_code: "24603",

    ste_name: "VA",
  },
  {
    zip_code: "24607",

    ste_name: "VA",
  },
  {
    zip_code: "24641",

    ste_name: "VA",
  },
  {
    zip_code: "24724",

    ste_name: "WV",
  },
  {
    zip_code: "24747",

    ste_name: "WV",
  },
  {
    zip_code: "24822",

    ste_name: "WV",
  },
  {
    zip_code: "24830",

    ste_name: "WV",
  },
  {
    zip_code: "24894",

    ste_name: "WV",
  },
  {
    zip_code: "24946",

    ste_name: "WV",
  },
  {
    zip_code: "25028",

    ste_name: "WV",
  },
  {
    zip_code: "25115",

    ste_name: "WV",
  },
  {
    zip_code: "25140",

    ste_name: "WV",
  },
  {
    zip_code: "25160",

    ste_name: "WV",
  },
  {
    zip_code: "25502",

    ste_name: "WV",
  },
  {
    zip_code: "25882",

    ste_name: "WV",
  },
  {
    zip_code: "25907",

    ste_name: "WV",
  },
  {
    zip_code: "25922",

    ste_name: "WV",
  },
  {
    zip_code: "26041",

    ste_name: "WV",
  },
  {
    zip_code: "26105",

    ste_name: "WV",
  },
  {
    zip_code: "26285",

    ste_name: "WV",
  },
  {
    zip_code: "26287",

    ste_name: "WV",
  },
  {
    zip_code: "26347",

    ste_name: "WV",
  },
  {
    zip_code: "26452",

    ste_name: "WV",
  },
  {
    zip_code: "26611",

    ste_name: "WV",
  },
  {
    zip_code: "27292",

    ste_name: "NC",
  },
  {
    zip_code: "27526",

    ste_name: "NC",
  },
  {
    zip_code: "27574",

    ste_name: "NC",
  },
  {
    zip_code: "27581",

    ste_name: "NC",
  },
  {
    zip_code: "27826",

    ste_name: "NC",
  },
  {
    zip_code: "27827",

    ste_name: "NC",
  },
  {
    zip_code: "27841",

    ste_name: "NC",
  },
  {
    zip_code: "27866",

    ste_name: "NC",
  },
  {
    zip_code: "27948",

    ste_name: "NC",
  },
  {
    zip_code: "28103",

    ste_name: "NC",
  },
  {
    zip_code: "28109",

    ste_name: "NC",
  },
  {
    zip_code: "28138",

    ste_name: "NC",
  },
  {
    zip_code: "28146",

    ste_name: "NC",
  },
  {
    zip_code: "28214",

    ste_name: "NC",
  },
  {
    zip_code: "28315",

    ste_name: "NC",
  },
  {
    zip_code: "28333",

    ste_name: "NC",
  },
  {
    zip_code: "28379",

    ste_name: "NC",
  },
  {
    zip_code: "28436",

    ste_name: "NC",
  },
  {
    zip_code: "28443",

    ste_name: "NC",
  },
  {
    zip_code: "28551",

    ste_name: "NC",
  },
  {
    zip_code: "28579",

    ste_name: "NC",
  },
  {
    zip_code: "28622",

    ste_name: "NC",
  },
  {
    zip_code: "28660",

    ste_name: "NC",
  },
  {
    zip_code: "28677",

    ste_name: "NC",
  },
  {
    zip_code: "28683",

    ste_name: "NC",
  },
  {
    zip_code: "28739",

    ste_name: "NC",
  },
  {
    zip_code: "28742",

    ste_name: "NC",
  },
  {
    zip_code: "29018",

    ste_name: "SC",
  },
  {
    zip_code: "29045",

    ste_name: "SC",
  },
  {
    zip_code: "29063",

    ste_name: "SC",
  },
  {
    zip_code: "29067",

    ste_name: "SC",
  },
  {
    zip_code: "29080",

    ste_name: "SC",
  },
  {
    zip_code: "29082",

    ste_name: "SC",
  },
  {
    zip_code: "29201",

    ste_name: "SC",
  },
  {
    zip_code: "29307",

    ste_name: "SC",
  },
  {
    zip_code: "29407",

    ste_name: "SC",
  },
  {
    zip_code: "29487",

    ste_name: "SC",
  },
  {
    zip_code: "29493",

    ste_name: "SC",
  },
  {
    zip_code: "29565",

    ste_name: "SC",
  },
  {
    zip_code: "29607",

    ste_name: "SC",
  },
  {
    zip_code: "29627",

    ste_name: "SC",
  },
  {
    zip_code: "29634",

    ste_name: "SC",
  },
  {
    zip_code: "29644",

    ste_name: "SC",
  },
  {
    zip_code: "29707",

    ste_name: "SC",
  },
  {
    zip_code: "29819",

    ste_name: "SC",
  },
  {
    zip_code: "29836",

    ste_name: "SC",
  },
  {
    zip_code: "29920",

    ste_name: "SC",
  },
  {
    zip_code: "30083",

    ste_name: "GA",
  },
  {
    zip_code: "30084",

    ste_name: "GA",
  },
  {
    zip_code: "30124",

    ste_name: "GA",
  },
  {
    zip_code: "30178",

    ste_name: "GA",
  },
  {
    zip_code: "30188",

    ste_name: "GA",
  },
  {
    zip_code: "30306",

    ste_name: "GA",
  },
  {
    zip_code: "30324",

    ste_name: "GA",
  },
  {
    zip_code: "30413",

    ste_name: "GA",
  },
  {
    zip_code: "30427",

    ste_name: "GA",
  },
  {
    zip_code: "30467",

    ste_name: "GA",
  },
  {
    zip_code: "30530",

    ste_name: "GA",
  },
  {
    zip_code: "30538",

    ste_name: "GA",
  },
  {
    zip_code: "30619",

    ste_name: "GA",
  },
  {
    zip_code: "30634",

    ste_name: "GA",
  },
  {
    zip_code: "30642",

    ste_name: "GA",
  },
  {
    zip_code: "30728",

    ste_name: "GA",
  },
  {
    zip_code: "30740",

    ste_name: "GA",
  },
  {
    zip_code: "30817",

    ste_name: "GA",
  },
  {
    zip_code: "38556",

    ste_name: "TN",
  },
  {
    zip_code: "38614",

    ste_name: "MS",
  },
  {
    zip_code: "38643",

    ste_name: "MS",
  },
  {
    zip_code: "38647",

    ste_name: "MS",
  },
  {
    zip_code: "38651",

    ste_name: "MS",
  },
  {
    zip_code: "38665",

    ste_name: "MS",
  },
  {
    zip_code: "38668",

    ste_name: "MS",
  },
  {
    zip_code: "38876",

    ste_name: "MS",
  },
  {
    zip_code: "38921",

    ste_name: "MS",
  },
  {
    zip_code: "39056",

    ste_name: "MS",
  },
  {
    zip_code: "39059",

    ste_name: "MS",
  },
  {
    zip_code: "39114",

    ste_name: "MS",
  },
  {
    zip_code: "39117",

    ste_name: "MS",
  },
  {
    zip_code: "39336",

    ste_name: "MS",
  },
  {
    zip_code: "39345",

    ste_name: "MS",
  },
  {
    zip_code: "39476",

    ste_name: "MS",
  },
  {
    zip_code: "40026",

    ste_name: "KY",
  },
  {
    zip_code: "40115",

    ste_name: "KY",
  },
  {
    zip_code: "40142",

    ste_name: "KY",
  },
  {
    zip_code: "40165",

    ste_name: "KY",
  },
  {
    zip_code: "40217",

    ste_name: "KY",
  },
  {
    zip_code: "40358",

    ste_name: "KY",
  },
  {
    zip_code: "40379",

    ste_name: "KY",
  },
  {
    zip_code: "40514",

    ste_name: "KY",
  },
  {
    zip_code: "40701",

    ste_name: "KY",
  },
  {
    zip_code: "40830",

    ste_name: "KY",
  },
  {
    zip_code: "40849",

    ste_name: "KY",
  },
  {
    zip_code: "40949",

    ste_name: "KY",
  },
  {
    zip_code: "41093",

    ste_name: "KY",
  },
  {
    zip_code: "41189",

    ste_name: "KY",
  },
  {
    zip_code: "41265",

    ste_name: "KY",
  },
  {
    zip_code: "41339",

    ste_name: "KY",
  },
  {
    zip_code: "41528",

    ste_name: "KY",
  },
  {
    zip_code: "41773",

    ste_name: "KY",
  },
  {
    zip_code: "41845",

    ste_name: "KY",
  },
  {
    zip_code: "42040",

    ste_name: "KY",
  },
  {
    zip_code: "42061",

    ste_name: "KY",
  },
  {
    zip_code: "42160",

    ste_name: "KY",
  },
  {
    zip_code: "42166",

    ste_name: "KY",
  },
  {
    zip_code: "42240",

    ste_name: "KY",
  },
  {
    zip_code: "42355",

    ste_name: "KY",
  },
  {
    zip_code: "42356",

    ste_name: "KY",
  },
  {
    zip_code: "42374",

    ste_name: "KY",
  },
  {
    zip_code: "42441",

    ste_name: "KY",
  },
  {
    zip_code: "42451",

    ste_name: "KY",
  },
  {
    zip_code: "42456",

    ste_name: "KY",
  },
  {
    zip_code: "42602",

    ste_name: "KY",
  },
  {
    zip_code: "42633",

    ste_name: "KY",
  },
  {
    zip_code: "43101",

    ste_name: "OH",
  },
  {
    zip_code: "43144",

    ste_name: "OH",
  },
  {
    zip_code: "43201",

    ste_name: "OH",
  },
  {
    zip_code: "43314",

    ste_name: "OH",
  },
  {
    zip_code: "43347",

    ste_name: "OH",
  },
  {
    zip_code: "43451",

    ste_name: "OH",
  },
  {
    zip_code: "43464",

    ste_name: "OH",
  },
  {
    zip_code: "43504",

    ste_name: "OH",
  },
  {
    zip_code: "43536",

    ste_name: "OH",
  },
  {
    zip_code: "43719",

    ste_name: "OH",
  },
  {
    zip_code: "43730",

    ste_name: "OH",
  },
  {
    zip_code: "43773",

    ste_name: "OH",
  },
  {
    zip_code: "43787",

    ste_name: "OH",
  },
  {
    zip_code: "43910",

    ste_name: "OH",
  },
  {
    zip_code: "44089",

    ste_name: "OH",
  },
  {
    zip_code: "44146",

    ste_name: "OH",
  },
  {
    zip_code: "44215",

    ste_name: "OH",
  },
  {
    zip_code: "44266",

    ste_name: "OH",
  },
  {
    zip_code: "44310",

    ste_name: "OH",
  },
  {
    zip_code: "44408",

    ste_name: "OH",
  },
  {
    zip_code: "44438",

    ste_name: "OH",
  },
  {
    zip_code: "44511",

    ste_name: "OH",
  },
  {
    zip_code: "44615",

    ste_name: "OH",
  },
  {
    zip_code: "44690",

    ste_name: "OH",
  },
  {
    zip_code: "44721",

    ste_name: "OH",
  },
  {
    zip_code: "44839",

    ste_name: "OH",
  },
  {
    zip_code: "44843",

    ste_name: "OH",
  },
  {
    zip_code: "44866",

    ste_name: "OH",
  },
  {
    zip_code: "45130",

    ste_name: "OH",
  },
  {
    zip_code: "45153",

    ste_name: "OH",
  },
  {
    zip_code: "45205",

    ste_name: "OH",
  },
  {
    zip_code: "45229",

    ste_name: "OH",
  },
  {
    zip_code: "45247",

    ste_name: "OH",
  },
  {
    zip_code: "45322",

    ste_name: "OH",
  },
  {
    zip_code: "45342",

    ste_name: "OH",
  },
  {
    zip_code: "45358",

    ste_name: "OH",
  },
  {
    zip_code: "45389",

    ste_name: "OH",
  },
  {
    zip_code: "45440",

    ste_name: "OH",
  },
  {
    zip_code: "45646",

    ste_name: "OH",
  },
  {
    zip_code: "45653",

    ste_name: "OH",
  },
  {
    zip_code: "45674",

    ste_name: "OH",
  },
  {
    zip_code: "45686",

    ste_name: "OH",
  },
  {
    zip_code: "45697",

    ste_name: "OH",
  },
  {
    zip_code: "45729",

    ste_name: "OH",
  },
  {
    zip_code: "45863",

    ste_name: "OH",
  },
  {
    zip_code: "45864",

    ste_name: "OH",
  },
  {
    zip_code: "45890",

    ste_name: "OH",
  },
  {
    zip_code: "45898",

    ste_name: "OH",
  },
  {
    zip_code: "46068",

    ste_name: "IN",
  },
  {
    zip_code: "46120",

    ste_name: "IN",
  },
  {
    zip_code: "46186",

    ste_name: "IN",
  },
  {
    zip_code: "46214",

    ste_name: "IN",
  },
  {
    zip_code: "46254",

    ste_name: "IN",
  },
  {
    zip_code: "46280",

    ste_name: "IN",
  },
  {
    zip_code: "46312",

    ste_name: "IN",
  },
  {
    zip_code: "46406",

    ste_name: "IN",
  },
  {
    zip_code: "46517",

    ste_name: "IN",
  },
  {
    zip_code: "46553",

    ste_name: "IN",
  },
  {
    zip_code: "46561",

    ste_name: "IN",
  },
  {
    zip_code: "46580",

    ste_name: "IN",
  },
  {
    zip_code: "46786",

    ste_name: "IN",
  },
  {
    zip_code: "46806",

    ste_name: "IN",
  },
  {
    zip_code: "46914",

    ste_name: "IN",
  },
  {
    zip_code: "46922",

    ste_name: "IN",
  },
  {
    zip_code: "47017",

    ste_name: "IN",
  },
  {
    zip_code: "47224",

    ste_name: "IN",
  },
  {
    zip_code: "47320",

    ste_name: "IN",
  },
  {
    zip_code: "47344",

    ste_name: "IN",
  },
  {
    zip_code: "47448",

    ste_name: "IN",
  },
  {
    zip_code: "47670",

    ste_name: "IN",
  },
  {
    zip_code: "47926",

    ste_name: "IN",
  },
  {
    zip_code: "47949",

    ste_name: "IN",
  },
  {
    zip_code: "48049",

    ste_name: "MI",
  },
  {
    zip_code: "48122",

    ste_name: "MI",
  },
  {
    zip_code: "48141",

    ste_name: "MI",
  },
  {
    zip_code: "48219",

    ste_name: "MI",
  },
  {
    zip_code: "48228",

    ste_name: "MI",
  },
  {
    zip_code: "48360",

    ste_name: "MI",
  },
  {
    zip_code: "48412",

    ste_name: "MI",
  },
  {
    zip_code: "48458",

    ste_name: "MI",
  },
  {
    zip_code: "48610",

    ste_name: "MI",
  },
  {
    zip_code: "48630",

    ste_name: "MI",
  },
  {
    zip_code: "48633",

    ste_name: "MI",
  },
  {
    zip_code: "48656",

    ste_name: "MI",
  },
  {
    zip_code: "48732",

    ste_name: "MI",
  },
  {
    zip_code: "48813",

    ste_name: "MI",
  },
  {
    zip_code: "48871",

    ste_name: "MI",
  },
  {
    zip_code: "49087",

    ste_name: "MI",
  },
  {
    zip_code: "49092",

    ste_name: "MI",
  },
  {
    zip_code: "49127",

    ste_name: "MI",
  },
  {
    zip_code: "49250",

    ste_name: "MI",
  },
  {
    zip_code: "49283",

    ste_name: "MI",
  },
  {
    zip_code: "49315",

    ste_name: "MI",
  },
  {
    zip_code: "49340",

    ste_name: "MI",
  },
  {
    zip_code: "49420",

    ste_name: "MI",
  },
  {
    zip_code: "49456",

    ste_name: "MI",
  },
  {
    zip_code: "49512",

    ste_name: "MI",
  },
  {
    zip_code: "49620",

    ste_name: "MI",
  },
  {
    zip_code: "49659",

    ste_name: "MI",
  },
  {
    zip_code: "49665",

    ste_name: "MI",
  },
  {
    zip_code: "49820",

    ste_name: "MI",
  },
  {
    zip_code: "49840",

    ste_name: "MI",
  },
  {
    zip_code: "49868",

    ste_name: "MI",
  },
  {
    zip_code: "49891",

    ste_name: "MI",
  },
  {
    zip_code: "49950",

    ste_name: "MI",
  },
  {
    zip_code: "50006",

    ste_name: "IA",
  },
  {
    zip_code: "50041",

    ste_name: "IA",
  },
  {
    zip_code: "50063",

    ste_name: "IA",
  },
  {
    zip_code: "50072",

    ste_name: "IA",
  },
  {
    zip_code: "50112",

    ste_name: "IA",
  },
  {
    zip_code: "50116",

    ste_name: "IA",
  },
  {
    zip_code: "50124",

    ste_name: "IA",
  },
  {
    zip_code: "50131",

    ste_name: "IA",
  },
  {
    zip_code: "50133",

    ste_name: "IA",
  },
  {
    zip_code: "50140",

    ste_name: "IA",
  },
  {
    zip_code: "50160",

    ste_name: "IA",
  },
  {
    zip_code: "50171",

    ste_name: "IA",
  },
  {
    zip_code: "50235",

    ste_name: "IA",
  },
  {
    zip_code: "50237",

    ste_name: "IA",
  },
  {
    zip_code: "50435",

    ste_name: "IA",
  },
  {
    zip_code: "50450",

    ste_name: "IA",
  },
  {
    zip_code: "50538",

    ste_name: "IA",
  },
  {
    zip_code: "50561",

    ste_name: "IA",
  },
  {
    zip_code: "50579",

    ste_name: "IA",
  },
  {
    zip_code: "50590",

    ste_name: "IA",
  },
  {
    zip_code: "50625",

    ste_name: "IA",
  },
  {
    zip_code: "50644",

    ste_name: "IA",
  },
  {
    zip_code: "50653",

    ste_name: "IA",
  },
  {
    zip_code: "50833",

    ste_name: "IA",
  },
  {
    zip_code: "51026",

    ste_name: "IA",
  },
  {
    zip_code: "51062",

    ste_name: "IA",
  },
  {
    zip_code: "51430",

    ste_name: "IA",
  },
  {
    zip_code: "51466",

    ste_name: "IA",
  },
  {
    zip_code: "51577",

    ste_name: "IA",
  },
  {
    zip_code: "51630",

    ste_name: "IA",
  },
  {
    zip_code: "51637",

    ste_name: "IA",
  },
  {
    zip_code: "52159",

    ste_name: "IA",
  },
  {
    zip_code: "52202",

    ste_name: "IA",
  },
  {
    zip_code: "52321",

    ste_name: "IA",
  },
  {
    zip_code: "52329",

    ste_name: "IA",
  },
  {
    zip_code: "52557",

    ste_name: "IA",
  },
  {
    zip_code: "52571",

    ste_name: "IA",
  },
  {
    zip_code: "52585",

    ste_name: "IA",
  },
  {
    zip_code: "52731",

    ste_name: "IA",
  },
  {
    zip_code: "52778",

    ste_name: "IA",
  },
  {
    zip_code: "53005",

    ste_name: "WI",
  },
  {
    zip_code: "53012",

    ste_name: "WI",
  },
  {
    zip_code: "53089",

    ste_name: "WI",
  },
  {
    zip_code: "53091",

    ste_name: "WI",
  },
  {
    zip_code: "53097",

    ste_name: "WI",
  },
  {
    zip_code: "53190",

    ste_name: "WI",
  },
  {
    zip_code: "53220",

    ste_name: "WI",
  },
  {
    zip_code: "53565",

    ste_name: "WI",
  },
  {
    zip_code: "53583",

    ste_name: "WI",
  },
  {
    zip_code: "54121",

    ste_name: "WI",
  },
  {
    zip_code: "54162",

    ste_name: "WI",
  },
  {
    zip_code: "54313",

    ste_name: "WI",
  },
  {
    zip_code: "54403",

    ste_name: "WI",
  },
  {
    zip_code: "54466",

    ste_name: "WI",
  },
  {
    zip_code: "54612",

    ste_name: "WI",
  },
  {
    zip_code: "54745",

    ste_name: "WI",
  },
  {
    zip_code: "54828",

    ste_name: "WI",
  },
  {
    zip_code: "54913",

    ste_name: "WI",
  },
  {
    zip_code: "55011",

    ste_name: "MN",
  },
  {
    zip_code: "55112",

    ste_name: "MN",
  },
  {
    zip_code: "55127",

    ste_name: "MN",
  },
  {
    zip_code: "55344",

    ste_name: "MN",
  },
  {
    zip_code: "55439",

    ste_name: "MN",
  },
  {
    zip_code: "55732",

    ste_name: "MN",
  },
  {
    zip_code: "55784",

    ste_name: "MN",
  },
  {
    zip_code: "56055",

    ste_name: "MN",
  },
  {
    zip_code: "56113",

    ste_name: "MN",
  },
  {
    zip_code: "56120",

    ste_name: "MN",
  },
  {
    zip_code: "56134",

    ste_name: "MN",
  },
  {
    zip_code: "56139",

    ste_name: "MN",
  },
  {
    zip_code: "56146",

    ste_name: "MN",
  },
  {
    zip_code: "56160",

    ste_name: "MN",
  },
  {
    zip_code: "56223",

    ste_name: "MN",
  },
  {
    zip_code: "56241",

    ste_name: "MN",
  },
  {
    zip_code: "56280",

    ste_name: "MN",
  },
  {
    zip_code: "56307",

    ste_name: "MN",
  },
  {
    zip_code: "56449",

    ste_name: "MN",
  },
  {
    zip_code: "56577",

    ste_name: "MN",
  },
  {
    zip_code: "56658",

    ste_name: "MN",
  },
  {
    zip_code: "56685",

    ste_name: "MN",
  },
  {
    zip_code: "56714",

    ste_name: "MN",
  },
  {
    zip_code: "57033",

    ste_name: "SD",
  },
  {
    zip_code: "57036",

    ste_name: "SD",
  },
  {
    zip_code: "57248",

    ste_name: "SD",
  },
  {
    zip_code: "57314",

    ste_name: "SD",
  },
  {
    zip_code: "57315",

    ste_name: "SD",
  },
  {
    zip_code: "57355",

    ste_name: "SD",
  },
  {
    zip_code: "57370",

    ste_name: "SD",
  },
  {
    zip_code: "57380",

    ste_name: "SD",
  },
  {
    zip_code: "57442",

    ste_name: "SD",
  },
  {
    zip_code: "57466",

    ste_name: "SD",
  },
  {
    zip_code: "57477",

    ste_name: "SD",
  },
  {
    zip_code: "57625",

    ste_name: "SD",
  },
  {
    zip_code: "57644",

    ste_name: "SD",
  },
  {
    zip_code: "57756",

    ste_name: "SD",
  },
  {
    zip_code: "58032",

    ste_name: "ND",
  },
  {
    zip_code: "58033",

    ste_name: "ND",
  },
  {
    zip_code: "58043",

    ste_name: "ND",
  },
  {
    zip_code: "58053",

    ste_name: "ND",
  },
  {
    zip_code: "58062",

    ste_name: "ND",
  },
  {
    zip_code: "58071",

    ste_name: "ND",
  },
  {
    zip_code: "58275",

    ste_name: "ND",
  },
  {
    zip_code: "58343",

    ste_name: "ND",
  },
  {
    zip_code: "58439",

    ste_name: "ND",
  },
  {
    zip_code: "58448",

    ste_name: "ND",
  },
  {
    zip_code: "58494",

    ste_name: "ND",
  },
  {
    zip_code: "58542",

    ste_name: "ND",
  },
  {
    zip_code: "58631",

    ste_name: "ND",
  },
  {
    zip_code: "58716",

    ste_name: "ND",
  },
  {
    zip_code: "58755",

    ste_name: "ND",
  },
  {
    zip_code: "58788",

    ste_name: "ND",
  },
  {
    zip_code: "59041",

    ste_name: "MT",
  },
  {
    zip_code: "59313",

    ste_name: "MT",
  },
  {
    zip_code: "59432",

    ste_name: "MT",
  },
  {
    zip_code: "59484",

    ste_name: "MT",
  },
  {
    zip_code: "59525",

    ste_name: "MT",
  },
  {
    zip_code: "59530",

    ste_name: "MT",
  },
  {
    zip_code: "59866",

    ste_name: "MT",
  },
  {
    zip_code: "59932",

    ste_name: "MT",
  },
  {
    zip_code: "59937",

    ste_name: "MT",
  },
  {
    zip_code: "60002",

    ste_name: "IL",
  },
  {
    zip_code: "60014",

    ste_name: "IL",
  },
  {
    zip_code: "60026",

    ste_name: "IL",
  },
  {
    zip_code: "60102",

    ste_name: "IL",
  },
  {
    zip_code: "60184",

    ste_name: "IL",
  },
  {
    zip_code: "60411",

    ste_name: "IL",
  },
  {
    zip_code: "60425",

    ste_name: "IL",
  },
  {
    zip_code: "60430",

    ste_name: "IL",
  },
  {
    zip_code: "60449",

    ste_name: "IL",
  },
  {
    zip_code: "60458",

    ste_name: "IL",
  },
  {
    zip_code: "60514",

    ste_name: "IL",
  },
  {
    zip_code: "60556",

    ste_name: "IL",
  },
  {
    zip_code: "60605",

    ste_name: "IL",
  },
  {
    zip_code: "60617",

    ste_name: "IL",
  },
  {
    zip_code: "60929",

    ste_name: "IL",
  },
  {
    zip_code: "61107",

    ste_name: "IL",
  },
  {
    zip_code: "61112",

    ste_name: "IL",
  },
  {
    zip_code: "61519",

    ste_name: "IL",
  },
  {
    zip_code: "61607",

    ste_name: "IL",
  },
  {
    zip_code: "61771",

    ste_name: "IL",
  },
  {
    zip_code: "61834",

    ste_name: "IL",
  },
  {
    zip_code: "61855",

    ste_name: "IL",
  },
  {
    zip_code: "61862",

    ste_name: "IL",
  },
  {
    zip_code: "61871",

    ste_name: "IL",
  },
  {
    zip_code: "61911",

    ste_name: "IL",
  },
  {
    zip_code: "62006",

    ste_name: "IL",
  },
  {
    zip_code: "62027",

    ste_name: "IL",
  },
  {
    zip_code: "62032",

    ste_name: "IL",
  },
  {
    zip_code: "62051",

    ste_name: "IL",
  },
  {
    zip_code: "62063",

    ste_name: "IL",
  },
  {
    zip_code: "62226",

    ste_name: "IL",
  },
  {
    zip_code: "62314",

    ste_name: "IL",
  },
  {
    zip_code: "62436",

    ste_name: "IL",
  },
  {
    zip_code: "62451",

    ste_name: "IL",
  },
  {
    zip_code: "62481",

    ste_name: "IL",
  },
  {
    zip_code: "62601",

    ste_name: "IL",
  },
  {
    zip_code: "62610",

    ste_name: "IL",
  },
  {
    zip_code: "62629",

    ste_name: "IL",
  },
  {
    zip_code: "62661",

    ste_name: "IL",
  },
  {
    zip_code: "62685",

    ste_name: "IL",
  },
  {
    zip_code: "62808",

    ste_name: "IL",
  },
  {
    zip_code: "62811",

    ste_name: "IL",
  },
  {
    zip_code: "62831",

    ste_name: "IL",
  },
  {
    zip_code: "62846",

    ste_name: "IL",
  },
  {
    zip_code: "62914",

    ste_name: "IL",
  },
  {
    zip_code: "62934",

    ste_name: "IL",
  },
  {
    zip_code: "62963",

    ste_name: "IL",
  },
  {
    zip_code: "62964",

    ste_name: "IL",
  },
  {
    zip_code: "63021",

    ste_name: "MO",
  },
  {
    zip_code: "63041",

    ste_name: "MO",
  },
  {
    zip_code: "63112",

    ste_name: "MO",
  },
  {
    zip_code: "63116",

    ste_name: "MO",
  },
  {
    zip_code: "63143",

    ste_name: "MO",
  },
  {
    zip_code: "63147",

    ste_name: "MO",
  },
  {
    zip_code: "63341",

    ste_name: "MO",
  },
  {
    zip_code: "63352",

    ste_name: "MO",
  },
  {
    zip_code: "63362",

    ste_name: "MO",
  },
  {
    zip_code: "63735",

    ste_name: "MO",
  },
  {
    zip_code: "63747",

    ste_name: "MO",
  },
  {
    zip_code: "63748",

    ste_name: "MO",
  },
  {
    zip_code: "63767",

    ste_name: "MO",
  },
  {
    zip_code: "63901",

    ste_name: "MO",
  },
  {
    zip_code: "63941",

    ste_name: "MO",
  },
  {
    zip_code: "63955",

    ste_name: "MO",
  },
  {
    zip_code: "64011",

    ste_name: "MO",
  },
  {
    zip_code: "64053",

    ste_name: "MO",
  },
  {
    zip_code: "64155",

    ste_name: "MO",
  },
  {
    zip_code: "64434",

    ste_name: "MO",
  },
  {
    zip_code: "64475",

    ste_name: "MO",
  },
  {
    zip_code: "64494",

    ste_name: "MO",
  },
  {
    zip_code: "64496",

    ste_name: "MO",
  },
  {
    zip_code: "64632",

    ste_name: "MO",
  },
  {
    zip_code: "64635",

    ste_name: "MO",
  },
  {
    zip_code: "64742",

    ste_name: "MO",
  },
  {
    zip_code: "65039",

    ste_name: "MO",
  },
  {
    zip_code: "65232",

    ste_name: "MO",
  },
  {
    zip_code: "65326",

    ste_name: "MO",
  },
  {
    zip_code: "65333",

    ste_name: "MO",
  },
  {
    zip_code: "65338",

    ste_name: "MO",
  },
  {
    zip_code: "65541",

    ste_name: "MO",
  },
  {
    zip_code: "65564",

    ste_name: "MO",
  },
  {
    zip_code: "65591",

    ste_name: "MO",
  },
  {
    zip_code: "65724",

    ste_name: "MO",
  },
  {
    zip_code: "65775",

    ste_name: "MO",
  },
  {
    zip_code: "66012",

    ste_name: "KS",
  },
  {
    zip_code: "66025",

    ste_name: "KS",
  },
  {
    zip_code: "66045",

    ste_name: "KS",
  },
  {
    zip_code: "66086",

    ste_name: "KS",
  },
  {
    zip_code: "66217",

    ste_name: "KS",
  },
  {
    zip_code: "66506",

    ste_name: "KS",
  },
  {
    zip_code: "66767",

    ste_name: "KS",
  },
  {
    zip_code: "66872",

    ste_name: "KS",
  },
  {
    zip_code: "67009",

    ste_name: "KS",
  },
  {
    zip_code: "67052",

    ste_name: "KS",
  },
  {
    zip_code: "67105",

    ste_name: "KS",
  },
  {
    zip_code: "67138",

    ste_name: "KS",
  },
  {
    zip_code: "67211",

    ste_name: "KS",
  },
  {
    zip_code: "67301",

    ste_name: "KS",
  },
  {
    zip_code: "67436",

    ste_name: "KS",
  },
  {
    zip_code: "67478",

    ste_name: "KS",
  },
  {
    zip_code: "67520",

    ste_name: "KS",
  },
  {
    zip_code: "67628",

    ste_name: "KS",
  },
  {
    zip_code: "67751",

    ste_name: "KS",
  },
  {
    zip_code: "67839",

    ste_name: "KS",
  },
  {
    zip_code: "67842",

    ste_name: "KS",
  },
  {
    zip_code: "67951",

    ste_name: "KS",
  },
  {
    zip_code: "68068",

    ste_name: "NE",
  },
  {
    zip_code: "68112",

    ste_name: "NE",
  },
  {
    zip_code: "68375",

    ste_name: "NE",
  },
  {
    zip_code: "68437",

    ste_name: "NE",
  },
  {
    zip_code: "68662",

    ste_name: "NE",
  },
  {
    zip_code: "68664",

    ste_name: "NE",
  },
  {
    zip_code: "68724",

    ste_name: "NE",
  },
  {
    zip_code: "68731",

    ste_name: "NE",
  },
  {
    zip_code: "68734",

    ste_name: "NE",
  },
  {
    zip_code: "68749",

    ste_name: "NE",
  },
  {
    zip_code: "68785",

    ste_name: "NE",
  },
  {
    zip_code: "68859",

    ste_name: "NE",
  },
  {
    zip_code: "68924",

    ste_name: "NE",
  },
  {
    zip_code: "68943",

    ste_name: "NE",
  },
  {
    zip_code: "69045",

    ste_name: "NE",
  },
  {
    zip_code: "69123",

    ste_name: "NE",
  },
  {
    zip_code: "69131",

    ste_name: "NE",
  },
  {
    zip_code: "69156",

    ste_name: "NE",
  },
  {
    zip_code: "69167",

    ste_name: "NE",
  },
  {
    zip_code: "69348",

    ste_name: "NE",
  },
  {
    zip_code: "70041",

    ste_name: "LA",
  },
  {
    zip_code: "70049",

    ste_name: "LA",
  },
  {
    zip_code: "70125",

    ste_name: "LA",
  },
  {
    zip_code: "70377",

    ste_name: "LA",
  },
  {
    zip_code: "70591",

    ste_name: "LA",
  },
  {
    zip_code: "70657",

    ste_name: "LA",
  },
  {
    zip_code: "70663",

    ste_name: "LA",
  },
  {
    zip_code: "70668",

    ste_name: "LA",
  },
  {
    zip_code: "70711",

    ste_name: "LA",
  },
  {
    zip_code: "70737",

    ste_name: "LA",
  },
  {
    zip_code: "70817",

    ste_name: "LA",
  },
  {
    zip_code: "71251",

    ste_name: "LA",
  },
  {
    zip_code: "71291",

    ste_name: "LA",
  },
  {
    zip_code: "71358",

    ste_name: "LA",
  },
  {
    zip_code: "71366",

    ste_name: "LA",
  },
  {
    zip_code: "71465",

    ste_name: "LA",
  },
  {
    zip_code: "71473",

    ste_name: "LA",
  },
  {
    zip_code: "71485",

    ste_name: "LA",
  },
  {
    zip_code: "71653",

    ste_name: "AR",
  },
  {
    zip_code: "71724",

    ste_name: "AR",
  },
  {
    zip_code: "71956",

    ste_name: "AR",
  },
  {
    zip_code: "71959",

    ste_name: "AR",
  },
  {
    zip_code: "71964",

    ste_name: "AR",
  },
  {
    zip_code: "71973",

    ste_name: "AR",
  },
  {
    zip_code: "72042",

    ste_name: "AR",
  },
  {
    zip_code: "72139",

    ste_name: "AR",
  },
  {
    zip_code: "72179",

    ste_name: "AR",
  },
  {
    zip_code: "72360",

    ste_name: "AR",
  },
  {
    zip_code: "72389",

    ste_name: "AR",
  },
  {
    zip_code: "72401",

    ste_name: "AR",
  },
  {
    zip_code: "72442",

    ste_name: "AR",
  },
  {
    zip_code: "72457",

    ste_name: "AR",
  },
  {
    zip_code: "72539",

    ste_name: "AR",
  },
  {
    zip_code: "72542",

    ste_name: "AR",
  },
  {
    zip_code: "72571",

    ste_name: "AR",
  },
  {
    zip_code: "72666",

    ste_name: "AR",
  },
  {
    zip_code: "72683",

    ste_name: "AR",
  },
  {
    zip_code: "72717",

    ste_name: "AR",
  },
  {
    zip_code: "72721",

    ste_name: "AR",
  },
  {
    zip_code: "72744",

    ste_name: "AR",
  },
  {
    zip_code: "72749",

    ste_name: "AR",
  },
  {
    zip_code: "72830",

    ste_name: "AR",
  },
  {
    zip_code: "73025",

    ste_name: "OK",
  },
  {
    zip_code: "73108",

    ste_name: "OK",
  },
  {
    zip_code: "73425",

    ste_name: "OK",
  },
  {
    zip_code: "73540",

    ste_name: "OK",
  },
  {
    zip_code: "73549",

    ste_name: "OK",
  },
  {
    zip_code: "73570",

    ste_name: "OK",
  },
  {
    zip_code: "73654",

    ste_name: "OK",
  },
  {
    zip_code: "73660",

    ste_name: "OK",
  },
  {
    zip_code: "74021",

    ste_name: "OK",
  },
  {
    zip_code: "74034",

    ste_name: "OK",
  },
  {
    zip_code: "74047",

    ste_name: "OK",
  },
  {
    zip_code: "74055",

    ste_name: "OK",
  },
  {
    zip_code: "74075",

    ste_name: "OK",
  },
  {
    zip_code: "74114",

    ste_name: "OK",
  },
  {
    zip_code: "74119",

    ste_name: "OK",
  },
  {
    zip_code: "74457",

    ste_name: "OK",
  },
  {
    zip_code: "74535",

    ste_name: "OK",
  },
  {
    zip_code: "74547",

    ste_name: "OK",
  },
  {
    zip_code: "74554",

    ste_name: "OK",
  },
  {
    zip_code: "74601",

    ste_name: "OK",
  },
  {
    zip_code: "74738",

    ste_name: "OK",
  },
  {
    zip_code: "74741",

    ste_name: "OK",
  },
  {
    zip_code: "74848",

    ste_name: "OK",
  },
  {
    zip_code: "74851",

    ste_name: "OK",
  },
  {
    zip_code: "74880",

    ste_name: "OK",
  },
  {
    zip_code: "75038",

    ste_name: "TX",
  },
  {
    zip_code: "75093",

    ste_name: "TX",
  },
  {
    zip_code: "75109",

    ste_name: "TX",
  },
  {
    zip_code: "75137",

    ste_name: "TX",
  },
  {
    zip_code: "75153",

    ste_name: "TX",
  },
  {
    zip_code: "75478",

    ste_name: "TX",
  },
  {
    zip_code: "75567",

    ste_name: "TX",
  },
  {
    zip_code: "75661",

    ste_name: "TX",
  },
  {
    zip_code: "75789",

    ste_name: "TX",
  },
  {
    zip_code: "75839",

    ste_name: "TX",
  },
  {
    zip_code: "75855",

    ste_name: "TX",
  },
  {
    zip_code: "76052",

    ste_name: "TX",
  },
  {
    zip_code: "76082",

    ste_name: "TX",
  },
  {
    zip_code: "76309",

    ste_name: "TX",
  },
  {
    zip_code: "76351",

    ste_name: "TX",
  },
  {
    zip_code: "76444",

    ste_name: "TX",
  },
  {
    zip_code: "76445",

    ste_name: "TX",
  },
  {
    zip_code: "76457",

    ste_name: "TX",
  },
  {
    zip_code: "76569",

    ste_name: "TX",
  },
  {
    zip_code: "76577",

    ste_name: "TX",
  },
  {
    zip_code: "76621",

    ste_name: "TX",
  },
  {
    zip_code: "76633",

    ste_name: "TX",
  },
  {
    zip_code: "76834",

    ste_name: "TX",
  },
  {
    zip_code: "76859",

    ste_name: "TX",
  },
  {
    zip_code: "76865",

    ste_name: "TX",
  },
  {
    zip_code: "76875",

    ste_name: "TX",
  },
  {
    zip_code: "76903",

    ste_name: "TX",
  },
  {
    zip_code: "76904",

    ste_name: "TX",
  },
  {
    zip_code: "76930",

    ste_name: "TX",
  },
  {
    zip_code: "76945",

    ste_name: "TX",
  },
  {
    zip_code: "77011",

    ste_name: "TX",
  },
  {
    zip_code: "77035",

    ste_name: "TX",
  },
  {
    zip_code: "77064",

    ste_name: "TX",
  },
  {
    zip_code: "77456",

    ste_name: "TX",
  },
  {
    zip_code: "77541",

    ste_name: "TX",
  },
  {
    zip_code: "77568",

    ste_name: "TX",
  },
  {
    zip_code: "77657",

    ste_name: "TX",
  },
  {
    zip_code: "77801",

    ste_name: "TX",
  },
  {
    zip_code: "77857",

    ste_name: "TX",
  },
  {
    zip_code: "77901",

    ste_name: "TX",
  },
  {
    zip_code: "77991",

    ste_name: "TX",
  },
  {
    zip_code: "78026",

    ste_name: "TX",
  },
  {
    zip_code: "78028",

    ste_name: "TX",
  },
  {
    zip_code: "78055",

    ste_name: "TX",
  },
  {
    zip_code: "78113",

    ste_name: "TX",
  },
  {
    zip_code: "78159",

    ste_name: "TX",
  },
  {
    zip_code: "78231",

    ste_name: "TX",
  },
  {
    zip_code: "78247",

    ste_name: "TX",
  },
  {
    zip_code: "78261",

    ste_name: "TX",
  },
  {
    zip_code: "78415",

    ste_name: "TX",
  },
  {
    zip_code: "78549",

    ste_name: "TX",
  },
  {
    zip_code: "78550",

    ste_name: "TX",
  },
  {
    zip_code: "78591",

    ste_name: "TX",
  },
  {
    zip_code: "78852",

    ste_name: "TX",
  },
  {
    zip_code: "78881",

    ste_name: "TX",
  },
  {
    zip_code: "78934",

    ste_name: "TX",
  },
  {
    zip_code: "78935",

    ste_name: "TX",
  },
  {
    zip_code: "78947",

    ste_name: "TX",
  },
  {
    zip_code: "79036",

    ste_name: "TX",
  },
  {
    zip_code: "79052",

    ste_name: "TX",
  },
  {
    zip_code: "79239",

    ste_name: "TX",
  },
  {
    zip_code: "79411",

    ste_name: "TX",
  },
  {
    zip_code: "79565",

    ste_name: "TX",
  },
  {
    zip_code: "79603",

    ste_name: "TX",
  },
  {
    zip_code: "80007",

    ste_name: "CO",
  },
  {
    zip_code: "80447",

    ste_name: "CO",
  },
  {
    zip_code: "80483",

    ste_name: "CO",
  },
  {
    zip_code: "80501",

    ste_name: "CO",
  },
  {
    zip_code: "80520",

    ste_name: "CO",
  },
  {
    zip_code: "80530",

    ste_name: "CO",
  },
  {
    zip_code: "80540",

    ste_name: "CO",
  },
  {
    zip_code: "80620",

    ste_name: "CO",
  },
  {
    zip_code: "80802",

    ste_name: "CO",
  },
  {
    zip_code: "80809",

    ste_name: "CO",
  },
  {
    zip_code: "80832",

    ste_name: "CO",
  },
  {
    zip_code: "81022",

    ste_name: "CO",
  },
  {
    zip_code: "81055",

    ste_name: "CO",
  },
  {
    zip_code: "81062",

    ste_name: "CO",
  },
  {
    zip_code: "81101",

    ste_name: "CO",
  },
  {
    zip_code: "81419",

    ste_name: "CO",
  },
  {
    zip_code: "81430",

    ste_name: "CO",
  },
  {
    zip_code: "81637",

    ste_name: "CO",
  },
  {
    zip_code: "81654",

    ste_name: "CO",
  },
  {
    zip_code: "81655",

    ste_name: "CO",
  },
  {
    zip_code: "82001",

    ste_name: "WY",
  },
  {
    zip_code: "82701",

    ste_name: "WY",
  },
  {
    zip_code: "83318",

    ste_name: "ID",
  },
  {
    zip_code: "83469",

    ste_name: "ID",
  },
  {
    zip_code: "83524",

    ste_name: "ID",
  },
  {
    zip_code: "83526",

    ste_name: "ID",
  },
  {
    zip_code: "83537",

    ste_name: "ID",
  },
  {
    zip_code: "83611",

    ste_name: "ID",
  },
  {
    zip_code: "83627",

    ste_name: "ID",
  },
  {
    zip_code: "83824",

    ste_name: "ID",
  },
  {
    zip_code: "83826",

    ste_name: "ID",
  },
  {
    zip_code: "84044",

    ste_name: "UT",
  },
  {
    zip_code: "84101",

    ste_name: "UT",
  },
  {
    zip_code: "84535",

    ste_name: "UT",
  },
  {
    zip_code: "84637",

    ste_name: "UT",
  },
  {
    zip_code: "84648",

    ste_name: "UT",
  },
  {
    zip_code: "84759",

    ste_name: "UT",
  },
  {
    zip_code: "85018",

    ste_name: "AZ",
  },
  {
    zip_code: "85027",

    ste_name: "AZ",
  },
  {
    zip_code: "85028",

    ste_name: "AZ",
  },
  {
    zip_code: "85087",

    ste_name: "AZ",
  },
  {
    zip_code: "85259",

    ste_name: "AZ",
  },
  {
    zip_code: "85310",

    ste_name: "AZ",
  },
  {
    zip_code: "85351",

    ste_name: "AZ",
  },
  {
    zip_code: "85643",

    ste_name: "AZ",
  },
  {
    zip_code: "85646",

    ste_name: "AZ",
  },
  {
    zip_code: "85719",

    ste_name: "AZ",
  },
  {
    zip_code: "85933",

    ste_name: "AZ",
  },
  {
    zip_code: "85935",

    ste_name: "AZ",
  },
  {
    zip_code: "85937",

    ste_name: "AZ",
  },
  {
    zip_code: "85938",

    ste_name: "AZ",
  },
  {
    zip_code: "86327",

    ste_name: "AZ",
  },
  {
    zip_code: "86351",

    ste_name: "AZ",
  },
  {
    zip_code: "86435",

    ste_name: "AZ",
  },
  {
    zip_code: "86506",

    ste_name: "AZ",
  },
  {
    zip_code: "86511",

    ste_name: "AZ",
  },
  {
    zip_code: "86520",

    ste_name: "AZ",
  },
  {
    zip_code: "87063",

    ste_name: "NM",
  },
  {
    zip_code: "87402",

    ste_name: "NM",
  },
  {
    zip_code: "87416",

    ste_name: "NM",
  },
  {
    zip_code: "87548",

    ste_name: "NM",
  },
  {
    zip_code: "87710",

    ste_name: "NM",
  },
  {
    zip_code: "87933",

    ste_name: "NM",
  },
  {
    zip_code: "88232",

    ste_name: "NM",
  },
  {
    zip_code: "88336",

    ste_name: "NM",
  },
  {
    zip_code: "89106",

    ste_name: "NV",
  },
  {
    zip_code: "89141",

    ste_name: "NV",
  },
  {
    zip_code: "89421",

    ste_name: "NV",
  },
  {
    zip_code: "89449",

    ste_name: "NV",
  },
  {
    zip_code: "90018",

    ste_name: "CA",
  },
  {
    zip_code: "90022",

    ste_name: "CA",
  },
  {
    zip_code: "90035",

    ste_name: "CA",
  },
  {
    zip_code: "90272",

    ste_name: "CA",
  },
  {
    zip_code: "90701",

    ste_name: "CA",
  },
  {
    zip_code: "90731",

    ste_name: "CA",
  },
  {
    zip_code: "91006",

    ste_name: "CA",
  },
  {
    zip_code: "91040",

    ste_name: "CA",
  },
  {
    zip_code: "91320",

    ste_name: "CA",
  },
  {
    zip_code: "91390",

    ste_name: "CA",
  },
  {
    zip_code: "91405",

    ste_name: "CA",
  },
  {
    zip_code: "91722",

    ste_name: "CA",
  },
  {
    zip_code: "91776",

    ste_name: "CA",
  },
  {
    zip_code: "91910",

    ste_name: "CA",
  },
  {
    zip_code: "92024",

    ste_name: "CA",
  },
  {
    zip_code: "92056",

    ste_name: "CA",
  },
  {
    zip_code: "92123",

    ste_name: "CA",
  },
  {
    zip_code: "92135",

    ste_name: "CA",
  },
  {
    zip_code: "92173",

    ste_name: "CA",
  },
  {
    zip_code: "92220",

    ste_name: "CA",
  },
  {
    zip_code: "92275",

    ste_name: "CA",
  },
  {
    zip_code: "92365",

    ste_name: "CA",
  },
  {
    zip_code: "92374",

    ste_name: "CA",
  },
  {
    zip_code: "92408",

    ste_name: "CA",
  },
  {
    zip_code: "92586",

    ste_name: "CA",
  },
  {
    zip_code: "92596",

    ste_name: "CA",
  },
  {
    zip_code: "92647",

    ste_name: "CA",
  },
  {
    zip_code: "92663",

    ste_name: "CA",
  },
  {
    zip_code: "92691",

    ste_name: "CA",
  },
  {
    zip_code: "92870",

    ste_name: "CA",
  },
  {
    zip_code: "93210",

    ste_name: "CA",
  },
  {
    zip_code: "93446",

    ste_name: "CA",
  },
  {
    zip_code: "93513",

    ste_name: "CA",
  },
  {
    zip_code: "93522",

    ste_name: "CA",
  },
  {
    zip_code: "93534",

    ste_name: "CA",
  },
  {
    zip_code: "93643",

    ste_name: "CA",
  },
  {
    zip_code: "93664",

    ste_name: "CA",
  },
  {
    zip_code: "93930",

    ste_name: "CA",
  },
  {
    zip_code: "94061",

    ste_name: "CA",
  },
  {
    zip_code: "94111",

    ste_name: "CA",
  },
  {
    zip_code: "94131",

    ste_name: "CA",
  },
  {
    zip_code: "94516",

    ste_name: "CA",
  },
  {
    zip_code: "94519",

    ste_name: "CA",
  },
  {
    zip_code: "94552",

    ste_name: "CA",
  },
  {
    zip_code: "94598",

    ste_name: "CA",
  },
  {
    zip_code: "94606",

    ste_name: "CA",
  },
  {
    zip_code: "95224",

    ste_name: "CA",
  },
  {
    zip_code: "95248",

    ste_name: "CA",
  },
  {
    zip_code: "95305",

    ste_name: "CA",
  },
  {
    zip_code: "95367",

    ste_name: "CA",
  },
  {
    zip_code: "95403",

    ste_name: "CA",
  },
  {
    zip_code: "95423",

    ste_name: "CA",
  },
  {
    zip_code: "95451",

    ste_name: "CA",
  },
  {
    zip_code: "95526",

    ste_name: "CA",
  },
  {
    zip_code: "95537",

    ste_name: "CA",
  },
  {
    zip_code: "95549",

    ste_name: "CA",
  },
  {
    zip_code: "95553",

    ste_name: "CA",
  },
  {
    zip_code: "95615",

    ste_name: "CA",
  },
  {
    zip_code: "95659",

    ste_name: "CA",
  },
  {
    zip_code: "95703",

    ste_name: "CA",
  },
  {
    zip_code: "95735",

    ste_name: "CA",
  },
  {
    zip_code: "95842",

    ste_name: "CA",
  },
  {
    zip_code: "95949",

    ste_name: "CA",
  },
  {
    zip_code: "96119",

    ste_name: "CA",
  },
  {
    zip_code: "96145",

    ste_name: "CA",
  },
  {
    zip_code: "96704",

    ste_name: "HI",
  },
  {
    zip_code: "96720",

    ste_name: "HI",
  },
  {
    zip_code: "96722",

    ste_name: "HI",
  },
  {
    zip_code: "96734",

    ste_name: "HI",
  },
  {
    zip_code: "96769",

    ste_name: "HI",
  },
  {
    zip_code: "96793",

    ste_name: "HI",
  },
  {
    zip_code: "96857",

    ste_name: "HI",
  },
  {
    zip_code: "97008",

    ste_name: "OR",
  },
  {
    zip_code: "97053",

    ste_name: "OR",
  },
  {
    zip_code: "97068",

    ste_name: "OR",
  },
  {
    zip_code: "97080",

    ste_name: "OR",
  },
  {
    zip_code: "97122",

    ste_name: "OR",
  },
  {
    zip_code: "97213",

    ste_name: "OR",
  },
  {
    zip_code: "97217",

    ste_name: "OR",
  },
  {
    zip_code: "97457",

    ste_name: "OR",
  },
  {
    zip_code: "97540",

    ste_name: "OR",
  },
  {
    zip_code: "97541",

    ste_name: "OR",
  },
  {
    zip_code: "97758",

    ste_name: "OR",
  },
  {
    zip_code: "97761",

    ste_name: "OR",
  },
  {
    zip_code: "97837",

    ste_name: "OR",
  },
  {
    zip_code: "97868",

    ste_name: "OR",
  },
  {
    zip_code: "98051",

    ste_name: "WA",
  },
  {
    zip_code: "98052",

    ste_name: "WA",
  },
  {
    zip_code: "98126",

    ste_name: "WA",
  },
  {
    zip_code: "98203",

    ste_name: "WA",
  },
  {
    zip_code: "98360",

    ste_name: "WA",
  },
  {
    zip_code: "98361",

    ste_name: "WA",
  },
  {
    zip_code: "98364",

    ste_name: "WA",
  },
  {
    zip_code: "97441",

    ste_name: "OR",
  },
  {
    zip_code: "97493",

    ste_name: "OR",
  },
  {
    zip_code: "97530",

    ste_name: "OR",
  },
  {
    zip_code: "98258",

    ste_name: "WA",
  },
  {
    zip_code: "98294",

    ste_name: "WA",
  },
  {
    zip_code: "98329",

    ste_name: "WA",
  },
  {
    zip_code: "98565",

    ste_name: "WA",
  },
  {
    zip_code: "98671",

    ste_name: "WA",
  },
  {
    zip_code: "98844",

    ste_name: "WA",
  },
  {
    zip_code: "98852",

    ste_name: "WA",
  },
  {
    zip_code: "98859",

    ste_name: "WA",
  },
  {
    zip_code: "99110",

    ste_name: "WA",
  },
  {
    zip_code: "99146",

    ste_name: "WA",
  },
  {
    zip_code: "99216",

    ste_name: "WA",
  },
  {
    zip_code: "99301",

    ste_name: "WA",
  },
  {
    zip_code: "99338",

    ste_name: "WA",
  },
  {
    zip_code: "99548",

    ste_name: "AK",
  },
  {
    zip_code: "99564",

    ste_name: "AK",
  },
  {
    zip_code: "99625",

    ste_name: "AK",
  },
  {
    zip_code: "99666",

    ste_name: "AK",
  },
  {
    zip_code: "99692",

    ste_name: "AK",
  },
  {
    zip_code: "99755",

    ste_name: "AK",
  },
  {
    zip_code: "99756",

    ste_name: "AK",
  },
  {
    zip_code: "99764",

    ste_name: "AK",
  },
  {
    zip_code: "99824",

    ste_name: "AK",
  },
  {
    zip_code: "99836",

    ste_name: "AK",
  },
  {
    zip_code: "99923",

    ste_name: "AK",
  },
  {
    zip_code: "622",

    ste_name: "PR",
  },
  {
    zip_code: "765",

    ste_name: "PR",
  },
  {
    zip_code: "1199",

    ste_name: "MA",
  },
  {
    zip_code: "1235",

    ste_name: "MA",
  },
  {
    zip_code: "1244",

    ste_name: "MA",
  },
  {
    zip_code: "1255",

    ste_name: "MA",
  },
  {
    zip_code: "1420",

    ste_name: "MA",
  },
  {
    zip_code: "1468",

    ste_name: "MA",
  },
  {
    zip_code: "1510",

    ste_name: "MA",
  },
  {
    zip_code: "1606",

    ste_name: "MA",
  },
  {
    zip_code: "1745",

    ste_name: "MA",
  },
  {
    zip_code: "1749",

    ste_name: "MA",
  },
  {
    zip_code: "1824",

    ste_name: "MA",
  },
  {
    zip_code: "1886",

    ste_name: "MA",
  },
  {
    zip_code: "2030",

    ste_name: "MA",
  },
  {
    zip_code: "2110",

    ste_name: "MA",
  },
  {
    zip_code: "2115",

    ste_name: "MA",
  },
  {
    zip_code: "2119",

    ste_name: "MA",
  },
  {
    zip_code: "2155",

    ste_name: "MA",
  },
  {
    zip_code: "2359",

    ste_name: "MA",
  },
  {
    zip_code: "2452",

    ste_name: "MA",
  },
  {
    zip_code: "2458",

    ste_name: "MA",
  },
  {
    zip_code: "2631",

    ste_name: "MA",
  },
  {
    zip_code: "2648",

    ste_name: "MA",
  },
  {
    zip_code: "2675",

    ste_name: "MA",
  },
  {
    zip_code: "3217",

    ste_name: "NH",
  },
  {
    zip_code: "3447",

    ste_name: "NH",
  },
  {
    zip_code: "3575",

    ste_name: "NH",
  },
  {
    zip_code: "3812",

    ste_name: "NH",
  },
  {
    zip_code: "3824",

    ste_name: "NH",
  },
  {
    zip_code: "3861",

    ste_name: "NH",
  },
  {
    zip_code: "4109",

    ste_name: "ME",
  },
  {
    zip_code: "4239",

    ste_name: "ME",
  },
  {
    zip_code: "4360",

    ste_name: "ME",
  },
  {
    zip_code: "4363",

    ste_name: "ME",
  },
  {
    zip_code: "4429",

    ste_name: "ME",
  },
  {
    zip_code: "4474",

    ste_name: "ME",
  },
  {
    zip_code: "4541",

    ste_name: "ME",
  },
  {
    zip_code: "4562",

    ste_name: "ME",
  },
  {
    zip_code: "4635",

    ste_name: "ME",
  },
  {
    zip_code: "4774",

    ste_name: "ME",
  },
  {
    zip_code: "4848",

    ste_name: "ME",
  },
  {
    zip_code: "4925",

    ste_name: "ME",
  },
  {
    zip_code: "4974",

    ste_name: "ME",
  },
  {
    zip_code: "5083",

    ste_name: "VT",
  },
  {
    zip_code: "5143",

    ste_name: "VT",
  },
  {
    zip_code: "5155",

    ste_name: "VT",
  },
  {
    zip_code: "5450",

    ste_name: "VT",
  },
  {
    zip_code: "5465",

    ste_name: "VT",
  },
  {
    zip_code: "5482",

    ste_name: "VT",
  },
  {
    zip_code: "5656",

    ste_name: "VT",
  },
  {
    zip_code: "5673",

    ste_name: "VT",
  },
  {
    zip_code: "5829",

    ste_name: "VT",
  },
  {
    zip_code: "5832",

    ste_name: "VT",
  },
  {
    zip_code: "5841",

    ste_name: "VT",
  },
  {
    zip_code: "5874",

    ste_name: "VT",
  },
  {
    zip_code: "6033",

    ste_name: "CT",
  },
  {
    zip_code: "6057",

    ste_name: "CT",
  },
  {
    zip_code: "6106",

    ste_name: "CT",
  },
  {
    zip_code: "6247",

    ste_name: "CT",
  },
  {
    zip_code: "6248",

    ste_name: "CT",
  },
  {
    zip_code: "6250",

    ste_name: "CT",
  },
  {
    zip_code: "6264",

    ste_name: "CT",
  },
  {
    zip_code: "6282",

    ste_name: "CT",
  },
  {
    zip_code: "6376",

    ste_name: "CT",
  },
  {
    zip_code: "6415",

    ste_name: "CT",
  },
  {
    zip_code: "6418",

    ste_name: "CT",
  },
  {
    zip_code: "6470",

    ste_name: "CT",
  },
  {
    zip_code: "6903",

    ste_name: "CT",
  },
  {
    zip_code: "7020",

    ste_name: "NJ",
  },
  {
    zip_code: "7632",

    ste_name: "NJ",
  },
  {
    zip_code: "7738",

    ste_name: "NJ",
  },
  {
    zip_code: "7849",

    ste_name: "NJ",
  },
  {
    zip_code: "7850",

    ste_name: "NJ",
  },
  {
    zip_code: "7874",

    ste_name: "NJ",
  },
  {
    zip_code: "7881",

    ste_name: "NJ",
  },
  {
    zip_code: "7930",

    ste_name: "NJ",
  },
  {
    zip_code: "7950",

    ste_name: "NJ",
  },
  {
    zip_code: "8026",

    ste_name: "NJ",
  },
  {
    zip_code: "8055",

    ste_name: "NJ",
  },
  {
    zip_code: "8062",

    ste_name: "NJ",
  },
  {
    zip_code: "8069",

    ste_name: "NJ",
  },
  {
    zip_code: "8073",

    ste_name: "NJ",
  },
  {
    zip_code: "8106",

    ste_name: "NJ",
  },
  {
    zip_code: "8205",

    ste_name: "NJ",
  },
  {
    zip_code: "8242",

    ste_name: "NJ",
  },
  {
    zip_code: "8330",

    ste_name: "NJ",
  },
  {
    zip_code: "8402",

    ste_name: "NJ",
  },
  {
    zip_code: "8810",

    ste_name: "NJ",
  },
  {
    zip_code: "10009",

    ste_name: "NY",
  },
  {
    zip_code: "10111",

    ste_name: "NY",
  },
  {
    zip_code: "10302",

    ste_name: "NY",
  },
  {
    zip_code: "10464",

    ste_name: "NY",
  },
  {
    zip_code: "10466",

    ste_name: "NY",
  },
  {
    zip_code: "10471",

    ste_name: "NY",
  },
  {
    zip_code: "10549",

    ste_name: "NY",
  },
  {
    zip_code: "10567",

    ste_name: "NY",
  },
  {
    zip_code: "10606",

    ste_name: "NY",
  },
  {
    zip_code: "10952",

    ste_name: "NY",
  },
  {
    zip_code: "10954",

    ste_name: "NY",
  },
  {
    zip_code: "10974",

    ste_name: "NY",
  },
  {
    zip_code: "10977",

    ste_name: "NY",
  },
  {
    zip_code: "11101",

    ste_name: "NY",
  },
  {
    zip_code: "11216",

    ste_name: "NY",
  },
  {
    zip_code: "11236",

    ste_name: "NY",
  },
  {
    zip_code: "11360",

    ste_name: "NY",
  },
  {
    zip_code: "11361",

    ste_name: "NY",
  },
  {
    zip_code: "11417",

    ste_name: "NY",
  },
  {
    zip_code: "11507",

    ste_name: "NY",
  },
  {
    zip_code: "11518",

    ste_name: "NY",
  },
  {
    zip_code: "11729",

    ste_name: "NY",
  },
  {
    zip_code: "11733",

    ste_name: "NY",
  },
  {
    zip_code: "11788",

    ste_name: "NY",
  },
  {
    zip_code: "11933",

    ste_name: "NY",
  },
  {
    zip_code: "11948",

    ste_name: "NY",
  },
  {
    zip_code: "11955",

    ste_name: "NY",
  },
  {
    zip_code: "12037",

    ste_name: "NY",
  },
  {
    zip_code: "12062",

    ste_name: "NY",
  },
  {
    zip_code: "12066",

    ste_name: "NY",
  },
  {
    zip_code: "12077",

    ste_name: "NY",
  },
  {
    zip_code: "12083",

    ste_name: "NY",
  },
  {
    zip_code: "12087",

    ste_name: "NY",
  },
  {
    zip_code: "12130",

    ste_name: "NY",
  },
  {
    zip_code: "12177",

    ste_name: "NY",
  },
  {
    zip_code: "12198",

    ste_name: "NY",
  },
  {
    zip_code: "12406",

    ste_name: "NY",
  },
  {
    zip_code: "12414",

    ste_name: "NY",
  },
  {
    zip_code: "12428",

    ste_name: "NY",
  },
  {
    zip_code: "12451",

    ste_name: "NY",
  },
  {
    zip_code: "12518",

    ste_name: "NY",
  },
  {
    zip_code: "12553",

    ste_name: "NY",
  },
  {
    zip_code: "12719",

    ste_name: "NY",
  },
  {
    zip_code: "12778",

    ste_name: "NY",
  },
  {
    zip_code: "12783",

    ste_name: "NY",
  },
  {
    zip_code: "12819",

    ste_name: "NY",
  },
  {
    zip_code: "12883",

    ste_name: "NY",
  },
  {
    zip_code: "12887",

    ste_name: "NY",
  },
  {
    zip_code: "12964",

    ste_name: "NY",
  },
  {
    zip_code: "12974",

    ste_name: "NY",
  },
  {
    zip_code: "13029",

    ste_name: "NY",
  },
  {
    zip_code: "13030",

    ste_name: "NY",
  },
  {
    zip_code: "13041",

    ste_name: "NY",
  },
  {
    zip_code: "13057",

    ste_name: "NY",
  },
  {
    zip_code: "13147",

    ste_name: "NY",
  },
  {
    zip_code: "13165",

    ste_name: "NY",
  },
  {
    zip_code: "13203",

    ste_name: "NY",
  },
  {
    zip_code: "13301",

    ste_name: "NY",
  },
  {
    zip_code: "13340",

    ste_name: "NY",
  },
  {
    zip_code: "13368",

    ste_name: "NY",
  },
  {
    zip_code: "13415",

    ste_name: "NY",
  },
  {
    zip_code: "13651",

    ste_name: "NY",
  },
  {
    zip_code: "13757",

    ste_name: "NY",
  },
  {
    zip_code: "13790",

    ste_name: "NY",
  },
  {
    zip_code: "13806",

    ste_name: "NY",
  },
  {
    zip_code: "13832",

    ste_name: "NY",
  },
  {
    zip_code: "14006",

    ste_name: "NY",
  },
  {
    zip_code: "14174",

    ste_name: "NY",
  },
  {
    zip_code: "14505",

    ste_name: "NY",
  },
  {
    zip_code: "14521",

    ste_name: "NY",
  },
  {
    zip_code: "14585",

    ste_name: "NY",
  },
  {
    zip_code: "14606",

    ste_name: "NY",
  },
  {
    zip_code: "14733",

    ste_name: "NY",
  },
  {
    zip_code: "14742",

    ste_name: "NY",
  },
  {
    zip_code: "14752",

    ste_name: "NY",
  },
  {
    zip_code: "14775",

    ste_name: "NY",
  },
  {
    zip_code: "14805",

    ste_name: "NY",
  },
  {
    zip_code: "14860",

    ste_name: "NY",
  },
  {
    zip_code: "14878",

    ste_name: "NY",
  },
  {
    zip_code: "14893",

    ste_name: "NY",
  },
  {
    zip_code: "15005",

    ste_name: "PA",
  },
  {
    zip_code: "15018",

    ste_name: "PA",
  },
  {
    zip_code: "15046",

    ste_name: "PA",
  },
  {
    zip_code: "15051",

    ste_name: "PA",
  },
  {
    zip_code: "15145",

    ste_name: "PA",
  },
  {
    zip_code: "15225",

    ste_name: "PA",
  },
  {
    zip_code: "15422",

    ste_name: "PA",
  },
  {
    zip_code: "15443",

    ste_name: "PA",
  },
  {
    zip_code: "15473",

    ste_name: "PA",
  },
  {
    zip_code: "15547",

    ste_name: "PA",
  },
  {
    zip_code: "15616",

    ste_name: "PA",
  },
  {
    zip_code: "15696",

    ste_name: "PA",
  },
  {
    zip_code: "15710",

    ste_name: "PA",
  },
  {
    zip_code: "15744",

    ste_name: "PA",
  },
  {
    zip_code: "15767",

    ste_name: "PA",
  },
  {
    zip_code: "15861",

    ste_name: "PA",
  },
  {
    zip_code: "15901",

    ste_name: "PA",
  },
  {
    zip_code: "15922",

    ste_name: "PA",
  },
  {
    zip_code: "16001",

    ste_name: "PA",
  },
  {
    zip_code: "16020",

    ste_name: "PA",
  },
  {
    zip_code: "16050",

    ste_name: "PA",
  },
  {
    zip_code: "16240",

    ste_name: "PA",
  },
  {
    zip_code: "16245",

    ste_name: "PA",
  },
  {
    zip_code: "16440",

    ste_name: "PA",
  },
  {
    zip_code: "16631",

    ste_name: "PA",
  },
  {
    zip_code: "16633",

    ste_name: "PA",
  },
  {
    zip_code: "16650",

    ste_name: "PA",
  },
  {
    zip_code: "16724",

    ste_name: "PA",
  },
  {
    zip_code: "16844",

    ste_name: "PA",
  },
  {
    zip_code: "16845",

    ste_name: "PA",
  },
  {
    zip_code: "16912",

    ste_name: "PA",
  },
  {
    zip_code: "16927",

    ste_name: "PA",
  },
  {
    zip_code: "17052",

    ste_name: "PA",
  },
  {
    zip_code: "17098",

    ste_name: "PA",
  },
  {
    zip_code: "17223",

    ste_name: "PA",
  },
  {
    zip_code: "17233",

    ste_name: "PA",
  },
  {
    zip_code: "17340",

    ste_name: "PA",
  },
  {
    zip_code: "17353",

    ste_name: "PA",
  },
  {
    zip_code: "17550",

    ste_name: "PA",
  },
  {
    zip_code: "17754",

    ste_name: "PA",
  },
  {
    zip_code: "17837",

    ste_name: "PA",
  },
  {
    zip_code: "17860",

    ste_name: "PA",
  },
  {
    zip_code: "17872",

    ste_name: "PA",
  },
  {
    zip_code: "17929",

    ste_name: "PA",
  },
  {
    zip_code: "17967",

    ste_name: "PA",
  },
  {
    zip_code: "18051",

    ste_name: "PA",
  },
  {
    zip_code: "18355",

    ste_name: "PA",
  },
  {
    zip_code: "18413",

    ste_name: "PA",
  },
  {
    zip_code: "18447",

    ste_name: "PA",
  },
  {
    zip_code: "18451",

    ste_name: "PA",
  },
  {
    zip_code: "18810",

    ste_name: "PA",
  },
  {
    zip_code: "18923",

    ste_name: "PA",
  },
  {
    zip_code: "19002",

    ste_name: "PA",
  },
  {
    zip_code: "19029",

    ste_name: "PA",
  },
  {
    zip_code: "19034",

    ste_name: "PA",
  },
  {
    zip_code: "19145",

    ste_name: "PA",
  },
  {
    zip_code: "19310",

    ste_name: "PA",
  },
  {
    zip_code: "19530",

    ste_name: "PA",
  },
  {
    zip_code: "19951",

    ste_name: "DE",
  },
  {
    zip_code: "20002",

    ste_name: "DC",
  },
  {
    zip_code: "20052",

    ste_name: "DC",
  },
  {
    zip_code: "20143",

    ste_name: "VA",
  },
  {
    zip_code: "20169",

    ste_name: "VA",
  },
  {
    zip_code: "20198",

    ste_name: "VA",
  },
  {
    zip_code: "20204",

    ste_name: "DC",
  },
  {
    zip_code: "20660",

    ste_name: "MD",
  },
  {
    zip_code: "20674",

    ste_name: "MD",
  },
  {
    zip_code: "20680",

    ste_name: "MD",
  },
  {
    zip_code: "20686",

    ste_name: "MD",
  },
  {
    zip_code: "20689",

    ste_name: "MD",
  },
  {
    zip_code: "20715",

    ste_name: "MD",
  },
  {
    zip_code: "20842",

    ste_name: "MD",
  },
  {
    zip_code: "20882",

    ste_name: "MD",
  },
  {
    zip_code: "21014",

    ste_name: "MD",
  },
  {
    zip_code: "21031",

    ste_name: "MD",
  },
  {
    zip_code: "21042",

    ste_name: "MD",
  },
  {
    zip_code: "21056",

    ste_name: "MD",
  },
  {
    zip_code: "21162",

    ste_name: "MD",
  },
  {
    zip_code: "21202",

    ste_name: "MD",
  },
  {
    zip_code: "21205",

    ste_name: "MD",
  },
  {
    zip_code: "21659",

    ste_name: "MD",
  },
  {
    zip_code: "21701",

    ste_name: "MD",
  },
  {
    zip_code: "21781",

    ste_name: "MD",
  },
  {
    zip_code: "21837",

    ste_name: "MD",
  },
  {
    zip_code: "21917",

    ste_name: "MD",
  },
  {
    zip_code: "22101",

    ste_name: "VA",
  },
  {
    zip_code: "22301",

    ste_name: "VA",
  },
  {
    zip_code: "22504",

    ste_name: "VA",
  },
  {
    zip_code: "22627",

    ste_name: "VA",
  },
  {
    zip_code: "22645",

    ste_name: "VA",
  },
  {
    zip_code: "22952",

    ste_name: "VA",
  },
  {
    zip_code: "23115",

    ste_name: "VA",
  },
  {
    zip_code: "23160",

    ste_name: "VA",
  },
  {
    zip_code: "23177",

    ste_name: "VA",
  },
  {
    zip_code: "23180",

    ste_name: "VA",
  },
  {
    zip_code: "23192",

    ste_name: "VA",
  },
  {
    zip_code: "23227",

    ste_name: "VA",
  },
  {
    zip_code: "23234",

    ste_name: "VA",
  },
  {
    zip_code: "23236",

    ste_name: "VA",
  },
  {
    zip_code: "23310",

    ste_name: "VA",
  },
  {
    zip_code: "23347",

    ste_name: "VA",
  },
  {
    zip_code: "23488",

    ste_name: "VA",
  },
  {
    zip_code: "23505",

    ste_name: "VA",
  },
  {
    zip_code: "23507",

    ste_name: "VA",
  },
  {
    zip_code: "23801",

    ste_name: "VA",
  },
  {
    zip_code: "23851",

    ste_name: "VA",
  },
  {
    zip_code: "23909",

    ste_name: "VA",
  },
  {
    zip_code: "23954",

    ste_name: "VA",
  },
  {
    zip_code: "23962",

    ste_name: "VA",
  },
  {
    zip_code: "24078",

    ste_name: "VA",
  },
  {
    zip_code: "24211",

    ste_name: "VA",
  },
  {
    zip_code: "24256",

    ste_name: "VA",
  },
  {
    zip_code: "24263",

    ste_name: "VA",
  },
  {
    zip_code: "24413",

    ste_name: "VA",
  },
  {
    zip_code: "24440",

    ste_name: "VA",
  },
  {
    zip_code: "24460",

    ste_name: "VA",
  },
  {
    zip_code: "24465",

    ste_name: "VA",
  },
  {
    zip_code: "24523",

    ste_name: "VA",
  },
  {
    zip_code: "24578",

    ste_name: "VA",
  },
  {
    zip_code: "24588",

    ste_name: "VA",
  },
  {
    zip_code: "24606",

    ste_name: "VA",
  },
  {
    zip_code: "25033",

    ste_name: "WV",
  },
  {
    zip_code: "25183",

    ste_name: "WV",
  },
  {
    zip_code: "25206",

    ste_name: "WV",
  },
  {
    zip_code: "25305",

    ste_name: "WV",
  },
  {
    zip_code: "25315",

    ste_name: "WV",
  },
  {
    zip_code: "25446",

    ste_name: "WV",
  },
  {
    zip_code: "25503",

    ste_name: "WV",
  },
  {
    zip_code: "25690",

    ste_name: "WV",
  },
  {
    zip_code: "25811",

    ste_name: "WV",
  },
  {
    zip_code: "25825",

    ste_name: "WV",
  },
  {
    zip_code: "25880",

    ste_name: "WV",
  },
  {
    zip_code: "25908",

    ste_name: "WV",
  },
  {
    zip_code: "26138",

    ste_name: "WV",
  },
  {
    zip_code: "26202",

    ste_name: "WV",
  },
  {
    zip_code: "26278",

    ste_name: "WV",
  },
  {
    zip_code: "26542",

    ste_name: "WV",
  },
  {
    zip_code: "26572",

    ste_name: "WV",
  },
  {
    zip_code: "26575",

    ste_name: "WV",
  },
  {
    zip_code: "26586",

    ste_name: "WV",
  },
  {
    zip_code: "26660",

    ste_name: "WV",
  },
  {
    zip_code: "26678",

    ste_name: "WV",
  },
  {
    zip_code: "27401",

    ste_name: "NC",
  },
  {
    zip_code: "27522",

    ste_name: "NC",
  },
  {
    zip_code: "27556",

    ste_name: "NC",
  },
  {
    zip_code: "27607",

    ste_name: "NC",
  },
  {
    zip_code: "27617",

    ste_name: "NC",
  },
  {
    zip_code: "27824",

    ste_name: "NC",
  },
  {
    zip_code: "27852",

    ste_name: "NC",
  },
  {
    zip_code: "27980",

    ste_name: "NC",
  },
  {
    zip_code: "28129",

    ste_name: "NC",
  },
  {
    zip_code: "28174",

    ste_name: "NC",
  },
  {
    zip_code: "28208",

    ste_name: "NC",
  },
  {
    zip_code: "28211",

    ste_name: "NC",
  },
  {
    zip_code: "28349",

    ste_name: "NC",
  },
  {
    zip_code: "28367",

    ste_name: "NC",
  },
  {
    zip_code: "28383",

    ste_name: "NC",
  },
  {
    zip_code: "28458",

    ste_name: "NC",
  },
  {
    zip_code: "28515",

    ste_name: "NC",
  },
  {
    zip_code: "28516",

    ste_name: "NC",
  },
  {
    zip_code: "28524",

    ste_name: "NC",
  },
  {
    zip_code: "28529",

    ste_name: "NC",
  },
  {
    zip_code: "28625",

    ste_name: "NC",
  },
  {
    zip_code: "28712",

    ste_name: "NC",
  },
  {
    zip_code: "28717",

    ste_name: "NC",
  },
  {
    zip_code: "28756",

    ste_name: "NC",
  },
  {
    zip_code: "28775",

    ste_name: "NC",
  },
  {
    zip_code: "28779",

    ste_name: "NC",
  },
  {
    zip_code: "28789",

    ste_name: "NC",
  },
  {
    zip_code: "28801",

    ste_name: "NC",
  },
  {
    zip_code: "28906",

    ste_name: "NC",
  },
  {
    zip_code: "29070",

    ste_name: "SC",
  },
  {
    zip_code: "29111",

    ste_name: "SC",
  },
  {
    zip_code: "29631",

    ste_name: "SC",
  },
  {
    zip_code: "29653",

    ste_name: "SC",
  },
  {
    zip_code: "29670",

    ste_name: "SC",
  },
  {
    zip_code: "29683",

    ste_name: "SC",
  },
  {
    zip_code: "29685",

    ste_name: "SC",
  },
  {
    zip_code: "29692",

    ste_name: "SC",
  },
  {
    zip_code: "29708",

    ste_name: "SC",
  },
  {
    zip_code: "29826",

    ste_name: "SC",
  },
  {
    zip_code: "29841",

    ste_name: "SC",
  },
  {
    zip_code: "29929",

    ste_name: "SC",
  },
  {
    zip_code: "30034",

    ste_name: "GA",
  },
  {
    zip_code: "30046",

    ste_name: "GA",
  },
  {
    zip_code: "30056",

    ste_name: "GA",
  },
  {
    zip_code: "30104",

    ste_name: "GA",
  },
  {
    zip_code: "30125",

    ste_name: "GA",
  },
  {
    zip_code: "30135",

    ste_name: "GA",
  },
  {
    zip_code: "30176",

    ste_name: "GA",
  },
  {
    zip_code: "30185",

    ste_name: "GA",
  },
  {
    zip_code: "30315",

    ste_name: "GA",
  },
  {
    zip_code: "30332",

    ste_name: "GA",
  },
  {
    zip_code: "30436",

    ste_name: "GA",
  },
  {
    zip_code: "30519",

    ste_name: "GA",
  },
  {
    zip_code: "30529",

    ste_name: "GA",
  },
  {
    zip_code: "30633",

    ste_name: "GA",
  },
  {
    zip_code: "30662",

    ste_name: "GA",
  },
  {
    zip_code: "30673",

    ste_name: "GA",
  },
  {
    zip_code: "30725",

    ste_name: "GA",
  },
  {
    zip_code: "30730",

    ste_name: "GA",
  },
  {
    zip_code: "30818",

    ste_name: "GA",
  },
  {
    zip_code: "30821",

    ste_name: "GA",
  },
  {
    zip_code: "31006",

    ste_name: "GA",
  },
  {
    zip_code: "31024",

    ste_name: "GA",
  },
  {
    zip_code: "31054",

    ste_name: "GA",
  },
  {
    zip_code: "31316",

    ste_name: "GA",
  },
  {
    zip_code: "31411",

    ste_name: "GA",
  },
  {
    zip_code: "31518",

    ste_name: "GA",
  },
  {
    zip_code: "31527",

    ste_name: "GA",
  },
  {
    zip_code: "31784",

    ste_name: "GA",
  },
  {
    zip_code: "31903",

    ste_name: "GA",
  },
  {
    zip_code: "32038",

    ste_name: "FL",
  },
  {
    zip_code: "32081",

    ste_name: "FL",
  },
  {
    zip_code: "32133",

    ste_name: "FL",
  },
  {
    zip_code: "32220",

    ste_name: "FL",
  },
  {
    zip_code: "32227",

    ste_name: "FL",
  },
  {
    zip_code: "32257",

    ste_name: "FL",
  },
  {
    zip_code: "32305",

    ste_name: "FL",
  },
  {
    zip_code: "32356",

    ste_name: "FL",
  },
  {
    zip_code: "32399",

    ste_name: "FL",
  },
  {
    zip_code: "32424",

    ste_name: "FL",
  },
  {
    zip_code: "32536",

    ste_name: "FL",
  },
  {
    zip_code: "32547",

    ste_name: "FL",
  },
  {
    zip_code: "32708",

    ste_name: "FL",
  },
  {
    zip_code: "32754",

    ste_name: "FL",
  },
  {
    zip_code: "32763",

    ste_name: "FL",
  },
  {
    zip_code: "32805",

    ste_name: "FL",
  },
  {
    zip_code: "32826",

    ste_name: "FL",
  },
  {
    zip_code: "32833",

    ste_name: "FL",
  },
  {
    zip_code: "32904",

    ste_name: "FL",
  },
  {
    zip_code: "33066",

    ste_name: "FL",
  },
  {
    zip_code: "33157",

    ste_name: "FL",
  },
  {
    zip_code: "33175",

    ste_name: "FL",
  },
  {
    zip_code: "33178",

    ste_name: "FL",
  },
  {
    zip_code: "33314",

    ste_name: "FL",
  },
  {
    zip_code: "33319",

    ste_name: "FL",
  },
  {
    zip_code: "33322",

    ste_name: "FL",
  },
  {
    zip_code: "33403",

    ste_name: "FL",
  },
  {
    zip_code: "33441",

    ste_name: "FL",
  },
  {
    zip_code: "33493",

    ste_name: "FL",
  },
  {
    zip_code: "33613",

    ste_name: "FL",
  },
  {
    zip_code: "33620",

    ste_name: "FL",
  },
  {
    zip_code: "33855",

    ste_name: "FL",
  },
  {
    zip_code: "33908",

    ste_name: "FL",
  },
  {
    zip_code: "33973",

    ste_name: "FL",
  },
  {
    zip_code: "33976",

    ste_name: "FL",
  },
  {
    zip_code: "34759",

    ste_name: "FL",
  },
  {
    zip_code: "35010",

    ste_name: "AL",
  },
  {
    zip_code: "35049",

    ste_name: "AL",
  },
  {
    zip_code: "35136",

    ste_name: "AL",
  },
  {
    zip_code: "35143",

    ste_name: "AL",
  },
  {
    zip_code: "35187",

    ste_name: "AL",
  },
  {
    zip_code: "35216",

    ste_name: "AL",
  },
  {
    zip_code: "35229",

    ste_name: "AL",
  },
  {
    zip_code: "35565",

    ste_name: "AL",
  },
  {
    zip_code: "35576",

    ste_name: "AL",
  },
  {
    zip_code: "35603",

    ste_name: "AL",
  },
  {
    zip_code: "35754",

    ste_name: "AL",
  },
  {
    zip_code: "35755",

    ste_name: "AL",
  },
  {
    zip_code: "35906",

    ste_name: "AL",
  },
  {
    zip_code: "35979",

    ste_name: "AL",
  },
  {
    zip_code: "35987",

    ste_name: "AL",
  },
  {
    zip_code: "36105",

    ste_name: "AL",
  },
  {
    zip_code: "36482",

    ste_name: "AL",
  },
  {
    zip_code: "36585",

    ste_name: "AL",
  },
  {
    zip_code: "36602",

    ste_name: "AL",
  },
  {
    zip_code: "36740",

    ste_name: "AL",
  },
  {
    zip_code: "36744",

    ste_name: "AL",
  },
  {
    zip_code: "36879",

    ste_name: "AL",
  },
  {
    zip_code: "36901",

    ste_name: "AL",
  },
  {
    zip_code: "37012",

    ste_name: "TN",
  },
  {
    zip_code: "37034",

    ste_name: "TN",
  },
  {
    zip_code: "37115",

    ste_name: "TN",
  },
  {
    zip_code: "37132",

    ste_name: "TN",
  },
  {
    zip_code: "37135",

    ste_name: "TN",
  },
  {
    zip_code: "37143",

    ste_name: "TN",
  },
  {
    zip_code: "37175",

    ste_name: "TN",
  },
  {
    zip_code: "37341",

    ste_name: "TN",
  },
  {
    zip_code: "37380",

    ste_name: "TN",
  },
  {
    zip_code: "37680",

    ste_name: "TN",
  },
  {
    zip_code: "37727",

    ste_name: "TN",
  },
  {
    zip_code: "37729",

    ste_name: "TN",
  },
  {
    zip_code: "37766",

    ste_name: "TN",
  },
  {
    zip_code: "38057",

    ste_name: "TN",
  },
  {
    zip_code: "38115",

    ste_name: "TN",
  },
  {
    zip_code: "38116",

    ste_name: "TN",
  },
  {
    zip_code: "38317",

    ste_name: "TN",
  },
  {
    zip_code: "38454",

    ste_name: "TN",
  },
  {
    zip_code: "38478",

    ste_name: "TN",
  },
  {
    zip_code: "38545",

    ste_name: "TN",
  },
  {
    zip_code: "38578",

    ste_name: "TN",
  },
  {
    zip_code: "38685",

    ste_name: "MS",
  },
  {
    zip_code: "39145",

    ste_name: "MS",
  },
  {
    zip_code: "39146",

    ste_name: "MS",
  },
  {
    zip_code: "39323",

    ste_name: "MS",
  },
  {
    zip_code: "39326",

    ste_name: "MS",
  },
  {
    zip_code: "39364",

    ste_name: "MS",
  },
  {
    zip_code: "39421",

    ste_name: "MS",
  },
  {
    zip_code: "39455",

    ste_name: "MS",
  },
  {
    zip_code: "39563",

    ste_name: "MS",
  },
  {
    zip_code: "39870",

    ste_name: "GA",
  },
  {
    zip_code: "40047",

    ste_name: "KY",
  },
  {
    zip_code: "40118",

    ste_name: "KY",
  },
  {
    zip_code: "40208",

    ste_name: "KY",
  },
  {
    zip_code: "40218",

    ste_name: "KY",
  },
  {
    zip_code: "40372",

    ste_name: "KY",
  },
  {
    zip_code: "40516",

    ste_name: "KY",
  },
  {
    zip_code: "40801",

    ste_name: "KY",
  },
  {
    zip_code: "40815",

    ste_name: "KY",
  },
  {
    zip_code: "40831",

    ste_name: "KY",
  },
  {
    zip_code: "40868",

    ste_name: "KY",
  },
  {
    zip_code: "40935",

    ste_name: "KY",
  },
  {
    zip_code: "41017",

    ste_name: "KY",
  },
  {
    zip_code: "41564",

    ste_name: "KY",
  },
  {
    zip_code: "41745",

    ste_name: "KY",
  },
  {
    zip_code: "41833",

    ste_name: "KY",
  },
  {
    zip_code: "41849",

    ste_name: "KY",
  },
  {
    zip_code: "42082",

    ste_name: "KY",
  },
  {
    zip_code: "42123",

    ste_name: "KY",
  },
  {
    zip_code: "42127",

    ste_name: "KY",
  },
  {
    zip_code: "42153",

    ste_name: "KY",
  },
  {
    zip_code: "42323",

    ste_name: "KY",
  },
  {
    zip_code: "42332",

    ste_name: "KY",
  },
  {
    zip_code: "42369",

    ste_name: "KY",
  },
  {
    zip_code: "42406",

    ste_name: "KY",
  },
  {
    zip_code: "42413",

    ste_name: "KY",
  },
  {
    zip_code: "42518",

    ste_name: "KY",
  },
  {
    zip_code: "42653",

    ste_name: "KY",
  },
  {
    zip_code: "42762",

    ste_name: "KY",
  },
  {
    zip_code: "42788",

    ste_name: "KY",
  },
  {
    zip_code: "43031",

    ste_name: "OH",
  },
  {
    zip_code: "43068",

    ste_name: "OH",
  },
  {
    zip_code: "43214",

    ste_name: "OH",
  },
  {
    zip_code: "43215",

    ste_name: "OH",
  },
  {
    zip_code: "43330",

    ste_name: "OH",
  },
  {
    zip_code: "43406",

    ste_name: "OH",
  },
  {
    zip_code: "43438",

    ste_name: "OH",
  },
  {
    zip_code: "43506",

    ste_name: "OH",
  },
  {
    zip_code: "43542",

    ste_name: "OH",
  },
  {
    zip_code: "43555",

    ste_name: "OH",
  },
  {
    zip_code: "43615",

    ste_name: "OH",
  },
  {
    zip_code: "43733",

    ste_name: "OH",
  },
  {
    zip_code: "43793",

    ste_name: "OH",
  },
  {
    zip_code: "43830",

    ste_name: "OH",
  },
  {
    zip_code: "44056",

    ste_name: "OH",
  },
  {
    zip_code: "44095",

    ste_name: "OH",
  },
  {
    zip_code: "44116",

    ste_name: "OH",
  },
  {
    zip_code: "44132",

    ste_name: "OH",
  },
  {
    zip_code: "44270",

    ste_name: "OH",
  },
  {
    zip_code: "44425",

    ste_name: "OH",
  },
  {
    zip_code: "44446",

    ste_name: "OH",
  },
  {
    zip_code: "44485",

    ste_name: "OH",
  },
  {
    zip_code: "44817",

    ste_name: "OH",
  },
  {
    zip_code: "44864",

    ste_name: "OH",
  },
  {
    zip_code: "45052",

    ste_name: "OH",
  },
  {
    zip_code: "45101",

    ste_name: "OH",
  },
  {
    zip_code: "45135",

    ste_name: "OH",
  },
  {
    zip_code: "45177",

    ste_name: "OH",
  },
  {
    zip_code: "45204",

    ste_name: "OH",
  },
  {
    zip_code: "45306",

    ste_name: "OH",
  },
  {
    zip_code: "45321",

    ste_name: "OH",
  },
  {
    zip_code: "45348",

    ste_name: "OH",
  },
  {
    zip_code: "45368",

    ste_name: "OH",
  },
  {
    zip_code: "45377",

    ste_name: "OH",
  },
  {
    zip_code: "45378",

    ste_name: "OH",
  },
  {
    zip_code: "45503",

    ste_name: "OH",
  },
  {
    zip_code: "45692",

    ste_name: "OH",
  },
  {
    zip_code: "45714",

    ste_name: "OH",
  },
  {
    zip_code: "45804",

    ste_name: "OH",
  },
  {
    zip_code: "46017",

    ste_name: "IN",
  },
  {
    zip_code: "46048",

    ste_name: "IN",
  },
  {
    zip_code: "46050",

    ste_name: "IN",
  },
  {
    zip_code: "46052",

    ste_name: "IN",
  },
  {
    zip_code: "46239",

    ste_name: "IN",
  },
  {
    zip_code: "46322",

    ste_name: "IN",
  },
  {
    zip_code: "46374",

    ste_name: "IN",
  },
  {
    zip_code: "46502",

    ste_name: "IN",
  },
  {
    zip_code: "46537",

    ste_name: "IN",
  },
  {
    zip_code: "46563",

    ste_name: "IN",
  },
  {
    zip_code: "46701",

    ste_name: "IN",
  },
  {
    zip_code: "46714",

    ste_name: "IN",
  },
  {
    zip_code: "46750",

    ste_name: "IN",
  },
  {
    zip_code: "46930",

    ste_name: "IN",
  },
  {
    zip_code: "47118",

    ste_name: "IN",
  },
  {
    zip_code: "47129",

    ste_name: "IN",
  },
  {
    zip_code: "47175",

    ste_name: "IN",
  },
  {
    zip_code: "47424",

    ste_name: "IN",
  },
  {
    zip_code: "47523",

    ste_name: "IN",
  },
  {
    zip_code: "47562",

    ste_name: "IN",
  },
  {
    zip_code: "47917",

    ste_name: "IN",
  },
  {
    zip_code: "47925",

    ste_name: "IN",
  },
  {
    zip_code: "47933",

    ste_name: "IN",
  },
  {
    zip_code: "47940",

    ste_name: "IN",
  },
  {
    zip_code: "48084",

    ste_name: "MI",
  },
  {
    zip_code: "48130",

    ste_name: "MI",
  },
  {
    zip_code: "48180",

    ste_name: "MI",
  },
  {
    zip_code: "48208",

    ste_name: "MI",
  },
  {
    zip_code: "48417",

    ste_name: "MI",
  },
  {
    zip_code: "48421",

    ste_name: "MI",
  },
  {
    zip_code: "48507",

    ste_name: "MI",
  },
  {
    zip_code: "48632",

    ste_name: "MI",
  },
  {
    zip_code: "48647",

    ste_name: "MI",
  },
  {
    zip_code: "48657",

    ste_name: "MI",
  },
  {
    zip_code: "48727",

    ste_name: "MI",
  },
  {
    zip_code: "48750",

    ste_name: "MI",
  },
  {
    zip_code: "48840",

    ste_name: "MI",
  },
  {
    zip_code: "48853",

    ste_name: "MI",
  },
  {
    zip_code: "48861",

    ste_name: "MI",
  },
  {
    zip_code: "49002",

    ste_name: "MI",
  },
  {
    zip_code: "49032",

    ste_name: "MI",
  },
  {
    zip_code: "49042",

    ste_name: "MI",
  },
  {
    zip_code: "49070",

    ste_name: "MI",
  },
  {
    zip_code: "49117",

    ste_name: "MI",
  },
  {
    zip_code: "49327",

    ste_name: "MI",
  },
  {
    zip_code: "49452",

    ste_name: "MI",
  },
  {
    zip_code: "49653",

    ste_name: "MI",
  },
  {
    zip_code: "49670",

    ste_name: "MI",
  },
  {
    zip_code: "49688",

    ste_name: "MI",
  },
  {
    zip_code: "49781",

    ste_name: "MI",
  },
  {
    zip_code: "49880",

    ste_name: "MI",
  },
  {
    zip_code: "49963",

    ste_name: "MI",
  },
  {
    zip_code: "50008",

    ste_name: "IA",
  },
  {
    zip_code: "50026",

    ste_name: "IA",
  },
  {
    zip_code: "50066",

    ste_name: "IA",
  },
  {
    zip_code: "50210",

    ste_name: "IA",
  },
  {
    zip_code: "50214",

    ste_name: "IA",
  },
  {
    zip_code: "50222",

    ste_name: "IA",
  },
  {
    zip_code: "50228",

    ste_name: "IA",
  },
  {
    zip_code: "50252",

    ste_name: "IA",
  },
  {
    zip_code: "50454",

    ste_name: "IA",
  },
  {
    zip_code: "50467",

    ste_name: "IA",
  },
  {
    zip_code: "50658",

    ste_name: "IA",
  },
  {
    zip_code: "50702",

    ste_name: "IA",
  },
  {
    zip_code: "50830",

    ste_name: "IA",
  },
  {
    zip_code: "51027",

    ste_name: "IA",
  },
  {
    zip_code: "51030",

    ste_name: "IA",
  },
  {
    zip_code: "51036",

    ste_name: "IA",
  },
  {
    zip_code: "51044",

    ste_name: "IA",
  },
  {
    zip_code: "51201",

    ste_name: "IA",
  },
  {
    zip_code: "51528",

    ste_name: "IA",
  },
  {
    zip_code: "52033",

    ste_name: "IA",
  },
  {
    zip_code: "52042",

    ste_name: "IA",
  },
  {
    zip_code: "52044",

    ste_name: "IA",
  },
  {
    zip_code: "52047",

    ste_name: "IA",
  },
  {
    zip_code: "52207",

    ste_name: "IA",
  },
  {
    zip_code: "52353",

    ste_name: "IA",
  },
  {
    zip_code: "52621",

    ste_name: "IA",
  },
  {
    zip_code: "52658",

    ste_name: "IA",
  },
  {
    zip_code: "53045",

    ste_name: "WI",
  },
  {
    zip_code: "53233",

    ste_name: "WI",
  },
  {
    zip_code: "53582",

    ste_name: "WI",
  },
  {
    zip_code: "53589",

    ste_name: "WI",
  },
  {
    zip_code: "53792",

    ste_name: "WI",
  },
  {
    zip_code: "53925",

    ste_name: "WI",
  },
  {
    zip_code: "53961",

    ste_name: "WI",
  },
  {
    zip_code: "54101",

    ste_name: "WI",
  },
  {
    zip_code: "54103",

    ste_name: "WI",
  },
  {
    zip_code: "54104",

    ste_name: "WI",
  },
  {
    zip_code: "54111",

    ste_name: "WI",
  },
  {
    zip_code: "54120",

    ste_name: "WI",
  },
  {
    zip_code: "54209",

    ste_name: "WI",
  },
  {
    zip_code: "54303",

    ste_name: "WI",
  },
  {
    zip_code: "54470",

    ste_name: "WI",
  },
  {
    zip_code: "54491",

    ste_name: "WI",
  },
  {
    zip_code: "54529",

    ste_name: "WI",
  },
  {
    zip_code: "54603",

    ste_name: "WI",
  },
  {
    zip_code: "54628",

    ste_name: "WI",
  },
  {
    zip_code: "54639",

    ste_name: "WI",
  },
  {
    zip_code: "54748",

    ste_name: "WI",
  },
  {
    zip_code: "54769",

    ste_name: "WI",
  },
  {
    zip_code: "54805",

    ste_name: "WI",
  },
  {
    zip_code: "54950",

    ste_name: "WI",
  },
  {
    zip_code: "55001",

    ste_name: "MN",
  },
  {
    zip_code: "55038",

    ste_name: "MN",
  },
  {
    zip_code: "55049",

    ste_name: "MN",
  },
  {
    zip_code: "55055",

    ste_name: "MN",
  },
  {
    zip_code: "55068",

    ste_name: "MN",
  },
  {
    zip_code: "55075",

    ste_name: "MN",
  },
  {
    zip_code: "55107",

    ste_name: "MN",
  },
  {
    zip_code: "55129",

    ste_name: "MN",
  },
  {
    zip_code: "55398",

    ste_name: "MN",
  },
  {
    zip_code: "55421",

    ste_name: "MN",
  },
  {
    zip_code: "55771",

    ste_name: "MN",
  },
  {
    zip_code: "55932",

    ste_name: "MN",
  },
  {
    zip_code: "55952",

    ste_name: "MN",
  },
  {
    zip_code: "56003",

    ste_name: "MN",
  },
  {
    zip_code: "56014",

    ste_name: "MN",
  },
  {
    zip_code: "56017",

    ste_name: "MN",
  },
  {
    zip_code: "56169",

    ste_name: "MN",
  },
  {
    zip_code: "56207",

    ste_name: "MN",
  },
  {
    zip_code: "56252",

    ste_name: "MN",
  },
  {
    zip_code: "56263",

    ste_name: "MN",
  },
  {
    zip_code: "56349",

    ste_name: "MN",
  },
  {
    zip_code: "56435",

    ste_name: "MN",
  },
  {
    zip_code: "56446",

    ste_name: "MN",
  },
  {
    zip_code: "56543",

    ste_name: "MN",
  },
  {
    zip_code: "56546",

    ste_name: "MN",
  },
  {
    zip_code: "56701",

    ste_name: "MN",
  },
  {
    zip_code: "56721",

    ste_name: "MN",
  },
  {
    zip_code: "57018",

    ste_name: "SD",
  },
  {
    zip_code: "57032",

    ste_name: "SD",
  },
  {
    zip_code: "57038",

    ste_name: "SD",
  },
  {
    zip_code: "57075",

    ste_name: "SD",
  },
  {
    zip_code: "57201",

    ste_name: "SD",
  },
  {
    zip_code: "57313",

    ste_name: "SD",
  },
  {
    zip_code: "57319",

    ste_name: "SD",
  },
  {
    zip_code: "57363",

    ste_name: "SD",
  },
  {
    zip_code: "57364",

    ste_name: "SD",
  },
  {
    zip_code: "57375",

    ste_name: "SD",
  },
  {
    zip_code: "57650",

    ste_name: "SD",
  },
  {
    zip_code: "58072",

    ste_name: "ND",
  },
  {
    zip_code: "58241",

    ste_name: "ND",
  },
  {
    zip_code: "58271",

    ste_name: "ND",
  },
  {
    zip_code: "58346",

    ste_name: "ND",
  },
  {
    zip_code: "58362",

    ste_name: "ND",
  },
  {
    zip_code: "58377",

    ste_name: "ND",
  },
  {
    zip_code: "58379",

    ste_name: "ND",
  },
  {
    zip_code: "58531",

    ste_name: "ND",
  },
  {
    zip_code: "58627",

    ste_name: "ND",
  },
  {
    zip_code: "58718",

    ste_name: "ND",
  },
  {
    zip_code: "58760",

    ste_name: "ND",
  },
  {
    zip_code: "58761",

    ste_name: "ND",
  },
  {
    zip_code: "58776",

    ste_name: "ND",
  },
  {
    zip_code: "59074",

    ste_name: "MT",
  },
  {
    zip_code: "59079",

    ste_name: "MT",
  },
  {
    zip_code: "59222",

    ste_name: "MT",
  },
  {
    zip_code: "59230",

    ste_name: "MT",
  },
  {
    zip_code: "59240",

    ste_name: "MT",
  },
  {
    zip_code: "59333",

    ste_name: "MT",
  },
  {
    zip_code: "59460",

    ste_name: "MT",
  },
  {
    zip_code: "59527",

    ste_name: "MT",
  },
  {
    zip_code: "59736",

    ste_name: "MT",
  },
  {
    zip_code: "59740",

    ste_name: "MT",
  },
  {
    zip_code: "59741",

    ste_name: "MT",
  },
  {
    zip_code: "59761",

    ste_name: "MT",
  },
  {
    zip_code: "59833",

    ste_name: "MT",
  },
  {
    zip_code: "60035",

    ste_name: "IL",
  },
  {
    zip_code: "60040",

    ste_name: "IL",
  },
  {
    zip_code: "60051",

    ste_name: "IL",
  },
  {
    zip_code: "60064",

    ste_name: "IL",
  },
  {
    zip_code: "60089",

    ste_name: "IL",
  },
  {
    zip_code: "60130",

    ste_name: "IL",
  },
  {
    zip_code: "60133",

    ste_name: "IL",
  },
  {
    zip_code: "60137",

    ste_name: "IL",
  },
  {
    zip_code: "60442",

    ste_name: "IL",
  },
  {
    zip_code: "60482",

    ste_name: "IL",
  },
  {
    zip_code: "60805",

    ste_name: "IL",
  },
  {
    zip_code: "60951",

    ste_name: "IL",
  },
  {
    zip_code: "60954",

    ste_name: "IL",
  },
  {
    zip_code: "60960",

    ste_name: "IL",
  },
  {
    zip_code: "60974",

    ste_name: "IL",
  },
  {
    zip_code: "61015",

    ste_name: "IL",
  },
  {
    zip_code: "61201",

    ste_name: "IL",
  },
  {
    zip_code: "61261",

    ste_name: "IL",
  },
  {
    zip_code: "61277",

    ste_name: "IL",
  },
  {
    zip_code: "61315",

    ste_name: "IL",
  },
  {
    zip_code: "61328",

    ste_name: "IL",
  },
  {
    zip_code: "61346",

    ste_name: "IL",
  },
  {
    zip_code: "61360",

    ste_name: "IL",
  },
  {
    zip_code: "61377",

    ste_name: "IL",
  },
  {
    zip_code: "61424",

    ste_name: "IL",
  },
  {
    zip_code: "61431",

    ste_name: "IL",
  },
  {
    zip_code: "61441",

    ste_name: "IL",
  },
  {
    zip_code: "61475",

    ste_name: "IL",
  },
  {
    zip_code: "61486",

    ste_name: "IL",
  },
  {
    zip_code: "61534",

    ste_name: "IL",
  },
  {
    zip_code: "61559",

    ste_name: "IL",
  },
  {
    zip_code: "61751",

    ste_name: "IL",
  },
  {
    zip_code: "61774",

    ste_name: "IL",
  },
  {
    zip_code: "61821",

    ste_name: "IL",
  },
  {
    zip_code: "61920",

    ste_name: "IL",
  },
  {
    zip_code: "62012",

    ste_name: "IL",
  },
  {
    zip_code: "62059",

    ste_name: "IL",
  },
  {
    zip_code: "62080",

    ste_name: "IL",
  },
  {
    zip_code: "62088",

    ste_name: "IL",
  },
  {
    zip_code: "62234",

    ste_name: "IL",
  },
  {
    zip_code: "62274",

    ste_name: "IL",
  },
  {
    zip_code: "62443",

    ste_name: "IL",
  },
  {
    zip_code: "62459",

    ste_name: "IL",
  },
  {
    zip_code: "62462",

    ste_name: "IL",
  },
  {
    zip_code: "62548",

    ste_name: "IL",
  },
  {
    zip_code: "62625",

    ste_name: "IL",
  },
  {
    zip_code: "62650",

    ste_name: "IL",
  },
  {
    zip_code: "62656",

    ste_name: "IL",
  },
  {
    zip_code: "62682",

    ste_name: "IL",
  },
  {
    zip_code: "62818",

    ste_name: "IL",
  },
  {
    zip_code: "62822",

    ste_name: "IL",
  },
  {
    zip_code: "62856",

    ste_name: "IL",
  },
  {
    zip_code: "62876",

    ste_name: "IL",
  },
  {
    zip_code: "62899",

    ste_name: "IL",
  },
  {
    zip_code: "62982",

    ste_name: "IL",
  },
  {
    zip_code: "63014",

    ste_name: "MO",
  },
  {
    zip_code: "63073",

    ste_name: "MO",
  },
  {
    zip_code: "63125",

    ste_name: "MO",
  },
  {
    zip_code: "63141",

    ste_name: "MO",
  },
  {
    zip_code: "63301",

    ste_name: "MO",
  },
  {
    zip_code: "63330",

    ste_name: "MO",
  },
  {
    zip_code: "63359",

    ste_name: "MO",
  },
  {
    zip_code: "63439",

    ste_name: "MO",
  },
  {
    zip_code: "63536",

    ste_name: "MO",
  },
  {
    zip_code: "63559",

    ste_name: "MO",
  },
  {
    zip_code: "63563",

    ste_name: "MO",
  },
  {
    zip_code: "63625",

    ste_name: "MO",
  },
  {
    zip_code: "63956",

    ste_name: "MO",
  },
  {
    zip_code: "63960",

    ste_name: "MO",
  },
  {
    zip_code: "64075",

    ste_name: "MO",
  },
  {
    zip_code: "64080",

    ste_name: "MO",
  },
  {
    zip_code: "64090",

    ste_name: "MO",
  },
  {
    zip_code: "64125",

    ste_name: "MO",
  },
  {
    zip_code: "64167",

    ste_name: "MO",
  },
  {
    zip_code: "64428",

    ste_name: "MO",
  },
  {
    zip_code: "64429",

    ste_name: "MO",
  },
  {
    zip_code: "64445",

    ste_name: "MO",
  },
  {
    zip_code: "64485",

    ste_name: "MO",
  },
  {
    zip_code: "64499",

    ste_name: "MO",
  },
  {
    zip_code: "64646",

    ste_name: "MO",
  },
  {
    zip_code: "64650",

    ste_name: "MO",
  },
  {
    zip_code: "64664",

    ste_name: "MO",
  },
  {
    zip_code: "64701",

    ste_name: "MO",
  },
  {
    zip_code: "64730",

    ste_name: "MO",
  },
  {
    zip_code: "64734",

    ste_name: "MO",
  },
  {
    zip_code: "64856",

    ste_name: "MO",
  },
  {
    zip_code: "65051",

    ste_name: "MO",
  },
  {
    zip_code: "65239",

    ste_name: "MO",
  },
  {
    zip_code: "65278",

    ste_name: "MO",
  },
  {
    zip_code: "65348",

    ste_name: "MO",
  },
  {
    zip_code: "65466",

    ste_name: "MO",
  },
  {
    zip_code: "65501",

    ste_name: "MO",
  },
  {
    zip_code: "65548",

    ste_name: "MO",
  },
  {
    zip_code: "65557",

    ste_name: "MO",
  },
  {
    zip_code: "65629",

    ste_name: "MO",
  },
  {
    zip_code: "65652",

    ste_name: "MO",
  },
  {
    zip_code: "65660",

    ste_name: "MO",
  },
  {
    zip_code: "65685",

    ste_name: "MO",
  },
  {
    zip_code: "65712",

    ste_name: "MO",
  },
  {
    zip_code: "65745",

    ste_name: "MO",
  },
  {
    zip_code: "65768",

    ste_name: "MO",
  },
  {
    zip_code: "66039",

    ste_name: "KS",
  },
  {
    zip_code: "66220",

    ste_name: "KS",
  },
  {
    zip_code: "66412",

    ste_name: "KS",
  },
  {
    zip_code: "66763",

    ste_name: "KS",
  },
  {
    zip_code: "66835",

    ste_name: "KS",
  },
  {
    zip_code: "66853",

    ste_name: "KS",
  },
  {
    zip_code: "66858",

    ste_name: "KS",
  },
  {
    zip_code: "66871",

    ste_name: "KS",
  },
  {
    zip_code: "66962",

    ste_name: "KS",
  },
  {
    zip_code: "67018",

    ste_name: "KS",
  },
  {
    zip_code: "67142",

    ste_name: "KS",
  },
  {
    zip_code: "67204",

    ste_name: "KS",
  },
  {
    zip_code: "67342",

    ste_name: "KS",
  },
  {
    zip_code: "67455",

    ste_name: "KS",
  },
  {
    zip_code: "67473",

    ste_name: "KS",
  },
  {
    zip_code: "67515",

    ste_name: "KS",
  },
  {
    zip_code: "67522",

    ste_name: "KS",
  },
  {
    zip_code: "67623",

    ste_name: "KS",
  },
  {
    zip_code: "67752",

    ste_name: "KS",
  },
  {
    zip_code: "67753",

    ste_name: "KS",
  },
  {
    zip_code: "67846",

    ste_name: "KS",
  },
  {
    zip_code: "67854",

    ste_name: "KS",
  },
  {
    zip_code: "67880",

    ste_name: "KS",
  },
  {
    zip_code: "67950",

    ste_name: "KS",
  },
  {
    zip_code: "68066",

    ste_name: "NE",
  },
  {
    zip_code: "68114",

    ste_name: "NE",
  },
  {
    zip_code: "68303",

    ste_name: "NE",
  },
  {
    zip_code: "68436",

    ste_name: "NE",
  },
  {
    zip_code: "68458",

    ste_name: "NE",
  },
  {
    zip_code: "68621",

    ste_name: "NE",
  },
  {
    zip_code: "68715",

    ste_name: "NE",
  },
  {
    zip_code: "68783",

    ste_name: "NE",
  },
  {
    zip_code: "68792",

    ste_name: "NE",
  },
  {
    zip_code: "68844",

    ste_name: "NE",
  },
  {
    zip_code: "68926",

    ste_name: "NE",
  },
  {
    zip_code: "68930",

    ste_name: "NE",
  },
  {
    zip_code: "68956",

    ste_name: "NE",
  },
  {
    zip_code: "68958",

    ste_name: "NE",
  },
  {
    zip_code: "68961",

    ste_name: "NE",
  },
  {
    zip_code: "68979",

    ste_name: "NE",
  },
  {
    zip_code: "68981",

    ste_name: "NE",
  },
  {
    zip_code: "69147",

    ste_name: "NE",
  },
  {
    zip_code: "69210",

    ste_name: "NE",
  },
  {
    zip_code: "70002",

    ste_name: "LA",
  },
  {
    zip_code: "70006",

    ste_name: "LA",
  },
  {
    zip_code: "70032",

    ste_name: "LA",
  },
  {
    zip_code: "70076",

    ste_name: "LA",
  },
  {
    zip_code: "70128",

    ste_name: "LA",
  },
  {
    zip_code: "70438",

    ste_name: "LA",
  },
  {
    zip_code: "70447",

    ste_name: "LA",
  },
  {
    zip_code: "70462",

    ste_name: "LA",
  },
  {
    zip_code: "70471",

    ste_name: "LA",
  },
  {
    zip_code: "70575",

    ste_name: "LA",
  },
  {
    zip_code: "70583",

    ste_name: "LA",
  },
  {
    zip_code: "70637",

    ste_name: "LA",
  },
  {
    zip_code: "70655",

    ste_name: "LA",
  },
  {
    zip_code: "70656",

    ste_name: "LA",
  },
  {
    zip_code: "70740",

    ste_name: "LA",
  },
  {
    zip_code: "70756",

    ste_name: "LA",
  },
  {
    zip_code: "70780",

    ste_name: "LA",
  },
  {
    zip_code: "71033",

    ste_name: "LA",
  },
  {
    zip_code: "71067",

    ste_name: "LA",
  },
  {
    zip_code: "71079",

    ste_name: "LA",
  },
  {
    zip_code: "71082",

    ste_name: "LA",
  },
  {
    zip_code: "71247",

    ste_name: "LA",
  },
  {
    zip_code: "71452",

    ste_name: "LA",
  },
  {
    zip_code: "71457",

    ste_name: "LA",
  },
  {
    zip_code: "71642",

    ste_name: "AR",
  },
  {
    zip_code: "71646",

    ste_name: "AR",
  },
  {
    zip_code: "71751",

    ste_name: "AR",
  },
  {
    zip_code: "71852",

    ste_name: "AR",
  },
  {
    zip_code: "71865",

    ste_name: "AR",
  },
  {
    zip_code: "72015",

    ste_name: "AR",
  },
  {
    zip_code: "72023",

    ste_name: "AR",
  },
  {
    zip_code: "72046",

    ste_name: "AR",
  },
  {
    zip_code: "72143",

    ste_name: "AR",
  },
  {
    zip_code: "72165",

    ste_name: "AR",
  },
  {
    zip_code: "72351",

    ste_name: "AR",
  },
  {
    zip_code: "72395",

    ste_name: "AR",
  },
  {
    zip_code: "72456",

    ste_name: "AR",
  },
  {
    zip_code: "72470",

    ste_name: "AR",
  },
  {
    zip_code: "72478",

    ste_name: "AR",
  },
  {
    zip_code: "72482",

    ste_name: "AR",
  },
  {
    zip_code: "72515",

    ste_name: "AR",
  },
  {
    zip_code: "72534",

    ste_name: "AR",
  },
  {
    zip_code: "72616",

    ste_name: "AR",
  },
  {
    zip_code: "72632",

    ste_name: "AR",
  },
  {
    zip_code: "72655",

    ste_name: "AR",
  },
  {
    zip_code: "72712",

    ste_name: "AR",
  },
  {
    zip_code: "72840",

    ste_name: "AR",
  },
  {
    zip_code: "72936",

    ste_name: "AR",
  },
  {
    zip_code: "73004",

    ste_name: "OK",
  },
  {
    zip_code: "73044",

    ste_name: "OK",
  },
  {
    zip_code: "73045",

    ste_name: "OK",
  },
  {
    zip_code: "73072",

    ste_name: "OK",
  },
  {
    zip_code: "73084",

    ste_name: "OK",
  },
  {
    zip_code: "73122",

    ste_name: "OK",
  },
  {
    zip_code: "73127",

    ste_name: "OK",
  },
  {
    zip_code: "73447",

    ste_name: "OK",
  },
  {
    zip_code: "73503",

    ste_name: "OK",
  },
  {
    zip_code: "73551",

    ste_name: "OK",
  },
  {
    zip_code: "73722",

    ste_name: "OK",
  },
  {
    zip_code: "73749",

    ste_name: "OK",
  },
  {
    zip_code: "73848",

    ste_name: "OK",
  },
  {
    zip_code: "74015",

    ste_name: "OK",
  },
  {
    zip_code: "74017",

    ste_name: "OK",
  },
  {
    zip_code: "74072",

    ste_name: "OK",
  },
  {
    zip_code: "74549",

    ste_name: "OK",
  },
  {
    zip_code: "74553",

    ste_name: "OK",
  },
  {
    zip_code: "74726",

    ste_name: "OK",
  },
  {
    zip_code: "74753",

    ste_name: "OK",
  },
  {
    zip_code: "74824",

    ste_name: "OK",
  },
  {
    zip_code: "74832",

    ste_name: "OK",
  },
  {
    zip_code: "74856",

    ste_name: "OK",
  },
  {
    zip_code: "74860",

    ste_name: "OK",
  },
  {
    zip_code: "74959",

    ste_name: "OK",
  },
  {
    zip_code: "74965",

    ste_name: "OK",
  },
  {
    zip_code: "75002",

    ste_name: "TX",
  },
  {
    zip_code: "75006",

    ste_name: "TX",
  },
  {
    zip_code: "75044",

    ste_name: "TX",
  },
  {
    zip_code: "75052",

    ste_name: "TX",
  },
  {
    zip_code: "75054",

    ste_name: "TX",
  },
  {
    zip_code: "75069",

    ste_name: "TX",
  },
  {
    zip_code: "75075",

    ste_name: "TX",
  },
  {
    zip_code: "75080",

    ste_name: "TX",
  },
  {
    zip_code: "75126",

    ste_name: "TX",
  },
  {
    zip_code: "75154",

    ste_name: "TX",
  },
  {
    zip_code: "75231",

    ste_name: "TX",
  },
  {
    zip_code: "75237",

    ste_name: "TX",
  },
  {
    zip_code: "75421",

    ste_name: "TX",
  },
  {
    zip_code: "75471",

    ste_name: "TX",
  },
  {
    zip_code: "75477",

    ste_name: "TX",
  },
  {
    zip_code: "75631",

    ste_name: "TX",
  },
  {
    zip_code: "75783",

    ste_name: "TX",
  },
  {
    zip_code: "75901",

    ste_name: "TX",
  },
  {
    zip_code: "75935",

    ste_name: "TX",
  },
  {
    zip_code: "75951",

    ste_name: "TX",
  },
  {
    zip_code: "75965",

    ste_name: "TX",
  },
  {
    zip_code: "75973",

    ste_name: "TX",
  },
  {
    zip_code: "76009",

    ste_name: "TX",
  },
  {
    zip_code: "76112",

    ste_name: "TX",
  },
  {
    zip_code: "76363",

    ste_name: "TX",
  },
  {
    zip_code: "76372",

    ste_name: "TX",
  },
  {
    zip_code: "76487",

    ste_name: "TX",
  },
  {
    zip_code: "76634",

    ste_name: "TX",
  },
  {
    zip_code: "76650",

    ste_name: "TX",
  },
  {
    zip_code: "77013",

    ste_name: "TX",
  },
  {
    zip_code: "77016",

    ste_name: "TX",
  },
  {
    zip_code: "77028",

    ste_name: "TX",
  },
  {
    zip_code: "77038",

    ste_name: "TX",
  },
  {
    zip_code: "77378",

    ste_name: "TX",
  },
  {
    zip_code: "77458",

    ste_name: "TX",
  },
  {
    zip_code: "77580",

    ste_name: "TX",
  },
  {
    zip_code: "77583",

    ste_name: "TX",
  },
  {
    zip_code: "77642",

    ste_name: "TX",
  },
  {
    zip_code: "77707",

    ste_name: "TX",
  },
  {
    zip_code: "77951",

    ste_name: "TX",
  },
  {
    zip_code: "78061",

    ste_name: "TX",
  },
  {
    zip_code: "78219",

    ste_name: "TX",
  },
  {
    zip_code: "78258",

    ste_name: "TX",
  },
  {
    zip_code: "78340",

    ste_name: "TX",
  },
  {
    zip_code: "78520",

    ste_name: "TX",
  },
  {
    zip_code: "78541",

    ste_name: "TX",
  },
  {
    zip_code: "78573",

    ste_name: "TX",
  },
  {
    zip_code: "78610",

    ste_name: "TX",
  },
  {
    zip_code: "78611",

    ste_name: "TX",
  },
  {
    zip_code: "78623",

    ste_name: "TX",
  },
  {
    zip_code: "78644",

    ste_name: "TX",
  },
  {
    zip_code: "78660",

    ste_name: "TX",
  },
  {
    zip_code: "78884",

    ste_name: "TX",
  },
  {
    zip_code: "78942",

    ste_name: "TX",
  },
  {
    zip_code: "78950",

    ste_name: "TX",
  },
  {
    zip_code: "79010",

    ste_name: "TX",
  },
  {
    zip_code: "79021",

    ste_name: "TX",
  },
  {
    zip_code: "79046",

    ste_name: "TX",
  },
  {
    zip_code: "79061",

    ste_name: "TX",
  },
  {
    zip_code: "79088",

    ste_name: "TX",
  },
  {
    zip_code: "79407",

    ste_name: "TX",
  },
  {
    zip_code: "79520",

    ste_name: "TX",
  },
  {
    zip_code: "79540",

    ste_name: "TX",
  },
  {
    zip_code: "79548",

    ste_name: "TX",
  },
  {
    zip_code: "79706",

    ste_name: "TX",
  },
  {
    zip_code: "79738",

    ste_name: "TX",
  },
  {
    zip_code: "79739",

    ste_name: "TX",
  },
  {
    zip_code: "79762",

    ste_name: "TX",
  },
  {
    zip_code: "79853",

    ste_name: "TX",
  },
  {
    zip_code: "80113",

    ste_name: "CO",
  },
  {
    zip_code: "80459",

    ste_name: "CO",
  },
  {
    zip_code: "80476",

    ste_name: "CO",
  },
  {
    zip_code: "80653",

    ste_name: "CO",
  },
  {
    zip_code: "80919",

    ste_name: "CO",
  },
  {
    zip_code: "81027",

    ste_name: "CO",
  },
  {
    zip_code: "81149",

    ste_name: "CO",
  },
  {
    zip_code: "81222",

    ste_name: "CO",
  },
  {
    zip_code: "81428",

    ste_name: "CO",
  },
  {
    zip_code: "81434",

    ste_name: "CO",
  },
  {
    zip_code: "81503",

    ste_name: "CO",
  },
  {
    zip_code: "81611",

    ste_name: "CO",
  },
  {
    zip_code: "81639",

    ste_name: "CO",
  },
  {
    zip_code: "82301",

    ste_name: "WY",
  },
  {
    zip_code: "82331",

    ste_name: "WY",
  },
  {
    zip_code: "82440",

    ste_name: "WY",
  },
  {
    zip_code: "82639",

    ste_name: "WY",
  },
  {
    zip_code: "83014",

    ste_name: "WY",
  },
  {
    zip_code: "83218",

    ste_name: "ID",
  },
  {
    zip_code: "83241",

    ste_name: "ID",
  },
  {
    zip_code: "83328",

    ste_name: "ID",
  },
  {
    zip_code: "83335",

    ste_name: "ID",
  },
  {
    zip_code: "83525",

    ste_name: "ID",
  },
  {
    zip_code: "83541",

    ste_name: "ID",
  },
  {
    zip_code: "83637",

    ste_name: "ID",
  },
  {
    zip_code: "83646",

    ste_name: "ID",
  },
  {
    zip_code: "83825",

    ste_name: "ID",
  },
  {
    zip_code: "84018",

    ste_name: "UT",
  },
  {
    zip_code: "84021",

    ste_name: "UT",
  },
  {
    zip_code: "84026",

    ste_name: "UT",
  },
  {
    zip_code: "84070",

    ste_name: "UT",
  },
  {
    zip_code: "84073",

    ste_name: "UT",
  },
  {
    zip_code: "84094",

    ste_name: "UT",
  },
  {
    zip_code: "84113",

    ste_name: "UT",
  },
  {
    zip_code: "84123",

    ste_name: "UT",
  },
  {
    zip_code: "84124",

    ste_name: "UT",
  },
  {
    zip_code: "84306",

    ste_name: "UT",
  },
  {
    zip_code: "84330",

    ste_name: "UT",
  },
  {
    zip_code: "85014",

    ste_name: "AZ",
  },
  {
    zip_code: "85021",

    ste_name: "AZ",
  },
  {
    zip_code: "85262",

    ste_name: "AZ",
  },
  {
    zip_code: "85307",

    ste_name: "AZ",
  },
  {
    zip_code: "85624",

    ste_name: "AZ",
  },
  {
    zip_code: "85630",

    ste_name: "AZ",
  },
  {
    zip_code: "85708",

    ste_name: "AZ",
  },
  {
    zip_code: "85711",

    ste_name: "AZ",
  },
  {
    zip_code: "85716",

    ste_name: "AZ",
  },
  {
    zip_code: "85742",

    ste_name: "AZ",
  },
  {
    zip_code: "85755",

    ste_name: "AZ",
  },
  {
    zip_code: "86001",

    ste_name: "AZ",
  },
  {
    zip_code: "86028",

    ste_name: "AZ",
  },
  {
    zip_code: "86043",

    ste_name: "AZ",
  },
  {
    zip_code: "86315",

    ste_name: "AZ",
  },
  {
    zip_code: "86426",

    ste_name: "AZ",
  },
  {
    zip_code: "87313",

    ste_name: "NM",
  },
  {
    zip_code: "87529",

    ste_name: "NM",
  },
  {
    zip_code: "87714",

    ste_name: "NM",
  },
  {
    zip_code: "87728",

    ste_name: "NM",
  },
  {
    zip_code: "87825",

    ste_name: "NM",
  },
  {
    zip_code: "87941",

    ste_name: "NM",
  },
  {
    zip_code: "88004",

    ste_name: "NM",
  },
  {
    zip_code: "88044",

    ste_name: "NM",
  },
  {
    zip_code: "88045",

    ste_name: "NM",
  },
  {
    zip_code: "88101",

    ste_name: "NM",
  },
  {
    zip_code: "88124",

    ste_name: "NM",
  },
  {
    zip_code: "88264",

    ste_name: "NM",
  },
  {
    zip_code: "88321",

    ste_name: "NM",
  },
  {
    zip_code: "89433",

    ste_name: "NV",
  },
  {
    zip_code: "98409",

    ste_name: "WA",
  },
  {
    zip_code: "98430",

    ste_name: "WA",
  },
  {
    zip_code: "98445",

    ste_name: "WA",
  },
  {
    zip_code: "98501",

    ste_name: "WA",
  },
  {
    zip_code: "98541",

    ste_name: "WA",
  },
  {
    zip_code: "98568",

    ste_name: "WA",
  },
  {
    zip_code: "98605",

    ste_name: "WA",
  },
  {
    zip_code: "98638",

    ste_name: "WA",
  },
  {
    zip_code: "98661",

    ste_name: "WA",
  },
  {
    zip_code: "98862",

    ste_name: "WA",
  },
  {
    zip_code: "98944",

    ste_name: "WA",
  },
  {
    zip_code: "99158",

    ste_name: "WA",
  },
  {
    zip_code: "99201",

    ste_name: "WA",
  },
  {
    zip_code: "99360",

    ste_name: "WA",
  },
  {
    zip_code: "99550",

    ste_name: "AK",
  },
  {
    zip_code: "99553",

    ste_name: "AK",
  },
  {
    zip_code: "99630",

    ste_name: "AK",
  },
  {
    zip_code: "99655",

    ste_name: "AK",
  },
  {
    zip_code: "99657",

    ste_name: "AK",
  },
  {
    zip_code: "99672",

    ste_name: "AK",
  },
  {
    zip_code: "99682",

    ste_name: "AK",
  },
  {
    zip_code: "99705",

    ste_name: "AK",
  },
  {
    zip_code: "99778",

    ste_name: "AK",
  },
  {
    zip_code: "99786",

    ste_name: "AK",
  },
  {
    zip_code: "99789",

    ste_name: "AK",
  },
  {
    zip_code: "90029",

    ste_name: "CA",
  },
  {
    zip_code: "90247",

    ste_name: "CA",
  },
  {
    zip_code: "90260",

    ste_name: "CA",
  },
  {
    zip_code: "90807",

    ste_name: "CA",
  },
  {
    zip_code: "91007",

    ste_name: "CA",
  },
  {
    zip_code: "91301",

    ste_name: "CA",
  },
  {
    zip_code: "91350",

    ste_name: "CA",
  },
  {
    zip_code: "91351",

    ste_name: "CA",
  },
  {
    zip_code: "91706",

    ste_name: "CA",
  },
  {
    zip_code: "91709",

    ste_name: "CA",
  },
  {
    zip_code: "91773",

    ste_name: "CA",
  },
  {
    zip_code: "91915",

    ste_name: "CA",
  },
  {
    zip_code: "92059",

    ste_name: "CA",
  },
  {
    zip_code: "92107",

    ste_name: "CA",
  },
  {
    zip_code: "92262",

    ste_name: "CA",
  },
  {
    zip_code: "92338",

    ste_name: "CA",
  },
  {
    zip_code: "92378",

    ste_name: "CA",
  },
  {
    zip_code: "93067",

    ste_name: "CA",
  },
  {
    zip_code: "92386",

    ste_name: "CA",
  },
  {
    zip_code: "92584",

    ste_name: "CA",
  },
  {
    zip_code: "93208",

    ste_name: "CA",
  },
  {
    zip_code: "93261",

    ste_name: "CA",
  },
  {
    zip_code: "93271",

    ste_name: "CA",
  },
  {
    zip_code: "93274",

    ste_name: "CA",
  },
  {
    zip_code: "93442",

    ste_name: "CA",
  },
  {
    zip_code: "93618",

    ste_name: "CA",
  },
  {
    zip_code: "93650",

    ste_name: "CA",
  },
  {
    zip_code: "93702",

    ste_name: "CA",
  },
  {
    zip_code: "93721",

    ste_name: "CA",
  },
  {
    zip_code: "93722",

    ste_name: "CA",
  },
  {
    zip_code: "93730",

    ste_name: "CA",
  },
  {
    zip_code: "93926",

    ste_name: "CA",
  },
  {
    zip_code: "94038",

    ste_name: "CA",
  },
  {
    zip_code: "94062",

    ste_name: "CA",
  },
  {
    zip_code: "94110",

    ste_name: "CA",
  },
  {
    zip_code: "94520",

    ste_name: "CA",
  },
  {
    zip_code: "94550",

    ste_name: "CA",
  },
  {
    zip_code: "94553",

    ste_name: "CA",
  },
  {
    zip_code: "94561",

    ste_name: "CA",
  },
  {
    zip_code: "95212",

    ste_name: "CA",
  },
  {
    zip_code: "95226",

    ste_name: "CA",
  },
  {
    zip_code: "95388",

    ste_name: "CA",
  },
  {
    zip_code: "95445",

    ste_name: "CA",
  },
  {
    zip_code: "95472",

    ste_name: "CA",
  },
  {
    zip_code: "95562",

    ste_name: "CA",
  },
  {
    zip_code: "95667",

    ste_name: "CA",
  },
  {
    zip_code: "95714",

    ste_name: "CA",
  },
  {
    zip_code: "95837",

    ste_name: "CA",
  },
  {
    zip_code: "95912",

    ste_name: "CA",
  },
  {
    zip_code: "95917",

    ste_name: "CA",
  },
  {
    zip_code: "95937",

    ste_name: "CA",
  },
  {
    zip_code: "95981",

    ste_name: "CA",
  },
  {
    zip_code: "96001",

    ste_name: "CA",
  },
  {
    zip_code: "96071",

    ste_name: "CA",
  },
  {
    zip_code: "96093",

    ste_name: "CA",
  },
  {
    zip_code: "96146",

    ste_name: "CA",
  },
  {
    zip_code: "96150",

    ste_name: "CA",
  },
  {
    zip_code: "96713",

    ste_name: "HI",
  },
  {
    zip_code: "96752",

    ste_name: "HI",
  },
  {
    zip_code: "97048",

    ste_name: "OR",
  },
  {
    zip_code: "97089",

    ste_name: "OR",
  },
  {
    zip_code: "97145",

    ste_name: "OR",
  },
  {
    zip_code: "97231",

    ste_name: "OR",
  },
  {
    zip_code: "97304",

    ste_name: "OR",
  },
  {
    zip_code: "97419",

    ste_name: "OR",
  },
  {
    zip_code: "97442",

    ste_name: "OR",
  },
  {
    zip_code: "97537",

    ste_name: "OR",
  },
  {
    zip_code: "97632",

    ste_name: "OR",
  },
  {
    zip_code: "97701",

    ste_name: "OR",
  },
  {
    zip_code: "98003",

    ste_name: "WA",
  },
  {
    zip_code: "98022",

    ste_name: "WA",
  },
  {
    zip_code: "98040",

    ste_name: "WA",
  },
  {
    zip_code: "98117",

    ste_name: "WA",
  },
  {
    zip_code: "98243",

    ste_name: "WA",
  },
  {
    zip_code: "98267",

    ste_name: "WA",
  },
  {
    zip_code: "98284",

    ste_name: "WA",
  },
  {
    zip_code: "98315",

    ste_name: "WA",
  },
  {
    zip_code: "98349",

    ste_name: "WA",
  },
  {
    zip_code: "98370",

    ste_name: "WA",
  },
  {
    zip_code: "31081",

    ste_name: "GA",
  },
  {
    zip_code: "31084",

    ste_name: "GA",
  },
  {
    zip_code: "31092",

    ste_name: "GA",
  },
  {
    zip_code: "31320",

    ste_name: "GA",
  },
  {
    zip_code: "31321",

    ste_name: "GA",
  },
  {
    zip_code: "31329",

    ste_name: "GA",
  },
  {
    zip_code: "31419",

    ste_name: "GA",
  },
  {
    zip_code: "31535",

    ste_name: "GA",
  },
  {
    zip_code: "31562",

    ste_name: "GA",
  },
  {
    zip_code: "31626",

    ste_name: "GA",
  },
  {
    zip_code: "31630",

    ste_name: "GA",
  },
  {
    zip_code: "31735",

    ste_name: "GA",
  },
  {
    zip_code: "31907",

    ste_name: "GA",
  },
  {
    zip_code: "32086",

    ste_name: "FL",
  },
  {
    zip_code: "32119",

    ste_name: "FL",
  },
  {
    zip_code: "32216",

    ste_name: "FL",
  },
  {
    zip_code: "32404",

    ste_name: "FL",
  },
  {
    zip_code: "32433",

    ste_name: "FL",
  },
  {
    zip_code: "32508",

    ste_name: "FL",
  },
  {
    zip_code: "32550",

    ste_name: "FL",
  },
  {
    zip_code: "32622",

    ste_name: "FL",
  },
  {
    zip_code: "32703",

    ste_name: "FL",
  },
  {
    zip_code: "32764",

    ste_name: "FL",
  },
  {
    zip_code: "33065",

    ste_name: "FL",
  },
  {
    zip_code: "33315",

    ste_name: "FL",
  },
  {
    zip_code: "33415",

    ste_name: "FL",
  },
  {
    zip_code: "33761",

    ste_name: "FL",
  },
  {
    zip_code: "33844",

    ste_name: "FL",
  },
  {
    zip_code: "33848",

    ste_name: "FL",
  },
  {
    zip_code: "33898",

    ste_name: "FL",
  },
  {
    zip_code: "33907",

    ste_name: "FL",
  },
  {
    zip_code: "33917",

    ste_name: "FL",
  },
  {
    zip_code: "33993",

    ste_name: "FL",
  },
  {
    zip_code: "34135",

    ste_name: "FL",
  },
  {
    zip_code: "34238",

    ste_name: "FL",
  },
  {
    zip_code: "34241",

    ste_name: "FL",
  },
  {
    zip_code: "34289",

    ste_name: "FL",
  },
  {
    zip_code: "34433",

    ste_name: "FL",
  },
  {
    zip_code: "34498",

    ste_name: "FL",
  },
  {
    zip_code: "34637",

    ste_name: "FL",
  },
  {
    zip_code: "34947",

    ste_name: "FL",
  },
  {
    zip_code: "34949",

    ste_name: "FL",
  },
  {
    zip_code: "34982",

    ste_name: "FL",
  },
  {
    zip_code: "35022",

    ste_name: "AL",
  },
  {
    zip_code: "35640",

    ste_name: "AL",
  },
  {
    zip_code: "35647",

    ste_name: "AL",
  },
  {
    zip_code: "35652",

    ste_name: "AL",
  },
  {
    zip_code: "35670",

    ste_name: "AL",
  },
  {
    zip_code: "35761",

    ste_name: "AL",
  },
  {
    zip_code: "36067",

    ste_name: "AL",
  },
  {
    zip_code: "36071",

    ste_name: "AL",
  },
  {
    zip_code: "36305",

    ste_name: "AL",
  },
  {
    zip_code: "36352",

    ste_name: "AL",
  },
  {
    zip_code: "36362",

    ste_name: "AL",
  },
  {
    zip_code: "36475",

    ste_name: "AL",
  },
  {
    zip_code: "36540",

    ste_name: "AL",
  },
  {
    zip_code: "36561",

    ste_name: "AL",
  },
  {
    zip_code: "36564",

    ste_name: "AL",
  },
  {
    zip_code: "36604",

    ste_name: "AL",
  },
  {
    zip_code: "36693",

    ste_name: "AL",
  },
  {
    zip_code: "36695",

    ste_name: "AL",
  },
  {
    zip_code: "36703",

    ste_name: "AL",
  },
  {
    zip_code: "36849",

    ste_name: "AL",
  },
  {
    zip_code: "36852",

    ste_name: "AL",
  },
  {
    zip_code: "37073",

    ste_name: "TN",
  },
  {
    zip_code: "37085",

    ste_name: "TN",
  },
  {
    zip_code: "37091",

    ste_name: "TN",
  },
  {
    zip_code: "37313",

    ste_name: "TN",
  },
  {
    zip_code: "37404",

    ste_name: "TN",
  },
  {
    zip_code: "37408",

    ste_name: "TN",
  },
  {
    zip_code: "37733",

    ste_name: "TN",
  },
  {
    zip_code: "37760",

    ste_name: "TN",
  },
  {
    zip_code: "37909",

    ste_name: "TN",
  },
  {
    zip_code: "38112",

    ste_name: "TN",
  },
  {
    zip_code: "38253",

    ste_name: "TN",
  },
  {
    zip_code: "38315",

    ste_name: "TN",
  },
  {
    zip_code: "38352",

    ste_name: "TN",
  },
  {
    zip_code: "38356",

    ste_name: "TN",
  },
  {
    zip_code: "38464",

    ste_name: "TN",
  },
  {
    zip_code: "38483",

    ste_name: "TN",
  },
  {
    zip_code: "38650",

    ste_name: "MS",
  },
  {
    zip_code: "38683",

    ste_name: "MS",
  },
  {
    zip_code: "38863",

    ste_name: "MS",
  },
  {
    zip_code: "38950",

    ste_name: "MS",
  },
  {
    zip_code: "38958",

    ste_name: "MS",
  },
  {
    zip_code: "39175",

    ste_name: "MS",
  },
  {
    zip_code: "39309",

    ste_name: "MS",
  },
  {
    zip_code: "39363",

    ste_name: "MS",
  },
  {
    zip_code: "39367",

    ste_name: "MS",
  },
  {
    zip_code: "39427",

    ste_name: "MS",
  },
  {
    zip_code: "39429",

    ste_name: "MS",
  },
  {
    zip_code: "39503",

    ste_name: "MS",
  },
  {
    zip_code: "39553",

    ste_name: "MS",
  },
  {
    zip_code: "39702",

    ste_name: "MS",
  },
  {
    zip_code: "39813",

    ste_name: "GA",
  },
  {
    zip_code: "40020",

    ste_name: "KY",
  },
  {
    zip_code: "40223",

    ste_name: "KY",
  },
  {
    zip_code: "40385",

    ste_name: "KY",
  },
  {
    zip_code: "40515",

    ste_name: "KY",
  },
  {
    zip_code: "40844",

    ste_name: "KY",
  },
  {
    zip_code: "40903",

    ste_name: "KY",
  },
  {
    zip_code: "40940",

    ste_name: "KY",
  },
  {
    zip_code: "40943",

    ste_name: "KY",
  },
  {
    zip_code: "41124",

    ste_name: "KY",
  },
  {
    zip_code: "41352",

    ste_name: "KY",
  },
  {
    zip_code: "41503",

    ste_name: "KY",
  },
  {
    zip_code: "41559",

    ste_name: "KY",
  },
  {
    zip_code: "41604",

    ste_name: "KY",
  },
  {
    zip_code: "41632",

    ste_name: "KY",
  },
  {
    zip_code: "41739",

    ste_name: "KY",
  },
  {
    zip_code: "41746",

    ste_name: "KY",
  },
  {
    zip_code: "41749",

    ste_name: "KY",
  },
  {
    zip_code: "41772",

    ste_name: "KY",
  },
  {
    zip_code: "41832",

    ste_name: "KY",
  },
  {
    zip_code: "42256",

    ste_name: "KY",
  },
  {
    zip_code: "43003",

    ste_name: "OH",
  },
  {
    zip_code: "43016",

    ste_name: "OH",
  },
  {
    zip_code: "43032",

    ste_name: "OH",
  },
  {
    zip_code: "43074",

    ste_name: "OH",
  },
  {
    zip_code: "43109",

    ste_name: "OH",
  },
  {
    zip_code: "43203",

    ste_name: "OH",
  },
  {
    zip_code: "43319",

    ste_name: "OH",
  },
  {
    zip_code: "43412",

    ste_name: "OH",
  },
  {
    zip_code: "43517",

    ste_name: "OH",
  },
  {
    zip_code: "43617",

    ste_name: "OH",
  },
  {
    zip_code: "43728",

    ste_name: "OH",
  },
  {
    zip_code: "43740",

    ste_name: "OH",
  },
  {
    zip_code: "43748",

    ste_name: "OH",
  },
  {
    zip_code: "44024",

    ste_name: "OH",
  },
  {
    zip_code: "44032",

    ste_name: "OH",
  },
  {
    zip_code: "44053",

    ste_name: "OH",
  },
  {
    zip_code: "44103",

    ste_name: "OH",
  },
  {
    zip_code: "44108",

    ste_name: "OH",
  },
  {
    zip_code: "44233",

    ste_name: "OH",
  },
  {
    zip_code: "44301",

    ste_name: "OH",
  },
  {
    zip_code: "44403",

    ste_name: "OH",
  },
  {
    zip_code: "44418",

    ste_name: "OH",
  },
  {
    zip_code: "44454",

    ste_name: "OH",
  },
  {
    zip_code: "44471",

    ste_name: "OH",
  },
  {
    zip_code: "44606",

    ste_name: "OH",
  },
  {
    zip_code: "44637",

    ste_name: "OH",
  },
  {
    zip_code: "44683",

    ste_name: "OH",
  },
  {
    zip_code: "44849",

    ste_name: "OH",
  },
  {
    zip_code: "45162",

    ste_name: "OH",
  },
  {
    zip_code: "45169",

    ste_name: "OH",
  },
  {
    zip_code: "45172",

    ste_name: "OH",
  },
  {
    zip_code: "45242",

    ste_name: "OH",
  },
  {
    zip_code: "45245",

    ste_name: "OH",
  },
  {
    zip_code: "45315",

    ste_name: "OH",
  },
  {
    zip_code: "45319",

    ste_name: "OH",
  },
  {
    zip_code: "45346",

    ste_name: "OH",
  },
  {
    zip_code: "45359",

    ste_name: "OH",
  },
  {
    zip_code: "45380",

    ste_name: "OH",
  },
  {
    zip_code: "45385",

    ste_name: "OH",
  },
  {
    zip_code: "45502",

    ste_name: "OH",
  },
  {
    zip_code: "45645",

    ste_name: "OH",
  },
  {
    zip_code: "45652",

    ste_name: "OH",
  },
  {
    zip_code: "45669",

    ste_name: "OH",
  },
  {
    zip_code: "45671",

    ste_name: "OH",
  },
  {
    zip_code: "45693",

    ste_name: "OH",
  },
  {
    zip_code: "45773",

    ste_name: "OH",
  },
  {
    zip_code: "45830",

    ste_name: "OH",
  },
  {
    zip_code: "45861",

    ste_name: "OH",
  },
  {
    zip_code: "46125",

    ste_name: "IN",
  },
  {
    zip_code: "46219",

    ste_name: "IN",
  },
  {
    zip_code: "46320",

    ste_name: "IN",
  },
  {
    zip_code: "46516",

    ste_name: "IN",
  },
  {
    zip_code: "46745",

    ste_name: "IN",
  },
  {
    zip_code: "46917",

    ste_name: "IN",
  },
  {
    zip_code: "46938",

    ste_name: "IN",
  },
  {
    zip_code: "47024",

    ste_name: "IN",
  },
  {
    zip_code: "47036",

    ste_name: "IN",
  },
  {
    zip_code: "47037",

    ste_name: "IN",
  },
  {
    zip_code: "47230",

    ste_name: "IN",
  },
  {
    zip_code: "47354",

    ste_name: "IN",
  },
  {
    zip_code: "47383",

    ste_name: "IN",
  },
  {
    zip_code: "47529",

    ste_name: "IN",
  },
  {
    zip_code: "47561",

    ste_name: "IN",
  },
  {
    zip_code: "47591",

    ste_name: "IN",
  },
  {
    zip_code: "47635",

    ste_name: "IN",
  },
  {
    zip_code: "47638",

    ste_name: "IN",
  },
  {
    zip_code: "47905",

    ste_name: "IN",
  },
  {
    zip_code: "47928",

    ste_name: "IN",
  },
  {
    zip_code: "47970",

    ste_name: "IN",
  },
  {
    zip_code: "47983",

    ste_name: "IN",
  },
  {
    zip_code: "48042",

    ste_name: "MI",
  },
  {
    zip_code: "48073",

    ste_name: "MI",
  },
  {
    zip_code: "48213",

    ste_name: "MI",
  },
  {
    zip_code: "48237",

    ste_name: "MI",
  },
  {
    zip_code: "48390",

    ste_name: "MI",
  },
  {
    zip_code: "48440",

    ste_name: "MI",
  },
  {
    zip_code: "48504",

    ste_name: "MI",
  },
  {
    zip_code: "48529",

    ste_name: "MI",
  },
  {
    zip_code: "48554",

    ste_name: "MI",
  },
  {
    zip_code: "48766",

    ste_name: "MI",
  },
  {
    zip_code: "48832",

    ste_name: "MI",
  },
  {
    zip_code: "48895",

    ste_name: "MI",
  },
  {
    zip_code: "48911",

    ste_name: "MI",
  },
  {
    zip_code: "49104",

    ste_name: "MI",
  },
  {
    zip_code: "49220",

    ste_name: "MI",
  },
  {
    zip_code: "49230",

    ste_name: "MI",
  },
  {
    zip_code: "49233",

    ste_name: "MI",
  },
  {
    zip_code: "49322",

    ste_name: "MI",
  },
  {
    zip_code: "49440",

    ste_name: "MI",
  },
  {
    zip_code: "49635",

    ste_name: "MI",
  },
  {
    zip_code: "49654",

    ste_name: "MI",
  },
  {
    zip_code: "49686",

    ste_name: "MI",
  },
  {
    zip_code: "49776",

    ste_name: "MI",
  },
  {
    zip_code: "49817",

    ste_name: "MI",
  },
  {
    zip_code: "49818",

    ste_name: "MI",
  },
  {
    zip_code: "49837",

    ste_name: "MI",
  },
  {
    zip_code: "49849",

    ste_name: "MI",
  },
  {
    zip_code: "49866",

    ste_name: "MI",
  },
  {
    zip_code: "49887",

    ste_name: "MI",
  },
  {
    zip_code: "49961",

    ste_name: "MI",
  },
  {
    zip_code: "49965",

    ste_name: "MI",
  },
  {
    zip_code: "50047",

    ste_name: "IA",
  },
  {
    zip_code: "50115",

    ste_name: "IA",
  },
  {
    zip_code: "50138",

    ste_name: "IA",
  },
  {
    zip_code: "50168",

    ste_name: "IA",
  },
  {
    zip_code: "50239",

    ste_name: "IA",
  },
  {
    zip_code: "50266",

    ste_name: "IA",
  },
  {
    zip_code: "50441",

    ste_name: "IA",
  },
  {
    zip_code: "50444",

    ste_name: "IA",
  },
  {
    zip_code: "50544",

    ste_name: "IA",
  },
  {
    zip_code: "50568",

    ste_name: "IA",
  },
  {
    zip_code: "50582",

    ste_name: "IA",
  },
  {
    zip_code: "50636",

    ste_name: "IA",
  },
  {
    zip_code: "50650",

    ste_name: "IA",
  },
  {
    zip_code: "50667",

    ste_name: "IA",
  },
  {
    zip_code: "50675",

    ste_name: "IA",
  },
  {
    zip_code: "50680",

    ste_name: "IA",
  },
  {
    zip_code: "50840",

    ste_name: "IA",
  },
  {
    zip_code: "51002",

    ste_name: "IA",
  },
  {
    zip_code: "51250",

    ste_name: "IA",
  },
  {
    zip_code: "51433",

    ste_name: "IA",
  },
  {
    zip_code: "51542",

    ste_name: "IA",
  },
  {
    zip_code: "51654",

    ste_name: "IA",
  },
  {
    zip_code: "52043",

    ste_name: "IA",
  },
  {
    zip_code: "52141",

    ste_name: "IA",
  },
  {
    zip_code: "52205",

    ste_name: "IA",
  },
  {
    zip_code: "52242",

    ste_name: "IA",
  },
  {
    zip_code: "52316",

    ste_name: "IA",
  },
  {
    zip_code: "52402",

    ste_name: "IA",
  },
  {
    zip_code: "52552",

    ste_name: "IA",
  },
  {
    zip_code: "52584",

    ste_name: "IA",
  },
  {
    zip_code: "52624",

    ste_name: "IA",
  },
  {
    zip_code: "52650",

    ste_name: "IA",
  },
  {
    zip_code: "52747",

    ste_name: "IA",
  },
  {
    zip_code: "52752",

    ste_name: "IA",
  },
  {
    zip_code: "52755",

    ste_name: "IA",
  },
  {
    zip_code: "52760",

    ste_name: "IA",
  },
  {
    zip_code: "52772",

    ste_name: "IA",
  },
  {
    zip_code: "53019",

    ste_name: "WI",
  },
  {
    zip_code: "53042",

    ste_name: "WI",
  },
  {
    zip_code: "53093",

    ste_name: "WI",
  },
  {
    zip_code: "53129",

    ste_name: "WI",
  },
  {
    zip_code: "53132",

    ste_name: "WI",
  },
  {
    zip_code: "53143",

    ste_name: "WI",
  },
  {
    zip_code: "53211",

    ste_name: "WI",
  },
  {
    zip_code: "53219",

    ste_name: "WI",
  },
  {
    zip_code: "53227",

    ste_name: "WI",
  },
  {
    zip_code: "53529",

    ste_name: "WI",
  },
  {
    zip_code: "53913",

    ste_name: "WI",
  },
  {
    zip_code: "54022",

    ste_name: "WI",
  },
  {
    zip_code: "54128",

    ste_name: "WI",
  },
  {
    zip_code: "54304",

    ste_name: "WI",
  },
  {
    zip_code: "54405",

    ste_name: "WI",
  },
  {
    zip_code: "54410",

    ste_name: "WI",
  },
  {
    zip_code: "54427",

    ste_name: "WI",
  },
  {
    zip_code: "54443",

    ste_name: "WI",
  },
  {
    zip_code: "54448",

    ste_name: "WI",
  },
  {
    zip_code: "54463",

    ste_name: "WI",
  },
  {
    zip_code: "54645",

    ste_name: "WI",
  },
  {
    zip_code: "54655",

    ste_name: "WI",
  },
  {
    zip_code: "54665",

    ste_name: "WI",
  },
  {
    zip_code: "54666",

    ste_name: "WI",
  },
  {
    zip_code: "54751",

    ste_name: "WI",
  },
  {
    zip_code: "54761",

    ste_name: "WI",
  },
  {
    zip_code: "54817",

    ste_name: "WI",
  },
  {
    zip_code: "54856",

    ste_name: "WI",
  },
  {
    zip_code: "54895",

    ste_name: "WI",
  },
  {
    zip_code: "54940",

    ste_name: "WI",
  },
  {
    zip_code: "54965",

    ste_name: "WI",
  },
  {
    zip_code: "55021",

    ste_name: "MN",
  },
  {
    zip_code: "55060",

    ste_name: "MN",
  },
  {
    zip_code: "55430",

    ste_name: "MN",
  },
  {
    zip_code: "55432",

    ste_name: "MN",
  },
  {
    zip_code: "55603",

    ste_name: "MN",
  },
  {
    zip_code: "55612",

    ste_name: "MN",
  },
  {
    zip_code: "55702",

    ste_name: "MN",
  },
  {
    zip_code: "55752",

    ste_name: "MN",
  },
  {
    zip_code: "55760",

    ste_name: "MN",
  },
  {
    zip_code: "55792",

    ste_name: "MN",
  },
  {
    zip_code: "55931",

    ste_name: "MN",
  },
  {
    zip_code: "55956",

    ste_name: "MN",
  },
  {
    zip_code: "55967",

    ste_name: "MN",
  },
  {
    zip_code: "55977",

    ste_name: "MN",
  },
  {
    zip_code: "56016",

    ste_name: "MN",
  },
  {
    zip_code: "56075",

    ste_name: "MN",
  },
  {
    zip_code: "56081",

    ste_name: "MN",
  },
  {
    zip_code: "56125",

    ste_name: "MN",
  },
  {
    zip_code: "56152",

    ste_name: "MN",
  },
  {
    zip_code: "56162",

    ste_name: "MN",
  },
  {
    zip_code: "56164",

    ste_name: "MN",
  },
  {
    zip_code: "56229",

    ste_name: "MN",
  },
  {
    zip_code: "56281",

    ste_name: "MN",
  },
  {
    zip_code: "56319",

    ste_name: "MN",
  },
  {
    zip_code: "56343",

    ste_name: "MN",
  },
  {
    zip_code: "56350",

    ste_name: "MN",
  },
  {
    zip_code: "56384",

    ste_name: "MN",
  },
  {
    zip_code: "56472",

    ste_name: "MN",
  },
  {
    zip_code: "56569",

    ste_name: "MN",
  },
  {
    zip_code: "56573",

    ste_name: "MN",
  },
  {
    zip_code: "56621",

    ste_name: "MN",
  },
  {
    zip_code: "56715",

    ste_name: "MN",
  },
  {
    zip_code: "57003",

    ste_name: "SD",
  },
  {
    zip_code: "57013",

    ste_name: "SD",
  },
  {
    zip_code: "57022",

    ste_name: "SD",
  },
  {
    zip_code: "57027",

    ste_name: "SD",
  },
  {
    zip_code: "57070",

    ste_name: "SD",
  },
  {
    zip_code: "57117",

    ste_name: "SD",
  },
  {
    zip_code: "57430",

    ste_name: "SD",
  },
  {
    zip_code: "57455",

    ste_name: "SD",
  },
  {
    zip_code: "57473",

    ste_name: "SD",
  },
  {
    zip_code: "57521",

    ste_name: "SD",
  },
  {
    zip_code: "57730",

    ste_name: "SD",
  },
  {
    zip_code: "57792",

    ste_name: "SD",
  },
  {
    zip_code: "58363",

    ste_name: "ND",
  },
  {
    zip_code: "58386",

    ste_name: "ND",
  },
  {
    zip_code: "58416",

    ste_name: "ND",
  },
  {
    zip_code: "58418",

    ste_name: "ND",
  },
  {
    zip_code: "58426",

    ste_name: "ND",
  },
  {
    zip_code: "58428",

    ste_name: "ND",
  },
  {
    zip_code: "58464",

    ste_name: "ND",
  },
  {
    zip_code: "58479",

    ste_name: "ND",
  },
  {
    zip_code: "58639",

    ste_name: "ND",
  },
  {
    zip_code: "58723",

    ste_name: "ND",
  },
  {
    zip_code: "92368",

    ste_name: "CA",
  },
  {
    zip_code: "92404",

    ste_name: "CA",
  },
  {
    zip_code: "92590",

    ste_name: "CA",
  },
  {
    zip_code: "92618",

    ste_name: "CA",
  },
  {
    zip_code: "92629",

    ste_name: "CA",
  },
  {
    zip_code: "92868",

    ste_name: "CA",
  },
  {
    zip_code: "93111",

    ste_name: "CA",
  },
  {
    zip_code: "93203",

    ste_name: "CA",
  },
  {
    zip_code: "93314",

    ste_name: "CA",
  },
  {
    zip_code: "93445",

    ste_name: "CA",
  },
  {
    zip_code: "98466",

    ste_name: "WA",
  },
  {
    zip_code: "98533",

    ste_name: "WA",
  },
  {
    zip_code: "98547",

    ste_name: "WA",
  },
  {
    zip_code: "98848",

    ste_name: "WA",
  },
  {
    zip_code: "99011",

    ste_name: "WA",
  },
  {
    zip_code: "99141",

    ste_name: "WA",
  },
  {
    zip_code: "99224",

    ste_name: "WA",
  },
  {
    zip_code: "99326",

    ste_name: "WA",
  },
  {
    zip_code: "99359",

    ste_name: "WA",
  },
  {
    zip_code: "99540",

    ste_name: "AK",
  },
  {
    zip_code: "99567",

    ste_name: "AK",
  },
  {
    zip_code: "99605",

    ste_name: "AK",
  },
  {
    zip_code: "99621",

    ste_name: "AK",
  },
  {
    zip_code: "99638",

    ste_name: "AK",
  },
  {
    zip_code: "99659",

    ste_name: "AK",
  },
  {
    zip_code: "99773",

    ste_name: "AK",
  },
  {
    zip_code: "99841",

    ste_name: "AK",
  },
  {
    zip_code: "90032",

    ste_name: "CA",
  },
  {
    zip_code: "90249",

    ste_name: "CA",
  },
  {
    zip_code: "90255",

    ste_name: "CA",
  },
  {
    zip_code: "90291",

    ste_name: "CA",
  },
  {
    zip_code: "90402",

    ste_name: "CA",
  },
  {
    zip_code: "90405",

    ste_name: "CA",
  },
  {
    zip_code: "90621",

    ste_name: "CA",
  },
  {
    zip_code: "91016",

    ste_name: "CA",
  },
  {
    zip_code: "91330",

    ste_name: "CA",
  },
  {
    zip_code: "91387",

    ste_name: "CA",
  },
  {
    zip_code: "91411",

    ste_name: "CA",
  },
  {
    zip_code: "91605",

    ste_name: "CA",
  },
  {
    zip_code: "91770",

    ste_name: "CA",
  },
  {
    zip_code: "92115",

    ste_name: "CA",
  },
  {
    zip_code: "92203",

    ste_name: "CA",
  },
  {
    zip_code: "92254",

    ste_name: "CA",
  },
  {
    zip_code: "92321",

    ste_name: "CA",
  },
  {
    zip_code: "92562",

    ste_name: "CA",
  },
  {
    zip_code: "93247",

    ste_name: "CA",
  },
  {
    zip_code: "93263",

    ste_name: "CA",
  },
  {
    zip_code: "93510",

    ste_name: "CA",
  },
  {
    zip_code: "93516",

    ste_name: "CA",
  },
  {
    zip_code: "93535",

    ste_name: "CA",
  },
  {
    zip_code: "93560",

    ste_name: "CA",
  },
  {
    zip_code: "93563",

    ste_name: "CA",
  },
  {
    zip_code: "93609",

    ste_name: "CA",
  },
  {
    zip_code: "93616",

    ste_name: "CA",
  },
  {
    zip_code: "93723",

    ste_name: "CA",
  },
  {
    zip_code: "94501",

    ste_name: "CA",
  },
  {
    zip_code: "94509",

    ste_name: "CA",
  },
  {
    zip_code: "94578",

    ste_name: "CA",
  },
  {
    zip_code: "94585",

    ste_name: "CA",
  },
  {
    zip_code: "94589",

    ste_name: "CA",
  },
  {
    zip_code: "94592",

    ste_name: "CA",
  },
  {
    zip_code: "94601",

    ste_name: "CA",
  },
  {
    zip_code: "94618",

    ste_name: "CA",
  },
  {
    zip_code: "94702",

    ste_name: "CA",
  },
  {
    zip_code: "95002",

    ste_name: "CA",
  },
  {
    zip_code: "95323",

    ste_name: "CA",
  },
  {
    zip_code: "95365",

    ste_name: "CA",
  },
  {
    zip_code: "95405",

    ste_name: "CA",
  },
  {
    zip_code: "95442",

    ste_name: "CA",
  },
  {
    zip_code: "95514",

    ste_name: "CA",
  },
  {
    zip_code: "95550",

    ste_name: "CA",
  },
  {
    zip_code: "95601",

    ste_name: "CA",
  },
  {
    zip_code: "95627",

    ste_name: "CA",
  },
  {
    zip_code: "95638",

    ste_name: "CA",
  },
  {
    zip_code: "95665",

    ste_name: "CA",
  },
  {
    zip_code: "95684",

    ste_name: "CA",
  },
  {
    zip_code: "95843",

    ste_name: "CA",
  },
  {
    zip_code: "95910",

    ste_name: "CA",
  },
  {
    zip_code: "95943",

    ste_name: "CA",
  },
  {
    zip_code: "95974",

    ste_name: "CA",
  },
  {
    zip_code: "96009",

    ste_name: "CA",
  },
  {
    zip_code: "96085",

    ste_name: "CA",
  },
  {
    zip_code: "96132",

    ste_name: "CA",
  },
  {
    zip_code: "96142",

    ste_name: "CA",
  },
  {
    zip_code: "96701",

    ste_name: "HI",
  },
  {
    zip_code: "96757",

    ste_name: "HI",
  },
  {
    zip_code: "96763",

    ste_name: "HI",
  },
  {
    zip_code: "96778",

    ste_name: "HI",
  },
  {
    zip_code: "96929",

    ste_name: "GU",
  },
  {
    zip_code: "96932",

    ste_name: "GU",
  },
  {
    zip_code: "97326",

    ste_name: "OR",
  },
  {
    zip_code: "97350",

    ste_name: "OR",
  },
  {
    zip_code: "97380",

    ste_name: "OR",
  },
  {
    zip_code: "97396",

    ste_name: "OR",
  },
  {
    zip_code: "97403",

    ste_name: "OR",
  },
  {
    zip_code: "97424",

    ste_name: "OR",
  },
  {
    zip_code: "97479",

    ste_name: "OR",
  },
  {
    zip_code: "97480",

    ste_name: "OR",
  },
  {
    zip_code: "97503",

    ste_name: "OR",
  },
  {
    zip_code: "97534",

    ste_name: "OR",
  },
  {
    zip_code: "97604",

    ste_name: "OR",
  },
  {
    zip_code: "97711",

    ste_name: "OR",
  },
  {
    zip_code: "97823",

    ste_name: "OR",
  },
  {
    zip_code: "97857",

    ste_name: "OR",
  },
  {
    zip_code: "97905",

    ste_name: "OR",
  },
  {
    zip_code: "98010",

    ste_name: "WA",
  },
  {
    zip_code: "98036",

    ste_name: "WA",
  },
  {
    zip_code: "98039",

    ste_name: "WA",
  },
  {
    zip_code: "98087",

    ste_name: "WA",
  },
  {
    zip_code: "98105",

    ste_name: "WA",
  },
  {
    zip_code: "98207",

    ste_name: "WA",
  },
  {
    zip_code: "98273",

    ste_name: "WA",
  },
  {
    zip_code: "98274",

    ste_name: "WA",
  },
  {
    zip_code: "98321",

    ste_name: "WA",
  },
  {
    zip_code: "98327",

    ste_name: "WA",
  },
  {
    zip_code: "98332",

    ste_name: "WA",
  },
  {
    zip_code: "98342",

    ste_name: "WA",
  },
  {
    zip_code: "58750",

    ste_name: "ND",
  },
  {
    zip_code: "58778",

    ste_name: "ND",
  },
  {
    zip_code: "58785",

    ste_name: "ND",
  },
  {
    zip_code: "58843",

    ste_name: "ND",
  },
  {
    zip_code: "59046",

    ste_name: "MT",
  },
  {
    zip_code: "59086",

    ste_name: "MT",
  },
  {
    zip_code: "59215",

    ste_name: "MT",
  },
  {
    zip_code: "59223",

    ste_name: "MT",
  },
  {
    zip_code: "59311",

    ste_name: "MT",
  },
  {
    zip_code: "59330",

    ste_name: "MT",
  },
  {
    zip_code: "59440",

    ste_name: "MT",
  },
  {
    zip_code: "59442",

    ste_name: "MT",
  },
  {
    zip_code: "59531",

    ste_name: "MT",
  },
  {
    zip_code: "59602",

    ste_name: "MT",
  },
  {
    zip_code: "59633",

    ste_name: "MT",
  },
  {
    zip_code: "59725",

    ste_name: "MT",
  },
  {
    zip_code: "59752",

    ste_name: "MT",
  },
  {
    zip_code: "59847",

    ste_name: "MT",
  },
  {
    zip_code: "59859",

    ste_name: "MT",
  },
  {
    zip_code: "59901",

    ste_name: "MT",
  },
  {
    zip_code: "60012",

    ste_name: "IL",
  },
  {
    zip_code: "60013",

    ste_name: "IL",
  },
  {
    zip_code: "60104",

    ste_name: "IL",
  },
  {
    zip_code: "60123",

    ste_name: "IL",
  },
  {
    zip_code: "60190",

    ste_name: "IL",
  },
  {
    zip_code: "60465",

    ste_name: "IL",
  },
  {
    zip_code: "60643",

    ste_name: "IL",
  },
  {
    zip_code: "60647",

    ste_name: "IL",
  },
  {
    zip_code: "60921",

    ste_name: "IL",
  },
  {
    zip_code: "60935",

    ste_name: "IL",
  },
  {
    zip_code: "60958",

    ste_name: "IL",
  },
  {
    zip_code: "61013",

    ste_name: "IL",
  },
  {
    zip_code: "61051",

    ste_name: "IL",
  },
  {
    zip_code: "61258",

    ste_name: "IL",
  },
  {
    zip_code: "61378",

    ste_name: "IL",
  },
  {
    zip_code: "61428",

    ste_name: "IL",
  },
  {
    zip_code: "61734",

    ste_name: "IL",
  },
  {
    zip_code: "61816",

    ste_name: "IL",
  },
  {
    zip_code: "61910",

    ste_name: "IL",
  },
  {
    zip_code: "61933",

    ste_name: "IL",
  },
  {
    zip_code: "62011",

    ste_name: "IL",
  },
  {
    zip_code: "62021",

    ste_name: "IL",
  },
  {
    zip_code: "62058",

    ste_name: "IL",
  },
  {
    zip_code: "62205",

    ste_name: "IL",
  },
  {
    zip_code: "62261",

    ste_name: "IL",
  },
  {
    zip_code: "62281",

    ste_name: "IL",
  },
  {
    zip_code: "62336",

    ste_name: "IL",
  },
  {
    zip_code: "62420",

    ste_name: "IL",
  },
  {
    zip_code: "62423",

    ste_name: "IL",
  },
  {
    zip_code: "62425",

    ste_name: "IL",
  },
  {
    zip_code: "62554",

    ste_name: "IL",
  },
  {
    zip_code: "62573",

    ste_name: "IL",
  },
  {
    zip_code: "62624",

    ste_name: "IL",
  },
  {
    zip_code: "62693",

    ste_name: "IL",
  },
  {
    zip_code: "62711",

    ste_name: "IL",
  },
  {
    zip_code: "62815",

    ste_name: "IL",
  },
  {
    zip_code: "62835",

    ste_name: "IL",
  },
  {
    zip_code: "62903",

    ste_name: "IL",
  },
  {
    zip_code: "62915",

    ste_name: "IL",
  },
  {
    zip_code: "62953",

    ste_name: "IL",
  },
  {
    zip_code: "63013",

    ste_name: "MO",
  },
  {
    zip_code: "63030",

    ste_name: "MO",
  },
  {
    zip_code: "63087",

    ste_name: "MO",
  },
  {
    zip_code: "63501",

    ste_name: "MO",
  },
  {
    zip_code: "63622",

    ste_name: "MO",
  },
  {
    zip_code: "63631",

    ste_name: "MO",
  },
  {
    zip_code: "63654",

    ste_name: "MO",
  },
  {
    zip_code: "64078",

    ste_name: "MO",
  },
  {
    zip_code: "64083",

    ste_name: "MO",
  },
  {
    zip_code: "64132",

    ste_name: "MO",
  },
  {
    zip_code: "64430",

    ste_name: "MO",
  },
  {
    zip_code: "64455",

    ste_name: "MO",
  },
  {
    zip_code: "64468",

    ste_name: "MO",
  },
  {
    zip_code: "64477",

    ste_name: "MO",
  },
  {
    zip_code: "64682",

    ste_name: "MO",
  },
  {
    zip_code: "64832",

    ste_name: "MO",
  },
  {
    zip_code: "64863",

    ste_name: "MO",
  },
  {
    zip_code: "64874",

    ste_name: "MO",
  },
  {
    zip_code: "65063",

    ste_name: "MO",
  },
  {
    zip_code: "65069",

    ste_name: "MO",
  },
  {
    zip_code: "65079",

    ste_name: "MO",
  },
  {
    zip_code: "65083",

    ste_name: "MO",
  },
  {
    zip_code: "65201",

    ste_name: "MO",
  },
  {
    zip_code: "65250",

    ste_name: "MO",
  },
  {
    zip_code: "65251",

    ste_name: "MO",
  },
  {
    zip_code: "65261",

    ste_name: "MO",
  },
  {
    zip_code: "65270",

    ste_name: "MO",
  },
  {
    zip_code: "65285",

    ste_name: "MO",
  },
  {
    zip_code: "65610",

    ste_name: "MO",
  },
  {
    zip_code: "65669",

    ste_name: "MO",
  },
  {
    zip_code: "65715",

    ste_name: "MO",
  },
  {
    zip_code: "65759",

    ste_name: "MO",
  },
  {
    zip_code: "65760",

    ste_name: "MO",
  },
  {
    zip_code: "65803",

    ste_name: "MO",
  },
  {
    zip_code: "66002",

    ste_name: "KS",
  },
  {
    zip_code: "66062",

    ste_name: "KS",
  },
  {
    zip_code: "66202",

    ste_name: "KS",
  },
  {
    zip_code: "66532",

    ste_name: "KS",
  },
  {
    zip_code: "66550",

    ste_name: "KS",
  },
  {
    zip_code: "66605",

    ste_name: "KS",
  },
  {
    zip_code: "66614",

    ste_name: "KS",
  },
  {
    zip_code: "66724",

    ste_name: "KS",
  },
  {
    zip_code: "66735",

    ste_name: "KS",
  },
  {
    zip_code: "66743",

    ste_name: "KS",
  },
  {
    zip_code: "66754",

    ste_name: "KS",
  },
  {
    zip_code: "66860",

    ste_name: "KS",
  },
  {
    zip_code: "66870",

    ste_name: "KS",
  },
  {
    zip_code: "66937",

    ste_name: "KS",
  },
  {
    zip_code: "67055",

    ste_name: "KS",
  },
  {
    zip_code: "67058",

    ste_name: "KS",
  },
  {
    zip_code: "67131",

    ste_name: "KS",
  },
  {
    zip_code: "67260",

    ste_name: "KS",
  },
  {
    zip_code: "67351",

    ste_name: "KS",
  },
  {
    zip_code: "67444",

    ste_name: "KS",
  },
  {
    zip_code: "67456",

    ste_name: "KS",
  },
  {
    zip_code: "67544",

    ste_name: "KS",
  },
  {
    zip_code: "67843",

    ste_name: "KS",
  },
  {
    zip_code: "67855",

    ste_name: "KS",
  },
  {
    zip_code: "68059",

    ste_name: "NE",
  },
  {
    zip_code: "68063",

    ste_name: "NE",
  },
  {
    zip_code: "68106",

    ste_name: "NE",
  },
  {
    zip_code: "68122",

    ste_name: "NE",
  },
  {
    zip_code: "68127",

    ste_name: "NE",
  },
  {
    zip_code: "68136",

    ste_name: "NE",
  },
  {
    zip_code: "68368",

    ste_name: "NE",
  },
  {
    zip_code: "68382",

    ste_name: "NE",
  },
  {
    zip_code: "68407",

    ste_name: "NE",
  },
  {
    zip_code: "68443",

    ste_name: "NE",
  },
  {
    zip_code: "68453",

    ste_name: "NE",
  },
  {
    zip_code: "68660",

    ste_name: "NE",
  },
  {
    zip_code: "68755",

    ste_name: "NE",
  },
  {
    zip_code: "68776",

    ste_name: "NE",
  },
  {
    zip_code: "68833",

    ste_name: "NE",
  },
  {
    zip_code: "68841",

    ste_name: "NE",
  },
  {
    zip_code: "68849",

    ste_name: "NE",
  },
  {
    zip_code: "68858",

    ste_name: "NE",
  },
  {
    zip_code: "69101",

    ste_name: "NE",
  },
  {
    zip_code: "69135",

    ste_name: "NE",
  },
  {
    zip_code: "69148",

    ste_name: "NE",
  },
  {
    zip_code: "69162",

    ste_name: "NE",
  },
  {
    zip_code: "69354",

    ste_name: "NE",
  },
  {
    zip_code: "70040",

    ste_name: "LA",
  },
  {
    zip_code: "70119",

    ste_name: "LA",
  },
  {
    zip_code: "70461",

    ste_name: "LA",
  },
  {
    zip_code: "70466",

    ste_name: "LA",
  },
  {
    zip_code: "70605",

    ste_name: "LA",
  },
  {
    zip_code: "70747",

    ste_name: "LA",
  },
  {
    zip_code: "70757",

    ste_name: "LA",
  },
  {
    zip_code: "70769",

    ste_name: "LA",
  },
  {
    zip_code: "70774",

    ste_name: "LA",
  },
  {
    zip_code: "70814",

    ste_name: "LA",
  },
  {
    zip_code: "71006",

    ste_name: "LA",
  },
  {
    zip_code: "71024",

    ste_name: "LA",
  },
  {
    zip_code: "71277",

    ste_name: "LA",
  },
  {
    zip_code: "71279",

    ste_name: "LA",
  },
  {
    zip_code: "71303",

    ste_name: "LA",
  },
  {
    zip_code: "71438",

    ste_name: "LA",
  },
  {
    zip_code: "71639",

    ste_name: "AR",
  },
  {
    zip_code: "71862",

    ste_name: "AR",
  },
  {
    zip_code: "71960",

    ste_name: "AR",
  },
  {
    zip_code: "72041",

    ste_name: "AR",
  },
  {
    zip_code: "72069",

    ste_name: "AR",
  },
  {
    zip_code: "72085",

    ste_name: "AR",
  },
  {
    zip_code: "72112",

    ste_name: "AR",
  },
  {
    zip_code: "72116",

    ste_name: "AR",
  },
  {
    zip_code: "72127",

    ste_name: "AR",
  },
  {
    zip_code: "72207",

    ste_name: "AR",
  },
  {
    zip_code: "72340",

    ste_name: "AR",
  },
  {
    zip_code: "72348",

    ste_name: "AR",
  },
  {
    zip_code: "72354",

    ste_name: "AR",
  },
  {
    zip_code: "72444",

    ste_name: "AR",
  },
  {
    zip_code: "72533",

    ste_name: "AR",
  },
  {
    zip_code: "72564",

    ste_name: "AR",
  },
  {
    zip_code: "72585",

    ste_name: "AR",
  },
  {
    zip_code: "72863",

    ste_name: "AR",
  },
  {
    zip_code: "72937",

    ste_name: "AR",
  },
  {
    zip_code: "73036",

    ste_name: "OK",
  },
  {
    zip_code: "73040",

    ste_name: "OK",
  },
  {
    zip_code: "73048",

    ste_name: "OK",
  },
  {
    zip_code: "73057",

    ste_name: "OK",
  },
  {
    zip_code: "73071",

    ste_name: "OK",
  },
  {
    zip_code: "73433",

    ste_name: "OK",
  },
  {
    zip_code: "73441",

    ste_name: "OK",
  },
  {
    zip_code: "73840",

    ste_name: "OK",
  },
  {
    zip_code: "73937",

    ste_name: "OK",
  },
  {
    zip_code: "74360",

    ste_name: "OK",
  },
  {
    zip_code: "74435",

    ste_name: "OK",
  },
  {
    zip_code: "74442",

    ste_name: "OK",
  },
  {
    zip_code: "74472",

    ste_name: "OK",
  },
  {
    zip_code: "74558",

    ste_name: "OK",
  },
  {
    zip_code: "74764",

    ste_name: "OK",
  },
  {
    zip_code: "74844",

    ste_name: "OK",
  },
  {
    zip_code: "74945",

    ste_name: "OK",
  },
  {
    zip_code: "74957",

    ste_name: "OK",
  },
  {
    zip_code: "75067",

    ste_name: "TX",
  },
  {
    zip_code: "75078",

    ste_name: "TX",
  },
  {
    zip_code: "75140",

    ste_name: "TX",
  },
  {
    zip_code: "75146",

    ste_name: "TX",
  },
  {
    zip_code: "75152",

    ste_name: "TX",
  },
  {
    zip_code: "75172",

    ste_name: "TX",
  },
  {
    zip_code: "75234",

    ste_name: "TX",
  },
  {
    zip_code: "75248",

    ste_name: "TX",
  },
  {
    zip_code: "75450",

    ste_name: "TX",
  },
  {
    zip_code: "75455",

    ste_name: "TX",
  },
  {
    zip_code: "75641",

    ste_name: "TX",
  },
  {
    zip_code: "75668",

    ste_name: "TX",
  },
  {
    zip_code: "75709",

    ste_name: "TX",
  },
  {
    zip_code: "75758",

    ste_name: "TX",
  },
  {
    zip_code: "75930",

    ste_name: "TX",
  },
  {
    zip_code: "75974",

    ste_name: "TX",
  },
  {
    zip_code: "76040",

    ste_name: "TX",
  },
  {
    zip_code: "76066",

    ste_name: "TX",
  },
  {
    zip_code: "76140",

    ste_name: "TX",
  },
  {
    zip_code: "76164",

    ste_name: "TX",
  },
  {
    zip_code: "76305",

    ste_name: "TX",
  },
  {
    zip_code: "76354",

    ste_name: "TX",
  },
  {
    zip_code: "76530",

    ste_name: "TX",
  },
  {
    zip_code: "76711",

    ste_name: "TX",
  },
  {
    zip_code: "76940",

    ste_name: "TX",
  },
  {
    zip_code: "76953",

    ste_name: "TX",
  },
  {
    zip_code: "77022",

    ste_name: "TX",
  },
  {
    zip_code: "77034",

    ste_name: "TX",
  },
  {
    zip_code: "77098",

    ste_name: "TX",
  },
  {
    zip_code: "77382",

    ste_name: "TX",
  },
  {
    zip_code: "77401",

    ste_name: "TX",
  },
  {
    zip_code: "77422",

    ste_name: "TX",
  },
  {
    zip_code: "77471",

    ste_name: "TX",
  },
  {
    zip_code: "77481",

    ste_name: "TX",
  },
  {
    zip_code: "77532",

    ste_name: "TX",
  },
  {
    zip_code: "77611",

    ste_name: "TX",
  },
  {
    zip_code: "77613",

    ste_name: "TX",
  },
  {
    zip_code: "77664",

    ste_name: "TX",
  },
  {
    zip_code: "77803",

    ste_name: "TX",
  },
  {
    zip_code: "77905",

    ste_name: "TX",
  },
  {
    zip_code: "77994",

    ste_name: "TX",
  },
  {
    zip_code: "78016",

    ste_name: "TX",
  },
  {
    zip_code: "78046",

    ste_name: "TX",
  },
  {
    zip_code: "78067",

    ste_name: "TX",
  },
  {
    zip_code: "78362",

    ste_name: "TX",
  },
  {
    zip_code: "78368",

    ste_name: "TX",
  },
  {
    zip_code: "78369",

    ste_name: "TX",
  },
  {
    zip_code: "78372",

    ste_name: "TX",
  },
  {
    zip_code: "78408",

    ste_name: "TX",
  },
  {
    zip_code: "78419",

    ste_name: "TX",
  },
  {
    zip_code: "78633",

    ste_name: "TX",
  },
  {
    zip_code: "78726",

    ste_name: "TX",
  },
  {
    zip_code: "78827",

    ste_name: "TX",
  },
  {
    zip_code: "79007",

    ste_name: "TX",
  },
  {
    zip_code: "79034",

    ste_name: "TX",
  },
  {
    zip_code: "79035",

    ste_name: "TX",
  },
  {
    zip_code: "79040",

    ste_name: "TX",
  },
  {
    zip_code: "79065",

    ste_name: "TX",
  },
  {
    zip_code: "79096",

    ste_name: "TX",
  },
  {
    zip_code: "79227",

    ste_name: "TX",
  },
  {
    zip_code: "79240",

    ste_name: "TX",
  },
  {
    zip_code: "79241",

    ste_name: "TX",
  },
  {
    zip_code: "79363",

    ste_name: "TX",
  },
  {
    zip_code: "79379",

    ste_name: "TX",
  },
  {
    zip_code: "79401",

    ste_name: "TX",
  },
  {
    zip_code: "80012",

    ste_name: "CO",
  },
  {
    zip_code: "80030",

    ste_name: "CO",
  },
  {
    zip_code: "80130",

    ste_name: "CO",
  },
  {
    zip_code: "80137",

    ste_name: "CO",
  },
  {
    zip_code: "80230",

    ste_name: "CO",
  },
  {
    zip_code: "80425",

    ste_name: "CO",
  },
  {
    zip_code: "80603",

    ste_name: "CO",
  },
  {
    zip_code: "80649",

    ste_name: "CO",
  },
  {
    zip_code: "80652",

    ste_name: "CO",
  },
  {
    zip_code: "80701",

    ste_name: "CO",
  },
  {
    zip_code: "80734",

    ste_name: "CO",
  },
  {
    zip_code: "80747",

    ste_name: "CO",
  },
  {
    zip_code: "80813",

    ste_name: "CO",
  },
  {
    zip_code: "80814",

    ste_name: "CO",
  },
  {
    zip_code: "80830",

    ste_name: "CO",
  },
  {
    zip_code: "80924",

    ste_name: "CO",
  },
  {
    zip_code: "81063",

    ste_name: "CO",
  },
  {
    zip_code: "81638",

    ste_name: "CO",
  },
  {
    zip_code: "82005",

    ste_name: "WY",
  },
  {
    zip_code: "82058",

    ste_name: "WY",
  },
  {
    zip_code: "82082",

    ste_name: "WY",
  },
  {
    zip_code: "82510",

    ste_name: "WY",
  },
  {
    zip_code: "82938",

    ste_name: "WY",
  },
  {
    zip_code: "83428",

    ste_name: "ID",
  },
  {
    zip_code: "83545",

    ste_name: "ID",
  },
  {
    zip_code: "83552",

    ste_name: "ID",
  },
  {
    zip_code: "83808",

    ste_name: "ID",
  },
  {
    zip_code: "83821",

    ste_name: "ID",
  },
  {
    zip_code: "83833",

    ste_name: "ID",
  },
  {
    zip_code: "83846",

    ste_name: "ID",
  },
  {
    zip_code: "84032",

    ste_name: "UT",
  },
  {
    zip_code: "84095",

    ste_name: "UT",
  },
  {
    zip_code: "84105",

    ste_name: "UT",
  },
  {
    zip_code: "84308",

    ste_name: "UT",
  },
  {
    zip_code: "84414",

    ste_name: "UT",
  },
  {
    zip_code: "84660",

    ste_name: "UT",
  },
  {
    zip_code: "84747",

    ste_name: "UT",
  },
  {
    zip_code: "84775",

    ste_name: "UT",
  },
  {
    zip_code: "85017",

    ste_name: "AZ",
  },
  {
    zip_code: "85019",

    ste_name: "AZ",
  },
  {
    zip_code: "85024",

    ste_name: "AZ",
  },
  {
    zip_code: "85035",

    ste_name: "AZ",
  },
  {
    zip_code: "85234",

    ste_name: "AZ",
  },
  {
    zip_code: "85325",

    ste_name: "AZ",
  },
  {
    zip_code: "85361",

    ste_name: "AZ",
  },
  {
    zip_code: "85365",

    ste_name: "AZ",
  },
  {
    zip_code: "85658",

    ste_name: "AZ",
  },
  {
    zip_code: "85735",

    ste_name: "AZ",
  },
  {
    zip_code: "85941",

    ste_name: "AZ",
  },
  {
    zip_code: "86016",

    ste_name: "AZ",
  },
  {
    zip_code: "86038",

    ste_name: "AZ",
  },
  {
    zip_code: "86538",

    ste_name: "AZ",
  },
  {
    zip_code: "86544",

    ste_name: "AZ",
  },
  {
    zip_code: "87001",

    ste_name: "NM",
  },
  {
    zip_code: "87012",

    ste_name: "NM",
  },
  {
    zip_code: "87032",

    ste_name: "NM",
  },
  {
    zip_code: "87047",

    ste_name: "NM",
  },
  {
    zip_code: "87108",

    ste_name: "NM",
  },
  {
    zip_code: "87301",

    ste_name: "NM",
  },
  {
    zip_code: "87418",

    ste_name: "NM",
  },
  {
    zip_code: "87501",

    ste_name: "NM",
  },
  {
    zip_code: "87712",

    ste_name: "NM",
  },
  {
    zip_code: "87730",

    ste_name: "NM",
  },
  {
    zip_code: "87753",

    ste_name: "NM",
  },
  {
    zip_code: "87940",

    ste_name: "NM",
  },
  {
    zip_code: "88003",

    ste_name: "NM",
  },
  {
    zip_code: "88005",

    ste_name: "NM",
  },
  {
    zip_code: "88007",

    ste_name: "NM",
  },
  {
    zip_code: "88022",

    ste_name: "NM",
  },
  {
    zip_code: "88055",

    ste_name: "NM",
  },
  {
    zip_code: "88134",

    ste_name: "NM",
  },
  {
    zip_code: "88255",

    ste_name: "NM",
  },
  {
    zip_code: "88341",

    ste_name: "NM",
  },
  {
    zip_code: "89008",

    ste_name: "NV",
  },
  {
    zip_code: "89020",

    ste_name: "NV",
  },
  {
    zip_code: "89029",

    ste_name: "NV",
  },
  {
    zip_code: "89101",

    ste_name: "NV",
  },
  {
    zip_code: "89122",

    ste_name: "NV",
  },
  {
    zip_code: "89156",

    ste_name: "NV",
  },
  {
    zip_code: "89425",

    ste_name: "NV",
  },
  {
    zip_code: "89441",

    ste_name: "NV",
  },
  {
    zip_code: "612",

    ste_name: "PR",
  },
  {
    zip_code: "641",

    ste_name: "PR",
  },
  {
    zip_code: "1010",

    ste_name: "MA",
  },
  {
    zip_code: "1013",

    ste_name: "MA",
  },
  {
    zip_code: "1056",

    ste_name: "MA",
  },
  {
    zip_code: "1086",

    ste_name: "MA",
  },
  {
    zip_code: "1222",

    ste_name: "MA",
  },
  {
    zip_code: "1230",

    ste_name: "MA",
  },
  {
    zip_code: "1264",

    ste_name: "MA",
  },
  {
    zip_code: "1342",

    ste_name: "MA",
  },
  {
    zip_code: "1343",

    ste_name: "MA",
  },
  {
    zip_code: "1522",

    ste_name: "MA",
  },
  {
    zip_code: "1525",

    ste_name: "MA",
  },
  {
    zip_code: "1810",

    ste_name: "MA",
  },
  {
    zip_code: "1840",

    ste_name: "MA",
  },
  {
    zip_code: "2093",

    ste_name: "MA",
  },
  {
    zip_code: "2131",

    ste_name: "MA",
  },
  {
    zip_code: "2132",

    ste_name: "MA",
  },
  {
    zip_code: "2330",

    ste_name: "MA",
  },
  {
    zip_code: "2379",

    ste_name: "MA",
  },
  {
    zip_code: "2451",

    ste_name: "MA",
  },
  {
    zip_code: "2553",

    ste_name: "MA",
  },
  {
    zip_code: "2564",

    ste_name: "MA",
  },
  {
    zip_code: "2630",

    ste_name: "MA",
  },
  {
    zip_code: "2638",

    ste_name: "MA",
  },
  {
    zip_code: "2651",

    ste_name: "MA",
  },
  {
    zip_code: "2740",

    ste_name: "MA",
  },
  {
    zip_code: "2906",

    ste_name: "RI",
  },
  {
    zip_code: "3031",

    ste_name: "NH",
  },
  {
    zip_code: "3049",

    ste_name: "NH",
  },
  {
    zip_code: "3070",

    ste_name: "NH",
  },
  {
    zip_code: "3103",

    ste_name: "NH",
  },
  {
    zip_code: "3229",

    ste_name: "NH",
  },
  {
    zip_code: "3290",

    ste_name: "NH",
  },
  {
    zip_code: "3457",

    ste_name: "NH",
  },
  {
    zip_code: "3601",

    ste_name: "NH",
  },
  {
    zip_code: "3870",

    ste_name: "NH",
  },
  {
    zip_code: "4072",

    ste_name: "ME",
  },
  {
    zip_code: "4088",

    ste_name: "ME",
  },
  {
    zip_code: "4427",

    ste_name: "ME",
  },
  {
    zip_code: "4463",

    ste_name: "ME",
  },
  {
    zip_code: "4563",

    ste_name: "ME",
  },
  {
    zip_code: "4658",

    ste_name: "ME",
  },
  {
    zip_code: "4662",

    ste_name: "ME",
  },
  {
    zip_code: "4666",

    ste_name: "ME",
  },
  {
    zip_code: "4686",

    ste_name: "ME",
  },
  {
    zip_code: "4765",

    ste_name: "ME",
  },
  {
    zip_code: "4776",

    ste_name: "ME",
  },
  {
    zip_code: "4860",

    ste_name: "ME",
  },
  {
    zip_code: "4918",

    ste_name: "ME",
  },
  {
    zip_code: "4970",

    ste_name: "ME",
  },
  {
    zip_code: "4975",

    ste_name: "ME",
  },
  {
    zip_code: "5356",

    ste_name: "VT",
  },
  {
    zip_code: "5701",

    ste_name: "VT",
  },
  {
    zip_code: "5764",

    ste_name: "VT",
  },
  {
    zip_code: "5862",

    ste_name: "VT",
  },
  {
    zip_code: "6092",

    ste_name: "CT",
  },
  {
    zip_code: "6238",

    ste_name: "CT",
  },
  {
    zip_code: "6336",

    ste_name: "CT",
  },
  {
    zip_code: "6377",

    ste_name: "CT",
  },
  {
    zip_code: "6450",

    ste_name: "CT",
  },
  {
    zip_code: "6483",

    ste_name: "CT",
  },
  {
    zip_code: "6524",

    ste_name: "CT",
  },
  {
    zip_code: "6831",

    ste_name: "CT",
  },
  {
    zip_code: "6853",

    ste_name: "CT",
  },
  {
    zip_code: "7016",

    ste_name: "NJ",
  },
  {
    zip_code: "7027",

    ste_name: "NJ",
  },
  {
    zip_code: "7057",

    ste_name: "NJ",
  },
  {
    zip_code: "7086",

    ste_name: "NJ",
  },
  {
    zip_code: "7205",

    ste_name: "NJ",
  },
  {
    zip_code: "7430",

    ste_name: "NJ",
  },
  {
    zip_code: "7608",

    ste_name: "NJ",
  },
  {
    zip_code: "7734",

    ste_name: "NJ",
  },
  {
    zip_code: "7735",

    ste_name: "NJ",
  },
  {
    zip_code: "7756",

    ste_name: "NJ",
  },
  {
    zip_code: "7821",

    ste_name: "NJ",
  },
  {
    zip_code: "8105",

    ste_name: "NJ",
  },
  {
    zip_code: "8247",

    ste_name: "NJ",
  },
  {
    zip_code: "8248",

    ste_name: "NJ",
  },
  {
    zip_code: "8270",

    ste_name: "NJ",
  },
  {
    zip_code: "8345",

    ste_name: "NJ",
  },
  {
    zip_code: "8734",

    ste_name: "NJ",
  },
  {
    zip_code: "8752",

    ste_name: "NJ",
  },
  {
    zip_code: "8812",

    ste_name: "NJ",
  },
  {
    zip_code: "8826",

    ste_name: "NJ",
  },
  {
    zip_code: "10005",

    ste_name: "NY",
  },
  {
    zip_code: "10007",

    ste_name: "NY",
  },
  {
    zip_code: "10026",

    ste_name: "NY",
  },
  {
    zip_code: "10065",

    ste_name: "NY",
  },
  {
    zip_code: "10177",

    ste_name: "NY",
  },
  {
    zip_code: "10308",

    ste_name: "NY",
  },
  {
    zip_code: "10460",

    ste_name: "NY",
  },
  {
    zip_code: "10467",

    ste_name: "NY",
  },
  {
    zip_code: "10532",

    ste_name: "NY",
  },
  {
    zip_code: "10580",

    ste_name: "NY",
  },
  {
    zip_code: "10598",

    ste_name: "NY",
  },
  {
    zip_code: "10915",

    ste_name: "NY",
  },
  {
    zip_code: "11040",

    ste_name: "NY",
  },
  {
    zip_code: "11219",

    ste_name: "NY",
  },
  {
    zip_code: "11418",

    ste_name: "NY",
  },
  {
    zip_code: "11516",

    ste_name: "NY",
  },
  {
    zip_code: "11558",

    ste_name: "NY",
  },
  {
    zip_code: "11753",

    ste_name: "NY",
  },
  {
    zip_code: "11763",

    ste_name: "NY",
  },
  {
    zip_code: "11961",

    ste_name: "NY",
  },
  {
    zip_code: "12052",

    ste_name: "NY",
  },
  {
    zip_code: "12058",

    ste_name: "NY",
  },
  {
    zip_code: "12061",

    ste_name: "NY",
  },
  {
    zip_code: "12063",

    ste_name: "NY",
  },
  {
    zip_code: "12071",

    ste_name: "NY",
  },
  {
    zip_code: "12157",

    ste_name: "NY",
  },
  {
    zip_code: "12196",

    ste_name: "NY",
  },
  {
    zip_code: "12411",

    ste_name: "NY",
  },
  {
    zip_code: "12480",

    ste_name: "NY",
  },
  {
    zip_code: "12491",

    ste_name: "NY",
  },
  {
    zip_code: "12501",

    ste_name: "NY",
  },
  {
    zip_code: "12520",

    ste_name: "NY",
  },
  {
    zip_code: "12550",

    ste_name: "NY",
  },
  {
    zip_code: "12561",

    ste_name: "NY",
  },
  {
    zip_code: "12564",

    ste_name: "NY",
  },
  {
    zip_code: "12585",

    ste_name: "NY",
  },
  {
    zip_code: "12721",

    ste_name: "NY",
  },
  {
    zip_code: "12808",

    ste_name: "NY",
  },
  {
    zip_code: "12812",

    ste_name: "NY",
  },
  {
    zip_code: "12827",

    ste_name: "NY",
  },
  {
    zip_code: "12912",

    ste_name: "NY",
  },
  {
    zip_code: "12998",

    ste_name: "NY",
  },
  {
    zip_code: "13788",

    ste_name: "NY",
  },
  {
    zip_code: "13811",

    ste_name: "NY",
  },
  {
    zip_code: "13849",

    ste_name: "NY",
  },
  {
    zip_code: "14086",

    ste_name: "NY",
  },
  {
    zip_code: "14105",

    ste_name: "NY",
  },
  {
    zip_code: "14132",

    ste_name: "NY",
  },
  {
    zip_code: "14303",

    ste_name: "NY",
  },
  {
    zip_code: "14466",

    ste_name: "NY",
  },
  {
    zip_code: "14470",

    ste_name: "NY",
  },
  {
    zip_code: "14477",

    ste_name: "NY",
  },
  {
    zip_code: "14514",

    ste_name: "NY",
  },
  {
    zip_code: "14526",

    ste_name: "NY",
  },
  {
    zip_code: "14555",

    ste_name: "NY",
  },
  {
    zip_code: "14617",

    ste_name: "NY",
  },
  {
    zip_code: "14820",

    ste_name: "NY",
  },
  {
    zip_code: "15015",

    ste_name: "PA",
  },
  {
    zip_code: "15068",

    ste_name: "PA",
  },
  {
    zip_code: "15129",

    ste_name: "PA",
  },
  {
    zip_code: "15241",

    ste_name: "PA",
  },
  {
    zip_code: "15341",

    ste_name: "PA",
  },
  {
    zip_code: "15563",

    ste_name: "PA",
  },
  {
    zip_code: "15641",

    ste_name: "PA",
  },
  {
    zip_code: "15725",

    ste_name: "PA",
  },
  {
    zip_code: "15734",

    ste_name: "PA",
  },
  {
    zip_code: "15739",

    ste_name: "PA",
  },
  {
    zip_code: "15772",

    ste_name: "PA",
  },
  {
    zip_code: "15823",

    ste_name: "PA",
  },
  {
    zip_code: "15846",

    ste_name: "PA",
  },
  {
    zip_code: "15937",

    ste_name: "PA",
  },
  {
    zip_code: "16056",

    ste_name: "PA",
  },
  {
    zip_code: "16123",

    ste_name: "PA",
  },
  {
    zip_code: "16160",

    ste_name: "PA",
  },
  {
    zip_code: "16228",

    ste_name: "PA",
  },
  {
    zip_code: "16238",

    ste_name: "PA",
  },
  {
    zip_code: "16335",

    ste_name: "PA",
  },
  {
    zip_code: "16370",

    ste_name: "PA",
  },
  {
    zip_code: "16730",

    ste_name: "PA",
  },
  {
    zip_code: "16827",

    ste_name: "PA",
  },
  {
    zip_code: "16838",

    ste_name: "PA",
  },
  {
    zip_code: "17040",

    ste_name: "PA",
  },
  {
    zip_code: "17043",

    ste_name: "PA",
  },
  {
    zip_code: "17055",

    ste_name: "PA",
  },
  {
    zip_code: "17214",

    ste_name: "PA",
  },
  {
    zip_code: "17345",

    ste_name: "PA",
  },
  {
    zip_code: "17349",

    ste_name: "PA",
  },
  {
    zip_code: "17512",

    ste_name: "PA",
  },
  {
    zip_code: "17565",

    ste_name: "PA",
  },
  {
    zip_code: "17581",

    ste_name: "PA",
  },
  {
    zip_code: "17752",

    ste_name: "PA",
  },
  {
    zip_code: "17760",

    ste_name: "PA",
  },
  {
    zip_code: "17923",

    ste_name: "PA",
  },
  {
    zip_code: "18037",

    ste_name: "PA",
  },
  {
    zip_code: "18229",

    ste_name: "PA",
  },
  {
    zip_code: "19025",

    ste_name: "PA",
  },
  {
    zip_code: "19076",

    ste_name: "PA",
  },
  {
    zip_code: "19104",

    ste_name: "PA",
  },
  {
    zip_code: "19121",

    ste_name: "PA",
  },
  {
    zip_code: "19134",

    ste_name: "PA",
  },
  {
    zip_code: "19153",

    ste_name: "PA",
  },
  {
    zip_code: "19319",

    ste_name: "PA",
  },
  {
    zip_code: "19541",

    ste_name: "PA",
  },
  {
    zip_code: "19602",

    ste_name: "PA",
  },
  {
    zip_code: "19801",

    ste_name: "DE",
  },
  {
    zip_code: "19802",

    ste_name: "DE",
  },
  {
    zip_code: "19803",

    ste_name: "DE",
  },
  {
    zip_code: "19933",

    ste_name: "DE",
  },
  {
    zip_code: "19941",

    ste_name: "DE",
  },
  {
    zip_code: "19945",

    ste_name: "DE",
  },
  {
    zip_code: "20015",

    ste_name: "DC",
  },
  {
    zip_code: "20194",

    ste_name: "VA",
  },
  {
    zip_code: "20678",

    ste_name: "MD",
  },
  {
    zip_code: "20688",

    ste_name: "MD",
  },
  {
    zip_code: "20816",

    ste_name: "MD",
  },
  {
    zip_code: "20874",

    ste_name: "MD",
  },
  {
    zip_code: "21060",

    ste_name: "MD",
  },
  {
    zip_code: "21212",

    ste_name: "MD",
  },
  {
    zip_code: "21610",

    ste_name: "MD",
  },
  {
    zip_code: "21617",

    ste_name: "MD",
  },
  {
    zip_code: "21628",

    ste_name: "MD",
  },
  {
    zip_code: "21631",

    ste_name: "MD",
  },
  {
    zip_code: "21636",

    ste_name: "MD",
  },
  {
    zip_code: "21647",

    ste_name: "MD",
  },
  {
    zip_code: "21733",

    ste_name: "MD",
  },
  {
    zip_code: "21778",

    ste_name: "MD",
  },
  {
    zip_code: "21795",

    ste_name: "MD",
  },
  {
    zip_code: "21798",

    ste_name: "MD",
  },
  {
    zip_code: "21863",

    ste_name: "MD",
  },
  {
    zip_code: "21890",

    ste_name: "MD",
  },
  {
    zip_code: "21919",

    ste_name: "MD",
  },
  {
    zip_code: "22408",

    ste_name: "VA",
  },
  {
    zip_code: "22580",

    ste_name: "VA",
  },
  {
    zip_code: "22620",

    ste_name: "VA",
  },
  {
    zip_code: "22623",

    ste_name: "VA",
  },
  {
    zip_code: "22932",

    ste_name: "VA",
  },
  {
    zip_code: "23023",

    ste_name: "VA",
  },
  {
    zip_code: "23140",

    ste_name: "VA",
  },
  {
    zip_code: "23173",

    ste_name: "VA",
  },
  {
    zip_code: "23221",

    ste_name: "VA",
  },
  {
    zip_code: "23225",

    ste_name: "VA",
  },
  {
    zip_code: "23303",

    ste_name: "VA",
  },
  {
    zip_code: "23405",

    ste_name: "VA",
  },
  {
    zip_code: "23417",

    ste_name: "VA",
  },
  {
    zip_code: "23461",

    ste_name: "VA",
  },
  {
    zip_code: "23551",

    ste_name: "VA",
  },
  {
    zip_code: "23868",

    ste_name: "VA",
  },
  {
    zip_code: "24014",

    ste_name: "VA",
  },
  {
    zip_code: "24076",

    ste_name: "VA",
  },
  {
    zip_code: "24093",

    ste_name: "VA",
  },
  {
    zip_code: "24102",

    ste_name: "VA",
  },
  {
    zip_code: "24134",

    ste_name: "VA",
  },
  {
    zip_code: "24138",

    ste_name: "VA",
  },
  {
    zip_code: "24322",

    ste_name: "VA",
  },
  {
    zip_code: "24325",

    ste_name: "VA",
  },
  {
    zip_code: "24432",

    ste_name: "VA",
  },
  {
    zip_code: "24472",

    ste_name: "VA",
  },
  {
    zip_code: "24554",

    ste_name: "VA",
  },
  {
    zip_code: "24605",

    ste_name: "VA",
  },
  {
    zip_code: "24737",

    ste_name: "WV",
  },
  {
    zip_code: "24823",

    ste_name: "WV",
  },
  {
    zip_code: "24874",

    ste_name: "WV",
  },
  {
    zip_code: "25081",

    ste_name: "WV",
  },
  {
    zip_code: "25132",

    ste_name: "WV",
  },
  {
    zip_code: "25174",

    ste_name: "WV",
  },
  {
    zip_code: "25419",

    ste_name: "WV",
  },
  {
    zip_code: "25505",

    ste_name: "WV",
  },
  {
    zip_code: "25523",

    ste_name: "WV",
  },
  {
    zip_code: "25696",

    ste_name: "WV",
  },
  {
    zip_code: "25972",

    ste_name: "WV",
  },
  {
    zip_code: "25985",

    ste_name: "WV",
  },
  {
    zip_code: "26070",

    ste_name: "WV",
  },
  {
    zip_code: "26142",

    ste_name: "WV",
  },
  {
    zip_code: "26209",

    ste_name: "WV",
  },
  {
    zip_code: "26424",

    ste_name: "WV",
  },
  {
    zip_code: "26571",

    ste_name: "WV",
  },
  {
    zip_code: "26591",

    ste_name: "WV",
  },
  {
    zip_code: "26627",

    ste_name: "WV",
  },
  {
    zip_code: "26722",

    ste_name: "WV",
  },
  {
    zip_code: "27217",

    ste_name: "NC",
  },
  {
    zip_code: "27509",

    ste_name: "NC",
  },
  {
    zip_code: "27553",

    ste_name: "NC",
  },
  {
    zip_code: "27801",

    ste_name: "NC",
  },
  {
    zip_code: "27839",

    ste_name: "NC",
  },
  {
    zip_code: "27863",

    ste_name: "NC",
  },
  {
    zip_code: "27944",

    ste_name: "NC",
  },
  {
    zip_code: "27956",

    ste_name: "NC",
  },
  {
    zip_code: "27972",

    ste_name: "NC",
  },
  {
    zip_code: "28032",

    ste_name: "NC",
  },
  {
    zip_code: "28037",

    ste_name: "NC",
  },
  {
    zip_code: "28227",

    ste_name: "NC",
  },
  {
    zip_code: "28280",

    ste_name: "NC",
  },
  {
    zip_code: "28303",

    ste_name: "NC",
  },
  {
    zip_code: "28364",

    ste_name: "NC",
  },
  {
    zip_code: "28405",

    ste_name: "NC",
  },
  {
    zip_code: "28457",

    ste_name: "NC",
  },
  {
    zip_code: "28616",

    ste_name: "NC",
  },
  {
    zip_code: "28618",

    ste_name: "NC",
  },
  {
    zip_code: "28735",

    ste_name: "NC",
  },
  {
    zip_code: "28753",

    ste_name: "NC",
  },
  {
    zip_code: "28774",

    ste_name: "NC",
  },
  {
    zip_code: "29003",

    ste_name: "SC",
  },
  {
    zip_code: "29042",

    ste_name: "SC",
  },
  {
    zip_code: "29062",

    ste_name: "SC",
  },
  {
    zip_code: "29072",

    ste_name: "SC",
  },
  {
    zip_code: "29074",

    ste_name: "SC",
  },
  {
    zip_code: "29129",

    ste_name: "SC",
  },
  {
    zip_code: "29301",

    ste_name: "SC",
  },
  {
    zip_code: "29340",

    ste_name: "SC",
  },
  {
    zip_code: "29376",

    ste_name: "SC",
  },
  {
    zip_code: "29414",

    ste_name: "SC",
  },
  {
    zip_code: "29501",

    ste_name: "SC",
  },
  {
    zip_code: "29596",

    ste_name: "SC",
  },
  {
    zip_code: "29673",

    ste_name: "SC",
  },
  {
    zip_code: "29728",

    ste_name: "SC",
  },
  {
    zip_code: "29842",

    ste_name: "SC",
  },
  {
    zip_code: "29939",

    ste_name: "SC",
  },
  {
    zip_code: "30008",

    ste_name: "GA",
  },
  {
    zip_code: "30019",

    ste_name: "GA",
  },
  {
    zip_code: "30115",

    ste_name: "GA",
  },
  {
    zip_code: "30204",

    ste_name: "GA",
  },
  {
    zip_code: "30214",

    ste_name: "GA",
  },
  {
    zip_code: "30217",

    ste_name: "GA",
  },
  {
    zip_code: "30238",

    ste_name: "GA",
  },
  {
    zip_code: "30417",

    ste_name: "GA",
  },
  {
    zip_code: "30421",

    ste_name: "GA",
  },
  {
    zip_code: "30477",

    ste_name: "GA",
  },
  {
    zip_code: "30548",

    ste_name: "GA",
  },
  {
    zip_code: "30581",

    ste_name: "GA",
  },
  {
    zip_code: "30705",

    ste_name: "GA",
  },
  {
    zip_code: "30746",

    ste_name: "GA",
  },
  {
    zip_code: "30755",

    ste_name: "GA",
  },
  {
    zip_code: "30803",

    ste_name: "GA",
  },
  {
    zip_code: "30833",

    ste_name: "GA",
  },
  {
    zip_code: "58041",

    ste_name: "ND",
  },
  {
    zip_code: "58060",

    ste_name: "ND",
  },
  {
    zip_code: "58372",

    ste_name: "ND",
  },
  {
    zip_code: "58380",

    ste_name: "ND",
  },
  {
    zip_code: "58451",

    ste_name: "ND",
  },
  {
    zip_code: "7107",

    ste_name: "NJ",
  },
  {
    zip_code: "7438",

    ste_name: "NJ",
  },
  {
    zip_code: "7481",

    ste_name: "NJ",
  },
  {
    zip_code: "703",

    ste_name: "PR",
  },
  {
    zip_code: "739",

    ste_name: "PR",
  },
  {
    zip_code: "802",

    ste_name: "VI",
  },
  {
    zip_code: "1001",

    ste_name: "MA",
  },
  {
    zip_code: "1005",

    ste_name: "MA",
  },
  {
    zip_code: "1035",

    ste_name: "MA",
  },
  {
    zip_code: "1462",

    ste_name: "MA",
  },
  {
    zip_code: "1518",

    ste_name: "MA",
  },
  {
    zip_code: "1541",

    ste_name: "MA",
  },
  {
    zip_code: "1542",

    ste_name: "MA",
  },
  {
    zip_code: "1607",

    ste_name: "MA",
  },
  {
    zip_code: "1741",

    ste_name: "MA",
  },
  {
    zip_code: "1756",

    ste_name: "MA",
  },
  {
    zip_code: "1803",

    ste_name: "MA",
  },
  {
    zip_code: "1905",

    ste_name: "MA",
  },
  {
    zip_code: "1907",

    ste_name: "MA",
  },
  {
    zip_code: "2054",

    ste_name: "MA",
  },
  {
    zip_code: "2111",

    ste_name: "MA",
  },
  {
    zip_code: "2171",

    ste_name: "MA",
  },
  {
    zip_code: "2180",

    ste_name: "MA",
  },
  {
    zip_code: "2190",

    ste_name: "MA",
  },
  {
    zip_code: "2339",

    ste_name: "MA",
  },
  {
    zip_code: "2462",

    ste_name: "MA",
  },
  {
    zip_code: "2466",

    ste_name: "MA",
  },
  {
    zip_code: "2667",

    ste_name: "MA",
  },
  {
    zip_code: "2717",

    ste_name: "MA",
  },
  {
    zip_code: "2744",

    ste_name: "MA",
  },
  {
    zip_code: "2769",

    ste_name: "MA",
  },
  {
    zip_code: "2873",

    ste_name: "RI",
  },
  {
    zip_code: "2879",

    ste_name: "RI",
  },
  {
    zip_code: "2891",

    ste_name: "RI",
  },
  {
    zip_code: "2917",

    ste_name: "RI",
  },
  {
    zip_code: "3241",

    ste_name: "NH",
  },
  {
    zip_code: "3279",

    ste_name: "NH",
  },
  {
    zip_code: "3293",

    ste_name: "NH",
  },
  {
    zip_code: "3441",

    ste_name: "NH",
  },
  {
    zip_code: "3465",

    ste_name: "NH",
  },
  {
    zip_code: "3598",

    ste_name: "NH",
  },
  {
    zip_code: "3785",

    ste_name: "NH",
  },
  {
    zip_code: "3840",

    ste_name: "NH",
  },
  {
    zip_code: "4038",

    ste_name: "ME",
  },
  {
    zip_code: "4286",

    ste_name: "ME",
  },
  {
    zip_code: "4342",

    ste_name: "ME",
  },
  {
    zip_code: "4357",

    ste_name: "ME",
  },
  {
    zip_code: "4408",

    ste_name: "ME",
  },
  {
    zip_code: "4460",

    ste_name: "ME",
  },
  {
    zip_code: "4556",

    ste_name: "ME",
  },
  {
    zip_code: "4622",

    ste_name: "ME",
  },
  {
    zip_code: "4654",

    ste_name: "ME",
  },
  {
    zip_code: "4676",

    ste_name: "ME",
  },
  {
    zip_code: "4743",

    ste_name: "ME",
  },
  {
    zip_code: "4763",

    ste_name: "ME",
  },
  {
    zip_code: "4930",

    ste_name: "ME",
  },
  {
    zip_code: "4945",

    ste_name: "ME",
  },
  {
    zip_code: "5046",

    ste_name: "VT",
  },
  {
    zip_code: "5068",

    ste_name: "VT",
  },
  {
    zip_code: "5255",

    ste_name: "VT",
  },
  {
    zip_code: "5346",

    ste_name: "VT",
  },
  {
    zip_code: "5459",

    ste_name: "VT",
  },
  {
    zip_code: "5478",

    ste_name: "VT",
  },
  {
    zip_code: "5826",

    ste_name: "VT",
  },
  {
    zip_code: "5850",

    ste_name: "VT",
  },
  {
    zip_code: "6052",

    ste_name: "CT",
  },
  {
    zip_code: "6091",

    ste_name: "CT",
  },
  {
    zip_code: "6242",

    ste_name: "CT",
  },
  {
    zip_code: "6269",

    ste_name: "CT",
  },
  {
    zip_code: "6412",

    ste_name: "CT",
  },
  {
    zip_code: "6477",

    ste_name: "CT",
  },
  {
    zip_code: "6478",

    ste_name: "CT",
  },
  {
    zip_code: "6610",

    ste_name: "CT",
  },
  {
    zip_code: "6779",

    ste_name: "CT",
  },
  {
    zip_code: "7031",

    ste_name: "NJ",
  },
  {
    zip_code: "7032",

    ste_name: "NJ",
  },
  {
    zip_code: "7072",

    ste_name: "NJ",
  },
  {
    zip_code: "7112",

    ste_name: "NJ",
  },
  {
    zip_code: "7403",

    ste_name: "NJ",
  },
  {
    zip_code: "7601",

    ste_name: "NJ",
  },
  {
    zip_code: "7640",

    ste_name: "NJ",
  },
  {
    zip_code: "7760",

    ste_name: "NJ",
  },
  {
    zip_code: "7838",

    ste_name: "NJ",
  },
  {
    zip_code: "7851",

    ste_name: "NJ",
  },
  {
    zip_code: "7876",

    ste_name: "NJ",
  },
  {
    zip_code: "7885",

    ste_name: "NJ",
  },
  {
    zip_code: "7936",

    ste_name: "NJ",
  },
  {
    zip_code: "8008",

    ste_name: "NJ",
  },
  {
    zip_code: "8053",

    ste_name: "NJ",
  },
  {
    zip_code: "8080",

    ste_name: "NJ",
  },
  {
    zip_code: "8311",

    ste_name: "NJ",
  },
  {
    zip_code: "8533",

    ste_name: "NJ",
  },
  {
    zip_code: "8620",

    ste_name: "NJ",
  },
  {
    zip_code: "8742",

    ste_name: "NJ",
  },
  {
    zip_code: "8833",

    ste_name: "NJ",
  },
  {
    zip_code: "8848",

    ste_name: "NJ",
  },
  {
    zip_code: "8879",

    ste_name: "NJ",
  },
  {
    zip_code: "10282",

    ste_name: "NY",
  },
  {
    zip_code: "10461",

    ste_name: "NY",
  },
  {
    zip_code: "10535",

    ste_name: "NY",
  },
  {
    zip_code: "10591",

    ste_name: "NY",
  },
  {
    zip_code: "10933",

    ste_name: "NY",
  },
  {
    zip_code: "10965",

    ste_name: "NY",
  },
  {
    zip_code: "11103",

    ste_name: "NY",
  },
  {
    zip_code: "11429",

    ste_name: "NY",
  },
  {
    zip_code: "11552",

    ste_name: "NY",
  },
  {
    zip_code: "11691",

    ste_name: "NY",
  },
  {
    zip_code: "11719",

    ste_name: "NY",
  },
  {
    zip_code: "11953",

    ste_name: "NY",
  },
  {
    zip_code: "12007",

    ste_name: "NY",
  },
  {
    zip_code: "12056",

    ste_name: "NY",
  },
  {
    zip_code: "12076",

    ste_name: "NY",
  },
  {
    zip_code: "12121",

    ste_name: "NY",
  },
  {
    zip_code: "12125",

    ste_name: "NY",
  },
  {
    zip_code: "12168",

    ste_name: "NY",
  },
  {
    zip_code: "12206",

    ste_name: "NY",
  },
  {
    zip_code: "12409",

    ste_name: "NY",
  },
  {
    zip_code: "12417",

    ste_name: "NY",
  },
  {
    zip_code: "12419",

    ste_name: "NY",
  },
  {
    zip_code: "12444",

    ste_name: "NY",
  },
  {
    zip_code: "12567",

    ste_name: "NY",
  },
  {
    zip_code: "12726",

    ste_name: "NY",
  },
  {
    zip_code: "12834",

    ste_name: "NY",
  },
  {
    zip_code: "12841",

    ste_name: "NY",
  },
  {
    zip_code: "12849",

    ste_name: "NY",
  },
  {
    zip_code: "12873",

    ste_name: "NY",
  },
  {
    zip_code: "12937",

    ste_name: "NY",
  },
  {
    zip_code: "12980",

    ste_name: "NY",
  },
  {
    zip_code: "13073",

    ste_name: "NY",
  },
  {
    zip_code: "13153",

    ste_name: "NY",
  },
  {
    zip_code: "13160",

    ste_name: "NY",
  },
  {
    zip_code: "13211",

    ste_name: "NY",
  },
  {
    zip_code: "13215",

    ste_name: "NY",
  },
  {
    zip_code: "13304",

    ste_name: "NY",
  },
  {
    zip_code: "13309",

    ste_name: "NY",
  },
  {
    zip_code: "13315",

    ste_name: "NY",
  },
  {
    zip_code: "13324",

    ste_name: "NY",
  },
  {
    zip_code: "13404",

    ste_name: "NY",
  },
  {
    zip_code: "13489",

    ste_name: "NY",
  },
  {
    zip_code: "13636",

    ste_name: "NY",
  },
  {
    zip_code: "13734",

    ste_name: "NY",
  },
  {
    zip_code: "13744",

    ste_name: "NY",
  },
  {
    zip_code: "13755",

    ste_name: "NY",
  },
  {
    zip_code: "13756",

    ste_name: "NY",
  },
  {
    zip_code: "13775",

    ste_name: "NY",
  },
  {
    zip_code: "13796",

    ste_name: "NY",
  },
  {
    zip_code: "13801",

    ste_name: "NY",
  },
  {
    zip_code: "14011",

    ste_name: "NY",
  },
  {
    zip_code: "14032",

    ste_name: "NY",
  },
  {
    zip_code: "14039",

    ste_name: "NY",
  },
  {
    zip_code: "14065",

    ste_name: "NY",
  },
  {
    zip_code: "14221",

    ste_name: "NY",
  },
  {
    zip_code: "14305",

    ste_name: "NY",
  },
  {
    zip_code: "14485",

    ste_name: "NY",
  },
  {
    zip_code: "14519",

    ste_name: "NY",
  },
  {
    zip_code: "14527",

    ste_name: "NY",
  },
  {
    zip_code: "14536",

    ste_name: "NY",
  },
  {
    zip_code: "14544",

    ste_name: "NY",
  },
  {
    zip_code: "14707",

    ste_name: "NY",
  },
  {
    zip_code: "14843",

    ste_name: "NY",
  },
  {
    zip_code: "14897",

    ste_name: "NY",
  },
  {
    zip_code: "15059",

    ste_name: "PA",
  },
  {
    zip_code: "15207",

    ste_name: "PA",
  },
  {
    zip_code: "15216",

    ste_name: "PA",
  },
  {
    zip_code: "15316",

    ste_name: "PA",
  },
  {
    zip_code: "15323",

    ste_name: "PA",
  },
  {
    zip_code: "15413",

    ste_name: "PA",
  },
  {
    zip_code: "15424",

    ste_name: "PA",
  },
  {
    zip_code: "15468",

    ste_name: "PA",
  },
  {
    zip_code: "15536",

    ste_name: "PA",
  },
  {
    zip_code: "15639",

    ste_name: "PA",
  },
  {
    zip_code: "15716",

    ste_name: "PA",
  },
  {
    zip_code: "15737",

    ste_name: "PA",
  },
  {
    zip_code: "15865",

    ste_name: "PA",
  },
  {
    zip_code: "15938",

    ste_name: "PA",
  },
  {
    zip_code: "16029",

    ste_name: "PA",
  },
  {
    zip_code: "16130",

    ste_name: "PA",
  },
  {
    zip_code: "16146",

    ste_name: "PA",
  },
  {
    zip_code: "16159",

    ste_name: "PA",
  },
  {
    zip_code: "16223",

    ste_name: "PA",
  },
  {
    zip_code: "16423",

    ste_name: "PA",
  },
  {
    zip_code: "16424",

    ste_name: "PA",
  },
  {
    zip_code: "16502",

    ste_name: "PA",
  },
  {
    zip_code: "16511",

    ste_name: "PA",
  },
  {
    zip_code: "16637",

    ste_name: "PA",
  },
  {
    zip_code: "16648",

    ste_name: "PA",
  },
  {
    zip_code: "16738",

    ste_name: "PA",
  },
  {
    zip_code: "16851",

    ste_name: "PA",
  },
  {
    zip_code: "16923",

    ste_name: "PA",
  },
  {
    zip_code: "16943",

    ste_name: "PA",
  },
  {
    zip_code: "17029",

    ste_name: "PA",
  },
  {
    zip_code: "17081",

    ste_name: "PA",
  },
  {
    zip_code: "17301",

    ste_name: "PA",
  },
  {
    zip_code: "17343",

    ste_name: "PA",
  },
  {
    zip_code: "17371",

    ste_name: "PA",
  },
  {
    zip_code: "17516",

    ste_name: "PA",
  },
  {
    zip_code: "17562",

    ste_name: "PA",
  },
  {
    zip_code: "17750",

    ste_name: "PA",
  },
  {
    zip_code: "17751",

    ste_name: "PA",
  },
  {
    zip_code: "17758",

    ste_name: "PA",
  },
  {
    zip_code: "17862",

    ste_name: "PA",
  },
  {
    zip_code: "17868",

    ste_name: "PA",
  },
  {
    zip_code: "17901",

    ste_name: "PA",
  },
  {
    zip_code: "18053",

    ste_name: "PA",
  },
  {
    zip_code: "18059",

    ste_name: "PA",
  },
  {
    zip_code: "18068",

    ste_name: "PA",
  },
  {
    zip_code: "18080",

    ste_name: "PA",
  },
  {
    zip_code: "18216",

    ste_name: "PA",
  },
  {
    zip_code: "18323",

    ste_name: "PA",
  },
  {
    zip_code: "18337",

    ste_name: "PA",
  },
  {
    zip_code: "18370",

    ste_name: "PA",
  },
  {
    zip_code: "18640",

    ste_name: "PA",
  },
  {
    zip_code: "18829",

    ste_name: "PA",
  },
  {
    zip_code: "18954",

    ste_name: "PA",
  },
  {
    zip_code: "19010",

    ste_name: "PA",
  },
  {
    zip_code: "19017",

    ste_name: "PA",
  },
  {
    zip_code: "19122",

    ste_name: "PA",
  },
  {
    zip_code: "19143",

    ste_name: "PA",
  },
  {
    zip_code: "19358",

    ste_name: "PA",
  },
  {
    zip_code: "19406",

    ste_name: "PA",
  },
  {
    zip_code: "19426",

    ste_name: "PA",
  },
  {
    zip_code: "20016",

    ste_name: "DC",
  },
  {
    zip_code: "20560",

    ste_name: "DC",
  },
  {
    zip_code: "20617",

    ste_name: "MD",
  },
  {
    zip_code: "20625",

    ste_name: "MD",
  },
  {
    zip_code: "20662",

    ste_name: "MD",
  },
  {
    zip_code: "20714",

    ste_name: "MD",
  },
  {
    zip_code: "20747",

    ste_name: "MD",
  },
  {
    zip_code: "20832",

    ste_name: "MD",
  },
  {
    zip_code: "21029",

    ste_name: "MD",
  },
  {
    zip_code: "21108",

    ste_name: "MD",
  },
  {
    zip_code: "21122",

    ste_name: "MD",
  },
  {
    zip_code: "21154",

    ste_name: "MD",
  },
  {
    zip_code: "21221",

    ste_name: "MD",
  },
  {
    zip_code: "21224",

    ste_name: "MD",
  },
  {
    zip_code: "21226",

    ste_name: "MD",
  },
  {
    zip_code: "21251",

    ste_name: "MD",
  },
  {
    zip_code: "21619",

    ste_name: "MD",
  },
  {
    zip_code: "21654",

    ste_name: "MD",
  },
  {
    zip_code: "21677",

    ste_name: "MD",
  },
  {
    zip_code: "21794",

    ste_name: "MD",
  },
  {
    zip_code: "22015",

    ste_name: "VA",
  },
  {
    zip_code: "22079",

    ste_name: "VA",
  },
  {
    zip_code: "22152",

    ste_name: "VA",
  },
  {
    zip_code: "22192",

    ste_name: "VA",
  },
  {
    zip_code: "22202",

    ste_name: "VA",
  },
  {
    zip_code: "22206",

    ste_name: "VA",
  },
  {
    zip_code: "22307",

    ste_name: "VA",
  },
  {
    zip_code: "22534",

    ste_name: "VA",
  },
  {
    zip_code: "22535",

    ste_name: "VA",
  },
  {
    zip_code: "22578",

    ste_name: "VA",
  },
  {
    zip_code: "22637",

    ste_name: "VA",
  },
  {
    zip_code: "22728",

    ste_name: "VA",
  },
  {
    zip_code: "22835",

    ste_name: "VA",
  },
  {
    zip_code: "22901",

    ste_name: "VA",
  },
  {
    zip_code: "22959",

    ste_name: "VA",
  },
  {
    zip_code: "23059",

    ste_name: "VA",
  },
  {
    zip_code: "23075",

    ste_name: "VA",
  },
  {
    zip_code: "23230",

    ste_name: "VA",
  },
  {
    zip_code: "23320",

    ste_name: "VA",
  },
  {
    zip_code: "23503",

    ste_name: "VA",
  },
  {
    zip_code: "23518",

    ste_name: "VA",
  },
  {
    zip_code: "23829",

    ste_name: "VA",
  },
  {
    zip_code: "23898",

    ste_name: "VA",
  },
  {
    zip_code: "24011",

    ste_name: "VA",
  },
  {
    zip_code: "24013",

    ste_name: "VA",
  },
  {
    zip_code: "24236",

    ste_name: "VA",
  },
  {
    zip_code: "24347",

    ste_name: "VA",
  },
  {
    zip_code: "24352",

    ste_name: "VA",
  },
  {
    zip_code: "24421",

    ste_name: "VA",
  },
  {
    zip_code: "24435",

    ste_name: "VA",
  },
  {
    zip_code: "24487",

    ste_name: "VA",
  },
  {
    zip_code: "24571",

    ste_name: "VA",
  },
  {
    zip_code: "24580",

    ste_name: "VA",
  },
  {
    zip_code: "24601",

    ste_name: "VA",
  },
  {
    zip_code: "24639",

    ste_name: "VA",
  },
  {
    zip_code: "24844",

    ste_name: "WV",
  },
  {
    zip_code: "24881",

    ste_name: "WV",
  },
  {
    zip_code: "25047",

    ste_name: "WV",
  },
  {
    zip_code: "25133",

    ste_name: "WV",
  },
  {
    zip_code: "25139",

    ste_name: "WV",
  },
  {
    zip_code: "25152",

    ste_name: "WV",
  },
  {
    zip_code: "25169",

    ste_name: "WV",
  },
  {
    zip_code: "25202",

    ste_name: "WV",
  },
  {
    zip_code: "25311",

    ste_name: "WV",
  },
  {
    zip_code: "25427",

    ste_name: "WV",
  },
  {
    zip_code: "25634",

    ste_name: "WV",
  },
  {
    zip_code: "25647",

    ste_name: "WV",
  },
  {
    zip_code: "25671",

    ste_name: "WV",
  },
  {
    zip_code: "25832",

    ste_name: "WV",
  },
  {
    zip_code: "26040",

    ste_name: "WV",
  },
  {
    zip_code: "26134",

    ste_name: "WV",
  },
  {
    zip_code: "26170",

    ste_name: "WV",
  },
  {
    zip_code: "26253",

    ste_name: "WV",
  },
  {
    zip_code: "26263",

    ste_name: "WV",
  },
  {
    zip_code: "26276",

    ste_name: "WV",
  },
  {
    zip_code: "26537",

    ste_name: "WV",
  },
  {
    zip_code: "26568",

    ste_name: "WV",
  },
  {
    zip_code: "26801",

    ste_name: "WV",
  },
  {
    zip_code: "26807",

    ste_name: "WV",
  },
  {
    zip_code: "27016",

    ste_name: "NC",
  },
  {
    zip_code: "27022",

    ste_name: "NC",
  },
  {
    zip_code: "27023",

    ste_name: "NC",
  },
  {
    zip_code: "27278",

    ste_name: "NC",
  },
  {
    zip_code: "27317",

    ste_name: "NC",
  },
  {
    zip_code: "27340",

    ste_name: "NC",
  },
  {
    zip_code: "27350",

    ste_name: "NC",
  },
  {
    zip_code: "27544",

    ste_name: "NC",
  },
  {
    zip_code: "27803",

    ste_name: "NC",
  },
  {
    zip_code: "27812",

    ste_name: "NC",
  },
  {
    zip_code: "27869",

    ste_name: "NC",
  },
  {
    zip_code: "27878",

    ste_name: "NC",
  },
  {
    zip_code: "27881",

    ste_name: "NC",
  },
  {
    zip_code: "27939",

    ste_name: "NC",
  },
  {
    zip_code: "27983",

    ste_name: "NC",
  },
  {
    zip_code: "28012",

    ste_name: "NC",
  },
  {
    zip_code: "28027",

    ste_name: "NC",
  },
  {
    zip_code: "28128",

    ste_name: "NC",
  },
  {
    zip_code: "28216",

    ste_name: "NC",
  },
  {
    zip_code: "28369",

    ste_name: "NC",
  },
  {
    zip_code: "28424",

    ste_name: "NC",
  },
  {
    zip_code: "28519",

    ste_name: "NC",
  },
  {
    zip_code: "28543",

    ste_name: "NC",
  },
  {
    zip_code: "28627",

    ste_name: "NC",
  },
  {
    zip_code: "28636",

    ste_name: "NC",
  },
  {
    zip_code: "28651",

    ste_name: "NC",
  },
  {
    zip_code: "28669",

    ste_name: "NC",
  },
  {
    zip_code: "28692",

    ste_name: "NC",
  },
  {
    zip_code: "28707",

    ste_name: "NC",
  },
  {
    zip_code: "29162",

    ste_name: "SC",
  },
  {
    zip_code: "29163",

    ste_name: "SC",
  },
  {
    zip_code: "29302",

    ste_name: "SC",
  },
  {
    zip_code: "29378",

    ste_name: "SC",
  },
  {
    zip_code: "29429",

    ste_name: "SC",
  },
  {
    zip_code: "29458",

    ste_name: "SC",
  },
  {
    zip_code: "29470",

    ste_name: "SC",
  },
  {
    zip_code: "29482",

    ste_name: "SC",
  },
  {
    zip_code: "29593",

    ste_name: "SC",
  },
  {
    zip_code: "29662",

    ste_name: "SC",
  },
  {
    zip_code: "29684",

    ste_name: "SC",
  },
  {
    zip_code: "29905",

    ste_name: "SC",
  },
  {
    zip_code: "29927",

    ste_name: "SC",
  },
  {
    zip_code: "30066",

    ste_name: "GA",
  },
  {
    zip_code: "30070",

    ste_name: "GA",
  },
  {
    zip_code: "30182",

    ste_name: "GA",
  },
  {
    zip_code: "30256",

    ste_name: "GA",
  },
  {
    zip_code: "30337",

    ste_name: "GA",
  },
  {
    zip_code: "30553",

    ste_name: "GA",
  },
  {
    zip_code: "30562",

    ste_name: "GA",
  },
  {
    zip_code: "30629",

    ste_name: "GA",
  },
  {
    zip_code: "30747",

    ste_name: "GA",
  },
  {
    zip_code: "30822",

    ste_name: "GA",
  },
  {
    zip_code: "31009",

    ste_name: "GA",
  },
  {
    zip_code: "31023",

    ste_name: "GA",
  },
  {
    zip_code: "31046",

    ste_name: "GA",
  },
  {
    zip_code: "31058",

    ste_name: "GA",
  },
  {
    zip_code: "31204",

    ste_name: "GA",
  },
  {
    zip_code: "31309",

    ste_name: "GA",
  },
  {
    zip_code: "31326",

    ste_name: "GA",
  },
  {
    zip_code: "31647",

    ste_name: "GA",
  },
  {
    zip_code: "31709",

    ste_name: "GA",
  },
  {
    zip_code: "31730",

    ste_name: "GA",
  },
  {
    zip_code: "31768",

    ste_name: "GA",
  },
  {
    zip_code: "31773",

    ste_name: "GA",
  },
  {
    zip_code: "32250",

    ste_name: "FL",
  },
  {
    zip_code: "32403",

    ste_name: "FL",
  },
  {
    zip_code: "32466",

    ste_name: "FL",
  },
  {
    zip_code: "32501",

    ste_name: "FL",
  },
  {
    zip_code: "32503",

    ste_name: "FL",
  },
  {
    zip_code: "32507",

    ste_name: "FL",
  },
  {
    zip_code: "32541",

    ste_name: "FL",
  },
  {
    zip_code: "32571",

    ste_name: "FL",
  },
  {
    zip_code: "32681",

    ste_name: "FL",
  },
  {
    zip_code: "32686",

    ste_name: "FL",
  },
  {
    zip_code: "32766",

    ste_name: "FL",
  },
  {
    zip_code: "32836",

    ste_name: "FL",
  },
  {
    zip_code: "32937",

    ste_name: "FL",
  },
  {
    zip_code: "33035",

    ste_name: "FL",
  },
  {
    zip_code: "33185",

    ste_name: "FL",
  },
  {
    zip_code: "33193",

    ste_name: "FL",
  },
  {
    zip_code: "33327",

    ste_name: "FL",
  },
  {
    zip_code: "33463",

    ste_name: "FL",
  },
  {
    zip_code: "33556",

    ste_name: "FL",
  },
  {
    zip_code: "33594",

    ste_name: "FL",
  },
  {
    zip_code: "33596",

    ste_name: "FL",
  },
  {
    zip_code: "33914",

    ste_name: "FL",
  },
  {
    zip_code: "33920",

    ste_name: "FL",
  },
  {
    zip_code: "33936",

    ste_name: "FL",
  },
  {
    zip_code: "34205",

    ste_name: "FL",
  },
  {
    zip_code: "34208",

    ste_name: "FL",
  },
  {
    zip_code: "34266",

    ste_name: "FL",
  },
  {
    zip_code: "34690",

    ste_name: "FL",
  },
  {
    zip_code: "34983",

    ste_name: "FL",
  },
  {
    zip_code: "35013",

    ste_name: "AL",
  },
  {
    zip_code: "35118",

    ste_name: "AL",
  },
  {
    zip_code: "35135",

    ste_name: "AL",
  },
  {
    zip_code: "35466",

    ste_name: "AL",
  },
  {
    zip_code: "35554",

    ste_name: "AL",
  },
  {
    zip_code: "35621",

    ste_name: "AL",
  },
  {
    zip_code: "35672",

    ste_name: "AL",
  },
  {
    zip_code: "35958",

    ste_name: "AL",
  },
  {
    zip_code: "35988",

    ste_name: "AL",
  },
  {
    zip_code: "36069",

    ste_name: "AL",
  },
  {
    zip_code: "36089",

    ste_name: "AL",
  },
  {
    zip_code: "36375",

    ste_name: "AL",
  },
  {
    zip_code: "36445",

    ste_name: "AL",
  },
  {
    zip_code: "36518",

    ste_name: "AL",
  },
  {
    zip_code: "36528",

    ste_name: "AL",
  },
  {
    zip_code: "36786",

    ste_name: "AL",
  },
  {
    zip_code: "36855",

    ste_name: "AL",
  },
  {
    zip_code: "36916",

    ste_name: "AL",
  },
  {
    zip_code: "37019",

    ste_name: "TN",
  },
  {
    zip_code: "37206",

    ste_name: "TN",
  },
  {
    zip_code: "37324",

    ste_name: "TN",
  },
  {
    zip_code: "37329",

    ste_name: "TN",
  },
  {
    zip_code: "37409",

    ste_name: "TN",
  },
  {
    zip_code: "37665",

    ste_name: "TN",
  },
  {
    zip_code: "37692",

    ste_name: "TN",
  },
  {
    zip_code: "37710",

    ste_name: "TN",
  },
  {
    zip_code: "37726",

    ste_name: "TN",
  },
  {
    zip_code: "37920",

    ste_name: "TN",
  },
  {
    zip_code: "37921",

    ste_name: "TN",
  },
  {
    zip_code: "38017",

    ste_name: "TN",
  },
  {
    zip_code: "38058",

    ste_name: "TN",
  },
  {
    zip_code: "38059",

    ste_name: "TN",
  },
  {
    zip_code: "38068",

    ste_name: "TN",
  },
  {
    zip_code: "38107",

    ste_name: "TN",
  },
  {
    zip_code: "38139",

    ste_name: "TN",
  },
  {
    zip_code: "38341",

    ste_name: "TN",
  },
  {
    zip_code: "38370",

    ste_name: "TN",
  },
  {
    zip_code: "38401",

    ste_name: "TN",
  },
  {
    zip_code: "38541",

    ste_name: "TN",
  },
  {
    zip_code: "38575",

    ste_name: "TN",
  },
  {
    zip_code: "38703",

    ste_name: "MS",
  },
  {
    zip_code: "38771",

    ste_name: "MS",
  },
  {
    zip_code: "38778",

    ste_name: "MS",
  },
  {
    zip_code: "38852",

    ste_name: "MS",
  },
  {
    zip_code: "38915",

    ste_name: "MS",
  },
  {
    zip_code: "38920",

    ste_name: "MS",
  },
  {
    zip_code: "38927",

    ste_name: "MS",
  },
  {
    zip_code: "38964",

    ste_name: "MS",
  },
  {
    zip_code: "38967",

    ste_name: "MS",
  },
  {
    zip_code: "39042",

    ste_name: "MS",
  },
  {
    zip_code: "39046",

    ste_name: "MS",
  },
  {
    zip_code: "39157",

    ste_name: "MS",
  },
  {
    zip_code: "39179",

    ste_name: "MS",
  },
  {
    zip_code: "39208",

    ste_name: "MS",
  },
  {
    zip_code: "39325",

    ste_name: "MS",
  },
  {
    zip_code: "39330",

    ste_name: "MS",
  },
  {
    zip_code: "39358",

    ste_name: "MS",
  },
  {
    zip_code: "39439",

    ste_name: "MS",
  },
  {
    zip_code: "39452",

    ste_name: "MS",
  },
  {
    zip_code: "39657",

    ste_name: "MS",
  },
  {
    zip_code: "39740",

    ste_name: "MS",
  },
  {
    zip_code: "39741",

    ste_name: "MS",
  },
  {
    zip_code: "39823",

    ste_name: "GA",
  },
  {
    zip_code: "40058",

    ste_name: "KY",
  },
  {
    zip_code: "40067",

    ste_name: "KY",
  },
  {
    zip_code: "40111",

    ste_name: "KY",
  },
  {
    zip_code: "40324",

    ste_name: "KY",
  },
  {
    zip_code: "40346",

    ste_name: "KY",
  },
  {
    zip_code: "40468",

    ste_name: "KY",
  },
  {
    zip_code: "40484",

    ste_name: "KY",
  },
  {
    zip_code: "40862",

    ste_name: "KY",
  },
  {
    zip_code: "41046",

    ste_name: "KY",
  },
  {
    zip_code: "41094",

    ste_name: "KY",
  },
  {
    zip_code: "41169",

    ste_name: "KY",
  },
  {
    zip_code: "41171",

    ste_name: "KY",
  },
  {
    zip_code: "41231",

    ste_name: "KY",
  },
  {
    zip_code: "41301",

    ste_name: "KY",
  },
  {
    zip_code: "41317",

    ste_name: "KY",
  },
  {
    zip_code: "41554",

    ste_name: "KY",
  },
  {
    zip_code: "41601",

    ste_name: "KY",
  },
  {
    zip_code: "41642",

    ste_name: "KY",
  },
  {
    zip_code: "41655",

    ste_name: "KY",
  },
  {
    zip_code: "41751",

    ste_name: "KY",
  },
  {
    zip_code: "41759",

    ste_name: "KY",
  },
  {
    zip_code: "42285",

    ste_name: "KY",
  },
  {
    zip_code: "42328",

    ste_name: "KY",
  },
  {
    zip_code: "42333",

    ste_name: "KY",
  },
  {
    zip_code: "42366",

    ste_name: "KY",
  },
  {
    zip_code: "42436",

    ste_name: "KY",
  },
  {
    zip_code: "42533",

    ste_name: "KY",
  },
  {
    zip_code: "42642",

    ste_name: "KY",
  },
  {
    zip_code: "42724",

    ste_name: "KY",
  },
  {
    zip_code: "43028",

    ste_name: "OH",
  },
  {
    zip_code: "43045",

    ste_name: "OH",
  },
  {
    zip_code: "43085",

    ste_name: "OH",
  },
  {
    zip_code: "43105",

    ste_name: "OH",
  },
  {
    zip_code: "43111",

    ste_name: "OH",
  },
  {
    zip_code: "43143",

    ste_name: "OH",
  },
  {
    zip_code: "43224",

    ste_name: "OH",
  },
  {
    zip_code: "43229",

    ste_name: "OH",
  },
  {
    zip_code: "43341",

    ste_name: "OH",
  },
  {
    zip_code: "43351",

    ste_name: "OH",
  },
  {
    zip_code: "43467",

    ste_name: "OH",
  },
  {
    zip_code: "43531",

    ste_name: "OH",
  },
  {
    zip_code: "43553",

    ste_name: "OH",
  },
  {
    zip_code: "43764",

    ste_name: "OH",
  },
  {
    zip_code: "43906",

    ste_name: "OH",
  },
  {
    zip_code: "43912",

    ste_name: "OH",
  },
  {
    zip_code: "43939",

    ste_name: "OH",
  },
  {
    zip_code: "44057",

    ste_name: "OH",
  },
  {
    zip_code: "44093",

    ste_name: "OH",
  },
  {
    zip_code: "44121",

    ste_name: "OH",
  },
  {
    zip_code: "44149",

    ste_name: "OH",
  },
  {
    zip_code: "44307",

    ste_name: "OH",
  },
  {
    zip_code: "44312",

    ste_name: "OH",
  },
  {
    zip_code: "44440",

    ste_name: "OH",
  },
  {
    zip_code: "44610",

    ste_name: "OH",
  },
  {
    zip_code: "44625",

    ste_name: "OH",
  },
  {
    zip_code: "44667",

    ste_name: "OH",
  },
  {
    zip_code: "44704",

    ste_name: "OH",
  },
  {
    zip_code: "44875",

    ste_name: "OH",
  },
  {
    zip_code: "44887",

    ste_name: "OH",
  },
  {
    zip_code: "44901",

    ste_name: "OH",
  },
  {
    zip_code: "45069",

    ste_name: "OH",
  },
  {
    zip_code: "45237",

    ste_name: "OH",
  },
  {
    zip_code: "45301",

    ste_name: "OH",
  },
  {
    zip_code: "45314",

    ste_name: "OH",
  },
  {
    zip_code: "45363",

    ste_name: "OH",
  },
  {
    zip_code: "45449",

    ste_name: "OH",
  },
  {
    zip_code: "45678",

    ste_name: "OH",
  },
  {
    zip_code: "45764",

    ste_name: "OH",
  },
  {
    zip_code: "45769",

    ste_name: "OH",
  },
  {
    zip_code: "45812",

    ste_name: "OH",
  },
  {
    zip_code: "45845",

    ste_name: "OH",
  },
  {
    zip_code: "45871",

    ste_name: "OH",
  },
  {
    zip_code: "45896",

    ste_name: "OH",
  },
  {
    zip_code: "46049",

    ste_name: "IN",
  },
  {
    zip_code: "46130",

    ste_name: "IN",
  },
  {
    zip_code: "46202",

    ste_name: "IN",
  },
  {
    zip_code: "46220",

    ste_name: "IN",
  },
  {
    zip_code: "46226",

    ste_name: "IN",
  },
  {
    zip_code: "46228",

    ste_name: "IN",
  },
  {
    zip_code: "46237",

    ste_name: "IN",
  },
  {
    zip_code: "46391",

    ste_name: "IN",
  },
  {
    zip_code: "46403",

    ste_name: "IN",
  },
  {
    zip_code: "46526",

    ste_name: "IN",
  },
  {
    zip_code: "46805",

    ste_name: "IN",
  },
  {
    zip_code: "46931",

    ste_name: "IN",
  },
  {
    zip_code: "46967",

    ste_name: "IN",
  },
  {
    zip_code: "46978",

    ste_name: "IN",
  },
  {
    zip_code: "47142",

    ste_name: "IN",
  },
  {
    zip_code: "47203",

    ste_name: "IN",
  },
  {
    zip_code: "47226",

    ste_name: "IN",
  },
  {
    zip_code: "47227",

    ste_name: "IN",
  },
  {
    zip_code: "47325",

    ste_name: "IN",
  },
  {
    zip_code: "47331",

    ste_name: "IN",
  },
  {
    zip_code: "47434",

    ste_name: "IN",
  },
  {
    zip_code: "47516",

    ste_name: "IN",
  },
  {
    zip_code: "47567",

    ste_name: "IN",
  },
  {
    zip_code: "47588",

    ste_name: "IN",
  },
  {
    zip_code: "47619",

    ste_name: "IN",
  },
  {
    zip_code: "47714",

    ste_name: "IN",
  },
  {
    zip_code: "47879",

    ste_name: "IN",
  },
  {
    zip_code: "47955",

    ste_name: "IN",
  },
  {
    zip_code: "47967",

    ste_name: "IN",
  },
  {
    zip_code: "47989",

    ste_name: "IN",
  },
  {
    zip_code: "48039",

    ste_name: "MI",
  },
  {
    zip_code: "48054",

    ste_name: "MI",
  },
  {
    zip_code: "48071",

    ste_name: "MI",
  },
  {
    zip_code: "48079",

    ste_name: "MI",
  },
  {
    zip_code: "48093",

    ste_name: "MI",
  },
  {
    zip_code: "48101",

    ste_name: "MI",
  },
  {
    zip_code: "48158",

    ste_name: "MI",
  },
  {
    zip_code: "48167",

    ste_name: "MI",
  },
  {
    zip_code: "48170",

    ste_name: "MI",
  },
  {
    zip_code: "48179",

    ste_name: "MI",
  },
  {
    zip_code: "48184",

    ste_name: "MI",
  },
  {
    zip_code: "48224",

    ste_name: "MI",
  },
  {
    zip_code: "48314",

    ste_name: "MI",
  },
  {
    zip_code: "48397",

    ste_name: "MI",
  },
  {
    zip_code: "48434",

    ste_name: "MI",
  },
  {
    zip_code: "48450",

    ste_name: "MI",
  },
  {
    zip_code: "48470",

    ste_name: "MI",
  },
  {
    zip_code: "48509",

    ste_name: "MI",
  },
  {
    zip_code: "48611",

    ste_name: "MI",
  },
  {
    zip_code: "48726",

    ste_name: "MI",
  },
  {
    zip_code: "48745",

    ste_name: "MI",
  },
  {
    zip_code: "48854",

    ste_name: "MI",
  },
  {
    zip_code: "48879",

    ste_name: "MI",
  },
  {
    zip_code: "49027",

    ste_name: "MI",
  },
  {
    zip_code: "49030",

    ste_name: "MI",
  },
  {
    zip_code: "49064",

    ste_name: "MI",
  },
  {
    zip_code: "49093",

    ste_name: "MI",
  },
  {
    zip_code: "49094",

    ste_name: "MI",
  },
  {
    zip_code: "49120",

    ste_name: "MI",
  },
  {
    zip_code: "49203",

    ste_name: "MI",
  },
  {
    zip_code: "49228",

    ste_name: "MI",
  },
  {
    zip_code: "49274",

    ste_name: "MI",
  },
  {
    zip_code: "49284",

    ste_name: "MI",
  },
  {
    zip_code: "49318",

    ste_name: "MI",
  },
  {
    zip_code: "49332",

    ste_name: "MI",
  },
  {
    zip_code: "49404",

    ste_name: "MI",
  },
  {
    zip_code: "49544",

    ste_name: "MI",
  },
  {
    zip_code: "49637",

    ste_name: "MI",
  },
  {
    zip_code: "49676",

    ste_name: "MI",
  },
  {
    zip_code: "49706",

    ste_name: "MI",
  },
  {
    zip_code: "49724",

    ste_name: "MI",
  },
  {
    zip_code: "49728",

    ste_name: "MI",
  },
  {
    zip_code: "49829",

    ste_name: "MI",
  },
  {
    zip_code: "49927",

    ste_name: "MI",
  },
  {
    zip_code: "50009",

    ste_name: "IA",
  },
  {
    zip_code: "50033",

    ste_name: "IA",
  },
  {
    zip_code: "50062",

    ste_name: "IA",
  },
  {
    zip_code: "50125",

    ste_name: "IA",
  },
  {
    zip_code: "50157",

    ste_name: "IA",
  },
  {
    zip_code: "50169",

    ste_name: "IA",
  },
  {
    zip_code: "50232",

    ste_name: "IA",
  },
  {
    zip_code: "50242",

    ste_name: "IA",
  },
  {
    zip_code: "50274",

    ste_name: "IA",
  },
  {
    zip_code: "50320",

    ste_name: "IA",
  },
  {
    zip_code: "50430",

    ste_name: "IA",
  },
  {
    zip_code: "50436",

    ste_name: "IA",
  },
  {
    zip_code: "50447",

    ste_name: "IA",
  },
  {
    zip_code: "50448",

    ste_name: "IA",
  },
  {
    zip_code: "50458",

    ste_name: "IA",
  },
  {
    zip_code: "50483",

    ste_name: "IA",
  },
  {
    zip_code: "50666",

    ste_name: "IA",
  },
  {
    zip_code: "50839",

    ste_name: "IA",
  },
  {
    zip_code: "50860",

    ste_name: "IA",
  },
  {
    zip_code: "51037",

    ste_name: "IA",
  },
  {
    zip_code: "51239",

    ste_name: "IA",
  },
  {
    zip_code: "51401",

    ste_name: "IA",
  },
  {
    zip_code: "51510",

    ste_name: "IA",
  },
  {
    zip_code: "51534",

    ste_name: "IA",
  },
  {
    zip_code: "51564",

    ste_name: "IA",
  },
  {
    zip_code: "52003",

    ste_name: "IA",
  },
  {
    zip_code: "52064",

    ste_name: "IA",
  },
  {
    zip_code: "52069",

    ste_name: "IA",
  },
  {
    zip_code: "52214",

    ste_name: "IA",
  },
  {
    zip_code: "52221",

    ste_name: "IA",
  },
  {
    zip_code: "52231",

    ste_name: "IA",
  },
  {
    zip_code: "52324",

    ste_name: "IA",
  },
  {
    zip_code: "52534",

    ste_name: "IA",
  },
  {
    zip_code: "52625",

    ste_name: "IA",
  },
  {
    zip_code: "52722",

    ste_name: "IA",
  },
  {
    zip_code: "52729",

    ste_name: "IA",
  },
  {
    zip_code: "53059",

    ste_name: "WI",
  },
  {
    zip_code: "53090",

    ste_name: "WI",
  },
  {
    zip_code: "53158",

    ste_name: "WI",
  },
  {
    zip_code: "53212",

    ste_name: "WI",
  },
  {
    zip_code: "53214",

    ste_name: "WI",
  },
  {
    zip_code: "53593",

    ste_name: "WI",
  },
  {
    zip_code: "53702",

    ste_name: "WI",
  },
  {
    zip_code: "53948",

    ste_name: "WI",
  },
  {
    zip_code: "53952",

    ste_name: "WI",
  },
  {
    zip_code: "53964",

    ste_name: "WI",
  },
  {
    zip_code: "54015",

    ste_name: "WI",
  },
  {
    zip_code: "54017",

    ste_name: "WI",
  },
  {
    zip_code: "54026",

    ste_name: "WI",
  },
  {
    zip_code: "54107",

    ste_name: "WI",
  },
  {
    zip_code: "54449",

    ste_name: "WI",
  },
  {
    zip_code: "54482",

    ste_name: "WI",
  },
  {
    zip_code: "54511",

    ste_name: "WI",
  },
  {
    zip_code: "54556",

    ste_name: "WI",
  },
  {
    zip_code: "54759",

    ste_name: "WI",
  },
  {
    zip_code: "54772",

    ste_name: "WI",
  },
  {
    zip_code: "54915",

    ste_name: "WI",
  },
  {
    zip_code: "54928",

    ste_name: "WI",
  },
  {
    zip_code: "54929",

    ste_name: "WI",
  },
  {
    zip_code: "55046",

    ste_name: "MN",
  },
  {
    zip_code: "55065",

    ste_name: "MN",
  },
  {
    zip_code: "55085",

    ste_name: "MN",
  },
  {
    zip_code: "55150",

    ste_name: "MN",
  },
  {
    zip_code: "55311",

    ste_name: "MN",
  },
  {
    zip_code: "55313",

    ste_name: "MN",
  },
  {
    zip_code: "55357",

    ste_name: "MN",
  },
  {
    zip_code: "55371",

    ste_name: "MN",
  },
  {
    zip_code: "55436",

    ste_name: "MN",
  },
  {
    zip_code: "55704",

    ste_name: "MN",
  },
  {
    zip_code: "55706",

    ste_name: "MN",
  },
  {
    zip_code: "55717",

    ste_name: "MN",
  },
  {
    zip_code: "55719",

    ste_name: "MN",
  },
  {
    zip_code: "55734",

    ste_name: "MN",
  },
  {
    zip_code: "55798",

    ste_name: "MN",
  },
  {
    zip_code: "55912",

    ste_name: "MN",
  },
  {
    zip_code: "55925",

    ste_name: "MN",
  },
  {
    zip_code: "55935",

    ste_name: "MN",
  },
  {
    zip_code: "55943",

    ste_name: "MN",
  },
  {
    zip_code: "55969",

    ste_name: "MN",
  },
  {
    zip_code: "56022",

    ste_name: "MN",
  },
  {
    zip_code: "56035",

    ste_name: "MN",
  },
  {
    zip_code: "56037",

    ste_name: "MN",
  },
  {
    zip_code: "56073",

    ste_name: "MN",
  },
  {
    zip_code: "56158",

    ste_name: "MN",
  },
  {
    zip_code: "56159",

    ste_name: "MN",
  },
  {
    zip_code: "56216",

    ste_name: "MN",
  },
  {
    zip_code: "56245",

    ste_name: "MN",
  },
  {
    zip_code: "56267",

    ste_name: "MN",
  },
  {
    zip_code: "56296",

    ste_name: "MN",
  },
  {
    zip_code: "56309",

    ste_name: "MN",
  },
  {
    zip_code: "56323",

    ste_name: "MN",
  },
  {
    zip_code: "56353",

    ste_name: "MN",
  },
  {
    zip_code: "56437",

    ste_name: "MN",
  },
  {
    zip_code: "56479",

    ste_name: "MN",
  },
  {
    zip_code: "56646",

    ste_name: "MN",
  },
  {
    zip_code: "56655",

    ste_name: "MN",
  },
  {
    zip_code: "56713",

    ste_name: "MN",
  },
  {
    zip_code: "56732",

    ste_name: "MN",
  },
  {
    zip_code: "57053",

    ste_name: "SD",
  },
  {
    zip_code: "57062",

    ste_name: "SD",
  },
  {
    zip_code: "57217",

    ste_name: "SD",
  },
  {
    zip_code: "57234",

    ste_name: "SD",
  },
  {
    zip_code: "57263",

    ste_name: "SD",
  },
  {
    zip_code: "57272",

    ste_name: "SD",
  },
  {
    zip_code: "57365",

    ste_name: "SD",
  },
  {
    zip_code: "57436",

    ste_name: "SD",
  },
  {
    zip_code: "57439",

    ste_name: "SD",
  },
  {
    zip_code: "57469",

    ste_name: "SD",
  },
  {
    zip_code: "57751",

    ste_name: "SD",
  },
  {
    zip_code: "57764",

    ste_name: "SD",
  },
  {
    zip_code: "57793",

    ste_name: "SD",
  },
  {
    zip_code: "58036",

    ste_name: "ND",
  },
  {
    zip_code: "58102",

    ste_name: "ND",
  },
  {
    zip_code: "58225",

    ste_name: "ND",
  },
  {
    zip_code: "58318",

    ste_name: "ND",
  },
  {
    zip_code: "58529",

    ste_name: "ND",
  },
  {
    zip_code: "58549",

    ste_name: "ND",
  },
  {
    zip_code: "58744",

    ste_name: "ND",
  },
  {
    zip_code: "58756",

    ste_name: "ND",
  },
  {
    zip_code: "59015",

    ste_name: "MT",
  },
  {
    zip_code: "59030",

    ste_name: "MT",
  },
  {
    zip_code: "59058",

    ste_name: "MT",
  },
  {
    zip_code: "59102",

    ste_name: "MT",
  },
  {
    zip_code: "59105",

    ste_name: "MT",
  },
  {
    zip_code: "59212",

    ste_name: "MT",
  },
  {
    zip_code: "59252",

    ste_name: "MT",
  },
  {
    zip_code: "59314",

    ste_name: "MT",
  },
  {
    zip_code: "59326",

    ste_name: "MT",
  },
  {
    zip_code: "59424",

    ste_name: "MT",
  },
  {
    zip_code: "59454",

    ste_name: "MT",
  },
  {
    zip_code: "59485",

    ste_name: "MT",
  },
  {
    zip_code: "59648",

    ste_name: "MT",
  },
  {
    zip_code: "59729",

    ste_name: "MT",
  },
  {
    zip_code: "59860",

    ste_name: "MT",
  },
  {
    zip_code: "59868",

    ste_name: "MT",
  },
  {
    zip_code: "59933",

    ste_name: "MT",
  },
  {
    zip_code: "60103",

    ste_name: "IL",
  },
  {
    zip_code: "60111",

    ste_name: "IL",
  },
  {
    zip_code: "60129",

    ste_name: "IL",
  },
  {
    zip_code: "60142",

    ste_name: "IL",
  },
  {
    zip_code: "60156",

    ste_name: "IL",
  },
  {
    zip_code: "60435",

    ste_name: "IL",
  },
  {
    zip_code: "60469",

    ste_name: "IL",
  },
  {
    zip_code: "60475",

    ste_name: "IL",
  },
  {
    zip_code: "60477",

    ste_name: "IL",
  },
  {
    zip_code: "60517",

    ste_name: "IL",
  },
  {
    zip_code: "60563",

    ste_name: "IL",
  },
  {
    zip_code: "60659",

    ste_name: "IL",
  },
  {
    zip_code: "60827",

    ste_name: "IL",
  },
  {
    zip_code: "61068",

    ste_name: "IL",
  },
  {
    zip_code: "61075",

    ste_name: "IL",
  },
  {
    zip_code: "61270",

    ste_name: "IL",
  },
  {
    zip_code: "61334",

    ste_name: "IL",
  },
  {
    zip_code: "61367",

    ste_name: "IL",
  },
  {
    zip_code: "61376",

    ste_name: "IL",
  },
  {
    zip_code: "61379",

    ste_name: "IL",
  },
  {
    zip_code: "61449",

    ste_name: "IL",
  },
  {
    zip_code: "61483",

    ste_name: "IL",
  },
  {
    zip_code: "61537",

    ste_name: "IL",
  },
  {
    zip_code: "61778",

    ste_name: "IL",
  },
  {
    zip_code: "61833",

    ste_name: "IL",
  },
  {
    zip_code: "61844",

    ste_name: "IL",
  },
  {
    zip_code: "61932",

    ste_name: "IL",
  },
  {
    zip_code: "61942",

    ste_name: "IL",
  },
  {
    zip_code: "62013",

    ste_name: "IL",
  },
  {
    zip_code: "62028",

    ste_name: "IL",
  },
  {
    zip_code: "62045",

    ste_name: "IL",
  },
  {
    zip_code: "62049",

    ste_name: "IL",
  },
  {
    zip_code: "62076",

    ste_name: "IL",
  },
  {
    zip_code: "62292",

    ste_name: "IL",
  },
  {
    zip_code: "62311",

    ste_name: "IL",
  },
  {
    zip_code: "62339",

    ste_name: "IL",
  },
  {
    zip_code: "62465",

    ste_name: "IL",
  },
  {
    zip_code: "62541",

    ste_name: "IL",
  },
  {
    zip_code: "62555",

    ste_name: "IL",
  },
  {
    zip_code: "62701",

    ste_name: "IL",
  },
  {
    zip_code: "62801",

    ste_name: "IL",
  },
  {
    zip_code: "62827",

    ste_name: "IL",
  },
  {
    zip_code: "62838",

    ste_name: "IL",
  },
  {
    zip_code: "62870",

    ste_name: "IL",
  },
  {
    zip_code: "62880",

    ste_name: "IL",
  },
  {
    zip_code: "62901",

    ste_name: "IL",
  },
  {
    zip_code: "62907",

    ste_name: "IL",
  },
  {
    zip_code: "62960",

    ste_name: "IL",
  },
  {
    zip_code: "62969",

    ste_name: "IL",
  },
  {
    zip_code: "62975",

    ste_name: "IL",
  },
  {
    zip_code: "62998",

    ste_name: "IL",
  },
  {
    zip_code: "63040",

    ste_name: "MO",
  },
  {
    zip_code: "63045",

    ste_name: "MO",
  },
  {
    zip_code: "63122",

    ste_name: "MO",
  },
  {
    zip_code: "63132",

    ste_name: "MO",
  },
  {
    zip_code: "63351",

    ste_name: "MO",
  },
  {
    zip_code: "63435",

    ste_name: "MO",
  },
  {
    zip_code: "63626",

    ste_name: "MO",
  },
  {
    zip_code: "63750",

    ste_name: "MO",
  },
  {
    zip_code: "63902",

    ste_name: "MO",
  },
  {
    zip_code: "63942",

    ste_name: "MO",
  },
  {
    zip_code: "64001",

    ste_name: "MO",
  },
  {
    zip_code: "64113",

    ste_name: "MO",
  },
  {
    zip_code: "64481",

    ste_name: "MO",
  },
  {
    zip_code: "64493",

    ste_name: "MO",
  },
  {
    zip_code: "64657",

    ste_name: "MO",
  },
  {
    zip_code: "64673",

    ste_name: "MO",
  },
  {
    zip_code: "64686",

    ste_name: "MO",
  },
  {
    zip_code: "64759",

    ste_name: "MO",
  },
  {
    zip_code: "64790",

    ste_name: "MO",
  },
  {
    zip_code: "64850",

    ste_name: "MO",
  },
  {
    zip_code: "65032",

    ste_name: "MO",
  },
  {
    zip_code: "65054",

    ste_name: "MO",
  },
  {
    zip_code: "65081",

    ste_name: "MO",
  },
  {
    zip_code: "65305",

    ste_name: "MO",
  },
  {
    zip_code: "65355",

    ste_name: "MO",
  },
  {
    zip_code: "65486",

    ste_name: "MO",
  },
  {
    zip_code: "65583",

    ste_name: "MO",
  },
  {
    zip_code: "65601",

    ste_name: "MO",
  },
  {
    zip_code: "65612",

    ste_name: "MO",
  },
  {
    zip_code: "65635",

    ste_name: "MO",
  },
  {
    zip_code: "65653",

    ste_name: "MO",
  },
  {
    zip_code: "65662",

    ste_name: "MO",
  },
  {
    zip_code: "65692",

    ste_name: "MO",
  },
  {
    zip_code: "65711",

    ste_name: "MO",
  },
  {
    zip_code: "65714",

    ste_name: "MO",
  },
  {
    zip_code: "65742",

    ste_name: "MO",
  },
  {
    zip_code: "65769",

    ste_name: "MO",
  },
  {
    zip_code: "66026",

    ste_name: "KS",
  },
  {
    zip_code: "66027",

    ste_name: "KS",
  },
  {
    zip_code: "66054",

    ste_name: "KS",
  },
  {
    zip_code: "66071",

    ste_name: "KS",
  },
  {
    zip_code: "66218",

    ste_name: "KS",
  },
  {
    zip_code: "66552",

    ste_name: "KS",
  },
  {
    zip_code: "66618",

    ste_name: "KS",
  },
  {
    zip_code: "66783",

    ste_name: "KS",
  },
  {
    zip_code: "66946",

    ste_name: "KS",
  },
  {
    zip_code: "66951",

    ste_name: "KS",
  },
  {
    zip_code: "66964",

    ste_name: "KS",
  },
  {
    zip_code: "67005",

    ste_name: "KS",
  },
  {
    zip_code: "67132",

    ste_name: "KS",
  },
  {
    zip_code: "67152",

    ste_name: "KS",
  },
  {
    zip_code: "67207",

    ste_name: "KS",
  },
  {
    zip_code: "67220",

    ste_name: "KS",
  },
  {
    zip_code: "67340",

    ste_name: "KS",
  },
  {
    zip_code: "67417",

    ste_name: "KS",
  },
  {
    zip_code: "67438",

    ste_name: "KS",
  },
  {
    zip_code: "67470",

    ste_name: "KS",
  },
  {
    zip_code: "67475",

    ste_name: "KS",
  },
  {
    zip_code: "67625",

    ste_name: "KS",
  },
  {
    zip_code: "67731",

    ste_name: "KS",
  },
  {
    zip_code: "67738",

    ste_name: "KS",
  },
  {
    zip_code: "67952",

    ste_name: "KS",
  },
  {
    zip_code: "68034",

    ste_name: "NE",
  },
  {
    zip_code: "68061",

    ste_name: "NE",
  },
  {
    zip_code: "68123",

    ste_name: "NE",
  },
  {
    zip_code: "68327",

    ste_name: "NE",
  },
  {
    zip_code: "68523",

    ste_name: "NE",
  },
  {
    zip_code: "68624",

    ste_name: "NE",
  },
  {
    zip_code: "68642",

    ste_name: "NE",
  },
  {
    zip_code: "68654",

    ste_name: "NE",
  },
  {
    zip_code: "68658",

    ste_name: "NE",
  },
  {
    zip_code: "68713",

    ste_name: "NE",
  },
  {
    zip_code: "68759",

    ste_name: "NE",
  },
  {
    zip_code: "68774",

    ste_name: "NE",
  },
  {
    zip_code: "68810",

    ste_name: "NE",
  },
  {
    zip_code: "68816",

    ste_name: "NE",
  },
  {
    zip_code: "68837",

    ste_name: "NE",
  },
  {
    zip_code: "68847",

    ste_name: "NE",
  },
  {
    zip_code: "68864",

    ste_name: "NE",
  },
  {
    zip_code: "68882",

    ste_name: "NE",
  },
  {
    zip_code: "68920",

    ste_name: "NE",
  },
  {
    zip_code: "69030",

    ste_name: "NE",
  },
  {
    zip_code: "69133",

    ste_name: "NE",
  },
  {
    zip_code: "69152",

    ste_name: "NE",
  },
  {
    zip_code: "69217",

    ste_name: "NE",
  },
  {
    zip_code: "70127",

    ste_name: "LA",
  },
  {
    zip_code: "70301",

    ste_name: "LA",
  },
  {
    zip_code: "70394",

    ste_name: "LA",
  },
  {
    zip_code: "70465",

    ste_name: "LA",
  },
  {
    zip_code: "70543",

    ste_name: "LA",
  },
  {
    zip_code: "70550",

    ste_name: "LA",
  },
  {
    zip_code: "70585",

    ste_name: "LA",
  },
  {
    zip_code: "70589",

    ste_name: "LA",
  },
  {
    zip_code: "70652",

    ste_name: "LA",
  },
  {
    zip_code: "70767",

    ste_name: "LA",
  },
  {
    zip_code: "70808",

    ste_name: "LA",
  },
  {
    zip_code: "70810",

    ste_name: "LA",
  },
  {
    zip_code: "71001",

    ste_name: "LA",
  },
  {
    zip_code: "71029",

    ste_name: "LA",
  },
  {
    zip_code: "71040",

    ste_name: "LA",
  },
  {
    zip_code: "71045",

    ste_name: "LA",
  },
  {
    zip_code: "71070",

    ste_name: "LA",
  },
  {
    zip_code: "71232",

    ste_name: "LA",
  },
  {
    zip_code: "71261",

    ste_name: "LA",
  },
  {
    zip_code: "71323",

    ste_name: "LA",
  },
  {
    zip_code: "71373",

    ste_name: "LA",
  },
  {
    zip_code: "71405",

    ste_name: "LA",
  },
  {
    zip_code: "71456",

    ste_name: "LA",
  },
  {
    zip_code: "71480",

    ste_name: "LA",
  },
  {
    zip_code: "71666",

    ste_name: "AR",
  },
  {
    zip_code: "71701",

    ste_name: "AR",
  },
  {
    zip_code: "71720",

    ste_name: "AR",
  },
  {
    zip_code: "71834",

    ste_name: "AR",
  },
  {
    zip_code: "71901",

    ste_name: "AR",
  },
  {
    zip_code: "71913",

    ste_name: "AR",
  },
  {
    zip_code: "71961",

    ste_name: "AR",
  },
  {
    zip_code: "71968",

    ste_name: "AR",
  },
  {
    zip_code: "71998",

    ste_name: "AR",
  },
  {
    zip_code: "72019",

    ste_name: "AR",
  },
  {
    zip_code: "72031",

    ste_name: "AR",
  },
  {
    zip_code: "72048",

    ste_name: "AR",
  },
  {
    zip_code: "72120",

    ste_name: "AR",
  },
  {
    zip_code: "72129",

    ste_name: "AR",
  },
  {
    zip_code: "72206",

    ste_name: "AR",
  },
  {
    zip_code: "72396",

    ste_name: "AR",
  },
  {
    zip_code: "72417",

    ste_name: "AR",
  },
  {
    zip_code: "72434",

    ste_name: "AR",
  },
  {
    zip_code: "72512",

    ste_name: "AR",
  },
  {
    zip_code: "72682",

    ste_name: "AR",
  },
  {
    zip_code: "72686",

    ste_name: "AR",
  },
  {
    zip_code: "72858",

    ste_name: "AR",
  },
  {
    zip_code: "72926",

    ste_name: "AR",
  },
  {
    zip_code: "72934",

    ste_name: "AR",
  },
  {
    zip_code: "73009",

    ste_name: "OK",
  },
  {
    zip_code: "73096",

    ste_name: "OK",
  },
  {
    zip_code: "73673",

    ste_name: "OK",
  },
  {
    zip_code: "73733",

    ste_name: "OK",
  },
  {
    zip_code: "73750",

    ste_name: "OK",
  },
  {
    zip_code: "73939",

    ste_name: "OK",
  },
  {
    zip_code: "73951",

    ste_name: "OK",
  },
  {
    zip_code: "74012",

    ste_name: "OK",
  },
  {
    zip_code: "74022",

    ste_name: "OK",
  },
  {
    zip_code: "74037",

    ste_name: "OK",
  },
  {
    zip_code: "74054",

    ste_name: "OK",
  },
  {
    zip_code: "74082",

    ste_name: "OK",
  },
  {
    zip_code: "74120",

    ste_name: "OK",
  },
  {
    zip_code: "74126",

    ste_name: "OK",
  },
  {
    zip_code: "74359",

    ste_name: "OK",
  },
  {
    zip_code: "74425",

    ste_name: "OK",
  },
  {
    zip_code: "74428",

    ste_name: "OK",
  },
  {
    zip_code: "74436",

    ste_name: "OK",
  },
  {
    zip_code: "74452",

    ste_name: "OK",
  },
  {
    zip_code: "74632",

    ste_name: "OK",
  },
  {
    zip_code: "74640",

    ste_name: "OK",
  },
  {
    zip_code: "74643",

    ste_name: "OK",
  },
  {
    zip_code: "74932",

    ste_name: "OK",
  },
  {
    zip_code: "74963",

    ste_name: "OK",
  },
  {
    zip_code: "75058",

    ste_name: "TX",
  },
  {
    zip_code: "75148",

    ste_name: "TX",
  },
  {
    zip_code: "75160",

    ste_name: "TX",
  },
  {
    zip_code: "75220",

    ste_name: "TX",
  },
  {
    zip_code: "75254",

    ste_name: "TX",
  },
  {
    zip_code: "75442",

    ste_name: "TX",
  },
  {
    zip_code: "75605",

    ste_name: "TX",
  },
  {
    zip_code: "75932",

    ste_name: "TX",
  },
  {
    zip_code: "75972",

    ste_name: "TX",
  },
  {
    zip_code: "76002",

    ste_name: "TX",
  },
  {
    zip_code: "76039",

    ste_name: "TX",
  },
  {
    zip_code: "76058",

    ste_name: "TX",
  },
  {
    zip_code: "76077",

    ste_name: "TX",
  },
  {
    zip_code: "76134",

    ste_name: "TX",
  },
  {
    zip_code: "76207",

    ste_name: "TX",
  },
  {
    zip_code: "76227",

    ste_name: "TX",
  },
  {
    zip_code: "76228",

    ste_name: "TX",
  },
  {
    zip_code: "76377",

    ste_name: "TX",
  },
  {
    zip_code: "76424",

    ste_name: "TX",
  },
  {
    zip_code: "76519",

    ste_name: "TX",
  },
  {
    zip_code: "76523",

    ste_name: "TX",
  },
  {
    zip_code: "76527",

    ste_name: "TX",
  },
  {
    zip_code: "76628",

    ste_name: "TX",
  },
  {
    zip_code: "76635",

    ste_name: "TX",
  },
  {
    zip_code: "76837",

    ste_name: "TX",
  },
  {
    zip_code: "76932",

    ste_name: "TX",
  },
  {
    zip_code: "76934",

    ste_name: "TX",
  },
  {
    zip_code: "77008",

    ste_name: "TX",
  },
  {
    zip_code: "77065",

    ste_name: "TX",
  },
  {
    zip_code: "77087",

    ste_name: "TX",
  },
  {
    zip_code: "77303",

    ste_name: "TX",
  },
  {
    zip_code: "77454",

    ste_name: "TX",
  },
  {
    zip_code: "77612",

    ste_name: "TX",
  },
  {
    zip_code: "77617",

    ste_name: "TX",
  },
  {
    zip_code: "77629",

    ste_name: "TX",
  },
  {
    zip_code: "77651",

    ste_name: "TX",
  },
  {
    zip_code: "77954",

    ste_name: "TX",
  },
  {
    zip_code: "77960",

    ste_name: "TX",
  },
  {
    zip_code: "77977",

    ste_name: "TX",
  },
  {
    zip_code: "78013",

    ste_name: "TX",
  },
  {
    zip_code: "78029",

    ste_name: "TX",
  },
  {
    zip_code: "78075",

    ste_name: "TX",
  },
  {
    zip_code: "78076",

    ste_name: "TX",
  },
  {
    zip_code: "78118",

    ste_name: "TX",
  },
  {
    zip_code: "78122",

    ste_name: "TX",
  },
  {
    zip_code: "78162",

    ste_name: "TX",
  },
  {
    zip_code: "78213",

    ste_name: "TX",
  },
  {
    zip_code: "78226",

    ste_name: "TX",
  },
  {
    zip_code: "78235",

    ste_name: "TX",
  },
  {
    zip_code: "78239",

    ste_name: "TX",
  },
  {
    zip_code: "78353",

    ste_name: "TX",
  },
  {
    zip_code: "78357",

    ste_name: "TX",
  },
  {
    zip_code: "78375",

    ste_name: "TX",
  },
  {
    zip_code: "78548",

    ste_name: "TX",
  },
  {
    zip_code: "78557",

    ste_name: "TX",
  },
  {
    zip_code: "78588",

    ste_name: "TX",
  },
  {
    zip_code: "78629",

    ste_name: "TX",
  },
  {
    zip_code: "78669",

    ste_name: "TX",
  },
  {
    zip_code: "78681",

    ste_name: "TX",
  },
  {
    zip_code: "78828",

    ste_name: "TX",
  },
  {
    zip_code: "78838",

    ste_name: "TX",
  },
  {
    zip_code: "79059",

    ste_name: "TX",
  },
  {
    zip_code: "79259",

    ste_name: "TX",
  },
  {
    zip_code: "79311",

    ste_name: "TX",
  },
  {
    zip_code: "79314",

    ste_name: "TX",
  },
  {
    zip_code: "79316",

    ste_name: "TX",
  },
  {
    zip_code: "79322",

    ste_name: "TX",
  },
  {
    zip_code: "79359",

    ste_name: "TX",
  },
  {
    zip_code: "79404",

    ste_name: "TX",
  },
  {
    zip_code: "79416",

    ste_name: "TX",
  },
  {
    zip_code: "79536",

    ste_name: "TX",
  },
  {
    zip_code: "79544",

    ste_name: "TX",
  },
  {
    zip_code: "79549",

    ste_name: "TX",
  },
  {
    zip_code: "79756",

    ste_name: "TX",
  },
  {
    zip_code: "79928",

    ste_name: "TX",
  },
  {
    zip_code: "80455",

    ste_name: "CO",
  },
  {
    zip_code: "80512",

    ste_name: "CO",
  },
  {
    zip_code: "80736",

    ste_name: "CO",
  },
  {
    zip_code: "80743",

    ste_name: "CO",
  },
  {
    zip_code: "80801",

    ste_name: "CO",
  },
  {
    zip_code: "80939",

    ste_name: "CO",
  },
  {
    zip_code: "81008",

    ste_name: "CO",
  },
  {
    zip_code: "81076",

    ste_name: "CO",
  },
  {
    zip_code: "81236",

    ste_name: "CO",
  },
  {
    zip_code: "81425",

    ste_name: "CO",
  },
  {
    zip_code: "82063",

    ste_name: "WY",
  },
  {
    zip_code: "82711",

    ste_name: "WY",
  },
  {
    zip_code: "82922",

    ste_name: "WY",
  },
  {
    zip_code: "82943",

    ste_name: "WY",
  },
  {
    zip_code: "83116",

    ste_name: "WY",
  },
  {
    zip_code: "83121",

    ste_name: "WY",
  },
  {
    zip_code: "83201",

    ste_name: "ID",
  },
  {
    zip_code: "83221",

    ste_name: "ID",
  },
  {
    zip_code: "83233",

    ste_name: "ID",
  },
  {
    zip_code: "83235",

    ste_name: "ID",
  },
  {
    zip_code: "83244",

    ste_name: "ID",
  },
  {
    zip_code: "83327",

    ste_name: "ID",
  },
  {
    zip_code: "83344",

    ste_name: "ID",
  },
  {
    zip_code: "83431",

    ste_name: "ID",
  },
  {
    zip_code: "83455",

    ste_name: "ID",
  },
  {
    zip_code: "83462",

    ste_name: "ID",
  },
  {
    zip_code: "83467",

    ste_name: "ID",
  },
  {
    zip_code: "83806",

    ste_name: "ID",
  },
  {
    zip_code: "83841",

    ste_name: "ID",
  },
  {
    zip_code: "83860",

    ste_name: "ID",
  },
  {
    zip_code: "83873",

    ste_name: "ID",
  },
  {
    zip_code: "84015",

    ste_name: "UT",
  },
  {
    zip_code: "84039",

    ste_name: "UT",
  },
  {
    zip_code: "84074",

    ste_name: "UT",
  },
  {
    zip_code: "84331",

    ste_name: "UT",
  },
  {
    zip_code: "84336",

    ste_name: "UT",
  },
  {
    zip_code: "84664",

    ste_name: "UT",
  },
  {
    zip_code: "84665",

    ste_name: "UT",
  },
  {
    zip_code: "85086",

    ste_name: "AZ",
  },
  {
    zip_code: "85264",

    ste_name: "AZ",
  },
  {
    zip_code: "85283",

    ste_name: "AZ",
  },
  {
    zip_code: "85346",

    ste_name: "AZ",
  },
  {
    zip_code: "85535",

    ste_name: "AZ",
  },
  {
    zip_code: "85618",

    ste_name: "AZ",
  },
  {
    zip_code: "85654",

    ste_name: "AZ",
  },
  {
    zip_code: "86314",

    ste_name: "AZ",
  },
  {
    zip_code: "86503",

    ste_name: "AZ",
  },
  {
    zip_code: "86545",

    ste_name: "AZ",
  },
  {
    zip_code: "87011",

    ste_name: "NM",
  },
  {
    zip_code: "87048",

    ste_name: "NM",
  },
  {
    zip_code: "87461",

    ste_name: "NM",
  },
  {
    zip_code: "87513",

    ste_name: "NM",
  },
  {
    zip_code: "87533",

    ste_name: "NM",
  },
  {
    zip_code: "87554",

    ste_name: "NM",
  },
  {
    zip_code: "87580",

    ste_name: "NM",
  },
  {
    zip_code: "87583",

    ste_name: "NM",
  },
  {
    zip_code: "88011",

    ste_name: "NM",
  },
  {
    zip_code: "88026",

    ste_name: "NM",
  },
  {
    zip_code: "88030",

    ste_name: "NM",
  },
  {
    zip_code: "89086",

    ste_name: "NV",
  },
  {
    zip_code: "89103",

    ste_name: "NV",
  },
  {
    zip_code: "89191",

    ste_name: "NV",
  },
  {
    zip_code: "89430",

    ste_name: "NV",
  },
  {
    zip_code: "89438",

    ste_name: "NV",
  },
  {
    zip_code: "89704",

    ste_name: "NV",
  },
  {
    zip_code: "89825",

    ste_name: "NV",
  },
  {
    zip_code: "90001",

    ste_name: "CA",
  },
  {
    zip_code: "90038",

    ste_name: "CA",
  },
  {
    zip_code: "90804",

    ste_name: "CA",
  },
  {
    zip_code: "91001",

    ste_name: "CA",
  },
  {
    zip_code: "91340",

    ste_name: "CA",
  },
  {
    zip_code: "91803",

    ste_name: "CA",
  },
  {
    zip_code: "91942",

    ste_name: "CA",
  },
  {
    zip_code: "92054",

    ste_name: "CA",
  },
  {
    zip_code: "92070",

    ste_name: "CA",
  },
  {
    zip_code: "92233",

    ste_name: "CA",
  },
  {
    zip_code: "92234",

    ste_name: "CA",
  },
  {
    zip_code: "92267",

    ste_name: "CA",
  },
  {
    zip_code: "92276",

    ste_name: "CA",
  },
  {
    zip_code: "92327",

    ste_name: "CA",
  },
  {
    zip_code: "92333",

    ste_name: "CA",
  },
  {
    zip_code: "92335",

    ste_name: "CA",
  },
  {
    zip_code: "92356",

    ste_name: "CA",
  },
  {
    zip_code: "92410",

    ste_name: "CA",
  },
  {
    zip_code: "92806",

    ste_name: "CA",
  },
  {
    zip_code: "92808",

    ste_name: "CA",
  },
  {
    zip_code: "93223",

    ste_name: "CA",
  },
  {
    zip_code: "93270",

    ste_name: "CA",
  },
  {
    zip_code: "93458",

    ste_name: "CA",
  },
  {
    zip_code: "93620",

    ste_name: "CA",
  },
  {
    zip_code: "93623",

    ste_name: "CA",
  },
  {
    zip_code: "93638",

    ste_name: "CA",
  },
  {
    zip_code: "93644",

    ste_name: "CA",
  },
  {
    zip_code: "93928",

    ste_name: "CA",
  },
  {
    zip_code: "94074",

    ste_name: "CA",
  },
  {
    zip_code: "94301",

    ste_name: "CA",
  },
  {
    zip_code: "94510",

    ste_name: "CA",
  },
  {
    zip_code: "94572",

    ste_name: "CA",
  },
  {
    zip_code: "95005",

    ste_name: "CA",
  },
  {
    zip_code: "95122",

    ste_name: "CA",
  },
  {
    zip_code: "95138",

    ste_name: "CA",
  },
  {
    zip_code: "95148",

    ste_name: "CA",
  },
  {
    zip_code: "95225",

    ste_name: "CA",
  },
  {
    zip_code: "95304",

    ste_name: "CA",
  },
  {
    zip_code: "95306",

    ste_name: "CA",
  },
  {
    zip_code: "95317",

    ste_name: "CA",
  },
  {
    zip_code: "95318",

    ste_name: "CA",
  },
  {
    zip_code: "95330",

    ste_name: "CA",
  },
  {
    zip_code: "95404",

    ste_name: "CA",
  },
  {
    zip_code: "95407",

    ste_name: "CA",
  },
  {
    zip_code: "95420",

    ste_name: "CA",
  },
  {
    zip_code: "95430",

    ste_name: "CA",
  },
  {
    zip_code: "95467",

    ste_name: "CA",
  },
  {
    zip_code: "95497",

    ste_name: "CA",
  },
  {
    zip_code: "95525",

    ste_name: "CA",
  },
  {
    zip_code: "95610",

    ste_name: "CA",
  },
  {
    zip_code: "95636",

    ste_name: "CA",
  },
  {
    zip_code: "95637",

    ste_name: "CA",
  },
  {
    zip_code: "95694",

    ste_name: "CA",
  },
  {
    zip_code: "95717",

    ste_name: "CA",
  },
  {
    zip_code: "95818",

    ste_name: "CA",
  },
  {
    zip_code: "95834",

    ste_name: "CA",
  },
  {
    zip_code: "95901",

    ste_name: "CA",
  },
  {
    zip_code: "96161",

    ste_name: "CA",
  },
  {
    zip_code: "96737",

    ste_name: "HI",
  },
  {
    zip_code: "96761",

    ste_name: "HI",
  },
  {
    zip_code: "97019",

    ste_name: "OR",
  },
  {
    zip_code: "97026",

    ste_name: "OR",
  },
  {
    zip_code: "97064",

    ste_name: "OR",
  },
  {
    zip_code: "97119",

    ste_name: "OR",
  },
  {
    zip_code: "97123",

    ste_name: "OR",
  },
  {
    zip_code: "97125",

    ste_name: "OR",
  },
  {
    zip_code: "97221",

    ste_name: "OR",
  },
  {
    zip_code: "97383",

    ste_name: "OR",
  },
  {
    zip_code: "97458",

    ste_name: "OR",
  },
  {
    zip_code: "97539",

    ste_name: "OR",
  },
  {
    zip_code: "97721",

    ste_name: "OR",
  },
  {
    zip_code: "97845",

    ste_name: "OR",
  },
  {
    zip_code: "97914",

    ste_name: "OR",
  },
  {
    zip_code: "98068",

    ste_name: "WA",
  },
  {
    zip_code: "98116",

    ste_name: "WA",
  },
  {
    zip_code: "98335",

    ste_name: "WA",
  },
  {
    zip_code: "98444",

    ste_name: "WA",
  },
  {
    zip_code: "98563",

    ste_name: "WA",
  },
  {
    zip_code: "98587",

    ste_name: "WA",
  },
  {
    zip_code: "98612",

    ste_name: "WA",
  },
  {
    zip_code: "99122",

    ste_name: "WA",
  },
  {
    zip_code: "99128",

    ste_name: "WA",
  },
  {
    zip_code: "99348",

    ste_name: "WA",
  },
  {
    zip_code: "99589",

    ste_name: "AK",
  },
  {
    zip_code: "99606",

    ste_name: "AK",
  },
  {
    zip_code: "99626",

    ste_name: "AK",
  },
  {
    zip_code: "99637",

    ste_name: "AK",
  },
  {
    zip_code: "99783",

    ste_name: "AK",
  },
];
